
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("6lIZU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ProjectPages", () => $cda1a522e18cccfc$export$3f8982b128d5aa35);
$parcel$export(module.exports, "default", () => $cda1a522e18cccfc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $eI64M = parcelRequire("eI64M");

var $ixwgj = parcelRequire("ixwgj");

var $bhwgQ = parcelRequire("bhwgQ");

var $gd0Sp = parcelRequire("gd0Sp");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");

var $egMes = parcelRequire("egMes");
const $cda1a522e18cccfc$export$3f8982b128d5aa35 = ()=>{
    const projectContext = (0, $lB25E.useResource)((0, $ixwgj.projectContextResource));
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    if ((0, $eI64M.isProjectArchivedCondition)(projectContext.data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "project-pages"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, projectContext && // @ts-expect-error - TS2322 - Type 'UseResourceHookResponse<ProjectContext | null>' is not assignable to type 'ProjectContextData'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $egMes.default), {
        projectContext: projectContext,
        tenantContext: tenantContext
    })));
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
$cda1a522e18cccfc$export$2e2bcd8739ae039 = (0, $lB25E.withRouter)($cda1a522e18cccfc$export$3f8982b128d5aa35);

});
parcelRegister("eI64M", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $949f89d276fadb14$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $949f89d276fadb14$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $949f89d276fadb14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $lB25E = parcelRequire("lB25E");

const $949f89d276fadb14$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $949f89d276fadb14$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>$949f89d276fadb14$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
        }) : null);
};
const $949f89d276fadb14$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
    });
var $949f89d276fadb14$export$2e2bcd8739ae039 = $949f89d276fadb14$var$RedirectIfProjectArchived;

});
const $8b47e2956ab1dffe$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("egMes", function(module, exports) {

$parcel$export(module.exports, "default", () => $199785afa9c5ebce$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $8UZbB = parcelRequire("8UZbB");

var $fO5rB = parcelRequire("fO5rB");

var $afBr0 = parcelRequire("afBr0");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $199785afa9c5ebce$var$Updater = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    });
var $199785afa9c5ebce$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $afBr0.default), {
    ProjectPagesApp: $8UZbB.default,
    Updater: $199785afa9c5ebce$var$Updater
});

});
parcelRegister("8UZbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ff6ad1f37d0a2ee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $6UEmo = parcelRequire("6UEmo");
function $4ff6ad1f37d0a2ee$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UEmo.default), props)));
}

});
parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

parcelRegister("6UEmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $868d89a6b2f3d218$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9rYNR = parcelRequire("9rYNR");

var $74EXT = parcelRequire("74EXT");

var $dpXKE = parcelRequire("dpXKE");

var $e91YZ = parcelRequire("e91YZ");

var $aR8n6 = parcelRequire("aR8n6");

var $heNSb = parcelRequire("heNSb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6FP8W = parcelRequire("6FP8W");

var $j3FUN = parcelRequire("j3FUN");

var $lB25E = parcelRequire("lB25E");

var $bG3kA = parcelRequire("bG3kA");

var $fkAfS = parcelRequire("fkAfS");

var $cBSii = parcelRequire("cBSii");

var $kCe2K = parcelRequire("kCe2K");
const $868d89a6b2f3d218$var$getFeatureFlagValue = ()=>({
    });
const $868d89a6b2f3d218$var$onFireExposureEvent = ()=>({});
const $868d89a6b2f3d218$var$ProjectPagesApp = (props)=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const hasConfluence = !!licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).CONFLUENCE];
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const featureState = (0, $bG3kA.usePagesFeatureState)(props.projectId);
    const isJWMProduct = props.parentProduct && props.parentProduct === 'JWM';
    /*
         Adding not a JWM product check is a hacky solution for now to solve
         https://jira.atlassian.com/browse/JWMCLOUD-319.
          Long term solution would be to investigate further if we need to add check project-pages-link-enabled property for JWM as well,
         if no then we need to pull out the redirection check from src/packages/confluence/project-pages package to src/packages/spa-apps/project/pages
         so that the change is only limited to JSW and not flowing to other consumers of project pages (like JWM)
     */ if (featureState === (0, $fkAfS.pagesFeatureStates).DISABLED && !isJWMProduct) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/projects/${props.projectKey}`
    });
    const { PerformanceTracking: PerformanceTracking } = props;
    const getProjectPagesComponent = ()=>{
        const projectPagesComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9rYNR.default), {
            ...props,
            // @ts-expect-error - TS2322 - Type 'ReactNode' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
            breadcrumbs: !(0, $6FP8W.getWillShowNav4)() && props.breadcrumbs,
            EmbeddedProductUpdater: (0, $74EXT.default),
            onGetFeatureFlagValue: $868d89a6b2f3d218$var$getFeatureFlagValue,
            onFireExposureEvent: $868d89a6b2f3d218$var$onFireExposureEvent,
            onFireErrorEvent: (0, $kCe2K.onFireErrorEvent),
            hasConfluence: hasConfluence,
            renderFullHeader: !(0, $6FP8W.getWillShowNav4)(),
            isProjectPagesSporkRebrandingEnabled: true
        });
        return projectPagesComponent;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "projectPages",
        packageName: "jiraProjectPages",
        attributes: {
            hasConfluence: hasConfluence
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, getProjectPagesComponent(), PerformanceTracking ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PerformanceTracking, {
        loading: featureState === (0, $fkAfS.pagesFeatureStates).LOADING
    }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $cBSii.default).pageTitlePages)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: props.baseUrl,
        projectKey: props.projectKey,
        projectName: props.projectName
    }, getProjectPagesComponent(), PerformanceTracking ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PerformanceTracking, {
        loading: featureState === (0, $fkAfS.pagesFeatureStates).LOADING
    }) : null))));
};
var $868d89a6b2f3d218$export$2e2bcd8739ae039 = $868d89a6b2f3d218$var$ProjectPagesApp;

});
parcelRegister("9rYNR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c0c387c9fce55fb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cllCv = parcelRequire("cllCv");

var $3dpxL = parcelRequire("3dpxL");

var $f86rB = parcelRequire("f86rB");

var $XHGTv = parcelRequire("XHGTv");
parcelRequire("2Nzqx");
var $hXPzA = parcelRequire("hXPzA");

var $jkH4Q = parcelRequire("jkH4Q");

var $aooQu = parcelRequire("aooQu");

var $6I7Zw = parcelRequire("6I7Zw");

var $b18Mx = parcelRequire("b18Mx");

var $jUlQz = parcelRequire("jUlQz");

var $gneuB = parcelRequire("gneuB");

var $3eKVQ = parcelRequire("3eKVQ");

var $kCoCX = parcelRequire("kCoCX");

var $ggLRr = parcelRequire("ggLRr");

var $8ueGw = parcelRequire("8ueGw");

var $8dZP8 = parcelRequire("8dZP8");

var $fFPgi = parcelRequire("fFPgi");

var $hG7sF = parcelRequire("hG7sF");

var $kqxVx = parcelRequire("kqxVx");

var $8lqS6 = parcelRequire("8lqS6");

var $kHo9c = parcelRequire("kHo9c");


var $6ji7W = parcelRequire("6ji7W");

var $a1ivA = parcelRequire("a1ivA");


var $hTSL3 = parcelRequire("hTSL3");
const $8c0c387c9fce55fb$var$i18n = $aooQu;
const $8c0c387c9fce55fb$var$getCodesFromLocale = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        country: country.toUpperCase()
    };
};
class $8c0c387c9fce55fb$var$ProjectPagesComponent extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            baseUrl: (0, $3eKVQ.initialContextState).baseUrl,
            locale: (0, $3eKVQ.initialContextState).locale,
            isAdmin: (0, $3eKVQ.initialContextState).isAdmin,
            cloudId: (0, $3eKVQ.initialContextState).cloudId,
            accountId: (0, $3eKVQ.initialContextState).accountId,
            parentProduct: (0, $4f13ed7939f15d31$export$ae07618062047a87),
            projectKey: (0, $gneuB.initialProjectState).key,
            projectId: (0, $gneuB.initialProjectState).id,
            projectType: (0, $gneuB.initialProjectState).type,
            projectName: (0, $gneuB.initialProjectState).name,
            environment: 'dev',
            hasConfluence: false
        };
    }
    constructor(props){
        super(props);
        const { baseUrl: baseUrl, locale: locale, isAdmin: isAdmin, cloudId: cloudId, accountId: accountId, projectKey: projectKey, projectId: projectId, projectType: projectType, projectName: projectName, environment: environment, onGetFeatureFlagValue: onGetFeatureFlagValue, onFireExposureEvent: onFireExposureEvent, onFireErrorEvent: onFireErrorEvent, isProjectPagesSporkRebrandingEnabled: isProjectPagesSporkRebrandingEnabled, parentProduct: parentProduct } = props;
        const origin = new (0, $jkH4Q.default)({
            product: 'jira'
        });
        this.store = (0, $kCoCX.createStore)();
        this.store.dispatch((0, $8ueGw.set)({
            baseUrl: baseUrl,
            locale: locale,
            isAdmin: isAdmin,
            cloudId: cloudId,
            accountId: accountId,
            confluenceState: (0, $kHo9c.CONFLUENCE_LOADING),
            suggestedKey: (0, $3eKVQ.initialContextState).suggestedKey,
            origin: // origin: origin as OriginTracing,
            origin,
            environment: environment || 'dev',
            licenseInformation: undefined,
            projectId: projectId,
            projectType: projectType
        }));
        this.store.dispatch((0, $ggLRr.set)({
            onGetFeatureFlagValue: onGetFeatureFlagValue,
            onFireExposureEvent: onFireExposureEvent,
            onFireErrorEvent: onFireErrorEvent,
            crossFlow: props.crossFlow
        }));
        this.store.dispatch((0, $fFPgi.set)({
            key: projectKey,
            id: projectId,
            type: projectType,
            name: projectName
        }));
        this.store.dispatch((0, $8dZP8.set)({
            isProjectPagesSporkRebrandingEnabled: isProjectPagesSporkRebrandingEnabled || false
        }));
        const isOnDemandEnabled = isAdmin && parentProduct === (0, $4f13ed7939f15d31$export$ae07618062047a87) && (0, $XHGTv.fg)('platform.xflow-provisioning-api_kgxk3');
        this.store.dispatch((0, $hG7sF.set)({
            status: isOnDemandEnabled ? 'not-started' : 'not-allowed',
            retryCount: 0,
            userInitiated: false
        }));
        (0, $b18Mx.initAnalyticsClient)({
            client: {
                environment: environment,
                locale: locale,
                cloudId: cloudId,
                accountId: accountId
            },
            context: {
                containerType: 'project',
                containerId: projectId,
                parent: 'projectPages'
            }
        });
    }
    render() {
        const { accountId: accountId, locale: locale, cloudId: cloudId, breadcrumbs: breadcrumbs, EmbeddedProductUpdater: EmbeddedProductUpdater, projectKey: projectKey, projectName: projectName, projectId: projectId, projectType: projectType, parentProduct: parentProduct, hasConfluence: hasConfluence, renderFullHeader: renderFullHeader, onFireExposureEvent: onFireExposureEvent, onFireErrorEvent: onFireErrorEvent, theme: theme, isAdmin: isAdmin, environment: environment } = this.props;
        const { language: language, country: country } = $8c0c387c9fce55fb$var$getCodesFromLocale(locale);
        const messages = $8c0c387c9fce55fb$var$i18n[`${language}_${country}`] || $8c0c387c9fce55fb$var$i18n[language];
        const defaultParentProduct = parentProduct ?? (0, $4f13ed7939f15d31$export$ae07618062047a87);
        (0, $6I7Zw.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cllCv.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            locale: language,
            messages: messages,
            defaultLocale: "en"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqxVx.ProjectPagesProvider), {
            value: {
                accountId: accountId,
                cloudId: cloudId,
                locale: locale,
                parentProduct: defaultParentProduct,
                projectKey: projectKey,
                projectName: projectName,
                projectId: projectId,
                projectType: projectType,
                isAdmin: isAdmin,
                environment: environment
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8lqS6.FeatureFlagsProvider), {
            value: {
                fireFeatureExposed: onFireExposureEvent
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f86rB.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ji7W.ThemeContext).Provider, {
            value: theme || (0, $6ji7W.whiteTheme)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jUlQz.default), {
            breadcrumbs: breadcrumbs,
            locale: locale,
            EmbeddedProductUpdater: EmbeddedProductUpdater,
            hasConfluence: hasConfluence,
            renderFullHeader: renderFullHeader,
            onFireExposureEvent: onFireExposureEvent,
            onFireErrorEvent: onFireErrorEvent
        })))))));
    }
}
const $8c0c387c9fce55fb$var$ProjectPagesWithCrossFlow = (0, $hXPzA.withCrossFlow)($8c0c387c9fce55fb$var$ProjectPagesComponent);
var $8c0c387c9fce55fb$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceType: (0, $e779cc169fd2a347$export$f636b5b56f1d624a),
        sourceName: "projectPages",
        containerType: "project",
        containerId: props.projectId ? `${props.projectId}` : undefined,
        attributes: {
            hasConfluence: props.hasConfluence,
            projectId: props.projectId,
            sourceComponent: (0, $2bdc823b57417d54$export$400f359cf7604d7a),
            sourceContext: (0, $2bdc823b57417d54$export$e776c72d9769c47a),
            isGoogleDriveInProjectPagesEnabled: (0, $XHGTv.fg)('platform.google-drive-in-project-pages') || false,
            featureFlags: {
                ...(0, $hTSL3.getAllBooleanFeatureFlags)()
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c0c387c9fce55fb$var$ProjectPagesWithCrossFlow, props)));

});
parcelRegister("2Nzqx", function(module, exports) {

$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("hXPzA")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("hXPzA")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("hXPzA")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("hXPzA")).Reasons);
$parcel$export(module.exports, "Targets", () => (parcelRequire("8a0ZO")).Targets);

var $hXPzA = parcelRequire("hXPzA");

var $8a0ZO = parcelRequire("8a0ZO");

});

parcelRegister("aooQu", function(module, exports) {

$parcel$export(module.exports, "zh", () => (parcelRequire("96jgW")).default);
$parcel$export(module.exports, "zh_TW", () => (parcelRequire("1tgRg")).default);
$parcel$export(module.exports, "cs", () => (parcelRequire("6B5Ae")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("lPDba")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("aqqpw")).default);
$parcel$export(module.exports, "et", () => (parcelRequire("cKAjd")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("iHMjO")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("1FHgV")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("1IM7q")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("AjJao")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("hVSzs")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("bj7Z8")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("6PrDX")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("gB4DF")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("kmIvU")).default);
$parcel$export(module.exports, "pt_BR", () => (parcelRequire("4tw7A")).default);
$parcel$export(module.exports, "pt_PT", () => (parcelRequire("7c9Jf")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("iLQyM")).default);
$parcel$export(module.exports, "sk", () => (parcelRequire("c28xq")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("4u295")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("7jrrb")).default);
$parcel$export(module.exports, "th", () => (parcelRequire("l67jB")).default);
$parcel$export(module.exports, "tr", () => (parcelRequire("cWhTA")).default);
$parcel$export(module.exports, "uk", () => (parcelRequire("giQQn")).default);
$parcel$export(module.exports, "vi", () => (parcelRequire("5JkrF")).default);
$parcel$export(module.exports, "en_ZZ", () => (parcelRequire("bSwAS")).default);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $96jgW = parcelRequire("96jgW");

var $1tgRg = parcelRequire("1tgRg");

var $6B5Ae = parcelRequire("6B5Ae");

var $lPDba = parcelRequire("lPDba");

var $aqqpw = parcelRequire("aqqpw");

var $cKAjd = parcelRequire("cKAjd");

var $iHMjO = parcelRequire("iHMjO");

var $1FHgV = parcelRequire("1FHgV");

var $1IM7q = parcelRequire("1IM7q");

var $AjJao = parcelRequire("AjJao");

var $hVSzs = parcelRequire("hVSzs");

var $bj7Z8 = parcelRequire("bj7Z8");

var $6PrDX = parcelRequire("6PrDX");

var $gB4DF = parcelRequire("gB4DF");

var $kmIvU = parcelRequire("kmIvU");

var $4tw7A = parcelRequire("4tw7A");

var $7c9Jf = parcelRequire("7c9Jf");

var $iLQyM = parcelRequire("iLQyM");

var $c28xq = parcelRequire("c28xq");

var $4u295 = parcelRequire("4u295");

var $7jrrb = parcelRequire("7jrrb");

var $l67jB = parcelRequire("l67jB");

var $cWhTA = parcelRequire("cWhTA");

var $giQQn = parcelRequire("giQQn");

var $5JkrF = parcelRequire("5JkrF");

var $bSwAS = parcelRequire("bSwAS");

});
parcelRegister("96jgW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f7d41aeb3a59ab4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $5f7d41aeb3a59ab4$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u6B64\u64CD\u4F5C\u7528\u65F6\u4E0D\u8D85\u8FC7\u4E00\u5206\u949F",
    'confluence.project-pages.improvement.provisioning-background.title': "\u6B63\u5728\u8BBE\u7F6E\u9879\u76EE\u9875\u9762",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u5173\u95ED",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u5B8C\u6210",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u4E0B\u4E00\u9875",
    'project-pages.activating.description': "\u5DF2\u8FDE\u63A5\u7684 Confluence \u7A7A\u95F4\u5C1A\u672A\u51C6\u5907\u5C31\u7EEA\u3002\u5982\u679C\u5237\u65B0\u65E0\u6CD5\u4FEE\u590D\u95EE\u9898\uFF0C\u5219\u8BF7{contactSupport}\u3002",
    'project-pages.activating.heading': "Confluence \u4ECD\u5728\u52A0\u8F7D",
    'project-pages.button.connect-different-space-or-page.label': "\u66F4\u65B0\u7A7A\u95F4\u6216\u9875\u9762\u56FE\u6807",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u8FDE\u63A5\u5176\u4ED6\u7A7A\u95F4\u6216\u9875\u9762",
    'project-pages.button.connect-space-or-page.tooltip': "\u8FDE\u63A5\u5230 Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "\u5728 Confluence \u4E2D\u6253\u5F00\u9875\u9762",
    'project-pages.button.go-to-connected-space.tooltip': "\u5728 Confluence \u4E2D\u6253\u5F00\u7A7A\u95F4",
    'project-pages.connect-space-dialog.connection-error': "\u8FDE\u63A5\u5931\u8D25\u3002",
    'project-pages.connect-space-dialog.connection-retry': "\u91CD\u8BD5",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u9009\u62E9\u8981\u8FDE\u63A5\u81F3\u60A8\u7684\u9879\u76EE\u7684\u7A7A\u95F4\u6216\u9875\u9762\u3002",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "\u5728 Confluence \u4E2D\u641C\u7D22",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u6B64\u9879\u76EE\u9700\u8FDE\u63A5\u81F3\u4E00\u4E2A\u7A7A\u95F4\uFF0C\u60A8\u624D\u80FD\u521B\u5EFA\u9875\u9762\u3002\u8BF7\u9009\u62E9\u8981\u8FDE\u63A5\u81F3\u6B64\u9879\u76EE\u7684\u7A7A\u95F4\u3002",
    'project-pages.connect-space-dialog.error-icon': "\u9519\u8BEF\uFF1A",
    'project-pages.connect-space-dialog.footer.cancel': "\u53D6\u6D88",
    'project-pages.connect-space-dialog.footer.connect-space': "\u8FDE\u63A5",
    'project-pages.connect-space-or-page-dialog.header.title': "\u5C06\u9879\u76EE\u8FDE\u63A5\u5230 Confluence",
    'project-pages.connect-space.description': "\u7A7A\u95F4\u7C7B\u4F3C\u6587\u4EF6\u5939 - \u60A8\u53EF\u4EE5\u4F7F\u7528\u5B83\u4EEC\u5C31\u4E0E\u9879\u76EE\u76F8\u5173\u7684\u6240\u6709\u5185\u5BB9\u8FDB\u884C\u521B\u5EFA\u3001\u7EC4\u7EC7\u548C\u534F\u4F5C\u3002",
    'project-pages.connect-space.not-connected.description': "\u82E5\u8981\u4F7F\u7528\u9879\u76EE\u9875\u9762\uFF0C\u8BF7\u8054\u7CFB\u60A8\u7684\u7BA1\u7406\u5458\u6216\u56E2\u961F\u8D1F\u8D23\u4EBA\uFF0C\u5C06 Confluence \u8FDE\u63A5\u5230\u6B64\u9879\u76EE\u3002",
    'project-pages.connect-space.not-connected.heading': "\u672A\u8FDE\u63A5\u5230 Confluence",
    'project-pages.connect-success-flag.description.content': "\u5DF2\u6210\u529F\u8FDE\u63A5 {connectedSpaceOrPageName} \u5185\u5BB9\u3002",
    'project-pages.connection-error.space-or-page-not-found.button': "\u8FDE\u63A5\u5230\u5176\u4ED6\u7A7A\u95F4\u6216\u9875\u9762",
    'project-pages.create-space-dialog.connection-error': "\u8FDE\u63A5\u5931\u8D25\u3002",
    'project-pages.create-space-dialog.connection-retry': "\u91CD\u8BD5",
    'project-pages.create-space-dialog.content.empty-name': "\u8BF7\u4E3A\u7A7A\u95F4\u547D\u540D\u3002",
    'project-pages.create-space-dialog.content.invalid-name': "\u7A7A\u95F4\u540D\u79F0\u81F3\u5C11\u9700\u5305\u542B\u4E00\u4E2A\u5B57\u6BCD\u6216\u6570\u5B57\u3002",
    'project-pages.create-space-dialog.content.placeholder': "\u8F93\u5165\u7A7A\u95F4\u540D\u79F0",
    'project-pages.create-space-dialog.creation-error': "\u7A7A\u95F4\u521B\u5EFA\u5931\u8D25\u3002",
    'project-pages.create-space-dialog.error-icon': "\u9519\u8BEF\uFF1A",
    'project-pages.create-space-dialog.footer.cancel': "\u53D6\u6D88",
    'project-pages.create-space-dialog.footer.create-space': "\u521B\u5EFA",
    'project-pages.create-space-dialog.header.title': "\u521B\u5EFA\u65B0\u7684 Confluence \u7A7A\u95F4",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u60A8\u65E0\u6CD5\u4F7F\u7528\u9879\u76EE\u9875\u9762\uFF0C\u56E0\u4E3A\u7BA1\u7406\u5458\u5DF2\u62D2\u7EDD\u60A8\u8BBF\u95EE Confluence\u3002\u8BF7\u8054\u7CFB\u7AD9\u70B9\u7BA1\u7406\u5458\u7533\u8BF7\u8BBF\u95EE\u6743\u9650\u3002",
    'project-pages.cross-join.access-revoked.templates.title': "\u60A8\u65E0\u6743\u4F7F\u7528\u9879\u76EE\u9875\u9762",
    'project-pages.cross-join.avatar.view-profile': "\u67E5\u770B\u4E2A\u4EBA\u8D44\u6599",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u60A8\u65E0\u6CD5\u4F7F\u7528\u9879\u76EE\u9875\u9762\uFF0C\u56E0\u4E3A\u7AD9\u70B9\u7BA1\u7406\u5458\u62D2\u7EDD\u4E86\u60A8\u52A0\u5165 Confluence \u7684\u8BF7\u6C42\u3002",
    'project-pages.cross-join.denied-request.templates.title': "\u60A8\u7684\u7BA1\u7406\u5458\u5DF2\u62D2\u7EDD\u60A8\u8BBF\u95EE",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "\u60A8\u5C06\u83B7\u5F97 Confluence \u7684\u8BBF\u95EE\u6743\u9650\u3002\u7AD9\u70B9\u7BA1\u7406\u5458\u5DF2\u6279\u51C6\u60A8\u52A0\u5165\u3002",
    'project-pages.cross-join.errors.unknown-error.description': "\u5982\u679C\u5237\u65B0\u65E0\u6CD5\u4FEE\u590D\u95EE\u9898\uFF0C\u5219\u8BF7{contactSupport}\u3002",
    'project-pages.cross-join.errors.unknown-error.title': "\u5F53\u524D\u65E0\u6CD5\u663E\u793A\u9879\u76EE\u9875\u9762",
    'project-pages.cross-join.inline-join-product.button': "\u60A8\u5C06\u83B7\u5F97 Confluence \u7684\u8BBF\u95EE\u6743\u9650\u3002\u7AD9\u70B9\u7BA1\u7406\u5458\u5DF2\u6279\u51C6\u60A8\u52A0\u5165\u3002",
    'project-pages.cross-join.inline-join-product.connected.description': "\u5728\u4E00\u4E2A\u96C6\u4E2D\u4F4D\u7F6E\u67E5\u770B\u3001\u7F16\u8F91\u548C\u521B\u5EFA\u6587\u6863",
    'project-pages.cross-join.inline-join-product.connected.title': "\u5728\u9879\u76EE\u9875\u9762\u4E0A\u4E0E\u60A8\u7684\u56E2\u961F\u5F00\u5C55\u534F\u4F5C",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u7AD9\u70B9\u7BA1\u7406\u5458\u5DF2\u6536\u5230\u60A8\u52A0\u5165 Confluence \u7684\u8BF7\u6C42\u3002\u5982\u679C\u60A8\u88AB\u6279\u51C6\u52A0\u5165\uFF0C\u9879\u76EE\u9875\u9762\u5C06\u5F00\u59CB\u8FD0\u884C\uFF0C\u6211\u4EEC\u4E5F\u4F1A\u5411\u60A8\u53D1\u9001\u786E\u8BA4\u7535\u5B50\u90AE\u4EF6\u3002",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\u8BF7\u6C42\u83B7\u5F97\u6279\u51C6\u540E\uFF0C\u60A8\u5C06\u6536\u5230\u4E00\u5C01\u5305\u542B\u201C\u9879\u76EE\u9875\u9762\u201D\u8BBF\u95EE\u6743\u9650\u7684\u7535\u5B50\u90AE\u4EF6\u3002",
    'project-pages.cross-join.pending-request.templates.title': "\u60A8\u5DF2\u8BF7\u6C42\u8BBF\u95EE Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u5DF2\u5411\u7BA1\u7406\u5458\u53D1\u9001\u8BBF\u95EE\u8BF7\u6C42",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u4E0E\u60A8\u7684\u56E2\u961F\u4E00\u8D77\u67E5\u770B\u3001\u7F16\u8F91\u548C\u521B\u5EFA\u9879\u76EE\u6587\u6863",
    'project-pages.cross-join.request-access.button': "\u8BF7\u6C42\u8BBF\u95EE",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "\u9009\u62E9\u201C\u52A0\u5165\u60A8\u7684\u56E2\u961F\u201D\uFF0C\u5373\u8868\u793A\u60A8\u8BF7\u6C42\u52A0\u5165 Confluence \u5E76\u540C\u610F\u4E0E\u7BA1\u7406\u5458\u5206\u4EAB\u60A8\u7684 Atlassian \u4E2A\u4EBA\u8D44\u6599\u3002",
    'project-pages.cross-join.request-access.button.experimental': "\u52A0\u5165\u60A8\u7684\u56E2\u961F",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u60A8\u7684\u56E2\u961F\u65E0\u9700\u79BB\u5F00 Jira\uFF0C\u5373\u53EF\u4F7F\u7528\u201C\u9879\u76EE\u9875\u9762\u201D\u6765\u8BC4\u8BBA\u3001\u7F16\u8F91\u548C\u534F\u4F5C\u5904\u7406\u9879\u76EE\u6587\u6863\u3002\u52A0\u5165 Confluence \u4EE5\u8BBF\u95EE\u60A8\u56E2\u961F\u7684\u201C\u9879\u76EE\u9875\u9762\u201D\u3002",
    'project-pages.cross-join.request-access.title': "\u9879\u76EE\u9875\u9762\u9700\u8981\u8BBF\u95EE Confluence",
    'project-pages.cross-join.request-access.title.experiment': "\u4E3A\u60A8\u7684\u56E2\u961F\u521B\u5EFA\u5355\u4E00\u4E8B\u5B9E\u6765\u6E90",
    'project-pages.default-contextual-heading': "\u9879\u76EE\u9875\u9762\u7531 Confluence \u63D0\u4F9B\u652F\u6301",
    'project-pages.default-contextual-message': "\u4F7F\u7528 Confluence \u9875\u9762\u5728\u4E00\u4E2A\u4F4D\u7F6E\u521B\u5EFA\u3001\u5171\u4EAB\u548C\u5408\u4F5C\u6240\u6709\u9879\u76EE\u6587\u6863\u3002",
    'project-pages.default-reactivate-CTA': "\u91CD\u65B0\u6FC0\u6D3B Confluence",
    'project-pages.default-trial-CTA': "\u514D\u8D39\u8BD5\u7528 Confluence 30 \u5929",
    'project-pages.draft-saved-flag.action': "\u6253\u5F00\u8349\u7A3F",
    'project-pages.draft-saved-flag.description': "\u5728\u60A8\u53D1\u5E03\u8349\u7A3F\u4E4B\u524D\uFF0C\u60A8\u7684\u8349\u7A3F\u4EC5\u5BF9\u60A8\u81EA\u5DF1\u53EF\u89C1\u3002",
    'project-pages.draft-saved-flag.title': "\u8349\u7A3F\u5DF2\u4FDD\u5B58",
    'project-pages.embedded-pages.create-page-error.close-button': "\u5173\u95ED",
    'project-pages.embedded-pages.create-page-error.description': "\u51FA\u73B0\u95EE\u9898\uFF0C\u65E0\u6CD5\u4E3A\u60A8\u521B\u5EFA\u9875\u9762\u3002",
    'project-pages.embedded-pages.create-page-error.title': "\u65E0\u6CD5\u521B\u5EFA\u9875\u9762",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u8BF7\u91CD\u8BD5",
    'project-pages.embedded-pages.modal.close.button.hint': "\u5173\u95ED",
    'project-pages.embedded-pages.modal.title.button': "\u5728 Confluence \u4E2D\u6253\u5F00",
    'project-pages.embedded-pages.modal.title.button.hint': "\u5728\u65B0\u6807\u7B7E\u9875\u4E2D\u6253\u5F00",
    'project-pages.errors.unknown-error.description.non-final': "\u5982\u679C\u5237\u65B0\u65E0\u6CD5\u4FEE\u590D\u95EE\u9898\uFF0C\u5219\u8BF7{contactSupport}\u3002",
    'project-pages.errors.unknown-error.title.non-final': "\u5F53\u524D\u65E0\u6CD5\u663E\u793A\u9879\u76EE\u9875\u9762",
    'project-pages.generic-error.button.reload': "\u91CD\u65B0\u52A0\u8F7D\u9875\u9762",
    'project-pages.generic-error.description': "\u51FA\u9519\u4E86\u3002\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002",
    'project-pages.generic-error.description.non-final': "\u51FA\u9519\u4E86\u3002\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002",
    'project-pages.generic-error.heading': "\u62B1\u6B49...",
    'project-pages.generic-error.title.non-final': "\u62B1\u6B49...",
    'project-pages.generic-info-flag.description': "\u53D1\u751F\u9519\u8BEF\u3002\u8BF7\u91CD\u8BD5\uFF1B\u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u652F\u6301\u56E2\u961F",
    'project-pages.generic-success-flag.description.page': "\u5DF2\u6210\u529F\u8FDE\u63A5 {connectedSpaceOrPageName} \u9875\u9762\u3002",
    'project-pages.generic-success-flag.description.space': "\u5DF2\u6210\u529F\u8FDE\u63A5 {connectedSpaceOrPageName} \u7A7A\u95F4\u3002",
    'project-pages.generic-success-flag.heading.page': "\u9875\u9762\u5DF2\u8FDE\u63A5",
    'project-pages.generic-success-flag.heading.space': "\u7A7A\u95F4\u5DF2\u8FDE\u63A5",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u6216\u8005\u521B\u5EFA\u65B0\u7A7A\u95F4",
    'project-pages.granular-pages.connect-space.button': "\u8FDE\u63A5\u5230 Confluence",
    'project-pages.granular-pages.connect-space.heading': "\u5C06\u6B64\u9879\u76EE\u8FDE\u63A5\u81F3 Confluence \u7A7A\u95F4\u6216\u9875\u9762",
    'project-pages.granular-pages.connect-space.heading.non-final': "\u5C06\u6B64\u9879\u76EE\u8FDE\u63A5\u81F3 Confluence \u7A7A\u95F4\u6216\u9875\u9762",
    'project-pages.improvement.contact-support': "\u8054\u7CFB\u652F\u6301\u56E2\u961F",
    'project-pages.improvement.errors.access-error.description': "\u8BF7\u5C1D\u8BD5\u8054\u7CFB\u7AD9\u70B9\u7BA1\u7406\u5458\u4EE5\u8BF7\u6C42\u8BBF\u95EE\u6743\u9650\u3002",
    'project-pages.improvement.errors.access-error.title': "\u60A8\u65E0\u6743\u67E5\u770B\u9879\u76EE\u9875\u9762",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u5C1D\u8BD5\u4ECE\u5DF2\u8FDE\u63A5\u7684 Confluence \u7A7A\u95F4\u663E\u793A\u9875\u9762\u65F6\u51FA\u9519\u3002\u5982\u679C\u5237\u65B0\u65E0\u6CD5\u4FEE\u590D\u95EE\u9898\uFF0C\u5219\u8BF7{contactSupport}\u3002",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u663E\u793A\u9879\u76EE\u9875\u9762\u65F6\u51FA\u73B0\u95EE\u9898",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u5DF2\u5173\u8054\u7684 Confluence \u7A7A\u95F4\u6216\u9875\u9762\u5DF2\u79FB\u52A8\u3001\u5F52\u6863\u6216\u5220\u9664\u3002\u5982\u679C\u91CD\u65B0\u5173\u8054\u65E0\u6CD5\u89E3\u51B3\u95EE\u9898\uFF0C\u8BF7<link>\u8054\u7CFB\u652F\u6301\u56E2\u961F</link>",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u672A\u627E\u5230\u7A7A\u95F4\u6216\u9875\u9762",
    'project-pages.improvement.errors.unknown-error.description': "\u5982\u679C\u5237\u65B0\u65E0\u6CD5\u4FEE\u590D\u95EE\u9898\uFF0C\u5219\u8BF7{contactSupport}\u3002",
    'project-pages.improvement.errors.unknown-error.title': "\u5F53\u524D\u65E0\u6CD5\u663E\u793A\u9879\u76EE\u9875\u9762",
    'project-pages.improvement.feature1': "\u65E0\u9700\u79BB\u5F00 Jira \u5373\u53EF\u8BBF\u95EE\u548C\u521B\u5EFA\u6587\u6863",
    'project-pages.improvement.feature2': "\u63D0\u4F9B\u7528\u4E8E\u4F1A\u8BAE\u3001\u51B2\u523A\u8BA1\u5212\u7B49\u7684\u6A21\u677F",
    'project-pages.improvement.feature3': "\u5C06\u6587\u6863\u540C\u6B65\u5230 Jira \u4EE5\u8FDB\u884C\u81EA\u52A8\u66F4\u65B0",
    'project-pages.improvement.heading-info': "\u638C\u63E1\u56E2\u961F\u7684\u77E5\u8BC6\uFF0C\u5E76\u6539\u8FDB\u5DE5\u4F5C\u7684\u5B8C\u6210\u65B9\u5F0F\u3002",
    'project-pages.improvement.heading-info-v2': "\u4E3A\u56E2\u961F\u7684\u6240\u6709\u9879\u76EE\u6587\u6863\u521B\u5EFA\u4E00\u4E2A\u7EDF\u4E00\u7684\u5B58\u653E\u5904",
    'project-pages.improvement.learn-more-button': "\u4E86\u89E3\u66F4\u591A",
    'project-pages.improvement.powered-by': "\u6280\u672F\u652F\u6301",
    'project-pages.improvement.powered-by.tooltip': "\u5728\u65B0\u6807\u7B7E\u9875\u4E2D\u6253\u5F00 Confluence",
    'project-pages.improvement.preview-teaser': "\u89E3\u9501\u6A21\u677F\u3001\u9879\u76EE\u9875\u9762\u7B49\u3002",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\u901A\u8FC7\u81EA\u52A8\u66F4\u65B0\u72B6\u6001\u6807\u7B7E\u4F7F\u9879\u76EE\u62A5\u544A\u4FDD\u6301\u6700\u65B0\u3002</p><p>\u53EA\u9700\u5728\u6587\u6863\u4E2D\u94FE\u63A5 Jira \u5DE5\u4F5C\u5355\uFF0C\u6587\u6863\u5373\u53EF\u81EA\u52A8\u663E\u793A\u4E0E\u5DE5\u4F5C\u5355\u540C\u6B65\u66F4\u65B0\u7684\u72B6\u6001\u6807\u7B7E\uFF0C\u8FD9\u6837\u60A8\u4FBF\u65E0\u9700\u518D\u82B1\u65F6\u95F4\u521B\u5EFA\u624B\u52A8\u62A5\u544A\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u65E0\u7F1D\u66F4\u65B0\u5229\u76CA\u76F8\u5173\u8005",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\u4F7F\u7528\u6211\u4EEC\u7684\u5185\u7F6E\u6A21\u677F\u521B\u5EFA\u4E00\u81F4\u7684\u6587\u6863\u3002\u8FD9\u4E9B\u6A21\u677F\u4E0D\u4EC5\u6613\u4E8E\u4F7F\u7528\uFF0C\u800C\u4E14\u53EF\u6839\u636E\u60A8\u7684\u9700\u6C42\u8FDB\u884C\u81EA\u5B9A\u4E49\u3002</p><p>\u60A8\u4E0D\u5FC5\u79BB\u5F00\u6B63\u5728\u5904\u7406\u7684\u5DE5\u4F5C\uFF0C\u5373\u53EF\u76F4\u63A5\u5728\u9879\u76EE\u9875\u9762\u4E0A\u4F7F\u7528\u6A21\u677F\u3002\u70B9\u51FB<a>\u6B64\u5904</a>\u53EF\u6D4F\u89C8\u6240\u6709\u6A21\u677F\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u7EDF\u4E00\u6587\u6863\u6807\u51C6",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>\u901A\u8FC7 Jira \u7684\u201C\u9879\u76EE\u9875\u9762\u201D\u9009\u9879\u5361\u521B\u5EFA\u548C\u7BA1\u7406\u6587\u6863\uFF0C\u4ECE\u800C\u4E3A\u91CD\u8981\u4FE1\u606F\u521B\u5EFA\u5355\u4E00\u6570\u636E\u6E90\u3002</p><p>\u60A8\u77E5\u9053\u9879\u76EE\u9875\u9762\u53EF\u5728 Confluence \u4E0A\u8FD0\u884C\u5417\uFF1FConfluence \u6700\u591A\u53EF\u4F9B 10 \u4F4D\u7528\u6237\u514D\u8D39\u4F7F\u7528\u3002\u8BF7\u5728\u201C\u7BA1\u7406\u5458\u8BBE\u7F6E\u201D\u4E2D\u9080\u8BF7\u56E2\u961F\u7684\u5176\u4ED6\u6210\u5458\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u76F4\u63A5\u5728 Jira \u4E2D\u67E5\u770B\u60A8\u7684\u9879\u76EE\u9875\u9762",
    'project-pages.improvement.templates.blank-page.description': "\u4ECE\u5934\u5F00\u59CB\u521B\u5EFA\u4E00\u4E2A\u9875\u9762\u3002",
    'project-pages.improvement.templates.blank-page.name': "\u7A7A\u767D\u9875\u9762",
    'project-pages.improvement.templates.decision.description': "\u8BB0\u5F55\u91CD\u8981\u7684\u9879\u76EE\u51B3\u7B56\uFF0C\u5E76\u5411\u60A8\u7684\u56E2\u961F\u4F20\u8FBE\u3002",
    'project-pages.improvement.templates.decision.name': "\u51B3\u7B56",
    'project-pages.improvement.templates.meeting-notes.description': "\u8BBE\u7F6E\u4F1A\u8BAE\u8BAE\u7A0B\u3001\u505A\u8BB0\u5F55\u5E76\u4E0E\u56E2\u961F\u5206\u4EAB\u884C\u52A8\u4E8B\u9879\u3002",
    'project-pages.improvement.templates.meeting-notes.name': "\u4F1A\u8BAE\u8BB0\u5F55",
    'project-pages.improvement.templates.post-expand.more': "\u66F4\u591A\u6A21\u677F",
    'project-pages.improvement.templates.post-expand.more.tooltip': "\u67E5\u770B Confluence \u4E2D\u7684\u6240\u6709\u6A21\u677F",
    'project-pages.improvement.templates.post-expand.subtitle': "\u70ED\u95E8\u6A21\u677F",
    'project-pages.improvement.templates.post-expand.title': "\u521B\u5EFA\u9875\u9762",
    'project-pages.improvement.templates.pre-expand.more': "\u63A2\u7D22\u66F4\u591A\u6A21\u677F",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u5907\u53D7\u4E0E\u60A8\u7C7B\u4F3C\u56E2\u961F\u7684\u9752\u7750",
    'project-pages.improvement.templates.pre-expand.title': "\u9884\u89C8\u6A21\u677F",
    'project-pages.improvement.templates.product-requirements.description': "\u4E3A\u60A8\u7684\u4EA7\u54C1\u6216\u529F\u80FD\u5B9A\u4E49\u3001\u8FFD\u8E2A\u9700\u6C42\uFF0C\u4EE5\u53CA\u786E\u5B9A\u9700\u6C42\u8303\u56F4\u3002",
    'project-pages.improvement.templates.product-requirements.name': "\u4EA7\u54C1\u9700\u6C42",
    'project-pages.improvement.templates.retrospective.description': "\u54EA\u4E9B\u8FDB\u5C55\u987A\u5229\uFF1F\u54EA\u4E9B\u53EF\u4EE5\u6539\u8FDB\uFF1F\u4E0E\u60A8\u7684\u56E2\u961F\u4E00\u8D77\u4E3A\u6539\u8FDB\u8FDB\u884C\u4F17\u5305\u3002",
    'project-pages.improvement.templates.retrospective.name': "\u56DE\u987E",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u8BF7\u5148\u8FDE\u63A5\u4E00\u4E2A Confluence \u7A7A\u95F4",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\u8282\u7EA6\u65F6\u95F4\uFF0C\u51CF\u5C11\u624B\u52A8\u4EFB\u52A1</b>\u3002Confluence \u6709\u8BB8\u591A\u9875\u9762<a>\u6A21\u677F</a>\u53EF\u4F9B\u4F7F\u7528\uFF0C\u8BA9\u60A8\u6C38\u8FDC\u4E0D\u5FC5\u4ECE\u96F6\u5F00\u59CB\u3002\u96C6\u4E2D\u7CBE\u529B\u6784\u601D\u6280\u672F\u6587\u6863\u3001\u6545\u969C\u6392\u9664\u6307\u5357\u3001\u9879\u76EE\u8BA1\u5212\u3001\u4EA7\u54C1\u9700\u6C42\u548C\u66F4\u591A\u5185\u5BB9\u3002",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u8F7B\u677E\u7F16\u8F91\u5E76\u8BBE\u7F6E\u683C\u5F0F\u3002</b>\u4F7F\u7528\u9876\u90E8\u7684\u7F16\u8F91\u83DC\u5355\u8C03\u6574\u6807\u51C6\u6587\u672C\u683C\u5F0F\uFF0C\u8F93\u5165 <b>/</b> \u4FBF\u53EF\u8F7B\u677E\u63D2\u5165\u5927\u91CF\u6613\u4E8E\u4F7F\u7528\u7684\u96C6\u6210\u3002\u8F93\u5165\u201C<c>/\u8868\u683C</c>\u201D\u4EE5\u63D2\u5165\u8868\u683C\uFF0C\u6216\u662F\u8F93\u5165\u201C<c>/\u56FE\u7247</c>\u201D\u4EE5\u63D2\u5165\u56FE\u7247\u3002\u60A8\u4E5F\u53EF\u4EE5\u63D2\u5165 Dropbox \u94FE\u63A5 (<c>/dropbox</c>)\u3001Microsoft Office \u5DE5\u5177 (<c>/microsoft</c>) \u6216 Trello \u9762\u677F\u548C\u5361\u7247 (<c>/trello</c>)\u3002",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u8F93\u5165 /\uFF0C\u540E\u63A5\u201C\u8868\u683C\u201D\u6216\u201C\u56FE\u7247\u201D",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u4EE5\u4E0B\u662F\u4E00\u4E9B\u5165\u95E8\u6280\u5DE7\uFF1A",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u6613\u4E8E\u4F7F\u7528\u7684\u94FE\u63A5",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "\u642D\u914D\u4F7F\u7528 Jira \u548C Confluence",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u4F7F\u7528\u771F\u5B9E\u7684 Jira \u6570\u636E\u5728\u60A8\u7684\u9875\u9762\u4E0A\u521B\u5EFA\u56FE\u8868\u3002\u8F93\u5165 <c>/Jira \u56FE\u8868</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u5728\u60A8\u9875\u9762\u4E0A\u7684\u4EFB\u610F\u4F4D\u7F6E\u5173\u8054 Jira \u4E8B\u52A1\u3002\u5728\u60A8\u66F4\u65B0 Jira \u4E8B\u52A1\u65F6\uFF0C\u9875\u9762\u4E0A\u7684\u94FE\u63A5\u4E5F\u4F1A\u5B9E\u65F6\u66F4\u65B0\u3002\u8F93\u5165 <c>/Jira</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u4F7F\u7528 Jira \u9879\u76EE\u4E3A\u60A8\u7684\u9875\u9762\u5D4C\u5165\u4EA4\u4E92\u5F0F\u8DEF\u7EBF\u56FE\u548C\u65F6\u95F4\u7EBF\u3002\u8F93\u5165 <c>/jira \u8DEF\u7EBF\u56FE</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u4F7F\u7528 Jira \u9879\u76EE\u4E3A\u60A8\u7684\u9875\u9762\u5D4C\u5165\u65F6\u95F4\u7EBF\u3002\u8F93\u5165 <c>/jira \u65F6\u95F4\u7EBF</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76% \u7684 Jira Software \u5BA2\u6237\u8868\u793A\uFF0C\u6DFB\u52A0 Confluence \u540E\uFF0C\u4ED6\u4EEC\u53EF\u4EE5\u66F4\u5FEB\u5730\u4EA4\u4ED8\u9879\u76EE\u3002",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76% \u7684 Jira \u5BA2\u6237\u8868\u793A\uFF0C\u6DFB\u52A0 Confluence \u540E\uFF0C\u4ED6\u4EEC\u53EF\u4EE5\u66F4\u5FEB\u5730\u4EA4\u4ED8\u9879\u76EE",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\u4F7F\u7528\u7A7A\u95F4\u548C\u9875\u9762</b>\u3002\u7A7A\u95F4\u662F\u6240\u6709 Confluence \u7AD9\u70B9\u7684\u7EC4\u6210\u90E8\u5206\uFF0C\u540C\u65F6\u4E5F\u662F\u6309\u7C7B\u522B\u6574\u7406\u9875\u9762\u7684\u4E00\u79CD\u65B9\u5F0F\u3002\u60A8\u53EF\u5C06\u7A7A\u95F4\u89C6\u4E3A\u4E0D\u540C\u7684\u6587\u4EF6\u5939\u6216\u9879\u76EE\uFF0C\u800C\u9875\u9762\u5219\u662F\u6536\u7EB3\u5728\u8FD9\u4E9B\u6587\u4EF6\u5939\u6216\u9879\u76EE\u4E2D\u7684\u6587\u6863\u3002<a>\u4E86\u89E3\u6709\u5173\u7A7A\u95F4\u4F7F\u7528\u65B9\u6CD5\u7684\u66F4\u591A\u4FE1\u606F</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u7ACB\u5373\u8BD5\u7528",
    'project-pages.improvement.templates.tutorial.description': "\u4E86\u89E3\u5982\u4F55\u7F16\u8F91\u9875\u9762\u3002",
    'project-pages.improvement.templates.tutorial.name': "\u6B22\u8FCE\u8BBF\u95EE\u201C\u9879\u76EE\u9875\u9762\u201D\uFF01",
    'project-pages.improvement.terms-and-conditions-v2': "\u9009\u62E9\u201C\u7ACB\u5373\u8BD5\u7528\u201D\uFF0C\u5373\u8868\u793A\u60A8\u786E\u8BA4\u60A8\u5C06\u6CE8\u518C Confluence\uFF0C\u5E76\u540C\u610F Atlassian <termsLink>Cloud \u670D\u52A1\u6761\u6B3E</termsLink>\u548C<privacyLink>\u9690\u79C1\u653F\u7B56</privacyLink>\u3002",
    'project-pages.improvement.title': "\u9879\u76EE\u9875\u9762",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u521B\u5EFA\u9875\u9762",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\u6211\u4EEC\u5DF2\u6DFB\u52A0 Confluence\uFF0C\u4EE5\u4FBF\u60A8\u5F00\u59CB\u521B\u5EFA\u5E76\u94FE\u63A5\u6240\u6709\u9879\u76EE\u6587\u6863\u3002\u5BF9\u6700\u591A 10 \u540D\u7528\u6237\u514D\u8D39\u3002",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u4E86\u89E3\u66F4\u591A",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u521B\u5EFA\u60A8\u7684\u9996\u4E2A\u9875\u9762",
    'project-pages.improvement.transient-states.empty-state.description': "\u521B\u5EFA\u4E00\u4E9B\u4F1A\u8BAE\u8BB0\u5F55\u3001\u4EA7\u54C1\u9700\u6C42\u3001\u51B3\u5B9A\u6216\u5176\u4ED6\u5185\u5BB9\u6765\u5145\u5B9E\u8BE5\u7A7A\u95F4\u3002",
    'project-pages.improvement.transient-states.empty-state.title': "\u65E0\u9650\u6F5C\u529B\uFF0C\u5C3D\u5F85\u6316\u6398",
    'project-pages.improvement.try-button': "\u5728 Confluence \u4E2D\u8BD5\u7528\u6B64\u6A21\u677F",
    'project-pages.improvement.try-it-now': "\u7ACB\u5373\u8BD5\u7528",
    'project-pages.improvement.try-lozenge': "\u8BD5\u7528",
    'project-pages.improvement.try-on-demand-button': "\u514D\u8D39\u8BD5\u7528",
    'project-pages.page-deleted-flag.title': "\u9875\u9762\u5DF2\u5220\u9664\u3002",
    'project-pages.page-published-flag.title': "\u60A8\u7684\u9875\u9762\u5DF2\u53D1\u5E03\u3002",
    'project-pages.unknown-error.description': "\u5982\u679C\u5237\u65B0\u65E0\u6CD5\u4FEE\u590D\u95EE\u9898\uFF0C\u5219\u8BF7{contactSupport}\u3002",
    'project-pages.unknown-error.heading': "\u5F53\u524D\u65E0\u6CD5\u663E\u793A\u9879\u76EE\u9875\u9762",
    'projectpages.templatepreview.termsandprivacy': "\u70B9\u51FB\u201C\u514D\u8D39\u8BD5\u7528\u201D\uFF0C\u5373\u8868\u793A\u60A8\u5C06\u6CE8\u518C Confluence \u5E76\u540C\u610F Atlassian <termsOfServiceLinkText>Cloud \u670D\u52A1\u6761\u6B3E</termsOfServiceLinkText>\u548C<privacyPolicyLinkText>\u9690\u79C1\u653F\u7B56</privacyPolicyLinkText>\u3002"
};

});

parcelRegister("1tgRg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9388a52d79619a5f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $9388a52d79619a5f$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u4E0D\u5230\u4E00\u5206\u9418\u5373\u53EF\u5B8C\u6210",
    'confluence.project-pages.improvement.provisioning-background.title': "\u8A2D\u5B9A\u60A8\u7684\u5C08\u6848\u9801\u9762",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u95DC\u9589",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u5B8C\u6210",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u4E0B\u4E00\u6B65",
    'project-pages.activating.description': "\u9023\u7D50\u7684 Confuence \u7A7A\u9593\u5C1A\u672A\u5C31\u7DD2\u3002\u5982\u679C\u91CD\u65B0\u6574\u7406\u7121\u6CD5\u89E3\u6C7A\u554F\u984C\uFF0C\u8ACB{contactSupport}",
    'project-pages.activating.heading': "Confluence \u9084\u5728\u8F09\u5165\u4E2D",
    'project-pages.button.connect-different-space-or-page.label': "\u66F4\u65B0\u7A7A\u9593\u6216\u9801\u9762\u5716\u793A",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u9023\u7D50\u4E0D\u540C\u7684\u7A7A\u9593\u6216\u9801\u9762",
    'project-pages.button.connect-space-or-page.tooltip': "\u9023\u7D50\u81F3 Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "\u958B\u555F Confluence \u4E2D\u7684\u9801\u9762",
    'project-pages.button.go-to-connected-space.tooltip': "\u958B\u555F Confluence \u4E2D\u7684\u7A7A\u9593",
    'project-pages.connect-space-dialog.connection-error': "\u9023\u7D50\u5931\u6557\u3002",
    'project-pages.connect-space-dialog.connection-retry': "\u91CD\u8A66",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u9078\u64C7\u8981\u8207\u5C08\u6848\u9023\u7D50\u7684\u7A7A\u9593\u6216\u9801\u9762\u3002",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "\u641C\u5C0B Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u6B64\u5C08\u6848\u9700\u5148\u9023\u7D50\u81F3\u7A7A\u9593\uFF0C\u624D\u53EF\u5EFA\u7ACB\u9801\u9762\u3002\u9078\u64C7\u8981\u9023\u7D50\u81F3\u6B64\u5C08\u6848\u7684\u7A7A\u9593\u3002",
    'project-pages.connect-space-dialog.error-icon': "\u932F\u8AA4\uFF1A",
    'project-pages.connect-space-dialog.footer.cancel': "\u53D6\u6D88",
    'project-pages.connect-space-dialog.footer.connect-space': "\u9023\u7D50",
    'project-pages.connect-space-or-page-dialog.header.title': "\u5C07\u5C08\u6848\u8207 Confluence \u9023\u7D50",
    'project-pages.connect-space.description': "\u7A7A\u9593\u5982\u540C\u8CC7\u6599\u593E - \u60A8\u53EF\u4F7F\u7528\u7A7A\u9593\u4F86\u5EFA\u7ACB\u3001\u6574\u7406\u548C\u5354\u4F5C\u8207\u5C08\u6848\u76F8\u95DC\u7684\u6240\u6709\u5167\u5BB9\u3002",
    'project-pages.connect-space.not-connected.description': "\u82E5\u8981\u4F7F\u7528\u5C08\u6848\u9801\u9762\uFF0C\u8ACB\u8981\u6C42\u60A8\u7684\u7BA1\u7406\u54E1\u6216\u5718\u968A\u8CA0\u8CAC\u4EBA\u5C07 Confluence \u9023\u7D50\u5230\u6B64\u5C08\u6848\u3002",
    'project-pages.connect-space.not-connected.heading': "\u672A\u9023\u7D50\u81F3 Confluence",
    'project-pages.connect-success-flag.description.content': "\u5DF2\u6210\u529F\u9023\u7D50 {connectedSpaceOrPageName} \u5167\u5BB9\u3002",
    'project-pages.connection-error.space-or-page-not-found.button': "\u9023\u7D50\u81F3\u4E0D\u540C\u7684\u7A7A\u9593\u6216\u9801\u9762",
    'project-pages.create-space-dialog.connection-error': "\u9023\u7D50\u5931\u6557\u3002",
    'project-pages.create-space-dialog.connection-retry': "\u91CD\u8A66",
    'project-pages.create-space-dialog.content.empty-name': "\u8ACB\u70BA\u60A8\u7684\u7A7A\u9593\u547D\u540D\u3002",
    'project-pages.create-space-dialog.content.invalid-name': "\u7A7A\u9593\u540D\u7A31\u5FC5\u9808\u5305\u542B\u81F3\u5C11\u4E00\u500B\u5B57\u6BCD\u6216\u6578\u5B57\u3002",
    'project-pages.create-space-dialog.content.placeholder': "\u8F38\u5165\u7A7A\u9593\u540D\u7A31",
    'project-pages.create-space-dialog.creation-error': "\u7A7A\u9593\u5EFA\u7ACB\u5931\u6557\u3002",
    'project-pages.create-space-dialog.error-icon': "\u932F\u8AA4\uFF1A",
    'project-pages.create-space-dialog.footer.cancel': "\u53D6\u6D88",
    'project-pages.create-space-dialog.footer.create-space': "\u5EFA\u7ACB",
    'project-pages.create-space-dialog.header.title': "\u5EFA\u7ACB\u65B0\u7684 Confluence \u7A7A\u9593",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u60A8\u7121\u6CD5\u4F7F\u7528\u5C08\u6848\u9801\u9762\uFF0C\u56E0\u70BA\u7BA1\u7406\u54E1\u5DF2\u62D2\u7D55\u60A8\u5B58\u53D6 Confluence\u3002\u8ACB\u9023\u7D61\u60A8\u7684\u7DB2\u7AD9\u7BA1\u7406\u54E1\u4EE5\u8981\u6C42\u5B58\u53D6\u6B0A\u3002",
    'project-pages.cross-join.access-revoked.templates.title': "\u60A8\u6C92\u6709\u6B0A\u9650\uFF0C\u7121\u6CD5\u4F7F\u7528\u5C08\u6848\u9801\u9762",
    'project-pages.cross-join.avatar.view-profile': "\u6AA2\u8996\u8A2D\u5B9A\u6A94",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u60A8\u7121\u6CD5\u4F7F\u7528\u5C08\u6848\u9801\u9762\uFF0C\u56E0\u70BA\u7DB2\u7AD9\u7BA1\u7406\u54E1\u5DF2\u62D2\u7D55\u60A8\u52A0\u5165 Confluence \u7684\u8981\u6C42\u3002",
    'project-pages.cross-join.denied-request.templates.title': "\u7BA1\u7406\u54E1\u5DF2\u62D2\u7D55\u60A8\u7684\u5B58\u53D6",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "\u60A8\u5C07\u53D6\u5F97 Confluence \u7684\u5B58\u53D6\u6B0A\u3002\u7DB2\u7AD9\u7BA1\u7406\u54E1\u5DF2\u5C07\u60A8\u6838\u51C6\u3002",
    'project-pages.cross-join.errors.unknown-error.description': "\u5982\u679C\u91CD\u65B0\u6574\u7406\u7121\u6CD5\u4FEE\u6B63\u554F\u984C\uFF0C\u8ACB{contactSupport}\u3002",
    'project-pages.cross-join.errors.unknown-error.title': "\u73FE\u5728\u7121\u6CD5\u986F\u793A\u5C08\u6848\u9801\u9762",
    'project-pages.cross-join.inline-join-product.button': "\u5B58\u53D6 Confluence\u3002\u7DB2\u7AD9\u7BA1\u7406\u54E1\u5DF2\u5C07\u60A8\u6838\u51C6\u3002",
    'project-pages.cross-join.inline-join-product.connected.description': "\u5F9E\u55AE\u4E00\u4F4D\u7F6E\u6AA2\u8996\u3001\u7DE8\u8F2F\u548C\u5EFA\u7ACB\u8AAA\u660E\u6587\u4EF6",
    'project-pages.cross-join.inline-join-product.connected.title': "\u8207\u60A8\u7684\u5718\u968A\u5728\u5C08\u6848\u9801\u9762\u4E0A\u5171\u540C\u4F5C\u696D",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u7DB2\u7AD9\u7BA1\u7406\u54E1\u5DF2\u6536\u5230\u60A8\u8981\u52A0\u5165 Confluence \u7684\u8981\u6C42\u3002\u5982\u679C\u60A8\u5DF2\u7372\u5F97\u52A0\u5165\u7684\u6838\u51C6\uFF0C\u5C08\u6848\u9801\u9762\u6703\u958B\u59CB\u904B\u4F5C\uFF0C\u800C\u6211\u5011\u6703\u5C07\u78BA\u8A8D\u96FB\u5B50\u90F5\u4EF6\u50B3\u9001\u7D66\u60A8\u3002",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\u60A8\u7372\u5F97\u6838\u51C6\u5F8C\uFF0C\u5C07\u6536\u5230\u4E00\u5C01\u96FB\u5B50\u90F5\u4EF6\uFF0C\u5176\u4E2D\u5305\u542B\u300C\u5C08\u6848\u9801\u9762\u300D\u7684\u5B58\u53D6\u6B0A\u3002",
    'project-pages.cross-join.pending-request.templates.title': "\u60A8\u5DF2\u8981\u6C42 Confluence \u7684\u5B58\u53D6\u6B0A",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u5B58\u53D6\u6B0A\u8981\u6C42\u5DF2\u50B3\u9001\u7D66\u7BA1\u7406\u54E1",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u8207\u60A8\u7684\u5718\u968A\u4E00\u8D77\u6AA2\u8996\u3001\u7DE8\u8F2F\u548C\u5EFA\u7ACB\u5C08\u6848\u8AAA\u660E\u6587\u4EF6",
    'project-pages.cross-join.request-access.button': "\u8981\u6C42\u5B58\u53D6\u6B0A",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "\u7576\u60A8\u9078\u53D6\u300C\u52A0\u5165\u60A8\u7684\u5718\u968A\u300D\u6642\uFF0C\u5373\u8868\u793A\u60A8\u8981\u6C42\u52A0\u5165 Confluence\uFF0C\u4E26\u540C\u610F\u8207\u7BA1\u7406\u54E1\u5206\u4EAB\u60A8\u7684 Atlassian \u8A2D\u5B9A\u6A94\u3002",
    'project-pages.cross-join.request-access.button.experimental': "\u52A0\u5165\u60A8\u7684\u5718\u968A",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u60A8\u7684\u5718\u968A\u6B63\u5728\u4F7F\u7528\u300C\u5C08\u6848\u9801\u9762\u300D\uFF0C\u5728\u5C08\u6848\u8AAA\u660E\u6587\u4EF6\u4E0A\u7559\u8A00\u3001\u7DE8\u8F2F\u548C\u5354\u4F5C\uFF0C\u5168\u90FD\u7121\u9808\u96E2\u958B Jira\u3002\u52A0\u5165 Confluence \u5373\u53EF\u5B58\u53D6\u60A8\u5C08\u6848\u7684\u300C\u5C08\u6848\u9801\u9762\u300D\u3002",
    'project-pages.cross-join.request-access.title': "\u5C08\u6848\u9801\u9762\u9700\u8981 Confluence \u7684\u5B58\u53D6\u6B0A",
    'project-pages.cross-join.request-access.title.experiment': "\u70BA\u60A8\u7684\u5718\u968A\u5EFA\u7ACB\u55AE\u4E00\u4E8B\u5BE6\u4F86\u6E90",
    'project-pages.default-contextual-heading': "\u5C08\u6848\u9801\u9762\u7531 Confluence \u6280\u8853\u652F\u63F4",
    'project-pages.default-contextual-message': "Confluence \u9801\u9762\u8B93\u60A8\u80FD\u5728\u540C\u4E00\u500B\u5730\u65B9\u5EFA\u7ACB\u3001\u5206\u4EAB\u4E26\u5354\u4F5C\u60A8\u6240\u6709\u7684\u5C08\u6848\u6587\u4EF6\u3002",
    'project-pages.default-reactivate-CTA': "\u91CD\u65B0\u555F\u7528 Confluence",
    'project-pages.default-trial-CTA': "\u514D\u8CBB\u8A66\u7528 30 \u5929 Confluence",
    'project-pages.draft-saved-flag.action': "\u958B\u555F\u8349\u7A3F",
    'project-pages.draft-saved-flag.description': "\u60A8\u7684\u8349\u7A3F\u5728\u767C\u4F48\u4E4B\u524D\uFF0C\u53EA\u6709\u60A8\u770B\u5F97\u5230\u3002",
    'project-pages.draft-saved-flag.title': "\u5DF2\u5132\u5B58\u8349\u7A3F",
    'project-pages.embedded-pages.create-page-error.close-button': "\u95DC\u9589",
    'project-pages.embedded-pages.create-page-error.description': "\u767C\u751F\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u70BA\u60A8\u5EFA\u7ACB\u9801\u9762\u3002",
    'project-pages.embedded-pages.create-page-error.title': "\u6211\u5011\u7121\u6CD5\u5EFA\u7ACB\u9801\u9762",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u518D\u8A66\u4E00\u6B21",
    'project-pages.embedded-pages.modal.close.button.hint': "\u95DC\u9589",
    'project-pages.embedded-pages.modal.title.button': "\u5728 Confluence \u4E2D\u958B\u555F",
    'project-pages.embedded-pages.modal.title.button.hint': "\u5728\u65B0\u7D22\u5F15\u6A19\u7C64\u4E2D\u958B\u555F",
    'project-pages.errors.unknown-error.description.non-final': "\u5982\u679C\u91CD\u65B0\u6574\u7406\u7121\u6CD5\u89E3\u6C7A\u554F\u984C\uFF0C\u8ACB{contactSupport}",
    'project-pages.errors.unknown-error.title.non-final': "\u73FE\u5728\u7121\u6CD5\u986F\u793A\u5C08\u6848\u9801\u9762",
    'project-pages.generic-error.button.reload': "\u91CD\u65B0\u8F09\u5165\u9801\u9762",
    'project-pages.generic-error.description': "\u767C\u751F\u932F\u8AA4\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'project-pages.generic-error.description.non-final': "\u767C\u751F\u932F\u8AA4\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'project-pages.generic-error.heading': "\u55EF\uFF0C\u9019\u6709\u9EDE\u5947\u602A...",
    'project-pages.generic-error.title.non-final': "\u55EF\uFF0C\u9019\u6709\u9EDE\u5947\u602A...",
    'project-pages.generic-info-flag.description': "\u767C\u751F\u932F\u8AA4\u3002\u5982\u679C\u554F\u984C\u4ECD\u7136\u5B58\u5728\uFF0C\u8ACB\u518D\u8A66\u4E00\u6B21\u6216\u9023\u7D61\u652F\u63F4\u4EBA\u54E1",
    'project-pages.generic-success-flag.description.page': "\u5DF2\u6210\u529F\u9023\u7D50 {connectedSpaceOrPageName} \u9801\u9762\u3002",
    'project-pages.generic-success-flag.description.space': "\u5DF2\u6210\u529F\u8207 {connectedSpaceOrPageName} \u7A7A\u9593\u9023\u7D50\u3002",
    'project-pages.generic-success-flag.heading.page': "\u9801\u9762\u5DF2\u9023\u7D50",
    'project-pages.generic-success-flag.heading.space': "\u7A7A\u9593\u5DF2\u9023\u7D50",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u6216\u5EFA\u7ACB\u65B0\u7A7A\u9593",
    'project-pages.granular-pages.connect-space.button': "\u9023\u7D50\u81F3 Confluence",
    'project-pages.granular-pages.connect-space.heading': "\u5C07\u6B64\u5C08\u6848\u9023\u7D50\u81F3 Confluence \u7A7A\u9593\u6216\u9801\u9762",
    'project-pages.granular-pages.connect-space.heading.non-final': "\u5C07\u6B64\u5C08\u6848\u9023\u7D50\u81F3 Confluence \u7A7A\u9593\u6216\u9801\u9762",
    'project-pages.improvement.contact-support': "\u9023\u7D61\u652F\u63F4\u4EBA\u54E1",
    'project-pages.improvement.errors.access-error.description': "\u8ACB\u5617\u8A66\u8207\u7DB2\u7AD9\u7BA1\u7406\u54E1\u9023\u7D61\u4EE5\u8ACB\u6C42\u5B58\u53D6\u6B0A\u3002",
    'project-pages.improvement.errors.access-error.title': "\u60A8\u6C92\u6709\u6AA2\u8996\u5C08\u6848\u9801\u9762\u7684\u6B0A\u9650",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u5617\u8A66\u5F9E\u60A8\u9023\u7D50\u7684 Confluence \u7A7A\u9593\u986F\u793A\u9801\u9762\u6642\u767C\u751F\u932F\u8AA4\u3002\u5982\u679C\u91CD\u65B0\u6574\u7406\u7121\u6CD5\u89E3\u6C7A\u554F\u984C\uFF0C\u8ACB{contactSupport}",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u986F\u793A\u5C08\u6848\u9801\u9762\u6642\u767C\u751F\u554F\u984C",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u9023\u7D50\u7684 Confluence \u7A7A\u9593\u6216\u9801\u9762\u5DF2\u79FB\u52D5\u3001\u5C01\u5B58\u6216\u522A\u9664\u3002\u5982\u679C\u91CD\u65B0\u9023\u7D50\u7121\u6CD5\u89E3\u6C7A\u554F\u984C\uFF0C\u8ACB<link>\u9023\u7D61\u652F\u63F4\u5718\u968A</link>",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u627E\u4E0D\u5230\u7A7A\u9593\u6216\u9801\u9762",
    'project-pages.improvement.errors.unknown-error.description': "\u5982\u679C\u91CD\u65B0\u6574\u7406\u7121\u6CD5\u89E3\u6C7A\u554F\u984C\uFF0C\u8ACB{contactSupport}",
    'project-pages.improvement.errors.unknown-error.title': "\u73FE\u5728\u7121\u6CD5\u986F\u793A\u5C08\u6848\u9801\u9762",
    'project-pages.improvement.feature1': "\u7121\u9700\u96E2\u958B Jira \u5373\u53EF\u5B58\u53D6\u548C\u5EFA\u7ACB\u6587\u4EF6",
    'project-pages.improvement.feature2': "\u9069\u7528\u65BC\u6703\u8B70\u548C\u885D\u523A\u8A08\u756B\u7B49\u7528\u9014\u7684\u7BC4\u672C",
    'project-pages.improvement.feature3': "\u5C07\u6587\u4EF6\u540C\u6B65\u5230 Jira \u4EE5\u81EA\u52D5\u66F4\u65B0",
    'project-pages.improvement.heading-info': "\u638C\u63E1\u60A8\u7684\u5718\u968A\uFF0C\u4E26\u6539\u5584\u5B8C\u6210\u5DE5\u4F5C\u7684\u65B9\u5F0F\u3002",
    'project-pages.improvement.heading-info-v2': "\u70BA\u5718\u968A\u7684\u6240\u6709\u5C08\u6848\u6587\u4EF6\u5EFA\u7ACB\u55AE\u4E00\u4F4D\u7F6E",
    'project-pages.improvement.learn-more-button': "\u4E86\u89E3\u66F4\u591A",
    'project-pages.improvement.powered-by': "\u7531\u4EE5\u4E0B\u6280\u8853\u652F\u63F4\uFF1A",
    'project-pages.improvement.powered-by.tooltip': "\u5728\u65B0\u7684\u7D22\u5F15\u6A19\u7C64\u4E2D\u958B\u555F Confluence",
    'project-pages.improvement.preview-teaser': "\u89E3\u9396\u7BC4\u672C\u3001\u5C08\u6848\u9801\u9762\u7B49\u7B49\u3002",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\u900F\u904E\u81EA\u52D5\u66F4\u65B0\u72C0\u614B\u6A19\u7C64\uFF0C\u8B93\u5C08\u6848\u5831\u544A\u4FDD\u6301\u6700\u65B0\u72C0\u614B\u3002</p><p>\u53EA\u9700\u5C07 Jira \u5DE5\u55AE\u9023\u7D50\u5230\u6587\u4EF6\u4E2D\uFF0C\u5C31\u6703\u81EA\u52D5\u986F\u793A\u8207\u5DE5\u55AE\u540C\u6B65\u66F4\u65B0\u7684\u72C0\u614B\u6A19\u7C64\uFF0C\u56E0\u6B64\u60A8\u53EF\u4EE5\u7701\u4E0B\u624B\u52D5\u88FD\u4F5C\u5831\u544A\u7684\u6642\u9593\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u7ACB\u5373\u544A\u77E5\u76F8\u95DC\u4EBA\u54E1",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\u4F7F\u7528\u6211\u5011\u7684\u5167\u5EFA\u7BC4\u672C\u5EFA\u7ACB\u4E00\u81F4\u7684\u8AAA\u660E\u6587\u4EF6\u3002\u9019\u4E9B\u7BC4\u672C\u4F7F\u7528\u65B9\u4FBF\uFF0C\u60A8\u53EF\u4EE5\u6839\u64DA\u9700\u6C42\u81EA\u8A02\u3002</p><p>\u60A8\u53EF\u4EE5\u76F4\u63A5\u5F9E\u5C08\u6848\u9801\u9762\u4F7F\u7528\u7BC4\u672C\uFF0C\u56E0\u6B64\u60A8\u4E0D\u5FC5\u96E2\u958B\u6B63\u5728\u5DE5\u4F5C\u7684\u5167\u5BB9\u3002<a>\u6B64\u8655</a>\u53EF\u700F\u89BD\u6240\u6709\u7BC4\u672C\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u7D71\u4E00\u60A8\u7684\u8AAA\u660E\u6587\u4EF6\u6A19\u6E96",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>\u5F9E Jira \u4E2D\u7684\u5C08\u6848\u9801\u9762\u5206\u9801\u4E2D\u5EFA\u7ACB\u548C\u7BA1\u7406\u8AAA\u660E\u6587\u4EF6\uFF0C\u4EE5\u5EFA\u7ACB\u91CD\u8981\u8CC7\u8A0A\u7684\u55AE\u4E00\u4E8B\u5BE6\u4F86\u6E90\u3002</p><p>\u60A8\u77E5\u9053\u5C08\u6848\u9801\u9762\u662F\u5728 Confluence \u4E0A\u57F7\u884C\u55CE\uFF1F\u6700\u591A\u53EF\u4F9B 10 \u4F4D\u4F7F\u7528\u8005\u514D\u8CBB\u4F7F\u7528\u3002\u8ACB\u5728\u7BA1\u7406\u54E1\u8A2D\u5B9A\u4E2D\u9080\u8ACB\u5718\u968A\u7684\u5176\u4ED6\u4EBA\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u60A8\u7684\u5C08\u6848\u9801\u9762\uFF0C\u5C31\u5728 Jira",
    'project-pages.improvement.templates.blank-page.description': "\u5F9E\u982D\u958B\u59CB\u5EFA\u7ACB\u4E00\u500B\u9801\u9762",
    'project-pages.improvement.templates.blank-page.name': "\u7A7A\u767D\u9801\u9762",
    'project-pages.improvement.templates.decision.description': "\u8A18\u9304\u91CD\u8981\u7684\u5C08\u6848\u6C7A\u5B9A\uFF0C\u4E26\u8207\u60A8\u7684\u5718\u968A\u9032\u884C\u6E9D\u901A\u3002",
    'project-pages.improvement.templates.decision.name': "\u6C7A\u5B9A",
    'project-pages.improvement.templates.meeting-notes.description': "\u8A2D\u5B9A\u6703\u8B70\u8B70\u7A0B\u3001\u505A\u7B46\u8A18\uFF0C\u4E26\u5C07\u4EA4\u8FA6\u4E8B\u9805\u5206\u4EAB\u7D66\u60A8\u7684\u5718\u968A\u3002",
    'project-pages.improvement.templates.meeting-notes.name': "\u6703\u8B70\u7B46\u8A18",
    'project-pages.improvement.templates.post-expand.more': "\u66F4\u591A\u7BC4\u672C",
    'project-pages.improvement.templates.post-expand.more.tooltip': "\u6AA2\u8996 Confluence \u4E2D\u6240\u6709\u7684\u7BC4\u672C",
    'project-pages.improvement.templates.post-expand.subtitle': "\u71B1\u9580\u7BC4\u672C",
    'project-pages.improvement.templates.post-expand.title': "\u5EFA\u7ACB\u9801\u9762",
    'project-pages.improvement.templates.pre-expand.more': "\u63A2\u7D22\u66F4\u591A\u7684\u7BC4\u672C",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u53D7\u5230\u50CF\u60A8\u5011\u9019\u6A23\u7684\u5718\u968A\u6B61\u8FCE\u3002",
    'project-pages.improvement.templates.pre-expand.title': "\u9810\u89BD\u7BC4\u672C",
    'project-pages.improvement.templates.product-requirements.description': "\u70BA\u60A8\u7684\u7522\u54C1\u6216\u529F\u80FD\u5B9A\u7FA9\u3001\u8FFD\u8E64\u548C\u9650\u5B9A\u9700\u6C42\u7BC4\u570D\u3002",
    'project-pages.improvement.templates.product-requirements.name': "\u7522\u54C1\u9700\u6C42",
    'project-pages.improvement.templates.retrospective.description': "\u9806\u5229\u55CE\uFF1F\u9084\u6709\u4EC0\u9EBC\u53EF\u4EE5\u6539\u9032\uFF1F\u8207\u60A8\u7684\u5718\u968A\u96C6\u601D\u5EE3\u76CA\u5982\u4F55\u6539\u9032\u3002",
    'project-pages.improvement.templates.retrospective.name': "\u56DE\u9867",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u8ACB\u5148\u8207 Confluence \u7A7A\u9593\u9023\u7D50",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\u7BC0\u7701\u6642\u9593\u4E26\u6E1B\u5C11\u624B\u52D5\u4EFB\u52D9</b>\u3002Confluence \u6709\u5F88\u591A\u9801\u9762<a>\u7BC4\u672C</a>\uFF0C\u56E0\u6B64\u60A8\u7121\u9808\u5F9E\u982D\u958B\u59CB\u3002\u6709\u6280\u8853\u6587\u4EF6\u3001\u7591\u96E3\u6392\u89E3\u6307\u5357\u3001\u5C08\u6848\u8A08\u756B\u3001\u7522\u54C1\u9700\u6C42\u7B49\u591A\u7A2E\u7BC4\u672C\u3002",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u8F15\u9B06\u7DE8\u8F2F\u548C\u8A2D\u5B9A\u683C\u5F0F\u3002</b>\u4F7F\u7528\u9802\u7AEF\u7684\u7DE8\u8F2F\u9078\u55AE\u8A2D\u5B9A\u6A19\u6E96\u7684\u6587\u5B57\u683C\u5F0F\uFF0C\u4E26\u900F\u904E\u8F38\u5165 <b>/</b> \u8F15\u9B06\u63D2\u5165\u8A31\u591A\u5BE6\u7528\u7684\u6574\u5408\u529F\u80FD\u3002\u8F38\u5165 <c>/table</c> \u5373\u53EF\u63D2\u5165\u8868\u683C\uFF0C\u8F38\u5165 <c>/image</c> \u5373\u53EF\u63D2\u5165\u5716\u7247\u3002\u60A8\u9084\u53EF\u4EE5\u4F7F\u7528 <c>/dropbox</c> \u63D2\u5165 Dropbox \u9023\u7D50\u3001\u4F7F\u7528 <c>/microsoft</c> \u63D2\u5165 Microsoft office \u5DE5\u5177\uFF0C\u6216\u4F7F\u7528 <c>/trello</c> \u63D2\u5165 Trello \u770B\u677F\u548C\u5361\u7247\u3002",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u8F38\u5165 / \u5F8C\u65B9\u63A5\u8457 \u2018table\u2019 \u6216 \u2018image\u2019",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u9019\u88E1\u6709\u5E7E\u500B\u63D0\u793A\uFF0C\u53EF\u5354\u52A9\u60A8\u958B\u59CB\uFF1A",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u5BE6\u7528\u7684\u9023\u7D50",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "\u4E00\u8D77\u4F7F\u7528 Jira \u548C Confluence",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u4F7F\u7528\u5BE6\u969B\u7684 Jira \u8CC7\u6599\uFF0C\u5728\u9801\u9762\u4E0A\u5EFA\u7ACB\u5716\u8868\u3002\u8F38\u5165 <c>/Jira charts</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u5728\u9801\u9762\u4E0A\u7684\u4EFB\u4F55\u4F4D\u7F6E\u9023\u7D50 Jira \u8B70\u984C\u3002\u7576\u60A8\u66F4\u65B0 Jira \u8B70\u984C\u6642\uFF0C\u9801\u9762\u4E0A\u7684\u9023\u7D50\u5C07\u5373\u6642\u66F4\u65B0\u3002\u8F38\u5165 <c>/Jira</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u4F7F\u7528 Jira \u5C08\u6848\u70BA\u60A8\u7684\u9801\u9762\u5D4C\u5165\u4E92\u52D5\u5F0F\u7684\u85CD\u5716\u548C\u6642\u9593\u8868\u3002\u8F38\u5165 <c>/jira roadmap</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u4F7F\u7528 Jira \u5C08\u6848\u70BA\u60A8\u7684\u9801\u9762\u5D4C\u5165\u4E92\u52D5\u5F0F\u6642\u9593\u8EF8\u3002\u8ACB\u8F38\u5165 <c>/jira \u6642\u9593\u8EF8</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\uFF05 \u7684 Jira Software \u5BA2\u6236\u8868\u793A\uFF0C\u4ED6\u5011\u5728\u65B0\u589E Confluence \u5F8C\u80FD\u66F4\u5FEB\u4EA4\u4ED8\u5C08\u6848",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\uFF05 \u7684 Jira \u5BA2\u6236\u8868\u793A\uFF0C\u4ED6\u5011\u5728\u65B0\u589E Confluence \u5F8C\u80FD\u66F4\u5FEB\u4EA4\u4ED8\u5C08\u6848",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\u4F7F\u7528\u7A7A\u9593\u548C\u9801\u9762</b>\u3002\u7A7A\u9593\u662F\u6BCF\u500B Confluence \u7DB2\u7AD9\u7684\u4E00\u90E8\u5206\uFF0C\u4E26\u4E14\u662F\u5C07\u9801\u9762\u7D44\u7E54\u70BA\u985E\u5225\u7684\u4E00\u7A2E\u65B9\u5F0F\u3002\u5C07\u7A7A\u9593\u8996\u70BA\u4E0D\u540C\u7684\u8CC7\u6599\u593E\u6216\u5C08\u6848\uFF0C\u800C\u9801\u9762\u5247\u662F\u5C6C\u65BC\u9019\u4E9B\u8CC7\u6599\u593E\u6216\u5C08\u6848\u4E2D\u7684\u6587\u4EF6\u3002<a>\u9032\u4E00\u6B65\u4E86\u89E3\u5982\u4F55\u4F7F\u7528\u7A7A\u9593</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u7ACB\u523B\u8A66\u7528",
    'project-pages.improvement.templates.tutorial.description': "\u4E86\u89E3\u5982\u4F55\u7DE8\u8F2F\u9801\u9762\u3002",
    'project-pages.improvement.templates.tutorial.name': "\u6B61\u8FCE\u4F86\u5230\u300C\u5C08\u6848\u9801\u9762\u300D\uFF01",
    'project-pages.improvement.terms-and-conditions-v2': "\u9078\u53D6\u300C\u7ACB\u5373\u8A66\u7528\u300D\u5373\u8868\u793A\u60A8\u78BA\u8A8D\u5C07\u65BC Confluence \u4E2D\u8A3B\u518A\uFF0C\u4E26\u4E14\u540C\u610F Atlassian<termsLink> Cloud \u670D\u52D9\u689D\u6B3E</termsLink>\u548C<privacyLink>\u96B1\u79C1\u653F\u7B56</privacyLink>\u3002",
    'project-pages.improvement.title': "\u5C08\u6848\u9801\u9762",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u5EFA\u7ACB\u9801\u9762",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\u6211\u5011\u5DF2\u65B0\u589E Confluence\uFF0C\u4EE5\u4FBF\u60A8\u958B\u59CB\u5EFA\u7ACB\u548C\u9023\u7D50\u6240\u6709\u5C08\u6848\u6587\u4EF6\u3002\u6700\u591A\u53EF\u4F9B 10 \u4F4D\u4F7F\u7528\u8005\u514D\u8CBB\u4F7F\u7528\u3002",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u4E86\u89E3\u66F4\u591A",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u5EFA\u7ACB\u60A8\u7684\u7B2C\u4E00\u500B\u9801\u9762",
    'project-pages.improvement.transient-states.empty-state.description': "\u5EFA\u7ACB\u4E00\u4E9B\u6703\u8B70\u7B46\u8A18\u3001\u7522\u54C1\u8981\u6C42\u3001\u6C7A\u7B56\u6216\u5176\u4ED6\u5167\u5BB9\uFF0C\u4EE5\u67E5\u770B\u6B64\u7A7A\u9593\u662F\u5426\u5DF2\u586B\u6EFF\u3002",
    'project-pages.improvement.transient-states.empty-state.title': "\u9019\u88E1\u76EE\u524D\u4EC0\u9EBC\u90FD\u6C92\u6709\uFF0C\u53EA\u6709\u6F5B\u529B\u7121\u9650",
    'project-pages.improvement.try-button': "\u5728 Confluence \u4E2D\u8A66\u7528\u6B64\u7BC4\u672C",
    'project-pages.improvement.try-it-now': "\u7ACB\u523B\u8A66\u7528",
    'project-pages.improvement.try-lozenge': "\u8A66\u7528",
    'project-pages.improvement.try-on-demand-button': "\u514D\u8CBB\u8A66\u7528",
    'project-pages.page-deleted-flag.title': "\u5DF2\u522A\u9664\u9801\u9762\u3002",
    'project-pages.page-published-flag.title': "\u60A8\u7684\u9801\u9762\u5DF2\u767C\u4F48\u3002",
    'project-pages.unknown-error.description': "\u5982\u679C\u91CD\u65B0\u6574\u7406\u7121\u6CD5\u89E3\u6C7A\u554F\u984C\uFF0C\u8ACB{contactSupport}",
    'project-pages.unknown-error.heading': "\u73FE\u5728\u7121\u6CD5\u986F\u793A\u5C08\u6848\u9801\u9762",
    'projectpages.templatepreview.termsandprivacy': "\u6309\u4E00\u4E0B\u300C\u514D\u8CBB\u8A66\u7528\u300D\u5F8C\uFF0C\u60A8\u5C07\u5728 Confluence \u4E2D\u8A3B\u518A\u4E26\u540C\u610F Atlassian <termsOfServiceLinkText>Cloud \u670D\u52D9\u689D\u6B3E</termsOfServiceLinkText>\u548C<privacyPolicyLinkText>\u96B1\u79C1\u653F\u7B56</privacyPolicyLinkText>\u3002"
};

});

parcelRegister("6B5Ae", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bfdcb5bd7c57315$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $7bfdcb5bd7c57315$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Nem\u011Blo by to trvat ani minutu.",
    'confluence.project-pages.improvement.provisioning-background.title': "Prob\xedh\xe1 nastavov\xe1n\xed va\u0161ich str\xe1nek projektu",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "Zav\u0159\xedt",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Hotovo',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "Dal\u0161\xed",
    'project-pages.activating.description': "P\u0159ipojen\xfd prostor Confluence je\u0161t\u011B nen\xed p\u0159ipraven\xfd. {contactSupport}, pokud probl\xe9m nevy\u0159e\u0161\xed obnoven\xed str\xe1nky.",
    'project-pages.activating.heading': "Confluence se st\xe1le na\u010D\xedt\xe1",
    'project-pages.button.connect-different-space-or-page.label': "Ikona aktualizace prostoru nebo str\xe1nky",
    'project-pages.button.connect-different-space-or-page.tooltip': "P\u0159ipojit jin\xfd prostor nebo str\xe1nku",
    'project-pages.button.connect-space-or-page.tooltip': "P\u0159ipojit ke Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "Otev\u0159\xedt str\xe1nku v\xa0Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "Otev\u0159\xedt prostor v\xa0Confluence",
    'project-pages.connect-space-dialog.connection-error': "P\u0159ipojen\xed se nezda\u0159ilo.",
    'project-pages.connect-space-dialog.connection-retry': 'Zkusit znovu',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Vyberte prostor nebo str\xe1nku, kter\xe9 k\xa0tomuto projektu chcete p\u0159ipojit.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "Vyhledat v r\xe1mci Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "P\u0159ed vytvo\u0159en\xedm str\xe1nky je nutn\xe9 p\u0159ipojit tento projekt k prostoru. Vyberte prostor, kter\xfd k tomuto projektu chcete p\u0159ipojit.",
    'project-pages.connect-space-dialog.error-icon': 'Chyba:',
    'project-pages.connect-space-dialog.footer.cancel': "Zru\u0161it",
    'project-pages.connect-space-dialog.footer.connect-space': "P\u0159ipojit",
    'project-pages.connect-space-or-page-dialog.header.title': "P\u0159ipojit projekt ke Confluence",
    'project-pages.connect-space.description': "Prostory jsou jako slo\u017Eky \u2013 m\u016F\u017Eete je vyu\u017E\xedt k vytv\xe1\u0159en\xed obsahu souvisej\xedc\xedho s va\u0161\xedm projektem, jeho organizaci nebo spolupr\xe1ci na n\u011Bm.",
    'project-pages.connect-space.not-connected.description': "Chcete-li pou\u017E\xedvat str\xe1nky projektu, obra\u0165te se na spr\xe1vce nebo vedouc\xedho t\xfdmu a\xa0p\u0159ipojte k\xa0tomuto projektu Confluence.",
    'project-pages.connect-space.not-connected.heading': "Chyb\xed p\u0159ipojen\xed ke Confluence",
    'project-pages.connect-success-flag.description.content': "P\u0159ipojen\xed k\xa0obsahu {connectedSpaceOrPageName} bylo \xfasp\u011B\u0161n\xe9.",
    'project-pages.connection-error.space-or-page-not-found.button': "P\u0159ipojit k\xa0jin\xe9mu prostoru nebo str\xe1nce",
    'project-pages.create-space-dialog.connection-error': "P\u0159ipojen\xed se nezda\u0159ilo.",
    'project-pages.create-space-dialog.connection-retry': 'Zkusit znovu',
    'project-pages.create-space-dialog.content.empty-name': "Zadejte n\xe1zev prostoru.",
    'project-pages.create-space-dialog.content.invalid-name': "N\xe1zev prostoru mus\xed obsahovat alespo\u0148 jedno p\xedsmeno nebo \u010D\xedslici.",
    'project-pages.create-space-dialog.content.placeholder': "Zadejte n\xe1zev prostoru",
    'project-pages.create-space-dialog.creation-error': "Vytvo\u0159en\xed prostoru se nezda\u0159ilo.",
    'project-pages.create-space-dialog.error-icon': 'Chyba:',
    'project-pages.create-space-dialog.footer.cancel': "Zru\u0161it",
    'project-pages.create-space-dialog.footer.create-space': "Vytvo\u0159it",
    'project-pages.create-space-dialog.header.title': "Vytvo\u0159it nov\xfd prostor Confluence",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Projektov\xe9 str\xe1nky nem\u016F\u017Eete pou\u017E\xedvat, proto\u017Ee v\xe1m administr\xe1tor odebral p\u0159\xedstup ke Confluence. Pokud chcete po\u017E\xe1dat o\xa0p\u0159\xedstup, kontaktujte administr\xe1tora webu.",
    'project-pages.cross-join.access-revoked.templates.title': "Nem\xe1te opr\xe1vn\u011Bn\xed pou\u017E\xedvat projektov\xe9 str\xe1nky",
    'project-pages.cross-join.avatar.view-profile': 'Zobrazit profil',
    'project-pages.cross-join.denied-request.templates.subtitle': "Projektov\xe9 str\xe1nky nem\u016F\u017Eete pou\u017E\xedvat, proto\u017Ee administr\xe1tor webu zam\xedtl va\u0161i \u017E\xe1dost o\xa0p\u0159ipojen\xed ke Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "Administr\xe1tor v\xe1m zam\xedtl p\u0159\xedstup",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Z\xedsk\xe1te p\u0159\xedstup ke Confluence. Spr\xe1vce webu u\u017E v\xe1s schv\xe1lil.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport}, pokud probl\xe9m nevy\u0159e\u0161\xed obnoven\xed str\xe1nky.",
    'project-pages.cross-join.errors.unknown-error.title': "Projektov\xe9 str\xe1nky moment\xe1ln\u011B nelze zobrazit",
    'project-pages.cross-join.inline-join-product.button': "Z\xedsk\xe1te p\u0159\xedstup ke Confluence. Spr\xe1vce webu u\u017E v\xe1s schv\xe1lil.",
    'project-pages.cross-join.inline-join-product.connected.description': "Prohl\xed\u017Eejte si, upravujte a\xa0vytv\xe1\u0159ejte dokumentaci na jednom m\xedst\u011B.",
    'project-pages.cross-join.inline-join-product.connected.title': "Spolupracujte se sv\xfdm t\xfdmem na str\xe1nk\xe1ch projektu.",
    'project-pages.cross-join.pending-request.templates.subtitle': "Administr\xe1tor webu obdr\u017Eel va\u0161i \u017E\xe1dost o\xa0p\u0159ipojen\xed ke Confluence. Pokud va\u0161e p\u0159ipojen\xed schv\xe1l\xed, za\u010Dnou v\xe1m fungovat projektov\xe9 str\xe1nky a\xa0p\u0159ijde v\xe1m potvrzovac\xed e-mail.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Po schv\xe1len\xed dostanete e-mail s\xa0p\u0159\xedstupem k\xa0n\xe1stroji Str\xe1nky projektu.",
    'project-pages.cross-join.pending-request.templates.title': "Po\u017E\xe1dali jste o\xa0p\u0159\xedstup ke Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u017D\xe1dost o\xa0p\u0159\xedstup byla odesl\xe1na spr\xe1vci",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Prohl\xed\u017Eejte si, upravujte a\xa0vytv\xe1\u0159ejte projektovou dokumentaci se sv\xfdm t\xfdmem.",
    'project-pages.cross-join.request-access.button': "Po\u017E\xe1dat o\xa0p\u0159\xedstup",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "V\xfdb\u011Brem mo\u017Enosti \u201EP\u0159ipojit k\xa0t\xfdmu\u201C \u017E\xe1d\xe1te o\xa0p\u0159ipojen\xed ke Confluence a\xa0vyjad\u0159ujete souhlas se sd\xedlen\xedm sv\xe9ho profilu Atlassian se spr\xe1vcem.",
    'project-pages.cross-join.request-access.button.experimental': "P\u0159ipojte se ke sv\xe9mu t\xfdmu",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u010Clenov\xe9 va\u0161eho t\xfdmu pou\u017E\xedvaj\xed n\xe1stroj Str\xe1nky projektu ke komentov\xe1n\xed, \xfaprav\xe1m a\xa0spolupr\xe1ci na projektov\xe9 dokumentaci, ani\u017E by museli odch\xe1zet z\xa0Jira. P\u0159ipojte se ke Confluence a\xa0z\xedskejte p\u0159\xedstup k\xa0projektov\xfdm str\xe1nk\xe1m sv\xe9ho t\xfdmu.",
    'project-pages.cross-join.request-access.title': "Projektov\xe9 str\xe1nky vy\u017Eaduj\xed p\u0159\xedstup ke Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Vytvo\u0159te centr\xe1ln\xed zdroj informac\xed pro sv\u016Fj t\xfdm",
    'project-pages.default-contextual-heading': "Str\xe1nky projekt\u016F vyu\u017E\xedvaj\xed technologii Confluence",
    'project-pages.default-contextual-message': "Vytv\xe1\u0159ejte dokumenty k projektu, sd\xedlejte je a spolupracujte na nich na jednom m\xedst\u011B d\xedky str\xe1nk\xe1m Confluence.",
    'project-pages.default-reactivate-CTA': 'Znovu aktivovat Confluence',
    'project-pages.default-trial-CTA': "Vyzkou\u0161ejte Confluence zdarma po dobu 30 dn\xed",
    'project-pages.draft-saved-flag.action': "Otev\u0159\xedt koncept",
    'project-pages.draft-saved-flag.description': "Koncept je pro v\xe1s viditeln\xfd pouze do t\xe9 doby, ne\u017E jej publikujete.",
    'project-pages.draft-saved-flag.title': "Koncept byl ulo\u017Een",
    'project-pages.embedded-pages.create-page-error.close-button': "Zav\u0159\xedt",
    'project-pages.embedded-pages.create-page-error.description': "Vyskytl se probl\xe9m a\xa0str\xe1nku se nepoda\u0159ilo vytvo\u0159it.",
    'project-pages.embedded-pages.create-page-error.title': "Vytvo\u0159en\xed str\xe1nky se nezda\u0159ilo",
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Zkusit znovu',
    'project-pages.embedded-pages.modal.close.button.hint': "Zav\u0159\xedt",
    'project-pages.embedded-pages.modal.title.button': "Otev\u0159\xedt v\xa0Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "Otev\u0159\xedt na nov\xe9 kart\u011B",
    'project-pages.errors.space-or-page-not-found.title.non-final': "Prostor/str\xe1nku se nepoda\u0159ilo naj\xedt",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport}, pokud probl\xe9m nevy\u0159e\u0161\xed obnoven\xed str\xe1nky.",
    'project-pages.errors.unknown-error.title.non-final': "Str\xe1nky projektu moment\xe1ln\u011B nelze zobrazit",
    'project-pages.generic-error.button.reload': "Znovu na\u010D\xedst str\xe1nku",
    'project-pages.generic-error.button.reload.non-final': "Znovu na\u010D\xedst str\xe1nku",
    'project-pages.generic-error.description': "N\u011Bco se pokazilo. Zkuste to znovu pozd\u011Bji.",
    'project-pages.generic-error.description.non-final': "N\u011Bco se pokazilo. Zkuste to znovu pozd\u011Bji.",
    'project-pages.generic-error.heading': "Hmm, toto je zvl\xe1\u0161tn\xed\u2026",
    'project-pages.generic-error.title.non-final': "Hmm, toto je zvl\xe1\u0161tn\xed\u2026",
    'project-pages.generic-info-flag.description': "N\u011Bco se pokazilo. Zkuste to znovu pozd\u011Bji nebo kontaktujte podporu, pokud probl\xe9m p\u0159etrv\xe1v\xe1.",
    'project-pages.generic-success-flag.description.page': "P\u0159ipojen\xed ke str\xe1nce {connectedSpaceOrPageName} bylo \xfasp\u011B\u0161n\xe9.",
    'project-pages.generic-success-flag.description.space': "P\u0159ipojen\xed k prostoru {connectedSpaceOrPageName} bylo \xfasp\u011B\u0161n\xe9.",
    'project-pages.generic-success-flag.heading.page': "Str\xe1nka byla p\u0159ipojena",
    'project-pages.generic-success-flag.heading.space': "Prostor byl p\u0159ipojen",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Nebo vytvo\u0159it nov\xfd prostor",
    'project-pages.granular-pages.connect-space.button': "P\u0159ipojit ke Confluence",
    'project-pages.granular-pages.connect-space.button.non-final': "P\u0159ipojit ke Confluence",
    'project-pages.granular-pages.connect-space.heading': "P\u0159ipojte tento projekt k\xa0prostoru nebo str\xe1nce Confluence",
    'project-pages.granular-pages.connect-space.heading.non-final': "P\u0159ipojte tento projekt k\xa0prostoru nebo str\xe1nce Confluence",
    'project-pages.improvement.contact-support': 'Kontaktovat podporu',
    'project-pages.improvement.errors.access-error.description': "Zkuste po\u017E\xe1dat o p\u0159\xedstup administr\xe1tora webu",
    'project-pages.improvement.errors.access-error.title': "K zobrazen\xed str\xe1nek projektu nem\xe1te opr\xe1vn\u011Bn\xed",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "P\u0159i pokusu o zobrazen\xed str\xe1nek z va\u0161eho p\u0159ipojen\xe9ho prostoru Confluence se vyskytl probl\xe9m. {contactSupport}, pokud probl\xe9m nevy\u0159e\u0161\xed obnoven\xed str\xe1nky.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "M\xe1me probl\xe9m se zobrazen\xedm str\xe1nek projektu",
    'project-pages.improvement.errors.space-or-page-not-found.description': "P\u0159ipojen\xfd prostor nebo str\xe1nku Confluence n\u011Bkdo p\u0159esunul, archivoval nebo odstranil. Pokud probl\xe9m nevy\u0159e\u0161\xed op\u011Btovn\xe9 p\u0159ipojen\xed, <link>obra\u0165te se na podporu</link>.",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Prostor/str\xe1nku se nepoda\u0159ilo naj\xedt",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport}, pokud probl\xe9m nevy\u0159e\u0161\xed obnoven\xed str\xe1nky.",
    'project-pages.improvement.errors.unknown-error.title': "Str\xe1nky projektu moment\xe1ln\u011B nelze zobrazit",
    'project-pages.improvement.feature1': "P\u0159\xedstup a\xa0vytv\xe1\u0159en\xed dokument\u016F bez opu\u0161t\u011Bn\xed Jira",
    'project-pages.improvement.feature2': "\u0160ablony pro sch\u016Fzky, pl\xe1ny sprintu a\xa0dal\u0161\xed sc\xe9n\xe1\u0159e",
    'project-pages.improvement.feature3': "Synchronizace dokument\u016F do Jira a\xa0automatick\xe9 aktualizace",
    'project-pages.improvement.heading-info': "Zachy\u0165te znalosti t\xfdmu a zlep\u0161ete zp\u016Fsob prov\xe1d\u011Bn\xed pr\xe1ce.",
    'project-pages.improvement.heading-info-v2': "Vytvo\u0159te jedno m\xedsto pro v\u0161echny dokumenty projektu va\u0161eho t\xfdmu",
    'project-pages.improvement.learn-more-button': "Zjistit v\xedce",
    'project-pages.improvement.powered-by': "Pou\u017E\xedv\xe1 technologii",
    'project-pages.improvement.powered-by.tooltip': "Otev\u0159\xedt Confluence na nov\xe9 kart\u011B",
    'project-pages.improvement.preview-teaser': "Odemkn\u011Bte \u0161ablony, str\xe1nky projekt\u016F a\xa0dal\u0161\xed.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Udr\u017Eujte sv\xe9 projektov\xe9 sestavy aktu\xe1ln\xed pomoc\xed automaticky aktualizovan\xfdch stavov\xfdch \u0161t\xedtk\u016F.</p> <p>Jednodu\u0161e p\u0159ipojte ticket Jira v\xa0dokumentu a\xa0automaticky se zobraz\xed stavov\xfd \u0161t\xedtek, kter\xfd se aktualizuje synchronizovan\u011B s\xa0ticketem, tak\u017Ee nemus\xedte tr\xe1vit \u010Das ru\u010Dn\xedm vytv\xe1\u0159en\xedm sestav.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Hladce informujte zainteresovan\xe9 osoby",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Vytv\xe1\u0159ejte konzistentn\xed dokumentaci pomoc\xed na\u0161ich integrovan\xfdch \u0161ablon. Snadno se pou\u017E\xedvaj\xed a\xa0jde je p\u0159izp\u016Fsobit va\u0161im pot\u0159eb\xe1m.</p> <p>\u0160ablony m\u016F\u017Eete pou\u017E\xedvat p\u0159\xedmo ze str\xe1nek projektu, tak\u017Ee nikdy nemus\xedte opou\u0161t\u011Bt to, na \u010Dem pracujete. V\u0161echny \u0161ablony si m\u016F\u017Eete proj\xedt <a>zde</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Sjedno\u0165te sv\xe9 standardy dokumentace",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Vytvo\u0159te centr\xe1ln\xed zdroj d\u016Fle\u017Eit\xfdch informac\xed d\xedky vytvo\u0159en\xed a\xa0spr\xe1v\u011B dokumentace prost\u0159ednictv\xedm karty str\xe1nek projektu v\xa0Jira.</p> <p>V\u011Bd\u011Bli jste, \u017Ee str\xe1nky projektu se nach\xe1z\xed v\xa0Confluence? Confluence je zdarma a\u017E pro 10\xa0u\u017Eivatel\u016F. Zbytek t\xfdmu m\u016F\u017Eete pozvat v\xa0nastaven\xed spr\xe1vce.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "Va\u0161e str\xe1nky projektu, p\u0159\xedmo v\xa0Jira",
    'project-pages.improvement.templates.blank-page.description': "Za\u010Dn\u011Bte novou str\xe1nku od za\u010D\xe1tku.",
    'project-pages.improvement.templates.blank-page.name': "Pr\xe1zdn\xe1 str\xe1nka",
    'project-pages.improvement.templates.decision.description': "Zaznamenejte d\u016Fle\u017Eit\xe1 projektov\xe1 rozhodnut\xed a komunikujte je se sv\xfdm t\xfdmem.",
    'project-pages.improvement.templates.decision.name': "Rozhodnut\xed",
    'project-pages.improvement.templates.meeting-notes.description': "Napl\xe1nujte sv\xe9 sch\u016Fzky a sd\xedlejte ak\u010Dn\xed polo\u017Eky se sv\xfdm t\xfdmem.",
    'project-pages.improvement.templates.meeting-notes.name': "Z\xe1pis ze sch\u016Fzky",
    'project-pages.improvement.templates.post-expand.more': "Dal\u0161\xed \u0161ablony",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Zobrazit v\u0161echny \u0161ablony v Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': "Popul\xe1rn\xed \u0161ablony",
    'project-pages.improvement.templates.post-expand.title': "Vytvo\u0159it str\xe1nku",
    'project-pages.improvement.templates.pre-expand.more': "Prozkoumat dal\u0161\xed \u0161ablony",
    'project-pages.improvement.templates.pre-expand.subtitle': "Popul\xe1rn\xed u t\xfdm\u016F podobn\xfdch va\u0161emu",
    'project-pages.improvement.templates.pre-expand.title': "N\xe1hled \u0161ablon",
    'project-pages.improvement.templates.product-requirements.description': "Definujte, sledujte a stanovte rozsah po\u017Eadavk\u016F na v\xe1\u0161 produkt \u010Di funkci.",
    'project-pages.improvement.templates.product-requirements.name': "Po\u017Eadavky produktu",
    'project-pages.improvement.templates.retrospective.description': "Co se v\xe1m l\xedbilo? Co by mohlo j\xedt l\xe9pe? Proberte zlep\u0161en\xed se sv\xfdm t\xfdmem.",
    'project-pages.improvement.templates.retrospective.name': "Retrospektivn\xed",
    'project-pages.improvement.templates.template.disabled-tooltip': "Nejd\u0159\xedve p\u0159ipojte prostor Confluence",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>U\u0161et\u0159ete \u010Das a\xa0redukujte manu\xe1ln\xed \xfakoly</b>. Confluence m\xe1 mnoho <a>\u0161ablon str\xe1nek</a>, tak\u017Ee nikdy nemus\xedte za\u010D\xednat od nuly. Najdete tu \u0161ablony pro technickou dokumentaci, pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F, projektov\xe9 pl\xe1ny, produktov\xe9 po\u017Eadavky a\xa0plno dal\u0161\xedch.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Snadno upravujte a\xa0form\xe1tujte.</b> Pomoc\xed horn\xed nab\xeddky pro \xfapravy m\u016F\u017Eete ur\u010Dit standardn\xed form\xe1tov\xe1n\xed textu a\xa0zad\xe1n\xedm znaku <b>/</b> m\u016F\u017Eete snadno vlo\u017Eit spoustu u\u017Eite\u010Dn\xfdch integrac\xed. Chcete-li vlo\u017Eit tabulku, zadejte text <c>/tabulka</c>, chcete-li vlo\u017Eit obr\xe1zek, zadejte text <c>/obr\xe1zek</c>. M\u016F\u017Eete tak\xe9 vlo\u017Eit odkazy na Dropbox (<c>/dropbox</c>), n\xe1stroje Microsoft Office (<c>/microsoft</c>) nebo n\xe1st\u011Bnky a\xa0karty Trello (<c>/trello</c>).",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Zadejte znak / a pot\xe9 text \u201Etabulka\u201C nebo \u201Eobr\xe1zek\u201C.",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Zde je n\u011Bkolik tip\u016F, jak za\u010D\xedt:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u0160ikovn\xe9 odkazy",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Pou\u017E\xedvejte Jira a\xa0Confluence spole\u010Dn\u011B",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Vytv\xe1\u0159ejte na sv\xfdch str\xe1nk\xe1ch grafy pomoc\xed re\xe1ln\xfdch dat z\xa0Jira. Zadejte text <c>/grafy Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "P\u0159ipojte po\u017Eadavek Jira kamkoli na str\xe1nku. Odkaz na str\xe1nce se p\u0159i aktualizaci po\u017Eadavku Jira v\xa0re\xe1ln\xe9m \u010Dase aktualizuje tak\xe9. Zadejte text <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Pomoc\xed projekt\u016F Jira m\u016F\u017Eete na str\xe1nku vlo\u017Eit interaktivn\xed roadmapy a\xa0\u010Dasov\xe9 osy. Zadejte text <c>/jira roadmap</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Pomoc\xed projekt\u016F Jira m\u016F\u017Eete na str\xe1nku vlo\u017Eit interaktivn\xed \u010Dasov\xe9 osy. Zadejte text <c>/\u010Dasov\xe1 osa jira</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% z\xe1kazn\xedk\u016F Jira Software uvedlo, \u017Ee p\u0159id\xe1n\xed Confluence jim pomohlo rychleji dod\xe1vat projekty.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% z\xe1kazn\xedk\u016F Jira uvedlo, \u017Ee p\u0159id\xe1n\xed Confluence jim pomohlo rychleji dod\xe1vat projekty.",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Pou\u017E\xedvejte prostory a\xa0str\xe1nky</b>. Prostory jsou sou\u010D\xe1st\xed ka\u017Ed\xe9ho webu Confluence a\xa0p\u0159edstavuj\xed zp\u016Fsob uspo\u0159\xe1d\xe1n\xed str\xe1nek do kategori\xed. Prostory si m\u016F\u017Eete p\u0159edstavit jako \u0159adu r\u016Fzn\xfdch slo\u017Eek nebo projekt\u016F, zat\xedmco str\xe1nky jsou dokumenty, kter\xe9 do t\u011Bchto slo\u017Eek nebo projekt\u016F pat\u0159\xed. <a>Dal\u0161\xed informace o\xa0tom, jak pou\u017E\xedvat prostory</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "Vyzkou\u0161et nyn\xed",
    'project-pages.improvement.templates.tutorial.description': "P\u0159e\u010Dt\u011Bte si, jak upravit str\xe1nku.",
    'project-pages.improvement.templates.tutorial.name': "V\xedtejte na projektov\xfdch str\xe1nk\xe1ch!",
    'project-pages.improvement.terms-and-conditions-v2': "V\xfdb\u011Brem mo\u017Enosti \u201EVyzkou\u0161et nyn\xed\u201C potvrzujete, \u017Ee budete zaregistrov\xe1ni do Confluence, a\xa0p\u0159ij\xedm\xe1te <termsLink>podm\xednky slu\u017Eby Atlassian Cloud</termsLink> a\xa0<privacyLink>z\xe1sady ochrany osobn\xedch \xfadaj\u016F</privacyLink>.",
    'project-pages.improvement.title': "Str\xe1nky projektu",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Vytvo\u0159it str\xe1nku",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "P\u0159idali jsme Confluence, abyste mohli za\u010D\xedt vytv\xe1\u0159et a\xa0p\u0159ipojovat v\u0161echny sv\xe9 projektov\xe9 dokumenty. Je to zdarma pro a\u017E 10\xa0u\u017Eivatel\u016F.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "Dal\u0161\xed informace",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Vytvo\u0159te svou prvn\xed str\xe1nku",
    'project-pages.improvement.transient-states.empty-state.description': "Tento prostor se zapln\xed, a\u017E za\u010Dnete vytv\xe1\u0159et z\xe1pisy ze sch\u016Fzek, produktov\xe9 po\u017Eadavky, rozhodnut\xed a\xa0dal\u0161\xed obsah.",
    'project-pages.improvement.transient-states.empty-state.title': "Nen\xed tu nic jin\xe9ho ne\u017E potenci\xe1l",
    'project-pages.improvement.try-button': "Vyzkou\u0161et tuto \u0161ablonu v\xa0Confluence",
    'project-pages.improvement.try-it-now': "Vyzkou\u0161et nyn\xed",
    'project-pages.improvement.try-lozenge': "Vyzkou\u0161et",
    'project-pages.improvement.try-on-demand-button': "Vyzkou\u0161et zdarma",
    'project-pages.page-deleted-flag.title': "Str\xe1nka byla odstran\u011Bna.",
    'project-pages.page-published-flag.title': "Va\u0161e str\xe1nka byla publikov\xe1na.",
    'project-pages.title.non-final': "Str\xe1nky projektu",
    'project-pages.unknown-error.description': "{contactSupport}, pokud probl\xe9m nevy\u0159e\u0161\xed obnoven\xed str\xe1nky.",
    'project-pages.unknown-error.heading': "Str\xe1nky projektu moment\xe1ln\u011B nelze zobrazit",
    'projectpages.templatepreview.termsandprivacy': "Kliknut\xedm na Vyzkou\u0161et zdarma budete zaregistrov\xe1ni do Confluence a\xa0p\u0159ij\xedm\xe1te <termsOfServiceLinkText>podm\xednky slu\u017Eby Atlassian Cloud</termsOfServiceLinkText> a\xa0<privacyPolicyLinkText>z\xe1sady ochrany osobn\xedch \xfadaj\u016F</privacyPolicyLinkText>."
};

});

parcelRegister("lPDba", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffc0e80819f7d582$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $ffc0e80819f7d582$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Dette b\xf8r tage mindre end et minut",
    'confluence.project-pages.improvement.provisioning-background.title': "Ops\xe6tning af dine projektsider",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Luk',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "F\xe6rdig",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "N\xe6ste",
    'project-pages.activating.description': "Det tilknyttede Confluence-omr\xe5de er ikke helt klar endnu. {contactSupport}, hvis problemet ikke l\xf8ses ved at opdatere siden.",
    'project-pages.activating.heading': "Confluence indl\xe6ses stadig",
    'project-pages.button.connect-different-space-or-page.label': "Opdater omr\xe5de eller sideikon",
    'project-pages.button.connect-different-space-or-page.tooltip': "Tilknyt et andet omr\xe5de eller en anden side",
    'project-pages.button.connect-space-or-page.tooltip': 'Opret forbindelse til Confluence',
    'project-pages.button.go-to-connected-page.tooltip': "\xc5bn side i Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "\xc5bn omr\xe5de i Confluence",
    'project-pages.connect-space-dialog.connection-error': 'Tilknytningen mislykkedes.',
    'project-pages.connect-space-dialog.connection-retry': "Pr\xf8v igen",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "V\xe6lg et omr\xe5de eller en side, som skal knyttes til dit projekt.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "S\xf8g i Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Dette projekt skal knyttes til et omr\xe5de, f\xf8r du kan oprette en side. V\xe6lg et omr\xe5de, som skal knyttes til dette projekt.",
    'project-pages.connect-space-dialog.error-icon': 'Fejl:',
    'project-pages.connect-space-dialog.footer.cancel': 'Annuller',
    'project-pages.connect-space-dialog.footer.connect-space': 'Forbind',
    'project-pages.connect-space-or-page-dialog.header.title': 'Knyt projekt til Confluence',
    'project-pages.connect-space.description': "Omr\xe5der er ligesom mapper \u2013 du kan bruge dem til at oprette, organisere og samarbejde om al indholdet, der vedr\xf8rer projektet.",
    'project-pages.connect-space.not-connected.description': 'Hvis du vil bruge projektsider, skal du kontakte din administrator eller teamleder for at forbinde Confluence til dette projekt.',
    'project-pages.connect-space.not-connected.heading': 'Ikke forbundet til Confluence',
    'project-pages.connect-success-flag.description.content': 'Tilknytningen til {connectedSpaceOrPageName}-indholdet blev oprettet.',
    'project-pages.connection-error.space-or-page-not-found.button': "Knyt til et andet omr\xe5de eller en anden side",
    'project-pages.create-space-dialog.connection-error': 'Tilknytningen mislykkedes.',
    'project-pages.create-space-dialog.connection-retry': "Pr\xf8v igen",
    'project-pages.create-space-dialog.content.empty-name': "Giv dit omr\xe5de et navn.",
    'project-pages.create-space-dialog.content.invalid-name': "Omr\xe5denavne skal have mindst \xe9t bogstav eller tal.",
    'project-pages.create-space-dialog.content.placeholder': "Indtast et omr\xe5denavn",
    'project-pages.create-space-dialog.creation-error': "Det lykkedes ikke at oprette omr\xe5det.",
    'project-pages.create-space-dialog.error-icon': 'Fejl:',
    'project-pages.create-space-dialog.footer.cancel': 'Annuller',
    'project-pages.create-space-dialog.footer.create-space': 'Opret',
    'project-pages.create-space-dialog.header.title': "Opret nyt Confluence-omr\xe5de",
    'project-pages.cross-join.access-revoked.templates.subtitle': 'Du kan ikke bruge projektsider, fordi administratoren ikke har givet dig adgang til Confluence. Kontakt administratoren for dit websted for at anmode om adgang.',
    'project-pages.cross-join.access-revoked.templates.title': 'Du har ikke tilladelse til at bruge projektsider',
    'project-pages.cross-join.avatar.view-profile': 'Se profil',
    'project-pages.cross-join.denied-request.templates.subtitle': "Du kan ikke bruge projektsider, fordi administratoren for webstedet har afvist din anmodning om at f\xe5 adgang til Confluence.",
    'project-pages.cross-join.denied-request.templates.title': 'Din administrator har afvist at give dig adgang',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Du f\xe5r adgang til Confluence. Din sideadministrator har allerede godkendt dig.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport}, hvis det ikke hj\xe6lper at opdatere.",
    'project-pages.cross-join.errors.unknown-error.title': 'Vi kan ikke vise projektsider lige nu',
    'project-pages.cross-join.inline-join-product.button': "Du f\xe5r adgang til Confluence. Din webstedsadministrator har allerede godkendt dig.",
    'project-pages.cross-join.inline-join-product.connected.description': "Se, rediger og opret dokumentation fra \xe9t sted",
    'project-pages.cross-join.inline-join-product.connected.title': "Samarbejd p\xe5 projektsider med dit team",
    'project-pages.cross-join.pending-request.templates.subtitle': "Webstedsadministratoren har modtaget din anmodning om adgang til Confluence. Hvis din anmodning bliver godkendt, begynder projektsider at fungere, og vi sender dig en e-mail med bekr\xe6ftelse.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Du modtager en e-mail med adgang til projektsider, n\xe5r du er godkendt.",
    'project-pages.cross-join.pending-request.templates.title': 'Du har anmodet om adgang til Confluence',
    'project-pages.cross-join.pending-request.templates.title.experiment': 'Adgangsanmodning sendt til administrator',
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'Se, rediger og opret projektdokumentation med dit team',
    'project-pages.cross-join.request-access.button': 'Anmod om adgang',
    'project-pages.cross-join.request-access.button-subtitle.experimental': 'N\xe5r du v\xe6lger "Bliv en del af teamet", beder du om at deltage i Confluence og accepterer at dele din Atlassian-profil med din administrator.',
    'project-pages.cross-join.request-access.button.experimental': 'Slut dig til dit team',
    'project-pages.cross-join.request-access.connected.description.experimental': "Dit team bruger projektsider til at kommentere, redigere og samarbejde om projektdokumentation uden at forlade Jira. Tilmeld dig Confluence for at f\xe5 adgang til dit teams projektsider.",
    'project-pages.cross-join.request-access.title': "Projektsider kr\xe6ver adgang til Confluence",
    'project-pages.cross-join.request-access.title.experiment': 'Skab en "single source of truth" til dit team',
    'project-pages.default-contextual-heading': 'Projektsider er drevet af Confluence',
    'project-pages.default-contextual-message': "Opret, del og samarbejd om alle dine projektdokumenter p\xe5 \xe9t sted med Confluence-sider.",
    'project-pages.default-reactivate-CTA': 'Genaktiver Confluence',
    'project-pages.default-trial-CTA': "Pr\xf8v Confluence gratis i 30 dage",
    'project-pages.draft-saved-flag.action': "\xc5bn udkast",
    'project-pages.draft-saved-flag.description': 'Dit udkast er kun synligt for dig, indtil du udgiver det.',
    'project-pages.draft-saved-flag.title': 'Udkastet blev gemt',
    'project-pages.embedded-pages.create-page-error.close-button': 'Luk',
    'project-pages.embedded-pages.create-page-error.description': 'Der opstod et problem, og vi kunne ikke oprette en side til dig.',
    'project-pages.embedded-pages.create-page-error.title': 'Vi kunne ikke oprette en side',
    'project-pages.embedded-pages.create-page-error.try-again-button': "Pr\xf8v igen",
    'project-pages.embedded-pages.modal.close.button.hint': 'Luk',
    'project-pages.embedded-pages.modal.title.button': "\xc5bn i Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "\xc5bn i en ny fane",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport}, hvis problemet ikke l\xf8ses ved at opdatere siden.",
    'project-pages.errors.unknown-error.title.non-final': 'Vi kan ikke vise projektsider lige nu',
    'project-pages.generic-error.button.reload': "Genindl\xe6s siden",
    'project-pages.generic-error.description': "Noget gik galt. Pr\xf8v igen senere.",
    'project-pages.generic-error.description.non-final': "Noget gik galt. Pr\xf8v igen senere.",
    'project-pages.generic-error.heading': 'Uh, det var akavet ...',
    'project-pages.generic-error.title.non-final': 'Ups, det var pinligt ...',
    'project-pages.generic-info-flag.description': "Der gik noget galt. Pr\xf8v igen, eller kontakt support, hvis problemet forts\xe6tter",
    'project-pages.generic-success-flag.description.page': 'Tilknytningen til {connectedSpaceOrPageName}-siden blev oprettet.',
    'project-pages.generic-success-flag.description.space': "Tilknytningen til {connectedSpaceOrPageName}-omr\xe5det blev oprettet.",
    'project-pages.generic-success-flag.heading.page': 'Siden blev tilknyttet',
    'project-pages.generic-success-flag.heading.space': "Omr\xe5de blev tilknyttet",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Eller opret et nyt omr\xe5de",
    'project-pages.granular-pages.connect-space.button': 'Opret forbindelse til Confluence',
    'project-pages.granular-pages.connect-space.heading': "Knyt dette projekt til et Confluence-omr\xe5de eller en Confluence-side",
    'project-pages.granular-pages.connect-space.heading.non-final': "Knyt dette projekt til et Confluence-omr\xe5de eller en Confluence-side",
    'project-pages.improvement.contact-support': 'Kontakt support',
    'project-pages.improvement.errors.access-error.description': "Pr\xf8v at kontakte sideadministratoren for at f\xe5 adgang.",
    'project-pages.improvement.errors.access-error.title': "Du har ikke tilladelse til at f\xe5 vist projektsider",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Noget gik galt under fors\xf8get p\xe5 at vise sider fra dit tilknyttede Confluence-omr\xe5de. {contactSupport}, hvis problemet ikke l\xf8ses ved at opdatere siden.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': 'Vi har problemer med at vise projektsider',
    'project-pages.improvement.errors.space-or-page-not-found.description': "Det tilknyttede Confluence-omr\xe5de eller den tilknyttede Confluence-side er blevet flyttet, arkiveret eller slettet. <link>Kontakt support</link>, hvis det ikke l\xf8ser problemet at oprette forbindelse igen",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Omr\xe5det eller siden blev ikke fundet",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport}, hvis problemet ikke l\xf8ses ved at opdatere siden.",
    'project-pages.improvement.errors.unknown-error.title': 'Vi kan ikke vise projektsider lige nu',
    'project-pages.improvement.feature1': "F\xe5 adgang til og opret dokumenter uden at forlade Jira",
    'project-pages.improvement.feature2': "Skabeloner til m\xf8der, sprintplaner og meget mere",
    'project-pages.improvement.feature3': "Synkroniser dokumenter til Jira, og f\xe5 automatiske opdateringer",
    'project-pages.improvement.heading-info': "Registrer dit teams viden, og forbedr den m\xe5de, hvorp\xe5 I f\xe5r arbejdet fra h\xe5nden.",
    'project-pages.improvement.heading-info-v2': "Opret \xe9t sted til alle teamets projektdokumenter",
    'project-pages.improvement.learn-more-button': "L\xe6s mere",
    'project-pages.improvement.powered-by': 'Drevet af',
    'project-pages.improvement.powered-by.tooltip': "\xc5bn Confluence p\xe5 en ny fane",
    'project-pages.improvement.preview-teaser': "L\xe5s op for skabeloner, projektsider m.m.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Hold dine projektrapporter opdaterede med automatisk opdatering af statusm\xe6rkater.</p> <p>Du skal blot linke til en Jira-supportanmodning i et dokument, s\xe5 vises der automatisk en statusm\xe6rkat, der synkroniseres med supportanmodningen, s\xe5 du ikke beh\xf8ver at bruge tid p\xe5 at oprette manuelle rapporter.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': 'Opdater dine interessenter uden problemer',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Opret ensartet dokumentation ved hj\xe6lp af vores indbyggede skabeloner. De er enkle at bruge og kan tilpasses til dine behov.</p> <p>Du kan bruge skabeloner direkte fra projektsider, s\xe5 du aldrig beh\xf8ver at forlade det, du arbejder p\xe5. Gennemse alle skabeloner <a>her</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Saml dine dokumentationsstandarder',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': '<p>Opret en enkelt kilde til sandhed til vigtige oplysninger ved at oprette og administrere dokumentation fra fanen projektsider i Jira.</p> <p>Vidste du, at projektsider findes i Confluence? Det er gratis for op til 10 brugere. Inviter resten af dit team i administratorindstillinger.</p>',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Dine projektsider, direkte i Jira',
    'project-pages.improvement.templates.blank-page.description': 'Start en side fra bunden.',
    'project-pages.improvement.templates.blank-page.name': 'Tom side',
    'project-pages.improvement.templates.decision.description': "Registrer vigtige projektbeslutninger, og dr\xf8ft dem med dit hold.",
    'project-pages.improvement.templates.decision.name': 'Beslutning',
    'project-pages.improvement.templates.meeting-notes.description': "Planl\xe6g dine m\xf8der, og del notater og handlinger med dit team.",
    'project-pages.improvement.templates.meeting-notes.name': "M\xf8denotater",
    'project-pages.improvement.templates.post-expand.more': 'Flere skabeloner',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Vis alle skabeloner i Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': "Popul\xe6re skabeloner",
    'project-pages.improvement.templates.post-expand.title': 'Opret en side',
    'project-pages.improvement.templates.pre-expand.more': 'Se flere skabeloner',
    'project-pages.improvement.templates.pre-expand.subtitle': "Popul\xe6re hos teams som dit",
    'project-pages.improvement.templates.pre-expand.title': "Forh\xe5ndsvisning af skabeloner",
    'project-pages.improvement.templates.product-requirements.description': "Defin\xe9r, spor og unders\xf8g kravene til dit produkt eller funktion.",
    'project-pages.improvement.templates.product-requirements.name': 'Produktkrav',
    'project-pages.improvement.templates.retrospective.description': "Hvad gik godt? Hvad kunne v\xe6re g\xe5et bedre? Crowdsource forbedringer med dit team.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektiv',
    'project-pages.improvement.templates.template.disabled-tooltip': "Tilknyt f\xf8rst et Confluence-omr\xe5de",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Spar tid, og mindsk m\xe6ngden af manuelle opgaver</b>. Confluence har mange <a>sideskabeloner</a>, s\xe5 du beh\xf8ver aldrig starte helt fra bunden. Der er bl.a. skabeloner til tekniske dokumenter, fejlfindingsvejledninger, projektplaner, produktkrav og meget mere.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Nem redigering og formatering.</b> Brug redigeringsmenuen foroven til standardordformatering, og ved hj\xe6lp af <b>/</b> kan du nemt inds\xe6tte masser af praktiske integrationer. Inds\xe6t en tabel ved at skrive <c>/table</c> eller et billede med <c>/image</c>. Du kan ogs\xe5 inds\xe6tte links til Dropbox <c>/dropbox</c>, Microsoft Office-v\xe6rkt\xf8jer <c>/microsoft</c> eller Trello-tavler og -kort <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Indtast / efterfulgt af "table" eller "image"',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': 'Her er et par tip til at komme i gang:',
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Nyttige links',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Brug Jira og Confluence sammen',
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Opret diagrammer p\xe5 dine sider ved hj\xe6lp af data fra Jira. Indtast <c>/Jira charts</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Tilknyt en Jira-sag hvor som helst p\xe5 siden. Linket p\xe5 siden opdateres i realtid, n\xe5r du opdaterer Jira-sagen. Indtast <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Integrer interaktive k\xf8replaner og tidslinjer for din side ved hj\xe6lp af dine Jira-projekter. Indtast <c>/Jira-k\xf8replan</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Integrer interaktive tidslinjer for din side ved hj\xe6lp af dine Jira-projekter. Skriv <c>/jira-tidslinje</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% af Jira Software-kunder siger, at de sender projekter hurtigere, efter de har tilf\xf8jet Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% af Jira-kunder siger, at de sender projekter ud hurtigere, efter de har tilf\xf8jet Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Brug af omr\xe5der og sider</b>. Omr\xe5der er en del af hvert Confluence-websted, og de er en m\xe5de at organisere sider i kategorier p\xe5. T\xe6nk p\xe5 omr\xe5der som forskellige mapper eller projekter, og sider er de dokumenter, der h\xf8rer hjemme i disse mapper eller projekter. <a>F\xe5 mere at vide om, hvordan man bruger omr\xe5der</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "Pr\xf8v det nu",
    'project-pages.improvement.templates.tutorial.description': "L\xe6r, hvordan du redigerer en side.",
    'project-pages.improvement.templates.tutorial.name': 'Velkommen til projektsider!',
    'project-pages.improvement.terms-and-conditions-v2': "Ved at klikke p\xe5 &quot;Pr\xf8v det nu&quot; accepterer du at blive tilmeldt Confluence, og du accepterer <termsLink>servicevilk\xe5r</termsLink> og <privacyLink>fortrolighedspolitik</privacyLink> for Atlassian Cloud.",
    'project-pages.improvement.title': 'Projektsider',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Opret side',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Vi har tilf\xf8jet Confluence, s\xe5 du kan begynde at oprette og tilknytte alle dine projektdokumenter. Det er gratis for op til 10 brugere.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "L\xe6s mere",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Opret din f\xf8rste side",
    'project-pages.improvement.transient-states.empty-state.description': "Opret m\xf8denoter, produktkrav, beslutninger eller andet indhold for at se omr\xe5det blive fyldt ud.",
    'project-pages.improvement.transient-states.empty-state.title': 'Der er ikke andet end potentiale her',
    'project-pages.improvement.try-button': "Pr\xf8v denne skabelon i Confluence",
    'project-pages.improvement.try-it-now': "Pr\xf8v det nu",
    'project-pages.improvement.try-lozenge': "Pr\xf8v",
    'project-pages.improvement.try-on-demand-button': "Pr\xf8v det gratis",
    'project-pages.page-deleted-flag.title': 'Siden blev slettet.',
    'project-pages.page-published-flag.title': 'Din side er blevet udgivet.',
    'project-pages.unknown-error.description': "{contactSupport}, hvis problemet ikke l\xf8ses ved at opdatere siden.",
    'project-pages.unknown-error.heading': 'Vi kan ikke vise projektsider lige nu',
    'projectpages.templatepreview.termsandprivacy': "Ved at klikke p\xe5 &quot;Pr\xf8v det gratis&quot; tilmeldes du Confluence og accepterer <termsOfServiceLinkText>servicevilk\xe5r</termsOfServiceLinkText> og <privacyPolicyLinkText>fortrolighedspolitik</privacyPolicyLinkText> for Atlassian Cloud."
};

});

parcelRegister("aqqpw", function(module, exports) {

$parcel$export(module.exports, "default", () => $725bb909bbe58b54$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $725bb909bbe58b54$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': 'Dit duurt niet langer dan een minuut',
    'confluence.project-pages.improvement.provisioning-background.title': "Je projectpagina's instellen",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Negeren',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Gereed',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Volgende',
    'project-pages.activating.description': 'De gekoppelde Confluence-space is nog niet gereed. Als vernieuwen de problemen niet verhelpt, {contactSupport}.',
    'project-pages.activating.heading': 'Confluence wordt nog steeds geladen',
    'project-pages.button.connect-different-space-or-page.label': 'Space of paginapictogram bijwerken',
    'project-pages.button.connect-different-space-or-page.tooltip': 'Met een andere space of pagina verbinding maken',
    'project-pages.button.connect-space-or-page.tooltip': 'Koppelen aan Confluence',
    'project-pages.button.go-to-connected-page.tooltip': 'Pagina openen in Confluence',
    'project-pages.button.go-to-connected-space.tooltip': 'Space openen in Confluence',
    'project-pages.connect-space-dialog.connection-error': 'Verbinding mislukt.',
    'project-pages.connect-space-dialog.connection-retry': 'Probeer opnieuw',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': 'Kies een space of pagina om dit project aan te koppelen.',
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Doorzoek Confluence',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': 'Dit project moet gekoppeld zijn aan een space voordat je een pagina kunt aanmaken. Kies een space om dit project aan te koppelen.',
    'project-pages.connect-space-dialog.error-icon': 'Fout:',
    'project-pages.connect-space-dialog.footer.cancel': 'Annuleren',
    'project-pages.connect-space-dialog.footer.connect-space': 'Koppelen',
    'project-pages.connect-space-or-page-dialog.header.title': 'Project aan Confluence koppelen',
    'project-pages.connect-space.description': 'Spaces zijn net mappen. Je kunt ze gebruiken om er alle content van je projecten in te maken, te organiseren en er in samen te werken.',
    'project-pages.connect-space.not-connected.description': "Als je projectpagina's wilt gebruiken, neem je contact op met je beheerder of teamleider om Confluence aan dit project te koppelen.",
    'project-pages.connect-space.not-connected.heading': 'Niet gekoppeld aan Confluence',
    'project-pages.connect-success-flag.description.content': 'Gekoppeld met inhoud van {connectedSpaceOrPageName}.',
    'project-pages.connection-error.space-or-page-not-found.button': 'Aan een andere space of pagina koppelen',
    'project-pages.create-space-dialog.connection-error': 'Verbinding mislukt.',
    'project-pages.create-space-dialog.connection-retry': 'Probeer opnieuw',
    'project-pages.create-space-dialog.content.empty-name': 'Geef je space een naam.',
    'project-pages.create-space-dialog.content.invalid-name': 'Spacenamen moeten minimaal een letter of cijfer bevatten.',
    'project-pages.create-space-dialog.content.placeholder': 'Voer een naam voor de space in',
    'project-pages.create-space-dialog.creation-error': 'Aanmaken van space mislukt.',
    'project-pages.create-space-dialog.error-icon': 'Fout:',
    'project-pages.create-space-dialog.footer.cancel': 'Annuleren',
    'project-pages.create-space-dialog.footer.create-space': 'Maken',
    'project-pages.create-space-dialog.header.title': 'Maak een nieuwe Confluence-space',
    'project-pages.cross-join.access-revoked.templates.subtitle': 'Je kunt de projectpagina niet gebruiken omdat de beheerder je de toegang tot Confluence heeft geweigerd. Neem contact op met je sitebeheerder om toegang aan te vragen.',
    'project-pages.cross-join.access-revoked.templates.title': "Je hebt geen rechten op het gebruik van projectpagina's",
    'project-pages.cross-join.avatar.view-profile': 'Profiel bekijken',
    'project-pages.cross-join.denied-request.templates.subtitle': "Je kunt geen projectpagina's gebruiken omdat de websitebeheerder je aanvraag voor aanmelding bij Confluence heeft geweigerd.",
    'project-pages.cross-join.denied-request.templates.title': 'Je beheerder heeft de toegang geweigerd',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': 'Je krijgt toegang tot Confluence. Je sitebeheerder heeft je al goedgekeurd.',
    'project-pages.cross-join.errors.unknown-error.description': '{contactSupport} als vernieuwen niet helpt.',
    'project-pages.cross-join.errors.unknown-error.title': "We kunnen projectpagina's op dit moment niet weergeven",
    'project-pages.cross-join.inline-join-product.button': 'Je krijgt toegang tot Confluence. Je sitebeheerder heeft je al goedgekeurd.',
    'project-pages.cross-join.inline-join-product.connected.description': "Documenten bekijken, bewerken en aanmaken vanaf \xe9\xe9n plek",
    'project-pages.cross-join.inline-join-product.connected.title': "Werk met je team samen op projectpagina's",
    'project-pages.cross-join.pending-request.templates.subtitle': "De sitebeheerder heeft je verzoek om aangemeld te worden bij Confluence ontvangen. Als je toestemming hebt gekregen om deel te nemen, treden de projectpagina's in werking en sturen we je een bevestigingsmail.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Je krijgt een e-mail met toegang tot de projectpagina's zodra je bent goedgekeurd.",
    'project-pages.cross-join.pending-request.templates.title': 'Je hebt toegang tot Confluence aangevraagd',
    'project-pages.cross-join.pending-request.templates.title.experiment': 'Aanvraag om toegang verstuurd naar de Beheerder',
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'Projectdocumenten bekijken, bewerken en aanmaken met je team',
    'project-pages.cross-join.request-access.button': 'Toegang aanvragen',
    'project-pages.cross-join.request-access.button-subtitle.experimental': "Wanneer je 'Lid worden van je team' selecteert, vraag je om lid te worden van Confluence en ga je ermee akkoord je Atlassian-profiel te delen met je beheerder.",
    'project-pages.cross-join.request-access.button.experimental': 'Lid worden van je team',
    'project-pages.cross-join.request-access.connected.description.experimental': "Je team gebruikt Projectpagina's om opmerkingen te plaatsen, te bewerken en samen te werken aan projectdocumentatie zonder Jira te verlaten. Word lid van Confluence om toegang te krijgen tot de projectpagina's van je team.",
    'project-pages.cross-join.request-access.title': "Projectpagina's vereisen toegang tot Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Maak \xe9\xe9n bron van waarheid aan voor je team",
    'project-pages.default-contextual-heading': "Projectpagina's worden mogelijk gemaakt door Confluence",
    'project-pages.default-contextual-message': "Met Confluence-pagina's maak, deel, en werk je op \xe9\xe9n plek samen aan al jouw projectdocumenten.",
    'project-pages.default-reactivate-CTA': 'Confluence opnieuw activeren',
    'project-pages.default-trial-CTA': 'Probeer Confluence 30 dagen gratis',
    'project-pages.draft-saved-flag.action': 'Concept openen',
    'project-pages.draft-saved-flag.description': 'Je concept is alleen zichtbaar voor jou tot je het publiceert.',
    'project-pages.draft-saved-flag.title': 'Concept opgeslagen',
    'project-pages.embedded-pages.create-page-error.close-button': 'Sluiten',
    'project-pages.embedded-pages.create-page-error.description': 'Er was een probleem en we konden geen pagina voor je aanmaken.',
    'project-pages.embedded-pages.create-page-error.title': 'We konden geen pagina aanmaken',
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Opnieuw proberen',
    'project-pages.embedded-pages.modal.close.button.hint': 'Sluiten',
    'project-pages.embedded-pages.modal.title.button': 'Openen in Confluence',
    'project-pages.embedded-pages.modal.title.button.hint': 'Openen in een nieuw tabblad',
    'project-pages.errors.unknown-error.description.non-final': 'Als vernieuwen de problemen niet verhelpt, {contactSupport}.',
    'project-pages.errors.unknown-error.title.non-final': "We kunnen projectpagina's op dit moment niet weergeven",
    'project-pages.generic-error.button.reload': 'Pagina opnieuw laden',
    'project-pages.generic-error.description': 'Er is iets misgegaan. Probeer het later opnieuw.',
    'project-pages.generic-error.description.non-final': 'Er is iets misgegaan. Probeer het later opnieuw.',
    'project-pages.generic-error.heading': 'Hmm, dit is niet zo handig...',
    'project-pages.generic-error.title.non-final': 'Hmm, dit is niet zo handig...',
    'project-pages.generic-info-flag.description': 'Er is iets misgegaan. Probeer het opnieuw of neem contact op met support als het probleem zich blijft voordoen',
    'project-pages.generic-success-flag.description.page': 'Gekoppeld met {connectedSpaceOrPageName}-pagina.',
    'project-pages.generic-success-flag.description.space': 'Gekoppeld met {connectedSpaceOrPageName}-space.',
    'project-pages.generic-success-flag.heading.page': 'Pagina gekoppeld',
    'project-pages.generic-success-flag.heading.space': 'Space gekoppeld',
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'Of een nieuwe space aanmaken',
    'project-pages.granular-pages.connect-space.button': 'Koppelen aan Confluence',
    'project-pages.granular-pages.connect-space.heading': 'Koppel dit project aan een Confluence-space of -pagina',
    'project-pages.granular-pages.connect-space.heading.non-final': 'Koppel dit project aan een Confluence-space of -pagina',
    'project-pages.improvement.contact-support': 'Neem contact op met support',
    'project-pages.improvement.errors.access-error.description': 'Neem contact op met de sitebeheerder voor toegang.',
    'project-pages.improvement.errors.access-error.title': "Je hebt geen rechten om projectpagina's weer te geven",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Er is iets misgegaan bij het weergeven van pagina's van je gekoppelde Confluence-space. Als vernieuwen de problemen niet verhelpt, {contactSupport}.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "We kunnen de projectpagina's niet weergeven",
    'project-pages.improvement.errors.space-or-page-not-found.description': 'De Confluence-space of -pagina die gekoppeld was, is verplaatst, gearchiveerd of verwijderd. <link>Neem contact op met support</link> als vernieuwen niet helpt',
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Space of pagina niet gevonden',
    'project-pages.improvement.errors.unknown-error.description': 'Als vernieuwen de problemen niet verhelpt, {contactSupport}.',
    'project-pages.improvement.errors.unknown-error.title': "We kunnen projectpagina's op dit moment niet weergeven",
    'project-pages.improvement.feature1': 'Open en maak documenten aan zonder Jira te verlaten',
    'project-pages.improvement.feature2': 'Sjablonen voor vergaderingen, sprintplannen en meer',
    'project-pages.improvement.feature3': 'Synchroniseer documenten naar Jira voor automatische updates',
    'project-pages.improvement.heading-info': 'Leg de kennis van je team vast en verbeter je manier van werken.',
    'project-pages.improvement.heading-info-v2': "Cre\xeber \xe9\xe9n plek voor alle projectdocumenten van je team",
    'project-pages.improvement.learn-more-button': 'Meer informatie',
    'project-pages.improvement.powered-by': 'Mogelijk gemaakt door',
    'project-pages.improvement.powered-by.tooltip': 'Confluence openen op een nieuw tabblad',
    'project-pages.improvement.preview-teaser': "Sjablonen, projectpagina's en meer ontgrendelen.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': '<p>Houd je projectrapporten up-to-date met statuslabels die automatisch bijgewerkt worden.</p> <p>Koppel een Jira-ticket in een document en deze geeft automatisch een statuslabel weer die tegelijk met het ticket wordt bijgewerkt. Je hoeft dan geen tijd te besteden aan het handmatig aanmaken van rapporten.</p>',
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': 'Werk je belanghebbenden moeiteloos bij',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Maak consistente documentatie aan door onze ingebouwde sjablonen te gebruiken. Deze zijn gebruiksvriendelijk en kunnen aan je behoeften aangepast worden.</p> <p>Je kunt sjablonen rechtstreeks op projectpagina's gebruiken, zodat je dat waar je aan werkt, nooit hoeft achter te laten. Blader <a>hier</a> door alle sjablonen.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Verenig je documentatienormen',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Zorg voor \xe9\xe9n bron van waarheid voor belangrijke informatie door documentatie aan te maken en te beheren vanaf het tabblad projectpagina's in Jira.</p> <p>Wist je dat projectpagina's op Confluence draaien? Het is gratis voor maximaal 10 gebruikers. Nodig de rest van je team uit in de beheerdersinstellingen.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "Je projectpagina's, rechtstreeks in Jira",
    'project-pages.improvement.templates.blank-page.description': 'Begin met een nieuwe pagina.',
    'project-pages.improvement.templates.blank-page.name': 'Lege pagina',
    'project-pages.improvement.templates.decision.description': 'Sla belangrijke projectbeslissingen op en communiceer deze met je team.',
    'project-pages.improvement.templates.decision.name': 'Beslissing',
    'project-pages.improvement.templates.meeting-notes.description': 'Plan je afspraken en deel notities en acties met je team.',
    'project-pages.improvement.templates.meeting-notes.name': 'Notulen',
    'project-pages.improvement.templates.post-expand.more': 'Meer sjablonen',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Bekijk alle sjablonen in Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': 'Populaire sjablonen',
    'project-pages.improvement.templates.post-expand.title': 'Maak een pagina aan',
    'project-pages.improvement.templates.pre-expand.more': 'Bekijk meer sjablonen',
    'project-pages.improvement.templates.pre-expand.subtitle': 'Populair bij andere teams',
    'project-pages.improvement.templates.pre-expand.title': 'Voorbeeldsjablonen',
    'project-pages.improvement.templates.product-requirements.description': 'Definieer, volg en beoordeel vereisten van je product of feature.',
    'project-pages.improvement.templates.product-requirements.name': 'Producteisen',
    'project-pages.improvement.templates.retrospective.description': 'Wat ging er goed? Wat had beter gekund? Crowdsource verbeteringen met je team.',
    'project-pages.improvement.templates.retrospective.name': 'Retrospectief',
    'project-pages.improvement.templates.template.disabled-tooltip': 'Koppel eerst een Confluence-space',
    'project-pages.improvement.templates.tutorial.content.confluence-templates': '<b>Bespaar tijd en doe minder handmatig</b>. Confluence heeft heel veel <a>paginasjablonen</a> dus je hoeft niet vanaf nul te beginnen. Denk aan technische documenten, handleidingen voor het oplossen van problemen, projectplannen, productvereisten en meer.',
    'project-pages.improvement.templates.tutorial.content.edit-and-format': '<b>Eenvoudig bewerken en formatteren.</b> Gebruik het bovenste bewerkingsmenu voor standaard woordopmaak. En door <b>/</b> te typen kun je gemakkelijk veel handige integraties invoegen. Voeg een tabel in door <c>/table</c> te typen of voeg een afbeelding in met <c>/image</c>. Je kunt ook Dropbox-links <c>/dropbox</c>, Microsoft 365-tools <c>/microsoft</c> of Trello-borden en -kaarten <c>/trello</c> invoegen.',
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Type / gevolgd door 'tabel' of 'afbeelding'",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': 'Hier zijn een aantal tips om aan de slag te gaan:',
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Handige links',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Jira en Confluence samen gebruiken',
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Maak grafieken op je pagina's met echte gegevens uit Jira Typ <c>/Jira-grafieken</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': 'Link waar je maar wilt een Jira-issue op je pagina. De link op de pagina zal in realtime bijgewerkt worden wanneer je de Jira-issue bijwerkt. Typ <c>/Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': 'Sluit interactieve roadmaps en tijdlijnen in op je pagina met behulp van je Jira-projecten. Typ <c>/jira-roadmap</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-timeline': 'Sluit interactieve tijdlijnen in op je pagina met behulp van je Jira-projecten. Typ <c>/jira-tijdlijn</c>.',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': '76% van de Jira Software-klanten zegt projecten sneller te leveren dankzij Confluence',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': '76% van de Jira-klanten zegt dat ze projecten sneller kunnen leveren nadat ze Confluence hebben toegevoegd',
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Spaces en pagina's gebruiken</b>. Spaces maken deel uit van elke Confluence-site en zijn een manier om pagina's in categorie\xebn in te delen. Zie spaces als verschillende mappen of projecten, en pagina's zijn de documenten die in die mappen of projecten thuishoren. <a>Meer informatie over het gebruik van spaces</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Probeer het nu',
    'project-pages.improvement.templates.tutorial.description': 'Meer informatie over hoe je een pagina bewerkt.',
    'project-pages.improvement.templates.tutorial.name': "Welkom bij de Projectpagina's!",
    'project-pages.improvement.terms-and-conditions-v2': "Door op 'Nu proberen' te klikken, stem je ermee in dat je wordt ingeschreven in Confluence en ga je akkoord met de <termsLink>Servicevoorwaarden</termsLink> en het <privacyLink>Privacybeleid</privacyLink> van Atlassian Cloud.",
    'project-pages.improvement.title': "Projectpagina's",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Pagina aanmaken',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': 'We hebben Confluence toegevoegd, zodat je kunt beginnen met het aanmaken en koppelen van al je projectdocumenten. Het is gratis voor maximaal 10 gebruikers.',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Meer informatie',
    'project-pages.improvement.transient-states.empty-state.create-page-button': 'Maak je eerste pagina aan',
    'project-pages.improvement.transient-states.empty-state.description': 'Maak vergadernotulen aan, stel productvereisten op, neem beslissingen of maak andere content aan, om deze space op te vullen.',
    'project-pages.improvement.transient-states.empty-state.title': 'Hier zijn alleen maar mogelijkheden',
    'project-pages.improvement.try-button': 'Probeer dit sjabloon in Confluence',
    'project-pages.improvement.try-it-now': 'Nu proberen',
    'project-pages.improvement.try-lozenge': 'Probeer',
    'project-pages.improvement.try-on-demand-button': 'Gratis uitproberen',
    'project-pages.page-deleted-flag.title': 'Pagina verwijderd.',
    'project-pages.page-published-flag.title': 'Je pagina is gepubliceerd.',
    'project-pages.unknown-error.description': 'Als vernieuwen de problemen niet verhelpt, {contactSupport}.',
    'project-pages.unknown-error.heading': "We kunnen projectpagina's op dit moment niet weergeven",
    'projectpages.templatepreview.termsandprivacy': "Door op 'Gratis uitproberen' te klikken, word je automatisch ingeschreven in Confluence en ga je akkoord met de <termsOfServiceLinkText>Servicevoorwaarden</termsOfServiceLinkText> en het <privacyPolicyLinkText>Privacybeleid</privacyPolicyLinkText> van Atlassian Cloud."
};

});

parcelRegister("cKAjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4ae2226b93f97c8$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Estonian
var $a4ae2226b93f97c8$export$2e2bcd8739ae039 = {
    'project-pages.connect-space-dialog.connection-error': "\xdchenduse loomine eba\xf5nnestus.",
    'project-pages.connect-space-dialog.connection-retry': 'Proovi uuesti',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Enne lehe loomist peab projekt olema \xfchendatud ruumiga. Projektiga \xfchenduse loomiseks valige ruum.",
    'project-pages.connect-space-dialog.error-icon': 'Viga:',
    'project-pages.connect-space-dialog.footer.cancel': "T\xfchista",
    'project-pages.connect-space-dialog.footer.connect-space': "\xdchenda",
    'project-pages.connect-space.description': "Ruumid on nagu kaustad \u2013 saate neid kasutada oma projektiga seotud sisu loomiseks ja sorteerimiseks ning koost\xf6\xf6 tegemiseks.",
    'project-pages.create-space-dialog.connection-error': "\xdchenduse loomine eba\xf5nnestus.",
    'project-pages.create-space-dialog.connection-retry': 'Proovi uuesti',
    'project-pages.create-space-dialog.content.empty-name': 'Andke ruumile nimi.',
    'project-pages.create-space-dialog.content.invalid-name': "Ruumi nimes peab olema v\xe4hemalt \xfcks t\xe4ht v\xf5i number.",
    'project-pages.create-space-dialog.content.placeholder': 'Sisestage ruumi nimi',
    'project-pages.create-space-dialog.creation-error': "Ruumi loomine eba\xf5nnestus.",
    'project-pages.create-space-dialog.error-icon': 'Viga:',
    'project-pages.create-space-dialog.footer.cancel': "T\xfchista",
    'project-pages.create-space-dialog.footer.create-space': 'Loo',
    'project-pages.create-space-dialog.header.title': "Uue Confluence\u2019i ruumi loomine",
    'project-pages.default-contextual-message': "Confluence\u2019i lehtede abil saate \xfches kohas k\xf5iki projektidokumente koostada ja jagada ning nende kallal koost\xf6\xf6d teha.",
    'project-pages.default-reactivate-CTA': 'Aktiveerige Confluence uuesti',
    'project-pages.default-trial-CTA': "Proovige Confluence\u2019i 30 p\xe4eva tasuta",
    'project-pages.generic-error.button.reload': "Lehek\xfclje uuesti laadimine",
    'project-pages.generic-error.description': "Midagi l\xe4ks valesti. Proovige hiljem uuesti.",
    'project-pages.generic-error.heading': 'Oih, piinlik lugu ...'
};

});

parcelRegister("iHMjO", function(module, exports) {

$parcel$export(module.exports, "default", () => $487c5f1bb842803d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $487c5f1bb842803d$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "T\xe4m\xe4 vie alle minuutin",
    'confluence.project-pages.improvement.provisioning-background.title': "M\xe4\xe4ritet\xe4\xe4n projektisivuja",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Ohita',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Valmis',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Seuraava',
    'project-pages.activating.description': "Yhdistetty Confluence-ty\xf6tila ei ole ihan viel\xe4 valmis. {contactSupport}, jos sivun p\xe4ivitt\xe4minen ei korjaa asiaa.",
    'project-pages.activating.heading': "Confluence latautuu viel\xe4",
    'project-pages.button.connect-different-space-or-page.label': "P\xe4ivit\xe4 ty\xf6tila tai sivu -kuvake",
    'project-pages.button.connect-different-space-or-page.tooltip': "Yhdist\xe4 eri ty\xf6tilaan tai sivuun",
    'project-pages.button.connect-space-or-page.tooltip': "Yhdist\xe4 Confluenceen",
    'project-pages.button.go-to-connected-page.tooltip': 'Avaa sivu Confluencessa',
    'project-pages.button.go-to-connected-space.tooltip': "Avaa ty\xf6tila Confluencessa",
    'project-pages.connect-space-dialog.connection-error': "Yhteys ep\xe4onnistui.",
    'project-pages.connect-space-dialog.connection-retry': "Yrit\xe4 uudelleen",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Valitse projektiisi yhdistett\xe4v\xe4 ty\xf6tila tai sivu.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Hae Confluencesta',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "T\xe4m\xe4 projekti t\xe4ytyy yhdist\xe4\xe4 ty\xf6tilaan, ennen kuin voit luoda sivun. Valitse ty\xf6tila, joka yhdistet\xe4\xe4n t\xe4h\xe4n projektiin.",
    'project-pages.connect-space-dialog.error-icon': 'Virhe:',
    'project-pages.connect-space-dialog.footer.cancel': 'Peruuta',
    'project-pages.connect-space-dialog.footer.connect-space': "Yhdist\xe4",
    'project-pages.connect-space-or-page-dialog.header.title': "Yhdist\xe4 projekti Confluenceen",
    'project-pages.connect-space.description': "Ty\xf6tilat ovat kuin kansioita \u2013 niit\xe4 voi k\xe4ytt\xe4\xe4, kun haluat luoda, j\xe4rjest\xe4\xe4 ja ty\xf6st\xe4\xe4 yhdess\xe4 kaikkea projektiisi liittyv\xe4\xe4 sis\xe4lt\xf6\xe4.",
    'project-pages.connect-space.not-connected.description': "Jotta voit k\xe4ytt\xe4\xe4 projektisivuja, ota yhteytt\xe4 yll\xe4pit\xe4j\xe4\xe4si tai tiimisi vet\xe4j\xe4\xe4n Confluencen yhdist\xe4miseksi t\xe4h\xe4n projektiin.",
    'project-pages.connect-space.not-connected.heading': 'Ei yhdistetty Confluenceen',
    'project-pages.connect-success-flag.description.content': "Yhdistetty sis\xe4ll\xf6n {connectedSpaceOrPageName} kanssa.",
    'project-pages.connection-error.space-or-page-not-found.button': "Yhdist\xe4 eri ty\xf6tilaan tai sivuun",
    'project-pages.create-space-dialog.connection-error': "Yhteys ep\xe4onnistui.",
    'project-pages.create-space-dialog.connection-retry': "Yrit\xe4 uudelleen",
    'project-pages.create-space-dialog.content.empty-name': "Nime\xe4 ty\xf6tilasi.",
    'project-pages.create-space-dialog.content.invalid-name': "Ty\xf6tilan nimess\xe4 on oltava v\xe4hint\xe4\xe4n yksi kirjain tai numero.",
    'project-pages.create-space-dialog.content.placeholder': "Sy\xf6t\xe4 ty\xf6tilan nimi",
    'project-pages.create-space-dialog.creation-error': "Ty\xf6tilan luonti ep\xe4onnistui.",
    'project-pages.create-space-dialog.error-icon': 'Virhe:',
    'project-pages.create-space-dialog.footer.cancel': 'Peruuta',
    'project-pages.create-space-dialog.footer.create-space': 'Luo',
    'project-pages.create-space-dialog.header.title': "Luo uusi Confluence-ty\xf6tila",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Et voi k\xe4ytt\xe4\xe4 projektin sivuja, koska yll\xe4pit\xe4j\xe4 on ev\xe4nnyt p\xe4\xe4sysi Confluenceen. Ota yhteytt\xe4 sivustosi yll\xe4pit\xe4j\xe4\xe4n p\xe4\xe4syn pyyt\xe4mist\xe4 varten.",
    'project-pages.cross-join.access-revoked.templates.title': "Sinulla ei ole oikeutta k\xe4ytt\xe4\xe4 projektin sivuja",
    'project-pages.cross-join.avatar.view-profile': "N\xe4yt\xe4 profiili",
    'project-pages.cross-join.denied-request.templates.subtitle': "Et voi k\xe4ytt\xe4\xe4 projektin sivuja, koska sivuston yll\xe4pit\xe4j\xe4 hylk\xe4si pyynt\xf6si liitty\xe4 Confluenceen.",
    'project-pages.cross-join.denied-request.templates.title': "Yll\xe4pit\xe4j\xe4si on ev\xe4nnyt p\xe4\xe4sysi",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Saat Confluencen k\xe4ytt\xf6oikeuden. Sivustosi yll\xe4pit\xe4j\xe4 on jo hyv\xe4ksynyt sinut.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport}, jos sivun p\xe4ivitt\xe4minen ei korjaa asiaa.",
    'project-pages.cross-join.errors.unknown-error.title': "Projektisivuja ei voi n\xe4ytt\xe4\xe4 juuri nyt",
    'project-pages.cross-join.inline-join-product.button': "Saat Confluencen k\xe4ytt\xf6oikeuden. Sivustosi yll\xe4pit\xe4j\xe4 on jo hyv\xe4ksynyt sinut.",
    'project-pages.cross-join.inline-join-product.connected.description': "Tarkastele, muokkaa ja luo dokumentteja yhdess\xe4 paikassa",
    'project-pages.cross-join.inline-join-product.connected.title': "Ty\xf6st\xe4 projektisivuja yhdess\xe4 tiimisi kanssa",
    'project-pages.cross-join.pending-request.templates.subtitle': "Sivuston yll\xe4pit\xe4j\xe4 on vastaanottanut pyynt\xf6si liitty\xe4 Confluenceen. Jos liittymispyynt\xf6si hyv\xe4ksyt\xe4\xe4n, projektisivut alkavat toimia ja l\xe4het\xe4mme sinulle vahvistuss\xe4hk\xf6postin.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Saat s\xe4hk\xf6postiviestin, jossa on p\xe4\xe4sy projektisivuille, kun sinut on hyv\xe4ksytty.",
    'project-pages.cross-join.pending-request.templates.title': "Olet pyyt\xe4nyt p\xe4\xe4sy\xe4 Confluenceen",
    'project-pages.cross-join.pending-request.templates.title.experiment': "K\xe4ytt\xf6oikeuspyynt\xf6 l\xe4hetetty yll\xe4pit\xe4j\xe4lle",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Tarkastele, muokkaa ja luo projektidokumentteja yhdess\xe4 tiimisi kanssa",
    'project-pages.cross-join.request-access.button': "Pyyd\xe4 p\xe4\xe4sy\xe4",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "Valitsemalla Liity tiimiisi pyyd\xe4t liittymist\xe4 Confluenceen ja hyv\xe4ksyt sen, ett\xe4 Atlassian-profiilisi jaetaan yll\xe4pit\xe4j\xe4lle.",
    'project-pages.cross-join.request-access.button.experimental': 'Liity tiimiisi',
    'project-pages.cross-join.request-access.connected.description.experimental': "Tiimisi k\xe4ytt\xe4\xe4 projektisivuja kommentointiin, muokkaamiseen ja yhteisty\xf6n tekoon projektidokumentaatiossa poistumatta Jirasta. Liity Confluenceen, niin p\xe4\xe4set tiimisi projektisivuille.",
    'project-pages.cross-join.request-access.title': "Projektisivut vaativat p\xe4\xe4syn Confluenceen",
    'project-pages.cross-join.request-access.title.experiment': "Luo yksi tiedonl\xe4hde tiimillesi",
    'project-pages.default-contextual-heading': 'Projektisivuista vastaa Confluence',
    'project-pages.default-contextual-message': "Luo, jaa ja ty\xf6st\xe4 yhdess\xe4 kaikkia projektiasiakirjojasi yhdess\xe4 paikassa Confluence-sivujen avulla.",
    'project-pages.default-reactivate-CTA': 'Aktivoi Confluence uudelleen',
    'project-pages.default-trial-CTA': "Kokeile Confluencea ilmaiseksi 30 p\xe4iv\xe4n ajan",
    'project-pages.draft-saved-flag.action': 'Avaa luonnos',
    'project-pages.draft-saved-flag.description': "Luonnoksesi n\xe4kyy vain siihen asti, kunnes julkaiset sen.",
    'project-pages.draft-saved-flag.title': 'Luonnos tallennettu',
    'project-pages.embedded-pages.create-page-error.close-button': 'Sulje',
    'project-pages.embedded-pages.create-page-error.description': "Tapahtui virhe, eik\xe4 sivun luominen onnistunut.",
    'project-pages.embedded-pages.create-page-error.title': 'Sivun luominen ei onnistunut',
    'project-pages.embedded-pages.create-page-error.try-again-button': "Yrit\xe4 uudelleen",
    'project-pages.embedded-pages.modal.close.button.hint': 'Sulje',
    'project-pages.embedded-pages.modal.title.button': 'Avaa Confluencessa',
    'project-pages.embedded-pages.modal.title.button.hint': "Avaa uudelle v\xe4lilehdelle",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport}, jos sivun p\xe4ivitt\xe4minen ei korjaa asiaa.",
    'project-pages.errors.unknown-error.title.non-final': "Projektisivuja ei voi n\xe4ytt\xe4\xe4 juuri nyt",
    'project-pages.generic-error.button.reload': 'Lataa sivu uudelleen',
    'project-pages.generic-error.description': "Jotain meni pieleen. Yrit\xe4 my\xf6hemmin uudelleen.",
    'project-pages.generic-error.description.non-final': "Jotain meni pieleen. Yrit\xe4 my\xf6hemmin uudelleen.",
    'project-pages.generic-error.heading': "Nyt k\xe4vi nolosti.",
    'project-pages.generic-error.title.non-final': "Nyt k\xe4vi nolosti.",
    'project-pages.generic-info-flag.description': "Jokin meni vikaan. Yrit\xe4 uudelleen tai ota yhteys tukeen, jos ongelma jatkuu",
    'project-pages.generic-success-flag.description.page': 'Yhdistetty onnistuneesti sivun {connectedSpaceOrPageName} kanssa.',
    'project-pages.generic-success-flag.description.space': "Yhdistetty onnistuneesti ty\xf6tilan {connectedSpaceOrPageName} kanssa.",
    'project-pages.generic-success-flag.heading.page': 'Sivu yhdistetty',
    'project-pages.generic-success-flag.heading.space': "Ty\xf6tila yhdistetty",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Tai luo uusi ty\xf6tila",
    'project-pages.granular-pages.connect-space.button': "Yhdist\xe4 Confluenceen",
    'project-pages.granular-pages.connect-space.heading': "Yhdist\xe4 t\xe4m\xe4 projekti Confluence-ty\xf6tilaan tai -sivuun",
    'project-pages.granular-pages.connect-space.heading.non-final': "Yhdist\xe4 t\xe4m\xe4 projekti Confluence-ty\xf6tilaan tai -sivuun",
    'project-pages.improvement.contact-support': "Ota yhteytt\xe4 tukeen",
    'project-pages.improvement.errors.access-error.description': "Kokeile pyyt\xe4\xe4 k\xe4ytt\xf6oikeutta sivuston yll\xe4pit\xe4j\xe4lt\xe4.",
    'project-pages.improvement.errors.access-error.title': 'Sinulla ei ole lupaa tarkastella projektisivuja',
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Jokin meni vikaan, kun yhdistetyn Confluence-ty\xf6tilan sivuja yritettiin n\xe4ytt\xe4\xe4. {contactSupport}, jos sivun p\xe4ivitt\xe4minen ei korjaa asiaa.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Projektisivujen n\xe4ytt\xe4misess\xe4 on ongelmia",
    'project-pages.improvement.errors.space-or-page-not-found.description': "Yhdistetty Confluence-ty\xf6tila tai \u2011sivu on siirretty, arkistoitu tai poistettu. <link>Ota yhteytt\xe4 tukeen</link>, jos uudelleen yhdist\xe4minen ei korjaa asiaa",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Ty\xf6tilaa tai sivua ei l\xf6ytynyt",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport}, jos sivun p\xe4ivitt\xe4minen ei korjaa asiaa.",
    'project-pages.improvement.errors.unknown-error.title': "Projektisivuja ei voi n\xe4ytt\xe4\xe4 juuri nyt",
    'project-pages.improvement.feature1': "K\xe4yt\xe4 ja luo asiakirjoja poistumatta Jirasta",
    'project-pages.improvement.feature2': 'Sivupohjat muun muassa kokouksiin ja sprinttisuunnitelmiin',
    'project-pages.improvement.feature3': "Synkronoi asiakirjat Jiraan automaattisia p\xe4ivityksi\xe4 varten",
    'project-pages.improvement.heading-info': "Taltioi tiimisi tiet\xe4mys ja paranna tapaa, jolla ty\xf6t vied\xe4\xe4n loppuun.",
    'project-pages.improvement.heading-info-v2': 'Luo yksi paikka kaikille tiimisi projektiasiakirjoille',
    'project-pages.improvement.learn-more-button': "Lue lis\xe4\xe4",
    'project-pages.improvement.powered-by': 'Palvelun tarjoaa',
    'project-pages.improvement.powered-by.tooltip': "Avaa Confluence uudella v\xe4lilehdell\xe4",
    'project-pages.improvement.preview-teaser': "Avaa k\xe4ytt\xf6\xf6n sivupohjia, projektisivuja ja paljon muuta.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Pid\xe4 projektiraportit ajan tasalla automaattisesti p\xe4ivittyvien tilatunnisteiden avulla.</p> <p>Yhdist\xe4 Jira-tukipyynt\xf6 asiakirjaan, niin tilatunniste n\xe4ytet\xe4\xe4n automaattisesti. Tunniste p\xe4ivittyy synkronoituna tukipyynn\xf6n kanssa, joten sinun ei tarvitse k\xe4ytt\xe4\xe4 aikaasi manuaalisten raporttien luomiseen.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "P\xe4ivit\xe4 sidosryhm\xe4t saumattomasti",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Luo johdonmukainen dokumentaatio k\xe4ytt\xe4m\xe4ll\xe4 sis\xe4\xe4nrakennettuja sivupohjia. Ne ovat helppok\xe4ytt\xf6isi\xe4 ja muokattavissa tarpeisiisi.</p> <p>Voit k\xe4ytt\xe4\xe4 sivupohjia suoraan projektisivuilta, joten sinun ei tarvitse koskaan j\xe4tt\xe4\xe4 ty\xf6t\xe4si. Selaa kaikkia sivupohjia <a>t\xe4\xe4ll\xe4</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Yhdist\xe4 dokumentointistandardit",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Luo yksi ainoa tiedonl\xe4hde t\xe4rkeille tiedoille luomalla ja hallitsemalla dokumentaatiota Jiran projektisivuv\xe4lilehdelt\xe4.</p> <p>Tiesitk\xf6, ett\xe4 projektisivut toimivat Confluencessa? Se on ilmainen jopa 10 k\xe4ytt\xe4j\xe4lle. Kutsu muu tiimisi yll\xe4pit\xe4j\xe4n asetuksissa.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Omat projektisivut suoraan Jirassa',
    'project-pages.improvement.templates.blank-page.description': "Aloita sivu tyhj\xe4st\xe4.",
    'project-pages.improvement.templates.blank-page.name': "Tyhj\xe4 sivu",
    'project-pages.improvement.templates.decision.description': "Tallenna t\xe4rke\xe4t projektien p\xe4\xe4t\xf6kset ja tiedota niist\xe4 tiimillesi.",
    'project-pages.improvement.templates.decision.name': "P\xe4\xe4t\xf6s",
    'project-pages.improvement.templates.meeting-notes.description': 'Suunnittele tapaamiset ja jaa muistiinpanoja tiimisi kanssa.',
    'project-pages.improvement.templates.meeting-notes.name': 'Kokousmuistiinpanot',
    'project-pages.improvement.templates.post-expand.more': "Lis\xe4\xe4 sivupohjia",
    'project-pages.improvement.templates.post-expand.more.tooltip': "N\xe4yt\xe4 kaikki sivupohjat Confluencessa",
    'project-pages.improvement.templates.post-expand.subtitle': 'Suositut sivupohjat',
    'project-pages.improvement.templates.post-expand.title': 'Luo sivu',
    'project-pages.improvement.templates.pre-expand.more': 'Tutki muita sivupohjia',
    'project-pages.improvement.templates.pre-expand.subtitle': 'Suositut omasi kaltaisten tiimien parissa',
    'project-pages.improvement.templates.pre-expand.title': 'Sivupohjien esikatselu',
    'project-pages.improvement.templates.product-requirements.description': "M\xe4\xe4rittele ja rajaa vaatimukset tuotteelle tai ominaisuudelle sek\xe4 seuraa niit\xe4.",
    'project-pages.improvement.templates.product-requirements.name': 'Tuote-edellytykset',
    'project-pages.improvement.templates.retrospective.description': "Mik\xe4 sujui hyvin? Mik\xe4 olisi voinut sujua paremmin? Keskustele tiimisi kanssa.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektiivi',
    'project-pages.improvement.templates.template.disabled-tooltip': "Yhdist\xe4 ensin Confluence-ty\xf6tila",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>S\xe4\xe4st\xe4 aikaa ja v\xe4henn\xe4 manuaalisia teht\xe4vi\xe4</b>. Confluencessa on paljon <a>sivupohjia</a>, jotta sinun ei tarvitse aloittaa tyhj\xe4st\xe4. N\xe4ihin kuuluvat muun muassa tekniset asiakirjat, vianm\xe4\xe4ritysoppaat, projektisuunnitelmat ja tuotevaatimukset.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Muokkaa ja muotoile helposti.</b> K\xe4yt\xe4 yl\xe4muokkausvalikkoa vakiomuotoiluun ja hy\xf6dynn\xe4 useita k\xe4tevi\xe4 integrointeja kirjoittamalla <b>/</b>. Lis\xe4\xe4 taulukko kirjoittamalla <c>/taulukko</c> tai kuva kirjoittamalla <c>/kuva</c>. Voit my\xf6s lis\xe4t\xe4 Dropbox-linkin kirjoittamalla <c>/dropbox</c>, Microsoft Office -ty\xf6kaluja kirjoittamalla <c>/microsoft</c> tai Trello-tauluja ja -kortteja kirjoittamalla <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Kirjoita / ja sen j\xe4lkeen "taulukko" tai "kuva"',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "T\xe4ss\xe4 on pari vinkki\xe4, joilla p\xe4\xe4set alkuun:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "K\xe4tevi\xe4 linkkej\xe4",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "K\xe4yt\xe4 Jiraa ja Confluencea yhdess\xe4",
    'project-pages.improvement.templates.tutorial.content.jira-charts': 'Luo sivuillesi kaavioita Jirasta saatujen tietojen pohjalta. Kirjoita <c>/Jira-kaaviot</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links': "Yhdist\xe4 Jira-asia minne tahansa sivullesi. Sivun linkki p\xe4ivittyy reaaliajassa, kun p\xe4ivit\xe4t Jira-asiaa. Kirjoita <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Upota interaktiivisia etenemissuunnitelmia ja aikajanoja sivuusi k\xe4ytt\xe4m\xe4ll\xe4 Jira-projektejasi. Kirjoita <c>/jira-etenemissuunnitelma</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Upota interaktiivisia aikajanoja sivuusi k\xe4ytt\xe4m\xe4ll\xe4 Jira-projektejasi. Kirjoita <c>/jira-aikajana</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% Jira Software -asiakkaista kertoi toimittaneensa projekteja nopeammin Confluencen lis\xe4\xe4misen j\xe4lkeen",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% Jira-asiakkaista kertoi toimittaneensa projekteja nopeammin Confluencen lis\xe4\xe4misen j\xe4lkeen",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Ty\xf6tilojen ja sivujen k\xe4ytt\xf6</b>. Ty\xf6tilat ovat osa jokaista Confluence-sivustoa, ja niiden avulla voi luokitella sivuja. Ty\xf6tilat ovat ik\xe4\xe4n kuin kansioita tai projekteja, ja sivut ovat kuin niiden sis\xe4lt\xe4mi\xe4 asiakirjoja. <a>Lue lis\xe4\xe4 ty\xf6tilojen k\xe4yt\xf6st\xe4</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Kokeile nyt',
    'project-pages.improvement.templates.tutorial.description': 'Lue, kuinka sivua voi muokata.',
    'project-pages.improvement.templates.tutorial.name': 'Tervetuloa projektisivuille!',
    'project-pages.improvement.terms-and-conditions-v2': "Valitsemalla &quot;Kokeile nyt&quot; hyv\xe4ksyt rekister\xf6itymisen Confluenceen sek\xe4 Atlassian Cloudin <termsLink>palveluehdot</termsLink> ja <privacyLink>tietosuojak\xe4yt\xe4nn\xf6n</privacyLink>.",
    'project-pages.improvement.title': 'Projektisivut',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Luo sivu',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Lis\xe4simme Confluencen, jotta voit ryhty\xe4 luomaan ja yhdist\xe4m\xe4\xe4n kaikkia projektisi asiakirjoja. Se on maksuton jopa 10 k\xe4ytt\xe4j\xe4lle.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "Lue lis\xe4\xe4",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Luo ensimm\xe4inen sivusi",
    'project-pages.improvement.transient-states.empty-state.description': "T\xe4yt\xe4 t\xe4m\xe4 ty\xf6tila luomalla kokousmuistioita, tuotevaatimuksia, p\xe4\xe4t\xf6ksi\xe4 tai muuta sis\xe4lt\xf6\xe4.",
    'project-pages.improvement.transient-states.empty-state.title': "T\xe4\xe4lt\xe4 l\xf6ytyy pelkk\xe4\xe4 potentiaalia",
    'project-pages.improvement.try-button': "Kokeile t\xe4t\xe4 sivupohjaa Confluencessa",
    'project-pages.improvement.try-it-now': 'Kokeile nyt',
    'project-pages.improvement.try-lozenge': 'Kokeile',
    'project-pages.improvement.try-on-demand-button': 'Kokeile ilmaiseksi',
    'project-pages.page-deleted-flag.title': 'Sivu poistettu.',
    'project-pages.page-published-flag.title': 'Sivusi on julkaistu.',
    'project-pages.unknown-error.description': "{contactSupport}, jos sivun p\xe4ivitt\xe4minen ei korjaa asiaa.",
    'project-pages.unknown-error.heading': "Projektisivuja ei voi n\xe4ytt\xe4\xe4 juuri nyt",
    'projectpages.templatepreview.termsandprivacy': "Napsauttamalla Kokeile ilmaiseksi \u2011painiketta sinut rekister\xf6id\xe4\xe4n Confluenceen ja hyv\xe4ksyt Atlassian <termsOfServiceLinkText>Cloudin palveluehdot</termsOfServiceLinkText> ja <privacyPolicyLinkText>tietosuojak\xe4yt\xe4nn\xf6n</privacyPolicyLinkText>."
};

});

parcelRegister("1FHgV", function(module, exports) {

$parcel$export(module.exports, "default", () => $51879626d3f4a7d5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $51879626d3f4a7d5$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "L'op\xe9ration devrait prendre moins d'une minute",
    'confluence.project-pages.improvement.provisioning-background.title': 'Configuration de vos pages de projet',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Ignorer',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "Termin\xe9",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Suivant',
    'project-pages.activating.description': "L'espace\xa0Confuence connect\xe9 n'est pas encore tout \xe0 fait pr\xeat. {contactSupport} si l'actualisation ne corrige pas le probl\xe8me.",
    'project-pages.activating.heading': 'Chargement de Confluence toujours en cours',
    'project-pages.button.connect-different-space-or-page.label': "Mettez \xe0 jour l'ic\xf4ne de l'espace ou de la page",
    'project-pages.button.connect-different-space-or-page.tooltip': "Connecter \xe0 un autre espace ou une autre page",
    'project-pages.button.connect-space-or-page.tooltip': "Connecter \xe0 Confluence",
    'project-pages.button.go-to-connected-page.tooltip': 'Ouvrir la page dans Confluence',
    'project-pages.button.go-to-connected-space.tooltip': "Ouvrir l'espace dans Confluence",
    'project-pages.connect-space-dialog.connection-error': "\xc9chec de la connexion.",
    'project-pages.connect-space-dialog.connection-retry': "R\xe9essayer",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': 'Choisissez un espace ou une page auxquels connecter votre projet.',
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Rechercher sur Confluence',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Ce projet doit \xeatre connect\xe9 \xe0 un espace avant que vous puissiez cr\xe9er une page. Choisissez un espace auquel connecter ce projet.",
    'project-pages.connect-space-dialog.error-icon': "Erreur\xa0:",
    'project-pages.connect-space-dialog.footer.cancel': 'Annuler',
    'project-pages.connect-space-dialog.footer.connect-space': 'Connecter',
    'project-pages.connect-space-or-page-dialog.header.title': "Connecter le projet \xe0 Confluence",
    'project-pages.connect-space.description': "Les espaces sont comme des dossiers\xa0: vous pouvez les utiliser afin de cr\xe9er du contenu associ\xe9 \xe0 votre projet, de l'organiser et de collaborer \xe0 sa mise en \u0153uvre.",
    'project-pages.connect-space.not-connected.description': "Pour utiliser les pages de projet, contactez votre administrateur ou votre chef d'\xe9quipe afin de connecter Confluence \xe0 ce projet.",
    'project-pages.connect-space.not-connected.heading': "Non connect\xe9es \xe0 Confluence",
    'project-pages.connect-success-flag.description.content': "Connexion r\xe9ussie au contenu {connectedSpaceOrPageName}.",
    'project-pages.connection-error.space-or-page-not-found.button': "Connecter \xe0 un autre espace ou une autre page",
    'project-pages.create-space-dialog.connection-error': "\xc9chec de la connexion.",
    'project-pages.create-space-dialog.connection-retry': "R\xe9essayer",
    'project-pages.create-space-dialog.content.empty-name': "Donnez un nom \xe0 votre espace.",
    'project-pages.create-space-dialog.content.invalid-name': "Les noms d'espaces doivent contenir au moins une lettre ou un chiffre.",
    'project-pages.create-space-dialog.content.placeholder': "Saisissez un nom d'espace",
    'project-pages.create-space-dialog.creation-error': "\xc9chec de cr\xe9ation de l'espace.",
    'project-pages.create-space-dialog.error-icon': "Erreur\xa0:",
    'project-pages.create-space-dialog.footer.cancel': 'Annuler',
    'project-pages.create-space-dialog.footer.create-space': "Cr\xe9er",
    'project-pages.create-space-dialog.header.title': "Cr\xe9er un espace Confluence",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Vous ne pouvez pas utiliser les pages de projet, car l'administrateur vous a refus\xe9 l'acc\xe8s \xe0 Confluence. Contactez votre administrateur de site pour demander l'acc\xe8s.",
    'project-pages.cross-join.access-revoked.templates.title': "Vous n'\xeates pas autoris\xe9 \xe0 utiliser les pages de projet",
    'project-pages.cross-join.avatar.view-profile': 'Afficher le profil',
    'project-pages.cross-join.denied-request.templates.subtitle': "Vous ne pouvez pas utiliser les pages de projet, car l'administrateur de site a rejet\xe9 votre demande de rejoindre Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "Votre administrateur vous a refus\xe9 l'acc\xe8s",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Vous allez obtenir l'acc\xe8s \xe0 Confluence. L'administrateur de votre site a d\xe9j\xe0 approuv\xe9 votre acc\xe8s.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} si l'actualisation ne corrige pas le probl\xe8me.",
    'project-pages.cross-join.errors.unknown-error.title': "Impossible d'afficher les pages de projet pour l'instant",
    'project-pages.cross-join.inline-join-product.button': "Vous aurez acc\xe8s \xe0 Confluence. L'administrateur de votre site a d\xe9j\xe0 approuv\xe9 votre acc\xe8s.",
    'project-pages.cross-join.inline-join-product.connected.description': "Affichez, modifiez et cr\xe9ez de la documentation depuis un seul et m\xeame endroit",
    'project-pages.cross-join.inline-join-product.connected.title': "Collaborez sur des pages de projet avec votre \xe9quipe",
    'project-pages.cross-join.pending-request.templates.subtitle': "Votre administrateur de site a re\xe7u votre demande de rejoindre Confluence. Si cette demande est accept\xe9e, les pages de projet seront accessibles, et vous recevrez un e-mail de confirmation.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Lorsque votre demande aura \xe9t\xe9 approuv\xe9e, vous recevrez un e-mail contenant un acc\xe8s aux pages de projet.",
    'project-pages.cross-join.pending-request.templates.title': "Vous avez demand\xe9 un acc\xe8s \xe0 Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "Demande d'acc\xe8s envoy\xe9e \xe0 l'administrateur",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Consultez, modifiez et cr\xe9ez la documentation du projet avec votre \xe9quipe",
    'project-pages.cross-join.request-access.button': "Demander l'acc\xe8s",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "Lorsque vous s\xe9lectionnez \xab\xa0Rejoindre votre \xe9quipe\xa0\xbb, vous demandez un acc\xe8s \xe0 Confluence et acceptez de partager votre profil\xa0Atlassian avec votre administrateur.",
    'project-pages.cross-join.request-access.button.experimental': "Rejoindre votre \xe9quipe",
    'project-pages.cross-join.request-access.connected.description.experimental': "Votre \xe9quipe utilise des pages de projet pour commenter la documentation de votre projet, la modifier et collaborer dessus, sans quitter Jira. Rejoignez Confluence pour acc\xe9der aux pages de projet de votre \xe9quipe.",
    'project-pages.cross-join.request-access.title': "Les pages de projet n\xe9cessitent un acc\xe8s \xe0 Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Cr\xe9er une source de r\xe9f\xe9rence unique pour votre \xe9quipe",
    'project-pages.default-contextual-heading': "Les pages des projets sont optimis\xe9es par Confluence",
    'project-pages.default-contextual-message': "Gr\xe2ce aux pages Confluence, vous pouvez cr\xe9er et partager tous les documents de vos projets ou collaborer pour les mener \xe0 bien \xe0 un seul et m\xeame endroit.",
    'project-pages.default-reactivate-CTA': "R\xe9activer Confluence",
    'project-pages.default-trial-CTA': "Essayez Confluence gratuitement pendant 30\xa0jours",
    'project-pages.draft-saved-flag.action': 'Ouvrir le brouillon',
    'project-pages.draft-saved-flag.description': "Votre brouillon est uniquement visible par vous jusqu'\xe0 sa publication.",
    'project-pages.draft-saved-flag.title': "Brouillon enregistr\xe9",
    'project-pages.embedded-pages.create-page-error.close-button': 'Fermer',
    'project-pages.embedded-pages.create-page-error.description': "Un probl\xe8me est survenu, et nous n'avons pas pu cr\xe9er une page pour vous.",
    'project-pages.embedded-pages.create-page-error.title': "Impossible de cr\xe9er une page",
    'project-pages.embedded-pages.create-page-error.try-again-button': "R\xe9essayez",
    'project-pages.embedded-pages.modal.close.button.hint': 'Fermer',
    'project-pages.embedded-pages.modal.title.button': 'Ouvrir dans Confluence',
    'project-pages.embedded-pages.modal.title.button.hint': 'Ouvrir dans un nouvel onglet',
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} si l'actualisation ne corrige pas le probl\xe8me.",
    'project-pages.errors.unknown-error.title.non-final': "Impossible d'afficher les pages de projet pour l'instant",
    'project-pages.generic-error.button.reload': 'Recharger la page',
    'project-pages.generic-error.description': "Une erreur s'est produite. R\xe9essayez ult\xe9rieurement.",
    'project-pages.generic-error.description.non-final': "Une erreur s'est produite. R\xe9essayez ult\xe9rieurement.",
    'project-pages.generic-error.heading': "Ah, c'est bizarre\u2026",
    'project-pages.generic-error.title.non-final': "Ah, c'est bizarre\u2026",
    'project-pages.generic-info-flag.description': "Une erreur s'est produite. Veuillez r\xe9essayer ou contacter le support si ce probl\xe8me persiste.",
    'project-pages.generic-success-flag.description.page': "Connexion r\xe9ussie \xe0 la page {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.space': "Connexion r\xe9ussie \xe0 l'espace {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.heading.page': "Page connect\xe9e",
    'project-pages.generic-success-flag.heading.space': "Connect\xe9 \xe0 l'espace",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Ou cr\xe9er un espace",
    'project-pages.granular-pages.connect-space.button': "Connecter \xe0 Confluence",
    'project-pages.granular-pages.connect-space.heading': "Connectez ce projet \xe0 un espace ou \xe0 une page\xa0Confluence",
    'project-pages.granular-pages.connect-space.heading.non-final': "Connectez ce projet \xe0 un espace ou \xe0 une page\xa0Confluence",
    'project-pages.improvement.contact-support': 'Contacter le support',
    'project-pages.improvement.errors.access-error.description': "Essayez de contacter l'administrateur de site pour demander un acc\xe8s.",
    'project-pages.improvement.errors.access-error.title': "Vous n'\xeates pas autoris\xe9 \xe0 afficher les pages de projet",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Une erreur s'est produite lors de la tentative d'affichage des pages de votre espace\xa0Confluence connect\xe9. {contactSupport} si l'actualisation ne corrige pas le probl\xe8me.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Nous ne parvenons pas \xe0 afficher les pages de projet",
    'project-pages.improvement.errors.space-or-page-not-found.description': "L'espace\xa0Confluence (ou la page) qui \xe9tait connect\xe9 a \xe9t\xe9 d\xe9plac\xe9, archiv\xe9 ou supprim\xe9. <link>Contactez le support</link> si une reconnexion ne r\xe9sout pas le probl\xe8me.",
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Espace ou page introuvable',
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} si l'actualisation ne corrige pas le probl\xe8me.",
    'project-pages.improvement.errors.unknown-error.title': "Impossible d'afficher les pages de projet pour l'instant",
    'project-pages.improvement.feature1': "Acc\xe9dez \xe0 des documents et cr\xe9ez-en sans quitter Jira",
    'project-pages.improvement.feature2': "Des mod\xe8les pour les r\xe9unions, les plans de sprint et bien plus encore",
    'project-pages.improvement.feature3': "Synchronisez des documents avec Jira pour les mises \xe0 jour automatiques",
    'project-pages.improvement.heading-info': "Capturez les connaissances de votre \xe9quipe et am\xe9liorez votre m\xe9thode de travail.",
    'project-pages.improvement.heading-info-v2': "Cr\xe9ez un emplacement unique pour tous les documents de projet de votre \xe9quipe",
    'project-pages.improvement.learn-more-button': 'En savoir plus',
    'project-pages.improvement.powered-by': "Optimis\xe9 par",
    'project-pages.improvement.powered-by.tooltip': 'Ouvrir Confluence dans un nouvel onglet',
    'project-pages.improvement.preview-teaser': "D\xe9bloquez les mod\xe8les, les pages de projets, et bien plus.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Tenez les rapports de vos projets \xe0 jour gr\xe2ce \xe0 la mise \xe0 jour automatique des \xe9tiquettes d'\xe9tat.</p> <p>Liez simplement un ticket\xa0Jira \xe0 un document pour qu'il affiche automatiquement une \xe9tiquette d'\xe9tat qui sera mise \xe0 jour en m\xeame temps que le ticket. Ainsi, vous ne devrez pas cr\xe9er de rapports manuels.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Tenez vos parties prenantes inform\xe9es en toute transparence",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Cr\xe9ez une documentation coh\xe9rente \xe0 l'aide de nos mod\xe8les int\xe9gr\xe9s. Ils sont simples \xe0 utiliser et personnalisables selon vos besoins.</p> <p>Vous pouvez utiliser des mod\xe8les directement depuis les pages de projet, afin de ne jamais devoir interrompre votre travail. Parcourez tous les mod\xe8les <a>ici</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Unifiez vos normes de documentation',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Cr\xe9ez une source de r\xe9f\xe9rence unique pour les informations importantes en cr\xe9ant et en g\xe9rant la documentation depuis l'onglet des pages de projet dans Jira.</p> <p>Saviez-vous que les pages de projet s'ex\xe9cutent sur Confluence\xa0? C'est gratuit pour un maximum de 10\xa0utilisateurs. Invitez le reste de votre \xe9quipe dans les param\xe8tres d'administration.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Vos pages de projet, directement dans Jira',
    'project-pages.improvement.templates.blank-page.description': "Cr\xe9ez une page en partant de rien.",
    'project-pages.improvement.templates.blank-page.name': 'Page vide',
    'project-pages.improvement.templates.decision.description': "Enregistrez les d\xe9cisions importantes li\xe9es \xe0 votre projet et communiquez-les \xe0 votre \xe9quipe.",
    'project-pages.improvement.templates.decision.name': "D\xe9cision",
    'project-pages.improvement.templates.meeting-notes.description': "Planifiez vos r\xe9unions et communiquez les notes et les actions \xe0 votre \xe9quipe.",
    'project-pages.improvement.templates.meeting-notes.name': "Notes de r\xe9union",
    'project-pages.improvement.templates.post-expand.more': "Plus de mod\xe8les",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Affichez tous les mod\xe8les dans Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': "Mod\xe8les populaires",
    'project-pages.improvement.templates.post-expand.title': "Cr\xe9er une page",
    'project-pages.improvement.templates.pre-expand.more': "D\xe9couvrir plus de mod\xe8les",
    'project-pages.improvement.templates.pre-expand.subtitle': "Populaires aupr\xe8s d'\xe9quipes comme la v\xf4tre",
    'project-pages.improvement.templates.pre-expand.title': "Pr\xe9visualiser les mod\xe8les",
    'project-pages.improvement.templates.product-requirements.description': "D\xe9finissez, suivez et d\xe9limitez les exigences de votre produit ou de votre fonctionnalit\xe9.",
    'project-pages.improvement.templates.product-requirements.name': 'Exigences produit',
    'project-pages.improvement.templates.retrospective.description': "Qu\u2019est-ce qui a bien fonctionn\xe9\xa0? Qu\u2019est-ce qui aurait pu mieux se passer\xa0? Crowdsourcez des am\xe9liorations avec votre \xe9quipe.",
    'project-pages.improvement.templates.retrospective.name': "R\xe9trospective",
    'project-pages.improvement.templates.template.disabled-tooltip': "Connectez d'abord un espace\xa0Confluence",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Gagnez du temps et r\xe9duisez les t\xe2ches manuelles.</b> Confluence comprend de nombreux <a>mod\xe8les</a> de pages. Ainsi, vous ne devez jamais partir de rien. Pensez aux documents techniques, aux guides de d\xe9pannage, aux plans de projet, aux exigences produit, et bien plus encore.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Modifiez et formatez facilement vos documents.</b> Utilisez le menu sup\xe9rieur de modification pour le formatage\xa0Word standard. En saisissant <b>/</b>, vous pouvez facilement ins\xe9rer de nombreuses int\xe9grations pratiques. Ins\xe9rez un tableau avec <c>/tableau</c> ou une image avec <c>/image</c>. Vous pouvez aussi ins\xe9rer des liens\xa0Dropbox avec <c>/dropbox</c>, des outils Microsoft\xa0Office avec <c>/microsoft</c>, ou des tableaux et des cartes\xa0Trello avec <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Saisissez / suivi de \xab\xa0tableau\xa0\xbb ou \xab\xa0image\xa0\xbb",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Voici quelques conseils pour vous lancer\xa0:",
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Liens pratiques',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Utilisation conjointe de Jira et de Confluence',
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Cr\xe9ez des graphiques sur vos pages \xe0 l'aide de donn\xe9es\xa0Jira r\xe9elles. Saisissez <c>/graphiques\xa0Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Liez un ticket\xa0Jira n'importe o\xf9 sur votre page. Le lien sur la page se mettra \xe0 jour en temps r\xe9el \xe0 mesure que vous actualisez le ticket\xa0Jira. Saisissez <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Int\xe9grez des feuilles de route et des chronologies interactives pour votre page \xe0 l'aide de vos projets\xa0Jira. Saisissez <c>/feuille de route jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Int\xe9grez des chronologies interactives pour votre page \xe0 l'aide de vos projets\xa0Jira. Saisissez <c>/feuille de route jira</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% des clients Jira\xa0Software d\xe9clarent avoir acc\xe9l\xe9r\xe9 leur livraison de projets apr\xe8s avoir ajout\xe9 Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% des clients\xa0Jira d\xe9clarent avoir acc\xe9l\xe9r\xe9 la livraison de projets apr\xe8s avoir ajout\xe9 Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Utilisation des espaces et des pages</b>. Les espaces font partie de chaque site\xa0Confluence et permettent d'organiser les pages en cat\xe9gories. Consid\xe9rez-les comme diff\xe9rents dossiers ou projets. Les pages sont les documents qui figurent dans ces dossiers ou projets. <a>En savoir plus sur l'utilisation des espaces</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Essayer maintenant',
    'project-pages.improvement.templates.tutorial.description': "D\xe9couvrez comment modifier une page.",
    'project-pages.improvement.templates.tutorial.name': "Bienvenue dans les pages de projet\xa0!",
    'project-pages.improvement.terms-and-conditions-v2': "En s\xe9lectionnant \xab\xa0Essayer maintenant\xa0\xbb, vous acceptez d'\xeatre inscrit \xe0 Confluence et vous acceptez les <termsLink>Conditions d'utilisation d'Atlassian\xa0Cloud</termsLink> et la <privacyLink>Politique de confidentialit\xe9</privacyLink>.",
    'project-pages.improvement.title': 'Pages de projet',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Cr\xe9er une page",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Nous avons ajout\xe9 Confluence pour que vous puissiez commencer \xe0 cr\xe9er et \xe0 lier tous les documents de votre projet. L'outil est gratuit jusqu'\xe0 10\xa0utilisateurs.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'En savoir plus',
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Cr\xe9er votre premi\xe8re page",
    'project-pages.improvement.transient-states.empty-state.description': "Cr\xe9ez des notes de r\xe9union, des exigences produit, des d\xe9cisions, ou tout autre contenu pour voir cet espace se remplir.",
    'project-pages.improvement.transient-states.empty-state.title': "Il n'y a rien ici hormis du potentiel",
    'project-pages.improvement.try-button': "Essayer ce mod\xe8le dans Confluence",
    'project-pages.improvement.try-it-now': 'Essayer maintenant',
    'project-pages.improvement.try-lozenge': 'Essayer',
    'project-pages.improvement.try-on-demand-button': 'Essayer gratuitement',
    'project-pages.page-deleted-flag.title': "Page supprim\xe9e.",
    'project-pages.page-published-flag.title': "Votre page a \xe9t\xe9 publi\xe9e.",
    'project-pages.unknown-error.description': "{contactSupport} si l'actualisation ne corrige pas le probl\xe8me.",
    'project-pages.unknown-error.heading': "Impossible d'afficher les pages de projet pour l'instant",
    'projectpages.templatepreview.termsandprivacy': "En cliquant sur \xab\xa0Essayer gratuitement\xa0\xbb, vous acceptez les <termsOfServiceLinkText>Conditions d'utilisation d'Atlassian\xa0Cloud</termsOfServiceLinkText> et la <privacyPolicyLinkText>Politique de confidentialit\xe9</privacyPolicyLinkText>."
};

});

parcelRegister("1IM7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac829f07ee439d28$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $ac829f07ee439d28$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': 'Dieser Vorgang sollte weniger als eine Minute dauern.',
    'confluence.project-pages.improvement.provisioning-background.title': 'Ihre Projektseiten werden eingerichtet',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Verwerfen',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Fertig',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Weiter',
    'project-pages.activating.description': 'Der verbundene Confluence-Bereich ist noch nicht bereit. {contactSupport}, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
    'project-pages.activating.heading': 'Confluence wird noch geladen',
    'project-pages.button.connect-different-space-or-page.label': 'Bereich- oder Seitensymbol aktualisieren',
    'project-pages.button.connect-different-space-or-page.tooltip': 'Anderen Bereich oder andere Seite verbinden',
    'project-pages.button.connect-space-or-page.tooltip': 'Mit Confluence verbinden',
    'project-pages.button.go-to-connected-page.tooltip': "Seite in Confluence \xf6ffnen",
    'project-pages.button.go-to-connected-space.tooltip': "Bereich in Confluence \xf6ffnen",
    'project-pages.connect-space-dialog.connection-error': 'Verbindung fehlgeschlagen.',
    'project-pages.connect-space-dialog.connection-retry': 'Erneut versuchen',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "W\xe4hlen Sie einen Bereich oder eine Seite aus, um sie mit Ihrem Projekt zu verbinden.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Confluence durchsuchen',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Dieses Projekt muss mit einem Bereich verbunden werden, bevor Sie eine Seite erstellen k\xf6nnen. W\xe4hlen Sie einen Bereich aus, um dieses Projekt zu verbinden.",
    'project-pages.connect-space-dialog.error-icon': 'Fehler:',
    'project-pages.connect-space-dialog.footer.cancel': 'Abbrechen',
    'project-pages.connect-space-dialog.footer.connect-space': 'Verbinden',
    'project-pages.connect-space-or-page-dialog.header.title': 'Projekt mit Confluence verbinden',
    'project-pages.connect-space.description': "Bereiche sind wie Ordner \u2013 Sie k\xf6nnen sie zum Erstellen, Organisieren und Zusammenarbeiten bei allen Inhalten, die mit Ihrem Projekt zusammenh\xe4ngen, verwenden.",
    'project-pages.connect-space.not-connected.description': "Um Projektseiten verwenden zu k\xf6nnen, bitten Sie Ihren Administrator oder die Teamleitung, Confluence mit diesem Projekt zu verbinden.",
    'project-pages.connect-space.not-connected.heading': 'Nicht mit Confluence verbunden',
    'project-pages.connect-success-flag.description.content': 'Erfolgreich mit Inhalt {connectedSpaceOrPageName} verbunden.',
    'project-pages.connection-error.space-or-page-not-found.button': 'Mit anderem Bereich oder anderer Seite verbinden',
    'project-pages.create-space-dialog.connection-error': 'Verbindung fehlgeschlagen.',
    'project-pages.create-space-dialog.connection-retry': 'Erneut versuchen',
    'project-pages.create-space-dialog.content.empty-name': 'Bitte geben Sie Ihrem Bereich einen Namen.',
    'project-pages.create-space-dialog.content.invalid-name': "Bereichsnamen m\xfcssen mindestens einen Buchstaben oder eine Ziffer enthalten.",
    'project-pages.create-space-dialog.content.placeholder': 'Bereichsnamen eingeben',
    'project-pages.create-space-dialog.creation-error': 'Bereich konnte nicht erstellt werden.',
    'project-pages.create-space-dialog.error-icon': 'Fehler:',
    'project-pages.create-space-dialog.footer.cancel': 'Abbrechen',
    'project-pages.create-space-dialog.footer.create-space': 'Erstellen',
    'project-pages.create-space-dialog.header.title': 'Neuen Confluence-Bereich erstellen',
    'project-pages.cross-join.access-revoked.templates.subtitle': "Sie k\xf6nnen keine Projektseiten verwenden, weil der Administrator Ihnen den Zugriff auf Confluence verweigert hat. Wenden Sie sich an Ihren Site-Administrator, um Zugriff anzufordern.",
    'project-pages.cross-join.access-revoked.templates.title': 'Sie sind nicht berechtigt, Projektseiten zu verwenden.',
    'project-pages.cross-join.avatar.view-profile': 'Profil anzeigen',
    'project-pages.cross-join.denied-request.templates.subtitle': "Sie k\xf6nnen keine Projektseiten verwenden, weil der Site-Administrator Ihre Anfrage zum Beitritt zu Confluence verweigert hat.",
    'project-pages.cross-join.denied-request.templates.title': 'Ihr Administrator hat Ihnen den Zugriff verweigert',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': 'Sie erhalten Zugriff auf Confluence. Ihr Site-Administrator hat dies bereits genehmigt.',
    'project-pages.cross-join.errors.unknown-error.description': '{contactSupport}, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
    'project-pages.cross-join.errors.unknown-error.title': "Projektseiten k\xf6nnen derzeit nicht angezeigt werden",
    'project-pages.cross-join.inline-join-product.button': 'Sie erhalten Zugriff auf Confluence. Ihr Site-Administrator hat dies bereits genehmigt.',
    'project-pages.cross-join.inline-join-product.connected.description': 'Dokumentation von einem zentralen Ort aus anzeigen, bearbeiten und erstellen',
    'project-pages.cross-join.inline-join-product.connected.title': 'Mit Ihrem Team an Projektseiten zusammenarbeiten',
    'project-pages.cross-join.pending-request.templates.subtitle': "Der Site-Administrator hat Ihre Anfrage zum Beitritt zu Confluence erhalten. Sobald Ihnen der Beitritt genehmigt wurde, k\xf6nnen Sie Projektseiten verwenden, und wir senden Ihnen eine Best\xe4tigungs-E-Mail.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': 'Sobald der Zugriff genehmigt wurde, erhalten Sie eine E-Mail mit Zugang zu den Projektseiten.',
    'project-pages.cross-join.pending-request.templates.title': 'Sie haben Zugriff auf Confluence angefordert',
    'project-pages.cross-join.pending-request.templates.title.experiment': 'Zugriffsanfrage an Administrator gesendet',
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'Projektdokumentation mit Ihrem Team ansehen, bearbeiten und erstellen',
    'project-pages.cross-join.request-access.button': 'Zugriff anfordern',
    'project-pages.cross-join.request-access.button-subtitle.experimental': 'Wenn Sie "Ihrem Team beitreten" ausw\xe4hlen, bitten Sie darum, Confluence beizutreten, und stimmen der Freigabe Ihres Atlassian-Profils f\xfcr Ihren Administrator zu.',
    'project-pages.cross-join.request-access.button.experimental': 'Ihrem Team beitreten',
    'project-pages.cross-join.request-access.connected.description.experimental': "Ihr Team verwendet Projektseiten, um Projektdokumentationen zu kommentieren, zu bearbeiten und daran zusammenzuarbeiten, ohne dabei Jira verlassen zu m\xfcssen. Treten Sie Confluence bei, um auf die Projektseiten Ihres Teams zuzugreifen.",
    'project-pages.cross-join.request-access.title': 'Projektseiten erfordern Zugriff auf Confluence',
    'project-pages.cross-join.request-access.title.experiment': "Eine zentrale Informationsquelle f\xfcr Ihr Team erstellen",
    'project-pages.default-contextual-heading': 'Projektseiten werden bereitgestellt von Confluence',
    'project-pages.default-contextual-message': "Confluence-Seiten machen das Erstellen, Teilen und Zusammenarbeiten bei all Ihren Projektdokumenten an einem Ort m\xf6glich.",
    'project-pages.default-reactivate-CTA': 'Confluence erneut aktivieren',
    'project-pages.default-trial-CTA': "Confluence 30\xa0Tage kostenlos testen",
    'project-pages.draft-saved-flag.action': "Entwurf \xf6ffnen",
    'project-pages.draft-saved-flag.description': "Ihr Entwurf ist f\xfcr andere erst sichtbar, wenn Sie ihn ver\xf6ffentlichen.",
    'project-pages.draft-saved-flag.title': 'Entwurf gespeichert',
    'project-pages.embedded-pages.create-page-error.close-button': "Schlie\xdfen",
    'project-pages.embedded-pages.create-page-error.description': 'Es ist ein Problem aufgetreten, sodass die Seite nicht erstellt werden konnte.',
    'project-pages.embedded-pages.create-page-error.title': 'Seite konnte nicht erstellt werden',
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Versuchen Sie es erneut.',
    'project-pages.embedded-pages.modal.close.button.hint': "Schlie\xdfen",
    'project-pages.embedded-pages.modal.title.button': "In Confluence \xf6ffnen",
    'project-pages.embedded-pages.modal.title.button.hint': "In neuer Registerkarte \xf6ffnen",
    'project-pages.errors.unknown-error.description.non-final': '{contactSupport}, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
    'project-pages.errors.unknown-error.title.non-final': "Projektseiten k\xf6nnen derzeit nicht angezeigt werden",
    'project-pages.generic-error.button.reload': 'Seite neu laden',
    'project-pages.generic-error.description': "Da hat etwas nicht geklappt. Bitte versuchen Sie es sp\xe4ter erneut.",
    'project-pages.generic-error.description.non-final': "Da hat etwas nicht geklappt. Bitte versuchen Sie es sp\xe4ter erneut.",
    'project-pages.generic-error.heading': 'Oh nein!',
    'project-pages.generic-error.title.non-final': "Das ist seltsam\xa0\u2026",
    'project-pages.generic-info-flag.description': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.',
    'project-pages.generic-success-flag.description.page': 'Erfolgreich mit Seite {connectedSpaceOrPageName} verbunden.',
    'project-pages.generic-success-flag.description.space': 'Erfolgreich mit Bereich {connectedSpaceOrPageName} verbunden.',
    'project-pages.generic-success-flag.heading.page': 'Seite verbunden',
    'project-pages.generic-success-flag.heading.space': 'Bereich verbunden',
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'Oder erstellen Sie einen neuen Bereich',
    'project-pages.granular-pages.connect-space.button': 'Mit Confluence verbinden',
    'project-pages.granular-pages.connect-space.heading': 'Verbinden Sie dieses Projekt mit einem Confluence-Bereich oder einer Confluence-Seite',
    'project-pages.granular-pages.connect-space.heading.non-final': 'Verbinden Sie dieses Projekt mit einem Confluence-Bereich oder einer Confluence-Seite',
    'project-pages.improvement.contact-support': 'Support kontaktieren',
    'project-pages.improvement.errors.access-error.description': 'Kontaktieren Sie den Site-Administrator, um Zugriff zu erhalten.',
    'project-pages.improvement.errors.access-error.title': 'Sie sind nicht berechtigt, Projektseiten anzuzeigen',
    'project-pages.improvement.errors.page-tree-unknown-error.description': 'Bei der Anzeige der Seiten von Ihrem verbundenen Confluence-Bereich ist ein Fehler aufgetreten. {contactSupport}, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Es k\xf6nnen keine Projektseiten angezeigt werden",
    'project-pages.improvement.errors.space-or-page-not-found.description': "Der verbundene Confluence-Bereich oder die verbundene Confluence-Seite wurde verschoben, archiviert oder gel\xf6scht. <link>Wenden Sie sich an den Support</link>, falls die erneute Verbindung das Problem nicht behebt.",
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Bereich oder Seite nicht gefunden',
    'project-pages.improvement.errors.unknown-error.description': '{contactSupport}, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
    'project-pages.improvement.errors.unknown-error.title': "Projektseiten k\xf6nnen derzeit nicht angezeigt werden",
    'project-pages.improvement.feature1': 'Dokumente erstellen und darauf zugreifen, ohne Jira zu verlassen',
    'project-pages.improvement.feature2': "Vorlagen f\xfcr Meetings, Sprintpl\xe4ne und mehr",
    'project-pages.improvement.feature3': "Dokumente f\xfcr automatische Updates mit Jira synchronisieren",
    'project-pages.improvement.heading-info': 'Protokollieren Sie das Wissen Ihres Teams und verbessern Sie die Art und Weise, Aufgaben zu erledigen.',
    'project-pages.improvement.heading-info-v2': "Schaffen Sie einen Ort f\xfcr alle Projektdokumente Ihres Teams",
    'project-pages.improvement.learn-more-button': 'Mehr erfahren',
    'project-pages.improvement.powered-by': 'Bereitgestellt von',
    'project-pages.improvement.powered-by.tooltip': "Confluence in einer neuen Registerkarte \xf6ffnen",
    'project-pages.improvement.preview-teaser': 'Profitieren Sie von Vorlagen, Projektseiten und mehr',
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Halten Sie Ihre Projektberichte mit automatisch aktualisierten Statusstichw\xf6rtern aktuell.</p> <p>Verkn\xfcpfen Sie einfach ein Jira-Ticket in einem Dokument und automatisch wird ein Statusstichwort angezeigt, das synchron mit dem Ticket aktualisiert wird. So m\xfcssen Sie Ihre Zeit nicht mit dem Erstellen manueller Berichte verbringen.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Nahtloses Update f\xfcr Ihre Stakeholder",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Erstellen Sie eine konsistente Dokumentation mithilfe unserer integrierten Vorlagen. Sie k\xf6nnen ganz einfach verwendet und an Ihre Anforderungen angepasst werden.</p> <p>Sie k\xf6nnen Vorlagen direkt \xfcber Projektseiten verwenden. So m\xfcssen Sie Ihre aktuelle Arbeit nicht verlassen. <a>Hier</a> k\xf6nnen Sie alle Vorlagen durchsuchen.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Ihre Dokumentationsstandards vereinheitlichen',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Erstellen Sie eine zentrale Informationsquelle f\xfcr wichtige Informationen, indem Sie die Dokumentation \xfcber die Registerkarte &quot;Projektseiten&quot; in Jira erstellen und verwalten.</p> <p>Haben Sie gewusst, dass die Option &quot;Projektseiten&quot; in Confluence ausgef\xfchrt werden kann? Sie ist kostenlos f\xfcr bis zu 10\xa0Benutzer. Laden Sie den Rest Ihres Teams in Ihren Administratoreinstellungen ein.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Ihre Projektseiten, direkt in Jira',
    'project-pages.improvement.templates.blank-page.description': 'Starten Sie mit einer ganz neuen Seite.',
    'project-pages.improvement.templates.blank-page.name': 'Leere Seite',
    'project-pages.improvement.templates.decision.description': 'Zeichnen Sie wichtige Projektentscheidungen auf und teilen Sie sie Ihrem Team mit.',
    'project-pages.improvement.templates.decision.name': 'Entscheidung',
    'project-pages.improvement.templates.meeting-notes.description': 'Planen Sie Besprechungen und teilen Sie Notizen und Aktionen mit Ihrem Team.',
    'project-pages.improvement.templates.meeting-notes.name': 'Besprechungsnotizen',
    'project-pages.improvement.templates.post-expand.more': 'Weitere Vorlagen',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Alle Vorlagen in Confluence anzeigen',
    'project-pages.improvement.templates.post-expand.subtitle': 'Beliebte Vorlagen',
    'project-pages.improvement.templates.post-expand.title': 'Eine Seite erstellen',
    'project-pages.improvement.templates.pre-expand.more': 'Weitere Vorlagen entdecken',
    'project-pages.improvement.templates.pre-expand.subtitle': "Bei \xe4hnlichen Teams beliebt",
    'project-pages.improvement.templates.pre-expand.title': 'Vorschau der Vorlagen anzeigen',
    'project-pages.improvement.templates.product-requirements.description': "Definieren und \xfcberwachen Sie die Anforderungen f\xfcr Ihr Produkt oder Ihre Funktion, und bestimmen Sie den Umfang.",
    'project-pages.improvement.templates.product-requirements.name': 'Produktanforderungen',
    'project-pages.improvement.templates.retrospective.description': "Was ist gut gelaufen? Was h\xe4tte besser laufen k\xf6nnen? Stellen Sie gemeinsam mit Ihrem Team Verbesserungen heraus.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektive',
    'project-pages.improvement.templates.template.disabled-tooltip': 'Verbinden Sie zuerst einen Confluence-Bereich.',
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Zeitersparnis und weniger manuelle Aufgaben:</b> In Confluence sind eine Vielzahl an <a>Seitenvorlagen</a> verf\xfcgbar. Sie m\xfcssen also nie ganz bei Null beginnen. Sie finden zum Beispiel Vorlagen f\xfcr technische Dokumente, Leitf\xe4den zur Fehlerbehebung, Projektpl\xe4ne, Produktanforderungen und mehr.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>M\xfchelose Bearbeitung und Formatierung:</b> \xdcber das obere Bearbeitungsmen\xfc stehen Ihnen Standard-Formatierungsoptionen zur Verf\xfcgung und mit <b>/</b> k\xf6nnen Sie viele praktische Integrationen einf\xfcgen. F\xfcgen Sie eine Tabelle ein, indem Sie <c>/tabelle</c> eingeben oder ein Bild mit <c>/bild</c>. Dar\xfcber hinaus k\xf6nnen Sie Dropbox-Links mit <c>/dropbox</c>, Microsoft Office-Tools mit <c>/microsoft</c> oder Trello-Boards und Karten mit <c>/trello</c> einf\xfcgen.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Geben Sie / ein und anschlie\xdfend "tabelle" oder "bild".',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Hier ein paar Tipps f\xfcr den Einstieg:",
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Praktische Links',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Jira und Confluence gemeinsam nutzen',
    'project-pages.improvement.templates.tutorial.content.jira-charts': 'Erstellen Sie auf Ihren Seiten Diagramme mit Echtzeit-Daten aus Jira. Geben Sie <c>/Jira-Diagramme</c> ein.',
    'project-pages.improvement.templates.tutorial.content.jira-links': "Verkn\xfcpfen Sie einen Jira-Vorgang an einer beliebigen Stelle auf Ihrer Seite. Der Link auf der Seite wird in Echtzeit aktualisiert, wenn Sie den Jira-Vorgang aktualisieren. Geben Sie <c>/Jira</c> ein.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Betten Sie mithilfe Ihrer Jira-Projekte interaktive Roadmaps und Zeitleisten f\xfcr Ihre Seite ein. Geben Sie <c>/jira roadmap</c> ein.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Betten Sie mithilfe Ihrer Jira-Projekte interaktive Zeitleisten f\xfcr Ihre Seite ein. Geben Sie <c>/Jira-Zeitleiste</c> ein.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% aller Jira Software-Kunden gaben an, dass sie die Projektauslieferung beschleunigen konnten, nachdem sie Confluence hinzugef\xfcgt hatten.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% aller Jira-Kunden gaben an, dass sie die Projektauslieferung beschleunigen konnten, nachdem sie Confluence hinzugef\xfcgt hatten.",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Verwendung von Bereichen und Seiten:</b> Bereiche sind Teil jeder Confluence-Site. Sie erm\xf6glichen die Unterteilung von Seiten in Kategorien. Bereiche sind sozusagen verschiedene Ordner oder Projekte, w\xe4hrend Seiten die Dokumente in diesen Ordnern oder Projekten sind. <a>Weitere Informationen zur Verwendung von Bereichen</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Jetzt testen',
    'project-pages.improvement.templates.tutorial.description': 'Erfahren Sie, wie Sie eine Seite bearbeiten.',
    'project-pages.improvement.templates.tutorial.name': 'Willkommen auf den Projektseiten!',
    'project-pages.improvement.terms-and-conditions-v2': "Indem Sie &quot;Jetzt testen&quot; ausw\xe4hlen, best\xe4tigen Sie, dass Sie bei Confluence registriert werden, und stimmen den <termsLink>Nutzungsbedingungen</termsLink> und der <privacyLink>Datenschutzrichtlinie</privacyLink> f\xfcr Atlassian Cloud zu.",
    'project-pages.improvement.title': 'Projektseiten',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Seite erstellen',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Wir haben Confluence hinzugef\xfcgt, damit Sie Projektdokumente erstellen und diese verkn\xfcpfen k\xf6nnen. Dies ist f\xfcr bis zu 10\xa0Benutzer kostenlos.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Mehr erfahren',
    'project-pages.improvement.transient-states.empty-state.create-page-button': 'Ihre erste Seite erstellen',
    'project-pages.improvement.transient-states.empty-state.description': "Erstellen Sie Besprechungsnotizen, Produktanforderungen, Entscheidungen und andere Inhalte, damit dieser Bereich sich f\xfcllt.",
    'project-pages.improvement.transient-states.empty-state.title': 'Hier gibt es nichts als Potenzial',
    'project-pages.improvement.try-button': 'Diese Vorlage in Confluence ausprobieren',
    'project-pages.improvement.try-it-now': 'Jetzt testen',
    'project-pages.improvement.try-lozenge': 'Testen',
    'project-pages.improvement.try-on-demand-button': 'Kostenlos testen',
    'project-pages.page-deleted-flag.title': "Seite gel\xf6scht",
    'project-pages.page-published-flag.title': "Ihre Seite wurde ver\xf6ffentlicht",
    'project-pages.unknown-error.description': '{contactSupport}, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
    'project-pages.unknown-error.heading': "Projektseiten k\xf6nnen derzeit nicht angezeigt werden",
    'projectpages.templatepreview.termsandprivacy': "Indem Sie unten auf &quot;Kostenlos testen&quot; klicken, werden Sie bei Confluence registriert und stimmen den <termsOfServiceLinkText>Nutzungsbedingungen</termsOfServiceLinkText> und der <privacyPolicyLinkText>Datenschutzrichtlinie</privacyPolicyLinkText> f\xfcr Atlassian Cloud zu."
};

});

parcelRegister("AjJao", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fc125e8370034a8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $7fc125e8370034a8$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Ez legfeljebb egy percet vesz ig\xe9nybe",
    'confluence.project-pages.improvement.provisioning-background.title': "A projektoldalak be\xe1ll\xedt\xe1sa folyamatban van",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "Elvet\xe9s",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "K\xe9sz",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "Tov\xe1bb",
    'project-pages.activating.description': "A csatlakoztatott Confluence-munkat\xe9r m\xe9g nincs teljesen k\xe9sz. {contactSupport}, ha a friss\xedt\xe9s nem jav\xedtja ki a probl\xe9m\xe1kat.",
    'project-pages.activating.heading': "A Confluence bet\xf6lt\xe9se m\xe9g folyamatban van",
    'project-pages.button.connect-different-space-or-page.label': "Munkat\xe9r vagy oldal ikonj\xe1nak m\xf3dos\xedt\xe1sa",
    'project-pages.button.connect-different-space-or-page.tooltip': "M\xe1sik munkat\xe9r vagy oldal csatlakoztat\xe1sa",
    'project-pages.button.connect-space-or-page.tooltip': "Csatlakoz\xe1s a Confluence-hez",
    'project-pages.button.go-to-connected-page.tooltip': "Oldal megnyit\xe1sa a Confluence-ben",
    'project-pages.button.go-to-connected-space.tooltip': "Munkat\xe9r megnyit\xe1sa a Confluence-ben",
    'project-pages.connect-space-dialog.connection-error': "A csatlakoztat\xe1s nem siker\xfclt.",
    'project-pages.connect-space-dialog.connection-retry': "\xdajra",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "V\xe1laszd ki a projekthez csatlakoztatni k\xedv\xe1nt munkateret vagy oldalt.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "Keres\xe9s a Confluence-ben",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Ha oldalt szeretn\xe9l l\xe9trehozni, ezt a projektet egy munkat\xe9rhez kell kapcsolnod. V\xe1laszd ki a projekthez csatlakoztatand\xf3 munkateret.",
    'project-pages.connect-space-dialog.error-icon': 'Hiba:',
    'project-pages.connect-space-dialog.footer.cancel': "M\xe9gse",
    'project-pages.connect-space-dialog.footer.connect-space': "Csatlakoztat\xe1s",
    'project-pages.connect-space-or-page-dialog.header.title': "Projekt csatlakoztat\xe1sa a Confluence-hez",
    'project-pages.connect-space.description': "A munkaterek a mapp\xe1khoz hasonl\xedtanak \u2013 l\xe9trehozhatod \xe9s rendszerezheted a projekteddel kapcsolatos tartalmakat, \xe9s egy\xfcttm\u0171k\xf6dhetsz benn\xfck.",
    'project-pages.connect-space.not-connected.description': "A projektoldalak haszn\xe1lat\xe1hoz vedd fel a kapcsolatot az adminisztr\xe1toroddal vagy csapatvezet\u0151ddel, hogy kapcsolja hozz\xe1 a Confluence-t a projekthez.",
    'project-pages.connect-space.not-connected.heading': 'Nincs csatlakoztatva a Confluence-hez',
    'project-pages.connect-success-flag.description.content': 'Sikeresen csatlakoztatva {connectedSpaceOrPageName} tartalomhoz.',
    'project-pages.connection-error.space-or-page-not-found.button': "Csatlakoztat\xe1s egy m\xe1sik munkat\xe9rhez vagy oldalhoz",
    'project-pages.create-space-dialog.connection-error': "A csatlakoztat\xe1s nem siker\xfclt.",
    'project-pages.create-space-dialog.connection-retry': "\xdajra",
    'project-pages.create-space-dialog.content.empty-name': 'Adj nevet a munkaterednek.',
    'project-pages.create-space-dialog.content.invalid-name': "A munkat\xe9r nev\xe9nek legal\xe1bb egy bet\u0171b\u0151l vagy sz\xe1mb\xf3l kell \xe1llnia.",
    'project-pages.create-space-dialog.content.placeholder': "Add meg a munkat\xe9r nev\xe9t",
    'project-pages.create-space-dialog.creation-error': "A munkat\xe9r l\xe9trehoz\xe1sa nem siker\xfclt.",
    'project-pages.create-space-dialog.error-icon': 'Hiba:',
    'project-pages.create-space-dialog.footer.cancel': "M\xe9gse",
    'project-pages.create-space-dialog.footer.create-space': "L\xe9trehoz\xe1s",
    'project-pages.create-space-dialog.header.title': "\xdaj Confluence-munkat\xe9r l\xe9trehoz\xe1sa",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Nem haszn\xe1lhatsz projektoldalakat, mert az admint\xf3l nem kapt\xe1l hozz\xe1f\xe9r\xe9st a Confluence-hez. Fordulj a webhely-adminisztr\xe1torodhoz, \xe9s k\xe9rj t\u0151le hozz\xe1f\xe9r\xe9st.",
    'project-pages.cross-join.access-revoked.templates.title': "Nincs jogosults\xe1god a projektoldalak haszn\xe1lat\xe1ra",
    'project-pages.cross-join.avatar.view-profile': "Profil megtekint\xe9se",
    'project-pages.cross-join.denied-request.templates.subtitle': "Nem haszn\xe1lhatsz projektoldalakat, mert a webhely-adminisztr\xe1tor elutas\xedtotta a Confluence-hez val\xf3 csatlakoz\xe1sra ir\xe1nyul\xf3 k\xe9relmedet.",
    'project-pages.cross-join.denied-request.templates.title': "Az admin elutas\xedtotta a hozz\xe1f\xe9r\xe9si k\xe9relmedet",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Hozz\xe1f\xe9r\xe9st kapsz a Confluence-hez. A webhely-adminisztr\xe1torod m\xe1r j\xf3v\xe1hagyta a k\xe9relmet.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport}, ha a friss\xedt\xe9s nem jav\xedtja ki a probl\xe9m\xe1kat.",
    'project-pages.cross-join.errors.unknown-error.title': "Jelenleg nem tudjuk megjelen\xedteni a projektoldalakat",
    'project-pages.cross-join.inline-join-product.button': "Hozz\xe1f\xe9r\xe9st kapsz a Confluence-hez. A webhely-adminisztr\xe1torod m\xe1r j\xf3v\xe1hagyta a k\xe9relmet.",
    'project-pages.cross-join.inline-join-product.connected.description': "Dokument\xe1ci\xf3 megtekint\xe9se, szerkeszt\xe9se \xe9s l\xe9trehoz\xe1sa egyetlen helyr\u0151l",
    'project-pages.cross-join.inline-join-product.connected.title': "Egy\xfcttm\u0171k\xf6dhetsz a projekt oldalain a csapatoddal",
    'project-pages.cross-join.pending-request.templates.subtitle': "A webhely-adminisztr\xe1tor megkapta a Confluence-hez val\xf3 csatlakoz\xe1si k\xe9relmedet. Ha j\xf3v\xe1hagyja, a projektoldalak m\u0171k\xf6dni fognak, \xe9s kapni fogsz t\u0151l\xfcnk egy visszaigazol\xf3 e-mailt.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "E-mailben \xe9rtes\xedteni fogunk a Projektoldalakhoz val\xf3 hozz\xe1f\xe9r\xe9sr\u0151l, ha j\xf3v\xe1hagyt\xe1k a k\xe9relmet.",
    'project-pages.cross-join.pending-request.templates.title': "Hozz\xe1f\xe9r\xe9st k\xe9rt\xe9l a Confluence-hez",
    'project-pages.cross-join.pending-request.templates.title.experiment': "Hozz\xe1f\xe9r\xe9si k\xe9relem elk\xfcldve az adminisztr\xe1tornak",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Projektdokument\xe1ci\xf3 megtekint\xe9se, szerkeszt\xe9se \xe9s l\xe9trehoz\xe1sa a csapattal k\xf6z\xf6sen",
    'project-pages.cross-join.request-access.button': "Hozz\xe1f\xe9r\xe9s k\xe9r\xe9se",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "A \u201ECsatlakoz\xe1s a csapathoz\u201D kiv\xe1laszt\xe1s\xe1val jelezheted, hogy csatlakozni szeretn\xe9l a Confluence-hez, \xe9s hozz\xe1j\xe1rulsz ahhoz, hogy a rendszer megossza az adminisztr\xe1toroddal az Atlassian-profilodat.",
    'project-pages.cross-join.request-access.button.experimental': 'Csatlakozom a csapatomhoz',
    'project-pages.cross-join.request-access.connected.description.experimental': "A csapatod tagjai a Projektoldalakat haszn\xe1lj\xe1k, hogy a Jira elhagy\xe1sa n\xe9lk\xfcl \xedrjanak megjegyz\xe9seket, hajtsanak v\xe9gre szerkeszt\xe9seket \xe9s egy\xfcttm\u0171k\xf6djenek a projektdokument\xe1ci\xf3kban. Csatlakozz a Confluence-hez, hogy hozz\xe1f\xe9rhess a csapatod Projektoldalaihoz.",
    'project-pages.cross-join.request-access.title': "A projektoldalak haszn\xe1lata \xe9rdek\xe9ben hozz\xe1f\xe9r\xe9s sz\xfcks\xe9ges a Confluence-hez",
    'project-pages.cross-join.request-access.title.experiment': "Hozz l\xe9tre egy egys\xe9ges inform\xe1ci\xf3forr\xe1st a csapatod sz\xe1m\xe1ra",
    'project-pages.default-contextual-heading': "A projektoldalakat a Confluence t\xe1mogatja",
    'project-pages.default-contextual-message': "L\xe9trehoz\xe1s, megoszt\xe1s \xe9s egy\xfcttm\u0171k\xf6d\xe9s minden projektdokumentumodon egy helyen, a Confluence-oldalakkal.",
    'project-pages.default-reactivate-CTA': "A Confluence \xfajraaktiv\xe1l\xe1sa",
    'project-pages.default-trial-CTA': "Pr\xf3b\xe1ld ki a Confluence szoftvert ingyenesen 30 napig",
    'project-pages.draft-saved-flag.action': "Piszkozat megnyit\xe1sa",
    'project-pages.draft-saved-flag.description': "Am\xedg k\xf6zz\xe9 nem teszed, addig a piszkozat csak sz\xe1modra l\xe1that\xf3.",
    'project-pages.draft-saved-flag.title': 'Piszkozat mentve',
    'project-pages.embedded-pages.create-page-error.close-button': "Bez\xe1r\xe1s",
    'project-pages.embedded-pages.create-page-error.description': "Hiba t\xf6rt\xe9nt, \xe9s nem siker\xfclt l\xe9trehozni az oldaladat.",
    'project-pages.embedded-pages.create-page-error.title': "Nem siker\xfclt l\xe9trehozni az oldalt",
    'project-pages.embedded-pages.create-page-error.try-again-button': "Pr\xf3b\xe1ld \xfajra",
    'project-pages.embedded-pages.modal.close.button.hint': "Bez\xe1r\xe1s",
    'project-pages.embedded-pages.modal.title.button': "Megnyit\xe1s a Confluence-ben",
    'project-pages.embedded-pages.modal.title.button.hint': "Megnyit\xe1s \xfaj lapon",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport}, ha a friss\xedt\xe9s nem jav\xedtja ki a probl\xe9m\xe1kat.",
    'project-pages.errors.unknown-error.title.non-final': "Jelenleg nem tudjuk megjelen\xedteni a projektoldalakat",
    'project-pages.generic-error.button.reload': "Oldal \xfajrat\xf6lt\xe9se",
    'project-pages.generic-error.description': "Hiba t\xf6rt\xe9nt. Pr\xf3b\xe1ld meg \xfajra k\xe9s\u0151bb.",
    'project-pages.generic-error.description.non-final': "Hiba t\xf6rt\xe9nt. Pr\xf3b\xe1ld meg \xfajra k\xe9s\u0151bb.",
    'project-pages.generic-error.heading': "Eln\xe9z\xe9st k\xe9r\xfcnk!",
    'project-pages.generic-error.title.non-final': "Eln\xe9z\xe9st k\xe9r\xfcnk!",
    'project-pages.generic-info-flag.description': "Hiba t\xf6rt\xe9nt. Pr\xf3b\xe1ld \xfajra, vagy fordulj az \xfcgyf\xe9lszolg\xe1lathoz, ha a probl\xe9ma tov\xe1bbra is fenn\xe1ll.",
    'project-pages.generic-success-flag.description.page': 'Sikeresen csatlakoztatva a(z) {connectedSpaceOrPageName} oldalhoz.',
    'project-pages.generic-success-flag.description.space': 'Sikeresen csatlakoztattad a munkateret ({connectedSpaceOrPageName}).',
    'project-pages.generic-success-flag.heading.page': 'Oldal csatlakoztatva',
    'project-pages.generic-success-flag.heading.space': "Munkat\xe9r csatlakoztatva",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Vagy hozz l\xe9tre \xfaj munkateret",
    'project-pages.granular-pages.connect-space.button': "Csatlakoz\xe1s a Confluence-hez",
    'project-pages.granular-pages.connect-space.heading': "A projekt csatlakoztat\xe1sa Confluence-munkat\xe9rhez vagy -oldalhoz",
    'project-pages.granular-pages.connect-space.heading.non-final': "A projekt csatlakoztat\xe1sa Confluence-munkat\xe9rhez vagy -oldalhoz",
    'project-pages.improvement.contact-support': "\xdcgyf\xe9lszolg\xe1lat",
    'project-pages.improvement.errors.access-error.description': "Ha hozz\xe1f\xe9r\xe9st szeretn\xe9l k\xe9rni, vedd fel a kapcsolatot a webhely adminj\xe1val.",
    'project-pages.improvement.errors.access-error.title': "Nincs jogosults\xe1god a projektoldalak megtekint\xe9s\xe9re",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Hiba t\xf6rt\xe9nt a csatlakoztatott Confluence-munkat\xe9r oldalainak megjelen\xedt\xe9sekor. {contactSupport}, ha a friss\xedt\xe9s nem jav\xedtja ki a probl\xe9m\xe1kat.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Probl\xe9m\xe1ba \xfctk\xf6zt\xfcnk a projektoldalak megjelen\xedt\xe9sekor",
    'project-pages.improvement.errors.space-or-page-not-found.description': "A csatlakoztatott Confluence-munkateret vagy -oldalt \xe1thelyezt\xe9k, archiv\xe1lt\xe1k vagy t\xf6r\xf6lt\xe9k. <link>Vedd fel a kapcsolatot a t\xe1mogat\xe1ssal</link>, ha az \xfajracsatlakoztat\xe1s nem oldja meg a probl\xe9m\xe1t",
    'project-pages.improvement.errors.space-or-page-not-found.title': "A munkat\xe9r vagy oldal nem tal\xe1lhat\xf3",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport}, ha a friss\xedt\xe9s nem jav\xedtja ki a probl\xe9m\xe1kat.",
    'project-pages.improvement.errors.unknown-error.title': "Jelenleg nem tudjuk megjelen\xedteni a projektoldalakat",
    'project-pages.improvement.feature1': "Dokumentumok el\xe9r\xe9se \xe9s l\xe9trehoz\xe1sa a Jira elhagy\xe1sa n\xe9lk\xfcl",
    'project-pages.improvement.feature2': "Sablonok az \xe9rtekezletekhez, sprinttervek \xe9s sok m\xe1s",
    'project-pages.improvement.feature3': "Dokumentumok szinkroniz\xe1l\xe1sa a Jir\xe1val az automatikus friss\xedt\xe9sekhez",
    'project-pages.improvement.heading-info': "R\xf6gz\xedtsd csapatod tud\xe1s\xe1t, \xe9s fejleszd a munka elv\xe9gz\xe9s\xe9re haszn\xe1lhat\xf3 m\xf3dszereket.",
    'project-pages.improvement.heading-info-v2': "Hozz l\xe9tre egy k\xf6zponti helyet a csapatod \xf6sszes projektdokumentum\xe1nak",
    'project-pages.improvement.learn-more-button': "Tov\xe1bbi inform\xe1ci\xf3",
    'project-pages.improvement.powered-by': "Szolg\xe1ltat\xf3:",
    'project-pages.improvement.powered-by.tooltip': "A Confluence megnyit\xe1sa \xfaj lapon",
    'project-pages.improvement.preview-teaser': "Sablonok, projektoldalak \xe9s egyebek felold\xe1sa.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Az \xe1llapotc\xedmk\xe9k automatikus friss\xedt\xe9s\xe9vel naprak\xe9szen tarthatod a projektjelent\xe9seidet.</p> <p>Egyszer\u0171en kapcsolj \xf6ssze egy Jira-jegyet egy dokumentumban, \xe9s automatikusan megjelenik az \xe1llapotc\xedmke, amely a jeggyel szinkronban friss\xfcl, \xedgy nem kell id\u0151t pazarolnod manu\xe1lis jelent\xe9sek l\xe9trehoz\xe1s\xe1ra.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Az \xe9rdekelt felek g\xf6rd\xfcl\xe9keny \xe9rtes\xedt\xe9se",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>A be\xe9p\xedtett sablonjainkkal konzisztens dokument\xe1ci\xf3kat hozhatsz l\xe9tre. K\xf6nnyen haszn\xe1lhat\xf3k, r\xe1ad\xe1sul szem\xe9lyre szabhatod \u0151ket az ig\xe9nyeidnek megfelel\u0151en.</p> <p>A sablonokat haszn\xe1lhatod k\xf6zvetlen\xfcl a projektoldalakr\xf3l, \xedgy soha nem kell elhagynod az aktu\xe1lis munk\xe1dat. <a>Itt</a> b\xf6ng\xe9szhetsz az \xf6sszes sablon k\xf6z\xf6tt.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Egys\xe9ges\xedtsd a dokument\xe1ci\xf3s standardjaidat",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>A Jira projektoldalak lapj\xe1r\xf3l a dokument\xe1ci\xf3k l\xe9trehoz\xe1s\xe1val \xe9s kezel\xe9s\xe9vel \xf6ssze\xe1ll\xedthatsz egy egys\xe9ges forr\xe1st a fontos inform\xe1ci\xf3k sz\xe1m\xe1ra.</p> <p>Tudtad, hogy a projektoldalak fel\xfclet a Confluence-ben fut? A haszn\xe1lata 10 felhaszn\xe1l\xf3ig ingyenes. A csapatod t\xf6bbi r\xe9sz\xe9t az adminisztr\xe1ci\xf3s be\xe1ll\xedt\xe1sokban h\xedvhatod meg.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "A projektoldalaid k\xf6zvetlen\xfcl a Jir\xe1ban",
    'project-pages.improvement.templates.blank-page.description': "Oldal k\xe9sz\xedt\xe9se null\xe1r\xf3l.",
    'project-pages.improvement.templates.blank-page.name': "\xdcres oldal",
    'project-pages.improvement.templates.decision.description': "R\xf6gz\xedtsd a fontosabb projektd\xf6nt\xe9seket, \xe9s besz\xe9ld meg \u0151ket a csapatoddal.",
    'project-pages.improvement.templates.decision.name': "D\xf6nt\xe9s",
    'project-pages.improvement.templates.meeting-notes.description': "Megtervezheted az \xe9rtekezleteket, jegyzetelhetsz \xe9s megoszthatod a teend\u0151ket a csapatoddal.",
    'project-pages.improvement.templates.meeting-notes.name': "Megbesz\xe9l\xe9s feljegyz\xe9sei",
    'project-pages.improvement.templates.post-expand.more': "Tov\xe1bbi sablonok",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Az \xf6sszes sablon megtekint\xe9se a Confluence-ben",
    'project-pages.improvement.templates.post-expand.subtitle': "N\xe9pszer\u0171 sablonok",
    'project-pages.improvement.templates.post-expand.title': "Oldal l\xe9trehoz\xe1sa",
    'project-pages.improvement.templates.pre-expand.more': "Tov\xe1bbi sablonok felfedez\xe9se",
    'project-pages.improvement.templates.pre-expand.subtitle': "N\xe9pszer\u0171 a ti\xe9dhez hasonl\xf3 csapatok k\xf6r\xe9ben",
    'project-pages.improvement.templates.pre-expand.title': "Sablonok el\u0151n\xe9zet\xe9nek megtekint\xe9se",
    'project-pages.improvement.templates.product-requirements.description': "Defini\xe1ld, k\xf6vesd \xe9s tedd \xe1ttekinthet\u0151v\xe9 a term\xe9ked vagy funkci\xf3d k\xf6vetelm\xe9nyeit.",
    'project-pages.improvement.templates.product-requirements.name': "Term\xe9kk\xf6vetelm\xe9nyek",
    'project-pages.improvement.templates.retrospective.description': "Mi az, ami j\xf3l alakult? Mi mehetett volna jobban? A csapatoddal k\xf6z\xf6sen tal\xe1ljatok ki fejleszt\xe9si lehet\u0151s\xe9geket.",
    'project-pages.improvement.templates.retrospective.name': "Visszatekint\xe9s",
    'project-pages.improvement.templates.template.disabled-tooltip': "El\u0151sz\xf6r csatlakoztass egy Confluence-munkateret",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Takar\xedts meg id\u0151t, \xe9s cs\xf6kkentsd a manu\xe1lis feladatok sz\xe1m\xe1t</b>. A Confluence rengeteg <a>oldalsablonnal</a> rendelkezik, \xedgy soha nem kell null\xe1r\xf3l kezdened. Ilyenekre gondolj: sablonok m\u0171szaki dokumentumokhoz, hibaelh\xe1r\xedt\xf3 \xfatmutat\xf3khoz, projekttervekhez, term\xe9kk\xf6vetelm\xe9nyekhez \xe9s sok m\xe1shoz.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>K\xf6nnyed\xe9n szerkeszthet\u0151 \xe9s form\xe1zhat\xf3.</b> A fenti szerkeszt\u0151men\xfc seg\xedts\xe9g\xe9vel elv\xe9gezheted a standard Word-form\xe1z\xe1sokat, a <b>/</b> be\xedr\xe1s\xe1val pedig egyszer\u0171en besz\xfarhatsz sok praktikus integr\xe1ci\xf3t. T\xe1bl\xe1zatot a <c>/t\xe1bl\xe1zat</c>, k\xe9pet pedig a <c>/k\xe9p</c> be\xedr\xe1s\xe1val sz\xfarhatsz be. A <c>/dropbox</c> be\xedr\xe1s\xe1val Dropbox linkeket, a <c>/microsoft</c> paranccsal Microsoft Office-eszk\xf6z\xf6ket, a <c>/trello</c> beg\xe9pel\xe9s\xe9vel pedig Trello-t\xe1bl\xe1kat \xe9s -k\xe1rty\xe1kat sz\xfarhatsz be.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\xcdrd be a / jelet, majd a \u201Et\xe1bl\xe1zat\u201C vagy a \u201Ek\xe9p\u201C sz\xf3t",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\xcdme n\xe9h\xe1ny tipp a kezd\xe9shez:",
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Praktikus linkek',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Haszn\xe1ld egy\xfctt a Jir\xe1t \xe9s a Confluence-t",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Hozz l\xe9tre diagramokat az oldalaidon val\xf3s Jira-adatok alapj\xe1n. \xcdrd be, hogy <c>/Jira diagramok</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Linkelj egy Jira-\xfcgyet b\xe1rhol az oldaladon. Az oldal linkje val\xf3s id\u0151ben friss\xfcl, ahogy friss\xedted a Jira-\xfcgyet. \xcdrd be, hogy <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\xc1gyazz be interakt\xedv \xfatvonalterveket \xe9s id\u0151vonalakat az oldaladra a Jira Projects haszn\xe1lat\xe1val. \xcdrd be, hogy <c>/jira \xfatvonalterv</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\xc1gyazz be interakt\xedv id\u0151vonalakat az oldaladra a Jira-projektek haszn\xe1lat\xe1val. G\xe9peld be a <c>/jira id\u0151vonal</c> kifejez\xe9st.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "A Jira Software haszn\xe1l\xf3inak 76%-a \xe1ll\xedtja, hogy a Confluence bevezet\xe9se \xf3ta gyorsabban tudja sz\xe1ll\xedtani a projekteket",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "A Jira-\xfcgyfelek 76%-a \xe1ll\xedtja, hogy a Confluence bevezet\xe9se \xf3ta gyorsabban tudja sz\xe1ll\xedtani a projekteket",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Munkaterek \xe9s oldalak haszn\xe1lata</b>. A munkaterek minden Confluence-webhely r\xe9szei, \xe9s kiv\xe1l\xf3 m\xf3dszert jelentenek az oldalak kateg\xf3ri\xe1kba rendez\xe9s\xe9re. Gondolj \xfagy a munkaterekre, mint k\xfcl\xf6nb\xf6z\u0151 mapp\xe1kra vagy projektekre, az oldalak pedig a mapp\xe1kba vagy projektekbe tartoz\xf3 dokumentumok. <a>Tov\xe1bbi inform\xe1ci\xf3 a munkaterek haszn\xe1lat\xe1r\xf3l</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "Pr\xf3b\xe1ld ki most",
    'project-pages.improvement.templates.tutorial.description': 'Ismerd meg, hogyan kell szerkeszteni egy oldalt.',
    'project-pages.improvement.templates.tutorial.name': "\xdcdv\xf6zl\xfcnk a Projektoldalakon!",
    'project-pages.improvement.terms-and-conditions-v2': "A \u201EPr\xf3b\xe1ld ki most\u201D gombra kattintva regisztr\xe1lsz a Confluence szolg\xe1ltat\xe1sra, \xe9s elfogadod az Atlassian <termsLink>Cloud \xc1ltal\xe1nos Szolg\xe1ltat\xe1si Felt\xe9teleit</termsLink> \xe9s <privacyLink>adatv\xe9delmi ir\xe1nyelveit</privacyLink>.",
    'project-pages.improvement.title': 'Projektoldalak',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Oldal l\xe9trehoz\xe1sa",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Hozz\xe1adtuk a Confluence-t, \xedgy hozz\xe1kezdhetsz, hogy l\xe9trehozd \xe9s \xf6sszekapcsold az \xf6sszes projektdokumentumot. 10 felhaszn\xe1l\xf3ig ingyenes.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "Tov\xe1bbi inform\xe1ci\xf3",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Hozd l\xe9tre az els\u0151 oldaladat",
    'project-pages.improvement.transient-states.empty-state.description': "Hozz l\xe9tre megbesz\xe9l\xe9sfeljegyz\xe9seket, term\xe9kk\xf6vetelm\xe9nyeket, d\xf6nt\xe9seket vagy m\xe1s tartalmakat, amelyekkel megt\xf6ltheted ezt a munkateret.",
    'project-pages.improvement.transient-states.empty-state.title': "Ez a hely tele van lehet\u0151s\xe9ggel",
    'project-pages.improvement.try-button': "Pr\xf3b\xe1ld ki ezt a sablont a Confluence-ben",
    'project-pages.improvement.try-it-now': "Pr\xf3b\xe1ld ki most",
    'project-pages.improvement.try-lozenge': "Pr\xf3b\xe1ld ki",
    'project-pages.improvement.try-on-demand-button': "Pr\xf3b\xe1ld ki ingyen",
    'project-pages.page-deleted-flag.title': "Oldal t\xf6r\xf6lve.",
    'project-pages.page-published-flag.title': "Az oldaladat k\xf6zz\xe9tett\xfck.",
    'project-pages.unknown-error.description': "{contactSupport}, ha a friss\xedt\xe9s nem jav\xedtja ki a probl\xe9m\xe1kat.",
    'project-pages.unknown-error.heading': "Jelenleg nem tudjuk megjelen\xedteni a projektoldalakat",
    'projectpages.templatepreview.termsandprivacy': "A \u201EPr\xf3b\xe1ld ki ingyen\u201D gombra kattintva regisztr\xe1lsz a Confluence szolg\xe1ltat\xe1sra, \xe9s elfogadod az Atlassian Cloud <termsOfServiceLinkText>\xc1ltal\xe1nos Szolg\xe1ltat\xe1si Felt\xe9teleit</termsOfServiceLinkText> \xe9s <privacyPolicyLinkText>adatv\xe9delmi ir\xe1nyelveit</privacyPolicyLinkText>."
};

});

parcelRegister("hVSzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d14badceb3effecb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $d14badceb3effecb$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "L'operazione dovrebbe richiedere meno di un minuto",
    'confluence.project-pages.improvement.provisioning-background.title': 'Configurazione delle pagine del progetto in corso',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Chiudi',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Fine',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Avanti',
    'project-pages.activating.description': "Lo spazio Confluence connesso non \xe8 ancora pronto. {contactSupport} se il problema non si risolve con un aggiornamento.",
    'project-pages.activating.heading': "Confluence \xe8 ancora in fase di caricamento",
    'project-pages.button.connect-different-space-or-page.label': "Aggiorna l'icona dello spazio o della pagina",
    'project-pages.button.connect-different-space-or-page.tooltip': 'Connetti uno spazio o una pagina diversi',
    'project-pages.button.connect-space-or-page.tooltip': 'Connetti a Confluence',
    'project-pages.button.go-to-connected-page.tooltip': 'Apri la pagina in Confluence',
    'project-pages.button.go-to-connected-space.tooltip': 'Apri lo spazio in Confluence',
    'project-pages.connect-space-dialog.connection-error': 'Connessione non riuscita.',
    'project-pages.connect-space-dialog.connection-retry': 'Riprova',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': 'Scegli uno spazio o una pagina da collegare al tuo progetto.',
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Cerca Confluence',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': 'Questo progetto deve essere collegato a uno spazio prima che sia possibile creare una pagina. Scegli uno spazio da collegare al progetto.',
    'project-pages.connect-space-dialog.error-icon': 'Errore:',
    'project-pages.connect-space-dialog.footer.cancel': 'Annulla',
    'project-pages.connect-space-dialog.footer.connect-space': 'Collega',
    'project-pages.connect-space-or-page-dialog.header.title': 'Connetti progetto a Confluence',
    'project-pages.connect-space.description': 'Gli spazi sono come cartelle: puoi utilizzarli per creare, organizzare e collaborare a tutti i contenuti correlati al tuo progetto.',
    'project-pages.connect-space.not-connected.description': "Per utilizzare le pagine di progetto, contatta l'amministratore o il team leader per connettere Confluence a questo progetto.",
    'project-pages.connect-space.not-connected.heading': 'Non connesso a Confluence',
    'project-pages.connect-success-flag.description.content': 'Connessione con il contenuto {connectedSpaceOrPageName} riuscita.',
    'project-pages.connection-error.space-or-page-not-found.button': 'Connetti a uno spazio o pagina diverso',
    'project-pages.create-space-dialog.connection-error': 'Connessione non riuscita.',
    'project-pages.create-space-dialog.connection-retry': 'Riprova',
    'project-pages.create-space-dialog.content.empty-name': 'Assegna un nome al tuo spazio.',
    'project-pages.create-space-dialog.content.invalid-name': 'I nomi degli spazi devono contenere almeno una lettera o un numero.',
    'project-pages.create-space-dialog.content.placeholder': 'Inserisci un nome per lo spazio',
    'project-pages.create-space-dialog.creation-error': 'Connessione dello spazio non riuscita.',
    'project-pages.create-space-dialog.error-icon': 'Errore:',
    'project-pages.create-space-dialog.footer.cancel': 'Annulla',
    'project-pages.create-space-dialog.footer.create-space': 'Crea',
    'project-pages.create-space-dialog.header.title': 'Crea nuovo spazio Confluence',
    'project-pages.cross-join.access-revoked.templates.subtitle': "Non puoi utilizzare le pagine del progetto perch\xe9 l'amministratore ti ha negato l'accesso a Confluence. Contatta l'amministratore del sito per richiedere l'accesso.",
    'project-pages.cross-join.access-revoked.templates.title': 'Non sei autorizzato a usare le pagine del progetto',
    'project-pages.cross-join.avatar.view-profile': 'Visualizza profilo',
    'project-pages.cross-join.denied-request.templates.subtitle': "Non puoi utilizzare le pagine del progetto perch\xe9 l'amministratore del sito ha rifiutato la tua richiesta di unirti a Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "Il tuo amministratore ti ha negato l'accesso",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Otterrai l'accesso a Confluence. L'amministratore del sito ha gi\xe0 approvato l'accesso.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} se con l'aggiornamento non risolvi il problema.",
    'project-pages.cross-join.errors.unknown-error.title': "Al momento non \xe8 possibile visualizzare le pagine del progetto",
    'project-pages.cross-join.inline-join-product.button': "Otterrai l'accesso a Confluence. L'amministratore del tuo sito ha gi\xe0 approvato il tuo accesso.",
    'project-pages.cross-join.inline-join-product.connected.description': "Visualizza, modifica e crea la documentazione da un'unica posizione",
    'project-pages.cross-join.inline-join-product.connected.title': 'Collabora alle pagine del progetto con il tuo team',
    'project-pages.cross-join.pending-request.templates.subtitle': "L'amministratore del sito ha ricevuto la tua richiesta di unirti a Confluence. Se la tua unione viene approvata, le pagine del progetto inizieranno a essere utilizzabili e riceverai un'e-mail di conferma.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Riceverai un messaggio e-mail con l'accesso alle pagine del progetto non appena la richiesta sar\xe0 stata approvata",
    'project-pages.cross-join.pending-request.templates.title': "Hai richiesto l'accesso a Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "Richiesta di accesso inviata all'amministratore",
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'Visualizza, modifica e crea la documentazione del progetto con il tuo team',
    'project-pages.cross-join.request-access.button': 'Richiedi accesso',
    'project-pages.cross-join.request-access.button-subtitle.experimental': 'Quando selezioni "Unisciti al team", ti sar\xe0 chiesto di entrare a far parte di Confluence e dovrai accettare di condividere il tuo profilo Atlassian con il tuo amministratore.',
    'project-pages.cross-join.request-access.button.experimental': 'Unisciti al tuo team',
    'project-pages.cross-join.request-access.connected.description.experimental': 'Il tuo team usa le pagine del progetto per commentare, modificare e collaborare alla documentazione del progetto senza lasciare Jira. Unisciti a Confluence per accedere alle pagine del progetto del tuo team.',
    'project-pages.cross-join.request-access.title': "Le pagine del progetto richiedono l'accesso a Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Crea un'unica origine di riferimento per il tuo team",
    'project-pages.default-contextual-heading': 'Le pagine di progetto usano la tecnologia di Confluence',
    'project-pages.default-contextual-message': "Crea, condividi e collabora a tutti i documenti del tuo progetto da un'unica posizione con le pagine Confluence.",
    'project-pages.default-reactivate-CTA': 'Riattiva Confluence',
    'project-pages.default-trial-CTA': 'Prova gratuitamente Confluence per 30 giorni',
    'project-pages.draft-saved-flag.action': 'Apri bozza',
    'project-pages.draft-saved-flag.description': "La bozza \xe8 visibile solo finch\xe9 non la pubblichi.",
    'project-pages.draft-saved-flag.title': 'Bozza salvata',
    'project-pages.embedded-pages.create-page-error.close-button': 'Chiudi',
    'project-pages.embedded-pages.create-page-error.description': "Si \xe8 verificato un problema e non \xe8 stato possibile creare una pagina.",
    'project-pages.embedded-pages.create-page-error.title': 'Impossibile creare una pagina',
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Riprova',
    'project-pages.embedded-pages.modal.close.button.hint': 'Chiudi',
    'project-pages.embedded-pages.modal.title.button': 'Apri in Confluence',
    'project-pages.embedded-pages.modal.title.button.hint': 'Apri in una nuova scheda',
    'project-pages.errors.unknown-error.description.non-final': '{contactSupport} se il problema non si risolve con un aggiornamento.',
    'project-pages.errors.unknown-error.title.non-final': "Al momento non \xe8 possibile visualizzare le pagine del progetto",
    'project-pages.generic-error.button.reload': 'Ricarica la pagina',
    'project-pages.generic-error.description': "Si \xe8 verificato un errore. Riprova pi\xf9 tardi.",
    'project-pages.generic-error.description.non-final': "Si \xe8 verificato un errore. Riprova pi\xf9 tardi.",
    'project-pages.generic-error.heading': "\xc8 imbarazzante...",
    'project-pages.generic-error.title.non-final': "\xc8 imbarazzante...",
    'project-pages.generic-info-flag.description': "Si \xe8 verificato un problema. Riprova o, se il problema persiste, contatta l'assistenza",
    'project-pages.generic-success-flag.description.page': 'Connessione con la pagina {connectedSpaceOrPageName} riuscita.',
    'project-pages.generic-success-flag.description.space': 'Collegamento con lo spazio {connectedSpaceOrPageName} riuscito.',
    'project-pages.generic-success-flag.heading.page': 'Pagina connessa',
    'project-pages.generic-success-flag.heading.space': 'Spazio collegato',
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'O crea un nuovo spazio',
    'project-pages.granular-pages.connect-space.button': 'Connetti a Confluence',
    'project-pages.granular-pages.connect-space.heading': 'Connetti questo progetto a uno spazio o una pagina Confluence',
    'project-pages.granular-pages.connect-space.heading.non-final': 'Connetti questo progetto a uno spazio o una pagina Confluence',
    'project-pages.improvement.contact-support': "Contatta l'assistenza",
    'project-pages.improvement.errors.access-error.description': "Prova a contattare l'amministratore del sito per richiedere l'accesso.",
    'project-pages.improvement.errors.access-error.title': 'Non sei autorizzato a visualizzare le pagine del progetto',
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Si \xe8 verificato un problema durante il tentativo di visualizzare le pagine dello spazio Confluence connesso. {contactSupport} se il problema non si risolve con un aggiornamento.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': 'Si sono verificati problemi durante la visualizzazione delle pagine del progetto',
    'project-pages.improvement.errors.space-or-page-not-found.description': "Lo spazio o la pagina Confluence connesso \xe8 stato spostato, archiviato o eliminato. <link>Contatta l'assistenza</link> se la riconnessione non risolve il problema",
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Spazio o pagina non trovati',
    'project-pages.improvement.errors.unknown-error.description': '{contactSupport} se il problema non si risolve con un aggiornamento.',
    'project-pages.improvement.errors.unknown-error.title': "Al momento non \xe8 possibile visualizzare le pagine del progetto",
    'project-pages.improvement.feature1': 'Crea e accedi ai documenti senza uscire da Jira',
    'project-pages.improvement.feature2': 'Modelli per riunioni, programmi di sprint e altro ancora',
    'project-pages.improvement.feature3': 'Sincronizza i documenti con Jira per gli aggiornamenti automatici',
    'project-pages.improvement.heading-info': 'Raccogli le conoscenze del tuo team e migliora lo svolgimento del lavoro.',
    'project-pages.improvement.heading-info-v2': 'Crea un posto per tutti i documenti di progetto del tuo team',
    'project-pages.improvement.learn-more-button': 'Maggiori informazioni',
    'project-pages.improvement.powered-by': 'Offerto da',
    'project-pages.improvement.powered-by.tooltip': 'Apri Confluence in una nuova scheda',
    'project-pages.improvement.preview-teaser': 'Sblocca modelli, pagine di progetto e altro ancora.',
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Mantieni aggiornati i report del progetto utilizzando le etichette di stato che si aggiornano automaticamente.</p> <p>Basta collegare un ticket Jira a un documento per visualizzare automaticamente un'etichetta di stato che si aggiorna in sincronia con il ticket, cos\xec da non perdere tempo a creare report manuali.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Aggiorna senza difficolt\xe0 i tuoi stakeholder",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': '<p>Crea una documentazione coerente utilizzando i nostri modelli integrati. Sono semplici da usare e personalizzabili secondo le tue esigenze.</p> <p>Puoi usare i modelli direttamente dalle pagine del progetto, in modo da non dover mai interrompere il lavoro in corso. Sfoglia tutti i modelli <a>qui</a>.</p>',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Unifica gli standard relativi alla documentazione',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Crea un'origine di riferimento unica per le informazioni importanti generando e gestendo la documentazione dalla scheda delle pagine del progetto in Jira.</p> <p>Sapevi che le pagine del progetto sono utilizzabili in Confluence? \xc8 gratuito per un massimo di 10 utenti. Invita il resto del tuo team dalle impostazioni di amministrazione.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Le tue pagine del progetto, direttamente in Jira',
    'project-pages.improvement.templates.blank-page.description': 'Costruisci una pagina da zero.',
    'project-pages.improvement.templates.blank-page.name': 'Pagina vuota',
    'project-pages.improvement.templates.decision.description': 'Registra le decisioni importanti per il progetto e comunicale al tuo team.',
    'project-pages.improvement.templates.decision.name': 'Decisione',
    'project-pages.improvement.templates.meeting-notes.description': 'Pianifica i tuoi incontri, prendi appunti e condividi le azioni con il tuo team.',
    'project-pages.improvement.templates.meeting-notes.name': 'Note della riunione',
    'project-pages.improvement.templates.post-expand.more': 'Altri modelli',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Visualizza tutti i modelli in Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': "Modelli pi\xf9 richiesti",
    'project-pages.improvement.templates.post-expand.title': 'Crea una pagina',
    'project-pages.improvement.templates.pre-expand.more': 'Scopri altri modelli',
    'project-pages.improvement.templates.pre-expand.subtitle': "I pi\xf9 richiesti tra i team come il tuo",
    'project-pages.improvement.templates.pre-expand.title': 'Visualizza anteprima modelli',
    'project-pages.improvement.templates.product-requirements.description': 'Definisci, monitora e delimita i requisiti per il tuo prodotto o la tua funzione.',
    'project-pages.improvement.templates.product-requirements.name': 'Requisiti del prodotto',
    'project-pages.improvement.templates.retrospective.description': "Che cosa \xe8 andato bene? Che cosa sarebbe potuto andare meglio? Gestisci i miglioramenti in crowdsourcing con il tuo team.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospettiva',
    'project-pages.improvement.templates.template.disabled-tooltip': 'Connetti prima uno spazio Confluence',
    'project-pages.improvement.templates.tutorial.content.confluence-templates': '<b>Risparmia tempo e riduci i task manuali</b>. Confluence dispone di molti <a>modelli</a> di pagina che ti eviteranno di dover cominciare da zero. Pensa ai documenti tecnici, alle guide alla risoluzione dei problemi, ai piani di progetto, ai requisiti dei prodotti e altro ancora.',
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Modifica e formatta con facilit\xe0.</b> Usa il menu di modifica in alto per la formattazione standard del testo e digita <b>/</b> per inserire facilmente diverse integrazioni utili. Inserisci una tabella digitando <c>/tabella</c> o un'immagine digitando <c>/immagine</c>. Puoi anche inserire link a Dropbox con <c>/dropbox</c>, agli strumenti di Microsoft Office con <c>/microsoft</c> o a bacheche e schede di Trello con <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Digita / seguito da "tabella" o "immagine"',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': 'Ecco alcuni suggerimenti per iniziare:',
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Link pratici',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Usa Jira e Confluence insieme',
    'project-pages.improvement.templates.tutorial.content.jira-charts': 'Crea grafici nelle pagine utilizzando dati autentici di Jira. Digita <c>/grafici Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links': "Collega un ticket Jira in qualsiasi punto della pagina. Il link sulla pagina sar\xe0 aggiornato in tempo reale quando aggiornerai il ticket Jira. Digita <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': 'Incorpora roadmap e timeline interattive nella pagina utilizzando i progetti Jira. Digita <c>/roadmap jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-timeline': 'Incorpora le timeline interattive nella pagina utilizzando i progetti Jira. Digita <c>/timeline jira</c>.',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': 'Il 76% dei clienti di Jira Software afferma di aver velocizzato il rilascio dei progetti grazie a Confluence',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': 'Il 76% dei clienti Jira afferma di aver velocizzato il rilascio dei progetti grazie a Confluence',
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Uso di spazi e pagine</b>. Gli spazi sono parte di ogni sito Confluence e rappresentano un mezzo per organizzare le pagine in categorie. Pensa agli spazi come a cartelle o progetti diversi; le pagine sono i documenti che appartengono a tali cartelle o progetti. <a>Scopri di pi\xf9 sull'uso degli spazi</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Prova subito',
    'project-pages.improvement.templates.tutorial.description': 'Scopri come modificare una pagina.',
    'project-pages.improvement.templates.tutorial.name': 'Ti diamo il benvenuto nelle pagine del progetto.',
    'project-pages.improvement.terms-and-conditions-v2': "Selezionando &quot;Prova ora&quot;, prendi atto che sarai iscritto a Confluence e accetti le <termsLink>Condizioni d'uso di Atlassian Cloud</termsLink> e l'<privacyLink>Informativa sulla privacy</privacyLink> di Atlassian.",
    'project-pages.improvement.title': 'Pagine di progetto',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Crea pagina',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Abbiamo aggiunto Confluence in modo che tu possa iniziare a creare e collegare tutti i documenti del tuo progetto. \xc8 gratuito per un massimo di 10 utenti.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Maggiori informazioni',
    'project-pages.improvement.transient-states.empty-state.create-page-button': 'Crea la tua prima pagina',
    'project-pages.improvement.transient-states.empty-state.description': 'Crea note della riunione, requisiti di prodotto, decisioni e altri contenuti per riempire questo spazio.',
    'project-pages.improvement.transient-states.empty-state.title': "Qui non c'\xe8 altro che il potenziale",
    'project-pages.improvement.try-button': 'Prova questo modello in Confluence',
    'project-pages.improvement.try-it-now': 'Provalo subito',
    'project-pages.improvement.try-lozenge': 'prova',
    'project-pages.improvement.try-on-demand-button': 'Provalo gratis',
    'project-pages.page-deleted-flag.title': 'Pagina eliminata.',
    'project-pages.page-published-flag.title': "La tua pagina \xe8 stata pubblicata.",
    'project-pages.unknown-error.description': '{contactSupport} se il problema non si risolve con un aggiornamento.',
    'project-pages.unknown-error.heading': "Al momento non \xe8 possibile visualizzare le pagine del progetto",
    'projectpages.templatepreview.termsandprivacy': "Cliccando su &quot;Provalo gratis&quot;, sarai registrato in Confluence e accetterai le <termsOfServiceLinkText>Condizioni d\u2019uso</termsOfServiceLinkText> di Atlassian Cloud e l\u2019<privacyPolicyLinkText>Informativa sulla privacy</privacyPolicyLinkText> di Atlassian."
};

});

parcelRegister("bj7Z8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8ff377817473f01$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $e8ff377817473f01$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u3053\u308C\u306F 1 \u5206\u672A\u6E80\u3067\u5B8C\u4E86\u3057\u307E\u3059",
    'confluence.project-pages.improvement.provisioning-background.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3059\u308B",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u9589\u3058\u308B",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u5B8C\u4E86",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u6B21\u3078",
    'project-pages.activating.description': "\u63A5\u7D9A\u3055\u308C\u305F Confluence \u30B9\u30DA\u30FC\u30B9\u306F\u307E\u3060\u6E96\u5099\u304C\u3067\u304D\u3066\u3044\u307E\u305B\u3093\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3082\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{contactSupport}\u3002",
    'project-pages.activating.heading': "Confluence \u306F\u307E\u3060\u8AAD\u307F\u8FBC\u307F\u4E2D\u3067\u3059",
    'project-pages.button.connect-different-space-or-page.label': "\u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30DA\u30FC\u30B8\u306E\u30A2\u30A4\u30B3\u30F3\u3092\u66F4\u65B0",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u5225\u306E\u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30DA\u30FC\u30B8\u3092\u63A5\u7D9A",
    'project-pages.button.connect-space-or-page.tooltip': "Confluence \u306B\u63A5\u7D9A\u3059\u308B",
    'project-pages.button.go-to-connected-page.tooltip': "Confluence \u3067\u30DA\u30FC\u30B8\u3092\u958B\u304F",
    'project-pages.button.go-to-connected-space.tooltip': "Confluence \u3067\u30B9\u30DA\u30FC\u30B9\u3092\u958B\u304F",
    'project-pages.connect-space-dialog.connection-error': "\u63A5\u7D9A\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    'project-pages.connect-space-dialog.connection-retry': "\u518D\u8A66\u884C",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u63A5\u7D9A\u3059\u308B\u30B9\u30DA\u30FC\u30B9\u304B\u30DA\u30FC\u30B8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "Confluence \u3092\u691C\u7D22",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u30DA\u30FC\u30B8\u3092\u4F5C\u6210\u3059\u308B\u524D\u306B\u3001\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u30B9\u30DA\u30FC\u30B9\u306B\u63A5\u7D9A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u63A5\u7D9A\u3059\u308B\u30B9\u30DA\u30FC\u30B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.connect-space-dialog.error-icon': "\u30A8\u30E9\u30FC: ",
    'project-pages.connect-space-dialog.footer.cancel': "\u30AD\u30E3\u30F3\u30BB\u30EB",
    'project-pages.connect-space-dialog.footer.connect-space': "\u63A5\u7D9A",
    'project-pages.connect-space-or-page-dialog.header.title': "Confluence \u306B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u63A5\u7D9A",
    'project-pages.connect-space.description': "\u30B9\u30DA\u30FC\u30B9\u306F\u30D5\u30A9\u30EB\u30C0\u306E\u3088\u3046\u306A\u3082\u306E\u3067\u3059\u3002\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u95A2\u9023\u3059\u308B\u3042\u3089\u3086\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u4F5C\u6210\u3001\u6574\u7406\u3001\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3\u306B\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002",
    'project-pages.connect-space.not-connected.description': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001\u7BA1\u7406\u8005\u307E\u305F\u306F\u30C1\u30FC\u30E0 \u30EA\u30FC\u30C9\u306B\u3054\u4F9D\u983C\u306E\u3046\u3048\u3001Confluence \u3092\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u63A5\u7D9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.connect-space.not-connected.heading': "Confluence \u306B\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    'project-pages.connect-success-flag.description.content': "{connectedSpaceOrPageName} \u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3068\u306E\u63A5\u7D9A\u306B\u6210\u529F\u3057\u307E\u3057\u305F\u3002",
    'project-pages.connection-error.space-or-page-not-found.button': "\u5225\u306E\u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30DA\u30FC\u30B8\u306B\u63A5\u7D9A",
    'project-pages.create-space-dialog.connection-error': "\u63A5\u7D9A\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    'project-pages.create-space-dialog.connection-retry': "\u518D\u8A66\u884C",
    'project-pages.create-space-dialog.content.empty-name': "\u30B9\u30DA\u30FC\u30B9\u306B\u540D\u524D\u3092\u4ED8\u3051\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.create-space-dialog.content.invalid-name': "\u30B9\u30DA\u30FC\u30B9\u540D\u306B\u306F\u82F1\u6570\u5B57\u3092 1 \u5B57\u4EE5\u4E0A\u4F7F\u7528\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    'project-pages.create-space-dialog.content.placeholder': "\u30B9\u30DA\u30FC\u30B9\u540D\u3092\u5165\u529B",
    'project-pages.create-space-dialog.creation-error': "\u30B9\u30DA\u30FC\u30B9\u306E\u4F5C\u6210\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    'project-pages.create-space-dialog.error-icon': "\u30A8\u30E9\u30FC: ",
    'project-pages.create-space-dialog.footer.cancel': "\u30AD\u30E3\u30F3\u30BB\u30EB",
    'project-pages.create-space-dialog.footer.create-space': "\u4F5C\u6210",
    'project-pages.create-space-dialog.header.title': "\u65B0\u3057\u3044 Confluence \u30B9\u30DA\u30FC\u30B9\u3092\u4F5C\u6210",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u7BA1\u7406\u8005\u304C Confluence \u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u62D2\u5426\u3057\u305F\u305F\u3081\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30DA\u30FC\u30B8\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u30A2\u30AF\u30BB\u30B9\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u306B\u306F\u3001\u30B5\u30A4\u30C8\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
    'project-pages.cross-join.access-revoked.templates.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u4F7F\u7528\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093",
    'project-pages.cross-join.avatar.view-profile': "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u3092\u8868\u793A",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u30B5\u30A4\u30C8\u7BA1\u7406\u8005\u304C Confluence \u3078\u306E\u53C2\u52A0\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u62D2\u5426\u3057\u305F\u305F\u3081\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002",
    'project-pages.cross-join.denied-request.templates.title': "\u7BA1\u7406\u8005\u304C\u30A2\u30AF\u30BB\u30B9\u3092\u62D2\u5426\u3057\u307E\u3057\u305F",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Confluence \u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002\u30B5\u30A4\u30C8\u7BA1\u7406\u8005\u306F\u3059\u3067\u306B\u3042\u306A\u305F\u3092\u627F\u8A8D\u3057\u3066\u3044\u307E\u3059\u3002",
    'project-pages.cross-join.errors.unknown-error.description': "\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3082\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{contactSupport}\u3002",
    'project-pages.cross-join.errors.unknown-error.title': "\u73FE\u5728\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u8868\u793A\u3067\u304D\u307E\u305B\u3093",
    'project-pages.cross-join.inline-join-product.button': "Confluence \u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002\u30B5\u30A4\u30C8\u7BA1\u7406\u8005\u306F\u3059\u3067\u306B\u3042\u306A\u305F\u3092\u627F\u8A8D\u3057\u3066\u3044\u307E\u3059\u3002",
    'project-pages.cross-join.inline-join-product.connected.description': "\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092 1 \u304B\u6240\u304B\u3089\u8868\u793A\u3001\u7DE8\u96C6\u3001\u4F5C\u6210\u3057\u307E\u3059\u3002",
    'project-pages.cross-join.inline-join-product.connected.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3067\u30C1\u30FC\u30E0\u3068\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3\u3059\u308B",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u30B5\u30A4\u30C8\u7BA1\u7406\u8005\u304C Confluence \u3078\u306E\u53C2\u52A0\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u53D6\u308A\u307E\u3057\u305F\u3002\u53C2\u52A0\u304C\u627F\u8A8D\u3055\u308C\u308B\u3068\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u304C\u8D77\u52D5\u3057\u3001\u78BA\u8A8D\u30E1\u30FC\u30EB\u304C\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\u627F\u8A8D\u3055\u308C\u305F\u3089\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u305F\u3081\u306E\u30E1\u30FC\u30EB\u304C\u5C4A\u304D\u307E\u3059\u3002",
    'project-pages.cross-join.pending-request.templates.title': "Confluence \u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3057\u307E\u3057\u305F",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u30A2\u30AF\u30BB\u30B9 \u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u7BA1\u7406\u8005\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u30C1\u30FC\u30E0\u3067\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u8868\u793A\u3001\u7DE8\u96C6\u3001\u4F5C\u6210\u3057\u307E\u3059\u3002",
    'project-pages.cross-join.request-access.button': "\u30A2\u30AF\u30BB\u30B9\u3092\u30EA\u30AF\u30A8\u30B9\u30C8",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "[\u30C1\u30FC\u30E0\u306B\u53C2\u52A0] \u3092\u9078\u629E\u3059\u308B\u3068\u3001Confluence \u3078\u306E\u53C2\u52A0\u3092\u7533\u8ACB\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u81EA\u8EAB\u306E\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u3092\u7BA1\u7406\u8005\u3068\u5171\u6709\u3059\u308B\u3053\u3068\u306B\u540C\u610F\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002",
    'project-pages.cross-join.request-access.button.experimental': "\u30C1\u30FC\u30E0\u306B\u53C2\u52A0",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u3042\u306A\u305F\u306E\u30C1\u30FC\u30E0\u306F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u4F7F\u7528\u3057\u3066\u3001Jira \u3092\u96E2\u308C\u308B\u3053\u3068\u306A\u304F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3067\u306E\u30B3\u30E1\u30F3\u30C8\u4F5C\u6210\u3001\u7DE8\u96C6\u3001\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3\u3092\u884C\u3063\u3066\u3044\u307E\u3059\u3002Confluence \u306B\u53C2\u52A0\u3057\u3066\u3001\u30C1\u30FC\u30E0\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u307E\u3057\u3087\u3046\u3002",
    'project-pages.cross-join.request-access.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306B\u306F Confluence \u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u5FC5\u8981\u3067\u3059",
    'project-pages.cross-join.request-access.title.experiment': "\u30C1\u30FC\u30E0\u7528\u306B\u4FE1\u983C\u3067\u304D\u308B\u552F\u4E00\u306E\u60C5\u5831\u6E90\u3092\u4F5C\u6210\u3059\u308B",
    'project-pages.default-contextual-heading': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306F Confluence \u306E\u6A5F\u80FD\u3092\u5229\u7528\u3057\u3066\u3044\u307E\u3059\u3002",
    'project-pages.default-contextual-message': "Confluence \u30DA\u30FC\u30B8\u3092\u4F7F\u3048\u3070\u3001\u3042\u3089\u3086\u308B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u6587\u66F8\u306E\u4F5C\u6210\u3001\u5171\u6709\u3001\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3\u3092\u4E00\u304B\u6240\u306B\u307E\u3068\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
    'project-pages.default-reactivate-CTA': "Confluence \u3092\u518D\u6709\u52B9\u5316",
    'project-pages.default-trial-CTA': "Confluence \u3092\u7121\u6599\u3067 30 \u65E5\u9593\u304A\u8A66\u3057\u304F\u3060\u3055\u3044",
    'project-pages.draft-saved-flag.action': "\u30C9\u30E9\u30D5\u30C8\u3092\u958B\u304F",
    'project-pages.draft-saved-flag.description': "\u30C9\u30E9\u30D5\u30C8\u306F\u3001\u516C\u958B\u3059\u308B\u307E\u3067\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u8868\u793A\u3055\u308C\u307E\u305B\u3093\u3002",
    'project-pages.draft-saved-flag.title': "\u30C9\u30E9\u30D5\u30C8\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F",
    'project-pages.embedded-pages.create-page-error.close-button': "\u9589\u3058\u308B",
    'project-pages.embedded-pages.create-page-error.description': "\u554F\u984C\u304C\u767A\u751F\u3057\u305F\u305F\u3081\u3001\u30DA\u30FC\u30B8\u3092\u4F5C\u6210\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    'project-pages.embedded-pages.create-page-error.title': "\u30DA\u30FC\u30B8\u3092\u4F5C\u6210\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u518D\u8A66\u884C",
    'project-pages.embedded-pages.modal.close.button.hint': "\u9589\u3058\u308B",
    'project-pages.embedded-pages.modal.title.button': "Confluence \u3067\u958B\u304F",
    'project-pages.embedded-pages.modal.title.button.hint': "\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304F",
    'project-pages.errors.unknown-error.description.non-final': "\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3082\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{contactSupport}\u3002",
    'project-pages.errors.unknown-error.title.non-final': "\u73FE\u5728\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u8868\u793A\u3067\u304D\u307E\u305B\u3093",
    'project-pages.generic-error.button.reload': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0",
    'project-pages.generic-error.description': "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.generic-error.description.non-final': "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.generic-error.heading': "\u6B63\u5E38\u306B\u6A5F\u80FD\u3057\u3066\u3044\u307E\u305B\u3093\u3002",
    'project-pages.generic-error.title.non-final': "\u6B63\u5E38\u306B\u6A5F\u80FD\u3057\u3066\u3044\u307E\u305B\u3093\u3002",
    'project-pages.generic-info-flag.description': "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u306E\u3046\u3048\u3001\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u30B5\u30DD\u30FC\u30C8\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
    'project-pages.generic-success-flag.description.page': "{connectedSpaceOrPageName} \u30DA\u30FC\u30B8\u3068\u63A5\u7D9A\u3057\u307E\u3057\u305F\u3002",
    'project-pages.generic-success-flag.description.space': "{connectedSpaceOrPageName} \u30B9\u30DA\u30FC\u30B9\u3068\u63A5\u7D9A\u3057\u307E\u3057\u305F\u3002",
    'project-pages.generic-success-flag.heading.page': "\u30DA\u30FC\u30B8\u3092\u63A5\u7D9A\u3057\u307E\u3057\u305F",
    'project-pages.generic-success-flag.heading.space': "\u30B9\u30DA\u30FC\u30B9\u3092\u63A5\u7D9A\u3057\u307E\u3057\u305F",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u307E\u305F\u306F\u65B0\u3057\u3044\u30B9\u30DA\u30FC\u30B9\u3092\u4F5C\u6210",
    'project-pages.granular-pages.connect-space.button': "Confluence \u306B\u63A5\u7D9A\u3059\u308B",
    'project-pages.granular-pages.connect-space.heading': "\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092 Confluence \u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30DA\u30FC\u30B8\u306B\u63A5\u7D9A",
    'project-pages.granular-pages.connect-space.heading.non-final': "\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092 Confluence \u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30DA\u30FC\u30B8\u306B\u63A5\u7D9A",
    'project-pages.improvement.contact-support': "\u30B5\u30DD\u30FC\u30C8\u306B\u554F\u3044\u5408\u308F\u305B",
    'project-pages.improvement.errors.access-error.description': "\u30B5\u30A4\u30C8\u7BA1\u7406\u8005\u306B\u30A2\u30AF\u30BB\u30B9\u6A29\u306B\u3064\u3044\u3066\u554F\u3044\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.improvement.errors.access-error.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u63A5\u7D9A\u3055\u308C\u305F Confluence \u30B9\u30DA\u30FC\u30B9\u306E\u30DA\u30FC\u30B8\u306E\u8868\u793A\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3082\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{contactSupport}\u3002",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306E\u8868\u793A\u3067\u554F\u984C\u304C\u767A\u751F\u3057\u3066\u3044\u307E\u3059",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u63A5\u7D9A\u3057\u305F Confluence \u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30DA\u30FC\u30B8\u306F\u3001\u79FB\u52D5\u3001\u30A2\u30FC\u30AB\u30A4\u30D6\u3001\u307E\u305F\u306F\u524A\u9664\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u518D\u63A5\u7D9A\u3057\u3066\u3082\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001<link>\u30B5\u30DD\u30FC\u30C8\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044</link>",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30DA\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093",
    'project-pages.improvement.errors.unknown-error.description': "\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3082\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{contactSupport}\u3002",
    'project-pages.improvement.errors.unknown-error.title': "\u73FE\u5728\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u8868\u793A\u3067\u304D\u307E\u305B\u3093",
    'project-pages.improvement.feature1': "Jira \u3092\u96E2\u308C\u308B\u3053\u3068\u306A\u304F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u3001\u4F5C\u6210\u3059\u308B",
    'project-pages.improvement.feature2': "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3084\u30B9\u30D7\u30EA\u30F3\u30C8\u8A08\u753B\u306A\u3069\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8",
    'project-pages.improvement.feature3': "\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092 Jira \u306B\u540C\u671F\u3057\u3066\u81EA\u52D5\u66F4\u65B0\u3059\u308B",
    'project-pages.improvement.heading-info': "\u30C1\u30FC\u30E0\u306E\u77E5\u8B58\u3092\u96C6\u3081\u3001\u696D\u52D9\u306E\u9032\u3081\u65B9\u3092\u6539\u5584\u3057\u307E\u3059\u3002",
    'project-pages.improvement.heading-info-v2': "\u30C1\u30FC\u30E0\u306E\u3059\u3079\u3066\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u307E\u3068\u3081\u308B\u5834\u6240\u3092\u4F5C\u6210\u3059\u308B",
    'project-pages.improvement.learn-more-button': "\u8A73\u7D30",
    'project-pages.improvement.powered-by': "\u4F7F\u7528\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3: ",
    'project-pages.improvement.powered-by.tooltip': "Confluence \u3092\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304F",
    'project-pages.improvement.preview-teaser': "\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306A\u3069\u306E\u30ED\u30C3\u30AF\u3092\u89E3\u9664\u3057\u307E\u3059\u3002",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\u30B9\u30C6\u30FC\u30BF\u30B9 \u30E9\u30D9\u30EB\u3092\u81EA\u52D5\u66F4\u65B0\u3057\u3066\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30EC\u30DD\u30FC\u30C8\u3092\u6700\u65B0\u306E\u72B6\u614B\u306B\u4FDD\u3061\u307E\u3057\u3087\u3046\u3002</p><p>\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u5185\u3067 Jira \u30C1\u30B1\u30C3\u30C8\u3092\u30EA\u30F3\u30AF\u3059\u308B\u3060\u3051\u3067\u3001\u30C1\u30B1\u30C3\u30C8\u3068\u540C\u671F\u3057\u3066\u66F4\u65B0\u3055\u308C\u308B\u30B9\u30C6\u30FC\u30BF\u30B9 \u30E9\u30D9\u30EB\u304C\u81EA\u52D5\u7684\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u6642\u9593\u3092\u304B\u3051\u3066\u624B\u52D5\u30EC\u30DD\u30FC\u30C8\u3092\u4F5C\u6210\u3059\u308B\u5FC5\u8981\u304C\u306A\u304F\u306A\u308A\u307E\u3059\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u95A2\u4FC2\u8005\u306B\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u6700\u65B0\u60C5\u5831\u3092\u4F1D\u3048\u308B",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\u7D44\u307F\u8FBC\u307F\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3001\u4E00\u8CAB\u6027\u306E\u3042\u308B\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3057\u307E\u3057\u3087\u3046\u3002\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306F\u30B7\u30F3\u30D7\u30EB\u3067\u4F7F\u3044\u3084\u3059\u304F\u3001\u30CB\u30FC\u30BA\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u307E\u3059\u3002</p><p>\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u304B\u3089\u76F4\u63A5\u4F7F\u7528\u3067\u304D\u308B\u306E\u3067\u3001\u4F5C\u696D\u4E2D\u306E\u30DA\u30FC\u30B8\u304B\u3089\u96E2\u308C\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u305B\u3093\u3002<a>\u3053\u3061\u3089</a>\u304B\u3089\u3059\u3079\u3066\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u53C2\u7167\u3067\u304D\u307E\u3059\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u6A19\u6E96\u3092\u7D71\u5408\u3059\u308B",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Jira \u306E [\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8] \u30BF\u30D6\u3067\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3057\u3066\u91CD\u8981\u306A\u60C5\u5831\u3092\u307E\u3068\u3081\u3001\u4FE1\u983C\u3067\u304D\u308B\u552F\u4E00\u306E\u60C5\u5831\u6E90\u3068\u3057\u3066\u904B\u7528\u3057\u307E\u3057\u3087\u3046\u3002</p><p>\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306F Confluence \u3067\u52D5\u4F5C\u3059\u308B\u3053\u3068\u3092\u3054\u5B58\u3058\u3067\u3057\u305F\u304B? \u6700\u5927 10 \u30E6\u30FC\u30B6\u30FC\u307E\u3067\u7121\u6599\u3067\u3054\u5229\u7528\u306B\u306A\u308C\u307E\u3059\u3002\u305C\u3072\u7BA1\u7406\u8005\u8A2D\u5B9A\u3067\u30C1\u30FC\u30E0\u306E\u4ED6\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85\u3057\u3066\u304F\u3060\u3055\u3044\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092 Jira \u3067\u76F4\u63A5\u5229\u7528",
    'project-pages.improvement.templates.blank-page.description': "\u6700\u521D\u304B\u3089\u30DA\u30FC\u30B8\u3092\u958B\u59CB\u3057\u307E\u3059\u3002",
    'project-pages.improvement.templates.blank-page.name': "\u767D\u7D19\u30DA\u30FC\u30B8",
    'project-pages.improvement.templates.decision.description': "\u91CD\u8981\u306A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u6C7A\u5B9A\u4E8B\u9805\u3092\u8A18\u9332\u3057\u3001\u305D\u308C\u306B\u3064\u3044\u3066\u30C1\u30FC\u30E0\u5185\u3067\u3084\u308A\u53D6\u308A\u3067\u304D\u307E\u3059\u3002",
    'project-pages.improvement.templates.decision.name': "\u6C7A\u5B9A\u4E8B\u9805",
    'project-pages.improvement.templates.meeting-notes.description': "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u8A08\u753B\u3057\u3066\u8B70\u4E8B\u9332\u3084\u30A2\u30AF\u30B7\u30E7\u30F3 \u30A2\u30A4\u30C6\u30E0\u3092\u30C1\u30FC\u30E0\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
    'project-pages.improvement.templates.meeting-notes.name': "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u8B70\u4E8B\u9332",
    'project-pages.improvement.templates.post-expand.more': "\u305D\u306E\u4ED6\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Confluence \u306E\u3059\u3079\u3066\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u8868\u793A",
    'project-pages.improvement.templates.post-expand.subtitle': "\u4EBA\u6C17\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8",
    'project-pages.improvement.templates.post-expand.title': "\u30DA\u30FC\u30B8\u3092\u4F5C\u6210",
    'project-pages.improvement.templates.pre-expand.more': "\u4ED6\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u78BA\u8A8D\u3059\u308B",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u4F3C\u305F\u3088\u3046\u306A\u30C1\u30FC\u30E0\u306B\u4EBA\u6C17\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8",
    'project-pages.improvement.templates.pre-expand.title': "\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u30D7\u30EC\u30D3\u30E5\u30FC",
    'project-pages.improvement.templates.product-requirements.description': "\u88FD\u54C1\u3084\u6A5F\u80FD\u306E\u8981\u4EF6\u306E\u5B9A\u7FA9\u3001\u8FFD\u8DE1\u3001\u7BC4\u56F2\u8A2D\u5B9A\u3092\u884C\u3044\u307E\u3059\u3002",
    'project-pages.improvement.templates.product-requirements.name': "\u88FD\u54C1\u8981\u4EF6",
    'project-pages.improvement.templates.retrospective.description': "\u3069\u306E\u70B9\u304C\u3046\u307E\u304F\u3044\u304D\u307E\u3057\u305F\u304B?\u6539\u5584\u70B9\u306F\u4F55\u3067\u3059\u304B?\u30C1\u30FC\u30E0\u5185\u3067\u306E\u30AF\u30E9\u30A6\u30C9\u30BD\u30FC\u30B7\u30F3\u30B0\u5229\u7528\u306E\u6539\u5584\u70B9\u3092\u51FA\u3057\u5408\u3044\u307E\u3059\u3002",
    'project-pages.improvement.templates.retrospective.name': "\u3075\u308A\u304B\u3048\u308A",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u307E\u305A Confluence \u30B9\u30DA\u30FC\u30B9\u3092\u63A5\u7D9A\u3057\u307E\u3059",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\u6642\u9593\u3092\u77ED\u7E2E\u3057\u3066\u3001\u624B\u52D5\u30BF\u30B9\u30AF\u3092\u524A\u6E1B\u3067\u304D\u307E\u3059</b>\u3002Confluence \u306B\u306F\u591A\u6570\u306E\u30DA\u30FC\u30B8 <a>\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8</a>\u304C\u7528\u610F\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u6700\u521D\u304B\u3089\u4F5C\u6210\u3059\u308B\u624B\u9593\u3092\u7701\u3051\u307E\u3059\u3002\u30C6\u30AF\u30CB\u30AB\u30EB \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3001\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u8A08\u753B\u3001\u88FD\u54C1\u8981\u4EF6\u306A\u3069\u306B\u3064\u3044\u3066\u8003\u3048\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u7DE8\u96C6\u3084\u66F8\u5F0F\u8A2D\u5B9A\u304C\u7C21\u5358\u306B\u3067\u304D\u307E\u3059</b>\u3002\u6700\u4E0A\u90E8\u306E\u7DE8\u96C6\u30E1\u30CB\u30E5\u30FC\u3092\u6A19\u6E96\u7684\u306A\u66F8\u5F0F\u8A2D\u5B9A\u306B\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002\u300C<b>/</b>\u300D\u3068\u5165\u529B\u3059\u308B\u3068\u591A\u6570\u306E\u4FBF\u5229\u306A\u7D71\u5408\u6A5F\u80FD\u3092\u7C21\u5358\u306B\u633F\u5165\u3067\u304D\u307E\u3059\u3002\u300C<c>/\u30C6\u30FC\u30D6\u30EB</c>\u300D\u3068\u5165\u529B\u3059\u308B\u3068\u30C6\u30FC\u30D6\u30EB\u3092\u3001\u300C<c>/\u753B\u50CF</c>\u300D\u3068\u5165\u529B\u3059\u308B\u3068\u753B\u50CF\u3092\u633F\u5165\u3067\u304D\u307E\u3059\u3002\u307E\u305F\u300C<c>/dropbox</c>\u300D\u3067 Dropbox \u306E\u30EA\u30F3\u30AF\u3092\u3001\u300C<c>/microsoft</c>\u300D\u3067 Microsoft Office \u30C4\u30FC\u30EB\u3092\u3001\u300C<c>/trello</c>\u300D\u3067 Trello \u306E\u30DC\u30FC\u30C9\u3084\u30AB\u30FC\u30C9\u3092\u633F\u5165\u3067\u304D\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u300C/\u300D\u306E\u5F8C\u306B\u300Ctable\u300D\u307E\u305F\u306F\u300Cimage\u300D\u3092\u5165\u529B",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u958B\u59CB\u3059\u308B\u306B\u3042\u305F\u308A\u5F79\u7ACB\u3064\u30D2\u30F3\u30C8\u3092\u3044\u304F\u3064\u304B\u7528\u610F\u3057\u307E\u3057\u305F\u3002",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u4FBF\u5229\u306A\u30EA\u30F3\u30AF",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Jira \u3068 Confluence \u3092\u4F75\u7528\u3059\u308B",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u5B9F\u969B\u306E Jira \u30C7\u30FC\u30BF\u3092\u4F7F\u7528\u3057\u3066\u30DA\u30FC\u30B8\u306B\u30C1\u30E3\u30FC\u30C8\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002\u300C<c>/Jira charts</c>\u300D\u3068\u5165\u529B\u3057\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u30DA\u30FC\u30B8\u4E0A\u306E\u4EFB\u610F\u306E\u5834\u6240\u306B Jira \u8AB2\u984C\u3092\u30EA\u30F3\u30AF\u3057\u307E\u3059\u3002\u30DA\u30FC\u30B8\u4E0A\u306E\u30EA\u30F3\u30AF\u306F\u3001Jira \u8AB2\u984C\u3092\u66F4\u65B0\u3059\u308B\u3068\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u300C<c>/Jira</c>\u300D\u3068\u5165\u529B\u3057\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Jira \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u3088\u3063\u3066\u3001\u30A4\u30F3\u30BF\u30E9\u30AF\u30C6\u30A3\u30D6\u306A\u30ED\u30FC\u30C9\u30DE\u30C3\u30D7\u3084\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u3092\u30DA\u30FC\u30B8\u306B\u57CB\u3081\u8FBC\u307F\u307E\u3059\u3002\u300C<c>/jira roadmap</c>\u300D\u3068\u5165\u529B\u3057\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Jira \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u3088\u3063\u3066\u3001\u30A4\u30F3\u30BF\u30E9\u30AF\u30C6\u30A3\u30D6\u306A\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u3092\u30DA\u30FC\u30B8\u306B\u57CB\u3081\u8FBC\u307F\u307E\u3059\u3002\u300C<c>/jira \u30BF\u30A4\u30E0\u30E9\u30A4\u30F3</c>\u300D\u3068\u5165\u529B\u3057\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "Jira Software \u3092\u3054\u5229\u7528\u306E\u304A\u5BA2\u69D8\u306E\u3046\u3061 76% \u304C\u3001Confluence \u3092\u8FFD\u52A0\u3057\u3066\u304B\u3089\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u30EA\u30EA\u30FC\u30B9\u304C\u65E9\u304F\u306A\u3063\u305F\u3068\u8A71\u3057\u3066\u3044\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "Jira \u3092\u3054\u5229\u7528\u306E\u304A\u5BA2\u69D8\u306E\u3046\u3061 76% \u304C\u3001Confluence \u3092\u8FFD\u52A0\u3057\u3066\u304B\u3089\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u30EA\u30EA\u30FC\u30B9\u304C\u65E9\u304F\u306A\u3063\u305F\u3068\u8A71\u3057\u3066\u3044\u307E\u3059",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\u30B9\u30DA\u30FC\u30B9\u3068\u30DA\u30FC\u30B8\u3092\u4F7F\u7528\u3057\u307E\u3059</b>\u3002\u30B9\u30DA\u30FC\u30B9\u306F\u3042\u3089\u3086\u308B Confluence \u30B5\u30A4\u30C8\u306E\u4E00\u90E8\u3067\u3042\u308A\u3001\u30DA\u30FC\u30B8\u3092\u30AB\u30C6\u30B4\u30EA\u306B\u6574\u7406\u3059\u308B\u65B9\u6CD5\u3067\u3082\u3042\u308A\u307E\u3059\u3002\u30B9\u30DA\u30FC\u30B9\u3092\u5225\u3005\u306E\u30D5\u30A9\u30EB\u30C0\u30FC\u307E\u305F\u306F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3068\u8003\u3048\u308B\u3068\u3001\u30DA\u30FC\u30B8\u306F\u305D\u306E\u30D5\u30A9\u30EB\u30C0\u30FC\u3084\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u5C5E\u3059\u308B\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3067\u3059\u3002<a>\u30B9\u30DA\u30FC\u30B9\u306E\u4F7F\u7528\u65B9\u6CD5\u306B\u95A2\u3059\u308B\u8A73\u7D30\u306B\u3064\u3044\u3066\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u4ECA\u3059\u3050\u8A66\u3059",
    'project-pages.improvement.templates.tutorial.description': "\u30DA\u30FC\u30B8\u306E\u7DE8\u96C6\u65B9\u6CD5\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
    'project-pages.improvement.templates.tutorial.name': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306B\u3088\u3046\u3053\u305D! ",
    'project-pages.improvement.terms-and-conditions-v2': "[\u4ECA\u3059\u3050\u8A66\u3059] \u3092\u9078\u629E\u3059\u308B\u3068\u3001Confluence \u3078\u306E\u767B\u9332\u3092\u627F\u8A8D\u3057\u3001Atlassian <termsLink>Cloud \u5229\u7528\u898F\u7D04</termsLink>\u304A\u3088\u3073<privacyLink>\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC \u30DD\u30EA\u30B7\u30FC</privacyLink>\u306B\u540C\u610F\u3057\u305F\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002",
    'project-pages.improvement.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u30DA\u30FC\u30B8\u3092\u4F5C\u6210",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Confluence \u304C\u8FFD\u52A0\u3055\u308C\u305F\u306E\u3067\u3001\u3059\u3079\u3066\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u4F5C\u6210\u3068\u30EA\u30F3\u30AF\u3092\u958B\u59CB\u3067\u304D\u307E\u3059\u3002\u6700\u5927 10 \u30E6\u30FC\u30B6\u30FC\u307E\u3067\u7121\u6599\u3067\u3059\u3002",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u8A73\u7D30",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u6700\u521D\u306E\u30DA\u30FC\u30B8\u3092\u4F5C\u6210",
    'project-pages.improvement.transient-states.empty-state.description': "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u8B70\u4E8B\u9332\u3001\u88FD\u54C1\u8981\u4EF6\u3001\u6C7A\u5B9A\u4E8B\u9805\u3084\u305D\u306E\u4ED6\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u3066\u3001\u3053\u306E\u30B9\u30DA\u30FC\u30B9\u3092\u57CB\u3081\u307E\u3057\u3087\u3046\u3002",
    'project-pages.improvement.transient-states.empty-state.title': "\u3053\u3053\u306B\u306F\u307E\u3060\u3001\u30DA\u30FC\u30B8\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    'project-pages.improvement.try-button': "Confluence \u3067\u3053\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u8A66\u3059",
    'project-pages.improvement.try-it-now': "\u4ECA\u3059\u3050\u8A66\u3059",
    'project-pages.improvement.try-lozenge': "\u8A66\u3059",
    'project-pages.improvement.try-on-demand-button': "\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB",
    'project-pages.page-deleted-flag.title': "\u30DA\u30FC\u30B8\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
    'project-pages.page-published-flag.title': "\u30DA\u30FC\u30B8\u304C\u516C\u958B\u3055\u308C\u307E\u3057\u305F\u3002",
    'project-pages.unknown-error.description': "\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3082\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{contactSupport}\u3002",
    'project-pages.unknown-error.heading': "\u73FE\u5728\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u8868\u793A\u3067\u304D\u307E\u305B\u3093",
    'projectpages.templatepreview.termsandprivacy': "[\u7121\u6599\u3067\u8A66\u3059] \u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001Atlassian <termsOfServiceLinkText>Cloud \u5229\u7528\u898F\u7D04</termsOfServiceLinkText>\u3068<privacyPolicyLinkText>\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC \u30DD\u30EA\u30B7\u30FC</privacyPolicyLinkText>\u306B\u540C\u610F\u3057\u305F\u3053\u3068\u306B\u306A\u308A\u3001Confluence \u306B\u767B\u9332\u3055\u308C\u307E\u3059\u3002"
};

});

parcelRegister("6PrDX", function(module, exports) {

$parcel$export(module.exports, "default", () => $29670a397cde34d3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $29670a397cde34d3$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\uC774 \uC791\uC5C5\uC740 1\uBD84 \uC774\uB0B4\uC5D0 \uC644\uB8CC\uB429\uB2C8\uB2E4",
    'confluence.project-pages.improvement.provisioning-background.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0 \uC124\uC815 \uC911",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\uD574\uC81C",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\uC644\uB8CC",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\uB2E4\uC74C",
    'project-pages.activating.description': "\uC5F0\uACB0\uB41C Confluence \uC2A4\uD398\uC774\uC2A4\uAC00 \uC544\uC9C1 \uC900\uBE44\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4. \uC0C8\uB85C \uACE0\uCCD0\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {contactSupport}.",
    'project-pages.activating.heading': "Confluence\uAC00 \uC544\uC9C1 \uB85C\uB4DC \uC911\uC785\uB2C8\uB2E4",
    'project-pages.button.connect-different-space-or-page.label': "\uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD398\uC774\uC9C0 \uC5C5\uB370\uC774\uD2B8 \uC544\uC774\uCF58",
    'project-pages.button.connect-different-space-or-page.tooltip': "\uB2E4\uB978 \uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD398\uC774\uC9C0 \uC5F0\uACB0",
    'project-pages.button.connect-space-or-page.tooltip': "Confluence\uC5D0 \uC5F0\uACB0",
    'project-pages.button.go-to-connected-page.tooltip': "Confluence\uC5D0\uC11C \uD398\uC774\uC9C0 \uC5F4\uAE30",
    'project-pages.button.go-to-connected-space.tooltip': "Confluence\uC5D0\uC11C \uC2A4\uD398\uC774\uC2A4 \uC5F4\uAE30",
    'project-pages.connect-space-dialog.connection-error': "\uC5F0\uACB0\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.connect-space-dialog.connection-retry': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\uD504\uB85C\uC81D\uD2B8\uC5D0 \uC5F0\uACB0\uD560 \uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD398\uC774\uC9C0\uB97C \uC120\uD0DD\uD558\uC138\uC694.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "Confluence \uAC80\uC0C9",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\uD398\uC774\uC9C0\uB97C \uB9CC\uB4E4\uB824\uBA74 \uBA3C\uC800 \uC774 \uD504\uB85C\uC81D\uD2B8\uB97C \uC2A4\uD398\uC774\uC2A4\uC5D0 \uC5F0\uACB0\uD574\uC57C \uD569\uB2C8\uB2E4. \uC774 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uC5F0\uACB0\uD560 \uC2A4\uD398\uC774\uC2A4\uB97C \uC120\uD0DD\uD558\uC138\uC694.",
    'project-pages.connect-space-dialog.error-icon': "\uC624\uB958:",
    'project-pages.connect-space-dialog.footer.cancel': "\uCDE8\uC18C",
    'project-pages.connect-space-dialog.footer.connect-space': "\uC5F0\uACB0",
    'project-pages.connect-space-or-page-dialog.header.title': "Confluence\uC5D0 \uD504\uB85C\uC81D\uD2B8 \uC5F0\uACB0",
    'project-pages.connect-space.description': "\uC2A4\uD398\uC774\uC2A4\uB294 \uD3F4\uB354\uCC98\uB7FC \uD504\uB85C\uC81D\uD2B8\uC640 \uAD00\uB828\uB41C \uBAA8\uB4E0 \uB0B4\uC6A9\uC744 \uB9CC\uB4E4\uACE0 \uC815\uB9AC\uD558\uACE0 \uACF5\uB3D9 \uC791\uC5C5\uD558\uB294 \uB370 \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    'project-pages.connect-space.not-connected.description': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uC0AC\uC6A9\uD558\uB824\uBA74 \uAD00\uB9AC\uC790\uB098 \uD300 \uB9AC\uB354\uC5D0\uAC8C \uBB38\uC758\uD558\uC5EC Confluence\uB97C \uC774 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uC5F0\uACB0\uD558\uC138\uC694.",
    'project-pages.connect-space.not-connected.heading': "Confluence\uC5D0 \uC5F0\uACB0\uB418\uC9C0 \uC54A\uC74C",
    'project-pages.connect-success-flag.description.content': "{connectedSpaceOrPageName}\uAC1C\uC758 \uCF58\uD150\uCE20\uC5D0 \uC5F0\uACB0\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.connection-error.space-or-page-not-found.button': "\uB2E4\uB978 \uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD398\uC774\uC9C0\uC5D0 \uC5F0\uACB0",
    'project-pages.create-space-dialog.connection-error': "\uC5F0\uACB0\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.create-space-dialog.connection-retry': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'project-pages.create-space-dialog.content.empty-name': "\uC2A4\uD398\uC774\uC2A4\uC758 \uC774\uB984\uC744 \uC9C0\uC815\uD558\uC138\uC694.",
    'project-pages.create-space-dialog.content.invalid-name': "\uC2A4\uD398\uC774\uC2A4 \uC774\uB984\uC5D0\uB294 \uD558\uB098 \uC774\uC0C1\uC758 \uBB38\uC790 \uB610\uB294 \uC22B\uC790\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4.",
    'project-pages.create-space-dialog.content.placeholder': "\uC2A4\uD398\uC774\uC2A4 \uC774\uB984 \uC785\uB825",
    'project-pages.create-space-dialog.creation-error': "\uC2A4\uD398\uC774\uC2A4\uB97C \uB9CC\uB4E4\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.create-space-dialog.error-icon': "\uC624\uB958:",
    'project-pages.create-space-dialog.footer.cancel': "\uCDE8\uC18C",
    'project-pages.create-space-dialog.footer.create-space': "\uB9CC\uB4E4\uAE30",
    'project-pages.create-space-dialog.header.title': "\uC0C8 Confluence \uC2A4\uD398\uC774\uC2A4 \uB9CC\uB4E4\uAE30",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\uAD00\uB9AC\uC790\uAC00 Confluence\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4 \uBD80\uC5EC\uB97C \uAC70\uBD80\uD588\uAE30 \uB54C\uBB38\uC5D0 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC561\uC138\uC2A4\uB97C \uC694\uCCAD\uD558\uB824\uBA74 \uC0AC\uC774\uD2B8 \uAD00\uB9AC\uC790\uC5D0\uAC8C \uBB38\uC758\uD558\uC138\uC694.",
    'project-pages.cross-join.access-revoked.templates.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uC0AC\uC6A9\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
    'project-pages.cross-join.avatar.view-profile': "\uD504\uB85C\uD544 \uBCF4\uAE30",
    'project-pages.cross-join.denied-request.templates.subtitle': "\uC0AC\uC774\uD2B8 \uAD00\uB9AC\uC790\uAC00 Confluence \uCC38\uC5EC\uC5D0 \uB300\uD55C \uC694\uCCAD\uC744 \uAC70\uBD80\uD588\uAE30 \uB54C\uBB38\uC5D0 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'project-pages.cross-join.denied-request.templates.title': "\uAD00\uB9AC\uC790\uAC00 \uC561\uC138\uC2A4 \uC694\uCCAD\uC744 \uAC70\uBD80\uD588\uC2B5\uB2C8\uB2E4",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Confluence\uC5D0 \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC0AC\uC774\uD2B8 \uAD00\uB9AC\uC790\uAC00 \uC774\uBBF8 \uC0AC\uC6A9\uC790\uB97C \uC2B9\uC778\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.cross-join.errors.unknown-error.description': "\uC0C8\uB85C \uACE0\uCCD0\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {contactSupport}.",
    'project-pages.cross-join.errors.unknown-error.title': "\uC9C0\uAE08\uC740 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'project-pages.cross-join.inline-join-product.button': "Confluence\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC5BB\uAC8C \uB429\uB2C8\uB2E4. \uC0AC\uC774\uD2B8 \uAD00\uB9AC\uC790\uAC00 \uC774\uBBF8 \uC0AC\uC6A9\uC790\uB97C \uC2B9\uC778\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.cross-join.inline-join-product.connected.description': "\uD55C\uACF3\uC5D0\uC11C \uC124\uBA85\uC11C\uB97C \uBCF4\uACE0, \uD3B8\uC9D1\uD558\uACE0, \uB9CC\uB4DC\uC138\uC694",
    'project-pages.cross-join.inline-join-product.connected.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uC5D0\uC11C \uD300\uACFC \uACF5\uB3D9 \uC791\uC5C5\uD558\uC138\uC694",
    'project-pages.cross-join.pending-request.templates.subtitle': "\uC0AC\uC774\uD2B8 \uAD00\uB9AC\uC790\uAC00 Confluence \uCC38\uC5EC \uC694\uCCAD\uC744 \uBC1B\uC558\uC2B5\uB2C8\uB2E4. \uCC38\uC5EC\uAC00 \uC2B9\uC778\uB41C \uACBD\uC6B0, \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0 \uC0AC\uC6A9\uC774 \uC2DC\uC791\uB418\uBA70 \uD655\uC778 \uC774\uBA54\uC77C\uC744 \uBCF4\uB0B4\uB4DC\uB9BD\uB2C8\uB2E4.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\uC2B9\uC778\uB418\uBA74 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uC5D0 \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uB294 \uC774\uBA54\uC77C\uC744 \uBC1B\uAC8C \uB429\uB2C8\uB2E4.",
    'project-pages.cross-join.pending-request.templates.title': "Confleunce\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4\uB97C \uC694\uCCAD\uD588\uC2B5\uB2C8\uB2E4",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\uAD00\uB9AC\uC790\uC5D0\uAC8C \uC561\uC138\uC2A4 \uC694\uCCAD\uC744 \uBCF4\uB0C4",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\uD300\uACFC \uD568\uAED8 \uD504\uB85C\uC81D\uD2B8 \uC124\uBA85\uC11C\uB97C \uBCF4\uACE0, \uD3B8\uC9D1\uD558\uACE0, \uB9CC\uB4DC\uC138\uC694",
    'project-pages.cross-join.request-access.button': "\uC561\uC138\uC2A4 \uC694\uCCAD",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "'\uD300\uC5D0 \uCC38\uAC00'\uB97C \uC120\uD0DD\uD558\uBA74 Confluence \uCC38\uAC00\uB97C \uC694\uCCAD\uD558\uACE0 Atlassian \uD504\uB85C\uD544\uC744 \uAD00\uB9AC\uC790\uC640 \uACF5\uC720\uD558\uB294 \uB370 \uB3D9\uC758\uD558\uAC8C \uB429\uB2C8\uB2E4.",
    'project-pages.cross-join.request-access.button.experimental': "\uD300\uC5D0 \uCC38\uAC00",
    'project-pages.cross-join.request-access.connected.description.experimental': "\uD300\uC774 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uC0AC\uC6A9\uD558\uC5EC Jira\uB97C \uB098\uAC00\uC9C0 \uC54A\uACE0\uB3C4 \uD504\uB85C\uC81D\uD2B8 \uC124\uBA85\uC11C\uC5D0 \uB313\uAE00\uC744 \uCD94\uAC00\uD558\uACE0 \uD504\uB85C\uC81D\uD2B8 \uC124\uBA85\uC11C\uB97C \uD3B8\uC9D1\uD558\uACE0 \uACF5\uB3D9 \uC791\uC5C5\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4. Confluence\uC5D0 \uCC38\uAC00\uD558\uC5EC \uD300\uC758 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uC5D0 \uC561\uC138\uC2A4\uD558\uC138\uC694.",
    'project-pages.cross-join.request-access.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uC5D0 Confluence \uC561\uC138\uC2A4 \uAD8C\uD55C \uD544\uC694",
    'project-pages.cross-join.request-access.title.experiment': "\uD300\uC744 \uC704\uD55C \uB2E8\uC77C \uC815\uBCF4 \uCD9C\uCC98 \uB9CC\uB4E4\uAE30",
    'project-pages.default-contextual-heading': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB294 Confluence\uC5D0\uC11C \uC81C\uACF5",
    'project-pages.default-contextual-message': "Confluence \uD398\uC774\uC9C0\uB85C \uBAA8\uB4E0 \uD504\uB85C\uC81D\uD2B8 \uBB38\uC11C\uB97C \uD55C\uACF3\uC5D0\uC11C \uB9CC\uB4E4\uACE0 \uACF5\uC720\uD558\uACE0 \uACF5\uB3D9 \uC791\uC5C5\uD558\uC138\uC694.",
    'project-pages.default-reactivate-CTA': "Confluence \uB2E4\uC2DC \uD65C\uC131\uD654",
    'project-pages.default-trial-CTA': "Confluence 30\uC77C \uD3C9\uAC00\uD310\uC744 \uC0AC\uC6A9\uD574\uBCF4\uC138\uC694.",
    'project-pages.draft-saved-flag.action': "\uCD08\uC548 \uC5F4\uAE30",
    'project-pages.draft-saved-flag.description': "\uCD08\uC548\uC740 \uAC8C\uC2DC\uD558\uAE30 \uC804\uAE4C\uC9C0 \uC790\uC2E0\uB9CC \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    'project-pages.draft-saved-flag.title': "\uCD08\uC548 \uC800\uC7A5\uB428",
    'project-pages.embedded-pages.create-page-error.close-button': "\uB2EB\uAE30",
    'project-pages.embedded-pages.create-page-error.description': "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD558\uC5EC \uD398\uC774\uC9C0\uB97C \uB9CC\uB4E4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'project-pages.embedded-pages.create-page-error.title': "\uD398\uC774\uC9C0\uB97C \uB9CC\uB4E4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'project-pages.embedded-pages.modal.close.button.hint': "\uB2EB\uAE30",
    'project-pages.embedded-pages.modal.title.button': "Confluence\uC5D0\uC11C \uC5F4\uAE30",
    'project-pages.embedded-pages.modal.title.button.hint': "\uC0C8 \uD0ED\uC5D0\uC11C \uC5F4\uAE30",
    'project-pages.errors.unknown-error.description.non-final': "\uC0C8\uB85C \uACE0\uCCD0\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {contactSupport}.",
    'project-pages.errors.unknown-error.title.non-final': "\uC9C0\uAE08\uC740 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'project-pages.generic-error.button.reload': "\uD398\uC774\uC9C0 \uB2E4\uC2DC \uB85C\uB4DC",
    'project-pages.generic-error.description': "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
    'project-pages.generic-error.description.non-final': "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
    'project-pages.generic-error.heading': "\uC8C4\uC1A1\uD569\uB2C8\uB2E4.",
    'project-pages.generic-error.title.non-final': "\uC8C4\uC1A1\uD569\uB2C8\uB2E4.",
    'project-pages.generic-info-flag.description': "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uBB38\uC81C\uAC00 \uC9C0\uC18D\uB418\uBA74 \uC9C0\uC6D0 \uD300\uC5D0 \uBB38\uC758\uD558\uC138\uC694",
    'project-pages.generic-success-flag.description.page': "{connectedSpaceOrPageName} \uD398\uC774\uC9C0\uC5D0 \uC5F0\uACB0\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
    'project-pages.generic-success-flag.description.space': "{connectedSpaceOrPageName} \uC2A4\uD398\uC774\uC2A4\uC5D0 \uC5F0\uACB0\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
    'project-pages.generic-success-flag.heading.page': "\uD398\uC774\uC9C0 \uC5F0\uACB0\uB428",
    'project-pages.generic-success-flag.heading.space': "\uC2A4\uD398\uC774\uC2A4\uC5D0 \uC5F0\uACB0\uB428",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\uB610\uB294 \uC0C8 \uC2A4\uD398\uC774\uC2A4 \uB9CC\uB4E4\uAE30",
    'project-pages.granular-pages.connect-space.button': "Confluence\uC5D0 \uC5F0\uACB0",
    'project-pages.granular-pages.connect-space.heading': "\uC774 \uD504\uB85C\uC81D\uD2B8\uB97C Confluence \uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD398\uC774\uC9C0\uC5D0 \uC5F0\uACB0",
    'project-pages.granular-pages.connect-space.heading.non-final': "\uC774 \uD504\uB85C\uC81D\uD2B8\uB97C Confluence \uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD398\uC774\uC9C0\uC5D0 \uC5F0\uACB0",
    'project-pages.improvement.contact-support': "\uC9C0\uC6D0\uD300\uC5D0 \uBB38\uC758",
    'project-pages.improvement.errors.access-error.description': "\uC0AC\uC774\uD2B8 \uAD00\uB9AC\uC790\uC5D0\uAC8C \uBB38\uC758\uD558\uC5EC \uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC694\uCCAD\uD558\uC138\uC694.",
    'project-pages.improvement.errors.access-error.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uBCFC \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\uC5F0\uACB0\uB41C Confluence \uC2A4\uD398\uC774\uC2A4\uC5D0 \uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD558\uB824\uB294 \uC911\uC5D0 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uC0C8\uB85C \uACE0\uCCD0\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {contactSupport}.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD558\uB294 \uB3D9\uC548 \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\uC5F0\uACB0\uD588\uB358 Confluence \uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD398\uC774\uC9C0\uAC00 \uC774\uB3D9, \uBCF4\uAD00 \uB610\uB294 \uC0AD\uC81C\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC5F0\uACB0\uD574\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 <link>\uC9C0\uC6D0 \uD300\uC5D0 \uBB38\uC758</link>\uD558\uC138\uC694",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD398\uC774\uC9C0\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC74C",
    'project-pages.improvement.errors.unknown-error.description': "\uC0C8\uB85C \uACE0\uCCD0\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {contactSupport}.",
    'project-pages.improvement.errors.unknown-error.title': "\uC9C0\uAE08\uC740 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'project-pages.improvement.feature1': "Jira\uC5D0\uC11C \uB098\uAC00\uC9C0 \uC54A\uACE0 \uBB38\uC11C\uC5D0 \uC561\uC138\uC2A4 \uBC0F \uBB38\uC11C \uB9CC\uB4E4\uAE30",
    'project-pages.improvement.feature2': "\uBBF8\uD305, \uC2A4\uD504\uB9B0\uD2B8 \uACC4\uD68D \uB4F1\uC744 \uC704\uD55C \uD15C\uD50C\uB9BF",
    'project-pages.improvement.feature3': "\uC790\uB3D9 \uC5C5\uB370\uC774\uD2B8\uB97C \uC704\uD574 Jira\uC5D0 \uBB38\uC11C\uB97C \uB3D9\uAE30\uD654",
    'project-pages.improvement.heading-info': "\uD300\uC758 \uC9C0\uC2DD\uC744 \uCEA1\uCC98\uD558\uACE0 \uC77C\uD558\uB294 \uBC29\uC2DD\uC744 \uAC1C\uC120\uD558\uC138\uC694.",
    'project-pages.improvement.heading-info-v2': "\uD300\uC758 \uBAA8\uB4E0 \uD504\uB85C\uC81D\uD2B8 \uBB38\uC11C\uB97C \uC704\uD55C \uD558\uB098\uC758 \uACF5\uAC04\uC744 \uB9CC\uB4DC\uC138\uC694",
    'project-pages.improvement.learn-more-button': "\uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30",
    'project-pages.improvement.powered-by': "\uC81C\uACF5:",
    'project-pages.improvement.powered-by.tooltip': "\uC0C8 \uD0ED\uC5D0\uC11C Confluence \uC5F4\uAE30",
    'project-pages.improvement.preview-teaser': "\uD15C\uD50C\uB9BF, \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0 \uB4F1\uC744 \uC7A0\uAE08 \uD574\uC81C\uD558\uC138\uC694.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\uC790\uB3D9 \uC5C5\uB370\uC774\uD2B8\uB418\uB294 \uC0C1\uD0DC \uB808\uC774\uBE14\uB85C \uD504\uB85C\uC81D\uD2B8 \uBCF4\uACE0\uC11C\uB97C \uCD5C\uC2E0 \uC0C1\uD0DC\uB85C \uC720\uC9C0\uD558\uC138\uC694.</p> <p>\uBB38\uC11C\uC5D0 Jira \uD2F0\uCF13\uC744 \uC5F0\uACB0\uD558\uAE30\uB9CC \uD558\uBA74 \uD2F0\uCF13\uACFC \uB3D9\uAE30\uD654\uD558\uC5EC \uC5C5\uB370\uC774\uD2B8\uB418\uB294 \uC0C1\uD0DC \uB808\uC774\uBE14\uC774 \uC790\uB3D9\uC73C\uB85C \uD45C\uC2DC\uB418\uBBC0\uB85C \uC218\uB3D9\uC73C\uB85C \uBCF4\uACE0\uC11C\uB97C \uB9CC\uB4DC\uB294 \uB370 \uC2DC\uAC04\uC744 \uB4E4\uC77C \uD544\uC694\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\uC774\uD574 \uAD00\uACC4\uC790\uC5D0\uAC8C \uC6D0\uD65C\uD558\uAC8C \uC5C5\uB370\uC774\uD2B8",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\uAE30\uBCF8 \uC81C\uACF5\uB418\uB294 \uD15C\uD50C\uB9BF\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC77C\uAD00\uC131 \uC788\uB294 \uBB38\uC11C\uB97C \uB9CC\uB4DC\uC138\uC694. \uC0AC\uC6A9\uD558\uAE30 \uC27D\uACE0 \uD544\uC694\uC5D0 \uB530\uB77C \uC0AC\uC6A9\uC790 \uC9C0\uC815\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.</p> <p>\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uC5D0\uC11C \uBC14\uB85C \uD15C\uD50C\uB9BF\uC744 \uC0AC\uC6A9\uD560 \uC218 \uC788\uC73C\uBBC0\uB85C \uD604\uC7AC \uC791\uC5C5\uC744 \uC885\uB8CC\uD560 \uD544\uC694\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. <a>\uC5EC\uAE30</a>\uC5D0\uC11C \uBAA8\uB4E0 \uD15C\uD50C\uB9BF\uC744 \uCC3E\uC544\uBCF4\uC138\uC694.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\uBB38\uC11C\uD654 \uD45C\uC900 \uD1B5\uD569",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Jira\uC758 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0 \uD0ED\uC5D0\uC11C \uC124\uBA85\uC11C\uB97C \uB9CC\uB4E4\uACE0 \uAD00\uB9AC\uD558\uC5EC \uC911\uC694\uD55C \uC815\uBCF4\uC5D0 \uB300\uD55C \uB2E8\uC77C \uC815\uBCF4 \uCD9C\uCC98\uB97C \uB9CC\uB4DC\uC138\uC694.</p> <p>\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uAC00 Confluence\uC5D0\uC11C \uC2E4\uD589\uB41C\uB2E4\uB294 \uC0AC\uC2E4\uC744 \uC54C\uACE0 \uACC4\uC168\uC2B5\uB2C8\uAE4C? \uCD5C\uB300 10\uBA85\uC758 \uC0AC\uC6A9\uC790\uAE4C\uC9C0 \uBB34\uB8CC\uC785\uB2C8\uB2E4. \uAD00\uB9AC\uC790 \uC124\uC815\uC5D0\uC11C \uB2E4\uB978 \uD300\uC6D0\uC744 \uCD08\uB300\uD558\uC138\uC694.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C Jira\uC5D0\uC11C \uBC14\uB85C \uD655\uC778",
    'project-pages.improvement.templates.blank-page.description': "\uCC98\uC74C\uBD80\uD130 \uD398\uC774\uC9C0\uB97C \uC2DC\uC791\uD558\uC138\uC694.",
    'project-pages.improvement.templates.blank-page.name': "\uBE48 \uD398\uC774\uC9C0",
    'project-pages.improvement.templates.decision.description': "\uC911\uC694\uD55C \uD504\uB85C\uC81D\uD2B8 \uACB0\uC815\uC744 \uAE30\uB85D\uD558\uACE0 \uAE30\uB85D\uD55C \uB0B4\uC6A9\uC744 \uD300\uC5D0 \uC804\uB2EC\uD558\uC138\uC694.",
    'project-pages.improvement.templates.decision.name': "\uACB0\uC815",
    'project-pages.improvement.templates.meeting-notes.description': "\uD68C\uC758 \uC5B4\uC820\uB354\uB97C \uC815\uD558\uACE0 \uBA54\uBAA8\uD558\uACE0 \uD300\uC5D0\uAC8C \uC791\uC5C5 \uD56D\uBAA9\uC744 \uACF5\uC720\uD558\uC138\uC694.",
    'project-pages.improvement.templates.meeting-notes.name': "\uBBF8\uD305 \uBA54\uBAA8",
    'project-pages.improvement.templates.post-expand.more': "\uB354 \uB9CE\uC740 \uD15C\uD50C\uB9BF",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Confluence\uC5D0\uC11C \uBAA8\uB4E0 \uD15C\uD50C\uB9BF \uBCF4\uAE30",
    'project-pages.improvement.templates.post-expand.subtitle': "\uC778\uAE30 \uD15C\uD50C\uB9BF",
    'project-pages.improvement.templates.post-expand.title': "\uD398\uC774\uC9C0 \uB9CC\uB4E4\uAE30",
    'project-pages.improvement.templates.pre-expand.more': "\uB354 \uB9CE\uC740 \uD15C\uD50C\uB9BF \uD0D0\uC0C9",
    'project-pages.improvement.templates.pre-expand.subtitle': "\uB098\uC758 \uD300\uACFC \uBE44\uC2B7\uD55C \uD300\uC5D0\uC11C \uC778\uAE30",
    'project-pages.improvement.templates.pre-expand.title': "\uD15C\uD50C\uB9BF \uBBF8\uB9AC\uBCF4\uAE30",
    'project-pages.improvement.templates.product-requirements.description': "\uC81C\uD488 \uB610\uB294 \uAE30\uB2A5\uC5D0 \uB300\uD55C \uC694\uAD6C \uC0AC\uD56D\uC744 \uC815\uC758\uD558\uACE0 \uCD94\uC801\uD558\uACE0 \uBC94\uC704\uB97C \uC9C0\uC815\uD569\uB2C8\uB2E4.",
    'project-pages.improvement.templates.product-requirements.name': "\uC81C\uD488 \uC694\uAD6C\uC0AC\uD56D",
    'project-pages.improvement.templates.retrospective.description': "\uC88B\uC558\uB358 \uC810\uC740 \uBB34\uC5C7\uC785\uB2C8\uAE4C? \uAC1C\uC120\uD560 \uC810\uC740 \uBB34\uC5C7\uC785\uB2C8\uAE4C? \uD300\uACFC \uD568\uAED8 \uAC1C\uC120 \uC0AC\uD56D\uC744 \uD06C\uB77C\uC6B0\uB4DC\uC18C\uC2F1",
    'project-pages.improvement.templates.retrospective.name': "\uD68C\uACE0\uB85D",
    'project-pages.improvement.templates.template.disabled-tooltip': "\uC6B0\uC120 Confluence \uC2A4\uD398\uC774\uC2A4\uC5D0 \uC5F0\uACB0\uD558\uC138\uC694",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\uC2DC\uAC04\uC744 \uC808\uC57D\uD558\uACE0 \uC218\uB3D9 \uC791\uC5C5\uC744 \uC904\uC774\uC138\uC694</b>. Confluence\uC5D0\uB294 \uC644\uC804\uD788 \uCC98\uC74C\uBD80\uD130 \uC2DC\uC791\uD560 \uD544\uC694\uAC00 \uC5C6\uB3C4\uB85D \uB2E4\uC591\uD55C \uD398\uC774\uC9C0 <a>\uD15C\uD50C\uB9BF</a>\uC774 \uC788\uC2B5\uB2C8\uB2E4. \uAE30\uC220 \uBB38\uC11C, \uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC, \uD504\uB85C\uC81D\uD2B8 \uACC4\uD68D, \uC81C\uD488 \uC694\uAD6C \uC0AC\uD56D \uB4F1\uC5D0 \uB300\uD574 \uC0DD\uAC01\uD574 \uBCF4\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\uD3B8\uC9D1\uACFC \uC11C\uC2DD \uC9C0\uC815\uC774 \uC27D\uC2B5\uB2C8\uB2E4.</b> \uC77C\uBC18\uC801\uC778 \uB2E8\uC5B4 \uC11C\uC2DD \uC9C0\uC815\uC740 \uC0C1\uB2E8 \uD3B8\uC9D1 \uBA54\uB274\uB97C \uC0AC\uC6A9\uD558\uACE0 <b>/</b>\uB97C \uC785\uB825\uD558\uBA74 \uD3B8\uB9AC\uD55C \uC5EC\uB7EC \uD1B5\uD569 \uAE30\uB2A5\uC744 \uC27D\uAC8C \uC0BD\uC785\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. <c>/\uD45C</c>\uB97C \uC785\uB825\uD558\uC5EC \uD45C\uB97C \uC0BD\uC785\uD558\uAC70\uB098 <c>/\uC774\uBBF8\uC9C0</c>\uB97C \uC785\uB825\uD558\uC5EC \uC774\uBBF8\uC9C0\uB97C \uC0BD\uC785\uD558\uC138\uC694. <c>/dropbox</c>\uB85C Dropbox \uB9C1\uD06C\uB97C, <c>/microsoft</c>\uB85C Microsoft office \uB3C4\uAD6C\uB97C \uB610\uB294 <c>/trello</c>\uB85C Trello \uBCF4\uB4DC \uBC0F \uCE74\uB4DC\uB97C \uC0BD\uC785\uD560 \uC218\uB3C4 \uC788\uC2B5\uB2C8\uB2E4.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "/ \uB4A4\uC5D0 '\uD45C' \uB610\uB294 '\uC774\uBBF8\uC9C0'\uB97C \uC785\uB825\uD558\uC138\uC694",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\uC2DC\uC791\uD558\uAE30 \uC704\uD55C \uBA87 \uAC00\uC9C0 \uD301\uC740 \uB2E4\uC74C\uACFC \uAC19\uC2B5\uB2C8\uB2E4.",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\uD3B8\uB9AC\uD55C \uB9C1\uD06C",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Jira \uBC0F Confluence \uD568\uAED8 \uC0AC\uC6A9\uD558\uAE30",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\uC2E4\uC81C Jira \uB370\uC774\uD130\uB97C \uC0AC\uC6A9\uD558\uC5EC \uD398\uC774\uC9C0\uC5D0 \uCC28\uD2B8\uB97C \uB9CC\uB4DC\uC138\uC694. <c>/Jira \uCC28\uD2B8</c>\uB97C \uC785\uB825\uD558\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Jira \uC774\uC288\uB97C \uD398\uC774\uC9C0\uC758 \uC6D0\uD558\uB294 \uC704\uCE58\uC5D0 \uC5F0\uACB0\uD558\uC138\uC694. Jira \uC774\uC288\uB97C \uC5C5\uB370\uC774\uD2B8\uD558\uBA74 \uD398\uC774\uC9C0\uC758 \uB9C1\uD06C\uAC00 \uC2E4\uC2DC\uAC04\uC73C\uB85C \uC5C5\uB370\uC774\uD2B8\uB429\uB2C8\uB2E4. <c>/Jira</c>\uB97C \uC785\uB825\uD558\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Jira \uD504\uB85C\uC81D\uD2B8\uB97C \uC0AC\uC6A9\uD558\uC5EC \uD398\uC774\uC9C0\uC5D0 \uB300\uD654\uD615 \uB85C\uB4DC\uB9F5\uACFC \uD0C0\uC784\uB77C\uC778\uC744 \uD3EC\uD568\uD558\uC138\uC694. <c>/Jira \uB85C\uB4DC\uB9F5</c>\uC744 \uC785\uB825\uD558\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Jira \uD504\uB85C\uC81D\uD2B8\uB97C \uC0AC\uC6A9\uD558\uC5EC \uD398\uC774\uC9C0\uC5D0 \uB300\uD654\uD615 \uD0C0\uC784\uB77C\uC778\uC744 \uD3EC\uD568\uD558\uC138\uC694. <c>/jira \uD0C0\uC784\uB77C\uC778</c>\uC744 \uC785\uB825\uD558\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "Jira Software \uACE0\uAC1D\uC758 76%\uAC00 Confluence\uB97C \uCD94\uAC00\uD55C \uD6C4 \uD504\uB85C\uC81D\uD2B8 \uCD9C\uC2DC \uAE30\uAC04\uC774 \uB2E8\uCD95\uB418\uC5C8\uB2E4\uACE0 \uC751\uB2F5\uD588\uC2B5\uB2C8\uB2E4",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "Jira \uACE0\uAC1D\uC758 76%\uAC00 Confluence\uB97C \uCD94\uAC00\uD55C \uD6C4 \uD504\uB85C\uC81D\uD2B8 \uC81C\uACF5 \uAE30\uAC04\uC774 \uB2E8\uCD95\uB418\uC5C8\uB2E4\uACE0 \uC751\uB2F5\uD588\uC2B5\uB2C8\uB2E4",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\uC2A4\uD398\uC774\uC2A4 \uBC0F \uD398\uC774\uC9C0 \uC0AC\uC6A9\uD558\uAE30</b>. \uC2A4\uD398\uC774\uC2A4\uB294 \uBAA8\uB4E0 Confluence \uC0AC\uC774\uD2B8\uC5D0 \uC18D\uD574 \uC788\uC73C\uBA70 \uD398\uC774\uC9C0\uB97C \uBC94\uC8FC\uBCC4\uB85C \uCCB4\uACC4\uD654\uD558\uB294 \uBC29\uBC95\uC785\uB2C8\uB2E4. \uC2A4\uD398\uC774\uC2A4\uB294 \uC5EC\uB7EC \uD3F4\uB354 \uB610\uB294 \uD504\uB85C\uC81D\uD2B8\uC774\uBA70 \uD398\uC774\uC9C0\uB294 \uADF8 \uD3F4\uB354 \uB610\uB294 \uD504\uB85C\uC81D\uD2B8 \uC548\uC758 \uBB38\uC11C\uB77C\uACE0 \uC0DD\uAC01\uD558\uC138\uC694. <a>\uC2A4\uD398\uC774\uC2A4 \uC0AC\uC6A9 \uBC29\uBC95 \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\uC9C0\uAE08 \uC0AC\uC6A9\uD574\uBCF4\uAE30",
    'project-pages.improvement.templates.tutorial.description': "\uD398\uC774\uC9C0\uB97C \uD3B8\uC9D1\uD558\uB294 \uBC29\uBC95\uC744 \uC54C\uC544\uBCF4\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.name': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uC5D0 \uC624\uC2E0 \uAC83\uC744 \uD658\uC601\uD569\uB2C8\uB2E4!",
    'project-pages.improvement.terms-and-conditions-v2': "&quot;\uC9C0\uAE08 \uC0AC\uC6A9\uD574 \uBCF4\uAE30&quot;\uB97C \uC120\uD0DD\uD558\uBA74 Confluence\uC5D0 \uB4F1\uB85D\uD55C\uB2E4\uB294 \uAC83\uC744 \uD655\uC778\uD558\uACE0 Atlassian <termsLink>Cloud \uC11C\uBE44\uC2A4 \uC57D\uAD00</termsLink> \uBC0F <privacyLink>\uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uC815\uCC45</privacyLink>\uC5D0 \uB3D9\uC758\uD558\uAC8C \uB429\uB2C8\uB2E4.",
    'project-pages.improvement.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\uD398\uC774\uC9C0 \uB9CC\uB4E4\uAE30",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\uBAA8\uB4E0 \uD504\uB85C\uC81D\uD2B8 \uBB38\uC11C\uB97C \uB9CC\uB4E4\uACE0 \uC5F0\uACB0\uD560 \uC218 \uC788\uB3C4\uB85D Confluence\uB97C \uCD94\uAC00\uD588\uC2B5\uB2C8\uB2E4. \uCD5C\uB300 10\uBA85\uC758 \uC0AC\uC6A9\uC790\uAE4C\uC9C0 \uBB34\uB8CC\uC785\uB2C8\uB2E4.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\uCCAB \uD398\uC774\uC9C0 \uB9CC\uB4E4\uAE30",
    'project-pages.improvement.transient-states.empty-state.description': "\uBBF8\uD305 \uBA54\uBAA8, \uC81C\uD488 \uC694\uAD6C \uC0AC\uD56D, \uACB0\uC815 \uC0AC\uD56D \uB610\uB294 \uAE30\uD0C0 \uCF58\uD150\uCE20\uB97C \uB9CC\uB4E4\uC5B4 \uC774 \uC2A4\uD398\uC774\uC2A4\uB97C \uCC44\uC6CC\uBCF4\uC138\uC694.",
    'project-pages.improvement.transient-states.empty-state.title': "\uC774\uACF3\uC740 \uC7A0\uC7AC\uB825\uC73C\uB85C \uAC00\uB4DD\uD569\uB2C8\uB2E4.",
    'project-pages.improvement.try-button': "Confluence\uC5D0\uC11C \uC774 \uD15C\uD50C\uB9BF \uC0AC\uC6A9\uD574 \uBCF4\uAE30",
    'project-pages.improvement.try-it-now': "\uC9C0\uAE08 \uC0AC\uC6A9\uD574 \uBCF4\uAE30",
    'project-pages.improvement.try-lozenge': "\uC0AC\uC6A9\uD574 \uBCF4\uAE30",
    'project-pages.improvement.try-on-demand-button': "\uBB34\uB8CC\uB85C \uC0AC\uC6A9\uD574 \uBCF4\uAE30",
    'project-pages.page-deleted-flag.title': "\uD398\uC774\uC9C0\uB97C \uC0AD\uC81C\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.page-published-flag.title': "\uD398\uC774\uC9C0\uB97C \uAC8C\uC2DC\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.unknown-error.description': "\uC0C8\uB85C \uACE0\uCCD0\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {contactSupport}.",
    'project-pages.unknown-error.heading': "\uC9C0\uAE08\uC740 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'projectpages.templatepreview.termsandprivacy': "&quot;\uBB34\uB8CC\uB85C \uC0AC\uC6A9\uD574 \uBCF4\uAE30&quot;\uB97C \uD074\uB9AD\uD558\uBA74 Confluence\uC5D0 \uB4F1\uB85D\uD558\uACE0 Atlassian <termsOfServiceLinkText>Cloud \uC11C\uBE44\uC2A4 \uC57D\uAD00</termsOfServiceLinkText> \uBC0F <privacyPolicyLinkText>\uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uC815\uCC45</privacyPolicyLinkText>\uC5D0 \uB3D9\uC758\uD558\uAC8C \uB429\uB2C8\uB2E4."
};

});

parcelRegister("gB4DF", function(module, exports) {

$parcel$export(module.exports, "default", () => $39ffbc308de3b4e9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $39ffbc308de3b4e9$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Dette b\xf8r ta mindre enn ett minutt",
    'confluence.project-pages.improvement.provisioning-background.title': 'Konfigurerer prosjektsidene dine',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Avvis',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Ferdig',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Neste',
    'project-pages.activating.description': "Det tilkoblede Confluence-omr\xe5det er ikke helt klart enn\xe5. {contactSupport} hvis det ikke hjelper \xe5 oppdatere.",
    'project-pages.activating.heading': 'Confluence lastes fortsatt',
    'project-pages.button.connect-different-space-or-page.label': "Oppdater omr\xe5de- eller sideikon",
    'project-pages.button.connect-different-space-or-page.tooltip': "Koble til et annet omr\xe5de eller en annen side",
    'project-pages.button.connect-space-or-page.tooltip': 'Koble til Confluence',
    'project-pages.button.go-to-connected-page.tooltip': "\xc5pne siden i Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "\xc5pne omr\xe5det i Confluence",
    'project-pages.connect-space-dialog.connection-error': 'Tilkobling mislykket.',
    'project-pages.connect-space-dialog.connection-retry': "Pr\xf8v igjen",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Velg et omr\xe5de eller en side du vil koble til prosjektet.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "S\xf8k gjennom Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Dette prosjektet m\xe5 kobles til et omr\xe5de f\xf8r du kan opprette en side. Velg et omr\xe5de som dette prosjektet skal kobles til.",
    'project-pages.connect-space-dialog.error-icon': 'Feil:',
    'project-pages.connect-space-dialog.footer.cancel': 'Avbryt',
    'project-pages.connect-space-dialog.footer.connect-space': 'Koble til',
    'project-pages.connect-space-or-page-dialog.header.title': 'Koble prosjektet til Confluence',
    'project-pages.connect-space.description': "Omr\xe5der er som mapper \u2013 du kan bruke dem til \xe5 opprette, organisere og samarbeide p\xe5 alt innhold relatert til prosjektet.",
    'project-pages.connect-space.not-connected.description': "Hvis du vil bruke prosjektsider, kontakter du administratoren eller teamlederen din for \xe5 koble Confluence til dette prosjektet.",
    'project-pages.connect-space.not-connected.heading': 'Ikke koblet til Confluence',
    'project-pages.connect-success-flag.description.content': 'Du er koblet til {connectedSpaceOrPageName}-innholdet.',
    'project-pages.connection-error.space-or-page-not-found.button': "Koble til et annet omr\xe5de eller en annen side",
    'project-pages.create-space-dialog.connection-error': 'Tilkobling mislykket.',
    'project-pages.create-space-dialog.connection-retry': "Pr\xf8v igjen",
    'project-pages.create-space-dialog.content.empty-name': "Angi et navn p\xe5 omr\xe5det.",
    'project-pages.create-space-dialog.content.invalid-name': "Omr\xe5denavn m\xe5 best\xe5 av minst ett tall eller en bokstav.",
    'project-pages.create-space-dialog.content.placeholder': "Oppgi et omr\xe5denavn",
    'project-pages.create-space-dialog.creation-error': "Kunne ikke opprette omr\xe5de.",
    'project-pages.create-space-dialog.error-icon': 'Feil:',
    'project-pages.create-space-dialog.footer.cancel': 'Avbryt',
    'project-pages.create-space-dialog.footer.create-space': 'Opprett',
    'project-pages.create-space-dialog.header.title': "Opprett nytt Confluence-omr\xe5de",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Du kan ikke bruke prosjektsider fordi administratoren har nektet deg tilgang til Confluence. Kontakt nettstedsadministratoren for \xe5 be om tilgang.",
    'project-pages.cross-join.access-revoked.templates.title': "Du har ikke tillatelse til \xe5 bruke prosjektsider",
    'project-pages.cross-join.avatar.view-profile': 'Se profil',
    'project-pages.cross-join.denied-request.templates.subtitle': "Du kan ikke bruke prosjektsider fordi nettstedsadministratoren avviste foresp\xf8rselen din om \xe5 bli med Confluence.",
    'project-pages.cross-join.denied-request.templates.title': 'Administratoren har nektet deg tilgang',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Du f\xe5r tilgang til Confluence. Nettstedsadministratoren har allerede godkjent deg.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} hvis det ikke hjelper \xe5 oppdatere siden.",
    'project-pages.cross-join.errors.unknown-error.title': "Vi kan ikke vise prosjektsider akkurat n\xe5",
    'project-pages.cross-join.inline-join-product.button': "Du f\xe5r tilgang til Confluence. Nettstedsadministratoren har allerede godkjent deg.",
    'project-pages.cross-join.inline-join-product.connected.description': 'Vis, rediger og opprett dokumentasjon fra ett sted',
    'project-pages.cross-join.inline-join-product.connected.title': "Samarbeid p\xe5 prosjektsider med teamet ditt",
    'project-pages.cross-join.pending-request.templates.subtitle': "Nettstedsadministratoren har mottatt foresp\xf8rselen din om \xe5 bli med i Confluence. Hvis du blir godkjent for \xe5 bli med, vil prosjektsidene begynne \xe5 fungere, og vi sender deg en e-postbekreftelse.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Du f\xe5r en e-post med tilgang til Prosjektsider n\xe5r du er godkjent.",
    'project-pages.cross-join.pending-request.templates.title': 'Du har bedt om tilgang til Confluence',
    'project-pages.cross-join.pending-request.templates.title.experiment': "Tilgangsforesp\xf8rselen ble sendt til administratoren",
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'Se, rediger og opprett prosjektdokumentasjon med teamet ditt',
    'project-pages.cross-join.request-access.button': 'Be om tilgang',
    'project-pages.cross-join.request-access.button-subtitle.experimental': "N\xe5r du velger \xabBli med i teamet ditt\xbb, ber du om \xe5 bli med i Confluence og godtar \xe5 dele Atlassian-profilen din med administratoren din.",
    'project-pages.cross-join.request-access.button.experimental': 'Bli med i teamet ditt',
    'project-pages.cross-join.request-access.connected.description.experimental': "Teamet ditt bruker Prosjektsider til \xe5 kommentere, redigere og samarbeide om prosjektdokumentasjon uten \xe5 forlate Jira. Bli med i Confluence for \xe5 f\xe5 tilgang til teamets prosjektsider.",
    'project-pages.cross-join.request-access.title': 'Prosjektsider krever tilgang til Confluence',
    'project-pages.cross-join.request-access.title.experiment': "Opprett \xe9n enkelt informasjonskilde for teamet ditt",
    'project-pages.default-contextual-heading': 'Prosjektsider er drevet av Confluence',
    'project-pages.default-contextual-message': "Opprett, del og samarbeid p\xe5 alle prosjektdokumenter p\xe5 ett sted med Confluence-sider.",
    'project-pages.default-reactivate-CTA': "Aktiver Confluence p\xe5 nytt",
    'project-pages.default-trial-CTA': "Pr\xf8v Confluence gratis i 30 dager",
    'project-pages.draft-saved-flag.action': "\xc5pne utkast",
    'project-pages.draft-saved-flag.description': 'Utkastet ditt er bare synlig for deg, frem til du publiserer det.',
    'project-pages.draft-saved-flag.title': 'Utkastet er lagret',
    'project-pages.embedded-pages.create-page-error.close-button': 'Lukk',
    'project-pages.embedded-pages.create-page-error.description': 'Det oppstod et problem, og vi kan ikke opprette en side for deg.',
    'project-pages.embedded-pages.create-page-error.title': 'Vi kan ikke opprette en side',
    'project-pages.embedded-pages.create-page-error.try-again-button': "Pr\xf8v p\xe5 nytt",
    'project-pages.embedded-pages.modal.close.button.hint': 'Lukk',
    'project-pages.embedded-pages.modal.title.button': "\xc5pne i Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "\xc5pne i en ny fane",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} hvis det ikke hjelper \xe5 oppdatere siden.",
    'project-pages.errors.unknown-error.title.non-final': "Vi kan ikke vise prosjektsider akkurat n\xe5",
    'project-pages.generic-error.button.reload': 'Oppdater siden',
    'project-pages.generic-error.description': "Det oppstod en feil. Pr\xf8v igjen senere.",
    'project-pages.generic-error.description.non-final': "Det oppstod en feil. Pr\xf8v igjen senere.",
    'project-pages.generic-error.heading': "Vel, dette er pinlig \u2026",
    'project-pages.generic-error.title.non-final': "Vel, dette er pinlig\xa0\u2026",
    'project-pages.generic-info-flag.description': "Noe gikk galt. Pr\xf8v p\xe5 nytt, eller kontakt st\xf8tte hvis problemet vedvarer",
    'project-pages.generic-success-flag.description.page': 'Du er koblet til {connectedSpaceOrPageName}-siden.',
    'project-pages.generic-success-flag.description.space': "Du er koblet til omr\xe5det {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.heading.page': 'Siden er tilkoblet',
    'project-pages.generic-success-flag.heading.space': "Omr\xe5det er tilkoblet",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Eller opprett et nytt omr\xe5de",
    'project-pages.granular-pages.connect-space.button': 'Koble til Confluence',
    'project-pages.granular-pages.connect-space.heading': "Koble dette prosjektet til et Confluence-omr\xe5de eller -side",
    'project-pages.granular-pages.connect-space.heading.non-final': "Koble dette prosjektet til et Confluence-omr\xe5de eller -side",
    'project-pages.improvement.contact-support': "Kontakt brukerst\xf8tte",
    'project-pages.improvement.errors.access-error.description': "Ta kontakt med nettstedadministrator for \xe5 be om tilgang.",
    'project-pages.improvement.errors.access-error.title': "Du har ikke tillatelse til \xe5 se prosjektsider",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Noe gikk galt under fors\xf8ket p\xe5 \xe5 vise sider fra det tilkoblede Confluence-omr\xe5det. {contactSupport} hvis det ikke hjelper \xe5 oppdatere siden.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Vi har problemer med \xe5 vise prosjektsider",
    'project-pages.improvement.errors.space-or-page-not-found.description': "Confluence-omr\xe5det eller -siden som ble koblet til, er flyttet, arkivert eller slettet. <link>Kontakt brukerst\xf8tte</link> hvis du ikke kan l\xf8se dette ved \xe5 koble til p\xe5 nytt",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Finner ikke omr\xe5de eller side",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} hvis det ikke hjelper \xe5 oppdatere siden.",
    'project-pages.improvement.errors.unknown-error.title': "Vi kan ikke vise prosjektsider akkurat n\xe5",
    'project-pages.improvement.feature1': "\xc5pne og opprett dokumenter uten \xe5 g\xe5 ut av Jira",
    'project-pages.improvement.feature2': "Maler for m\xf8ter, sprintplaner og mer",
    'project-pages.improvement.feature3': 'Synkroniser dokumenter til Jira for automatiske oppdateringer',
    'project-pages.improvement.heading-info': "Registrer teamets kunnskap og forbedre m\xe5ten du f\xe5r arbeidet utf\xf8rt p\xe5.",
    'project-pages.improvement.heading-info-v2': 'Opprett ett sted for alle teamets prosjektdokumenter',
    'project-pages.improvement.learn-more-button': 'Finn ut mer',
    'project-pages.improvement.powered-by': 'Levert av',
    'project-pages.improvement.powered-by.tooltip': "\xc5pne Confluence i en ny fane",
    'project-pages.improvement.preview-teaser': "L\xe5s opp maler, prosjektsider med mer.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Hold prosjektrapportene oppdaterte med statusetiketter som oppdateres automatisk.</p> <p>Bare koble til en Jira-st\xf8tteforesp\xf8rsel i et dokument, s\xe5 viser den automatisk en statusetikett som oppdateres synkront med st\xf8tteforesp\xf8rselen. Da trenger du ikke bruke tid p\xe5 manuelle rapporter.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': 'Oppdater interessentene uten problemer',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Opprett konsekvent dokumentasjon ved \xe5 bruke de innebygde malene v\xe5re. De er lette \xe5 bruke og tilpasse etter behov.</p> <p>Du kan bruke maler direkte fra prosjektsider slik at du aldri trenger \xe5 forlate det du jobber p\xe5. Du kan se gjennom alle malene <a>her</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Foren dokumentasjonsstandardene',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Opprett en enkelt informasjonskilde for viktig informasjon ved \xe5 opprette og administrere dokumentasjon fra fanene i prosjektsidene i Jira.</p> <p>Visste du at prosjektsider kj\xf8res med Confluence? Det er gratis for opptil ti brukere. Inviter resten av teamet i administratorinnstillingene.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Prosjektsidene dine, direkte i Jira',
    'project-pages.improvement.templates.blank-page.description': 'Start en side fra bunnen av.',
    'project-pages.improvement.templates.blank-page.name': 'Tom side',
    'project-pages.improvement.templates.decision.description': "F\xf8r opp viktige prosjektbeslutninger og formidle dem til teamet.",
    'project-pages.improvement.templates.decision.name': 'Beslutning',
    'project-pages.improvement.templates.meeting-notes.description': "Planlegg m\xf8ter, og del notater og handlingselementer med teamet.",
    'project-pages.improvement.templates.meeting-notes.name': "M\xf8tenotater",
    'project-pages.improvement.templates.post-expand.more': 'Flere maler',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Vis alle malene i Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': "Popul\xe6re maler",
    'project-pages.improvement.templates.post-expand.title': 'Opprett en side',
    'project-pages.improvement.templates.pre-expand.more': 'Utforsk flere maler',
    'project-pages.improvement.templates.pre-expand.subtitle': "Popul\xe6re hos lignende team",
    'project-pages.improvement.templates.pre-expand.title': "Forh\xe5ndsvisning av maler",
    'project-pages.improvement.templates.product-requirements.description': 'Definer, spor og avgrens kravene for produktet eller funksjonen.',
    'project-pages.improvement.templates.product-requirements.name': 'Produktkrav',
    'project-pages.improvement.templates.retrospective.description': "Hva gikk bra? Hva kunne ha g\xe5tt bedre? Crowdsource forbedringer med teamet.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektiv',
    'project-pages.improvement.templates.template.disabled-tooltip': "Koble til et Confluence-omr\xe5de f\xf8rst",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Spar tid og reduser manuelle oppgaver</b>. Confluence har mange <a>sidemaler</a>, slik at du aldri trenger \xe5 starte fra bunnen av. Du finner maler for tekniske dokumenter, feils\xf8kingsveiledninger, prosjektplaner, produktkrav og mer.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>De er enkle \xe5 redigere og formatere.</b> Bruk redigeringsmenyen \xf8verst til standard tekstformatering, og du kan enkelt sette inn mange hendige integreringer ved \xe5 skrive inn <b>/</b>. Sett inn en tabell ved \xe5 skrive <c>/tabell</c> eller et bilde med <c>/bilde</c>. Du kan ogs\xe5 sette inn Dropbox-koblinger <c>/dropbox</c>, Microsoft Office-verkt\xf8y <c>/microsoft</c> eller Trello-tavler og kort <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Skriv inn / etterfulgt av tabell eller bilde',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Her er et par tips for \xe5 komme i gang:",
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Hendige koblinger',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Bruk Jira og Confluence sammen',
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Opprett diagrammer p\xe5 sidene dine ved hjelp av Jira-data. Skriv inn <c>/Jira-diagrammer</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Sett inn en kobling til en Jira-sak hvor som helst p\xe5 siden. Koblingen p\xe5 siden blir oppdatert i sanntid etter hvert som du oppdaterer Jira-saken. Skriv inn <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Bygg inn interaktive veikart og tidslinjer for siden din ved \xe5 bruke Jira-prosjektene dine. Skriv inn <c>/jira-veikart</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Bygg inn interaktive tidslinjer for siden ved \xe5 bruke Jira-prosjekter. Skriv inn <c>/jira-tidslinje</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% av Jira Software-kundene sa at de leverte prosjekter raskere etter \xe5 ha lagt til Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% av Jira-kundene sa at de leverte prosjekter raskere etter \xe5 ha lagt til Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Bruk omr\xe5der og sider</b>. Omr\xe5der er en del av hvert Confluence-nettsted og er en m\xe5te \xe5 organisere sider i kategorier p\xe5. Tenk p\xe5 omr\xe5der som forskjellige mapper eller prosjekter, og sider som dokumentene som h\xf8rer hjemme i disse mappene eller prosjektene. <a>Finn ut mer om hvordan du bruker omr\xe5der</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "Pr\xf8v det n\xe5",
    'project-pages.improvement.templates.tutorial.description': 'Finn ut hvordan du redigerer en side.',
    'project-pages.improvement.templates.tutorial.name': 'Velkommen til Prosjektsider!',
    'project-pages.improvement.terms-and-conditions-v2': "N\xe5r du velger \xabPr\xf8v det n\xe5\xbb, bekrefter du at du blir registrert i Confluence og godtar Atlassian <termsLink>Clouds tjenestevilk\xe5r</termsLink> og <privacyLink>personvernerkl\xe6ring</privacyLink>.",
    'project-pages.improvement.title': 'Prosjektsider',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Opprett side',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Vi har lagt til Confluence slik at du kan begynne \xe5 opprette og koble sammen alle prosjektdokumentene dine. Det er gratis for opptil ti brukere.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Finn ut mer',
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Opprett din f\xf8rste side",
    'project-pages.improvement.transient-states.empty-state.description': "Opprett m\xf8tenotater, produktkrav, beslutninger eller annet innhold for \xe5 fylle opp dette omr\xe5det.",
    'project-pages.improvement.transient-states.empty-state.title': 'Her finnes det ingenting annet enn potensial',
    'project-pages.improvement.try-button': "Pr\xf8v denne malen i Confluence",
    'project-pages.improvement.try-it-now': "Pr\xf8v det n\xe5",
    'project-pages.improvement.try-lozenge': "Pr\xf8v",
    'project-pages.improvement.try-on-demand-button': "Pr\xf8v det gratis",
    'project-pages.page-deleted-flag.title': 'Siden er slettet.',
    'project-pages.page-published-flag.title': 'Siden din er publisert.',
    'project-pages.unknown-error.description': "{contactSupport} hvis det ikke hjelper \xe5 oppdatere.",
    'project-pages.unknown-error.heading': "Vi kan ikke vise prosjektsider akkurat n\xe5",
    'projectpages.templatepreview.termsandprivacy': "N\xe5r du klikker p\xe5 \xabPr\xf8v det gratis\xbb, blir du registrert i Confluence og godtar Atlassian <termsOfServiceLinkText>Clouds tjenestevilk\xe5r</termsOfServiceLinkText> og <privacyPolicyLinkText>personvernerkl\xe6ring</privacyPolicyLinkText>."
};

});

parcelRegister("kmIvU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a45e057e1907b479$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $a45e057e1907b479$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Powinno to\xa0zaj\u0105\u0107 mniej ni\u017C minut\u0119",
    'confluence.project-pages.improvement.provisioning-background.title': "Konfigurowanie stron projekt\xf3w",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Zamknij',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Gotowe',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Dalej',
    'project-pages.activating.description': "Po\u0142\u0105czona przestrze\u0144 Confuence nie jest jeszcze gotowa. {contactSupport}, je\u015Bli od\u015Bwie\u017Cenie nie rozwi\u0105\u017Ce problemu.",
    'project-pages.activating.heading': "Confluence wci\u0105\u017C si\u0119 \u0142aduje",
    'project-pages.button.connect-different-space-or-page.label': 'Ikona aktualizacji przestrzeni lub strony',
    'project-pages.button.connect-different-space-or-page.tooltip': "Po\u0142\u0105cz inn\u0105 przestrze\u0144 lub stron\u0119",
    'project-pages.button.connect-space-or-page.tooltip': "Po\u0142\u0105cz z Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "Otw\xf3rz stron\u0119 w Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "Otw\xf3rz przestrze\u0144 w Confluence",
    'project-pages.connect-space-dialog.connection-error': "Po\u0142\u0105czenie si\u0119 nie powiod\u0142o.",
    'project-pages.connect-space-dialog.connection-retry': "Spr\xf3buj ponownie",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Wybierz przestrze\u0144 lub stron\u0119, aby po\u0142\u0105czy\u0107 j\u0105 z Twoim projektem.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Szukaj w Confluence',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Ten projekt musi by\u0107 po\u0142\u0105czony z przestrzeni\u0105, zanim b\u0119dzie mo\u017Cna utworzy\u0107 stron\u0119. Wybierz przestrze\u0144, aby po\u0142\u0105czy\u0107 j\u0105 z tym projektem.",
    'project-pages.connect-space-dialog.error-icon': "B\u0142\u0105d:",
    'project-pages.connect-space-dialog.footer.cancel': 'Anuluj',
    'project-pages.connect-space-dialog.footer.connect-space': "Po\u0142\u0105cz",
    'project-pages.connect-space-or-page-dialog.header.title': "\u0141\u0105czenie projektu z Confluence",
    'project-pages.connect-space.description': "Przestrzenie s\u0105 jak foldery \u2014 mo\u017Cna w nich tworzy\u0107 tre\u015Bci zwi\u0105zane z projektem, organizowa\u0107 je i wsp\xf3\u0142pracowa\u0107 w ich ramach.",
    'project-pages.connect-space.not-connected.description': "Aby skorzysta\u0107 ze stron projektu, skontaktuj si\u0119 z administratorem lub kierownikiem zespo\u0142u w celu po\u0142\u0105czenia Confluence z tym projektem.",
    'project-pages.connect-space.not-connected.heading': "Nie po\u0142\u0105czono z Confluence",
    'project-pages.connect-success-flag.description.content': "Po\u0142\u0105czenie z\xa0tre\u015Bci\u0105 {connectedSpaceOrPageName} powiod\u0142o si\u0119.",
    'project-pages.connection-error.space-or-page-not-found.button': "Po\u0142\u0105cz z inn\u0105 przestrzeni\u0105 lub stron\u0105",
    'project-pages.create-space-dialog.connection-error': "Po\u0142\u0105czenie si\u0119 nie powiod\u0142o.",
    'project-pages.create-space-dialog.connection-retry': "Spr\xf3buj ponownie",
    'project-pages.create-space-dialog.content.empty-name': "Wprowad\u017A nazw\u0119 przestrzeni.",
    'project-pages.create-space-dialog.content.invalid-name': "Nazwa przestrzeni musi zawiera\u0107 przynajmniej jedn\u0105 liter\u0119 lub cyfr\u0119.",
    'project-pages.create-space-dialog.content.placeholder': "Wprowad\u017A nazw\u0119 przestrzeni",
    'project-pages.create-space-dialog.creation-error': "Tworzenie przestrzeni nie powiod\u0142o si\u0119.",
    'project-pages.create-space-dialog.error-icon': "B\u0142\u0105d:",
    'project-pages.create-space-dialog.footer.cancel': 'Anuluj',
    'project-pages.create-space-dialog.footer.create-space': "Utw\xf3rz",
    'project-pages.create-space-dialog.header.title': "Utw\xf3rz now\u0105 przestrze\u0144 Confluence",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Nie mo\u017Cesz korzysta\u0107 ze stron projektu, poniewa\u017C administrator odm\xf3wi\u0142 Ci dost\u0119pu do Confluence. Skontaktuj si\u0119 z administratorem witryny, aby uzyska\u0107 dost\u0119p.",
    'project-pages.cross-join.access-revoked.templates.title': "Nie masz uprawnie\u0144 do korzystania ze stron projektu",
    'project-pages.cross-join.avatar.view-profile': "Wy\u015Bwietl profil",
    'project-pages.cross-join.denied-request.templates.subtitle': "Nie mo\u017Cesz korzysta\u0107 ze stron projektu, poniewa\u017C administrator witryny odrzuci\u0142 Tw\xf3j wniosek o do\u0142\u0105czenie do Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "Administrator odm\xf3wi\u0142 Ci dost\u0119pu",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Uzyskasz dost\u0119p do\xa0Confluence. Administrator witryny ju\u017C zatwierdzi\u0142 do\u0142\u0105czenie.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport}, je\u015Bli od\u015Bwie\u017Cenie nie rozwi\u0105\u017Ce problemu.",
    'project-pages.cross-join.errors.unknown-error.title': "Obecnie nie mo\u017Cna wy\u015Bwietli\u0107 stron projektu",
    'project-pages.cross-join.inline-join-product.button': "Uzyskasz dost\u0119p do Confluence. Administrator witryny ju\u017C zatwierdzi\u0142 do\u0142\u0105czenie.",
    'project-pages.cross-join.inline-join-product.connected.description': "Wy\u015Bwietlaj, edytuj i tw\xf3rz dokumentacj\u0119 w jednym miejscu",
    'project-pages.cross-join.inline-join-product.connected.title': "Wsp\xf3\u0142pracuj nad stronami projektu ze swoim zespo\u0142em",
    'project-pages.cross-join.pending-request.templates.subtitle': "Administrator witryny otrzyma\u0142 Tw\xf3j wniosek o do\u0142\u0105czenie do Confluence. Po jego zatwierdzeniu strony projektu zaczn\u0105 dzia\u0142a\u0107 i otrzymasz wiadomo\u015B\u0107 e-mail z potwierdzeniem.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Po\xa0zatwierdzeniu otrzymasz wiadomo\u015B\u0107 e-mail z\xa0danymi dost\u0119powymi do\xa0stron projekt\xf3w.",
    'project-pages.cross-join.pending-request.templates.title': "Wys\u0142ano wniosek o dost\u0119p do Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "Wys\u0142ano do\xa0administratora wniosek o\xa0dost\u0119p",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Wy\u015Bwietlaj, edytuj i tw\xf3rz dokumentacj\u0119 projektu wraz z zespo\u0142em",
    'project-pages.cross-join.request-access.button': "Popro\u015B o dost\u0119p",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "Wybieraj\u0105c opcj\u0119 \u201EDo\u0142\u0105cz do\xa0zespo\u0142u\u201D, prosisz o\xa0do\u0142\u0105czenie do\xa0Confluence i\xa0wyra\u017Casz zgod\u0119 na\xa0udost\u0119pnienie profilu Atlassian swojemu administratorowi.",
    'project-pages.cross-join.request-access.button.experimental': "Do\u0142\u0105cz do\xa0swojego zespo\u0142u",
    'project-pages.cross-join.request-access.connected.description.experimental': "Tw\xf3j zesp\xf3\u0142 korzysta ze\xa0stron projektu w\xa0celu komentowania, edytowania i\xa0wsp\xf3\u0142pracy nad dokumentacj\u0105 projektow\u0105 bez wychodzenia z\xa0Jiry. Do\u0142\u0105cz do\xa0Confluence, aby zyska\u0107 dost\u0119p do\xa0stron projektu Twojego zespo\u0142u.",
    'project-pages.cross-join.request-access.title': "Strony projektu wymagaj\u0105 dost\u0119pu do Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Stw\xf3rz pojedyncze \u017Ar\xf3d\u0142o rzetelnych informacji dla swojego zespo\u0142u",
    'project-pages.default-contextual-heading': "Strony projektu s\u0105 obs\u0142ugiwane przez Confluence",
    'project-pages.default-contextual-message': "Tw\xf3rz dokumenty projektu, udost\u0119pniaj je i wsp\xf3\u0142pracuj \u2014 wszystko z jednego miejsca na stronach Confluence.",
    'project-pages.default-reactivate-CTA': 'Ponownie aktywuj Confluence',
    'project-pages.default-trial-CTA': "Wypr\xf3buj Confluence bezp\u0142atnie przez 30 dni",
    'project-pages.draft-saved-flag.action': "Otw\xf3rz wersj\u0119 robocz\u0105",
    'project-pages.draft-saved-flag.description': "Twoja wersja robocza b\u0119dzie widoczna tylko dla Ciebie, dop\xf3ki jej nie opublikujesz.",
    'project-pages.draft-saved-flag.title': "Zapisano wersj\u0119 robocz\u0105",
    'project-pages.embedded-pages.create-page-error.close-button': 'Zamknij',
    'project-pages.embedded-pages.create-page-error.description': "Wyst\u0105pi\u0142 problem i nie mo\u017Cemy utworzy\u0107 strony.",
    'project-pages.embedded-pages.create-page-error.title': "Nie mo\u017Cna utworzy\u0107 strony",
    'project-pages.embedded-pages.create-page-error.try-again-button': "Spr\xf3buj ponownie",
    'project-pages.embedded-pages.modal.close.button.hint': 'Zamknij',
    'project-pages.embedded-pages.modal.title.button': "Otw\xf3rz w Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "Otw\xf3rz w nowej karcie",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport}, je\u015Bli od\u015Bwie\u017Cenie nie usunie problemu.",
    'project-pages.errors.unknown-error.title.non-final': "Nie mo\u017Cna teraz wy\u015Bwietli\u0107 stron projektu",
    'project-pages.generic-error.button.reload': "Za\u0142aduj stron\u0119 ponownie",
    'project-pages.generic-error.description': "Co\u015B posz\u0142o nie tak. Spr\xf3buj ponownie p\xf3\u017Aniej.",
    'project-pages.generic-error.description.non-final': "Co\u015B posz\u0142o nie tak. Spr\xf3buj ponownie p\xf3\u017Aniej.",
    'project-pages.generic-error.heading': "To dziwne\u2026",
    'project-pages.generic-error.title.non-final': "To dziwne\u2026",
    'project-pages.generic-info-flag.description': "Co\u015B posz\u0142o nie tak. Spr\xf3buj ponownie albo skontaktuj si\u0119 z\xa0dzia\u0142em wsparcia, je\u017Celi problem nie ust\u0105pi.",
    'project-pages.generic-success-flag.description.page': "Po\u0142\u0105czenie ze stron\u0105 {connectedSpaceOrPageName} powiod\u0142o si\u0119.",
    'project-pages.generic-success-flag.description.space': "Po\u0142\u0105czenie z przestrzeni\u0105 {connectedSpaceOrPageName} powiod\u0142o si\u0119.",
    'project-pages.generic-success-flag.heading.page': "Strona po\u0142\u0105czona",
    'project-pages.generic-success-flag.heading.space': "Przestrze\u0144 po\u0142\u0105czona",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Lub utw\xf3rz now\u0105 przestrze\u0144",
    'project-pages.granular-pages.connect-space.button': "Po\u0142\u0105cz z Confluence",
    'project-pages.granular-pages.connect-space.heading': "Po\u0142\u0105cz projekt z przestrzeni\u0105 lub stron\u0105 Confluence",
    'project-pages.granular-pages.connect-space.heading.non-final': "Po\u0142\u0105cz projekt z przestrzeni\u0105 lub stron\u0105 Confluence",
    'project-pages.improvement.contact-support': "Skontaktuj si\u0119 z zespo\u0142em wsparcia",
    'project-pages.improvement.errors.access-error.description': "Spr\xf3buj skontaktowa\u0107 si\u0119 z administratorem witryny, aby poprosi\u0107 o dost\u0119p.",
    'project-pages.improvement.errors.access-error.title': "Nie masz uprawnie\u0144 do przegl\u0105dania stron projektu",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Co\u015B posz\u0142o nie tak podczas pr\xf3by wy\u015Bwietlenia stron z po\u0142\u0105czonej przestrzeni Confluence. {contactSupport}, je\u015Bli od\u015Bwie\u017Cenie nie usunie problemu.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Wyst\u0119puj\u0105 problemy z wy\u015Bwietlaniem stron projektu",
    'project-pages.improvement.errors.space-or-page-not-found.description': "Po\u0142\u0105czona przestrze\u0144 lub strona Confluence zosta\u0142a przeniesiona, zarchiwizowana lub usuni\u0119ta. <link>Skontaktuj si\u0119 z\xa0dzia\u0142em wsparcia</link>, je\u015Bli ponowne po\u0142\u0105czenie nie rozwi\u0105\u017Ce problemu.",
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Nie znaleziono przestrzeni lub strony',
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport}, je\u015Bli od\u015Bwie\u017Cenie nie naprawi problemu.",
    'project-pages.improvement.errors.unknown-error.title': "Obecnie nie mo\u017Cna wy\u015Bwietli\u0107 stron projektu",
    'project-pages.improvement.feature1': "Dost\u0119p do\xa0dokument\xf3w i\xa0ich tworzenie bez opuszczania systemu Jira",
    'project-pages.improvement.feature2': "Szablony spotka\u0144, plan\xf3w sprint\xf3w i\xa0wiele innych",
    'project-pages.improvement.feature3': "Synchronizacja dokument\xf3w z\xa0systemem Jira na\xa0potrzeby automatycznych aktualizacji",
    'project-pages.improvement.heading-info': "Zgromad\u017A wiedz\u0119 zespo\u0142u i usprawnij spos\xf3b pracy.",
    'project-pages.improvement.heading-info-v2': "Utw\xf3rz jedno miejsce dla wszystkich dokument\xf3w projektowych zespo\u0142u",
    'project-pages.improvement.learn-more-button': "Dowiedz si\u0119 wi\u0119cej",
    'project-pages.improvement.powered-by': "Obs\u0142ugiwane przez",
    'project-pages.improvement.powered-by.tooltip': "Otw\xf3rz Confluence w nowej karcie",
    'project-pages.improvement.preview-teaser': 'Odblokuj szablony, strony projektu i wiele innych.',
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Dzi\u0119ki automatycznie aktualizowanym etykietom statusu raporty z\xa0projekt\xf3w s\u0105\xa0zawsze aktualne.</p> <p>Po prostu dodaj \u0142\u0105cze do\xa0zg\u0142oszenia Jira w\xa0dokumencie, aby automatycznie wy\u015Bwietla\u0107 etykiet\u0119 statusu aktualizowan\u0105 razem ze\xa0zg\u0142oszeniem, dzi\u0119ki czemu nie trzeba traci\u0107 czasu na\xa0r\u0119czne tworzenie raport\xf3w.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Bezproblemowe informowanie na\xa0bie\u017C\u0105co interesariuszy",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Tw\xf3rz sp\xf3jn\u0105 dokumentacj\u0119, korzystaj\u0105c z\xa0naszych wbudowanych szablon\xf3w. S\u0105 one proste w\xa0u\u017Cyciu i\xa0mo\u017Cna je\xa0dostosowa\u0107 do\xa0w\u0142asnych potrzeb.</p> <p>Mo\u017Cesz u\u017Cywa\u0107 szablon\xf3w bezpo\u015Brednio z\xa0poziomu stron projekt\xf3w, wi\u0119c nie musisz odrywa\u0107 si\u0119 od\xa0tego, nad czym pracujesz. Przegl\u0105daj wszystkie szablony <a>tutaj</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Ujednolicenie standard\xf3w dokumentacji",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Zapewnij pojedyncze \u017Ar\xf3d\u0142o wa\u017Cnych informacji, tworz\u0105c dokumentacj\u0119 i\xa0zarz\u0105dzaj\u0105c ni\u0105 na\xa0karcie Strony projektu w\xa0systemie Jira.</p> <p>Czy wiesz, \u017Ce\xa0strony projekt\xf3w dzia\u0142aj\u0105 w\xa0Confluence? Jest to\xa0bezp\u0142atne rozwi\u0105zanie dla maksymalnie 10\xa0u\u017Cytkownik\xf3w. Zapro\u015B reszt\u0119 swojego zespo\u0142u w\xa0ustawieniach administratora.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "Twoje strony projekt\xf3w, bezpo\u015Brednio w\xa0systemie Jira",
    'project-pages.improvement.templates.blank-page.description': 'Rozpocznij od pustej strony.',
    'project-pages.improvement.templates.blank-page.name': 'Pusta strona',
    'project-pages.improvement.templates.decision.description': "Rejestruj wa\u017Cne decyzje dotycz\u0105ce projektu i przekazuj je zespo\u0142owi.",
    'project-pages.improvement.templates.decision.name': 'Decyzja',
    'project-pages.improvement.templates.meeting-notes.description': "Okre\u015Blaj plany spotka\u0144, r\xf3b notatki i udost\u0119pniaj zespo\u0142owi zadania do wykonania.",
    'project-pages.improvement.templates.meeting-notes.name': 'Notatki ze spotkania',
    'project-pages.improvement.templates.post-expand.more': "Wi\u0119cej szablon\xf3w",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Wy\u015Bwietl wszystkie szablony w Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': 'Popularne szablony',
    'project-pages.improvement.templates.post-expand.title': "Utw\xf3rz stron\u0119",
    'project-pages.improvement.templates.pre-expand.more': "Poznaj wi\u0119cej szablon\xf3w",
    'project-pages.improvement.templates.pre-expand.subtitle': "Popularne w zespo\u0142ach takich jak Tw\xf3j",
    'project-pages.improvement.templates.pre-expand.title': "Wy\u015Bwietl podgl\u0105d szablon\xf3w",
    'project-pages.improvement.templates.product-requirements.description': "Definiuj i \u015Bled\u017A wymagania dotycz\u0105ce produktu lub funkcji oraz ustalaj ich zakres.",
    'project-pages.improvement.templates.product-requirements.name': "Wymagania dotycz\u0105ce produktu",
    'project-pages.improvement.templates.retrospective.description': "Co zrobili\u015Bmy dobrze? Co powinni\u015Bmy zrobi\u0107 lepiej? Okre\u015Bl usprawnienia z Twoim zespo\u0142em, korzystaj\u0105c z metody crowdsourcingu.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektywa',
    'project-pages.improvement.templates.template.disabled-tooltip': "Najpierw po\u0142\u0105cz przestrze\u0144 Confluence",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Oszcz\u0119dzaj czas, ograniczaj\u0105c r\u0119czne wykonywanie zada\u0144</b>. Confluence zawiera wiele <a>szablon\xf3w</a> stron, dzi\u0119ki czemu nigdy nie musisz zaczyna\u0107 od zera. Pomy\u015Bl o dokumentacji technicznej, przewodnikach rozwi\u0105zywania problem\xf3w, planach projekt\xf3w, wymaganiach dotycz\u0105cych produkt\xf3w i wielu innych dokumentach.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u0141atwa edycja i proste formatowanie</b>. G\xf3rne menu edycji pozwala korzysta\u0107 ze standardowych funkcji formatowania tekstu, a wpisuj\u0105c symbol <b>/</b>, mo\u017Cesz z \u0142atwo\u015Bci\u0105 wstawi\u0107 mn\xf3stwo por\u0119cznych integracji. Polecenie <c>/tabela</c> pozwoli wstawi\u0107 tabel\u0119, a polecenie <c>/obraz</c> \u2014 obraz. Mo\u017Cesz r\xf3wnie\u017C wstawi\u0107 \u0142\u0105cza Dropbox za pomoc\u0105 polecenia <c>/dropbox</c>, narz\u0119dzia Microsoft Office <c>/microsoft</c> lub tablice i karty Trello za pomoc\u0105 polecenia <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Wystarczy wpisa\u0107 symbol uko\u015Bnika /, a nast\u0119pnie odpowiednie s\u0142owo, takie jak tabela lub obraz",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Poni\u017Cej przedstawiamy kilka porad na pocz\u0105tek:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "Por\u0119czne \u0142\u0105cza",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Korzystaj z rozwi\u0105za\u0144 Jira i Confluence w kombinacji",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Utw\xf3rz na swoich stronach wykresy, korzystaj\u0105c z rzeczywistych danych Jira. Wpisz polecenie <c>/wykresy Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Utw\xf3rz \u0142\u0105cze do zg\u0142oszenia Jira w dowolnym miejscu na stronie. \u0141\u0105cze na stronie b\u0119dzie aktualizowane w czasie rzeczywistym w miar\u0119 aktualizacji zg\u0142oszenia w systemie Jira. Wpisz polecenie <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Korzystaj\u0105c z Projekt\xf3w Jira, osad\u017A na swojej stronie interaktywne harmonogramy i osie czasu. Wpisz polecenie <c>/harmonogram jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Korzystaj\u0105c z projekt\xf3w Jira, osad\u017A na swojej stronie interaktywne osie czasu. Wpisz <c>/o\u015B czasu jira</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76% klient\xf3w korzystaj\u0105cych z Jira Software stwierdzi\u0142o, \u017Ce realizowa\u0142o projekty szybciej po dodaniu integracji z Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76%\xa0klient\xf3w korzystaj\u0105cych z\xa0systemu Jira stwierdzi\u0142o, \u017Ce\xa0realizowa\u0142o projekty szybciej po\xa0dodaniu integracji z\xa0Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Korzystanie z przestrzeni i stron</b>. Przestrzenie s\u0105 cz\u0119\u015Bci\u0105 ka\u017Cdej witryny Confluence i sposobem na uporz\u0105dkowanie stron w kategorie. Wyobra\u017A sobie przestrzenie jako r\xf3\u017Cne foldery lub projekty, a strony, jako znajduj\u0105ce si\u0119 w nich dokumenty. <a>Dowiedz si\u0119 wi\u0119cej o sposobie korzystania z tych przestrzeni</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "Wypr\xf3buj teraz",
    'project-pages.improvement.templates.tutorial.description': "Dowiedz si\u0119, jak edytowa\u0107 stron\u0119.",
    'project-pages.improvement.templates.tutorial.name': 'Witamy na stronach projektu!',
    'project-pages.improvement.terms-and-conditions-v2': "Klikaj\u0105c przycisk \u201EWypr\xf3buj teraz\u201D, potwierdzasz rejestracje w\xa0Confluence i\xa0akceptujesz <termsLink>Warunki \u015Bwiadczenia us\u0142ug Cloud</termsLink> oraz <privacyLink>Polityk\u0119 prywatno\u015Bci</privacyLink> Atlassian.",
    'project-pages.improvement.title': "Strony projekt\xf3w",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Utw\xf3rz stron\u0119",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Dodali\u015Bmy Confluence, wi\u0119c mo\u017Cesz zacz\u0105\u0107 tworzy\u0107 ca\u0142\u0105 dokumentacj\u0119 i po\u0142\u0105czy\u0107 j\u0105 ze swoim projektem. Wersja jest bezp\u0142atna dla maksymalnie 10 u\u017Cytkownik\xf3w.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "Dowiedz si\u0119 wi\u0119cej",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Utw\xf3rz swoj\u0105 pierwsz\u0105 stron\u0119",
    'project-pages.improvement.transient-states.empty-state.description': "Utw\xf3rz notatki ze spotka\u0144, wymagania produktowe, decyzje lub inne tre\u015Bci, aby wype\u0142ni\u0107 t\u0119 przestrze\u0144.",
    'project-pages.improvement.transient-states.empty-state.title': "Nie ma tu nic opr\xf3cz potencja\u0142u",
    'project-pages.improvement.try-button': "Wypr\xf3buj ten szablon w Confluence",
    'project-pages.improvement.try-it-now': "Wypr\xf3buj teraz",
    'project-pages.improvement.try-lozenge': "Wypr\xf3buj",
    'project-pages.improvement.try-on-demand-button': "Wypr\xf3buj bezp\u0142atnie",
    'project-pages.page-deleted-flag.title': "Usuni\u0119to stron\u0119.",
    'project-pages.page-published-flag.title': "Twoja strona zosta\u0142a opublikowana.",
    'project-pages.unknown-error.description': "{contactSupport}, je\u015Bli od\u015Bwie\u017Cenie nie naprawi problemu.",
    'project-pages.unknown-error.heading': "Nie mo\u017Cna teraz wy\u015Bwietli\u0107 stron projektu",
    'projectpages.templatepreview.termsandprivacy': "Klikaj\u0105c przycisk \u201EWypr\xf3buj bezp\u0142atnie\u201D, akceptujesz <termsOfServiceLinkText>Warunki \u015Bwiadczenia us\u0142ug Cloud</termsOfServiceLinkText> oraz <privacyPolicyLinkText>Polityk\u0119 prywatno\u015Bci</privacyPolicyLinkText> Atlassian."
};

});

parcelRegister("4tw7A", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f97151bf69ed584$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $5f97151bf69ed584$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': 'Deve levar menos de um minuto',
    'confluence.project-pages.improvement.provisioning-background.title': "Como configurar p\xe1ginas de projeto",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Ignorar',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "Conclu\xeddo",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "Pr\xf3ximo",
    'project-pages.activating.description': "O espa\xe7o conectado do Confluence ainda n\xe3o est\xe1 pronto por completo. {contactSupport} se a atualiza\xe7\xe3o n\xe3o funcionar.",
    'project-pages.activating.heading': "O Confluence ainda est\xe1 carregando",
    'project-pages.button.connect-different-space-or-page.label': "Atualizar o espa\xe7o ou \xedcone da p\xe1gina",
    'project-pages.button.connect-different-space-or-page.tooltip': "Conecte a um espa\xe7o ou p\xe1gina diferente",
    'project-pages.button.connect-space-or-page.tooltip': 'Conectar ao Confluence',
    'project-pages.button.go-to-connected-page.tooltip': "Abrir p\xe1gina no Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "Abrir espa\xe7o no Confluence",
    'project-pages.connect-space-dialog.connection-error': "Falha na conex\xe3o.",
    'project-pages.connect-space-dialog.connection-retry': 'Tentar novamente',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Escolha um espa\xe7o ou p\xe1gina para conectar ao projeto.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Pesquisar no Confluence',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Este projeto precisa ser conectado a um espa\xe7o para que voc\xea possa criar uma p\xe1gina. Escolha um espa\xe7o para conectar a este projeto.",
    'project-pages.connect-space-dialog.error-icon': 'Erro:',
    'project-pages.connect-space-dialog.footer.cancel': 'Cancelar',
    'project-pages.connect-space-dialog.footer.connect-space': 'Conectar',
    'project-pages.connect-space-or-page-dialog.header.title': 'Conecte o projeto ao Confluence',
    'project-pages.connect-space.description': "Espa\xe7os s\xe3o como pastas: podem ser usados para criar, organizar e colaborar em todo o conte\xfado relacionado ao seu projeto.",
    'project-pages.connect-space.not-connected.description': "Para utilizar p\xe1ginas de projeto, entre em contato com o administrador ou l\xedder da equipe para conectar o Confluence a esse projeto.",
    'project-pages.connect-space.not-connected.heading': "N\xe3o conectado ao Confluence",
    'project-pages.connect-success-flag.description.content': "Conectado ao conte\xfado {connectedSpaceOrPageName}.",
    'project-pages.connection-error.space-or-page-not-found.button': "Conecte a um espa\xe7o ou p\xe1gina diferente",
    'project-pages.create-space-dialog.connection-error': "Falha na conex\xe3o.",
    'project-pages.create-space-dialog.connection-retry': 'Tentar novamente',
    'project-pages.create-space-dialog.content.empty-name': "D\xea um nome para o seu espa\xe7o.",
    'project-pages.create-space-dialog.content.invalid-name': "Os nomes de espa\xe7os exigem pelo menos uma letra ou um n\xfamero.",
    'project-pages.create-space-dialog.content.placeholder': "Digite um nome de espa\xe7o",
    'project-pages.create-space-dialog.creation-error': "Falha ao criar o espa\xe7o.",
    'project-pages.create-space-dialog.error-icon': 'Erro:',
    'project-pages.create-space-dialog.footer.cancel': 'Cancelar',
    'project-pages.create-space-dialog.footer.create-space': 'Criar',
    'project-pages.create-space-dialog.header.title': "Criar novo espa\xe7o do Confluence",
    'project-pages.cross-join.access-revoked.templates.subtitle': "N\xe3o \xe9 poss\xedvel usar p\xe1ginas do projeto porque o administrador negou acesso ao Confluence. Entre em contato com o administrador do site para solicitar acesso.",
    'project-pages.cross-join.access-revoked.templates.title': "Voc\xea n\xe3o tem permiss\xf5es para usar p\xe1ginas do projeto",
    'project-pages.cross-join.avatar.view-profile': 'Visualizar perfil',
    'project-pages.cross-join.denied-request.templates.subtitle': "N\xe3o \xe9 poss\xedvel usar p\xe1ginas do projeto porque o administrador do site negou a solicita\xe7\xe3o para entrar no Confluence.",
    'project-pages.cross-join.denied-request.templates.title': 'O administrador negou o acesso',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Voc\xea vai receber acesso ao Confluence. O administrador do seu site j\xe1 aprovou voc\xea.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} se a atualiza\xe7\xe3o n\xe3o funcionar.",
    'project-pages.cross-join.errors.unknown-error.title': "N\xe3o \xe9 poss\xedvel exibir as p\xe1ginas do projeto agora",
    'project-pages.cross-join.inline-join-product.button': "Voc\xea vai ter acesso ao Confluence. O administrador do seu site j\xe1 aprovou voc\xea.",
    'project-pages.cross-join.inline-join-product.connected.description': "Veja, edite e crie documenta\xe7\xe3o em um \xfanico local",
    'project-pages.cross-join.inline-join-product.connected.title': "Colabore nas p\xe1ginas do projeto com sua equipe",
    'project-pages.cross-join.pending-request.templates.subtitle': "O administrador do site recebeu sua solicita\xe7\xe3o para entrar no Confluence. Se ela for aprovada, as p\xe1ginas do projeto v\xe3o come\xe7ar a funcionar e voc\xea vai receber um e-mail de confirma\xe7\xe3o.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Ap\xf3s a aprova\xe7\xe3o, voc\xea vai receber um e-mail com acesso \xe0s P\xe1ginas do projeto.",
    'project-pages.cross-join.pending-request.templates.title': "Voc\xea solicitou acesso ao Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "Solicita\xe7\xe3o de acesso enviada ao administrador",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Veja, edite e crie documenta\xe7\xe3o do projeto com sua equipe",
    'project-pages.cross-join.request-access.button': 'Solicitar acesso',
    'project-pages.cross-join.request-access.button-subtitle.experimental': 'Ao selecionar "Entrar na equipe", voc\xea est\xe1 pedindo para entrar no Confluence e autoriza o compartilhamento do perfil na Atlassian com o administrador.',
    'project-pages.cross-join.request-access.button.experimental': 'Entrar na equipe',
    'project-pages.cross-join.request-access.connected.description.experimental': "A equipe est\xe1 usando P\xe1ginas do projeto para comentar, editar e colaborar na documenta\xe7\xe3o do projeto sem sair do Jira. Entre no Confluence para acessar as P\xe1ginas do projeto da equipe.",
    'project-pages.cross-join.request-access.title': "As p\xe1ginas do projeto exigem acesso ao Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Crie uma s\xf3 fonte \xfanica de informa\xe7\xf5es para a equipe",
    'project-pages.default-contextual-heading': "As p\xe1ginas de projeto s\xe3o desenvolvidas no Confluence",
    'project-pages.default-contextual-message': "Crie, compartilhe e colabore em todos os documentos de seu projeto em um \xfanico lugar, com as p\xe1ginas do Confluence.",
    'project-pages.default-reactivate-CTA': 'Reativar Confluence',
    'project-pages.default-trial-CTA': "Experimente o Confluence gr\xe1tis por 30 dias",
    'project-pages.draft-saved-flag.action': 'Abrir rascunho',
    'project-pages.draft-saved-flag.description': "O rascunho s\xf3 fica vis\xedvel at\xe9 ser publicado.",
    'project-pages.draft-saved-flag.title': 'Rascunho salvo',
    'project-pages.embedded-pages.create-page-error.close-button': 'Fechar',
    'project-pages.embedded-pages.create-page-error.description': "Um problema surgiu e n\xe3o foi poss\xedvel criar uma p\xe1gina para voc\xea.",
    'project-pages.embedded-pages.create-page-error.title': "N\xe3o foi poss\xedvel criar uma p\xe1gina",
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Tentar novamente',
    'project-pages.embedded-pages.modal.close.button.hint': 'Fechar',
    'project-pages.embedded-pages.modal.title.button': 'Abrir no Confluence',
    'project-pages.embedded-pages.modal.title.button.hint': 'Abrir em uma nova guia',
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} se a atualiza\xe7\xe3o n\xe3o funcionar.",
    'project-pages.errors.unknown-error.title.non-final': "N\xe3o \xe9 poss\xedvel exibir as p\xe1ginas do projeto agora",
    'project-pages.generic-error.button.reload': "Recarregar p\xe1gina",
    'project-pages.generic-error.description': 'Algo deu errado. Tente novamente mais tarde.',
    'project-pages.generic-error.description.non-final': 'Algo deu errado. Tente novamente mais tarde.',
    'project-pages.generic-error.heading': "Poxa, isso est\xe1 estranho...",
    'project-pages.generic-error.title.non-final': "Poxa, isso est\xe1 estranho...",
    'project-pages.generic-info-flag.description': 'Algo deu errado. Tente de novo ou fale com o suporte se o problema persistir',
    'project-pages.generic-success-flag.description.page': "P\xe1gina {connectedSpaceOrPageName} conectada com sucesso.",
    'project-pages.generic-success-flag.description.space': "Espa\xe7o {connectedSpaceOrPageName} conectado com sucesso.",
    'project-pages.generic-success-flag.heading.page': "P\xe1gina conectada",
    'project-pages.generic-success-flag.heading.space': "Espa\xe7o conectado",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Ou crie um novo espa\xe7o",
    'project-pages.granular-pages.connect-space.button': 'Conectar ao Confluence',
    'project-pages.granular-pages.connect-space.heading': "Conecte este projeto a um espa\xe7o ou p\xe1gina do Confluence",
    'project-pages.granular-pages.connect-space.heading.non-final': "Conecte este projeto a um espa\xe7o ou p\xe1gina do Confluence",
    'project-pages.improvement.contact-support': 'Entre em contato com o suporte',
    'project-pages.improvement.errors.access-error.description': 'Tente entrar em contato com o administrador do site para pedir acesso.',
    'project-pages.improvement.errors.access-error.title': "Voc\xea n\xe3o tem permiss\xe3o para visualizar as p\xe1ginas do projeto",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Ocorreu um erro durante a tentativa de exibir p\xe1ginas do seu espa\xe7o conectado do Confluence. {contactSupport} se a atualiza\xe7\xe3o n\xe3o funcionar.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "A gente est\xe1 com problemas para exibir as p\xe1ginas do projeto",
    'project-pages.improvement.errors.space-or-page-not-found.description': "O espa\xe7o ou p\xe1gina do Confluence que estava conectado foi movido, arquivado ou exclu\xeddo. <link>Entre em contato com o suporte</link> se a reconex\xe3o n\xe3o corrigir as coisas",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Espa\xe7o ou p\xe1gina n\xe3o encontrados",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} se a atualiza\xe7\xe3o n\xe3o funcionar.",
    'project-pages.improvement.errors.unknown-error.title': "N\xe3o \xe9 poss\xedvel exibir as p\xe1ginas do projeto agora",
    'project-pages.improvement.feature1': 'Acesse e crie documentos sem sair do Jira',
    'project-pages.improvement.feature2': "Templates para reuni\xf5es, planos de sprint e mais",
    'project-pages.improvement.feature3': "Sincronize documentos com o Jira para receber atualiza\xe7\xf5es autom\xe1ticas",
    'project-pages.improvement.heading-info': 'Registre o conhecimento da equipe e melhore a forma de trabalhar.',
    'project-pages.improvement.heading-info-v2': 'Crie um lugar para todos os documentos de projeto da equipe',
    'project-pages.improvement.learn-more-button': 'Saiba mais',
    'project-pages.improvement.powered-by': "Distribu\xeddo por",
    'project-pages.improvement.powered-by.tooltip': 'Abrir o Confluence em uma nova guia',
    'project-pages.improvement.preview-teaser': "Descubra templates, p\xe1ginas de projeto e muito mais.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Mantenha os relat\xf3rios de projeto atualizados com a atualiza\xe7\xe3o autom\xe1tica de etiquetas de status.</p> <p>Basta vincular um ticket do Jira em um documento que ele vai exibir uma etiqueta de status autom\xe1tica com atualiza\xe7\xe3o em sincronia com o ticket. Assim, voc\xea n\xe3o precisa gastar tempo criando relat\xf3rios manuais.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': 'Atualize as partes interessadas com continuidade',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Crie uma documenta\xe7\xe3o consistente usando os templates integrados. Eles s\xe3o f\xe1ceis de usar e podem ser personalizados.</p> <p>Voc\xea pode usar templates direto das p\xe1ginas do projeto para nunca ter que sair de onde est\xe1 trabalhando. Veja todos os templates <a>aqui</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Unifique os padr\xf5es de documenta\xe7\xe3o",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Elabore e gerencie a documenta\xe7\xe3o na guia de p\xe1ginas do projeto no Jira para criar uma fonte \xfanica de verdade para informa\xe7\xf5es importantes.</p> <p>Voc\xea sabia que as p\xe1ginas do projeto s\xe3o executadas no Confluence? \xc9 gr\xe1tis para at\xe9 10 usu\xe1rios. Convide o resto da equipe nas configura\xe7\xf5es do administrador.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "As p\xe1ginas do projeto, direto no Jira",
    'project-pages.improvement.templates.blank-page.description': "Comece uma p\xe1gina do zero.",
    'project-pages.improvement.templates.blank-page.name': "P\xe1gina em branco",
    'project-pages.improvement.templates.decision.description': "Registre decis\xf5es importantes do projeto e compartilhe com a equipe.",
    'project-pages.improvement.templates.decision.name': "Decis\xe3o",
    'project-pages.improvement.templates.meeting-notes.description': "Defina pautas para reuni\xf5es, fa\xe7a anota\xe7\xf5es e compartilhe itens de a\xe7\xe3o com a equipe.",
    'project-pages.improvement.templates.meeting-notes.name': "Anota\xe7\xf5es de reuni\xe3o",
    'project-pages.improvement.templates.post-expand.more': 'Mais templates',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Ver todos os templates no Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': 'Templates populares',
    'project-pages.improvement.templates.post-expand.title': "Criar uma p\xe1gina",
    'project-pages.improvement.templates.pre-expand.more': 'Explore mais templates',
    'project-pages.improvement.templates.pre-expand.subtitle': 'Popular com equipes como a sua',
    'project-pages.improvement.templates.pre-expand.title': 'Visualizar templates',
    'project-pages.improvement.templates.product-requirements.description': "Defina e monitore os requisitos e seu escopo para seu produto ou fun\xe7\xe3o.",
    'project-pages.improvement.templates.product-requirements.name': 'Requisitos do produto',
    'project-pages.improvement.templates.retrospective.description': "O que estava bom? O que poderia ter sido melhor? Re\xfana melhorias por meio de crowdsourcing com a equipe.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospectiva',
    'project-pages.improvement.templates.template.disabled-tooltip': "Conecte um espa\xe7o do Confluence primeiro",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Economize tempo e reduza as tarefas manuais</b>. O Confluence tem v\xe1rios <a>templates</a> de p\xe1gina, ent\xe3o voc\xea nunca precisa come\xe7ar do zero. S\xe3o documentos t\xe9cnicos, guias de solu\xe7\xe3o de problemas, planos de projetos, requisitos do produto e muito mais.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Edite e formate com facilidade.</b> Use o menu de edi\xe7\xe3o superior para formata\xe7\xe3o padr\xe3o de palavras e digite <b>/</b> para inserir v\xe1rias integra\xe7\xf5es \xfateis com facilidade. Insira uma tabela digitando <c>/tabela</c> ou uma imagem com <c>/imagem.</c> Voc\xea tamb\xe9m pode inserir links do Dropbox <c>/dropbox</c>, ferramentas do Microsoft Office <c>/microsoft</c> ou quadros e cart\xf5es do Trello <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Digite / seguido por 'tabela' ou 'imagem'",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Veja algumas dicas para voc\xea come\xe7ar:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "Links \xfateis",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Use o Jira e o Confluence juntos',
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Crie gr\xe1ficos nas p\xe1ginas usando dados reais do Jira. Digite <c>/gr\xe1ficos do Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Vincule um item do Jira em qualquer lugar da p\xe1gina. O link na p\xe1gina \xe9 atualizado em tempo real, conforme voc\xea atualiza o item do Jira. Digite <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Insira roteiros e cronogramas interativos na p\xe1gina usando projetos do Jira. Digite <c>/roteiro do jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Incorpore linhas do tempo interativas na p\xe1gina usando os projetos do Jira. Digite <c>/jira timeline</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76% dos clientes do Jira Software disseram que la\xe7aram projetos com mais rapidez depois de adicionarem o Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76% dos clientes do Jira afirmam terem lan\xe7ado projetos com mais rapidez depois de adicionar o Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Uso de espa\xe7os e p\xe1ginas</b>. Os espa\xe7os fazem parte de todos os sites do Confluence e permitem organizar as p\xe1ginas em categorias. Pense nos espa\xe7os como diferentes pastas ou projetos. As p\xe1ginas s\xe3o os documentos que pertencem a essas pastas ou projetos. <a>Saiba mais sobre como usar espa\xe7os</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Experimente agora',
    'project-pages.improvement.templates.tutorial.description': "Saiba como editar uma p\xe1gina.",
    'project-pages.improvement.templates.tutorial.name': "Bem-vindo(a) \xe0s p\xe1ginas do projeto!",
    'project-pages.improvement.terms-and-conditions-v2': "Ao clicar em &quot;Testar agora&quot;, voc\xea reconhece a inscri\xe7\xe3o no Confluence e concorda com os <termsLink>Termos de Servi\xe7o</termsLink> e a <privacyLink>Pol\xedtica de Privacidade</privacyLink> do Atlassian Cloud.",
    'project-pages.improvement.title': "P\xe1ginas de projeto",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Criar p\xe1gina",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Adicionamos o Confluence para que voc\xea possa come\xe7ar a criar e vincular todos os documentos do projeto. \xc9 gratuito para at\xe9 10 usu\xe1rios.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Saiba mais',
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Criar sua primeira p\xe1gina",
    'project-pages.improvement.transient-states.empty-state.description': "Crie algumas anota\xe7\xf5es de reuni\xe3o, requisitos de produtos, decis\xf5es ou outros assuntos para ver este espa\xe7o ser preenchido.",
    'project-pages.improvement.transient-states.empty-state.title': "N\xe3o tem nada aqui, s\xf3 potencial",
    'project-pages.improvement.try-button': 'Experimente este template no Confluence',
    'project-pages.improvement.try-it-now': 'Testar agora',
    'project-pages.improvement.try-lozenge': 'avaliar',
    'project-pages.improvement.try-on-demand-button': "Teste gr\xe1tis",
    'project-pages.page-deleted-flag.title': "P\xe1gina exclu\xedda.",
    'project-pages.page-published-flag.title': "A p\xe1gina foi publicada.",
    'project-pages.unknown-error.description': "{contactSupport} se a atualiza\xe7\xe3o n\xe3o funcionar.",
    'project-pages.unknown-error.heading': "N\xe3o \xe9 poss\xedvel exibir as p\xe1ginas do projeto agora",
    'projectpages.templatepreview.termsandprivacy': "Ao clicar em &quot;Testar gr\xe1tis&quot;, voc\xea faz a inscri\xe7\xe3o no Confluence e concorda com os <termsOfServiceLinkText>Termos de servi\xe7o</termsOfServiceLinkText> e a <privacyPolicyLinkText>Pol\xedtica de Privacidade</privacyPolicyLinkText> do Atlassian Cloud."
};

});

parcelRegister("7c9Jf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5d74836f579b78e$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Portugal)
var $c5d74836f579b78e$export$2e2bcd8739ae039 = {
    'project-pages.connect-space-dialog.connection-error': "Falha da liga\xe7\xe3o.",
    'project-pages.connect-space-dialog.connection-retry': 'Tentar novamente',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Este projeto tem de estar ligado a um espa\xe7o antes de o utilizador poder criar uma p\xe1gina. Selecione um espa\xe7o para ligar a este projeto.",
    'project-pages.connect-space-dialog.error-icon': 'Erro:',
    'project-pages.connect-space-dialog.footer.cancel': 'Cancelar',
    'project-pages.connect-space-dialog.footer.connect-space': 'Ligar',
    'project-pages.connect-space.description': "Os espa\xe7os s\xe3o como pastas, pode utiliz\xe1-los para criar, organizar e colaborar em todo o conte\xfado relacionado com o seu projeto.",
    'project-pages.create-space-dialog.connection-error': "Falha da liga\xe7\xe3o.",
    'project-pages.create-space-dialog.connection-retry': 'Tentar novamente',
    'project-pages.create-space-dialog.content.empty-name': "Atribua um nome ao seu espa\xe7o.",
    'project-pages.create-space-dialog.content.invalid-name': "Os nomes de espa\xe7o t\xeam de incluir pelo menos uma letra ou n\xfamero.",
    'project-pages.create-space-dialog.content.placeholder': "Introduza um nome de espa\xe7o",
    'project-pages.create-space-dialog.creation-error': "Falha ao criar o espa\xe7o.",
    'project-pages.create-space-dialog.error-icon': 'Erro:',
    'project-pages.create-space-dialog.footer.cancel': 'Cancelar',
    'project-pages.create-space-dialog.footer.create-space': 'Criar',
    'project-pages.create-space-dialog.header.title': "Criar novo espa\xe7o do Confluence",
    'project-pages.default-contextual-message': "Crie, partilhe e colabore nos documentos do seu projeto num s\xf3 local, com as p\xe1ginas Confluence.",
    'project-pages.default-reactivate-CTA': 'Reativar o Confluence',
    'project-pages.default-trial-CTA': "Experimente o Confluence gr\xe1tis durante 30 dias",
    'project-pages.generic-error.button.reload': "Recarregar p\xe1gina",
    'project-pages.generic-error.description': 'Ocorreu um erro. Tente novamente mais tarde.',
    'project-pages.generic-error.heading': "Bem, isto \xe9 constrangedor..."
};

});

parcelRegister("iLQyM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d903b505549a54fe$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $d903b505549a54fe$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u042D\u0442\u043E \u0437\u0430\u0439\u043C\u0435\u0442 \u043C\u0435\u043D\u0435\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
    'confluence.project-pages.improvement.provisioning-background.title': "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u0413\u043E\u0442\u043E\u0432\u043E",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u0414\u0430\u043B\u0435\u0435",
    'project-pages.activating.description': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0439 \u0440\u0430\u0437\u0434\u0435\u043B Confluence \u043F\u043E\u043A\u0430 \u043D\u0435 \u0433\u043E\u0442\u043E\u0432. \u0415\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0435 \u0440\u0435\u0448\u0430\u0435\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.activating.heading': "Confluence \u0432\u0441\u0435 \u0435\u0449\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0442\u0441\u044F",
    'project-pages.button.connect-different-space-or-page.label': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0437\u043D\u0430\u0447\u043E\u043A \u0440\u0430\u0437\u0434\u0435\u043B\u0430 \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u043A \u0434\u0440\u0443\u0433\u043E\u043C\u0443 \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435",
    'project-pages.button.connect-space-or-page.tooltip': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0432 Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0440\u0430\u0437\u0434\u0435\u043B \u0432 Confluence",
    'project-pages.connect-space-dialog.connection-error': "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438.",
    'project-pages.connect-space-dialog.connection-retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0430\u0437\u0434\u0435\u043B \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "\u041F\u043E\u0438\u0441\u043A \u0432 Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u0427\u0442\u043E\u0431\u044B \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443, \u043D\u0443\u0436\u043D\u043E \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442 \u043A \u043E\u0434\u043D\u043E\u043C\u0443 \u0438\u0437 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u0432. \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0430\u0437\u0434\u0435\u043B \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043A \u044D\u0442\u043E\u043C\u0443 \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'project-pages.connect-space-dialog.error-icon': "\u041E\u0448\u0438\u0431\u043A\u0430:",
    'project-pages.connect-space-dialog.footer.cancel': "\u041E\u0442\u043C\u0435\u043D\u0430",
    'project-pages.connect-space-dialog.footer.connect-space': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C",
    'project-pages.connect-space-or-page-dialog.header.title': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043A Confluence",
    'project-pages.connect-space.description': "\u0420\u0430\u0437\u0434\u0435\u043B\u044B \u0430\u043D\u0430\u043B\u043E\u0433\u0438\u0447\u043D\u044B \u043F\u0430\u043F\u043A\u0430\u043C: \u0438\u0445 \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0434\u043B\u044F \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F, \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u0438 \u0438 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E\u0433\u043E \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043B\u044E\u0431\u043E\u0433\u043E \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0433\u043E \u0441 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C.",
    'project-pages.connect-space.not-connected.description': "\u0414\u043B\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0441\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u043E\u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u0438\u043B\u0438 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0435\u0433\u043E \u043A Confluence.",
    'project-pages.connect-space.not-connected.heading': "\u041D\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u043A Confluence",
    'project-pages.connect-success-flag.description.content': "\u0421\u0432\u044F\u0437\u044C \u0441 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u043E\u043C {connectedSpaceOrPageName} \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0430.",
    'project-pages.connection-error.space-or-page-not-found.button': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A \u0434\u0440\u0443\u0433\u043E\u043C\u0443 \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435",
    'project-pages.create-space-dialog.connection-error': "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438.",
    'project-pages.create-space-dialog.connection-retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
    'project-pages.create-space-dialog.content.empty-name': "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0438\u043C\u044F \u0440\u0430\u0437\u0434\u0435\u043B\u0430.",
    'project-pages.create-space-dialog.content.invalid-name': "\u0418\u043C\u044F \u0440\u0430\u0437\u0434\u0435\u043B\u0430 \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u043A\u0430\u043A \u043C\u0438\u043D\u0438\u043C\u0443\u043C \u0438\u0437 \u043E\u0434\u043D\u043E\u0439 \u0431\u0443\u043A\u0432\u044B \u0438\u043B\u0438 \u0446\u0438\u0444\u0440\u044B.",
    'project-pages.create-space-dialog.content.placeholder': "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043C\u044F \u0440\u0430\u0437\u0434\u0435\u043B\u0430",
    'project-pages.create-space-dialog.creation-error': "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u0440\u0430\u0437\u0434\u0435\u043B\u0430.",
    'project-pages.create-space-dialog.error-icon': "\u041E\u0448\u0438\u0431\u043A\u0430:",
    'project-pages.create-space-dialog.footer.cancel': "\u041E\u0442\u043C\u0435\u043D\u0430",
    'project-pages.create-space-dialog.footer.create-space': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C",
    'project-pages.create-space-dialog.header.title': "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u0430 Confluence",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u0412\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430, \u043F\u043E\u0441\u043A\u043E\u043B\u044C\u043A\u0443 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u043E\u0442\u043A\u0430\u0437\u0430\u043B \u0432\u0430\u043C \u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u0435 \u043A Confluence. \u041E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F.",
    'project-pages.cross-join.access-revoked.templates.title': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u043F\u0440\u0430\u0432 \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.cross-join.avatar.view-profile': "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044C",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u0412\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430, \u043F\u043E\u0441\u043A\u043E\u043B\u044C\u043A\u0443 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0430\u0439\u0442\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u0438\u043B \u0432\u0430\u0448 \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043A Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u043E\u0442\u043A\u0430\u0437\u0430\u043B \u0432\u0430\u043C \u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u0435",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A Confluence. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0430\u0439\u0442\u0430 \u0443\u0436\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u043B \u0432\u0430\u0448 \u0437\u0430\u043F\u0440\u043E\u0441.",
    'project-pages.cross-join.errors.unknown-error.description': "\u0415\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u043F\u043E\u043C\u043E\u0433\u0430\u0435\u0442, {contactSupport}.",
    'project-pages.cross-join.errors.unknown-error.title': "\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.cross-join.inline-join-product.button': "\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A Confluence. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0430\u0439\u0442\u0430 \u0443\u0436\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u043B \u0435\u0433\u043E \u0434\u043B\u044F \u0432\u0430\u0441.",
    'project-pages.cross-join.inline-join-product.connected.description': "\u041F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0439\u0442\u0435, \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u0438 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E \u0432 \u043E\u0434\u043D\u043E\u043C \u043C\u0435\u0441\u0442\u0435",
    'project-pages.cross-join.inline-join-product.connected.title': "\u0412\u0435\u0434\u0438\u0442\u0435 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443 \u0441 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439 \u043D\u0430\u0434 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0430\u0439\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u043B \u0432\u0430\u0448 \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043A Confluence. \u0415\u0441\u043B\u0438 \u043E\u043D \u0431\u0443\u0434\u0435\u0442 \u0443\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D, \u0432\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0432\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E \u0434\u043B\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432.",
    'project-pages.cross-join.pending-request.templates.title': "\u0412\u044B \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u043B\u0438 \u0434\u043E\u0441\u0442\u0443\u043F \u043A Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u0417\u0430\u043F\u0440\u043E\u0441 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u041F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0439\u0442\u0435, \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u0438 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u043D\u0443\u044E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E \u0432\u043C\u0435\u0441\u0442\u0435 \u0441 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439",
    'project-pages.cross-join.request-access.button': "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043A\u043D\u043E\u043F\u043A\u0443 \xab\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u043A\u043E\u043C\u0430\u043D\u0434\u0435\xbb, \u0432\u044B \u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A Confluence \u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0432\u043E\u0438\u043C \u043F\u0440\u043E\u0444\u0438\u043B\u0435\u043C Atlassian \u0441 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u043C.",
    'project-pages.cross-join.request-access.button.experimental': "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u043A\u043E\u043C\u0430\u043D\u0434\u0435",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u0412\u0430\u0448\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432, \u0447\u0442\u043E\u0431\u044B \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E \u043F\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u043C, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u043D\u0430\u0434 \u043D\u0435\u0439 \u043F\u0440\u044F\u043C\u043E \u0432 Jira. \u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0439\u0442\u0435\u0441\u044C \u043A Confluence, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0432\u0430\u0448\u0435\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u044B.",
    'project-pages.cross-join.request-access.title': "\u0414\u043B\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0434\u043E\u0441\u0442\u0443\u043F \u043A Confluence",
    'project-pages.cross-join.request-access.title.experiment': "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0435\u0434\u0438\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u044B\u0439 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
    'project-pages.default-contextual-heading': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0435 Confluence",
    'project-pages.default-contextual-message': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B, \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0438\u043C\u0438 \u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u043E\u0432\u044B\u0432\u0430\u0439\u0442\u0435 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 \u043E\u0434\u043D\u043E\u043C \u043C\u0435\u0441\u0442\u0435 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446 Confluence.",
    'project-pages.default-reactivate-CTA': "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0443\u0439\u0442\u0435 Confluence",
    'project-pages.default-trial-CTA': "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 Confluence \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 30\xa0\u0434\u043D\u0435\u0439",
    'project-pages.draft-saved-flag.action': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A",
    'project-pages.draft-saved-flag.description': "\u0414\u043E \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A \u0432\u0438\u0434\u0435\u043D \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u0430\u043C.",
    'project-pages.draft-saved-flag.title': "\u0427\u0435\u0440\u043D\u043E\u0432\u0438\u043A \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D",
    'project-pages.embedded-pages.create-page-error.close-button': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    'project-pages.embedded-pages.create-page-error.description': "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
    'project-pages.embedded-pages.create-page-error.title': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    'project-pages.embedded-pages.modal.close.button.hint': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    'project-pages.embedded-pages.modal.title.button': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432 Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043D\u0430 \u043D\u043E\u0432\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435",
    'project-pages.errors.unknown-error.description.non-final': "\u0415\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0435 \u0440\u0435\u0448\u0430\u0435\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.errors.unknown-error.title.non-final': "\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.generic-error.button.reload': "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'project-pages.generic-error.description': "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u043F\u043E\u0437\u0436\u0435.",
    'project-pages.generic-error.description.non-final': "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u043F\u043E\u0437\u0436\u0435.",
    'project-pages.generic-error.heading': "\u041D\u0430\u043C \u0442\u0430\u043A \u043D\u0435\u043B\u043E\u0432\u043A\u043E...",
    'project-pages.generic-error.title.non-final': "\u041D\u0430\u043C \u0442\u0430\u043A \u043D\u0435\u043B\u043E\u0432\u043A\u043E...",
    'project-pages.generic-info-flag.description': "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443. \u0415\u0441\u043B\u0438 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u043D\u0435 \u0438\u0441\u0447\u0435\u0437\u043D\u0435\u0442, \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438.",
    'project-pages.generic-success-flag.description.page': "\u0421\u0432\u044F\u0437\u044C \u0441\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435\u0439 {connectedSpaceOrPageName} \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0430.",
    'project-pages.generic-success-flag.description.space': "\u0421\u0432\u044F\u0437\u044C \u0441 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u043C {connectedSpaceOrPageName} \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0430.",
    'project-pages.generic-success-flag.heading.page': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0430",
    'project-pages.generic-success-flag.heading.space': "\u0420\u0430\u0437\u0434\u0435\u043B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u0418\u043B\u0438 \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0440\u0430\u0437\u0434\u0435\u043B",
    'project-pages.granular-pages.connect-space.button': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A Confluence",
    'project-pages.granular-pages.connect-space.heading': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442 \u043A \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 Confluence",
    'project-pages.granular-pages.connect-space.heading.non-final': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442 \u043A \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 Confluence",
    'project-pages.improvement.contact-support': "\u041E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438",
    'project-pages.improvement.errors.access-error.description': "\u0414\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u044C\u0441\u044F \u043A \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443 \u0441\u0430\u0439\u0442\u0430.",
    'project-pages.improvement.errors.access-error.title': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u044D\u0442\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u041F\u0440\u0438 \u043F\u043E\u043F\u044B\u0442\u043A\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0438\u0437 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u0430 Confluence \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u0415\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0435 \u0440\u0435\u0448\u0430\u0435\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u0412\u043E\u0437\u043D\u0438\u043A\u043B\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0441 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043C \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0439 \u0440\u0430\u0437\u0434\u0435\u043B \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 Confluence \u0431\u044B\u043B\u0438 \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u044B, \u0437\u0430\u0430\u0440\u0445\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u0438\u043B\u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u044B. \u0415\u0441\u043B\u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043D\u0435 \u0440\u0435\u0448\u0438\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, <link>\u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438</link>",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u0420\u0430\u0437\u0434\u0435\u043B \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B",
    'project-pages.improvement.errors.unknown-error.description': "\u0415\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0435 \u0440\u0435\u0448\u0430\u0435\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.improvement.errors.unknown-error.title': "\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.improvement.feature1': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043F\u0440\u044F\u043C\u043E \u0432 Jira",
    'project-pages.improvement.feature2': "\u0428\u0430\u0431\u043B\u043E\u043D\u044B \u0441\u043E\u0431\u0440\u0430\u043D\u0438\u0439, \u043F\u043B\u0430\u043D\u044B \u0441\u043F\u0440\u0438\u043D\u0442\u043E\u0432 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438",
    'project-pages.improvement.feature3': "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0441 Jira \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F",
    'project-pages.improvement.heading-info': "\u041D\u0430\u043A\u0430\u043F\u043B\u0438\u0432\u0430\u0439\u0442\u0435 \u0437\u043D\u0430\u043D\u0438\u044F \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438 \u0441\u043F\u0440\u0430\u0432\u043B\u044F\u0439\u0442\u0435\u0441\u044C \u0441 \u0440\u0430\u0431\u043E\u0442\u043E\u0439 \u0432\u0441\u0435 \u043B\u0443\u0447\u0448\u0435.",
    'project-pages.improvement.heading-info-v2': "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0435\u0434\u0438\u043D\u043E\u0435 \u043C\u0435\u0441\u0442\u043E \u0434\u043B\u044F \u0432\u0441\u0435\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u043F\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0443",
    'project-pages.improvement.learn-more-button': "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
    'project-pages.improvement.powered-by': "\u041F\u0440\u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0435",
    'project-pages.improvement.powered-by.tooltip': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C Confluence \u043D\u0430 \u043D\u043E\u0432\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435",
    'project-pages.improvement.preview-teaser': "\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0448\u0430\u0431\u043B\u043E\u043D\u044B, \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0438 \u043C\u043D\u043E\u0433\u043E\u0435 \u0434\u0440\u0443\u0433\u043E\u0435.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u043E\u0442\u0447\u0435\u0442\u044B \u043F\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u043C \u0432 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u043C \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0438 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0435\u043C\u044B\u0445 \u043C\u0435\u0442\u043E\u043A \u0441\u0442\u0430\u0442\u0443\u0441\u0430.</p> <p>\u041F\u0440\u043E\u0441\u0442\u043E \u0441\u0432\u044F\u0436\u0438\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443 Jira \u0441 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u043C, \u0438 \u0432 \u043D\u0435\u043C \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u043C\u0435\u0442\u043A\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0430, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u0431\u0443\u0434\u0435\u0442 \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u043D\u043E \u0441 \u0437\u0430\u044F\u0432\u043A\u043E\u0439, \u0442\u0430\u043A \u0447\u0442\u043E \u0432\u0430\u043C \u043D\u0435 \u043F\u0440\u0438\u0434\u0435\u0442\u0441\u044F \u0442\u0440\u0430\u0442\u0438\u0442\u044C \u0432\u0440\u0435\u043C\u044F \u043D\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043E\u0442\u0447\u0435\u0442\u043E\u0432 \u0432\u0440\u0443\u0447\u043D\u0443\u044E.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u041F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u043E \u0434\u0435\u0440\u0436\u0438\u0442\u0435 \u0437\u0430\u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043B\u0438\u0446 \u0432 \u043A\u0443\u0440\u0441\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u0439",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0435\u0434\u0438\u043D\u043E\u043E\u0431\u0440\u0430\u0437\u043D\u0443\u044E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0443\u0434\u043E\u0431\u043D\u044B\u0445 \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0445 \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u043F\u043E\u0434 \u0432\u0430\u0448\u0438 \u043F\u043E\u0442\u0440\u0435\u0431\u043D\u043E\u0441\u0442\u0438.</p> <p>\u0428\u0430\u0431\u043B\u043E\u043D\u044B \u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0442\u044C \u043F\u0440\u044F\u043C\u043E \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430, \u043D\u0435 \u043E\u0442\u0440\u044B\u0432\u0430\u044F\u0441\u044C \u043E\u0442 \u0440\u0430\u0431\u043E\u0442\u044B. \u0412\u0441\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u044B \u0441\u043C. <a>\u0437\u0434\u0435\u0441\u044C</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0435\u0434\u0438\u043D\u044B\u0435 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u044B \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E \u0438 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0439\u0442\u0435 \u0435\u044E \u043D\u0430 \u0432\u043A\u043B\u0430\u0434\u043A\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0432 Jira. \u042D\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u0432\u043D\u0435\u0434\u0440\u0438\u0442\u044C \u0435\u0434\u0438\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u044B\u0439 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A \u0432\u0430\u0436\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.</p> <p>\u0417\u043D\u0430\u0435\u0442\u0435 \u043B\u0438 \u0432\u044B, \u0447\u0442\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0440\u0430\u0431\u043E\u0442\u0430\u044E\u0442 \u0432 Confluence? \u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0434\u043E 10\xa0\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439. \u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435 \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u0420\u0430\u0431\u043E\u0442\u0430 \u0441\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u0440\u044F\u043C\u043E \u0432 Jira",
    'project-pages.improvement.templates.blank-page.description': "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0441 \u0447\u0438\u0441\u0442\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430.",
    'project-pages.improvement.templates.blank-page.name': "\u041F\u0443\u0441\u0442\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
    'project-pages.improvement.templates.decision.description': "\u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432\u0430\u0436\u043D\u044B\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043F\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u0438 \u043E\u0431\u0441\u0443\u0434\u0438\u0442\u0435 \u0438\u0445 \u0441\u043E \u0441\u0432\u043E\u0435\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439.",
    'project-pages.improvement.templates.decision.name': "\u0420\u0435\u0448\u0435\u043D\u0438\u0435",
    'project-pages.improvement.templates.meeting-notes.description': "\u041F\u043B\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 \u0432\u0441\u0442\u0440\u0435\u0447\u0438, \u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0437\u0430\u043C\u0435\u0442\u043A\u0438 \u0438 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0437\u0430\u0434\u0430\u043D\u0438\u044F\u043C\u0438 \u0441 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439.",
    'project-pages.improvement.templates.meeting-notes.name': "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u044B \u0441\u043E\u0431\u0440\u0430\u043D\u0438\u0439",
    'project-pages.improvement.templates.post-expand.more': "\u0414\u0440\u0443\u0433\u0438\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u044B",
    'project-pages.improvement.templates.post-expand.more.tooltip': "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u044B \u0432 Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u044B",
    'project-pages.improvement.templates.post-expand.title': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'project-pages.improvement.templates.pre-expand.more': "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0434\u0440\u0443\u0433\u0438\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u044B",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u043E \u0443 \u0430\u043D\u0430\u043B\u043E\u0433\u0438\u0447\u043D\u044B\u0445 \u043A\u043E\u043C\u0430\u043D\u0434",
    'project-pages.improvement.templates.pre-expand.title': "\u041F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432",
    'project-pages.improvement.templates.product-requirements.description': "\u041E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435, \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0438 \u043E\u0446\u0435\u043D\u043A\u0430 \u043E\u0431\u044A\u0435\u043C\u0430 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0439 \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430 \u0438\u043B\u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u0438.",
    'project-pages.improvement.templates.product-requirements.name': "\u0422\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F \u043A \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443",
    'project-pages.improvement.templates.retrospective.description': "\u0427\u0442\u043E \u0443\u0436\u0435 \u0441\u0434\u0435\u043B\u0430\u043D\u043E? \u0427\u0442\u043E \u043C\u043E\u0436\u043D\u043E \u0443\u043B\u0443\u0447\u0448\u0438\u0442\u044C? \u0421\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u0430\u044F \u0440\u0430\u0431\u043E\u0442\u0430 \u0432\u0430\u0448\u0435\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u043D\u0430\u0434 \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F\u043C\u0438.",
    'project-pages.improvement.templates.retrospective.name': "\u0420\u0435\u0442\u0440\u043E\u0441\u043F\u0435\u043A\u0442\u0438\u0432\u0430",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u0421\u043D\u0430\u0447\u0430\u043B\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0440\u0430\u0437\u0434\u0435\u043B Confluence",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\u042D\u043A\u043E\u043D\u043E\u043C\u0438\u044F \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0438 \u0441\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u043C\u044B\u0445 \u0432\u0440\u0443\u0447\u043D\u0443\u044E \u0437\u0430\u0434\u0430\u0447</b>. \u0412 Confluence \u0435\u0441\u0442\u044C \u043C\u043D\u043E\u0436\u0435\u0441\u0442\u0432\u043E <a>\u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432</a> \u0441\u0442\u0440\u0430\u043D\u0438\u0446, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u0432\u0430\u043C \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u043F\u0440\u0438\u0434\u0435\u0442\u0441\u044F \u043D\u0430\u0447\u0438\u043D\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0441 \u0447\u0438\u0441\u0442\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430. \u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0448\u0430\u0431\u043B\u043E\u043D\u044B \u0434\u043B\u044F \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u0438, \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432 \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A, \u043F\u043B\u0430\u043D\u043E\u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432, \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0439 \u043A \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430\u043C \u0438 \u043C\u043D\u043E\u0433\u043E\u0433\u043E \u0434\u0440\u0443\u0433\u043E\u0433\u043E.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u0423\u0434\u043E\u0431\u043D\u043E\u0435 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0438 \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435.</b> \u0414\u043B\u044F \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0442\u0435\u043A\u0441\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0432\u0435\u0440\u0445\u043D\u0435\u0435 \u043C\u0435\u043D\u044E \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F, \u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043A\u043E\u043C\u0430\u043D\u0434\u044B <b>/</b> \u043C\u043E\u0436\u043D\u043E \u043B\u0435\u0433\u043A\u043E \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043C\u043D\u043E\u0436\u0435\u0441\u0442\u0432\u043E \u0443\u0434\u043E\u0431\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0439. \u0414\u043B\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0438 \u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u0443 <c>/\u0442\u0430\u0431\u043B\u0438\u0446\u0430</c>, \u0434\u043B\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0438 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\xa0\u2014 <c>/\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435</c>. \u041C\u043E\u0436\u043D\u043E \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0438 Dropbox (<c>/dropbox</c>), \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u044B Microsoft Office (<c>/microsoft</c>) \u0438\u043B\u0438 \u0434\u043E\u0441\u043A\u0438 \u0438 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438 Trello (<c>/trello</c>).",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u0412\u0435\u0434\u0438\u0442\u0435 \xab/\xbb, \u0430 \u0437\u0430\u0442\u0435\u043C \xab\u0442\u0430\u0431\u043B\u0438\u0446\u0430\xbb \u0438\u043B\u0438 \xab\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\xbb",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u0412\u043E\u0442 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u043E\u0432\u0435\u0442\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043F\u043E\u043C\u043E\u0433\u0443\u0442 \u0432\u0430\u043C \u043D\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443.",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u0423\u0434\u043E\u0431\u043D\u044B\u0435 \u0441\u0441\u044B\u043B\u043A\u0438",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "\u0421\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 Jira \u0438 Confluence",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0433\u0440\u0430\u0444\u0438\u043A\u0438 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0445, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0440\u0435\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 Jira. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 <c>/\u0433\u0440\u0430\u0444\u0438\u043A\u0438 Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 \u0437\u0430\u0434\u0430\u0447\u0438 Jira \u0432 \u043B\u044E\u0431\u043E\u043C \u043C\u0435\u0441\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B. \u041F\u0440\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0438 \u0437\u0430\u0434\u0430\u0447\u0438 Jira \u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0431\u0443\u0434\u0435\u0442 \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u0412\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0439\u0442\u0435 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u0434\u043E\u0440\u043E\u0436\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u044B \u0438 \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u044B Jira. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 <c>/\u0434\u043E\u0440\u043E\u0436\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430 jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u0412\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0439\u0442\u0435 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u044B Jira. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 <c>/\u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u044F Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 Jira Software \u043E\u0442\u043C\u0435\u0442\u0438\u043B\u0438, \u0447\u0442\u043E \u043F\u043E\u0441\u043B\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F Confluence \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0443\u0441\u043A\u043E\u0440\u0438\u043B\u0430\u0441\u044C.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 Jira \u043E\u0442\u043C\u0435\u0442\u0438\u043B\u0438, \u0447\u0442\u043E \u043F\u043E\u0441\u043B\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F Confluence \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0443\u0441\u043A\u043E\u0440\u0438\u043B\u0430\u0441\u044C",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u0432 \u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446</b>. \u0420\u0430\u0437\u0434\u0435\u043B\u044B\xa0\u2014 \u043D\u0435\u043E\u0442\u044A\u0435\u043C\u043B\u0435\u043C\u0430\u044F \u0447\u0430\u0441\u0442\u044C \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0441\u0430\u0439\u0442\u0430 Confluence. \u041E\u043D\u0438 \u043F\u043E\u043C\u043E\u0433\u0430\u044E\u0442 \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u043E \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u043C. \u0420\u0430\u0437\u0434\u0435\u043B\u044B \u043C\u043E\u0436\u043D\u043E \u0440\u0430\u0441\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u043A\u0430\u043A \u043F\u0430\u043F\u043A\u0438 \u0438\u043B\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u044B, \u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B\xa0\u2014 \u043A\u0430\u043A \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0430\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u0432 \u044D\u0442\u0438\u0445 \u043F\u0430\u043F\u043A\u0430\u0445 \u0438\u043B\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u0445. <a>\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E\u0431 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u0432</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C",
    'project-pages.improvement.templates.tutorial.description': "\u0423\u0437\u043D\u0430\u0439\u0442\u0435, \u043A\u0430\u043A \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
    'project-pages.improvement.templates.tutorial.name': "\u0414\u043E\u0431\u0440\u043E \u043F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430!",
    'project-pages.improvement.terms-and-conditions-v2': "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043A\u043D\u043E\u043F\u043A\u0443 \xab\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0441\u0435\u0439\u0447\u0430\u0441\xbb, \u0432\u044B \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u0432 Confluence, \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442\u0435 <termsLink>\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432 Atlassian Cloud</termsLink> \u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441 <privacyLink>\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 Atlassian</privacyLink>.",
    'project-pages.improvement.title': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\u041C\u044B \u0434\u043E\u0431\u0430\u0432\u0438\u043B\u0438 Confluence, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043C\u043E\u0433\u043B\u0438 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043B\u044E\u0431\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0438 \u0441\u0432\u044F\u0437\u044B\u0432\u0430\u0442\u044C \u0438\u0445 \u0441 \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u043C\u0438. \u0414\u043E 10\xa0\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043F\u0435\u0440\u0432\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'project-pages.improvement.transient-states.empty-state.description': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u044B \u0441\u043E\u0431\u0440\u0430\u043D\u0438\u0439, \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F \u043A \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443, \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u043E\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0440\u0430\u0437\u0434\u0435\u043B.",
    'project-pages.improvement.transient-states.empty-state.title': "\u0417\u0434\u0435\u0441\u044C \u043D\u0435\u0442 \u043D\u0438\u0447\u0435\u0433\u043E, \u043A\u0440\u043E\u043C\u0435 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u0430",
    'project-pages.improvement.try-button': "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u044D\u0442\u043E\u0442 \u0448\u0430\u0431\u043B\u043E\u043D \u0432 Confluence",
    'project-pages.improvement.try-it-now': "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C",
    'project-pages.improvement.try-lozenge': "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C",
    'project-pages.improvement.try-on-demand-button': "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E",
    'project-pages.page-deleted-flag.title': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430.",
    'project-pages.page-published-flag.title': "\u0412\u0430\u0448\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u0430.",
    'project-pages.unknown-error.description': "\u0415\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0435 \u0440\u0435\u0448\u0430\u0435\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.unknown-error.heading': "\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'projectpages.templatepreview.termsandprivacy': "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043A\u043D\u043E\u043F\u043A\u0443 \xab\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E\xbb, \u0432\u044B \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0435\u0442\u0435\u0441\u044C \u0432 Confluence, \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442\u0435 <termsOfServiceLinkText>\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432 Atlassian Cloud</termsOfServiceLinkText> \u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441 <privacyPolicyLinkText>\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438</privacyPolicyLinkText>."
};

});

parcelRegister("c28xq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe26006dfcbc3889$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $fe26006dfcbc3889$export$2e2bcd8739ae039 = {
    'project-pages.connect-space-dialog.connection-error': 'Pripojenie zlyhalo.',
    'project-pages.connect-space-dialog.connection-retry': "Opakova\u0165",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Pred vytvoren\xedm str\xe1nky je nutn\xe9 prepoji\u0165 tento projekt s priestorom. Vyberte priestor, ktor\xfd s t\xfdmto projektom chcete prepoji\u0165.",
    'project-pages.connect-space-dialog.error-icon': 'Chyba:',
    'project-pages.connect-space-dialog.footer.cancel': "Zru\u0161i\u0165",
    'project-pages.connect-space-dialog.footer.connect-space': "Pripoji\u0165",
    'project-pages.connect-space.description': "Priestory s\xfa ako prie\u010Dinky. M\xf4\u017Eete ich pou\u017E\xedva\u0165 na vytv\xe1ranie obsahu s\xfavisiaceho s va\u0161\xedm projektom, jeho organizovanie alebo spolupr\xe1cu na \u0148om.",
    'project-pages.create-space-dialog.connection-error': 'Pripojenie zlyhalo.',
    'project-pages.create-space-dialog.connection-retry': "Opakova\u0165",
    'project-pages.create-space-dialog.content.empty-name': 'Pomenujte svoj priestor.',
    'project-pages.create-space-dialog.content.invalid-name': "N\xe1zvy priestorov musia obsahova\u0165 aspo\u0148 jedno p\xedsmeno alebo \u010D\xedslicu.",
    'project-pages.create-space-dialog.content.placeholder': "Zadajte n\xe1zov priestoru",
    'project-pages.create-space-dialog.creation-error': 'Vytvorenie priestoru sa nepodarilo.',
    'project-pages.create-space-dialog.error-icon': 'Chyba:',
    'project-pages.create-space-dialog.footer.cancel': "Zru\u0161i\u0165",
    'project-pages.create-space-dialog.footer.create-space': "Vytvori\u0165",
    'project-pages.create-space-dialog.header.title': "Vytvori\u0165 nov\xfd priestor Confluence",
    'project-pages.default-contextual-message': "Vytv\xe1rajte dokumenty k projektu, zdie\u013Eajte ich a spolupracujte na nich na jednom mieste so str\xe1nkami Confluence.",
    'project-pages.default-reactivate-CTA': "Znovu aktivova\u0165 Confluence",
    'project-pages.default-trial-CTA': "Vysk\xfa\u0161ajte si aplik\xe1ciu Confluence bezplatne na 30 dn\xed",
    'project-pages.generic-error.button.reload': "Znova na\u010D\xedtajte str\xe1nku",
    'project-pages.generic-error.description': "Nie\u010Do sa pokazilo. Sk\xfaste to znova nesk\xf4r.",
    'project-pages.generic-error.heading': "Ejha, toto je tr\xe1pne..."
};

});

parcelRegister("4u295", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcc3edc0587632bf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $fcc3edc0587632bf$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Esto deber\xeda llevar menos de un minuto",
    'confluence.project-pages.improvement.provisioning-background.title': "Configurando las p\xe1ginas de tu proyecto",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Descartar',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Listo',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Siguiente',
    'project-pages.activating.description': "El espacio conectado de Confluence a\xfan no est\xe1 listo. {contactSupport} si la opci\xf3n de actualizar no soluciona el problema.",
    'project-pages.activating.heading': 'Confluence sigue cargando',
    'project-pages.button.connect-different-space-or-page.label': "Actualizar icono de p\xe1gina o espacio",
    'project-pages.button.connect-different-space-or-page.tooltip': "Conectarse a un espacio o una p\xe1gina diferente",
    'project-pages.button.connect-space-or-page.tooltip': 'Conectarse a Confluence',
    'project-pages.button.go-to-connected-page.tooltip': "Abrir p\xe1gina en Confluence",
    'project-pages.button.go-to-connected-space.tooltip': 'Abrir espacio en Confluence',
    'project-pages.connect-space-dialog.connection-error': "Se ha producido un error en la conexi\xf3n.",
    'project-pages.connect-space-dialog.connection-retry': 'Reintentar',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Elige un espacio o una p\xe1gina para conectarlo a tu proyecto.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Buscar en Confluence',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Este proyecto debe estar conectado a un espacio antes de crear una p\xe1gina. Elige un espacio para conectarlo a este proyecto.",
    'project-pages.connect-space-dialog.error-icon': 'Error:',
    'project-pages.connect-space-dialog.footer.cancel': 'Cancelar',
    'project-pages.connect-space-dialog.footer.connect-space': 'Conectar',
    'project-pages.connect-space-or-page-dialog.header.title': 'Conectar proyecto a Confluence',
    'project-pages.connect-space.description': "Los espacios son como carpetas: puedes usarlos para crear y organizar todo el contenido relacionado con tu proyecto, as\xed como para colaborar en este.",
    'project-pages.connect-space.not-connected.description': "Para usar las p\xe1ginas del proyecto, ponte en contacto con tu administrador o con el responsable de tu equipo para que conecte Confluence con este proyecto.",
    'project-pages.connect-space.not-connected.heading': 'No conectada a Confluence',
    'project-pages.connect-success-flag.description.content': "Conectado con \xe9xito con el contenido {connectedSpaceOrPageName}.",
    'project-pages.connection-error.space-or-page-not-found.button': "Conectarse a un espacio o p\xe1gina diferente",
    'project-pages.create-space-dialog.connection-error': "Se ha producido un error en la conexi\xf3n.",
    'project-pages.create-space-dialog.connection-retry': 'Reintentar',
    'project-pages.create-space-dialog.content.empty-name': 'Pon un nombre a tu espacio.',
    'project-pages.create-space-dialog.content.invalid-name': "Los nombres de espacio deben tener, al menos, una letra o un n\xfamero.",
    'project-pages.create-space-dialog.content.placeholder': 'Introduce un nombre de espacio',
    'project-pages.create-space-dialog.creation-error': 'No se ha podido crear el espacio.',
    'project-pages.create-space-dialog.error-icon': 'Error:',
    'project-pages.create-space-dialog.footer.cancel': 'Cancelar',
    'project-pages.create-space-dialog.footer.create-space': 'Crear',
    'project-pages.create-space-dialog.header.title': 'Crea un espacio de Confluence nuevo',
    'project-pages.cross-join.access-revoked.templates.subtitle': "No puedes usar las p\xe1ginas del proyecto porque el administrador te ha negado el acceso a Confluence. Ponte en contacto con el administrador del sitio para solicitar acceso.",
    'project-pages.cross-join.access-revoked.templates.title': "No tienes permisos para usar las p\xe1ginas del proyecto",
    'project-pages.cross-join.avatar.view-profile': 'Ver perfil',
    'project-pages.cross-join.denied-request.templates.subtitle': "No puedes usar las p\xe1ginas del proyecto porque el administrador del sitio rechaz\xf3 tu solicitud para unirte a Confluence.",
    'project-pages.cross-join.denied-request.templates.title': 'El administrador te ha negado el acceso',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Conseguir\xe1s acceder a Confluence. El administrador del sitio ya ha aprobado tu acceso.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} si la opci\xf3n de actualizar no soluciona el problema.",
    'project-pages.cross-join.errors.unknown-error.title': "No se pueden mostrar las p\xe1ginas del proyecto ahora mismo",
    'project-pages.cross-join.inline-join-product.button': "Conseguir\xe1s acceder a Confluence. El administrador del sitio ya ha aprobado tu acceso.",
    'project-pages.cross-join.inline-join-product.connected.description': "Consulta, edita y crea documentaci\xf3n desde un \xfanico lugar",
    'project-pages.cross-join.inline-join-product.connected.title': "Colaborar en p\xe1ginas del proyecto con tu equipo",
    'project-pages.cross-join.pending-request.templates.subtitle': "El administrador del sitio ha recibido tu solicitud para unirte a Confluence. Si la aprueba, las p\xe1ginas del proyecto comenzar\xe1n a funcionar y te enviaremos un mensaje de correo electr\xf3nico de confirmaci\xf3n.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Recibir\xe1s un correo electr\xf3nico con acceso a las p\xe1ginas de proyectos cuando se apruebe la solicitud.",
    'project-pages.cross-join.pending-request.templates.title': 'Has solicitado acceso a Confluence',
    'project-pages.cross-join.pending-request.templates.title.experiment': 'Solicitud de acceso enviada al administrador',
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Consulta, edita y crea documentaci\xf3n del proyecto con tu equipo",
    'project-pages.cross-join.request-access.button': 'Solicitar acceso',
    'project-pages.cross-join.request-access.button-subtitle.experimental': "Cuando seleccionas \xdanete a tu equipo, pides unirte a Confluence y aceptas compartir tu perfil de Atlassian con tu administrador.",
    'project-pages.cross-join.request-access.button.experimental': 'Unirme al equipo',
    'project-pages.cross-join.request-access.connected.description.experimental': "Tu equipo usa las p\xe1ginas de proyectos para comentar, editar y colaborar en la documentaci\xf3n del proyecto sin salir de Jira. \xdanete a Confluence para acceder a las p\xe1ginas del proyecto de tu equipo.",
    'project-pages.cross-join.request-access.title': "Las p\xe1ginas del proyecto requieren acceso a Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Crea una fuente \xfanica de informaci\xf3n fiable para tu equipo",
    'project-pages.default-contextual-heading': "Las p\xe1ginas de los proyectos se basan en la tecnolog\xeda de Confluence",
    'project-pages.default-contextual-message': "Crea y comparte todos los documentos de tu proyecto en un \xfanico lugar y colabora en ellos con las p\xe1ginas de Confluence.",
    'project-pages.default-reactivate-CTA': 'Reactivar Confluence',
    'project-pages.default-trial-CTA': "Prueba Confluence de manera gratuita durante 30\xa0d\xedas",
    'project-pages.draft-saved-flag.action': 'Abrir borrador',
    'project-pages.draft-saved-flag.description': "Solo t\xfa puedes ver el borrador hasta que lo publiques.",
    'project-pages.draft-saved-flag.title': 'Borrador guardado',
    'project-pages.embedded-pages.create-page-error.close-button': 'Cerrar',
    'project-pages.embedded-pages.create-page-error.description': "Ha habido un problema y no te hemos podido crear una p\xe1gina.",
    'project-pages.embedded-pages.create-page-error.title': "No hemos podido crear una p\xe1gina",
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Volver a intentarlo',
    'project-pages.embedded-pages.modal.close.button.hint': 'Cerrar',
    'project-pages.embedded-pages.modal.title.button': 'Abrir en Confluence',
    'project-pages.embedded-pages.modal.title.button.hint': "Abrir en una nueva pesta\xf1a",
    'project-pages.errors.space-or-page-not-found.title.non-final': "Espacio o p\xe1gina no encontrados",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} si la opci\xf3n de actualizar no soluciona el problema.",
    'project-pages.errors.unknown-error.title.non-final': "No se pueden mostrar las p\xe1ginas del proyecto ahora mismo",
    'project-pages.generic-error.button.reload': "Recargar p\xe1gina",
    'project-pages.generic-error.button.reload.non-final': "Recargar p\xe1gina",
    'project-pages.generic-error.description': "Algo ha ido mal. Int\xe9ntalo de nuevo m\xe1s tarde.",
    'project-pages.generic-error.description.non-final': "Algo ha ido mal. Int\xe9ntalo de nuevo m\xe1s tarde.",
    'project-pages.generic-error.heading': 'Bueno, esto es un poco embarazoso...',
    'project-pages.generic-error.title.non-final': 'Bueno, esto es un poco embarazoso...',
    'project-pages.generic-info-flag.description': "Algo ha ido mal. Int\xe9ntalo de nuevo o ponte en contacto con el servicio de soporte si la incidencia contin\xfaa.",
    'project-pages.generic-success-flag.description.page': "Te has conectado correctamente con la p\xe1gina {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.space': 'Te has conectado correctamente con el espacio {connectedSpaceOrPageName}.',
    'project-pages.generic-success-flag.heading.page': "P\xe1gina conectada",
    'project-pages.generic-success-flag.heading.space': 'Espacio conectado',
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'O crear un espacio nuevo',
    'project-pages.granular-pages.connect-space.button': 'Conectarse a Confluence',
    'project-pages.granular-pages.connect-space.button.non-final': 'Conectarse a Confluence',
    'project-pages.granular-pages.connect-space.heading': "Conecta este proyecto a un espacio o p\xe1gina de Confluence",
    'project-pages.granular-pages.connect-space.heading.non-final': "Conecta este proyecto a un espacio o p\xe1gina de Confluence",
    'project-pages.improvement.contact-support': 'Contacta con el servicio de soporte',
    'project-pages.improvement.errors.access-error.description': 'Intenta ponerte en contacto con el administrador del sitio para pedirle acceso.',
    'project-pages.improvement.errors.access-error.title': "No tienes permiso para ver las p\xe1ginas del proyecto",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Se ha producido un error al intentar mostrar las p\xe1ginas desde el espacio conectado de Confluence. {contactSupport} si la opci\xf3n de actualizar no soluciona el problema.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Tenemos problemas para mostrar las p\xe1ginas del proyecto",
    'project-pages.improvement.errors.space-or-page-not-found.description': "El espacio o la p\xe1gina de Confluence que estaba conectado se ha movido, archivado o eliminado. <link>Ponte en contacto con el servicio de asistencia</link> si volver a conectarte no soluciona las cosas",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Espacio o p\xe1gina no encontrados",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} si la opci\xf3n de actualizar no soluciona el problema.",
    'project-pages.improvement.errors.unknown-error.title': "No se pueden mostrar las p\xe1ginas del proyecto ahora mismo",
    'project-pages.improvement.feature1': 'Crear documentos y acceder a ellos sin salir de Jira',
    'project-pages.improvement.feature2': "Plantillas para reuniones, planes de sprints y mucho m\xe1s",
    'project-pages.improvement.feature3': "Sincronizar documentos en Jira para las actualizaciones autom\xe1ticas",
    'project-pages.improvement.heading-info': 'Capta el conocimiento de tu equipo y mejora la forma de hacer el trabajo.',
    'project-pages.improvement.heading-info-v2': 'Crea un espacio para todos los documentos de los proyectos de tu equipo',
    'project-pages.improvement.learn-more-button': "M\xe1s informaci\xf3n",
    'project-pages.improvement.powered-by': "Con tecnolog\xeda de",
    'project-pages.improvement.powered-by.tooltip': "Abrir Confluence en una pesta\xf1a nueva",
    'project-pages.improvement.preview-teaser': "Desbloquear plantillas, p\xe1ginas de proyectos y mucho m\xe1s.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Mant\xe9n los informes de tus proyectos actualizados con etiquetas de estado que se actualizan autom\xe1ticamente.</p> <p>Solo tienes que vincular un ticket de Jira a un documento y se mostrar\xe1 autom\xe1ticamente una etiqueta de estado que se actualizar\xe1 de forma sincronizada con el ticket, de modo que no tendr\xe1s que perder tiempo creando informes manuales.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Actualiza a la perfecci\xf3n las partes interesadas",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Crea una documentaci\xf3n coherente con nuestras plantillas integradas. Son f\xe1ciles de usar y se pueden personalizar seg\xfan tus necesidades.</p> <p>Puedes usar las plantillas directamente desde las p\xe1ginas del proyecto, as\xed no tendr\xe1s que dejar nunca lo que tengas entre manos. Explora todas las plantillas <a>aqu\xed</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Unifica tus est\xe1ndares de documentaci\xf3n",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Crea una fuente \xfanica de informaci\xf3n importante creando y gestionando la documentaci\xf3n desde la pesta\xf1a de p\xe1ginas de proyectos de Jira.</p> <p>\xbfSab\xedas que las p\xe1ginas de proyectos funcionan en Confluence? Es gratis para un m\xe1ximo de 10\xa0usuarios. Invita al resto de tu equipo a la configuraci\xf3n de administraci\xf3n.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "Tus p\xe1ginas de proyectos directamente en Jira",
    'project-pages.improvement.templates.blank-page.description': "Inicia una p\xe1gina desde cero.",
    'project-pages.improvement.templates.blank-page.name': "P\xe1gina en blanco",
    'project-pages.improvement.templates.decision.description': "Registra las decisiones importantes del proyecto y comun\xedcalas a tu equipo.",
    'project-pages.improvement.templates.decision.name': "Decisi\xf3n",
    'project-pages.improvement.templates.meeting-notes.description': 'Planifica tus reuniones, toma notas y comparte acciones con tu equipo.',
    'project-pages.improvement.templates.meeting-notes.name': 'Notas',
    'project-pages.improvement.templates.post-expand.more': "M\xe1s plantillas",
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Ver todas las plantillas en Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': 'Plantillas populares',
    'project-pages.improvement.templates.post-expand.title': "Crear una p\xe1gina",
    'project-pages.improvement.templates.pre-expand.more': "Explorar m\xe1s plantillas",
    'project-pages.improvement.templates.pre-expand.subtitle': 'Popular en equipos como el tuyo',
    'project-pages.improvement.templates.pre-expand.title': 'Previsualizar plantillas',
    'project-pages.improvement.templates.product-requirements.description': "Define, haz un seguimiento y determina el alcance de los requisitos de tu producto o funci\xf3n.",
    'project-pages.improvement.templates.product-requirements.name': 'Requisitos del producto',
    'project-pages.improvement.templates.retrospective.description': "\xbfQu\xe9 ha funcionado correctamente? \xbfQu\xe9 podr\xeda haber salido mejor? Colabora de forma abierta con tu equipo para sugerir mejoras.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospectiva',
    'project-pages.improvement.templates.template.disabled-tooltip': 'Conecta un espacio de Confluence primero',
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Ahorro de tiempo y reducci\xf3n de tareas manuales</b> Confluence cuenta con muchas <a>plantillas</a> de p\xe1ginas, por lo que nunca tendr\xe1s que empezar de cero. Podr\xe1s crear documentos t\xe9cnicos, gu\xedas de soluci\xf3n de problemas, planes de proyectos, requisitos de productos y mucho m\xe1s.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Edici\xf3n y formato sencillos</b> Usa el men\xfa de edici\xf3n superior para dar formato est\xe1ndar a las palabras o escribe <b>/</b> para insertar f\xe1cilmente todo tipo de integraciones. Inserta una tabla escribiendo <c>/tabla</c> o una imagen con <c>/imagen</c>. Tambi\xe9n puedes insertar enlaces de Dropbox (<c>/dropbox</c>), herramientas de Microsoft Office (<c>/microsoft</c>) o tableros y tarjetas de Trello (<c>/trello</c>).",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Escribe / seguido de "tabla" o "imagen"',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Aqu\xed tienes un par de consejos para empezar:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "Enlaces pr\xe1cticos",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Utiliza Jira y Confluence conjuntamente',
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Crea gr\xe1ficos en tus p\xe1ginas con datos reales de Jira. Escribe <c>/gr\xe1ficos de Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Vincula una incidencia de Jira en cualquier parte de tu p\xe1gina. El enlace de la p\xe1gina se actualizar\xe1 en tiempo real a medida que actualices la incidencia de Jira. Escribe <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Inserta hojas de ruta y cronogramas interactivos en tu p\xe1gina con tus proyectos de Jira. Escribe <c>/hoja de ruta de Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Inserta cronogramas interactivos en tu p\xe1gina con tus proyectos de Jira. Escribe <c>/cronograma de jira</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "El 76\xa0% de los clientes de Jira Software afirman que lanzaron los proyectos m\xe1s r\xe1pido tras a\xf1adir Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "El 76\xa0% de los clientes de Jira afirman que lanzaron los proyectos m\xe1s r\xe1pido tras a\xf1adir Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Uso de espacios y p\xe1ginas</b> Los espacios forman parte de todos los sitios de Confluence y son una forma de organizar las p\xe1ginas por categor\xedas. Los espacios son como carpetas o proyectos diferentes, y las p\xe1ginas son los documentos que pertenecen a esas carpetas o proyectos. <a>M\xe1s informaci\xf3n sobre c\xf3mo usar los espacios</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Probar ahora',
    'project-pages.improvement.templates.tutorial.description': "Aprende a editar una p\xe1gina.",
    'project-pages.improvement.templates.tutorial.name': "\xa1Estas son las p\xe1ginas de Proyecto!",
    'project-pages.improvement.terms-and-conditions-v2': "Al seleccionar &quot;Probar ahora&quot;, admites que te inscribir\xe1s en Confluence y aceptas las <termsLink>Condiciones de servicio</termsLink> y la <privacyLink>Pol\xedtica de privacidad</privacyLink> de Atlassian Cloud.",
    'project-pages.improvement.title': "P\xe1ginas de proyectos",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Crear p\xe1gina",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Hemos a\xf1adido Confluence para que puedas empezar a crear y vincular todos los documentos de tu proyecto. Es gratis para un m\xe1ximo de 10\xa0usuarios.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "M\xe1s informaci\xf3n",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Crea tu primera p\xe1gina",
    'project-pages.improvement.transient-states.empty-state.description': 'Crea notas, requisitos de productos, decisiones u otros contenidos para llenar este espacio.',
    'project-pages.improvement.transient-states.empty-state.title': "Aqu\xed solo hay potencial",
    'project-pages.improvement.try-button': 'Probar este plantilla en Confluence',
    'project-pages.improvement.try-it-now': 'Probar ahora',
    'project-pages.improvement.try-lozenge': "Pru\xe9balo",
    'project-pages.improvement.try-on-demand-button': 'Probar gratis',
    'project-pages.page-deleted-flag.title': "P\xe1gina eliminada.",
    'project-pages.page-published-flag.title': "Tu p\xe1gina se ha publicado.",
    'project-pages.title.non-final': "P\xe1ginas de proyectos",
    'project-pages.unknown-error.description': "{contactSupport} si la opci\xf3n de actualizar no soluciona el problema.",
    'project-pages.unknown-error.heading': "No se pueden mostrar las p\xe1ginas del proyecto ahora mismo",
    'projectpages.templatepreview.termsandprivacy': "Al hacer clic en &quot;Probarlo gratis&quot;, te inscribir\xe1s en Confluence y aceptar\xe1s las <termsOfServiceLinkText>Condiciones de servicio</termsOfServiceLinkText> y la <privacyPolicyLinkText>Pol\xedtica de privacidad</privacyPolicyLinkText> de Atlassian Cloud."
};

});

parcelRegister("7jrrb", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d357ab3e4248bd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $70d357ab3e4248bd$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Detta b\xf6r ta mindre \xe4n en minut",
    'confluence.project-pages.improvement.provisioning-background.title': 'Konfigurera dina projektsidor',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "Avf\xe4rda",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Klar',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "N\xe4sta",
    'project-pages.activating.description': "Det anslutna Confluence-utrymmet \xe4r inte riktigt redo \xe4n. {contactSupport} om det inte hj\xe4lper att uppdatera.",
    'project-pages.activating.heading': "Confluence l\xe4ses fortfarande in",
    'project-pages.button.connect-different-space-or-page.label': "Uppdatera ikon f\xf6r utrymme eller sida",
    'project-pages.button.connect-different-space-or-page.tooltip': 'Anslut ett annat utrymme eller en annan sida',
    'project-pages.button.connect-space-or-page.tooltip': 'Anslut till Confluence',
    'project-pages.button.go-to-connected-page.tooltip': "\xd6ppna sida i Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "\xd6ppna utrymme i Confluence",
    'project-pages.connect-space-dialog.connection-error': 'Anslutningen misslyckades.',
    'project-pages.connect-space-dialog.connection-retry': "F\xf6rs\xf6k igen",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "V\xe4lj ett utrymme eller en sida som du vill ansluta till ditt projekt.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "S\xf6k Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Det h\xe4r projektet beh\xf6ver vara anslutet till ett utrymme innan du kan skapa en sida. V\xe4lj ett utrymme att ansluta till det h\xe4r projektet.",
    'project-pages.connect-space-dialog.error-icon': 'Fel:',
    'project-pages.connect-space-dialog.footer.cancel': 'Avbryt',
    'project-pages.connect-space-dialog.footer.connect-space': 'Anslut',
    'project-pages.connect-space-or-page-dialog.header.title': 'Anslut ett projekt till Confluence',
    'project-pages.connect-space.description': "Utrymmen \xe4r som mappar: du kan anv\xe4nda dem f\xf6r att skapa, organisera och samarbeta p\xe5 allt inneh\xe5ll med anknytning till projektet.",
    'project-pages.connect-space.not-connected.description': "Om du vill anv\xe4nda projektsidor kontaktar du din administrat\xf6r eller teamledare f\xf6r att ansluta Confluence till projektet.",
    'project-pages.connect-space.not-connected.heading': 'Inte anslutet till Confluence',
    'project-pages.connect-success-flag.description.content': "Anslutning har uppr\xe4ttats till {connectedSpaceOrPageName}-inneh\xe5ll.",
    'project-pages.connection-error.space-or-page-not-found.button': 'Anslut till ett annat utrymme eller en annan sida',
    'project-pages.create-space-dialog.connection-error': 'Anslutningen misslyckades.',
    'project-pages.create-space-dialog.connection-retry': "F\xf6rs\xf6k igen",
    'project-pages.create-space-dialog.content.empty-name': 'Ge ditt utrymme ett namn.',
    'project-pages.create-space-dialog.content.invalid-name': "Utrymmesnamn m\xe5ste best\xe5 av minst en bokstav eller siffra.",
    'project-pages.create-space-dialog.content.placeholder': 'Ange ett utrymmesnamn',
    'project-pages.create-space-dialog.creation-error': 'Det gick inte skapa utrymme.',
    'project-pages.create-space-dialog.error-icon': 'Fel:',
    'project-pages.create-space-dialog.footer.cancel': 'Avbryt',
    'project-pages.create-space-dialog.footer.create-space': 'Skapa',
    'project-pages.create-space-dialog.header.title': 'Skapa nytt Confluence-utrymme',
    'project-pages.cross-join.access-revoked.templates.subtitle': "Du kan inte anv\xe4nda projektsidor eftersom administrat\xf6ren har nekat dig \xe5tkomst till Confluence. Kontakta webbplatsadministrat\xf6ren f\xf6r att beg\xe4ra \xe5tkomst.",
    'project-pages.cross-join.access-revoked.templates.title': "Du har inte beh\xf6righet att anv\xe4nda projektsidor",
    'project-pages.cross-join.avatar.view-profile': 'Visa profil',
    'project-pages.cross-join.denied-request.templates.subtitle': "Du kan inte anv\xe4nda projektsidor eftersom webbplatsadministrat\xf6ren nekade din beg\xe4ran om att g\xe5 med i Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "Din administrat\xf6r har nekat dig \xe5tkomst",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Du f\xe5r \xe5tkomst till Confluence. Din webbplatsadministrat\xf6r har redan godk\xe4nt dig.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} om det inte hj\xe4lper att uppdatera.",
    'project-pages.cross-join.errors.unknown-error.title': 'Vi kan inte visa projektsidorna just nu',
    'project-pages.cross-join.inline-join-product.button': "Du f\xe5r \xe5tkomst till Confluence. Din webbplatsadministrat\xf6r har redan godk\xe4nt dig.",
    'project-pages.cross-join.inline-join-product.connected.description': "Visa, redigera och skapa dokumentation fr\xe5n en och samma plats",
    'project-pages.cross-join.inline-join-product.connected.title': "Samarbeta med ditt team p\xe5 projektsidor",
    'project-pages.cross-join.pending-request.templates.subtitle': "Webbplatsadministrat\xf6ren har f\xe5tt din beg\xe4ran att g\xe5 med i Confluence. Om du \xe4r godk\xe4nd att g\xe5 med kommer projektsidorna att b\xf6rja fungera och vi skickar ett bekr\xe4ftelsemeddelande till dig.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Du f\xe5r ett e-postmeddelande med \xe5tkomst till projektsidor n\xe4r du har godk\xe4nts.",
    'project-pages.cross-join.pending-request.templates.title': "Du har beg\xe4rt \xe5tkomst till Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\xc5tkomstf\xf6rfr\xe5gan har skickats till administrat\xf6r",
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'Visa, redigera och skapa projektdokumentation med ditt team',
    'project-pages.cross-join.request-access.button': "Beg\xe4r \xe5tkomst",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "N\xe4r du v\xe4ljer \u201DG\xe5 med i ditt team\u201D ber du om att g\xe5 med i Confluence och samtycker till att dela din Atlassian-profil med administrat\xf6ren.",
    'project-pages.cross-join.request-access.button.experimental': 'Anslut till ditt team',
    'project-pages.cross-join.request-access.connected.description.experimental': "Ditt team anv\xe4nder projektsidor f\xf6r att kommentera, redigera och samarbeta kring projektdokumentation utan att l\xe4mna Jira. G\xe5 med i Confluence f\xf6r att komma \xe5t ditt teams projektsidor.",
    'project-pages.cross-join.request-access.title': "Projektsidor kr\xe4ver \xe5tkomst till Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Skapa en enda sanningsk\xe4lla f\xf6r ditt team",
    'project-pages.default-contextual-heading': 'Projektsidor drivs av Confluence',
    'project-pages.default-contextual-message': "Skapa, dela och samarbeta i alla projektdokument p\xe5 ett st\xe4lle med Confluence-sidor.",
    'project-pages.default-reactivate-CTA': "\xc5teraktivera Confluence",
    'project-pages.default-trial-CTA': 'Prova Confluence gratis i 30 dagar',
    'project-pages.draft-saved-flag.action': "\xd6ppna utkast",
    'project-pages.draft-saved-flag.description': 'Du ser bara ditt utkast tills du publicerar det.',
    'project-pages.draft-saved-flag.title': 'Utkastet har sparats',
    'project-pages.embedded-pages.create-page-error.close-button': "St\xe4ng",
    'project-pages.embedded-pages.create-page-error.description': "Det uppstod ett problem och vi kunde inte skapa en sida \xe5t dig.",
    'project-pages.embedded-pages.create-page-error.title': 'Vi kunde inte skapa en sida',
    'project-pages.embedded-pages.create-page-error.try-again-button': "F\xf6rs\xf6k igen",
    'project-pages.embedded-pages.modal.close.button.hint': "St\xe4ng",
    'project-pages.embedded-pages.modal.title.button': "\xd6ppna i Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "\xd6ppna p\xe5 ny flik",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} om det inte hj\xe4lper att uppdatera.",
    'project-pages.errors.unknown-error.title.non-final': 'Vi kan inte visa projektsidorna just nu',
    'project-pages.generic-error.button.reload': 'Uppdatera sida',
    'project-pages.generic-error.description': "Ett fel intr\xe4ffade. F\xf6rs\xf6k igen senare.",
    'project-pages.generic-error.description.non-final': "Ett fel intr\xe4ffade. F\xf6rs\xf6k igen senare.",
    'project-pages.generic-error.heading': 'Det var konstigt ...',
    'project-pages.generic-error.title.non-final': 'Det var konstigt ...',
    'project-pages.generic-info-flag.description': "N\xe5got gick fel. F\xf6rs\xf6k igen eller kontakta support om problemet kvarst\xe5r",
    'project-pages.generic-success-flag.description.page': "Anslutning har uppr\xe4ttats till sidan {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.space': "Anslutning har uppr\xe4ttats till utrymmet {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.heading.page': 'Sidan har anslutits',
    'project-pages.generic-success-flag.heading.space': 'Utrymme har anslutits',
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'Eller skapa ett nytt utrymme',
    'project-pages.granular-pages.connect-space.button': 'Anslut till Confluence',
    'project-pages.granular-pages.connect-space.heading': 'Anslut projektet till ett Confluence-utrymme eller -sida',
    'project-pages.granular-pages.connect-space.heading.non-final': 'Anslut projektet till ett Confluence-utrymme eller -sida',
    'project-pages.improvement.contact-support': 'Kontakta supporten',
    'project-pages.improvement.errors.access-error.description': "Prova att kontakta webbplatsadministrat\xf6ren f\xf6r att be om \xe5tkomst.",
    'project-pages.improvement.errors.access-error.title': "Du har inte beh\xf6righet att visa projektsidorna",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "N\xe5got gick fel n\xe4r vi f\xf6rs\xf6kte visa sidorna fr\xe5n ditt anslutna Confluence-utrymme. {contactSupport} om det inte hj\xe4lper att uppdatera.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': 'Vi kan inte visa projektsidorna',
    'project-pages.improvement.errors.space-or-page-not-found.description': "Confluence-utrymmet eller -sidan som var ansluten har flyttats, arkiverats eller raderats. <link>Kontakta support</link> om det inte hj\xe4lper att ansluta p\xe5 nytt.",
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Utrymme eller sida hittades inte',
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} om det inte hj\xe4lper att uppdatera.",
    'project-pages.improvement.errors.unknown-error.title': 'Vi kan inte visa projektsidorna just nu',
    'project-pages.improvement.feature1': "Kom \xe5t och skapa dokument utan att l\xe4mna Jira",
    'project-pages.improvement.feature2': "Mallar f\xf6r m\xf6ten, sprintplaner och mer",
    'project-pages.improvement.feature3': "Synkronisera dokument till Jira f\xf6r automatiska uppdateringar",
    'project-pages.improvement.heading-info': "F\xe5nga upp ditt teams kunskaper och f\xf6rb\xe4ttra hur arbete utf\xf6rs.",
    'project-pages.improvement.heading-info-v2': "Skapa en plats f\xf6r teamets samtliga projektdokument",
    'project-pages.improvement.learn-more-button': "L\xe4s mer",
    'project-pages.improvement.powered-by': 'Drivs av',
    'project-pages.improvement.powered-by.tooltip': "\xd6ppna Confluence i en ny flik",
    'project-pages.improvement.preview-teaser': "Kom \xe5t mallar, projektsidor och mycket mer.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>H\xe5ll dina projektrapporter uppdaterade med statusetiketter som uppdateras automatiskt.</p> <p>N\xe4r du l\xe4nkar ett Jira-\xe4rende i ett dokument visar det automatiskt en statusetikett som uppdateras n\xe4r \xe4rendet uppdateras. P\xe5 s\xe5 s\xe4tt beh\xf6ver du inte l\xe4gga tid p\xe5 att skapa manuella rapporter.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': 'Uppdatera effektivt dina intressenter',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Skapa konsekvent dokumentation med hj\xe4lp av v\xe5ra inbyggda mallar. De \xe4r enkla att anv\xe4nda och kan anpassas efter dina behov.</p> <p>Du kan anv\xe4nda mallar direkt fr\xe5n projektsidor. Du beh\xf6ver inte l\xe4mna projektet f\xf6r att h\xe4mta dem. Bl\xe4ddra bland alla mallar <a>h\xe4r</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Skapa en enhetlig dokumentationsstandard',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Skapa en enda sanningsk\xe4lla f\xf6r viktig information genom att skapa och hantera dokumentation fr\xe5n fliken projektsidor i Jira.</p> <p>Visste du att projektsidor k\xf6rs p\xe5 Confluence? Det \xe4r kostnadsfritt f\xf6r upp till 10 anv\xe4ndare. Bjud in resten av teamet i administrat\xf6rsinst\xe4llningarna.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Dina projektsidor, direkt i Jira.',
    'project-pages.improvement.templates.blank-page.description': "B\xf6rja med en tom sida.",
    'project-pages.improvement.templates.blank-page.name': 'Blank sida',
    'project-pages.improvement.templates.decision.description': "Protokollf\xf6r viktiga projektbeslut och kommunicera dem med ditt team.",
    'project-pages.improvement.templates.decision.name': 'Beslut',
    'project-pages.improvement.templates.meeting-notes.description': "Planera dina m\xf6ten, f\xf6r anteckningar och dela \xe5tg\xe4rder med ditt team.",
    'project-pages.improvement.templates.meeting-notes.name': "M\xf6tesanteckningar",
    'project-pages.improvement.templates.post-expand.more': 'Fler mallar',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Visa alla mallar i Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': "Popul\xe4ra mallar",
    'project-pages.improvement.templates.post-expand.title': 'Skapa en sida',
    'project-pages.improvement.templates.pre-expand.more': 'Utforska fler mallar',
    'project-pages.improvement.templates.pre-expand.subtitle': "Popul\xe4ra f\xf6r team som ditt",
    'project-pages.improvement.templates.pre-expand.title': "F\xf6rhandsgranska mallar",
    'project-pages.improvement.templates.product-requirements.description': "Definiera, sp\xe5ra och avgr\xe4nsa krav f\xf6r din produkt eller funktion.",
    'project-pages.improvement.templates.product-requirements.name': 'Produktkrav',
    'project-pages.improvement.templates.retrospective.description': "Vad gick bra? Vad kunde ha g\xe5tt b\xe4ttre? Crowdsourca f\xf6rb\xe4ttringar med ditt team.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektiv',
    'project-pages.improvement.templates.template.disabled-tooltip': "Anslut ett Confluence-utrymme f\xf6rst",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Spara tid och minska m\xe4ngden manuella uppgifter</b> Confluence har m\xe5nga <a>sidmallar</a>, s\xe5 du beh\xf6ver aldrig b\xf6rja fr\xe5n b\xf6rjan. Allt fr\xe5n tekniska dokument, fels\xf6kningsguider, projektplaner och produktkrav till mycket mer.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Redigera och formatera med l\xe4tthet.</b> Anv\xe4nd den \xf6vre redigeringsmenyn f\xf6r standardordformatering och genom att skriva <b>/</b> kan du enkelt infoga en massa anv\xe4ndbara integrationer. Infoga en tabell genom att skriva <c>/table</c> eller en bild med <c>/image</c>. Du kan \xe4ven infoga Dropbox-l\xe4nkar <c>/dropbox</c>, Microsoft Office-verktyg <c>/microsoft</c> eller Trello-tavlor och -kort <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Skriv / f\xf6ljt av \u201Dtable\u201D eller \u201Dimage\u201D",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "H\xe4r f\xf6ljer n\xe5gra tips f\xf6r att komma ig\xe5ng:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "Anv\xe4ndbara l\xe4nkar",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Anv\xe4nd Jira och Confluence tillsammans",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Skapa diagram p\xe5 dina sidor med faktiska Jira-data. Skriv <c>/Jira charts</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "L\xe4nka ett Jira-\xe4rende p\xe5 valfri plats p\xe5 sidan. L\xe4nken p\xe5 sidan uppdateras i realtid samtidigt som Jira-\xe4rendet uppdateras. Skriv <c>/Jira</c>",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "B\xe4dda in interaktiva \xf6versikter och tidslinjer p\xe5 sidan med hj\xe4lp av dina Jira-projekt. Skriv <c>/jira roadmap</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "B\xe4dda in interaktiva tidslinjer p\xe5 sidan med hj\xe4lp av dina Jira-projekt. Skriv <c>/jira tidslinje</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% av Jira Software-kunder uppgav att de levererar projekt snabbare efter att ha lagt till Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% av Jira-kunder uppgav att de levererar projekt snabbare efter att ha lagt till Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Anv\xe4nda utrymmen och sidor</b>. Utrymmen \xe4r en del av varje Confluence-plats och ett bra s\xe4tt att organisera sidor i olika kategorier. T\xe4nk p\xe5 utrymmen som olika mappar eller projekt och sidor som de dokument som h\xf6r hemma i mapparna eller projekten. <a>L\xe4s mer om hur du anv\xe4nder utrymmen</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Testa nu',
    'project-pages.improvement.templates.tutorial.description': "L\xe4r dig hur du redigerar en sida.",
    'project-pages.improvement.templates.tutorial.name': "V\xe4lkommen till projektsidor!",
    'project-pages.improvement.terms-and-conditions-v2': "Genom att klicka p\xe5 Prova nu bekr\xe4ftar du att du registreras i Confluence och samtycker till <termsLink>anv\xe4ndarvillkoren</termsLink> och <privacyLink>sekretesspolicyn</privacyLink> f\xf6r Atlassian Cloud.",
    'project-pages.improvement.title': 'Projektsidor',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Skapa sida',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Vi har lagt till Confluence s\xe5 att du kan b\xf6rja skapa och l\xe4nka alla dina projektdokument. Det \xe4r gratis f\xf6r upp till 10 anv\xe4ndare.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "L\xe4s mer",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Skapa din f\xf6rsta sida",
    'project-pages.improvement.transient-states.empty-state.description': "Skapa m\xf6tesanteckningar, produktkrav, beslut eller annat inneh\xe5ll f\xf6r att fylla utrymmet.",
    'project-pages.improvement.transient-states.empty-state.title': "H\xe4r finns inget annat \xe4n potential",
    'project-pages.improvement.try-button': 'Prova mallen i Confluence',
    'project-pages.improvement.try-it-now': 'Testa nu',
    'project-pages.improvement.try-lozenge': 'Testa',
    'project-pages.improvement.try-on-demand-button': 'Prova gratis',
    'project-pages.page-deleted-flag.title': 'Sidan har raderats.',
    'project-pages.page-published-flag.title': 'Din sida har publicerats.',
    'project-pages.unknown-error.description': "{contactSupport} om det inte hj\xe4lper att uppdatera.",
    'project-pages.unknown-error.heading': 'Vi kan inte visa projektsidorna just nu',
    'projectpages.templatepreview.termsandprivacy': "Genom att klicka p\xe5 Prova kostnadsfritt registreras du i Confluence och samtycker till <termsOfServiceLinkText>anv\xe4ndarvillkoren</termsOfServiceLinkText> och <privacyPolicyLinkText>sekretesspolicyn</privacyPolicyLinkText> f\xf6r Atlassian Cloud."
};

});

parcelRegister("l67jB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5579127c408c4c73$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $5579127c408c4c73$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E08\u0E30\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E25\u0E32\u0E44\u0E21\u0E48\u0E16\u0E36\u0E07\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    'confluence.project-pages.improvement.provisioning-background.title': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u0E16\u0E31\u0E14\u0E44\u0E1B",
    'project-pages.activating.description': "\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confuence \u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E41\u0E25\u0E49\u0E27\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E04\u0E48\u0E2D\u0E22\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 {contactSupport} \u0E2B\u0E32\u0E01\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.activating.heading': "Confluence \u0E22\u0E31\u0E07\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14\u0E2D\u0E22\u0E39\u0E48",
    'project-pages.button.connect-different-space-or-page.label': "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E37\u0E48\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E2D\u0E37\u0E48\u0E19",
    'project-pages.button.connect-space-or-page.tooltip': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19 Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19 Confluence",
    'project-pages.connect-space-dialog.connection-error': "\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
    'project-pages.connect-space-dialog.connection-retry': "\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "\u0E04\u0E49\u0E19\u0E2B\u0E32 Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E19\u0E35\u0E49\u0E01\u0E31\u0E1A\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E01\u0E48\u0E2D\u0E19\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E08\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49 \u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E19\u0E35\u0E49",
    'project-pages.connect-space-dialog.error-icon': "\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14:",
    'project-pages.connect-space-dialog.footer.cancel': "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    'project-pages.connect-space-dialog.footer.connect-space': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D",
    'project-pages.connect-space-or-page-dialog.header.title': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E1B\u0E22\u0E31\u0E07 Confluence",
    'project-pages.connect-space.description': "\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E27\u0E48\u0E32\u0E07\u0E40\u0E1B\u0E23\u0E35\u0E22\u0E1A\u0E40\u0E2A\u0E21\u0E37\u0E2D\u0E19\u0E42\u0E1F\u0E25\u0E40\u0E14\u0E2D\u0E23\u0E4C \u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07 \u0E08\u0E31\u0E14\u0E40\u0E23\u0E35\u0E22\u0E07 \u0E41\u0E25\u0E30\u0E17\u0E33\u0E07\u0E32\u0E19\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19\u0E1A\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.connect-space.not-connected.description': "\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E19\u0E35\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E31\u0E27\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Confluence \u0E01\u0E31\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E19\u0E35\u0E49",
    'project-pages.connect-space.not-connected.heading': "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A Confluence",
    'project-pages.connect-success-flag.description.content': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32 {connectedSpaceOrPageName} \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27",
    'project-pages.connection-error.space-or-page-not-found.button': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E2D\u0E37\u0E48\u0E19",
    'project-pages.create-space-dialog.connection-error': "\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
    'project-pages.create-space-dialog.connection-retry': "\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'project-pages.create-space-dialog.content.empty-name': "\u0E42\u0E1B\u0E23\u0E14\u0E15\u0E31\u0E49\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.create-space-dialog.content.invalid-name': "\u0E0A\u0E37\u0E48\u0E2D\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E15\u0E31\u0E27",
    'project-pages.create-space-dialog.content.placeholder': "\u0E1B\u0E49\u0E2D\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48",
    'project-pages.create-space-dialog.creation-error': "\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
    'project-pages.create-space-dialog.error-icon': "\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14:",
    'project-pages.create-space-dialog.footer.cancel': "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    'project-pages.create-space-dialog.footer.create-space': "\u0E2A\u0E23\u0E49\u0E32\u0E07",
    'project-pages.create-space-dialog.header.title': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confluence \u0E43\u0E2B\u0E21\u0E48",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 Confluence \u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07",
    'project-pages.cross-join.access-revoked.templates.title': "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'project-pages.cross-join.avatar.view-profile': "\u0E14\u0E39\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E04\u0E33\u0E02\u0E2D\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 Confluence \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.cross-join.denied-request.templates.title': "\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E04\u0E33\u0E02\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 Confluence \u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} \u0E2B\u0E32\u0E01\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.cross-join.errors.unknown-error.title': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49",
    'project-pages.cross-join.inline-join-product.button': "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 Confluence \u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
    'project-pages.cross-join.inline-join-product.connected.description': "\u0E14\u0E39 \u0E41\u0E01\u0E49\u0E44\u0E02 \u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E17\u0E33\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E40\u0E14\u0E35\u0E22\u0E27",
    'project-pages.cross-join.inline-join-product.connected.title': "\u0E17\u0E33\u0E07\u0E32\u0E19\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E01\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E33\u0E02\u0E2D\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 Confluence \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E08\u0E30\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E07\u0E32\u0E19\u0E41\u0E25\u0E30\u0E40\u0E23\u0E32\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': '\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 "\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C" \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E41\u0E25\u0E49\u0E27',
    'project-pages.cross-join.pending-request.templates.title': "\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 Confluence \u0E41\u0E25\u0E49\u0E27",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u0E14\u0E39 \u0E41\u0E01\u0E49\u0E44\u0E02 \u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E17\u0E33\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E01\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.cross-join.request-access.button': "\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E40\u0E25\u0E37\u0E2D\u0E01 '\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13' \u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E02\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 Confluence \u0E41\u0E25\u0E30\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E17\u0E35\u0E48\u0E08\u0E30\u0E41\u0E1A\u0E48\u0E07\u0E1B\u0E31\u0E19\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C Atlassian \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.cross-join.request-access.button.experimental': "\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.cross-join.request-access.connected.description.experimental': '\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E43\u0E0A\u0E49 "\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E2A\u0E14\u0E07\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E40\u0E2B\u0E47\u0E19 \u0E41\u0E01\u0E49\u0E44\u0E02 \u0E41\u0E25\u0E30\u0E17\u0E33\u0E07\u0E32\u0E19\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19\u0E1A\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01 Jira \u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 Confluence \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 "\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C" \u0E02\u0E2D\u0E07\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13',
    'project-pages.cross-join.request-access.title': "\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 Confluence",
    'project-pages.cross-join.request-access.title.experiment': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E23\u0E34\u0E07\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E40\u0E14\u0E35\u0E22\u0E27\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.default-contextual-heading': "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E04\u0E23\u0E07\u0E01\u0E32\u0E23\u0E42\u0E14\u0E22 Confluence",
    'project-pages.default-contextual-message': "\u0E2A\u0E23\u0E49\u0E32\u0E07 \u0E41\u0E0A\u0E23\u0E4C \u0E41\u0E25\u0E30\u0E17\u0E33\u0E07\u0E32\u0E19\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19\u0E1A\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E19\u0E17\u0E35\u0E48\u0E40\u0E14\u0E35\u0E22\u0E27\u0E14\u0E49\u0E27\u0E22\u0E2B\u0E19\u0E49\u0E32 Confluence",
    'project-pages.default-reactivate-CTA': "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 Confluence \u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'project-pages.default-trial-CTA': "\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49 Confluence \u0E1F\u0E23\u0E35 30 \u0E27\u0E31\u0E19",
    'project-pages.draft-saved-flag.action': "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07",
    'project-pages.draft-saved-flag.description': "\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E19\u0E40\u0E14\u0E35\u0E22\u0E27\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E39\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E08\u0E19\u0E01\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E08\u0E30\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E2D\u0E2D\u0E01\u0E2A\u0E39\u0E48\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30",
    'project-pages.draft-saved-flag.title': "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E41\u0E25\u0E49\u0E27",
    'project-pages.embedded-pages.create-page-error.close-button': "\u0E1B\u0E34\u0E14",
    'project-pages.embedded-pages.create-page-error.description': "\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E41\u0E25\u0E30\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49",
    'project-pages.embedded-pages.create-page-error.title': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'project-pages.embedded-pages.modal.close.button.hint': "\u0E1B\u0E34\u0E14",
    'project-pages.embedded-pages.modal.title.button': "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19 Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19\u0E41\u0E16\u0E1A\u0E43\u0E2B\u0E21\u0E48",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} \u0E2B\u0E32\u0E01\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.errors.unknown-error.title.non-final': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49",
    'project-pages.generic-error.button.reload': "\u0E42\u0E2B\u0E25\u0E14\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'project-pages.generic-error.description': "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E43\u0E19\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07",
    'project-pages.generic-error.description.non-final': "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E43\u0E19\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07",
    'project-pages.generic-error.heading': "\u0E41\u0E22\u0E48\u0E08\u0E31\u0E07",
    'project-pages.generic-error.title.non-final': "\u0E41\u0E22\u0E48\u0E08\u0E31\u0E07",
    'project-pages.generic-info-flag.description': "\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E23 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E2B\u0E32\u0E01\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E22\u0E31\u0E07\u0E04\u0E07\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48",
    'project-pages.generic-success-flag.description.page': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 {connectedSpaceOrPageName} \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27",
    'project-pages.generic-success-flag.description.space': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 {connectedSpaceOrPageName} \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27",
    'project-pages.generic-success-flag.heading.page': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E49\u0E27",
    'project-pages.generic-success-flag.heading.space': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E43\u0E2B\u0E21\u0E48",
    'project-pages.granular-pages.connect-space.button': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Confluence",
    'project-pages.granular-pages.connect-space.heading': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E19\u0E35\u0E49\u0E01\u0E31\u0E1A\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confluence \u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'project-pages.granular-pages.connect-space.heading.non-final': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E19\u0E35\u0E49\u0E01\u0E31\u0E1A\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confluence \u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'project-pages.improvement.contact-support': "\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19",
    'project-pages.improvement.errors.access-error.description': "\u0E25\u0E2D\u0E07\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07",
    'project-pages.improvement.errors.access-error.title': "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E23\u0E02\u0E13\u0E30\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1E\u0E22\u0E32\u0E22\u0E32\u0E21\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E32\u0E01\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confluence \u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E41\u0E25\u0E49\u0E27\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 {contactSupport} \u0E2B\u0E32\u0E01\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u0E40\u0E23\u0E32\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confluence \u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E22\u0E49\u0E32\u0E22 \u0E40\u0E01\u0E47\u0E1A \u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E1A\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27 <link>\u0E42\u0E1B\u0E23\u0E14\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19</link> \u0E2B\u0E32\u0E01\u0E27\u0E48\u0E32\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E43\u0E2B\u0E21\u0E48\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} \u0E2B\u0E32\u0E01\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.improvement.errors.unknown-error.title': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49",
    'project-pages.improvement.feature1': "\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E41\u0E25\u0E30\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01 Jira",
    'project-pages.improvement.feature2': "\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21 \u0E41\u0E1C\u0E19\u0E04\u0E27\u0E32\u0E21\u0E40\u0E23\u0E47\u0E27\u0E43\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19 \u0E41\u0E25\u0E30\u0E2D\u0E35\u0E01\u0E21\u0E32\u0E01\u0E21\u0E32\u0E22",
    'project-pages.improvement.feature3': "\u0E0B\u0E34\u0E07\u0E04\u0E4C\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E44\u0E1B\u0E22\u0E31\u0E07 Jira \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
    'project-pages.improvement.heading-info': "\u0E40\u0E01\u0E47\u0E1A\u0E23\u0E27\u0E21\u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E49\u0E02\u0E2D\u0E07\u0E17\u0E35\u0E21\u0E41\u0E25\u0E30\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E25\u0E38\u0E25\u0E48\u0E27\u0E07\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E21\u0E35\u0E1B\u0E23\u0E30\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E20\u0E32\u0E1E",
    'project-pages.improvement.heading-info-v2': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E17\u0E35\u0E21\u0E44\u0E27\u0E49\u0E43\u0E19\u0E17\u0E35\u0E48\u0E40\u0E14\u0E35\u0E22\u0E27",
    'project-pages.improvement.learn-more-button': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'project-pages.improvement.powered-by': "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E42\u0E14\u0E22",
    'project-pages.improvement.powered-by.tooltip': "\u0E40\u0E1B\u0E34\u0E14 Confluence \u0E43\u0E19\u0E41\u0E16\u0E1A\u0E43\u0E2B\u0E21\u0E48",
    'project-pages.improvement.preview-teaser': "\u0E1B\u0E25\u0E14\u0E25\u0E47\u0E2D\u0E01\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A, \u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C \u0E41\u0E25\u0E30\u0E2D\u0E37\u0E48\u0E19 \u0E46",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E2A\u0E21\u0E2D\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E1B\u0E49\u0E32\u0E22\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34</p> <p>\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07 Jira \u0E43\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23 \u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E1B\u0E49\u0E32\u0E22\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E17\u0E35\u0E48\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E42\u0E14\u0E22\u0E0B\u0E34\u0E07\u0E04\u0E4C\u0E01\u0E31\u0E1A\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07 \u0E04\u0E38\u0E13\u0E08\u0E36\u0E07\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E25\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E1C\u0E39\u0E49\u0E21\u0E35\u0E2A\u0E48\u0E27\u0E19\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E27\u0E19\u0E40\u0E2A\u0E35\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E32\u0E1A\u0E23\u0E37\u0E48\u0E19",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E14\u0E04\u0E25\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E19\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E43\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32 \u0E0B\u0E36\u0E48\u0E07\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E07\u0E48\u0E32\u0E22\u0E41\u0E25\u0E30\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E44\u0E14\u0E49\u0E15\u0E32\u0E21\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13</p> <p>\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E44\u0E14\u0E49\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E08\u0E32\u0E01\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C \u0E04\u0E38\u0E13\u0E08\u0E36\u0E07\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E17\u0E33\u0E07\u0E32\u0E19\u0E2D\u0E22\u0E39\u0E48 \u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E44\u0E14\u0E49<a>\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48</a></p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u0E23\u0E27\u0E21\u0E21\u0E32\u0E15\u0E23\u0E10\u0E32\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E27\u0E49\u0E14\u0E49\u0E27\u0E22\u0E01\u0E31\u0E19",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E23\u0E34\u0E07\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E40\u0E14\u0E35\u0E22\u0E27\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E33\u0E04\u0E31\u0E0D \u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E08\u0E32\u0E01\u0E41\u0E17\u0E47\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E43\u0E19 Jira</p> <p>\u0E04\u0E38\u0E13\u0E23\u0E39\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32 \u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E17\u0E33\u0E07\u0E32\u0E19\u0E1A\u0E19 Confluence \u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E1F\u0E23\u0E35\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E16\u0E36\u0E07 10 \u0E23\u0E32\u0E22 \u0E40\u0E0A\u0E34\u0E0D\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E43\u0E19\u0E17\u0E35\u0E21\u0E17\u0E35\u0E48\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E43\u0E19\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E43\u0E19 Jira",
    'project-pages.improvement.templates.blank-page.description': "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E32\u0E01\u0E28\u0E39\u0E19\u0E22\u0E4C",
    'project-pages.improvement.templates.blank-page.name': "\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E27\u0E48\u0E32\u0E07",
    'project-pages.improvement.templates.decision.description': "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E04\u0E31\u0E0D\u0E41\u0E25\u0E30\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E01\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.improvement.templates.decision.name': "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08",
    'project-pages.improvement.templates.meeting-notes.description': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E27\u0E32\u0E23\u0E30\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21 \u0E08\u0E14\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01 \u0E41\u0E25\u0E30\u0E41\u0E0A\u0E23\u0E4C\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E01\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.improvement.templates.meeting-notes.name': "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21",
    'project-pages.improvement.templates.post-expand.more': "\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'project-pages.improvement.templates.post-expand.more.tooltip': "\u0E14\u0E39\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E43\u0E19 Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': "\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E22\u0E2D\u0E14\u0E19\u0E34\u0E22\u0E21",
    'project-pages.improvement.templates.post-expand.title': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'project-pages.improvement.templates.pre-expand.more': "\u0E14\u0E39\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E35\u0E48\u0E19\u0E34\u0E22\u0E21\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E40\u0E0A\u0E48\u0E19\u0E04\u0E38\u0E13",
    'project-pages.improvement.templates.pre-expand.title': "\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A",
    'project-pages.improvement.templates.product-requirements.description': "\u0E23\u0E30\u0E1A\u0E38 \u0E15\u0E34\u0E14\u0E15\u0E32\u0E21 \u0E41\u0E25\u0E30\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.improvement.templates.product-requirements.name': "\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C",
    'project-pages.improvement.templates.retrospective.description': "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23\u0E1A\u0E49\u0E32\u0E07 \u0E2A\u0E34\u0E48\u0E07\u0E43\u0E14\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E04\u0E34\u0E14\u0E27\u0E48\u0E32\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E17\u0E33\u0E44\u0E14\u0E49\u0E14\u0E35\u0E01\u0E27\u0E48\u0E32\u0E19\u0E35\u0E49 \u0E23\u0E30\u0E14\u0E21\u0E01\u0E33\u0E25\u0E31\u0E07\u0E43\u0E19\u0E01\u0E32\u0E23\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E01\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.improvement.templates.retrospective.name': "\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21\u0E2A\u0E23\u0E38\u0E1B",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confluence \u0E01\u0E48\u0E2D\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E31\u0E19\u0E14\u0E31\u0E1A\u0E41\u0E23\u0E01",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\u0E1B\u0E23\u0E30\u0E2B\u0E22\u0E31\u0E14\u0E40\u0E27\u0E25\u0E32\u0E41\u0E25\u0E30\u0E25\u0E14\u0E07\u0E32\u0E19\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E33\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07\u0E25\u0E07\u0E44\u0E14\u0E49</b> Confluence \u0E21\u0E35<a>\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A</a>\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E21\u0E32\u0E01\u0E21\u0E32\u0E22 \u0E04\u0E38\u0E13\u0E08\u0E36\u0E07\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07 \u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E08\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E17\u0E32\u0E07\u0E40\u0E17\u0E04\u0E19\u0E34\u0E04 \u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32 \u0E41\u0E1C\u0E19\u0E42\u0E04\u0E23\u0E07\u0E01\u0E32\u0E23 \u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E02\u0E2D\u0E07\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C \u0E41\u0E25\u0E30\u0E2D\u0E37\u0E48\u0E19 \u0E46",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u0E41\u0E01\u0E49\u0E44\u0E02\u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22 \u0E46</b> \u0E43\u0E0A\u0E49\u0E40\u0E21\u0E19\u0E39\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E21\u0E32\u0E15\u0E23\u0E10\u0E32\u0E19 \u0E41\u0E25\u0E30\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C <b>/</b> \u0E04\u0E38\u0E13\u0E01\u0E47\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E17\u0E23\u0E01\u0E01\u0E32\u0E23\u0E1A\u0E39\u0E23\u0E13\u0E32\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E21\u0E35\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E0A\u0E19\u0E4C\u0E21\u0E32\u0E01\u0E21\u0E32\u0E22\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22 \u0E46 \u0E41\u0E17\u0E23\u0E01\u0E15\u0E32\u0E23\u0E32\u0E07\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C <c>/\u0E15\u0E32\u0E23\u0E32\u0E07</c> \u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E14\u0E49\u0E27\u0E22 <c>/\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E</c> \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E19\u0E35\u0E49 \u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E17\u0E23\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C Dropbox <c>/dropbox</c>, \u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E21\u0E37\u0E2D Microsoft Office <c>/microsoft</c> \u0E2B\u0E23\u0E37\u0E2D\u0E1A\u0E2D\u0E23\u0E4C\u0E14\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E4C\u0E14 Trello <c>/trello</c> \u0E44\u0E14\u0E49\u0E2D\u0E35\u0E01\u0E14\u0E49\u0E27\u0E22",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u0E1E\u0E34\u0E21\u0E1E\u0E4C / \u0E15\u0E32\u0E21\u0E14\u0E49\u0E27\u0E22 \u2018\u0E15\u0E32\u0E23\u0E32\u0E07\u2019 \u0E2B\u0E23\u0E37\u0E2D \u2018\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u2019",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u0E19\u0E35\u0E48\u0E04\u0E37\u0E2D\u0E40\u0E04\u0E25\u0E47\u0E14\u0E25\u0E31\u0E1A\u0E2A\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E23\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E0A\u0E19\u0E4C",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "\u0E43\u0E0A\u0E49 Jira \u0E41\u0E25\u0E30 Confluence \u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u0E08\u0E31\u0E14\u0E17\u0E33\u0E41\u0E1C\u0E19\u0E20\u0E39\u0E21\u0E34\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E23\u0E34\u0E07\u0E02\u0E2D\u0E07 Jira \u0E1E\u0E34\u0E21\u0E1E\u0E4C <c>/\u0E41\u0E1C\u0E19\u0E20\u0E39\u0E21\u0E34 Jira</c>",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32 Jira \u0E17\u0E35\u0E48\u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E25\u0E34\u0E07\u0E01\u0E4C\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E30\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E1A\u0E1A\u0E40\u0E23\u0E35\u0E22\u0E25\u0E44\u0E17\u0E21\u0E4C \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E1B\u0E31\u0E0D\u0E2B\u0E32 Jira \u0E1E\u0E34\u0E21\u0E1E\u0E4C <c>/Jira</c>",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u0E1D\u0E31\u0E07\u0E41\u0E1C\u0E19\u0E07\u0E32\u0E19\u0E41\u0E1A\u0E1A\u0E2D\u0E34\u0E19\u0E40\u0E17\u0E2D\u0E23\u0E4C\u0E41\u0E2D\u0E04\u0E17\u0E35\u0E1F\u0E41\u0E25\u0E30\u0E44\u0E17\u0E21\u0E4C\u0E44\u0E25\u0E19\u0E4C\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E42\u0E04\u0E23\u0E07\u0E01\u0E32\u0E23 Jira \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E1E\u0E34\u0E21\u0E1E\u0E4C <c>/\u0E41\u0E1C\u0E19\u0E07\u0E32\u0E19 Jira</c>",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u0E1D\u0E31\u0E07\u0E40\u0E2A\u0E49\u0E19\u0E40\u0E27\u0E25\u0E32 (\u0E44\u0E17\u0E21\u0E4C\u0E44\u0E25\u0E19\u0E4C) \u0E41\u0E1A\u0E1A\u0E2D\u0E34\u0E19\u0E40\u0E17\u0E2D\u0E23\u0E4C\u0E41\u0E2D\u0E04\u0E17\u0E35\u0E1F\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E42\u0E04\u0E23\u0E07\u0E01\u0E32\u0E23 Jira \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E1E\u0E34\u0E21\u0E1E\u0E4C <c>/jira timeline</c>",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76% \u0E02\u0E2D\u0E07\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 Jira Software \u0E01\u0E25\u0E48\u0E32\u0E27\u0E27\u0E48\u0E32\u0E1E\u0E27\u0E01\u0E40\u0E02\u0E32\u0E2A\u0E48\u0E07\u0E21\u0E2D\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E1E\u0E34\u0E48\u0E21 Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76% \u0E02\u0E2D\u0E07\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 Jira \u0E01\u0E25\u0E48\u0E32\u0E27\u0E27\u0E48\u0E32\u0E1E\u0E27\u0E01\u0E40\u0E02\u0E32\u0E2A\u0E48\u0E07\u0E21\u0E2D\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E1E\u0E34\u0E48\u0E21 Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E41\u0E25\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25</b> \u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E04\u0E37\u0E2D\u0E2A\u0E48\u0E27\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E02\u0E2D\u0E07\u0E44\u0E0B\u0E15\u0E4C Confluence \u0E41\u0E25\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E27\u0E34\u0E18\u0E35\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E41\u0E1A\u0E48\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E43\u0E2B\u0E49\u0E04\u0E34\u0E14\u0E27\u0E48\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E1F\u0E25\u0E40\u0E14\u0E2D\u0E23\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E41\u0E25\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E42\u0E1F\u0E25\u0E40\u0E14\u0E2D\u0E23\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 <a>\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49",
    'project-pages.improvement.templates.tutorial.description': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'project-pages.improvement.templates.tutorial.name': "\u0E22\u0E34\u0E19\u0E14\u0E35\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A\u0E2A\u0E39\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C!",
    'project-pages.improvement.terms-and-conditions-v2': "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E25\u0E37\u0E2D\u0E01 '\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E40\u0E25\u0E22' \u0E2B\u0E21\u0E32\u0E22\u0E16\u0E36\u0E07\u0E04\u0E38\u0E13\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E43\u0E19 Confluence \u0E41\u0E25\u0E30\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A<termsLink>\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23</termsLink> Atlassian Cloud \u0E41\u0E25\u0E30<privacyLink>\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27</privacyLink>",
    'project-pages.improvement.title': "\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21 Confluence \u0E41\u0E25\u0E49\u0E27\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E25\u0E30\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49 \u0E1F\u0E23\u0E35\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E16\u0E36\u0E07 10 \u0E23\u0E32\u0E22",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E23\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.improvement.transient-states.empty-state.description': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21 \u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E49\u0E32\u0E19\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C \u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E01\u0E32\u0E23\u0E40\u0E15\u0E34\u0E21\u0E40\u0E15\u0E47\u0E21\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E43\u0E19\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E19\u0E35\u0E49",
    'project-pages.improvement.transient-states.empty-state.title': "\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2D\u0E30\u0E44\u0E23\u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E44\u0E14\u0E49",
    'project-pages.improvement.try-button': "\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E19\u0E35\u0E49\u0E43\u0E19 Confluence",
    'project-pages.improvement.try-it-now': "\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E40\u0E25\u0E22",
    'project-pages.improvement.try-lozenge': "\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49",
    'project-pages.improvement.try-on-demand-button': "\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E1F\u0E23\u0E35",
    'project-pages.page-deleted-flag.title': "\u0E25\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E49\u0E27",
    'project-pages.page-published-flag.title': "\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
    'project-pages.unknown-error.description': "{contactSupport} \u0E2B\u0E32\u0E01\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.unknown-error.heading': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49",
    'projectpages.templatepreview.termsandprivacy': "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48 &quot;\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E1F\u0E23\u0E35&quot; \u0E04\u0E38\u0E13\u0E08\u0E30\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E43\u0E19 Confluence \u0E41\u0E25\u0E30\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A <termsOfServiceLinkText>\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23 Atlassian Cloud</termsOfServiceLinkText> \u0E41\u0E25\u0E30 <privacyPolicyLinkText>\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27</privacyPolicyLinkText>"
};

});

parcelRegister("cWhTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $93fb42182f757245$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $93fb42182f757245$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Bu i\u015Flem bir dakikadan k\u0131sa s\xfcrer",
    'confluence.project-pages.improvement.provisioning-background.title': "Proje Sayfalar\u0131n\u0131z olu\u015Fturuluyor",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Kapat',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "Tamamland\u0131",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u0130leri",
    'project-pages.activating.description': "Ba\u011Flanan Confluence alan\u0131 hen\xfcz haz\u0131r de\u011Fil. Sayfay\u0131 yenilemeniz sorunu \xe7\xf6zmezse {contactSupport}.",
    'project-pages.activating.heading': "Confluence h\xe2l\xe2 y\xfckleniyor",
    'project-pages.button.connect-different-space-or-page.label': "Alan veya sayfa simgesini g\xfcncelle",
    'project-pages.button.connect-different-space-or-page.tooltip': "Ba\u015Fka bir alan\u0131 veya sayfay\u0131 ba\u011Flay\u0131n",
    'project-pages.button.connect-space-or-page.tooltip': "Confluence'a ba\u011Flan",
    'project-pages.button.go-to-connected-page.tooltip': "Sayfay\u0131 Confluence'ta a\xe7\u0131n",
    'project-pages.button.go-to-connected-space.tooltip': "Alan\u0131 Confluence'ta a\xe7\u0131n",
    'project-pages.connect-space-dialog.connection-error': "Ba\u011Flant\u0131 ba\u015Far\u0131s\u0131z oldu.",
    'project-pages.connect-space-dialog.connection-retry': 'Yeniden Dene',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Projenize ba\u011Flamak istedi\u011Finiz alan\u0131 veya sayfay\u0131 se\xe7in.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "Confluence'ta ara",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Sayfa olu\u015Fturabilmeniz i\xe7in bu projenin bir alana ba\u011Flanmas\u0131 gerekiyor. Bu projeyle ba\u011Flamak i\xe7in bir alan se\xe7in",
    'project-pages.connect-space-dialog.error-icon': 'Hata:',
    'project-pages.connect-space-dialog.footer.cancel': "\u0130ptal",
    'project-pages.connect-space-dialog.footer.connect-space': "Ba\u011Fla",
    'project-pages.connect-space-or-page-dialog.header.title': "Projeyi Confluence'a ba\u011Flay\u0131n",
    'project-pages.connect-space.description': "Alanlar, klas\xf6rlere benzer. Projenizle ilgili t\xfcm i\xe7erikleri olu\u015Fturmak, d\xfczenlemek ve bu i\xe7eriklerde i\u015F birli\u011Fi yapmak i\xe7in alanlar\u0131 kullanabilirsiniz.",
    'project-pages.connect-space.not-connected.description': "Proje sayfalar\u0131n\u0131 kullanmak i\xe7in y\xf6neticinizle veya tak\u0131m liderinizle ileti\u015Fime ge\xe7erek Confluence'\u0131 bu projeye ba\u011Flamas\u0131n\u0131 isteyin.",
    'project-pages.connect-space.not-connected.heading': "Confluence'a ba\u011Flanmam\u0131\u015F",
    'project-pages.connect-success-flag.description.content': "{connectedSpaceOrPageName} i\xe7eri\u011Fine ba\u015Far\u0131yla ba\u011Fland\u0131.",
    'project-pages.connection-error.space-or-page-not-found.button': "Ba\u015Fka bir alana veya sayfaya ba\u011Flay\u0131n",
    'project-pages.create-space-dialog.connection-error': "Ba\u011Flant\u0131 ba\u015Far\u0131s\u0131z oldu.",
    'project-pages.create-space-dialog.connection-retry': 'Yeniden Dene',
    'project-pages.create-space-dialog.content.empty-name': "L\xfctfen alan\u0131n\u0131za bir ad verin.",
    'project-pages.create-space-dialog.content.invalid-name': "Alan adlar\u0131n\u0131n en az bir harf veya rakamdan olu\u015Fmas\u0131 gerekir.",
    'project-pages.create-space-dialog.content.placeholder': "Bir alan ad\u0131 girin",
    'project-pages.create-space-dialog.creation-error': "Alan olu\u015Fturulamad\u0131.",
    'project-pages.create-space-dialog.error-icon': 'Hata:',
    'project-pages.create-space-dialog.footer.cancel': "\u0130ptal",
    'project-pages.create-space-dialog.footer.create-space': "Olu\u015Ftur",
    'project-pages.create-space-dialog.header.title': "Yeni Confluence alan\u0131 olu\u015Fturun",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Y\xf6netici size Confluence eri\u015Fim izni vermedi\u011Fi i\xe7in proje sayfalar\u0131n\u0131 kullanamazs\u0131n\u0131z. Eri\u015Fim talep etmek i\xe7in site y\xf6neticinizle ileti\u015Fime ge\xe7in.",
    'project-pages.cross-join.access-revoked.templates.title': "Proje sayfalar\u0131n\u0131 kullanma izniniz yok",
    'project-pages.cross-join.avatar.view-profile': "Profili g\xf6r\xfcnt\xfcle",
    'project-pages.cross-join.denied-request.templates.subtitle': "Site y\xf6neticisi Confluence'a kat\u0131lma talebinizi reddetti\u011Fi i\xe7in proje sayfalar\u0131n\u0131 kullanamazs\u0131n\u0131z.",
    'project-pages.cross-join.denied-request.templates.title': "Y\xf6neticiniz size eri\u015Fim izni vermedi",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Confluence'a eri\u015Fim elde edeceksiniz. Site y\xf6neticiniz sizi onaylad\u0131.",
    'project-pages.cross-join.errors.unknown-error.description': "Sayfay\u0131 yenilemeniz sorunu \xe7\xf6zmezse {contactSupport}.",
    'project-pages.cross-join.errors.unknown-error.title': "\u015Eu anda proje sayfalar\u0131 g\xf6r\xfcnt\xfclenemiyor",
    'project-pages.cross-join.inline-join-product.button': "Confluence'a eri\u015Fim elde edeceksiniz. Site y\xf6neticiniz sizi onaylad\u0131.",
    'project-pages.cross-join.inline-join-product.connected.description': "Tek yerden belge g\xf6r\xfcnt\xfcleyin, d\xfczenleyin ve olu\u015Fturun",
    'project-pages.cross-join.inline-join-product.connected.title': "Tak\u0131m\u0131n\u0131zla proje sayfalar\u0131nda i\u015F birli\u011Fi yap\u0131n",
    'project-pages.cross-join.pending-request.templates.subtitle': "Site y\xf6neticisi, Confluence'a kat\u0131lma talebinizi ald\u0131. Kat\u0131l\u0131m\u0131n\u0131z onaylan\u0131rsa proje sayfalar\u0131 \xe7al\u0131\u015Fmaya ba\u015Flar ve size bir onay e-postas\u0131 g\xf6nderilir.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Onayland\u0131\u011F\u0131n\u0131zda Proje Sayfalar\u0131na eri\u015Fim i\xe7eren bir e-posta al\u0131rs\u0131n\u0131z.",
    'project-pages.cross-join.pending-request.templates.title': "Confluence'a eri\u015Fim talep ettiniz",
    'project-pages.cross-join.pending-request.templates.title.experiment': "Y\xf6neticiye eri\u015Fim talebi g\xf6nderildi",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Proje belgelerini tak\u0131m\u0131n\u0131zla birlikte g\xf6r\xfcnt\xfcleyin, d\xfczenleyin ve olu\u015Fturun",
    'project-pages.cross-join.request-access.button': "Eri\u015Fim talep edin",
    'project-pages.cross-join.request-access.button-subtitle.experimental': '"Tak\u0131m\u0131n\u0131za Kat\u0131l\u0131n"\u0131 se\xe7ti\u011Finizde Confluence\'a kat\u0131lmay\u0131 ister ve Atlassian profilinizin y\xf6neticinizle payla\u015F\u0131lmas\u0131n\u0131 kabul edersiniz.',
    'project-pages.cross-join.request-access.button.experimental': "Tak\u0131m\u0131n\u0131za kat\u0131l\u0131n",
    'project-pages.cross-join.request-access.connected.description.experimental': "Tak\u0131m\u0131n\u0131z Jira'dan ayr\u0131lmadan proje belgelerinde yorum yapmak, d\xfczenlemek ve i\u015F birli\u011Fi yapmak i\xe7in Proje Sayfalar\u0131 \xf6zelli\u011Fini kullan\u0131yor. Tak\u0131m\u0131n\u0131z\u0131n Proje Sayfalar\u0131na eri\u015Fmek i\xe7in Confluence'a kat\u0131l\u0131n.",
    'project-pages.cross-join.request-access.title': "Proje sayfalar\u0131n\u0131 kullanabilmeniz i\xe7in Confluence eri\u015Fimi gereklidir",
    'project-pages.cross-join.request-access.title.experiment': "Tak\u0131m\u0131n\u0131z i\xe7in bir bilgi kayna\u011F\u0131 olu\u015Fturun",
    'project-pages.default-contextual-heading': "Proje sayfalar\u0131 Confluence taraf\u0131ndan desteklenir",
    'project-pages.default-contextual-message': "Confluence sayfalar\u0131 sayesinde t\xfcm proje belgelerinizi tek bir yerde olu\u015Fturup payla\u015F\u0131n ve bu belgeler \xfczerinde i\u015F birli\u011Fi yap\u0131n.",
    'project-pages.default-reactivate-CTA': "Confluence'\u0131 Yeniden Etkinle\u015Ftirin",
    'project-pages.default-trial-CTA': "Confluence'\u0131 30 g\xfcn \xfccretsiz deneyin",
    'project-pages.draft-saved-flag.action': "Tasla\u011F\u0131 a\xe7\u0131n",
    'project-pages.draft-saved-flag.description': "Tasla\u011F\u0131n\u0131z\u0131 yay\u0131nlayana kadar yaln\u0131zca siz g\xf6rebilirsiniz.",
    'project-pages.draft-saved-flag.title': 'Taslak kaydedildi',
    'project-pages.embedded-pages.create-page-error.close-button': 'Kapat',
    'project-pages.embedded-pages.create-page-error.description': "Bir sorun ya\u015Fand\u0131 ve sayfa olu\u015Fturulamad\u0131.",
    'project-pages.embedded-pages.create-page-error.title': "Sayfa olu\u015Fturulamad\u0131",
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Yeniden dene',
    'project-pages.embedded-pages.modal.close.button.hint': 'Kapat',
    'project-pages.embedded-pages.modal.title.button': "Confluence'ta a\xe7",
    'project-pages.embedded-pages.modal.title.button.hint': "Yeni sekmede a\xe7",
    'project-pages.errors.unknown-error.description.non-final': "Sayfay\u0131 yenilemeniz sorunu \xe7\xf6zmezse {contactSupport}.",
    'project-pages.errors.unknown-error.title.non-final': "\u015Eu anda proje sayfalar\u0131 g\xf6r\xfcnt\xfclenemiyor",
    'project-pages.generic-error.button.reload': "Sayfay\u0131 yeniden y\xfckle",
    'project-pages.generic-error.description': "Bir hata olu\u015Ftu. L\xfctfen daha sonra yeniden deneyin.",
    'project-pages.generic-error.description.non-final': "Bir hata olu\u015Ftu. L\xfctfen daha sonra yeniden deneyin.",
    'project-pages.generic-error.heading': 'Bir sorun var...',
    'project-pages.generic-error.title.non-final': 'Bir sorun var...',
    'project-pages.generic-info-flag.description': "Bir hata olu\u015Ftu. Sorun devam ederse l\xfctfen yeniden deneyin veya destek ekibiyle ileti\u015Fime ge\xe7in",
    'project-pages.generic-success-flag.description.page': "{connectedSpaceOrPageName} sayfas\u0131na ba\u015Far\u0131yla ba\u011Fland\u0131.",
    'project-pages.generic-success-flag.description.space': "{connectedSpaceOrPageName} alan\u0131na ba\u015Far\u0131yla ba\u011Fland\u0131.",
    'project-pages.generic-success-flag.heading.page': "Sayfa ba\u011Fland\u0131",
    'project-pages.generic-success-flag.heading.space': "Alan ba\u011Fland\u0131",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Veya yeni bir alan olu\u015Fturun",
    'project-pages.granular-pages.connect-space.button': "Confluence'a ba\u011Flan",
    'project-pages.granular-pages.connect-space.heading': "Bu projeyi bir Confluence alan\u0131na veya sayfas\u0131na ba\u011Flay\u0131n",
    'project-pages.granular-pages.connect-space.heading.non-final': "Bu projeyi bir Confluence alan\u0131na veya sayfas\u0131na ba\u011Flay\u0131n",
    'project-pages.improvement.contact-support': "Destek ekibiyle ileti\u015Fime ge\xe7in",
    'project-pages.improvement.errors.access-error.description': "Eri\u015Fim talep etmek i\xe7in site y\xf6neticisiyle ileti\u015Fime ge\xe7in.",
    'project-pages.improvement.errors.access-error.title': "Proje sayfalar\u0131n\u0131 g\xf6r\xfcnt\xfcleme izniniz yok",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Ba\u011Flanan Confluence alan\u0131n\u0131zdaki sayfalar g\xf6r\xfcnt\xfclenirken bir sorun ya\u015Fand\u0131. Sayfay\u0131 yenilemeniz sorunu \xe7\xf6zmezse {contactSupport}.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Proje sayfalar\u0131 g\xf6r\xfcnt\xfclenirken bir sorunla kar\u015F\u0131la\u015F\u0131ld\u0131",
    'project-pages.improvement.errors.space-or-page-not-found.description': "Ba\u011Flanan Confluence alan\u0131 veya sayfas\u0131 ta\u015F\u0131nm\u0131\u015F, ar\u015Fivlenmi\u015F veya silinmi\u015F. Yeniden ba\u011Flanman\u0131z sorunu \xe7\xf6zmezse <link>destek ekibiyle ileti\u015Fime ge\xe7in</link>",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Alan veya sayfa bulunamad\u0131",
    'project-pages.improvement.errors.unknown-error.description': "Sayfay\u0131 yenilemeniz sorunu \xe7\xf6zmezse {contactSupport}.",
    'project-pages.improvement.errors.unknown-error.title': "\u015Eu anda proje sayfalar\u0131 g\xf6r\xfcnt\xfclenemiyor",
    'project-pages.improvement.feature1': "Jira'dan ayr\u0131lmadan belgelere eri\u015Fin ve belgeler olu\u015Fturun",
    'project-pages.improvement.feature2': "Toplant\u0131lar, sprint planlar\u0131 ve daha fazlas\u0131 i\xe7in \u015Fablonlar",
    'project-pages.improvement.feature3': "Otomatik g\xfcncellemeler i\xe7in belgeleri Jira'ya senkronize edin",
    'project-pages.improvement.heading-info': "Tak\u0131m\u0131n\u0131z\u0131n bilgilerinden yararlan\u0131n ve i\u015Flerin y\xfcr\xfct\xfclme s\xfcrecini iyile\u015Ftirin.",
    'project-pages.improvement.heading-info-v2': "Tak\u0131m\u0131n\u0131z\u0131n t\xfcm proje belgeleri i\xe7in tek bir yer olu\u015Fturun",
    'project-pages.improvement.learn-more-button': 'Daha fazla bilgi edinin',
    'project-pages.improvement.powered-by': "Sa\u011Flayan:",
    'project-pages.improvement.powered-by.tooltip': "Confluence'\u0131 yeni sekmede a\xe7ar",
    'project-pages.improvement.preview-teaser': "\u015Eablonlardan, proje sayfalar\u0131ndan ve \xe7ok daha fazlas\u0131ndan yararlan\u0131n.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Otomatik olarak g\xfcncellenen durum etiketleriyle proje raporlar\u0131n\u0131z\u0131 g\xfcncel tutun.</p> <p>Bir belgedeki Jira biletini ba\u011Flad\u0131\u011F\u0131n\u0131zda otomatik olarak biletle senkronize \u015Fekilde g\xfcncellenen bir durum etiketi g\xf6sterilir. B\xf6ylece raporlar\u0131 manuel olarak olu\u015Fturmakla zaman kaybetmezsiniz.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Payda\u015Flara sorunsuzca g\xfcncelleme g\xf6nderin",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Yerle\u015Fik \u015Fablonlar\u0131m\u0131z\u0131 kullanarak tutarl\u0131 belgeler olu\u015Fturun. Bu \u015Fablonlar kolay kullan\u0131l\u0131r ve ihtiya\xe7lar\u0131n\u0131za g\xf6re \xf6zelle\u015Ftirilebilir.</p> <p>\u015Eablonlar\u0131 do\u011Frudan proje sayfalar\u0131ndan kullanabilirsiniz, b\xf6ylece \xfczerinde \xe7al\u0131\u015Ft\u0131\u011F\u0131n\u0131z sayfadan ayr\u0131lman\u0131z gerekmez. <a>Buradan</a> t\xfcm \u015Fablonlara g\xf6z at\u0131n.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Belgeleme standartlar\u0131n\u0131z\u0131 b\xfct\xfcnle\u015Ftirin",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Jira'da proje sayfalar\u0131 sekmesinden belgeler olu\u015Fturarak ve bunlar\u0131 y\xf6neterek \xf6nemli bilgiler i\xe7in g\xfcvenilir bir kaynak olu\u015Fturun.</p> <p>Proje sayfalar\u0131n\u0131z\u0131n Confluence'ta da \xe7al\u0131\u015Ft\u0131\u011F\u0131n\u0131 biliyor muydunuz? \xdcstelik 10 kullan\u0131c\u0131ya kadar \xfccretsiz. Y\xf6netici ayarlar\u0131ndan tak\u0131m\u0131n\u0131z\u0131n kalan\u0131n\u0131 davet edin.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "Proje sayfalar\u0131n\u0131z, do\u011Frudan Jira'da",
    'project-pages.improvement.templates.blank-page.description': "En ba\u015Ftan bir sayfa olu\u015Fturun.",
    'project-pages.improvement.templates.blank-page.name': "Bo\u015F sayfa",
    'project-pages.improvement.templates.decision.description': "Projeyle ilgili \xf6nemli kararlar\u0131 kaydedin ve bunlar\u0131 tak\u0131m\u0131n\u0131zla g\xf6r\xfc\u015F\xfcn.",
    'project-pages.improvement.templates.decision.name': 'Karar',
    'project-pages.improvement.templates.meeting-notes.description': "Toplant\u0131 g\xfcndemleri olu\u015Fturun, not tutun ve yap\u0131lacaklar listelerini tak\u0131m\u0131n\u0131zla payla\u015F\u0131n.",
    'project-pages.improvement.templates.meeting-notes.name': "Toplant\u0131 notlar\u0131",
    'project-pages.improvement.templates.post-expand.more': "Daha fazla \u015Fablon",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Confluence'taki t\xfcm \u015Fablonlar\u0131 g\xf6r\xfcnt\xfcleyin",
    'project-pages.improvement.templates.post-expand.subtitle': "Pop\xfcler \u015Fablonlar",
    'project-pages.improvement.templates.post-expand.title': "Sayfa olu\u015Fturun",
    'project-pages.improvement.templates.pre-expand.more': "Daha fazla \u015Fablon ke\u015Ffedin",
    'project-pages.improvement.templates.pre-expand.subtitle': "Sizinkine benzer tak\u0131mlar\u0131n s\u0131k kulland\u0131\u011F\u0131 \u015Fablonlar",
    'project-pages.improvement.templates.pre-expand.title': "\u015Eablon \xf6nizlemeleri",
    'project-pages.improvement.templates.product-requirements.description': "\xdcr\xfcn\xfcn\xfcz\xfcn veya \xf6zelli\u011Fin gerekliliklerini tan\u0131mlay\u0131n, izleyin veya kapsama al\u0131n.",
    'project-pages.improvement.templates.product-requirements.name': "\xdcr\xfcn gereklilikleri",
    'project-pages.improvement.templates.retrospective.description': "Ba\u015Far\u0131l\u0131 noktalar nelerdi? Neler geli\u015Ftirilebilirdi? Geli\u015Fmeleri tak\u0131m\u0131n\u0131zla payla\u015F\u0131n.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektif',
    'project-pages.improvement.templates.template.disabled-tooltip': "\u0130lk olarak bir Confluence alan\u0131 ba\u011Flay\u0131n",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Zamandan tasarruf edin ve manuel g\xf6revleri azalt\u0131n</b>. Confluence'ta \xe7ok say\u0131da sayfa <a>\u015Fablonu</a> var, yani hi\xe7bir zaman s\u0131f\u0131rdan ba\u015Flamak zorunda de\u011Filsiniz. Teknik belgeler, sorun giderme k\u0131lavuzlar\u0131, proje planlar\u0131, \xfcr\xfcn gereksinimleri ve daha fazlas\u0131 i\xe7in \u015Fablonlar mevcut.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Kolayl\u0131kla d\xfczenleyin ve bi\xe7imlendirin.</b> Standart s\xf6zc\xfck bi\xe7imlendirmesi i\xe7in en \xfcstteki d\xfczenleme men\xfcs\xfcn\xfc kullanabilir ve <b>/</b> yazarak \xe7ok say\u0131da kullan\u0131\u015Fl\u0131 entegrasyonu kolayl\u0131kla ekleyebilirsiniz. <c>/tablo</c> yazarak tablo ya da <c>/g\xf6rsel</c> yazarak bir g\xf6rsel ekleyebilirsiniz. Bunun yan\u0131 s\u0131ra <c>/dropbox</c> yazarak Dropbox ba\u011Flant\u0131lar\u0131, <c>/microsoft</c> yazarak Microsoft Office ara\xe7lar\u0131n\u0131 veya <c>/trello</c> yazarak Trello panolar\u0131 ve kartlar\u0131n\u0131 ekleyebilirsiniz.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': '/ ve ard\u0131ndan "tablo" veya "g\xf6rsel" yaz\u0131n',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Ba\u015Flaman\u0131za yard\u0131mc\u0131 olacak birka\xe7 ipucu:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "Kullan\u0131\u015Fl\u0131 ba\u011Flant\u0131lar",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Jira ve Confluence'\u0131 birlikte kullan\u0131n",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Ger\xe7ek Jira verilerini kullanarak sayfalar\u0131n\u0131zda grafikler olu\u015Fturun <c>/Jira grafikleri</c> yaz\u0131n.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Sayfan\u0131zda herhangi bir yere Jira konusu ba\u011Flay\u0131n. Sayfadaki ba\u011Flant\u0131, Jira konusu g\xfcncellendik\xe7e ger\xe7ek zamanl\u0131 olarak g\xfcncellenir. <c>/Jira</c> yaz\u0131n.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Jira Projelerinizi kullanarak sayfan\u0131za etkile\u015Fimli yol haritalar\u0131 ve zaman \xe7izelgeleri ekleyin. <c>/Jira yol haritas\u0131</c> yaz\u0131n.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Jira Projelerinizi kullanarak sayfan\u0131za etkile\u015Fimli zaman \xe7izelgeleri ekleyin. <c>/jira zaman \xe7izelgesi</c> yaz\u0131n.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "Jira Software m\xfc\u015Fterilerinin %76's\u0131, Confluence'\u0131 ekledikten sonra projeleri daha h\u0131zl\u0131 tamamlad\u0131klar\u0131n\u0131 s\xf6yl\xfcyor",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "Jira m\xfc\u015Fterilerinin %76's\u0131, Confluence'\u0131 ekledikten sonra projeleri daha h\u0131zl\u0131 tamamlad\u0131klar\u0131n\u0131 s\xf6yl\xfcyor",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Alan ve sayfa kullan\u0131m\u0131</b>. Alanlar t\xfcm Confluence sitelerinin bir par\xe7as\u0131d\u0131r ve sayfalar\u0131 kategoriler halinde d\xfczenlemenin bir yolunu sunar. Alanlar\u0131 farkl\u0131 klas\xf6r veya projeler gibi d\xfc\u015F\xfcn\xfcn, sayfalarsa bu klas\xf6r ya da projelere ait belgelerdir. <a>Alanlar\u0131 nas\u0131l kullanaca\u011F\u0131n\u0131z hakk\u0131nda daha fazla bilgi edinin</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Hemen deneyin',
    'project-pages.improvement.templates.tutorial.description': "Bir sayfay\u0131 nas\u0131l d\xfczenleyece\u011Finizi \xf6\u011Frenin.",
    'project-pages.improvement.templates.tutorial.name': "Proje Sayfalar\u0131na Ho\u015F Geldiniz!",
    'project-pages.improvement.terms-and-conditions-v2': "&quot;\u015Eimdi dene&quot; se\xe7ene\u011Fini belirleyerek Confluence'a kaydolaca\u011F\u0131n\u0131z\u0131 ve Atlassian <termsLink>Cloud Hizmet Ko\u015Fullar\u0131n\u0131</termsLink> ve <privacyLink>Gizlilik Politikas\u0131n\u0131</privacyLink> kabul edece\u011Finizi onaylam\u0131\u015F olursunuz.",
    'project-pages.improvement.title': "Proje sayfalar\u0131",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Sayfa olu\u015Ftur",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Confluence'\u0131 ekledik, proje belgeleri olu\u015Fturup ba\u011Flamaya ba\u015Flayabilirsiniz. 10 kullan\u0131c\u0131ya kadar \xfccretsiz.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Daha fazla bilgi edinin',
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u0130lk sayfan\u0131z\u0131 olu\u015Fturun",
    'project-pages.improvement.transient-states.empty-state.description': "Bu alan\u0131 doldurmak i\xe7in toplant\u0131 notlar\u0131, \xfcr\xfcn gereklilikleri, kararlar veya ba\u015Fka i\xe7erikler olu\u015Fturun.",
    'project-pages.improvement.transient-states.empty-state.title': "Bu sayfada hen\xfcz i\xe7erik yok",
    'project-pages.improvement.try-button': "Bu \u015Fablonu Confluence'ta deneyin",
    'project-pages.improvement.try-it-now': 'Hemen deneyin',
    'project-pages.improvement.try-lozenge': 'Deneyin',
    'project-pages.improvement.try-on-demand-button': "\xdccretsiz dene",
    'project-pages.page-deleted-flag.title': 'Sayfa silindi.',
    'project-pages.page-published-flag.title': "Sayfan\u0131z yay\u0131nland\u0131.",
    'project-pages.unknown-error.description': "Sayfay\u0131 yenilemeniz sorunu \xe7\xf6zmezse {contactSupport}.",
    'project-pages.unknown-error.heading': "\u015Eu anda proje sayfalar\u0131 g\xf6r\xfcnt\xfclenemiyor",
    'projectpages.templatepreview.termsandprivacy': "&quot;\xdccretsiz dene&quot; se\xe7ene\u011Fine t\u0131klarsan\u0131z Confluence'a kaydolur ve Atlassian Cloud <termsOfServiceLinkText>Hizmet Ko\u015Fullar\u0131n\u0131</termsOfServiceLinkText> ve <privacyPolicyLinkText>Gizlilik Politikas\u0131n\u0131</privacyPolicyLinkText> kabul etmi\u015F olursunuz."
};

});

parcelRegister("giQQn", function(module, exports) {

$parcel$export(module.exports, "default", () => $99a2ce808389f751$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $99a2ce808389f751$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u041F\u0440\u043E\u0446\u0435\u0441 \u0437\u0430\u0439\u043C\u0430\u0454 \u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
    'confluence.project-pages.improvement.provisioning-background.title': "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F Project Pages",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u0413\u043E\u0442\u043E\u0432\u043E",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u0414\u0430\u043B\u0456",
    'project-pages.activating.description': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0439 \u0440\u043E\u0437\u0434\u0456\u043B Confuence \u0449\u0435 \u043D\u0435 \u0433\u043E\u0442\u043E\u0432\u0438\u0439. \u042F\u043A\u0449\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0443\u0454 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.activating.heading': "Confluence \u0449\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u0442\u044C\u0441\u044F",
    'project-pages.button.connect-different-space-or-page.label': "\u0417\u043D\u0430\u0447\u043E\u043A \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u043E\u0437\u0434\u0456\u043B\u0443 \u0430\u0431\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0456\u043D\u0448\u0438\u0445 \u0440\u043E\u0437\u0434\u0456\u043B\u0443 \u0447\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
    'project-pages.button.connect-space-or-page.tooltip': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044F \u0434\u043E Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "\u0412\u0456\u0434\u043A\u0440\u0438\u0439\u0442\u0435 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0432 Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "\u0412\u0456\u0434\u043A\u0440\u0438\u0439\u0442\u0435 \u0446\u0435\u0439 \u0440\u043E\u0437\u0434\u0456\u043B \u0443 Confluence",
    'project-pages.connect-space-dialog.connection-error': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F.",
    'project-pages.connect-space-dialog.connection-retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0440\u043E\u0437\u0434\u0456\u043B \u0447\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u044F\u043A\u0456 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u0434\u043E \u0446\u044C\u043E\u0433\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "\u041F\u043E\u0448\u0443\u043A \u0443 Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u0426\u0435\u0439 \u043F\u0440\u043E\u0454\u043A\u0442 \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u0434\u043E \u0440\u043E\u0437\u0434\u0456\u043B\u0443, \u043F\u0435\u0440\u0448 \u043D\u0456\u0436 \u043C\u043E\u0436\u043D\u0430 \u0431\u0443\u0434\u0435 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443. \u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0440\u043E\u0437\u0434\u0456\u043B, \u044F\u043A\u0438\u0439 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u0434\u043E \u0446\u044C\u043E\u0433\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443.",
    'project-pages.connect-space-dialog.error-icon': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430:",
    'project-pages.connect-space-dialog.footer.cancel': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    'project-pages.connect-space-dialog.footer.connect-space': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F",
    'project-pages.connect-space-or-page-dialog.header.title': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C \u043F\u0440\u043E\u0454\u043A\u0442 \u0434\u043E Confluence",
    'project-pages.connect-space.description': "\u0420\u043E\u0437\u0434\u0456\u043B\u0438 \u043F\u043E\u0434\u0456\u0431\u043D\u0456 \u0434\u043E \u043F\u0430\u043F\u043E\u043A\xa0\u2014 \u0457\u0445 \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0434\u043B\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0442\u0430 \u0432\u043F\u043E\u0440\u044F\u0434\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0443, \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u043E\u0433\u043E \u0437 \u043F\u0440\u043E\u0454\u043A\u0442\u043E\u043C, \u0430 \u0442\u0430\u043A\u043E\u0436 \u0441\u043F\u0456\u043B\u044C\u043D\u043E\u0457 \u0440\u043E\u0431\u043E\u0442\u0438 \u043D\u0430\u0434 \u043D\u0438\u043C.",
    'project-pages.connect-space.not-connected.description': "\u0429\u043E\u0431 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443, \u0437\u0432\u2019\u044F\u0436\u0456\u0442\u044C\u0441\u044F \u0437\u0456 \u0441\u0432\u043E\u0457\u043C \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u043C \u0430\u0431\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u044E, \u0449\u043E\u0431 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 Confluence \u0434\u043E \u0446\u044C\u043E\u0433\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443.",
    'project-pages.connect-space.not-connected.heading': "\u041D\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u0434\u043E Confluence",
    'project-pages.connect-success-flag.description.content': "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E {connectedSpaceOrPageName}.",
    'project-pages.connection-error.space-or-page-not-found.button': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0456\u043D\u0448\u0438\u0445 \u0440\u043E\u0437\u0434\u0456\u043B\u0443 \u0447\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
    'project-pages.create-space-dialog.connection-error': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F.",
    'project-pages.create-space-dialog.connection-retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'project-pages.create-space-dialog.content.empty-name': "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u043D\u0430\u0437\u0432\u0443 \u0440\u043E\u0437\u0434\u0456\u043B\u0443.",
    'project-pages.create-space-dialog.content.invalid-name': "\u0423 \u043D\u0430\u0437\u0432\u0456 \u0440\u043E\u0437\u0434\u0456\u043B\u0443 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u0430 \u043B\u0456\u0442\u0435\u0440\u0430 \u0430\u0431\u043E \u0446\u0438\u0444\u0440\u0430.",
    'project-pages.create-space-dialog.content.placeholder': "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u0430\u0437\u0432\u0443 \u0440\u043E\u0437\u0434\u0456\u043B\u0443",
    'project-pages.create-space-dialog.creation-error': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0440\u043E\u0437\u0434\u0456\u043B\u0443.",
    'project-pages.create-space-dialog.error-icon': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430:",
    'project-pages.create-space-dialog.footer.cancel': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    'project-pages.create-space-dialog.footer.create-space': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
    'project-pages.create-space-dialog.header.title': "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0440\u043E\u0437\u0434\u0456\u043B\u0443 Confluence",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u0412\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443, \u0442\u043E\u043C\u0443 \u0449\u043E \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u043E\u0431\u043C\u0435\u0436\u0438\u0432 \u0432\u0430\u043C \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E Confluence. \u041F\u043E\u043F\u0440\u043E\u0441\u0456\u0442\u044C \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u043D\u0430\u0434\u0430\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F.",
    'project-pages.cross-join.access-revoked.templates.title': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u043C\u0430\u0454 \u0434\u043E\u0437\u0432\u043E\u043B\u0443 \u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A \u043F\u0440\u043E\u0454\u043A\u0442\u0443",
    'project-pages.cross-join.avatar.view-profile': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043F\u0440\u043E\u0444\u0456\u043B\u044C",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u0412\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443, \u0442\u043E\u043C\u0443 \u0449\u043E \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0430\u0439\u0442\u0443 \u0432\u0456\u0434\u0445\u0438\u043B\u0438\u0432 \u0432\u0430\u0448 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u043F\u0440\u0438\u0454\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043E Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "\u0412\u0430\u0448 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0432\u0456\u0434\u0445\u0438\u043B\u0438\u0432 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u0434\u043E\u0441\u0442\u0443\u043F",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "\u0412\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u0454\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E Confluence. \u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0432\u0430\u0448\u043E\u0433\u043E \u0441\u0430\u0439\u0442\u0443 \u0432\u0436\u0435 \u0441\u0445\u0432\u0430\u043B\u0438\u0432 \u0432\u0430\u0441.",
    'project-pages.cross-join.errors.unknown-error.description': "\u042F\u043A\u0449\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0443\u0454 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.cross-join.errors.unknown-error.title': "\u041D\u0430\u0440\u0430\u0437\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456",
    'project-pages.cross-join.inline-join-product.button': "\u0412\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u0454\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E Confluence. \u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0432\u0430\u0448\u043E\u0433\u043E \u0441\u0430\u0439\u0442\u0443 \u0432\u0436\u0435 \u0441\u0445\u0432\u0430\u043B\u0438\u0432 \u0432\u0430\u0441.",
    'project-pages.cross-join.inline-join-product.connected.description': "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u0456\u0437\u043E\u0432\u0430\u043D\u043E \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0430\u0439\u0442\u0435, \u0440\u0435\u0434\u0430\u0433\u0443\u0439\u0442\u0435 \u0442\u0430 \u0441\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
    'project-pages.cross-join.inline-join-product.connected.title': "\u041F\u0440\u0430\u0446\u044E\u0439\u0442\u0435 \u0432 \u043A\u043E\u043C\u0430\u043D\u0434\u0456 \u043D\u0430\u0434 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430\u043C\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0430\u0439\u0442\u0443 \u043E\u0442\u0440\u0438\u043C\u0430\u0432 \u0432\u0430\u0448 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u043F\u0440\u0438\u0454\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043E Confluence. \u042F\u043A\u0449\u043E \u0432\u0456\u043D \u043D\u0430\u0434\u0430\u0441\u0442\u044C \u0432\u0430\u043C \u0434\u043E\u0437\u0432\u0456\u043B \u043D\u0430 \u043F\u0440\u0438\u0454\u0434\u043D\u0430\u043D\u043D\u044F, \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u0430\u043A\u0442\u0438\u0432\u0443\u044E\u0442\u044C\u0441\u044F \u0442\u0430 \u043C\u0438 \u043D\u0430\u0434\u0456\u0448\u043B\u0435\u043C\u043E \u0432\u0430\u043C \u043B\u0438\u0441\u0442\u0430 \u0437 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F\u043C.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\u041F\u0456\u0441\u043B\u044F \u0441\u0445\u0432\u0430\u043B\u0435\u043D\u043D\u044F \u0432\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u0454\u0442\u0435 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430 \u0437 \u0434\u043E\u0441\u0442\u0443\u043F\u043E\u043C \u0434\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A \u043F\u0440\u043E\u0454\u043A\u0442\u0443.",
    'project-pages.cross-join.pending-request.templates.title': "\u0412\u0438 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043B\u0438 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u0417\u0430\u043F\u0438\u0442 \u043D\u0430 \u0434\u043E\u0441\u0442\u0443\u043F \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0430\u0439\u0442\u0435, \u0440\u0435\u0434\u0430\u0433\u0443\u0439\u0442\u0435 \u0442\u0430 \u0441\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u0432 \u043A\u043E\u043C\u0430\u043D\u0434\u0456",
    'project-pages.cross-join.request-access.button': "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u0434\u043E\u0441\u0442\u0443\u043F",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "\u041D\u0430\u0442\u0438\u0441\u043A\u0430\u044E\u0447\u0438 \u043A\u043D\u043E\u043F\u043A\u0443 \xab\u041F\u0440\u0438\u0454\u0434\u043D\u0430\u0442\u0438\u0441\u044F \u0434\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u0438\xbb, \u0432\u0438 \u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0434\u043E\u0437\u0432\u043E\u043B\u0443 \u043F\u0440\u0438\u0454\u0434\u043D\u0430\u0442\u0438\u0441\u044F \u0434\u043E Confluence \u0456 \u043F\u043E\u0433\u043E\u0434\u0436\u0443\u0454\u0442\u0435\u0441\u044F \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0441\u0432\u043E\u0457\u043C \u043F\u0440\u043E\u0444\u0456\u043B\u0435\u043C Atlassian \u0456\u0437 \u0432\u0430\u0448\u0438\u043C \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u043C.",
    'project-pages.cross-join.request-access.button.experimental': "\u041F\u0440\u0438\u0454\u0434\u043D\u0430\u0442\u0438\u0441\u044F \u0434\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u0438",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u0412\u0430\u0448\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432, \u0449\u043E\u0431 \u043A\u043E\u043C\u0435\u043D\u0442\u0443\u0432\u0430\u0442\u0438 \u0439 \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u043D\u0443 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044E, \u0430 \u0442\u0430\u043A\u043E\u0436 \u0440\u0430\u0437\u043E\u043C \u043F\u0440\u0430\u0446\u044E\u0432\u0430\u0442\u0438 \u043D\u0430\u0434 \u043D\u0435\u044E \u0431\u0435\u0437\u043F\u043E\u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E \u0432 Jira. \u041F\u0440\u0438\u0454\u0434\u043D\u0443\u0439\u0442\u0435\u0441\u044F \u0434\u043E Confluence, \u0449\u043E\u0431 \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A \u043A\u043E\u043C\u0430\u043D\u0434\u043D\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432.",
    'project-pages.cross-join.request-access.title': "\u0414\u043B\u044F \u0440\u043E\u0431\u043E\u0442\u0438 \u0437\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430\u043C\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043C\u0430\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E Confluence",
    'project-pages.cross-join.request-access.title.experiment': "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0454\u0434\u0438\u043D\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E \u0434\u043E\u0441\u0442\u043E\u0432\u0456\u0440\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0441\u0432\u043E\u0454\u0457 \u043A\u043E\u043C\u0430\u043D\u0434\u0438",
    'project-pages.default-contextual-heading': "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E \u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456 Confluence",
    'project-pages.default-contextual-message': "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u0456\u0437\u043E\u0432\u0430\u043D\u043E \u0441\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u043E\u0454\u043A\u0442\u0443, \u0434\u0456\u043B\u0456\u0442\u044C\u0441\u044F \u043D\u0438\u043C\u0438 \u0442\u0430 \u043F\u0440\u0430\u0446\u044E\u0439\u0442\u0435 \u043D\u0430\u0434 \u043D\u0438\u043C\u0438 \u0441\u043F\u0456\u043B\u044C\u043D\u043E \u0437 \u0456\u043D\u0448\u0438\u043C\u0438 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A Confluence.",
    'project-pages.default-reactivate-CTA': "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 Confluence",
    'project-pages.default-trial-CTA': "\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 Confluence \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 30\xa0\u0434\u043D\u0456\u0432",
    'project-pages.draft-saved-flag.action': "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0447\u0435\u0440\u043D\u0435\u0442\u043A\u0443",
    'project-pages.draft-saved-flag.description': "\u0414\u043E\u043A\u0438 \u0432\u0438 \u043D\u0435 \u043E\u043F\u0443\u0431\u043B\u0456\u043A\u0443\u0454\u0442\u0435 \u0447\u0435\u0440\u043D\u0435\u0442\u043A\u0443, \u0457\u0457 \u0437\u043C\u043E\u0436\u0435\u0442\u0435 \u0431\u0430\u0447\u0438\u0442\u0438 \u043B\u0438\u0448\u0435 \u0432\u0438.",
    'project-pages.draft-saved-flag.title': "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0443 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
    'project-pages.embedded-pages.create-page-error.close-button': "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    'project-pages.embedded-pages.create-page-error.description': "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430. \u041C\u0438 \u043D\u0435 \u0437\u043C\u043E\u0433\u043B\u0438 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0434\u043B\u044F \u0432\u0430\u0441 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443.",
    'project-pages.embedded-pages.create-page-error.title': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u041F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443",
    'project-pages.embedded-pages.modal.close.button.hint': "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    'project-pages.embedded-pages.modal.title.button': "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 \u043D\u043E\u0432\u0456\u0439 \u0432\u043A\u043B\u0430\u0434\u0446\u0456",
    'project-pages.errors.unknown-error.description.non-final': "\u042F\u043A\u0449\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0443\u0454 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.errors.unknown-error.title.non-final': "\u0417\u0430\u0440\u0430\u0437 \u043C\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'project-pages.generic-error.button.reload': "\u041F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'project-pages.generic-error.description': "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443 \u043F\u0456\u0437\u043D\u0456\u0448\u0435.",
    'project-pages.generic-error.description.non-final': "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443 \u043F\u0456\u0437\u043D\u0456\u0448\u0435.",
    'project-pages.generic-error.heading': "\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0437\u0430 \u043F\u043B\u0430\u043D\u043E\u043C...",
    'project-pages.generic-error.title.non-final': "\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0437\u0430 \u043F\u043B\u0430\u043D\u043E\u043C...",
    'project-pages.generic-info-flag.description': "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443 \u0430\u0431\u043E \u0437\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0441\u043B\u0443\u0436\u0431\u0438 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438, \u044F\u043A\u0449\u043E \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u043D\u0435 \u0437\u043D\u0438\u043A\u043D\u0435",
    'project-pages.generic-success-flag.description.page': "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.space': "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0440\u043E\u0437\u0434\u0456\u043B\u0443 {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.heading.page': "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
    'project-pages.generic-success-flag.heading.space': "\u0420\u043E\u0437\u0434\u0456\u043B \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u0430\u0431\u043E \u0441\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u043D\u043E\u0432\u0438\u0439 \u0440\u043E\u0437\u0434\u0456\u043B",
    'project-pages.granular-pages.connect-space.button': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044F \u0434\u043E Confluence",
    'project-pages.granular-pages.connect-space.heading': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C \u0446\u0435\u0439 \u043F\u0440\u043E\u0454\u043A\u0442 \u0434\u043E \u0440\u043E\u0437\u0434\u0456\u043B\u0443 \u0447\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 Confluence",
    'project-pages.granular-pages.connect-space.heading.non-final': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C \u0446\u0435\u0439 \u043F\u0440\u043E\u0454\u043A\u0442 \u0434\u043E \u0440\u043E\u0437\u0434\u0456\u043B\u0443 \u0447\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 Confluence",
    'project-pages.improvement.contact-support': "\u0437\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0443 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
    'project-pages.improvement.errors.access-error.description': "\u0417\u0430\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0443 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u0441\u0430\u0439\u0442\u0443.",
    'project-pages.improvement.errors.access-error.title': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u043C\u0430\u0454 \u0434\u043E\u0437\u0432\u043E\u043B\u0443 \u043D\u0430 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u0432\u0456\u0434 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E\u0433\u043E \u0440\u043E\u0437\u0434\u0456\u043B\u0443 Confluence. \u042F\u043A\u0449\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0443\u0454 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0456 \u0440\u043E\u0437\u0434\u0456\u043B \u0430\u0431\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 Confluence \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043E, \u0437\u0430\u0430\u0440\u0445\u0456\u0432\u043E\u0432\u0430\u043D\u043E \u0430\u0431\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E. \u042F\u043A\u0449\u043E \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u043D\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0436\u0435, <link>\u0437\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0441\u043B\u0443\u0436\u0431\u0438 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438</link>.",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u0420\u043E\u0437\u0434\u0456\u043B \u0430\u0431\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'project-pages.improvement.errors.unknown-error.description': "\u042F\u043A\u0449\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0443\u0454 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.improvement.errors.unknown-error.title': "\u0417\u0430\u0440\u0430\u0437 \u043C\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'project-pages.improvement.feature1': "\u0414\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0456 \u0457\u0445 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0431\u0435\u0437 \u0432\u0438\u0445\u043E\u0434\u0443 \u0437 Jira.",
    'project-pages.improvement.feature2': "\u0428\u0430\u0431\u043B\u043E\u043D\u0438, \u043F\u043B\u0430\u043D\u0438 \u0441\u043F\u0440\u0438\u043D\u0442\u0443 \u0442\u043E\u0449\u043E.",
    'project-pages.improvement.feature3': "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0456\u0437 Jira \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E\u0433\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F.",
    'project-pages.improvement.heading-info': "\u041D\u0430\u043A\u043E\u043F\u0438\u0447\u0443\u0439\u0442\u0435 \u0437\u043D\u0430\u043D\u043D\u044F \u0442\u0430 \u0434\u043E\u0441\u0432\u0456\u0434 \u0441\u0432\u043E\u0454\u0457 \u043A\u043E\u043C\u0430\u043D\u0434\u0438 \u0439 \u043F\u043E\u043A\u0440\u0430\u0449\u0443\u0439\u0442\u0435 \u043C\u0435\u0442\u043E\u0434\u0438 \u0440\u043E\u0431\u043E\u0442\u0438.",
    'project-pages.improvement.heading-info-v2': "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0454\u0434\u0438\u043D\u0435 \u0440\u043E\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u0432\u0441\u0456\u0454\u0457 \u043F\u0440\u043E\u0454\u043A\u0442\u043D\u043E\u0457 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u0457 \u0432\u0430\u0448\u043E\u0457 \u043A\u043E\u043C\u0430\u043D\u0434\u0438",
    'project-pages.improvement.learn-more-button': "\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435",
    'project-pages.improvement.powered-by': "\u041D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456",
    'project-pages.improvement.powered-by.tooltip': "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 Confluence \u043D\u0430 \u043D\u043E\u0432\u0456\u0439 \u0432\u043A\u043B\u0430\u0434\u0446\u0456",
    'project-pages.improvement.preview-teaser': "\u0420\u043E\u0437\u0431\u043B\u043E\u043A\u0443\u0439\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432, \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0456\u0432 \u0442\u043E\u0449\u043E.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\u0421\u0442\u0435\u0436\u0442\u0435 \u0437\u0430 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0456\u0441\u0442\u044E \u0437\u0432\u0456\u0442\u0456\u0432 \u0434\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0437\u0430\u0432\u0434\u044F\u043A\u0438 \u043C\u0456\u0442\u043A\u0430\u043C \u0441\u0442\u0430\u0442\u0443\u0441\u0443, \u0449\u043E \u043E\u043D\u043E\u0432\u043B\u044E\u044E\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E.</p> <p>\u041F\u0440\u043E\u0441\u0442\u043E \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0437\u0430\u044F\u0432\u043A\u0443 Jira \u0432 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456, \u0456 \u0432 \u043D\u044C\u043E\u043C\u0443 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C\u0441\u044F \u043C\u0456\u0442\u043A\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0443, \u044F\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u043D\u043E \u0456\u0437 \u0437\u0430\u044F\u0432\u043A\u043E\u044E, \u0442\u043E\u0436 \u0432\u0430\u043C \u043D\u0435 \u0434\u043E\u0432\u0435\u0434\u0435\u0442\u044C\u0441\u044F \u0432\u0438\u0442\u0440\u0430\u0447\u0430\u0442\u0438 \u0447\u0430\u0441 \u043D\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437\u0432\u0456\u0442\u0456\u0432 \u0432\u0440\u0443\u0447\u043D\u0443.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u0417 \u043B\u0435\u0433\u043A\u0456\u0441\u0442\u044E \u0442\u0440\u0438\u043C\u0430\u0439\u0442\u0435 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432 \u0443 \u043A\u0443\u0440\u0441\u0456 \u043F\u043E\u0434\u0456\u0439",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\u0421\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u0443 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044E \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u043D\u0430\u0448\u0438\u0445 \u0432\u0431\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0445 \u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432. \u0412\u043E\u043D\u0438 \u043F\u0440\u043E\u0441\u0442\u0456 \u0443 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u0456 \u0439 \u043B\u0435\u0433\u043A\u043E \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0443\u044E\u0442\u044C\u0441\u044F \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u043E \u0434\u043E \u0432\u0430\u0448\u0438\u0445 \u043F\u043E\u0442\u0440\u0435\u0431.</p> <p>\u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D\u0438 \u0431\u0435\u0437\u043F\u043E\u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432, \u0442\u043E\u043C\u0443 \u0432\u0430\u043C \u043D\u0456\u043A\u043E\u043B\u0438 \u043D\u0435 \u0434\u043E\u0432\u0435\u0434\u0435\u0442\u044C\u0441\u044F \u0437\u0430\u043B\u0438\u0448\u0430\u0442\u0438 \u043F\u043E\u0442\u043E\u0447\u043D\u0456 \u0441\u043F\u0440\u0430\u0432\u0438. \u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u044C\u0442\u0435 \u0432\u0441\u0456 \u0448\u0430\u0431\u043B\u043E\u043D\u0438 <a>\u0442\u0443\u0442</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u0423\u043D\u0456\u0444\u0456\u043A\u0443\u0439\u0442\u0435 \u0432\u043B\u0430\u0441\u043D\u0456 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u0457",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>\u041E\u0442\u0440\u0438\u043C\u0430\u0439\u0442\u0435 \u0454\u0434\u0438\u043D\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E \u0434\u043E\u0441\u0442\u043E\u0432\u0456\u0440\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0432\u0430\u0436\u043B\u0438\u0432\u043E\u0457 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457: \u043F\u0440\u043E\u0441\u0442\u043E \u0441\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044E \u0442\u0430 \u043A\u0435\u0440\u0443\u0439\u0442\u0435 \u043D\u0435\u044E \u043D\u0430 \u0432\u043A\u043B\u0430\u0434\u0446\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u0432 Jira.</p> <p>\u0427\u0438 \u0437\u043D\u0430\u043B\u0438 \u0432\u0438, \u0449\u043E \u0437\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430\u043C\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u043C\u043E\u0436\u043D\u0430 \u043F\u0440\u0430\u0446\u044E\u0432\u0430\u0442\u0438 \u0432 Confluence? \u0426\u044F \u0444\u0443\u043D\u043A\u0446\u0456\u044F \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u0430 \u0434\u043B\u044F 10\xa0\u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432. \u0417\u0430\u043F\u0440\u043E\u0441\u0456\u0442\u044C \u0440\u0435\u0448\u0442\u0443 \u0432\u0430\u0448\u043E\u0457 \u043A\u043E\u043C\u0430\u043D\u0434\u0438 \u0432 \u0440\u043E\u0437\u0434\u0456\u043B\u0456 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u044C \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u0432\u0430\u0448\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0431\u0435\u0437\u043F\u043E\u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E \u0432 Jira",
    'project-pages.improvement.templates.blank-page.description': "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0437 \u043D\u0443\u043B\u044F.",
    'project-pages.improvement.templates.blank-page.name': "\u0427\u0438\u0441\u0442\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430",
    'project-pages.improvement.templates.decision.description': "\u0417\u0430\u043F\u0438\u0441\u0443\u0439\u0442\u0435 \u0432\u0430\u0436\u043B\u0438\u0432\u0456 \u0440\u0456\u0448\u0435\u043D\u043D\u044F \u0449\u043E\u0434\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u0439 \u043E\u0431\u0433\u043E\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0457\u0445 \u0456\u0437 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u044E.",
    'project-pages.improvement.templates.decision.name': "\u0420\u0456\u0448\u0435\u043D\u043D\u044F",
    'project-pages.improvement.templates.meeting-notes.description': "\u041F\u043B\u0430\u043D\u0443\u0439\u0442\u0435 \u0437\u0443\u0441\u0442\u0440\u0456\u0447\u0456, \u0437\u0430\u043F\u0438\u0441\u0443\u0439\u0442\u0435 \u0456\u0434\u0435\u0457 \u0439 \u043E\u0431\u0433\u043E\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0437 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u044E.",
    'project-pages.improvement.templates.meeting-notes.name': "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u043F\u0440\u043E \u0437\u0443\u0441\u0442\u0440\u0456\u0447",
    'project-pages.improvement.templates.post-expand.more': "\u0411\u0456\u043B\u044C\u0448\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432",
    'project-pages.improvement.templates.post-expand.more.tooltip': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432\u0441\u0456 \u0448\u0430\u0431\u043B\u043E\u043D\u0438 \u0432 Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0456 \u0448\u0430\u0431\u043B\u043E\u043D\u0438",
    'project-pages.improvement.templates.post-expand.title': "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
    'project-pages.improvement.templates.pre-expand.more': "\u0414\u0456\u0437\u043D\u0430\u0442\u0438\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u0448\u0430\u0431\u043B\u043E\u043D\u0438",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0456 \u0441\u0435\u0440\u0435\u0434 \u0441\u0445\u043E\u0436\u0438\u0445 \u043D\u0430 \u0432\u0430\u0448\u0443 \u043A\u043E\u043C\u0430\u043D\u0434",
    'project-pages.improvement.templates.pre-expand.title': "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432",
    'project-pages.improvement.templates.product-requirements.description': "\u0412\u0438\u0437\u043D\u0430\u0447\u0430\u0439\u0442\u0435, \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0443\u0439\u0442\u0435 \u0439 \u043E\u0446\u0456\u043D\u044E\u0439\u0442\u0435 \u043E\u0431\u0441\u044F\u0433 \u0432\u0438\u043C\u043E\u0433 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443 \u0447\u0438 \u0444\u0443\u043D\u043A\u0446\u0456\u0457.",
    'project-pages.improvement.templates.product-requirements.name': "\u0412\u0438\u043C\u043E\u0433\u0438 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443",
    'project-pages.improvement.templates.retrospective.description': "\u0429\u043E \u043F\u0440\u043E\u0439\u0448\u043B\u043E \u0432\u0434\u0430\u043B\u043E? \u0410 \u0449\u043E \u043C\u043E\u0436\u043D\u0430 \u0431\u0443\u043B\u043E \u0431 \u0432\u0434\u043E\u0441\u043A\u043E\u043D\u0430\u043B\u0438\u0442\u0438? \u0421\u043F\u0456\u043B\u044C\u043D\u0456 \u0437\u0443\u0441\u0438\u043B\u043B\u044F \u043A\u043E\u043C\u0430\u043D\u0434\u0438 \u0434\u043B\u044F \u043F\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u044F \u0440\u043E\u0431\u043E\u0442\u0438.",
    'project-pages.improvement.templates.retrospective.name': "\u0420\u0435\u0442\u0440\u043E\u0441\u043F\u0435\u043A\u0442\u0438\u0432\u0430",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u0421\u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C \u0440\u043E\u0437\u0434\u0456\u043B Confluence",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\u0417\u0430\u043E\u0449\u0430\u0434\u0436\u0443\u0439\u0442\u0435 \u0447\u0430\u0441 \u0456 \u043C\u0456\u043D\u0456\u043C\u0456\u0437\u0443\u0439\u0442\u0435 \u0440\u0443\u0447\u043D\u0443 \u0440\u043E\u0431\u043E\u0442\u0443</b>. \u0423 Confluence \u0431\u0430\u0433\u0430\u0442\u043E <a>\u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432</a> \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A, \u0442\u043E\u0436 \u0432\u0430\u043C \u043D\u0435 \u0434\u043E\u0432\u0435\u0434\u0435\u0442\u044C\u0441\u044F \u043F\u043E\u0447\u0438\u043D\u0430\u0442\u0438 \u0437 \u043D\u0443\u043B\u044F. \u0421\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438, \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A\u0438 \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A, \u043F\u043B\u0430\u043D\u0438 \u0434\u043B\u044F \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432, \u0432\u0438\u043C\u043E\u0433\u0438 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443 \u0442\u043E\u0449\u043E.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u0417 \u043B\u0435\u0433\u043A\u0456\u0441\u0442\u044E \u0440\u0435\u0434\u0430\u0433\u0443\u0439\u0442\u0435 \u0439 \u0444\u043E\u0440\u043C\u0430\u0442\u0443\u0439\u0442\u0435 \u0442\u0435\u043A\u0441\u0442.</b> \u0417\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0443\u0439\u0442\u0435 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u0443\u0432\u0430\u043D\u043D\u044F Word \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u043C\u0435\u043D\u044E \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0430\u0431\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 <b>/</b>, \u0449\u043E\u0431 \u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u0431\u0435\u0437\u043B\u0456\u0447 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0445 \u0456\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0439. \u0429\u043E\u0431 \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0442\u0430\u0431\u043B\u0438\u0446\u044E, \u0432\u0432\u0435\u0434\u0456\u0442\u044C <c>/\u0442\u0430\u0431\u043B\u0438\u0446\u044F</c>, \u0430 \u044F\u043A\u0449\u043E \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0434\u043E\u0434\u0430\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u2014 <c>/\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F</c>. \u0422\u0430\u043A\u043E\u0436 \u043C\u043E\u0436\u043D\u0430 \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F Dropbox (<c>/dropbox</c>), \u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0438 Microsoft Office (<c>/microsoft</c>) \u0430\u0431\u043E \u0434\u043E\u0448\u043A\u0438 \u0442\u0430 \u043A\u0430\u0440\u0442\u043A\u0438 Trello (<c>/trello</c>).",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u0412\u0432\u0435\u0434\u0456\u0442\u044C /, \u0430 \u043F\u043E\u0442\u0456\u043C \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u0441\u043B\u043E\u0432\u043E \xab\u0442\u0430\u0431\u043B\u0438\u0446\u044F\xbb \u0430\u0431\u043E \xab\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F\xbb",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u041E\u0441\u044C \u043A\u0456\u043B\u044C\u043A\u0430 \u043F\u043E\u0440\u0430\u0434 \u0434\u043B\u044F \u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u0440\u043E\u0431\u043E\u0442\u0438:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u041A\u043E\u0440\u0438\u0441\u043D\u0456 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 Jira \u0442\u0430 Confluence \u0440\u0430\u0437\u043E\u043C",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u0421\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0438 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430\u0445 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0434\u0430\u043D\u0438\u0445, \u044F\u043A\u0456 \u043D\u0430\u0434\u0445\u043E\u0434\u044F\u0442\u044C \u0432\u0456\u0434 Jira \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0447\u0430\u0441\u0456. \u0412\u0432\u0435\u0434\u0456\u0442\u044C <c>/\u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0438 Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u041F\u043E\u0432\u2019\u044F\u0437\u0443\u0439\u0442\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0432 Jira \u0437 \u0431\u0443\u0434\u044C-\u044F\u043A\u0438\u043C \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u043C \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438. \u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0447\u0430\u0441\u0456 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u043C\u0456\u043D, \u044F\u043A\u0456 \u0432\u0438 \u0432\u043D\u043E\u0441\u0438\u0442\u0435 \u0432 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F Jira. \u0412\u0432\u0435\u0434\u0456\u0442\u044C <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u0412\u0431\u0443\u0434\u043E\u0432\u0443\u0439\u0442\u0435 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0456\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u0456 \u043F\u043B\u0430\u043D\u0438 \u0440\u043E\u0437\u0440\u043E\u0431\u043A\u0438 \u0430\u0431\u043E \u0447\u0430\u0441\u043E\u0432\u0456 \u0448\u043A\u0430\u043B\u0438 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 Jira. \u0412\u0432\u0435\u0434\u0456\u0442\u044C <c>/\u043F\u043B\u0430\u043D \u0440\u043E\u0437\u0440\u043E\u0431\u043A\u0438 Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u0412\u0431\u0443\u0434\u043E\u0432\u0443\u0439\u0442\u0435 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0456\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u0456 \u0447\u0430\u0441\u043E\u0432\u0456 \u0448\u043A\u0430\u043B\u0438 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 Jira. \u0412\u0432\u0435\u0434\u0456\u0442\u044C <c>/jira timeline</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432 Jira Software \u0437\u0430\u0443\u0432\u0430\u0436\u0438\u043B\u0438, \u0449\u043E \u043F\u0456\u0441\u043B\u044F \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F Confluence \u043F\u0440\u043E\u0446\u0435\u0441 \u0437\u0434\u0430\u0447\u0456 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u043F\u0440\u0438\u0448\u0432\u0438\u0434\u0448\u0438\u0432\u0441\u044F",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432 Jira \u0437\u0430\u0443\u0432\u0430\u0436\u0438\u043B\u0438, \u0449\u043E \u043F\u0456\u0441\u043B\u044F \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F Confluence \u043F\u0440\u043E\u0446\u0435\u0441 \u0437\u0434\u0430\u0447\u0456 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u043F\u0440\u0438\u0448\u0432\u0438\u0434\u0448\u0438\u0432\u0441\u044F",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0440\u043E\u0437\u0434\u0456\u043B\u0456\u0432 \u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A</b>. \u0411\u0443\u0434\u044C-\u044F\u043A\u0438\u0439 \u0441\u0430\u0439\u0442 Confluence \u0441\u043A\u043B\u0430\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437 \u0440\u043E\u0437\u0434\u0456\u043B\u0456\u0432, \u0449\u043E \u0434\u0430\u044E\u0442\u044C \u0437\u043C\u043E\u0433\u0443 \u0437\u0440\u0443\u0447\u043D\u043E \u0432\u043F\u043E\u0440\u044F\u0434\u043A\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u0437\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F\u043C\u0438. \u0420\u043E\u0437\u0434\u0456\u043B\u0438 \u043C\u043E\u0436\u043D\u0430 \u043F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0437 \u0440\u0456\u0437\u043D\u0438\u043C\u0438 \u043F\u0430\u043F\u043A\u0430\u043C\u0438 \u0430\u0431\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0430\u043C\u0438, \u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438\xa0\u2014 \u0437 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043C\u0438, \u0449\u043E \u0432\u0445\u043E\u0434\u044F\u0442\u044C \u0434\u043E \u0446\u0438\u0445 \u043F\u0430\u043F\u043E\u043A \u0430\u0431\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432. <a>\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435 \u043F\u0440\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0440\u043E\u0437\u0434\u0456\u043B\u0456\u0432</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'project-pages.improvement.templates.tutorial.description': "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u044F\u043A \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443.",
    'project-pages.improvement.templates.tutorial.name': "\u041B\u0430\u0441\u043A\u0430\u0432\u043E \u043F\u0440\u043E\u0441\u0438\u043C\u043E \u0434\u043E Project Pages!",
    'project-pages.improvement.terms-and-conditions-v2': "\u041D\u0430\u0442\u0438\u0441\u043D\u0443\u0432\u0448\u0438 \u043A\u043D\u043E\u043F\u043A\u0443 \xab\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438\xbb, \u0432\u0438 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0443\u0454\u0442\u0435 \u0437\u0433\u043E\u0434\u0443 \u043D\u0430 \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044E \u0432 Confluence \u0456 \u043F\u0440\u0438\u0439\u043C\u0430\u0454\u0442\u0435 <termsLink>\u0423\u043C\u043E\u0432\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0445\u043C\u0430\u0440\u043D\u0438\u0445 \u0441\u043B\u0443\u0436\u0431</termsLink> \u0456 <privacyLink>\u041F\u043E\u043B\u0456\u0442\u0438\u043A\u0443 \u043A\u043E\u043D\u0444\u0456\u0434\u0435\u043D\u0446\u0456\u0439\u043D\u043E\u0441\u0442\u0456</privacyLink> Atlassian.",
    'project-pages.improvement.title': "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0443",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\u041C\u0438 \u0434\u043E\u0434\u0430\u043B\u0438 Confluence, \u0442\u043E\u0436 \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0442\u0432\u043E\u0440\u044E\u0432\u0430\u0442\u0438 \u0442\u0430 \u043F\u043E\u0432\u2019\u044F\u0437\u0443\u0432\u0430\u0442\u0438 \u0432\u0441\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0432 \u043C\u0435\u0436\u0430\u0445 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432. \u0426\u0435 \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E \u0434\u043B\u044F 10\xa0\u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0441\u0432\u043E\u044E \u043F\u0435\u0440\u0448\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'project-pages.improvement.transient-states.empty-state.description': "\u0429\u043E\u0431 \u0437\u0430\u043F\u043E\u0432\u043D\u0438\u0442\u0438 \u0446\u0435\u0439 \u0440\u043E\u0437\u0434\u0456\u043B, \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u0432 \u043D\u044C\u043E\u0433\u043E \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u0434\u043E \u043D\u0430\u0440\u0430\u0434\u0438, \u0432\u0438\u043C\u043E\u0433\u0438 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443, \u0440\u0456\u0448\u0435\u043D\u043D\u044F \u0447\u0438 \u0456\u043D\u0448\u0438\u0439 \u0432\u043C\u0456\u0441\u0442.",
    'project-pages.improvement.transient-states.empty-state.title': "\u0422\u0443\u0442 \u0431\u0430\u0433\u0430\u0442\u043E \u043C\u043E\u0436\u043B\u0438\u0432\u043E\u0441\u0442\u0435\u0439",
    'project-pages.improvement.try-button': "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u0448\u0430\u0431\u043B\u043E\u043D \u0443 Confluence",
    'project-pages.improvement.try-it-now': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'project-pages.improvement.try-lozenge': "\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043D\u043E\u0432\u0435",
    'project-pages.improvement.try-on-demand-button': "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E",
    'project-pages.page-deleted-flag.title': "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E.",
    'project-pages.page-published-flag.title': "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u043E\u043F\u0443\u0431\u043B\u0456\u043A\u043E\u0432\u0430\u043D\u043E.",
    'project-pages.unknown-error.description': "\u042F\u043A\u0449\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0443\u0454 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.unknown-error.heading': "\u0417\u0430\u0440\u0430\u0437 \u043C\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'projectpages.templatepreview.termsandprivacy': "\u041D\u0430\u0442\u0438\u0441\u043D\u0443\u0432\u0448\u0438 \u043A\u043D\u043E\u043F\u043A\u0443 \xab\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E\xbb, \u0432\u0438 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0454\u0442\u0435\u0441\u044F \u0432 Confluence \u0456 \u043F\u0440\u0438\u0439\u043C\u0435\u0442\u0435 <termsOfServiceLinkText>\u0423\u043C\u043E\u0432\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0445\u043C\u0430\u0440\u043D\u0438\u0445 \u0441\u043B\u0443\u0436\u0431</termsOfServiceLinkText> \u0456 <privacyPolicyLinkText>\u041F\u043E\u043B\u0456\u0442\u0438\u043A\u0443 \u043A\u043E\u043D\u0444\u0456\u0434\u0435\u043D\u0446\u0456\u0439\u043D\u043E\u0441\u0442\u0456</privacyPolicyLinkText> Atlassian."
};

});

parcelRegister("5JkrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d104a8d7089cbef$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $4d104a8d7089cbef$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Qu\xe1 tr\xecnh n\xe0y s\u1EBD m\u1EA5t ch\u01B0a \u0111\u1EBFn 1 ph\xfat",
    'confluence.project-pages.improvement.provisioning-background.title': "\u0110ang thi\u1EBFt l\u1EADp c\xe1c trang d\u1EF1 \xe1n",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "B\u1ECF qua",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u0110\xe3 xong",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "Ti\u1EBFp theo",
    'project-pages.activating.description': "V\xf9ng Confuence \u0111\xe3 k\u1EBFt n\u1ED1i v\u1EABn ch\u01B0a s\u1EB5n s\xe0ng. {contactSupport} n\u1EBFu thao t\xe1c l\xe0m m\u1EDBi kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c m\u1ECDi th\u1EE9.",
    'project-pages.activating.heading': "Confluence v\u1EABn \u0111ang t\u1EA3i",
    'project-pages.button.connect-different-space-or-page.label': "Bi\u1EC3u t\u01B0\u1EE3ng c\u1EADp nh\u1EADt v\xf9ng ho\u1EB7c trang",
    'project-pages.button.connect-different-space-or-page.tooltip': "K\u1EBFt n\u1ED1i kh\xf4ng gian ho\u1EB7c trang kh\xe1c",
    'project-pages.button.connect-space-or-page.tooltip': "K\u1EBFt n\u1ED1i v\u1EDBi Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "M\u1EDF trang trong Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "M\u1EDF kh\xf4ng gian trong Confluence",
    'project-pages.connect-space-dialog.connection-error': "Kh\xf4ng th\u1EC3 k\u1EBFt n\u1ED1i.",
    'project-pages.connect-space-dialog.connection-retry': "Th\u1EED l\u1EA1i",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Ch\u1ECDn kh\xf4ng gian ho\u1EB7c trang c\u1EA7n k\u1EBFt n\u1ED1i v\u1EDBi d\u1EF1 \xe1n c\u1EE7a b\u1EA1n.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "T\xecm ki\u1EBFm Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "D\u1EF1 \xe1n n\xe0y c\u1EA7n ph\u1EA3i \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i v\u1EDBi v\xf9ng tr\u01B0\u1EDBc khi b\u1EA1n c\xf3 th\u1EC3 t\u1EA1o trang. Ch\u1ECDn v\xf9ng c\u1EA7n k\u1EBFt n\u1ED1i v\u1EDBi d\u1EF1 \xe1n n\xe0y.",
    'project-pages.connect-space-dialog.error-icon': "L\u1ED7i:",
    'project-pages.connect-space-dialog.footer.cancel': "H\u1EE7y",
    'project-pages.connect-space-dialog.footer.connect-space': "K\u1EBFt n\u1ED1i",
    'project-pages.connect-space-or-page-dialog.header.title': "K\u1EBFt n\u1ED1i d\u1EF1 \xe1n v\u1EDBi Confluence",
    'project-pages.connect-space.description': "V\xf9ng gi\u1ED1ng nh\u01B0 th\u01B0 m\u1EE5c - b\u1EA1n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng ch\xfang \u0111\u1EC3 t\u1EA1o, s\u1EAFp x\u1EBFp v\xe0 c\u1ED9ng t\xe1c cho t\u1EA5t c\u1EA3 n\u1ED9i dung li\xean quan \u0111\u1EBFn d\u1EF1 \xe1n c\u1EE7a b\u1EA1n.",
    'project-pages.connect-space.not-connected.description': "\u0110\u1EC3 s\u1EED d\u1EE5ng trang d\u1EF1 \xe1n, h\xe3y li\xean h\u1EC7 v\u1EDBi qu\u1EA3n tr\u1ECB vi\xean ho\u1EB7c tr\u01B0\u1EDFng nh\xf3m c\u1EE7a b\u1EA1n \u0111\u1EC3 k\u1EBFt n\u1ED1i Confluence v\u1EDBi d\u1EF1 \xe1n n\xe0y.",
    'project-pages.connect-space.not-connected.heading': "Kh\xf4ng \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i v\u1EDBi Confluence",
    'project-pages.connect-success-flag.description.content': "\u0110\xe3 k\u1EBFt n\u1ED1i th\xe0nh c\xf4ng v\u1EDBi n\u1ED9i dung {connectedSpaceOrPageName}.",
    'project-pages.connection-error.space-or-page-not-found.button': "K\u1EBFt n\u1ED1i v\u1EDBi m\u1ED9t kh\xf4ng gian ho\u1EB7c trang kh\xe1c",
    'project-pages.create-space-dialog.connection-error': "Kh\xf4ng th\u1EC3 k\u1EBFt n\u1ED1i.",
    'project-pages.create-space-dialog.connection-retry': "Th\u1EED l\u1EA1i",
    'project-pages.create-space-dialog.content.empty-name': "Vui l\xf2ng \u0111\u1EB7t t\xean cho v\xf9ng c\u1EE7a b\u1EA1n.",
    'project-pages.create-space-dialog.content.invalid-name': "T\xean v\xf9ng c\u1EA7n ch\u1EE9a t\u1ED1i thi\u1EC3u m\u1ED9t ch\u1EEF c\xe1i ho\u1EB7c ch\u1EEF s\u1ED1.",
    'project-pages.create-space-dialog.content.placeholder': "Nh\u1EADp t\xean v\xf9ng",
    'project-pages.create-space-dialog.creation-error': "Kh\xf4ng th\u1EC3 t\u1EA1o v\xf9ng.",
    'project-pages.create-space-dialog.error-icon': "L\u1ED7i:",
    'project-pages.create-space-dialog.footer.cancel': "H\u1EE7y",
    'project-pages.create-space-dialog.footer.create-space': "T\u1EA1o",
    'project-pages.create-space-dialog.header.title': "T\u1EA1o v\xf9ng Confluence m\u1EDBi",
    'project-pages.cross-join.access-revoked.templates.subtitle': "B\u1EA1n kh\xf4ng th\u1EC3 s\u1EED d\u1EE5ng c\xe1c trang d\u1EF1 \xe1n v\xec qu\u1EA3n tr\u1ECB vi\xean \u0111\xe3 t\u1EEB ch\u1ED1i y\xeau c\u1EA7u truy c\u1EADp v\xe0o Confluence c\u1EE7a b\u1EA1n. H\xe3y li\xean h\u1EC7 v\u1EDBi qu\u1EA3n tr\u1ECB vi\xean trang web c\u1EE7a b\u1EA1n \u0111\u1EC3 y\xeau c\u1EA7u c\u1EA5p quy\u1EC1n truy c\u1EADp.",
    'project-pages.cross-join.access-revoked.templates.title': "B\u1EA1n kh\xf4ng c\xf3 quy\u1EC1n s\u1EED d\u1EE5ng c\xe1c trang d\u1EF1 \xe1n",
    'project-pages.cross-join.avatar.view-profile': "Xem h\u1ED3 s\u01A1",
    'project-pages.cross-join.denied-request.templates.subtitle': "B\u1EA1n kh\xf4ng th\u1EC3 s\u1EED d\u1EE5ng c\xe1c trang d\u1EF1 \xe1n v\xec qu\u1EA3n tr\u1ECB vi\xean trang web \u0111\xe3 t\u1EEB ch\u1ED1i y\xeau c\u1EA7u tham gia Confluence c\u1EE7a b\u1EA1n.",
    'project-pages.cross-join.denied-request.templates.title': "Qu\u1EA3n tr\u1ECB vi\xean c\u1EE7a b\u1EA1n \u0111\xe3 t\u1EEB ch\u1ED1i y\xeau c\u1EA7u truy c\u1EADp c\u1EE7a b\u1EA1n",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "B\u1EA1n s\u1EBD c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o Confluence. Qu\u1EA3n tr\u1ECB vi\xean trang web \u0111\xe3 ph\xea duy\u1EC7t b\u1EA1n.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} n\u1EBFu thao t\xe1c l\xe0m m\u1EDBi kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c v\u1EA5n \u0111\u1EC1.",
    'project-pages.cross-join.errors.unknown-error.title': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 hi\u1EC3n th\u1ECB c\xe1c trang d\u1EF1 \xe1n ngay b\xe2y gi\u1EDD",
    'project-pages.cross-join.inline-join-product.button': "B\u1EA1n s\u1EBD c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o Confluence. Qu\u1EA3n tr\u1ECB vi\xean trang web \u0111\xe3 ch\u1EA5p thu\u1EADn b\u1EA1n.",
    'project-pages.cross-join.inline-join-product.connected.description': "Xem, ch\u1EC9nh s\u1EEDa v\xe0 t\u1EA1o t\xe0i li\u1EC7u t\u1EEB c\xf9ng m\u1ED9t n\u01A1i",
    'project-pages.cross-join.inline-join-product.connected.title': "C\u1ED9ng t\xe1c v\u1EDBi nh\xf3m c\u1EE7a b\u1EA1n tr\xean c\xe1c trang d\u1EF1 \xe1n",
    'project-pages.cross-join.pending-request.templates.subtitle': "Qu\u1EA3n tr\u1ECB vi\xean trang web \u0111\xe3 nh\u1EADn \u0111\u01B0\u1EE3c y\xeau c\u1EA7u tham gia Confluence c\u1EE7a b\u1EA1n. N\u1EBFu b\u1EA1n \u0111\u01B0\u1EE3c ch\u1EA5p thu\u1EADn tham gia, c\xe1c trang d\u1EF1 \xe1n s\u1EBD b\u1EAFt \u0111\u1EA7u ho\u1EA1t \u0111\u1ED9ng v\xe0 ch\xfang t\xf4i s\u1EBD g\u1EEDi cho b\u1EA1n email x\xe1c nh\u1EADn.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "B\u1EA1n s\u1EBD nh\u1EADn \u0111\u01B0\u1EE3c email k\xe8m quy\u1EC1n truy c\u1EADp v\xe0o Trang d\u1EF1 \xe1n sau khi b\u1EA1n \u0111\u01B0\u1EE3c ph\xea duy\u1EC7t.",
    'project-pages.cross-join.pending-request.templates.title': "B\u1EA1n \u0111\xe3 y\xeau c\u1EA7u c\u1EA5p quy\u1EC1n truy c\u1EADp v\xe0o Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u0110\xe3 g\u1EEDi y\xeau c\u1EA7u c\u1EA5p quy\u1EC1n truy c\u1EADp t\u1EDBi Qu\u1EA3n tr\u1ECB vi\xean",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Xem, ch\u1EC9nh s\u1EEDa v\xe0 t\u1EA1o t\xe0i li\u1EC7u d\u1EF1 \xe1n v\u1EDBi nh\xf3m c\u1EE7a b\u1EA1n",
    'project-pages.cross-join.request-access.button': "Y\xeau c\u1EA7u c\u1EA5p quy\u1EC1n truy c\u1EADp",
    'project-pages.cross-join.request-access.button-subtitle.experimental': 'Ch\u1ECDn "Tham gia \u0111\u1ED9i ng\u0169" ngh\u0129a l\xe0 b\u1EA1n \u0111ang y\xeau c\u1EA7u tham gia Confluence v\xe0 \u0111\u1ED3ng \xfd chia s\u1EBB h\u1ED3 s\u01A1 Atlassian c\u1EE7a b\u1EA1n v\u1EDBi qu\u1EA3n tr\u1ECB vi\xean.',
    'project-pages.cross-join.request-access.button.experimental': "Tham gia \u0111\u1ED9i ng\u0169",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u0110\u1ED9i ng\u0169 c\u1EE7a b\u1EA1n \u0111ang s\u1EED d\u1EE5ng Trang d\u1EF1 \xe1n \u0111\u1EC3 nh\u1EADn x\xe9t, s\u1EEDa v\xe0 c\u1ED9ng t\xe1c tr\xean t\xe0i li\u1EC7u d\u1EF1 \xe1n m\xe0 kh\xf4ng c\u1EA7n r\u1EDDi kh\u1ECFi Jira. Tham gia Confluence \u0111\u1EC3 truy c\u1EADp Trang d\u1EF1 \xe1n c\u1EE7a \u0111\u1ED9i ng\u0169.",
    'project-pages.cross-join.request-access.title': "C\u1EA7n c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o Confluence \u0111\u1EC3 s\u1EED d\u1EE5ng c\xe1c trang d\u1EF1 \xe1n",
    'project-pages.cross-join.request-access.title.experiment': "T\u1EA1o m\u1ED9t ngu\u1ED3n th\xf4ng tin duy nh\u1EA5t cho \u0111\u1ED9i ng\u0169 c\u1EE7a b\u1EA1n",
    'project-pages.default-contextual-heading': "C\xe1c trang d\u1EF1 \xe1n \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EDFi Confluence",
    'project-pages.default-contextual-message': "T\u1EA1o, chia s\u1EBB v\xe0 c\u1ED9ng t\xe1c tr\xean t\u1EA5t c\u1EA3 c\xe1c t\xe0i li\u1EC7u c\u1EE7a d\u1EF1 \xe1n \u1EDF m\u1ED9t n\u01A1i t\u1EADp trung duy nh\u1EA5t, v\u1EDBi trang Confluence.",
    'project-pages.default-reactivate-CTA': "H\u1EE7y k\xedch ho\u1EA1t Confluence",
    'project-pages.default-trial-CTA': "D\xf9ng th\u1EED Confluence mi\u1EC5n ph\xed trong 30 ng\xe0y",
    'project-pages.draft-saved-flag.action': "M\u1EDF b\u1EA3n nh\xe1p",
    'project-pages.draft-saved-flag.description': "B\u1EA3n nh\xe1p ch\u01B0a \u0111\u0103ng s\u1EBD ch\u1EC9 hi\u1EC3n th\u1ECB v\u1EDBi b\u1EA1n.",
    'project-pages.draft-saved-flag.title': "\u0110\xe3 l\u01B0u b\u1EA3n nh\xe1p",
    'project-pages.embedded-pages.create-page-error.close-button': "\u0110\xf3ng",
    'project-pages.embedded-pages.create-page-error.description': "\u0110\xe3 x\u1EA3y ra s\u1EF1 c\u1ED1 v\xe0 ch\xfang t\xf4i kh\xf4ng th\u1EC3 t\u1EA1o trang cho b\u1EA1n.",
    'project-pages.embedded-pages.create-page-error.title': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 t\u1EA1o trang",
    'project-pages.embedded-pages.create-page-error.try-again-button': "Th\u1EED l\u1EA1i",
    'project-pages.embedded-pages.modal.close.button.hint': "\u0110\xf3ng",
    'project-pages.embedded-pages.modal.title.button': "M\u1EDF trong Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "M\u1EDF trong tab m\u1EDBi",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} n\u1EBFu thao t\xe1c l\xe0m m\u1EDBi kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c m\u1ECDi th\u1EE9.",
    'project-pages.errors.unknown-error.title.non-final': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 hi\u1EC3n th\u1ECB c\xe1c trang d\u1EF1 \xe1n ngay b\xe2y gi\u1EDD",
    'project-pages.generic-error.button.reload': "T\u1EA3i l\u1EA1i trang",
    'project-pages.generic-error.description': "\u0110\xe3 x\u1EA3y ra l\u1ED7i. Vui l\xf2ng th\u1EED l\u1EA1i sau.",
    'project-pages.generic-error.description.non-final': "\u0110\xe3 x\u1EA3y ra l\u1ED7i. Vui l\xf2ng th\u1EED l\u1EA1i sau.",
    'project-pages.generic-error.heading': "Ch\xe0, th\u1EADt l\xe0 l\u1EA1...",
    'project-pages.generic-error.title.non-final': "Ch\xe0, th\u1EADt l\xe0 l\u1EA1...",
    'project-pages.generic-info-flag.description': "\u0110\xe3 x\u1EA3y ra l\u1ED7i. Vui l\xf2ng th\u1EED l\u1EA1i ho\u1EB7c li\xean h\u1EC7 v\u1EDBi b\u1ED9 ph\u1EADn h\u1ED7 tr\u1EE3 n\u1EBFu s\u1EF1 c\u1ED1 v\u1EABn ti\u1EBFp di\u1EC5n",
    'project-pages.generic-success-flag.description.page': "\u0110\xe3 k\u1EBFt n\u1ED1i th\xe0nh c\xf4ng v\u1EDBi trang {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.space': "\u0110\xe3 k\u1EBFt n\u1ED1i th\xe0nh c\xf4ng v\u1EDBi v\xf9ng {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.heading.page': "Trang \u0111\xe3 k\u1EBFt n\u1ED1i",
    'project-pages.generic-success-flag.heading.space': "\u0110\xe3 k\u1EBFt n\u1ED1i v\xf9ng",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Ho\u1EB7c t\u1EA1o m\u1ED9t kh\xf4ng gian m\u1EDBi",
    'project-pages.granular-pages.connect-space.button': "K\u1EBFt n\u1ED1i v\u1EDBi Confluence",
    'project-pages.granular-pages.connect-space.heading': "K\u1EBFt n\u1ED1i d\u1EF1 \xe1n n\xe0y v\u1EDBi v\xf9ng ho\u1EB7c trang Confluence",
    'project-pages.granular-pages.connect-space.heading.non-final': "K\u1EBFt n\u1ED1i d\u1EF1 \xe1n n\xe0y v\u1EDBi v\xf9ng ho\u1EB7c trang Confluence",
    'project-pages.improvement.contact-support': "Li\xean h\u1EC7 v\u1EDBi b\u1ED9 ph\u1EADn h\u1ED7 tr\u1EE3",
    'project-pages.improvement.errors.access-error.description': "H\xe3y th\u1EED li\xean h\u1EC7 v\u1EDBi qu\u1EA3n tr\u1ECB vi\xean trang web \u0111\u1EC3 c\xf3 quy\u1EC1n truy c\u1EADp.",
    'project-pages.improvement.errors.access-error.title': "B\u1EA1n kh\xf4ng c\xf3 quy\u1EC1n xem c\xe1c trang d\u1EF1 \xe1n",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u0110\xe3 x\u1EA3y ra l\u1ED7i khi c\u1ED1 g\u1EAFng hi\u1EC3n th\u1ECB c\xe1c trang t\u1EEB v\xf9ng Confluence \u0111\xe3 k\u1EBFt n\u1ED1i c\u1EE7a b\u1EA1n. {contactSupport} n\u1EBFu thao t\xe1c l\xe0m m\u1EDBi kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c m\u1ECDi th\u1EE9.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Ch\xfang t\xf4i \u0111\xe3 g\u1EB7p s\u1EF1 c\u1ED1 khi hi\u1EC3n th\u1ECB c\xe1c trang d\u1EF1 \xe1n",
    'project-pages.improvement.errors.space-or-page-not-found.description': "Kh\xf4ng gian ho\u1EB7c trang Confluence \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i \u0111\xe3 b\u1ECB chuy\u1EC3n \u0111i, l\u01B0u tr\u1EEF ho\u1EB7c x\xf3a. <link>Li\xean h\u1EC7 v\u1EDBi b\u1ED9 ph\u1EADn h\u1ED7 tr\u1EE3</link> n\u1EBFu thao t\xe1c k\u1EBFt n\u1ED1i l\u1EA1i kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c s\u1EF1 c\u1ED1",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Kh\xf4ng t\xecm th\u1EA5y kh\xf4ng gian ho\u1EB7c trang",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} n\u1EBFu thao t\xe1c l\xe0m m\u1EDBi kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c m\u1ECDi th\u1EE9.",
    'project-pages.improvement.errors.unknown-error.title': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 hi\u1EC3n th\u1ECB c\xe1c trang d\u1EF1 \xe1n ngay b\xe2y gi\u1EDD",
    'project-pages.improvement.feature1': "Truy c\u1EADp v\xe0 t\u1EA1o t\xe0i li\u1EC7u m\xe0 kh\xf4ng c\u1EA7n r\u1EDDi kh\u1ECFi Jira",
    'project-pages.improvement.feature2': "M\u1EABu cho cu\u1ED9c h\u1ECDp, k\u1EBF ho\u1EA1ch sprint, v.v.",
    'project-pages.improvement.feature3': "\u0110\u1ED3ng b\u1ED9 t\xe0i li\u1EC7u l\xean Jira \u0111\u1EC3 n\u1ED9i dung \u0111\u01B0\u1EE3c t\u1EF1 \u0111\u1ED9ng c\u1EADp nh\u1EADt",
    'project-pages.improvement.heading-info': "Th\u1EA5u hi\u1EC3u \u0111\u01B0\u1EE3c nh\xf3m c\u1EE7a b\u1EA1n v\xe0 c\u1EA3i thi\u1EC7n c\xe1ch b\u1EA1n ho\xe0n th\xe0nh c\xf4ng vi\u1EC7c.",
    'project-pages.improvement.heading-info-v2': "T\u1EA1o m\u1ED9t kh\xf4ng gian chung ch\u1EE9a m\u1ECDi t\xe0i li\u1EC7u d\u1EF1 \xe1n c\u1EE7a \u0111\u1ED9i ng\u0169.",
    'project-pages.improvement.learn-more-button': "T\xecm hi\u1EC3u th\xeam",
    'project-pages.improvement.powered-by': "\u0110\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EDFi",
    'project-pages.improvement.powered-by.tooltip': "M\u1EDF Confluence trong tab m\u1EDBi",
    'project-pages.improvement.preview-teaser': "M\u1EDF kh\xf3a bi\u1EC3u m\u1EABu, c\xe1c trang d\u1EF1 \xe1n v\xe0 nhi\u1EC1u l\u1EF1a ch\u1ECDn kh\xe1c.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>C\u1EADp nh\u1EADt c\xe1c b\xe1o c\xe1o d\u1EF1 \xe1n c\u1EE7a b\u1EA1n v\u1EDBi nh\xe3n tr\u1EA1ng th\xe1i t\u1EF1 \u0111\u1ED9ng c\u1EADp nh\u1EADt.</p> <p>Ch\u1EC9 c\u1EA7n li\xean k\u1EBFt phi\u1EBFu Jira trong t\xe0i li\u1EC7u v\xe0 phi\u1EBFu s\u1EBD t\u1EF1 \u0111\u1ED9ng hi\u1EC3n th\u1ECB nh\xe3n tr\u1EA1ng th\xe1i \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt \u0111\u1ED3ng b\u1ED9 v\u1EDBi phi\u1EBFu. V\xec v\u1EADy, b\u1EA1n kh\xf4ng ph\u1EA3i m\u1EA5t th\u1EDDi gian t\u1EA1o b\xe1o c\xe1o th\u1EE7 c\xf4ng.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "C\u1EADp nh\u1EADt li\u1EC1n m\u1EA1ch c\xe1c b\xean li\xean quan",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>T\u1EA1o t\xe0i li\u1EC7u nh\u1EA5t qu\xe1n b\u1EB1ng c\xe1ch s\u1EED d\u1EE5ng c\xe1c m\u1EABu t\xedch h\u1EE3p s\u1EB5n c\u1EE7a ch\xfang t\xf4i. C\xe1c m\u1EABu n\xe0y r\u1EA5t d\u1EC5 s\u1EED d\u1EE5ng v\xe0 c\xf3 th\u1EC3 t\xf9y ch\u1EC9nh theo nhu c\u1EA7u c\u1EE7a b\u1EA1n.</p> <p>V\xec c\xf3 th\u1EC3 s\u1EED d\u1EE5ng m\u1EABu tr\u1EF1c ti\u1EBFp t\u1EEB c\xe1c trang d\u1EF1 \xe1n n\xean b\u1EA1n kh\xf4ng bao gi\u1EDD ph\u1EA3i b\u1ECF d\u1EDF d\u1EF1 \xe1n m\xecnh \u0111ang l\xe0m. Duy\u1EC7t t\xecm t\u1EA5t c\u1EA3 c\xe1c m\u1EABu <a>t\u1EA1i \u0111\xe2y</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Th\u1ED1ng nh\u1EA5t c\xe1c ti\xeau chu\u1EA9n v\u1EC1 t\xe0i li\u1EC7u",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>T\u1EA1o m\u1ED9t ngu\u1ED3n th\xf4ng tin duy nh\u1EA5t cho th\xf4ng tin quan tr\u1ECDng b\u1EB1ng c\xe1ch t\u1EA1o v\xe0 qu\u1EA3n l\xfd t\xe0i li\u1EC7u t\u1EEB tab c\xe1c trang d\u1EF1 \xe1n trong Jira.</p> <p>B\u1EA1n c\xf3 bi\u1EBFt r\u1EB1ng c\xe1c trang d\u1EF1 \xe1n ch\u1EA1y tr\xean Confluence? Confluence mi\u1EC5n ph\xed cho t\u1ED1i \u0111a 10 ng\u01B0\u1EDDi d\xf9ng. M\u1EDDi nh\u1EEFng th\xe0nh vi\xean c\xf2n l\u1EA1i trong nh\xf3m c\u1EE7a b\u1EA1n th\xf4ng qua c\xe0i \u0111\u1EB7t qu\u1EA3n tr\u1ECB vi\xean.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "C\xe1c trang d\u1EF1 \xe1n c\u1EE7a b\u1EA1n, ngay trong Jira",
    'project-pages.improvement.templates.blank-page.description': "B\u1EAFt \u0111\u1EA7u m\u1ED9t trang ngay t\u1EEB \u0111\u1EA7u.",
    'project-pages.improvement.templates.blank-page.name': "Trang tr\u1ED1ng",
    'project-pages.improvement.templates.decision.description': "Ghi l\u1EA1i c\xe1c quy\u1EBFt \u0111\u1ECBnh quan tr\u1ECDng v\u1EC1 d\u1EF1 \xe1n v\xe0 trao \u0111\u1ED5i ch\xfang v\u1EDBi nh\xf3m c\u1EE7a b\u1EA1n.",
    'project-pages.improvement.templates.decision.name': "Quy\u1EBFt \u0111\u1ECBnh",
    'project-pages.improvement.templates.meeting-notes.description': "\u0110\u1EB7t ch\u01B0\u01A1ng tr\xecnh h\u1ECDp, ghi ch\xfa v\xe0 chia s\u1EBB c\xe1c m\u1EE5c h\xe0nh \u0111\u1ED9ng v\u1EDBi nh\xf3m.",
    'project-pages.improvement.templates.meeting-notes.name': "Bi\xean b\u1EA3n cu\u1ED9c h\u1ECDp",
    'project-pages.improvement.templates.post-expand.more': "C\xe1c m\u1EABu kh\xe1c",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Xem t\u1EA5t c\u1EA3 c\xe1c m\u1EABu trong Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': "C\xe1c m\u1EABu ph\u1ED5 bi\u1EBFn",
    'project-pages.improvement.templates.post-expand.title': "T\u1EA1o trang",
    'project-pages.improvement.templates.pre-expand.more': "Kh\xe1m ph\xe1 c\xe1c m\u1EABu kh\xe1c",
    'project-pages.improvement.templates.pre-expand.subtitle': "Quen thu\u1ED9c v\u1EDBi c\xe1c nh\xf3m nh\u01B0 nh\xf3m c\u1EE7a b\u1EA1n",
    'project-pages.improvement.templates.pre-expand.title': "Xem tr\u01B0\u1EDBc m\u1EABu",
    'project-pages.improvement.templates.product-requirements.description': "X\xe1c \u0111\u1ECBnh, theo d\xf5i v\xe0 xem x\xe9t c\xe1c y\xeau c\u1EA7u \u0111\u1ED1i v\u1EDBi s\u1EA3n ph\u1EA9m ho\u1EB7c t\xednh n\u0103ng c\u1EE7a b\u1EA1n.",
    'project-pages.improvement.templates.product-requirements.name': "Y\xeau c\u1EA7u s\u1EA3n ph\u1EA9m",
    'project-pages.improvement.templates.retrospective.description': "Ph\u1EA7n n\xe0o \u0111\xe3 t\u1ED1t r\u1ED3i? Ph\u1EA7n n\xe0o c\xf2n c\xf3 th\u1EC3 c\u1EA3i thi\u1EC7n? C\u1EA3i thi\u1EC7n ngu\u1ED3n l\u1EF1c c\u1ED9ng \u0111\u1ED3ng v\u1EDBi nh\xf3m c\u1EE7a b\u1EA1n.",
    'project-pages.improvement.templates.retrospective.name': "Xem l\u1EA1i",
    'project-pages.improvement.templates.template.disabled-tooltip': "Tr\u01B0\u1EDBc ti\xean, h\xe3y k\u1EBFt n\u1ED1i v\u1EDBi m\u1ED9t v\xf9ng Confluence",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Ti\u1EBFt ki\u1EC7m th\u1EDDi gian v\xe0 gi\u1EA3m s\u1ED1 t\xe1c v\u1EE5 c\u1EA7n th\u1EF1c hi\u1EC7n th\u1EE7 c\xf4ng</b>. Confluence c\xf3 v\xf4 v\xe0n <a>m\u1EABu</a> trang n\xean b\u1EA1n kh\xf4ng bao gi\u1EDD ph\u1EA3i b\u1EAFt \u0111\u1EA7u t\u1EEB \u0111\u1EA7u. C\xe1c m\u1EABu n\xe0y bao g\u1ED3m t\xe0i li\u1EC7u k\u1EF9 thu\u1EADt, h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1, k\u1EBF ho\u1EA1ch d\u1EF1 \xe1n, y\xeau c\u1EA7u v\u1EC1 s\u1EA3n ph\u1EA9m, v.v.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>D\u1EC5 d\xe0ng s\u1EEDa v\xe0 \u0111\u1ECBnh d\u1EA1ng.</b> Truy c\u1EADp menu s\u1EEDa \u1EDF ph\xeda tr\xean c\xf9ng \u0111\u1EC3 s\u1EED d\u1EE5ng t\xednh n\u0103ng \u0111\u1ECBnh d\u1EA1ng v\u0103n b\u1EA3n ti\xeau chu\u1EA9n v\xe0 nh\u1EADp <b>/</b> \u0111\u1EC3 d\u1EC5 d\xe0ng ch\xe8n nhi\u1EC1u th\xe0nh ph\u1EA7n t\xedch h\u1EE3p ti\u1EC7n d\u1EE5ng. Nh\u1EADp <c>/b\u1EA3ng</c> \u0111\u1EC3 ch\xe8n b\u1EA3ng ho\u1EB7c nh\u1EADp <c>/\u1EA3nh</c> \u0111\u1EC3 ch\xe8n \u1EA3nh. B\u1EA1n c\u0169ng c\xf3 th\u1EC3 ch\xe8n li\xean k\u1EBFt \u0111\u1EBFn Dropbox <c>/dropbox</c>, c\xf4ng c\u1EE5 v\u0103n ph\xf2ng c\u1EE7a Microsoft <c>/microsoft</c> ho\u1EB7c b\u1EA3ng v\xe0 th\u1EBB c\u1EE7a Trello <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Nh\u1EADp / r\u1ED3i nh\u1EADp "b\u1EA3ng" ho\u1EB7c "\u1EA3nh"',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Sau \u0111\xe2y l\xe0 m\u1ED9t s\u1ED1 m\u1EB9o gi\xfap b\u1EA1n b\u1EAFt \u0111\u1EA7u:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "Li\xean k\u1EBFt ti\u1EC7n d\u1EE5ng",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "S\u1EED d\u1EE5ng Jira k\u1EBFt h\u1EE3p c\xf9ng Confluence",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "T\u1EA1o bi\u1EC3u \u0111\u1ED3 tr\xean c\xe1c trang c\u1EE7a b\u1EA1n b\u1EB1ng d\u1EEF li\u1EC7u th\u1EF1c t\u1EEB Jira. Nh\u1EADp <c>/bi\u1EC3u \u0111\u1ED3 Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Li\xean k\u1EBFt \u0111\u1EBFn v\u1EA5n \u0111\u1EC1 tr\xean Jira \u1EDF v\u1ECB tr\xed b\u1EA5t k\u1EF3 tr\xean trang. Li\xean k\u1EBFt tr\xean trang s\u1EBD c\u1EADp nh\u1EADt trong th\u1EDDi gian th\u1EF1c khi b\u1EA1n c\u1EADp nh\u1EADt v\u1EA5n \u0111\u1EC1 tr\xean Jira. Nh\u1EADp <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u0110\u01B0a l\u1ECBch tr\xecnh d\u1EF1 \xe1n v\xe0 l\u1ECBch tr\xecnh mang t\xednh t\u01B0\u01A1ng t\xe1c v\xe0o trang th\xf4ng qua c\xe1c D\u1EF1 \xe1n Jira. Nh\u1EADp <c>/l\u1ECBch tr\xecnh d\u1EF1 \xe1n jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u0110\u01B0a l\u1ECBch tr\xecnh mang t\xednh t\u01B0\u01A1ng t\xe1c v\xe0o trang th\xf4ng qua c\xe1c D\u1EF1 \xe1n Jira. Nh\u1EADp <c>/jira timeline</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76% kh\xe1ch h\xe0ng s\u1EED d\u1EE5ng Jira Software cho bi\u1EBFt h\u1ECD b\xe0n giao d\u1EF1 \xe1n nhanh h\u01A1n sau khi th\xeam Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76% kh\xe1ch h\xe0ng s\u1EED d\u1EE5ng Jira cho bi\u1EBFt h\u1ECD b\xe0n giao d\u1EF1 \xe1n nhanh h\u01A1n sau khi th\xeam Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>S\u1EED d\u1EE5ng c\xe1c trang v\xe0 kh\xf4ng gian</b>. Kh\xf4ng gian l\xe0 m\u1ED9t ph\u1EA7n c\xf3 m\u1EB7t tr\xean m\u1ECDi trang Confluence nh\u1EB1m gi\xfap s\u1EAFp x\u1EBFp c\xe1c trang theo danh m\u1EE5c. B\u1EA1n c\xf3 th\u1EC3 coi kh\xf4ng gian l\xe0 c\xe1c th\u01B0 m\u1EE5c ho\u1EB7c d\u1EF1 \xe1n kh\xe1c nhau, c\xf2n trang l\xe0 t\xe0i li\u1EC7u thu\u1ED9c v\u1EC1 c\xe1c th\u01B0 m\u1EE5c ho\u1EB7c d\u1EF1 \xe1n \u0111\xf3. <a>T\xecm hi\u1EC3u th\xeam v\u1EC1 c\xe1ch s\u1EED d\u1EE5ng kh\xf4ng gian</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "Th\u1EED ngay",
    'project-pages.improvement.templates.tutorial.description': "T\xecm hi\u1EC3u c\xe1ch s\u1EEDa m\u1ED9t trang.",
    'project-pages.improvement.templates.tutorial.name': "Ch\xe0o m\u1EEBng b\u1EA1n \u0111\u1EBFn v\u1EDBi c\xe1c trang D\u1EF1 \xe1n!",
    'project-pages.improvement.terms-and-conditions-v2': "Ch\u1ECDn &quot;D\xf9ng th\u1EED ngay&quot; c\xf3 ngh\u0129a l\xe0 b\u1EA1n c\xf4ng nh\u1EADn r\u1EB1ng b\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c \u0111\u0103ng k\xfd tham gia Confluence c\u0169ng nh\u01B0 \u0111\u1ED3ng \xfd v\u1EDBi <termsLink>\u0110i\u1EC1u kho\u1EA3n d\u1ECBch v\u1EE5</termsLink> v\xe0 <privacyLink>Ch\xednh s\xe1ch quy\u1EC1n ri\xeang t\u01B0</privacyLink> c\u1EE7a Atlassian Cloud.",
    'project-pages.improvement.title': "C\xe1c trang d\u1EF1 \xe1n",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "T\u1EA1o trang",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Ch\xfang t\xf4i \u0111\xe3 th\xeam Confluence \u0111\u1EC3 b\u1EA1n c\xf3 th\u1EC3 b\u1EAFt \u0111\u1EA7u t\u1EA1o v\xe0 li\xean k\u1EBFt t\u1EA5t c\u1EA3 t\xe0i li\u1EC7u d\u1EF1 \xe1n c\u1EE7a b\u1EA1n. Mi\u1EC5n ph\xed cho t\u1ED1i \u0111a 10 ng\u01B0\u1EDDi d\xf9ng.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "T\xecm hi\u1EC3u th\xeam",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "T\u1EA1o trang \u0111\u1EA7u ti\xean",
    'project-pages.improvement.transient-states.empty-state.description': "T\u1EA1o v\xe0i ghi ch\xfa cu\u1ED9c h\u1ECDp, y\xeau c\u1EA7u s\u1EA3n ph\u1EA9m, quy\u1EBFt \u0111\u1ECBnh ho\u1EB7c n\u1ED9i dung kh\xe1c \u0111\u1EC3 th\u1EA5y v\xf9ng n\xe0y l\u1EA5p \u0111\u1EA7y.",
    'project-pages.improvement.transient-states.empty-state.title': "Kh\xf4ng c\xf3 g\xec \u1EDF \u0111\xe2y ngo\xe0i ti\u1EC1m n\u0103ng",
    'project-pages.improvement.try-button': "Th\u1EED bi\u1EC3u m\u1EABu n\xe0y trong Confluence",
    'project-pages.improvement.try-it-now': "D\xf9ng th\u1EED ngay",
    'project-pages.improvement.try-lozenge': "Th\u1EED",
    'project-pages.improvement.try-on-demand-button': "D\xf9ng th\u1EED mi\u1EC5n ph\xed",
    'project-pages.page-deleted-flag.title': "\u0110\xe3 x\xf3a trang.",
    'project-pages.page-published-flag.title': "\u0110\xe3 \u0111\u0103ng trang c\u1EE7a b\u1EA1n.",
    'project-pages.unknown-error.description': "{contactSupport} n\u1EBFu thao t\xe1c l\xe0m m\u1EDBi kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c m\u1ECDi th\u1EE9.",
    'project-pages.unknown-error.heading': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 hi\u1EC3n th\u1ECB c\xe1c trang d\u1EF1 \xe1n ngay b\xe2y gi\u1EDD",
    'projectpages.templatepreview.termsandprivacy': "B\u1EB1ng c\xe1ch nh\u1EA5p v\xe0o &quot;D\xf9ng th\u1EED mi\u1EC5n ph\xed&quot;, b\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c \u0111\u0103ng k\xfd v\xe0o Confluence v\xe0 \u0111\u1ED3ng \xfd v\u1EDBi <termsOfServiceLinkText>\u0110i\u1EC1u kho\u1EA3n d\u1ECBch v\u1EE5</termsOfServiceLinkText> v\xe0 <privacyPolicyLinkText>Ch\xednh s\xe1ch quy\u1EC1n ri\xeang t\u01B0</privacyPolicyLinkText> c\u1EE7a Atlassian Cloud."
};

});

parcelRegister("bSwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $71468ef004aa757f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $71468ef004aa757f$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u2063\u2062This should take less than a minute\x8d\u206A\u206B\u206D\u206D\u206E\u206C\u061C\u206F\x8d\u206C\u206C\x8d\u206D\u200C\u206E\x9d\u206D\u206F\u206E\u200C\u206A\u206D\u206A\x81\x8d\u206F\u200D\u206A\u206F\u200C\u206D\u2063\u2064",
    'confluence.project-pages.improvement.provisioning-background.title': "\u2063\u2062Setting up your Project Pages\u206D\u206F\x90\u206C\x9d\u206D\u200D\u206A\u061C\u206B\u206A\u206D\x90\u206B\u200D\u206E\x90\u206D\u061C\u2060\u206D\u2060\u200D\x90\x81\u206F\x90\u2061\u206B\u206E\u206D\u2060\u2063\u2064",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u2063\u2062Dismiss\x9d\u200C\u2060\u200D\x90\u206A\x9d\u206A\u206C\u206F\x81\u200C\u200C\u206E\x8f\u206B\u206C\x8d\u206C\x9d\u206A\x9d\u200C\u206C\x9d\u206D\x8d\u2061\u206C\x90\x90\u206B\u2063\u2064",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u2063\u2062Done\x9d\u206E\u061C\u206D\x81\u2061\u200D\u061C\u206D\x81\u200D\x9d\u206C\u061C\x9d\x8d\u206E\u200D\u206E\x81\u206D\u206F\x8d\u061C\u206C\u206A\u206A\u200C\x9d\x8f\u200C\x9d\u2063\u2064",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u2063\u2062Next\u061C\u206C\u206A\u200D\u200D\u200D\u200D\u206E\u206B\u206F\u206D\x9d\u206D\u206C\x8f\u061C\u2061\x90\u206B\u206B\u206C\u206E\u206A\u2061\u206A\u206C\u2060\x8d\u2060\u200D\u206C\u200D\u2063\u2064",
    'embedded-content-tree.button.connect-different-source.label.non-final': "\u2063\u2062Update space or page icon\u206C\u206E\u200C\u206E\x81\u206F\u200C\u200C\u2061\u200C\u206B\u2061\u2061\x8f\u206B\u206B\x8d\u206A\u206B\u206D\x81\x9d\u061C\x8d\u206D\x81\u206A\u200C\u206B\x8d\u206B\x8d\u2063\u2064",
    'embedded-content-tree.button.connect-different-source.tooltip.non-final': "\u2063\u2062Connect different space or page\x9d\x81\u206C\u200D\u206B\u2060\u206B\u206A\u206A\u2061\u206D\u206C\u200C\u206E\u206E\x8d\x81\x9d\u2061\u206F\u206E\u206F\u206F\u206B\u061C\u200D\u206C\u200C\u206E\u206D\x8f\u206D\u2063\u2064",
    'embedded-content-tree.button.connect-to-confluence.tooltip.non-final': "\u2063\u2062Connect to Confluence\u206A\x90\x9d\u2061\u206E\u206F\u200C\x9d\u206D\u206A\u2061\u206E\u061C\u206C\u2060\u206A\u206A\u206E\u200D\u206D\u206A\u206D\u206B\u206E\u206A\u206A\u206A\u206D\u200D\u200D\u061C\x8d\u2063\u2064",
    'embedded-content-tree.button.go-to-connected-page.tooltip.non-final': "\u2063\u2062Open page in Confluence\x8d\u206B\x81\x9d\u206D\u206B\u206D\u206B\x9d\u206A\u2060\u206E\u206A\u206C\u206D\u200D\u206E\u200D\u2061\x81\u206F\x8d\u2061\x8d\u206A\x90\u206E\u061C\u061C\x8d\x81\u200D\u2063\u2064",
    'embedded-content-tree.button.go-to-connected-space.tooltip.non-final': "\u2063\u2062Open space in Confluence\u206D\u206A\u206E\x8d\u206A\u2060\x90\u206B\u2060\u200D\u206B\u200C\u200C\u206C\u200C\u206E\u206E\u200D\x8f\x8f\u061C\u206E\u061C\x9d\u206F\u061C\x81\x8f\u206F\x9d\u2060\u2060\u2063\u2064",
    'embedded-content-tree.column.contributors.non-final': "\u2063\u2062Contributors\u2060\u206D\x90\u206C\x90\x90\x8d\u2061\u206B\x90\u061C\u206B\u206C\u206D\u2060\x81\u206B\u206D\u2060\u2061\u206D\x90\u200D\x81\u206F\u2061\u206E\u206B\x9d\u200D\u2061\u206B\u2063\u2064",
    'embedded-content-tree.column.last-modified.non-final': "\u2063\u2062Last modified\x9d\x90\u206D\u206E\u200C\u206B\x9d\u200D\x8f\u2060\x81\u206B\u206D\u206E\u2061\u206F\x9d\x9d\u200D\x90\u2060\u206A\u206E\x9d\u2060\u206B\u206A\u206F\u2061\x81\u206C\x9d\u2063\u2064",
    'embedded-content-tree.column.title.non-final': "\u2063\u2062Name\u206A\u2060\u206A\u200D\u200D\u2060\x90\x8d\x8f\u206E\u200D\u2060\u206C\u061C\x8d\x8d\u200D\u061C\u2061\u200C\u206C\x81\u206D\u206F\u206A\x8d\x8d\x8d\u206F\u206B\u061C\x9d\u2063\u2064",
    'embedded-content-tree.could-not-load-contributors.non-final': "\u2063\u2062Couldn't load contributors\u200D\u2061\x8d\x81\x9d\u206A\u206E\x81\u206C\u200D\u2060\x8d\u2061\u2060\x8d\u061C\x8f\u206B\u061C\x8d\x8d\u206F\x8d\x9d\x8f\x9d\u206E\x9d\u061C\u061C\u206A\u206E\u2063\u2064",
    'embedded-content-tree.could-not-load.non-final': "\u2063\u2062Couldn't load\x9d\x8d\u206C\u200D\x90\u206D\u061C\x8f\u206A\x9d\x8f\u206C\u206D\x90\x90\u200D\u200C\u200C\u2060\x90\u200D\x9d\u2061\u206B\u200C\u061C\x8f\u206B\u206F\u200D\u2060\x8d\u2063\u2064",
    'embedded-content-tree.create-child-page.non-final': "\u2063\u2062Create a child page\u206C\u206C\u2060\u200D\u206B\x8d\u206F\u200D\u2060\u206B\u206D\u206C\u200D\x90\x8f\x8f\u2061\u206D\u206C\u200D\u2060\x8d\u061C\u061C\x8f\u206E\u206C\u206C\u2060\u206B\u206F\u200C\u2063\u2064",
    'embedded-content-tree.create-page.non-final': "\u2063\u2062Create page\x9d\u206C\x81\u206F\u2060\u206C\u200D\x81\u200D\u206E\u200D\u2061\u206F\x90\x81\u206B\u061C\x90\u206F\x9d\x81\u061C\u206D\u2061\x8d\u206F\u206B\u206D\u206A\u206E\x8f\u206F\u2063\u2064",
    'embedded-content-tree.drafts-toggle.label.non-final': "\u2063\u2062Show drafts\x8f\u2061\u200C\x8f\x9d\u200D\u206D\x9d\u206A\u061C\u061C\u200D\x90\x8f\u206E\u2061\u206A\u200D\u206A\u206C\u200D\x8d\u200C\u200D\u206E\x8f\u206C\u206F\u2060\u206D\u206C\x8f\u2063\u2064",
    'embedded-content-tree.edit-in-confluence.non-final': "\u2063\u2062Edit in Confluence\x90\u061C\x81\u200D\x81\u206A\x8d\x90\x81\u206F\x8f\u206D\u206C\x8d\u206A\u206B\x8f\u061C\u2060\u2060\u2061\x8d\u200C\x90\u206C\x81\u200C\u206C\u061C\x8d\u206E\u2061\u2063\u2064",
    'embedded-content-tree.edit.non-final': "\u2063\u2062Edit\u206A\x8d\u206D\u200D\u206A\u200D\u206D\u2061\u2061\u2061\u2060\u206E\x8d\x8f\u206D\u206A\u206E\u2061\u206C\x9d\u2060\u200C\x8f\u2060\u206C\u206C\u061C\u206D\x81\x90\u200D\u206A\u2063\u2064",
    'embedded-content-tree.empty.description.non-final': "\u2063\u2062Create some meeting notes, product requirements, decisions, or other content to see this space fill up.\x8f\u206E\u206A\x8f\u2060\u206A\u200C\u061C\u061C\u206B\u206C\u206B\u2061\x81\x9d\u206A\u206B\u2061\u200C\u206F\u206C\u200D\u2060\u061C\u206D\u061C\x90\x8f\u2060\u200D\u206C\x8d\u2063\u2064",
    'embedded-content-tree.empty.title.non-final': "\u2063\u2062There's nothing here but potential\u206B\u206E\u2060\u206C\u200D\x8d\x9d\x9d\x9d\u2061\x8f\u206C\u206B\u061C\u061C\u206D\u200D\u206D\x90\u2061\u206C\x9d\x9d\x8f\u206E\u200C\u200C\u200D\x8f\u206E\u2061\u206E\u2063\u2064",
    'embedded-content-tree.error.description.non-final': "\u2063\u2062We can't show you these pages. Please try again later.\u206E\u206F\u206B\u200D\x9d\u061C\u206E\u206D\u206E\u2061\x8f\x90\u061C\u061C\u2061\u2060\u206F\x8d\u206B\x8f\u206B\u061C\x90\x81\u2061\u206D\u206B\x9d\u206E\u206A\u206C\x81\u2063\u2064",
    'embedded-content-tree.error.row.non-final': "\u2063\u2062Unable to load pages.\x8d\u206C\u206C\u206D\x9d\u200D\u061C\u206C\x9d\u206C\u206B\u206C\x81\u200C\x81\u206B\u2060\u2061\u2061\x90\x9d\u206A\u061C\u2061\u206E\u206D\u200D\u206A\u2061\u206E\u061C\u206F\u2063\u2064",
    'embedded-content-tree.error.title.non-final': "\u2063\u2062Well, this is awkward...\u206C\x90\u206A\u2060\u061C\x9d\x90\u061C\u200D\u206C\x8f\u206B\u061C\u2061\x90\u2060\x9d\u206A\u2061\u200D\u200C\u206D\u061C\u2060\x90\u206D\u206A\x90\u206B\u206F\x9d\u206D\u2063\u2064",
    'embedded-content-tree.friendly-when-created.non-final': "\u2063\u2062Created\u200C\u2061\u206E\u200D\x90\u2061\x81\u2061\x8d\u2060\u2061\u200D\x8f\x90\x8d\x8f\u061C\x81\x8d\x81\u200D\x90\u206E\x8d\x81\u2060\u206E\u200C\x90\x8f\u061C\u200D\u2063\u2064",
    'embedded-content-tree.friendly-when-updated.non-final': "\u2063\u2062Updated\u206F\u206C\x81\u200D\u2061\u206B\u206B\u206D\u061C\u200D\x8f\x9d\u206A\u200C\x8f\u061C\u061C\x90\x90\x9d\u206B\u200C\x90\u061C\u2061\x9d\x8d\u2060\u2060\u200D\u200D\x81\u2063\u2064",
    'embedded-content-tree.view-profile.non-final': "\u2063\u2062View profile\x90\u200C\x8f\u206A\x9d\x8f\x90\x8d\u206C\u2060\x90\u2061\x90\x90\x9d\x90\x8d\u206F\x90\x8d\u200C\u2061\u200C\u206C\u206B\u206A\u206C\x8f\u206A\u206E\u206A\u206A\u2063\u2064",
    'project-pages.activating.description': "\u2063\u2062The connected Confuence space isn\u2019t quite ready yet. {contactSupport} if refreshing doesn\u2019t fix things.\x90\x9d\u206D\x81\u206C\u206C\u206A\u206E\u2060\x90\x8d\u206F\u200D\u200D\u061C\u061C\x90\x81\u206A\u206A\u200D\x81\u200D\x8d\u200C\u206C\u200D\x8d\u061C\x9d\x9d\u206F\u2063\u2064",
    'project-pages.activating.heading': "\u2063\u2062Confluence is still loading\x8f\u2061\x90\x90\u206B\x9d\x9d\u206F\x8f\u206B\u200C\u200C\u206A\u061C\x81\u206C\u206C\u206D\u061C\u061C\u061C\u2060\u206F\u206A\u206E\u206E\u206D\u206D\u206E\u206C\u200C\x8d\u2063\u2064",
    'project-pages.button.connect-different-space-or-page.label': "\u2063\u2062Update space or page icon\u206B\u206E\x81\x81\u061C\u200C\u206B\u206D\x81\x81\u206E\x90\x8f\u206D\x8d\x8d\x8f\u206A\u206A\u206E\u206E\x90\u206E\u206D\u061C\u206A\u206E\u2060\u2061\u206C\u2060\x8f\u2063\u2064",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u2063\u2062Connect different space or page\u206C\u206E\x81\u206B\u206D\u200D\u2060\x9d\u206B\u206C\x9d\u2060\u206D\u206F\u206C\x9d\u206E\u206A\u200C\u206D\x9d\u206D\x8d\u206A\u200D\u061C\u206C\x8f\u061C\u206A\u2060\u061C\u2063\u2064",
    'project-pages.button.connect-space-or-page.tooltip': "\u2063\u2062Connect to Confluence\u206F\u2060\u206F\x81\u2061\u206B\x9d\x90\x9d\x81\u206A\x8f\u200C\u2060\u206A\u206E\u206B\u206A\u206C\u206B\x8d\u2061\u206C\x9d\x8f\u200C\u206C\u206D\u200C\u206D\u206D\u206C\u2063\u2064",
    'project-pages.button.go-to-connected-page.tooltip': "\u2063\u2062Open page in Confluence\u061C\u061C\u200C\u200C\u206A\x8f\u206A\u2061\x90\u206E\u206B\u206A\x8f\u200D\u206D\u206F\u2060\u061C\x90\u206B\x8f\u206F\u206B\u061C\u206B\u206E\u206A\x9d\u206C\u200D\u206F\u206F\u2063\u2064",
    'project-pages.button.go-to-connected-space.tooltip': "\u2063\u2062Open space in Confluence\u2061\u200D\u200C\x90\u206A\u2060\u200C\u200C\x90\u2060\x90\x90\x8f\x8d\x8d\x8f\x81\u200C\x90\u206C\u200C\u2061\u206A\u206E\u206B\u200C\u206A\u206A\u200C\x8f\x8d\x9d\u2063\u2064",
    'project-pages.connect-space-dialog.connection-error': "\u2063\u2062Connection failed.\u2060\x8d\u200C\u200C\u061C\u061C\u2061\x8f\u206F\u206F\u061C\x9d\u206B\u206B\u206A\x90\x90\u206E\u206F\u200D\u2061\x81\u206D\x90\u200C\u206B\x8d\x8d\x90\x90\u206F\u206C\u2063\u2064",
    'project-pages.connect-space-dialog.connection-retry': "\u2063\u2062Retry\u206C\u2061\u206E\x9d\u200C\x9d\x8d\x8d\u200C\u200C\u200D\x8f\x81\x9d\u206B\u206D\u206E\x90\u206F\u206D\u206A\x8d\u2060\u206A\u206A\x9d\u206C\u2061\u2060\u061C\x8f\u061C\u2063\u2064",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u2063\u2062Choose a space or page to connect to your project.\u206E\x90\u2060\u200D\u206F\u2061\u061C\x90\x8f\u206C\x90\u206C\u206E\x8d\u200D\x8f\u2061\x9d\u206D\x9d\x90\x9d\u206B\x81\x8f\x8d\u200D\u206B\x81\x9d\u206C\x8d\u2063\u2064",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "\u2063\u2062Search Confluence\u200C\u206A\x9d\x9d\u2060\u206D\x8d\u206C\u2060\x90\x90\x90\u200C\u206B\u2060\u206A\u206C\x8d\u206C\u206D\u206A\u206C\u2060\u2061\u200D\u206C\x8d\u206D\u206A\u206B\x9d\x9d\u2063\u2064",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u2063\u2062This project needs to be connected to a space before you can create a page. Choose a space to connect to this project.\u200D\x9d\u061C\u061C\u2060\u206A\x81\u206D\x9d\u206A\x90\x8f\u206D\x81\u2061\u200D\u061C\u206C\u061C\x81\x9d\x90\u206A\u200C\u206A\x8f\u206B\x81\x8f\u206A\x90\x8f\u2063\u2064",
    'project-pages.connect-space-dialog.error-icon': "\u2063\u2062Error:\u206D\u206A\x81\x81\u206C\x8f\u206E\u206A\u2061\u206D\x8f\u206E\u2061\u061C\u206C\u2061\u2061\u206B\u206D\u200D\x90\x81\u206B\u2061\x8d\u206C\x81\u206E\u206F\x90\u206E\u206B\u2063\u2064",
    'project-pages.connect-space-dialog.footer.cancel': "\u2063\u2062Cancel\u206C\x8f\u206D\x81\u206E\u206B\u206E\x8d\x81\x9d\u061C\u206D\x8f\x9d\u206C\x8f\x9d\u206A\u206F\x8d\u061C\x8f\x81\u206C\u200D\x81\u2061\u2061\u206B\x90\u206C\u061C\u2063\u2064",
    'project-pages.connect-space-dialog.footer.connect-space': "\u2063\u2062Connect\x9d\x9d\x90\u200C\x8d\u206E\u206A\u206C\u200D\u206F\u206D\x8d\u200C\u206B\u206C\u206E\u2061\u061C\u206F\u206C\u061C\u200C\x8f\u206F\u200D\u206D\u061C\x8f\u206B\u2060\u206B\u206E\u2063\u2064",
    'project-pages.connect-space-or-page-dialog.header.title': "\u2063\u2062Connect project to Confluence\x81\u061C\u061C\x81\x81\x90\u206C\u2060\u200C\u206D\u206D\u200D\x9d\x9d\u200D\x81\u2060\u200D\u206C\u206D\u206D\u2060\x9d\x81\u206E\u206A\u2061\u2061\u206A\u200D\x8d\x8d\u2063\u2064",
    'project-pages.connect-space.button.non-final': "\u2063\u2062Connect to Confluence\u206E\x90\x8f\u206B\x81\u200C\u2060\u2060\u206A\u206D\u200D\x90\u206A\x81\x8d\x8d\u061C\u061C\u061C\u206F\u206D\u200C\u206A\u206A\u206D\u206B\x9d\x8d\u206F\u2060\x8f\u206D\u2063\u2064",
    'project-pages.connect-space.description': "\u2063\u2062Spaces are like folders - you can use them to create, organize, and collaborate on all the content related to your project.\u206B\u061C\u206F\u200C\u206F\x90\x90\x8d\u206C\u200D\x8f\u206B\u200D\u206D\u206B\u206E\u206F\u206B\u2060\u2060\x81\x8d\u206C\u206D\u206B\u206B\u206F\x81\u206C\u061C\u206C\u206F\u2063\u2064",
    'project-pages.connect-space.description.non-final': "\u2063\u2062Spaces are like folders - you can use them to create, organize, and collaborate on all the content related to your project.\u206C\x8f\x8f\u206D\u2060\u2060\u206A\u200D\u206D\u206A\u206B\u206C\x81\u206E\u200C\x81\u200C\x81\x81\x8f\u206A\u200D\u200C\u200D\u061C\x8f\x90\x9d\u206E\u206C\u206A\u2061\u2063\u2064",
    'project-pages.connect-space.not-connected.description': "\u2063\u2062To use project pages, contact your admin or team lead to connect Confluence to this project.\u200C\u200C\u061C\u2060\u2061\x8d\u206B\u206E\u206C\u206F\u206E\x90\u206E\u200D\x8d\x8f\x81\x90\x90\x9d\u2061\x8f\u200D\x81\u2060\u2060\u206E\u206E\u2061\x9d\u206A\u200C\u2063\u2064",
    'project-pages.connect-space.not-connected.description.non-final': "\u2063\u2062To use project pages, contact your admin or team lead to connect Confluence to this project.\u206B\u206D\u2061\x8d\x90\x90\u206D\u206B\x81\u206B\x81\x8d\u206D\u2060\u2060\u206D\u206F\u206E\u206C\u2060\x8d\u206C\u206D\u2060\u206F\x9d\x90\u2061\u206B\u206E\u061C\u200D\u2063\u2064",
    'project-pages.connect-space.not-connected.heading': "\u2063\u2062Not connected to Confluence\x90\x90\u206F\x8d\x9d\u206D\u206F\u206A\u206E\x90\u206E\x9d\u206E\u200C\u200C\u2061\u200D\u206C\u206E\x81\x81\u206B\u206B\u2061\u200C\u2061\x8f\u206A\u200C\x9d\x8f\u206A\u2063\u2064",
    'project-pages.connect-space.not-connected.heading.non-final': "\u2063\u2062Unable to connect to Confluence\u206C\x8d\u206E\x9d\u206A\u206B\x9d\u2060\u206A\x8f\u206D\u206D\x81\x8d\u206A\u206B\u206A\u200C\x81\u206B\u200C\x8d\u061C\u2060\u206B\u200C\u206C\u206D\u206F\u206A\u206A\u200D\u2063\u2064",
    'project-pages.connect-success-flag.description.content': "\u2063\u2062Successfully connected with {connectedSpaceOrPageName} content.\u206D\x9d\x81\u206B\x90\x8d\u200C\u206A\x9d\u2060\x9d\u206D\x81\u200C\u200C\x9d\u061C\x90\u206F\x8d\u206F\x81\u200C\u206F\u2060\u206E\x9d\u206E\u206F\u206D\u206B\u206D\u2063\u2064",
    'project-pages.connection-error.space-or-page-not-found.button': "\u2063\u2062Connect to a different space or page\u200D\x9d\u2060\u061C\x8d\u061C\x8d\u206F\u061C\u061C\u2060\u206E\x9d\u206F\u206E\u200D\u200C\x8f\u206E\u206A\u206C\x9d\x81\u206B\x90\x8d\u061C\u206B\u206A\u206D\u206E\u206E\u2063\u2064",
    'project-pages.contact-support.non-final': "\u2063\u2062Contact support\x8f\u206E\u206E\u200D\u200C\u061C\x81\x8f\x81\u206B\u206C\u2061\u206A\u200C\u206A\x9d\u206F\x8f\u200C\x8d\u200C\u061C\x8f\u2061\x9d\u206C\u2060\u2060\u206A\u206F\x8d\u200D\u2063\u2064",
    'project-pages.create-space-dialog.connection-error': "\u2063\u2062Connection failed.\u206E\u206E\u206D\x8f\x8d\x9d\u206B\u206C\u206D\u206A\u200C\u200C\u200D\x8d\x81\u206A\u206D\u206B\u206F\u206F\u061C\u200D\u061C\u200C\u206A\u061C\x8f\u200D\u200C\u206B\x8d\u200C\u2063\u2064",
    'project-pages.create-space-dialog.connection-retry': "\u2063\u2062Retry\u206A\u206A\x8f\u200D\x90\x9d\x8d\x9d\x8f\x9d\u061C\u206C\u206C\u206C\u2060\x81\u206A\x9d\x9d\u206F\u206B\u206A\u200C\u200D\x8f\u2061\u2060\u2060\x8f\u200C\u206B\x8d\u2063\u2064",
    'project-pages.create-space-dialog.content.empty-name': "\u2063\u2062Please give your space a name.\x9d\u206D\u200C\x8d\u206C\x90\u206F\u206F\u2060\u206E\u2061\u206E\u206E\u206F\x81\u200C\u206A\x8d\u206D\x90\u206A\x8f\u206E\x8d\u061C\u206B\u206B\x8f\u061C\u206A\u206D\u2060\u2063\u2064",
    'project-pages.create-space-dialog.content.invalid-name': "\u2063\u2062Space names require at least one letter or number.\x8d\x8d\u206D\x81\u206E\u206B\x81\x90\u206A\u206C\u200D\x9d\u206C\u2061\u206E\u206C\u206D\u061C\x8f\u206C\u2061\x8d\x81\u061C\x9d\u200C\u061C\u206C\x8f\x9d\u206B\u2060\u2063\u2064",
    'project-pages.create-space-dialog.content.placeholder': "\u2063\u2062Enter a space name\u2061\u206F\u206A\u200C\u206B\x9d\x90\u206D\u2060\x81\u206F\u061C\x8f\u061C\u206B\u206F\x81\x81\u206D\u206F\u206C\u206E\u206A\u200C\u200C\u206C\u206C\u206E\x90\u061C\u206D\x8f\u2063\u2064",
    'project-pages.create-space-dialog.creation-error': "\u2063\u2062Space creation failed.\u206A\u061C\u2061\u206D\u2061\u206D\u206C\u2060\u206E\u206D\x81\x81\u2060\u200D\u061C\u206C\u206A\x8f\u206E\u206F\u206D\u206C\u200D\u061C\u206F\u200C\u206B\u206E\x8f\x9d\x90\u061C\u2063\u2064",
    'project-pages.create-space-dialog.error-icon': "\u2063\u2062Error:\u206B\u061C\u206C\u206E\x8d\u2061\u200D\u206E\u206E\x8f\u206B\u200C\u200D\u206F\u206D\x8d\u206B\u206E\x8d\u2061\u2061\u206F\u061C\u200D\u200D\u061C\u061C\x81\u2061\u206A\u2061\x8f\u2063\u2064",
    'project-pages.create-space-dialog.footer.cancel': "\u2063\u2062Cancel\u206E\u206D\x90\u200D\u200D\u200C\x90\u206D\u206C\u206F\x9d\u200D\x90\u200D\u206A\u206A\u206C\u206F\u206A\u206C\x81\u206C\u061C\x8f\x9d\x90\u206C\x90\x8f\u206A\u206F\u206B\u2063\u2064",
    'project-pages.create-space-dialog.footer.create-space': "\u2063\u2062Create\x90\x90\x8d\u206B\u200C\x81\x8d\u2061\x9d\x90\u206A\x90\u206F\x9d\x9d\u206D\u200C\x8f\u2061\u206B\u061C\u206B\x8f\x8d\x90\x81\u206E\x8d\x8d\u2060\u200D\u206F\u2063\u2064",
    'project-pages.create-space-dialog.header.title': "\u2063\u2062Create new Confluence space\u206E\u2061\x90\u061C\u206D\x8f\u2060\u206A\x81\x9d\u061C\u206E\u206A\x81\u206B\u061C\x90\u061C\u200C\u206A\u206F\u206A\x8f\x81\x90\x9d\u206A\u206E\x9d\x8f\x9d\x81\u2063\u2064",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u2063\u2062You cannot use project pages because the admin has denied you access to Confluence. Contact your site admin to request access.\x9d\u2061\x90\u061C\u206A\x81\u206B\u206B\u206A\x81\x81\x81\u206C\u200D\u206A\u2061\u206B\u206C\u2061\u206D\u206A\u2060\u200D\u200D\x9d\u206A\u2060\x90\u061C\u2060\u061C\u200D\u2063\u2064",
    'project-pages.cross-join.access-revoked.templates.title': "\u2063\u2062You don't have permissions to use project pages\x9d\u206F\x90\x9d\u200D\x90\u206E\u206E\u206D\u061C\u206E\u206E\x90\u206F\x8f\u200C\x8f\x90\u206A\u200D\u200D\u206F\x8f\u206F\u206A\u206F\x9d\x90\u206E\u200D\u206F\u200D\u2063\u2064",
    'project-pages.cross-join.avatar.view-profile': "\u2063\u2062View profile\u206B\u206B\x9d\u206E\u2060\u206C\u2061\x90\u2061\u206F\u206F\u206F\u2061\x9d\u200D\u2060\u206D\x81\u2061\u206C\x9d\u2061\u200D\x8f\u206E\u2061\x8d\u206E\x9d\x81\x81\u206A\u2063\u2064",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u2063\u2062You can't use project pages because the site admin denied your request to join Confluence.\x8d\u200D\u061C\x81\u206F\u206E\u206F\u061C\u061C\u200C\x8d\u206C\u206F\x9d\u206C\x8d\u206F\u061C\u200D\u206A\x9d\x9d\u206C\x90\x8d\u206A\u061C\x90\u200D\x9d\x9d\u200D\u2063\u2064",
    'project-pages.cross-join.denied-request.templates.title': "\u2063\u2062Your admin has denied you access\u2060\u206F\x8f\u2060\x9d\u2060\u206E\u2060\u206C\u206E\u206C\u206C\u200D\u206F\u206E\x90\u206E\x8f\u206E\x8f\u206A\x9d\x90\u061C\u206C\u061C\u206D\u200C\u2060\u200C\x90\u206D\u2063\u2064",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "\u2063\u2062You'll get access to Confluence. Your site admin has already approved you.\u206F\u206C\u200D\u200C\u206E\x90\u200C\u206A\x90\u2060\u200D\u206E\x8f\u206C\u2060\u200D\u200C\u200D\x8f\u206A\x81\x90\u206E\u206C\u206B\u206E\u206B\x81\u200D\u2061\u200C\u206A\u2063\u2064",
    'project-pages.cross-join.errors.unknown-error.description': "\u2063\u2062{contactSupport} if refreshing doesn't fix things.\u206C\u2060\x9d\u206E\u206E\u206D\u200C\x81\u206F\x9d\x90\u2060\x9d\u206B\u206B\x9d\u2061\x8f\x8d\u206D\u061C\u061C\x9d\x90\u206E\u206D\u206E\x81\x8f\x90\u206A\u2060\u2063\u2064",
    'project-pages.cross-join.errors.unknown-error.title': "\u2063\u2062We can't display project pages right now\u206A\x8d\u2061\x9d\u2061\u2060\u061C\x90\u206B\x81\u206E\x81\u200C\u200C\u206D\u206E\x81\x8f\u206B\x8f\u206C\x9d\x8f\u206C\x81\u206E\x8d\u061C\u206F\x9d\x8d\u206A\u2063\u2064",
    'project-pages.cross-join.inline-join-product.button': "\u2063\u2062You\u2019ll get access to Confluence. Your site admin has already approved you.\u206E\u061C\x81\u2061\u206A\x8f\u2061\u206A\u061C\u206E\x8d\x81\u206A\u2061\u2060\u2061\x8f\u206C\u206B\x8d\u200C\x90\u200D\u061C\u061C\x9d\u206B\u2061\u200D\x8f\u206B\x8f\u2063\u2064",
    'project-pages.cross-join.inline-join-product.connected.description': "\u2063\u2062View, edit and create documentation from a single place\u206B\u200C\u206B\u061C\u206F\x9d\x81\x90\u200C\u206E\x81\u206F\u206F\x8d\u206C\x90\u206B\u200D\u206A\u061C\u206D\x8d\u061C\x81\x90\x81\u2060\x8d\u2060\u061C\x81\x9d\u2063\u2064",
    'project-pages.cross-join.inline-join-product.connected.title': "\u2063\u2062Collaborate on project pages with your team\u2060\u206C\u206E\u206E\x8d\u206B\u200D\u206A\u2061\u206D\u061C\x90\u206F\u2060\x8f\u200C\u061C\x8f\x9d\x8d\u061C\x90\u200D\u200C\u2060\u2060\u206B\u2060\u206D\u2060\u206C\u206F\u2063\u2064",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u2063\u2062The site admin has received your request to join Confluence. If you're approved to join, project pages will start working and we'll send you a confirmation email.\u206D\u206D\u200D\u2061\u200C\u206D\u2060\x81\u061C\x8f\u200C\u206D\u206F\u206A\x8d\u206B\u2061\x90\x8f\u200C\x81\u061C\u206C\u206A\u206C\x8d\x8d\u2061\u206B\u206A\x90\u206A\u2063\u2064",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\u2063\u2062You'll get an email with access to Project Pages once you\u2019re approved.\u200D\x8d\u206F\u200C\u206F\u206D\u206B\u061C\u206C\x9d\x8d\u2060\x8d\u061C\x81\u206D\u2060\u206C\u206A\u206B\u2060\x9d\u200D\u2061\u206C\x8d\x8d\u206A\u2061\u200C\u206F\u206A\u2063\u2064",
    'project-pages.cross-join.pending-request.templates.title': "\u2063\u2062You've requested access to Confluence\x81\u206C\u206D\u206A\u2061\x90\u2060\u206D\u200D\x8f\u200D\u206A\u206F\u206A\x8d\u200C\u206E\x81\u206B\u206D\u206E\x8f\x8d\u206B\u206D\x81\u206A\u2060\u200C\x90\x8d\u061C\u2063\u2064",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u2063\u2062Access request sent to Admin\u206D\u061C\x81\u206C\u200C\u200C\u200C\x8d\u061C\u200D\u206B\x8f\x90\u206D\x8d\u206B\u206F\u206D\u061C\u200C\u206D\u206B\x90\u061C\x9d\u2061\x8d\x81\u206B\x8d\u206F\u2061\u2063\u2064",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u2063\u2062View, edit and create project documentation with your team\u206C\u2060\x9d\u200C\u061C\u206A\u206E\u206F\u206E\u200D\u206D\u2061\u206C\u206C\x9d\x8d\u206E\u061C\u061C\u206C\u206E\x8f\u061C\u206A\u206B\x8d\u2061\x8f\u2060\u206F\u206E\u206F\u2063\u2064",
    'project-pages.cross-join.request-access.button': "\u2063\u2062Request access\u2060\x9d\x9d\u206C\u206F\u061C\u200C\u2061\u206B\u206E\x81\x90\u206E\u206B\u2061\u206D\x8d\u061C\x90\x90\x90\u206B\x9d\u2060\x8f\x9d\u2060\u206C\u200C\u206E\u206C\x9d\u2063\u2064",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "\u2063\u2062When you select 'Join Your Team', you're asking to join Confluence and agree to share your Atlassian profile with your admin.\x8d\x9d\u2061\x90\u2061\u2060\u206F\u2061\u061C\u206E\u2060\u061C\u061C\u206C\u206B\u206D\u206A\x8f\u206D\u206A\u206D\u206E\u200D\u206C\u206A\u206B\x81\x8f\u206D\u2061\u206D\u206D\u2063\u2064",
    'project-pages.cross-join.request-access.button.experimental': "\u2063\u2062Join your team\x9d\u200C\x8f\x8d\u206E\u2060\u206C\u206A\u206B\u206A\x9d\u200D\x9d\x90\u2061\u2060\u2060\u2061\u206F\u206C\u206B\x8f\x90\x81\u200D\u206F\x8f\u206B\u206B\u206B\u2060\x8d\u2063\u2064",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u2063\u2062Your team is using Project Pages to comment, edit, and collaborate on project documentation without leaving Jira. Join Confluence to access your team\u2019s Project Pages.\x9d\x81\u2060\u061C\u206B\x9d\x8f\u206C\u200C\u2060\x9d\x81\u206A\u061C\x81\u206C\u206D\u2060\x9d\u200D\u061C\u206F\u200C\u206F\x8f\u061C\x90\u2061\u061C\u206C\u061C\u206B\u2063\u2064",
    'project-pages.cross-join.request-access.title': "\u2063\u2062Project pages require access to Confluence\u200C\u206E\u206B\u200D\x8d\u200D\u206B\x90\u206E\u206B\u206E\u200C\x90\u206C\u206D\u206F\u061C\u200C\u2061\x8d\x8f\u206F\u206E\u061C\x9d\x8d\x81\u206A\u200D\x90\u206D\x8f\u2063\u2064",
    'project-pages.cross-join.request-access.title.experiment': "\u2063\u2062Create a single source of truth for your team\x90\x8f\u206D\u206A\x8f\x81\u200C\u206B\x8f\u206F\u2061\x8d\x90\u061C\u061C\x81\u206D\u061C\u206C\u200C\u2060\u2061\u206D\x8f\u200D\x8d\u206D\u206A\x8d\u2060\u200D\u2061\u2063\u2064",
    'project-pages.default-contextual-heading': "\u2063\u2062Project pages are powered by Confluence\u2061\u061C\u206A\u061C\x90\u206A\x81\u206D\u200C\x8d\u206F\x81\x90\u200C\u206E\u200D\u2060\u2061\u200D\u206C\u200C\x8f\u206F\u206F\u206F\u2060\u2061\u2061\u2060\u206D\u061C\u206F\u2063\u2064",
    'project-pages.default-contextual-message': "\u2063\u2062Create, share, and collaborate on all your project docs in one place, with Confluence pages.\u206A\x8d\x8f\u206D\u206A\u2060\u206A\u061C\x9d\x8f\x8d\x8f\u206A\x8d\u2061\u061C\u206D\x90\u206E\u206E\x81\u206B\u2060\u206E\x8d\x90\u206A\x90\x8f\x9d\x8d\u200D\u2063\u2064",
    'project-pages.default-reactivate-CTA': "\u2063\u2062Reactivate Confluence\u206C\u061C\x9d\u206F\u206B\u206A\u206C\x90\u2060\u200C\u061C\u200C\u061C\u206B\x81\u206E\x8f\u200D\u206C\u206A\u200D\u2060\u206D\u2060\u200C\u2060\u200D\u206C\u206D\x90\u200C\u206E\u2063\u2064",
    'project-pages.default-trial-CTA': "\u2063\u2062Try Confluence free for 30 days\x8d\u206C\u200C\u206B\u2060\u206B\x9d\u200D\u200C\u2061\x90\x8d\u061C\u206C\x81\x8d\u206E\u206E\u206B\u206D\x81\u206B\u206D\u206E\x8d\u206F\u206F\x90\x81\u200D\x9d\u206E\u2063\u2064",
    'project-pages.draft-saved-flag.action': "\u2063\u2062Open draft\u200C\x8d\u206F\u2061\u206B\x81\u206F\u206C\u200D\u206D\u200C\u2061\u206B\x81\x8f\x9d\u206E\u206F\u206F\x8d\u2061\u2061\u206F\x8f\u206D\u061C\u206B\u061C\u206B\x81\x9d\u200C\u2063\u2064",
    'project-pages.draft-saved-flag.description': "\u2063\u2062Your draft is only visible to you until you publish it.\u2060\x9d\u206C\u200D\u206E\u206C\u2060\x90\u061C\u206D\u200D\u200D\u200D\u200D\x8d\u200D\x81\u200C\u206F\u206E\u2060\u200D\u2060\x8d\u206D\u206F\u206D\x9d\x90\u206F\u061C\u206E\u2063\u2064",
    'project-pages.draft-saved-flag.title': "\u2063\u2062Draft saved\u206E\x81\u2060\u206E\u2061\x9d\x8f\x8d\u061C\u200C\u061C\x8d\u2061\x9d\u2061\u206F\u206E\u206A\x81\u061C\u2061\u200D\x8f\x8f\x90\u206F\x90\u206A\u206C\u206A\u206F\u061C\u2063\u2064",
    'project-pages.embedded-pages.create-page-error.close-button': "\u2063\u2062Close\x9d\u206F\u200C\u206D\x8f\u206D\u206F\u061C\u206C\u2061\u206D\x8f\u2061\u061C\u206D\x8f\u206C\u206D\x90\u206F\u206C\u206A\u206E\u200D\u200D\u206A\u206B\u2061\u206B\x8f\x81\u206B\u2063\u2064",
    'project-pages.embedded-pages.create-page-error.description': "\u2063\u2062There was a problem and we couldn\u2019t create a page for you.\x8d\u206F\x81\u200C\x81\x9d\u206E\u200D\x8f\u206F\u2060\x8f\x8f\u206D\u2061\u206E\u200C\x9d\u2061\u206F\u061C\u206F\x90\u2061\u206E\x8d\u206A\x90\u206B\x90\u2060\x8d\u2063\u2064",
    'project-pages.embedded-pages.create-page-error.title': "\u2063\u2062We couldn\u2019t create a page\u206B\x90\x8f\u206D\u206A\x8f\u206B\x9d\u206E\x81\u206A\u206B\u061C\u2060\u206A\u200D\u206D\x90\x8f\u206A\u200D\u2060\u206C\u206B\u206E\u206B\u206D\x8f\u206A\u206F\u206D\u206D\u2063\u2064",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u2063\u2062Try again\u206C\x8f\u061C\u206C\u200C\u206A\u200C\x81\u206B\x8d\u206C\u206D\u206D\u206A\u206E\x9d\u206D\u206F\u206D\x9d\u206F\u206A\u206E\u206E\x9d\u2061\u061C\u206A\u200C\u206E\x9d\x81\u2063\u2064",
    'project-pages.embedded-pages.modal.close.button.hint': "\u2063\u2062Close\u200C\x9d\u200D\u206A\x8f\x81\u206E\x90\u206C\u200C\u2060\u206E\u200D\u2061\u061C\x81\u2060\x9d\u206A\u2061\u2061\x9d\u200D\u206B\u206A\u206B\x8d\u200C\u206A\u2060\u061C\u206A\u2063\u2064",
    'project-pages.embedded-pages.modal.title.button': "\u2063\u2062Open in Confluence\x9d\u2060\x8d\u206B\x8d\u206A\u206C\u206C\u206E\x8f\u2061\u2061\u206C\x8d\u2061\u206B\u206C\u061C\u200D\x9d\x9d\u2060\u061C\x81\u2061\u200D\x9d\u206C\x8d\x9d\u206E\u206E\u2063\u2064",
    'project-pages.embedded-pages.modal.title.button.hint': "\u2063\u2062Open in a new tab\u206C\x9d\u061C\x90\u061C\x81\u206E\u2060\u206B\u200D\x9d\x8d\x81\u206D\x9d\x9d\x8d\u2061\u206F\x9d\u206A\u061C\u206C\x9d\u206F\u206D\u206B\u206D\u206F\u206C\u206A\u2061\u2063\u2064",
    'project-pages.errors.access-error.title.non-final': "\u2063\u2062You don\u2019t have permission to view project pages\u200C\u206C\x9d\x81\u206C\x8f\u206A\u206E\u200D\x9d\u200D\u206E\x90\u206E\u206D\u206B\u206A\u206D\x9d\u206E\u200C\x9d\x8f\u206A\x8f\u206E\u206C\u2060\u200C\u206A\u206D\u206C\u2063\u2064",
    'project-pages.errors.connection-error.space-or-page-not-found.button.non-final': "\u2063\u2062Connect to a different space or page\u206E\u206A\x90\u206F\u206A\u206A\x90\u2060\x81\u2061\x81\x8f\u206D\x8f\u206E\x8d\u2060\u061C\u200C\u2061\u200D\u206D\x8d\u061C\u206A\x9d\x8f\u206F\u061C\x90\x90\u200C\u2063\u2064",
    'project-pages.errors.page-tree-unknown-error.description.non-final': "\u2063\u2062Something went wrong while trying to display pages from your connected Confluence space. {contactSupport} if refreshing doesn\u2019t fix things.\u2061\x81\u2061\u206E\u2061\u2061\u206C\u206E\x8d\x81\x8f\x81\u206E\u206B\x8d\u2061\u200D\u200D\x8d\x81\u206D\x81\x8f\u206D\u206D\u2060\x81\x8f\u206A\u206C\u2061\u200D\u2063\u2064",
    'project-pages.errors.page-tree-unknown-error.title.non-final': "\u2063\u2062We\u2019re having trouble displaying project pages\u206E\x90\x81\u206E\u206C\x81\x8f\x8f\x81\x9d\x90\u206B\x90\u206A\u2061\u206F\u206C\u206B\x81\u206F\x8f\u206E\u206D\u206B\u2061\u206C\u206C\u206F\x81\x90\u061C\u206E\u2063\u2064",
    'project-pages.errors.space-or-page-not-found.description.non-final': "\u2063\u2062The Confluence space or page that was connected has been moved, archived, or deleted. <link>Contact support</link> if re-connecting doesn't fix things\u206D\x8d\u061C\x8d\u200C\x90\u061C\u206B\x81\u206B\u2060\u206E\u206E\x8d\u061C\u061C\x9d\x90\u2061\u061C\u206B\u2061\x81\u206E\u061C\u2061\u200D\x90\u061C\u206F\u2061\x8f\u2063\u2064",
    'project-pages.errors.space-or-page-not-found.title.non-final': "\u2063\u2062Space or page not found\u061C\u206E\x90\x90\u061C\x90\u2060\x90\u2060\u206F\u206C\x81\u2061\u2060\x8d\u206C\u206D\u206C\x8d\u2061\u206E\x8d\x90\u200C\u206E\u2060\u206D\x8d\u206F\u206F\u206E\u200D\u2063\u2064",
    'project-pages.errors.unknown-error.description.non-final': "\u2063\u2062{contactSupport} if refreshing doesn\u2019t fix things.\u200C\x81\u2060\u061C\x81\x8d\x8f\u2061\u2061\u206D\x81\u206E\x9d\x9d\x8d\x8d\x8f\u206F\u061C\u206E\u206C\x90\u200C\u206B\x90\u206B\u200D\u206A\x90\x81\x8f\u206B\u2063\u2064",
    'project-pages.errors.unknown-error.title.non-final': "\u2063\u2062We can\u2019t display project pages right now\u061C\u206C\x81\u206A\x8f\u206B\x81\u206A\u206F\x8f\u2061\u206D\u2060\u206B\u206C\u206F\u206B\u206C\u206F\u206C\u061C\u2061\u200C\x81\u200C\x9d\u206C\u206D\u2060\u206E\x9d\u206B\u2063\u2064",
    'project-pages.generic-error.button.reload': "\u2063\u2062Reload page\x9d\u206C\x81\u206D\u206D\u206B\u061C\x8f\x8f\u2061\u2060\x81\x81\u206F\u2061\u206D\x81\u200C\u200C\x81\x8d\x90\u206B\u206A\x81\u2061\u206D\u200D\u2061\u206A\u206D\u2060\u2063\u2064",
    'project-pages.generic-error.button.reload.non-final': "\u2063\u2062Reload page\u206A\x90\x9d\u061C\u206F\u206D\u061C\u206A\x8f\u206F\u206C\u200C\u206D\u206F\u206B\u200D\u206D\x8d\u206B\u200D\x9d\u206F\u2061\u206C\u2060\x8f\u2060\x90\u206B\u206F\u200D\u206D\u2063\u2064",
    'project-pages.generic-error.description': "\u2063\u2062Something went wrong. Please try again later.\x9d\u2061\u200D\u206B\u200D\u200D\x90\u206C\u200D\x8d\x8d\x8f\x81\x8f\u200C\x8d\u206F\u2061\u2060\x8f\u2061\u061C\u206C\u206D\u206E\u206B\u206F\x9d\x81\u2060\x81\u200D\u2063\u2064",
    'project-pages.generic-error.description.non-final': "\u2063\u2062Something went wrong. Please try again later.\u2060\x8d\x90\u206E\u061C\u206F\x9d\u2060\x8f\u206F\u206E\x9d\u206A\u206F\u206A\x81\u200D\u206F\x90\u206E\u2060\u206B\x8f\x8f\u206E\u206C\u2060\x90\u206A\u200C\x9d\u206C\u2063\u2064",
    'project-pages.generic-error.heading': "\u2063\u2062Well, this is awkward...\x9d\u061C\x81\u206A\x8f\u206E\x8d\u206A\u2061\u206E\u206F\u2060\x9d\u200C\u2060\u206E\u061C\u200C\u206F\x90\u2061\u200D\u200C\u206B\u206B\u2061\u206A\x8d\u061C\u206C\u206A\u061C\u2063\u2064",
    'project-pages.generic-error.title.non-final': "\u2063\u2062Well, this is awkward...\x90\u200D\u206D\x90\u206D\x9d\u200D\u200C\u206D\u200D\u200C\x8f\u206A\u2060\u206D\x8f\u206D\x90\u2061\u206C\u200D\u061C\x8d\u061C\u206E\x90\u2061\u2060\u200D\u206E\u200D\x81\u2063\u2064",
    'project-pages.generic-info-flag.description': "\u2063\u2062Something went wrong. Please try again or contact support if the issue persists\x90\u200C\x90\u206C\u200C\x81\u206D\u206D\u200D\u206A\u200D\x9d\u206E\u2061\x90\u206A\u2060\u206F\u206B\u2061\u061C\u206E\u206A\u200C\x90\u206E\u206C\u200C\x9d\x8d\x90\u206C\u2063\u2064",
    'project-pages.generic-success-flag.description.page': "\u2063\u2062Successfully connected with {connectedSpaceOrPageName} page.\x9d\x81\u200D\u206A\u206E\x81\x90\u200D\x81\x81\u206A\u200C\u200C\u206A\x90\u200D\u206E\u200D\u206D\u200C\x9d\u061C\u206B\u206C\u061C\u2060\u206C\u061C\u2060\u206E\u200D\u206E\u2063\u2064",
    'project-pages.generic-success-flag.description.space': "\u2063\u2062Successfully connected with {connectedSpaceOrPageName} space.\u200C\u206A\x81\x8f\u206B\u200D\u206A\x9d\u206A\x90\u2061\u206C\u2061\u206E\u200D\x9d\u206D\x81\x9d\u206E\u200D\u206B\u206C\x90\x8f\u2060\x8f\x81\u061C\u2061\u2060\u200D\u2063\u2064",
    'project-pages.generic-success-flag.heading.page': "\u2063\u2062Page connected\u206F\u206A\u206D\u200C\x9d\u2060\u206F\u2061\u206D\x8d\u200D\x8d\x81\u2060\x90\u061C\u2061\x9d\u2061\u206B\x81\x9d\x8d\u200C\u206B\u200C\u206C\u2061\x81\x8f\u200D\x9d\u2063\u2064",
    'project-pages.generic-success-flag.heading.space': "\u2063\u2062Space connected\u206C\u206B\u2060\u206A\u061C\u2061\u206C\x81\u206F\x81\u206F\x9d\u206D\x90\u206F\x81\u200C\x8d\u206F\u200C\x8f\u206E\x8d\u206A\x8f\x81\u061C\u206D\x8d\u200C\x90\u2061\u2063\u2064",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u2063\u2062Or create a new space\u061C\x8d\u206C\x81\u061C\u206C\x90\x81\u206C\u206F\x90\u206F\u200D\u206D\u200C\u061C\x9d\x90\u2060\u2060\x8f\u200D\u206C\x9d\x90\u2061\u2060\u200D\u206B\u206E\u200C\u200D\u2063\u2064",
    'project-pages.granular-pages.connect-space.button': "\u2063\u2062Connect to Confluence\x81\u200D\u206A\u2060\x8d\x9d\x8f\u206E\u206D\u206E\u206D\x90\x8d\u206D\x8f\x90\x81\u200D\u2060\u200D\x81\u061C\u206D\u200D\u206B\x9d\u200D\x81\u200C\u206E\u2060\u061C\u2063\u2064",
    'project-pages.granular-pages.connect-space.button.non-final': "\u2063\u2062Connect to Confluence\u206A\u2060\x9d\x9d\x90\u206A\u206A\u206D\x8f\u206C\u206F\u200D\u206A\x81\u200C\u200C\u2060\u2060\u2061\x8d\x8f\u200D\u206A\u206D\x90\u200C\u206B\x8d\u206D\u206F\x81\x81\u2063\u2064",
    'project-pages.granular-pages.connect-space.heading': "\u2063\u2062Connect this project to a Confluence space or page\u206D\x81\u061C\x8d\u206C\x90\x9d\u206C\u206C\x90\u200C\x8d\u2061\u206B\x81\u206C\x8d\u200C\x9d\u206D\x81\x8d\x9d\u206E\x8d\u206E\x9d\u2060\u206E\x81\x8f\u206C\u2063\u2064",
    'project-pages.granular-pages.connect-space.heading.non-final': "\u2063\u2062Connect this project to a Confluence space or page\u200C\x8d\x81\u200C\x81\u200D\x90\u200C\u206D\x8f\u061C\x8f\x81\x81\x8d\u200D\x9d\u206E\x8f\u206F\x90\x90\u200C\u206A\u200D\x90\u206D\u206E\x8f\x81\x90\u206E\u2063\u2064",
    'project-pages.improvement.contact-support': "\u2063\u2062Contact support\u200C\u206E\x81\u206C\x90\u206C\x8f\u200C\u200C\u206F\u2060\u206F\u2060\x90\u206A\x81\u200C\u200D\u206A\u206D\u206B\u200D\x8d\x9d\x81\x8f\u206F\u206A\u206F\x8d\u206C\u206B\u2063\u2064",
    'project-pages.improvement.errors.access-error.description': "\u2063\u2062Try contacting the site admin to ask for access.\x9d\u061C\x8d\u206A\x81\u200D\u2060\u206C\u206B\x90\u2060\u206F\u061C\u206B\u206C\u2061\x8d\u206F\x8f\u2061\x8f\u2060\u2061\u2061\x90\u206D\u206D\x81\u206D\x9d\u206A\u206F\u2063\u2064",
    'project-pages.improvement.errors.access-error.title': "\u2063\u2062You don\u2019t have permission to view project pages\u061C\u206C\u206E\x90\x8d\u200D\u206F\u2061\u206A\x90\u206A\u200D\u200C\u206F\x8f\x90\u2060\u2061\u2061\x8d\x9d\x90\u206E\u2061\x90\u206C\x9d\u206B\u206E\x9d\u206B\u206C\u2063\u2064",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u2063\u2062Something went wrong while trying to display pages from your connected Confluence space. {contactSupport} if refreshing doesn\u2019t fix things.\u2061\u206F\u206D\u061C\u061C\u2061\u206E\x9d\u200D\u206B\u206B\u2060\x90\u206A\u2061\x81\u206C\u206E\u206D\x81\u206A\u2061\u200D\u200C\u2061\x90\u206F\u206D\u206D\u2060\u2061\x9d\u2063\u2064",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u2063\u2062We\u2019re having trouble displaying project pages\u061C\u200C\u206C\u200C\u2060\u061C\u2060\x90\u061C\x8f\u2061\x8f\u061C\u2061\u200D\u2060\u2060\u206F\x8f\x8f\x8f\u206B\x90\u206F\x8f\u206D\u206A\u206D\u206F\u200D\x81\x81\u2063\u2064",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u2063\u2062The Confluence space or page that was connected has been moved, archived, or deleted. <link>Contact support</link> if re-connecting doesn't fix things\u206A\u200C\x8d\x81\x8d\u206A\x8d\x9d\x90\u206F\x9d\u206C\u061C\u206E\u206D\x8f\u206C\x90\u200C\u206A\u206A\x90\u2061\u206F\u061C\u206A\u200C\x8f\u200D\u206C\u206B\x90\u2063\u2064",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u2063\u2062Space or page not found\u200C\u206F\x90\x81\u200D\u206D\u206A\x8d\u206B\x90\u206A\u200C\u206B\u206A\x8f\u2061\u206C\u206D\x9d\u206A\u200C\u200D\x8d\u206F\u206A\u206B\u206F\x9d\u206D\u206C\u061C\u206A\u2063\u2064",
    'project-pages.improvement.errors.unknown-error.description': "\u2063\u2062{contactSupport} if refreshing doesn\u2019t fix things.\x9d\u200D\u2060\x8f\x8f\u200C\x8f\u061C\x9d\u206F\u206C\u206A\u200C\u200C\u2060\u2060\u061C\u206F\u200D\u2060\u206A\u206D\x9d\u2061\x90\u206C\u206C\u206F\u206F\u061C\x8d\x81\u2063\u2064",
    'project-pages.improvement.errors.unknown-error.title': "\u2063\u2062We can\u2019t display project pages right now\x9d\u206C\u206F\u2060\u206F\x81\x8d\x8d\u206A\u206D\u061C\u061C\u206B\u2061\u2061\x9d\u206F\u206A\x9d\x9d\u061C\x90\u061C\u206D\u206B\u206B\u206C\u200D\u061C\x81\u206B\u206D\u2063\u2064",
    'project-pages.improvement.feature1': "\u2063\u2062Access and create documents without leaving Jira\u206C\x8d\x8f\u200D\u200C\u206A\u206E\u206E\u200C\u200D\u206F\u061C\x9d\u206F\u206D\x81\u206A\u206F\u206E\u206B\u206D\u206C\u206C\u061C\x81\x81\u2060\u200C\x8f\u206D\u200D\u206B\u2063\u2064",
    'project-pages.improvement.feature1.non-final': "\u2063\u2062Access and create documents without leaving Jira\u206A\x8d\x8f\u2061\u200C\x8f\u2060\x81\x8f\u2061\u206F\x90\u206D\u206D\u061C\u206E\x81\u200C\u061C\x8f\u206B\u206C\x8f\u2060\u206B\u2060\u206A\u200C\u2061\u206D\u206D\u200D\u2063\u2064",
    'project-pages.improvement.feature2': "\u2063\u2062Templates for meetings, sprint plans, and more\x81\u061C\u206F\x81\x8f\u061C\u200D\u206B\u206E\x90\x8d\x8f\u206C\u206A\u206A\x90\u061C\x90\u200C\u206D\u200D\u206A\u2060\x9d\x81\x81\x81\u206E\u206F\x8f\x81\u206C\u2063\u2064",
    'project-pages.improvement.feature2.non-final': "\u2063\u2062Templates for meetings, sprint plans, and more\u206A\u200D\u200D\x81\x8f\u206C\u200D\u2060\u061C\u206C\u206D\x81\x90\x9d\x90\u206C\u200D\x9d\x9d\x9d\u200D\x8d\u061C\u206E\u206B\x8d\u206B\u200C\x90\u206E\x9d\u206A\u2063\u2064",
    'project-pages.improvement.feature3': "\u2063\u2062Sync documents to Jira for automatic updates\u206F\u206B\u200D\u2060\u206A\x8f\u200C\u206F\u200D\u206F\u206D\x90\u206C\u206F\x8f\u206E\u200C\x90\x90\x81\u200C\x90\u206F\u206C\x90\u206F\u200D\x9d\u206B\u061C\u206D\u2060\u2063\u2064",
    'project-pages.improvement.feature3.non-final': "\u2063\u2062Sync documents to Jira for automatic updates\x8d\x9d\u2060\u206F\u200D\u206B\u206B\u206C\u2061\x8f\u206C\u206B\u206E\x8f\x8f\x8d\x81\x8f\u206E\x9d\u206F\x81\u206E\x81\u206F\u206E\u206D\u206C\x9d\u200D\u2060\x8f\u2063\u2064",
    'project-pages.improvement.heading-info': "\u2063\u2062Capture your team's knowledge and improve the way you get work done.\x8d\u206E\u206F\x8d\x8f\u206F\x81\x90\x9d\u200C\u206A\u206A\x90\u206F\u2061\u206A\u206F\u206A\x90\x8f\x9d\u206E\u200C\u2061\x9d\u206F\u206F\u200C\u206D\u2060\x8d\u061C\u2063\u2064",
    'project-pages.improvement.heading-info-v2': "\u2063\u2062Create one place for all your team's project documents\u206E\u206D\u206D\u206D\u2060\u200C\u206F\u206A\x9d\u206B\u200C\u206E\x9d\u206B\u200D\u2060\u206F\u206E\u206B\u2060\u206C\u200D\u200D\u206E\x81\u206F\u200D\x9d\x8d\x8f\u061C\u200D\u2063\u2064",
    'project-pages.improvement.heading-info-v2.non-final': "\u2063\u2062Create one place for all your team's project documents\x8f\u206D\u2060\u206B\u206B\u061C\u206F\u2060\u061C\x81\x8f\u206A\x9d\u206A\u206B\u206D\u200C\u206D\u200C\u206D\u061C\x81\u206B\u200C\u200D\x81\x81\u206C\u206C\u206F\u206B\x8f\u2063\u2064",
    'project-pages.improvement.heading-info.non-final': "\u2063\u2062Capture your team's knowledge and improve the way you get work done.\x8d\x9d\u206E\u061C\x8f\x8d\u206D\u206A\x90\x90\u061C\u206A\x81\u206B\x8f\u206D\u2060\x9d\x90\u200C\u206C\u206B\u206B\u206F\x9d\x81\u200D\x8f\x90\u061C\u206A\u206C\u2063\u2064",
    'project-pages.improvement.learn-more-button': "\u2063\u2062Learn more\x81\u206B\u206D\x9d\u206C\u206B\u061C\u206B\u061C\x81\u206C\u206E\u206C\x81\x8d\u2061\x9d\u206F\x8d\u200C\u206F\x8f\x90\u206A\x9d\x8f\x8f\x81\u200C\u206F\u200D\x8f\u2063\u2064",
    'project-pages.improvement.learn-more-button.non-final': "\u2063\u2062Learn more\x8d\x90\u206A\u2061\u200C\x8f\x90\u2061\u2061\u206E\x81\u206D\u2060\u200C\u206A\u206E\u206F\u2060\x8f\u200C\u206D\u206B\u206E\u200C\u206C\u2061\x8f\u206F\x9d\x8d\x8d\x8d\u2063\u2064",
    'project-pages.improvement.powered-by': "\u2063\u2062Powered by\u206E\u206D\u206B\u061C\u206D\x90\x8f\u200D\x8f\u206D\u200D\u206C\x8f\x81\x81\u206D\u2060\x81\u206A\u206B\x9d\u206A\u200D\u206C\u2060\u2061\u206A\x90\x81\x9d\u200D\u206D\u2063\u2064",
    'project-pages.improvement.powered-by.non-final': "\u2063\u2062Powered by\u200D\u206F\u2061\u2061\u206D\u200C\u2061\u206B\u206A\u206F\u200C\u206B\u206E\u206B\u200D\u206F\x81\x90\u206B\x8d\u206D\x8d\x8f\x81\u206B\x81\u061C\u206B\x8f\u206C\u206E\u206F\u2063\u2064",
    'project-pages.improvement.powered-by.tooltip': "\u2063\u2062Open Confluence in a new tab\u200D\u2061\u2060\u206F\x90\u2060\u206C\u206C\u200C\x8d\x90\u200D\u200D\x90\x8f\u2061\x90\u206A\u200D\u206C\u206B\u2060\u206F\x8f\u200D\u200C\u206B\u061C\u2061\x8f\u206C\x81\u2063\u2064",
    'project-pages.improvement.powered-by.tooltip.non-final': "\u2063\u2062Open Confluence in a new tab\x9d\x8d\u061C\x81\x9d\u061C\u061C\u206A\x9d\x81\u200C\u2060\x8f\u200D\u061C\x81\u2060\u206B\u206B\u206C\u206F\u206E\u200C\x90\u206D\u206F\x8d\u2060\u206C\u061C\u206D\x8d\u2063\u2064",
    'project-pages.improvement.preview-teaser': "\u2063\u2062Unlock templates, project pages, and more.\u206C\u200D\u2061\u061C\x8d\u206A\u200D\u206D\u2061\u200C\x81\x8d\u206A\x8d\u206A\u200C\u206A\u2060\x8d\u206E\x9d\u2060\u200D\u206D\u061C\u2061\u206E\u2060\u206A\u2061\u206A\u200D\u2063\u2064",
    'project-pages.improvement.preview-teaser.non-final': "\u2063\u2062Unlock templates, project pages, and more.\x9d\x8f\u206F\x81\u2061\x8d\u2060\u206A\u2060\u061C\x81\u206B\u200C\x81\x8d\u206F\u206E\u2061\u206B\u206C\u200D\u2060\u061C\u206F\u200D\u206E\x90\u206D\x8f\u2061\u206A\u2061\u2063\u2064",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "\u2063\u2062<p>Keep your project reports up-to-date with auto-updating status labels.</p> <p>Simply link a Jira ticket in a doc and it will automatically display a status label that updates in sync with the ticket, so you don't have to spend your time creating manual reports.</p>\u061C\u206F\x8d\u206E\u206B\u206D\x9d\u061C\x81\u206C\x81\x8f\u200D\u200C\u206D\u061C\u2060\x8f\u061C\u206A\u061C\u200D\u061C\u200D\u206B\u200D\x8d\u206E\x81\x8d\u206B\u206C\u2063\u2064",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u2063\u2062Seamlessly update your stakeholders\u2060\x90\x9d\u206A\u206C\u2061\x81\u2061\x81\x8f\u206C\x8d\u206A\u206C\u206C\u061C\u206E\u061C\u2061\x90\x8f\u206E\u200D\u206C\x8f\x8f\u061C\u206B\u200D\u2060\u2060\u061C\u2063\u2064",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "\u2063\u2062<p>Create consistent documentation by using our built-in templates. They are simple to use and customizable for your needs.</p> <p>You can use templates directly from project pages, so you never have to leave what you're working on. Browse all templates <a>here</a>.</p>\u206D\x81\x9d\u200D\u206B\u2060\u206F\u206D\x8d\u206E\x8d\u206B\u206F\x9d\x81\u206C\u200D\u206A\u206D\x90\x90\u200D\u206B\u206D\x8f\x8d\x81\u206B\u2060\u206B\u206C\u206D\u2063\u2064",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u2063\u2062Unify your documentation standards\u206B\u200C\u200D\x8d\u206E\u200D\x8f\x8d\u061C\u206C\x8f\u2061\u206E\u206F\x9d\u206C\x9d\x9d\x8f\u206C\x81\x9d\u2060\x9d\x8d\u2060\x8f\u2060\u206A\x90\u206C\x9d\u2063\u2064",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "\u2063\u2062<p>Create a single source of truth for important information by creating and managing documentation from the project pages tab in Jira.</p> <p>Did you know project pages runs on Confluence? It's free for up to 10 users. Invite the rest of your team in admin settings.</p>\x9d\u206B\x8f\u2061\x9d\u061C\x9d\u206D\u206F\u2061\u206B\u206B\x9d\u206A\u200C\u200D\u206C\x8d\x8f\u206A\x8d\x90\x81\u206A\u2061\x81\u206F\u2060\x8d\u200D\u206E\u206E\u2063\u2064",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u2063\u2062Your project pages, directly in Jira\u2061\u206A\u206F\u206D\x90\u206F\x81\x8f\u206D\u206B\u206D\u2061\u206F\u061C\x8f\u206D\u206A\u206B\x81\x81\u206F\x8d\x8d\u206E\x8f\x8d\x8d\u206F\u061C\u206C\u206A\u2061\u2063\u2064",
    'project-pages.improvement.templates.blank-page.description': "\u2063\u2062Start a page from scratch.\u206C\u200C\x90\u2061\u061C\u206B\u2060\u206A\x8f\u206C\u061C\u206D\u206B\u206C\u206E\x90\u200D\u2060\x81\u206E\x90\u206D\u200D\u200C\u206F\x81\u206C\x9d\u2060\x9d\x9d\x81\u2063\u2064",
    'project-pages.improvement.templates.blank-page.description.non-final': "\u2063\u2062Start a page from scratch.\u061C\u061C\x81\u2060\u206A\u061C\u2061\x81\x81\u200D\u206A\u200D\x8d\u206E\u206E\x90\u206A\u200C\u200D\u206E\u2061\x81\u206F\u200C\u2061\u206C\u206C\x81\u200C\u206E\x8d\u206A\u2063\u2064",
    'project-pages.improvement.templates.blank-page.name': "\u2063\u2062Blank page\u200C\u206C\u206D\x8d\u2060\u206D\x81\u206F\u206B\u206F\u206E\u061C\u2061\u206A\u206D\u206C\u206E\u200C\u206F\u2061\u2061\u200C\u206E\x8d\u206F\u206E\u206B\u2060\u200D\x8f\x8d\u200C\u2063\u2064",
    'project-pages.improvement.templates.blank-page.name.non-final': "\u2063\u2062Blank page\u206B\x8f\u206B\u206E\u206D\x90\u2061\x8f\u061C\u061C\x8d\u206A\x8f\x9d\x8f\u206D\x90\u061C\x9d\u206E\u200C\u206B\u200C\u200C\u2060\u200D\u2061\u206A\u061C\u2060\x81\u206F\u2063\u2064",
    'project-pages.improvement.templates.decision.description': "\u2063\u2062Record important project decisions and communicate them with your team.\x8d\u200D\u206B\x8d\u200C\u206C\u061C\x90\u206F\u206D\u206F\x90\u061C\u061C\x8f\u2060\u206D\u2060\x8f\u206D\u2060\u206E\x8f\u206A\x81\u206B\u206E\u206E\u2060\x8d\u061C\u206D\u2063\u2064",
    'project-pages.improvement.templates.decision.description.non-final': "\u2063\u2062Record important project decisions and communicate them with your team.\x81\x8d\x8d\x81\u2060\u206F\x9d\u206A\u200D\u206D\x9d\x9d\u206D\x8f\u2060\u200C\u061C\x8f\u200D\u2060\u2061\u2060\x81\u061C\u206F\x8f\u2060\u206F\u061C\u200D\u206F\x8d\u2063\u2064",
    'project-pages.improvement.templates.decision.name': "\u2063\u2062Decision\x8d\u2060\u206E\u2061\x81\u200D\x9d\u206B\x81\u200D\u200D\u200C\u206F\x8f\u200C\x9d\u2061\u206C\x81\u206D\u206A\x90\u2061\u2061\u206D\u061C\u206C\u206A\x81\u206E\x8d\x81\u2063\u2064",
    'project-pages.improvement.templates.decision.name.non-final': "\u2063\u2062Decision\x90\u200C\u206E\u206E\u206F\x9d\u2060\u206A\x8d\u2060\u206E\u2060\u200D\u200C\x9d\u206B\u206E\x9d\x8f\u2060\u2061\u206A\u206D\u200D\u206D\u206A\x9d\x8d\u206B\u206F\x8d\u200C\u2063\u2064",
    'project-pages.improvement.templates.meeting-notes.description': "\u2063\u2062Set meeting agendas, take notes, and share action items with your team.\u2060\u206C\u206D\u206C\x8f\u200C\u206B\x8d\x90\u206C\u206D\u206C\u206A\u206F\u206D\u061C\x81\u206C\u200D\u200D\x8d\u206D\x9d\u061C\u206B\x90\x8d\u200C\u206A\u2061\x8d\x8f\u2063\u2064",
    'project-pages.improvement.templates.meeting-notes.description.non-final': "\u2063\u2062Set meeting agendas, take notes, and share action items with your team.\x9d\u2060\u206B\x8d\u200C\u200C\x90\x81\u206B\u061C\x8d\x90\u200D\x9d\u2060\u2061\u2060\u061C\u206E\u2061\u200D\u200D\u206B\u206F\u206D\u2060\u061C\u2060\u206C\u200D\x90\x9d\u2063\u2064",
    'project-pages.improvement.templates.meeting-notes.name': "\u2063\u2062Meeting notes\u206A\u2060\u206C\u2061\x8f\u2061\x90\u200C\u206E\u206F\u206A\u206D\x81\u2060\x9d\u2061\u200C\x8d\u206A\x8f\u206D\u206E\u206C\x9d\u206F\x8d\x9d\x9d\u2061\u200C\u200D\x9d\u2063\u2064",
    'project-pages.improvement.templates.meeting-notes.name.non-final': "\u2063\u2062Meeting notes\u061C\u206E\x8f\u206E\u061C\u2061\u200C\x8f\u206A\x90\x81\u206E\u200C\u200C\u061C\u206B\x81\u2060\u206A\u206D\x90\x81\x9d\u206F\x8d\u206A\u200C\u061C\x8d\u200D\x8d\x8d\u2063\u2064",
    'project-pages.improvement.templates.post-expand.more': "\u2063\u2062More templates\u206F\x90\u206A\u206B\u061C\x8d\u206C\u206D\u206C\u200D\x90\u206C\u2060\u200C\u206A\u2060\u206F\u206D\x90\u2061\x90\x90\x81\u200D\x9d\u206E\x9d\u206D\x81\u206E\u200C\u061C\u2063\u2064",
    'project-pages.improvement.templates.post-expand.more.non-final': "\u2063\u2062More templates\u206A\u206A\u2060\u2060\x8d\u206F\u061C\u206F\u2061\u206F\u206E\x9d\x90\u206D\u200D\u200D\x8f\u2060\u2060\u061C\x90\x90\u200C\u200C\u200D\u200C\u206C\u206D\x8f\x9d\u206F\x8f\u2063\u2064",
    'project-pages.improvement.templates.post-expand.more.tooltip': "\u2063\u2062View all templates in Confluence\u200C\u200C\x8f\u2061\u2060\x9d\u200D\x8d\x9d\x8d\u200C\u206D\u2061\x90\x9d\x8d\u200D\u206D\x81\u206F\u200C\u206E\u200D\x90\u206D\u206A\u206A\u200C\u200C\x8d\u200D\u206B\u2063\u2064",
    'project-pages.improvement.templates.post-expand.more.tooltip.non-final': "\u2063\u2062View all templates in Confluence\x81\u206A\u206F\u200D\u206C\u200D\u206F\u206F\u061C\x90\x90\u2060\u206A\x8f\x8f\x81\u206D\x90\u206A\x8f\x81\u206F\x8d\x8d\x90\u206F\u2061\u206B\u200D\u206F\x8f\u200C\u2063\u2064",
    'project-pages.improvement.templates.post-expand.subtitle': "\u2063\u2062Popular templates\x81\u2060\x81\u206E\x9d\x90\u2060\u206C\u2061\u206A\u206A\u206B\u2060\x8d\u061C\x90\u061C\u206C\x90\x9d\u061C\x81\x8d\u206D\u200D\x81\x9d\u2061\u2060\u206A\u2061\x8f\u2063\u2064",
    'project-pages.improvement.templates.post-expand.subtitle.non-final': "\u2063\u2062Popular templates\u2061\u206C\u2060\x90\u206E\u206D\u200C\x90\u200C\x8d\x8d\u206F\u2060\u200C\u2060\u206C\u2061\x90\u061C\u200D\u200C\x8f\u200C\u200D\x9d\x8f\u2060\u200D\u206D\u206D\u061C\x8f\u2063\u2064",
    'project-pages.improvement.templates.post-expand.title': "\u2063\u2062Create a page\x8f\x8f\u200D\u2061\x81\u206B\u2061\u2060\u200D\u206D\u2061\u206D\u206C\x90\u206B\u2061\x81\u2061\u206C\x9d\u206C\x81\u206C\u200C\u200D\x9d\u200D\x8d\u206B\x8d\x90\x90\u2063\u2064",
    'project-pages.improvement.templates.post-expand.title.non-final': "\u2063\u2062Create a page\x81\u200C\u2060\u206F\u206C\u2060\u206B\u061C\u206F\u206D\u206A\u200C\u2061\u206E\x8f\u206C\u206E\u206E\x8d\x90\u2061\u206E\u206B\x90\x9d\x81\x81\u200C\x90\x81\u2061\u206A\u2063\u2064",
    'project-pages.improvement.templates.pre-expand.more': "\u2063\u2062Explore more templates\u206C\u200D\u2061\x8d\u206F\u206F\x8f\x8f\u206A\u061C\x9d\u206E\x81\u2061\u2061\x9d\u200C\u206B\u061C\u061C\x81\x8d\u200C\x8f\u2060\u200D\x81\x81\u200D\u206B\u2060\x8d\u2063\u2064",
    'project-pages.improvement.templates.pre-expand.more.non-final': "\u2063\u2062Explore more templates\u206A\u206C\x90\u2061\x8d\u2061\u200C\u2060\u2060\u206C\u200D\u206E\x9d\u206B\u2060\u061C\x90\u061C\u200C\u2061\x81\u061C\u2061\x90\u206D\x8d\x8f\u206D\x90\u206D\x8f\u206F\u2063\u2064",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u2063\u2062Popular with teams like yours\u206E\u206C\x8f\x9d\u206B\x8f\u2060\u206F\x81\u206A\u206D\x90\x81\x81\u2061\u206B\u2060\x8f\x90\u2061\u206D\u206B\x9d\u2060\x8d\u206B\x90\x81\x81\u206E\u206E\u2061\u2063\u2064",
    'project-pages.improvement.templates.pre-expand.subtitle.non-final': "\u2063\u2062Popular with teams like yours\x90\x90\u2060\u206B\u206A\u206E\u206F\u206D\u206A\x90\u061C\u206F\u200C\x81\u061C\u2061\x8f\u061C\u206F\u200D\u206C\u206B\u206F\u206D\u061C\u200D\x8f\u206B\u2060\u061C\x9d\x90\u2063\u2064",
    'project-pages.improvement.templates.pre-expand.title': "\u2063\u2062Preview templates\u206B\u206B\u206A\u206C\u200C\x81\u206A\u206A\u200C\u206E\u206A\u206E\x81\u206D\u206E\u206F\u206C\u206A\x90\x81\x8d\u2061\u2061\u200C\u206D\u206D\u061C\x8d\u206E\u2060\u206C\u206D\u2063\u2064",
    'project-pages.improvement.templates.pre-expand.title.non-final': "\u2063\u2062Preview templates\u2060\u206B\u061C\x8d\u206A\x8f\u206A\x9d\u2060\u206D\u206E\u200D\u200C\u2061\u061C\u061C\u206A\x90\u2060\u206C\u206C\x9d\u206B\u206C\x90\u206E\x90\u206C\x8f\x8f\u206E\x8f\u2063\u2064",
    'project-pages.improvement.templates.product-requirements.description': "\u2063\u2062Define, track and scope requirements for your product or feature.\u206E\u206F\x8d\u200C\x81\u206E\u2060\x9d\x8d\u061C\u200C\u061C\u2060\u206B\u061C\x90\u2060\x9d\x8d\u206F\x9d\u206D\u200D\u061C\u061C\u206C\u206F\x81\x81\u206D\u206D\u206D\u2063\u2064",
    'project-pages.improvement.templates.product-requirements.description.non-final': "\u2063\u2062Define, track and scope requirements for your product or feature.\u206A\x8d\u206C\u200D\x9d\u2060\x81\u200D\x8d\u2060\u200D\x8f\x81\x9d\u206E\u206D\u206D\u206E\u200D\u206F\u2060\x8d\x8f\u206B\u2061\u206F\u206C\x9d\u061C\u206A\u061C\u206C\u2063\u2064",
    'project-pages.improvement.templates.product-requirements.name': "\u2063\u2062Product requirements\u206E\u206D\u206F\x90\x9d\u061C\x8f\x81\x8f\u206C\u206A\u206C\u206F\x90\u206B\u200C\u206E\u206C\u206A\u206C\u200C\u206A\u2061\u2061\u061C\u2061\u200D\u200D\x8d\u200D\u206C\u200D\u2063\u2064",
    'project-pages.improvement.templates.product-requirements.name.non-final': "\u2063\u2062Product requirements\u200D\u206A\u2060\u206A\u206C\x9d\u2060\u206A\u206D\x8f\x90\u2060\x81\x81\u2060\u206C\x81\u200C\u200D\u206D\x9d\x8d\u206F\u200C\u2060\x8d\x8f\u206A\u061C\u2061\u206F\u200D\u2063\u2064",
    'project-pages.improvement.templates.retrospective.description': "\u2063\u2062What went well? What could have gone better? Crowdsource improvements with your team.\u200C\x8d\u206D\u206C\u206F\u200C\x8d\u200D\u206C\x81\u206A\x9d\u206A\u200D\u206E\u206D\u2060\x90\u2061\u2061\u206E\u200D\u206B\u206E\x9d\u206D\u206C\u206A\u2060\x8f\u206E\x9d\u2063\u2064",
    'project-pages.improvement.templates.retrospective.description.non-final': "\u2063\u2062What went well? What could have gone better? Crowdsource improvements with your team.\x9d\u206B\x8f\u206A\x8f\u200C\u206C\u061C\u200D\u200D\u206C\u206F\x81\x8d\u206E\u206D\u2061\u200D\x8d\u206B\u206B\u206B\u200D\x90\x90\x90\x90\u2061\u206A\x8f\u2060\u2060\u2063\u2064",
    'project-pages.improvement.templates.retrospective.name': "\u2063\u2062Retrospective\u061C\u2061\u200C\x8d\u206B\u206F\u200D\u061C\x90\x8d\u206F\x8f\x90\u061C\u200D\u2060\u206F\u2060\u206F\u206E\x81\u206F\x8d\u200C\x90\x81\u206B\u206B\x8d\u206A\u206F\u200D\u2063\u2064",
    'project-pages.improvement.templates.retrospective.name.non-final': "\u2063\u2062Retrospective\x8f\u206F\x90\x81\u200C\u2060\u200C\x8f\u200C\x8d\x8f\u206C\u206B\u200D\u200D\u061C\u206C\u206F\u200C\u206B\u206E\x81\u200D\x81\u2060\u206D\u206E\u206A\x81\u206D\x9d\u2061\u2063\u2064",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u2063\u2062Connect a Confluence space first\u206D\u061C\x8d\u206C\u206C\x8f\x8f\u206D\u206D\u206E\u200C\u061C\u206B\u206F\x9d\x90\u200D\x8d\u2061\u206D\u2061\u2060\u206C\x8d\u2061\u200D\x8f\u200D\x8d\u206D\x81\x81\u2063\u2064",
    'project-pages.improvement.templates.template.disabled-tooltip.non-final': "\u2063\u2062Connect a Confluence space first\x81\u2061\x8f\u061C\u2061\x8d\u206C\u206B\u2061\u2061\u200C\u206C\u200D\u200D\u206A\u206A\u206D\u2060\u2061\u2061\u200C\x8f\u206B\u206E\u206B\u206F\u206A\u206F\x90\u206A\u206F\u206E\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "\u2063\u2062<b>Save time and reduce manual tasks</b>. Confluence has lots of page <a>templates</a>, so you never have to start from scratch. Think technical documents, troubleshooting guides, project plans, product requirements, and more.\u206C\x9d\u2060\u2060\x81\x81\u206B\u206F\x81\u206A\u200D\u2061\u206E\u200D\x81\u206C\u2061\x90\u206D\x8d\x9d\u206C\u206A\u206F\x9d\u200C\x9d\x90\u206A\u200D\u200C\u206F\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.confluence-templates.non-final': "\u2063\u2062<b>Save time and reduce manual tasks</b>. Confluence has lots of page <a>templates</a>, so you never have to start from scratch. Think technical documents, troubleshooting guides, project plans, product requirements, and more.\x81\u200D\u206A\u2060\u200D\u061C\x8d\x9d\x81\u206F\x90\x8f\u200C\u206D\x9d\u2060\u206B\u200D\u061C\x8d\x90\x90\u206F\u200C\u061C\u206F\u206B\u206A\u2061\u200C\x8f\u200D\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "\u2063\u2062<b>Easily edit and format.</b> Use the top editing menu for standard word formatting, and by typing <b>/</b> you can easily insert lots of handy integrations. Insert a table by typing <c>/table</c> or an image with <c>/image</c>. You can also insert Dropbox links <c>/dropbox</c>, Microsoft office tools <c>/microsoft</c>, or Trello boards and cards <c>/trello</c>.\u206D\x90\x9d\u206C\u061C\x8f\x81\u206E\u200C\u061C\u206A\u206E\u206F\u206B\x9d\u206E\x9d\u206A\u2060\u200D\u200C\x8f\u206B\x81\x90\x9d\u200D\u2061\u206C\x90\u206C\u206A\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.edit-and-format.non-final': "\u2063\u2062<b>Easily edit and format.</b> Use the top editing menu for standard word formatting, and by typing <b>/</b> you can easily insert lots of handy integrations. Insert a table by typing <c>/table</c> or an image with <c>/image</c>. You can also insert Dropbox links <c>/dropbox</c>, Microsoft office tools <c>/microsoft</c>, or Trello boards and cards <c>/trello</c>.\u206F\u200C\u2061\u2061\u206F\u2060\u200C\u206A\x81\u2061\u206B\u2061\u206F\x8d\u206E\u206B\x8d\u206D\u206B\x8d\u206B\u061C\x90\u206B\u2061\x90\x8d\x9d\u206C\u206F\x8f\u2061\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u2063\u2062Type / followed by \u2018table\u2019 or \u2018image\u2019\x8f\u206E\x8f\x90\u206C\x8d\u2061\x81\u061C\u200C\u2061\u206F\u200C\u200D\u206F\u2061\u206E\x8f\u206C\x8f\u206A\u206F\u2061\x81\u206B\x8f\x9d\u206D\u206B\x9d\u206E\u206E\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt.non-final': "\u2063\u2062Type / followed by \u2018table\u2019 or \u2018image\u2019\x8f\u061C\u206B\u200C\u206D\u206E\u200C\x9d\u206F\u206F\u061C\x81\u2060\u200D\u206D\x8d\u206D\u2061\u206F\u206F\u206A\u200D\x8d\u206A\u206A\u206B\u206B\x81\u200C\x8d\x8f\u200D\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u2063\u2062Here are a couple of tips to get you started:\u206A\x90\x8f\x9d\x81\u200D\u200D\u2060\u2060\u200C\u2060\u206A\x8d\x8d\u206B\x9d\u206D\x81\x81\u206D\u200D\u2060\u206E\x8f\x9d\u200C\u061C\u206C\u200C\u206C\x8d\u206F\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips.non-final': "\u2063\u2062Here are a couple of tips to get you started:\x90\u2060\x8f\u200D\x8f\u2061\x90\u206E\u2060\u061C\x9d\x90\u206D\u200D\u206E\x90\x90\u206C\u061C\x9d\u206D\u206E\u206D\u200C\u200C\u206B\u206B\u200C\x81\u206A\u206E\u200D\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u2063\u2062Handy links\u206F\u206B\x8f\u2061\u2061\u206A\u2060\x8d\u206A\x8f\u2060\u206C\u206B\u206D\u2060\x90\x8d\x8f\x90\x90\u206D\u206D\u2060\u206B\x90\x9d\x81\u206D\u2060\u2060\u200D\x9d\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.handy-links.non-final': "\u2063\u2062Handy links\u206C\u2060\u206F\x9d\u2061\u2061\u200C\u061C\u200D\x90\u206C\u206F\u2060\u061C\u206D\u206E\u061C\u206D\u200C\u206A\u200D\u206E\u206C\u206A\u206E\u206E\u206D\u206D\u2061\u206A\x8d\u200C\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "\u2063\u2062Use Jira and Confluence together\u206F\x90\u206A\u2060\u206A\x9d\u206F\u206A\x90\x8f\x81\u2061\u2060\u206D\u200C\x90\u206E\u206A\x90\x81\u206A\x81\u206B\u206D\u206A\u200C\u200C\u206C\u061C\x90\u206A\u206E\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence.non-final': "\u2063\u2062Use Jira and Confluence together\u206E\u206D\u2061\u206B\x8d\x81\x81\u206C\u200C\u2061\u206B\u200C\u206B\x8d\u206B\x81\x90\u2060\u206C\x8d\u2060\u061C\x81\u206B\x8f\u206F\x90\u206C\u2061\u061C\u206E\u200D\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u2063\u2062Create charts on your pages using real Jira data. Type <c>/Jira charts</c>.\u206D\x9d\u2060\x9d\u206C\u206E\x9d\u206A\u200D\u206B\x9d\u206D\u206D\u2061\u200D\x8d\x8d\u200C\u206F\u206C\u206E\u2060\u206C\u2061\u200D\x9d\x81\u061C\u200C\u061C\u200D\u2061\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-charts.non-final': "\u2063\u2062Create charts on your pages using real Jira data. Type <c>/Jira charts</c>.\u206E\u206A\x90\u206E\u206A\u2061\u206C\u200C\x8f\x8f\u206E\u206F\u206C\u206F\u200D\x81\x81\u206A\x8f\u2060\u2061\u206F\u206B\u200C\u200D\u206E\u2061\x90\u206A\u200C\u200C\u206D\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u2063\u2062Link a Jira issue anywhere on your page. The link on the page will update in real-time, as you update the Jira issue. Type <c>/Jira</c>.\u200D\u206E\u200D\x81\u2061\x8d\u200D\u200C\u200C\u206D\u200C\x90\u206C\u061C\u206D\u200D\x8d\u206E\x90\u200C\u206F\u206C\u2061\u2061\u206B\u061C\x81\x8f\u2061\u206A\u2060\x81\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final': "\u2063\u2062Link a Jira issue anywhere on your page. The link on the page will update in real-time, as you update the Jira issue. Type <c>/Jira</c>.\x81\x8d\u206A\u200D\u206F\u200C\u206B\x8d\u2061\u206F\u200C\u206D\u2061\u206F\u061C\u206D\x81\u2061\u206B\u200D\u2061\u206D\u206D\u2060\u200D\x90\u2060\x9d\u206A\u206C\u061C\u2061\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u2063\u2062Embed interactive roadmaps and timelines for your page using your Jira Projects. Type <c>/jira roadmap</c>.\u206D\u206F\x8f\u206F\u206B\x81\u206E\u2061\x8f\u061C\u206D\x8f\u200D\u206D\u061C\u206E\x9d\u206C\u2061\u206E\u206F\u200D\u206B\u200C\u206A\u206B\u206E\x8d\u200D\x90\u206C\u206A\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps.non-final': "\u2063\u2062Embed interactive roadmaps and timelines for your page using your Jira Projects. Type <c>/jira roadmap</c>.\u206E\u206A\u2061\u061C\u200C\u2060\u206D\u200C\u206F\u061C\u206B\u061C\u200D\u200C\u200C\u206D\u206D\x90\u200D\u206C\u206F\u2061\x9d\u061C\u206D\x90\x8d\u2061\u206D\u206B\u206E\x8f\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u2063\u2062Embed interactive timelines for your page using your Jira Projects. Type <c>/jira timeline</c>.\u206C\u206E\x8d\x81\u206A\x90\x8f\x81\x8d\u206D\u2060\u206E\x81\u2061\u206F\u206F\u200C\u200D\u2061\u200C\u2060\x9d\u206E\u206B\u200C\u2060\u200C\x8f\u200D\x8d\x8d\u206A\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-timeline.non-final': "\u2063\u2062Embed interactive timelines for your page using your Jira Projects. Type <c>/jira timeline</c>.\u061C\u206B\u206D\u2061\u206B\u206A\u206A\x9d\u061C\u206F\u200D\u2061\u2060\u206B\u206E\u2061\u206F\u061C\u061C\u2060\x8f\x90\u200D\u206B\u200D\u2061\x8f\u2061\x8d\x8f\u200C\u206E\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "\u2063\u206276% of Jira Software customers said they shipped projects faster after adding Confluence\x81\u206E\x8d\u206B\u206C\u206B\u206B\x81\u200D\u200C\x9d\x8d\u206D\x90\u206E\u200C\u200C\x8d\u2061\x90\x8f\u061C\u206B\x8f\x81\x90\x90\x90\u206B\u200C\x90\u206B\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.non-final': "\u2063\u206276% of Jira Software customers said they shipped projects faster after adding Confluence\u206D\x81\u206D\u2061\x90\u2060\u206E\u206B\u200D\u2061\u061C\u2061\u200D\x8f\u206A\x8f\u061C\u200D\x81\u061C\u200D\u206E\x90\u2060\x81\u206D\u206D\u206F\u206F\x9d\u200C\u206B\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "\u2063\u206276% of Jira customers said they shipped projects faster after adding Confluence\u206E\u206E\x9d\u206D\u206D\u206B\x81\x8f\u061C\u200C\x81\u206C\u200D\x90\x8d\u2061\u061C\x8d\x9d\x8f\u206E\x8d\u200D\u200D\u206D\u061C\x8d\u061C\u2061\u061C\x8f\u206B\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding.non-final': "\u2063\u206276% of Jira customers said they shipped projects faster after adding Confluence\u2060\u206B\u206C\x8d\x90\u206B\u200C\x8f\u206C\u200C\x8d\u206E\x9d\u206B\u206D\u061C\u206C\x81\x8f\u200D\u200D\u206E\u200D\x9d\u206C\u206D\u200D\x9d\u206B\u206F\u061C\u206B\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "\u2063\u2062<b>Using spaces and pages</b>. Spaces are part of every Confluence site and are a way of organizing pages into categories. Think of spaces as different folders or projects, and pages are the documents that belong in those folders or projects. <a>Learn more about how to use spaces</a>\u206C\x90\u206C\u206B\u2061\u206C\u200D\x8d\u206E\u200C\x90\u206F\u206F\u206C\x8f\u206D\u206E\x90\u2061\u206B\u206F\x90\x81\u200D\u2060\x81\u206D\u061C\u061C\u200C\u2060\u206F\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages.non-final': "\u2063\u2062<b>Using spaces and pages</b>. Spaces are part of every Confluence site and are a way of organizing pages into categories. Think of spaces as different folders or projects, and pages are the documents that belong in those folders or projects. <a>Learn more about how to use spaces</a>\x9d\x90\x8d\u2060\u206F\u061C\u206D\x8f\u206F\u206C\u206A\u206D\u061C\x81\u200C\u206C\u2060\u061C\u061C\x9d\u200D\u206D\u200D\x81\x81\u200C\u2061\x8d\u061C\u206E\u206C\x9d\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u2063\u2062Try it now\x81\u2060\u206B\u206E\u061C\u2061\u206A\u200D\u061C\x81\u200D\u206B\x81\u206A\x81\u206B\u206F\x8d\u2061\x90\u206D\x8f\u206B\u2061\u206A\u2060\u206E\u2061\u2060\u206A\u2061\u200D\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.try-it-now.non-final': "\u2063\u2062Try it now\u200C\u061C\u206D\u206C\u206A\x8f\x9d\x8f\x8d\u206F\u200D\x8d\x8d\u206F\x81\x8f\x9d\u2060\x9d\u2061\u2061\u206E\x9d\u206E\x81\u2061\u2060\u206A\x8f\u200D\u206A\u206F\u2063\u2064",
    'project-pages.improvement.templates.tutorial.description': "\u2063\u2062Learn how to edit a page.\u200D\x90\u206C\u2061\u206D\x81\u2060\x9d\x8f\u206D\x90\u206A\u200D\u206D\u061C\u206A\u2060\x81\u061C\u061C\u061C\x8d\u2060\x8f\u200D\u206B\x8d\u206E\u206D\x81\x81\u200C\u2063\u2064",
    'project-pages.improvement.templates.tutorial.description.non-final': "\u2063\u2062Learn how to edit a page.\u206F\x9d\u206F\u206A\x9d\u206B\u061C\x90\x90\u2060\u200D\u206E\u206E\u2060\x81\u061C\u206F\u200C\x8f\x9d\u2060\u2061\u206C\u206F\u200D\u200C\u206D\u206C\u061C\x81\u206B\u2060\u2063\u2064",
    'project-pages.improvement.templates.tutorial.name': "\u2063\u2062Welcome to Project Pages!\u200C\u206D\u2061\x90\u200C\x8f\x90\u061C\u206A\u2060\u206E\u206A\u206C\x81\u200D\x81\u206F\u206D\u061C\u206A\u206E\x9d\u200D\u206C\x81\x81\x9d\x81\x8d\u061C\u206C\u2061\u2063\u2064",
    'project-pages.improvement.templates.tutorial.name.non-final': "\u2063\u2062Welcome to Project Pages!\x81\u206C\x81\u206E\x8d\u2061\u200C\u206B\u206F\x8f\u206C\x8f\u206F\x8d\u2061\x9d\x90\u206A\u200D\x9d\x81\u200D\x9d\u206E\u206C\x81\u206B\u206C\x90\u206F\x81\u206D\u2063\u2064",
    'project-pages.improvement.terms-and-conditions-v2': "\u2063\u2062By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.\u206A\u2061\u206E\x81\u2061\u2061\u061C\x81\x81\u2060\u206A\x90\u206E\x9d\u206A\x8f\u206C\u206B\u206F\u206C\u200C\x8d\x8f\x9d\u061C\u206D\u206E\u206E\x9d\x90\u206E\u200C\u2063\u2064",
    'project-pages.improvement.terms-and-conditions-v2.non-final': "\u2063\u2062By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.\u206C\x9d\u200C\u206E\x8d\u206B\u206D\u200D\u2061\x90\u061C\u206B\u200D\u200C\u2061\u200D\u200D\u2060\x8d\u206C\x9d\u206B\x8d\u206C\x8f\x8d\x9d\u206A\x8f\x90\u206C\u200D\u2063\u2064",
    'project-pages.improvement.title': "\u2063\u2062Project pages\u206B\u206C\u2061\u206E\u206A\u206F\u206D\u206B\u200C\u206B\u2060\u206B\x8f\u206A\x81\u206F\u206B\u206C\u206A\u200C\u206B\x8d\u200C\u200D\u061C\u2060\u206C\u2060\x9d\u206D\u2061\u200D\u2063\u2064",
    'project-pages.improvement.title.non-final': "\u2063\u2062Project pages\u061C\u206D\x81\u2060\u200C\x81\u206E\x8f\u206E\u206E\u206F\u200C\u2061\u061C\u061C\u206C\u2061\x90\x9d\u2060\u200C\u200C\u206C\u206D\x90\u206F\x8f\u206B\u206D\x9d\u206A\u206C\u2063\u2064",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u2063\u2062Create page\u200D\u061C\x8d\u206C\u206A\u206F\x90\u061C\x81\x90\u200C\u206B\u206E\x8d\x90\u2061\u2061\u200C\u2061\u200D\u206E\u206E\u2061\x81\u2060\x8d\u206D\u206E\u206F\u061C\x8f\x90\u2063\u2064",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\u2063\u2062We\u2019ve added Confluence so you can start creating and linking all your project documents. It\u2019s free for up to 10 users.\u2061\x81\u206B\x8d\u206E\u2061\u206C\u206B\u206D\u200D\x90\u206A\x8d\x8f\u206E\x8d\u206E\u206D\u200C\u206C\x81\u200C\u206A\u206F\x8f\u200D\u200C\x90\u206F\x8d\u200D\x8f\u2063\u2064",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u2063\u2062Learn more\u200D\u206F\u206E\u206B\x8d\x81\x9d\x9d\x81\x9d\u206D\x9d\u206F\x8d\x81\u200D\u200C\u206A\u206C\u200D\x8d\u200D\x9d\u206B\u206F\u2060\u206D\u206D\u206B\x90\u206C\u200C\u2063\u2064",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u2063\u2062Create your first page\x90\u200D\u206A\u061C\x81\u061C\u200D\u206D\x9d\u206F\u206B\u206C\u200D\u200D\u206B\x8d\x8f\u206C\u206D\u061C\u2060\x8f\x81\u2061\x8f\u2061\x8f\u2061\x90\u206E\x9d\u061C\u2063\u2064",
    'project-pages.improvement.transient-states.empty-state.description': "\u2063\u2062Create some meeting notes, product requirements, decisions, or other content to see this space fill up.\u200C\x9d\u206A\u061C\u2061\u206F\u2061\u206F\x8f\u206D\x9d\u2061\u206F\u2061\u206F\u2060\u2060\u2060\x8d\u200C\x81\x8d\u206C\u2060\u206E\u200D\x90\x9d\x81\x90\u206C\u206B\u2063\u2064",
    'project-pages.improvement.transient-states.empty-state.title': "\u2063\u2062There\u2019s nothing here but potential\u206A\u206D\u206C\u206C\u206C\u206B\u206B\u206D\x8d\x90\u200C\u206D\x8d\u061C\x90\x9d\u2061\x90\x90\u206C\x8f\u061C\u206C\u206C\u206B\u200C\u206C\x90\u206A\u200D\u206B\x9d\u2063\u2064",
    'project-pages.improvement.try-button': "\u2063\u2062Try this template in Confluence\u206B\u2060\x90\x90\u200D\u206A\u206F\x8d\u206F\u206F\u2060\u061C\u206F\u2060\x9d\x8f\x81\x8d\u200C\x81\x81\u2060\u2060\u206B\u206F\u200D\u061C\u206A\u200D\u206F\u200C\u206B\u2063\u2064",
    'project-pages.improvement.try-button.non-final': "\u2063\u2062Try this template in Confluence\u206E\x81\u206B\u061C\u200D\x81\u2061\u206E\u206B\u206F\u2060\u206D\u206C\x8d\u2060\x9d\u206F\u206B\u206B\x9d\u206A\u206E\u200D\u206E\u206E\u206E\x8f\u206C\u206B\x8f\u206E\x9d\u2063\u2064",
    'project-pages.improvement.try-it-now': "\u2063\u2062Try it now\x81\u2060\u206B\x90\x9d\x81\x81\x9d\u200D\u206A\u2060\u206F\u200D\u200D\u206D\u061C\u2061\x9d\u206B\u206F\u200D\u2061\x9d\u206F\u206D\x9d\x8f\x8f\u200C\x9d\u206D\u200D\u2063\u2064",
    'project-pages.improvement.try-it-now.non-final': "\u2063\u2062Try it now\u206D\u206A\u2060\u200C\x8f\u061C\u2061\x81\x81\x81\x8f\u206A\u206B\u206F\x8d\x81\u206B\u061C\x81\x8f\u206F\u206E\x8d\u206C\u206B\u206C\x90\u206B\u206F\x9d\u206B\u2060\u2063\u2064",
    'project-pages.improvement.try-lozenge': "\u2063\u2062try\u206A\x9d\u200C\u206F\u061C\x8f\u206C\x90\u206B\u061C\u206E\u2061\u206F\x81\u206B\x8d\u2061\u2061\u206A\x8f\u2061\u200C\x90\x81\u2061\x8d\u061C\u206E\u206E\u206D\u200D\u2061\u2063\u2064",
    'project-pages.improvement.try-lozenge.non-final': "\u2063\u2062try\x81\u206B\x8f\x8f\u206A\u206B\x81\u061C\u200C\u206B\u200D\x8f\u206C\u061C\u200D\u200C\u206D\u206A\u061C\u200C\u061C\x8f\u206C\u206A\u206F\u2061\u061C\x8f\u206C\x9d\u206A\u206E\u2063\u2064",
    'project-pages.improvement.try-on-demand-button': "\u2063\u2062Try it free\u206E\u206D\x8d\u206C\x90\u061C\x8f\u206C\u206E\u206A\u206C\x81\u200C\u206B\x9d\x8f\u2061\x9d\u2061\u206A\u206E\u206D\u206E\u206D\u200C\u061C\u206D\u206F\x90\x9d\u2061\x8d\u2063\u2064",
    'project-pages.improvement.try-on-demand-button.non-final': "\u2063\u2062Try it free\x8d\u206D\u206E\u200D\u206E\u206F\u206D\x9d\u061C\u200D\x8d\u206E\x90\u206E\u2061\u206F\u061C\u206B\u206E\u206D\u2061\u206E\u206B\u206E\x81\x81\u200C\u206E\u206A\u2060\x9d\u206D\u2063\u2064",
    'project-pages.join-confluence-screens.denied-access-title.non-final': "\u2063\u2062Denied Access Screen\x8d\x8f\u206C\u200C\u206D\u2060\u2061\u2060\u2060\u2061\u200C\u2061\u206E\u061C\u206B\u206A\u2060\x81\u206D\u206B\u206C\u2060\u206B\u206F\x81\u206C\x9d\x8f\x90\x90\u200D\u206A\u2063\u2064",
    'project-pages.join-confluence-screens.direct-join-title.non-final': "\u2063\u2062Direct Join Screen\u061C\x8d\x90\u2061\u206E\u206A\x90\u206F\u200C\u2061\x9d\x90\u061C\x81\u061C\x90\u206F\u2060\u061C\u206A\u206D\u200D\u200C\u200D\x8f\u206C\u206D\x8f\u200D\x9d\u061C\x81\u2063\u2064",
    'project-pages.join-confluence-screens.pending-request-title.non-final': "\u2063\u2062Pending Request Screen\u206F\x8d\x81\u200C\u200C\u2060\u206A\x8f\u200C\x8f\u206B\u2060\u206F\u206B\u206B\u200D\u206E\u200C\u206D\x8f\u2060\u2060\u206B\x81\u200D\x9d\u206E\u206A\u061C\u2060\x90\u206D\u2063\u2064",
    'project-pages.join-confluence-screens.request-access-title.non-final': "\u2063\u2062Request Access Screen\u2061\u206E\u200D\u061C\x8d\u2061\u206F\u2061\u206C\x8d\u200D\x81\u061C\u200D\u061C\u200C\x90\u206D\u2060\x90\x9d\u206F\u206D\u206F\x8d\u200D\u206D\u206C\u200C\x8d\u206B\u2060\u2063\u2064",
    'project-pages.join-confluence-screens.revoked-access-title.non-final': "\u2063\u2062Revoked Access Screen\x8d\u200C\u206E\x9d\u206D\x8f\u206E\x8d\u061C\u061C\u206A\u206A\u200C\u206D\u206D\u206A\u206A\u2060\x8d\u206C\u2060\u206E\x9d\x8d\u206C\u206D\u206E\u2060\u200C\u200C\u061C\u2060\u2063\u2064",
    'project-pages.join-confluence-screens.title.non-final': "\u2063\u2062Join Confluence Page\x9d\u200D\x90\u2061\u206E\u206C\u206F\x8f\x8f\u2061\u206C\u200D\u206C\u206A\u206D\x9d\x81\u061C\u2060\u206E\u2061\u206A\x81\u206A\u206E\u206A\x90\u206D\x9d\u206B\u200C\u206C\u2063\u2064",
    'project-pages.landing-page.feature1.non-final': "\u2063\u2062Access and create documents without leaving Jira\x90\u2061\u206F\u206D\u206F\u2061\x8d\u206F\u2060\x90\x8d\u061C\x9d\x8d\u061C\u206E\u200C\u206A\u200C\u200D\x9d\u2060\x9d\u200D\u206D\u206D\u206B\u206A\x9d\u206F\u200C\u206A\u2063\u2064",
    'project-pages.landing-page.feature2.non-final': "\u2063\u2062Templates for meetings, sprint plans, and more\u206C\x8d\x8d\u206A\u200D\u200D\x9d\u061C\u2061\u206D\u206A\x8d\u200D\x8d\u206B\x8f\u206D\u206D\x90\u206E\x8f\u061C\x90\u2061\u061C\x8d\u200D\x8f\x90\u206F\u206B\u206E\u2063\u2064",
    'project-pages.landing-page.feature3.non-final': "\u2063\u2062Sync documents to Jira for automatic updates\x90\u206F\u061C\x9d\x8f\u2061\u200D\u206F\u206B\x81\u206A\u206F\x9d\u2061\x81\u2060\u206B\u206B\u206F\u206B\u2060\u2060\u206D\u206F\u2061\u206B\x90\u206B\u2060\u2060\u200C\u200C\u2063\u2064",
    'project-pages.landing-page.illustration.title.non-final': "\u2063\u2062Project pages\u2061\u061C\u2060\u206E\u200D\u206D\x9d\u206F\u2061\u061C\u200D\u206D\x81\u206A\u206B\u200C\u206D\u061C\u200D\u206E\u206C\u200D\x81\u206E\u2061\u200C\u206D\u206D\u206B\u2061\u206D\x81\u2063\u2064",
    'project-pages.landing-page.terms-and-conditions.non-final': "\u2063\u2062By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.\u2061\u2060\u200C\u200C\u061C\u2060\u206B\u206F\u206A\x81\x8d\x8f\u200D\x81\u200C\u200C\u200D\u061C\x8d\x9d\u206F\u206E\x9d\x9d\u206E\u206E\u200D\u206A\x9d\u2061\x81\u206C\u2063\u2064",
    'project-pages.landing-page.title.non-final': "\u2063\u2062Welcome to Project Pages\u200D\u061C\u2060\u206B\u200D\u200C\u2060\u2060\x9d\u206D\u206E\u200D\u206E\u206A\x81\u206C\u200D\u2060\u200D\x8f\u200D\u206A\u200C\u200C\u061C\u200C\x90\u206B\u2061\x8f\u061C\u206C\u2063\u2064",
    'project-pages.landing-page.try-now-btn.non-final': "\u2063\u2062Try it now\u206E\u206F\u200D\u2061\u206E\u200D\u206C\u206F\u2060\x90\u206F\u206A\x81\x8f\u206B\x8d\x90\x90\x8d\u206E\u206F\u206B\u206A\u206A\u206E\x8d\u206A\u206C\u2060\u200C\x9d\x81\u2063\u2064",
    'project-pages.page-deleted-flag.title': "\u2063\u2062Page deleted.\u206E\u200D\u206A\x90\u200C\u061C\x9d\u206E\u206E\u206E\u2060\u206C\u200D\u061C\u206A\x90\x9d\x9d\x9d\u2060\u200C\u206D\x90\u206E\u200C\u206F\u206F\u206B\u200C\x90\u2061\u206F\u2063\u2064",
    'project-pages.page-published-flag.title': "\u2063\u2062Your page has been published.\u200C\x9d\u206F\x90\u2060\u061C\u206F\u2060\x8f\u2061\x8f\u206E\u200C\u206D\u2060\x8d\x8d\u200C\u200C\x9d\u061C\u206F\u061C\x81\u206B\u2061\u2060\u206D\u206D\u061C\u206C\u061C\u2063\u2064",
    'project-pages.space-connectsuccess-flag.title.space.non-final': "\u2063\u2062Content connected\u2060\u206A\x8f\u206B\u206C\u206E\u206B\u061C\x9d\x81\u061C\x8f\u200C\u206F\u206A\u206C\u206A\x81\u206E\u206A\x8d\u061C\x81\x90\u206C\u2060\x81\x90\u200C\x8d\x9d\u200D\u2063\u2064",
    'project-pages.title.non-final': "\u2063\u2062Project pages\u206A\x90\u206C\x81\x9d\x9d\x8d\u200C\x81\u206A\x8d\u206F\u206E\u2061\u200D\x8f\x81\x9d\u2060\u206F\x81\u206A\x8d\u061C\u206A\x9d\u200C\u206D\x81\x81\u061C\u206C\u2063\u2064",
    'project-pages.unknown-error.description': "\u2063\u2062{contactSupport} if refreshing doesn\u2019t fix things.\x81\u2061\u206D\x81\x8d\x9d\u2061\u206F\u061C\u2061\x8d\x90\u206D\x90\u061C\u206A\u206A\u206E\x8d\u2060\u206A\u2061\u206D\x9d\x90\x8f\x81\u206C\u206D\u206C\u206D\u2060\u2063\u2064",
    'project-pages.unknown-error.heading': "\u2063\u2062We can\u2019t display project pages right now\u206A\u206B\u206A\u200C\u2061\u206E\u200C\u2060\x8d\u206A\x9d\u206C\x90\x9d\u206C\u206F\u200C\x8d\u206B\u206C\x8f\u206C\u206C\u061C\u206F\x81\u2061\x81\x81\u061C\x9d\u206D\u2063\u2064",
    'projectpages.templatepreview.termsandprivacy': "\u2063\u2062By clicking &quot;Try it free&quot;, you will be enrolled in Confluence and agree to the Atlassian <termsOfServiceLinkText>Cloud Terms of Service</termsOfServiceLinkText> and <privacyPolicyLinkText>Privacy Policy</privacyPolicyLinkText>.\u2061\x90\u061C\u206C\x81\u206D\u206F\x9d\u206A\x8d\u200D\u200D\x8f\u206F\x90\u200D\x90\u206C\x9d\u206D\u061C\u206C\u061C\u2060\x8d\x81\u2060\u206F\u2060\u206E\u206C\u206C\u2063\u2064"
};

});


parcelRegister("6I7Zw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83cafd2bb0b7afc$export$2e2bcd8739ae039);
var $e83cafd2bb0b7afc$export$2e2bcd8739ae039 = ()=>{
    // TODO: Clean up
    return;
};

});

parcelRegister("b18Mx", function(module, exports) {

$parcel$export(module.exports, "sendTrackAnalyticsEvent", () => $691feaa45682d03b$export$2876719c0f567f52);
$parcel$export(module.exports, "sendOperationalAnalyticsEvent", () => $691feaa45682d03b$export$e16236c4f06d26b8);
$parcel$export(module.exports, "initAnalyticsClient", () => $691feaa45682d03b$export$5021d68a48726232);
$parcel$export(module.exports, "getAnalyticsWebClient", () => $691feaa45682d03b$export$e9ba7ef9458d1a4a);

var $9OdO2 = parcelRequire("9OdO2");

var $dNAsL = parcelRequire("dNAsL");
var $1C9jQ = parcelRequire("1C9jQ");
let $691feaa45682d03b$var$rootContext = {};
let $691feaa45682d03b$var$analyticsClient;
const $691feaa45682d03b$var$joinCamelCase = (base, value)=>{
    const camelCasedValues = (0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))([
        value
    ], (v)=>v.split('.')).map((v)=>v.replace(/^./, (c)=>c.toUpperCase()));
    return [
        base,
        ...camelCasedValues
    ].join('');
};
const $691feaa45682d03b$var$createEvent = ({ objectType: objectType, objectId: objectId, source: source, action: action, actionSubject: actionSubject, attributes: attributes, tags: tags })=>({
        containerType: $691feaa45682d03b$var$rootContext.containerType,
        containerId: $691feaa45682d03b$var$rootContext.containerId,
        objectType: objectType,
        objectId: objectId,
        source: $691feaa45682d03b$var$joinCamelCase($691feaa45682d03b$var$rootContext.parent, source),
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: $691feaa45682d03b$var$joinCamelCase(action, actionSubject),
        attributes: attributes,
        tags: tags
    });
const $691feaa45682d03b$var$sendEvent = ({ type: type, payload: payload })=>{
    switch(type){
        case (0, $1C9jQ.eventType).UI:
            $691feaa45682d03b$var$analyticsClient.sendUIEvent(payload);
            break;
        case (0, $1C9jQ.eventType).TRACK:
            $691feaa45682d03b$var$analyticsClient.sendTrackEvent(payload);
            break;
        case (0, $1C9jQ.eventType).OPERATIONAL:
            $691feaa45682d03b$var$analyticsClient.sendOperationalEvent(payload);
            break;
        case (0, $1C9jQ.eventType).SCREEN:
            $691feaa45682d03b$var$analyticsClient.sendScreenEvent(payload.name, null, payload.attributes);
            break;
        default:
    }
};
const $691feaa45682d03b$export$2876719c0f567f52 = (eventData)=>{
    const analyticsEvent = $691feaa45682d03b$var$createEvent(eventData);
    $691feaa45682d03b$var$sendEvent({
        type: (0, $1C9jQ.eventType).TRACK,
        payload: analyticsEvent
    });
};
const $691feaa45682d03b$export$e16236c4f06d26b8 = (eventData)=>{
    const analyticsEvent = $691feaa45682d03b$var$createEvent(eventData);
    $691feaa45682d03b$var$sendEvent({
        type: (0, $1C9jQ.eventType).OPERATIONAL,
        payload: analyticsEvent
    });
};
const $691feaa45682d03b$export$5021d68a48726232 = ({ client: { environment: environment, locale: locale, cloudId: cloudId, accountId: accountId }, context: context })=>{
    $691feaa45682d03b$var$analyticsClient = new (0, $dNAsL.default)({
        env: environment === 'prod' ? (0, $1C9jQ.envType).PROD : (0, $1C9jQ.envType).DEV,
        product: 'jira',
        version: '1.0.0',
        locale: locale
    });
    $691feaa45682d03b$var$analyticsClient.setTenantInfo((0, $1C9jQ.tenantType).CLOUD_ID, cloudId);
    $691feaa45682d03b$var$analyticsClient.setUserInfo((0, $1C9jQ.userType).ATLASSIAN_ACCOUNT, accountId);
    $691feaa45682d03b$var$rootContext = context;
};
const $691feaa45682d03b$export$e9ba7ef9458d1a4a = ()=>$691feaa45682d03b$var$analyticsClient;

});

parcelRegister("jUlQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70ebef515725348$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $3pvFP = parcelRequire("3pvFP");

var $lpJ9O = parcelRequire("lpJ9O");

var $hMy8N = parcelRequire("hMy8N");

var $9yekW = parcelRequire("9yekW");

var $4aXoz = parcelRequire("4aXoz");

var $fuxC8 = parcelRequire("fuxC8");

var $fQ6dp = parcelRequire("fQ6dp");

var $e6aAb = parcelRequire("e6aAb");

var $khgCp = parcelRequire("khgCp");

var $fOSB9 = parcelRequire("fOSB9");

var $33NPm = parcelRequire("33NPm");

var $jsOid = parcelRequire("jsOid");

var $3a6Xq = parcelRequire("3a6Xq");

var $k0kPd = parcelRequire("k0kPd");

var $6shJa = parcelRequire("6shJa");

var $2ZONo = parcelRequire("2ZONo");
const $d70ebef515725348$export$c31df4bd766f9c35 = (state, { hasConfluence: hasConfluence })=>({
        ConnectSpaceDialog: $fuxC8.default,
        CreateSpaceDialog: $fQ6dp.default,
        MoreMenu: $3a6Xq.default,
        ConnectSpace: $khgCp.default,
        ConfluenceTree: $fOSB9.default,
        ServerError: $33NPm.default,
        ConfluenceActivating: $e6aAb.default,
        PagesHeading: $k0kPd.default,
        Flags: $jsOid.default,
        EmbeddedConfluenceDialog: $6shJa.EmbeddedConfluenceDialog,
        confluenceLicenseStatus: (0, $9yekW.getConfluenceLicenseStatus)(state),
        confluenceState: (0, $hMy8N.getConfluenceState)(state),
        hasAccessToConfluence: (0, $9yekW.getIsPostExpand)(state, hasConfluence),
        origin: (0, $hMy8N.getOrigin)(state),
        cloudId: (0, $hMy8N.getCloudId)(state),
        projectSpaceKey: (0, $4aXoz.getProjectSpaceKey)(state),
        projectSpacePageTitleHasBeenFetched: state.confluence.connectedSpace.projectSpacePageTitleHasBeenFetched,
        accountId: (0, $hMy8N.getAccountId)(state)
    });
const $d70ebef515725348$export$9e6a17cf56877796 = (dispatch)=>({
        triggerShowConnectSpaceDialog: ()=>{
            dispatch((0, $3pvFP.showConnectSpaceDialog)());
            dispatch((0, $3pvFP.fetchConfluenceSpaces)());
        },
        triggerHideConnectSpaceDialog: ()=>dispatch((0, $3pvFP.hideConnectSpaceDialog)()),
        triggerErrorFlag: ()=>dispatch((0, $3pvFP.showError)()),
        triggerInitializeView: ()=>{
            dispatch((0, $lpJ9O.initializeView)());
        }
    });
var $d70ebef515725348$export$2e2bcd8739ae039 = (0, $cllCv.connect)($d70ebef515725348$export$c31df4bd766f9c35, $d70ebef515725348$export$9e6a17cf56877796)((0, $2ZONo.default));

});
parcelRegister("3pvFP", function(module, exports) {

$parcel$export(module.exports, "CHANGE_SPACE_NAME", () => $b1fd0e044a377788$export$975d476978f4be6d);
$parcel$export(module.exports, "changeSpaceName", () => $b1fd0e044a377788$export$3e1566633c96b95);
$parcel$export(module.exports, "CHECK_PRODUCTS_LICENCE_STATE", () => $b1fd0e044a377788$export$e3e0aa9fa72a9172);
$parcel$export(module.exports, "checkProductsLicenceState", () => $b1fd0e044a377788$export$758ea8f67c1b6038);
$parcel$export(module.exports, "CHECK_CONFLUENCE_USER_PERMISSIONS", () => $b1fd0e044a377788$export$498ddfccd74f6b2e);
$parcel$export(module.exports, "checkConfluenceUserPermissions", () => $b1fd0e044a377788$export$e645a900e228e518);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_USER_ACCESS", () => $b1fd0e044a377788$export$5ae85edd40fea59);
$parcel$export(module.exports, "updateConfluenceUserAccess", () => $b1fd0e044a377788$export$190a933252181349);
$parcel$export(module.exports, "CONNECT_CONFLUENCE_SPACE", () => $b1fd0e044a377788$export$98f58cdac80fc749);
$parcel$export(module.exports, "connectConfluenceSpace", () => $b1fd0e044a377788$export$30ea72c711e481ce);
$parcel$export(module.exports, "FETCH_CONNECTED_SPACE_BLUEPRINTS", () => $b1fd0e044a377788$export$477de93d41065628);
$parcel$export(module.exports, "fetchConnectedSpaceBlueprints", () => $b1fd0e044a377788$export$c9e2bdc7b72fcdd1);
$parcel$export(module.exports, "CHECK_CONFLUENCE_ACCESS_WITH_RETRY", () => $b1fd0e044a377788$export$70014928e1a39ffa);
$parcel$export(module.exports, "checkConfluenceAccessWithRetry", () => $b1fd0e044a377788$export$76137a25f6d06d6c);
$parcel$export(module.exports, "RESET_CONNECTED_SPACE", () => $b1fd0e044a377788$export$aa2e879d6392e0ba);
$parcel$export(module.exports, "resetConnectedSpace", () => $b1fd0e044a377788$export$89f1e56d63058051);
$parcel$export(module.exports, "FETCH_CONNECTED_SPACE_BLUEPRINTS_ERROR", () => $b1fd0e044a377788$export$5ba9db9ab3024aed);
$parcel$export(module.exports, "fetchConnectedSpaceBlueprintsError", () => $b1fd0e044a377788$export$ca0d39c192dc7e82);
$parcel$export(module.exports, "FETCH_CONFLUENCE_SPACES", () => $b1fd0e044a377788$export$d5ff56be054b9a75);
$parcel$export(module.exports, "fetchConfluenceSpaces", () => $b1fd0e044a377788$export$919c2c6ec09a9e2);
$parcel$export(module.exports, "FETCH_CONFLUENCE_SPACES_ERROR", () => $b1fd0e044a377788$export$9b2363ba0c628e02);
$parcel$export(module.exports, "fetchConfluenceSpacesError", () => $b1fd0e044a377788$export$356782d51ee2d59b);
$parcel$export(module.exports, "GENERATE_SPACE_KEY", () => $b1fd0e044a377788$export$ef3af75fc9a7bae5);
$parcel$export(module.exports, "generateSpaceKey", () => $b1fd0e044a377788$export$a7109cd91ae8e809);
$parcel$export(module.exports, "GET_PROJECT_SPACE_LINK", () => $b1fd0e044a377788$export$cbecd83851a98ad6);
$parcel$export(module.exports, "getProjectSpaceLink", () => $b1fd0e044a377788$export$1b6f4b19aebf4179);
$parcel$export(module.exports, "GET_PROJECT_SPACE_LINK_ERROR", () => $b1fd0e044a377788$export$b5274c19dade5a70);
$parcel$export(module.exports, "getProjectSpaceLinkError", () => $b1fd0e044a377788$export$5e3ded0c0b0d9c89);
$parcel$export(module.exports, "HIDE_CONNECT_SPACE_DIALOG", () => $b1fd0e044a377788$export$e28b20bc070fc43b);
$parcel$export(module.exports, "hideConnectSpaceDialog", () => $b1fd0e044a377788$export$71590f212f9d75e8);
$parcel$export(module.exports, "HIDE_CREATE_SPACE_DIALOG", () => $b1fd0e044a377788$export$180bd051e24ee787);
$parcel$export(module.exports, "NO_VALID_KEY", () => $b1fd0e044a377788$export$e8286506c58654e7);
$parcel$export(module.exports, "noValidKey", () => $b1fd0e044a377788$export$1f5ff8c210c74c43);
$parcel$export(module.exports, "NO_VALID_KEY_FAILURE", () => $b1fd0e044a377788$export$435625977ffffaa0);
$parcel$export(module.exports, "noValidKeyFailure", () => $b1fd0e044a377788$export$451f6f5389f13654);
$parcel$export(module.exports, "PUT_PROJECT_SPACE_LINK", () => $b1fd0e044a377788$export$e3d116cfcae27c34);
$parcel$export(module.exports, "putProjectSpaceLink", () => $b1fd0e044a377788$export$dfc1b065e2e5ad09);
$parcel$export(module.exports, "PUT_PROJECT_SPACE_LINK_ERROR", () => $b1fd0e044a377788$export$460b0974c0bd7b54);
$parcel$export(module.exports, "putProjectSpaceLinkError", () => $b1fd0e044a377788$export$bd0e95966c45b296);
$parcel$export(module.exports, "REDIRECT_TO_CONFLUENCE_CREATE_ERROR", () => $b1fd0e044a377788$export$13fb952efbb55e5e);
$parcel$export(module.exports, "SET_FIRST_SPACE_CREATED_FLAG", () => $b1fd0e044a377788$export$272c7ebed0cbae54);
$parcel$export(module.exports, "setFirstSpaceCreatedFlag", () => $b1fd0e044a377788$export$549bff0573523370);
$parcel$export(module.exports, "SET_SELECTED_SPACE", () => $b1fd0e044a377788$export$5bba470e3809ed4);
$parcel$export(module.exports, "setSelectedSpace", () => $b1fd0e044a377788$export$cfcf789129734d0c);
$parcel$export(module.exports, "SHOW_CONNECT_SPACE_DIALOG", () => $b1fd0e044a377788$export$ee02c3bec5d74835);
$parcel$export(module.exports, "showConnectSpaceDialog", () => $b1fd0e044a377788$export$2a60bfdeb4e71f1);
$parcel$export(module.exports, "SHOW_CREATE_SPACE_DIALOG", () => $b1fd0e044a377788$export$2aeaf697b0878e2b);
$parcel$export(module.exports, "showCreateSpaceDialog", () => $b1fd0e044a377788$export$6ac9be769bc6d43a);
$parcel$export(module.exports, "INVOKE_CROSS_FLOW", () => $b1fd0e044a377788$export$829393f05adb1a58);
$parcel$export(module.exports, "SHOW_XFLOW_DIALOG_ERROR", () => $b1fd0e044a377788$export$37b19eb01a9ffb47);
$parcel$export(module.exports, "showXflowDialogError", () => $b1fd0e044a377788$export$9619e8c6e7ff9f87);
$parcel$export(module.exports, "TOGGLE_SPACE_NAME_INVALID", () => $b1fd0e044a377788$export$d7025623a892f5e7);
$parcel$export(module.exports, "toggleSpaceNameInvalid", () => $b1fd0e044a377788$export$72e6f4914f4db320);
$parcel$export(module.exports, "UPDATE_CONNECTED_SPACE_BLUEPRINTS", () => $b1fd0e044a377788$export$35546514045d3ef6);
$parcel$export(module.exports, "updateConnectedSpaceBlueprints", () => $b1fd0e044a377788$export$868df370576ed7b9);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_SPACES", () => $b1fd0e044a377788$export$3add0fd96e0a0f94);
$parcel$export(module.exports, "updateConfluenceSpaces", () => $b1fd0e044a377788$export$af25752520107849);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_STATE", () => $b1fd0e044a377788$export$642f8c42c3174bb3);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_EDITION", () => $b1fd0e044a377788$export$4945c781e256866);
$parcel$export(module.exports, "UPDATE_JSW_EDITION", () => $b1fd0e044a377788$export$d249ebe59cef7fd0);
$parcel$export(module.exports, "updateConfluenceState", () => $b1fd0e044a377788$export$f0daa551fdf516de);
$parcel$export(module.exports, "updateConfluenceEdition", () => $b1fd0e044a377788$export$fcd065f821290c09);
$parcel$export(module.exports, "updateJswEdition", () => $b1fd0e044a377788$export$843be94842235022);
$parcel$export(module.exports, "UPDATE_PROJECT_SPACE_LINK", () => $b1fd0e044a377788$export$b5f26e81b011310);
$parcel$export(module.exports, "updateProjectSpaceLink", () => $b1fd0e044a377788$export$9d63c755cd3b59d4);
$parcel$export(module.exports, "UPDATE_SPACE_NAME", () => $b1fd0e044a377788$export$c774daa37662a6e2);
$parcel$export(module.exports, "updateSpaceName", () => $b1fd0e044a377788$export$f5c0413e2566c026);
$parcel$export(module.exports, "UPDATE_SUGGESTED_KEY", () => $b1fd0e044a377788$export$910d1d3b9b49d47f);
$parcel$export(module.exports, "updateSuggestedKey", () => $b1fd0e044a377788$export$5bf0de5eee5cf319);
$parcel$export(module.exports, "SUCCESSFULLY_CONNECTED_SPACE", () => $b1fd0e044a377788$export$56a6b0eafd2ee646);
$parcel$export(module.exports, "successfullyConnectedSpace", () => $b1fd0e044a377788$export$5fe667e6e7e6ce92);
$parcel$export(module.exports, "SHOW_ACTIVATION_ERROR_FLAG", () => $b1fd0e044a377788$export$c6f909e212a85e8);
$parcel$export(module.exports, "showActivationErrorFlag", () => $b1fd0e044a377788$export$aa7e0797d3fa2965);
$parcel$export(module.exports, "SHOW_ERROR", () => $b1fd0e044a377788$export$5973607600a0786d);
$parcel$export(module.exports, "showError", () => $b1fd0e044a377788$export$3879b24e8245693d);
$parcel$export(module.exports, "DISMISS_SUCCESS_FLAG", () => $b1fd0e044a377788$export$2dd037467821974b);
$parcel$export(module.exports, "dismissSuccessFlag", () => $b1fd0e044a377788$export$f6370a49e43e0576);
$parcel$export(module.exports, "DISMISS_ERROR", () => $b1fd0e044a377788$export$3cd97e75ca3b9296);
$parcel$export(module.exports, "dismissError", () => $b1fd0e044a377788$export$c1844e841b0106f7);
$parcel$export(module.exports, "DISMISS_ACTIVATION_ERROR_FLAG", () => $b1fd0e044a377788$export$960a68c7ad7aa3a);
$parcel$export(module.exports, "dismissActivationErrorFlag", () => $b1fd0e044a377788$export$d336837fff09d47f);
$parcel$export(module.exports, "SUCCESSFULLY_REQUESTED_ACCESS", () => $b1fd0e044a377788$export$cfc13953d69f0001);
$parcel$export(module.exports, "FETCH_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES", () => $b1fd0e044a377788$export$996348d031105c73);
$parcel$export(module.exports, "fetchConfluenceAccessRequestCapabilities", () => $b1fd0e044a377788$export$448a117797b4db5f);
$parcel$export(module.exports, "INLINE_JOIN_CONFLUENCE", () => $b1fd0e044a377788$export$75e62da1cc0402ef);
$parcel$export(module.exports, "inlineJoinConfluence", () => $b1fd0e044a377788$export$62909a668caf4055);
$parcel$export(module.exports, "INLINE_JOIN_FAILED", () => $b1fd0e044a377788$export$db3820748244cc8b);
$parcel$export(module.exports, "inlineJoinConfluenceFailed", () => $b1fd0e044a377788$export$15ba59499cf4c67);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES", () => $b1fd0e044a377788$export$18cedb2141f6d92b);
$parcel$export(module.exports, "updateConfluenceAccessRequestCapabilities", () => $b1fd0e044a377788$export$d9296536f93a8e55);
$parcel$export(module.exports, "FETCH_CONFLUENCE_COLLABORATORS", () => $b1fd0e044a377788$export$b354c67a4077ba9c);
$parcel$export(module.exports, "fetchConfluenceCollaborators", () => $b1fd0e044a377788$export$7a04b158659a6a5e);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_COLLABORATORS", () => $b1fd0e044a377788$export$868df1522dd01363);
$parcel$export(module.exports, "updateConfluenceCollaborators", () => $b1fd0e044a377788$export$1f606a1ee0a12a77);
$parcel$export(module.exports, "FETCH_CONNECTED_SPACE_OR_PAGE_TITLE", () => $b1fd0e044a377788$export$6a5d0396986b2002);
$parcel$export(module.exports, "fetchConnectedSpaceOrPageTitle", () => $b1fd0e044a377788$export$2682af34eb3aa1e3);
$parcel$export(module.exports, "FETCH_CONNECTED_SPACE", () => $b1fd0e044a377788$export$c044983cd2f9624c);
$parcel$export(module.exports, "fetchConnectedSpace", () => $b1fd0e044a377788$export$b18ea8549fbce2f);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_SPACE_CONNECTION_STATE", () => $b1fd0e044a377788$export$bcdcc308c5deb22f);
$parcel$export(module.exports, "updateConfluenceSpaceConnectionState", () => $b1fd0e044a377788$export$e5b6b4f53362d4fc);
$parcel$export(module.exports, "UPDATE_CONNECTED_SPACE_OR_PAGE_CONTENT", () => $b1fd0e044a377788$export$b4e21ab2a8049f3a);
$parcel$export(module.exports, "updateConnectedSpaceOrPageContent", () => $b1fd0e044a377788$export$721e32cdead77c18);
$parcel$export(module.exports, "FETCH_JIRA_PROJECT_PERMISSIONS", () => $b1fd0e044a377788$export$99a8dcf38de45a88);
$parcel$export(module.exports, "fetchJiraProjectPermissions", () => $b1fd0e044a377788$export$2a09832034358a97);
const $b1fd0e044a377788$export$975d476978f4be6d = 'CHANGE_SPACE_NAME';
const $b1fd0e044a377788$export$3e1566633c96b95 = (name)=>({
        type: $b1fd0e044a377788$export$975d476978f4be6d,
        name: name
    });
const $b1fd0e044a377788$export$e3e0aa9fa72a9172 = 'CHECK_PRODUCTS_LICENCE_STATE';
const $b1fd0e044a377788$export$758ea8f67c1b6038 = ()=>({
        type: $b1fd0e044a377788$export$e3e0aa9fa72a9172
    });
const $b1fd0e044a377788$export$498ddfccd74f6b2e = 'CHECK_CONFLUENCE_USER_PERMISSIONS';
const $b1fd0e044a377788$export$e645a900e228e518 = ()=>({
        type: $b1fd0e044a377788$export$498ddfccd74f6b2e
    });
const $b1fd0e044a377788$export$5ae85edd40fea59 = 'UPDATE_CONFLUENCE_USER_ACCESS';
const $b1fd0e044a377788$export$190a933252181349 = (userAccess)=>({
        type: $b1fd0e044a377788$export$5ae85edd40fea59,
        access: userAccess
    });
const $b1fd0e044a377788$export$98f58cdac80fc749 = 'CONNECT_CONFLUENCE_SPACE';
const $b1fd0e044a377788$export$30ea72c711e481ce = ()=>({
        type: $b1fd0e044a377788$export$98f58cdac80fc749
    });
const $b1fd0e044a377788$export$477de93d41065628 = 'FETCH_CONNECTED_SPACE_BLUEPRINTS';
const $b1fd0e044a377788$export$c9e2bdc7b72fcdd1 = ()=>({
        type: $b1fd0e044a377788$export$477de93d41065628
    });
const $b1fd0e044a377788$export$70014928e1a39ffa = 'CHECK_CONFLUENCE_ACCESS_WITH_RETRY';
const $b1fd0e044a377788$export$76137a25f6d06d6c = ()=>({
        type: $b1fd0e044a377788$export$70014928e1a39ffa
    });
const $b1fd0e044a377788$export$aa2e879d6392e0ba = 'RESET_CONNECTED_SPACE';
const $b1fd0e044a377788$export$89f1e56d63058051 = ()=>({
        type: $b1fd0e044a377788$export$aa2e879d6392e0ba
    });
const $b1fd0e044a377788$export$5ba9db9ab3024aed = 'FETCH_CONNECTED_SPACE_BLUEPRINTS_ERROR';
const $b1fd0e044a377788$export$ca0d39c192dc7e82 = ()=>({
        type: $b1fd0e044a377788$export$5ba9db9ab3024aed
    });
const $b1fd0e044a377788$export$d5ff56be054b9a75 = 'FETCH_CONFLUENCE_SPACES';
const $b1fd0e044a377788$export$919c2c6ec09a9e2 = ()=>({
        type: $b1fd0e044a377788$export$d5ff56be054b9a75
    });
const $b1fd0e044a377788$export$9b2363ba0c628e02 = 'FETCH_CONFLUENCE_SPACES_ERROR';
const $b1fd0e044a377788$export$356782d51ee2d59b = ()=>({
        type: $b1fd0e044a377788$export$9b2363ba0c628e02
    });
const $b1fd0e044a377788$export$ef3af75fc9a7bae5 = 'GENERATE_SPACE_KEY';
const $b1fd0e044a377788$export$a7109cd91ae8e809 = (name)=>({
        type: $b1fd0e044a377788$export$ef3af75fc9a7bae5,
        name: name
    });
const $b1fd0e044a377788$export$cbecd83851a98ad6 = 'GET_PROJECT_SPACE_LINK';
const $b1fd0e044a377788$export$1b6f4b19aebf4179 = (projectId)=>({
        type: $b1fd0e044a377788$export$cbecd83851a98ad6,
        projectId: projectId
    });
const $b1fd0e044a377788$export$b5274c19dade5a70 = 'GET_PROJECT_SPACE_LINK_ERROR';
const $b1fd0e044a377788$export$5e3ded0c0b0d9c89 = ()=>({
        type: $b1fd0e044a377788$export$b5274c19dade5a70
    });
const $b1fd0e044a377788$export$e28b20bc070fc43b = 'HIDE_CONNECT_SPACE_DIALOG';
const $b1fd0e044a377788$export$71590f212f9d75e8 = ()=>({
        type: $b1fd0e044a377788$export$e28b20bc070fc43b
    });
const $b1fd0e044a377788$export$180bd051e24ee787 = 'HIDE_CREATE_SPACE_DIALOG';
const $b1fd0e044a377788$export$d6d601929e7da41d = ()=>({
        type: $b1fd0e044a377788$export$180bd051e24ee787
    });
const $b1fd0e044a377788$export$e8286506c58654e7 = 'NO_VALID_KEY';
const $b1fd0e044a377788$export$1f5ff8c210c74c43 = ()=>({
        type: $b1fd0e044a377788$export$e8286506c58654e7
    });
const $b1fd0e044a377788$export$435625977ffffaa0 = 'NO_VALID_KEY_FAILURE';
const $b1fd0e044a377788$export$451f6f5389f13654 = ()=>({
        type: $b1fd0e044a377788$export$435625977ffffaa0
    });
const $b1fd0e044a377788$export$e3d116cfcae27c34 = 'PUT_PROJECT_SPACE_LINK';
const $b1fd0e044a377788$export$dfc1b065e2e5ad09 = ({ spaceId: spaceId, spaceKey: spaceKey, spaceUrl: spaceUrl, projectKey: projectKey, projectId: projectId, linkedPageId: linkedPageId, linkedPageTitle: linkedPageTitle, autoCreated: autoCreated, connectedSpaceId: connectedSpaceId, connectedPageId: connectedPageId })=>({
        type: $b1fd0e044a377788$export$e3d116cfcae27c34,
        spaceId: spaceId,
        spaceKey: spaceKey,
        spaceUrl: spaceUrl,
        projectKey: projectKey,
        projectId: projectId,
        linkedPageId: linkedPageId,
        linkedPageTitle: linkedPageTitle,
        autoCreated: autoCreated,
        connectedSpaceId: connectedSpaceId,
        connectedPageId: connectedPageId
    });
const $b1fd0e044a377788$export$460b0974c0bd7b54 = 'PUT_PROJECT_SPACE_LINK_ERROR';
const $b1fd0e044a377788$export$bd0e95966c45b296 = ()=>({
        type: $b1fd0e044a377788$export$460b0974c0bd7b54
    });
const $b1fd0e044a377788$export$13fb952efbb55e5e = 'REDIRECT_TO_CONFLUENCE_CREATE_ERROR';
const $b1fd0e044a377788$export$839bcd5570d94176 = ()=>({
        type: $b1fd0e044a377788$export$13fb952efbb55e5e
    });
const $b1fd0e044a377788$export$272c7ebed0cbae54 = 'SET_FIRST_SPACE_CREATED_FLAG';
const $b1fd0e044a377788$export$549bff0573523370 = ()=>({
        type: $b1fd0e044a377788$export$272c7ebed0cbae54
    });
const $b1fd0e044a377788$export$5bba470e3809ed4 = 'SET_SELECTED_SPACE';
const $b1fd0e044a377788$export$cfcf789129734d0c = (payload)=>({
        type: $b1fd0e044a377788$export$5bba470e3809ed4,
        payload: payload
    });
const $b1fd0e044a377788$export$ee02c3bec5d74835 = 'SHOW_CONNECT_SPACE_DIALOG';
const $b1fd0e044a377788$export$2a60bfdeb4e71f1 = (disconnectedTemplatesClick = false)=>({
        type: $b1fd0e044a377788$export$ee02c3bec5d74835,
        disconnectedTemplatesClick: disconnectedTemplatesClick
    });
const $b1fd0e044a377788$export$2aeaf697b0878e2b = 'SHOW_CREATE_SPACE_DIALOG';
const $b1fd0e044a377788$export$6ac9be769bc6d43a = ()=>({
        type: $b1fd0e044a377788$export$2aeaf697b0878e2b
    });
const $b1fd0e044a377788$export$829393f05adb1a58 = 'INVOKE_CROSS_FLOW';
const $b1fd0e044a377788$export$3852642f4bf51096 = (contextInfo)=>({
        type: $b1fd0e044a377788$export$829393f05adb1a58,
        contextInfo: contextInfo
    });
const $b1fd0e044a377788$export$37b19eb01a9ffb47 = 'SHOW_XFLOW_DIALOG_ERROR';
const $b1fd0e044a377788$export$9619e8c6e7ff9f87 = ()=>({
        type: $b1fd0e044a377788$export$37b19eb01a9ffb47
    });
const $b1fd0e044a377788$export$d7025623a892f5e7 = 'TOGGLE_SPACE_NAME_INVALID';
const $b1fd0e044a377788$export$72e6f4914f4db320 = (userEnteredSpaceNameInvalid)=>({
        type: $b1fd0e044a377788$export$d7025623a892f5e7,
        userEnteredSpaceNameInvalid: userEnteredSpaceNameInvalid
    });
const $b1fd0e044a377788$export$35546514045d3ef6 = 'UPDATE_CONNECTED_SPACE_BLUEPRINTS';
const $b1fd0e044a377788$export$868df370576ed7b9 = (blueprints)=>({
        type: $b1fd0e044a377788$export$35546514045d3ef6,
        payload: blueprints
    });
const $b1fd0e044a377788$export$3add0fd96e0a0f94 = 'UPDATE_CONFLUENCE_SPACES';
const $b1fd0e044a377788$export$af25752520107849 = (confluenceSpaces)=>({
        type: $b1fd0e044a377788$export$3add0fd96e0a0f94,
        payload: confluenceSpaces
    });
const $b1fd0e044a377788$export$642f8c42c3174bb3 = 'UPDATE_CONFLUENCE_STATE';
const $b1fd0e044a377788$export$4945c781e256866 = 'UPDATE_CONFLUENCE_EDITION';
const $b1fd0e044a377788$export$d249ebe59cef7fd0 = 'UPDATE_JSW_EDITION';
const $b1fd0e044a377788$export$f0daa551fdf516de = (confluenceState)=>({
        type: $b1fd0e044a377788$export$642f8c42c3174bb3,
        payload: confluenceState
    });
const $b1fd0e044a377788$export$fcd065f821290c09 = (confluenceEdition)=>({
        type: $b1fd0e044a377788$export$4945c781e256866,
        payload: confluenceEdition
    });
const $b1fd0e044a377788$export$843be94842235022 = (jswEdition)=>({
        type: $b1fd0e044a377788$export$d249ebe59cef7fd0,
        payload: jswEdition
    });
const $b1fd0e044a377788$export$b5f26e81b011310 = 'UPDATE_PROJECT_SPACE_LINK';
const $b1fd0e044a377788$export$9d63c755cd3b59d4 = (spaceKey, linkedPageId)=>({
        type: $b1fd0e044a377788$export$b5f26e81b011310,
        spaceKey: spaceKey,
        linkedPageId: linkedPageId
    });
const $b1fd0e044a377788$export$c774daa37662a6e2 = 'UPDATE_SPACE_NAME';
const $b1fd0e044a377788$export$f5c0413e2566c026 = (userEnteredSpaceName)=>({
        type: $b1fd0e044a377788$export$c774daa37662a6e2,
        userEnteredSpaceName: userEnteredSpaceName
    });
const $b1fd0e044a377788$export$910d1d3b9b49d47f = 'UPDATE_SUGGESTED_KEY';
const $b1fd0e044a377788$export$5bf0de5eee5cf319 = (key)=>({
        type: $b1fd0e044a377788$export$910d1d3b9b49d47f,
        key: key
    });
const $b1fd0e044a377788$export$56a6b0eafd2ee646 = 'SUCCESSFULLY_CONNECTED_SPACE';
const $b1fd0e044a377788$export$5fe667e6e7e6ce92 = (connectedSpaceName, isConnectedToPage)=>({
        type: $b1fd0e044a377788$export$56a6b0eafd2ee646,
        connectedSpaceName: connectedSpaceName,
        isConnectedToPage: isConnectedToPage
    });
const $b1fd0e044a377788$export$c6f909e212a85e8 = 'SHOW_ACTIVATION_ERROR_FLAG';
const $b1fd0e044a377788$export$aa7e0797d3fa2965 = ()=>({
        type: $b1fd0e044a377788$export$c6f909e212a85e8
    });
const $b1fd0e044a377788$export$5973607600a0786d = 'SHOW_ERROR';
const $b1fd0e044a377788$export$3879b24e8245693d = ()=>({
        type: $b1fd0e044a377788$export$5973607600a0786d
    });
const $b1fd0e044a377788$export$2dd037467821974b = 'DISMISS_SUCCESS_FLAG';
const $b1fd0e044a377788$export$f6370a49e43e0576 = ()=>({
        type: $b1fd0e044a377788$export$2dd037467821974b
    });
const $b1fd0e044a377788$export$3cd97e75ca3b9296 = 'DISMISS_ERROR';
const $b1fd0e044a377788$export$c1844e841b0106f7 = ()=>({
        type: $b1fd0e044a377788$export$3cd97e75ca3b9296
    });
const $b1fd0e044a377788$export$960a68c7ad7aa3a = 'DISMISS_ACTIVATION_ERROR_FLAG';
const $b1fd0e044a377788$export$d336837fff09d47f = ()=>({
        type: $b1fd0e044a377788$export$960a68c7ad7aa3a
    });
const $b1fd0e044a377788$export$cfc13953d69f0001 = 'SUCCESSFULLY_REQUESTED_ACCESS';
const $b1fd0e044a377788$export$e1dc4a56133b3011 = (payload)=>({
        type: $b1fd0e044a377788$export$cfc13953d69f0001,
        payload: payload
    });
const $b1fd0e044a377788$export$996348d031105c73 = 'FETCH_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES';
const $b1fd0e044a377788$export$448a117797b4db5f = ()=>({
        type: $b1fd0e044a377788$export$996348d031105c73
    });
const $b1fd0e044a377788$export$75e62da1cc0402ef = 'INLINE_JOIN_CONFLUENCE';
const $b1fd0e044a377788$export$62909a668caf4055 = ()=>({
        type: $b1fd0e044a377788$export$75e62da1cc0402ef
    });
const $b1fd0e044a377788$export$db3820748244cc8b = 'INLINE_JOIN_FAILED';
const $b1fd0e044a377788$export$15ba59499cf4c67 = ()=>({
        type: $b1fd0e044a377788$export$db3820748244cc8b
    });
const $b1fd0e044a377788$export$18cedb2141f6d92b = 'UPDATE_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES';
const $b1fd0e044a377788$export$d9296536f93a8e55 = (capability)=>({
        type: $b1fd0e044a377788$export$18cedb2141f6d92b,
        capability: capability
    });
const $b1fd0e044a377788$export$b354c67a4077ba9c = 'FETCH_CONFLUENCE_COLLABORATORS';
const $b1fd0e044a377788$export$7a04b158659a6a5e = ()=>({
        type: $b1fd0e044a377788$export$b354c67a4077ba9c
    });
const $b1fd0e044a377788$export$868df1522dd01363 = 'UPDATE_CONFLUENCE_COLLABORATORS';
const $b1fd0e044a377788$export$1f606a1ee0a12a77 = (users)=>({
        type: $b1fd0e044a377788$export$868df1522dd01363,
        users: users
    });
const $b1fd0e044a377788$export$6a5d0396986b2002 = 'FETCH_CONNECTED_SPACE_OR_PAGE_TITLE';
const $b1fd0e044a377788$export$2682af34eb3aa1e3 = ()=>({
        type: $b1fd0e044a377788$export$6a5d0396986b2002
    });
const $b1fd0e044a377788$export$c044983cd2f9624c = 'FETCH_CONNECTED_SPACE';
const $b1fd0e044a377788$export$b18ea8549fbce2f = (spaceKey)=>({
        type: $b1fd0e044a377788$export$c044983cd2f9624c,
        spaceKey: spaceKey
    });
const $b1fd0e044a377788$export$bcdcc308c5deb22f = 'UPDATE_CONFLUENCE_SPACE_CONNECTION_STATE';
const $b1fd0e044a377788$export$e5b6b4f53362d4fc = (connectionState)=>({
        type: $b1fd0e044a377788$export$bcdcc308c5deb22f,
        connectionState: connectionState
    });
const $b1fd0e044a377788$export$b4e21ab2a8049f3a = 'UPDATE_CONNECTED_SPACE_OR_PAGE_CONTENT';
const $b1fd0e044a377788$export$721e32cdead77c18 = ({ spaceId: spaceId, title: title, isConnectedToPage: isConnectedToPage, url: url, projectSpacePageTitleHasBeenFetched: projectSpacePageTitleHasBeenFetched, iconUrl: iconUrl, pageId: pageId })=>({
        spaceId: spaceId,
        type: $b1fd0e044a377788$export$b4e21ab2a8049f3a,
        title: title,
        url: url,
        isConnectedToPage: isConnectedToPage,
        projectSpacePageTitleHasBeenFetched: projectSpacePageTitleHasBeenFetched,
        iconUrl: iconUrl,
        pageId: pageId
    });
const $b1fd0e044a377788$export$99a8dcf38de45a88 = 'FETCH_JIRA_PROJECT_PERMISSIONS';
const $b1fd0e044a377788$export$2a09832034358a97 = ()=>({
        type: $b1fd0e044a377788$export$99a8dcf38de45a88
    });

});

parcelRegister("lpJ9O", function(module, exports) {

$parcel$export(module.exports, "INITIALIZE_VIEW", () => $50d121fd1421e984$export$6ff5d8ee39b8d7c7);
$parcel$export(module.exports, "initializeView", () => $50d121fd1421e984$export$28b89ff8ea962a50);
const $50d121fd1421e984$export$6ff5d8ee39b8d7c7 = 'INITIALIZE_VIEW';
const $50d121fd1421e984$export$28b89ff8ea962a50 = ()=>({
        type: $50d121fd1421e984$export$6ff5d8ee39b8d7c7
    });

});

parcelRegister("hMy8N", function(module, exports) {

$parcel$export(module.exports, "getCloudId", () => $699588c238b86b45$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getAccountId", () => $699588c238b86b45$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "getOrigin", () => $699588c238b86b45$export$5a759dc7a1cfb72a);
$parcel$export(module.exports, "getConfluenceState", () => $699588c238b86b45$export$34d7071b87580de5);
$parcel$export(module.exports, "getSuggestedKey", () => $699588c238b86b45$export$a9b8464ee6c5051e);

var $kHo9c = parcelRequire("kHo9c");
const $699588c238b86b45$export$31553aaa555c1514 = (state)=>state.context;
const $699588c238b86b45$export$f654b28f82155665 = (state)=>state.context.baseUrl;
const $699588c238b86b45$export$180605366c04f0cd = (state)=>state.context.locale;
const $699588c238b86b45$export$fc970ed23da99565 = (state)=>state.context.isAdmin;
const $699588c238b86b45$export$fdd2c0ba94025c3c = (state)=>state.context.cloudId;
const $699588c238b86b45$export$c1e0336bde96e2dc = (state)=>state.context.accountId;
const $699588c238b86b45$export$5a759dc7a1cfb72a = (state)=>state?.context?.origin || null;
const $699588c238b86b45$export$34d7071b87580de5 = (state)=>state.context.confluenceState;
const $699588c238b86b45$export$a9b8464ee6c5051e = (state)=>state.context.suggestedKey;
const $699588c238b86b45$export$a22e881e6bf2a030 = (state)=>$699588c238b86b45$export$34d7071b87580de5(state) === (0, $kHo9c.CONFLUENCE_ACTIVE);
const $699588c238b86b45$export$57570b1603cf6adb = (state)=>state.context.environment;
const $699588c238b86b45$export$e3b2eefe2a608e05 = (state)=>state.context.licenseInformation;

});
parcelRegister("kHo9c", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_LOADING", () => $5d5e912988a48b83$export$33e529db1eae9509);
$parcel$export(module.exports, "CONFLUENCE_INACTIVE", () => $5d5e912988a48b83$export$d678d0da8cb40d2d);
$parcel$export(module.exports, "CONFLUENCE_DEACTIVATED", () => $5d5e912988a48b83$export$9ef8869caad736a1);
$parcel$export(module.exports, "CONFLUENCE_ACTIVE", () => $5d5e912988a48b83$export$4542e1f28f48047);
$parcel$export(module.exports, "CONFLUENCE_ACTIVATING", () => $5d5e912988a48b83$export$701136fece9e2d4e);
$parcel$export(module.exports, "CONFLUENCE_EXPIRED", () => $5d5e912988a48b83$export$110475fcfacac90b);
$parcel$export(module.exports, "CONFLUENCE_ERROR", () => $5d5e912988a48b83$export$ce51dd384a6f10ed);
$parcel$export(module.exports, "ProductKeys", () => $5d5e912988a48b83$export$ef2c0ffddaaaf76c);
const $5d5e912988a48b83$export$33e529db1eae9509 = 'CONFLUENCE_LOADING';
const $5d5e912988a48b83$export$d678d0da8cb40d2d = 'CONFLUENCE_INACTIVE';
const $5d5e912988a48b83$export$9ef8869caad736a1 = 'CONFLUENCE_DEACTIVATED';
const $5d5e912988a48b83$export$4542e1f28f48047 = 'CONFLUENCE_ACTIVE';
const $5d5e912988a48b83$export$701136fece9e2d4e = 'CONFLUENCE_ACTIVATING';
const $5d5e912988a48b83$export$110475fcfacac90b = 'CONFLUENCE_EXPIRED';
const $5d5e912988a48b83$export$ce51dd384a6f10ed = 'CONFLUENCE_ERROR';
const $5d5e912988a48b83$export$e69af2c4378638a2 = 'free';
const $5d5e912988a48b83$export$7bc7dd5faba7ad6b = 'standard';
const $5d5e912988a48b83$export$3fd0bbb8c68dc4c7 = 'premium';
const $5d5e912988a48b83$export$88ff5aec29d74e90 = 'enterprise';
var $5d5e912988a48b83$export$869044b313ebefcc;
(function(ProductLicensingState) {
    ProductLicensingState["ACTIVE"] = "ACTIVE";
    ProductLicensingState["ACTIVATING"] = "ACTIVATING";
    ProductLicensingState["INACTIVE"] = "INACTIVE";
    ProductLicensingState["DEACTIVATED"] = "DEACTIVATED";
})($5d5e912988a48b83$export$869044b313ebefcc || ($5d5e912988a48b83$export$869044b313ebefcc = {}));
var $5d5e912988a48b83$export$ef2c0ffddaaaf76c;
(function(ProductKeys) {
    ProductKeys["CONFLUENCE"] = "confluence.ondemand";
    ProductKeys["JIRA_CORE"] = "jira-core.ondemand";
    ProductKeys["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKeys["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKeys["TRELLO"] = "trello";
    ProductKeys["OPSGENIE"] = "opsgenie";
    ProductKeys["BITBUCKET"] = "bitbucket.ondemand";
    ProductKeys["STATUSPAGE"] = "statuspage";
    ProductKeys["TOWNSQUARE"] = "townsquare";
})($5d5e912988a48b83$export$ef2c0ffddaaaf76c || ($5d5e912988a48b83$export$ef2c0ffddaaaf76c = {}));

});


parcelRegister("9yekW", function(module, exports) {

$parcel$export(module.exports, "isSpaceHomePageNull", () => $a71888001baad3ae$export$646f21b73f12650);
$parcel$export(module.exports, "isPageHomePageNull", () => $a71888001baad3ae$export$3a390e14f9c6d2ae);
$parcel$export(module.exports, "getConfluenceLicenseStatus", () => $a71888001baad3ae$export$18a481a6de61c404);
$parcel$export(module.exports, "getIsPostExpand", () => $a71888001baad3ae$export$35f86e486ebae26b);

var $hXy49 = parcelRequire("hXy49");


var $3NcOY = parcelRequire("3NcOY");

var $hMy8N = parcelRequire("hMy8N");

var $kHo9c = parcelRequire("kHo9c");

const $a71888001baad3ae$export$67214a67db0792b3 = (state)=>state.context.confluenceState === (0, $kHo9c.CONFLUENCE_INACTIVE) || state.context.confluenceState === (0, $kHo9c.CONFLUENCE_DEACTIVATED);
const $a71888001baad3ae$export$1406596cde1d72d8 = (state)=>state.context.confluenceState === (0, $kHo9c.CONFLUENCE_ACTIVATING);
const $a71888001baad3ae$export$14f7f59d0be6078b = (state)=>state.context.confluenceState === (0, $kHo9c.CONFLUENCE_ACTIVE) && state.confluence.connectedSpace.connectionState === (0, $d01310c7d13ad40a$export$4c83162cd5864fb8);
const $a71888001baad3ae$export$646f21b73f12650 = (state)=>state.context.confluenceState === (0, $kHo9c.CONFLUENCE_ACTIVE) && state.confluence.connectedSpace.connectionState === (0, $d01310c7d13ad40a$export$1a9cf3a686991f62) && state.confluence.connectedSpace.projectSpacePageTitleHasBeenFetched && state.confluence.connectedSpace.projectSpacePageTitle === null && state.confluence.connectedSpace.projectPageLinkedId === null;
const $a71888001baad3ae$export$3a390e14f9c6d2ae = (state)=>state.context.confluenceState === (0, $kHo9c.CONFLUENCE_ACTIVE) && state.confluence.connectedSpace.connectionState === (0, $d01310c7d13ad40a$export$1a9cf3a686991f62) && state.confluence.connectedSpace.projectSpacePageTitleHasBeenFetched && state.confluence.connectedSpace.projectSpacePageTitle === null && state.confluence.connectedSpace.projectPageLinkedId !== null;
const $a71888001baad3ae$export$c67fbce9d0b9ccb6 = (state)=>state.confluence.connectedSpace.connectionState === (0, $d01310c7d13ad40a$export$1a9cf3a686991f62) && state.context.confluenceState === (0, $kHo9c.CONFLUENCE_ACTIVE);
const $a71888001baad3ae$export$3ed197ee58985de5 = (state)=>state.context.confluenceState === (0, $kHo9c.CONFLUENCE_ERROR) || state.context.confluenceState === (0, $kHo9c.CONFLUENCE_EXPIRED);
const $a71888001baad3ae$export$f153181262b16ee6 = (state)=>state.confluence.connectedSpace.connectionState === (0, $d01310c7d13ad40a$export$103bedf43ba882db);
const $a71888001baad3ae$export$18a481a6de61c404 = (state)=>{
    const activationStatus = (0, $hXy49.getActivationStatus)(state);
    if (activationStatus === 'activating') return 0, $eda5adb3daefc3fa$export$ed9dbaba8445f424;
    if ($a71888001baad3ae$export$67214a67db0792b3(state)) return 0, $eda5adb3daefc3fa$export$beb27109f0387267;
    const userHasConfluenceAccess = (0, $3NcOY.doesUserHaveConfluenceAccess)(state);
    if (userHasConfluenceAccess === undefined) // until we know whether a user has access to confluence, don't try to render anything
    return 0, $eda5adb3daefc3fa$export$bde25b564fc94248;
    else if (userHasConfluenceAccess === false) return 0, $eda5adb3daefc3fa$export$52022723d6fe5666;
    if ($a71888001baad3ae$export$1406596cde1d72d8(state)) return 0, $eda5adb3daefc3fa$export$22ad4d38ecffca72;
    if ($a71888001baad3ae$export$14f7f59d0be6078b(state)) return 0, $eda5adb3daefc3fa$export$e74e627186613bef;
    if ($a71888001baad3ae$export$646f21b73f12650(state)) return 0, $eda5adb3daefc3fa$export$f603e10769c22ef6;
    if ($a71888001baad3ae$export$3a390e14f9c6d2ae(state)) return 0, $eda5adb3daefc3fa$export$396960dbbf8fe6e1;
    if ($a71888001baad3ae$export$c67fbce9d0b9ccb6(state)) return 0, $eda5adb3daefc3fa$export$2f82131be5023f37;
    if ($a71888001baad3ae$export$3ed197ee58985de5(state)) return 0, $eda5adb3daefc3fa$export$65d0a606bcce00e6;
    if ($a71888001baad3ae$export$f153181262b16ee6(state)) return 0, $eda5adb3daefc3fa$export$98cc058279f6e82f;
    return 0, $eda5adb3daefc3fa$export$5a0e72a8258542bd;
};
const $a71888001baad3ae$export$7d65532d8ecf8068 = (state)=>state.ui;
const $a71888001baad3ae$export$35f86e486ebae26b = (state, hasConfluence)=>{
    // if confluence state gives us a clear answer, use that
    switch((0, $hMy8N.getConfluenceState)(state)){
        case 0, $kHo9c.CONFLUENCE_ACTIVE:
        case 0, $kHo9c.CONFLUENCE_ACTIVATING:
            return true;
        case 0, $kHo9c.CONFLUENCE_DEACTIVATED:
        case 0, $kHo9c.CONFLUENCE_EXPIRED:
        case 0, $kHo9c.CONFLUENCE_INACTIVE:
            return false;
        default:
            // otherwise (state = loading or error), rely on the supplied prop from Jira
            return hasConfluence;
    }
};

});
parcelRegister("hXy49", function(module, exports) {

$parcel$export(module.exports, "getActivationStatus", () => $bf651045ad1f460f$export$f83700fde4ece7e8);
$parcel$export(module.exports, "getActivationMethod", () => $bf651045ad1f460f$export$47a02b64ca588fb8);
$parcel$export(module.exports, "isActivationMethodDetermined", () => $bf651045ad1f460f$export$bbb567931044e99d);
$parcel$export(module.exports, "activationStatusRetryCount", () => $bf651045ad1f460f$export$f3454041f580301a);
$parcel$export(module.exports, "getUserInitiatedActivation", () => $bf651045ad1f460f$export$9bab1e2e467860a);
$parcel$export(module.exports, "isConfluenceActivationCompleteForPreselectedTemplate", () => $bf651045ad1f460f$export$b7cdb7448850d3b5);

var $4aXoz = parcelRequire("4aXoz");

var $elvqY = parcelRequire("elvqY");

const $bf651045ad1f460f$export$87e04069ced1cebb = (state)=>state.activation;
const $bf651045ad1f460f$export$f83700fde4ece7e8 = (state)=>$bf651045ad1f460f$export$87e04069ced1cebb(state).status;
const $bf651045ad1f460f$export$47a02b64ca588fb8 = (state)=>{
    switch($bf651045ad1f460f$export$f83700fde4ece7e8(state)){
        case 'activating':
        case 'allowed':
            return 'integrated';
        case 'not-started':
            return 'loading';
        case 'completed':
        case 'error':
        case 'not-allowed':
        default:
            return 'modal';
    }
};
const $bf651045ad1f460f$export$bbb567931044e99d = (state)=>$bf651045ad1f460f$export$47a02b64ca588fb8(state) !== 'loading';
const $bf651045ad1f460f$export$f3454041f580301a = (state)=>$bf651045ad1f460f$export$87e04069ced1cebb(state).retryCount;
const $bf651045ad1f460f$export$9bab1e2e467860a = (state)=>state.activation.userInitiated;
const $bf651045ad1f460f$export$b7cdb7448850d3b5 = (state)=>{
    const status = $bf651045ad1f460f$export$f83700fde4ece7e8(state);
    const userInitiated = $bf651045ad1f460f$export$9bab1e2e467860a(state);
    const spaceKey = (0, $4aXoz.getProjectSpaceKey)(state);
    const templatesToShow = (0, $elvqY.getTemplatesToShow)(state);
    return status === 'completed' && userInitiated && spaceKey !== null && templatesToShow === (0, $35e37a96dfcc0d6b$export$3cbf6ffeca115be3);
};

});
parcelRegister("4aXoz", function(module, exports) {

$parcel$export(module.exports, "getConnectedSpace", () => $e206d1f0320f46ff$export$ac45ebe2b54867fe);
$parcel$export(module.exports, "getBlueprintsState", () => $e206d1f0320f46ff$export$4c6a4429feb04f4f);
$parcel$export(module.exports, "getBlueprints", () => $e206d1f0320f46ff$export$1dca7dd1d5604f2c);
$parcel$export(module.exports, "getConnectionState", () => $e206d1f0320f46ff$export$93a0230e8a62bcf5);
$parcel$export(module.exports, "getProjectSpaceKey", () => $e206d1f0320f46ff$export$31514e1d1dc386f7);
$parcel$export(module.exports, "getConnectedSpaceOrPageTitle", () => $e206d1f0320f46ff$export$a76f36600fd6d921);
$parcel$export(module.exports, "getConnectedSpaceOrPageUrl", () => $e206d1f0320f46ff$export$979c567300794ce3);
$parcel$export(module.exports, "getProjectPageLinkedId", () => $e206d1f0320f46ff$export$cf793c89a0c16d51);
$parcel$export(module.exports, "getIsConnectedToPage", () => $e206d1f0320f46ff$export$8062d4f2391d5856);
$parcel$export(module.exports, "getProjectSpaceIcon", () => $e206d1f0320f46ff$export$853da650555a02bc);
$parcel$export(module.exports, "getProjectSpaceId", () => $e206d1f0320f46ff$export$cbf857d98845c8ab);
$parcel$export(module.exports, "getProjectSpacePageTitleHasBeenFetched", () => $e206d1f0320f46ff$export$486075bda46e01fa);
$parcel$export(module.exports, "isSpaceConnected", () => $e206d1f0320f46ff$export$ed44960edb45ecd);
$parcel$export(module.exports, "getConfluenceEdition", () => $e206d1f0320f46ff$export$777a279710b4717f);
$parcel$export(module.exports, "getJswEdition", () => $e206d1f0320f46ff$export$3b594b2bb25495df);

var $elvqY = parcelRequire("elvqY");


const $e206d1f0320f46ff$export$ac45ebe2b54867fe = (state)=>state.confluence.connectedSpace;
const $e206d1f0320f46ff$export$4c6a4429feb04f4f = (state)=>state.confluence.connectedSpace.blueprintsState;
const $e206d1f0320f46ff$export$1dca7dd1d5604f2c = (state)=>(0, $elvqY.getTemplatesToShow)(state) === (0, $35e37a96dfcc0d6b$export$3cbf6ffeca115be3) ? state.confluence.connectedSpace.blueprints || (0, $elvqY.getDefaultBlueprints)(state) : (0, $elvqY.getDefaultBlueprints)(state);
const $e206d1f0320f46ff$export$93a0230e8a62bcf5 = (state)=>state.confluence.connectedSpace.connectionState;
const $e206d1f0320f46ff$export$31514e1d1dc386f7 = (state)=>state.confluence.connectedSpace.projectSpaceKey;
const $e206d1f0320f46ff$export$a76f36600fd6d921 = (state)=>state.confluence.connectedSpace.projectSpacePageTitle;
const $e206d1f0320f46ff$export$979c567300794ce3 = (state)=>state.confluence.connectedSpace.projectSpacePageUrl;
const $e206d1f0320f46ff$export$cf793c89a0c16d51 = (state)=>state.confluence.connectedSpace.projectPageLinkedId;
const $e206d1f0320f46ff$export$8062d4f2391d5856 = (state)=>state.confluence.connectedSpace.projectIsConnectedToPage;
const $e206d1f0320f46ff$export$853da650555a02bc = (state)=>state.confluence.connectedSpace.projectSpaceIcon;
const $e206d1f0320f46ff$export$cbf857d98845c8ab = (state)=>state.confluence.connectedSpace.projectSpaceId;
const $e206d1f0320f46ff$export$486075bda46e01fa = (state)=>state.confluence.connectedSpace.projectSpacePageTitleHasBeenFetched;
const $e206d1f0320f46ff$export$ed44960edb45ecd = (state)=>$e206d1f0320f46ff$export$93a0230e8a62bcf5(state) === (0, $d01310c7d13ad40a$export$1a9cf3a686991f62);
const $e206d1f0320f46ff$export$777a279710b4717f = (state)=>state.context.confluenceEdition;
const $e206d1f0320f46ff$export$3b594b2bb25495df = (state)=>state.context.jswEdition;

});
parcelRegister("elvqY", function(module, exports) {

$parcel$export(module.exports, "getDefaultBlueprints", () => $64079bde3399aaf4$export$db52c73ad41e40f7);
$parcel$export(module.exports, "getTemplatesToShow", () => $64079bde3399aaf4$export$d6086b2ac208694f);
$parcel$export(module.exports, "areTemplatesEnabled", () => $64079bde3399aaf4$export$152293483cf81db3);


var $kHo9c = parcelRequire("kHo9c");


var $9yekW = parcelRequire("9yekW");

const $64079bde3399aaf4$var$forceTemplatesDisabled = (state)=>(0, $9yekW.getConfluenceLicenseStatus)(state) === (0, $eda5adb3daefc3fa$export$52022723d6fe5666);
const $64079bde3399aaf4$export$db52c73ad41e40f7 = (state)=>state.ui.blueprints.defaultBlueprints;
const $64079bde3399aaf4$export$d6086b2ac208694f = (state)=>{
    if (state.context.confluenceState === (0, $kHo9c.CONFLUENCE_LOADING) || state.confluence.connectedSpace.connectionState === (0, $d01310c7d13ad40a$export$26d55645375ca9a) || state.confluence.connectedSpace.blueprintsState === (0, $d01310c7d13ad40a$export$26d55645375ca9a)) return 0, $35e37a96dfcc0d6b$export$2050e0d4d0f39e8a;
    if (state.confluence.connectedSpace.blueprintsState === (0, $d01310c7d13ad40a$export$c6813a8d51f77eaf)) return 0, $35e37a96dfcc0d6b$export$3cbf6ffeca115be3;
    return 0, $35e37a96dfcc0d6b$export$2050e0d4d0f39e8a;
};
const $64079bde3399aaf4$export$152293483cf81db3 = (state)=>state.context.confluenceState === (0, $kHo9c.CONFLUENCE_INACTIVE) || state.context.confluenceState === (0, $kHo9c.CONFLUENCE_DEACTIVATED) || state.confluence.connectedSpace.blueprintsState === (0, $d01310c7d13ad40a$export$c6813a8d51f77eaf) || state.context.confluenceState === (0, $kHo9c.CONFLUENCE_ACTIVE) && state.confluence.connectedSpace.connectionState === (0, $d01310c7d13ad40a$export$4c83162cd5864fb8) && !$64079bde3399aaf4$var$forceTemplatesDisabled;

});
const $d01310c7d13ad40a$export$c6813a8d51f77eaf = 'OK';
const $d01310c7d13ad40a$export$26d55645375ca9a = 'LOADING';
const $d01310c7d13ad40a$export$a3269a3914b007e3 = 'FORBIDDEN';
const $d01310c7d13ad40a$export$1cc76b53f23597de = 'DELETED';
const $d01310c7d13ad40a$export$103bedf43ba882db = 'ERROR';
const $d01310c7d13ad40a$export$1a9cf3a686991f62 = 'CONNECTED';
const $d01310c7d13ad40a$export$4c83162cd5864fb8 = 'NOT_CONNECTED';
const $d01310c7d13ad40a$export$78244dbb77cfa6b6 = 'UNKNOWN';

const $35e37a96dfcc0d6b$export$3cbf6ffeca115be3 = 'TEMPLATES_REAL_LIST';
const $35e37a96dfcc0d6b$export$2050e0d4d0f39e8a = 'TEMPLATES_DEFAULT_LIST';

const $eda5adb3daefc3fa$export$5a0e72a8258542bd = 'CONFTREE_PLACEHOLDER';
const $eda5adb3daefc3fa$export$beb27109f0387267 = 'CONFTREE_CROSS_SELL';
const $eda5adb3daefc3fa$export$22ad4d38ecffca72 = 'CONFTREE_CONFLUENCE_ACTIVATING';
const $eda5adb3daefc3fa$export$e74e627186613bef = 'CONFTREE_CONNECT_SPACE';
const $eda5adb3daefc3fa$export$2f82131be5023f37 = 'CONFTREE_DISPLAY_PAGETREE';
const $eda5adb3daefc3fa$export$65d0a606bcce00e6 = 'CONFTREE_ERROR';
const $eda5adb3daefc3fa$export$52022723d6fe5666 = 'CONFTREE_NO_ACCESS_TEASER';
const $eda5adb3daefc3fa$export$bde25b564fc94248 = 'CONFTREE_ACCESS_LOADING';
const $eda5adb3daefc3fa$export$f603e10769c22ef6 = 'CONFTREE_SPACE_NOT_FOUND';
const $eda5adb3daefc3fa$export$396960dbbf8fe6e1 = 'CONFTREE_PAGE_NOT_FOUND';
const $eda5adb3daefc3fa$export$98cc058279f6e82f = 'CONFLUENCE_CONNECTION_BROKEN';
const $eda5adb3daefc3fa$export$ed9dbaba8445f424 = 'CONFTREE_CONFLUENCE_ACTIVATING_ONDEMAND';




parcelRegister("3NcOY", function(module, exports) {

$parcel$export(module.exports, "doesUserHaveConfluenceAccess", () => $b66b9c88caff5844$export$6206363f18b5406c);

const $b66b9c88caff5844$export$6206363f18b5406c = (state)=>state.confluence.user.access !== (0, $dfecdf57a1227fce$export$26d55645375ca9a) && state.confluence.user.access !== (0, $dfecdf57a1227fce$export$78244dbb77cfa6b6) ? state.confluence.user.access !== (0, $dfecdf57a1227fce$export$a3269a3914b007e3) : undefined;

});
const $dfecdf57a1227fce$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $dfecdf57a1227fce$export$26d55645375ca9a = 'LOADING';
const $dfecdf57a1227fce$export$c6813a8d51f77eaf = 'OK';
const $dfecdf57a1227fce$export$a3269a3914b007e3 = 'FORBIDDEN';



parcelRegister("fuxC8", function(module, exports) {

$parcel$export(module.exports, "default", () => $19fdc2a97b917a10$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $dJJDt = parcelRequire("dJJDt");

var $8lssp = parcelRequire("8lssp");

var $9AQpH = parcelRequire("9AQpH");

var $4mhsh = parcelRequire("4mhsh");

var $1kxNg = parcelRequire("1kxNg");
const $19fdc2a97b917a10$var$mapStateToProps = (state)=>({
        Header: $4mhsh.default,
        Content: $8lssp.default,
        Footer: $9AQpH.default,
        isOpen: (0, $dJJDt.isConnectSpaceDialogOpen)(state)
    });
var $19fdc2a97b917a10$export$2e2bcd8739ae039 = (0, $cllCv.connect)($19fdc2a97b917a10$var$mapStateToProps)((0, $1kxNg.default));

});
parcelRegister("dJJDt", function(module, exports) {

$parcel$export(module.exports, "getConnectSpaceDialogErrorState", () => $6334b191902c373b$export$c73f884b9b688b51);
$parcel$export(module.exports, "getSelectedSpace", () => $6334b191902c373b$export$8c50b65fa38d42d1);
$parcel$export(module.exports, "isConnectingSpace", () => $6334b191902c373b$export$b070128a7b7bf204);
$parcel$export(module.exports, "isConnectSpaceDialogOpen", () => $6334b191902c373b$export$d0660dc76452a62b);
$parcel$export(module.exports, "isSubmitAllowed", () => $6334b191902c373b$export$77e706a05fb8b3f5);
$parcel$export(module.exports, "isDisconnectedTemplatesClick", () => $6334b191902c373b$export$4eb4b37d0696f31f);
const $6334b191902c373b$export$c73f884b9b688b51 = (state)=>state.ui.connectSpaceDialog.connectSpaceDialogErrorState;
const $6334b191902c373b$export$8c50b65fa38d42d1 = (state)=>state.ui.connectSpaceDialog.selectedSpace;
const $6334b191902c373b$export$b070128a7b7bf204 = (state)=>state.ui.connectSpaceDialog.connectingSpace;
const $6334b191902c373b$export$d0660dc76452a62b = (state)=>state.ui.connectSpaceDialog.connectSpaceDialogOpen;
const $6334b191902c373b$export$77e706a05fb8b3f5 = (state)=>state.ui.connectSpaceDialog.selectedSpace !== null;
const $6334b191902c373b$export$4eb4b37d0696f31f = (state)=>state.ui.connectSpaceDialog.disconnectedTemplatesClick;

});

parcelRegister("8lssp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0851ebe7b7583c1$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $3pvFP = parcelRequire("3pvFP");

var $iLwk2 = parcelRequire("iLwk2");

var $iScRU = parcelRequire("iScRU");

var $ijyMF = parcelRequire("ijyMF");
const $e0851ebe7b7583c1$var$mapStateToProps = ()=>({
        SpacePicker: // @ts-ignore - Type '(value: SpacePickerOptionValue, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(value: SpacePickerOptionValue) => void'
        // This was added when enrolling `@atlassiansox/project-pages` into JFE local consumption
        $iScRU.default,
        CreateSpaceLink: $iLwk2.default
    });
const $e0851ebe7b7583c1$var$dispatch = (dispatch)=>({
        onSpaceSelected: (value)=>dispatch((0, $3pvFP.setSelectedSpace)(value)),
        onCreateSpace: ()=>dispatch((0, $3pvFP.showCreateSpaceDialog)())
    });
var $e0851ebe7b7583c1$export$2e2bcd8739ae039 = (0, $cllCv.connect)($e0851ebe7b7583c1$var$mapStateToProps, $e0851ebe7b7583c1$var$dispatch)((0, $ijyMF.default));

});
parcelRegister("iLwk2", function(module, exports) {

$parcel$export(module.exports, "default", () => $87d31a5002a72838$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $dJJDt = parcelRequire("dJJDt");

var $ez5VP = parcelRequire("ez5VP");
var $87d31a5002a72838$export$2e2bcd8739ae039 = (0, $cllCv.connect)((state)=>({
        isConnectingSpace: (0, $dJJDt.isConnectingSpace)(state)
    }), {})((0, $ez5VP.default));

});
parcelRegister("ez5VP", function(module, exports) {

$parcel$export(module.exports, "default", () => $acca6238aeedc5ae$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $frXXJ = parcelRequire("frXXJ");
const $acca6238aeedc5ae$var$containerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100'
});
class $acca6238aeedc5ae$var$CreateSpaceLink extends (0, $eUqFw.PureComponent) {
    render() {
        const { intl: { formatMessage: formatMessage }, onCreateSpace: onCreateSpace, isConnectingSpace: isConnectingSpace } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $acca6238aeedc5ae$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            spacing: "none",
            // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
            appearance: "link",
            onClick: (_event, analyticsEvent)=>onCreateSpace(analyticsEvent),
            isDisabled: isConnectingSpace,
            "data-test-id": "confluence-project-pages.post-expand.connect-or-update-space-modal.create-space-link"
        }, formatMessage((0, $frXXJ.default).linkText)));
    }
}
var $acca6238aeedc5ae$export$2e2bcd8739ae039 = (0, $2qhQi.default)($acca6238aeedc5ae$var$CreateSpaceLink);

});
parcelRegister("frXXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d15043f51f1328f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4d15043f51f1328f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    linkText: {
        id: 'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text',
        defaultMessage: 'Or create a new space',
        description: ''
    }
});

});



parcelRegister("iScRU", function(module, exports) {

$parcel$export(module.exports, "default", () => $306b4462bcf34663$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $dJJDt = parcelRequire("dJJDt");

var $ktLEy = parcelRequire("ktLEy");

var $hMy8N = parcelRequire("hMy8N");

var $jGyKS = parcelRequire("jGyKS");
var $306b4462bcf34663$export$2e2bcd8739ae039 = (0, $cllCv.connect)((state)=>({
        isConnectingSpace: (0, $dJJDt.isConnectingSpace)(state),
        isDisconnectedTemplatesClick: (0, $dJJDt.isDisconnectedTemplatesClick)(state),
        cloudId: (0, $hMy8N.getCloudId)(state),
        projectId: (0, $jGyKS.getProjectId)(state),
        projectType: (0, $jGyKS.getProjectType)(state)
    }), {})((0, $ktLEy.default));

});
parcelRegister("ktLEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c722d960f201fef9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $2okKT = parcelRequire("2okKT");

var $fm9CZ = parcelRequire("fm9CZ");
var $jQxSL = parcelRequire("jQxSL");

var $lcnyw = parcelRequire("lcnyw");

var $XDv42 = parcelRequire("XDv42");

var $9cKZS = parcelRequire("9cKZS");

var $2fabp = parcelRequire("2fabp");

var $cqrGi = parcelRequire("cqrGi");

var $5aAqT = parcelRequire("5aAqT");
const $c722d960f201fef9$var$Option = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $XDv42.IconWrapper), null, props.value?.isPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9cKZS.PageIcon), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9cKZS.SpaceIcon), {
        iconPath: props.value?.iconPath
    })), children);
const $c722d960f201fef9$var$mapPageAndSpaceOptions = (spaceSearch, pageSearch)=>{
    const spaceOptions = spaceSearch?.scopes?.[0]?.results?.map(({ title: title, space: space, baseUrl: baseUrl, url: url, id: id })=>({
            label: title,
            value: {
                spaceId: id,
                spaceKey: space?.key,
                spaceName: title,
                spaceUrl: `${baseUrl}${url}`,
                iconPath: `${baseUrl}${space?.icon?.path}`,
                isPage: false
            }
        }));
    const pageOptions = pageSearch?.results?.map(({ title: title, space: space, id: id, _links: _links })=>({
            label: title,
            value: {
                spaceId: space.id,
                spaceKey: space.key,
                spaceName: space.name,
                linkedPageId: id,
                linkedPageTitle: title,
                isPage: true,
                linkedPageUrl: `${pageSearch._links?.base}${_links?.webui}`
            }
        }));
    return [
        {
            label: 'Spaces',
            options: spaceOptions
        },
        {
            label: 'Pages',
            options: pageOptions
        }
    ];
};
const $c722d960f201fef9$var$SPACES_MAX_RESULTS = 5;
const $c722d960f201fef9$var$SpacePicker = ({ intl: { formatMessage: formatMessage }, onSelected: onSelected, isDisconnectedTemplatesClick: isDisconnectedTemplatesClick, isConnectingSpace: isConnectingSpace, cloudId: cloudId, projectId: projectId, projectType: projectType })=>{
    const [defaultOptions, setDefaultOptions] = (0, $eUqFw.useState)(true);
    const [defaultOptionsAreLoaded, setDefaultOptionsAreLoaded] = (0, $eUqFw.useState)(false);
    const fetchPageAndSpaceOptions = async (inputValue)=>{
        const pageSearch = await (0, $2fabp.searchConfluencePages)(inputValue, projectId, projectType);
        let spaceSearch = await (0, $2fabp.searchConfluenceSpaces)({
            cloudId: cloudId,
            limit: $c722d960f201fef9$var$SPACES_MAX_RESULTS,
            searchString: inputValue
        });
        const options = $c722d960f201fef9$var$mapPageAndSpaceOptions(spaceSearch, pageSearch);
        if (!defaultOptionsAreLoaded && !inputValue) {
            // Save initial results to return them when no input is passed
            setDefaultOptionsAreLoaded(true);
            setDefaultOptions(options);
        }
        return options;
    };
    const debouncedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($2okKT)))(fetchPageAndSpaceOptions, 300);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $XDv42.Container), {
        "data-test-id": "confluence-project-pages.post-expand.connect-or-update-space-modal.space-picker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $XDv42.Instructions), null, isDisconnectedTemplatesClick ? formatMessage((0, $cqrGi.default)['disconnected-templates-description']) : formatMessage((0, $cqrGi.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fm9CZ.default), {
        // When AsyncSelect defaultOptions prop is set to `false`, `loadOptions` is called on render to populate defaultOptions.
        defaultOptions: defaultOptions,
        loadOptions: debouncedOptions,
        isSearchable: true,
        placeholder: formatMessage((0, $cqrGi.default).placeholder),
        isDisabled: isConnectingSpace,
        menuPortalTarget: document.body,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $lcnyw.layers).modal()
                }),
            option: (base)=>({
                    ...base,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer'
                })
        },
        components: {
            Option: $c722d960f201fef9$var$Option
        },
        onChange: (result, { action: action })=>{
            if (result && action === 'select-option') {
                const { value: value } = result;
                onSelected(value);
            }
        }
    }));
};
var $c722d960f201fef9$export$2e2bcd8739ae039 = (0, $5aAqT.AnalyticsEventToProps)('spacePicker', {
    onSelected: 'selected'
})((0, $2qhQi.default)($c722d960f201fef9$var$SpacePicker));

});
parcelRegister("2okKT", function(module, exports) {
'use strict';
/* global setTimeout, clearTimeout */ module.exports = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lastCallAt = void 0;
    var deferred = void 0;
    var timer = void 0;
    var pendingArgs = [];
    return function debounced() {
        var currentWait = $1bddec3ffc2ad8ec$var$getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
            args
        ])).then(function(result) {
            return result[0];
        }) : Promise.resolve(fn.call.apply(fn, [
            this
        ].concat(args)));
        if (deferred) clearTimeout(timer);
        else deferred = $1bddec3ffc2ad8ec$var$defer();
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
};
function $1bddec3ffc2ad8ec$var$getWait(wait) {
    return typeof wait === 'function' ? wait() : wait;
}
function $1bddec3ffc2ad8ec$var$defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});

parcelRegister("fm9CZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14ede2f273d8bdb$export$2e2bcd8739ae039);

var $hgTYM = parcelRequire("hgTYM");

var $5FjBr = parcelRequire("5FjBr");
const $a14ede2f273d8bdb$var$AsyncSelect = (0, $5FjBr.default)((0, $hgTYM.default));
var $a14ede2f273d8bdb$export$2e2bcd8739ae039 = $a14ede2f273d8bdb$var$AsyncSelect;

});
parcelRegister("hgTYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c92f5a99b4ea3691$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("3IL7Z")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $3IL7Z = parcelRequire("3IL7Z");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $c92f5a99b4ea3691$var$AsyncSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, $3IL7Z.u)(props);
    var selectProps = (0, $7IqRg.u)(stateManagedProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $c92f5a99b4ea3691$export$2e2bcd8739ae039 = $c92f5a99b4ea3691$var$AsyncSelect;

});
parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aM0Ke.default)(o.key), o);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fcfd452a83bb612a$var$_defineProperties(e.prototype, r), t && $fcfd452a83bb612a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c2pQl.default)(t, e);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(t) {
    var r = (0, $8c5pC.default)();
    return function() {
        var e, o = (0, $i3rTN.default)(t);
        if (r) {
            var s = (0, $i3rTN.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $4mIeV.default)(this, e);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t) {
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5sKOb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(t);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(r) {
    return (0, $b7OIr.default)(r) || (0, $2B3l3.default)(r) || (0, $e5SQy.default)(r) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aLrjs.default)(r);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aLrjs.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aLrjs.default)(r, a) : void 0;
    }
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(r, e) {
    return (0, $kcDiK.default)(r) || (0, $61Jn4.default)(r, e) || (0, $e5SQy.default)(r, e) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});



parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("3IL7Z", function(module, exports) {

$parcel$export(module.exports, "u", () => $2b5a09c16d37496a$export$3b14a55fb2447963);

var $5zQU9 = parcelRequire("5zQU9");

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
var $2b5a09c16d37496a$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $2b5a09c16d37496a$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $bwPfh.default)(_ref, $2b5a09c16d37496a$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $eUqFw.useRef)(undefined);
    var mounted = (0, $eUqFw.useRef)(false);
    var _useState = (0, $eUqFw.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $aKcqM.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsDefaultOptions === true), _useState6 = (0, $aKcqM.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $eUqFw.useState)(undefined), _useState8 = (0, $aKcqM.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $eUqFw.useState)([]), _useState10 = (0, $aKcqM.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $eUqFw.useState)(false), _useState12 = (0, $aKcqM.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $eUqFw.useState)({}), _useState14 = (0, $aKcqM.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $eUqFw.useState)(undefined), _useState16 = (0, $aKcqM.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $eUqFw.useState)(undefined), _useState18 = (0, $aKcqM.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $eUqFw.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $eUqFw.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $jQxSL.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $1Xn5q.default)((0, $1Xn5q.default)({}, optionsCache), {}, (0, $5zQU9.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});


parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $lT14u.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $e9T6i = parcelRequire("e9T6i");

var $exKxp = parcelRequire("exKxp");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $a14d8b5e9bff27a8$var$dropdownWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exKxp))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        as: "span",
        xcss: $a14d8b5e9bff27a8$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("exKxp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9683f39a4d9c20b$var$_react = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9683f39a4d9c20b$var$_crossCircle = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("iOPxW")));

var $a9683f39a4d9c20b$var$_selectClear = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("hUbUe")));
function $a9683f39a4d9c20b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9683f39a4d9c20b$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a9683f39a4d9c20b$var$_react.default.createElement($a9683f39a4d9c20b$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $a9683f39a4d9c20b$var$_selectClear.default
    }, props));
$a9683f39a4d9c20b$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $a9683f39a4d9c20b$var$_default = module.exports.default = $a9683f39a4d9c20b$var$CrossCircleIcon;

});
parcelRegister("iOPxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db34e18c123e5251$var$_react = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $db34e18c123e5251$var$_UNSAFE_baseNew = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $db34e18c123e5251$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db34e18c123e5251$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $db34e18c123e5251$var$_react.default.createElement($db34e18c123e5251$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db34e18c123e5251$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $db34e18c123e5251$var$_default = module.exports.default = $db34e18c123e5251$var$CrossCircleIcon;

});

parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d090e6e9cc89e346$var$_crossCircle = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $d090e6e9cc89e346$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d090e6e9cc89e346$var$_crossCircle.default
    }));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = module.exports.default = $d090e6e9cc89e346$var$SelectClearIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});




parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hUbUe = parcelRequire("hUbUe");

var $adUQx = parcelRequire("adUQx");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.025'
});
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
            xcss: $7fda2332979a5c13$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});


parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $1Yimi = parcelRequire("1Yimi");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
                ...(0, $XHGTv.fg)('platform_design_system_team_select_typography') && {
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                }
            })
    };
}

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';


parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $7ccc5140c845bc58$export$8ee33f304118fce4);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $7ccc5140c845bc58$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("XDv42", function(module, exports) {

$parcel$export(module.exports, "Container", () => $9b79fb1929a63f1b$export$42a852a2b6b56249);
$parcel$export(module.exports, "Instructions", () => $9b79fb1929a63f1b$export$9e5bb8ba6c1f6b31);
$parcel$export(module.exports, "IconWrapper", () => $9b79fb1929a63f1b$export$be58b4326e23250f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $9b79fb1929a63f1b$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "knf1vh-0"
})({
    margin: `${"var(--ds-space-100, 8px)"} 0 0`,
    display: 'flex',
    flexDirection: 'column'
});
const $9b79fb1929a63f1b$export$9e5bb8ba6c1f6b31 = /*#__PURE__*/ (0, $kwce8.default).p.withConfig({
    componentId: "knf1vh-1"
})({
    margin: `0 0 ${"var(--ds-space-200, 16px)"}`
});
const $9b79fb1929a63f1b$export$be58b4326e23250f = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "knf1vh-2"
})({
    marginRight: "var(--ds-space-100, 8px)"
});

});

parcelRegister("9cKZS", function(module, exports) {

$parcel$export(module.exports, "SpaceIcon", () => $b6d6540106e669c9$export$38ffce4a7986ba20);
$parcel$export(module.exports, "PageIcon", () => $b6d6540106e669c9$export$d1143dd23ca69d4e);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");


var $33pqc = parcelRequire("33pqc");
const $b6d6540106e669c9$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "b88vl8-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundImage: `url(${props.iconPath})`,
        backgroundColor: `var(--ds-skeleton, ${0, $73a5c9d720aa66e1$export$8d43898f60b96a82})`,
        backgroundSize: 'contain',
        height: "var(--ds-space-200, 16px)",
        width: "var(--ds-space-200, 16px)",
        borderRadius: "var(--ds-border-radius-100, 3px)"
    }));
const $b6d6540106e669c9$export$d1143dd23ca69d4e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33pqc))), {
        label: "Page"
    });

});
parcelRegister("33pqc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $23955f1f88135281$var$_react = $23955f1f88135281$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $23955f1f88135281$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $23955f1f88135281$var$Document16Icon = (props)=>/*#__PURE__*/ $23955f1f88135281$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2 3a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 000 2h4a1 1 0 000-2H4z"/></svg>`
    }, props, {
        size: 'small'
    }));
$23955f1f88135281$var$Document16Icon.displayName = 'Document16Icon';
var $23955f1f88135281$var$_default = $23955f1f88135281$var$Document16Icon;
module.exports.default = $23955f1f88135281$var$_default;

});


parcelRegister("2fabp", function(module, exports) {

$parcel$export(module.exports, "requestProductLicenceState$", () => $5f6ee7b74770ef0d$export$e16d9fc1107f8c00);
$parcel$export(module.exports, "requestConfluenceSpaces$", () => $5f6ee7b74770ef0d$export$836d55263fa85c87);
$parcel$export(module.exports, "requestCreateConfluenceSpace$", () => $5f6ee7b74770ef0d$export$b699837851084807);
$parcel$export(module.exports, "checkConfluenceSpaceAvailability$", () => $5f6ee7b74770ef0d$export$5fd40bd59aba14a0);
$parcel$export(module.exports, "putFirstSpaceCreatedFlag$", () => $5f6ee7b74770ef0d$export$803b1898c3d83afd);
$parcel$export(module.exports, "createProjectSpaceLink$", () => $5f6ee7b74770ef0d$export$e1967fc978903284);
$parcel$export(module.exports, "deleteProjectSpaceLink$", () => $5f6ee7b74770ef0d$export$f93215d152c7ceac);
$parcel$export(module.exports, "fetchProjectSpaceLink$", () => $5f6ee7b74770ef0d$export$e1498d86ff7a5f7);
$parcel$export(module.exports, "fetchConnectedSpaceBlueprints$", () => $5f6ee7b74770ef0d$export$a9bcdbdfc3a4c568);
$parcel$export(module.exports, "fetchConfluenceCurrentUser", () => $5f6ee7b74770ef0d$export$dff559fe4d82b44d);
$parcel$export(module.exports, "searchConfluencePages", () => $5f6ee7b74770ef0d$export$b7c915cfba7db283);
$parcel$export(module.exports, "searchConfluenceSpaces", () => $5f6ee7b74770ef0d$export$dd2276d83e80b5ed);
$parcel$export(module.exports, "getConfluenceAccessRequestCapabilities$", () => $5f6ee7b74770ef0d$export$3c28db22d8ae1b4f);
$parcel$export(module.exports, "getConfluencePageContent$", () => $5f6ee7b74770ef0d$export$25561b7d64fb4325);
$parcel$export(module.exports, "getConfluenceSpace$", () => $5f6ee7b74770ef0d$export$c2d8b9bcabaeb4d0);
$parcel$export(module.exports, "getJiraProjectPermissions$", () => $5f6ee7b74770ef0d$export$2b5fae8bff1d96a8);
$parcel$export(module.exports, "requestPersonalizationSiteTraits$", () => $5f6ee7b74770ef0d$export$554089415931795c);
$parcel$export(module.exports, "startConfluenceActivation$", () => $5f6ee7b74770ef0d$export$197e5a1a1bedbe96);
$parcel$export(module.exports, "planConfluenceActivation$", () => $5f6ee7b74770ef0d$export$1ac30eea14e5e902);
$parcel$export(module.exports, "checkConfluenceActivationStatus$", () => $5f6ee7b74770ef0d$export$29c2be969084daf8);
parcelRequire("flmol");
parcelRequire("l5lul");

var $8riMk = parcelRequire("8riMk");

var $7y517 = parcelRequire("7y517");

var $h2beI = parcelRequire("h2beI");

const $5f6ee7b74770ef0d$var$XFLOW_SERVICE_URL = '/gateway/api/xflow';
const $5f6ee7b74770ef0d$var$BXP_SIGNUP_URL = '/gateway/api/bxp/signup/cloud';
const $5f6ee7b74770ef0d$var$IGNORE_MAU_HEADER = 'x-atlassian-mau-ignore';
const $5f6ee7b74770ef0d$var$EP_ENITITY_ID_HEADER = 'X-Atl-EmbeddablePage-EntityIDs';
const $5f6ee7b74770ef0d$export$13309df55f6e6231 = '/wiki/rest/api/space';
const $5f6ee7b74770ef0d$export$bc7d169343cd2cf6 = '/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=10&otherSpacesLimit=1000';
const $5f6ee7b74770ef0d$export$2bf2ad2b61364815 = '/wiki/rest/onboarding/1/store/global';
const $5f6ee7b74770ef0d$export$981b0f082b0d776b = `/gateway/api/xpsearch-aggregator/quicksearch/v1`;
const $5f6ee7b74770ef0d$export$126be369638921c0 = (spaceKey)=>`/wiki/rest/create-dialog/1.0/blueprints/web-items?spaceKey=${spaceKey}&_=${Date.now()}`;
const $5f6ee7b74770ef0d$export$7c44ff3083bd8b37 = ()=>`/wiki/rest/api/user/current?expand=operations`;
const $5f6ee7b74770ef0d$export$256b0e8bff582010 = (cloudId)=>`${$5f6ee7b74770ef0d$var$BXP_SIGNUP_URL}/${encodeURIComponent(cloudId)}/license-information`;
const $5f6ee7b74770ef0d$export$6521d5279ac5589e = `${$5f6ee7b74770ef0d$var$XFLOW_SERVICE_URL}/provision/cloud`;
const $5f6ee7b74770ef0d$export$16b02e26b9083bd3 = (cloudId)=>`${$5f6ee7b74770ef0d$export$6521d5279ac5589e}/${encodeURIComponent(cloudId)}/product/confluence.ondemand/job/project-pages`;
const $5f6ee7b74770ef0d$export$711aa425c20c30b2 = ()=>'/gateway/api/graphql';
const $5f6ee7b74770ef0d$export$fbb12358ff8c5995 = (spaceKey)=>`/wiki/rest/api/space/${spaceKey}/content?depth=root`;
const $5f6ee7b74770ef0d$export$ad713ec1d3078265 = (key)=>`/wiki/ajax/spaceavailable.action?key=${key}`;
const $5f6ee7b74770ef0d$export$b71c51cebe3b5358 = (cqlQuery)=>`/wiki/rest/api/content/search?${new URLSearchParams({
        cql: cqlQuery,
        expand: 'space,link'
    }).toString()}`;
const $5f6ee7b74770ef0d$export$5c479b434f7669a6 = (pageId)=>`/wiki/rest/api/content/${pageId}`;
const $5f6ee7b74770ef0d$export$2a3fa5b1d638ae51 = (cloudId)=>{
    const params = new URLSearchParams({
        resource: `ari:cloud:confluence::site/${cloudId}`
    });
    return `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
};
const $5f6ee7b74770ef0d$export$35bc6862a72d40bd = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $5f6ee7b74770ef0d$export$8d2096151be97527 = (projectKey)=>{
    const params = new URLSearchParams({
        projectKey: projectKey,
        permissions: `${"CREATE_ISSUES"},${"EDIT_ISSUES"}`
    });
    return `/rest/api/2/mypermissions?${params.toString()}`;
};
const $5f6ee7b74770ef0d$export$e16d9fc1107f8c00 = (cloudId)=>(0, $7y517.default)($5f6ee7b74770ef0d$export$256b0e8bff582010(cloudId), {
        credentials: 'include'
    });
const $5f6ee7b74770ef0d$export$836d55263fa85c87 = (projectId, projectType)=>(0, $7y517.default)($5f6ee7b74770ef0d$export$bc7d169343cd2cf6, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$5f6ee7b74770ef0d$var$IGNORE_MAU_HEADER]: 'true',
            [$5f6ee7b74770ef0d$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    }).map((response)=>[
            ...new Set([
                ...response.promotedSpaces.spaces,
                ...response.otherSpaces.spaces
            ])
        ]);
const $5f6ee7b74770ef0d$export$b699837851084807 = (confluenceSpaceName, confluenceSpaceKey, projectKey, projectId, projectType)=>(0, $7y517.default)($5f6ee7b74770ef0d$export$13309df55f6e6231, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$5f6ee7b74770ef0d$var$IGNORE_MAU_HEADER]: 'true',
            [$5f6ee7b74770ef0d$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        },
        body: JSON.stringify({
            key: confluenceSpaceKey,
            name: confluenceSpaceName,
            description: {
                plain: {
                    value: projectKey ? `Confluence Space created for Jira Project ${projectKey}` : '',
                    representation: 'plain'
                }
            }
        })
    }).map((response)=>({
            spaceKey: response.key,
            spaceId: response.id,
            spaceUrl: `${response._links?.base}${response._links?.webui}`,
            projectKey: projectKey
        }));
const $5f6ee7b74770ef0d$export$5fd40bd59aba14a0 = (key, projectId, projectType)=>(0, $7y517.default)($5f6ee7b74770ef0d$export$ad713ec1d3078265(key), {
        credentials: 'include',
        headers: {
            [$5f6ee7b74770ef0d$var$IGNORE_MAU_HEADER]: 'true',
            [$5f6ee7b74770ef0d$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    }).map((response)=>({
            available: response.available,
            key: key
        }));
const $5f6ee7b74770ef0d$export$95467f9327511805 = (spaceKey, projectId, projectType)=>(0, $7y517.default)($5f6ee7b74770ef0d$export$fbb12358ff8c5995(spaceKey), {
        credentials: 'include',
        headers: {
            [$5f6ee7b74770ef0d$var$IGNORE_MAU_HEADER]: 'true',
            [$5f6ee7b74770ef0d$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    }).map((response)=>{
        const firstRootPageFallback = response.page.results[0].id;
        const rootPageWithSlashOverview = response.page.results.filter((result)=>// find the page at the root level that is the space home
            result._links.webui.indexOf('/overview') >= 0).map((rootPage)=>rootPage.id);
        return rootPageWithSlashOverview.length ? rootPageWithSlashOverview[0] : firstRootPageFallback;
    });
const $5f6ee7b74770ef0d$export$803b1898c3d83afd = (projectId, projectType)=>(0, $8riMk.fromPromise)(fetch($5f6ee7b74770ef0d$export$2bf2ad2b61364815, {
        method: 'PUT',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$5f6ee7b74770ef0d$var$IGNORE_MAU_HEADER]: 'true',
            [$5f6ee7b74770ef0d$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        },
        body: JSON.stringify({
            key: 'is-first-space-created',
            value: 'true'
        })
    }).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                throw new (0, $h2beI.default)(status, str);
            });
        }
        return null;
    }));
const $5f6ee7b74770ef0d$var$COMMON_AGG_REQUEST_CONFIG = {
    credentials: 'include',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'X-ExperimentalApi': 'ariGraph,devOps'
    }
};
const $5f6ee7b74770ef0d$var$throwGraphQLErrors = (errors)=>{
    const errStr = errors.map((err)=>err.message).join(', ');
    throw new Error(errStr);
};
const $5f6ee7b74770ef0d$var$handleFetchResponse = (response)=>{
    if (!response.ok) {
        const { status: status } = response;
        return response.text().then((str)=>{
            throw new (0, $h2beI.default)(status, str);
        });
    }
    return response.json();
};
const $5f6ee7b74770ef0d$var$buildAris = ({ cloudId: cloudId, projectId: projectId, linkedPageId: linkedPageId, spaceId: spaceId })=>{
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    // Construct the Page ARI if there is a linkedPageId otherwise construct the Space ARI
    const pageOrSpaceAri = linkedPageId ? `ari:cloud:confluence:${cloudId}:page/${linkedPageId}` : `ari:cloud:confluence:${cloudId}:space/${spaceId}`;
    return {
        projectAri: projectAri,
        pageOrSpaceAri: pageOrSpaceAri
    };
};
const $5f6ee7b74770ef0d$var$CREATE_CONFLUENCE_RELATIONSHIP_QUERY = `
  mutation createConfluenceRelationship($fromAri: ID!, $toAri: ID!) {
    devOps {
      ariGraph {
        createRelationships(
          input: {relationships: {type: "project-documentation-entity", from: $fromAri, to: $toAri}}
        ) {
          success
          errors {
            message
          }
        }
      }
    }
  }
`;
const $5f6ee7b74770ef0d$export$e1967fc978903284 = ({ cloudId: cloudId, linkedPageId: linkedPageId, projectId: projectId, spaceId: spaceId })=>{
    const { projectAri: projectAri, pageOrSpaceAri: pageOrSpaceAri } = $5f6ee7b74770ef0d$var$buildAris({
        cloudId: cloudId,
        linkedPageId: linkedPageId,
        projectId: projectId,
        spaceId: spaceId
    });
    return (0, $8riMk.fromPromise)(fetch($5f6ee7b74770ef0d$export$711aa425c20c30b2(), {
        ...$5f6ee7b74770ef0d$var$COMMON_AGG_REQUEST_CONFIG,
        body: JSON.stringify({
            query: $5f6ee7b74770ef0d$var$CREATE_CONFLUENCE_RELATIONSHIP_QUERY,
            variables: {
                fromAri: projectAri,
                toAri: pageOrSpaceAri
            }
        })
    }).then($5f6ee7b74770ef0d$var$handleFetchResponse).then(({ data: data })=>{
        const { success: success, errors: errors } = data?.devOps?.ariGraph?.createRelationships;
        if (!success) $5f6ee7b74770ef0d$var$throwGraphQLErrors(errors || []);
        return null;
    }));
};
const $5f6ee7b74770ef0d$var$DELETE_CONFLUENCE_RELATIONSHIP_QUERY = `
  mutation deleteConfluenceRelationship($fromAri: ID!, $toAri: ID!) {
    devOps {
      ariGraph {
        deleteRelationships(
          input: {type: "project-documentation-entity", from: $fromAri, to: $toAri}
        ) {
          success
          errors {
            message
          }
        }
      }
    }
  }
`;
const $5f6ee7b74770ef0d$export$f93215d152c7ceac = ({ cloudId: cloudId, linkedPageId: linkedPageId, projectId: projectId, spaceId: spaceId })=>{
    const { projectAri: projectAri, pageOrSpaceAri: pageOrSpaceAri } = $5f6ee7b74770ef0d$var$buildAris({
        cloudId: cloudId,
        linkedPageId: linkedPageId,
        projectId: projectId,
        spaceId: spaceId
    });
    return (0, $8riMk.fromPromise)(fetch($5f6ee7b74770ef0d$export$711aa425c20c30b2(), {
        ...$5f6ee7b74770ef0d$var$COMMON_AGG_REQUEST_CONFIG,
        body: JSON.stringify({
            query: $5f6ee7b74770ef0d$var$DELETE_CONFLUENCE_RELATIONSHIP_QUERY,
            variables: {
                fromAri: projectAri,
                toAri: pageOrSpaceAri
            }
        })
    }).then($5f6ee7b74770ef0d$var$handleFetchResponse).then(({ data: data })=>{
        const { success: success, errors: errors } = data?.devOps?.ariGraph?.deleteRelationships;
        if (!success) $5f6ee7b74770ef0d$var$throwGraphQLErrors(errors || []);
        return null;
    }));
};
const $5f6ee7b74770ef0d$var$GET_CONFLUENCE_RELATIONSHIP_QUERY = `
  query getConfluenceRelationship($projectAri: ID!) {
    devOps {
      ariGraph {
        relationships(
          filter: {
            from: $projectAri
            type: "project-documentation-entity"
          }
          sort: {
            lastUpdatedSortDirection: DESC
          }
        ) {
          nodes {
            to {
              id
              data {
                __typename
                ... on ConfluenceSpace {
                  key
                }
                ... on ConfluencePage {
                  pageId
                  space {
                    key
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  `;
const $5f6ee7b74770ef0d$export$e1498d86ff7a5f7 = (cloudId, projectId)=>{
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    return (0, $7y517.default)($5f6ee7b74770ef0d$export$711aa425c20c30b2(), {
        credentials: 'include',
        method: 'POST',
        headers: {
            'X-ExperimentalApi': 'ariGraph,devOps'
        },
        body: JSON.stringify({
            query: $5f6ee7b74770ef0d$var$GET_CONFLUENCE_RELATIONSHIP_QUERY,
            variables: {
                projectAri: projectAri
            }
        })
    }).map(({ data: data })=>{
        const spacesAndPages = data.devOps.ariGraph.relationships.nodes.filter((node)=>[
                'ConfluencePage',
                'ConfluenceSpace'
            ].includes(node.to.data.__typename));
        // TODO: Project pages should implement a more robust solution here rather than reading the first in the list of returned relationships, because there could be many associated pages/spaces
        const [relationshipNode] = spacesAndPages;
        if (relationshipNode == null) return {
            spaceKey: null,
            linkedPageId: null
        };
        const spaceKey = relationshipNode.to.data.__typename === 'ConfluencePage' ? relationshipNode.to.data.space.key : relationshipNode.to.data.key;
        const linkedPageId = relationshipNode.to.data.__typename === 'ConfluencePage' ? relationshipNode.to.data.pageId : null;
        return {
            spaceKey: spaceKey,
            linkedPageId: linkedPageId
        };
    });
};
const $5f6ee7b74770ef0d$export$a9bcdbdfc3a4c568 = (spaceKey, projectId, projectType)=>(0, $7y517.default)($5f6ee7b74770ef0d$export$126be369638921c0(spaceKey), {
        credentials: 'include',
        headers: {
            [$5f6ee7b74770ef0d$var$IGNORE_MAU_HEADER]: 'true',
            [$5f6ee7b74770ef0d$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    });
const $5f6ee7b74770ef0d$export$dff559fe4d82b44d = (projectId, projectType)=>(0, $7y517.default)($5f6ee7b74770ef0d$export$7c44ff3083bd8b37(), {
        credentials: 'include',
        headers: {
            [$5f6ee7b74770ef0d$var$IGNORE_MAU_HEADER]: 'true',
            [$5f6ee7b74770ef0d$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    });
const $5f6ee7b74770ef0d$var$sanitizeInput = (input = '')=>input.replace(/"|\*|~/g, '\\$&');
const $5f6ee7b74770ef0d$export$b7c915cfba7db283 = (searchString, projectId, projectType)=>{
    let cqlQuery;
    if (searchString) cqlQuery = `type=page and title ~ "${$5f6ee7b74770ef0d$var$sanitizeInput(searchString)}"`;
    else cqlQuery = `type=page`;
    return (0, $7y517.default)($5f6ee7b74770ef0d$export$b71c51cebe3b5358(cqlQuery), {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$5f6ee7b74770ef0d$var$IGNORE_MAU_HEADER]: 'true',
            [$5f6ee7b74770ef0d$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    }).toPromise();
};
const $5f6ee7b74770ef0d$export$dd2276d83e80b5ed = ({ searchString: searchString, cloudId: cloudId, limit: limit })=>{
    const query = searchString ? $5f6ee7b74770ef0d$var$sanitizeInput(searchString) : '';
    return (0, $7y517.default)($5f6ee7b74770ef0d$export$981b0f082b0d776b, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: query,
            cloudId: cloudId,
            limit: limit,
            scopes: [
                'confluence.space'
            ],
            experience: 'jira.projectPages'
        })
    }).toPromise();
};
const $5f6ee7b74770ef0d$export$3c28db22d8ae1b4f = (cloudId)=>(0, $7y517.default)($5f6ee7b74770ef0d$export$2a3fa5b1d638ae51(cloudId), {
        credentials: 'include'
    });
const $5f6ee7b74770ef0d$export$25561b7d64fb4325 = (pageId, projectId, projectType)=>(0, $7y517.default)($5f6ee7b74770ef0d$export$5c479b434f7669a6(pageId), {
        credentials: 'include',
        headers: {
            [$5f6ee7b74770ef0d$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    });
const $5f6ee7b74770ef0d$export$c2d8b9bcabaeb4d0 = (spaceKey, projectId, projectType)=>(0, $7y517.default)(`/wiki/rest/api/space/${spaceKey}?expand=icon,homepage`, {
        credentials: 'include',
        headers: {
            [$5f6ee7b74770ef0d$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    });
var $5f6ee7b74770ef0d$export$5b73c005b9475dcb;
(function(JiraProjectPermissionType) {
    JiraProjectPermissionType["EditIssues"] = "EDIT_ISSUES";
    JiraProjectPermissionType["CreateIssues"] = "CREATE_ISSUES";
})($5f6ee7b74770ef0d$export$5b73c005b9475dcb || ($5f6ee7b74770ef0d$export$5b73c005b9475dcb = {}));
const $5f6ee7b74770ef0d$export$2b5fae8bff1d96a8 = (projectKey)=>(0, $7y517.default)($5f6ee7b74770ef0d$export$8d2096151be97527(projectKey), {
        credentials: 'include'
    });
const $5f6ee7b74770ef0d$export$554089415931795c = (cloudId)=>(0, $7y517.default)($5f6ee7b74770ef0d$export$35bc6862a72d40bd(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$5f6ee7b74770ef0d$var$IGNORE_MAU_HEADER]: 'true'
        }
    }).map((response)=>response.attributes);
const $5f6ee7b74770ef0d$export$4e1ad3f3c6e5680c = [
    'activate',
    'wait-for-activation',
    'wait-for-confluence',
    'create-space',
    'link-space'
];
const $5f6ee7b74770ef0d$export$30557b1912f2c86a = [
    'PROVISIONING_IN_PROGRESS',
    'PROVISIONING_COMPLETED',
    'PROVISIONING_FAILED',
    'PROVISIONING_PROCESS_NOT_FOUND'
];
const $5f6ee7b74770ef0d$export$197e5a1a1bedbe96 = (cloudId, body)=>(0, $7y517.default)(`${$5f6ee7b74770ef0d$export$16b02e26b9083bd3(cloudId)}/start`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$5f6ee7b74770ef0d$var$IGNORE_MAU_HEADER]: 'true'
        },
        body: JSON.stringify({
            ...body,
            sourceContext: (0, $2bdc823b57417d54$export$e776c72d9769c47a),
            sourceComponent: (0, $2bdc823b57417d54$export$400f359cf7604d7a)
        })
    });
const $5f6ee7b74770ef0d$export$1ac30eea14e5e902 = (cloudId, body)=>(0, $7y517.default)(`${$5f6ee7b74770ef0d$export$16b02e26b9083bd3(cloudId)}/plan`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$5f6ee7b74770ef0d$var$IGNORE_MAU_HEADER]: 'true'
        },
        body: JSON.stringify({
            ...body,
            sourceContext: (0, $2bdc823b57417d54$export$e776c72d9769c47a),
            sourceComponent: (0, $2bdc823b57417d54$export$400f359cf7604d7a)
        })
    });
const $5f6ee7b74770ef0d$export$29c2be969084daf8 = (cloudId)=>(0, $7y517.default)(`${$5f6ee7b74770ef0d$export$16b02e26b9083bd3(cloudId)}/status`, {
        method: 'GET',
        credentials: 'include'
    });

});
parcelRegister("7y517", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1b3dfd5c3451189$export$2e2bcd8739ae039);
parcelRequire("jyKN9");

var $3JafE = parcelRequire("3JafE");

var $6JFcL = parcelRequire("6JFcL");

var $h2beI = parcelRequire("h2beI");

const $b1b3dfd5c3451189$var$noContentStatus = (0, $d66f1468f922cebe$export$3288b14b6745c572);
const $b1b3dfd5c3451189$var$defaultOptions = (0, $6JFcL.freeze)({
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
});
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
const $b1b3dfd5c3451189$var$fetchJson$ = (url, options = {})=>{
    const { headersProcessor: headersProcessor, ...opts } = options;
    return (0, $3JafE.Observable).of(url).mergeMap(()=>fetch(url, (0, $6JFcL.merge)($b1b3dfd5c3451189$var$defaultOptions, opts))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                throw new (0, $h2beI.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $b1b3dfd5c3451189$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        return response.json();
    });
};
var $b1b3dfd5c3451189$export$2e2bcd8739ae039 = $b1b3dfd5c3451189$var$fetchJson$;

});
parcelRegister("6JFcL", function(module, exports) {
/**
 * This allows you to work with object hierarchies that have been frozen
 * with Object.freeze().  "get" operations can use the normal JS syntax,
 * but operations that modify the data will have to return partial copies of
 * the structure. The portions of the structure that did not change will
 * === their previous values.
 *
 * Inspired by clojure/mori and Immutable.js
 */ 'use strict';
const $4e76e87dd407b653$var$i = module.exports;
const $4e76e87dd407b653$var$identity = (coll)=>coll;
// we only care about objects or arrays for now
const $4e76e87dd407b653$var$weCareAbout = (val)=>val !== null && (Array.isArray(val) || // This will skip objects created with `new Foo()`
    // and objects created with `Object.create(proto)`
    // The benefit is ignoring DOM elements and event emitters,
    // which are often circular.
    $4e76e87dd407b653$var$isObjectLike(val));
const $4e76e87dd407b653$var$isObjectLike = (val)=>typeof val === 'object' && val.constructor === Object && Object.getPrototypeOf(val) === Object.prototype;
const $4e76e87dd407b653$var$forKeys = (obj, iter)=>{
    let idx, keys;
    if (Array.isArray(obj)) {
        idx = obj.length;
        while(idx--)iter(idx);
        return;
    }
    keys = Object.keys(obj);
    idx = keys.length;
    while(idx--)iter(keys[idx]);
};
const $4e76e87dd407b653$var$cloneObj = (obj)=>{
    const newObj = {};
    const keys = Object.keys(obj);
    let idx = keys.length;
    let key;
    while(idx--){
        key = keys[idx];
        newObj[key] = obj[key];
    }
    return newObj;
};
const $4e76e87dd407b653$var$clone = (coll)=>{
    if (Array.isArray(coll)) return coll.slice();
    else return $4e76e87dd407b653$var$cloneObj(coll);
};
const $4e76e87dd407b653$var$freezeIfNeeded = $4e76e87dd407b653$var$identity;
const $4e76e87dd407b653$var$_freeze = $4e76e87dd407b653$var$identity;
const $4e76e87dd407b653$var$prevNodes = [];
const $4e76e87dd407b653$var$baseFreeze = (coll)=>{
    if ($4e76e87dd407b653$var$prevNodes.some((val)=>val === coll)) throw new Error('object has a reference cycle');
    $4e76e87dd407b653$var$prevNodes.push(coll);
    $4e76e87dd407b653$var$forKeys(coll, (key)=>{
        const prop = coll[key];
        if ($4e76e87dd407b653$var$weCareAbout(prop)) $4e76e87dd407b653$var$baseFreeze(prop);
    });
    $4e76e87dd407b653$var$prevNodes.pop();
    Object.freeze(coll);
    return coll;
};
/**
 * recrursively freeze an object and all its child objects
 * @param  {Object|Array} coll
 * @return {Object|Array}
 */ module.exports.freeze = $4e76e87dd407b653$var$identity;
/**
 * recursively un-freeze an object, by cloning frozen collections
 * @param  {[type]} coll [description]
 * @return {[type]}      [description]
 */ module.exports.thaw = function thaw(coll) {
    if (!$4e76e87dd407b653$var$weCareAbout(coll) || !Object.isFrozen(coll)) return coll;
    const newColl = Array.isArray(coll) ? new Array(coll.length) : {};
    $4e76e87dd407b653$var$forKeys(coll, (key)=>{
        newColl[key] = thaw(coll[key]);
    });
    return newColl;
};
/**
 * set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key   Key or index
 * @param  {Object}        value
 * @return {Object|Array}        new object hierarchy with modifications
 */ module.exports.assoc = function assoc(coll, key, value) {
    if (coll[key] === value) return $4e76e87dd407b653$var$_freeze(coll);
    const newObj = $4e76e87dd407b653$var$clone(coll);
    newObj[key] = $4e76e87dd407b653$var$freezeIfNeeded(value);
    return $4e76e87dd407b653$var$_freeze(newObj);
};
module.exports.set = module.exports.assoc;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key  Key or Index
 * @return {Object|Array}       New object or array
 */ module.exports.dissoc = function dissoc(coll, key) {
    const newObj = $4e76e87dd407b653$var$clone(coll);
    delete newObj[key];
    return $4e76e87dd407b653$var$_freeze(newObj);
};
module.exports.unset = module.exports.dissoc;
/**
 * set a value deep in a hierarchical structure
 * @param  {Object|Array} coll
 * @param  {Array}        path    A list of keys to traverse
 * @param  {Object}       value
 * @return {Object|Array}       new object hierarchy with modifications
 */ module.exports.assocIn = function assocIn(coll, path, value) {
    const key0 = path[0];
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple assoc.
    return $4e76e87dd407b653$var$i.assoc(coll, key0, value);
    else // break the problem down.  Assoc this object with the first key
    // and the result of assocIn with the rest of the keys
    return $4e76e87dd407b653$var$i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
};
module.exports.setIn = module.exports.assocIn;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {Array} path  A list of keys to traverse
 * @return {Object|Array}       New object or array
 */ module.exports.dissocIn = function dissocIn(coll, path) {
    const key0 = path[0];
    if (!coll.hasOwnProperty(key0)) return coll;
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple dissoc.
    return $4e76e87dd407b653$var$i.dissoc(coll, key0);
    else // break the problem down.  Assoc this object with the first key
    // and the result of dissocIn with the rest of the keys
    return $4e76e87dd407b653$var$i.assoc(coll, key0, dissocIn(coll[key0], path.slice(1)));
};
module.exports.unsetIn = module.exports.dissocIn;
/**
 * get an object from a hierachy based on an array of keys
 * @param  {Object|Array} coll
 * @param  {Array}        path    list of keys
 * @return {Object}       value, or undefined
 */ function $4e76e87dd407b653$var$baseGet(coll, path) {
    return (path || []).reduce((curr, key)=>{
        if (!curr) return;
        return curr[key];
    }, coll);
}
module.exports.getIn = $4e76e87dd407b653$var$baseGet;
/**
 * Update a value in a hierarchy
 * @param  {Object|Array}   coll
 * @param  {Array}          path     list of keys
 * @param  {Function} callback The existing value with be passed to this.
 *                             Return the new value to set
 * @return {Object|Array}      new object hierarchy with modifications
 */ module.exports.updateIn = function updateIn(coll, path, callback) {
    const existingVal = $4e76e87dd407b653$var$baseGet(coll, path);
    return $4e76e87dd407b653$var$i.assocIn(coll, path, callback(existingVal));
};
// generate wrappers for the mutative array methods
[
    'push',
    'unshift',
    'pop',
    'shift',
    'reverse',
    'sort'
].forEach((methodName)=>{
    module.exports[methodName] = function(arr, val) {
        const newArr = [
            ...arr
        ];
        newArr[methodName]($4e76e87dd407b653$var$freezeIfNeeded(val));
        return $4e76e87dd407b653$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = 'icepick.' + methodName;
});
// splice is special because it is variadic
module.exports.splice = function splice(arr, ..._args) {
    const newArr = [
        ...arr
    ];
    const args = _args.map($4e76e87dd407b653$var$freezeIfNeeded);
    newArr.splice.apply(newArr, args);
    return $4e76e87dd407b653$var$_freeze(newArr);
};
// slice is non-mutative
module.exports.slice = function slice(arr, arg1, arg2) {
    const newArr = arr.slice(arg1, arg2);
    return $4e76e87dd407b653$var$_freeze(newArr);
};
[
    'map',
    'filter'
].forEach((methodName)=>{
    module.exports[methodName] = function(fn, arr) {
        const newArr = arr[methodName](fn);
        return $4e76e87dd407b653$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = 'icepick.' + methodName;
});
module.exports.extend = module.exports.assign = function assign(obj, ...objs) {
    const newObj = objs.reduce($4e76e87dd407b653$var$singleAssign, obj);
    return $4e76e87dd407b653$var$_freeze(newObj);
};
function $4e76e87dd407b653$var$singleAssign(obj1, obj2) {
    return Object.keys(obj2).reduce((obj, key)=>{
        return $4e76e87dd407b653$var$i.assoc(obj, key, obj2[key]);
    }, obj1);
}
module.exports.merge = $4e76e87dd407b653$var$merge;
function $4e76e87dd407b653$var$merge(target, source, resolver) {
    if (target == null || source == null) return target;
    return Object.keys(source).reduce((obj, key)=>{
        const sourceVal = source[key];
        const targetVal = obj[key];
        const resolvedSourceVal = resolver ? resolver(targetVal, sourceVal, key) : sourceVal;
        if ($4e76e87dd407b653$var$weCareAbout(sourceVal) && $4e76e87dd407b653$var$weCareAbout(targetVal)) {
            // if they are both frozen and reference equal, assume they are deep equal
            if (resolvedSourceVal === targetVal && true) return obj;
            if (Array.isArray(sourceVal)) return $4e76e87dd407b653$var$i.assoc(obj, key, resolvedSourceVal);
            // recursively merge pairs of objects
            return $4e76e87dd407b653$var$assocIfDifferent(obj, key, $4e76e87dd407b653$var$merge(targetVal, resolvedSourceVal, resolver));
        }
        // primitive values, stuff with prototypes
        return $4e76e87dd407b653$var$assocIfDifferent(obj, key, resolvedSourceVal);
    }, target);
}
function $4e76e87dd407b653$var$assocIfDifferent(target, key, value) {
    if (target[key] === value) return target;
    return $4e76e87dd407b653$var$i.assoc(target, key, value);
}
const $4e76e87dd407b653$var$chainProto = {
    value: function value() {
        return this.val;
    },
    thru: function thru(fn) {
        this.val = $4e76e87dd407b653$var$freezeIfNeeded(fn(this.val));
        return this;
    }
};
Object.keys(module.exports).forEach((methodName)=>{
    if (methodName.match(/^(map|filter)$/)) {
        $4e76e87dd407b653$var$chainProto[methodName] = function(fn) {
            this.val = module.exports[methodName](fn, this.val);
            return this;
        };
        return;
    }
    $4e76e87dd407b653$var$chainProto[methodName] = function(...args) {
        this.val = module.exports[methodName](this.val, ...args);
        return this;
    };
});
module.exports.chain = function chain(val) {
    const wrapped = Object.create($4e76e87dd407b653$var$chainProto);
    wrapped.val = val;
    return wrapped;
};

});

parcelRegister("h2beI", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf0df37481944d63$export$2e2bcd8739ae039);
/**
 * One field validation error
 */ class $bf0df37481944d63$var$ExtensibleError extends Error {
    constructor(message){
        super(message);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $bf0df37481944d63$export$2191b9da168c6cf0 extends $bf0df37481944d63$var$ExtensibleError {
    constructor(message, errors = []){
        super(message);
        this.errors = errors;
    }
}
class $bf0df37481944d63$export$2e2bcd8739ae039 extends $bf0df37481944d63$var$ExtensibleError {
    constructor(statusCode, message){
        super(message || `Fetch call failed with status code: ${statusCode}`);
        this.statusCode = statusCode;
    }
}

});

const $d66f1468f922cebe$export$ff39ebd4bb12b718 = 201;
const $d66f1468f922cebe$export$3288b14b6745c572 = 204;
const $d66f1468f922cebe$export$9de493bcd9b1d977 = 400;
const $d66f1468f922cebe$export$67d19e9a991baa07 = 401;
const $d66f1468f922cebe$export$a3269a3914b007e3 = 403;
const $d66f1468f922cebe$export$8bca792d963eb0ef = 404;
const $d66f1468f922cebe$export$e813cd7045fcc98d = 500;


const $2bdc823b57417d54$export$400f359cf7604d7a = 'project-pages';
const $2bdc823b57417d54$export$e776c72d9769c47a = 'project-pages';


parcelRegister("cqrGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eaf803e0478d73c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6eaf803e0478d73c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    description: {
        id: 'project-pages.connect-space-dialog.content.space-or-page-selector.description',
        defaultMessage: 'Choose a space or page to connect to your project.',
        description: 'Description of the modal dialog to link a Confluence space or page to a Jira project'
    },
    placeholder: {
        id: 'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder',
        defaultMessage: 'Search Confluence',
        description: 'Placeholder to search a space or a page in Confluence to link to a Jira project'
    },
    'disconnected-templates-description': {
        id: 'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description',
        defaultMessage: 'This project needs to be connected to a space before you can create a page. Choose a space to connect to this project.',
        description: ''
    }
});

});

parcelRegister("5aAqT", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $0b372ff65a5e754b$export$3e9ef96ba97ea9dc);

var $czx3b = parcelRequire("czx3b");

var $2jDha = parcelRequire("2jDha");
const $0b372ff65a5e754b$export$871de8747c9eaa88 = (callbacks, componentName)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(callbacks, (value)=>({
            action: value,
            actionSubject: componentName
        }));
const $0b372ff65a5e754b$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>(WrappedComponent)=>// @ts-ignore
        (0, $2jDha.default)($0b372ff65a5e754b$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});
parcelRegister("czx3b", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9272640aa667e27d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $9272640aa667e27d$var$mapValues;

});



parcelRegister("jGyKS", function(module, exports) {

$parcel$export(module.exports, "getProject", () => $7436f90126d3e52c$export$637b60a42bb03f06);
$parcel$export(module.exports, "getProjectKey", () => $7436f90126d3e52c$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $7436f90126d3e52c$export$89040d072f281f85);
$parcel$export(module.exports, "getProjectType", () => $7436f90126d3e52c$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectName", () => $7436f90126d3e52c$export$2cd058184eb75757);
$parcel$export(module.exports, "getIsProjectMember", () => $7436f90126d3e52c$export$bf22b096835a2b37);
const $7436f90126d3e52c$export$637b60a42bb03f06 = (state)=>state.project;
const $7436f90126d3e52c$export$667f2a0f99c75faa = (state)=>state.project.key;
const $7436f90126d3e52c$export$89040d072f281f85 = (state)=>state.project.id;
const $7436f90126d3e52c$export$3dd0da95519c1a33 = (state)=>state.project.type;
const $7436f90126d3e52c$export$2cd058184eb75757 = (state)=>state.project.name;
const $7436f90126d3e52c$export$bf22b096835a2b37 = (state)=>state.project.isMember;

});


parcelRegister("ijyMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe5e7ba53872099d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gWxA1 = parcelRequire("gWxA1");
class $fe5e7ba53872099d$var$Content extends (0, $eUqFw.PureComponent) {
    render() {
        const { SpacePicker: SpacePicker, CreateSpaceLink: CreateSpaceLink, onCreateSpace: onCreateSpace, onSpaceSelected: onSpaceSelected } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SpacePicker, {
            onSelected: (value, analyticsEvent)=>{
                (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'spaceSelectedSpacePicker', {
                    isPageSelected: value.isPage
                });
                onSpaceSelected(value);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CreateSpaceLink, {
            onCreateSpace: (analyticsEvent)=>{
                (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'createdSpaceButton');
                onCreateSpace();
            }
        }));
    }
}
var $fe5e7ba53872099d$export$2e2bcd8739ae039 = $fe5e7ba53872099d$var$Content;

});
parcelRegister("gWxA1", function(module, exports) {

$parcel$export(module.exports, "fireAnalytics", () => $b7eea2a826f748b2$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $b7eea2a826f748b2$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $b7eea2a826f748b2$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $b7eea2a826f748b2$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $b7eea2a826f748b2$export$6f46fb37ad7d962b);

var $iTvqy = parcelRequire("iTvqy");


var $bJASI = parcelRequire("bJASI");
const $b7eea2a826f748b2$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $e779cc169fd2a347$export$2ceccf177fae277c));
};
const $b7eea2a826f748b2$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $b7eea2a826f748b2$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $bJASI.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $b7eea2a826f748b2$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $b7eea2a826f748b2$export$34ac71ce24cddec2(event, (0, $e779cc169fd2a347$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b7eea2a826f748b2$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $bJASI.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $b7eea2a826f748b2$export$34ac71ce24cddec2(event, (0, $e779cc169fd2a347$export$947dac6c72b26f81), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b7eea2a826f748b2$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $bJASI.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $b7eea2a826f748b2$export$34ac71ce24cddec2(event, (0, $e779cc169fd2a347$export$12346a674644c156), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b7eea2a826f748b2$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $bJASI.getImperativeAnalyticsDataFromArguments)(rest);
    $b7eea2a826f748b2$export$34ac71ce24cddec2(event, (0, $e779cc169fd2a347$export$f1d537d508d2945a), {
        attributes: attributes
    });
};

});
const $e779cc169fd2a347$export$f636b5b56f1d624a = 'Screen';
const $e779cc169fd2a347$export$9d2de6eebf7462b5 = 'Drawer';
const $e779cc169fd2a347$export$1171103ea9083ffa = 'Modal';
const $e779cc169fd2a347$export$cae2783c9279926 = 'InlineDialog';
const $e779cc169fd2a347$export$d1123261ca8831d2 = 'Dropdown';
const $e779cc169fd2a347$export$a1562d08625f5d7e = 'UI';
const $e779cc169fd2a347$export$947dac6c72b26f81 = 'TRACK';
const $e779cc169fd2a347$export$f1d537d508d2945a = 'SCREEN';
const $e779cc169fd2a347$export$12346a674644c156 = 'OPERATIONAL';
const $e779cc169fd2a347$export$2ceccf177fae277c = 'analyticsBridge';

parcelRegister("bJASI", function(module, exports) {

$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $c312bbf32bff530f$export$e6baab532ef8c6bf);
const $c312bbf32bff530f$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $c312bbf32bff530f$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $c312bbf32bff530f$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $c312bbf32bff530f$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $c312bbf32bff530f$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $c312bbf32bff530f$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $c312bbf32bff530f$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $c312bbf32bff530f$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $c312bbf32bff530f$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $c312bbf32bff530f$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $c312bbf32bff530f$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $c312bbf32bff530f$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});




parcelRegister("9AQpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dee4a5e2a112866$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $3pvFP = parcelRequire("3pvFP");

var $dJJDt = parcelRequire("dJJDt");

var $822Go = parcelRequire("822Go");
var $6dee4a5e2a112866$export$2e2bcd8739ae039 = (0, $cllCv.connect)((state)=>({
        errorState: (0, $dJJDt.getConnectSpaceDialogErrorState)(state),
        isSubmitAllowed: (0, $dJJDt.isSubmitAllowed)(state),
        isSubmitting: (0, $dJJDt.isConnectingSpace)(state),
        selectedSpace: (0, $dJJDt.getSelectedSpace)(state)
    }), (dispatch)=>({
        onFetch: ()=>dispatch((0, $3pvFP.fetchConfluenceSpaces)()),
        onConnect: ()=>dispatch((0, $3pvFP.connectConfluenceSpace)()),
        onCancel: ()=>dispatch((0, $3pvFP.hideConnectSpaceDialog)())
    }))((0, $822Go.default));

});
parcelRegister("822Go", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3fc3d04f8759051$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $bLFgh = parcelRequire("bLFgh");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");


var $gw74N = parcelRequire("gw74N");

var $lzRGK = parcelRequire("lzRGK");


var $gWxA1 = parcelRequire("gWxA1");

var $cDuJy = parcelRequire("cDuJy");
const $d3fc3d04f8759051$var$Footer = ({ isSubmitAllowed: isSubmitAllowed, isSubmitting: isSubmitting, errorState: errorState, selectedSpace: selectedSpace, onFetch: onFetch, onConnect: onConnect, onCancel: onCancel, intl: { formatMessage: formatMessage } })=>{
    const [hasError, setHasError] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        const test = errorState === (0, $9b5baad096b49e71$export$f5569b14a81f6409) || errorState === (0, $9b5baad096b49e71$export$a71624947af1f122) || false;
        setHasError(test);
    }, [
        errorState
    ]);
    const handleSubmit = (analyticsEvent)=>{
        const isPageSelected = selectedSpace?.isPage;
        if (errorState === (0, $9b5baad096b49e71$export$f5569b14a81f6409)) {
            onConnect();
            (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'retryConnectButton', {
                isPageSelected: isPageSelected
            });
        } else if (errorState === (0, $9b5baad096b49e71$export$a71624947af1f122)) {
            onFetch();
            (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'retryFetchButton', {
                isPageSelected: isPageSelected
            });
        } else {
            onConnect();
            (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'connectButton', {
                isPageSelected: isPageSelected
            });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cDuJy.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cDuJy.WrappedError), null, hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gw74N))), {
        spacing: "spacious",
        label: formatMessage((0, $lzRGK.default).error),
        color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`
    }), hasError && formatMessage((0, $lzRGK.default).connectionError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        isDisabled: isSubmitting,
        onClick: (_, analyticsEvent)=>{
            onCancel();
            (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'cancelButton');
        }
    }, formatMessage((0, $lzRGK.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        "data-test-id": "confluence-project-pages.post-expand.connect-or-update-space-modal.connect-button",
        appearance: "primary",
        isLoading: isSubmitting,
        isDisabled: !isSubmitAllowed,
        onClick: (_, analyticsEvent)=>handleSubmit(analyticsEvent)
    }, hasError ? formatMessage((0, $lzRGK.default).retry) : formatMessage((0, $lzRGK.default).connectSpace))));
};
var $d3fc3d04f8759051$export$2e2bcd8739ae039 = (0, $2qhQi.default)($d3fc3d04f8759051$var$Footer);

});
parcelRegister("lzRGK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8f071f36074f61$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2b8f071f36074f61$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    connectSpace: {
        id: 'project-pages.connect-space-dialog.footer.connect-space',
        defaultMessage: 'Connect',
        description: ''
    },
    cancel: {
        id: 'project-pages.connect-space-dialog.footer.cancel',
        defaultMessage: 'Cancel',
        description: ''
    },
    error: {
        id: 'project-pages.connect-space-dialog.error-icon',
        defaultMessage: 'Error:',
        description: ''
    },
    connectionError: {
        id: 'project-pages.connect-space-dialog.connection-error',
        defaultMessage: 'Connection failed.',
        description: ''
    },
    retry: {
        id: 'project-pages.connect-space-dialog.connection-retry',
        defaultMessage: 'Retry',
        description: ''
    }
});

});

const $9b5baad096b49e71$export$f5569b14a81f6409 = 'CONNECT_ERROR';
const $9b5baad096b49e71$export$a71624947af1f122 = 'FETCH_ERROR';
const $9b5baad096b49e71$export$2841857f996c7c26 = 'NO_ERROR';

parcelRegister("cDuJy", function(module, exports) {

$parcel$export(module.exports, "Container", () => $a81ba4046204831c$export$42a852a2b6b56249);
$parcel$export(module.exports, "WrappedError", () => $a81ba4046204831c$export$16ae3e28e3481b64);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $gw74N = parcelRequire("gw74N");

const $a81ba4046204831c$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-30h76f-0"
})({
    display: 'flex',
    justifyContent: 'space-between'
});
const $a81ba4046204831c$export$9d264cdddcb5f530 = /*#__PURE__*/ (0, $kwce8.default)((0, (/*@__PURE__*/$parcel$interopDefault($gw74N)))).withConfig({
    componentId: "sc-30h76f-1"
})({
    marginRight: "var(--ds-space-100, 8px)"
});
const $a81ba4046204831c$export$16ae3e28e3481b64 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-30h76f-2"
})({
    display: 'flex',
    alignItems: 'center',
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    fontSize: '12px'
});

});



parcelRegister("4mhsh", function(module, exports) {

$parcel$export(module.exports, "default", () => $01b066c433859c3c$export$2e2bcd8739ae039);

var $fFn3H = parcelRequire("fFn3H");
var $01b066c433859c3c$export$2e2bcd8739ae039 = (0, $fFn3H.default);

});
parcelRegister("fFn3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $93c11e9f7fa2bd0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $8bYJE = parcelRequire("8bYJE");
const $93c11e9f7fa2bd0e$var$Header = ({ intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h3", null, formatMessage((0, $8bYJE.default).title));
var $93c11e9f7fa2bd0e$export$2e2bcd8739ae039 = (0, $2qhQi.default)($93c11e9f7fa2bd0e$var$Header);

});
parcelRegister("8bYJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $aebbeeadad34ef79$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $aebbeeadad34ef79$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        id: 'project-pages.connect-space-or-page-dialog.header.title',
        defaultMessage: 'Connect project to Confluence',
        description: 'Title to connect a Jira project to Confluence'
    }
});

});



parcelRegister("1kxNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48621d6d6a6508b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");

var $kwce8 = parcelRequire("kwce8");

var $7kR5M = parcelRequire("7kR5M");

var $85INN = parcelRequire("85INN");

var $a1ivA = parcelRequire("a1ivA");
var $gWxA1 = parcelRequire("gWxA1");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f48621d6d6a6508b$var$FullWidthContainer = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1ygglpx-0"
})({
    width: '100%'
});
class $f48621d6d6a6508b$var$ConnectSpaceDialog extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            ModalDialog: null
        };
    }
    constructor(props){
        super(props);
        this.onDismissed = (_, analyticsEvent)=>{
            const { onCancel: onCancel } = this.props;
            onCancel && onCancel();
            (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'dismissedModalDialog');
        };
        const { ModalDialog: ModalDialog } = props;
        this.ModalDialogImpl = (0, $7kR5M.default)('connectSpaceModal', ModalDialog);
    }
    render() {
        const { Header: Header, Content: Content, Footer: Footer, isOpen: isOpen } = this.props;
        // eslint-disable-next-line no-undef
        if (false) return null;
        return isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(this.ModalDialogImpl, {
            width: 'small',
            shouldCloseOnEscapePress: true,
            onClose: this.onDismissed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48621d6d6a6508b$var$FullWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Content, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48621d6d6a6508b$var$FullWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Footer, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null)));
    }
}
var $f48621d6d6a6508b$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceName: "connectSpace",
        sourceType: (0, $e779cc169fd2a347$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48621d6d6a6508b$var$ConnectSpaceDialog, props));

});
parcelRegister("7kR5M", function(module, exports) {

$parcel$export(module.exports, "default", () => $28563b86cd1704c9$export$2e2bcd8739ae039);

var $1ngde = parcelRequire("1ngde");

var $aOw1G = parcelRequire("aOw1G");
var $28563b86cd1704c9$export$2e2bcd8739ae039 = (name, Component)=>(0, $1ngde.default)({
        componentName: name
    })(Component || (0, $aOw1G.default));

});

parcelRegister("85INN", function(module, exports) {

$parcel$export(module.exports, "default", () => $88b36a727bd8d5d1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gWxA1 = parcelRequire("gWxA1");
var $hF25J = parcelRequire("hF25J");
const $88b36a727bd8d5d1$var$ViewTracker = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hF25J.MountEvent), {
        onMount: (analyticsEvent)=>(0, $gWxA1.fireScreenAnalytics)(analyticsEvent)
    });
var $88b36a727bd8d5d1$export$2e2bcd8739ae039 = $88b36a727bd8d5d1$var$ViewTracker;

});
parcelRegister("hF25J", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $41c89a5ff8975a8a$export$2c6963927dbc68f1);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
class $41c89a5ff8975a8a$var$MountEventComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $41c89a5ff8975a8a$var$MountEventComponentWithHOC = (0, $2jDha.default)()($41c89a5ff8975a8a$var$MountEventComponent);
const $41c89a5ff8975a8a$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41c89a5ff8975a8a$var$MountEventComponentWithHOC, props);

});


parcelRegister("a1ivA", function(module, exports) {

$parcel$export(module.exports, "ContextWrapper", () => $0fc3fc62a7811fbb$export$34282a1f95511a11);

var $eUqFw = parcelRequire("eUqFw");

var $kkgbD = parcelRequire("kkgbD");

var $i7Fym = parcelRequire("i7Fym");

var $aw5Sy = parcelRequire("aw5Sy");
const $0fc3fc62a7811fbb$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD))));
};
const $0fc3fc62a7811fbb$export$34282a1f95511a11 = (props)=>{
    const data = $0fc3fc62a7811fbb$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children));
};

});



parcelRegister("fQ6dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $01f791dfe6aab997$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $d5OES = parcelRequire("d5OES");

var $4IoeL = parcelRequire("4IoeL");

var $fpLbJ = parcelRequire("fpLbJ");

var $cImV0 = parcelRequire("cImV0");

var $hbJmr = parcelRequire("hbJmr");
const $01f791dfe6aab997$var$mapStateToProps = (state)=>({
        Header: $cImV0.default,
        Content: $4IoeL.default,
        Footer: $fpLbJ.default,
        isOpen: (0, $d5OES.isCreateSpaceDialogOpen)(state)
    });
var $01f791dfe6aab997$export$2e2bcd8739ae039 = (0, $cllCv.connect)($01f791dfe6aab997$var$mapStateToProps)((0, $hbJmr.default));

});
parcelRegister("d5OES", function(module, exports) {

$parcel$export(module.exports, "isCreateSpaceDialogOpen", () => $565cf16c7683d5a2$export$9e106e7a4197025c);
$parcel$export(module.exports, "getCreateSpaceDialogErrorState", () => $565cf16c7683d5a2$export$b9a0f0708810ac97);
$parcel$export(module.exports, "isCreatingSpace", () => $565cf16c7683d5a2$export$83088c344f79a64b);
$parcel$export(module.exports, "isGeneratingKey", () => $565cf16c7683d5a2$export$80d139ccc3bd3ca3);
$parcel$export(module.exports, "isUserEnteredSpaceNameInvalid", () => $565cf16c7683d5a2$export$d91e14355a533343);
$parcel$export(module.exports, "getUserEnteredSpaceName", () => $565cf16c7683d5a2$export$f3d7f5a7926550e9);
const $565cf16c7683d5a2$export$9e106e7a4197025c = (state)=>state.ui.createSpaceDialog.createSpaceDialogOpen;
const $565cf16c7683d5a2$export$b9a0f0708810ac97 = (state)=>state.ui.createSpaceDialog.createSpaceDialogErrorState;
const $565cf16c7683d5a2$export$83088c344f79a64b = (state)=>state.ui.createSpaceDialog.creatingSpace;
const $565cf16c7683d5a2$export$80d139ccc3bd3ca3 = (state)=>state.ui.createSpaceDialog.generatingKey;
const $565cf16c7683d5a2$export$d91e14355a533343 = (state)=>state.ui.createSpaceDialog.userEnteredSpaceNameInvalid;
const $565cf16c7683d5a2$export$f3d7f5a7926550e9 = (state)=>state.ui.createSpaceDialog.userEnteredSpaceName;

});

parcelRegister("4IoeL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1865dc2d035ef7b$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $3pvFP = parcelRequire("3pvFP");

var $gilIH = parcelRequire("gilIH");

var $d5OES = parcelRequire("d5OES");

var $9t5hc = parcelRequire("9t5hc");
const $d1865dc2d035ef7b$var$mapStateToProps = (state)=>({
        spaceNameInvalid: (0, $d5OES.isUserEnteredSpaceNameInvalid)(state),
        userEnteredSpaceName: (0, $d5OES.getUserEnteredSpaceName)(state),
        isCreatingSpace: (0, $d5OES.isCreatingSpace)(state)
    });
const $d1865dc2d035ef7b$var$mapDispatchToProps = (dispatch)=>({
        onSpaceNameChanged: (value)=>dispatch((0, $3pvFP.changeSpaceName)(value)),
        onCreate: ()=>dispatch((0, $gilIH.createConfluenceSpace)())
    });
var $d1865dc2d035ef7b$export$2e2bcd8739ae039 = (0, $cllCv.connect)($d1865dc2d035ef7b$var$mapStateToProps, $d1865dc2d035ef7b$var$mapDispatchToProps)((0, $9t5hc.default));

});
parcelRegister("gilIH", function(module, exports) {

$parcel$export(module.exports, "CREATE_CONFLUENCE_SPACE", () => $3ceab71e56a8bd6e$export$cbaa153fef1dd1f1);
$parcel$export(module.exports, "createConfluenceSpace", () => $3ceab71e56a8bd6e$export$c9aee4801cf839af);
$parcel$export(module.exports, "CREATE_CONFLUENCE_SPACE_ERROR", () => $3ceab71e56a8bd6e$export$f2e869db106e2af3);
$parcel$export(module.exports, "createConfluenceSpaceError", () => $3ceab71e56a8bd6e$export$99a7810842156751);
const $3ceab71e56a8bd6e$export$cbaa153fef1dd1f1 = 'CREATE_CONFLUENCE_SPACE';
const $3ceab71e56a8bd6e$export$c9aee4801cf839af = (autoCreated)=>({
        type: $3ceab71e56a8bd6e$export$cbaa153fef1dd1f1,
        autoCreated: autoCreated
    });
const $3ceab71e56a8bd6e$export$f2e869db106e2af3 = 'CREATE_CONFLUENCE_SPACE_ERROR';
const $3ceab71e56a8bd6e$export$99a7810842156751 = ()=>({
        type: $3ceab71e56a8bd6e$export$f2e869db106e2af3
    });

});

parcelRegister("9t5hc", function(module, exports) {

$parcel$export(module.exports, "default", () => $57e2d6ec91c9d198$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $kwce8 = parcelRequire("kwce8");

var $cf2Y4 = parcelRequire("cf2Y4");

var $7jPhn = parcelRequire("7jPhn");

var $9ssSw = parcelRequire("9ssSw");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $57e2d6ec91c9d198$var$Container = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1w2omun-0"
})`margin-top:${"var(--ds-space-100, 8px)"};`;
class $57e2d6ec91c9d198$var$Content extends (0, $eUqFw.PureComponent) {
    render() {
        const { intl: { formatMessage: formatMessage }, isCreatingSpace: isCreatingSpace, spaceNameInvalid: spaceNameInvalid, userEnteredSpaceName: userEnteredSpaceName, onSpaceNameChanged: onSpaceNameChanged } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57e2d6ec91c9d198$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            autoFocus: true,
            isDisabled: isCreatingSpace,
            placeholder: formatMessage((0, $9ssSw.default).placeholder),
            onChange: (input)=>onSpaceNameChanged(input.target.value),
            onKeyPress: this.handleKeyPress,
            isInvalid: spaceNameInvalid,
            value: userEnteredSpaceName,
            label: "",
            maxLength: 80,
            "data-test-id": "confluence-project-pages.post-expand.create-space-modal.name-entry"
        }), spaceNameInvalid && this.renderAppropriateInvalidMessage()));
    }
    constructor(...args){
        super(...args);
        this.handleKeyPress = ({ key: key })=>{
            const { onCreate: onCreate, userEnteredSpaceName: userEnteredSpaceName } = this.props;
            const containsAtLeastTwoAlphanumericValues = (str)=>/[a-zA-Z0-9]{2,}/g.test(str);
            if (key === 'Enter' && containsAtLeastTwoAlphanumericValues(userEnteredSpaceName)) onCreate();
        };
        this.renderAppropriateInvalidMessage = ()=>{
            const { intl: { formatMessage: formatMessage }, userEnteredSpaceName: userEnteredSpaceName } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage(userEnteredSpaceName.length < 1 ? (0, $9ssSw.default).emptyName : (0, $9ssSw.default).invalidName));
        };
    }
}
var $57e2d6ec91c9d198$export$2e2bcd8739ae039 = (0, $2qhQi.default)($57e2d6ec91c9d198$var$Content);

});
parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");


var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    const messageRef = (0, $eUqFw.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $eUqFw.useState)(false);
    const { isWrapper: isWrapper } = (0, $eUqFw.useContext)($8d7fd15aabd72279$export$579aef2c392a54d4);
    (0, $eUqFw.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isWrapper: false
});
const $8d7fd15aabd72279$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $fbef6921e18df378$var$_success = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("50qGm")));
function $fbef6921e18df378$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $fbef6921e18df378$var$_success.default
    }));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = module.exports.default = $fbef6921e18df378$var$EditorSuccessIcon;

});
parcelRegister("50qGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a51a662974016bc$var$_react = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a51a662974016bc$var$_UNSAFE_baseNew = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a51a662974016bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a51a662974016bc$var$SuccessIcon = (props)=>/*#__PURE__*/ $3a51a662974016bc$var$_react.default.createElement($3a51a662974016bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3a51a662974016bc$var$SuccessIcon.displayName = 'SuccessIcon';
var $3a51a662974016bc$var$_default = module.exports.default = $3a51a662974016bc$var$SuccessIcon;

});


parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});


parcelRegister("9ssSw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3a5c9cff8d16d7f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c3a5c9cff8d16d7f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'project-pages.create-space-dialog.content.placeholder',
        defaultMessage: 'Enter a space name',
        description: ''
    },
    emptyName: {
        id: 'project-pages.create-space-dialog.content.empty-name',
        defaultMessage: 'Please give your space a name.',
        description: ''
    },
    invalidName: {
        id: 'project-pages.create-space-dialog.content.invalid-name',
        defaultMessage: 'Space names require at least one letter or number.',
        description: ''
    }
});

});



parcelRegister("fpLbJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $62fba0c09a12439e$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $3pvFP = parcelRequire("3pvFP");

var $gilIH = parcelRequire("gilIH");

var $hMy8N = parcelRequire("hMy8N");

var $d5OES = parcelRequire("d5OES");

var $bcEUw = parcelRequire("bcEUw");
const $62fba0c09a12439e$export$c31df4bd766f9c35 = (state)=>({
        isCreatingSpace: (0, $d5OES.isCreatingSpace)(state),
        isGeneratingKey: (0, $d5OES.isGeneratingKey)(state),
        suggestedKey: (0, $hMy8N.getSuggestedKey)(state),
        userEnteredSpaceName: (0, $d5OES.getUserEnteredSpaceName)(state),
        userEnteredSpaceNameInvalid: (0, $d5OES.isUserEnteredSpaceNameInvalid)(state),
        errorState: (0, $d5OES.getCreateSpaceDialogErrorState)(state)
    });
const $62fba0c09a12439e$export$9e6a17cf56877796 = (dispatch)=>({
        onSpaceNameChanged: (value)=>dispatch((0, $3pvFP.changeSpaceName)(value)),
        onCreate: ()=>dispatch((0, $gilIH.createConfluenceSpace)())
    });
var $62fba0c09a12439e$export$2e2bcd8739ae039 = (0, $cllCv.connect)($62fba0c09a12439e$export$c31df4bd766f9c35, $62fba0c09a12439e$export$9e6a17cf56877796)((0, $bcEUw.default));

});
parcelRegister("bcEUw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c25e357e18d8a0c1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $kwce8 = parcelRequire("kwce8");

var $bLFgh = parcelRequire("bLFgh");

var $7u4fN = parcelRequire("7u4fN");

var $gw74N = parcelRequire("gw74N");

var $4Bees = parcelRequire("4Bees");



var $gWxA1 = parcelRequire("gWxA1");

var $eB5WF = parcelRequire("eB5WF");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c25e357e18d8a0c1$var$Container = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1or2l73-0"
})({
    display: 'flex',
    justifyContent: 'flex-end'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c25e357e18d8a0c1$var$WrappedErrorIcon = /*#__PURE__*/ (0, $kwce8.default)((0, (/*@__PURE__*/$parcel$interopDefault($gw74N)))).withConfig({
    componentId: "sc-1or2l73-1"
})({
    marginRight: "var(--ds-space-100, 8px)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c25e357e18d8a0c1$var$ConnectionFailed = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1or2l73-2"
})({
    alignItems: 'center',
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    display: 'flex',
    fontSize: '12px',
    lineHeight: 1.25
});
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c25e357e18d8a0c1$var$SpinnerDiv = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1or2l73-3"
})({
    display: 'inline-block',
    marginRight: "var(--ds-space-100, 8px)",
    position: 'relative',
    top: "var(--ds-space-075, 6px)"
});
class $c25e357e18d8a0c1$var$Footer extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            errorState: (0, $a4d39a31ee3c5204$export$2841857f996c7c26)
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { isCreatingSpace: isCreatingSpace, isGeneratingKey: isGeneratingKey, errorState: errorState, suggestedKey: suggestedKey, onSpaceNameChanged: onSpaceNameChanged, onCreate: onCreate, onCancel: onCancel, userEnteredSpaceName: userEnteredSpaceName, userEnteredSpaceNameInvalid: userEnteredSpaceNameInvalid } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c25e357e18d8a0c1$var$Container, null, errorState === (0, $a4d39a31ee3c5204$export$d822474b2a7c6d59) && this.renderConnectionError((analyticsEvent)=>{
            onSpaceNameChanged(userEnteredSpaceName);
            (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'retrySpaceNameChangeButton');
        }), errorState === (0, $a4d39a31ee3c5204$export$58e5d3e30f50fa06) && this.renderConnectionError((analyticsEvent)=>{
            onCreate();
            (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'retrySpaceNameChangeButton');
        }), (isCreatingSpace || isGeneratingKey) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c25e357e18d8a0c1$var$SpinnerDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            isDisabled: isCreatingSpace,
            onClick: (_, analyticsEvent)=>{
                (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'cancelButton');
                onCancel();
            }
        }, formatMessage((0, $eB5WF.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            isDisabled: userEnteredSpaceNameInvalid || !suggestedKey || isCreatingSpace || isGeneratingKey,
            onClick: (_, analyticsEvent)=>{
                (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'createButton');
                onCreate();
            },
            "data-test-id": "confluence-project-pages.post-expand.create-space-modal.create-button"
        }, formatMessage((0, $eB5WF.default).createSpace))));
    }
    constructor(...args){
        super(...args);
        this.renderConnectionError = (onRetry)=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c25e357e18d8a0c1$var$ConnectionFailed, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c25e357e18d8a0c1$var$WrappedErrorIcon, {
                label: formatMessage((0, $eB5WF.default).error),
                color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`
            }), formatMessage((0, $eB5WF.default).connectionError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
                appearance: "link",
                onClick: (event, analyticsEvent)=>{
                    onRetry(analyticsEvent);
                }
            }, formatMessage((0, $eB5WF.default).retry)));
        };
    }
}
var $c25e357e18d8a0c1$export$2e2bcd8739ae039 = (0, $2qhQi.default)($c25e357e18d8a0c1$var$Footer);

});
const $a4d39a31ee3c5204$export$2841857f996c7c26 = 'NO_ERROR';
const $a4d39a31ee3c5204$export$d822474b2a7c6d59 = 'KEY_ERROR';
const $a4d39a31ee3c5204$export$58e5d3e30f50fa06 = 'CREATE_ERROR';

parcelRegister("eB5WF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eb069814a06f84f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7eb069814a06f84f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createSpace: {
        id: 'project-pages.create-space-dialog.footer.create-space',
        defaultMessage: 'Create',
        description: ''
    },
    cancel: {
        id: 'project-pages.create-space-dialog.footer.cancel',
        defaultMessage: 'Cancel',
        description: ''
    },
    error: {
        id: 'project-pages.create-space-dialog.error-icon',
        defaultMessage: 'Error:',
        description: ''
    },
    connectionError: {
        id: 'project-pages.create-space-dialog.connection-error',
        defaultMessage: 'Connection failed.',
        description: ''
    },
    creationError: {
        id: 'project-pages.create-space-dialog.creation-error',
        defaultMessage: 'Space creation failed.',
        description: ''
    },
    retry: {
        id: 'project-pages.create-space-dialog.connection-retry',
        defaultMessage: 'Retry',
        description: ''
    }
});

});



parcelRegister("cImV0", function(module, exports) {

$parcel$export(module.exports, "default", () => $dac6547de59586d5$export$2e2bcd8739ae039);

var $OOuGY = parcelRequire("OOuGY");
var $dac6547de59586d5$export$2e2bcd8739ae039 = (0, $OOuGY.default);

});
parcelRegister("OOuGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e9eb69f563eb60c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $iwqaP = parcelRequire("iwqaP");
const $8e9eb69f563eb60c$var$Header = ({ intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h3", null, formatMessage((0, $iwqaP.default).title));
var $8e9eb69f563eb60c$export$2e2bcd8739ae039 = (0, $2qhQi.default)($8e9eb69f563eb60c$var$Header);

});
parcelRegister("iwqaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $850a7d08ec999673$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $850a7d08ec999673$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        id: 'project-pages.create-space-dialog.header.title',
        defaultMessage: 'Create new Confluence space',
        description: ''
    }
});

});



parcelRegister("hbJmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $682bc2cdb598e0dd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");

var $kwce8 = parcelRequire("kwce8");

var $7kR5M = parcelRequire("7kR5M");

var $a1ivA = parcelRequire("a1ivA");
var $gWxA1 = parcelRequire("gWxA1");

var $85INN = parcelRequire("85INN");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $682bc2cdb598e0dd$var$FullWidthContainer = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1qf4r6s-0"
})({
    width: '100%'
});
class $682bc2cdb598e0dd$var$CreateSpaceDialog extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            ModalDialog: null
        };
    }
    constructor(props){
        super(props);
        this.onDismissed = (_, analyticsEvent)=>{
            const { onCancel: onCancel } = this.props;
            onCancel && onCancel();
            (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'dismissedModalDialog');
        };
        const { ModalDialog: ModalDialog } = props;
        this.ModalDialogImpl = (0, $7kR5M.default)('createSpaceModal', ModalDialog);
    }
    render() {
        const { Header: Header, Content: Content, Footer: Footer, isOpen: isOpen, onCancel: onCancel, onOpenComplete: onOpenComplete } = this.props;
        // eslint-disable-next-line no-undef
        if (false) return null;
        return isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(this.ModalDialogImpl, {
            onOpenComplete: onOpenComplete,
            width: 'small',
            shouldCloseOnEscapePress: true,
            onClose: this.onDismissed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($682bc2cdb598e0dd$var$FullWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Content, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($682bc2cdb598e0dd$var$FullWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Footer, {
            onCancel: onCancel
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null));
    }
}
var $682bc2cdb598e0dd$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceName: "createSpace",
        sourceType: (0, $e779cc169fd2a347$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($682bc2cdb598e0dd$var$CreateSpaceDialog, props));

});


parcelRegister("e6aAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $161178bc010d2efb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $220ac = parcelRequire("220ac");

var $iPBkV = parcelRequire("iPBkV");

var $bSiqi = parcelRequire("bSiqi");

var $48Bjb = parcelRequire("48Bjb");

var $j5YY5 = parcelRequire("j5YY5");
const $161178bc010d2efb$var$MountTracker = (0, $48Bjb.default)('confluenceActivatingEmptyState');
const $161178bc010d2efb$var$ConfluenceActivating = ({ intl: { formatMessage: formatMessage } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        size: "wide",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($bSiqi))),
        maxImageWidth: 82,
        header: formatMessage((0, $iPBkV.default).heading),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $iPBkV.default).description,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j5YY5.default), {
                        label: chunks
                    })
            }
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($161178bc010d2efb$var$MountTracker, null));
};
var $161178bc010d2efb$export$2e2bcd8739ae039 = (0, $2qhQi.default)($161178bc010d2efb$var$ConfluenceActivating);

});
parcelRegister("iPBkV", function(module, exports) {

$parcel$export(module.exports, "default", () => $442b24f23051e5da$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $442b24f23051e5da$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        id: 'project-pages.activating.heading',
        defaultMessage: 'Confluence is still loading',
        description: 'Heading when Confluence is active but not ready'
    },
    description: {
        id: 'project-pages.activating.description',
        defaultMessage: "The connected Confuence space isn\u2019t quite ready yet. {contactSupport} if refreshing doesn\u2019t fix things.",
        description: 'Description when Confluence is active but not ready'
    }
});

});

parcelRegister("bSiqi", function(module, exports) {
module.exports = new URL("gears.ffa28e68.svg", import.meta.url).toString();

});

parcelRegister("48Bjb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b9e5ce171780ba9$export$2e2bcd8739ae039);

var $gWxA1 = parcelRequire("gWxA1");
var $hF25J = parcelRequire("hF25J");

var $eUqFw = parcelRequire("eUqFw");
const $5b9e5ce171780ba9$var$COMPONENT_MOUNTED_EVENT_ACTION = 'mounted';
var $5b9e5ce171780ba9$export$2e2bcd8739ae039 = (componentName)=>(attributes)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hF25J.MountEvent), {
            onMount: (analyticsEvent)=>(0, $gWxA1.fireOperationalAnalytics)(analyticsEvent, `${componentName} ${$5b9e5ce171780ba9$var$COMPONENT_MOUNTED_EVENT_ACTION}`, {
                    attributes: attributes
                })
        });

});

parcelRegister("j5YY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $83db6f624466b900$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jihEd = parcelRequire("jihEd");

var $gWxA1 = parcelRequire("gWxA1");

var $5OdZ3 = parcelRequire("5OdZ3");

var $5JgJ2 = parcelRequire("5JgJ2");
const $83db6f624466b900$var$ContactSupport = ({ label: label })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        analyticsEvent.update({
            actionSubject: 'link'
        });
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'contactSupportLink');
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
        href: "https://support.atlassian.com/contact/",
        target: "_blank",
        rel: "noopener",
        onClick: handleClick
    }, label ?? formatMessage((0, $jihEd.default).linkText));
};
var $83db6f624466b900$export$2e2bcd8739ae039 = $83db6f624466b900$var$ContactSupport;

});
parcelRegister("jihEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $36d3f9499bc6bb64$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $36d3f9499bc6bb64$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    linkText: {
        id: 'project-pages.improvement.contact-support',
        defaultMessage: 'Contact support',
        description: 'Link text for contacting support'
    }
});

});



parcelRegister("khgCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1376b5db98a152f$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $7KIVa = parcelRequire("7KIVa");

var $jGyKS = parcelRequire("jGyKS");
var $e1376b5db98a152f$export$2e2bcd8739ae039 = (0, $cllCv.connect)((state)=>({
        isProjectMember: (0, $jGyKS.getIsProjectMember)(state)
    }), {})((0, $7KIVa.ConnectSpace));

});
parcelRegister("7KIVa", function(module, exports) {

$parcel$export(module.exports, "ConnectSpace", () => $666c9d5cb1890564$export$741341fabd43a51f);

var $eUqFw = parcelRequire("eUqFw");

var $6c6eZ = parcelRequire("6c6eZ");

var $g3l4r = parcelRequire("g3l4r");
const $666c9d5cb1890564$export$741341fabd43a51f = ({ isProjectMember: isProjectMember })=>{
    switch(isProjectMember){
        case true:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6c6eZ.default), null);
        case false:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3l4r.default), null);
        default:
            return null; // isProjectMember = undefined (still fetching), don't render anything yet
    }
};

});
parcelRegister("6c6eZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $116a0dc99e105012$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $3pvFP = parcelRequire("3pvFP");

var $gYHNJ = parcelRequire("gYHNJ");
var $116a0dc99e105012$export$2e2bcd8739ae039 = (0, $cllCv.connect)(null, (dispatch)=>({
        showConnectSpaceDialog: ()=>{
            dispatch((0, $3pvFP.showConnectSpaceDialog)());
            dispatch((0, $3pvFP.fetchConfluenceSpaces)());
        }
    }))((0, $gYHNJ.default));

});
parcelRegister("gYHNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $441ac5a770483403$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $6zOB7 = parcelRequire("6zOB7");

var $220ac = parcelRequire("220ac");

var $gWxA1 = parcelRequire("gWxA1");

var $hH699 = parcelRequire("hH699");

var $hs5te = parcelRequire("hs5te");

var $48Bjb = parcelRequire("48Bjb");
const $441ac5a770483403$var$MountTracker = (0, $48Bjb.default)('connectSpaceEmptyState');
const $441ac5a770483403$var$CanConnect = ({ intl: { formatMessage: formatMessage }, showConnectSpaceDialog: showConnectSpaceDialog })=>{
    const handleConfirmClick = (_, analyticsEvent)=>{
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'connectSpaceButton');
        showConnectSpaceDialog();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        size: "wide",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hs5te))),
        maxImageWidth: 101,
        header: formatMessage((0, $hH699.default).granularPagesConnectSpaceHeading),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            onClick: handleConfirmClick
        }, formatMessage((0, $hH699.default).granularPagesConnectSpaceButton))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($441ac5a770483403$var$MountTracker, null));
};
var $441ac5a770483403$export$2e2bcd8739ae039 = (0, $2qhQi.default)($441ac5a770483403$var$CanConnect);

});
parcelRegister("hH699", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f35a0751b6a7a0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f8f35a0751b6a7a0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    connectSpaceDescription: {
        id: 'project-pages.connect-space.description',
        defaultMessage: 'Spaces are like folders - you can use them to create, organize, and collaborate on all the content related to your project.',
        description: ''
    },
    granularPagesConnectSpaceHeading: {
        id: 'project-pages.granular-pages.connect-space.heading',
        defaultMessage: 'Connect this project to a Confluence space or page',
        description: 'Heading when a Confluence space or page is not connected to a Jira project'
    },
    granularPagesConnectSpaceButton: {
        id: 'project-pages.granular-pages.connect-space.button',
        defaultMessage: 'Connect to Confluence',
        description: 'Button to connect a Jira project to a Confluence space or page'
    }
});

});

parcelRegister("hs5te", function(module, exports) {
module.exports = new URL("file-cabinet.6176e2f0.svg", import.meta.url).toString();

});



parcelRegister("g3l4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac86ce6bad888f06$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $220ac = parcelRequire("220ac");

var $3WPJb = parcelRequire("3WPJb");

var $h43I4 = parcelRequire("h43I4");

var $48Bjb = parcelRequire("48Bjb");
const $ac86ce6bad888f06$var$MountTracker = (0, $48Bjb.default)('connectSpaceNoPermissionEmptyState');
const $ac86ce6bad888f06$var$NoPermission = ({ intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        size: "wide",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($h43I4))),
        maxImageWidth: 201,
        header: formatMessage((0, $3WPJb.default).heading),
        description: formatMessage((0, $3WPJb.default).description)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac86ce6bad888f06$var$MountTracker, null));
var $ac86ce6bad888f06$export$2e2bcd8739ae039 = (0, $2qhQi.default)($ac86ce6bad888f06$var$NoPermission);

});
parcelRegister("3WPJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b03f1f06914162ff$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b03f1f06914162ff$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    description: {
        id: 'project-pages.connect-space.not-connected.description',
        defaultMessage: 'To use project pages, contact your admin or team lead to connect Confluence to this project.',
        description: 'Page content when project pages is not connected to Confluence but the user does not have permission to connect it'
    },
    heading: {
        id: 'project-pages.connect-space.not-connected.heading',
        defaultMessage: 'Not connected to Confluence',
        description: 'Page headding when project pages is not connected to Confluence but the user does not have permission to connect it'
    }
});

});

parcelRegister("h43I4", function(module, exports) {
module.exports = new URL("plug.96aead60.svg", import.meta.url).toString();

});




parcelRegister("fOSB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeb85c3ee378d7b8$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $3pvFP = parcelRequire("3pvFP");

var $4aXoz = parcelRequire("4aXoz");


var $9yekW = parcelRequire("9yekW");

var $jGyKS = parcelRequire("jGyKS");


var $gu0D4 = parcelRequire("gu0D4");

var $hXy49 = parcelRequire("hXy49");
const $aeb85c3ee378d7b8$var$mapStateToProps = (state)=>({
        spaceKey: (0, $4aXoz.getProjectSpaceKey)(state),
        contentId: (0, $4aXoz.getProjectPageLinkedId)(state),
        permissionState: (0, $4aXoz.getBlueprintsState)(state),
        confluenceLisenseStatus: (0, $9yekW.getConfluenceLicenseStatus)(state),
        projectSpacePageTitleHasBeenFetched: (0, $4aXoz.getProjectSpacePageTitleHasBeenFetched)(state),
        projectId: (0, $jGyKS.getProjectId)(state),
        projectType: (0, $jGyKS.getProjectType)(state),
        blueprints: (0, $4aXoz.getBlueprints)(state),
        isConfluenceActivationCompleteForPreselectedTemplate: (0, $hXy49.isConfluenceActivationCompleteForPreselectedTemplate)(state)
    });
const $aeb85c3ee378d7b8$var$mapDispatchToProps = (dispatch)=>({
        onError: ()=>dispatch((0, $3pvFP.showError)())
    });
var $aeb85c3ee378d7b8$export$2e2bcd8739ae039 = (0, $cllCv.connect)($aeb85c3ee378d7b8$var$mapStateToProps, $aeb85c3ee378d7b8$var$mapDispatchToProps, ({ blueprints: blueprints, isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate, permissionState: permissionState, confluenceLisenseStatus: confluenceLisenseStatus, projectSpacePageTitleHasBeenFetched: projectSpacePageTitleHasBeenFetched, contentId: contentId, spaceKey: spaceKey, projectId: projectId, projectType: projectType }, dispatchProps, ownProps)=>{
    const shouldPopulateDataFields = ![
        (0, $eda5adb3daefc3fa$export$52022723d6fe5666),
        (0, $eda5adb3daefc3fa$export$bde25b564fc94248)
    ].includes(confluenceLisenseStatus) && projectSpacePageTitleHasBeenFetched;
    return {
        blueprints: blueprints,
        isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate,
        contentId: shouldPopulateDataFields ? contentId : null,
        spaceKey: shouldPopulateDataFields ? spaceKey : null,
        projectId: projectId,
        projectType: projectType,
        readOnly: permissionState !== (0, $d01310c7d13ad40a$export$c6813a8d51f77eaf),
        ...dispatchProps,
        ...ownProps
    };
})((0, $gu0D4.PageTree));

});
parcelRegister("gu0D4", function(module, exports) {

$parcel$export(module.exports, "PageTree", () => $101e261407a74464$export$73500bf5f2e2b0c4);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("hPmJU");
var $eJiiU = parcelRequire("eJiiU");
var $1QBZx = parcelRequire("1QBZx");
var $kQ8I0 = parcelRequire("kQ8I0");
var $6K8He = parcelRequire("6K8He");
var $a9Brc = parcelRequire("a9Brc");

var $a1ivA = parcelRequire("a1ivA");

var $48Bjb = parcelRequire("48Bjb");

var $kqxVx = parcelRequire("kqxVx");

var $hFx9Z = parcelRequire("hFx9Z");

var $brKSp = parcelRequire("brKSp");

var $4iCLc = parcelRequire("4iCLc");

var $iCgZp = parcelRequire("iCgZp");

var $12kyE = parcelRequire("12kyE");
var $6Qy8u = parcelRequire("6Qy8u");
var $kDfSL = parcelRequire("kDfSL");
var $9IbuV = parcelRequire("9IbuV");

var $hTSL3 = parcelRequire("hTSL3");

var $4Dxzk = parcelRequire("4Dxzk");
const $101e261407a74464$var$ufoExperienceTracker = new (0, $kDfSL.UFOExperience)('project-pages-embedded-page-tree', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $12kyE.ExperienceTypes).Load,
    featureFlags: (0, $hTSL3.getAllBooleanFeatureFlagKeys)()
});
const $101e261407a74464$var$MountTracker = (0, $48Bjb.default)('confluencePageTree');
const $101e261407a74464$export$73500bf5f2e2b0c4 = ({ blueprints: blueprints, contentId: contentId, isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate, spaceKey: spaceKey, readOnly: readOnly, EmbeddedProductUpdater: EmbeddedProductUpdater, projectId: projectId, projectType: projectType, showDraftToggle: showDraftToggle = true })=>{
    (0, $9IbuV.useUFOComponentExperience)($101e261407a74464$var$ufoExperienceTracker);
    const { treeState: treeState, setContent: setContent, setProjectData: setProjectData } = (0, $a9Brc.useConfluencePageTree)();
    const { setEmbeddedPage: setEmbeddedPage } = (0, $4iCLc.useEmbeddedPage)();
    const showRealTree = treeState === (0, $6K8He.TreeStates).RenderedChildren;
    const isTreeLoaded = treeState !== (0, $6K8He.TreeStates).Loading && treeState !== null;
    const { cloudId: cloudId, locale: locale } = (0, $kqxVx.useProjectPages)();
    const handleEdit = (0, $eUqFw.useCallback)((page)=>{
        if (!page.hasEmbeddedEdit) window.open(page.editUrl, '_blank');
        else setEmbeddedPage({
            isOpen: true,
            isLoading: true,
            page: page,
            mode: page.isLive ? 'view' : 'edit'
        });
    }, [
        setEmbeddedPage
    ]);
    const handleView = (0, $eUqFw.useCallback)((page)=>{
        if (page.type !== (0, $1QBZx.ContentType).PAGE) window.open(page.url, '_blank');
        else setEmbeddedPage({
            isOpen: true,
            isLoading: true,
            page: page,
            mode: 'view'
        });
    }, [
        setEmbeddedPage
    ]);
    const createEmbeddedPage = (0, $iCgZp.useCreateEmbeddedPage)({
        spaceKey: spaceKey,
        projectId: projectId,
        projectType: projectType
    });
    const handleAddChildPage = (0, $eUqFw.useCallback)(async (parentContentId)=>{
        await createEmbeddedPage(parentContentId, false);
    }, [
        createEmbeddedPage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (spaceKey) setContent(spaceKey, contentId || undefined);
        setProjectData(projectId, projectType);
    }, [
        contentId,
        setContent,
        spaceKey,
        setProjectData,
        projectId,
        projectType
    ]);
    const pageTree = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceType: (0, $e779cc169fd2a347$export$f636b5b56f1d624a),
        sourceName: "projectPages"
    }, isTreeLoaded && showDraftToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ8I0.default), {
        locale: locale
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brKSp.DisplayWrapper), {
        isShown: showRealTree
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJiiU.ConfluencePageTree), {
        key: `${spaceKey}${contentId}`,
        cloudId: cloudId,
        readOnly: readOnly,
        onEdit: handleEdit,
        onView: handleView,
        onAddChildPage: handleAddChildPage,
        locale: locale
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFx9Z.PageTreePlaceholder), {
        treeState: treeState
    })), showRealTree && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EmbeddedProductUpdater, {
        embeddedProduct: "confluence"
    }), isTreeLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Qy8u.ExperienceSuccess), {
        experience: $101e261407a74464$var$ufoExperienceTracker
    }), isTreeLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Dxzk.ShowUserPreselectedTemplateExperiment), {
        blueprints: blueprints,
        createEmbeddedPage: createEmbeddedPage,
        contentId: contentId,
        isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($101e261407a74464$var$MountTracker, null));
    // ConfluencePageTreeProvider includes the AnalyticsProvider already
    return pageTree;
};

});
parcelRegister("hPmJU", function(module, exports) {

$parcel$export(module.exports, "TreeStates", () => (parcelRequire("6K8He")).TreeStates);
$parcel$export(module.exports, "ContentType", () => (parcelRequire("1QBZx")).ContentType);
$parcel$export(module.exports, "ConfluencePageTree", () => (parcelRequire("eJiiU")).ConfluencePageTree);
$parcel$export(module.exports, "DraftsToggle", () => (parcelRequire("kQ8I0")).default);
$parcel$export(module.exports, "ConfluencePageTreeProvider", () => (parcelRequire("03Jpi")).ConfluencePageTreeProvider);
$parcel$export(module.exports, "useConfluencePageTree", () => (parcelRequire("a9Brc")).useConfluencePageTree);
$parcel$export(module.exports, "pageAnalyticsAttributes", () => (parcelRequire("aM4Um")).pageAnalyticsAttributes);

var $6K8He = parcelRequire("6K8He");

var $1QBZx = parcelRequire("1QBZx");

var $hfG2L = parcelRequire("hfG2L");

var $eJiiU = parcelRequire("eJiiU");

var $kQ8I0 = parcelRequire("kQ8I0");

var $03Jpi = parcelRequire("03Jpi");

var $a9Brc = parcelRequire("a9Brc");

var $aM4Um = parcelRequire("aM4Um");

});
parcelRegister("6K8He", function(module, exports) {

$parcel$export(module.exports, "Errors", () => $1cddeab5b918ee80$export$b8e9cd941e8016ac);
$parcel$export(module.exports, "TreeStates", () => $1cddeab5b918ee80$export$4b8251500bedd042);
var $1cddeab5b918ee80$export$e2e108cbe2e4f865;
(function(ContentType) {
    ContentType["PAGE"] = "page";
    ContentType["WHITEBOARD"] = "whiteboard";
})($1cddeab5b918ee80$export$e2e108cbe2e4f865 || ($1cddeab5b918ee80$export$e2e108cbe2e4f865 = {}));
var $1cddeab5b918ee80$export$b8e9cd941e8016ac;
(function(Errors) {
    Errors["Error"] = "error";
    Errors["Empty"] = "empty";
})($1cddeab5b918ee80$export$b8e9cd941e8016ac || ($1cddeab5b918ee80$export$b8e9cd941e8016ac = {}));
var $1cddeab5b918ee80$export$4b8251500bedd042;
(function(TreeStates) {
    TreeStates["Loading"] = "loading";
    TreeStates["RenderedChildren"] = "rendered-children";
    TreeStates["Empty"] = "empty";
    TreeStates["Error"] = "error";
})($1cddeab5b918ee80$export$4b8251500bedd042 || ($1cddeab5b918ee80$export$4b8251500bedd042 = {}));

});

parcelRegister("1QBZx", function(module, exports) {

$parcel$export(module.exports, "ContentType", () => $f4046f5129d77227$export$e2e108cbe2e4f865);
var $f4046f5129d77227$export$e2e108cbe2e4f865;
(function(ContentType) {
    ContentType["PAGE"] = "page";
    ContentType["WHITEBOARD"] = "whiteboard";
})($f4046f5129d77227$export$e2e108cbe2e4f865 || ($f4046f5129d77227$export$e2e108cbe2e4f865 = {}));

});

parcelRegister("hfG2L", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $ed9c00fba457f6e3$export$1b581a2ec13e37f1);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");

var $b8H1q = parcelRequire("b8H1q");
const $ed9c00fba457f6e3$export$1b581a2ec13e37f1 = ({ children: children, analyticsClient: analyticsClient })=>{
    const sendEvent = (0, $eUqFw.useCallback)((event)=>{
        const { type: type, payload: payload } = event;
        switch(type){
            case 0, $e779cc169fd2a347$export$a1562d08625f5d7e:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.sendUIEvent(payload);
                break;
            case 0, $e779cc169fd2a347$export$947dac6c72b26f81:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.sendTrackEvent(payload);
                break;
            case 0, $e779cc169fd2a347$export$12346a674644c156:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.sendOperationalEvent(payload);
                break;
            case 0, $e779cc169fd2a347$export$f1d537d508d2945a:
                analyticsClient.sendScreenEvent(payload.name, null, payload.attributes);
                break;
            default:
                break;
        }
    }, [
        analyticsClient
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
        channel: (0, $e779cc169fd2a347$export$2ceccf177fae277c),
        onEvent: (event)=>sendEvent((0, $b8H1q.extractAWCDataFromEvent)(event))
    }, children);
};

});
parcelRegister("b8H1q", function(module, exports) {

$parcel$export(module.exports, "extractAWCDataFromEvent", () => $e05a2371d0a41288$export$1c850cf68c053906);

var $kkgbD = parcelRequire("kkgbD");

var $i7Fym = parcelRequire("i7Fym");


var $dI4J1 = parcelRequire("dI4J1");
const $e05a2371d0a41288$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $dI4J1.getAnalyticsType)(castedEvent);
    const attributes = (0, $dI4J1.getAttributes)(castedEvent);
    const source = (0, $dI4J1.getSource)(castedEvent);
    const actionSubject = (0, $dI4J1.getActionSubject)(castedEvent);
    if (analyticsType === (0, $e779cc169fd2a347$export$f1d537d508d2945a)) return {
        type: (0, $e779cc169fd2a347$export$f1d537d508d2945a),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $e779cc169fd2a347$export$a1562d08625f5d7e:
        case 0, $e779cc169fd2a347$export$947dac6c72b26f81:
        case 0, $e779cc169fd2a347$export$12346a674644c156:
            {
                const action = (0, $dI4J1.getAction)(castedEvent);
                const actionSubjectId = (0, $dI4J1.getActionSubjectId)(castedEvent);
                const containerId = (0, $dI4J1.getContainerId)(castedEvent);
                const containerType = (0, $dI4J1.getContainerType)(castedEvent);
                const objectId = (0, $dI4J1.getObjectId)(castedEvent);
                const objectType = (0, $dI4J1.getObjectType)(castedEvent);
                const tags = (0, $dI4J1.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
parcelRegister("dI4J1", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsType", () => $3ca2da368a81a168$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $3ca2da368a81a168$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $3ca2da368a81a168$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $3ca2da368a81a168$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $3ca2da368a81a168$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $3ca2da368a81a168$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $3ca2da368a81a168$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $3ca2da368a81a168$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $3ca2da368a81a168$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $3ca2da368a81a168$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $3ca2da368a81a168$export$af63d7414243dad3);

var $6ZDS2 = parcelRequire("6ZDS2");

var $kkgbD = parcelRequire("kkgbD");

var $iTvqy = parcelRequire("iTvqy");

var $2vzCR = parcelRequire("2vzCR");

var $i7Fym = parcelRequire("i7Fym");

var $MdoH4 = parcelRequire("MdoH4");
const $3ca2da368a81a168$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $3ca2da368a81a168$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $3ca2da368a81a168$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $3ca2da368a81a168$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $3ca2da368a81a168$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD))));
};
const $3ca2da368a81a168$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'source').filter(Boolean));
const $3ca2da368a81a168$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $3ca2da368a81a168$export$6ca3170acb89054 = (event)=>event.payload.action;
const $3ca2da368a81a168$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $3ca2da368a81a168$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'containerId').filter(Boolean));
const $3ca2da368a81a168$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'containerType').filter(Boolean));
const $3ca2da368a81a168$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'objectId').filter(Boolean));
const $3ca2da368a81a168$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'objectType').filter(Boolean));
const $3ca2da368a81a168$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))((0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))($3ca2da368a81a168$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};

});



parcelRegister("eJiiU", function(module, exports) {

$parcel$export(module.exports, "ConfluencePageTree", () => $373da97e357f7bcd$export$bb03c987203d806f);

var $eUqFw = parcelRequire("eUqFw");

var $e75AZ = parcelRequire("e75AZ");

var $j7dt3 = parcelRequire("j7dt3");
const $373da97e357f7bcd$export$bb03c987203d806f = ({ locale: locale = (0, $j7dt3.DEFAULT_LOCALE), ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7dt3.TranslationsProvider), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e75AZ.default), props));
};

});
parcelRegister("e75AZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bf57bad8a057dcc$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $eUqFw = parcelRequire("eUqFw");

var $5NIRN = parcelRequire("5NIRN");
var $38sCF = parcelRequire("38sCF");
var $4qM4y = parcelRequire("4qM4y");
var $l71n5 = parcelRequire("l71n5");

var $6zOB7 = parcelRequire("6zOB7");

var $2eG9N = parcelRequire("2eG9N");

var $ffiyv = parcelRequire("ffiyv");

var $gWxA1 = parcelRequire("gWxA1");

var $jkH4Q = parcelRequire("jkH4Q");

var $86L81 = parcelRequire("86L81");

var $7hnEh = parcelRequire("7hnEh");

var $a9Brc = parcelRequire("a9Brc");

var $dWkg6 = parcelRequire("dWkg6");

var $mWrG0 = parcelRequire("mWrG0");

var $3bVnn = parcelRequire("3bVnn");

var $cbVLV = parcelRequire("cbVLV");

var $asyNC = parcelRequire("asyNC");

var $gD5gl = parcelRequire("gD5gl");

var $aM4Um = parcelRequire("aM4Um");

var $9RnJ8 = parcelRequire("9RnJ8");

var $joBf7 = parcelRequire("joBf7");
function $0bf57bad8a057dcc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0bf57bad8a057dcc$var$TooltipContainer = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "ernlrkp1"
})({
    name: "ajfry4",
    styles: "display:inline-block;padding-left:var(--ds-space-100, 8px);cursor:pointer;flex-shrink:0"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bf57bad8a057dcc$var$StyledLink = /*#__PURE__*/ (0, $joBf7.default)((0, $asyNC.default), {
    target: "ernlrkp0"
})({
    name: "thgwgc",
    styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:block"
});
const $0bf57bad8a057dcc$var$i18n = (0, $90IgZ.defineMessages)({
    draftPageTooltip: {
        id: 'confluence-table-tree.draft.tooltip',
        defaultMessage: 'Drafts can only be seen by you.'
    },
    draftPageLozenge: {
        id: 'confluence-table-tree.draft.lozenge',
        defaultMessage: 'DRAFT'
    },
    defaultPageTitle: {
        id: 'confluence-table-tree.default.page.title',
        defaultMessage: 'Untitled'
    },
    showAllPagesButtonLabel: {
        id: 'confluence-table-tree.default.show-all-pages-button.label',
        defaultMessage: 'Show all pages'
    },
    showMorePagesButtonLabel: {
        id: 'confluence-table-tree.default.show-all-pages-button.label',
        defaultMessage: 'Show more pages'
    }
});
const $0bf57bad8a057dcc$var$PageTreeBase = ({ readOnly: readOnly, cloudId: cloudId = null, onEdit: onEdit, onView: onView, onAddChildPage: onAddChildPage })=>{
    const { items: items, errorType: errorType, rootContentId: rootContentId, spaceKey: spaceKey, expandSubtree: expandSubtree, collapseSubtree: collapseSubtree, canShowMorePages: canShowMorePages, showMorePages: showMorePages } = (0, $a9Brc.useConfluencePageTreeContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [stickyRowContentId, setStickyRowContentId] = (0, $eUqFw.useState)(null);
    const [{ isDraftsShown: isDraftsShown }] = (0, $86L81.useDraftsToggle)();
    const handleRowExpand = (0, $eUqFw.useCallback)(async (rowData, analyticsEvent)=>{
        if (analyticsEvent) (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'confluencePageTree');
        await expandSubtree(rowData.id);
    }, [
        expandSubtree
    ]);
    const handleRowCollapse = (0, $eUqFw.useCallback)((rowData, analyticsEvent)=>{
        collapseSubtree(rowData.id);
        if (analyticsEvent) (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'confluencePageTree');
    }, [
        collapseSubtree
    ]);
    const handleClickOnPageLink = (0, $eUqFw.useCallback)((event, pageProperties, analyticsEvent, origin)=>{
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'confluencePageTreeLink', {
            ...origin.toAnalyticsAttributes({
                hasGeneratedId: true
            }),
            ...(0, $aM4Um.pageAnalyticsAttributes)(pageProperties)
        });
        if (!(event.ctrlKey || event.metaKey || event.shiftKey)) {
            if (typeof onView === 'function' && !pageProperties.isDraft) {
                event.preventDefault();
                onView(pageProperties);
            } else if (typeof onEdit === 'function') {
                event.preventDefault();
                onEdit(pageProperties);
            }
        }
    }, [
        onView,
        onEdit
    ]);
    const handleShareToggle = (0, $eUqFw.useCallback)((pageId)=>{
        setStickyRowContentId(pageId);
    }, []);
    const getTableRow = (0, $eUqFw.useCallback)(({ error: error, children: children, ...page })=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3bVnn.default), null);
        const { id: id, childTypes: childTypes, hasDraftChildren: hasDraftChildren, title: title, history: { contributors: contributors, lastUpdated: lastUpdated } = {}, isExpanded: isExpanded } = page;
        const origin = new (0, $jkH4Q.default)({
            product: 'jira'
        });
        const pageItem = (0, $7hnEh.getPageTreeItemProperties)(page);
        pageItem.url = origin.addToUrl(pageItem.url);
        pageItem.editUrl = origin.addToUrl(pageItem.editUrl);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qM4y.default), {
            itemId: id,
            items: children,
            hasChildren: childTypes.page.value || !!(hasDraftChildren && isDraftsShown),
            isExpanded: isExpanded,
            onExpand: handleRowExpand,
            onCollapse: handleRowCollapse
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5NIRN.default), {
            width: "55%",
            singleLine: true,
            className: "cell x-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bf57bad8a057dcc$var$StyledLink, {
            onClick: (event, analyticsEvent)=>handleClickOnPageLink(event, pageItem, analyticsEvent, origin),
            href: pageItem.url,
            target: "_blank",
            rel: "noopener noreferrer",
            testId: "confluence-project-pages.page-tree-row.page-title"
        }, title ? title : formatMessage($0bf57bad8a057dcc$var$i18n.defaultPageTitle)), pageItem.isDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: formatMessage($0bf57bad8a057dcc$var$i18n.draftPageTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bf57bad8a057dcc$var$TooltipContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "inprogress"
        }, formatMessage($0bf57bad8a057dcc$var$i18n.draftPageLozenge))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5NIRN.default), {
            width: "10%",
            className: "cell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWkg6.Contributors), {
            cloudId: cloudId,
            contributors: contributors,
            isAvatarTooltipDisabled: true,
            testId: "confluence-project-pages.page-tree-row.contributors"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5NIRN.default), {
            width: "35%",
            singleLine: true,
            className: "cell x-end"
        }, stickyRowContentId !== id && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: "hoverHide"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cbVLV.default), {
            lastUpdated: lastUpdated
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: stickyRowContentId === id ? undefined : 'hoverShow'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RnJ8.default), {
            page: pageItem,
            onEditClick: onEdit,
            onShareToggle: handleShareToggle,
            onAddChildClick: onAddChildPage,
            stickyRowContentId: stickyRowContentId,
            readOnly: readOnly,
            origin: origin
        }))));
    }, [
        cloudId,
        formatMessage,
        handleClickOnPageLink,
        handleRowCollapse,
        handleRowExpand,
        handleShareToggle,
        isDraftsShown,
        onAddChildPage,
        onEdit,
        readOnly,
        stickyRowContentId
    ]);
    let tableBody;
    if (rootContentId === null && spaceKey === null) tableBody = null;
    else if (errorType) {
        if (spaceKey) tableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $mWrG0.ErrorState), {
            type: errorType,
            spaceKey: spaceKey,
            readOnly: readOnly
        });
        else tableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $mWrG0.ErrorState), {
            type: errorType,
            readOnly: readOnly
        });
    } else tableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gD5gl.HoverWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l71n5.default), {
        key: rootContentId,
        items: items,
        render: getTableRow
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gD5gl.TableTreeWrapper), {
        "data-testid": "confluence-project-pages.page-tree.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $38sCF.default), null, tableBody), canShowMorePages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bf57bad8a057dcc$var$ShowMorePagesButton, {
        showMorePages: showMorePages
    }));
};
const $0bf57bad8a057dcc$var$ShowMorePagesButton = ({ showMorePages: showMorePages })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const loadMore = async ()=>{
        setIsLoading(true);
        await showMorePages();
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gD5gl.ButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        onClick: loadMore,
        isLoading: isLoading
    }, formatMessage($0bf57bad8a057dcc$var$i18n.showMorePagesButtonLabel)));
};
var $0bf57bad8a057dcc$export$2e2bcd8739ae039 = $0bf57bad8a057dcc$var$PageTreeBase;

});
parcelRegister("5NIRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9520c21ecd306c8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $liBD9 = parcelRequire("liBD9");

var $eLPXF = parcelRequire("eLPXF");

var $9le3V = parcelRequire("9le3V");

var $cbZVZ = parcelRequire("cbZVZ");
const $9520c21ecd306c8f$var$CellComponent = ({ children: children, singleLine: singleLine, indentLevel: indentLevel, width: width, className: className, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $liBD9.default), {
        indent: indentLevel ? `calc(${0, $9le3V.indentBase} * ${indentLevel})` : undefined,
        width: width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eLPXF.default), {
        isSingleLine: singleLine
    }, children));
const $9520c21ecd306c8f$var$Cell = (0, $cbZVZ.default)($9520c21ecd306c8f$var$CellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9520c21ecd306c8f$export$2e2bcd8739ae039 = $9520c21ecd306c8f$var$Cell;

});
parcelRegister("liBD9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfdc08879059dd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");


var $9le3V = parcelRequire("9le3V");
const $bfdc08879059dd21$var$commonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    minHeight: 40,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 10px)"} ${(0, $9le3V.indentBase)} ${"var(--ds-space-100, 10px)"} var(--indent, ${(0, $9le3V.indentBase)})`,
    position: 'relative',
    alignItems: 'center',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    hyphens: 'auto',
    wordBreak: 'break-word'
});
/**
 * __Common cell__
 */ const $bfdc08879059dd21$var$CommonCell = ({ indent: indent, width: width, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "gridcell",
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--indent': indent,
            width: width
        },
        css: $bfdc08879059dd21$var$commonStyles
    });
var $bfdc08879059dd21$export$2e2bcd8739ae039 = $bfdc08879059dd21$var$CommonCell;

});
parcelRegister("9le3V", function(module, exports) {

$parcel$export(module.exports, "indentBase", () => $8e560fb6738ea796$export$aa740e17a7fcafcd);
$parcel$export(module.exports, "TreeRowContainer", () => $8e560fb6738ea796$export$802d2031792f9e4);
$parcel$export(module.exports, "ChevronContainer", () => $8e560fb6738ea796$export$f25bd028f55b3d30);
$parcel$export(module.exports, "LoaderItemContainer", () => $8e560fb6738ea796$export$94ae573de7227397);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

function $8e560fb6738ea796$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8e560fb6738ea796$export$aa740e17a7fcafcd = "var(--ds-space-300, 25px)";
const $8e560fb6738ea796$var$treeRowContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`}`
});
const $8e560fb6738ea796$export$802d2031792f9e4 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "row",
        css: $8e560fb6738ea796$var$treeRowContainerStyles,
        ...props
    });
const $8e560fb6738ea796$var$commonCellElementStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    // indentBase is re-used elsewhere and is primarily used as positive value; we need to negate it here
    marginInlineStart: `calc(${$8e560fb6738ea796$export$aa740e17a7fcafcd} * -1)`
});
const $8e560fb6738ea796$var$commonChevronContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Aligns position:absolute chevron button with the adjacent text. Any future visual breaking changes
    // should consider setting this to `-2px` for better alignment, or refactor completely
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginBlockStart: -3
});
const $8e560fb6738ea796$export$f25bd028f55b3d30 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...props,
        css: [
            $8e560fb6738ea796$var$commonCellElementStyles,
            $8e560fb6738ea796$var$commonChevronContainerStyles
        ]
    });
const $8e560fb6738ea796$var$loadingItemContainerStyles = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $8e560fb6738ea796$var$paddingLeftStyles = {
    name: "1oszimk",
    styles: "padding-inline-start:50%"
};
const $8e560fb6738ea796$export$94ae573de7227397 = ({ isRoot: isRoot, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $8e560fb6738ea796$var$commonCellElementStyles,
            $8e560fb6738ea796$var$loadingItemContainerStyles,
            isRoot && $8e560fb6738ea796$var$paddingLeftStyles
        ],
        ...props
    });

});


parcelRegister("eLPXF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aea786554ceb264$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $8aea786554ceb264$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8aea786554ceb264$var$overflowContainerStyles = {
    name: "1h52dri",
    styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
/**
 * __Overflow container__
 */ const $8aea786554ceb264$var$OverflowContainer = ({ isSingleLine: isSingleLine, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: isSingleLine && $8aea786554ceb264$var$overflowContainerStyles,
        ...props
    });
var $8aea786554ceb264$export$2e2bcd8739ae039 = $8aea786554ceb264$var$OverflowContainer;

});

parcelRegister("cbZVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00679864e6bff806$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gleYX = parcelRequire("gleYX");
function $00679864e6bff806$export$2e2bcd8739ae039(Cell) {
    return (props)=>{
        const { setColumnWidth: setColumnWidth, getColumnWidth: getColumnWidth } = (0, $eUqFw.useContext)((0, $gleYX.TableTreeContext));
        const { width: width, columnIndex: columnIndex, ...other } = props;
        (0, $eUqFw.useEffect)(()=>{
            if (width !== undefined && columnIndex !== undefined) setColumnWidth(columnIndex, width);
        }, [
            width,
            columnIndex,
            setColumnWidth
        ]);
        let columnWidth;
        if (width !== null && width !== undefined) columnWidth = width;
        else if (columnIndex !== undefined) columnWidth = getColumnWidth(columnIndex);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Cell, {
            width: columnWidth,
            ...other
        });
    };
}

});
parcelRegister("gleYX", function(module, exports) {

$parcel$export(module.exports, "TableTreeContext", () => $8e71b471af761322$export$662c2d348d8b71af);

var $eUqFw = parcelRequire("eUqFw");
const $8e71b471af761322$export$662c2d348d8b71af = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setColumnWidth: ()=>{},
    getColumnWidth: ()=>null
});

});



parcelRegister("38sCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3358c9e85e0e2c32$export$2e2bcd8739ae039);
/* eslint-disable react/prop-types */ 
var $eUqFw = parcelRequire("eUqFw");

var $5NIRN = parcelRequire("5NIRN");

var $j98gZ = parcelRequire("j98gZ");

var $fB9WM = parcelRequire("fB9WM");

var $gleYX = parcelRequire("gleYX");

var $4qM4y = parcelRequire("4qM4y");

var $l71n5 = parcelRequire("l71n5");
const $3358c9e85e0e2c32$var$emptyColumnWidths = [];
function $3358c9e85e0e2c32$var$TableTree({ children: children, columns: columns, columnWidths: defaultColumnWidths = $3358c9e85e0e2c32$var$emptyColumnWidths, headers: headers, shouldExpandOnClick: shouldExpandOnClick, items: items, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, label: label, referencedLabel: referencedLabel }) {
    const [columnWidths, setColumnWidths] = (0, $eUqFw.useState)(defaultColumnWidths);
    const setColumnWidth = (0, $eUqFw.useCallback)((columnIndex, width)=>{
        if (width === columnWidths[columnIndex]) return;
        setColumnWidths((columnWidths)=>{
            const newColumnWidths = [
                ...columnWidths
            ];
            newColumnWidths[columnIndex] = width;
            return newColumnWidths;
        });
    }, [
        columnWidths
    ]);
    const getColumnWidth = (0, $eUqFw.useCallback)((columnIndex)=>{
        return columnWidths[columnIndex] || null;
    }, [
        columnWidths
    ]);
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            setColumnWidth: setColumnWidth,
            getColumnWidth: getColumnWidth
        }), [
        setColumnWidth,
        getColumnWidth
    ]);
    const heads = headers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fB9WM.default), null, headers.map((header, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j98gZ.default), {
            key: index,
            columnIndex: index,
            width: columnWidths[index]
        }, header)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gleYX.TableTreeContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "treegrid",
        "aria-readonly": true,
        "aria-label": label,
        "aria-labelledby": referencedLabel
    }, heads, columns && items && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l71n5.default), {
        items: items,
        render: ({ id: id, children: children, content: content })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qM4y.default), {
                itemId: id,
                items: children,
                hasChildren: !!children && children.length > 0,
                shouldExpandOnClick: shouldExpandOnClick,
                mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel
            }, columns.map((CellContent, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5NIRN.default), {
                    key: `cell-${index}`,
                    columnIndex: index,
                    width: columnWidths[index]
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CellContent, content));
            }))
    }), children));
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3358c9e85e0e2c32$export$2e2bcd8739ae039 = $3358c9e85e0e2c32$var$TableTree;

});
parcelRegister("j98gZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $860a41c34ac2410a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $liBD9 = parcelRequire("liBD9");

var $cbZVZ = parcelRequire("cbZVZ");
const $860a41c34ac2410a$var$headerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
const $860a41c34ac2410a$var$HeaderComponent = ({ width: width, children: children, onClick: onClick, id: id, role: role = 'columnheader' })=>{
    // TODO: Determine whether proper `th` elements can be used instead of
    // roles (DSP-11588)
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $liBD9.default), {
        css: $860a41c34ac2410a$var$headerStyles,
        role: role,
        width: width,
        id: id,
        onClick: onClick
    }, children);
};
const $860a41c34ac2410a$var$Header = (0, $cbZVZ.default)($860a41c34ac2410a$var$HeaderComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$860a41c34ac2410a$export$2e2bcd8739ae039 = $860a41c34ac2410a$var$Header;

});

parcelRegister("fB9WM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3218da4cd1e6552e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/react/no-clone-element */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $3218da4cd1e6552e$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    borderBlockEnd: `solid 2px ${"var(--ds-border, #dfe1e6)"}`
});
/**
 * __Headers__
 *
 * Headers component for advanced composition of data, allowing custom data structures.
 *
 * - [Examples](https://atlassian.design/components/table-tree/examples#advanced)
 * - [Code](https://atlassian.design/components/table-tree/code#headers-props)
 */ const $3218da4cd1e6552e$var$Headers = ({ children: children })=>// TODO: Determine whether proper `tr` elements can be used instead of
    // roles (DSP-11588)
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $3218da4cd1e6552e$var$containerStyles,
        role: "row"
    }, (0, $eUqFw.Children).map(children, (header, index)=>/*#__PURE__*/ (0, $eUqFw.cloneElement)(header, {
            key: index,
            columnIndex: index
        })));
var $3218da4cd1e6552e$export$2e2bcd8739ae039 = $3218da4cd1e6552e$var$Headers;

});

parcelRegister("4qM4y", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f4c2f6c86447203$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $fwqfJ = parcelRequire("fwqfJ");

var $249p2 = parcelRequire("249p2");

var $9le3V = parcelRequire("9le3V");
function $7f4c2f6c86447203$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7f4c2f6c86447203$var$treeRowClickableStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $7f4c2f6c86447203$var$getExtendedLabel = (cellContent, cellIndex, mainColumnForExpandCollapseLabel)=>{
    /**
   * First condition - when we pass data via `items` property in `<TableTree />`
   * Second condition - when we pass data via `<Rows />` as children in `<TableTree />`.
   */ if (cellContent.hasOwnProperty('props')) return cellContent?.props[mainColumnForExpandCollapseLabel?.toLowerCase()];
    else if (cellIndex === mainColumnForExpandCollapseLabel) return cellContent;
    return undefined;
};
function $7f4c2f6c86447203$var$Row({ shouldExpandOnClick: shouldExpandOnClick, hasChildren: hasChildren, depth: depth, renderChildren: renderChildren, isDefaultExpanded: isDefaultExpanded, data: data, onExpand: providedOnExpand, onCollapse: providedOnCollapse, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, expandLabel: expandLabel, collapseLabel: collapseLabel, itemId: itemId, children: children, isExpanded: isProvidedExpanded }) {
    const [isExpandedState, setIsExpandedState] = (0, $eUqFw.useState)(isDefaultExpanded || false);
    (0, $eUqFw.useEffect)(()=>{
        if (isProvidedExpanded === undefined && isDefaultExpanded !== undefined && isExpandedState !== isDefaultExpanded) setIsExpandedState(isDefaultExpanded);
    }, [
        isDefaultExpanded,
        isProvidedExpanded,
        isExpandedState
    ]);
    const onExpand = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnExpand && providedOnExpand(value),
        action: 'expanded',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onCollapse = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnCollapse && providedOnCollapse(value),
        action: 'collapsed',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    /**
   * This ensures a user won't trigger a click event and expand the accordion
   * when making a text selection.
   */ const onClickHandler = (e)=>{
        const selection = window.getSelection()?.toString() || '';
        if (selection?.length === 0) onExpandToggle();
    };
    const onExpandStateChange = (isExpanded)=>{
        if (data) {
            if (isExpanded && onExpand) onExpand(data);
            else if (!isExpanded && onCollapse) onCollapse(data);
        }
    };
    const onExpandToggle = ()=>{
        if (isProvidedExpanded !== undefined) onExpandStateChange(!isProvidedExpanded);
        else setIsExpandedState((prevState)=>{
            onExpandStateChange(!prevState);
            return !prevState;
        });
    };
    const renderCell = (cell, cellIndex)=>{
        const isFirstCell = cellIndex === 0;
        const indentLevel = isFirstCell ? depth : 0;
        let cellContent = cell.props.children || [];
        const extendedLabel = $7f4c2f6c86447203$var$getExtendedLabel(cellContent, cellIndex, mainColumnForExpandCollapseLabel);
        if (isFirstCell && hasChildren) cellContent = [
            /*#__PURE__*/ (0, $byn9U.jsx)((0, $249p2.default), {
                key: "chevron",
                expandLabel: expandLabel,
                collapseLabel: collapseLabel,
                extendedLabel: extendedLabel,
                isExpanded: isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState,
                onExpandToggle: onExpandToggle,
                ariaControls: (isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState) && !!itemId ? (0, $fwqfJ.default)(itemId) : undefined,
                rowId: !!itemId ? itemId : ''
            })
        ].concat(cellContent);
        // eslint-disable-next-line @repo/internal/react/no-clone-element
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(cell, {
            key: cellIndex,
            columnIndex: cellIndex,
            indentLevel: indentLevel
        }, cellContent);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9le3V.TreeRowContainer), {
        css: hasChildren && shouldExpandOnClick ? $7f4c2f6c86447203$var$treeRowClickableStyles : undefined,
        onClick: hasChildren && shouldExpandOnClick ? onClickHandler : undefined,
        "aria-expanded": hasChildren ? isExpandedState : undefined,
        "aria-level": depth ? depth : undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (cell, index)=>renderCell(cell, index))), hasChildren && (isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState) && renderChildren && renderChildren());
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7f4c2f6c86447203$export$2e2bcd8739ae039 = $7f4c2f6c86447203$var$Row;

});
parcelRegister("fwqfJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d814e28aba1de0ff$export$2e2bcd8739ae039);
function $d814e28aba1de0ff$export$2e2bcd8739ae039(id) {
    return `tabletreeitem-${id}`.replace(/[^-_a-zA-Z0-9]/g, '');
}

});

parcelRegister("249p2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9672c0f4576e850$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/consistent-props-definitions */ /* eslint-disable react/prop-types */ 
var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $5Q9wj = parcelRequire("5Q9wj");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $9le3V = parcelRequire("9le3V");
/**
 * Internal chevron component.
 */ const $d9672c0f4576e850$var$Chevron = ({ isExpanded: isExpanded, ariaControls: ariaControls, collapseLabel: collapseLabel = 'Collapse', expandLabel: expandLabel = 'Expand', rowId: rowId, extendedLabel: extendedLabel, onExpandToggle: onExpandToggle = (0, $5Q9wj.default) })=>{
    const getLabel = (defaultLabel)=>extendedLabel ? `${defaultLabel} ${extendedLabel} row` : `${defaultLabel} row ${rowId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9le3V.ChevronContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        onClick: onExpandToggle,
        spacing: "compact",
        icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))) : (0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))),
        "aria-controls": ariaControls,
        label: isExpanded ? getLabel(collapseLabel) : getLabel(expandLabel)
    }));
};
var $d9672c0f4576e850$export$2e2bcd8739ae039 = $d9672c0f4576e850$var$Chevron;

});


parcelRegister("l71n5", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa522068e9c29aaf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bheb4 = parcelRequire("bheb4");
function $aa522068e9c29aaf$var$Rows({ items: items, render: render, loadingLabel: loadingLabel = 'Loading' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "rowgroup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bheb4.default), {
        items: items,
        loadingLabel: loadingLabel,
        render: render
    }));
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aa522068e9c29aaf$export$2e2bcd8739ae039 = $aa522068e9c29aaf$var$Rows;

});
parcelRegister("bheb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e64e5fc5d012862$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZVvs = parcelRequire("7ZVvs");

var $eQYVc = parcelRequire("eQYVc");
function $2e64e5fc5d012862$var$Items({ depth: depth = 0, items: items, loadingLabel: loadingLabel, render: render }) {
    const [isLoaderShown, setIsLoaderShown] = (0, $eUqFw.useState)(false);
    const handleLoaderComplete = ()=>setIsLoaderShown(false);
    return !items || isLoaderShown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eQYVc.default), {
        isCompleting: !!(items && items.length),
        onComplete: handleLoaderComplete,
        depth: depth + 1,
        loadingLabel: loadingLabel
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, items.map((data)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZVvs.default), {
            data: data,
            depth: depth + 1,
            key: data.id,
            render: render,
            loadingLabel: loadingLabel
        })));
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2e64e5fc5d012862$export$2e2bcd8739ae039 = $2e64e5fc5d012862$var$Items;

});
parcelRegister("7ZVvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $2595a92458c505e1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/react/no-clone-element */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $fwqfJ = parcelRequire("fwqfJ");

var $bheb4 = parcelRequire("bheb4");
/**
 * __Item__
 * Internal item component.
 */ function $2595a92458c505e1$var$Item({ depth: depth = 0, data: data, render: render, loadingLabel: loadingLabel }) {
    const renderedRow = render(data);
    if (!renderedRow) return null;
    // itemId exists on RowProps, but not on RowsProps
    const itemId = 'itemId' in renderedRow.props ? renderedRow.props.itemId : undefined;
    const items = renderedRow.props.items;
    return /*#__PURE__*/ (0, $eUqFw.cloneElement)(renderedRow, {
        depth: depth,
        data: data,
        loadingLabel: loadingLabel,
        renderChildren: ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                id: !!itemId ? (0, $fwqfJ.default)(itemId) : undefined
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bheb4.default), {
                depth: depth,
                items: items,
                render: render,
                loadingLabel: loadingLabel
            }))
    });
}
var $2595a92458c505e1$export$2e2bcd8739ae039 = $2595a92458c505e1$var$Item;

});

parcelRegister("eQYVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d0e1c5b263a70b5$export$2e2bcd8739ae039);
/* eslint-disable react/prop-types */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $liBD9 = parcelRequire("liBD9");

var $9le3V = parcelRequire("9le3V");
const $3d0e1c5b263a70b5$var$LoaderItem = ({ depth: depth = 1, loadingLabel: loadingLabel, isCompleting: isCompleting, onComplete: onComplete })=>{
    const [phase, setPhase] = (0, $eUqFw.useState)('loading');
    (0, $eUqFw.useEffect)(()=>{
        if (phase === 'loading' && isCompleting) setPhase(()=>{
            onComplete();
            return 'complete';
        });
    }, [
        isCompleting,
        onComplete,
        phase
    ]);
    return phase === 'loading' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9le3V.TreeRowContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $liBD9.default), {
        indent: `calc(${(0, $9le3V.indentBase)} * ${depth})`,
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9le3V.LoaderItemContainer), {
        isRoot: depth === 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small",
        testId: "table-tree-spinner",
        label: loadingLabel
    })))) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3d0e1c5b263a70b5$export$2e2bcd8739ae039 = $3d0e1c5b263a70b5$var$LoaderItem;

});




parcelRegister("86L81", function(module, exports) {

$parcel$export(module.exports, "useDraftsToggle", () => $29eaf343cebf4bad$export$e77ae2c63da4e5a);

var $WBLbN = parcelRequire("WBLbN");

var $1GHLx = parcelRequire("1GHLx");
const $29eaf343cebf4bad$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        isDraftsShown: false,
        isTreeUpdatedForDrafts: false
    },
    actions: $1GHLx
});
const $29eaf343cebf4bad$export$e77ae2c63da4e5a = (0, $WBLbN.createHook)($29eaf343cebf4bad$var$Store);

});
parcelRegister("1GHLx", function(module, exports) {

$parcel$export(module.exports, "setIsDraftsShown", () => $5b138d07913a99a1$export$a491c6a0b1d65edb);
$parcel$export(module.exports, "loadIsDraftsShownPreference", () => $5b138d07913a99a1$export$c0acb5b0c57287a8);
$parcel$export(module.exports, "setIsTreeUpdatedForDrafts", () => $5b138d07913a99a1$export$a3f13805269938c);

var $d4Q6m = parcelRequire("d4Q6m");
const $5b138d07913a99a1$var$SHOW_DRAFTS_USER_PROPERTY = 'growth.project-pages.confluence-table-tree.show-drafts';
const $5b138d07913a99a1$export$a491c6a0b1d65edb = (accountId, isDraftsShown)=>async ({ setState: setState })=>{
        setState({
            isDraftsShown: isDraftsShown,
            isTreeUpdatedForDrafts: false
        });
        // save the preference
        await (0, $d4Q6m.putUserProperty)(accountId, $5b138d07913a99a1$var$SHOW_DRAFTS_USER_PROPERTY, isDraftsShown);
    };
const $5b138d07913a99a1$export$c0acb5b0c57287a8 = (accountId)=>async ({ setState: setState })=>{
        // default is to show drafts
        const isDraftsShown = await (0, $d4Q6m.getUserProperty)(accountId, $5b138d07913a99a1$var$SHOW_DRAFTS_USER_PROPERTY, true);
        setState({
            isDraftsShown: isDraftsShown,
            isTreeUpdatedForDrafts: false
        });
    };
const $5b138d07913a99a1$export$a3f13805269938c = (isTreeUpdatedForDrafts)=>({ setState: setState })=>{
        setState({
            isTreeUpdatedForDrafts: isTreeUpdatedForDrafts
        });
    };

});
parcelRegister("d4Q6m", function(module, exports) {

$parcel$export(module.exports, "getUserProperty", () => $dd2d9976e935a86a$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "putUserProperty", () => $dd2d9976e935a86a$export$ab7d27b408d7b5b);
const $dd2d9976e935a86a$var$USER_PROPERTIES_URL = '/rest/api/3/user/properties';
const $dd2d9976e935a86a$export$b3126db2ef6e34ed = async (accountId, key, defaultValue)=>{
    const response = await fetch(`${$dd2d9976e935a86a$var$USER_PROPERTIES_URL}/${key}?${new URLSearchParams({
        accountId: accountId
    })}`, {
        credentials: 'same-origin'
    });
    if (response.status === 404 && defaultValue !== undefined) return defaultValue;
    if (!response.ok) throw new Error(`Failed to fetch user property ${key} ${response.status} ${response.statusText}`);
    return (await response.json()).value;
};
const $dd2d9976e935a86a$export$ab7d27b408d7b5b = async (accountId, key, value)=>{
    const response = await fetch(`${$dd2d9976e935a86a$var$USER_PROPERTIES_URL}/${key}?${new URLSearchParams({
        accountId: accountId
    })}`, {
        method: 'PUT',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(value)
    });
    if (!response.ok) throw new Error(`Failed to set user property ${key} ${response.status} ${response.statusText}`);
    return;
};

});



parcelRegister("7hnEh", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTableTreeData", () => $ebba8cd1eca1fcf0$export$34121f16d7c7ab27);
$parcel$export(module.exports, "getPageTreeItemProperties", () => $ebba8cd1eca1fcf0$export$761824c0680778ff);
class $ebba8cd1eca1fcf0$export$34121f16d7c7ab27 {
    constructor(){
        this.items = [];
        this.lookup = {};
        this.rootContentId = null;
    }
    getPage(id) {
        return this.lookup[id];
    }
    getRootPages() {
        return this.items;
    }
    /**
	 * Inject an error marker as the children of the given pageId
	 * @param parentId
	 * @returns the update page tree root items
	 */ markChildError(parentId) {
        const parent = this.getPage(parentId);
        if (!parent) throw new Error(`unknown parent id ${parentId}`);
        this.getDescendentIds(parent).forEach((id)=>delete this.lookup[id]);
        parent.children = [
            {
                error: true
            }
        ];
        return [
            ...this.items
        ];
    }
    // traverse the tree and return all descendents of the given parent (or root)
    getDescendentIds(parent) {
        return (parent ? parent.children || [] : this.items).reduce((descendents, child)=>[
                child.id,
                ...this.getDescendentIds(child),
                ...descendents
            ], []);
    }
    /**
	 * Remove all descendents from given parent and collapse the subtree
	 *
	 * @param parentId
	 * @returns the updated page tree root items
	 */ pruneSubtree(parentId) {
        const parent = this.getPage(parentId);
        if (!parent) return this.items;
        this.getDescendentIds(parent).forEach((id)=>delete this.lookup[id]);
        parent.childTypes.page.value = false;
        parent.children = undefined;
        parent.isExpanded = false;
        parent.hasDraftChildren = false;
        return [
            ...this.items
        ];
    }
    apppendChildPages(pages, parentId) {
        const parent = parentId ? this.getPage(parentId) : undefined;
        if (parentId !== undefined && !parent) throw new Error(`unknown parent id ${parentId}`);
        const origDescendentIds = this.getDescendentIds(parent);
        // populate the incoming page data with parent and any existing children information
        const newItems = pages.map((page)=>({
                ...page,
                parent: parent,
                children: this.getPage(page.id)?.children,
                isExpanded: this.getPage(page.id)?.isExpanded || false
            }));
        const items = parent ? parent.children : this.items;
        const published = items?.filter((item)=>item.status === 'current') ?? [];
        const drafts = items?.filter((item)=>item.status === 'draft') ?? [];
        published.push(...newItems);
        if (parent) {
            // modify parent to have the new children
            parent.children = [
                ...published,
                ...drafts
            ];
            parent.childTypes = {
                page: {
                    value: pages.length > 0
                }
            };
            // always expand the parent when fetching children for it
            parent.isExpanded = true;
        } else // update root pages
        this.items = [
            ...published,
            ...drafts
        ];
        this.cleanUpAndUpdateLookUp(newItems, parent, origDescendentIds);
        // always return copies to trigger re-renders
        return [
            ...this.items
        ];
    }
    /**
	 * Replace the root pages or child pages of a parent in the page tree
	 * @param pages
	 * @param parentId if specified, replaces the children of this parent with given pages. Otherwise replaces the root pages
	 * @returns the updated page tree root items
	 */ updateChildPages(pages, parentId) {
        const parent = parentId ? this.getPage(parentId) : undefined;
        if (parentId !== undefined && !parent) throw new Error(`unknown parent id ${parentId}`);
        const origDescendentIds = this.getDescendentIds(parent);
        // populate the incoming page data with parent and any existing children information
        const newItems = pages.map((page)=>({
                ...page,
                parent: parent,
                children: this.getPage(page.id)?.children,
                isExpanded: this.getPage(page.id)?.isExpanded || false
            }));
        if (parent) {
            // modify parent to have the new children
            parent.children = newItems.length > 0 ? newItems : undefined;
            parent.childTypes = {
                page: {
                    value: pages.length > 0
                }
            };
            // always expand the parent when fetching children for it
            parent.isExpanded = true;
        } else // update root pages
        this.items = newItems;
        this.cleanUpAndUpdateLookUp(newItems, parent, origDescendentIds);
        // always return copies to trigger re-renders
        return [
            ...this.items
        ];
    }
    cleanUpAndUpdateLookUp(newItems, parent, origDescendentIds) {
        // delete from lookup any original descendents of the parent that is no longer in the tree
        const newDescendentIds = new Set(this.getDescendentIds(parent));
        origDescendentIds.filter((origId)=>!newDescendentIds.has(origId)).forEach((id)=>delete this.lookup[id]);
        // update lookup for the new pages, and the .parent of the existing (grand)children
        newItems.forEach((page)=>{
            page.children?.forEach((child)=>{
                child.parent = page;
            });
            this.lookup[page.id] = page;
        });
    }
    setIsExpanded(id, isExpanded) {
        const page = this.getPage(id);
        if (page) {
            page.isExpanded = isExpanded;
            return [
                ...this.items
            ];
        }
        return this.items;
    }
    init(rootContentId) {
        this.items = [];
        this.lookup = {};
        this.rootContentId = rootContentId;
    }
    /**
	 * Remove the given page from the tree if it exists, and prune all descendants
	 *
	 * @param pageId
	 * @returns the updated page tree root items
	 */ removePage(pageId) {
        const page = this.getPage(pageId);
        if (!page) return this.items;
        if (page.parent) {
            // we can assume that the parent is currently expanded, as it has page as a child
            page.parent.children = page.parent.children ? page.parent.children.filter((p)=>p.id !== pageId) : undefined;
            // if there are no drafts remaining
            if (page.parent.children?.find((p)=>p.status === 'draft') === undefined) page.parent.hasDraftChildren = false;
            // if there are no published pages remaining
            if (page.parent.children?.find((p)=>p.status === 'current') === undefined) page.parent.childTypes.page.value = false;
            if (page.parent.children === undefined) page.parent.isExpanded = false;
        } else // remove root page
        this.items = this.items.filter((p)=>p.id !== pageId);
        // published pages can have children, delete all the lookups for them as well
        if (page.status === 'current') this.getDescendentIds(page).forEach((id)=>delete this.lookup[id]);
        delete this.lookup[pageId];
        return [
            ...this.items
        ];
    }
    static copyPageData(src, dst) {
        // manually copy relevant attributes into the existing item, so the object reference is preserved
        dst._links = src._links;
        dst.childTypes = src.childTypes;
        dst.metadata = src.metadata;
        dst.status = src.status;
        dst.title = src.title;
        dst.history = src.history;
        dst.extensions = src.extensions;
        return true;
    }
    /**
	 * Inject pages into the tree based on the current expansion state. Pages already in the tree
	 * will be replaced by any pages in the given list. Parent pages will gain the hasDraftChildren
	 * or childTypes.pages.value attribute and expanded parents will have pages inserted into children.
	 *
	 * @param pages an array of pages with ancestor information (via confluence::getPage or confluence::getDrafts)
	 * @returns the updated page tree root items
	 */ injectPages(pages) {
        pages.forEach((page)=>{
            // calculate the parent by looking at last element of ancestors
            const parentId = page.ancestors.length === 0 ? null : page.ancestors[page.ancestors.length - 1].id;
            // first consider if this draft can simply be replaced in place
            const existing = this.getPage(page.id);
            let replaced = false;
            if (existing) {
                // has this draft moved in the tree?
                if (existing.parent?.id === parentId || existing.parent === undefined && parentId === this.rootContentId) {
                    // if not, we can just replace in place
                    $ebba8cd1eca1fcf0$export$34121f16d7c7ab27.copyPageData(page, existing);
                    replaced = true;
                } else // otherwise, remove it first before inserting
                this.removePage(page.id);
            }
            // then try to insert it into the tree
            const item = {
                ...page,
                isExpanded: false,
                children: undefined
            };
            // check if it is a "root" level draft
            if (!replaced && parentId === this.rootContentId) {
                this.items.push(item);
                this.lookup[page.id] = item;
                return;
            }
            if (parentId === null) // got a root draft but we have a non-null rootContentId... so discard it
            return;
            const parent = this.getPage(parentId);
            if (!parent) // parent is not in tree, discard this draft
            return;
            // mark the parent appropriately
            if (page.status === 'draft') parent.hasDraftChildren = true;
            else if (page.status === 'current') parent.childTypes.page.value = true;
            // if the parent is expanded, append this draft to the children
            if (!replaced && parent.isExpanded) {
                item.parent = parent;
                if (parent.children) parent.children.push(item);
                else parent.children = [
                    item
                ];
                this.lookup[page.id] = item;
            }
        });
        return [
            ...this.items
        ];
    }
    /**
	 * Remove all drafts from the page tree
	 * @returns the updated page tree root items
	 */ purgeDrafts() {
        const filterDrafts = (pages)=>pages.reduce((acc, page)=>{
                if (page.status === 'draft') {
                    delete this.lookup[page.id];
                    return acc;
                }
                const children = page.children ? filterDrafts(page.children) : undefined;
                const updatedPage = {
                    ...page,
                    children: children,
                    hasDraftChildren: false
                };
                this.lookup[page.id] = updatedPage;
                acc.push(updatedPage);
                return acc;
            }, []);
        this.items = filterDrafts(this.items);
        return this.items;
    }
}
const $ebba8cd1eca1fcf0$export$761824c0680778ff = ({ id: id, status: status, _links: _links, metadata: metadata, type: type, subType: subType })=>({
        id: id,
        isDraft: status === 'draft',
        isLive: subType === 'live',
        url: `${_links.base}${_links.webui}`,
        editUrl: `${_links.base}${_links.editui}`,
        hasEmbeddedEdit: metadata.frontend?.collabService === 'ncs',
        type: type
    });

});

parcelRegister("a9Brc", function(module, exports) {

$parcel$export(module.exports, "ConfluencePageTreeContext", () => $f809994ee6dc4144$export$8f8931214163d67c);
$parcel$export(module.exports, "useConfluencePageTreeContext", () => $f809994ee6dc4144$export$6bdfd12fd9251472);
$parcel$export(module.exports, "useConfluencePageTree", () => $f809994ee6dc4144$export$98b66195d4a10d4a);

var $eUqFw = parcelRequire("eUqFw");

var $6K8He = parcelRequire("6K8He");
const $f809994ee6dc4144$var$noop = ()=>{};
const $f809994ee6dc4144$export$8f8931214163d67c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    treeState: (0, $6K8He.TreeStates).Loading,
    spaceKey: null,
    rootContentId: null,
    items: null,
    errorType: null,
    accountId: '',
    setContent: $f809994ee6dc4144$var$noop,
    expandSubtree: ()=>Promise.reject(),
    collapseSubtree: $f809994ee6dc4144$var$noop,
    insertPage: ()=>Promise.reject(),
    updatePage: ()=>Promise.reject(),
    removePage: ()=>Promise.reject(),
    canShowMorePages: false,
    showMorePages: ()=>Promise.resolve(),
    setProjectData: $f809994ee6dc4144$var$noop
});
const $f809994ee6dc4144$export$6bdfd12fd9251472 = ()=>(0, $eUqFw.useContext)($f809994ee6dc4144$export$8f8931214163d67c);
const $f809994ee6dc4144$export$98b66195d4a10d4a = ()=>{
    const { treeState: treeState, setContent: setContent, insertPage: insertPage, updatePage: updatePage, removePage: removePage, setProjectData: setProjectData } = (0, $eUqFw.useContext)($f809994ee6dc4144$export$8f8931214163d67c);
    return {
        treeState: treeState,
        setContent: setContent,
        insertPage: insertPage,
        updatePage: updatePage,
        removePage: removePage,
        setProjectData: setProjectData
    };
};

});

parcelRegister("dWkg6", function(module, exports) {

$parcel$export(module.exports, "Contributors", () => $10c7b4afed447806$export$5360f064464e9211);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jYVKV = parcelRequire("jYVKV");
var $bFzGY = parcelRequire("bFzGY");
var $2jDha = parcelRequire("2jDha");

var $iJlfe = parcelRequire("iJlfe");

var $4XQdE = parcelRequire("4XQdE");

var $eqp74 = parcelRequire("eqp74");

var $8PYmV = parcelRequire("8PYmV");

var $2eG9N = parcelRequire("2eG9N");

var $gWxA1 = parcelRequire("gWxA1");

var $cArR5 = parcelRequire("cArR5");

var $e2gVN = parcelRequire("e2gVN");
const $10c7b4afed447806$var$openUserProfileWindow = (userId)=>window.open(`/wiki/display/~${userId}`, '_blank');
const $10c7b4afed447806$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
const $10c7b4afed447806$export$2a1ba0e121ca02bd = (props)=>{
    const { userId: userId, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const profileClient = new (0, $8PYmV.default)({
        url: $10c7b4afed447806$var$DIRECTORY_URL
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
        onEvent: (analyticsEvent)=>{
            if (createAnalyticsEvent) {
                const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = analyticsEvent.payload;
                if (action === 'rendered' && actionSubject === 'profilecard' && actionSubjectId === 'content') (0, $gWxA1.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluencePageTreeAvatar profileCardView');
            }
        },
        channel: "peopleTeams"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eqp74.default), {
        cloudId: cloudId,
        userId: userId,
        resourceClient: profileClient,
        actions: [
            {
                label: formatMessage((0, $e2gVN.default).viewProfile),
                callback: ()=>{
                    $10c7b4afed447806$var$openUserProfileWindow(userId);
                }
            }
        ],
        prepopulatedData: {
            fullName: props.username
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...props,
        onClick: (_, analyticsEvent)=>{
            if (analyticsEvent) (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'confluencePageTreeAvatar', {
                dropdown: false
            });
        }
    })));
};
const $10c7b4afed447806$export$291ed8247fe10969 = (0, $2jDha.default)()($10c7b4afed447806$export$2a1ba0e121ca02bd);
const $10c7b4afed447806$export$5360f064464e9211 = ({ cloudId: cloudId, contributors: contributors, testId: testId, isAvatarTooltipDisabled: isAvatarTooltipDisabled })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if (!cloudId || !contributors || !contributors.publishers || !contributors.publishers.users) {
        if (createAnalyticsEvent) (0, $gWxA1.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluencePageTree unknownContributor');
        const couldNotLoadContMessage = formatMessage((0, $e2gVN.default).couldNotLoadContributors);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cArR5.ContributorsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: couldNotLoadContMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            size: "small",
            name: couldNotLoadContMessage,
            label: couldNotLoadContMessage
        })));
    }
    const data = contributors.publishers.users.map((user)=>({
            name: user.displayName,
            size: 'medium',
            src: user.profilePicture.path,
            userId: user.accountId
        }));
    const AvatarWithCloudId = (avatarProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10c7b4afed447806$export$291ed8247fe10969, {
            ...avatarProps,
            cloudId: cloudId
        });
    const handleAvatarClicked = (_event, _analyticsEvent, index)=>{
        if (createAnalyticsEvent) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'avatar'
            });
            (0, $gWxA1.fireUIAnalytics)(event, 'confluencePageTreeAvatar', {
                dropdown: true
            });
        }
        $10c7b4afed447806$var$openUserProfileWindow(data[index].userId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cArR5.ContributorsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        data: data,
        avatar: AvatarWithCloudId,
        size: "small",
        maxCount: 3,
        onAvatarClick: handleAvatarClicked,
        testId: testId && `${testId}--avatargroup`,
        isTooltipDisabled: isAvatarTooltipDisabled
    }));
};

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $2eG9N = parcelRequire("2eG9N");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $XHGTv = parcelRequire("XHGTv");

const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`}`,
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("eqp74", function(module, exports) {

$parcel$export(module.exports, "default", () => $f417a985f66752de$export$2e2bcd8739ae039);


var $hSM1E = parcelRequire("hSM1E");

var $1I4cW = parcelRequire("1I4cW");
var $f417a985f66752de$export$2e2bcd8739ae039 = (0, $1I4cW.default);

});
const $515c9dbc88c31cf4$export$5b956b542f1bc1b3 = 800;
const $515c9dbc88c31cf4$export$89a9f35a94d7f196 = 200;

parcelRegister("hSM1E", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $79ec67bb4c36fbd6$export$403d297463f226af);

var $eUqFw = parcelRequire("eUqFw");

const $79ec67bb4c36fbd6$export$403d297463f226af = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("9CPN0")));

});
parcelRegister("9CPN0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("25tQW")
]).then(()=>parcelRequire('ehM5E'));

});


parcelRegister("1I4cW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9a11e1a2b837fef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $dx7Op = parcelRequire("dx7Op");
var $btCBO = parcelRequire("btCBO");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $5Jx7I = parcelRequire("5Jx7I");

var $l2W2J = parcelRequire("l2W2J");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");


var $eKJ5n = parcelRequire("eKJ5n");

var $hSM1E = parcelRequire("hSM1E");

var $ijWKk = parcelRequire("ijWKk");
function $d9a11e1a2b837fef$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent && (0, $XHGTv.fg)('enable_agent_profile_card')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eKJ5n.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSM1E.ProfileCardLazy), {
        ...profilecardProps,
        actions: profileCardAction,
        hasError: hasError,
        errorType: errorType,
        withoutElevation: true
    }));
}
function $d9a11e1a2b837fef$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isMounted = (0, $eUqFw.useRef)(false);
    const showDelay = trigger === 'click' ? 0 : (0, $515c9dbc88c31cf4$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' ? 0 : (0, $515c9dbc88c31cf4$export$89a9f35a94d7f196);
    const showTimer = (0, $eUqFw.useRef)(0);
    const hideTimer = (0, $eUqFw.useRef)(0);
    const [visible, setVisible] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(undefined);
    const [hasError, setHasError] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $eUqFw.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eUqFw.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eUqFw.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $eUqFw.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const triggerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $eUqFw.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $eUqFw.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $eUqFw.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setTeamCentralBaseUrl(resourceClient.getTeamCentralBaseUrl());
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos()
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const containerListeners = (0, $eUqFw.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $eUqFw.useCallback)(()=>{
        return (0, $5Jx7I.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $eUqFw.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: (0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query_profile_card') ? userId === viewingUserId : data?.isCurrentUser,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: !!visible,
        onClose: (event)=>{
            hideProfilecard();
            handleKeyboardClose(event);
        },
        placement: position,
        offset: offset ?? [
            0,
            8
        ],
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", wrapperProps, showLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9a11e1a2b837fef$var$LoadingView, {
                fireAnalytics: fireAnalytics
            }) : visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9a11e1a2b837fef$var$ProfileCardContent, {
                profilecardProps: profilecardProps,
                isAgent: !!data?.isAgent,
                userId: userId,
                cloudId: cloudId,
                resourceClient: resourceClient,
                viewingUserId: viewingUserId,
                trigger: trigger,
                product: product,
                profileCardAction: filterActions(),
                errorType: error,
                hasError: hasError,
                agentActions: agentActions,
                addFlag: addFlag
            })),
        trigger: (triggerProps)=>{
            const { ref: callbackRef, ...innerProps } = triggerProps;
            const ref = (element)=>{
                triggerRef.current = element;
                if (typeof callbackRef === 'function') callbackRef(element);
            };
            const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                ...disabledAriaAttributes ? restInnerProps : triggerProps,
                ...containerListeners,
                ref: ref,
                "data-testid": testId,
                "aria-labelledby": ariaLabelledBy,
                ...disabledAriaAttributes ? {} : {
                    role: 'button',
                    tabIndex: 0,
                    'aria-label': (0, $l2W2J.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                }
            }, children);
        },
        zIndex: (0, $lcnyw.layers).modal(),
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: autoFocus ?? trigger === 'click'
    }), shouldShowGiveKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx7Op.GiveKudosLauncherLazy), {
        isOpen: kudosDrawerOpen,
        recipient: {
            type: (0, $btCBO.KudosType).INDIVIDUAL,
            recipientId: userId
        },
        analyticsSource: "profile-card",
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        addFlag: addFlag,
        onClose: closeKudosDrawer
    })));
}
const $d9a11e1a2b837fef$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), {
        "data-testId": "profilecard.profilecardtrigger.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijWKk.default), {
        fireAnalytics: fireAnalytics
    }));

});
parcelRegister("dx7Op", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $1be4d1ec21b65937$export$93fe397a02fe8b76);

var $eUqFw = parcelRequire("eUqFw");

const $1be4d1ec21b65937$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("7lJgg")));

});
parcelRegister("7lJgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dSAyy")
]).then(()=>parcelRequire('5A0d0'));

});


parcelRegister("btCBO", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $5cf31a8d69eb9e81$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $5cf31a8d69eb9e81$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $5cf31a8d69eb9e81$export$7a1fc1a1b0477464);
var $5cf31a8d69eb9e81$export$4fa2020056771264;
(function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
})($5cf31a8d69eb9e81$export$4fa2020056771264 || ($5cf31a8d69eb9e81$export$4fa2020056771264 = {}));
var $5cf31a8d69eb9e81$export$d21f9befaa2961a;
(function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
})($5cf31a8d69eb9e81$export$d21f9befaa2961a || ($5cf31a8d69eb9e81$export$d21f9befaa2961a = {}));
const $5cf31a8d69eb9e81$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($5cf31a8d69eb9e81$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("5Jx7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c805980c1a8d0797$export$2e2bcd8739ae039);
const $c805980c1a8d0797$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $c805980c1a8d0797$export$2e2bcd8739ae039 = $c805980c1a8d0797$var$filterActions;

});

parcelRegister("l2W2J", function(module, exports) {

$parcel$export(module.exports, "default", () => $02881092ed20fd17$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $02881092ed20fd17$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($02881092ed20fd17$var$messages.label, {
        fullName: fullName
    }) : formatMessage($02881092ed20fd17$var$messages.fallbackLabel);
};
const $02881092ed20fd17$var$messages = (0, $90IgZ.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $02881092ed20fd17$export$2e2bcd8739ae039 = $02881092ed20fd17$var$getLabelMessage;

});

parcelRegister("kqibQ", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $9338621abe3237e0$export$6aa22a823032b784);
$parcel$export(module.exports, "ProfileImage", () => $9338621abe3237e0$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $9338621abe3237e0$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $9338621abe3237e0$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $9338621abe3237e0$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $9338621abe3237e0$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $9338621abe3237e0$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $9338621abe3237e0$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $9338621abe3237e0$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $9338621abe3237e0$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $9338621abe3237e0$export$2062e7265a95a823);
$parcel$export(module.exports, "FullNameLabel", () => $9338621abe3237e0$export$1270e9c1fc39142b);
$parcel$export(module.exports, "LozengeWrapper", () => $9338621abe3237e0$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $9338621abe3237e0$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $9338621abe3237e0$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $9338621abe3237e0$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "SpinnerContainer", () => $9338621abe3237e0$export$a5e06607a5ac6158);
$parcel$export(module.exports, "CardContainer", () => $9338621abe3237e0$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $9338621abe3237e0$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $9338621abe3237e0$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $9338621abe3237e0$export$b0ec2c767a0e0eab);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $lcnyw = parcelRequire("lcnyw");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
function $9338621abe3237e0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9338621abe3237e0$var$getFullNameMargin = (props)=>props.noMeta ? `${"var(--ds-space-400, 32px)"} 0 ${"var(--ds-space-150, 12px)"} 0` : `${"var(--ds-space-150, 12px)"} 0 0 0`;
const $9338621abe3237e0$export$6aa22a823032b784 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo20"
})("background-color:", (0, $5PC5M.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:", (0, $lcnyw.gridSize)() * 45, "px;");
const $9338621abe3237e0$export$a7a74ab5cffd1455 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo19"
})({
    name: "eukccz",
    styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
});
const $9338621abe3237e0$export$d395c8d16f1e359d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo18"
})({
    name: "18pny36",
    styles: "flex:1 0 auto"
});
// eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
const $9338621abe3237e0$var$kudosButtonAnimationTransformation = (0, $byn9U.keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
const $9338621abe3237e0$export$b08abf2f97b92ea5 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo17"
})("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", (0, $lcnyw.gridSize)() * 4 / (0, $lcnyw.fontSize)(), "em;animation-name:", $9338621abe3237e0$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
const $9338621abe3237e0$export$4a8a956251d4bf6f = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9338621abe3237e0$export$b08abf2f97b92ea5, {
        className: "kudos-blob-animation",
        ...props
    });
const $9338621abe3237e0$export$58517bb1b373a54c = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo16"
})("clip-path:inset(0px 0px 0px 0px round ", (0, $lcnyw.borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
const $9338621abe3237e0$export$6196a3f52a6944fe = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo15"
})({
    name: "18xp5qc",
    styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
});
const $9338621abe3237e0$export$73d695ae27330056 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo14"
})("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $9338621abe3237e0$export$ff778e5b796745a6 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo13"
})("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $9338621abe3237e0$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo12"
})("display:flex;flex-direction:column;min-height:", (0, $lcnyw.gridSize)() * 17, "px;");
const $9338621abe3237e0$export$35cf684daac137ac = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo11"
})("display:flex;flex-direction:column;margin-left:", (0, $lcnyw.gridSize)() * 14.5, "px;width:", (0, $lcnyw.gridSize)() * 24.5, "px;");
const $9338621abe3237e0$export$2062e7265a95a823 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo10"
})("font-size:", (0, $lcnyw.fontSizeSmall)(), "px;color:", (0, $5PC5M.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
const $9338621abe3237e0$export$1270e9c1fc39142b = /*#__PURE__*/ (0, $joBf7.default)("h2", {
    target: "e1ebb2vo9"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:18px;font-weight:400;letter-spacing:normal;color:", (props)=>props.isDisabledAccount ? (0, $5PC5M.headerTextColorInactive) : (0, $5PC5M.headerTextColor), ";margin:", (props)=>$9338621abe3237e0$var$getFullNameMargin(props), ";line-height:", 24 / 18, "em;:first-child{margin:", (props)=>$9338621abe3237e0$var$getFullNameMargin(props), ";}");
const $9338621abe3237e0$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo8"
})({
    name: "m760b1",
    styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
});
const $9338621abe3237e0$export$6ebf103500ba5a45 = /*#__PURE__*/ (0, $joBf7.default)($9338621abe3237e0$export$75180efdd3f4d9c2, {
    target: "e1ebb2vo7"
})({
    name: "15oqcei",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
});
const $9338621abe3237e0$export$d6c0e5f211c8d617 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1ebb2vo6"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;color:", (0, $5PC5M.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
const $9338621abe3237e0$export$4865ffa72a4d5f9 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1ebb2vo5"
})("background:", (0, $5PC5M.appLabelBgColor), ";color:", (0, $5PC5M.appLabelTextColor), ";border-radius:", (0, $lcnyw.borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:bold;text-transform:uppercase;font-size:12px;margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
const $9338621abe3237e0$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo4"
})("align-items:center;display:flex;height:", (0, $lcnyw.gridSize)() * 12, "px;justify-content:center;position:relative;");
const $9338621abe3237e0$export$8a23e74e5cf3ca41 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo3"
})("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $5PC5M.headerBgColorDisabledUser) : (0, $5PC5M.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $5PC5M.headerBgColorDisabledUser) : (0, $5PC5M.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% ", (0, $lcnyw.gridSize)() * 12, "px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5}, 0 0 1px ${0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, $lcnyw.borderRadius)()}px`, ";overflow:hidden;");
const $9338621abe3237e0$export$138a08882ebf7289 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo2"
})("display:flex;align-items:center;line-height:24px;font-size:", (0, $lcnyw.gridSize)() * 1.5, "px;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}");
const $9338621abe3237e0$export$79d7d9b2f6a70c70 = /*#__PURE__*/ (0, $joBf7.default)("dt", {
    target: "e1ebb2vo1"
})("display:flex;flex-shrink:0;color:", (0, $5PC5M.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
const $9338621abe3237e0$export$b0ec2c767a0e0eab = /*#__PURE__*/ (0, $joBf7.default)("dd", {
    target: "e1ebb2vo0"
})("overflow:hidden;text-overflow:ellipsis;color:", (0, $5PC5M.labelTextColor), ";padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");

});
parcelRegister("5PC5M", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $94991c92a8b245c9$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $94991c92a8b245c9$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $94991c92a8b245c9$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $94991c92a8b245c9$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $94991c92a8b245c9$export$5c2df128da90e8de);
$parcel$export(module.exports, "headerTextColorInactive", () => $94991c92a8b245c9$export$a882617dcf7f98a6);
$parcel$export(module.exports, "appLabelBgColor", () => $94991c92a8b245c9$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $94991c92a8b245c9$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $94991c92a8b245c9$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $94991c92a8b245c9$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $94991c92a8b245c9$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $94991c92a8b245c9$export$be3c814f7ed506ed);
$parcel$export(module.exports, "errorTextColor", () => $94991c92a8b245c9$export$ddf766d3bfcf965c);

const $94991c92a8b245c9$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $94991c92a8b245c9$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`;
const $94991c92a8b245c9$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`;
const $94991c92a8b245c9$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $94991c92a8b245c9$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $94991c92a8b245c9$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
const $94991c92a8b245c9$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`;
const $94991c92a8b245c9$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
const $94991c92a8b245c9$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
const $94991c92a8b245c9$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$c2e91cbeada39b8b)})`;
const $94991c92a8b245c9$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`;
const $94991c92a8b245c9$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
const $94991c92a8b245c9$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`;

});


parcelRegister("3vXh8", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $3825798267526520$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $3825798267526520$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $3825798267526520$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $3825798267526520$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $3825798267526520$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $3825798267526520$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $3825798267526520$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $3825798267526520$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $3825798267526520$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $3825798267526520$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $3825798267526520$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $3825798267526520$export$a9f8c9f412cf5664);

var $cEOpo = parcelRequire("cEOpo");
/** Below lines are copied from teams common analytics */ const $3825798267526520$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $3825798267526520$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $3825798267526520$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $3825798267526520$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($3825798267526520$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $3825798267526520$var$TEAM_SUBJECT = 'teamProfileCard';
const $3825798267526520$var$USER_SUBJECT = 'profilecard';
const $3825798267526520$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $3825798267526520$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $cEOpo.getPageTime)())
        }
    });
const $3825798267526520$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $3825798267526520$var$USER_SUBJECT;
        case 'team':
            return $3825798267526520$var$TEAM_SUBJECT;
        case 'agent':
            return $3825798267526520$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $3825798267526520$export$d50ab8a3b6975c = (type, method)=>{
    return $3825798267526520$var$createEvent('ui', 'triggered', $3825798267526520$var$getActionSubject(type), undefined, {
        method: method
    });
};
const $3825798267526520$export$c9b0e37b229a297b = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$TEAM_SUBJECT, 'request', attributes);
const $3825798267526520$export$12dae48763368ac9 = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$USER_SUBJECT, 'request', attributes);
const $3825798267526520$export$41816a317479160b = (type, actionSubjectId, attributes)=>$3825798267526520$var$createEvent('ui', 'rendered', $3825798267526520$var$getActionSubject(type), actionSubjectId, attributes);
const $3825798267526520$export$fdcd134fbeb1f921 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$getActionSubject(type), 'action', attributes);
const $3825798267526520$export$93260987012593be = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$USER_SUBJECT, 'reportingLines', attributes);
const $3825798267526520$export$79befd155063a6a7 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$getActionSubject(type), 'moreActions', attributes);
const $3825798267526520$export$2703289b35687fde = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'avatar', attributes);
const $3825798267526520$export$b4411a7661cf2d3f = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $3825798267526520$export$c86679da702d560e = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $3825798267526520$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("cEOpo", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $77671953c6d01f45$export$e9faea7c41053334);
const $77671953c6d01f45$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $77671953c6d01f45$var$performanceAvailable = $77671953c6d01f45$var$isPerformanceAvailable();
const $77671953c6d01f45$var$initialPageTime = Date.now();
const $77671953c6d01f45$export$e9faea7c41053334 = ()=>{
    if ($77671953c6d01f45$var$performanceAvailable) return performance.now();
    return Date.now() - $77671953c6d01f45$var$initialPageTime;
};

});


parcelRegister("eKJ5n", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $f174a152b20761e7$export$4b013ffffcb40af8);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $3vXh8 = parcelRequire("3vXh8");

var $6oOPK = parcelRequire("6oOPK");

var $4ga2m = parcelRequire("4ga2m");

var $kCTG1 = parcelRequire("kCTG1");

var $i6n3V = parcelRequire("i6n3V");
const $f174a152b20761e7$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $eUqFw.useState)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $eUqFw.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $6oOPK.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $eUqFw.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const getAgentInfo = (0, $eUqFw.useCallback)(()=>{
        return props.resourceClient.getRovoAgentProfile({
            type: 'identity',
            value: props.accountId
        }, fireAnalytics);
    }, [
        fireAnalytics,
        props.accountId,
        props.resourceClient
    ]);
    const fetchData = (0, $eUqFw.useCallback)(async ()=>{
        setIsLoading(true);
        const getAgentData = async ()=>{
            const profileData = await getAgentInfo();
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            return {
                ...profileData,
                creatorInfo: agentCreatorInfo
            };
        };
        const agentData = await getAgentData();
        setAgentData(agentData);
        setIsLoading(false);
    }, [
        getAgentInfo,
        getCreator
    ]);
    (0, $eUqFw.useEffect)(()=>{
        try {
            fetchData();
        } catch (error) {
            setIsLoading(false);
            setError(error);
        }
    }, [
        fetchData,
        getAgentInfo,
        getCreator,
        props.accountId,
        props.cloudId,
        props.resourceClient
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCTG1.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ga2m.default), {
        reload: ()=>{
            fetchData();
        },
        errorType: error || null,
        fireAnalytics: ()=>{}
    }));
    if (agentData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6n3V.AgentProfileCardLazy), {
        agent: agentData,
        isLoading: isLoading,
        hasError: !!error,
        isCreatedByViewingUser: creatorUserId === props.viewingUserId,
        product: props.product,
        onConversationStartersClick: props.onConversationStartersClick,
        onChatClick: props.onChatClick,
        addFlag: props.addFlag,
        resourceClient: props.resourceClient,
        cloudId: props.cloudId
    });
    return null;
};

});
parcelRegister("6oOPK", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $d85581b87885252e$export$3761e66a04602cbd);
const $d85581b87885252e$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d85581b87885252e$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d85581b87885252e$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("4ga2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $486d3bd21855e22f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5k4ch = parcelRequire("5k4ch");

var $fnJ1y = parcelRequire("fnJ1y");

var $3vXh8 = parcelRequire("3vXh8");
const $486d3bd21855e22f$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $eUqFw.useEffect)(()=>{
        fireAnalytics((0, $3vXh8.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorTitle), null, "The user is no longer available for the site");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorTitle), null, "Oops, looks like we\u2019re having issues", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorText), null, "Try again and we\u2019ll give it another shot"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorWrapper), {
        "data-testid": "profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
        label: "icon error",
        size: "xlarge"
    }), errorContent(), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: reload
    }, "Try again"));
};
var $486d3bd21855e22f$export$2e2bcd8739ae039 = $486d3bd21855e22f$var$ErrorMessage;

});
parcelRegister("5k4ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e02137160dfc264$var$_react = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $3e02137160dfc264$var$_crossCircle = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $3e02137160dfc264$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e02137160dfc264$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $3e02137160dfc264$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $3e02137160dfc264$var$_crossCircle.default
    }));
$3e02137160dfc264$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $3e02137160dfc264$var$_default = module.exports.default = $3e02137160dfc264$var$CrossCircleIcon;

});

parcelRegister("fnJ1y", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $0ffb74661b2a3e3e$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $0ffb74661b2a3e3e$export$b065fd053267ec81);
$parcel$export(module.exports, "ErrorText", () => $0ffb74661b2a3e3e$export$7f714e6c560938e5);
$parcel$export(module.exports, "TeamErrorTitle", () => $0ffb74661b2a3e3e$export$d139ade0bdee219d);
$parcel$export(module.exports, "TeamErrorText", () => $0ffb74661b2a3e3e$export$90d92ccfb27352c6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $lcnyw = parcelRequire("lcnyw");

var $4lTFP = parcelRequire("4lTFP");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
const $0ffb74661b2a3e3e$export$bb27b7e39840238f = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1g2atxt4"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorIconColor)
});
const $0ffb74661b2a3e3e$export$b065fd053267ec81 = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorTitleColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: `${(0, $lcnyw.gridSize)() * 3}px`,
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $0ffb74661b2a3e3e$export$7f714e6c560938e5 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1g2atxt2"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorTextColor)
});
const $0ffb74661b2a3e3e$export$d139ade0bdee219d = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt1"
})((0, $4lTFP.h400));
const $0ffb74661b2a3e3e$export$90d92ccfb27352c6 = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt0"
})({
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});


parcelRegister("kCTG1", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $66858e19046e4863$export$2c6604b50c274e6f);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $66858e19046e4863$var$styles = (0, $1ZAYh.xcss)({
    width: '360px'
});
const $66858e19046e4863$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $66858e19046e4863$var$styles
    }, children);
};

});

parcelRegister("i6n3V", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $05a0ac107f346903$export$ed0ca9c1d49ea0bf);

var $eUqFw = parcelRequire("eUqFw");

const $05a0ac107f346903$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("a70Wh")));

});
parcelRegister("a70Wh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("i4qmQ")
]).then(()=>parcelRequire('6uyUT'));

});



parcelRegister("ijWKk", function(module, exports) {

$parcel$export(module.exports, "default", () => $005cfbb6d85cc048$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
const $005cfbb6d85cc048$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $eUqFw.useEffect)(()=>{
        fireAnalytics((0, $3vXh8.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
};
var $005cfbb6d85cc048$export$2e2bcd8739ae039 = $005cfbb6d85cc048$var$UserLoadingState;

});



parcelRegister("8PYmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac2720ab38ce9772$export$2e2bcd8739ae039);

var $4eGN1 = parcelRequire("4eGN1");

var $lsiAJ = parcelRequire("lsiAJ");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");
var $ac2720ab38ce9772$export$2e2bcd8739ae039 = (0, $lsiAJ.default);

});
parcelRegister("4eGN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3adc3d48b40454$export$2e2bcd8739ae039);

var $6roQF = parcelRequire("6roQF");
class $7c3adc3d48b40454$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $6roQF.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});
parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("lsiAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b7dde52ef02eed$export$2e2bcd8739ae039);

var $dfBCt = parcelRequire("dfBCt");

var $XHGTv = parcelRequire("XHGTv");

var $9KeXL = parcelRequire("9KeXL");

var $kmpkL = parcelRequire("kmpkL");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");
const $84b7dde52ef02eed$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $84b7dde52ef02eed$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$84b7dde52ef02eed$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $84b7dde52ef02eed$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $b4hs7.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $kWhjG.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $9KeXL.default)(withDefaultConfig);
        this.tcClient = $84b7dde52ef02eed$var$maybeCreateTeamCentralClient(config, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    getTeamCentralBaseUrl() {
        return this.tcClient?.options.teamCentralBaseUrl;
    }
    shouldShowGiveKudos() {
        if (!this.tcClient || !this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $84b7dde52ef02eed$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $dfBCt.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = (0, $XHGTv.fg)('enable_ptc_sharded_townsquare_calls') ? config.teamCentralDisabled !== true : config.teamCentralUrl;
    return teamCentralEnabled ? new (0, $kmpkL.default)({
        ...config
    }) : undefined;
}
var $84b7dde52ef02eed$export$2e2bcd8739ae039 = $84b7dde52ef02eed$var$ProfileCardClient;

});
parcelRegister("9KeXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a501e1692a6dcaf$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");
const $4a501e1692a6dcaf$var$createHeaders = (product, cloudId)=>{
    const config = {
        headers: {
            'X-Product': product,
            'X-Experience-Id': 'profile-card',
            'X-Cloudid': cloudId || ''
        }
    };
    return new Headers({
        ...config.headers || {}
    });
};
class $4a501e1692a6dcaf$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $4a501e1692a6dcaf$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`/gateway/api/assist/agents/v1/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`/gateway/api/assist/agents/v1/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('triggered'));
            const headers = $4a501e1692a6dcaf$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $4a501e1692a6dcaf$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("bl3OJ", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $d2cc0f3532818141$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $d2cc0f3532818141$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $d2cc0f3532818141$export$d9ad65d422ee3f8c);

var $j4C9S = parcelRequire("j4C9S");
const $d2cc0f3532818141$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $d2cc0f3532818141$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $d2cc0f3532818141$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $d2cc0f3532818141$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $j4C9S.DirectoryGraphQLError)) return !!error && $d2cc0f3532818141$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $j4C9S.AGGError)) return !!error.errorType && $d2cc0f3532818141$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $d2cc0f3532818141$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $d2cc0f3532818141$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $j4C9S.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d2cc0f3532818141$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d2cc0f3532818141$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $j4C9S.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$d2cc0f3532818141$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $j4C9S.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d2cc0f3532818141$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d2cc0f3532818141$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $j4C9S.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$d2cc0f3532818141$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $j4C9S.DirectoryGraphQLErrors) || causeError instanceof (0, $j4C9S.AGGErrors)) return $d2cc0f3532818141$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $d2cc0f3532818141$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $j4C9S.DirectoryGraphQLErrors)(errors, traceId);
};
const $d2cc0f3532818141$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $j4C9S.AGGErrors)(errors, traceId);
};

});
parcelRegister("j4C9S", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $343a8316fe4e3587$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $343a8316fe4e3587$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $343a8316fe4e3587$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $343a8316fe4e3587$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $343a8316fe4e3587$export$60d8267243755b9c);
class $343a8316fe4e3587$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $343a8316fe4e3587$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $343a8316fe4e3587$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $343a8316fe4e3587$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $343a8316fe4e3587$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $343a8316fe4e3587$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $343a8316fe4e3587$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("kmpkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8fb2ad4171564c$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $4eGN1 = parcelRequire("4eGN1");

var $6WG70 = parcelRequire("6WG70");
const $ab8fb2ad4171564c$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
let $ab8fb2ad4171564c$var$isTCReadyPromiseMap = new Map();
class $ab8fb2ad4171564c$var$TeamCentralCardClient extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.isTCReadyPromise = this.createTcReadyPromise(options);
    }
    createTcReadyPromise(config) {
        if (config.cloudId) {
            let promise = $ab8fb2ad4171564c$var$isTCReadyPromiseMap.get(config.cloudId);
            if (!promise) {
                promise = this.hasTCWorkspace(config);
                $ab8fb2ad4171564c$var$isTCReadyPromiseMap.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if ((0, $XHGTv.fg)('enable_ptc_sharded_townsquare_calls')) {
            if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
            const query = $ab8fb2ad4171564c$export$1862ef0c3880ca8d(userId);
            const response = await (0, $6WG70.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
            return response.reportingLines;
        } else {
            if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
            const query = $ab8fb2ad4171564c$export$1862ef0c3880ca8d(userId);
            const response = await (0, $6WG70.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=ReportingLines`, query);
            return response.reportingLines;
        }
    }
    checkWorkspaceExists() {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    hasTCWorkspace(config) {
        if (config.cloudId) {
            const maybeShardedPath = (0, $XHGTv.fg)('enable_ptc_sharded_townsquare_calls') ? `/townsquare/s/${config.cloudId}` : '/watermelon';
            return fetch(`/gateway/api${maybeShardedPath}/organization/containsAnyWorkspace?cloudId=${config.cloudId}`).then((res)=>{
                return !res || res && res.ok;
            });
        } else return Promise.resolve(false);
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $ab8fb2ad4171564c$export$2e2bcd8739ae039 = $ab8fb2ad4171564c$var$TeamCentralCardClient;

});
parcelRegister("6WG70", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $415b57eeeceb8e81$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $415b57eeeceb8e81$export$a14afb5f82fe705);

var $j4C9S = parcelRequire("j4C9S");

var $bl3OJ = parcelRequire("bl3OJ");
const $415b57eeeceb8e81$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $415b57eeeceb8e81$var$id = (headers)=>headers;
async function $415b57eeeceb8e81$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id) {
    return $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bl3OJ.handleDirectoryGraphQLErrors));
}
async function $415b57eeeceb8e81$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id) {
    return $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bl3OJ.handleAGGErrors));
}
async function $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id, handleErrors) {
    const headers = processHeaders($415b57eeeceb8e81$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $j4C9S.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});


parcelRegister("kWhjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $26e65ba6df7e3eef$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $k39sp = parcelRequire("k39sp");
class $26e65ba6df7e3eef$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $k39sp.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("k39sp", function(module, exports) {

$parcel$export(module.exports, "getTeamFromAGG", () => $b92dd34bfd4aec4a$export$26a8aad0c7182dd6);

var $6WG70 = parcelRequire("6WG70");
const $b92dd34bfd4aec4a$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $b92dd34bfd4aec4a$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $b92dd34bfd4aec4a$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $b92dd34bfd4aec4a$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $b92dd34bfd4aec4a$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $b92dd34bfd4aec4a$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$b92dd34bfd4aec4a$var$TEAM_FRAGMENT}
    }
  }
}`;
const $b92dd34bfd4aec4a$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $b92dd34bfd4aec4a$export$4968f4e0119a5d9c,
        variables: {
            teamId: $b92dd34bfd4aec4a$export$681597d03c8a0fd2(teamId),
            siteId: siteId || 'None'
        }
    });
const $b92dd34bfd4aec4a$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $b92dd34bfd4aec4a$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $b92dd34bfd4aec4a$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $6WG70.AGGQuery)(url, query, $b92dd34bfd4aec4a$export$1229c72526c01df2);
    return $b92dd34bfd4aec4a$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("b4hs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b3ff2ca38ed950$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $3vXh8 = parcelRequire("3vXh8");

var $j9Z8Z = parcelRequire("j9Z8Z");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $6WG70 = parcelRequire("6WG70");
const $80b3ff2ca38ed950$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $80b3ff2ca38ed950$export$bfbf383663068c37 = (cloudId, userId)=>({
        query: `query User($userId: String!, $cloudId: String!) {
    User: CloudUser(userId: $userId, cloudId: $cloudId) {
      id
      isCurrentUser
      status
      statusModifiedDate
      isBot
      isNotMentionable
      fullName
      nickname
      email
      meta: title
      location
      companyName
      avatarUrl(size: 192)
      remoteWeekdayIndex: localTime(format: "d")
      remoteWeekdayString: localTime(format: "ddd")
      remoteTimeString: localTime(format: "h:mma")
    }
  }`,
        variables: {
            cloudId: cloudId,
            userId: userId
        }
    });
const $80b3ff2ca38ed950$export$8230f28f7ae567ea = (userId)=>({
        //The query name needs to be app_user_characteristics in order to return appType field
        query: `query app_user_characteristics($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`,
        variables: {
            userId: userId
        }
    });
const $80b3ff2ca38ed950$var$queryAGGUser = async (url, userId)=>{
    const query = $80b3ff2ca38ed950$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $6WG70.AGGQuery)(url, query);
    return user;
};
class $80b3ff2ca38ed950$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        if ((0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query_profile_card')) {
            const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
            const userQueryPromise = $80b3ff2ca38ed950$var$queryAGGUser(gatewayGraphqlUrl, userId);
            const user = await userQueryPromise;
            let timestring;
            const localWeekdayIndex = new Date().getDay().toString();
            if (user.zoneinfo) {
                if ((0, $j9Z8Z.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $j9Z8Z.localTime)(user.zoneinfo, 'h:mmbbb') || undefined;
                else timestring = (0, $j9Z8Z.localTime)(user.zoneinfo, 'eee h:mmbbb') || undefined;
            }
            return {
                ...user,
                isBot: user.__typename === 'AppUser',
                isAgent: user.appType === 'agent',
                status: user.accountStatus,
                statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
                avatarUrl: user.picture,
                email: user.email,
                fullName: user.name,
                location: user.extendedProfile?.location,
                meta: user.extendedProfile?.jobTitle,
                nickname: user.nickname,
                companyName: user.extendedProfile?.organization,
                timestring: timestring
            };
        } else {
            if (!this.options.url) throw new Error('options.url is a required parameter');
            const query = $80b3ff2ca38ed950$export$bfbf383663068c37(cloudId, userId);
            const response = await (0, $6WG70.directoryGraphqlQuery)(this.options.url, query);
            return $80b3ff2ca38ed950$export$b26b7f9bcf400835(response);
        }
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("j9Z8Z", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $8973c96ca3937b75$export$f0dfd716e7b023cd);
parcelRequire("isoj5");
var $hhZDn = parcelRequire("hhZDn");
const $8973c96ca3937b75$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $hhZDn.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("isoj5", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("hhZDn")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $hhZDn = parcelRequire("hhZDn");





});
parcelRegister("hhZDn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c963d570fe7b6c77$export$2e2bcd8739ae039);

var $1WmNj = parcelRequire("1WmNj");

var $7ue53 = parcelRequire("7ue53");

var $iPYJi = parcelRequire("iPYJi");
function $c963d570fe7b6c77$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1WmNj)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $7ue53.default)((0, $iPYJi.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("7ue53", function(module, exports) {

$parcel$export(module.exports, "default", () => $573641d4461c49f9$export$2e2bcd8739ae039);

var $Yg8hb = parcelRequire("Yg8hb");

var $fIcie = parcelRequire("fIcie");

var $MQM8H = parcelRequire("MQM8H");
var $573641d4461c49f9$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $573641d4461c49f9$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($573641d4461c49f9$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $MQM8H.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $fIcie.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yg8hb)))(dirtyDate, formatStr, options);
}

});
parcelRegister("fIcie", function(module, exports) {

$parcel$export(module.exports, "default", () => $b704803901ba91de$export$2e2bcd8739ae039);

var $3duP9 = parcelRequire("3duP9");

var $5joVX = parcelRequire("5joVX");
var $b704803901ba91de$var$MILLISECONDS_IN_MINUTE = 60000;
var $b704803901ba91de$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $b704803901ba91de$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $b704803901ba91de$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $b704803901ba91de$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $b704803901ba91de$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $b704803901ba91de$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $b704803901ba91de$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $b704803901ba91de$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $b704803901ba91de$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $b704803901ba91de$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $b704803901ba91de$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $b704803901ba91de$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $3duP9.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $3duP9.default)('long', date, options);
        }
    }
};
function $b704803901ba91de$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $5joVX.default)(timeZone, originalDate, true) / $b704803901ba91de$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $b704803901ba91de$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $b704803901ba91de$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $b704803901ba91de$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $b704803901ba91de$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $b704803901ba91de$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $b704803901ba91de$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $b704803901ba91de$var$formatTimezone(offset, dirtyDelimeter);
}
function $b704803901ba91de$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $b704803901ba91de$var$addLeadingZeros(minutes, 2);
}
var $b704803901ba91de$export$2e2bcd8739ae039 = $b704803901ba91de$var$formatters;

});
parcelRegister("3duP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $257a7efc9a6a7864$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $257a7efc9a6a7864$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $257a7efc9a6a7864$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $257a7efc9a6a7864$var$partsTimeZone(dtf, date) : $257a7efc9a6a7864$var$hackyTimeZone(dtf, date);
}
function $257a7efc9a6a7864$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $257a7efc9a6a7864$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $257a7efc9a6a7864$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("5joVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de211721fa9aed9$export$2e2bcd8739ae039);

var $fu1or = parcelRequire("fu1or");

var $469iB = parcelRequire("469iB");
var $3de211721fa9aed9$var$MILLISECONDS_IN_HOUR = 3600000;
var $3de211721fa9aed9$var$MILLISECONDS_IN_MINUTE = 60000;
var $3de211721fa9aed9$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $3de211721fa9aed9$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $3de211721fa9aed9$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $3de211721fa9aed9$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$3de211721fa9aed9$var$validateTimezone(hours)) return NaN;
        return -(hours * $3de211721fa9aed9$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $3de211721fa9aed9$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$3de211721fa9aed9$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $3de211721fa9aed9$var$MILLISECONDS_IN_HOUR + minutes * $3de211721fa9aed9$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($3de211721fa9aed9$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $3de211721fa9aed9$var$toUtcDate(date);
        var offset = $3de211721fa9aed9$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $3de211721fa9aed9$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $3de211721fa9aed9$var$toUtcDate(date) {
    return (0, $469iB.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $3de211721fa9aed9$var$calcOffset(date, timezoneString) {
    var tokens = (0, $fu1or.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $469iB.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $3de211721fa9aed9$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $3de211721fa9aed9$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $3de211721fa9aed9$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $3de211721fa9aed9$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $3de211721fa9aed9$var$validIANATimezoneCache = {};
function $3de211721fa9aed9$var$isValidTimezoneIANAString(timeZoneString) {
    if ($3de211721fa9aed9$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $3de211721fa9aed9$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("fu1or", function(module, exports) {

$parcel$export(module.exports, "default", () => $b45abcffef27852f$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $b45abcffef27852f$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $b45abcffef27852f$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $b45abcffef27852f$var$partsOffset(dtf, date) : $b45abcffef27852f$var$hackyOffset(dtf, date);
}
var $b45abcffef27852f$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $b45abcffef27852f$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $b45abcffef27852f$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $b45abcffef27852f$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $b45abcffef27852f$var$dtfCache = {};
function $b45abcffef27852f$var$getDateTimeFormat(timeZone) {
    if (!$b45abcffef27852f$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $b45abcffef27852f$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $b45abcffef27852f$var$dtfCache[timeZone];
}

});

parcelRegister("469iB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fbeef8f33537542$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $2fbeef8f33537542$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("MQM8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $092d6be9aa48deb7$export$2e2bcd8739ae039);

var $4Zzm9 = parcelRequire("4Zzm9");

var $YdpzT = parcelRequire("YdpzT");

var $5joVX = parcelRequire("5joVX");

var $cK6LU = parcelRequire("cK6LU");
var $092d6be9aa48deb7$var$MILLISECONDS_IN_HOUR = 3600000;
var $092d6be9aa48deb7$var$MILLISECONDS_IN_MINUTE = 60000;
var $092d6be9aa48deb7$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $092d6be9aa48deb7$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $cK6LU.default)
};
function $092d6be9aa48deb7$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $092d6be9aa48deb7$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($4Zzm9)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $092d6be9aa48deb7$var$splitDateString(argument);
    var parseYearResult = $092d6be9aa48deb7$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $092d6be9aa48deb7$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $092d6be9aa48deb7$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $5joVX.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $092d6be9aa48deb7$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $092d6be9aa48deb7$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $092d6be9aa48deb7$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $092d6be9aa48deb7$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $092d6be9aa48deb7$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $092d6be9aa48deb7$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $092d6be9aa48deb7$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $092d6be9aa48deb7$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $092d6be9aa48deb7$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $092d6be9aa48deb7$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $092d6be9aa48deb7$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$092d6be9aa48deb7$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $092d6be9aa48deb7$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$092d6be9aa48deb7$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $092d6be9aa48deb7$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$092d6be9aa48deb7$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $092d6be9aa48deb7$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$092d6be9aa48deb7$var$validateWeekDate(year, week)) return new Date(NaN);
        return $092d6be9aa48deb7$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $092d6be9aa48deb7$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$092d6be9aa48deb7$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $092d6be9aa48deb7$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $092d6be9aa48deb7$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $092d6be9aa48deb7$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$092d6be9aa48deb7$var$validateTime(hours)) return NaN;
        return hours % 24 * $092d6be9aa48deb7$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $092d6be9aa48deb7$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$092d6be9aa48deb7$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $092d6be9aa48deb7$var$MILLISECONDS_IN_HOUR + minutes * $092d6be9aa48deb7$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $092d6be9aa48deb7$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$092d6be9aa48deb7$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $092d6be9aa48deb7$var$MILLISECONDS_IN_HOUR + minutes * $092d6be9aa48deb7$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $092d6be9aa48deb7$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $092d6be9aa48deb7$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $092d6be9aa48deb7$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $092d6be9aa48deb7$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $092d6be9aa48deb7$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $092d6be9aa48deb7$var$isLeapYearIndex(year);
        if (isLeapYear && date > $092d6be9aa48deb7$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $092d6be9aa48deb7$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $092d6be9aa48deb7$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $092d6be9aa48deb7$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $092d6be9aa48deb7$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $092d6be9aa48deb7$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("cK6LU", function(module, exports) {

$parcel$export(module.exports, "default", () => $946f08a27a12da04$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $946f08a27a12da04$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $946f08a27a12da04$export$2e2bcd8739ae039 = $946f08a27a12da04$var$tzPattern;

});



parcelRegister("iPYJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $db6c190bd1e807d1$export$2e2bcd8739ae039);

var $5joVX = parcelRequire("5joVX");

var $MQM8H = parcelRequire("MQM8H");
function $db6c190bd1e807d1$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $MQM8H.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $5joVX.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("cArR5", function(module, exports) {

$parcel$export(module.exports, "ErrorStateContainer", () => $ef14515637d63aef$export$3c552bcab5076086);
$parcel$export(module.exports, "DescriptionContainer", () => $ef14515637d63aef$export$31dea26885d599bc);
$parcel$export(module.exports, "ContributorsContainer", () => $ef14515637d63aef$export$99a01e3168077336);
$parcel$export(module.exports, "ErrorStateTitleContainer", () => $ef14515637d63aef$export$356d8151189db67b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points


var $joBf7 = parcelRequire("joBf7");
function $ef14515637d63aef$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ef14515637d63aef$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$exports).N800})`;
const $ef14515637d63aef$export$3c552bcab5076086 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e14gx3xq5"
})({
    margin: `${"var(--ds-space-1000, 80px)"} auto 0px auto`,
    textAlign: 'center',
    width: '30%',
    color: $ef14515637d63aef$export$32f78bffcd82ff28
});
const $ef14515637d63aef$export$31dea26885d599bc = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e14gx3xq4"
})({
    margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-0, 0px)"}`
});
const $ef14515637d63aef$export$99a01e3168077336 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e14gx3xq3"
})({
    margin: `${"var(--ds-space-negative-025, -2px)"} 0px`
});
const $ef14515637d63aef$export$356d8151189db67b = /*#__PURE__*/ (0, $joBf7.default)("h3", {
    target: "e14gx3xq2"
})({
    name: "0",
    styles: ""
});
const $ef14515637d63aef$export$6edec4986bb81a80 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e14gx3xq1"
})({
    name: "0",
    styles: ""
});
const $ef14515637d63aef$export$402a96ca7c4b4618 = /*#__PURE__*/ (0, $joBf7.default)("small", {
    target: "e14gx3xq0"
})({
    name: "0",
    styles: ""
});

});

parcelRegister("e2gVN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2fe62de8782020$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f2fe62de8782020$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        id: 'confluence-table-tree.error.title',
        defaultMessage: 'Well, this is awkward...'
    },
    errorDescription: {
        id: 'confluence-table-tree.error.description',
        defaultMessage: "We can't show you these pages. Please try again later."
    },
    errorRow: {
        id: 'confluence-table-tree.error.row',
        defaultMessage: 'Unable to load pages.'
    },
    emptyTitle: {
        id: 'confluence-table-tree.empty.title',
        defaultMessage: "There's nothing here but potential"
    },
    emptyDescription: {
        id: 'confluence-table-tree.empty.description',
        defaultMessage: 'Create some meeting notes, product requirements, decisions, or other content to see this space fill up.'
    },
    create: {
        id: 'confluence-table-tree.create-page',
        defaultMessage: 'Create page'
    },
    title: {
        id: 'confluence-table-tree.column.title',
        defaultMessage: 'Name'
    },
    contributors: {
        id: 'confluence-table-tree.column.contributors',
        defaultMessage: 'Contributors'
    },
    lastModified: {
        id: 'confluence-table-tree.column.last-modified',
        defaultMessage: 'Last modified'
    },
    viewProfile: {
        id: 'confluence-table-tree.view-profile',
        defaultMessage: 'View profile'
    },
    couldNotLoad: {
        id: 'confluence-table-tree.could-not-load',
        defaultMessage: "Couldn't load",
        description: 'Message shown when unable to fetch last update time of a page'
    },
    couldNotLoadContributors: {
        id: 'confluence-table-tree.could-not-load-contributors',
        defaultMessage: "Couldn't load contributors",
        description: 'Tooltip shown when unable to fetch contributors of a page'
    },
    editInConfluence: {
        id: 'confluence-table-tree.edit-in-confluence',
        defaultMessage: 'Edit in Confluence'
    },
    edit: {
        id: 'confluence-table-tree.edit',
        defaultMessage: 'Edit'
    },
    createChildPage: {
        id: 'confluence-table-tree.create-child-page',
        defaultMessage: 'Create a child page',
        description: 'Tooltip for button to create a child page in the Project Pages page tree'
    }
});

});


parcelRegister("mWrG0", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $0e0fe9908ca127bf$export$c1ed4f415b9e7023);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $fI650 = parcelRequire("fI650");

var $gWxA1 = parcelRequire("gWxA1");

var $2jDha = parcelRequire("2jDha");

var $cArR5 = parcelRequire("cArR5");

var $6K8He = parcelRequire("6K8He");

var $e2gVN = parcelRequire("e2gVN");

var $k2uNy = parcelRequire("k2uNy");

var $atana = parcelRequire("atana");
const $0e0fe9908ca127bf$var$errorTypeToMessages = (type)=>{
    if (type === 'error') return {
        title: (0, $e2gVN.default).errorTitle,
        description: (0, $e2gVN.default).errorDescription
    };
    return {
        title: (0, $e2gVN.default).emptyTitle,
        description: (0, $e2gVN.default).emptyDescription
    };
};
class $0e0fe9908ca127bf$export$156af8fdc16e5770 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            readOnly: false
        };
    }
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent, type: type, readOnly: readOnly } = this.props;
        if (createAnalyticsEvent) {
            if (type === (0, $6K8He.Errors).Error) (0, $gWxA1.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluencePageTree errorStateShown');
            else if (type === (0, $6K8He.Errors).Empty) (0, $gWxA1.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluencePageTree emptyStateShown', {
                readOnly: readOnly
            });
        }
    }
    render() {
        const { type: type, readOnly: readOnly, spaceKey: spaceKey } = this.props;
        const { title: title, description: description } = $0e0fe9908ca127bf$var$errorTypeToMessages(type);
        const imgMap = {
            error: (0, (/*@__PURE__*/$parcel$interopDefault($atana))),
            empty: (0, (/*@__PURE__*/$parcel$interopDefault($k2uNy)))
        };
        let createPageHref = '';
        if (spaceKey) createPageHref = `/wiki/spaces/${spaceKey}/overview?createDialog=true&createDialogSpaceKey=${spaceKey}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cArR5.ErrorStateContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            src: imgMap[type],
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cArR5.ErrorStateTitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cArR5.DescriptionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), description)), type === (0, $6K8He.Errors).Empty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
            appearance: "primary",
            isDisabled: readOnly,
            href: createPageHref,
            target: "_blank",
            onClick: (_, analyticsEvent)=>{
                (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'confluencePageTreeEmptyStateCreateButton');
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $e2gVN.default).create)) : null);
    }
}
const $0e0fe9908ca127bf$export$c1ed4f415b9e7023 = (0, $2jDha.default)()((0, $2qhQi.default)($0e0fe9908ca127bf$export$156af8fdc16e5770));

});
parcelRegister("fI650", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b28527f26e4865$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4kMup = parcelRequire("4kMup");

var $3Ucf8 = parcelRequire("3Ucf8");
const $f7b28527f26e4865$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const baseProps = (0, $3Ucf8.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        ...saferRest,
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        /**
			 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
			 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
			 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }, baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $f7b28527f26e4865$var$WithRef = /*#__PURE__*/ (0, $eUqFw.forwardRef)($f7b28527f26e4865$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $f7b28527f26e4865$var$LinkButton = /*#__PURE__*/ (0, $eUqFw.memo)($f7b28527f26e4865$var$WithRef);
var $f7b28527f26e4865$export$2e2bcd8739ae039 = $f7b28527f26e4865$var$LinkButton;

});

parcelRegister("k2uNy", function(module, exports) {
module.exports = new URL("empty.2697b975.png", import.meta.url).toString();

});

parcelRegister("atana", function(module, exports) {
module.exports = new URL("error.6d4f954a.png", import.meta.url).toString();

});


parcelRegister("3bVnn", function(module, exports) {

$parcel$export(module.exports, "default", () => $62b92224c9f9bd72$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $5NIRN = parcelRequire("5NIRN");
var $4qM4y = parcelRequire("4qM4y");

var $e2gVN = parcelRequire("e2gVN");
const $62b92224c9f9bd72$var$ErrorRowBase = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qM4y.default), {
        itemId: "error",
        hasChildren: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5NIRN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $e2gVN.default).errorRow))));
};
var $62b92224c9f9bd72$export$2e2bcd8739ae039 = $62b92224c9f9bd72$var$ErrorRowBase;

});

parcelRegister("cbVLV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a07a738a59f7831$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $gWxA1 = parcelRequire("gWxA1");

var $bFzGY = parcelRequire("bFzGY");

var $e2gVN = parcelRequire("e2gVN");

var $1NUEg = parcelRequire("1NUEg");
const $2a07a738a59f7831$var$lastUpdatedMessages = (0, $90IgZ.defineMessages)({
    created: {
        id: 'confluence-table-tree.friendly-when-created',
        defaultMessage: 'Created',
        description: 'Displayed next to a timestamp to indicate when a page was first created'
    },
    updated: {
        id: 'confluence-table-tree.friendly-when-updated',
        defaultMessage: 'Updated',
        description: 'Displayed next to a timestamp to indicate when a page was last updated'
    }
});
const $2a07a738a59f7831$export$94198873dffecd09 = ({ lastUpdated: lastUpdated })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if (!lastUpdated) {
        (0, $gWxA1.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluencePageTree unknownContributor');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $e2gVN.default).couldNotLoad));
    }
    const { friendlyWhen: friendlyWhen, number: number } = lastUpdated;
    const prefix = number === 1 ? $2a07a738a59f7831$var$lastUpdatedMessages.created : $2a07a738a59f7831$var$lastUpdatedMessages.updated;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1NUEg.LastUpdatedWrapper), null, formatMessage(prefix), " ", friendlyWhen);
};
var $2a07a738a59f7831$export$2e2bcd8739ae039 = $2a07a738a59f7831$export$94198873dffecd09;

});
parcelRegister("1NUEg", function(module, exports) {

$parcel$export(module.exports, "LastUpdatedWrapper", () => $1c7d93b887f84544$export$11a1eabbcab58afc);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lcnyw = parcelRequire("lcnyw");

var $joBf7 = parcelRequire("joBf7");
const $1c7d93b887f84544$export$11a1eabbcab58afc = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1q391dv0"
})({
    fontSize: `${(0, $lcnyw.fontSizeSmall)()}px`
});

});


parcelRegister("asyNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb20a407cb55ef6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hM7RE = parcelRequire("hM7RE");
var $2jDha = parcelRequire("2jDha");

var $5OdZ3 = parcelRequire("5OdZ3");
const $cb20a407cb55ef6b$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $cb20a407cb55ef6b$var$ButtonBase = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), props);
var $cb20a407cb55ef6b$export$2e2bcd8739ae039 = (0, $2jDha.default)({
    onClick: $cb20a407cb55ef6b$var$createAndFireEventOnAtlaskit({
        action: 'clicked',
        actionSubject: 'link'
    })
})($cb20a407cb55ef6b$var$ButtonBase);

});

parcelRegister("gD5gl", function(module, exports) {

$parcel$export(module.exports, "ButtonWrapper", () => $9ca99ddab05981f0$export$d53c836cccbb0d90);
$parcel$export(module.exports, "TableTreeWrapper", () => $9ca99ddab05981f0$export$360f7407dc4b3879);
$parcel$export(module.exports, "HoverWrapper", () => $9ca99ddab05981f0$export$ca23f4c021898078);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $joBf7 = parcelRequire("joBf7");
function $9ca99ddab05981f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9ca99ddab05981f0$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e4t0e7h2"
})({
    name: "1kra095",
    styles: "display:flex;justify-content:center;padding-top:var(--ds-space-100, 8px)"
});
const $9ca99ddab05981f0$export$360f7407dc4b3879 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e4t0e7h1"
})({
    borderTop: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "[role='row']": {
        borderBottom: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$791e57b27ca738ef)})`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.cell': {
        alignItems: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.x-end': {
        justifyContent: 'flex-end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.x-start > *': {
        display: 'flex',
        width: '100%',
        overflow: 'visible'
    }
});
const $9ca99ddab05981f0$export$ca23f4c021898078 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e4t0e7h0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "[role='row']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover, :focus-within': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$791e57b27ca738ef)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.hoverShow': {
                position: 'static',
                opacity: 1,
                zIndex: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.hoverHide': {
                position: 'fixed',
                opacity: 0,
                zIndex: -1
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.hoverShow': {
            position: 'fixed',
            opacity: 0,
            zIndex: -1
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.x-end': {
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-300, 24px)"}`
    }
});

});

parcelRegister("aM4Um", function(module, exports) {

$parcel$export(module.exports, "pageAnalyticsAttributes", () => $166ed1d79a65fe91$export$2e416653733068a8);
const $166ed1d79a65fe91$export$2e416653733068a8 = (page)=>({
        hasEmbeddedEditing: page.hasEmbeddedEdit,
        pageType: page.isDraft ? 'draft' : 'page'
    });

});

parcelRegister("9RnJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9221f338cc6d17d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9RE1U = parcelRequire("9RE1U");

var $gLR87 = parcelRequire("gLR87");

var $j9fWg = parcelRequire("j9fWg");

var $bLFgh = parcelRequire("bLFgh");

var $2eG9N = parcelRequire("2eG9N");

var $gWxA1 = parcelRequire("gWxA1");

var $aw5Sy = parcelRequire("aw5Sy");

var $e2gVN = parcelRequire("e2gVN");

var $aM4Um = parcelRequire("aM4Um");

var $3jwwU = parcelRequire("3jwwU");
const $9221f338cc6d17d8$var$PageControls = ({ page: page, readOnly: readOnly, onEditClick: onEditClick, onShareToggle: onShareToggle, onAddChildClick: onAddChildClick, stickyRowContentId: stickyRowContentId, origin: origin })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleEditClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        onEditClick?.(page);
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'editPageButton', origin.toAnalyticsAttributes({
            hasGeneratedId: true
        }));
    }, [
        onEditClick,
        origin,
        page
    ]);
    const handleAddChildClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        onAddChildClick?.(page.id);
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'createChildPageButton', origin.toAnalyticsAttributes({
            hasGeneratedId: true
        }));
    }, [
        onAddChildClick,
        origin,
        page.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, !readOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage(page.hasEmbeddedEdit ? (0, $e2gVN.default).edit : (0, $e2gVN.default).editInConfluence),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RE1U))),
        onClick: handleEditClick,
        testId: "confluence-project-pages.page-tree.page-controls.edit-button",
        label: "edit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3jwwU.default), {
        page: page,
        onToggle: onShareToggle,
        stickyRowContentId: stickyRowContentId
    }), !page.isDraft && !readOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $e2gVN.default).createChildPage),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gLR87))),
        onClick: handleAddChildClick,
        testId: "confluence-project-pages.page-tree.page-controls.create-child-page-button",
        label: "create child page"
    })));
};
var $9221f338cc6d17d8$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            attributes: (0, $aM4Um.pageAnalyticsAttributes)(props.page)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9221f338cc6d17d8$var$PageControls, props));

});
parcelRegister("9RE1U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0bc716a0db7d939b06b255b25c2b388>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72e81d6607d9bfdb$var$_react = $72e81d6607d9bfdb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $72e81d6607d9bfdb$var$_edit = $72e81d6607d9bfdb$var$_interopRequireDefault((parcelRequire("e5yQJ")));

var $72e81d6607d9bfdb$var$_edit2 = $72e81d6607d9bfdb$var$_interopRequireDefault((parcelRequire("bZ1Zi")));
function $72e81d6607d9bfdb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72e81d6607d9bfdb$var$EditIcon = (props)=>/*#__PURE__*/ $72e81d6607d9bfdb$var$_react.default.createElement($72e81d6607d9bfdb$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $72e81d6607d9bfdb$var$_edit2.default
    }, props));
$72e81d6607d9bfdb$var$EditIcon.Name = 'EditIconMigration';
var $72e81d6607d9bfdb$var$_default = module.exports.default = $72e81d6607d9bfdb$var$EditIcon;

});
parcelRegister("e5yQJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48c51235c7072e6617b637653c3f4fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a41c90bad15a5169$var$_react = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a41c90bad15a5169$var$_UNSAFE_baseNew = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a41c90bad15a5169$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a41c90bad15a5169$var$EditIcon = (props)=>/*#__PURE__*/ $a41c90bad15a5169$var$_react.default.createElement($a41c90bad15a5169$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$a41c90bad15a5169$var$EditIcon.displayName = 'EditIcon';
var $a41c90bad15a5169$var$_default = module.exports.default = $a41c90bad15a5169$var$EditIcon;

});

parcelRegister("bZ1Zi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b96eef1afb7c03f$var$_react = $8b96eef1afb7c03f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $8b96eef1afb7c03f$var$_edit = $8b96eef1afb7c03f$var$_interopRequireDefault((parcelRequire("e5yQJ")));
function $8b96eef1afb7c03f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8b96eef1afb7c03f$var$EditIcon = (props)=>/*#__PURE__*/ $8b96eef1afb7c03f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $8b96eef1afb7c03f$var$_edit.default
    }));
$8b96eef1afb7c03f$var$EditIcon.displayName = 'EditIcon';
var $8b96eef1afb7c03f$var$_default = module.exports.default = $8b96eef1afb7c03f$var$EditIcon;

});


parcelRegister("gLR87", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45e9dbc5862bfe91f01c54aec1c8b1e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c35a3f9a7f658828$var$_react = $c35a3f9a7f658828$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c35a3f9a7f658828$var$_add = $c35a3f9a7f658828$var$_interopRequireDefault((parcelRequire("cS2gQ")));

var $c35a3f9a7f658828$var$_add2 = $c35a3f9a7f658828$var$_interopRequireDefault((parcelRequire("gO9Xw")));
function $c35a3f9a7f658828$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c35a3f9a7f658828$var$AddIcon = (props)=>/*#__PURE__*/ $c35a3f9a7f658828$var$_react.default.createElement($c35a3f9a7f658828$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $c35a3f9a7f658828$var$_add2.default
    }, props));
$c35a3f9a7f658828$var$AddIcon.Name = 'AddIconMigration';
var $c35a3f9a7f658828$var$_default = module.exports.default = $c35a3f9a7f658828$var$AddIcon;

});

parcelRegister("3jwwU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e04c5183759575e3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");

var $fwAIO = parcelRequire("fwAIO");

var $kjwij = parcelRequire("kjwij");

var $5oEc8 = parcelRequire("5oEc8");

var $29yDk = parcelRequire("29yDk");

var $cf2Y4 = parcelRequire("cf2Y4");


var $2eG9N = parcelRequire("2eG9N");

var $byn9U = parcelRequire("byn9U");

var $a1ivA = parcelRequire("a1ivA");
var $2UZ8t = parcelRequire("2UZ8t");
var $gWxA1 = parcelRequire("gWxA1");

var $jkH4Q = parcelRequire("jkH4Q");

var $hEtVP = parcelRequire("hEtVP");

var $8mk6Y = parcelRequire("8mk6Y");
const $e04c5183759575e3$var$ShareButton = ({ page: page, onToggle: onToggle, stickyRowContentId: stickyRowContentId })=>{
    const [isCopied, setIsCopied] = (0, $eUqFw.useState)(false);
    const isOpen = stickyRowContentId === page.id;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // the page-tree gets re-rendered every time a share is clicked so we have to create a new origin here,
    // otherwise the actual generated ID would be behind by 1 render
    const origin = (0, $eUqFw.useMemo)(()=>new (0, $jkH4Q.default)({
            product: 'jira'
        }), []);
    const handleCopy = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        navigator.clipboard.writeText(origin.addToUrl(page.url)).then(()=>{
            setIsCopied(true);
            (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'copyPageLinkButton', origin.toAnalyticsAttributes());
        });
    }, [
        origin,
        page.url
    ]);
    const handleShareClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'sharePageButton', {
            // we negate isOpen since state in parent hasn't been updated yet
            isOpen: !isOpen,
            ...origin.toAnalyticsAttributes({
                hasGeneratedId: !isOpen
            }) // start an origin trace when the share toggle is opened
        });
        onToggle?.(isOpen ? null : page.id);
        if (isOpen) setIsCopied(false);
    }, [
        page,
        isOpen,
        origin,
        onToggle
    ]);
    // need to use different callback as we don't get the same props from inline dialog as we do from button
    const handleShareClose = (0, $eUqFw.useCallback)(()=>{
        onToggle?.(null);
        setIsCopied(false);
    }, [
        onToggle
    ]);
    const textFieldOverrideStyles = /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`
    });
    const dialogContent = /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $a1ivA.ContextWrapper), {
        sourceName: "sharePage",
        sourceType: (0, $e779cc169fd2a347$export$d1123261ca8831d2)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8mk6Y.Title), null, formatMessage((0, $hEtVP.default).title)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8mk6Y.Subtitle), null, formatMessage((0, $hEtVP.default).subtitle)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8mk6Y.Content), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cf2Y4.default), {
        isCompact: true,
        name: "link",
        isReadOnly: true,
        value: origin.addToUrl(page.url),
        appearance: "subtle",
        css: textFieldOverrideStyles
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $6zOB7.default), {
        onClick: handleCopy
    }, formatMessage((0, $hEtVP.default).copyButton))), isCopied && /*#__PURE__*/ (0, $byn9U.jsx)((0, $8mk6Y.InlineMessage), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kjwij))), {
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fwAIO))),
        color: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$a49394138f7b8e85)})`,
        LEGACY_size: "small",
        label: "copied"
    }), formatMessage((0, $hEtVP.default).copied)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2UZ8t.FireScreenAnalytics), {
        attributes: origin.toAnalyticsAttributes()
    })));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: formatMessage((0, $hEtVP.default).tooltip),
        position: "top"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $29yDk.default), {
        content: dialogContent,
        isOpen: isOpen,
        placement: "bottom-end",
        onClose: handleShareClose
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5oEc8))),
        isSelected: isOpen,
        onClick: handleShareClick,
        testId: "confluence-project-pages.page-tree.page-controls.share-button",
        label: "share"
    })));
};
var $e04c5183759575e3$export$2e2bcd8739ae039 = $e04c5183759575e3$var$ShareButton;

});
parcelRegister("fwAIO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4d65456e92ed895$var$_react = $b4d65456e92ed895$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b4d65456e92ed895$var$_checkCircle = $b4d65456e92ed895$var$_interopRequireDefault((parcelRequire("9pzt9")));
function $b4d65456e92ed895$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b4d65456e92ed895$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $b4d65456e92ed895$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $b4d65456e92ed895$var$_checkCircle.default
    }));
$b4d65456e92ed895$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
var $b4d65456e92ed895$var$_default = module.exports.default = $b4d65456e92ed895$var$CheckCircleOutlineIcon;

});
parcelRegister("9pzt9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33c5439f087752870260bcf48e3a4598>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6da1f64ef8beed05$var$_react = $6da1f64ef8beed05$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6da1f64ef8beed05$var$_UNSAFE_baseNew = $6da1f64ef8beed05$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $6da1f64ef8beed05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6da1f64ef8beed05$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $6da1f64ef8beed05$var$_react.default.createElement($6da1f64ef8beed05$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
    }, props));
$6da1f64ef8beed05$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $6da1f64ef8beed05$var$_default = module.exports.default = $6da1f64ef8beed05$var$CheckCircleIcon;

});


parcelRegister("kjwij", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96fa4d3d068726116211916d25154c83>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec9ea1fbab626656$var$_react = $ec9ea1fbab626656$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ec9ea1fbab626656$var$_UNSAFE_baseNew = $ec9ea1fbab626656$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $ec9ea1fbab626656$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-circle
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ec9ea1fbab626656$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $ec9ea1fbab626656$var$_react.default.createElement($ec9ea1fbab626656$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3.284 6 1.81 2.172 3.622-4.344M6 .75a5.25 5.25 0 1 0 0 10.5A5.25 5.25 0 0 0 6 .75Z"/>`,
        type: 'utility'
    }, props));
$ec9ea1fbab626656$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $ec9ea1fbab626656$var$_default = module.exports.default = $ec9ea1fbab626656$var$CheckCircleIcon;

});

parcelRegister("5oEc8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::238da1d3f1c6691c40bb15e631a6cdbf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ede5f7f6efda26a$var$_react = $3ede5f7f6efda26a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3ede5f7f6efda26a$var$_share = $3ede5f7f6efda26a$var$_interopRequireDefault((parcelRequire("ec2xp")));

var $3ede5f7f6efda26a$var$_share2 = $3ede5f7f6efda26a$var$_interopRequireDefault((parcelRequire("dFWNP")));
function $3ede5f7f6efda26a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3ede5f7f6efda26a$var$ShareIcon = (props)=>/*#__PURE__*/ $3ede5f7f6efda26a$var$_react.default.createElement($3ede5f7f6efda26a$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $3ede5f7f6efda26a$var$_share2.default
    }, props));
$3ede5f7f6efda26a$var$ShareIcon.Name = 'ShareIconMigration';
var $3ede5f7f6efda26a$var$_default = module.exports.default = $3ede5f7f6efda26a$var$ShareIcon;

});
parcelRegister("ec2xp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a55427aa389adc57$var$_react = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a55427aa389adc57$var$_UNSAFE_baseNew = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a55427aa389adc57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a55427aa389adc57$var$ShareIcon = (props)=>/*#__PURE__*/ $a55427aa389adc57$var$_react.default.createElement($a55427aa389adc57$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$a55427aa389adc57$var$ShareIcon.displayName = 'ShareIcon';
var $a55427aa389adc57$var$_default = module.exports.default = $a55427aa389adc57$var$ShareIcon;

});

parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9f4cb7ac67043f68$var$_share = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("ec2xp")));
function $9f4cb7ac67043f68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $9f4cb7ac67043f68$var$_share.default
    }));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = module.exports.default = $9f4cb7ac67043f68$var$ShareIcon;

});


parcelRegister("2UZ8t", function(module, exports) {

$parcel$export(module.exports, "FireUIAnalytics", () => $8c82c5c0e8ce27fb$export$1f3555c9be6c5e08);
$parcel$export(module.exports, "FireTrackAnalytics", () => $8c82c5c0e8ce27fb$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $8c82c5c0e8ce27fb$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $8c82c5c0e8ce27fb$export$2ccf161b817b43b);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");


var $gWxA1 = parcelRequire("gWxA1");
const $8c82c5c0e8ce27fb$var$getFixedActionAndActionSubject = (props)=>{
    const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
    if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
    const eventNameSplit = eventName ? eventName.split(' ') : [];
    const fixedAction = action || eventNameSplit[1];
    const fixedActionSubject = actionSubject || eventNameSplit[0];
    if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
    return {
        action: fixedAction,
        actionSubject: fixedActionSubject
    };
};
const $8c82c5c0e8ce27fb$var$getFixedActionSubjectId = (props)=>{
    const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
    if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
    const fixedActionSubjectId = actionSubjectId || componentName;
    return {
        actionSubjectId: fixedActionSubjectId
    };
};
class $8c82c5c0e8ce27fb$var$FireComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes } = this.props;
        if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
        const { action: action, actionSubject: actionSubject } = $8c82c5c0e8ce27fb$var$getFixedActionAndActionSubject(this.props);
        const { actionSubjectId: actionSubjectId } = $8c82c5c0e8ce27fb$var$getFixedActionSubjectId(this.props);
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $gWxA1.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $8c82c5c0e8ce27fb$var$WithAnalytics = (0, $2jDha.default)()($8c82c5c0e8ce27fb$var$FireComponent);
const $8c82c5c0e8ce27fb$export$1f3555c9be6c5e08 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c82c5c0e8ce27fb$var$WithAnalytics, {
        ...props,
        type: (0, $e779cc169fd2a347$export$a1562d08625f5d7e)
    });
const $8c82c5c0e8ce27fb$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c82c5c0e8ce27fb$var$WithAnalytics, {
        ...props,
        type: (0, $e779cc169fd2a347$export$947dac6c72b26f81)
    });
const $8c82c5c0e8ce27fb$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c82c5c0e8ce27fb$var$WithAnalytics, {
        ...props,
        type: (0, $e779cc169fd2a347$export$12346a674644c156)
    });
const $8c82c5c0e8ce27fb$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c82c5c0e8ce27fb$var$WithAnalytics, {
        ...props,
        type: (0, $e779cc169fd2a347$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("hEtVP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d05abf59f8b3d276$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d05abf59f8b3d276$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        id: 'confluence-table-tree.share.title',
        defaultMessage: 'Share page',
        description: 'Title of the inline dialog that allows users to copy a page link'
    },
    subtitle: {
        id: 'confluence-table-tree.share.subtitle',
        defaultMessage: 'Share this link',
        description: 'Subtitle of the inline dialog that allows users to copy a page link'
    },
    copyButton: {
        id: 'confluence-table-tree.share.copy-button',
        defaultMessage: 'Copy',
        description: 'Label of the button that copies a page link'
    },
    copied: {
        id: 'confluence-table-tree.share.copied',
        defaultMessage: 'Copied to clipboard',
        description: 'Small inline message letting users know that a page link has been copied'
    },
    tooltip: {
        id: 'confluence-table-tree.share.tooltip',
        defaultMessage: 'Share',
        description: 'Tooltip when users hover over the button that allows them to share a page link'
    }
});

});

parcelRegister("8mk6Y", function(module, exports) {

$parcel$export(module.exports, "Title", () => $caa9e152ee4d105a$export$f99233281efd08a0);
$parcel$export(module.exports, "Subtitle", () => $caa9e152ee4d105a$export$cf345ef34cd72655);
$parcel$export(module.exports, "Content", () => $caa9e152ee4d105a$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "InlineMessage", () => $caa9e152ee4d105a$export$9eebc872739f8128);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $4lTFP = parcelRequire("4lTFP");


var $lcnyw = parcelRequire("lcnyw");

var $joBf7 = parcelRequire("joBf7");
function $caa9e152ee4d105a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $caa9e152ee4d105a$export$f99233281efd08a0 = /*#__PURE__*/ (0, $joBf7.default)("h3", {
    target: "esfzs1f3"
})((0, $4lTFP.h600));
const $caa9e152ee4d105a$export$cf345ef34cd72655 = /*#__PURE__*/ (0, $joBf7.default)("h4", {
    target: "esfzs1f2"
})((0, $4lTFP.h200));
const $caa9e152ee4d105a$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "esfzs1f1"
})({
    name: "o9998f",
    styles: "display:flex;gap:var(--ds-space-200, 16px);margin-top:var(--ds-space-050, 4px)"
});
const $caa9e152ee4d105a$export$9eebc872739f8128 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "esfzs1f0"
})({
    display: 'flex',
    alignItems: 'center',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`,
    fontSize: `${(0, $lcnyw.fontSizeSmall)()}px`,
    gap: "var(--ds-space-050, 4px)",
    marginTop: "var(--ds-space-100, 8px)"
});

});




parcelRegister("j7dt3", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $5d5eeaabfedc98f3$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "TranslationsProvider", () => $5d5eeaabfedc98f3$export$7df75b8194cf0ae5);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");

var $gNBxY = parcelRequire("gNBxY");
const $5d5eeaabfedc98f3$var$i18n = $gNBxY;
const $5d5eeaabfedc98f3$export$1af4c7e47ad72f44 = 'en_US';
const $5d5eeaabfedc98f3$export$7df75b8194cf0ae5 = ({ locale: locale, children: children })=>{
    const { language: language, country: country } = (0, $eUqFw.useMemo)(()=>{
        const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
        if (!match) throw Error('Unable to get language and country from invalid Locale');
        const [, language, country] = match;
        return {
            language: language.toLowerCase(),
            country: country.toUpperCase()
        };
    }, [
        locale
    ]);
    const translatedMessages = $5d5eeaabfedc98f3$var$i18n[`${language}_${country}`] || $5d5eeaabfedc98f3$var$i18n[language];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: language,
        messages: translatedMessages
    }, children);
};

});
parcelRegister("gNBxY", function(module, exports) {

$parcel$export(module.exports, "zh", () => (parcelRequire("kuyyM")).default);
$parcel$export(module.exports, "zh_TW", () => (parcelRequire("d15Go")).default);
$parcel$export(module.exports, "cs", () => (parcelRequire("lTUSe")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("4aNLZ")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("3uVQS")).default);
$parcel$export(module.exports, "et", () => (parcelRequire("lJ4qd")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("kzIJN")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("aQDw7")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("lKs7Q")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("j4nlf")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("7Txe8")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("40voG")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("9PTiS")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("d1nmm")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("4abIB")).default);
$parcel$export(module.exports, "pt_BR", () => (parcelRequire("13nCm")).default);
$parcel$export(module.exports, "pt_PT", () => (parcelRequire("jfK0U")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("2N05V")).default);
$parcel$export(module.exports, "sk", () => (parcelRequire("gIEmE")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("eXEpp")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("c6Gq3")).default);
$parcel$export(module.exports, "th", () => (parcelRequire("gCKun")).default);
$parcel$export(module.exports, "tr", () => (parcelRequire("7KhSO")).default);
$parcel$export(module.exports, "uk", () => (parcelRequire("4iYEg")).default);
$parcel$export(module.exports, "vi", () => (parcelRequire("2Dlkb")).default);
$parcel$export(module.exports, "en_ZZ", () => (parcelRequire("Yy6gr")).default);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $kuyyM = parcelRequire("kuyyM");

var $d15Go = parcelRequire("d15Go");

var $lTUSe = parcelRequire("lTUSe");

var $4aNLZ = parcelRequire("4aNLZ");

var $3uVQS = parcelRequire("3uVQS");

var $lJ4qd = parcelRequire("lJ4qd");

var $kzIJN = parcelRequire("kzIJN");

var $aQDw7 = parcelRequire("aQDw7");

var $lKs7Q = parcelRequire("lKs7Q");

var $j4nlf = parcelRequire("j4nlf");

var $7Txe8 = parcelRequire("7Txe8");

var $40voG = parcelRequire("40voG");

var $9PTiS = parcelRequire("9PTiS");

var $d1nmm = parcelRequire("d1nmm");

var $4abIB = parcelRequire("4abIB");

var $13nCm = parcelRequire("13nCm");

var $jfK0U = parcelRequire("jfK0U");

var $2N05V = parcelRequire("2N05V");

var $gIEmE = parcelRequire("gIEmE");

var $eXEpp = parcelRequire("eXEpp");

var $c6Gq3 = parcelRequire("c6Gq3");

var $gCKun = parcelRequire("gCKun");

var $7KhSO = parcelRequire("7KhSO");

var $4iYEg = parcelRequire("4iYEg");

var $2Dlkb = parcelRequire("2Dlkb");

var $Yy6gr = parcelRequire("Yy6gr");

});
parcelRegister("kuyyM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f731deefd7c88715$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $f731deefd7c88715$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u53C2\u4E0E\u8005",
    'confluence-table-tree.column.last-modified': "\u4E0A\u6B21\u4FEE\u6539\u65F6\u95F4",
    'confluence-table-tree.column.title': "\u540D\u79F0",
    'confluence-table-tree.could-not-load': "\u65E0\u6CD5\u52A0\u8F7D",
    'confluence-table-tree.could-not-load-contributors': "\u65E0\u6CD5\u52A0\u8F7D\u8D21\u732E\u8005",
    'confluence-table-tree.create-child-page': "\u521B\u5EFA\u5B50\u9875\u9762",
    'confluence-table-tree.create-page': "\u521B\u5EFA\u9875\u9762",
    'confluence-table-tree.default.page.title': "\u672A\u547D\u540D",
    'confluence-table-tree.default.show-all-pages-button.label': "\u663E\u793A\u66F4\u591A\u9875\u9762",
    'confluence-table-tree.draft.lozenge': "\u8349\u7A3F",
    'confluence-table-tree.draft.tooltip': "\u53EA\u6709\u60A8\u53EF\u4EE5\u770B\u5230\u8349\u7A3F\u3002",
    'confluence-table-tree.drafts-toggle.label': "\u663E\u793A\u8349\u7A3F",
    'confluence-table-tree.edit': "\u7F16\u8F91",
    'confluence-table-tree.edit-in-confluence': "\u5728 Confluence \u4E2D\u7F16\u8F91",
    'confluence-table-tree.empty.description': "\u521B\u5EFA\u4E00\u4E9B\u4F1A\u8BAE\u8BB0\u5F55\u3001\u4EA7\u54C1\u9700\u6C42\u3001\u51B3\u5B9A\u6216\u5176\u4ED6\u5185\u5BB9\u6765\u5145\u5B9E\u8BE5\u7A7A\u95F4\u3002",
    'confluence-table-tree.empty.title': "\u65E0\u9650\u6F5C\u529B\uFF0C\u5C3D\u5F85\u6316\u6398",
    'confluence-table-tree.error.description': "\u65E0\u6CD5\u663E\u793A\u8FD9\u4E9B\u9875\u9762\u3002\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002",
    'confluence-table-tree.error.row': "\u65E0\u6CD5\u52A0\u8F7D\u9875\u9762\u3002",
    'confluence-table-tree.error.title': "\u62B1\u6B49...",
    'confluence-table-tree.friendly-when-created': "\u521B\u5EFA\u65E5\u671F",
    'confluence-table-tree.friendly-when-updated': "\u4E0A\u6B21\u66F4\u65B0\u65F6\u95F4",
    'confluence-table-tree.share.copied': "\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
    'confluence-table-tree.share.copy-button': "\u590D\u5236",
    'confluence-table-tree.share.subtitle': "\u5206\u4EAB\u6B64\u94FE\u63A5",
    'confluence-table-tree.share.title': "\u5206\u4EAB\u9875\u9762",
    'confluence-table-tree.share.tooltip': "\u5171\u4EAB",
    'confluence-table-tree.view-profile': "\u67E5\u770B\u4E2A\u4EBA\u8D44\u6599"
};

});

parcelRegister("d15Go", function(module, exports) {

$parcel$export(module.exports, "default", () => $592ed46e83e905c1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $592ed46e83e905c1$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u53C3\u8207\u8005",
    'confluence-table-tree.column.last-modified': "\u4E0A\u6B21\u4FEE\u6539",
    'confluence-table-tree.column.title': "\u540D\u7A31",
    'confluence-table-tree.could-not-load': "\u7121\u6CD5\u8F09\u5165",
    'confluence-table-tree.could-not-load-contributors': "\u7121\u6CD5\u8F09\u5165\u53C3\u8207\u8005",
    'confluence-table-tree.create-child-page': "\u5EFA\u7ACB\u5B50\u7CFB\u9801\u9762",
    'confluence-table-tree.create-page': "\u5EFA\u7ACB\u9801\u9762",
    'confluence-table-tree.default.page.title': "\u672A\u547D\u540D",
    'confluence-table-tree.default.show-all-pages-button.label': "\u986F\u793A\u66F4\u591A\u9801\u9762",
    'confluence-table-tree.draft.lozenge': "\u8349\u7A3F",
    'confluence-table-tree.draft.tooltip': "\u53EA\u6709\u60A8\u770B\u5F97\u5230\u8349\u7A3F\u3002",
    'confluence-table-tree.drafts-toggle.label': "\u986F\u793A\u8349\u7A3F",
    'confluence-table-tree.edit': "\u7DE8\u8F2F",
    'confluence-table-tree.edit-in-confluence': "\u5728 Confluence \u4E2D\u7DE8\u8F2F",
    'confluence-table-tree.empty.description': "\u5EFA\u7ACB\u4E00\u4E9B\u6703\u8B70\u7B46\u8A18\u3001\u7522\u54C1\u8981\u6C42\u3001\u6C7A\u7B56\u6216\u5176\u4ED6\u5167\u5BB9\uFF0C\u4EE5\u67E5\u770B\u6B64\u7A7A\u9593\u662F\u5426\u5DF2\u586B\u6EFF\u3002",
    'confluence-table-tree.empty.title': "\u9019\u88E1\u76EE\u524D\u4EC0\u9EBC\u90FD\u6C92\u6709\uFF0C\u53EA\u6709\u6F5B\u529B\u7121\u9650",
    'confluence-table-tree.error.description': "\u6211\u5011\u7121\u6CD5\u5411\u60A8\u986F\u793A\u9801\u9762\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'confluence-table-tree.error.row': "\u7121\u6CD5\u8F09\u5165\u9801\u9762\u3002",
    'confluence-table-tree.error.title': "\u55EF\uFF0C\u9019\u6709\u9EDE\u5947\u602A...",
    'confluence-table-tree.friendly-when-created': "\u5DF2\u5EFA\u7ACB",
    'confluence-table-tree.friendly-when-updated': "\u5DF2\u66F4\u65B0",
    'confluence-table-tree.share.copied': "\u5DF2\u8907\u88FD\u5230\u526A\u8CBC\u7C3F",
    'confluence-table-tree.share.copy-button': "\u8907\u88FD",
    'confluence-table-tree.share.subtitle': "\u5206\u4EAB\u6B64\u9023\u7D50",
    'confluence-table-tree.share.title': "\u5206\u4EAB\u9801\u9762",
    'confluence-table-tree.share.tooltip': "\u5206\u4EAB",
    'confluence-table-tree.view-profile': "\u6AA2\u8996\u8A2D\u5B9A\u6A94"
};

});

parcelRegister("lTUSe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eb3d4d942ddf0da$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $7eb3d4d942ddf0da$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "P\u0159isp\u011Bvatel\xe9",
    'confluence-table-tree.column.last-modified': "Naposledy zm\u011Bn\u011Bno",
    'confluence-table-tree.column.title': "N\xe1zev",
    'confluence-table-tree.could-not-load': "Nelze na\u010D\xedst",
    'confluence-table-tree.could-not-load-contributors': "Na\u010Dten\xed p\u0159isp\u011Bvatel\u016F se nezda\u0159ilo.",
    'confluence-table-tree.create-child-page': "Vytvo\u0159it pod\u0159azenou str\xe1nku",
    'confluence-table-tree.create-page': "Vytvo\u0159it str\xe1nku",
    'confluence-table-tree.default.page.title': "Bez n\xe1zvu",
    'confluence-table-tree.default.show-all-pages-button.label': "Zobrazit v\xedce str\xe1nek",
    'confluence-table-tree.draft.lozenge': 'KONCEPT',
    'confluence-table-tree.draft.tooltip': "Koncepty uvid\xedte pouze vy.",
    'confluence-table-tree.drafts-toggle.label': 'Zobrazit koncepty',
    'confluence-table-tree.edit': 'Upravit',
    'confluence-table-tree.edit-in-confluence': "Upravit v\xa0Confluence",
    'confluence-table-tree.empty.description': "Tento prostor se zapln\xed, a\u017E za\u010Dnete vytv\xe1\u0159et z\xe1pisy ze sch\u016Fzek, produktov\xe9 po\u017Eadavky, rozhodnut\xed a\xa0dal\u0161\xed obsah.",
    'confluence-table-tree.empty.title': "Nic zde nen\xed, ale m\u016F\u017Ee b\xfdt",
    'confluence-table-tree.error.description': "Tyto str\xe1nky v\xe1m nem\u016F\u017Eeme zobrazit. Zkuste to znovu pozd\u011Bji.",
    'confluence-table-tree.error.row': "Na\u010Dten\xed str\xe1nek se nezda\u0159ilo.",
    'confluence-table-tree.error.title': "Hmm, toto je zvl\xe1\u0161tn\xed\u2026",
    'confluence-table-tree.friendly-when-created': "Vytvo\u0159eno",
    'confluence-table-tree.friendly-when-updated': "Aktualizov\xe1no",
    'confluence-table-tree.share.copied': "Zkop\xedrov\xe1no do schr\xe1nky",
    'confluence-table-tree.share.copy-button': "Kop\xedrovat",
    'confluence-table-tree.share.subtitle': "Sd\xedlejte tento odkaz",
    'confluence-table-tree.share.title': "Sd\xedlet str\xe1nku",
    'confluence-table-tree.share.tooltip': "Sd\xedlet",
    'confluence-table-tree.view-profile': 'Zobrazit profil'
};

});

parcelRegister("4aNLZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ef313c507894e39$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $6ef313c507894e39$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Bidragydere',
    'confluence-table-tree.column.last-modified': "Sidst \xe6ndret",
    'confluence-table-tree.column.title': 'Navn',
    'confluence-table-tree.could-not-load': "Kunne ikke indl\xe6ses",
    'confluence-table-tree.could-not-load-contributors': "Bidragsydere kunne ikke indl\xe6ses",
    'confluence-table-tree.create-child-page': 'Opret en underordnet side',
    'confluence-table-tree.create-page': 'Opret side',
    'confluence-table-tree.default.page.title': 'Uden titel',
    'confluence-table-tree.default.show-all-pages-button.label': 'Vis flere sider',
    'confluence-table-tree.draft.lozenge': 'UDKAST',
    'confluence-table-tree.draft.tooltip': 'Udkast kan kun ses af dig.',
    'confluence-table-tree.drafts-toggle.label': 'Vis udkast',
    'confluence-table-tree.edit': 'Rediger',
    'confluence-table-tree.edit-in-confluence': 'Rediger i Confluence',
    'confluence-table-tree.empty.description': "Opret m\xf8denoter, produktkrav, beslutninger eller andet indhold for at se omr\xe5det blive fyldt ud.",
    'confluence-table-tree.empty.title': 'Der er ikke andet end potentiale her',
    'confluence-table-tree.error.description': "Vi kan ikke vise dig disse sider. Pr\xf8v igen senere.",
    'confluence-table-tree.error.row': "Sider kan ikke indl\xe6ses.",
    'confluence-table-tree.error.title': 'Ups, det var pinligt ...',
    'confluence-table-tree.friendly-when-created': 'Oprettet',
    'confluence-table-tree.friendly-when-updated': 'Opdateret',
    'confluence-table-tree.share.copied': 'Kopieret til udklipsholderen',
    'confluence-table-tree.share.copy-button': "Kopi\xe9r",
    'confluence-table-tree.share.subtitle': 'Del dette link',
    'confluence-table-tree.share.title': 'Del side',
    'confluence-table-tree.share.tooltip': 'Del',
    'confluence-table-tree.view-profile': 'Se profil'
};

});

parcelRegister("3uVQS", function(module, exports) {

$parcel$export(module.exports, "default", () => $31680b80a647abea$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $31680b80a647abea$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Bijdragers',
    'confluence-table-tree.column.last-modified': 'Laatst aangepast',
    'confluence-table-tree.column.title': 'Naam',
    'confluence-table-tree.could-not-load': 'Kon niet worden geladen',
    'confluence-table-tree.could-not-load-contributors': 'Bijdragers konden niet worden geladen',
    'confluence-table-tree.create-child-page': 'Maak een onderliggende pagina aan',
    'confluence-table-tree.create-page': 'Pagina aanmaken',
    'confluence-table-tree.default.page.title': 'Ongetiteld',
    'confluence-table-tree.default.show-all-pages-button.label': "Meer pagina's tonen",
    'confluence-table-tree.draft.lozenge': 'CONCEPT',
    'confluence-table-tree.draft.tooltip': 'Concepten zijn alleen zichtbaar voor jou.',
    'confluence-table-tree.drafts-toggle.label': 'Concepten weergeven',
    'confluence-table-tree.edit': 'Bewerken',
    'confluence-table-tree.edit-in-confluence': 'Bewerken in Confluence',
    'confluence-table-tree.empty.description': 'Maak vergadernotulen, stel productvereisten op, neem beslissingen of maak andere content aan, om deze space op te vullen.',
    'confluence-table-tree.empty.title': 'Hier zijn alleen maar mogelijkheden',
    'confluence-table-tree.error.description': "We kunnen je deze pagina's niet laten zien. Probeer het later opnieuw.",
    'confluence-table-tree.error.row': "Kan pagina's niet laden.",
    'confluence-table-tree.error.title': 'Hmm, dit is niet zo handig...',
    'confluence-table-tree.friendly-when-created': 'Aangemaakt',
    'confluence-table-tree.friendly-when-updated': 'Bijgewerkt',
    'confluence-table-tree.share.copied': 'Gekopieerd naar klembord',
    'confluence-table-tree.share.copy-button': "Kopi\xebren",
    'confluence-table-tree.share.subtitle': 'Deel deze link',
    'confluence-table-tree.share.title': 'Pagina delen',
    'confluence-table-tree.share.tooltip': 'Delen',
    'confluence-table-tree.view-profile': 'Profiel bekijken'
};

});

parcelRegister("lJ4qd", function(module, exports) {

$parcel$export(module.exports, "default", () => $998d0b096f205c1d$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Estonian
var $998d0b096f205c1d$export$2e2bcd8739ae039 = {};

});

parcelRegister("kzIJN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecf8ff1e58ea80e8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $ecf8ff1e58ea80e8$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Osallistujat',
    'confluence-table-tree.column.last-modified': 'Viimeksi muokattu',
    'confluence-table-tree.column.title': 'Nimi',
    'confluence-table-tree.could-not-load': 'Ei voitu ladata',
    'confluence-table-tree.could-not-load-contributors': 'Osallistujia ei voitu ladata',
    'confluence-table-tree.create-child-page': 'Luo alasivu',
    'confluence-table-tree.create-page': 'Luo sivu',
    'confluence-table-tree.default.page.title': "Nime\xe4m\xe4t\xf6n",
    'confluence-table-tree.default.show-all-pages-button.label': "N\xe4yt\xe4 enemm\xe4n sivuja",
    'confluence-table-tree.draft.lozenge': 'LUONNOS',
    'confluence-table-tree.draft.tooltip': "Luonnokset n\xe4kyv\xe4t vain sinulle.",
    'confluence-table-tree.drafts-toggle.label': "N\xe4yt\xe4 luonnokset",
    'confluence-table-tree.edit': 'Muokkaa',
    'confluence-table-tree.edit-in-confluence': 'Muokkaa Confluencessa',
    'confluence-table-tree.empty.description': "T\xe4yt\xe4 t\xe4m\xe4 ty\xf6tila luomalla kokousmuistioita, tuotevaatimuksia, p\xe4\xe4t\xf6ksi\xe4 tai muuta sis\xe4lt\xf6\xe4.",
    'confluence-table-tree.empty.title': "T\xe4\xe4ll\xe4 on pelkk\xe4\xe4 potentiaalia",
    'confluence-table-tree.error.description': "N\xe4it\xe4 sivuja ei voi n\xe4ytt\xe4\xe4. Yrit\xe4 my\xf6hemmin uudelleen.",
    'confluence-table-tree.error.row': 'Sivujen lataus ei onnistu.',
    'confluence-table-tree.error.title': "Nyt k\xe4vi nolosti.",
    'confluence-table-tree.friendly-when-created': 'Luotu',
    'confluence-table-tree.friendly-when-updated': "P\xe4ivitetty",
    'confluence-table-tree.share.copied': "Kopioitu leikep\xf6yd\xe4lle",
    'confluence-table-tree.share.copy-button': 'Kopioi',
    'confluence-table-tree.share.subtitle': "Jaa t\xe4m\xe4 linkki",
    'confluence-table-tree.share.title': 'Jaa sivu',
    'confluence-table-tree.share.tooltip': 'Jaa',
    'confluence-table-tree.view-profile': "N\xe4yt\xe4 profiili"
};

});

parcelRegister("aQDw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $59511f3b489cf5c8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $59511f3b489cf5c8$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Contributeurs',
    'confluence-table-tree.column.last-modified': "Derni\xe8re modification",
    'confluence-table-tree.column.title': 'Nom',
    'confluence-table-tree.could-not-load': 'Chargement impossible',
    'confluence-table-tree.could-not-load-contributors': 'Impossible de charger les contributeurs',
    'confluence-table-tree.create-child-page': "Cr\xe9er une page enfant",
    'confluence-table-tree.create-page': "Cr\xe9er une page",
    'confluence-table-tree.default.page.title': 'Sans titre',
    'confluence-table-tree.default.show-all-pages-button.label': 'Afficher plus de pages',
    'confluence-table-tree.draft.lozenge': 'BROUILLON',
    'confluence-table-tree.draft.tooltip': "Les brouillons ne peuvent \xeatre vus que par vous.",
    'confluence-table-tree.drafts-toggle.label': 'Afficher les brouillons',
    'confluence-table-tree.edit': 'Modifier',
    'confluence-table-tree.edit-in-confluence': 'Modifier dans Confluence',
    'confluence-table-tree.empty.description': "Cr\xe9ez des notes de r\xe9union, des exigences produit, des d\xe9cisions, ou tout autre contenu pour voir cet espace se remplir.",
    'confluence-table-tree.empty.title': "Il n'y a rien ici hormis du potentiel",
    'confluence-table-tree.error.description': "Impossible d'afficher ces pages. Veuillez r\xe9essayer ult\xe9rieurement.",
    'confluence-table-tree.error.row': 'Impossible de charger les pages.',
    'confluence-table-tree.error.title': "Ah, c'est bizarre\u2026",
    'confluence-table-tree.friendly-when-created': "Cr\xe9ation",
    'confluence-table-tree.friendly-when-updated': "Mise \xe0 jour",
    'confluence-table-tree.share.copied': "Copi\xe9 dans le presse-papiers",
    'confluence-table-tree.share.copy-button': 'Copier',
    'confluence-table-tree.share.subtitle': 'Partager ce lien',
    'confluence-table-tree.share.title': 'Partager la page',
    'confluence-table-tree.share.tooltip': 'Partager',
    'confluence-table-tree.view-profile': 'Afficher le profil'
};

});

parcelRegister("lKs7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $82ddd21819a700cd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $82ddd21819a700cd$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Beitragende',
    'confluence-table-tree.column.last-modified': "Letzte \xc4nderung",
    'confluence-table-tree.column.title': 'Name',
    'confluence-table-tree.could-not-load': 'Konnte nicht geladen werden',
    'confluence-table-tree.could-not-load-contributors': 'Beitragende konnten nicht geladen werden',
    'confluence-table-tree.create-child-page': 'Untergeordnete Seite erstellen',
    'confluence-table-tree.create-page': 'Seite erstellen',
    'confluence-table-tree.default.page.title': 'Ohne Namen',
    'confluence-table-tree.default.show-all-pages-button.label': 'Weitere Seiten anzeigen',
    'confluence-table-tree.draft.lozenge': 'ENTWURF',
    'confluence-table-tree.draft.tooltip': "Entw\xfcrfe k\xf6nnen nur von Ihnen gesehen werden.",
    'confluence-table-tree.drafts-toggle.label': "Entw\xfcrfe anzeigen",
    'confluence-table-tree.edit': 'Bearbeiten',
    'confluence-table-tree.edit-in-confluence': 'In Confluence bearbeiten',
    'confluence-table-tree.empty.description': "Erstellen Sie Besprechungsnotizen, Produktanforderungen, Entscheidungen und andere Inhalte, damit dieser Bereich sich f\xfcllt.",
    'confluence-table-tree.empty.title': "Es gibt hier nichts, au\xdfer Potenzial",
    'confluence-table-tree.error.description': "Wir k\xf6nnen diese Seiten nicht anzeigen. Bitte versuchen Sie es sp\xe4ter erneut.",
    'confluence-table-tree.error.row': 'Seiten konnten nicht geladen werden.',
    'confluence-table-tree.error.title': "Das ist seltsam\xa0\u2026",
    'confluence-table-tree.friendly-when-created': 'Erstellt',
    'confluence-table-tree.friendly-when-updated': 'Aktualisiert',
    'confluence-table-tree.share.copied': 'In Zwischenablage kopiert',
    'confluence-table-tree.share.copy-button': 'Kopieren',
    'confluence-table-tree.share.subtitle': 'Link teilen',
    'confluence-table-tree.share.title': 'Seite teilen',
    'confluence-table-tree.share.tooltip': 'Teilen',
    'confluence-table-tree.view-profile': 'Profil anzeigen'
};

});

parcelRegister("j4nlf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e89eb0e0b9dd1893$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $e89eb0e0b9dd1893$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "K\xf6zrem\u0171k\xf6d\u0151k",
    'confluence-table-tree.column.last-modified': "Utols\xf3 m\xf3dos\xedt\xe1s",
    'confluence-table-tree.column.title': "N\xe9v",
    'confluence-table-tree.could-not-load': "Nem siker\xfclt bet\xf6lteni",
    'confluence-table-tree.could-not-load-contributors': "Nem siker\xfclt bet\xf6lteni a k\xf6zrem\u0171k\xf6d\u0151ket",
    'confluence-table-tree.create-child-page': "Al\xe1rendelt oldal l\xe9trehoz\xe1sa",
    'confluence-table-tree.create-page': "Oldal l\xe9trehoz\xe1sa",
    'confluence-table-tree.default.page.title': "N\xe9vtelen",
    'confluence-table-tree.default.show-all-pages-button.label': "T\xf6bb oldal megjelen\xedt\xe9se",
    'confluence-table-tree.draft.lozenge': 'PISZKOZAT',
    'confluence-table-tree.draft.tooltip': "Csak te l\xe1thatod a piszkozatokat",
    'confluence-table-tree.drafts-toggle.label': "Piszkozatok megjelen\xedt\xe9se",
    'confluence-table-tree.edit': "Szerkeszt\xe9s",
    'confluence-table-tree.edit-in-confluence': "Szerkeszt\xe9s Confluence-ben",
    'confluence-table-tree.empty.description': "Hozz l\xe9tre megbesz\xe9l\xe9sfeljegyz\xe9seket, term\xe9kk\xf6vetelm\xe9nyeket, d\xf6nt\xe9seket vagy m\xe1s tartalmakat, amelyekkel megt\xf6ltheted ezt a munkateret.",
    'confluence-table-tree.empty.title': "Ez a hely tele van lehet\u0151s\xe9ggel",
    'confluence-table-tree.error.description': "Ezek az oldalak nem jelen\xedthet\u0151k meg. Pr\xf3b\xe1ld meg \xfajra k\xe9s\u0151bb.",
    'confluence-table-tree.error.row': "Nem lehet bet\xf6lteni az oldalakat.",
    'confluence-table-tree.error.title': "Eln\xe9z\xe9st k\xe9r\xfcnk!",
    'confluence-table-tree.friendly-when-created': "L\xe9trehozva",
    'confluence-table-tree.friendly-when-updated': "Friss\xedtve",
    'confluence-table-tree.share.copied': "V\xe1g\xf3lapra m\xe1solva",
    'confluence-table-tree.share.copy-button': "M\xe1sol\xe1s",
    'confluence-table-tree.share.subtitle': "Link megoszt\xe1sa",
    'confluence-table-tree.share.title': "Oldal megoszt\xe1sa",
    'confluence-table-tree.share.tooltip': "Megoszt\xe1s",
    'confluence-table-tree.view-profile': "Profil megtekint\xe9se"
};

});

parcelRegister("7Txe8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ebc4b390c645acb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $3ebc4b390c645acb$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Collaboratori',
    'confluence-table-tree.column.last-modified': 'Ultima modifica',
    'confluence-table-tree.column.title': 'Nome',
    'confluence-table-tree.could-not-load': 'Impossibile caricare',
    'confluence-table-tree.could-not-load-contributors': 'Impossibile caricare i collaboratori',
    'confluence-table-tree.create-child-page': 'Crea una pagina subordinata',
    'confluence-table-tree.create-page': 'Crea pagina',
    'confluence-table-tree.default.page.title': 'Senza titolo',
    'confluence-table-tree.default.show-all-pages-button.label': 'Mostra altre pagine',
    'confluence-table-tree.draft.lozenge': 'BOZZA',
    'confluence-table-tree.draft.tooltip': 'Solo tu puoi vedere le bozze.',
    'confluence-table-tree.drafts-toggle.label': 'Mostra bozze',
    'confluence-table-tree.edit': 'Modifica',
    'confluence-table-tree.edit-in-confluence': 'Modifica in Confluence',
    'confluence-table-tree.empty.description': 'Crea note della riunione, requisiti di prodotto, decisioni e altri contenuti per riempire questo spazio.',
    'confluence-table-tree.empty.title': "Non c\u2019\xe8 niente qui, solo possibilit\xe0",
    'confluence-table-tree.error.description': "Al momento non possiamo mostrarti queste pagine. Riprova pi\xf9 tardi.",
    'confluence-table-tree.error.row': 'Impossibile caricare le pagine.',
    'confluence-table-tree.error.title': "\xc8 imbarazzante...",
    'confluence-table-tree.friendly-when-created': 'Creati',
    'confluence-table-tree.friendly-when-updated': 'Aggiornato',
    'confluence-table-tree.share.copied': 'Copiato negli appunti',
    'confluence-table-tree.share.copy-button': 'Copia',
    'confluence-table-tree.share.subtitle': 'Condividi questo link',
    'confluence-table-tree.share.title': 'Condividi pagina',
    'confluence-table-tree.share.tooltip': 'Condividi',
    'confluence-table-tree.view-profile': 'Visualizza profilo'
};

});

parcelRegister("40voG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5950b31bfc322d02$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $5950b31bfc322d02$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u6295\u7A3F\u8005",
    'confluence-table-tree.column.last-modified': "\u6700\u7D42\u66F4\u65B0\u65E5",
    'confluence-table-tree.column.title': "\u540D\u524D",
    'confluence-table-tree.could-not-load': "\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    'confluence-table-tree.could-not-load-contributors': "\u6295\u7A3F\u8005\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    'confluence-table-tree.create-child-page': "\u5B50\u30DA\u30FC\u30B8\u3092\u4F5C\u6210",
    'confluence-table-tree.create-page': "\u30DA\u30FC\u30B8\u3092\u4F5C\u6210",
    'confluence-table-tree.default.page.title': "\u7121\u984C",
    'confluence-table-tree.default.show-all-pages-button.label': "\u3055\u3089\u306B\u30DA\u30FC\u30B8\u3092\u8868\u793A",
    'confluence-table-tree.draft.lozenge': "\u30C9\u30E9\u30D5\u30C8",
    'confluence-table-tree.draft.tooltip': "\u30C9\u30E9\u30D5\u30C8\u306F\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u306F\u8868\u793A\u3055\u308C\u307E\u305B\u3093\u3002",
    'confluence-table-tree.drafts-toggle.label': "\u4E0B\u66F8\u304D\u3092\u8868\u793A",
    'confluence-table-tree.edit': "\u7DE8\u96C6",
    'confluence-table-tree.edit-in-confluence': "Confluence \u3067\u7DE8\u96C6",
    'confluence-table-tree.empty.description': "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u8B70\u4E8B\u9332\u3001\u88FD\u54C1\u8981\u4EF6\u3001\u6C7A\u5B9A\u4E8B\u9805\u3084\u305D\u306E\u4ED6\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u3066\u3001\u3053\u306E\u30B9\u30DA\u30FC\u30B9\u3092\u57CB\u3081\u307E\u3057\u3087\u3046\u3002",
    'confluence-table-tree.empty.title': "\u73FE\u5728\u306F\u4F55\u3082\u542B\u307E\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    'confluence-table-tree.error.description': "\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3067\u304D\u307E\u305B\u3093\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    'confluence-table-tree.error.row': "\u30DA\u30FC\u30B8\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3002",
    'confluence-table-tree.error.title': "\u6B63\u5E38\u306B\u6A5F\u80FD\u3057\u3066\u3044\u307E\u305B\u3093\u3002",
    'confluence-table-tree.friendly-when-created': "\u4F5C\u6210\u65E5",
    'confluence-table-tree.friendly-when-updated': "\u6700\u7D42\u66F4\u65B0",
    'confluence-table-tree.share.copied': "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F",
    'confluence-table-tree.share.copy-button': "\u30B3\u30D4\u30FC",
    'confluence-table-tree.share.subtitle': "\u3053\u306E\u30EA\u30F3\u30AF\u3092\u5171\u6709",
    'confluence-table-tree.share.title': "\u30DA\u30FC\u30B8\u306E\u5171\u6709",
    'confluence-table-tree.share.tooltip': "\u5171\u6709",
    'confluence-table-tree.view-profile': "\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u3092\u8868\u793A"
};

});

parcelRegister("9PTiS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5310e6a810fbcef0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $5310e6a810fbcef0$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\uAE30\uC5EC\uC790",
    'confluence-table-tree.column.last-modified': "\uCD5C\uADFC \uC218\uC815",
    'confluence-table-tree.column.title': "\uC774\uB984",
    'confluence-table-tree.could-not-load': "\uB85C\uB4DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'confluence-table-tree.could-not-load-contributors': "\uAE30\uC5EC\uC790\uB97C \uB85C\uB4DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'confluence-table-tree.create-child-page': "\uD558\uC704 \uD398\uC774\uC9C0 \uB9CC\uB4E4\uAE30",
    'confluence-table-tree.create-page': "\uD398\uC774\uC9C0 \uB9CC\uB4E4\uAE30",
    'confluence-table-tree.default.page.title': "\uC81C\uBAA9 \uC5C6\uC74C",
    'confluence-table-tree.default.show-all-pages-button.label': "\uD398\uC774\uC9C0 \uB354 \uBCF4\uAE30",
    'confluence-table-tree.draft.lozenge': "\uCD08\uC548",
    'confluence-table-tree.draft.tooltip': "\uCD08\uC548\uC740 \uC790\uC2E0\uB9CC \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    'confluence-table-tree.drafts-toggle.label': "\uCD08\uC548 \uBCF4\uAE30",
    'confluence-table-tree.edit': "\uD3B8\uC9D1",
    'confluence-table-tree.edit-in-confluence': "Confluence\uC5D0\uC11C \uD3B8\uC9D1",
    'confluence-table-tree.empty.description': "\uBBF8\uD305 \uBA54\uBAA8, \uC81C\uD488 \uC694\uAD6C \uC0AC\uD56D, \uACB0\uC815 \uC0AC\uD56D \uB610\uB294 \uAE30\uD0C0 \uCF58\uD150\uCE20\uB97C \uB9CC\uB4E4\uC5B4 \uC774 \uC2A4\uD398\uC774\uC2A4\uB97C \uCC44\uC6CC\uBCF4\uC138\uC694.",
    'confluence-table-tree.empty.title': "\uC774\uACF3\uC740 \uBE44\uC5B4 \uC788\uC9C0\uB9CC \uC7A0\uC7AC\uB825\uC73C\uB85C ",
    'confluence-table-tree.error.description': "\uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
    'confluence-table-tree.error.row': "\uD398\uC774\uC9C0\uB97C \uB85C\uB4DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'confluence-table-tree.error.title': "\uC8C4\uC1A1\uD569\uB2C8\uB2E4.",
    'confluence-table-tree.friendly-when-created': "\uB9CC\uB4E6",
    'confluence-table-tree.friendly-when-updated': "\uC5C5\uB370\uC774\uD2B8",
    'confluence-table-tree.share.copied': "\uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uB428",
    'confluence-table-tree.share.copy-button': "\uBCF5\uC0AC",
    'confluence-table-tree.share.subtitle': "\uC774 \uB9C1\uD06C \uACF5\uC720",
    'confluence-table-tree.share.title': "\uD398\uC774\uC9C0 \uACF5\uC720",
    'confluence-table-tree.share.tooltip': "\uACF5\uC720",
    'confluence-table-tree.view-profile': "\uD504\uB85C\uD544 \uBCF4\uAE30"
};

});

parcelRegister("d1nmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $759923dba2713bac$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $759923dba2713bac$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Bidragsytere',
    'confluence-table-tree.column.last-modified': 'Sist endret',
    'confluence-table-tree.column.title': 'Navn',
    'confluence-table-tree.could-not-load': 'Kan ikke laste inn',
    'confluence-table-tree.could-not-load-contributors': 'Kan ikke laste inn bidragsytere',
    'confluence-table-tree.create-child-page': 'Opprett en underordnet side',
    'confluence-table-tree.create-page': 'Opprett side',
    'confluence-table-tree.default.page.title': 'Uten navn',
    'confluence-table-tree.default.show-all-pages-button.label': 'Vis flere sider',
    'confluence-table-tree.draft.lozenge': 'UTKAST',
    'confluence-table-tree.draft.tooltip': 'Utkast kan kun ses av deg.',
    'confluence-table-tree.drafts-toggle.label': 'Vis utkast',
    'confluence-table-tree.edit': 'Rediger',
    'confluence-table-tree.edit-in-confluence': 'Rediger i Confluence',
    'confluence-table-tree.empty.description': "Opprett m\xf8tenotater, produktkrav, beslutninger eller annet innhold for \xe5 fylle opp dette omr\xe5det.",
    'confluence-table-tree.empty.title': 'Her finnes det ingenting annet enn potensial',
    'confluence-table-tree.error.description': "Vi kan ikke vise deg disse sidene. Pr\xf8v igjen senere.",
    'confluence-table-tree.error.row': 'Kan ikke laste inn sider.',
    'confluence-table-tree.error.title': "Vel, dette er pinlig\xa0\u2026",
    'confluence-table-tree.friendly-when-created': 'Opprettet',
    'confluence-table-tree.friendly-when-updated': 'Oppdatert',
    'confluence-table-tree.share.copied': 'Kopiert til utklippstavlen',
    'confluence-table-tree.share.copy-button': 'Kopier',
    'confluence-table-tree.share.subtitle': 'Del denne koblingen',
    'confluence-table-tree.share.title': 'Del side',
    'confluence-table-tree.share.tooltip': 'Del',
    'confluence-table-tree.view-profile': 'Se profil'
};

});

parcelRegister("4abIB", function(module, exports) {

$parcel$export(module.exports, "default", () => $68d0bff2cfb2b928$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $68d0bff2cfb2b928$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "Wsp\xf3\u0142autorzy",
    'confluence-table-tree.column.last-modified': 'Ostatnia modyfikacja',
    'confluence-table-tree.column.title': 'Nazwa',
    'confluence-table-tree.could-not-load': "Nie mo\u017Cna za\u0142adowa\u0107",
    'confluence-table-tree.could-not-load-contributors': "Nie mo\u017Cna za\u0142adowa\u0107 wsp\xf3\u0142autor\xf3w",
    'confluence-table-tree.create-child-page': "Utw\xf3rz stron\u0119 podrz\u0119dn\u0105",
    'confluence-table-tree.create-page': "Utw\xf3rz stron\u0119",
    'confluence-table-tree.default.page.title': "Bez tytu\u0142u",
    'confluence-table-tree.default.show-all-pages-button.label': "Poka\u017C wi\u0119cej stron",
    'confluence-table-tree.draft.lozenge': 'SZKIC',
    'confluence-table-tree.draft.tooltip': 'Tylko Ty widzisz wersje robocze',
    'confluence-table-tree.drafts-toggle.label': "Poka\u017C wersje robocze",
    'confluence-table-tree.edit': 'Edytuj',
    'confluence-table-tree.edit-in-confluence': 'Edytuj w Confluence',
    'confluence-table-tree.empty.description': "Utw\xf3rz notatki ze spotka\u0144, wymagania produktowe, decyzje lub inne tre\u015Bci, aby wype\u0142ni\u0107 t\u0119 przestrze\u0144.",
    'confluence-table-tree.empty.title': "Nie ma tu nic opr\xf3cz potencja\u0142u",
    'confluence-table-tree.error.description': "Nie mo\u017Cemy wy\u015Bwietli\u0107 tych stron. Spr\xf3buj ponownie p\xf3\u017Aniej.",
    'confluence-table-tree.error.row': "Nie mo\u017Cna za\u0142adowa\u0107 stron.",
    'confluence-table-tree.error.title': "To dziwne\u2026",
    'confluence-table-tree.friendly-when-created': 'Utworzono',
    'confluence-table-tree.friendly-when-updated': 'Zaktualizowano',
    'confluence-table-tree.share.copied': 'Skopiowano do schowka',
    'confluence-table-tree.share.copy-button': 'Kopiuj',
    'confluence-table-tree.share.subtitle': "Udost\u0119pnij to \u0142\u0105cze",
    'confluence-table-tree.share.title': "Udost\u0119pnij stron\u0119",
    'confluence-table-tree.share.tooltip': "Udost\u0119pnij",
    'confluence-table-tree.view-profile': "Wy\u015Bwietl profil"
};

});

parcelRegister("13nCm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5a037327ce9b2bb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $e5a037327ce9b2bb$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Contribuidores',
    'confluence-table-tree.column.last-modified': "\xdaltima modifica\xe7\xe3o",
    'confluence-table-tree.column.title': 'Nome',
    'confluence-table-tree.could-not-load': "N\xe3o foi poss\xedvel carregar",
    'confluence-table-tree.could-not-load-contributors': "N\xe3o foi poss\xedvel carregar os colaboradores",
    'confluence-table-tree.create-child-page': "Criar uma p\xe1gina filho",
    'confluence-table-tree.create-page': "Criar p\xe1gina",
    'confluence-table-tree.default.page.title': "Sem t\xedtulo",
    'confluence-table-tree.default.show-all-pages-button.label': "Mostrar mais p\xe1ginas",
    'confluence-table-tree.draft.lozenge': 'RASCUNHO',
    'confluence-table-tree.draft.tooltip': "S\xf3 voc\xea pode ver os rascunhos.",
    'confluence-table-tree.drafts-toggle.label': 'Mostrar rascunhos',
    'confluence-table-tree.edit': 'Editar',
    'confluence-table-tree.edit-in-confluence': 'Editar no Confluence',
    'confluence-table-tree.empty.description': "Crie algumas anota\xe7\xf5es de reuni\xe3o, requisitos de produtos, decis\xf5es ou outros assuntos para ver este espa\xe7o ser preenchido.",
    'confluence-table-tree.empty.title': "N\xe3o h\xe1 nada aqui al\xe9m de potencial",
    'confluence-table-tree.error.description': "N\xe3o podemos mostrar estas p\xe1ginas para voc\xea. Tente de novo mais tarde.",
    'confluence-table-tree.error.row': "N\xe3o \xe9 poss\xedvel carregar p\xe1ginas.",
    'confluence-table-tree.error.title': "Poxa, isso est\xe1 estranho...",
    'confluence-table-tree.friendly-when-created': 'Criado',
    'confluence-table-tree.friendly-when-updated': 'Atualizado',
    'confluence-table-tree.share.copied': "Copiado para a \xe1rea de transfer\xeancia",
    'confluence-table-tree.share.copy-button': 'Copiar',
    'confluence-table-tree.share.subtitle': 'Compartilhar este link',
    'confluence-table-tree.share.title': "Compartilhar p\xe1gina",
    'confluence-table-tree.share.tooltip': 'Compartilhar',
    'confluence-table-tree.view-profile': 'Visualizar perfil'
};

});

parcelRegister("jfK0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b93d6abf4916478$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Portugal)
var $1b93d6abf4916478$export$2e2bcd8739ae039 = {};

});

parcelRegister("2N05V", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8e173eca535a64c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $a8e173eca535a64c$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
    'confluence-table-tree.column.last-modified': "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435",
    'confluence-table-tree.column.title': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
    'confluence-table-tree.could-not-load': "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435",
    'confluence-table-tree.could-not-load-contributors': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432",
    'confluence-table-tree.create-child-page': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0434\u043E\u0447\u0435\u0440\u043D\u044E\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'confluence-table-tree.create-page': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'confluence-table-tree.default.page.title': "\u0411\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F",
    'confluence-table-tree.default.show-all-pages-button.label': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446",
    'confluence-table-tree.draft.lozenge': "\u0427\u0415\u0420\u041D\u041E\u0412\u0418\u041A",
    'confluence-table-tree.draft.tooltip': "\u0427\u0435\u0440\u043D\u043E\u0432\u0438\u043A\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u044B.",
    'confluence-table-tree.drafts-toggle.label': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A\u0438",
    'confluence-table-tree.edit': "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C",
    'confluence-table-tree.edit-in-confluence': "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 Confluence",
    'confluence-table-tree.empty.description': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u044B \u0441\u043E\u0431\u0440\u0430\u043D\u0438\u0439, \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F \u043A \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443, \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u043E\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0440\u0430\u0437\u0434\u0435\u043B.",
    'confluence-table-tree.empty.title': "\u0417\u0434\u0435\u0441\u044C \u043D\u0435\u0442 \u043D\u0438\u0447\u0435\u0433\u043E, \u043A\u0440\u043E\u043C\u0435 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u0430",
    'confluence-table-tree.error.description': "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u044D\u0442\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u043F\u043E\u0437\u0436\u0435.",
    'confluence-table-tree.error.row': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B.",
    'confluence-table-tree.error.title': "\u041D\u0430\u043C \u0442\u0430\u043A \u043D\u0435\u043B\u043E\u0432\u043A\u043E...",
    'confluence-table-tree.friendly-when-created': "\u0421\u043E\u0437\u0434\u0430\u043D\u043E",
    'confluence-table-tree.friendly-when-updated': "\u0414\u0430\u0442\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F",
    'confluence-table-tree.share.copied': "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
    'confluence-table-tree.share.copy-button': "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
    'confluence-table-tree.share.subtitle': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u044D\u0442\u043E\u0439 \u0441\u0441\u044B\u043B\u043A\u043E\u0439",
    'confluence-table-tree.share.title': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435\u0439",
    'confluence-table-tree.share.tooltip': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'confluence-table-tree.view-profile': "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044C"
};

});

parcelRegister("gIEmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a7dd555ea353bff$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $6a7dd555ea353bff$export$2e2bcd8739ae039 = {};

});

parcelRegister("eXEpp", function(module, exports) {

$parcel$export(module.exports, "default", () => $32a55a033aff5013$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $32a55a033aff5013$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Colaboradores',
    'confluence-table-tree.column.last-modified': "\xdaltima modificaci\xf3n",
    'confluence-table-tree.column.title': 'Nombre',
    'confluence-table-tree.could-not-load': 'No se ha podido cargar',
    'confluence-table-tree.could-not-load-contributors': 'No se han podido cargar los colaboradores',
    'confluence-table-tree.create-child-page': "Crear una p\xe1gina secundaria",
    'confluence-table-tree.create-page': "Crear p\xe1gina",
    'confluence-table-tree.default.page.title': "Sin t\xedtulo",
    'confluence-table-tree.default.show-all-pages-button.label': "Mostrar m\xe1s p\xe1ginas",
    'confluence-table-tree.draft.lozenge': 'BORRADOR',
    'confluence-table-tree.draft.tooltip': "Solo t\xfa puedes ver los borradores.",
    'confluence-table-tree.drafts-toggle.label': 'Mostrar borradores',
    'confluence-table-tree.edit': 'Editar',
    'confluence-table-tree.edit-in-confluence': 'Editar en Confluence',
    'confluence-table-tree.empty.description': 'Crea notas, requisitos de productos, decisiones u otros contenidos para llenar este espacio.',
    'confluence-table-tree.empty.title': "Aqu\xed no hay sino potencial",
    'confluence-table-tree.error.description': "No podemos mostrarte estas p\xe1ginas. Int\xe9ntalo de nuevo m\xe1s tarde.",
    'confluence-table-tree.error.row': "No se pueden cargar p\xe1ginas.",
    'confluence-table-tree.error.title': 'Bueno, esto es un poco embarazoso...',
    'confluence-table-tree.friendly-when-created': "Creaci\xf3n",
    'confluence-table-tree.friendly-when-updated': 'Actualizado',
    'confluence-table-tree.share.copied': 'Copiado en el portapapeles',
    'confluence-table-tree.share.copy-button': 'Copiar',
    'confluence-table-tree.share.subtitle': 'Compartir este enlace',
    'confluence-table-tree.share.title': "Compartir p\xe1gina",
    'confluence-table-tree.share.tooltip': 'Compartir',
    'confluence-table-tree.view-profile': 'Ver perfil'
};

});

parcelRegister("c6Gq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4293f4c41aa9a555$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $4293f4c41aa9a555$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Medarbetare',
    'confluence-table-tree.column.last-modified': "Senast \xe4ndrad",
    'confluence-table-tree.column.title': 'Namn',
    'confluence-table-tree.could-not-load': "Det gick inte att l\xe4sa in",
    'confluence-table-tree.could-not-load-contributors': "Det gick inte att l\xe4sa in medarbetare",
    'confluence-table-tree.create-child-page': 'Skapa en underordnad sida',
    'confluence-table-tree.create-page': 'Skapa sida',
    'confluence-table-tree.default.page.title': 'Utan rubrik',
    'confluence-table-tree.default.show-all-pages-button.label': 'Visa fler sidor',
    'confluence-table-tree.draft.lozenge': 'UTKAST',
    'confluence-table-tree.draft.tooltip': 'Endast du kan se utkast.',
    'confluence-table-tree.drafts-toggle.label': 'Visa utkast',
    'confluence-table-tree.edit': 'Redigera',
    'confluence-table-tree.edit-in-confluence': 'Redigera i Confluence',
    'confluence-table-tree.empty.description': "Skapa m\xf6tesanteckningar, produktkrav, beslut eller annat inneh\xe5ll f\xf6r att fylla utrymmet.",
    'confluence-table-tree.empty.title': "H\xe4r finns inget annat \xe4n potential",
    'confluence-table-tree.error.description': "Vi kan inte visa de h\xe4r sidorna. F\xf6rs\xf6k igen senare.",
    'confluence-table-tree.error.row': "Det gick inte att l\xe4sa in sidor.",
    'confluence-table-tree.error.title': 'Det var konstigt ...',
    'confluence-table-tree.friendly-when-created': 'Skapad',
    'confluence-table-tree.friendly-when-updated': 'Uppdaterad',
    'confluence-table-tree.share.copied': 'Kopierad till urklipp',
    'confluence-table-tree.share.copy-button': 'Kopiera',
    'confluence-table-tree.share.subtitle': "Dela denna l\xe4nk",
    'confluence-table-tree.share.title': 'Dela sida',
    'confluence-table-tree.share.tooltip': 'Dela',
    'confluence-table-tree.view-profile': 'Visa profil'
};

});

parcelRegister("gCKun", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d3782835e3a5c45$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $8d3782835e3a5c45$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u0E1C\u0E39\u0E49\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19",
    'confluence-table-tree.column.last-modified': "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E04\u0E23\u0E31\u0E49\u0E07\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14",
    'confluence-table-tree.column.title': "\u0E0A\u0E37\u0E48\u0E2D",
    'confluence-table-tree.could-not-load': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E14\u0E49",
    'confluence-table-tree.could-not-load-contributors': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E42\u0E2B\u0E25\u0E14\u0E1C\u0E39\u0E49\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E44\u0E14\u0E49",
    'confluence-table-tree.create-child-page': "\u0E08\u0E31\u0E14\u0E17\u0E33\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E23\u0E2D\u0E07",
    'confluence-table-tree.create-page': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'confluence-table-tree.default.page.title': "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E0A\u0E37\u0E48\u0E2D",
    'confluence-table-tree.default.show-all-pages-button.label': "\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'confluence-table-tree.draft.lozenge': "\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07",
    'confluence-table-tree.draft.tooltip': "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E39\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E04\u0E19\u0E40\u0E14\u0E35\u0E22\u0E27",
    'confluence-table-tree.drafts-toggle.label': "\u0E41\u0E2A\u0E14\u0E07\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07",
    'confluence-table-tree.edit': "\u0E41\u0E01\u0E49\u0E44\u0E02",
    'confluence-table-tree.edit-in-confluence': "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E43\u0E19 Confluence",
    'confluence-table-tree.empty.description': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21 \u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E49\u0E32\u0E19\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C \u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E01\u0E32\u0E23\u0E40\u0E15\u0E34\u0E21\u0E40\u0E15\u0E47\u0E21\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E43\u0E19\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E19\u0E35\u0E49",
    'confluence-table-tree.empty.title': "\u0E17\u0E38\u0E01\u0E2A\u0E34\u0E48\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
    'confluence-table-tree.error.description': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E43\u0E19\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07",
    'confluence-table-tree.error.row': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E42\u0E2B\u0E25\u0E14\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'confluence-table-tree.error.title': "\u0E41\u0E22\u0E48\u0E08\u0E31\u0E07",
    'confluence-table-tree.friendly-when-created': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E25\u0E49\u0E27",
    'confluence-table-tree.friendly-when-updated': "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E25\u0E49\u0E27",
    'confluence-table-tree.share.copied': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E07\u0E04\u0E25\u0E34\u0E1B\u0E1A\u0E2D\u0E23\u0E4C\u0E14\u0E41\u0E25\u0E49\u0E27",
    'confluence-table-tree.share.copy-button': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01",
    'confluence-table-tree.share.subtitle': "\u0E41\u0E0A\u0E23\u0E4C\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E19\u0E35\u0E49",
    'confluence-table-tree.share.title': "\u0E41\u0E0A\u0E23\u0E4C\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'confluence-table-tree.share.tooltip': "\u0E41\u0E0A\u0E23\u0E4C",
    'confluence-table-tree.view-profile': "\u0E14\u0E39\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C"
};

});

parcelRegister("7KhSO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3d4bc4610e66b17$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $d3d4bc4610e66b17$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "Katk\u0131da bulunanlar",
    'confluence-table-tree.column.last-modified': "Son de\u011Fi\u015Fiklik",
    'confluence-table-tree.column.title': "Ad\u0131",
    'confluence-table-tree.could-not-load': "Y\xfcklenemedi",
    'confluence-table-tree.could-not-load-contributors': "Katk\u0131da bulunanlar y\xfcklenemedi",
    'confluence-table-tree.create-child-page': "Alt sayfa olu\u015Ftur",
    'confluence-table-tree.create-page': "Sayfa olu\u015Ftur",
    'confluence-table-tree.default.page.title': "Ba\u015Fl\u0131ks\u0131z",
    'confluence-table-tree.default.show-all-pages-button.label': "Daha fazla sayfa g\xf6ster",
    'confluence-table-tree.draft.lozenge': 'TASLAK',
    'confluence-table-tree.draft.tooltip': "Taslaklar yaln\u0131zca sizin taraf\u0131n\u0131zdan g\xf6r\xfclebilir.",
    'confluence-table-tree.drafts-toggle.label': "Taslaklar\u0131 g\xf6ster",
    'confluence-table-tree.edit': "D\xfczenle",
    'confluence-table-tree.edit-in-confluence': "Confluence'ta d\xfczenleyin",
    'confluence-table-tree.empty.description': "Bu alan\u0131 doldurmak i\xe7in toplant\u0131 notlar\u0131, \xfcr\xfcn gereklilikleri, kararlar veya ba\u015Fka i\xe7erikler olu\u015Fturun.",
    'confluence-table-tree.empty.title': "Bu sayfada hen\xfcz i\xe7erik yok",
    'confluence-table-tree.error.description': "Size bu sayfalar\u0131 g\xf6steremiyoruz. L\xfctfen daha sonra yeniden deneyin.",
    'confluence-table-tree.error.row': "Sayfalar y\xfcklenemedi.",
    'confluence-table-tree.error.title': 'Bir sorun var...',
    'confluence-table-tree.friendly-when-created': "Olu\u015Fturulma",
    'confluence-table-tree.friendly-when-updated': "G\xfcncellenme",
    'confluence-table-tree.share.copied': "Panoya kopyaland\u0131",
    'confluence-table-tree.share.copy-button': 'Kopyala',
    'confluence-table-tree.share.subtitle': "Bu ba\u011Flant\u0131y\u0131 payla\u015F\u0131n",
    'confluence-table-tree.share.title': "Sayfay\u0131 payla\u015F\u0131n",
    'confluence-table-tree.share.tooltip': "Payla\u015F",
    'confluence-table-tree.view-profile': "Profili g\xf6r\xfcnt\xfcle"
};

});

parcelRegister("4iYEg", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd65ea6b7d96cab7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $fd65ea6b7d96cab7$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u0423\u0447\u0430\u0441\u043D\u0438\u043A\u0438",
    'confluence-table-tree.column.last-modified': "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0437\u043C\u0456\u043D\u0430",
    'confluence-table-tree.column.title': "\u0406\u043C\u2019\u044F",
    'confluence-table-tree.could-not-load': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
    'confluence-table-tree.could-not-load-contributors': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u0440\u0456\u0432",
    'confluence-table-tree.create-child-page': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0434\u043E\u0447\u0456\u0440\u043D\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'confluence-table-tree.create-page': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'confluence-table-tree.default.page.title': "\u0411\u0435\u0437 \u043D\u0430\u0437\u0432\u0438",
    'confluence-table-tree.default.show-all-pages-button.label': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A",
    'confluence-table-tree.draft.lozenge': "\u0427\u0415\u0420\u041D\u0415\u0422\u041A\u0410",
    'confluence-table-tree.draft.tooltip': "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0431\u0430\u0447\u0438\u0442\u0438 \u0442\u0456\u043B\u044C\u043A\u0438 \u0432\u0438.",
    'confluence-table-tree.drafts-toggle.label': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0447\u0435\u0440\u043D\u0435\u0442\u043A\u0438",
    'confluence-table-tree.edit': "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
    'confluence-table-tree.edit-in-confluence': "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0432 Confluence",
    'confluence-table-tree.empty.description': "\u0429\u043E\u0431 \u0437\u0430\u043F\u043E\u0432\u043D\u0438\u0442\u0438 \u0446\u0435\u0439 \u0440\u043E\u0437\u0434\u0456\u043B, \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u0432 \u043D\u044C\u043E\u0433\u043E \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u0434\u043E \u043D\u0430\u0440\u0430\u0434\u0438, \u0432\u0438\u043C\u043E\u0433\u0438 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443, \u0440\u0456\u0448\u0435\u043D\u043D\u044F \u0447\u0438 \u0456\u043D\u0448\u0438\u0439 \u0432\u043C\u0456\u0441\u0442.",
    'confluence-table-tree.empty.title': "\u0422\u0443\u0442 \u0431\u0430\u0433\u0430\u0442\u043E \u043C\u043E\u0436\u043B\u0438\u0432\u043E\u0441\u0442\u0435\u0439",
    'confluence-table-tree.error.description': "\u041D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u0446\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438. \u041F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443 \u043F\u0456\u0437\u043D\u0456\u0448\u0435.",
    'confluence-table-tree.error.row': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438.",
    'confluence-table-tree.error.title': "\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0437\u0430 \u043F\u043B\u0430\u043D\u043E\u043C...",
    'confluence-table-tree.friendly-when-created': "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    'confluence-table-tree.friendly-when-updated': "\u0417\u043C\u0456\u043D\u0435\u043D\u043E",
    'confluence-table-tree.share.copied': "\u0421\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443",
    'confluence-table-tree.share.copy-button': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438",
    'confluence-table-tree.share.subtitle': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0446\u0438\u043C \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F\u043C",
    'confluence-table-tree.share.title': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u043E\u044E",
    'confluence-table-tree.share.tooltip': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F",
    'confluence-table-tree.view-profile': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043F\u0440\u043E\u0444\u0456\u043B\u044C"
};

});

parcelRegister("2Dlkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ececf7dfa8729b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $19ececf7dfa8729b$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "Ng\u01B0\u1EDDi \u0111\xf3ng g\xf3p",
    'confluence-table-tree.column.last-modified': "S\u1EEDa \u0111\u1ED5i g\u1EA7n \u0111\xe2y nh\u1EA5t",
    'confluence-table-tree.column.title': "T\xean",
    'confluence-table-tree.could-not-load': "Kh\xf4ng t\u1EA3i \u0111\u01B0\u1EE3c",
    'confluence-table-tree.could-not-load-contributors': "Kh\xf4ng t\u1EA3i \u0111\u01B0\u1EE3c th\xf4ng tin v\u1EC1 nh\u1EEFng ng\u01B0\u1EDDi \u0111\xf3ng g\xf3p",
    'confluence-table-tree.create-child-page': "T\u1EA1o trang con",
    'confluence-table-tree.create-page': "T\u1EA1o trang",
    'confluence-table-tree.default.page.title': "Ch\u01B0a c\xf3 ti\xeau \u0111\u1EC1",
    'confluence-table-tree.default.show-all-pages-button.label': "Hi\u1EC3n th\u1ECB nhi\u1EC1u trang h\u01A1n",
    'confluence-table-tree.draft.lozenge': "B\u1EA2N NH\xc1P",
    'confluence-table-tree.draft.tooltip': "Ch\u1EC9 b\u1EA1n m\u1EDBi c\xf3 th\u1EC3 th\u1EA5y b\u1EA3n nh\xe1p.",
    'confluence-table-tree.drafts-toggle.label': "Hi\u1EC3n th\u1ECB b\u1EA3n nh\xe1p",
    'confluence-table-tree.edit': "Ch\u1EC9nh s\u1EEDa",
    'confluence-table-tree.edit-in-confluence': "S\u1EEDa trong Confluence",
    'confluence-table-tree.empty.description': "T\u1EA1o v\xe0i ghi ch\xfa cu\u1ED9c h\u1ECDp, y\xeau c\u1EA7u s\u1EA3n ph\u1EA9m, quy\u1EBFt \u0111\u1ECBnh ho\u1EB7c n\u1ED9i dung kh\xe1c \u0111\u1EC3 th\u1EA5y v\xf9ng n\xe0y l\u1EA5p \u0111\u1EA7y.",
    'confluence-table-tree.empty.title': "Kh\xf4ng c\xf3 g\xec \u1EDF \u0111\xe2y ngo\xe0i ti\u1EC1m n\u0103ng",
    'confluence-table-tree.error.description': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 hi\u1EC3n th\u1ECB cho b\u1EA1n nh\u1EEFng trang n\xe0y. Vui l\xf2ng th\u1EED l\u1EA1i sau.",
    'confluence-table-tree.error.row': "Kh\xf4ng th\u1EC3 t\u1EA3i trang.",
    'confluence-table-tree.error.title': "Ch\xe0, th\u1EADt l\xe0 l\u1EA1...",
    'confluence-table-tree.friendly-when-created': "\u0110\xe3 t\u1EA1o",
    'confluence-table-tree.friendly-when-updated': "\u0110\xe3 c\u1EADp nh\u1EADt",
    'confluence-table-tree.share.copied': "\u0110\xe3 sao ch\xe9p v\xe0o b\u1EA3ng nh\u1EDB t\u1EA1m",
    'confluence-table-tree.share.copy-button': "Sao ch\xe9p",
    'confluence-table-tree.share.subtitle': "Chia s\u1EBB li\xean k\u1EBFt n\xe0y",
    'confluence-table-tree.share.title': "Chia s\u1EBB trang",
    'confluence-table-tree.share.tooltip': "Chia s\u1EBB",
    'confluence-table-tree.view-profile': "Xem h\u1ED3 s\u01A1"
};

});

parcelRegister("Yy6gr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec7eac91429a4b1d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $ec7eac91429a4b1d$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u2063\u2062Contributors\u2060\x8d\x8d\x81\x9d\u206B\u206F\u061C\u2061\u2060\u200D\u200C\u206F\u200C\u206A\x9d\u2061\x9d\u200D\u206B\x81\u200D\x9d\u2060\u206D\u206A\u206C\u2061\u061C\u200D\u206C\x81\u2063\u2064",
    'confluence-table-tree.column.last-modified': "\u2063\u2062Last modified\u200D\u206F\u2060\x9d\u206F\u206A\u206D\u206A\u200C\u200D\u206C\u206B\u200C\u2060\u206D\u2061\u206A\u206E\u2061\u206A\u206A\u206A\u206B\u206C\x9d\u206E\u200D\u206A\u200D\u206B\x9d\x81\u2063\u2064",
    'confluence-table-tree.column.title': "\u2063\u2062Name\u206C\x8f\u206F\x8d\u2060\u2060\u206F\u200C\u2061\u206F\u206C\u200C\u2061\u206D\u2060\u206A\u200D\u206E\x8f\u206E\u200C\u206C\u206D\u2060\u2060\x9d\u206D\u206F\u206E\x9d\u2061\u206F\u2063\u2064",
    'confluence-table-tree.could-not-load': "\u2063\u2062Couldn't load\u200D\u206F\u206E\u206D\u206B\u200C\u200C\u2061\u061C\x81\x8f\u206F\u206F\u206F\u2061\u206E\u206C\x8f\u206C\u2060\u206D\u2060\x90\u2061\u206F\u206B\u206A\u200C\u200C\x90\u2060\u200C\u2063\u2064",
    'confluence-table-tree.could-not-load-contributors': "\u2063\u2062Couldn't load contributors\u206E\u2060\x9d\u2061\x9d\u206D\u206C\x8f\u2060\u2061\x9d\u206F\x81\u206C\x8d\x8f\x9d\u206F\x90\x8d\u206B\x8f\u2060\x9d\u206A\u2060\x8d\u200D\x81\x9d\x9d\u206B\u2063\u2064",
    'confluence-table-tree.create-child-page': "\u2063\u2062Create a child page\u2061\u206D\x8f\x81\u061C\x81\u206C\u206B\u061C\u206F\u061C\u206D\u206C\u206F\u206E\x90\x8f\u206D\u061C\x8d\x8d\x9d\u2061\x90\u206F\x81\u206F\u200C\u200C\u200D\u206B\x9d\u2063\u2064",
    'confluence-table-tree.create-page': "\u2063\u2062Create page\u206C\x81\u061C\u206A\u2060\u206F\u206E\u200D\u2060\u2060\u200C\u2061\x90\x8f\x81\u2060\u206C\u061C\u206B\x90\u061C\u200C\u200C\u200D\x81\u200C\u2060\u206B\u200C\u206E\u200D\x81\u2063\u2064",
    'confluence-table-tree.default.page.title': "\u2063\u2062Untitled\u206B\x90\x9d\x8f\u206B\u206F\u061C\u206C\x8f\x90\u061C\x81\u061C\x9d\x81\u206C\u206D\u061C\u206B\u2060\x90\x81\u200C\u206F\u206F\u206E\u206D\u206D\u2061\u206F\x9d\x81\u2063\u2064",
    'confluence-table-tree.default.show-all-pages-button.label': "\u2063\u2062Show more pages\u206C\u206A\u206C\u200D\x8d\u206F\u206E\u206F\u206F\x8f\u2060\u206D\x90\x8d\u206A\x90\u206F\u206D\u206D\x8d\u200C\u200D\u200C\u200D\x81\u206A\u061C\x8d\u2061\x90\u206E\x8d\u2063\u2064",
    'confluence-table-tree.draft.lozenge': "\u2063\u2062DRAFT\u206E\x81\u2061\u206A\x90\x81\u2060\x8d\x8d\u2060\x8d\u206F\x8f\x81\x81\u061C\x81\x8d\u200D\u200C\u2060\u206F\u2060\x90\u200D\x81\u206C\u206E\u206B\u2061\u200C\u2061\u2063\u2064",
    'confluence-table-tree.draft.tooltip': "\u2063\u2062Drafts can only be seen by you.\u206F\u2061\x9d\u206D\u206A\u200D\u061C\x9d\x9d\u206E\u206B\x8f\u200D\x90\x8f\x90\u206E\x81\x8f\u206A\u206A\u2060\u206F\x90\u206E\u200C\u206B\u2061\u206F\u200C\u206F\x81\u2063\u2064",
    'confluence-table-tree.drafts-toggle.label': "\u2063\u2062Show drafts\u206F\x9d\x8d\u200C\u061C\x9d\x9d\u2060\x90\u2061\u200D\x90\u206C\x90\u206F\x8f\u206A\u206D\u206E\x81\u206C\u2061\x90\u206C\u206D\u061C\u200D\u061C\x8f\x81\u206F\x9d\u2063\u2064",
    'confluence-table-tree.edit': "\u2063\u2062Edit\u2061\u2061\x9d\u206D\x8f\x8d\x9d\u206C\u206F\u206C\u206E\u200C\x8f\u206C\u206F\u206B\u206A\u206F\u061C\x90\x81\u206E\u206E\x8f\u200C\u206F\u206C\x8d\u200D\x90\u200C\x8d\u2063\u2064",
    'confluence-table-tree.edit-in-confluence': "\u2063\u2062Edit in Confluence\u206F\u2061\u206B\u206B\u206D\u2060\u2061\x8d\x90\u200D\x8f\u206B\x8d\u200C\u206D\x9d\u2061\u200D\u206B\u206C\u206A\x90\u206A\x8f\u206B\u206D\u206E\u206F\u200D\x9d\u206D\u061C\u2063\u2064",
    'confluence-table-tree.empty.description': "\u2063\u2062Create some meeting notes, product requirements, decisions, or other content to see this space fill up.\u206D\u200C\u206C\x90\x8d\u206F\u206B\u200D\x90\u206F\u206C\x8d\x90\u2060\x9d\x8d\x9d\u2061\u206B\x90\u200D\u206B\u2061\x8f\x9d\x81\u206A\x8f\u2060\u206B\u206E\u206B\u2063\u2064",
    'confluence-table-tree.empty.title': "\u2063\u2062There's nothing here but potential\u206C\u206D\u206C\u2061\x8f\u200C\x8f\u206C\x90\u206D\x9d\x8f\x9d\u2060\u206F\u200C\u206C\u200D\u061C\x81\x90\u200C\u206A\x8f\x8d\u2061\u061C\u2060\u206B\u206A\u061C\u200C\u2063\u2064",
    'confluence-table-tree.error.description': "\u2063\u2062We can't show you these pages. Please try again later.\u2060\x90\u200C\u2060\u2061\u206C\u206E\x8d\x81\x8d\x8f\u206D\x8d\x8d\x8f\u206F\x8f\u206F\u200D\u206E\x8f\u206B\x81\u206C\u206F\u206C\x90\x8f\u200D\u206E\x9d\x81\u2063\u2064",
    'confluence-table-tree.error.row': "\u2063\u2062Unable to load pages.\x8f\u206E\u206C\u2060\x8d\u061C\x9d\u200D\u206D\u2060\x90\u2060\u206D\u206A\u206D\x81\u206A\u206F\u2060\x9d\u206D\u206F\u200C\u206B\u206A\u206A\u206E\x8f\u200C\u200D\x90\u206B\u2063\u2064",
    'confluence-table-tree.error.title': "\u2063\u2062Well, this is awkward...\u200D\x8d\x8d\u061C\u206C\u206C\x8d\u2060\x8d\u061C\u200C\x81\u206D\u206D\u206A\x81\u2061\u200D\u206D\x81\x9d\u2061\u206B\u2060\u206B\u206B\u2061\u200D\u2061\u2060\u206A\u206A\u2063\u2064",
    'confluence-table-tree.friendly-when-created': "\u2063\u2062Created\x90\x90\u061C\x8d\u206F\u206D\x8f\x81\u2061\u206E\u206A\u2061\x8f\u206C\u206C\u200C\x9d\u206E\u206F\x9d\u206D\u2060\x81\x8f\x8f\u2061\u206C\u206F\x8f\u200D\u200C\u2061\u2063\u2064",
    'confluence-table-tree.friendly-when-updated': "\u2063\u2062Updated\u206A\u206C\x8d\u2060\x9d\u206B\u200D\u206E\u2060\x8d\u206A\x8d\u061C\u2060\u2060\u206B\u061C\u200C\u206C\u2061\u206A\u200D\u206F\u200D\x81\u061C\u206C\u061C\u200C\x90\u206D\u206B\u2063\u2064",
    'confluence-table-tree.share.copied': "\u2063\u2062Copied to clipboard\u2061\u206B\u200D\x8d\u200C\u206E\x9d\u200D\x8f\u206D\u200D\u206C\u206F\u061C\u061C\u2060\u206D\u206F\x9d\u2061\u200C\x81\u206C\x8d\u061C\u206D\u061C\u206A\x8f\u200C\x90\u206C\u2063\u2064",
    'confluence-table-tree.share.copy-button': "\u2063\u2062Copy\x8f\x90\x8f\u206D\u206A\u206C\x9d\u2061\u200C\u206A\x90\u061C\x81\u206A\x90\u206A\u206E\u206E\u206E\u200D\x8d\u206C\u2060\u206E\u206A\x8f\x9d\u200D\u206C\u206B\x9d\u206C\u2063\u2064",
    'confluence-table-tree.share.subtitle': "\u2063\u2062Share this link\u200C\u2060\u2061\u206B\u206A\x81\u2060\x9d\u2060\x8f\u206E\u200D\u206D\u2061\x90\u206A\x90\x8f\x81\u206E\u200D\u206B\x9d\u206A\u206E\x90\u2061\x9d\u206B\u206F\u200D\x8f\u2063\u2064",
    'confluence-table-tree.share.title': "\u2063\u2062Share page\u200D\u206A\u061C\u206C\u206A\u206F\u206A\x8f\x90\u206B\x8f\u206C\u200D\u206A\u206E\u061C\u206D\u206B\x8f\x9d\u061C\u206A\u206F\u206E\u206F\u061C\u206C\u061C\u206F\x8f\u2061\u206C\u2063\u2064",
    'confluence-table-tree.share.tooltip': "\u2063\u2062Share\u061C\x9d\x8f\x8f\u206E\u206F\u206A\u061C\u200C\x90\u200D\x8f\u206A\u200C\x9d\x8f\u200D\u200D\u206D\u2061\u206F\x90\u206B\u2060\u061C\u206A\u206D\u200C\u061C\u200C\u206E\x8f\u2063\u2064",
    'confluence-table-tree.view-profile': "\u2063\u2062View profile\u206B\x8f\u2060\u2061\u061C\u206F\u200C\u206F\x8d\u206B\u206A\u206E\u206F\u206E\u206F\u2060\u200D\u206A\u061C\u206C\u206F\x90\u206A\u2060\u206A\u200C\x81\x8f\x8f\u206F\u200D\x9d\u2063\u2064"
};

});




parcelRegister("kQ8I0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3986a0943cd7d151$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $e270j = parcelRequire("e270j");

var $gWxA1 = parcelRequire("gWxA1");

var $86L81 = parcelRequire("86L81");

var $a9Brc = parcelRequire("a9Brc");

var $j7dt3 = parcelRequire("j7dt3");

var $joBf7 = parcelRequire("joBf7");
function $3986a0943cd7d151$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3986a0943cd7d151$var$messages = (0, $90IgZ.defineMessages)({
    label: {
        id: 'confluence-table-tree.drafts-toggle.label',
        defaultMessage: 'Show drafts',
        description: 'Label for the toggle that turns on or off showing drafts in the page tree'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3986a0943cd7d151$var$Wrapper = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ecvq3120"
})({
    name: "4jyrxv",
    styles: "display:flex;align-items:center;justify-content:flex-end;margin-bottom:var(--ds-space-100, 8px)"
});
const $3986a0943cd7d151$var$DraftsToggle = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ isDraftsShown: isDraftsShown, isTreeUpdatedForDrafts: isTreeUpdatedForDrafts }, { setIsDraftsShown: setIsDraftsShown }] = (0, $86L81.useDraftsToggle)();
    const { accountId: accountId } = (0, $a9Brc.useConfluencePageTreeContext)();
    const handleChange = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        setIsDraftsShown(accountId, !isDraftsShown);
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'showDraftsToggle', {
            isDraftsShown: !isDraftsShown
        });
    }, [
        accountId,
        isDraftsShown,
        setIsDraftsShown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3986a0943cd7d151$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        id: "show-drafts",
        testId: "show-drafts-toggle",
        isChecked: isDraftsShown || false,
        isDisabled: isDraftsShown === null || !isTreeUpdatedForDrafts,
        onChange: handleChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label", {
        htmlFor: "show-drafts"
    }, formatMessage($3986a0943cd7d151$var$messages.label)));
};
var $3986a0943cd7d151$export$2e2bcd8739ae039 = ({ locale: locale })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7dt3.TranslationsProvider), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3986a0943cd7d151$var$DraftsToggle, null));

});
parcelRegister("e270j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3122f1d9f9fa05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $hnob3 = parcelRequire("hnob3");

var $fbOgz = parcelRequire("fbOgz");

var $2wLr6 = parcelRequire("2wLr6");

var $gnr5M = parcelRequire("gnr5M");
const $4d3122f1d9f9fa05$var$noop = (0, $5Q9wj.default);
const $4d3122f1d9f9fa05$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4d3122f1d9f9fa05$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $4d3122f1d9f9fa05$var$Toggle = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $4d3122f1d9f9fa05$var$noop, onChange: providedChange = $4d3122f1d9f9fa05$var$noop, onFocus: providedFocus = $4d3122f1d9f9fa05$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eUqFw.useState)(defaultChecked);
    const handleBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleChange = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $eUqFw.useMemo)(()=>(0, $gnr5M.getStyles)(size), [
        size
    ]);
    const legacyIconSize = $4d3122f1d9f9fa05$var$iconSizeMap[size];
    const labelId = (0, $ki32l.useId)();
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hnob3))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-check-icon`
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fbOgz))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-cross-icon`
    }))));
}));
$4d3122f1d9f9fa05$var$Toggle.displayName = 'Toggle';
var $4d3122f1d9f9fa05$export$2e2bcd8739ae039 = $4d3122f1d9f9fa05$var$Toggle;

});
parcelRegister("hnob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116024720ac5bfd6b5d0b476c677b799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca6756bf734aa598$var$_react = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca6756bf734aa598$var$_checkMark = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("7RK9I")));

var $ca6756bf734aa598$var$_done = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("k9Z3M")));
function $ca6756bf734aa598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca6756bf734aa598$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ca6756bf734aa598$var$_react.default.createElement($ca6756bf734aa598$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ca6756bf734aa598$var$_done.default
    }, props));
$ca6756bf734aa598$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ca6756bf734aa598$var$_default = module.exports.default = $ca6756bf734aa598$var$CheckMarkIcon;

});
parcelRegister("7RK9I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d905e7dc6c2480f22f2a9081c36a5712>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ba14938eb17fe40$var$_react = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5ba14938eb17fe40$var$_UNSAFE_baseNew = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5ba14938eb17fe40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ba14938eb17fe40$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5ba14938eb17fe40$var$_react.default.createElement($5ba14938eb17fe40$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$5ba14938eb17fe40$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $5ba14938eb17fe40$var$_default = module.exports.default = $5ba14938eb17fe40$var$CheckMarkIcon;

});

parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});



parcelRegister("fbOgz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b0cdbbee1b52bd7575a4eda010b0e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0eedfeb10f4bac1$var$_react = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b0eedfeb10f4bac1$var$_cross = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("adUQx")));

var $b0eedfeb10f4bac1$var$_close = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("je5kZ")));
function $b0eedfeb10f4bac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0eedfeb10f4bac1$var$CrossIcon = (props)=>/*#__PURE__*/ $b0eedfeb10f4bac1$var$_react.default.createElement($b0eedfeb10f4bac1$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $b0eedfeb10f4bac1$var$_close.default
    }, props));
$b0eedfeb10f4bac1$var$CrossIcon.Name = 'CrossIconMigration';
var $b0eedfeb10f4bac1$var$_default = module.exports.default = $b0eedfeb10f4bac1$var$CrossIcon;

});
parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});


parcelRegister("2wLr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3035e6738b21544f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $3035e6738b21544f$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease',
    position: 'absolute',
    insetBlockStart: 'space.025'
});
const $3035e6738b21544f$var$iconContainerRegularStyles = (0, $1ZAYh.xcss)({
    width: '16px',
    height: '16px'
});
const $3035e6738b21544f$var$iconContainerLargeStyles = (0, $1ZAYh.xcss)({
    width: '20px',
    height: '20px'
});
const $3035e6738b21544f$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $3035e6738b21544f$var$leftStyles = (0, $1ZAYh.xcss)({
    insetInlineStart: '3px'
});
const $3035e6738b21544f$var$rightStyles = (0, $1ZAYh.xcss)({
    insetInlineEnd: '3px'
});
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $3035e6738b21544f$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $3035e6738b21544f$var$iconContainerStyles,
            isHidden && (0, $XHGTv.fg)('platform-visual-refresh-icons') && $3035e6738b21544f$var$hiddenStyles,
            size === 'regular' && $3035e6738b21544f$var$iconContainerRegularStyles,
            size === 'large' && $3035e6738b21544f$var$iconContainerLargeStyles,
            position === 'left' && $3035e6738b21544f$var$leftStyles,
            position === 'right' && $3035e6738b21544f$var$rightStyles
        ]
    }, children);
};
var $3035e6738b21544f$export$2e2bcd8739ae039 = $3035e6738b21544f$var$IconContainer;

});

parcelRegister("gnr5M", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $f3c1d4ec47a37a63$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $lcnyw = parcelRequire("lcnyw");

var $3Vu5P = parcelRequire("3Vu5P");
const $f3c1d4ec47a37a63$var$globalGridSize = (0, $lcnyw.gridSize)();
const $f3c1d4ec47a37a63$var$dimensions = {
    regular: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 4
    },
    large: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2 + $f3c1d4ec47a37a63$var$globalGridSize / 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 5
    }
};
const $f3c1d4ec47a37a63$var$getHeight = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].height;
const $f3c1d4ec47a37a63$var$getWidth = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].width;
const $f3c1d4ec47a37a63$var$borderWidth = 2;
const $f3c1d4ec47a37a63$var$paddingUnitless = $f3c1d4ec47a37a63$var$globalGridSize / 4;
const $f3c1d4ec47a37a63$var$transition = 'transform 0.2s ease';
const $f3c1d4ec47a37a63$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3Vu5P.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $f3c1d4ec47a37a63$var$borderWidth,
        margin: $f3c1d4ec47a37a63$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$f3c1d4ec47a37a63$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$f3c1d4ec47a37a63$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $f3c1d4ec47a37a63$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // Remove during new icon flag cleanup. This is required to maintain the size of legacy icons.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        !(0, $XHGTv.fg)('platform-visual-refresh-icons') && {
            '> span > span': {
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3Vu5P", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $a04fcc2fd7c04036$export$6cee60e8aa85e528);

const $a04fcc2fd7c04036$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$a49394138f7b8e85)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
};
const $a04fcc2fd7c04036$export$6cee60e8aa85e528 = ()=>$a04fcc2fd7c04036$var$colorMap;

});




parcelRegister("03Jpi", function(module, exports) {

$parcel$export(module.exports, "ConfluencePageTreeProvider", () => $bfbe8e9d244fa3b5$export$bc80c2f90a0a10c6);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $hfG2L = parcelRequire("hfG2L");

var $4wyem = parcelRequire("4wyem");

var $6K8He = parcelRequire("6K8He");

var $86L81 = parcelRequire("86L81");

var $cSwOk = parcelRequire("cSwOk");

var $7hnEh = parcelRequire("7hnEh");

var $a9Brc = parcelRequire("a9Brc");

var $8nJSl = parcelRequire("8nJSl");
const $bfbe8e9d244fa3b5$export$33eadec77c3a34cd = new (0, $7hnEh.ConfluenceTableTreeData)();
const $bfbe8e9d244fa3b5$export$274a9a2a3c6432ca = ({ onError: onError, accountId: accountId, children: children })=>{
    const [items, setItems] = (0, $eUqFw.useState)(null);
    const [errorType, setErrorType] = (0, $eUqFw.useState)(null);
    const [spaceKey, setSpaceKey] = (0, $eUqFw.useState)(null);
    const [rootContentId, setRootContentId] = (0, $eUqFw.useState)(null);
    const [canShowMorePages, setCanShowMorePages] = (0, $eUqFw.useState)(false);
    const [currentLoadMoreCursor, setCurrentLoadMoreCursor] = (0, $eUqFw.useState)(0);
    const [projectId, setProjectId] = (0, $eUqFw.useState)(0);
    const [projectType, setProjectType] = (0, $eUqFw.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ isDraftsShown: isDraftsShown, isTreeUpdatedForDrafts: isTreeUpdatedForDrafts }, { loadIsDraftsShownPreference: loadIsDraftsShownPreference, setIsTreeUpdatedForDrafts: setIsTreeUpdatedForDrafts }] = (0, $86L81.useDraftsToggle)();
    const setContent = (0, $eUqFw.useCallback)((spaceKey, rootContentId)=>{
        setSpaceKey(spaceKey);
        setRootContentId(rootContentId || null);
    }, []);
    const setProjectData = (0, $eUqFw.useCallback)((projectId, projectType)=>{
        setProjectId(projectId);
        setProjectType(projectType);
    }, []);
    // use this instead of setItems() that may affect root items to ensure Empty state is updated appropriately
    const updateTree = (0, $eUqFw.useCallback)((items, isRoot)=>{
        if (isRoot) setErrorType(items.length > 0 ? null : (0, $6K8He.Errors).Empty);
        setItems(items);
    }, []);
    const fetchPublishedPagesAndUpdateSubtree = (0, $eUqFw.useCallback)(async (parentContentId, start)=>{
        const isRoot = parentContentId === rootContentId;
        const response = await (0, $8nJSl.fetchPublishedPageTreeItems)(spaceKey, parentContentId, isRoot, start, $bfbe8e9d244fa3b5$export$33eadec77c3a34cd, projectId, projectType);
        let treeItems = response.pageTreeItems;
        if (isDraftsShown) // Inject drafts page tree into the current page tree
        treeItems = await (0, $8nJSl.fetchDraftsPageTreeItems)(spaceKey, parentContentId, $bfbe8e9d244fa3b5$export$33eadec77c3a34cd, projectId, projectType);
        setCanShowMorePages(Boolean(response.next));
        updateTree(treeItems, isRoot);
        (0, $8nJSl.firePageTreeOperationalEvents)({
            eventName: (0, $cSwOk.EventName).SHOWN,
            analyticsAttributes: {
                pageCount: treeItems.length,
                isRoot: isRoot
            },
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        rootContentId,
        spaceKey,
        isDraftsShown,
        updateTree,
        createAnalyticsEvent,
        projectId,
        projectType
    ]);
    const updatePublishedPagesAndSubtree = (0, $eUqFw.useCallback)(async ({ parentContentId: parentContentId, start: start, maxPages: maxPages })=>{
        const isRoot = parentContentId === rootContentId;
        let treeItems = await (0, $8nJSl.updatePublishedPageTreeItems)(spaceKey, parentContentId, isRoot, start, $bfbe8e9d244fa3b5$export$33eadec77c3a34cd, maxPages, projectId, projectType);
        if (isDraftsShown) // Inject drafts page tree into the current page tree
        treeItems = await (0, $8nJSl.fetchDraftsPageTreeItems)(spaceKey, parentContentId, $bfbe8e9d244fa3b5$export$33eadec77c3a34cd, projectId, projectType);
        updateTree(treeItems, isRoot);
        (0, $8nJSl.firePageTreeOperationalEvents)({
            eventName: (0, $cSwOk.EventName).SHOWN,
            analyticsAttributes: {
                pageCount: treeItems.length,
                isRoot: isRoot
            },
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        rootContentId,
        isDraftsShown,
        spaceKey,
        updateTree,
        createAnalyticsEvent,
        projectId,
        projectType
    ]);
    const fetchRootTree = (0, $eUqFw.useCallback)(async ()=>{
        if (rootContentId === null && spaceKey === null) return;
        try {
            await fetchPublishedPagesAndUpdateSubtree(rootContentId, 0);
            setIsTreeUpdatedForDrafts(true);
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            const newErrorState = message.includes('404') ? (0, $6K8He.Errors).Empty : (0, $6K8He.Errors).Error;
            const error = err;
            (0, $8nJSl.firePageTreeOperationalEvents)({
                eventName: (0, $cSwOk.EventName).FAILED,
                analyticsAttributes: {
                    error: typeof error === 'string' ? 'Failed to fetch' : String(error.message),
                    isRoot: true
                },
                createAnalyticsEvent: createAnalyticsEvent
            });
            setErrorType(newErrorState);
        }
    }, [
        rootContentId,
        fetchPublishedPagesAndUpdateSubtree,
        setIsTreeUpdatedForDrafts,
        spaceKey,
        createAnalyticsEvent
    ]);
    const expandSubtree = (0, $eUqFw.useCallback)(async (parentContentId)=>{
        // expand the subtree from the start to reveal the spinner row first
        setItems($bfbe8e9d244fa3b5$export$33eadec77c3a34cd.setIsExpanded(parentContentId, true));
        try {
            await updatePublishedPagesAndSubtree({
                parentContentId: parentContentId,
                start: 0
            });
        } catch (error) {
            (0, $8nJSl.firePageTreeOperationalEvents)({
                eventName: (0, $cSwOk.EventName).FAILED,
                analyticsAttributes: {
                    error: typeof error === 'string' ? 'Failed to fetch' : String(error.message),
                    isRoot: false
                },
                createAnalyticsEvent: createAnalyticsEvent
            });
            setItems($bfbe8e9d244fa3b5$export$33eadec77c3a34cd.markChildError(parentContentId));
            onError?.(error);
        }
        // collapse & prune the subtree if in the end we found no children
        if ($bfbe8e9d244fa3b5$export$33eadec77c3a34cd.getPage(parentContentId)?.children === undefined) setItems($bfbe8e9d244fa3b5$export$33eadec77c3a34cd.pruneSubtree(parentContentId));
    }, [
        updatePublishedPagesAndSubtree,
        onError,
        createAnalyticsEvent
    ]);
    const collapseSubtree = (0, $eUqFw.useCallback)((parentContentId)=>{
        setItems($bfbe8e9d244fa3b5$export$33eadec77c3a34cd.setIsExpanded(parentContentId, false));
    }, []);
    const updatePage = (0, $eUqFw.useCallback)(async (contentId, status)=>{
        try {
            const page = await (0, $4wyem.getPage)(contentId, status, projectId, projectType);
            if (page.status === 'current' || page.status === 'draft' && isDraftsShown) setItems($bfbe8e9d244fa3b5$export$33eadec77c3a34cd.injectPages([
                page
            ]));
            return (0, $7hnEh.getPageTreeItemProperties)(page);
        } catch (error) {
            (0, $8nJSl.firePageTreeOperationalEvents)({
                eventName: (0, $cSwOk.EventName).FAILED,
                analyticsAttributes: {
                    error: typeof error === 'string' ? 'Failed to fetch' : String(error.message),
                    isRoot: false
                },
                createAnalyticsEvent: createAnalyticsEvent
            });
            onError?.(error);
        }
    }, [
        isDraftsShown,
        onError,
        createAnalyticsEvent,
        projectId,
        projectType
    ]);
    const insertPage = (0, $eUqFw.useCallback)(async (contentId, parentContentId)=>{
        try {
            const isRoot = parentContentId === undefined || parentContentId === rootContentId;
            // when inserting a page, we first try to fetch the latest tree
            await updatePublishedPagesAndSubtree({
                parentContentId: parentContentId || rootContentId,
                start: 0,
                // With "show more", we only want to fetch the pages til reaching the ones shown currently
                // We want to add this max cap only if "show more" FF enabled and the fetching is targeting on root level
                maxPages: isRoot ? currentLoadMoreCursor + (0, $4wyem.PAGE_SIZE_LIMIT) : undefined
            });
            // this subtree may not yet contain the new page, so we fetch it directly as well
            const page = await (0, $4wyem.getPage)(contentId, 'draft', projectId, projectType);
            // and inject it into the tree
            if (isDraftsShown) updateTree($bfbe8e9d244fa3b5$export$33eadec77c3a34cd.injectPages([
                page
            ]), isRoot);
            return (0, $7hnEh.getPageTreeItemProperties)(page);
        } catch (error) {
            (0, $8nJSl.firePageTreeOperationalEvents)({
                eventName: (0, $cSwOk.EventName).FAILED,
                analyticsAttributes: {
                    error: typeof error === 'string' ? 'Failed to fetch' : String(error.message),
                    isRoot: parentContentId === undefined
                },
                createAnalyticsEvent: createAnalyticsEvent
            });
            onError?.(error);
        }
    }, [
        updatePublishedPagesAndSubtree,
        isDraftsShown,
        onError,
        rootContentId,
        updateTree,
        currentLoadMoreCursor,
        createAnalyticsEvent,
        projectId,
        projectType
    ]);
    const removePage = (0, $eUqFw.useCallback)(async (contentId)=>{
        const page = $bfbe8e9d244fa3b5$export$33eadec77c3a34cd.getPage(contentId);
        const isRoot = page?.parent === undefined;
        try {
            // try to update the tree, which may reflect the latest changes like child pages shifting up to parent
            await updatePublishedPagesAndSubtree({
                parentContentId: page?.parent?.id || rootContentId,
                start: 0,
                // With "show more", we only want to fetch the pages til reaching the ones shown currently
                // We want to add this max cap only if "show more" FF enabled and the fetching is targeting on root level
                maxPages: isRoot ? currentLoadMoreCursor + (0, $4wyem.PAGE_SIZE_LIMIT) : undefined
            });
            // forcibly remove page from tree if for some reason it is still in the tree
            updateTree($bfbe8e9d244fa3b5$export$33eadec77c3a34cd.removePage(contentId), page?.parent === undefined);
            // collapse & prune the subtree if this was the last child page
            if (page?.parent && page?.parent.children === undefined) setItems($bfbe8e9d244fa3b5$export$33eadec77c3a34cd.pruneSubtree(page.parent.id));
        } catch (error) {
            (0, $8nJSl.firePageTreeOperationalEvents)({
                eventName: (0, $cSwOk.EventName).FAILED,
                analyticsAttributes: {
                    error: typeof error === 'string' ? 'Failed to fetch' : String(error.message),
                    isRoot: page?.parent === undefined
                },
                createAnalyticsEvent: createAnalyticsEvent
            });
            onError?.(error);
        }
    }, [
        updatePublishedPagesAndSubtree,
        onError,
        rootContentId,
        updateTree,
        currentLoadMoreCursor,
        createAnalyticsEvent
    ]);
    const fetchAndShowDraftsPage = (0, $eUqFw.useCallback)(()=>{
        (0, $8nJSl.fetchDraftsPageTreeItems)(spaceKey, rootContentId, $bfbe8e9d244fa3b5$export$33eadec77c3a34cd, projectId, projectType).then((draftsPageTreeItems)=>{
            updateTree(draftsPageTreeItems, true);
            setIsTreeUpdatedForDrafts(true);
        });
    }, [
        spaceKey,
        rootContentId,
        updateTree,
        setIsTreeUpdatedForDrafts,
        projectId,
        projectType
    ]);
    // initialise the drafts toggle preference on mount
    (0, $eUqFw.useEffect)(()=>{
        loadIsDraftsShownPreference(accountId);
    }, [
        loadIsDraftsShownPreference,
        accountId
    ]);
    // initial load: load the page tree when we don't have a page tree
    (0, $eUqFw.useEffect)(()=>{
        if (isDraftsShown === null) // don't start fetching until draft setting is loaded
        return;
        if (items === null) fetchRootTree();
    }, [
        isDraftsShown,
        items,
        setIsTreeUpdatedForDrafts,
        fetchRootTree,
        projectId,
        projectType
    ]);
    // handle fetching/purging drafts in page tree when the toggle setting changes
    (0, $eUqFw.useEffect)(()=>{
        if (items === null) return;
        if (isTreeUpdatedForDrafts === false) {
            setIsTreeUpdatedForDrafts(null); // put it in a loading state so we don't retrigger it
            if (isDraftsShown) fetchAndShowDraftsPage();
            else {
                const updatedTree = $bfbe8e9d244fa3b5$export$33eadec77c3a34cd.purgeDrafts();
                if (updatedTree.length === 0) setErrorType((0, $6K8He.Errors).Empty);
                updateTree(updatedTree, true);
                setIsTreeUpdatedForDrafts(true);
            }
        }
    }, [
        isDraftsShown,
        items,
        isTreeUpdatedForDrafts,
        setIsTreeUpdatedForDrafts,
        updateTree,
        fetchAndShowDraftsPage,
        fetchRootTree
    ]);
    // if spaceKey or contentId changes, reload
    (0, $eUqFw.useEffect)(()=>{
        setErrorType(null);
        setItems(null);
        $bfbe8e9d244fa3b5$export$33eadec77c3a34cd.init(rootContentId);
    }, [
        spaceKey,
        rootContentId
    ]);
    // tree state is an entirely derived var
    let treeState = (0, $6K8He.TreeStates).Loading;
    if (errorType === (0, $6K8He.Errors).Empty) treeState = (0, $6K8He.TreeStates).Empty;
    else if (errorType === (0, $6K8He.Errors).Error) treeState = (0, $6K8He.TreeStates).Error;
    else if (items && items.length > 0) treeState = (0, $6K8He.TreeStates).RenderedChildren;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a9Brc.ConfluencePageTreeContext).Provider, {
        value: {
            treeState: treeState,
            spaceKey: spaceKey,
            errorType: errorType,
            rootContentId: rootContentId,
            accountId: accountId,
            items: items,
            setContent: setContent,
            expandSubtree: expandSubtree,
            collapseSubtree: collapseSubtree,
            insertPage: insertPage,
            updatePage: updatePage,
            removePage: removePage,
            canShowMorePages: canShowMorePages,
            showMorePages: async ()=>{
                await fetchPublishedPagesAndUpdateSubtree(rootContentId, currentLoadMoreCursor + (0, $4wyem.PAGE_SIZE_LIMIT));
                setCurrentLoadMoreCursor((prev)=>prev + (0, $4wyem.PAGE_SIZE_LIMIT));
            },
            setProjectData: setProjectData,
            projectId: projectId,
            projectType: projectType
        }
    }, children);
};
const $bfbe8e9d244fa3b5$export$bc80c2f90a0a10c6 = ({ analyticsClient: analyticsClient, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfG2L.AnalyticsProvider), {
        // @ts-expect-error - Type 'AnalyticsWebClient' is missing the following properties from type 'AnalyticsWebClient': _apdexEvent, _context, eventDelayQueue, _historyReplaceFn, and 61 more
        analyticsClient: analyticsClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bfbe8e9d244fa3b5$export$274a9a2a3c6432ca, props));

});
parcelRegister("4wyem", function(module, exports) {

$parcel$export(module.exports, "getPage", () => $371fbd28b524ae48$export$c2a6433281518c91);
$parcel$export(module.exports, "getDrafts", () => $371fbd28b524ae48$export$d705ef743e424c06);
$parcel$export(module.exports, "PAGE_SIZE_LIMIT", () => $371fbd28b524ae48$export$43637df0ace5ee44);
$parcel$export(module.exports, "getChildrenWithNextUrl", () => $371fbd28b524ae48$export$6a3613429c451655);
$parcel$export(module.exports, "getChildren", () => $371fbd28b524ae48$export$f8cf48ee793b41be);
const $371fbd28b524ae48$var$fetchOptions = (projectId, projectType)=>({
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true',
            'X-Atl-EmbeddablePage-EntityIDs': JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        },
        credentials: 'same-origin'
    });
const $371fbd28b524ae48$export$8f665cf65eb666bb = [
    'childTypes.page',
    'history.contributors.publishers.users',
    'history.lastUpdated',
    'metadata.frontend.collabService'
];
const $371fbd28b524ae48$export$83c877457e95cd21 = [
    'childTypes.page',
    'metadata.frontend.collabService',
    'version',
    'version.collaborators.users',
    'extensions',
    'ancestors'
];
const $371fbd28b524ae48$var$SEARCH_API_URL = '/wiki/rest/api/content/search';
const $371fbd28b524ae48$var$ANCESTOR = 'ancestor';
const $371fbd28b524ae48$var$SPACE = 'space';
const $371fbd28b524ae48$var$draftSearchParams = (primaryType, primaryId, limit, start)=>new URLSearchParams({
        cql: `${primaryType}="${primaryId}" AND type in (page)`,
        cqlcontext: '{"contentStatuses":["draft"]}',
        limit: `${limit}`,
        start: `${start}`,
        expand: $371fbd28b524ae48$export$83c877457e95cd21.join(',')
    }).toString();
const $371fbd28b524ae48$var$constructChildPagesResponseFromSpaceContentResponse = ({ page: page, _links: _links })=>({
        ...page,
        _links: _links
    });
const $371fbd28b524ae48$var$injectLinksBase = (page, base)=>({
        ...page,
        _links: {
            ...page._links,
            base: base
        }
    });
const $371fbd28b524ae48$var$normaliseSearchResult = (page)=>{
    const { version: { friendlyWhen: friendlyWhen, number: number, collaborators: { users: users } } } = page;
    return {
        ...page,
        history: {
            contributors: {
                publishers: {
                    users: users
                }
            },
            lastUpdated: {
                friendlyWhen: friendlyWhen,
                number: number
            }
        }
    };
};
const $371fbd28b524ae48$var$injectLinksBaseToChildPagesResponse = ({ results: results, _links: { base: base } })=>results.map((page)=>$371fbd28b524ae48$var$injectLinksBase(page, base));
const $371fbd28b524ae48$var$statusSortValues = {
    current: 0,
    draft: 1
};
const $371fbd28b524ae48$var$typeSortValues = {
    number: 0,
    string: 1
};
const $371fbd28b524ae48$var$compareByIdStatusAndPosition = ({ id: idA, status: statusA, extensions: { position: positionA } }, { id: idB, status: statusB, extensions: { position: positionB } })=>{
    // If they have the same id, they are the same page
    if (idA === idB) return 0;
    const statusSort = $371fbd28b524ae48$var$statusSortValues[statusA] - $371fbd28b524ae48$var$statusSortValues[statusB];
    // We show drafts after published pages
    if (statusSort !== 0) return statusSort;
    const typeSort = $371fbd28b524ae48$var$typeSortValues[typeof positionA] - $371fbd28b524ae48$var$typeSortValues[typeof positionB];
    // We get the string "none" in the position field, which should be sorted under the numerical values
    if (typeSort !== 0) return typeSort;
    //
    if (typeof positionA === 'number' && typeof positionB === 'number') return positionA - positionB;
    // Try to parse the id's to numbers and compare them, other wise keep the original sort order
    return parseInt(idA) - parseInt(idB) || 1;
};
const $371fbd28b524ae48$var$getChildrenForTypeWithDrafts = async (primaryType, primaryId, limit, projectId, projectType)=>primaryId !== null && await $371fbd28b524ae48$var$recursivelyFetchPages(limit, (start, limit)=>$371fbd28b524ae48$var$searchChildPagesWithDrafts(primaryType, primaryId, start, limit, projectId, projectType), ({ results: results, _links: { base: base } })=>results.filter((page)=>page.status === 'draft').map((page)=>$371fbd28b524ae48$var$injectLinksBase($371fbd28b524ae48$var$normaliseSearchResult(page), base)).sort($371fbd28b524ae48$var$compareByIdStatusAndPosition), 0);
const $371fbd28b524ae48$var$recursiveFetch = ({ currentFetch: currentFetch, terminatingFn: terminatingFn, getNextFetch: getNextFetch, getResults: getResults, accumulator: accumulator = [], maxCap: maxCap })=>currentFetch.then((response)=>{
        const results = getResults(response);
        const mergedResult = [
            ...accumulator,
            ...results
        ];
        const hasReachedMaxCap = maxCap === undefined ? false : mergedResult.length >= maxCap;
        return terminatingFn(response) || hasReachedMaxCap ? Promise.resolve(mergedResult) : $371fbd28b524ae48$var$recursiveFetch({
            currentFetch: getNextFetch(response),
            terminatingFn: terminatingFn,
            getNextFetch: getNextFetch,
            getResults: getResults,
            accumulator: mergedResult,
            maxCap: maxCap
        });
    });
const $371fbd28b524ae48$var$handleFetchResponse = (response)=>{
    if (response.ok) return response.json();
    throw new Error(`API responded with failure HTTP code: ${response.status}`);
};
const $371fbd28b524ae48$var$fetchPages = async (url, projectId, projectType)=>{
    const response = await fetch(url, $371fbd28b524ae48$var$fetchOptions(projectId, projectType));
    return $371fbd28b524ae48$var$handleFetchResponse(response);
};
const $371fbd28b524ae48$export$c2a6433281518c91 = async (contentId, status, projectId, projectType)=>{
    const page = await $371fbd28b524ae48$var$fetchPages(`/wiki/rest/api/content/${contentId}?${new URLSearchParams({
        status: status,
        expand: $371fbd28b524ae48$export$83c877457e95cd21.join(',')
    }).toString()}`, projectId, projectType);
    return $371fbd28b524ae48$var$normaliseSearchResult(page);
};
const $371fbd28b524ae48$var$searchChildPagesWithDrafts = async (primaryType, primaryId, start, limit, projectId, projectType)=>{
    return $371fbd28b524ae48$var$fetchPages(`${$371fbd28b524ae48$var$SEARCH_API_URL}?${$371fbd28b524ae48$var$draftSearchParams(primaryType, primaryId, limit, start)}`, projectId, projectType);
};
const $371fbd28b524ae48$var$fetchChildPages = async (contentId, start, limit, projectId, projectType)=>{
    const path = `/wiki/rest/api/content/${contentId}/child/page`;
    const params = `limit=${limit}&start=${start}&expand=${$371fbd28b524ae48$export$8f665cf65eb666bb.join(',')}`;
    return $371fbd28b524ae48$var$fetchPages(`${path}?${params}`, projectId, projectType);
};
const $371fbd28b524ae48$var$fetchRootPages = async (spaceKey, start, limit, projectId, projectType)=>{
    const path = `/wiki/rest/api/space/${spaceKey}/content`;
    const params = `limit=${limit}&start=${start}&expand=${$371fbd28b524ae48$export$8f665cf65eb666bb.join(',')}&depth=root`;
    const pages = await $371fbd28b524ae48$var$fetchPages(`${path}?${params}`, projectId, projectType);
    return $371fbd28b524ae48$var$constructChildPagesResponseFromSpaceContentResponse(pages);
};
const $371fbd28b524ae48$var$recursivelyFetchPages = (limit, fetchFunction, resultTransformations, start, maxCap)=>$371fbd28b524ae48$var$recursiveFetch({
        currentFetch: fetchFunction(start, limit),
        terminatingFn: ({ size: size, limit: returnedLimit })=>{
            // although we specify a limit, the service may have a lower limit than our specified one and we should use that as source of truth
            // calls to /wiki/rest/api/space/:spaceKey/content and /wiki/rest/api/content/:contentId/child/page do support 200 results (our default limit)
            // but /wiki/rest/api/content/search only supports up to 100 results even if we specify a higher limit
            return size < returnedLimit;
        },
        getNextFetch: ({ start: start, limit: returnedLimit })=>fetchFunction(start + returnedLimit, returnedLimit),
        getResults: resultTransformations,
        maxCap: maxCap
    });
const $371fbd28b524ae48$var$getChildrenForSpace = async (spaceKey, limit, start, maxCap, projectId, projectType)=>spaceKey !== null && await $371fbd28b524ae48$var$recursivelyFetchPages(limit, (start, limit)=>$371fbd28b524ae48$var$fetchRootPages(spaceKey, start, limit, projectId, projectType), $371fbd28b524ae48$var$injectLinksBaseToChildPagesResponse, start, maxCap);
const $371fbd28b524ae48$var$getChildrenForPage = async (contentId, limit, start, maxCap, projectId, projectType)=>contentId !== null && await $371fbd28b524ae48$var$recursivelyFetchPages(limit, (start, limit)=>$371fbd28b524ae48$var$fetchChildPages(contentId, start, limit, projectId, projectType), $371fbd28b524ae48$var$injectLinksBaseToChildPagesResponse, start, maxCap);
const $371fbd28b524ae48$export$d705ef743e424c06 = async (spaceKey, contentId, projectId, projectType)=>{
    const limit = 200;
    // either fetch child pages of a given page, or fetch all root pages of the space
    const childPages = await $371fbd28b524ae48$var$getChildrenForTypeWithDrafts($371fbd28b524ae48$var$ANCESTOR, contentId, limit, projectId, projectType) || await $371fbd28b524ae48$var$getChildrenForTypeWithDrafts($371fbd28b524ae48$var$SPACE, spaceKey, limit, projectId, projectType) || [];
    if (childPages.length === 0) return [];
    return childPages;
};
const $371fbd28b524ae48$export$43637df0ace5ee44 = 200;
const $371fbd28b524ae48$export$6a3613429c451655 = async (spaceKey, contentId, start, projectId, projectType)=>{
    const response = await $371fbd28b524ae48$var$getChildrenForPageWithNextUrl(contentId, $371fbd28b524ae48$export$43637df0ace5ee44, start, projectId, projectType) || await $371fbd28b524ae48$var$getChildrenForSpaceWithNextUrl(spaceKey, $371fbd28b524ae48$export$43637df0ace5ee44, start, projectId, projectType);
    if (!response || response.pages?.length === 0) return {};
    return {
        pages: response.pages.filter((childPage)=>childPage.status === 'current'),
        next: response.next
    };
};
const $371fbd28b524ae48$var$getChildrenForSpaceWithNextUrl = async (spaceKey, limit, start, projectId, projectType)=>spaceKey !== null && $371fbd28b524ae48$var$transformResponseWithNextUrl(await $371fbd28b524ae48$var$fetchRootPages(spaceKey, start, limit, projectId, projectType));
const $371fbd28b524ae48$var$getChildrenForPageWithNextUrl = async (contentId, limit, start, projectId, projectType)=>contentId !== null && $371fbd28b524ae48$var$transformResponseWithNextUrl(await $371fbd28b524ae48$var$fetchChildPages(contentId, start, limit, projectId, projectType));
const $371fbd28b524ae48$var$transformResponseWithNextUrl = ({ results: results, _links: { base: base, next: next } })=>({
        pages: results.map((page)=>$371fbd28b524ae48$var$injectLinksBase(page, base)),
        next: next
    });
const $371fbd28b524ae48$export$f8cf48ee793b41be = async (spaceKey, contentId, limit, start, maxCap, projectId, projectType)=>{
    // either fetch child pages of a given page, or fetch all root pages of the space
    const childPages = await $371fbd28b524ae48$var$getChildrenForPage(contentId, limit, start, maxCap, projectId, projectType) || await $371fbd28b524ae48$var$getChildrenForSpace(spaceKey, limit, start, maxCap, projectId, projectType) || [];
    if (childPages.length === 0) return [];
    return childPages.filter((childPage)=>childPage.status === 'current');
};

});

parcelRegister("cSwOk", function(module, exports) {

$parcel$export(module.exports, "EventName", () => $211e49ec6262e9dd$export$8e49444f78fbbdb8);
var $211e49ec6262e9dd$export$8e49444f78fbbdb8;
(function(EventName) {
    EventName["SHOWN"] = "shown";
    EventName["FAILED"] = "failed";
})($211e49ec6262e9dd$export$8e49444f78fbbdb8 || ($211e49ec6262e9dd$export$8e49444f78fbbdb8 = {}));

});

parcelRegister("8nJSl", function(module, exports) {

$parcel$export(module.exports, "firePageTreeOperationalEvents", () => $bc2e68acc1a31add$export$65824eb1735a8662);
$parcel$export(module.exports, "updatePublishedPageTreeItems", () => $bc2e68acc1a31add$export$811ad7ec06276acb);
$parcel$export(module.exports, "fetchPublishedPageTreeItems", () => $bc2e68acc1a31add$export$4f93abb356bf34d2);
$parcel$export(module.exports, "fetchDraftsPageTreeItems", () => $bc2e68acc1a31add$export$2c036ac8969eb3b0);

var $4wyem = parcelRequire("4wyem");

var $gWxA1 = parcelRequire("gWxA1");
const $bc2e68acc1a31add$export$65824eb1735a8662 = ({ eventName: eventName, analyticsAttributes: analyticsAttributes, createAnalyticsEvent: createAnalyticsEvent })=>{
    if (createAnalyticsEvent) (0, $gWxA1.fireOperationalAnalytics)(createAnalyticsEvent({}), `confluencePageTree ${eventName}`, analyticsAttributes);
};
const $bc2e68acc1a31add$export$811ad7ec06276acb = async (spaceKey, parentContentId, isRoot, start, tableTreeData, maxPages, projectId, projectType)=>{
    const publishedPages = await (0, $4wyem.getChildren)(spaceKey, parentContentId, (0, $4wyem.PAGE_SIZE_LIMIT), start, maxPages, projectId, projectType);
    const pageTreeItems = tableTreeData.updateChildPages(publishedPages, isRoot ? undefined : parentContentId || undefined);
    return pageTreeItems;
};
const $bc2e68acc1a31add$export$4f93abb356bf34d2 = async (spaceKey, parentContentId, isRoot, start, tableTreeData, projectId, projectType)=>{
    const { pages: publishedPages, next: next } = await (0, $4wyem.getChildrenWithNextUrl)(spaceKey, parentContentId, start, projectId, projectType);
    const pageTreeItems = tableTreeData.apppendChildPages(publishedPages ?? [], isRoot ? undefined : parentContentId || undefined);
    return {
        pageTreeItems: pageTreeItems,
        next: next
    };
};
const $bc2e68acc1a31add$export$2c036ac8969eb3b0 = async (spaceKey, parentContentId, tableTreeData, projectId, projectType)=>{
    const drafts = await (0, $4wyem.getDrafts)(spaceKey, parentContentId, projectId, projectType);
    return tableTreeData.injectPages(drafts);
};

});



parcelRegister("kqxVx", function(module, exports) {

$parcel$export(module.exports, "useProjectPages", () => $cad6315075e2db8f$export$bb347a8713b896e6);
$parcel$export(module.exports, "ProjectPagesProvider", () => $cad6315075e2db8f$export$8582af416d6f689b);

var $eUqFw = parcelRequire("eUqFw");


const $cad6315075e2db8f$var$ProjectPagesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    accountId: '',
    locale: (0, $32df593be34bd00e$export$d7f512c98c859244),
    cloudId: '',
    parentProduct: (0, $4f13ed7939f15d31$export$ae07618062047a87),
    environment: 'dev'
});
const $cad6315075e2db8f$export$bb347a8713b896e6 = ()=>(0, $eUqFw.useContext)($cad6315075e2db8f$var$ProjectPagesContext);
const $cad6315075e2db8f$export$8582af416d6f689b = $cad6315075e2db8f$var$ProjectPagesContext.Provider;

});
const $4f13ed7939f15d31$export$ae07618062047a87 = 'JSW';
const $4f13ed7939f15d31$export$2c5916240ec6ec9e = 'JWM';

const $32df593be34bd00e$export$d7f512c98c859244 = 'en_US';


parcelRegister("hFx9Z", function(module, exports) {

$parcel$export(module.exports, "PageTreePlaceholder", () => $6fddeb0377fcfe8a$export$a31f8fba1571ae1c);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("hPmJU");
var $6K8He = parcelRequire("6K8He");

var $jVr6p = parcelRequire("jVr6p");

var $iTfWt = parcelRequire("iTfWt");

var $h5ZmY = parcelRequire("h5ZmY");
const $6fddeb0377fcfe8a$export$a31f8fba1571ae1c = ({ treeState: treeState })=>{
    switch(treeState){
        case (0, $6K8He.TreeStates).Empty:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVr6p.default), null);
        case (0, $6K8He.TreeStates).Error:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iTfWt.default), null);
        case (0, $6K8He.TreeStates).Loading:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h5ZmY.PageTreeSkeleton), null);
        default:
            return null;
    }
};

});
parcelRegister("jVr6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd472c84e1adcc99$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $h8R7H = parcelRequire("h8R7H");

var $4aXoz = parcelRequire("4aXoz");

var $baKYD = parcelRequire("baKYD");

var $jGyKS = parcelRequire("jGyKS");
const $cd472c84e1adcc99$var$mapStateToProps = (state)=>({
        spaceKey: (0, $4aXoz.getProjectSpaceKey)(state),
        contentId: (0, $4aXoz.getProjectPageLinkedId)(state),
        isConfluenceAutoProvisioned: (0, $baKYD.isConfluenceAutoProvisioned)(state),
        projectId: (0, $jGyKS.getProjectId)(state),
        projectType: (0, $jGyKS.getProjectType)(state)
    });
var $cd472c84e1adcc99$export$2e2bcd8739ae039 = (0, $cllCv.connect)($cd472c84e1adcc99$var$mapStateToProps)((0, $h8R7H.default));

});
parcelRegister("h8R7H", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e70df069465aeb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $iuoIG = parcelRequire("iuoIG");

var $56QQi = parcelRequire("56QQi");

var $6Fj9A = parcelRequire("6Fj9A");
const $b1e70df069465aeb$var$EmptyState = ({ intl: intl, spaceKey: spaceKey, contentId: contentId, isConfluenceAutoProvisioned: isConfluenceAutoProvisioned = false })=>isConfluenceAutoProvisioned ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iuoIG.default), {
        intl: intl,
        spaceKey: spaceKey,
        contentId: contentId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56QQi.default), {
        intl: intl,
        spaceKey: spaceKey,
        contentId: contentId,
        description: (0, $6Fj9A.default).description,
        primaryActionMessage: (0, $6Fj9A.default).createFirstPageButton
    });
var $b1e70df069465aeb$export$2e2bcd8739ae039 = (0, $2qhQi.default)($b1e70df069465aeb$var$EmptyState);

});
parcelRegister("iuoIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d22f1d4b3f57ab91$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6Fj9A = parcelRequire("6Fj9A");

var $fI650 = parcelRequire("fI650");


var $56QQi = parcelRequire("56QQi");

var $dWs8I = parcelRequire("dWs8I");

var $gWxA1 = parcelRequire("gWxA1");

var $bFzGY = parcelRequire("bFzGY");
const $d22f1d4b3f57ab91$var$AutoProvisionedConfluenceEmptyState = ({ intl: intl, spaceKey: spaceKey, contentId: contentId, isProjectPagesSporkRebrandingEnabled: isProjectPagesSporkRebrandingEnabled })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $gWxA1.fireScreenAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubjectId: 'autoProvisionedConfluenceEmptyState'
        }));
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56QQi.default), {
        intl: intl,
        spaceKey: spaceKey,
        contentId: contentId,
        description: (0, $6Fj9A.default).confluenceAutoProvisionedDescription,
        primaryActionMessage: (0, $6Fj9A.default).createPageButton,
        pageContent: {
            title: intl.formatMessage((0, $6Fj9A.default).tutorialPageName),
            body: (0, $dWs8I.getTutorialContent)(intl, isProjectPagesSporkRebrandingEnabled)
        },
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
            appearance: "subtle",
            target: "_blank",
            href: (0, $147e706095c3617f$export$eebcff9497e6f75c),
            testId: "confluence-project-pages.empty-state.learn-more-button",
            onClick: ()=>{
                (0, $gWxA1.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link',
                    source: 'confluencePageTreeEmptyStateLearnMoreButton',
                    actionSubjectId: 'howToUseConfluenceDocumentationLink'
                }));
            }
        }, intl.formatMessage((0, $6Fj9A.default).learnMoreButton))
    });
};
var $d22f1d4b3f57ab91$export$2e2bcd8739ae039 = $d22f1d4b3f57ab91$var$AutoProvisionedConfluenceEmptyState;

});
parcelRegister("6Fj9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ffcf63c4867c864$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6ffcf63c4867c864$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        id: 'project-pages.improvement.transient-states.empty-state.title',
        defaultMessage: "There\u2019s nothing here but potential",
        description: 'Title of message letting users know there are no pages'
    },
    description: {
        id: 'project-pages.improvement.transient-states.empty-state.description',
        defaultMessage: 'Create some meeting notes, product requirements, decisions, or other content to see this space fill up.',
        description: 'Description text letting users know there are no pages'
    },
    confluenceAutoProvisionedDescription: {
        id: 'project-pages.improvement.transient-states.empty-state.auto-provisioned-description',
        defaultMessage: "We\u2019ve added Confluence so you can start creating and linking all your project documents. It\u2019s free for up to 10 users.",
        description: 'Description text letting users know Confluence has been auto provisioned'
    },
    createFirstPageButton: {
        id: 'project-pages.improvement.transient-states.empty-state.create-page-button',
        defaultMessage: 'Create your first page',
        description: 'Button label for creating a new first page'
    },
    createPageButton: {
        id: 'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button',
        defaultMessage: 'Create page',
        description: 'Button label for creating a new page'
    },
    learnMoreButton: {
        id: 'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button',
        defaultMessage: 'Learn more',
        description: 'Label for link to Confluence guides, tutorials and demos'
    },
    tutorialPageName: {
        id: 'project-pages.improvement.templates.tutorial.name',
        defaultMessage: 'Welcome to Project Pages!',
        description: 'Title of the tutorial page'
    }
});

});

const $147e706095c3617f$export$eebcff9497e6f75c = 'https://www.atlassian.com/software/confluence/guides';

parcelRegister("56QQi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b44709384270f78f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $6Fj9A = parcelRequire("6Fj9A");

var $ekeOb = parcelRequire("ekeOb");

var $6zOB7 = parcelRequire("6zOB7");

var $iCgZp = parcelRequire("iCgZp");

var $gWxA1 = parcelRequire("gWxA1");
const $b44709384270f78f$var$BaseEmptyState = ({ intl: { formatMessage: formatMessage }, spaceKey: spaceKey, contentId: contentId, description: description, primaryActionMessage: primaryActionMessage, pageContent: pageContent, secondaryAction: secondaryAction = null, projectId: projectId, projectType: projectType })=>{
    const createEmbeddedPage = (0, $iCgZp.useCreateEmbeddedPage)({
        spaceKey: spaceKey,
        projectId: projectId,
        projectType: projectType
    });
    const handleClick = (0, $eUqFw.useCallback)(async (_, analyticsEvent)=>{
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'confluencePageTreeEmptyStateCreateButton');
        await createEmbeddedPage(contentId || undefined, true, undefined, pageContent);
    }, [
        contentId,
        pageContent,
        createEmbeddedPage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ekeOb))),
        imageWidth: 160,
        description: formatMessage(description),
        header: formatMessage((0, $6Fj9A.default).title),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            appearance: "primary",
            onClick: handleClick,
            testId: "confluence-project-pages.empty-state.create-page-button"
        }, formatMessage(primaryActionMessage)),
        secondaryAction: secondaryAction
    });
};
var $b44709384270f78f$export$2e2bcd8739ae039 = $b44709384270f78f$var$BaseEmptyState;

});
parcelRegister("ekeOb", function(module, exports) {
module.exports = new URL("play-button-pages.233781be.svg", import.meta.url).toString();

});

parcelRegister("iCgZp", function(module, exports) {

$parcel$export(module.exports, "useCreateEmbeddedPage", () => $aaff60524de12d34$export$e578e124f061619f);

var $bFzGY = parcelRequire("bFzGY");

var $gWxA1 = parcelRequire("gWxA1");

var $bgrIS = parcelRequire("bgrIS");
parcelRequire("hPmJU");
var $1QBZx = parcelRequire("1QBZx");
var $a9Brc = parcelRequire("a9Brc");

var $eUqFw = parcelRequire("eUqFw");

var $4iCLc = parcelRequire("4iCLc");

var $i4JmU = parcelRequire("i4JmU");
const $aaff60524de12d34$export$e578e124f061619f = ({ spaceKey: spaceKey, projectId: projectId, projectType: projectType })=>{
    const { setEmbeddedPage: setEmbeddedPage } = (0, $4iCLc.useEmbeddedPage)();
    const { insertPage: insertPage } = (0, $a9Brc.useConfluencePageTree)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(async (parentContentId, isRoot, blueprint, content)=>{
        if (spaceKey) {
            setEmbeddedPage({
                mode: 'edit',
                isOpen: true,
                isLoading: true,
                page: null,
                pageCreate: {
                    error: null,
                    parentContentId: parentContentId,
                    isRoot: isRoot,
                    blueprint: blueprint
                }
            });
            try {
                let contentId;
                let isLive = false;
                let status;
                if (blueprint?.contentBlueprintId) {
                    const response = await (0, $i4JmU.createConfluenceDraft)({
                        projectSpaceKey: spaceKey,
                        projectPageLinkedId: parentContentId || null,
                        templateId: blueprint.contentBlueprintId,
                        isEmbeddedPage: true,
                        projectId: projectId,
                        projectType: projectType
                    });
                    contentId = response.content.id;
                    isLive = response.content.subType === 'live';
                    status = response.content.status;
                } else {
                    const response = await (0, $bgrIS.createContent)({
                        spaceKey: spaceKey,
                        parentPageId: parentContentId,
                        parentProduct: projectType,
                        parentProductContentContainerId: projectId?.toString(),
                        body: content?.body ? {
                            storage: {
                                value: content.body,
                                representation: 'storage'
                            }
                        } : undefined,
                        title: content?.title
                    });
                    contentId = response.contentId;
                    isLive = response.subType === 'live';
                    status = response.status;
                }
                if (contentId) {
                    setEmbeddedPage({
                        mode: isLive ? 'view' : 'edit',
                        page: {
                            id: contentId,
                            url: `/wiki/spaces/${spaceKey}/pages/${contentId}`,
                            editUrl: '',
                            hasEmbeddedEdit: true,
                            isDraft: status === 'draft',
                            isLive: isLive,
                            type: (0, $1QBZx.ContentType).PAGE
                        }
                    });
                    (0, $gWxA1.fireTrackAnalytics)(createAnalyticsEvent({}), 'embeddedPageDraft created', {
                        template: blueprint?.name || 'blank',
                        embeddedPageAction: true,
                        hasContent: Boolean(content)
                    });
                    try {
                        await insertPage(contentId, parentContentId);
                    } catch  {
                    // ignore error
                    }
                } else throw new Error('createContent returned undefined contentId');
            } catch (error) {
                setEmbeddedPage({
                    page: null,
                    isLoading: false,
                    pageCreate: {
                        error: error instanceof Error ? error : null,
                        parentContentId: parentContentId,
                        isRoot: isRoot,
                        blueprint: blueprint
                    }
                });
                (0, $gWxA1.fireOperationalAnalytics)(createAnalyticsEvent({}), 'createEmbeddedPageDraft failed', {
                    template: blueprint?.name || 'blank',
                    embeddedPageAction: true,
                    errorMessage: String(error) || 'Unknown error',
                    hasContent: Boolean(content)
                });
                return;
            }
        }
    }, [
        createAnalyticsEvent,
        insertPage,
        setEmbeddedPage,
        spaceKey,
        projectId,
        projectType
    ]);
};

});
parcelRegister("bgrIS", function(module, exports) {

$parcel$export(module.exports, "createContent", () => $c713a5698918f511$export$41c7a4cacf5bab80);
/**
 * This function would be used by Embedding product to create Confluence Content. Content created by this function will be tagged with "embedded" flag.
 * At the moment we only support creating a blank page and does not support cross domain request (Parent Product must be in same domain as Confluence)
 * To enable unlicensed user to create a page, parentProduct & parentProductContentContainerId are required.
 */ 
var $2GDCE = parcelRequire("2GDCE");
const $c713a5698918f511$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS = [
    'parentProduct',
    'parentProductContentContainerId',
    'spaceKey'
];
const $c713a5698918f511$export$4de094b68e927f31 = 'X-Atl-EmbeddablePage-EntityIDs';
const $c713a5698918f511$export$41c7a4cacf5bab80 = async ({ spaceKey: spaceKey, parentPageId: parentPageId, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, domain: domain = '', title: title, body: body })=>{
    const payload = {
        type: 'page',
        status: 'draft',
        metadata: {
            properties: {
                editor: {
                    value: 'v2'
                }
            },
            frontend: {
                embedded: true
            }
        },
        space: {
            key: spaceKey
        },
        title: title,
        body: body
    };
    if (parentPageId) payload.ancestors = [
        {
            id: parentPageId
        }
    ];
    const baseurl = domain ? `https://${domain}` : domain;
    const unlicensedAccessHeader = $c713a5698918f511$var$getUnlicensedAccessHeader({
        parentProduct: parentProduct,
        parentProductContentContainerId: parentProductContentContainerId,
        spaceKey: spaceKey
    });
    let response;
    try {
        response = await fetch(`${baseurl}/wiki/rest/api/content`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                credentials: 'include',
                ...unlicensedAccessHeader
            },
            body: JSON.stringify(payload)
        });
    } catch (e) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
        // Promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side else resolve
        throw new Error(`Network failure ${e}`);
    }
    const responseJson = await response.json();
    if (!response.ok) throw new (0, $2GDCE.CreateError)(`Status: ${responseJson.statusCode} Message: ${responseJson.message}`, responseJson.statusCode);
    return {
        draftShareId: $c713a5698918f511$var$getDraftShareId(responseJson),
        spaceKey: responseJson?.space?.key,
        contentId: responseJson?.id,
        status: responseJson?.status,
        subType: responseJson?.subType
    };
};
const $c713a5698918f511$var$getDraftShareId = (data)=>(data?._links?.editui || '').match(/draftShareId=(.*?)(#|&|$)/)?.[1] || undefined;
const $c713a5698918f511$var$getUnlicensedAccessHeader = ({ parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, spaceKey: spaceKey })=>{
    const headerValue = {
        parentProduct: parentProduct,
        parentProductContentContainerId: parentProductContentContainerId,
        spaceKey: spaceKey
    };
    const isValidHeader = $c713a5698918f511$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS.every((key)=>Boolean(headerValue[key]));
    return isValidHeader ? {
        [$c713a5698918f511$export$4de094b68e927f31]: JSON.stringify(headerValue)
    } : undefined;
};

});
parcelRegister("2GDCE", function(module, exports) {

$parcel$export(module.exports, "CreateError", () => $6bfe30688a197e5f$export$91ee1703d5a5ab8b);
class $6bfe30688a197e5f$export$91ee1703d5a5ab8b extends Error {
    constructor(message, statusCode){
        super(message);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("4iCLc", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPage", () => $551f8ba7184e33c7$export$723f81cacfb30bb4);
$parcel$export(module.exports, "EmbeddedPageProvider", () => $551f8ba7184e33c7$export$db7a10e5d0439504);

var $eUqFw = parcelRequire("eUqFw");
const $551f8ba7184e33c7$var$EmbeddedPageContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    mode: 'view',
    page: null,
    isOpen: false,
    isLoading: false,
    pageCreate: null,
    setEmbeddedPage: ()=>{}
});
const $551f8ba7184e33c7$export$723f81cacfb30bb4 = ()=>(0, $eUqFw.useContext)($551f8ba7184e33c7$var$EmbeddedPageContext);
const $551f8ba7184e33c7$var$reducer = (prevState, action)=>({
        ...prevState,
        ...action
    });
const $551f8ba7184e33c7$export$db7a10e5d0439504 = ({ children: children })=>{
    const [pageState, setEmbeddedPage] = (0, $eUqFw.useReducer)($551f8ba7184e33c7$var$reducer, {
        mode: 'view',
        page: null,
        isOpen: false,
        isLoading: false,
        pageCreate: null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($551f8ba7184e33c7$var$EmbeddedPageContext.Provider, {
        value: {
            ...pageState,
            setEmbeddedPage: setEmbeddedPage
        }
    }, children);
};

});

parcelRegister("i4JmU", function(module, exports) {

$parcel$export(module.exports, "createConfluenceDraft", () => $fb436787e548b6d6$export$35a28ef15d43eade);

var $6EdKF = parcelRequire("6EdKF");
const $fb436787e548b6d6$var$IGNORE_MAU_HEADER = 'x-atlassian-mau-ignore';
const $fb436787e548b6d6$var$EP_ENITITY_ID_HEADER = 'X-Atl-EmbeddablePage-EntityIDs';
const $fb436787e548b6d6$export$35a28ef15d43eade = ({ templateId: templateId, projectSpaceKey: projectSpaceKey, projectPageLinkedId: projectPageLinkedId, isEmbeddedPage: isEmbeddedPage, pageTitle: pageTitle, projectId: projectId, projectType: projectType })=>(0, $6EdKF.fetchJson)(`/wiki/rest/create-dialog/1.0/content/blueprint/${templateId}/instance`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$fb436787e548b6d6$var$IGNORE_MAU_HEADER]: 'true',
            [$fb436787e548b6d6$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        },
        body: JSON.stringify({
            content: {
                type: 'page',
                status: 'draft',
                space: {
                    key: projectSpaceKey
                },
                ...projectPageLinkedId && {
                    ancestors: [
                        {
                            id: projectPageLinkedId
                        }
                    ]
                },
                title: pageTitle,
                ...isEmbeddedPage && {
                    metadata: {
                        frontend: {
                            embedded: true
                        }
                    }
                }
            },
            contentBlueprintSpec: {
                context: {},
                blueprintId: templateId
            }
        })
    });

});
parcelRegister("6EdKF", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $2930b4f597cecc2c$export$6d71b655afe1638d);
const $2930b4f597cecc2c$export$6d71b655afe1638d = (url, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        throw new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`);
    });

});




parcelRegister("dWs8I", function(module, exports) {

$parcel$export(module.exports, "getTutorialContent", () => $7a31d81b2bd3e1af$export$24a8368452d5530a);

var $6qwvC = parcelRequire("6qwvC");
const $7a31d81b2bd3e1af$export$24a8368452d5530a = (intl, isProjectPagesSporkRebrandingEnabled = false)=>{
    const tutorialContentShippingSpeedStatistic = intl.formatMessage((0, $6qwvC.default).tutorialContentShippingSpeedStatistic);
    const tutorialContentShippingSpeedStatisticSporkRebranding = intl.formatMessage((0, $6qwvC.default).tutorialContentShippingSpeedStatisticSporkRebranding);
    const tutorialContentGettingStatedTips = intl.formatMessage((0, $6qwvC.default).tutorialContentGettingStatedTips);
    const tutorialContentConfluenceTemplates = intl.formatMessage((0, $6qwvC.default).tutorialContentConfluenceTemplates, {
        a: (...chunks)=>`<a href="https://www.atlassian.com/software/confluence/templates">${chunks}</a>`,
        b: (...chunks)=>`<strong>${chunks}</strong>`
    });
    const tutorialContentEditAndFormat = intl.formatMessage((0, $6qwvC.default).tutorialContentEditAndFormat, {
        b: (...chunks)=>`<strong>${chunks}</strong>`,
        c: (...chunks)=>`<code>${chunks}</code>`
    });
    const tutorialContentSpacesAndPages = intl.formatMessage((0, $6qwvC.default).tutorialContentSpacesAndPages, {
        a: (...chunks)=>`<a href="https://www.atlassian.com/software/confluence/guides/get-started/set-up">${chunks}</a>`,
        b: (...chunks)=>`<strong>${chunks}</strong>`
    });
    const tutorialContentJiraAndConfluence = intl.formatMessage((0, $6qwvC.default).tutorialContentJiraAndConfluence);
    const tutorialContentJiraLinks = intl.formatMessage((0, $6qwvC.default).tutorialContentJiraLinks, {
        c: (...chunks)=>`<code>${chunks}</code>`
    });
    const tutorialContentJiraTimeline = intl.formatMessage((0, $6qwvC.default).tutorialContentJiraTimeline, {
        c: (...chunks)=>`<code>${chunks}</code>`
    });
    const tutorialContentJiraCharts = intl.formatMessage((0, $6qwvC.default).tutorialContentJiraCharts, {
        c: (...chunks)=>`<code>${chunks}</code>`
    });
    const tutorialContentTryItNow = intl.formatMessage((0, $6qwvC.default).tutorialContentTryItNow);
    const tutorialContentForwardSlashPrompt = intl.formatMessage((0, $6qwvC.default).tutorialContentForwardSlashPrompt);
    const tutorialContentHandyLinks = intl.formatMessage((0, $6qwvC.default).tutorialContentHandyLinks);
    const content = `<h4><ac:emoticon ac:name="blue-star" ac:emoji-shortname=":rocket:" ac:emoji-id="1f680" ac:emoji-fallback="\u{1F680}" /><strong>${isProjectPagesSporkRebrandingEnabled ? tutorialContentShippingSpeedStatisticSporkRebranding : tutorialContentShippingSpeedStatistic}</strong></h4><p>${tutorialContentGettingStatedTips}</p><ul><li><p>${tutorialContentConfluenceTemplates}</p></li><li><p>${tutorialContentEditAndFormat}</p></li><li><p>${tutorialContentSpacesAndPages}</p></li></ul><h3><ac:emoticon ac:name="blue-star" ac:emoji-shortname=":palms_up_together:" ac:emoji-id="1f932" ac:emoji-fallback="\u{1F932}" />${tutorialContentJiraAndConfluence}</h3><ul><li><p>${tutorialContentJiraLinks}</p></li><li><p>${tutorialContentJiraTimeline}</p></li><li><p>${tutorialContentJiraCharts}</p></li></ul>${isProjectPagesSporkRebrandingEnabled ? '' : '<a href="https://www.youtube.com/watch?v=ohtDFXNAUns&amp;t=1s" data-layout="center" data-original-height="480.00" data-width="66.67" data-original-width="853.34" data-card-appearance="embed">https://www.youtube.com/watch?v=ohtDFXNAUns&amp;t=1s</a>'}<ac:structured-macro ac:name="tip" ac:schema-version="1" ac:macro-id="45fcf348-9a07-42f8-b131-b48f9b1e50b3"><ac:rich-text-body><h3><strong><span style="color: rgb(54,179,126);">${tutorialContentTryItNow}</span></strong><ac:emoticon ac:name="blue-star" ac:emoji-shortname=":point_down:" ac:emoji-id="1f447" ac:emoji-fallback="\u{1F447}" /></h3></ac:rich-text-body></ac:structured-macro><table data-layout="default" ac:local-id="3b898e26-4024-4420-9593-3646c925e48b"><colgroup><col style="width: 680.0px;" /></colgroup><tbody><tr><th data-highlight-colour="#ffffff"><p><span style="color: rgb(151,160,175);">${tutorialContentForwardSlashPrompt}</span></p><p> </p></th></tr></tbody></table><p /><p> <ac:emoticon ac:name="blue-star" ac:emoji-shortname=":ok_hand:" ac:emoji-id="1f44c" ac:emoji-fallback="\u{1F44C}" />${tutorialContentHandyLinks}</p><p><a href="https://www.atlassian.com/software/confluence/jira-integration" data-card-appearance="inline">https://www.atlassian.com/software/confluence/jira-integration</a> </p><p><a href="https://www.youtube.com/watch?v=ybQIV15BO44" data-card-appearance="inline">https://www.youtube.com/watch?v=ybQIV15BO44</a> </p><p><a href="https://www.atlassian.com/software/confluence/guides" data-card-appearance="inline">https://www.atlassian.com/software/confluence/guides</a> </p><hr /><p />`;
    return content;
};

});
parcelRegister("6qwvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fd81e2507cd7566$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2fd81e2507cd7566$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tutorialContentShippingSpeedStatistic: {
        id: 'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic',
        defaultMessage: ' 76% of Jira Software customers said they shipped projects faster after adding Confluence',
        description: 'Customers statistic on development speed improvement when using Confluence'
    },
    tutorialContentShippingSpeedStatisticSporkRebranding: {
        id: 'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding',
        defaultMessage: ' 76% of Jira customers said they shipped projects faster after adding Confluence',
        description: 'Customers statistic on development speed improvement when using Confluence'
    },
    tutorialContentGettingStatedTips: {
        id: 'project-pages.improvement.templates.tutorial.content.getting-started-tips',
        defaultMessage: 'Here are a couple of tips to get you started:',
        description: 'Intro text for Confluence tips list'
    },
    tutorialContentConfluenceTemplates: {
        id: 'project-pages.improvement.templates.tutorial.content.confluence-templates',
        defaultMessage: '<b>Save time and reduce manual tasks</b>. Confluence has lots of page <a>templates</a>, so you never have to start from scratch. Think technical documents, troubleshooting guides, project plans, product requirements, and more.',
        description: 'Hint on advantages of using Confluence templates'
    },
    tutorialContentEditAndFormat: {
        id: 'project-pages.improvement.templates.tutorial.content.edit-and-format',
        defaultMessage: '<b>Easily edit and format.</b> Use the top editing menu for standard word formatting, and by typing <b>/</b> you can easily insert lots of handy integrations. Insert a table by typing <c>/table</c> or an image with <c>/image</c>. You can also insert Dropbox links <c>/dropbox</c>, Microsoft office tools <c>/microsoft</c>, or Trello boards and cards <c>/trello</c>.',
        description: 'Hint for info on editing and formatting Confluence documents'
    },
    tutorialContentSpacesAndPages: {
        id: 'project-pages.improvement.templates.tutorial.content.spaces-and-pages',
        defaultMessage: '<b>Using spaces and pages</b>. Spaces are part of every Confluence site and are a way of organizing pages into categories. Think of spaces as different folders or projects, and pages are the documents that belong in those folders or projects. <a>Learn more about how to use spaces</a>',
        description: 'Hint for info on Confluence spaces'
    },
    tutorialContentJiraAndConfluence: {
        id: 'project-pages.improvement.templates.tutorial.content.jira-and-confluence',
        defaultMessage: ' Use Jira and Confluence together',
        description: 'Title of Jira and Confluence integrations section'
    },
    tutorialContentJiraLinks: {
        id: 'project-pages.improvement.templates.tutorial.content.jira-links',
        defaultMessage: 'Link a Jira issue anywhere on your page. The link on the page will update in real-time, as you update the Jira issue. Type <c>/Jira</c>.',
        description: 'Description of links to Jira in Confluence'
    },
    tutorialContentJiraRoadmaps: {
        id: 'project-pages.improvement.templates.tutorial.content.jira-roadmaps',
        defaultMessage: 'Embed interactive roadmaps and timelines for your page using your Jira Projects. Type <c>/jira roadmap</c>.',
        description: 'Description of Jira roadmaps slash command'
    },
    tutorialContentJiraTimeline: {
        id: 'project-pages.improvement.templates.tutorial.content.jira-timeline',
        defaultMessage: 'Embed interactive timelines for your page using your Jira Projects. Type <c>/jira timeline</c>.',
        description: 'Description of Jira timeline slash command'
    },
    tutorialContentJiraCharts: {
        id: 'project-pages.improvement.templates.tutorial.content.jira-charts',
        defaultMessage: 'Create charts on your pages using real Jira data. Type <c>/Jira charts</c>.',
        description: 'Description of Jira charts slash command'
    },
    tutorialContentTryItNow: {
        id: 'project-pages.improvement.templates.tutorial.content.try-it-now',
        defaultMessage: 'Try it now ',
        description: 'Call to action at the bottom the tutorial template'
    },
    tutorialContentForwardSlashPrompt: {
        id: 'project-pages.improvement.templates.tutorial.content.forward-slash-prompt',
        defaultMessage: "Type / followed by \u2018table\u2019 or \u2018image\u2019",
        description: 'Placeholder text detailing how to use Confluence slash commands'
    },
    tutorialContentHandyLinks: {
        id: 'project-pages.improvement.templates.tutorial.content.handy-links',
        defaultMessage: ' Handy links',
        description: 'Title of section with links to guides and videos'
    }
});

});




parcelRegister("baKYD", function(module, exports) {

$parcel$export(module.exports, "isConfluenceAutoProvisioned", () => $351b3630ddaf11fc$export$fe56838272897f8f);
$parcel$export(module.exports, "shouldCreateSpaceForAutoProvisionedConfluence", () => $351b3630ddaf11fc$export$36c363b78a521200);

var $b18Mx = parcelRequire("b18Mx");

var $4aXoz = parcelRequire("4aXoz");

var $490NN = parcelRequire("490NN");
const $351b3630ddaf11fc$export$665dc32a4d0473f7 = 'confluence.auto-provision.activationDate';
const $351b3630ddaf11fc$export$847d02aadbf9f5f8 = (state)=>state.personalization.siteTraits;
const $351b3630ddaf11fc$export$fe56838272897f8f = (state)=>{
    try {
        const siteTraits = $351b3630ddaf11fc$export$847d02aadbf9f5f8(state);
        if (siteTraits.length < 1) return false;
        const autoProvisionDateTrait = siteTraits.find((trait)=>trait.name === $351b3630ddaf11fc$export$665dc32a4d0473f7);
        if (!autoProvisionDateTrait || !autoProvisionDateTrait.value) return false;
        return !!autoProvisionDateTrait.value;
    } catch (error) {
        (0, $b18Mx.sendOperationalAnalyticsEvent)({
            source: 'projectPages',
            action: 'failed',
            actionSubject: 'autoProvisionedConfluenceEligibilityCheck',
            attributes: {
                errorMessage: error ? error.message : 'Unknown error when determining the eligibilty of auto-provisioned Confluence site trait in isConfluenceAutoProvisioned selector'
            }
        });
        return false;
    }
};
const $351b3630ddaf11fc$export$36c363b78a521200 = (state)=>{
    const hasConnectedSpace = (0, $4aXoz.isSpaceConnected)(state);
    const hasAvailableSpaces = (0, $490NN.getAvailableSpaces)(state).length > 0;
    const hasAutoProvisionedConfluenceTrait = $351b3630ddaf11fc$export$fe56838272897f8f(state);
    const areAvailableSpacesLoaded = (0, $490NN.areSpacesLoaded)(state);
    return hasAutoProvisionedConfluenceTrait && areAvailableSpacesLoaded && !hasConnectedSpace && !hasAvailableSpaces;
};

});
parcelRegister("490NN", function(module, exports) {

$parcel$export(module.exports, "getAvailableSpaces", () => $0dc7f3475a72f024$export$d093ba54969384ed);
$parcel$export(module.exports, "areSpacesLoaded", () => $0dc7f3475a72f024$export$4439d288066fed0f);
const $0dc7f3475a72f024$export$c747993fa9b91546 = (state)=>state.confluence.spaces;
const $0dc7f3475a72f024$export$d093ba54969384ed = (state)=>state.confluence.spaces.availableSpaces;
const $0dc7f3475a72f024$export$4439d288066fed0f = (state)=>state.confluence.spaces.spacesLoaded;

});



parcelRegister("iTfWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ace397cafe85eb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6kvA9 = parcelRequire("6kvA9");

var $48Bjb = parcelRequire("48Bjb");

var $hqaEI = parcelRequire("hqaEI");
const $37ace397cafe85eb$var$MountTracker = (0, $48Bjb.default)('PageTreeUnknownError');
const $37ace397cafe85eb$var$PageTreeUnknownError = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqaEI.default), {
        messages: (0, $6kvA9.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($37ace397cafe85eb$var$MountTracker, null));
var $37ace397cafe85eb$export$2e2bcd8739ae039 = $37ace397cafe85eb$var$PageTreeUnknownError;

});
parcelRegister("6kvA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $974b819d4f95f2c2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $974b819d4f95f2c2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        id: 'project-pages.improvement.errors.page-tree-unknown-error.title',
        defaultMessage: "We\u2019re having trouble displaying project pages",
        description: 'Title when an unknown error occurred while fetching Confluence pages'
    },
    description: {
        id: 'project-pages.improvement.errors.page-tree-unknown-error.description',
        defaultMessage: "Something went wrong while trying to display pages from your connected Confluence space. {contactSupport} if refreshing doesn\u2019t fix things.",
        description: 'Description when an unknown error occurred while fetching Confluence pages'
    }
});

});

parcelRegister("hqaEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $690c7183191fb68c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $l3ugm = parcelRequire("l3ugm");

var $j5YY5 = parcelRequire("j5YY5");
const $690c7183191fb68c$var$BaseUnknownError = ({ intl: { formatMessage: formatMessage }, messages: messages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($l3ugm))),
        imageWidth: 71,
        header: formatMessage(messages.title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...messages.description,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j5YY5.default), {
                        label: chunks
                    })
            }
        }),
        testId: "confluence-project-pages.unknown-error"
    });
var $690c7183191fb68c$export$2e2bcd8739ae039 = (0, $2qhQi.default)($690c7183191fb68c$var$BaseUnknownError);

});
parcelRegister("l3ugm", function(module, exports) {
module.exports = new URL("error.f961de0c.svg", import.meta.url).toString();

});



parcelRegister("h5ZmY", function(module, exports) {

$parcel$export(module.exports, "PageTreeSkeleton", () => $e73f9d2a88f2bbaa$export$985ab6661ca3f4dc);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e73f9d2a88f2bbaa$var$Rectangle = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "rkiqr1-0"
})({
    width: '100%',
    height: `calc(100% - ${"var(--ds-space-200, 16px)"})`,
    borderRadius: "var(--ds-border-radius-100, 3px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e73f9d2a88f2bbaa$var$Circle = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "rkiqr1-1"
})({
    height: "var(--ds-space-400, 32px)",
    width: "var(--ds-space-400, 32px)",
    borderRadius: '50%',
    backgroundColor: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e73f9d2a88f2bbaa$var$Wrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "rkiqr1-2"
})({
    display: 'flex',
    flexWrap: 'wrap'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e73f9d2a88f2bbaa$var$Row = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "rkiqr1-3"
})({
    display: 'grid',
    gridTemplateColumns: '40% auto 20%',
    width: '100%',
    borderTop: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`}`,
    padding: `${"var(--ds-space-100, 8px)"} 0`,
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $e73f9d2a88f2bbaa$export$985ab6661ca3f4dc = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e73f9d2a88f2bbaa$var$Wrapper, {
        "data-testid": "confluence-project-pages.page-tree-skeleton"
    }, Array.from(Array(6), (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e73f9d2a88f2bbaa$var$Row, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e73f9d2a88f2bbaa$var$Rectangle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e73f9d2a88f2bbaa$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e73f9d2a88f2bbaa$var$Rectangle, null))));
};

});


parcelRegister("brKSp", function(module, exports) {

$parcel$export(module.exports, "DisplayWrapper", () => $9e2cc85f328c300d$export$6833d6d22987ee7f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $9e2cc85f328c300d$export$6833d6d22987ee7f = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "jgbp2w-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.isShown ? 'initial' : 'none'
    }));

});

parcelRegister("9IbuV", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $dfcd8ff9c232688c$export$30ab340faaed55d4);

var $eUqFw = parcelRequire("eUqFw");
const $dfcd8ff9c232688c$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eUqFw.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $dfcd8ff9c232688c$export$30ab340faaed55d4 = (experience)=>{
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $dfcd8ff9c232688c$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("hTSL3", function(module, exports) {

$parcel$export(module.exports, "getAllBooleanFeatureFlags", () => $11d3e712efd0c2f3$export$bb21a292576d06fe);
$parcel$export(module.exports, "getAllBooleanFeatureFlagKeys", () => $11d3e712efd0c2f3$export$bce38ec35444ea8b);

var $1RAqP = parcelRequire("1RAqP");
const $11d3e712efd0c2f3$export$bb21a292576d06fe = ()=>{
    try {
        const generatedFeatureFlags = (0, $1RAqP.getGeneratedBooleanFeatureFlags)() || {};
        return generatedFeatureFlags;
    } catch (error) {
        return {};
    }
};
const $11d3e712efd0c2f3$export$bce38ec35444ea8b = ()=>{
    if (typeof (0, $1RAqP.generatedBooleanFeatureFlagKeys) === 'object') return 0, $1RAqP.generatedBooleanFeatureFlagKeys;
    return [];
};

});
parcelRegister("1RAqP", function(module, exports) {

$parcel$export(module.exports, "getGeneratedBooleanFeatureFlags", () => $d77ca832f5df9216$export$5d8fc734b5305558);
$parcel$export(module.exports, "generatedBooleanFeatureFlagKeys", () => $d77ca832f5df9216$export$ba3accfade8b4417);
/**
 * This file is auto-generated. Run yarn workspace @atlassiansox/project-pages generate:feature-flags to re-generate.
 */ 
var $XHGTv = parcelRequire("XHGTv");
const $d77ca832f5df9216$export$5d8fc734b5305558 = ()=>{
    try {
        const flags = {
            'project-pages-embedded-confluence-aa-gate': (0, $XHGTv.fg)('project-pages-embedded-confluence-aa-gate'),
            'project_pages_embededed_confluence_gate': (0, $XHGTv.fg)('project_pages_embededed_confluence_gate'),
            'platform.google-drive-in-project-pages': (0, $XHGTv.fg)('platform.google-drive-in-project-pages'),
            'platform.xflow-provisioning-api_kgxk3': (0, $XHGTv.fg)('platform.xflow-provisioning-api_kgxk3'),
            'project-pages-cta-content-update-gate': (0, $XHGTv.fg)('project-pages-cta-content-update-gate'),
            'jsw_project_pages_reorder_templates_v2': (0, $XHGTv.fg)('jsw_project_pages_reorder_templates_v2')
        };
        return flags;
    } catch (error) {
        return {};
    }
};
const $d77ca832f5df9216$export$ba3accfade8b4417 = [
    'project-pages-embedded-confluence-aa-gate',
    'project_pages_embededed_confluence_gate',
    'platform.google-drive-in-project-pages',
    'platform.xflow-provisioning-api_kgxk3',
    'project-pages-cta-content-update-gate',
    'jsw_project_pages_reorder_templates_v2'
];

});


parcelRegister("4Dxzk", function(module, exports) {

$parcel$export(module.exports, "ShowUserPreselectedTemplateExperiment", () => $2e422ab35310d533$export$48e42f8052cd108);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("5R9VD");
var $2iVww = parcelRequire("2iVww");

var $jb3WS = parcelRequire("jb3WS");

var $XHGTv = parcelRequire("XHGTv");

var $7ifyX = parcelRequire("7ifyX");
const $2e422ab35310d533$export$48e42f8052cd108 = ({ contentId: contentId, isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate, blueprints: blueprints, createEmbeddedPage: createEmbeddedPage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        onError: (error)=>{
            (0, $2iVww.default)({
                meta: {
                    id: 'project-pages-embedded-confluence-error',
                    packageName: '@atlassiansox/project-pages'
                },
                error: error
            });
        }
    }, (0, $XHGTv.fg)('project_pages_embededed_confluence_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ifyX.SelectedTemplatePreview), {
        contentId: contentId,
        isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate,
        blueprints: blueprints,
        createEmbeddedPage: createEmbeddedPage
    }));
};

});
parcelRegister("5R9VD", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => (parcelRequire("2iVww")).default);
$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => (parcelRequire("2iVww")).initialiseErrorAnalyticsClient);
$parcel$export(module.exports, "ReportErrors", () => (parcelRequire("fNQX5")).default);

var $8YauA = parcelRequire("8YauA");

var $2iVww = parcelRequire("2iVww");

var $fNQX5 = parcelRequire("fNQX5");

});
parcelRegister("8YauA", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $b547794667f85d76$export$f5282963edea4a68);

var $jDYYE = parcelRequire("jDYYE");
const $b547794667f85d76$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $jDYYE.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $b547794667f85d76$export$f5282963edea4a68 = (location, error, details = {})=>(0, $jDYYE.default).captureException(location, error, details);

});
parcelRegister("jDYYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $46a99679bff64c4f$export$2e2bcd8739ae039);
// This is the only file that should directly import Raven.

var $cZi0S = parcelRequire("cZi0S");
var $OArqR = parcelRequire("OArqR");
var $5kdbo = parcelRequire("5kdbo");

var $3UO40 = parcelRequire("3UO40");
var $3OSfe = parcelRequire("3OSfe");
var $ddI3U = parcelRequire("ddI3U");
var $fkbBB = parcelRequire("fkbBB");

var $MdoH4 = parcelRequire("MdoH4");
const $46a99679bff64c4f$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $46a99679bff64c4f$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $46a99679bff64c4f$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $46a99679bff64c4f$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $46a99679bff64c4f$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $OArqR.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $46a99679bff64c4f$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$46a99679bff64c4f$var$getFilteredIntegrations(integrations),
                new $3OSfe.Dedupe(),
                new $ddI3U.ExtraErrorData(),
                new $fkbBB.Transaction(),
                new $3UO40.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $5kdbo.init({
        ...defaultConfig,
        ...config
    });
    try {
        $cZi0S.setExtras(getExtraContext());
    } catch (e) {
        $cZi0S.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $46a99679bff64c4f$var$tags = [
    'packageName'
];
const $46a99679bff64c4f$var$captureException = (location, error, details)=>{
    $cZi0S.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($46a99679bff64c4f$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $cZi0S.captureException(error);
};
var $46a99679bff64c4f$export$2e2bcd8739ae039 = {
    installGlobalHandler: $46a99679bff64c4f$var$installGlobalHandler,
    captureException: $46a99679bff64c4f$var$captureException
};

});
parcelRegister("cZi0S", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $974927907f8d3c67$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $974927907f8d3c67$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $974927907f8d3c67$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $974927907f8d3c67$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $974927907f8d3c67$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $974927907f8d3c67$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $974927907f8d3c67$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setTags", () => $974927907f8d3c67$export$74a8fb34822092e6);
$parcel$export(module.exports, "setExtra", () => $974927907f8d3c67$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTag", () => $974927907f8d3c67$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $974927907f8d3c67$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $974927907f8d3c67$export$ec58d9285c204497);
$parcel$export(module.exports, "startTransaction", () => $974927907f8d3c67$export$e262da7ae6480481);

var $fKE23 = parcelRequire("fKE23");

var $OArqR = parcelRequire("OArqR");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $974927907f8d3c67$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $OArqR.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $fKE23.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $974927907f8d3c67$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $974927907f8d3c67$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $974927907f8d3c67$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $974927907f8d3c67$var$callOnHub('captureMessage', message, level, (0, $fKE23.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $974927907f8d3c67$export$1462b974fdcf6ba2(event) {
    return $974927907f8d3c67$var$callOnHub('captureEvent', event);
}
function $974927907f8d3c67$export$99d44f04437e9cb8(callback) {
    $974927907f8d3c67$var$callOnHub('configureScope', callback);
}
function $974927907f8d3c67$export$efda9a273d7a036d(breadcrumb) {
    $974927907f8d3c67$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $974927907f8d3c67$export$2f04de43fe27971a(name, context) {
    $974927907f8d3c67$var$callOnHub('setContext', name, context);
}
function $974927907f8d3c67$export$bb4922da0dd51b92(extras) {
    $974927907f8d3c67$var$callOnHub('setExtras', extras);
}
function $974927907f8d3c67$export$74a8fb34822092e6(tags) {
    $974927907f8d3c67$var$callOnHub('setTags', tags);
}
function $974927907f8d3c67$export$8e8e7789d42ed61d(key, extra) {
    $974927907f8d3c67$var$callOnHub('setExtra', key, extra);
}
function $974927907f8d3c67$export$a37d07ee78eb4569(key, value) {
    $974927907f8d3c67$var$callOnHub('setTag', key, value);
}
function $974927907f8d3c67$export$8b6bb3dd62a01be2(user) {
    $974927907f8d3c67$var$callOnHub('setUser', user);
}
function $974927907f8d3c67$export$ec58d9285c204497(callback) {
    $974927907f8d3c67$var$callOnHub('withScope', callback);
}
function $974927907f8d3c67$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $974927907f8d3c67$var$callOnHub.apply(void 0, (0, $fKE23.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $974927907f8d3c67$export$e262da7ae6480481(context, customSamplingContext) {
    return $974927907f8d3c67$var$callOnHub('startTransaction', (0, $fKE23.__assign)({}, context), customSamplingContext);
}

});
parcelRegister("OArqR", function(module, exports) {

$parcel$export(module.exports, "Hub", () => $0980f023f6699809$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $0980f023f6699809$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getHubFromCarrier", () => $0980f023f6699809$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $0980f023f6699809$export$a07cdf6544bbd7c);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("4rc7U");
var $iACIJ = parcelRequire("iACIJ");
var $kVqeH = parcelRequire("kVqeH");
var $elIfN = parcelRequire("elIfN");
var $cbZpL = parcelRequire("cbZpL");
var $d6buR = parcelRequire("d6buR");

var $dp7ee = parcelRequire("dp7ee");

var $87JfJ = parcelRequire("87JfJ");

var $cTyWz = parcelRequire("cTyWz");
var $0980f023f6699809$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $0980f023f6699809$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $0980f023f6699809$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $87JfJ.Scope)();
        if (_version === void 0) _version = $0980f023f6699809$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $87JfJ.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $d6buR.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $d6buR.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $d6buR.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $0980f023f6699809$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $kVqeH.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $fKE23.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $iACIJ.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $0980f023f6699809$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $0980f023f6699809$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $dp7ee.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $elIfN.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $cTyWz.Session)((0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $fKE23.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $0980f023f6699809$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $dp7ee.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $0980f023f6699809$export$19eade501500c6c1() {
    var carrier = (0, $elIfN.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $0980f023f6699809$export$4188a14ad302d1bc(hub) {
    var registry = $0980f023f6699809$export$19eade501500c6c1();
    var oldHub = $0980f023f6699809$export$bfa8a924a84a76b7(registry);
    $0980f023f6699809$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $0980f023f6699809$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $0980f023f6699809$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$0980f023f6699809$var$hasHubOnCarrier(registry) || $0980f023f6699809$export$bfa8a924a84a76b7(registry).isOlderThan($0980f023f6699809$export$24a86ef7798177e4)) $0980f023f6699809$export$849f05434e95d2f2(registry, new $0980f023f6699809$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $cbZpL.isNodeEnv)()) return $0980f023f6699809$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $0980f023f6699809$export$bfa8a924a84a76b7(registry);
}
function $0980f023f6699809$export$1c4d656130202699() {
    (0, $dp7ee.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $0980f023f6699809$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $0980f023f6699809$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $0980f023f6699809$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $0980f023f6699809$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$0980f023f6699809$var$hasHubOnCarrier(activeDomain) || $0980f023f6699809$export$bfa8a924a84a76b7(activeDomain).isOlderThan($0980f023f6699809$export$24a86ef7798177e4)) {
            var registryHubTopStack = $0980f023f6699809$export$bfa8a924a84a76b7(registry).getStackTop();
            $0980f023f6699809$export$849f05434e95d2f2(activeDomain, new $0980f023f6699809$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $87JfJ.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $0980f023f6699809$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $0980f023f6699809$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $0980f023f6699809$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $0980f023f6699809$export$bfa8a924a84a76b7(carrier) {
    return (0, $elIfN.getGlobalSingleton)('hub', function() {
        return new $0980f023f6699809$export$8c41bb232f1008b1();
    }, carrier);
}
function $0980f023f6699809$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("4rc7U", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("elIfN")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("elIfN")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("hiXkV")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("hiXkV")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("iACIJ")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("iACIJ")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("d6buR")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("8Ydiu")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("5PjAl")).SyncPromise);





parcelRequire("elIfN");

parcelRequire("hiXkV");
parcelRequire("iACIJ");

parcelRequire("d6buR");

var $cbZpL = parcelRequire("cbZpL");

parcelRequire("8Ydiu");







parcelRequire("5PjAl");

var $kVqeH = parcelRequire("kVqeH");





$parcel$exportWildcard(module.exports, $cbZpL);
$parcel$exportWildcard(module.exports, $kVqeH);

});
parcelRegister("elIfN", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $a7255abf53d9628a$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $a7255abf53d9628a$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $cbZpL = parcelRequire("cbZpL");
var $a7255abf53d9628a$var$fallbackGlobalObject = {};
function $a7255abf53d9628a$export$256479dc0cea61c4() {
    return (0, $cbZpL.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $a7255abf53d9628a$var$fallbackGlobalObject;
}
function $a7255abf53d9628a$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $a7255abf53d9628a$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("cbZpL", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $9DHLK = parcelRequire("9DHLK");

var $2fFJv = parcelRequire("2fFJv");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $9DHLK.isBrowserBundle)() && Object.prototype.toString.call(typeof $2fFJv !== 'undefined' ? $2fFJv : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("9DHLK", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $7049b5388f3bc16b$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $7049b5388f3bc16b$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("hiXkV", function(module, exports) {

$parcel$export(module.exports, "isError", () => $c992251c3cf6d112$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $c992251c3cf6d112$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $c992251c3cf6d112$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $c992251c3cf6d112$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $c992251c3cf6d112$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $c992251c3cf6d112$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $c992251c3cf6d112$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $c992251c3cf6d112$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $c992251c3cf6d112$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $c992251c3cf6d112$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $c992251c3cf6d112$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $c992251c3cf6d112$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $c992251c3cf6d112$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $c992251c3cf6d112$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $c992251c3cf6d112$var$objectToString = Object.prototype.toString;
function $c992251c3cf6d112$export$e6127cc7fe7395c3(wat) {
    switch($c992251c3cf6d112$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $c992251c3cf6d112$export$49034edbe6b62415(wat, Error);
    }
}
function $c992251c3cf6d112$var$isBuiltin(wat, ty) {
    return $c992251c3cf6d112$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $c992251c3cf6d112$export$9f9636d330b71954(wat) {
    return $c992251c3cf6d112$var$isBuiltin(wat, 'ErrorEvent');
}
function $c992251c3cf6d112$export$ef9e2056653f0c8e(wat) {
    return $c992251c3cf6d112$var$isBuiltin(wat, 'DOMError');
}
function $c992251c3cf6d112$export$12e869b2a583f783(wat) {
    return $c992251c3cf6d112$var$isBuiltin(wat, 'DOMException');
}
function $c992251c3cf6d112$export$844ec244b1367d54(wat) {
    return $c992251c3cf6d112$var$isBuiltin(wat, 'String');
}
function $c992251c3cf6d112$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $c992251c3cf6d112$export$53b83ca8eaab0383(wat) {
    return $c992251c3cf6d112$var$isBuiltin(wat, 'Object');
}
function $c992251c3cf6d112$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $c992251c3cf6d112$export$49034edbe6b62415(wat, Event);
}
function $c992251c3cf6d112$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $c992251c3cf6d112$export$49034edbe6b62415(wat, Element);
}
function $c992251c3cf6d112$export$49841c62b9eff15(wat) {
    return $c992251c3cf6d112$var$isBuiltin(wat, 'RegExp');
}
function $c992251c3cf6d112$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $c992251c3cf6d112$export$bc2894c7158efbac(wat) {
    return $c992251c3cf6d112$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $c992251c3cf6d112$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $c992251c3cf6d112$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("iACIJ", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $d8899fddf2254d3f$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "consoleSandbox", () => $d8899fddf2254d3f$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $d8899fddf2254d3f$export$af88d00dbe7f521);

var $fKE23 = parcelRequire("fKE23");

var $e1VHv = parcelRequire("e1VHv");

var $elIfN = parcelRequire("elIfN");
// TODO: Implement different loggers for different environments
var $d8899fddf2254d3f$var$global = (0, $elIfN.getGlobalObject)();
/** Prefix for logging strings */ var $d8899fddf2254d3f$var$PREFIX = 'Sentry Logger ';
var $d8899fddf2254d3f$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $d8899fddf2254d3f$export$cda52e2a8927a2ca(callback) {
    var global = (0, $elIfN.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $d8899fddf2254d3f$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $d8899fddf2254d3f$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $e1VHv.IS_DEBUG_BUILD) $d8899fddf2254d3f$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $d8899fddf2254d3f$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $d8899fddf2254d3f$var$global.console)[name].apply(_a, (0, $fKE23.__spread)([
                    $d8899fddf2254d3f$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $d8899fddf2254d3f$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $d8899fddf2254d3f$export$af88d00dbe7f521;
if (0, $e1VHv.IS_DEBUG_BUILD) $d8899fddf2254d3f$export$af88d00dbe7f521 = (0, $elIfN.getGlobalSingleton)('logger', $d8899fddf2254d3f$var$makeLogger);
else $d8899fddf2254d3f$export$af88d00dbe7f521 = $d8899fddf2254d3f$var$makeLogger();

});
parcelRegister("e1VHv", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $a36dead3698ec8cd$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $a36dead3698ec8cd$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("d6buR", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $9894c0f0631e8740$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $9894c0f0631e8740$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $9894c0f0631e8740$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $9894c0f0631e8740$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $9894c0f0631e8740$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $9894c0f0631e8740$export$6de4ffac6a2f1098);

var $fKE23 = parcelRequire("fKE23");

var $elIfN = parcelRequire("elIfN");

var $8Ydiu = parcelRequire("8Ydiu");

var $X8Ykq = parcelRequire("X8Ykq");
function $9894c0f0631e8740$export$19f53698e68b2496() {
    var global = (0, $elIfN.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $9894c0f0631e8740$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $9894c0f0631e8740$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $9894c0f0631e8740$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $9894c0f0631e8740$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $9894c0f0631e8740$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $9894c0f0631e8740$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $9894c0f0631e8740$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $9894c0f0631e8740$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $9894c0f0631e8740$export$d364f2020ab30578(input) {
    var match = input.match($9894c0f0631e8740$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $9894c0f0631e8740$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $X8Ykq.snipLine)(line, 0);
    });
    frame.context_line = (0, $X8Ykq.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $X8Ykq.snipLine)(line, 0);
    });
}
function $9894c0f0631e8740$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $9894c0f0631e8740$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $8Ydiu.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("8Ydiu", function(module, exports) {

$parcel$export(module.exports, "fill", () => $687e3de4b8c7d568$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $687e3de4b8c7d568$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $687e3de4b8c7d568$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $687e3de4b8c7d568$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $687e3de4b8c7d568$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $687e3de4b8c7d568$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $687e3de4b8c7d568$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $687e3de4b8c7d568$export$d25f2688db1bb433);

var $fKE23 = parcelRequire("fKE23");

var $lCbG4 = parcelRequire("lCbG4");

var $hiXkV = parcelRequire("hiXkV");

var $X8Ykq = parcelRequire("X8Ykq");
function $687e3de4b8c7d568$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $687e3de4b8c7d568$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $687e3de4b8c7d568$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $687e3de4b8c7d568$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $687e3de4b8c7d568$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $687e3de4b8c7d568$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $687e3de4b8c7d568$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $687e3de4b8c7d568$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $hiXkV.isError)(value)) newObj = (0, $fKE23.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $687e3de4b8c7d568$var$getOwnProperties(value));
    else if ((0, $hiXkV.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $fKE23.__assign)({
            type: event_1.type,
            target: $687e3de4b8c7d568$var$serializeEventTarget(event_1.target),
            currentTarget: $687e3de4b8c7d568$var$serializeEventTarget(event_1.currentTarget)
        }, $687e3de4b8c7d568$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $hiXkV.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $687e3de4b8c7d568$var$serializeEventTarget(target) {
    try {
        return (0, $hiXkV.isElement)(target) ? (0, $lCbG4.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $687e3de4b8c7d568$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $687e3de4b8c7d568$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($687e3de4b8c7d568$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $X8Ykq.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $X8Ykq.truncate)(serialized, maxLength);
    }
    return '';
}
function $687e3de4b8c7d568$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $hiXkV.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $fKE23.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $687e3de4b8c7d568$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($687e3de4b8c7d568$export$d25f2688db1bb433);
    return val;
}
function $687e3de4b8c7d568$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $hiXkV.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("lCbG4", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $fbc63483f1d5e9fb$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $fbc63483f1d5e9fb$export$1cfafeee2987818b);

var $elIfN = parcelRequire("elIfN");

var $hiXkV = parcelRequire("hiXkV");
function $fbc63483f1d5e9fb$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $fbc63483f1d5e9fb$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $fbc63483f1d5e9fb$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $hiXkV.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $fbc63483f1d5e9fb$export$1cfafeee2987818b() {
    var global = (0, $elIfN.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("X8Ykq", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $0b1c78768d09f615$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $0b1c78768d09f615$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $0b1c78768d09f615$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $0b1c78768d09f615$export$cdded5b28a5f8c6d);

var $hiXkV = parcelRequire("hiXkV");
function $0b1c78768d09f615$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $0b1c78768d09f615$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $0b1c78768d09f615$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $0b1c78768d09f615$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $hiXkV.isString)(value)) return false;
    if ((0, $hiXkV.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $0b1c78768d09f615$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});



parcelRegister("5PjAl", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $43e0e860a18e4b11$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $43e0e860a18e4b11$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $43e0e860a18e4b11$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $hiXkV = parcelRequire("hiXkV");
function $43e0e860a18e4b11$export$1fda8aa4d135f8aa(value) {
    return new $43e0e860a18e4b11$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $43e0e860a18e4b11$export$78e43115b553f358(reason) {
    return new $43e0e860a18e4b11$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $43e0e860a18e4b11$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $hiXkV.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});

parcelRegister("kVqeH", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $elIfN = parcelRequire("elIfN");

var $cbZpL = parcelRequire("cbZpL");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $elIfN.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $cbZpL.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $cbZpL.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $elIfN.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});


parcelRegister("dp7ee", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $9c23379fa9385e05$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $9c23379fa9385e05$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("87JfJ", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $5ea2146d67bf681a$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $5ea2146d67bf681a$export$8e4e25f54d456511);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("4rc7U");
var $kVqeH = parcelRequire("kVqeH");
var $elIfN = parcelRequire("elIfN");
var $hiXkV = parcelRequire("hiXkV");
var $5PjAl = parcelRequire("5PjAl");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $5ea2146d67bf681a$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $5ea2146d67bf681a$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $fKE23.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $fKE23.__assign)({}, scope._tags);
            newScope._extra = (0, $fKE23.__assign)({}, scope._extra);
            newScope._contexts = (0, $fKE23.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $fKE23.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $hiXkV.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $5ea2146d67bf681a$var$MAX_BREADCRUMBS) : $5ea2146d67bf681a$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $fKE23.__assign)({
            timestamp: (0, $kVqeH.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $fKE23.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $fKE23.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $fKE23.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $fKE23.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $fKE23.__spread)($5ea2146d67bf681a$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $5PjAl.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $fKE23.__assign)({}, event), hint);
                if ((0, $hiXkV.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $5ea2146d67bf681a$var$getGlobalEventProcessors() {
    return (0, $elIfN.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $5ea2146d67bf681a$export$8e4e25f54d456511(callback) {
    $5ea2146d67bf681a$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("cTyWz", function(module, exports) {

$parcel$export(module.exports, "Session", () => $9635ba30690c682e$export$1fb4852a55678982);
parcelRequire("4rc7U");
var $8Ydiu = parcelRequire("8Ydiu");
var $kVqeH = parcelRequire("kVqeH");
var $d6buR = parcelRequire("d6buR");
/**
 * @inheritdoc
 */ var $9635ba30690c682e$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $d6buR.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $kVqeH.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $kVqeH.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $d6buR.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $8Ydiu.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});



parcelRegister("5kdbo", function(module, exports) {

$parcel$export(module.exports, "init", () => $3e090bd02bc7c967$export$2cd8252107eb640b);

var $fKE23 = parcelRequire("fKE23");

var $OArqR = parcelRequire("OArqR");
var $iUrEw = parcelRequire("iUrEw");
var $9LhPA = parcelRequire("9LhPA");
parcelRequire("lRNHc");
var $jLCUE = parcelRequire("jLCUE");
var $1rQSq = parcelRequire("1rQSq");
var $4ihNC = parcelRequire("4ihNC");
var $8RBQ1 = parcelRequire("8RBQ1");

var $cUpUA = parcelRequire("cUpUA");

var $ed0Qo = parcelRequire("ed0Qo");

var $dCjZk = parcelRequire("dCjZk");

var $793hP = parcelRequire("793hP");
var $aFRiS = parcelRequire("aFRiS");
var $5rouO = parcelRequire("5rouO");
var $4Zia6 = parcelRequire("4Zia6");
var $8x62I = parcelRequire("8x62I");
var $9czaH = parcelRequire("9czaH");
var $3e090bd02bc7c967$export$5ef831fccfce35e5 = [
    new (0, $9LhPA).InboundFilters(),
    new (0, $9LhPA).FunctionToString(),
    new (0, $8x62I.TryCatch)(),
    new (0, $793hP.Breadcrumbs)(),
    new (0, $5rouO.GlobalHandlers)(),
    new (0, $4Zia6.LinkedErrors)(),
    new (0, $aFRiS.Dedupe)(),
    new (0, $9czaH.UserAgent)()
];
function $3e090bd02bc7c967$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $3e090bd02bc7c967$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $1rQSq.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $iUrEw.initAndBind)((0, $cUpUA.BrowserClient), options);
    if (options.autoSessionTracking) $3e090bd02bc7c967$var$startSessionTracking();
}
function $3e090bd02bc7c967$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $OArqR.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $3e090bd02bc7c967$export$5d4e9fd7fac8e617() {
    return (0, $OArqR.getCurrentHub)().lastEventId();
}
function $3e090bd02bc7c967$export$a3f323d81eede727() {
// Noop
}
function $3e090bd02bc7c967$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $3e090bd02bc7c967$export$4909b86c8034bf73(timeout) {
    var client = (0, $OArqR.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn('Cannot flush events. No client defined.');
    return (0, $8RBQ1.resolvedSyncPromise)(false);
}
function $3e090bd02bc7c967$export$8360e631d277ea4d(timeout) {
    var client = (0, $OArqR.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $8RBQ1.resolvedSyncPromise)(false);
}
function $3e090bd02bc7c967$export$4997ffc0176396a6(fn) {
    return (0, $dCjZk.wrap)(fn)();
}
function $3e090bd02bc7c967$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $3e090bd02bc7c967$var$startSessionTracking() {
    var window = (0, $1rQSq.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $OArqR.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $3e090bd02bc7c967$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $jLCUE.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $3e090bd02bc7c967$var$startSessionOnHub((0, $OArqR.getCurrentHub)());
    });
}

});
parcelRegister("iUrEw", function(module, exports) {

$parcel$export(module.exports, "initAndBind", () => $dc42e835558c531d$export$5333c3f1c58d9bc1);

var $OArqR = parcelRequire("OArqR");
parcelRequire("lRNHc");
var $4ihNC = parcelRequire("4ihNC");

var $2k7cn = parcelRequire("2k7cn");
function $dc42e835558c531d$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $2k7cn.IS_DEBUG_BUILD) (0, $4ihNC.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $OArqR.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});
parcelRegister("lRNHc", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("bplvQ")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("3WEbu")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("3WEbu")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("fKQSd")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("fKQSd")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("hPQzi")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("1rQSq")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("jLCUE")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("bM45J")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("bM45J")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("bM45J")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("bM45J")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("bM45J")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("bM45J")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("bM45J")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("bM45J")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("bM45J")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("bM45J")).isThenable);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("4ihNC")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("4ihNC")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("fR8Sp")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("fR8Sp")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("fR8Sp")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("fR8Sp")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("fR8Sp")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("fR8Sp")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("kYiFy")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("kYiFy")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("koJfb")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("koJfb")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("koJfb")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("koJfb")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("koJfb")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("koJfb")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("6m1BR")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("9pvxT")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("bhTeQ")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("bhTeQ")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("jYkUl")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("jZkqD")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("jZkqD")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("jZkqD")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("bEOmW")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("bEOmW")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("bEOmW")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("8RBQ1")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("8RBQ1")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("8RBQ1")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("57nRK")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("57nRK")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("57nRK")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("a44V3")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("4Y7Sc")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("4Y7Sc")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("4Y7Sc")).updateRateLimits);
parcelRequire("bplvQ");
parcelRequire("3WEbu");
parcelRequire("fKQSd");

parcelRequire("hPQzi");
parcelRequire("1rQSq");
parcelRequire("jLCUE");
parcelRequire("bM45J");
parcelRequire("4ihNC");

parcelRequire("fR8Sp");

var $7QqGh = parcelRequire("7QqGh");
parcelRequire("kYiFy");
parcelRequire("koJfb");

parcelRequire("6m1BR");
parcelRequire("9pvxT");
parcelRequire("bhTeQ");
parcelRequire("jYkUl");
parcelRequire("jZkqD");
parcelRequire("bEOmW");
parcelRequire("8RBQ1");

var $cIM48 = parcelRequire("cIM48");


parcelRequire("57nRK");
parcelRequire("a44V3");
parcelRequire("4Y7Sc");
$parcel$exportWildcard(module.exports, $7QqGh);
$parcel$exportWildcard(module.exports, $cIM48);

});
parcelRegister("bplvQ", function(module, exports) {

$parcel$export(module.exports, "forget", () => $84e2b77bd35f29c1$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $84e2b77bd35f29c1$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("3WEbu", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $2df5f5a82b296684$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $2df5f5a82b296684$export$1cfafeee2987818b);

var $1rQSq = parcelRequire("1rQSq");

var $bM45J = parcelRequire("bM45J");
function $2df5f5a82b296684$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $2df5f5a82b296684$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $2df5f5a82b296684$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $bM45J.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $2df5f5a82b296684$export$1cfafeee2987818b() {
    var global = (0, $1rQSq.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("1rQSq", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $10e15447af8c353e$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $10e15447af8c353e$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $7QqGh = parcelRequire("7QqGh");
var $10e15447af8c353e$var$fallbackGlobalObject = {};
function $10e15447af8c353e$export$256479dc0cea61c4() {
    return (0, $7QqGh.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $10e15447af8c353e$var$fallbackGlobalObject;
}
function $10e15447af8c353e$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $10e15447af8c353e$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("7QqGh", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $eSylE = parcelRequire("eSylE");

var $2fFJv = parcelRequire("2fFJv");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $eSylE.isBrowserBundle)() && Object.prototype.toString.call(typeof $2fFJv !== 'undefined' ? $2fFJv : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("eSylE", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $ad50c0a81984e05e$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $ad50c0a81984e05e$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("bM45J", function(module, exports) {

$parcel$export(module.exports, "isError", () => $892759e09b4ef8dd$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $892759e09b4ef8dd$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $892759e09b4ef8dd$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $892759e09b4ef8dd$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $892759e09b4ef8dd$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $892759e09b4ef8dd$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $892759e09b4ef8dd$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $892759e09b4ef8dd$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $892759e09b4ef8dd$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $892759e09b4ef8dd$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $892759e09b4ef8dd$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $892759e09b4ef8dd$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $892759e09b4ef8dd$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $892759e09b4ef8dd$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $892759e09b4ef8dd$var$objectToString = Object.prototype.toString;
function $892759e09b4ef8dd$export$e6127cc7fe7395c3(wat) {
    switch($892759e09b4ef8dd$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $892759e09b4ef8dd$export$49034edbe6b62415(wat, Error);
    }
}
function $892759e09b4ef8dd$var$isBuiltin(wat, ty) {
    return $892759e09b4ef8dd$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $892759e09b4ef8dd$export$9f9636d330b71954(wat) {
    return $892759e09b4ef8dd$var$isBuiltin(wat, 'ErrorEvent');
}
function $892759e09b4ef8dd$export$ef9e2056653f0c8e(wat) {
    return $892759e09b4ef8dd$var$isBuiltin(wat, 'DOMError');
}
function $892759e09b4ef8dd$export$12e869b2a583f783(wat) {
    return $892759e09b4ef8dd$var$isBuiltin(wat, 'DOMException');
}
function $892759e09b4ef8dd$export$844ec244b1367d54(wat) {
    return $892759e09b4ef8dd$var$isBuiltin(wat, 'String');
}
function $892759e09b4ef8dd$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $892759e09b4ef8dd$export$53b83ca8eaab0383(wat) {
    return $892759e09b4ef8dd$var$isBuiltin(wat, 'Object');
}
function $892759e09b4ef8dd$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $892759e09b4ef8dd$export$49034edbe6b62415(wat, Event);
}
function $892759e09b4ef8dd$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $892759e09b4ef8dd$export$49034edbe6b62415(wat, Element);
}
function $892759e09b4ef8dd$export$49841c62b9eff15(wat) {
    return $892759e09b4ef8dd$var$isBuiltin(wat, 'RegExp');
}
function $892759e09b4ef8dd$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $892759e09b4ef8dd$export$bc2894c7158efbac(wat) {
    return $892759e09b4ef8dd$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $892759e09b4ef8dd$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $892759e09b4ef8dd$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("fKQSd", function(module, exports) {

$parcel$export(module.exports, "dsnToString", () => $b7842a78d3154e36$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $b7842a78d3154e36$export$128827c3562ec0cb);

var $fKE23 = parcelRequire("fKE23");

var $hPQzi = parcelRequire("hPQzi");

var $laWAH = parcelRequire("laWAH");
/** Regular expression used to parse a Dsn. */ var $b7842a78d3154e36$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $b7842a78d3154e36$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $b7842a78d3154e36$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $b7842a78d3154e36$var$dsnFromString(str) {
    var match = $b7842a78d3154e36$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $hPQzi.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $fKE23.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $b7842a78d3154e36$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $b7842a78d3154e36$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $b7842a78d3154e36$var$validateDsn(dsn) {
    if (!(0, $laWAH.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $hPQzi.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $hPQzi.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$b7842a78d3154e36$var$isValidProtocol(protocol)) throw new (0, $hPQzi.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $hPQzi.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $b7842a78d3154e36$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $b7842a78d3154e36$var$dsnFromString(from) : $b7842a78d3154e36$var$dsnFromComponents(from);
    $b7842a78d3154e36$var$validateDsn(components);
    return components;
}

});
parcelRegister("hPQzi", function(module, exports) {

$parcel$export(module.exports, "SentryError", () => $cfbffa0d82e9f720$export$5949942ba2a7c0e2);

var $fKE23 = parcelRequire("fKE23");

var $7Ea2A = parcelRequire("7Ea2A");
/** An error emitted by Sentry SDKs and related utilities. */ var $cfbffa0d82e9f720$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $7Ea2A.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("7Ea2A", function(module, exports) {

$parcel$export(module.exports, "setPrototypeOf", () => $59140eb715a52a9e$export$1cb0d91350beb6cc);
var $59140eb715a52a9e$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $59140eb715a52a9e$var$setProtoOf : $59140eb715a52a9e$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $59140eb715a52a9e$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $59140eb715a52a9e$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("laWAH", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $f6a7fb19d1657d17$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $f6a7fb19d1657d17$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("jLCUE", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", () => $e640975bb4e018bb$export$285b9172a3741fb7);

var $fKE23 = parcelRequire("fKE23");

var $laWAH = parcelRequire("laWAH");

var $1rQSq = parcelRequire("1rQSq");

var $bM45J = parcelRequire("bM45J");

var $4ihNC = parcelRequire("4ihNC");

var $koJfb = parcelRequire("koJfb");

var $bhTeQ = parcelRequire("bhTeQ");

var $bEOmW = parcelRequire("bEOmW");
var $e640975bb4e018bb$var$global = (0, $1rQSq.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $e640975bb4e018bb$var$handlers = {};
var $e640975bb4e018bb$var$instrumented = {};
/** Instruments given API */ function $e640975bb4e018bb$var$instrument(type) {
    if ($e640975bb4e018bb$var$instrumented[type]) return;
    $e640975bb4e018bb$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $e640975bb4e018bb$var$instrumentConsole();
            break;
        case 'dom':
            $e640975bb4e018bb$var$instrumentDOM();
            break;
        case 'xhr':
            $e640975bb4e018bb$var$instrumentXHR();
            break;
        case 'fetch':
            $e640975bb4e018bb$var$instrumentFetch();
            break;
        case 'history':
            $e640975bb4e018bb$var$instrumentHistory();
            break;
        case 'error':
            $e640975bb4e018bb$var$instrumentError();
            break;
        case 'unhandledrejection':
            $e640975bb4e018bb$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $laWAH.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $e640975bb4e018bb$export$285b9172a3741fb7(type, callback) {
    $e640975bb4e018bb$var$handlers[type] = $e640975bb4e018bb$var$handlers[type] || [];
    $e640975bb4e018bb$var$handlers[type].push(callback);
    $e640975bb4e018bb$var$instrument(type);
}
/** JSDoc */ function $e640975bb4e018bb$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$e640975bb4e018bb$var$handlers[type]) return;
    try {
        for(var _b = (0, $fKE23.__values)($e640975bb4e018bb$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $laWAH.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $bhTeQ.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $e640975bb4e018bb$var$instrumentConsole() {
    if (!('console' in $e640975bb4e018bb$var$global)) return;
    (0, $4ihNC.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $e640975bb4e018bb$var$global.console)) return;
        (0, $koJfb.fill)($e640975bb4e018bb$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $e640975bb4e018bb$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($e640975bb4e018bb$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $e640975bb4e018bb$var$instrumentFetch() {
    if (!(0, $bEOmW.supportsNativeFetch)()) return;
    (0, $koJfb.fill)($e640975bb4e018bb$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $e640975bb4e018bb$var$getFetchMethod(args),
                    url: $e640975bb4e018bb$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $e640975bb4e018bb$var$triggerHandlers('fetch', (0, $fKE23.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($e640975bb4e018bb$var$global, args).then(function(response) {
                $e640975bb4e018bb$var$triggerHandlers('fetch', (0, $fKE23.__assign)((0, $fKE23.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $e640975bb4e018bb$var$triggerHandlers('fetch', (0, $fKE23.__assign)((0, $fKE23.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $e640975bb4e018bb$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $e640975bb4e018bb$var$global && (0, $bM45J.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $e640975bb4e018bb$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $e640975bb4e018bb$var$global && (0, $bM45J.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $e640975bb4e018bb$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $e640975bb4e018bb$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $koJfb.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $bM45J.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $bM45J.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $e640975bb4e018bb$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $koJfb.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $koJfb.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $e640975bb4e018bb$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $e640975bb4e018bb$var$lastHref;
/** JSDoc */ function $e640975bb4e018bb$var$instrumentHistory() {
    if (!(0, $bEOmW.supportsHistory)()) return;
    var oldOnPopState = $e640975bb4e018bb$var$global.onpopstate;
    $e640975bb4e018bb$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $e640975bb4e018bb$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $e640975bb4e018bb$var$lastHref;
        $e640975bb4e018bb$var$lastHref = to;
        $e640975bb4e018bb$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $e640975bb4e018bb$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $e640975bb4e018bb$var$lastHref = to;
                $e640975bb4e018bb$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $koJfb.fill)($e640975bb4e018bb$var$global.history, 'pushState', historyReplacementFunction);
    (0, $koJfb.fill)($e640975bb4e018bb$var$global.history, 'replaceState', historyReplacementFunction);
}
var $e640975bb4e018bb$var$debounceDuration = 1000;
var $e640975bb4e018bb$var$debounceTimerID;
var $e640975bb4e018bb$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $e640975bb4e018bb$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $e640975bb4e018bb$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $e640975bb4e018bb$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $e640975bb4e018bb$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($e640975bb4e018bb$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($e640975bb4e018bb$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $e640975bb4e018bb$var$lastCapturedEvent = event;
        } else if ($e640975bb4e018bb$var$shouldShortcircuitPreviousDebounce($e640975bb4e018bb$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $e640975bb4e018bb$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($e640975bb4e018bb$var$debounceTimerID);
        $e640975bb4e018bb$var$debounceTimerID = $e640975bb4e018bb$var$global.setTimeout(function() {
            $e640975bb4e018bb$var$debounceTimerID = undefined;
        }, $e640975bb4e018bb$var$debounceDuration);
    };
}
/** JSDoc */ function $e640975bb4e018bb$var$instrumentDOM() {
    if (!('document' in $e640975bb4e018bb$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $e640975bb4e018bb$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $e640975bb4e018bb$var$makeDOMEventHandler(triggerDOMHandler, true);
    $e640975bb4e018bb$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $e640975bb4e018bb$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $e640975bb4e018bb$var$global[target] && $e640975bb4e018bb$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $koJfb.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $e640975bb4e018bb$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $koJfb.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $e640975bb4e018bb$var$_oldOnErrorHandler = null;
/** JSDoc */ function $e640975bb4e018bb$var$instrumentError() {
    $e640975bb4e018bb$var$_oldOnErrorHandler = $e640975bb4e018bb$var$global.onerror;
    $e640975bb4e018bb$var$global.onerror = function(msg, url, line, column, error) {
        $e640975bb4e018bb$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($e640975bb4e018bb$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $e640975bb4e018bb$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $e640975bb4e018bb$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $e640975bb4e018bb$var$instrumentUnhandledRejection() {
    $e640975bb4e018bb$var$_oldOnUnhandledRejectionHandler = $e640975bb4e018bb$var$global.onunhandledrejection;
    $e640975bb4e018bb$var$global.onunhandledrejection = function(e) {
        $e640975bb4e018bb$var$triggerHandlers('unhandledrejection', e);
        if ($e640975bb4e018bb$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $e640975bb4e018bb$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("4ihNC", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $3206a67408d171a1$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $3206a67408d171a1$export$af88d00dbe7f521);

var $fKE23 = parcelRequire("fKE23");

var $laWAH = parcelRequire("laWAH");

var $1rQSq = parcelRequire("1rQSq");
// TODO: Implement different loggers for different environments
var $3206a67408d171a1$var$global = (0, $1rQSq.getGlobalObject)();
/** Prefix for logging strings */ var $3206a67408d171a1$var$PREFIX = 'Sentry Logger ';
var $3206a67408d171a1$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $3206a67408d171a1$export$cda52e2a8927a2ca(callback) {
    var global = (0, $1rQSq.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $3206a67408d171a1$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $3206a67408d171a1$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $laWAH.IS_DEBUG_BUILD) $3206a67408d171a1$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $3206a67408d171a1$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $3206a67408d171a1$var$global.console)[name].apply(_a, (0, $fKE23.__spread)([
                    $3206a67408d171a1$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $3206a67408d171a1$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $3206a67408d171a1$export$af88d00dbe7f521;
if (0, $laWAH.IS_DEBUG_BUILD) $3206a67408d171a1$export$af88d00dbe7f521 = (0, $1rQSq.getGlobalSingleton)('logger', $3206a67408d171a1$var$makeLogger);
else $3206a67408d171a1$export$af88d00dbe7f521 = $3206a67408d171a1$var$makeLogger();

});

parcelRegister("koJfb", function(module, exports) {

$parcel$export(module.exports, "fill", () => $ed99250a1b0f7946$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $ed99250a1b0f7946$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $ed99250a1b0f7946$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $ed99250a1b0f7946$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $ed99250a1b0f7946$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $ed99250a1b0f7946$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $ed99250a1b0f7946$export$b0244d5063c0b61b);

var $fKE23 = parcelRequire("fKE23");

var $3WEbu = parcelRequire("3WEbu");

var $bM45J = parcelRequire("bM45J");

var $jZkqD = parcelRequire("jZkqD");
function $ed99250a1b0f7946$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $ed99250a1b0f7946$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $ed99250a1b0f7946$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $ed99250a1b0f7946$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $ed99250a1b0f7946$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $ed99250a1b0f7946$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $ed99250a1b0f7946$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $ed99250a1b0f7946$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $bM45J.isError)(value)) newObj = (0, $fKE23.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $ed99250a1b0f7946$var$getOwnProperties(value));
    else if ((0, $bM45J.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $fKE23.__assign)({
            type: event_1.type,
            target: $ed99250a1b0f7946$var$serializeEventTarget(event_1.target),
            currentTarget: $ed99250a1b0f7946$var$serializeEventTarget(event_1.currentTarget)
        }, $ed99250a1b0f7946$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $bM45J.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $ed99250a1b0f7946$var$serializeEventTarget(target) {
    try {
        return (0, $bM45J.isElement)(target) ? (0, $3WEbu.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $ed99250a1b0f7946$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $ed99250a1b0f7946$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($ed99250a1b0f7946$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $jZkqD.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $jZkqD.truncate)(serialized, maxLength);
    }
    return '';
}
function $ed99250a1b0f7946$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $bM45J.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $fKE23.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $ed99250a1b0f7946$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($ed99250a1b0f7946$export$d25f2688db1bb433);
    return val;
}
function $ed99250a1b0f7946$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $bM45J.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("jZkqD", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $03c159063c032d8b$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $03c159063c032d8b$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $03c159063c032d8b$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $03c159063c032d8b$export$cdded5b28a5f8c6d);

var $bM45J = parcelRequire("bM45J");
function $03c159063c032d8b$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $03c159063c032d8b$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $03c159063c032d8b$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $03c159063c032d8b$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $bM45J.isString)(value)) return false;
    if ((0, $bM45J.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $03c159063c032d8b$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("bhTeQ", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $837c2175fa65dee0$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $837c2175fa65dee0$export$aad197c7121a6651);

var $fKE23 = parcelRequire("fKE23");
var $837c2175fa65dee0$var$STACKTRACE_LIMIT = 50;
function $837c2175fa65dee0$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $fKE23.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $fKE23.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $837c2175fa65dee0$export$c55c24c0eeba0205(frames);
    };
}
function $837c2175fa65dee0$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $837c2175fa65dee0$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $837c2175fa65dee0$var$defaultFunctionName = '<anonymous>';
function $837c2175fa65dee0$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $837c2175fa65dee0$var$defaultFunctionName;
        return fn.name || $837c2175fa65dee0$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $837c2175fa65dee0$var$defaultFunctionName;
    }
}

});

parcelRegister("bEOmW", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", () => $87ca805ddaace2ec$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $87ca805ddaace2ec$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $87ca805ddaace2ec$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $87ca805ddaace2ec$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $87ca805ddaace2ec$export$67fc34576016d6ec);

var $laWAH = parcelRequire("laWAH");

var $1rQSq = parcelRequire("1rQSq");

var $4ihNC = parcelRequire("4ihNC");
function $87ca805ddaace2ec$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $87ca805ddaace2ec$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $87ca805ddaace2ec$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $87ca805ddaace2ec$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $1rQSq.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $87ca805ddaace2ec$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $87ca805ddaace2ec$export$c82d238e23c40b21() {
    if (!$87ca805ddaace2ec$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $1rQSq.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($87ca805ddaace2ec$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $87ca805ddaace2ec$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $laWAH.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $87ca805ddaace2ec$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $1rQSq.getGlobalObject)();
}
function $87ca805ddaace2ec$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$87ca805ddaace2ec$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $87ca805ddaace2ec$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $1rQSq.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("fR8Sp", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $b8b2b0f2a4fb7614$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $b8b2b0f2a4fb7614$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $b8b2b0f2a4fb7614$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $b8b2b0f2a4fb7614$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $b8b2b0f2a4fb7614$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $b8b2b0f2a4fb7614$export$6de4ffac6a2f1098);

var $fKE23 = parcelRequire("fKE23");

var $1rQSq = parcelRequire("1rQSq");

var $koJfb = parcelRequire("koJfb");

var $jZkqD = parcelRequire("jZkqD");
function $b8b2b0f2a4fb7614$export$19f53698e68b2496() {
    var global = (0, $1rQSq.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $b8b2b0f2a4fb7614$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $b8b2b0f2a4fb7614$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $b8b2b0f2a4fb7614$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $b8b2b0f2a4fb7614$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $b8b2b0f2a4fb7614$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $b8b2b0f2a4fb7614$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $b8b2b0f2a4fb7614$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $b8b2b0f2a4fb7614$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $b8b2b0f2a4fb7614$export$d364f2020ab30578(input) {
    var match = input.match($b8b2b0f2a4fb7614$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $b8b2b0f2a4fb7614$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $jZkqD.snipLine)(line, 0);
    });
    frame.context_line = (0, $jZkqD.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $jZkqD.snipLine)(line, 0);
    });
}
function $b8b2b0f2a4fb7614$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $b8b2b0f2a4fb7614$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $koJfb.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("kYiFy", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $f447e48ba08489bc$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $f447e48ba08489bc$export$23fbbb20bed71033);

var $fKE23 = parcelRequire("fKE23");

var $bM45J = parcelRequire("bM45J");

var $cXvA4 = parcelRequire("cXvA4");

var $koJfb = parcelRequire("koJfb");

var $bhTeQ = parcelRequire("bhTeQ");
function $f447e48ba08489bc$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $f447e48ba08489bc$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $f447e48ba08489bc$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $f447e48ba08489bc$export$a3295358bff77e(object, depth);
    if ($f447e48ba08489bc$var$jsonSize(normalized) > maxSize) return $f447e48ba08489bc$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $f447e48ba08489bc$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $cXvA4.memoBuilder)();
    var _a = (0, $fKE23.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $bM45J.isNaN)(value)) return value;
    var stringified = $f447e48ba08489bc$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $bM45J.isError)(value) || (0, $bM45J.isEvent)(value) ? (0, $koJfb.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $f447e48ba08489bc$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $f447e48ba08489bc$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $bM45J.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $bhTeQ.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $f447e48ba08489bc$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $f447e48ba08489bc$var$jsonSize(value) {
    return $f447e48ba08489bc$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("cXvA4", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $96f37dfd3c45e390$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $96f37dfd3c45e390$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("6m1BR", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", () => $4a060bcad656eeab$export$85a4f67f852183e6);

var $hPQzi = parcelRequire("hPQzi");

var $8RBQ1 = parcelRequire("8RBQ1");
function $4a060bcad656eeab$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $8RBQ1.rejectedSyncPromise)(new (0, $hPQzi.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $8RBQ1.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $8RBQ1.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("8RBQ1", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $67409fd3eaff7026$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $67409fd3eaff7026$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $67409fd3eaff7026$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $bM45J = parcelRequire("bM45J");
function $67409fd3eaff7026$export$1fda8aa4d135f8aa(value) {
    return new $67409fd3eaff7026$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $67409fd3eaff7026$export$78e43115b553f358(reason) {
    return new $67409fd3eaff7026$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $67409fd3eaff7026$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $bM45J.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("9pvxT", function(module, exports) {

$parcel$export(module.exports, "severityFromString", () => $6d9eeb265cf082c3$export$e01cef29b4327697);

var $9CfQ8 = parcelRequire("9CfQ8");

var $aSeHW = parcelRequire("aSeHW");
function $6d9eeb265cf082c3$var$isSupportedSeverity(level) {
    return (0, $aSeHW.SeverityLevels).indexOf(level) !== -1;
}
function $6d9eeb265cf082c3$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $9CfQ8.Severity).Warning;
    if ($6d9eeb265cf082c3$var$isSupportedSeverity(level)) return level;
    return (0, $9CfQ8.Severity).Log;
}

});
parcelRegister("9CfQ8", function(module, exports) {

$parcel$export(module.exports, "Severity", () => $7003f327588a70dd$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $7003f327588a70dd$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($7003f327588a70dd$export$918a9776c0a3cf27 || ($7003f327588a70dd$export$918a9776c0a3cf27 = {}));
var $7003f327588a70dd$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("aSeHW", function(module, exports) {

$parcel$export(module.exports, "SeverityLevels", () => $7eaa5b2bce2bd078$export$484b1ea9aec914c);
var $7eaa5b2bce2bd078$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("jYkUl", function(module, exports) {

$parcel$export(module.exports, "eventStatusFromHttpCode", () => $e8a3d6c7ad6c1793$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $e8a3d6c7ad6c1793$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("cIM48", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);

var $1rQSq = parcelRequire("1rQSq");

var $7QqGh = parcelRequire("7QqGh");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $1rQSq.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $7QqGh.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $7QqGh.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $1rQSq.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("57nRK", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", () => $3ba01e74a3e851d0$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $3ba01e74a3e851d0$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $3ba01e74a3e851d0$export$32f9b428425aac85);

var $fKE23 = parcelRequire("fKE23");

var $bM45J = parcelRequire("bM45J");
function $3ba01e74a3e851d0$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $3ba01e74a3e851d0$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $fKE23.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $fKE23.__spread)(items, [
            newItem
        ])
    ];
}
function $3ba01e74a3e851d0$export$d84939284bbafcd4(envelope) {
    var _a = (0, $fKE23.__read)(envelope, 2), _b = (0, $fKE23.__read)(_a[1], 1), _c = (0, $fKE23.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $3ba01e74a3e851d0$export$32f9b428425aac85(envelope) {
    var _a = (0, $fKE23.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $fKE23.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $bM45J.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("a44V3", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", () => $753e17fbbc63b41e$export$f3b9ed77c03eeb00);

var $57nRK = parcelRequire("57nRK");

var $cIM48 = parcelRequire("cIM48");
function $753e17fbbc63b41e$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $cIM48.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $57nRK.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("4Y7Sc", function(module, exports) {

$parcel$export(module.exports, "disabledUntil", () => $39e2df789c1b4b6e$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $39e2df789c1b4b6e$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $39e2df789c1b4b6e$export$699aff705e0d49d4);

var $fKE23 = parcelRequire("fKE23");
var $39e2df789c1b4b6e$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $39e2df789c1b4b6e$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $39e2df789c1b4b6e$export$b09ce39faaeb1e7c;
}
function $39e2df789c1b4b6e$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $39e2df789c1b4b6e$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $39e2df789c1b4b6e$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $39e2df789c1b4b6e$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $fKE23.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $fKE23.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $fKE23.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $39e2df789c1b4b6e$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("2k7cn", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $1b1308872def4a55$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $1b1308872def4a55$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("9LhPA", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("fM3N0")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("hT1GJ")).InboundFilters);

var $fM3N0 = parcelRequire("fM3N0");

var $hT1GJ = parcelRequire("hT1GJ");

});
parcelRegister("fM3N0", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", () => $b7be4737ce5faef7$export$da4704525c20ae79);
parcelRequire("lRNHc");
var $koJfb = parcelRequire("koJfb");
var $b7be4737ce5faef7$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $b7be4737ce5faef7$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $b7be4737ce5faef7$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $koJfb.getOriginalFunction)(this) || this;
            return $b7be4737ce5faef7$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

});

parcelRegister("hT1GJ", function(module, exports) {

$parcel$export(module.exports, "InboundFilters", () => $d058e1f531d0f771$export$2ffbb5359dcc6be4);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("lRNHc");
var $fR8Sp = parcelRequire("fR8Sp");
var $jZkqD = parcelRequire("jZkqD");
var $4ihNC = parcelRequire("4ihNC");

var $2k7cn = parcelRequire("2k7cn");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $d058e1f531d0f771$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $d058e1f531d0f771$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $d058e1f531d0f771$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $d058e1f531d0f771$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $d058e1f531d0f771$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $fKE23.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $fKE23.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $fKE23.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $d058e1f531d0f771$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $d058e1f531d0f771$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $d058e1f531d0f771$var$_isSentryError(event)) {
        (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $fR8Sp.getEventDescription)(event));
        return true;
    }
    if ($d058e1f531d0f771$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $fR8Sp.getEventDescription)(event));
        return true;
    }
    if ($d058e1f531d0f771$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $fR8Sp.getEventDescription)(event) + ".\nUrl: " + $d058e1f531d0f771$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$d058e1f531d0f771$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $fR8Sp.getEventDescription)(event) + ".\nUrl: " + $d058e1f531d0f771$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $d058e1f531d0f771$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $d058e1f531d0f771$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $jZkqD.isMatchingPattern)(message, pattern);
        });
    });
}
function $d058e1f531d0f771$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $d058e1f531d0f771$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $jZkqD.isMatchingPattern)(url, pattern);
    });
}
function $d058e1f531d0f771$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $d058e1f531d0f771$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $jZkqD.isMatchingPattern)(url, pattern);
    });
}
function $d058e1f531d0f771$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error("Cannot extract message for event " + (0, $fR8Sp.getEventDescription)(event));
        return [];
    }
    return [];
}
function $d058e1f531d0f771$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $d058e1f531d0f771$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $d058e1f531d0f771$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $d058e1f531d0f771$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $d058e1f531d0f771$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error("Cannot extract url for event " + (0, $fR8Sp.getEventDescription)(event));
        return null;
    }
}

});


parcelRegister("cUpUA", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", () => $965ed08b1345c82e$export$1df9218a526d318d);

var $fKE23 = parcelRequire("fKE23");

var $1QLbS = parcelRequire("1QLbS");
var $aMkFn = parcelRequire("aMkFn");
parcelRequire("lRNHc");
var $1rQSq = parcelRequire("1rQSq");
var $4ihNC = parcelRequire("4ihNC");

var $kOc6P = parcelRequire("kOc6P");

var $ed0Qo = parcelRequire("ed0Qo");

var $dCjZk = parcelRequire("dCjZk");

var $793hP = parcelRequire("793hP");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $965ed08b1345c82e$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $fKE23.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $aMkFn.SDK_VERSION)
                }
            ],
            version: (0, $aMkFn.SDK_VERSION)
        };
        _this = _super.call(this, (0, $kOc6P.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $1rQSq.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $dCjZk.injectReportDialog)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $793hP.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $1QLbS.BaseClient));

});
parcelRegister("1QLbS", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $158f40dba79b7196$export$4f22f74eddb7716a);

var $fKE23 = parcelRequire("fKE23");

var $87JfJ = parcelRequire("87JfJ");
parcelRequire("lRNHc");
var $fR8Sp = parcelRequire("fR8Sp");
var $cIM48 = parcelRequire("cIM48");
var $bM45J = parcelRequire("bM45J");
var $4ihNC = parcelRequire("4ihNC");
var $fKQSd = parcelRequire("fKQSd");
var $kYiFy = parcelRequire("kYiFy");
var $8RBQ1 = parcelRequire("8RBQ1");
var $hPQzi = parcelRequire("hPQzi");
var $jZkqD = parcelRequire("jZkqD");

var $2k7cn = parcelRequire("2k7cn");

var $hW6bp = parcelRequire("hW6bp");
var $158f40dba79b7196$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $158f40dba79b7196$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $fKQSd.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $fR8Sp.checkOrSetAlreadyCaught)(exception)) {
            (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).log($158f40dba79b7196$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $bM45J.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $fR8Sp.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).log($158f40dba79b7196$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $hW6bp.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $fKE23.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $fKE23.__assign)((0, $fKE23.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $8RBQ1.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $fR8Sp.uuid4)()),
            timestamp: event.timestamp || (0, $cIM48.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $87JfJ.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $8RBQ1.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $kYiFy.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, b), b.data && {
                    data: (0, $kYiFy.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $kYiFy.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $kYiFy.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $kYiFy.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $jZkqD.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $jZkqD.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $jZkqD.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $fKE23.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $8RBQ1.rejectedSyncPromise)(new (0, $hPQzi.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $8RBQ1.rejectedSyncPromise)(new (0, $hPQzi.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $hPQzi.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $158f40dba79b7196$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $hPQzi.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $hPQzi.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $hPQzi.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $158f40dba79b7196$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $bM45J.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $bM45J.isPlainObject)(event) || event === null)) throw new (0, $hPQzi.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $hPQzi.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $bM45J.isPlainObject)(rv) || rv === null)) throw new (0, $hPQzi.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("hW6bp", function(module, exports) {

$parcel$export(module.exports, "setupIntegrations", () => $d0eca63fa74c7a13$export$51abed9797baa598);

var $fKE23 = parcelRequire("fKE23");

var $87JfJ = parcelRequire("87JfJ");
var $OArqR = parcelRequire("OArqR");
parcelRequire("lRNHc");
var $koJfb = parcelRequire("koJfb");
var $4ihNC = parcelRequire("4ihNC");

var $2k7cn = parcelRequire("2k7cn");
var $d0eca63fa74c7a13$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $d0eca63fa74c7a13$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $d0eca63fa74c7a13$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $fKE23.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $fKE23.__spread)($d0eca63fa74c7a13$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $fKE23.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $d0eca63fa74c7a13$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $fKE23.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $d0eca63fa74c7a13$export$e7390a03b70a6f2f(integration) {
    if ($d0eca63fa74c7a13$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $87JfJ.addGlobalEventProcessor), (0, $OArqR.getCurrentHub));
    $d0eca63fa74c7a13$export$b14a8888f80a0b3e.push(integration.name);
    (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).log("Integration installed: " + integration.name);
}
function $d0eca63fa74c7a13$export$51abed9797baa598(options) {
    var integrations = {};
    $d0eca63fa74c7a13$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $d0eca63fa74c7a13$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $koJfb.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("aMkFn", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $7d8e6af7c0563c58$export$31499a9cd224b78c);
var $7d8e6af7c0563c58$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("kOc6P", function(module, exports) {

$parcel$export(module.exports, "BrowserBackend", () => $f261dec4b9d8c720$export$2526e21aec9d0ce7);

var $fKE23 = parcelRequire("fKE23");

var $e66so = parcelRequire("e66so");
var $kWRpG = parcelRequire("kWRpG");

var $9CfQ8 = parcelRequire("9CfQ8");
parcelRequire("lRNHc");
var $bEOmW = parcelRequire("bEOmW");

var $48jhe = parcelRequire("48jhe");

var $akLHM = parcelRequire("akLHM");
var $5R72e = parcelRequire("5R72e");
var $fDLAC = parcelRequire("fDLAC");
var $7ROu5 = parcelRequire("7ROu5");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $f261dec4b9d8c720$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $48jhe.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $9CfQ8.Severity).Info;
        return (0, $48jhe.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $kWRpG.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $kWRpG.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $bEOmW.supportsFetch)()) {
            var requestOptions = (0, $fKE23.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $5R72e.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $akLHM.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $fDLAC.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $7ROu5.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $e66so.BaseBackend));

});
parcelRegister("e66so", function(module, exports) {

$parcel$export(module.exports, "BaseBackend", () => $a436a27552c4007b$export$8f43a53a38d7e95f);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("lRNHc");
var $4ihNC = parcelRequire("4ihNC");
var $hPQzi = parcelRequire("hPQzi");

var $kWRpG = parcelRequire("kWRpG");

var $2k7cn = parcelRequire("2k7cn");

var $g1YE9 = parcelRequire("g1YE9");

var $4EJtD = parcelRequire("4EJtD");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $a436a27552c4007b$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $hPQzi.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $hPQzi.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $kWRpG.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $g1YE9.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $kWRpG.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $fKE23.__read)((0, $g1YE9.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $2k7cn.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $4EJtD.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("kWRpG", function(module, exports) {

$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $f402a83583613b98$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $f402a83583613b98$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $f402a83583613b98$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $f402a83583613b98$export$671c7ed8e40a7a57);
parcelRequire("lRNHc");
var $fKQSd = parcelRequire("fKQSd");
var $koJfb = parcelRequire("koJfb");
var $f402a83583613b98$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $f402a83583613b98$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $fKQSd.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $f402a83583613b98$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $f402a83583613b98$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $f402a83583613b98$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $f402a83583613b98$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $f402a83583613b98$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $fKQSd.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $f402a83583613b98$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $f402a83583613b98$var$_getIngestEndpoint(dsn, target) {
    return "" + $f402a83583613b98$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $f402a83583613b98$var$_encodedAuth(dsn) {
    return (0, $koJfb.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $f402a83583613b98$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $f402a83583613b98$var$getStoreEndpoint(dsn) {
    return $f402a83583613b98$var$_getIngestEndpoint(dsn, 'store');
}
function $f402a83583613b98$export$c1677e22ac2217a5(dsn) {
    return $f402a83583613b98$var$getStoreEndpoint(dsn) + "?" + $f402a83583613b98$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $f402a83583613b98$var$_getEnvelopeEndpoint(dsn) {
    return $f402a83583613b98$var$_getIngestEndpoint(dsn, 'envelope');
}
function $f402a83583613b98$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $f402a83583613b98$var$_getEnvelopeEndpoint(dsn) + "?" + $f402a83583613b98$var$_encodedAuth(dsn);
}
function $f402a83583613b98$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $f402a83583613b98$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $f402a83583613b98$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $fKQSd.makeDsn)(dsnLike);
    var endpoint = $f402a83583613b98$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $fKQSd.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("g1YE9", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", () => $babbc87d690535a5$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $babbc87d690535a5$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $babbc87d690535a5$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $babbc87d690535a5$export$2006389de558b996);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("lRNHc");
var $57nRK = parcelRequire("57nRK");
var $fKQSd = parcelRequire("fKQSd");
var $kYiFy = parcelRequire("kYiFy");

var $kWRpG = parcelRequire("kWRpG");
/** Extract sdk info from from the API metadata */ function $babbc87d690535a5$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $babbc87d690535a5$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $fKE23.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $fKE23.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $babbc87d690535a5$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $babbc87d690535a5$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $fKE23.__assign)((0, $fKE23.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $fKQSd.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $57nRK.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $babbc87d690535a5$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $fKE23.__read)($babbc87d690535a5$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $57nRK.serializeEnvelope)(envelope),
        type: type,
        url: (0, $kWRpG.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $babbc87d690535a5$export$c31057337a18010f(event, api) {
    var sdkInfo = $babbc87d690535a5$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $babbc87d690535a5$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $fKE23.__assign)((0, $fKE23.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $fKQSd.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $57nRK.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $babbc87d690535a5$export$2006389de558b996(event, api) {
    var sdkInfo = $babbc87d690535a5$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $babbc87d690535a5$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $kYiFy.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $kWRpG.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $kWRpG.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $fKE23.__assign)((0, $fKE23.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $fKQSd.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $57nRK.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $57nRK.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("4EJtD", function(module, exports) {

$parcel$export(module.exports, "NoopTransport", () => $363e2ca13d915960$export$6f2767450ea1346c);
parcelRequire("lRNHc");
var $8RBQ1 = parcelRequire("8RBQ1");
/** Noop transport */ var $363e2ca13d915960$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $8RBQ1.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $8RBQ1.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("48jhe", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", () => $3026dccbe1b9bf21$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $3026dccbe1b9bf21$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $3026dccbe1b9bf21$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $3026dccbe1b9bf21$export$5425b53185d13d6c);

var $fKE23 = parcelRequire("fKE23");

var $9CfQ8 = parcelRequire("9CfQ8");
parcelRequire("lRNHc");
var $fR8Sp = parcelRequire("fR8Sp");
var $bhTeQ = parcelRequire("bhTeQ");
var $koJfb = parcelRequire("koJfb");
var $bM45J = parcelRequire("bM45J");
var $kYiFy = parcelRequire("kYiFy");
var $8RBQ1 = parcelRequire("8RBQ1");

var $6heex = parcelRequire("6heex");
function $3026dccbe1b9bf21$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $3026dccbe1b9bf21$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $3026dccbe1b9bf21$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $3026dccbe1b9bf21$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $bM45J.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $koJfb.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $kYiFy.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $3026dccbe1b9bf21$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $3026dccbe1b9bf21$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $3026dccbe1b9bf21$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $3026dccbe1b9bf21$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $3026dccbe1b9bf21$var$getPopSize(ex);
    try {
        return (0, $bhTeQ.createStackParser)((0, $6heex.opera10StackParser), (0, $6heex.opera11StackParser), (0, $6heex.chromeStackParser), (0, $6heex.winjsStackParser), (0, $6heex.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $3026dccbe1b9bf21$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $3026dccbe1b9bf21$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($3026dccbe1b9bf21$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $3026dccbe1b9bf21$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $3026dccbe1b9bf21$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $3026dccbe1b9bf21$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $fR8Sp.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $9CfQ8.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $8RBQ1.resolvedSyncPromise)(event);
}
function $3026dccbe1b9bf21$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $9CfQ8.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $3026dccbe1b9bf21$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $8RBQ1.resolvedSyncPromise)(event);
}
function $3026dccbe1b9bf21$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $bM45J.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $3026dccbe1b9bf21$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $bM45J.isDOMError)(exception) || (0, $bM45J.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $3026dccbe1b9bf21$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $bM45J.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $3026dccbe1b9bf21$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $fR8Sp.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $bM45J.isError)(exception)) // we have a real Error object, do nothing
    return $3026dccbe1b9bf21$export$73fbea5a0a5234af(exception);
    if ((0, $bM45J.isPlainObject)(exception) || (0, $bM45J.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $3026dccbe1b9bf21$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $fR8Sp.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $3026dccbe1b9bf21$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $fR8Sp.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $fR8Sp.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $3026dccbe1b9bf21$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $3026dccbe1b9bf21$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("6heex", function(module, exports) {

$parcel$export(module.exports, "chromeStackParser", () => $491f5f0fa2cf668b$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $491f5f0fa2cf668b$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $491f5f0fa2cf668b$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $491f5f0fa2cf668b$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $491f5f0fa2cf668b$export$989a1824b4734ce6);

var $fKE23 = parcelRequire("fKE23");
// global reference to slice
var $491f5f0fa2cf668b$var$UNKNOWN_FUNCTION = '?';
var $491f5f0fa2cf668b$var$OPERA10_PRIORITY = 10;
var $491f5f0fa2cf668b$var$OPERA11_PRIORITY = 20;
var $491f5f0fa2cf668b$var$CHROME_PRIORITY = 30;
var $491f5f0fa2cf668b$var$WINJS_PRIORITY = 40;
var $491f5f0fa2cf668b$var$GECKO_PRIORITY = 50;
function $491f5f0fa2cf668b$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $491f5f0fa2cf668b$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $491f5f0fa2cf668b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $491f5f0fa2cf668b$var$chrome = function(line) {
    var parts = $491f5f0fa2cf668b$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $491f5f0fa2cf668b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $fKE23.__read)($491f5f0fa2cf668b$var$extractSafariExtensionDetails(parts[1] || $491f5f0fa2cf668b$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $491f5f0fa2cf668b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $491f5f0fa2cf668b$export$c693d9295441d8f9 = [
    $491f5f0fa2cf668b$var$CHROME_PRIORITY,
    $491f5f0fa2cf668b$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $491f5f0fa2cf668b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $491f5f0fa2cf668b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $491f5f0fa2cf668b$var$gecko = function(line) {
    var _a;
    var parts = $491f5f0fa2cf668b$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $491f5f0fa2cf668b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $491f5f0fa2cf668b$var$UNKNOWN_FUNCTION;
        _a = (0, $fKE23.__read)($491f5f0fa2cf668b$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $491f5f0fa2cf668b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $491f5f0fa2cf668b$export$c9ddf1e2b5d48bff = [
    $491f5f0fa2cf668b$var$GECKO_PRIORITY,
    $491f5f0fa2cf668b$var$gecko
];
var $491f5f0fa2cf668b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $491f5f0fa2cf668b$var$winjs = function(line) {
    var parts = $491f5f0fa2cf668b$var$winjsRegex.exec(line);
    return parts ? $491f5f0fa2cf668b$var$createFrame(parts[2], parts[1] || $491f5f0fa2cf668b$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $491f5f0fa2cf668b$export$b6d155d85c1dcba5 = [
    $491f5f0fa2cf668b$var$WINJS_PRIORITY,
    $491f5f0fa2cf668b$var$winjs
];
var $491f5f0fa2cf668b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $491f5f0fa2cf668b$var$opera10 = function(line) {
    var parts = $491f5f0fa2cf668b$var$opera10Regex.exec(line);
    return parts ? $491f5f0fa2cf668b$var$createFrame(parts[2], parts[3] || $491f5f0fa2cf668b$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $491f5f0fa2cf668b$export$966ec832d9699d6 = [
    $491f5f0fa2cf668b$var$OPERA10_PRIORITY,
    $491f5f0fa2cf668b$var$opera10
];
var $491f5f0fa2cf668b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $491f5f0fa2cf668b$var$opera11 = function(line) {
    var parts = $491f5f0fa2cf668b$var$opera11Regex.exec(line);
    return parts ? $491f5f0fa2cf668b$var$createFrame(parts[5], parts[3] || parts[4] || $491f5f0fa2cf668b$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $491f5f0fa2cf668b$export$989a1824b4734ce6 = [
    $491f5f0fa2cf668b$var$OPERA11_PRIORITY,
    $491f5f0fa2cf668b$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $491f5f0fa2cf668b$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $491f5f0fa2cf668b$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("akLHM", function(module, exports) {

$parcel$export(module.exports, "FetchTransport", () => $7860c6e7d758df53$export$2bdee3f9b92f4e82);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("lRNHc");
var $hPQzi = parcelRequire("hPQzi");
var $bEOmW = parcelRequire("bEOmW");
var $8RBQ1 = parcelRequire("8RBQ1");

var $dUu27 = parcelRequire("dUu27");

var $cCEk1 = parcelRequire("cCEk1");
/** `fetch` based transport */ var $7860c6e7d758df53$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $cCEk1.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $bEOmW.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $8RBQ1.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $hPQzi.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $dUu27.BaseTransport));

});
parcelRegister("dUu27", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", () => $a207cd4592a59b9d$export$74b99d619e90f481);

var $fKE23 = parcelRequire("fKE23");

var $g1YE9 = parcelRequire("g1YE9");
var $kWRpG = parcelRequire("kWRpG");
parcelRequire("lRNHc");
var $a44V3 = parcelRequire("a44V3");
var $4Y7Sc = parcelRequire("4Y7Sc");
var $fKQSd = parcelRequire("fKQSd");
var $jYkUl = parcelRequire("jYkUl");
var $1rQSq = parcelRequire("1rQSq");
var $4ihNC = parcelRequire("4ihNC");
var $6m1BR = parcelRequire("6m1BR");
var $57nRK = parcelRequire("57nRK");

var $ed0Qo = parcelRequire("ed0Qo");

var $cCEk1 = parcelRequire("cCEk1");
function $a207cd4592a59b9d$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $a207cd4592a59b9d$var$global = (0, $1rQSq.getGlobalObject)();
/** Base Transport class implementation */ var $a207cd4592a59b9d$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $6m1BR.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $kWRpG.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $kWRpG.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $a207cd4592a59b9d$var$global.document) $a207cd4592a59b9d$var$global.document.addEventListener('visibilitychange', function() {
            if ($a207cd4592a59b9d$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $g1YE9.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $g1YE9.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $a207cd4592a59b9d$var$requestTypeToCategory(category) + ":" + reason;
        (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).log('No outcomes to flush');
            return;
        }
        (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $kWRpG.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $fKE23.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $a44V3.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $fKQSd.dsnToString)(this._api.dsn));
        try {
            (0, $cCEk1.sendReport)(url, (0, $57nRK.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $jYkUl.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $4Y7Sc.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $ed0Qo.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $4ihNC.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $a207cd4592a59b9d$var$requestTypeToCategory(requestType);
        return new Date((0, $4Y7Sc.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $a207cd4592a59b9d$var$requestTypeToCategory(requestType);
        return (0, $4Y7Sc.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("ed0Qo", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $a582ef2eab5a0ca0$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $a582ef2eab5a0ca0$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("cCEk1", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", () => $93084fba2685716c$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $93084fba2685716c$export$84bb63b2c17ec44d);
parcelRequire("lRNHc");
var $bplvQ = parcelRequire("bplvQ");
var $1rQSq = parcelRequire("1rQSq");
var $bEOmW = parcelRequire("bEOmW");
var $4ihNC = parcelRequire("4ihNC");

var $ed0Qo = parcelRequire("ed0Qo");
var $93084fba2685716c$var$global = (0, $1rQSq.getGlobalObject)();
var $93084fba2685716c$var$cachedFetchImpl;
function $93084fba2685716c$export$8be2119ce08e3379() {
    if ($93084fba2685716c$var$cachedFetchImpl) return $93084fba2685716c$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $bEOmW.isNativeFetch)($93084fba2685716c$var$global.fetch)) return $93084fba2685716c$var$cachedFetchImpl = $93084fba2685716c$var$global.fetch.bind($93084fba2685716c$var$global);
    var document = $93084fba2685716c$var$global.document;
    var fetchImpl = $93084fba2685716c$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $93084fba2685716c$var$cachedFetchImpl = fetchImpl.bind($93084fba2685716c$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $93084fba2685716c$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($93084fba2685716c$var$global && $93084fba2685716c$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $93084fba2685716c$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $93084fba2685716c$var$global.navigator.sendBeacon.bind($93084fba2685716c$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $bEOmW.supportsFetch)()) {
        var fetch_1 = $93084fba2685716c$export$8be2119ce08e3379();
        return (0, $bplvQ.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("5R72e", function(module, exports) {

$parcel$export(module.exports, "makeNewFetchTransport", () => $44375bfb03c1e4db$export$1c57e6bfd09bad13);

var $fKE23 = parcelRequire("fKE23");

var $3Cvoq = parcelRequire("3Cvoq");

var $cCEk1 = parcelRequire("cCEk1");
function $44375bfb03c1e4db$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $cCEk1.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $fKE23.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $3Cvoq.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("3Cvoq", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $2a2d45aee687c4be$export$d09f50d9ab7f7b69);
parcelRequire("lRNHc");
var $4Y7Sc = parcelRequire("4Y7Sc");
var $jYkUl = parcelRequire("jYkUl");
var $57nRK = parcelRequire("57nRK");
var $6m1BR = parcelRequire("6m1BR");
var $8RBQ1 = parcelRequire("8RBQ1");
var $2a2d45aee687c4be$export$d8a725a7dce95622 = 'error';
var $2a2d45aee687c4be$export$99adc6fe67a3c63e = 'transaction';
var $2a2d45aee687c4be$export$9d7ad34f132fe68f = 'attachment';
var $2a2d45aee687c4be$export$42d9e7b5fc564c45 = 'session';
var $2a2d45aee687c4be$export$e515cf6dfd2f98b8 = 30;
function $2a2d45aee687c4be$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $6m1BR.makePromiseBuffer)(options.bufferSize || $2a2d45aee687c4be$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $57nRK.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $57nRK.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $4Y7Sc.isRateLimited)(rateLimits, category)) return (0, $8RBQ1.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $2a2d45aee687c4be$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $jYkUl.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $4Y7Sc.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $8RBQ1.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $8RBQ1.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $2a2d45aee687c4be$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $2a2d45aee687c4be$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $4Y7Sc.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("fDLAC", function(module, exports) {

$parcel$export(module.exports, "makeNewXHRTransport", () => $b62f69dca3f3629d$export$4c0ac1dd4bbf4921);

var $3Cvoq = parcelRequire("3Cvoq");
parcelRequire("lRNHc");
var $8RBQ1 = parcelRequire("8RBQ1");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $b62f69dca3f3629d$var$XHR_READYSTATE_DONE = 4;
function $b62f69dca3f3629d$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $8RBQ1.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $b62f69dca3f3629d$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $3Cvoq.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("7ROu5", function(module, exports) {

$parcel$export(module.exports, "XHRTransport", () => $5ba4a4c325aaa8e3$export$874a283af77e8e62);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("lRNHc");
var $hPQzi = parcelRequire("hPQzi");
var $8RBQ1 = parcelRequire("8RBQ1");

var $dUu27 = parcelRequire("dUu27");
/** `XHR` based transport */ var $5ba4a4c325aaa8e3$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $8RBQ1.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $hPQzi.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $dUu27.BaseTransport));

});


parcelRegister("dCjZk", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreOnError", () => $9e9e5436492ba8ac$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $9e9e5436492ba8ac$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $9e9e5436492ba8ac$export$deb9aac8ea0b576c);

var $fKE23 = parcelRequire("fKE23");

var $cZi0S = parcelRequire("cZi0S");
var $kWRpG = parcelRequire("kWRpG");
parcelRequire("lRNHc");
var $fR8Sp = parcelRequire("fR8Sp");
var $koJfb = parcelRequire("koJfb");
var $1rQSq = parcelRequire("1rQSq");
var $4ihNC = parcelRequire("4ihNC");

var $ed0Qo = parcelRequire("ed0Qo");
var $9e9e5436492ba8ac$var$global = (0, $1rQSq.getGlobalObject)();
var $9e9e5436492ba8ac$var$ignoreOnError = 0;
function $9e9e5436492ba8ac$export$b79738ab10c590b2() {
    return $9e9e5436492ba8ac$var$ignoreOnError > 0;
}
function $9e9e5436492ba8ac$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9e9e5436492ba8ac$var$ignoreOnError += 1;
    setTimeout(function() {
        $9e9e5436492ba8ac$var$ignoreOnError -= 1;
    });
}
function $9e9e5436492ba8ac$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $koJfb.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $9e9e5436492ba8ac$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9e9e5436492ba8ac$export$1265a142ff5ba165();
            (0, $cZi0S.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $fR8Sp.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $fR8Sp.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $cZi0S.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $koJfb.markFunctionWrapped)(sentryWrapped, fn);
    (0, $koJfb.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $9e9e5436492ba8ac$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$9e9e5436492ba8ac$var$global.document) return;
    if (!options.eventId) {
        (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $9e9e5436492ba8ac$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $kWRpG.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $9e9e5436492ba8ac$var$global.document.head || $9e9e5436492ba8ac$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("793hP", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $533bec4ef9f7790d$export$2dc68d50d56fbbd);

var $fKE23 = parcelRequire("fKE23");

var $OArqR = parcelRequire("OArqR");

var $9CfQ8 = parcelRequire("9CfQ8");
parcelRequire("lRNHc");
var $jLCUE = parcelRequire("jLCUE");
var $fR8Sp = parcelRequire("fR8Sp");
var $1rQSq = parcelRequire("1rQSq");
var $3WEbu = parcelRequire("3WEbu");
var $jZkqD = parcelRequire("jZkqD");
var $9pvxT = parcelRequire("9pvxT");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $533bec4ef9f7790d$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $fKE23.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $OArqR.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $fR8Sp.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $jLCUE.addInstrumentationHandler)('console', $533bec4ef9f7790d$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $jLCUE.addInstrumentationHandler)('dom', $533bec4ef9f7790d$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $jLCUE.addInstrumentationHandler)('xhr', $533bec4ef9f7790d$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $jLCUE.addInstrumentationHandler)('fetch', $533bec4ef9f7790d$var$_fetchBreadcrumb);
        if (this._options.history) (0, $jLCUE.addInstrumentationHandler)('history', $533bec4ef9f7790d$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $533bec4ef9f7790d$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $3WEbu.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $3WEbu.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $OArqR.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $533bec4ef9f7790d$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $9pvxT.severityFromString)(handlerData.level),
        message: (0, $jZkqD.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $jZkqD.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $OArqR.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $533bec4ef9f7790d$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $OArqR.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $533bec4ef9f7790d$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $OArqR.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $9CfQ8.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $OArqR.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $533bec4ef9f7790d$var$_historyBreadcrumb(handlerData) {
    var global = (0, $1rQSq.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $fR8Sp.parseUrl)(global.location.href);
    var parsedFrom = (0, $fR8Sp.parseUrl)(from);
    var parsedTo = (0, $fR8Sp.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $OArqR.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("aFRiS", function(module, exports) {

$parcel$export(module.exports, "Dedupe", () => $7c5714a7b4422698$export$688d98c249d31ad3);
parcelRequire("lRNHc");
var $4ihNC = parcelRequire("4ihNC");

var $ed0Qo = parcelRequire("ed0Qo");
/** Deduplication filter */ var $7c5714a7b4422698$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($7c5714a7b4422698$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $7c5714a7b4422698$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($7c5714a7b4422698$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($7c5714a7b4422698$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $7c5714a7b4422698$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$7c5714a7b4422698$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$7c5714a7b4422698$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $7c5714a7b4422698$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $7c5714a7b4422698$var$_getExceptionFromEvent(previousEvent);
    var currentException = $7c5714a7b4422698$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$7c5714a7b4422698$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$7c5714a7b4422698$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $7c5714a7b4422698$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $7c5714a7b4422698$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $7c5714a7b4422698$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $7c5714a7b4422698$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $7c5714a7b4422698$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $7c5714a7b4422698$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});

parcelRegister("5rouO", function(module, exports) {

$parcel$export(module.exports, "GlobalHandlers", () => $3f6279bff428b9e1$export$204155decbc90e5a);

var $fKE23 = parcelRequire("fKE23");

var $OArqR = parcelRequire("OArqR");

var $9CfQ8 = parcelRequire("9CfQ8");
parcelRequire("lRNHc");
var $fR8Sp = parcelRequire("fR8Sp");
var $jLCUE = parcelRequire("jLCUE");
var $3WEbu = parcelRequire("3WEbu");
var $bM45J = parcelRequire("bM45J");
var $4ihNC = parcelRequire("4ihNC");

var $48jhe = parcelRequire("48jhe");

var $ed0Qo = parcelRequire("ed0Qo");

var $dCjZk = parcelRequire("dCjZk");
/** Global handlers */ var $3f6279bff428b9e1$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $3f6279bff428b9e1$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $3f6279bff428b9e1$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $fKE23.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $3f6279bff428b9e1$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $3f6279bff428b9e1$var$_installGlobalOnErrorHandler() {
    (0, $jLCUE.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $fKE23.__read)($3f6279bff428b9e1$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($3f6279bff428b9e1$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $dCjZk.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $bM45J.isString)(msg) ? $3f6279bff428b9e1$var$_eventFromIncompleteOnError(msg, url, line, column) : $3f6279bff428b9e1$var$_enhanceEventWithInitialFrame((0, $48jhe.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $9CfQ8.Severity).Error;
        $3f6279bff428b9e1$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $3f6279bff428b9e1$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $jLCUE.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $fKE23.__read)($3f6279bff428b9e1$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($3f6279bff428b9e1$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $dCjZk.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $bM45J.isPrimitive)(error) ? $3f6279bff428b9e1$var$_eventFromRejectionWithPrimitive(error) : (0, $48jhe.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $9CfQ8.Severity).Error;
        $3f6279bff428b9e1$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3f6279bff428b9e1$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3f6279bff428b9e1$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $bM45J.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $3f6279bff428b9e1$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3f6279bff428b9e1$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $bM45J.isString)(url) && url.length > 0 ? url : (0, $3WEbu.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3f6279bff428b9e1$var$globalHandlerLog(type) {
    (0, $ed0Qo.IS_DEBUG_BUILD) && (0, $4ihNC.logger).log("Global Handler attached: " + type);
}
function $3f6279bff428b9e1$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $fR8Sp.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $3f6279bff428b9e1$var$getHubAndAttachStacktrace() {
    var hub = (0, $OArqR.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

});

parcelRegister("4Zia6", function(module, exports) {

$parcel$export(module.exports, "LinkedErrors", () => $3a1af27ed5c47cfd$export$8d1e60aaf616fb4f);

var $fKE23 = parcelRequire("fKE23");

var $87JfJ = parcelRequire("87JfJ");
var $OArqR = parcelRequire("OArqR");
parcelRequire("lRNHc");
var $bM45J = parcelRequire("bM45J");

var $48jhe = parcelRequire("48jhe");
var $3a1af27ed5c47cfd$var$DEFAULT_KEY = 'cause';
var $3a1af27ed5c47cfd$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $3a1af27ed5c47cfd$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $3a1af27ed5c47cfd$var$DEFAULT_KEY;
        this._limit = options.limit || $3a1af27ed5c47cfd$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $87JfJ.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $OArqR.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $3a1af27ed5c47cfd$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $3a1af27ed5c47cfd$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $bM45J.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $3a1af27ed5c47cfd$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $fKE23.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $3a1af27ed5c47cfd$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $bM45J.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $48jhe.exceptionFromError)(error[key]);
    return $3a1af27ed5c47cfd$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $fKE23.__spread)([
        exception
    ], stack));
}

});

parcelRegister("8x62I", function(module, exports) {

$parcel$export(module.exports, "TryCatch", () => $636617c2017c1969$export$f1a018517668e6d3);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("lRNHc");
var $koJfb = parcelRequire("koJfb");
var $bhTeQ = parcelRequire("bhTeQ");
var $1rQSq = parcelRequire("1rQSq");

var $dCjZk = parcelRequire("dCjZk");
var $636617c2017c1969$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $636617c2017c1969$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $fKE23.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $1rQSq.getGlobalObject)();
        if (this._options.setTimeout) (0, $koJfb.fill)(global, 'setTimeout', $636617c2017c1969$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $koJfb.fill)(global, 'setInterval', $636617c2017c1969$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $koJfb.fill)(global, 'requestAnimationFrame', $636617c2017c1969$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $koJfb.fill)(XMLHttpRequest.prototype, 'send', $636617c2017c1969$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $636617c2017c1969$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($636617c2017c1969$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $636617c2017c1969$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $dCjZk.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $bhTeQ.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $636617c2017c1969$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $dCjZk.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $bhTeQ.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $636617c2017c1969$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $koJfb.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $bhTeQ.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $koJfb.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $bhTeQ.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $dCjZk.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $636617c2017c1969$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $1rQSq.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $koJfb.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $dCjZk.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $bhTeQ.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $dCjZk.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $bhTeQ.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $koJfb.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("9czaH", function(module, exports) {

$parcel$export(module.exports, "UserAgent", () => $6b308465ca95ab46$export$5fba5e10934a4faf);

var $fKE23 = parcelRequire("fKE23");

var $87JfJ = parcelRequire("87JfJ");
var $OArqR = parcelRequire("OArqR");
parcelRequire("lRNHc");
var $1rQSq = parcelRequire("1rQSq");
var $6b308465ca95ab46$var$global = (0, $1rQSq.getGlobalObject)();
/** UserAgent */ var $6b308465ca95ab46$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $87JfJ.addGlobalEventProcessor)(function(event) {
            if ((0, $OArqR.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$6b308465ca95ab46$var$global.navigator && !$6b308465ca95ab46$var$global.location && !$6b308465ca95ab46$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $6b308465ca95ab46$var$global.location && $6b308465ca95ab46$var$global.location.href;
                var referrer = ($6b308465ca95ab46$var$global.document || {}).referrer;
                var userAgent = ($6b308465ca95ab46$var$global.navigator || {}).userAgent;
                var headers = (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();

});


parcelRegister("3UO40", function(module, exports) {

$parcel$export(module.exports, "CaptureConsole", () => $2d9d6fa4e22e16c1$export$25a43cb5b5c58c08);
parcelRequire("lRNHc");
var $4ihNC = parcelRequire("4ihNC");
var $koJfb = parcelRequire("koJfb");
var $1rQSq = parcelRequire("1rQSq");
var $jZkqD = parcelRequire("jZkqD");
var $9pvxT = parcelRequire("9pvxT");
var $2d9d6fa4e22e16c1$var$global = (0, $1rQSq.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $2d9d6fa4e22e16c1$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $4ihNC.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $2d9d6fa4e22e16c1$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $2d9d6fa4e22e16c1$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $koJfb.fill)($2d9d6fa4e22e16c1$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $9pvxT.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $jZkqD.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $jZkqD.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($2d9d6fa4e22e16c1$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();

});

parcelRegister("3OSfe", function(module, exports) {

$parcel$export(module.exports, "Dedupe", () => $2c801e770ca5bee4$export$688d98c249d31ad3);
parcelRequire("lRNHc");
var $4ihNC = parcelRequire("4ihNC");

var $cgBtd = parcelRequire("cgBtd");
/** Deduplication filter */ var $2c801e770ca5bee4$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($2c801e770ca5bee4$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $cgBtd.IS_DEBUG_BUILD) && (0, $4ihNC.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $2c801e770ca5bee4$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($2c801e770ca5bee4$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($2c801e770ca5bee4$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $2c801e770ca5bee4$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$2c801e770ca5bee4$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$2c801e770ca5bee4$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $2c801e770ca5bee4$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $2c801e770ca5bee4$var$_getExceptionFromEvent(previousEvent);
    var currentException = $2c801e770ca5bee4$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$2c801e770ca5bee4$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$2c801e770ca5bee4$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $2c801e770ca5bee4$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $2c801e770ca5bee4$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $2c801e770ca5bee4$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $2c801e770ca5bee4$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $2c801e770ca5bee4$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $2c801e770ca5bee4$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});
parcelRegister("cgBtd", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $8ee40b7904bc7d91$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $8ee40b7904bc7d91$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("ddI3U", function(module, exports) {

$parcel$export(module.exports, "ExtraErrorData", () => $99feab1116481053$export$56d961ef3a52a072);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("lRNHc");
var $bM45J = parcelRequire("bM45J");
var $4ihNC = parcelRequire("4ihNC");
var $kYiFy = parcelRequire("kYiFy");

var $cgBtd = parcelRequire("cgBtd");
/** Patch toString calls to return proper name for wrapped functions */ var $99feab1116481053$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $fKE23.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $bM45J.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $fKE23.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $kYiFy.normalize)(errorData, this._options.depth);
            if ((0, $bM45J.isPlainObject)(normalizedErrorData)) contexts = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $fKE23.__assign)({}, normalizedErrorData), _a));
            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $fKE23.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $bM45J.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $fKE23.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $bM45J.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $cgBtd.IS_DEBUG_BUILD) && (0, $4ihNC.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();

});

parcelRegister("fkbBB", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $b281b9dfa81ea893$export$febc5573c75cefb0);
/** Add node transaction to the event */ var $b281b9dfa81ea893$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();

});



parcelRegister("2iVww", function(module, exports) {

$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => $c114108427f07f01$export$d4079397f9611138);
$parcel$export(module.exports, "default", () => $c114108427f07f01$export$2e2bcd8739ae039);

var $8blac = parcelRequire("8blac");

var $i7Fym = parcelRequire("i7Fym");

var $b8H1q = parcelRequire("b8H1q");
var $gWxA1 = parcelRequire("gWxA1");

var $8YauA = parcelRequire("8YauA");
let $c114108427f07f01$var$analyticsClient;
const $c114108427f07f01$export$d4079397f9611138 = (client)=>{
    $c114108427f07f01$var$analyticsClient = client;
};
const $c114108427f07f01$export$bf406c01a195b215 = ()=>{
    $c114108427f07f01$var$analyticsClient = undefined;
};
const $c114108427f07f01$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName } = meta;
    if (false) {
        if (error) throw error;
        else {
            const payload = event && (0, $b8H1q.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
            ...attributes,
            packageName: packageName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($8blac))));
        if (event && event.context) {
            const fullEvent = (0, $b8H1q.extractAWCDataFromEvent)(event);
            (0, $8YauA.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $8YauA.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $gWxA1.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($c114108427f07f01$var$analyticsClient && $c114108427f07f01$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $c114108427f07f01$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $8YauA.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $c114108427f07f01$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $c114108427f07f01$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $c114108427f07f01$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $c114108427f07f01$export$2e2bcd8739ae039 = $c114108427f07f01$var$fireErrorAnalytics;

});

parcelRegister("fNQX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f577cfe97d048bf5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $2iVww = parcelRequire("2iVww");
class $f577cfe97d048bf5$var$CatchAndReportErrors extends (0, $eUqFw.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $2iVww.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: attributes
        });
        throw error;
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    }
}
var $f577cfe97d048bf5$export$2e2bcd8739ae039 = (0, $2jDha.default)()($f577cfe97d048bf5$var$CatchAndReportErrors);

});


parcelRegister("jb3WS", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("eUqFw")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("7ifyX", function(module, exports) {

$parcel$export(module.exports, "SelectedTemplatePreview", () => $46a4523d8e8191ec$export$e4149dbed9d42567);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $8tM2T = parcelRequire("8tM2T");

var $40pIP = parcelRequire("40pIP");

parcelRequire("5R9VD");
var $2iVww = parcelRequire("2iVww");

var $12dBW = parcelRequire("12dBW");

var $6TeVR = parcelRequire("6TeVR");
const $46a4523d8e8191ec$export$e4149dbed9d42567 = ({ contentId: contentId, blueprints: blueprints, isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate, createEmbeddedPage: createEmbeddedPage })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const showEmbeddedConfluencePage = (0, $eUqFw.useCallback)((template)=>{
        try {
            if (template.key === (0, $f1b1a3a8569ed0d9$export$947879e664d1885a) || template.itemModuleCompleteKey === (0, $6TeVR.ItemModuleCompleteKeys).BLANK_PAGE) createEmbeddedPage(contentId || undefined, true, undefined, undefined);
            else {
                const blueprint = blueprints.find((blueprint)=>blueprint.itemModuleCompleteKey === template.blueprintModuleCompleteKey || blueprint.blueprintModuleCompleteKey === template.blueprintModuleCompleteKey);
                if (blueprint) createEmbeddedPage(contentId || undefined, true, blueprint);
                else (0, $2iVww.default)({
                    error: new Error(`Embedded page was not showing due to blueprint with id: ${template.blueprintModuleCompleteKey} not found.`),
                    meta: {
                        id: 'project-pages-embedded-confluence-error',
                        packageName: '@atlassiansox/project-pages'
                    }
                });
            }
            return true;
        } catch (error) {
            (0, $2iVww.default)({
                error: new Error(`Unknown error when calling createEmbeddedPage for template: ${template.blueprintModuleCompleteKey}`),
                attributes: {
                    cause: error instanceof Error ? error.message : 'Not known'
                },
                meta: {
                    id: 'project-pages-embedded-confluence-error',
                    packageName: '@atlassiansox/project-pages'
                }
            });
            return true;
        }
    }, [
        contentId,
        createEmbeddedPage,
        blueprints
    ]);
    const onShouldShowEmbeddedConfluence = (0, $eUqFw.useCallback)((template)=>{
        const cohort = (0, $8tM2T.default).getExperimentValue('project_pages_embedded_confluence_experiment', 'cohort', 'not-enrolled');
        const isInVariation = cohort === 'variation';
        (0, $12dBW.fireExposure)({
            event: createAnalyticsEvent({
                type: 'sendTrackEvent',
                action: 'viewed'
            }),
            experimentType: 'ab',
            cohort: cohort
        });
        if (isInVariation) return showEmbeddedConfluencePage(template);
        return true;
    }, [
        createAnalyticsEvent,
        showEmbeddedConfluencePage
    ]);
    (0, $40pIP.useShouldShowEmbeddedConfluence)({
        isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate,
        onShouldShowEmbeddedConfluence: onShouldShowEmbeddedConfluence
    });
    return null;
};

});
parcelRegister("40pIP", function(module, exports) {

$parcel$export(module.exports, "useShouldShowEmbeddedConfluence", () => $cd0a0032395d503e$export$81d36c7488a45593);

var $eUqFw = parcelRequire("eUqFw");

var $dZsZr = parcelRequire("dZsZr");

var $kgX2t = parcelRequire("kgX2t");
function $cd0a0032395d503e$export$81d36c7488a45593({ isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate, onShouldShowEmbeddedConfluence: onShouldShowEmbeddedConfluence }) {
    const [hasShownEmbeddedConfluence, setHasShown] = (0, $eUqFw.useState)(false);
    const { template: template } = (0, $kgX2t.useTemplate)();
    (0, $eUqFw.useEffect)(()=>{
        if (!hasShownEmbeddedConfluence && isConfluenceActivationCompleteForPreselectedTemplate && template?.type === (0, $dZsZr.TemplateType).Confluence) {
            const didShow = onShouldShowEmbeddedConfluence(template);
            setHasShown(didShow);
        }
    }, [
        hasShownEmbeddedConfluence,
        isConfluenceActivationCompleteForPreselectedTemplate,
        template,
        onShouldShowEmbeddedConfluence
    ]);
    return hasShownEmbeddedConfluence;
}

});
parcelRegister("dZsZr", function(module, exports) {

$parcel$export(module.exports, "TemplateType", () => $247ba7adbaca5971$export$fd0446c06165ed92);
var $247ba7adbaca5971$export$fd0446c06165ed92;
(function(TemplateType) {
    TemplateType[TemplateType["Confluence"] = 0] = "Confluence";
    TemplateType[TemplateType["Link"] = 1] = "Link";
})($247ba7adbaca5971$export$fd0446c06165ed92 || ($247ba7adbaca5971$export$fd0446c06165ed92 = {}));

});

parcelRegister("kgX2t", function(module, exports) {

$parcel$export(module.exports, "useTemplate", () => $4758dbc7e48ce676$export$5c3a5f48c762cb34);
$parcel$export(module.exports, "TemplateProvider", () => $4758dbc7e48ce676$export$5abfb1150fa6da6a);
$parcel$export(module.exports, "usePreloadPreviews", () => $4758dbc7e48ce676$export$1700393387b8743b);

var $eUqFw = parcelRequire("eUqFw");

var $c06r3 = parcelRequire("c06r3");
const $4758dbc7e48ce676$var$TemplateContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    template: undefined,
    setActiveTemplatePreview: ()=>{}
});
const $4758dbc7e48ce676$export$5c3a5f48c762cb34 = ()=>(0, $eUqFw.useContext)($4758dbc7e48ce676$var$TemplateContext);
const $4758dbc7e48ce676$export$5abfb1150fa6da6a = $4758dbc7e48ce676$var$TemplateContext.Provider;
const $4758dbc7e48ce676$export$1700393387b8743b = (templates, isPostExpand)=>{
    (0, $eUqFw.useEffect)(()=>{
        templates.filter((0, $c06r3.isConfluenceTemplate)).forEach((t)=>{
            const img = new Image();
            img.src = isPostExpand ? t.preview.postExpand.default : t.preview.preExpand.default;
        });
    }, [
        isPostExpand,
        templates
    ]);
};

});
parcelRegister("c06r3", function(module, exports) {

$parcel$export(module.exports, "isConfluenceTemplate", () => $6a062467641eeb72$export$edbc62ee780712e3);
$parcel$export(module.exports, "isMoreTemplates", () => $6a062467641eeb72$export$19b46866d305b8e4);

var $dZsZr = parcelRequire("dZsZr");
const $6a062467641eeb72$export$edbc62ee780712e3 = (template)=>template?.type === (0, $dZsZr.TemplateType).Confluence;
const $6a062467641eeb72$export$19b46866d305b8e4 = (template)=>template?.type === (0, $dZsZr.TemplateType).Link;

});



const $f1b1a3a8569ed0d9$export$947879e664d1885a = 'blankPage';

parcelRegister("12dBW", function(module, exports) {

$parcel$export(module.exports, "fireExposure", () => $a7c640a397b660fd$export$4fddbecd50660ab8);

var $gWxA1 = parcelRequire("gWxA1");
const $a7c640a397b660fd$var$EXPERIMENT_NAMES = {
    aa: 'project_pages_embedded_confluence_experiment_aa',
    ab: 'project_pages_embedded_confluence_experiment'
};
function $a7c640a397b660fd$export$4fddbecd50660ab8({ event: event, experimentType: experimentType, cohort: cohort }) {
    const experiment = $a7c640a397b660fd$var$EXPERIMENT_NAMES[experimentType];
    (0, $gWxA1.fireTrackAnalytics)(event, 'exposed experiment', {
        action: 'viewed',
        cohort: cohort,
        experiment: experiment
    });
}

});

parcelRegister("6TeVR", function(module, exports) {

$parcel$export(module.exports, "ItemModuleCompleteKeys", () => $e60916444c14b665$export$2ae1f6a9458e9684);
$parcel$export(module.exports, "BlueprintModuleCompleteKeys", () => $e60916444c14b665$export$3159bae21226cb8d);
var $e60916444c14b665$export$2ae1f6a9458e9684;
(function(ItemModuleCompleteKeys) {
    ItemModuleCompleteKeys["BLANK_PAGE"] = "com.atlassian.confluence.plugins.confluence-create-content-plugin:create-blank-page";
    ItemModuleCompleteKeys["PRODUCT_REQUIREMENTS"] = "com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-item";
    ItemModuleCompleteKeys["DECISION"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint-item";
    ItemModuleCompleteKeys["MEETING_NOTES"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-item";
    ItemModuleCompleteKeys["RESTROSPECTIVE"] = "com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-item";
})($e60916444c14b665$export$2ae1f6a9458e9684 || ($e60916444c14b665$export$2ae1f6a9458e9684 = {}));
var $e60916444c14b665$export$3159bae21226cb8d;
(function(BlueprintModuleCompleteKeys) {
    BlueprintModuleCompleteKeys["PRODUCT_REQUIREMENTS"] = "com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint";
    BlueprintModuleCompleteKeys["DECISION"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint";
    BlueprintModuleCompleteKeys["MEETING_NOTES"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint";
    BlueprintModuleCompleteKeys["RESTROSPECTIVE"] = "com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint";
})($e60916444c14b665$export$3159bae21226cb8d || ($e60916444c14b665$export$3159bae21226cb8d = {}));

});





parcelRegister("33NPm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5206a45cf5d7ac5f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $220ac = parcelRequire("220ac");

var $eouzD = parcelRequire("eouzD");

var $l3ugm = parcelRequire("l3ugm");


var $kJeqC = parcelRequire("kJeqC");

var $48Bjb = parcelRequire("48Bjb");

var $j5YY5 = parcelRequire("j5YY5");

var $hM8l4 = parcelRequire("hM8l4");
const $5206a45cf5d7ac5f$var$MountTracker = (0, $48Bjb.default)('serverErrorEmptySpace');
const $5206a45cf5d7ac5f$var$ServerError = ({ type: type = 'server', intl: { formatMessage: formatMessage } })=>{
    const isCrossJoinProjectExperimentEnabled = (0, $kJeqC.getTargetingGate)((0, $acc8984185b87525$export$7d578ef8316f5d8b));
    // Feature exposed event has been fired when users view lozenge & spotlight, so we disable this one
    const crossJoinNudgeExperimentCohort = isCrossJoinProjectExperimentEnabled ? (0, $kJeqC.getExperimentValue)((0, $acc8984185b87525$export$616a7764e9436f13), 'not-enrolled', false) : 'not-enrolled';
    if (type === 'access') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hM8l4.default), {
        parentPageId: null,
        spaceKey: null,
        isCrossJoinProjectExperimentEnabled: isCrossJoinProjectExperimentEnabled,
        crossJoinProjectExperimentCohort: crossJoinNudgeExperimentCohort
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5206a45cf5d7ac5f$var$MountTracker, {
        type: type
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        size: "wide",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($l3ugm))),
        maxImageWidth: 82,
        header: formatMessage((0, $eouzD.default).heading),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $eouzD.default).description,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j5YY5.default), {
                        label: chunks
                    })
            }
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5206a45cf5d7ac5f$var$MountTracker, {
        type: type
    }));
};
var $5206a45cf5d7ac5f$export$2e2bcd8739ae039 = (0, $2qhQi.default)($5206a45cf5d7ac5f$var$ServerError);

});
parcelRegister("eouzD", function(module, exports) {

$parcel$export(module.exports, "default", () => $40dc5b3db396e728$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $40dc5b3db396e728$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        id: 'project-pages.unknown-error.heading',
        defaultMessage: "We can\u2019t display project pages right now",
        description: 'Heading when an unknown error occurs'
    },
    description: {
        id: 'project-pages.unknown-error.description',
        defaultMessage: "{contactSupport} if refreshing doesn\u2019t fix things.",
        description: 'Description when an unknown error occurs'
    }
});

});

const $acc8984185b87525$export$7d578ef8316f5d8b = 'cross-join-nudge-in-project-pages-gate';
const $acc8984185b87525$export$616a7764e9436f13 = 'cross-join-nudge-in-project-pages';

parcelRegister("kJeqC", function(module, exports) {

$parcel$export(module.exports, "getExperimentValue", () => $f39de6364d6e9042$export$df4f69f663fe2d96);
$parcel$export(module.exports, "getTargetingGate", () => $f39de6364d6e9042$export$c123608fb702e1aa);

var $8tM2T = parcelRequire("8tM2T");
const $f39de6364d6e9042$export$df4f69f663fe2d96 = (experimentKey, defaultCohort, fireExperimentExposure)=>{
    if ((0, $8tM2T.default).initializeCalled()) return (0, $8tM2T.default).getExperimentValue(experimentKey, 'cohort', defaultCohort, {
        fireExperimentExposure: fireExperimentExposure
    });
    return defaultCohort;
};
const $f39de6364d6e9042$export$c123608fb702e1aa = (experimentKey)=>(0, $8tM2T.default).initializeCompleted() && (0, $8tM2T.default).checkGate(experimentKey);

});

parcelRegister("hM8l4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9ded611f972b826$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $l6ExU = parcelRequire("l6ExU");

var $3pvFP = parcelRequire("3pvFP");

var $9c14t = parcelRequire("9c14t");

var $4aXoz = parcelRequire("4aXoz");

var $hMy8N = parcelRequire("hMy8N");

var $6znmO = parcelRequire("6znmO");
const $a9ded611f972b826$var$mapStateToProps = (state)=>({
        connectedSpace: (0, $4aXoz.getConnectedSpace)(state),
        accessRequestCapability: (0, $9c14t.getAccessRequestCapability)(state),
        origin: (0, $hMy8N.getOrigin)(state),
        collaborators: (0, $6znmO.getCollaborators)(state),
        cloudId: (0, $hMy8N.getCloudId)(state)
    });
const $a9ded611f972b826$var$mapDispatchToProps = (dispatch)=>({
        triggerConfluenceAccessRequestCheck: ()=>dispatch((0, $3pvFP.fetchConfluenceAccessRequestCapabilities)()),
        triggerFetchConfluenceCollaborators: ()=>dispatch((0, $3pvFP.fetchConfluenceCollaborators)())
    });
var $a9ded611f972b826$export$2e2bcd8739ae039 = (0, $cllCv.connect)($a9ded611f972b826$var$mapStateToProps, $a9ded611f972b826$var$mapDispatchToProps)((0, $l6ExU.default));

});
parcelRegister("l6ExU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f147eed01acef66$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dcSvg = parcelRequire("dcSvg");

var $i2XdE = parcelRequire("i2XdE");
const $4f147eed01acef66$var$CrossJoin = ({ connectedSpace: connectedSpace, accessRequestCapability: accessRequestCapability, origin: origin, collaborators: collaborators, triggerConfluenceAccessRequestCheck: triggerConfluenceAccessRequestCheck, triggerFetchConfluenceCollaborators: triggerFetchConfluenceCollaborators, cloudId: cloudId, isCrossJoinProjectExperimentEnabled: isCrossJoinProjectExperimentEnabled = false, crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort = 'not-enrolled' })=>{
    (0, $eUqFw.useEffect)(()=>{
        triggerConfluenceAccessRequestCheck();
    }, [
        triggerConfluenceAccessRequestCheck
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (accessRequestCapability && [
            (0, $dcSvg.AccessRequestCapabilityType).REQUEST_ACCESS,
            (0, $dcSvg.AccessRequestCapabilityType).DIRECT_ACCESS
        ].includes(accessRequestCapability)) // fetch collaborators only for the RA / join product scenario
        triggerFetchConfluenceCollaborators();
    }, [
        accessRequestCapability,
        triggerFetchConfluenceCollaborators
    ]);
    // still loading
    if (!accessRequestCapability) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i2XdE.default), {
        accessRequestCapability: accessRequestCapability,
        connectedSpace: connectedSpace,
        origin: origin,
        collaborators: collaborators,
        cloudId: cloudId,
        spaceKey: connectedSpace.projectSpaceKey,
        parentPageId: connectedSpace.projectPageLinkedId,
        isCrossJoinProjectExperimentEnabled: isCrossJoinProjectExperimentEnabled,
        crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort
    });
};
var $4f147eed01acef66$export$2e2bcd8739ae039 = $4f147eed01acef66$var$CrossJoin;

});
parcelRegister("dcSvg", function(module, exports) {

$parcel$export(module.exports, "AccessRequestCapabilityType", () => $195cfd87175f7401$export$a4cf803cc5ad528);
// https://stash.atlassian.com/projects/IPS/repos/id-invitations-service/browse/src/main/java/com/atlassian/identity/invitations/model/access/AccessRequestCapability.java
var $195cfd87175f7401$export$a4cf803cc5ad528;
(function(AccessRequestCapabilityType) {
    // only the ones we care about, if we get anything else, treat it as ERROR
    AccessRequestCapabilityType["DIRECT_ACCESS"] = "DIRECT_ACCESS";
    AccessRequestCapabilityType["REQUEST_ACCESS"] = "REQUEST_ACCESS";
    AccessRequestCapabilityType["ACCESS_EXISTS"] = "ACCESS_EXISTS";
    AccessRequestCapabilityType["ACCESS_GRANTED"] = "ACCESS_GRANTED";
    AccessRequestCapabilityType["PENDING_REQUEST_EXISTS"] = "PENDING_REQUEST_EXISTS";
    AccessRequestCapabilityType["PENDING_REQUEST_CREATED"] = "PENDING_REQUEST_CREATED";
    AccessRequestCapabilityType["DENIED_REQUEST_EXISTS"] = "DENIED_REQUEST_EXISTS";
    AccessRequestCapabilityType["APPROVED_REQUEST_EXISTS"] = "APPROVED_REQUEST_EXISTS";
    AccessRequestCapabilityType["ERROR"] = "ERROR";
})($195cfd87175f7401$export$a4cf803cc5ad528 || ($195cfd87175f7401$export$a4cf803cc5ad528 = {}));

});

parcelRegister("i2XdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f1aa9c8a174dbc1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $xgdEy = parcelRequire("xgdEy");

var $dcSvg = parcelRequire("dcSvg");

var $io6e6 = parcelRequire("io6e6");

var $kwce8 = parcelRequire("kwce8");

var $gi2Mq = parcelRequire("gi2Mq");

var $hZtuk = parcelRequire("hZtuk");

var $5W8P1 = parcelRequire("5W8P1");

var $gOz9L = parcelRequire("gOz9L");

var $jH70B = parcelRequire("jH70B");

var $kc9lj = parcelRequire("kc9lj");

var $gWxA1 = parcelRequire("gWxA1");
// eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $8f1aa9c8a174dbc1$var$HeroImageWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1d80gtt-0"
})({
    marginBottom: "var(--ds-space-200, 16px)"
});
const $8f1aa9c8a174dbc1$var$CrossJoinView = ({ accessRequestCapability: accessRequestCapability, origin: origin, collaborators: collaborators, cloudId: cloudId, spaceKey: spaceKey, parentPageId: parentPageId, crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort, isCrossJoinProjectExperimentEnabled: isCrossJoinProjectExperimentEnabled })=>{
    // enrich analytics event with origin and then fire the event via supplied handler
    const createClickHandlerForAnalytics = (0, $eUqFw.useCallback)((eventName)=>(_, analyticsEvent)=>{
            const originAttributes = origin?.toAnalyticsAttributes({
                hasGeneratedId: true
            });
            (0, $gWxA1.fireUIAnalytics)(analyticsEvent, `${eventName}Button`, {
                numberOfCollaborators: collaborators?.length,
                crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort,
                isCrossJoinProjectExperimentEnabled: isCrossJoinProjectExperimentEnabled,
                ...originAttributes
            });
        }, [
        collaborators,
        origin,
        crossJoinProjectExperimentCohort,
        isCrossJoinProjectExperimentEnabled
    ]);
    const renderHeroImage = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f1aa9c8a174dbc1$var$HeroImageWrapper, null, collaborators && collaborators.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xgdEy.default), {
            collaborators: collaborators,
            cloudId: cloudId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($io6e6))),
            height: 80,
            width: 99.56
        })), [
        collaborators,
        cloudId
    ]);
    // for scenarios where collaborators are shown (RA/join), wait until collaborators are retrieved
    if (accessRequestCapability && [
        (0, $dcSvg.AccessRequestCapabilityType).REQUEST_ACCESS,
        (0, $dcSvg.AccessRequestCapabilityType).DIRECT_ACCESS
    ].includes(accessRequestCapability) && !collaborators) return null;
    if (isCrossJoinProjectExperimentEnabled && crossJoinProjectExperimentCohort === 'variation') {
        if (accessRequestCapability === (0, $dcSvg.AccessRequestCapabilityType).REQUEST_ACCESS || accessRequestCapability === (0, $dcSvg.AccessRequestCapabilityType).DIRECT_ACCESS) {
            const analyticsAction = accessRequestCapability === (0, $dcSvg.AccessRequestCapabilityType).REQUEST_ACCESS ? 'requestAccess' : 'joinProduct';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gi2Mq.default), {
                renderHeroImage: renderHeroImage,
                onClick: createClickHandlerForAnalytics(analyticsAction),
                origin: origin,
                spaceKey: spaceKey,
                parentPageId: parentPageId,
                crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort,
                accessRequestCapability: accessRequestCapability
            });
        }
    }
    switch(accessRequestCapability){
        case (0, $dcSvg.AccessRequestCapabilityType).REQUEST_ACCESS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gi2Mq.default), {
                renderHeroImage: renderHeroImage,
                onClick: createClickHandlerForAnalytics('requestAccess'),
                origin: origin,
                spaceKey: spaceKey,
                parentPageId: parentPageId
            });
        case (0, $dcSvg.AccessRequestCapabilityType).PENDING_REQUEST_EXISTS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hZtuk.default), {
                crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort
            });
        case (0, $dcSvg.AccessRequestCapabilityType).DENIED_REQUEST_EXISTS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gOz9L.default), null);
        case (0, $dcSvg.AccessRequestCapabilityType).APPROVED_REQUEST_EXISTS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jH70B.default), null);
        case (0, $dcSvg.AccessRequestCapabilityType).DIRECT_ACCESS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5W8P1.default), {
                onClick: createClickHandlerForAnalytics('joinProduct'),
                renderHeroImage: renderHeroImage
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kc9lj.default), null);
    }
};
var $8f1aa9c8a174dbc1$export$2e2bcd8739ae039 = $8f1aa9c8a174dbc1$var$CrossJoinView;

});
parcelRegister("xgdEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $71914ee7e3eda050$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4XQdE = parcelRequire("4XQdE");

var $kwce8 = parcelRequire("kwce8");

var $kvYle = parcelRequire("kvYle");

var $28qwP = parcelRequire("28qwP");

var $0zxaD = parcelRequire("0zxaD");

var $g0zAT = parcelRequire("g0zAT");

var $jyjMi = parcelRequire("jyjMi");

var $eqp74 = parcelRequire("eqp74");

var $8PYmV = parcelRequire("8PYmV");

var $iJlfe = parcelRequire("iJlfe");

var $2qhQi = parcelRequire("2qhQi");

var $2pBhQ = parcelRequire("2pBhQ");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $71914ee7e3eda050$var$Wrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1q2960e-0"
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '36px'
});
const $71914ee7e3eda050$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
const $71914ee7e3eda050$var$fallback = [
    [
        'vania',
        (0, (/*@__PURE__*/$parcel$interopDefault($jyjMi)))
    ],
    [
        'alvin',
        (0, (/*@__PURE__*/$parcel$interopDefault($kvYle)))
    ],
    [
        'katina',
        (0, (/*@__PURE__*/$parcel$interopDefault($0zxaD)))
    ],
    [
        'eliot',
        (0, (/*@__PURE__*/$parcel$interopDefault($28qwP)))
    ],
    [
        'norah',
        (0, (/*@__PURE__*/$parcel$interopDefault($g0zAT)))
    ]
].map(([name, src])=>({
        name: name,
        src: src,
        id: ''
    }));
const $71914ee7e3eda050$var$openUserProfileWindow = (userId)=>window.open($71914ee7e3eda050$var$getUserProfileUrl(userId), '_blank');
const $71914ee7e3eda050$var$getUserProfileUrl = (userId)=>`/jira/people/${userId}`;
const $71914ee7e3eda050$var$PopupAvatar = (props)=>{
    const profileClient = new (0, $8PYmV.default)({
        url: $71914ee7e3eda050$var$DIRECTORY_URL
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eqp74.default), {
        trigger: "hover",
        userId: props.id,
        resourceClient: profileClient,
        cloudId: props.cloudId,
        actions: [
            {
                label: props.intl.formatMessage((0, $2pBhQ.default).viewProfile),
                callback: ()=>{
                    $71914ee7e3eda050$var$openUserProfileWindow(props.id);
                }
            }
        ],
        prepopulatedData: {
            fullName: props.name
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...props,
        onClick: ()=>{}
    }));
};
const $71914ee7e3eda050$var$PopupAvatarWithIntl = (0, $2qhQi.default)($71914ee7e3eda050$var$PopupAvatar);
const $71914ee7e3eda050$var$CollaboratorsAvatarGroup = ({ collaborators: collaborators, cloudId: cloudId })=>{
    const { data: data, hasCollaborators: hasCollaborators } = (0, $eUqFw.useMemo)(()=>({
            data: !collaborators || !Boolean(collaborators?.length) ? $71914ee7e3eda050$var$fallback : collaborators.map((c)=>({
                    id: c.id,
                    key: c.id,
                    name: c.name,
                    src: c.avatarUrl
                })),
            hasCollaborators: !Boolean(collaborators?.length) // Do not show tooltips for fallback avatar icons
        }), [
        collaborators
    ]);
    const handleAvatarClicked = (_event, _analyticsEvent, index)=>{
        if (!hasCollaborators) $71914ee7e3eda050$var$openUserProfileWindow(data[index].id); // Do not try and open a profile on click if there are no collaborators (fallback to placeholder profile images)
    };
    const PopupAvatarWithCloudId = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71914ee7e3eda050$var$PopupAvatarWithIntl, {
            ...props,
            cloudId: cloudId
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71914ee7e3eda050$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        data: data,
        // @ts-ignore the AvatarGroup typing says it won't accept this type..
        avatar: hasCollaborators ? (0, $iJlfe.default) : PopupAvatarWithCloudId,
        size: "medium",
        isTooltipDisabled: hasCollaborators,
        onAvatarClick: handleAvatarClicked
    }));
};
var $71914ee7e3eda050$export$2e2bcd8739ae039 = $71914ee7e3eda050$var$CollaboratorsAvatarGroup;

});
parcelRegister("kvYle", function(module, exports) {
module.exports = new URL("Alvin.617c22ff.svg", import.meta.url).toString();

});

parcelRegister("28qwP", function(module, exports) {
module.exports = new URL("Eliot.b55e69ea.svg", import.meta.url).toString();

});

parcelRegister("0zxaD", function(module, exports) {
module.exports = new URL("Katina.38e0ef7e.svg", import.meta.url).toString();

});

parcelRegister("g0zAT", function(module, exports) {
module.exports = new URL("Norah.a590f774.svg", import.meta.url).toString();

});

parcelRegister("jyjMi", function(module, exports) {
module.exports = new URL("Vania.8579933b.svg", import.meta.url).toString();

});

parcelRegister("2pBhQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3793864b2bcc41fe$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3793864b2bcc41fe$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    requestAccessTitle: {
        id: 'project-pages.cross-join.request-access.title',
        defaultMessage: 'Project pages require access to Confluence',
        description: 'Title for the request access view'
    },
    requestAccessTitleExp: {
        id: 'project-pages.cross-join.request-access.title.experiment',
        defaultMessage: 'Create a single source of truth for your team',
        description: 'Title for the unified request access & direct join view in project page for cross join nudge experiment'
    },
    requestAccessWithoutBetterTogetherDescription: {
        id: 'project-pages.cross-join.request-access-without-better-together.connected.description',
        defaultMessage: 'View, edit and create project documentation with your team',
        description: 'Description for request access view when there is a Confluence space connected'
    },
    requestAccessDescriptionExp: {
        id: 'project-pages.cross-join.request-access.connected.description.experimental',
        defaultMessage: "Your team is using Project Pages to comment, edit, and collaborate on project documentation without leaving Jira. Join Confluence to access your team\u2019s Project Pages.",
        description: 'Description for request access view when there is a Confluence space connected for new cross join nudge experiment'
    },
    requestAccessButton: {
        id: 'project-pages.cross-join.request-access.button',
        defaultMessage: 'Request access',
        description: 'Button label for request access CTA'
    },
    requestAccessButtonExp: {
        id: 'project-pages.cross-join.request-access.button.experimental',
        defaultMessage: 'Join your team',
        description: 'Button label for request access & direct join CTA for new cross join nudge experiment'
    },
    requestAccessButtonSubtitleExp: {
        id: 'project-pages.cross-join.request-access.button-subtitle.experimental',
        defaultMessage: "When you select 'Join Your Team', you're asking to join Confluence and agree to share your Atlassian profile with your admin.",
        description: 'Subtitle under Join Your Team button for request access scenario for new cross join nudge experiment'
    },
    joinProductButtonDescriptionExp: {
        id: 'project-pages.cross-join.direct-access.button-subtitle.experimental',
        defaultMessage: "You'll get access to Confluence. Your site admin has already approved you.",
        description: 'Subtitle under Join Your Team button for direct join scenario for new cross join nudge experiment'
    },
    requestAccessPendingRequestTitle: {
        id: 'project-pages.cross-join.pending-request.templates.title',
        defaultMessage: "You've requested access to Confluence",
        description: 'Title shown when user has requested access to Confluence but the request is pending'
    },
    requestAccessPendingRequestExp: {
        id: 'project-pages.cross-join.pending-request.templates.title.experiment',
        defaultMessage: 'Access request sent to Admin',
        description: 'Title shown when user has requested access to Confluence but the request is pending for new cross join nudge experiment'
    },
    requestAccessPendingRequestSubtitle: {
        id: 'project-pages.cross-join.pending-request.templates.subtitle',
        defaultMessage: "The site admin has received your request to join Confluence. If you're approved to join, project pages will start working and we'll send you a confirmation email.",
        description: 'Long description shown when user has requested access to Confluence but the request is pending'
    },
    requestAccessPendingRequestSubtitleExp: {
        id: 'project-pages.cross-join.pending-request.templates.subtitle.experiment',
        defaultMessage: "You'll get an email with access to Project Pages once you\u2019re approved.",
        description: 'Long description shown when user has requested access to Confluence but the request is pending for new cross join experiment'
    },
    requestDeniedAccessRequestTitle: {
        id: 'project-pages.cross-join.denied-request.templates.title',
        defaultMessage: 'Your admin has denied you access',
        description: 'Title shown when user has requested access to Confluence but the request is denied'
    },
    requestDeniedAccessRequestSubtitle: {
        id: 'project-pages.cross-join.denied-request.templates.subtitle',
        defaultMessage: "You can't use project pages because the site admin denied your request to join Confluence.",
        description: 'Subtitle shown when user has requested access to Confluence but the request is denied'
    },
    requestAccessRevokedTitle: {
        id: 'project-pages.cross-join.access-revoked.templates.title',
        defaultMessage: "You don't have permissions to use project pages",
        description: 'Title shown when user has requested access to Confluence but the request has since been revoked'
    },
    requestAccessRevokedSubtitle: {
        id: 'project-pages.cross-join.access-revoked.templates.subtitle',
        defaultMessage: 'You cannot use project pages because the admin has denied you access to Confluence. Contact your site admin to request access.',
        description: 'Subtitle shown when user has requested access to Confluence but the request has since been revoked'
    },
    viewProfile: {
        id: 'project-pages.cross-join.avatar.view-profile',
        defaultMessage: 'View profile'
    }
});

});


parcelRegister("io6e6", function(module, exports) {
module.exports = new URL("cross-join-folder.39b6d302.svg", import.meta.url).toString();

});

parcelRegister("gi2Mq", function(module, exports) {

$parcel$export(module.exports, "default", () => $940760a04a8cb45b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /** @jsxfrag */ 
var $7JEyt = parcelRequire("7JEyt");

var $fI650 = parcelRequire("fI650");

var $220ac = parcelRequire("220ac");

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $2pBhQ = parcelRequire("2pBhQ");

var $fTKxv = parcelRequire("fTKxv");

var $53bO0 = parcelRequire("53bO0");

var $85INN = parcelRequire("85INN");

var $a1ivA = parcelRequire("a1ivA");

var $dcSvg = parcelRequire("dcSvg");
const $940760a04a8cb45b$var$subtitleStyle = null;
const $940760a04a8cb45b$var$RequestAccess = (0, $2qhQi.default)(({ intl: { formatMessage: formatMessage }, onClick: onClick, origin: origin, renderHeroImage: renderHeroImage, spaceKey: spaceKey, parentPageId: parentPageId, crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort = 'not-enrolled', accessRequestCapability: accessRequestCapability })=>{
    const requestAccessUrl = (0, $eUqFw.useMemo)(()=>(0, $fTKxv.getCrossJoinConfluenceEditorUrl)(origin, spaceKey, parentPageId), [
        origin,
        spaceKey,
        parentPageId
    ]);
    const inCrossJoinVariation = crossJoinProjectExperimentCohort === 'variation';
    const getSubtitle = ()=>{
        if (!(crossJoinProjectExperimentCohort === 'variation') || !accessRequestCapability) return null;
        if (accessRequestCapability === (0, $dcSvg.AccessRequestCapabilityType).REQUEST_ACCESS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
            className: (0, $7JEyt.default)([
                "_syaz1rc1 _y3gn1h6o _19pk10v4"
            ])
        }, formatMessage((0, $2pBhQ.default).requestAccessButtonSubtitleExp));
        if (accessRequestCapability === (0, $dcSvg.AccessRequestCapabilityType).DIRECT_ACCESS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
            className: (0, $7JEyt.default)([
                "_syaz1rc1 _y3gn1h6o _19pk10v4"
            ])
        }, formatMessage((0, $2pBhQ.default).joinProductButtonDescriptionExp));
    };
    const getPrimaryAction = ()=>{
        if (!(crossJoinProjectExperimentCohort === 'variation') || !accessRequestCapability) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
            appearance: "primary",
            href: requestAccessUrl,
            target: "_blank",
            onClick: onClick
        }, formatMessage((0, $2pBhQ.default).requestAccessButton));
        // Note that InlineJoinButton has ability to do RA as well
        // Inline join button will fire RA or DA API call to identity and refreshes accessRequestCapability state
        // Successfull RA / DA will go to PendingRequest screen
        if (accessRequestCapability === (0, $dcSvg.AccessRequestCapabilityType).REQUEST_ACCESS || accessRequestCapability === (0, $dcSvg.AccessRequestCapabilityType).DIRECT_ACCESS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53bO0.default), {
            onClick: onClick
        }, formatMessage((0, $2pBhQ.default).requestAccessButtonExp));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: renderHeroImage,
        header: formatMessage(inCrossJoinVariation ? (0, $2pBhQ.default).requestAccessTitleExp : (0, $2pBhQ.default).requestAccessTitle),
        description: formatMessage(inCrossJoinVariation ? (0, $2pBhQ.default).requestAccessDescriptionExp : (0, $2pBhQ.default).requestAccessWithoutBetterTogetherDescription),
        primaryAction: getPrimaryAction(),
        testId: "confluence-project-pages.cross-join.request-access"
    }), getSubtitle(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null));
});
var $940760a04a8cb45b$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceName: "projectPagesRequestAccess",
        sourceType: (0, $e779cc169fd2a347$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($940760a04a8cb45b$var$RequestAccess, props));

});
parcelRegister("fTKxv", function(module, exports) {

$parcel$export(module.exports, "getCrossJoinConfluenceEditorUrl", () => $0b54c32c2b3a4a31$export$be8d5a1a55011585);
const $0b54c32c2b3a4a31$var$getConfluenceEditorUrl = (spaceKey, parentPageId)=>{
    if (spaceKey !== null && typeof spaceKey !== 'undefined') {
        const parentPageSection = parentPageId !== null && typeof parentPageId !== 'undefined' ? '/pages/' + parentPageId : '';
        return `/wiki/spaces/${spaceKey}${parentPageSection}`;
    } else return '/wiki';
};
const $0b54c32c2b3a4a31$export$be8d5a1a55011585 = (origin, spaceKey, parentPageId)=>{
    const destUrl = $0b54c32c2b3a4a31$var$getConfluenceEditorUrl(spaceKey, parentPageId);
    const identityParams = new URLSearchParams({
        'dest-url': origin ? origin.addToUrl(destUrl) : destUrl,
        application: 'confluence',
        'permission-violation': 'true'
    });
    return `/login?${identityParams.toString()}`;
};

});

parcelRegister("53bO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fc1d6029776f34a$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $edtAk = parcelRequire("edtAk");

var $3pvFP = parcelRequire("3pvFP");

var $hG8hK = parcelRequire("hG8hK");
const $2fc1d6029776f34a$var$mapStateToProps = (state)=>({
        isInlineJoinPending: (0, $hG8hK.getIsInlineJoinPending)(state)
    });
const $2fc1d6029776f34a$var$mapDispatchToProps = (dispatch)=>({
        triggerInlineJoin: ()=>dispatch((0, $3pvFP.inlineJoinConfluence)())
    });
var $2fc1d6029776f34a$export$2e2bcd8739ae039 = (0, $cllCv.connect)($2fc1d6029776f34a$var$mapStateToProps, $2fc1d6029776f34a$var$mapDispatchToProps)((0, $edtAk.InlineJoinButton));

});
parcelRegister("edtAk", function(module, exports) {

$parcel$export(module.exports, "InlineJoinButton", () => $51757e61a699384e$export$e4c2be29b76a28b9);

var $6zOB7 = parcelRequire("6zOB7");

var $eUqFw = parcelRequire("eUqFw");
const $51757e61a699384e$export$e4c2be29b76a28b9 = ({ children: children, onClick: onClick, triggerInlineJoin: triggerInlineJoin, isInlineJoinPending: isInlineJoinPending })=>{
    const onClickHandler = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        // do the inline-join
        triggerInlineJoin();
        onClick(e, analyticsEvent);
    }, [
        triggerInlineJoin,
        onClick
    ]);
    const buttonProps = isInlineJoinPending ? {
        isLoading: true
    } : {
        onClick: onClickHandler
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "primary",
        ...buttonProps
    }, children);
};

});

parcelRegister("hG8hK", function(module, exports) {

$parcel$export(module.exports, "getIsInlineJoinPending", () => $f1ad15215fb0c0b5$export$481f1783eddeff04);
const $f1ad15215fb0c0b5$export$481f1783eddeff04 = (state)=>state.ui.inlineJoin.isJoinPending;

});



parcelRegister("hZtuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d887a1e01b6a17d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gFdoE = parcelRequire("gFdoE");

var $220ac = parcelRequire("220ac");

var $2pBhQ = parcelRequire("2pBhQ");

var $2qhQi = parcelRequire("2qhQi");

var $85INN = parcelRequire("85INN");

var $a1ivA = parcelRequire("a1ivA");
const $5d887a1e01b6a17d$var$PendingRequest = (0, $2qhQi.default)(({ intl: { formatMessage: formatMessage }, crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort = 'not-enrolled' })=>{
    const inCrossJoinVariation = crossJoinProjectExperimentCohort === 'variation';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($gFdoE))),
        imageHeight: 95,
        imageWidth: 124,
        header: formatMessage((0, $2pBhQ.default).requestAccessPendingRequestTitle),
        description: formatMessage(inCrossJoinVariation ? (0, $2pBhQ.default).requestAccessPendingRequestSubtitleExp : (0, $2pBhQ.default).requestAccessPendingRequestSubtitle),
        testId: "confluence-project-pages.cross-join.pending-request"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null));
});
var $5d887a1e01b6a17d$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceName: "projectPagesPendingRequest",
        sourceType: (0, $e779cc169fd2a347$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5d887a1e01b6a17d$var$PendingRequest, props));

});
parcelRegister("gFdoE", function(module, exports) {
module.exports = new URL("paper-aeroplane.83d00122.svg", import.meta.url).toString();

});


parcelRegister("5W8P1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef65043b81c1042c$export$2e2bcd8739ae039);

var $220ac = parcelRequire("220ac");

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $8iNqQ = parcelRequire("8iNqQ");

var $85INN = parcelRequire("85INN");

var $a1ivA = parcelRequire("a1ivA");

var $53bO0 = parcelRequire("53bO0");

var $kwce8 = parcelRequire("kwce8");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef65043b81c1042c$var$Subtitle = /*#__PURE__*/ (0, $kwce8.default).p.withConfig({
    componentId: "sc-1kmrlg4-0"
})({
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    textAlign: 'center',
    marginTop: "var(--ds-space-negative-300, -24px)"
});
const $ef65043b81c1042c$var$InlineJoinProduct = (0, $2qhQi.default)(({ intl: { formatMessage: formatMessage }, onClick: onClick, renderHeroImage: renderHeroImage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: renderHeroImage,
        header: formatMessage((0, $8iNqQ.default).joinProductTitle),
        description: formatMessage((0, $8iNqQ.default).joinProductDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53bO0.default), {
            onClick: onClick
        }, formatMessage((0, $8iNqQ.default).joinProductButton)),
        testId: "confluence-project-pages.cross-join.join-product"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef65043b81c1042c$var$Subtitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", null, formatMessage((0, $8iNqQ.default).joinProductButtonDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null));
});
var $ef65043b81c1042c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceName: "projectPagesJoin",
        sourceType: (0, $e779cc169fd2a347$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef65043b81c1042c$var$InlineJoinProduct, props));

});
parcelRegister("8iNqQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c0816cf51df4fb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d9c0816cf51df4fb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    joinProductTitle: {
        id: 'project-pages.cross-join.inline-join-product.connected.title',
        defaultMessage: 'Collaborate on project pages with your team',
        description: 'Title encouraging users to join Confluence when there is a connected Confluence space'
    },
    joinProductDescription: {
        id: 'project-pages.cross-join.inline-join-product.connected.description',
        defaultMessage: 'View, edit and create documentation from a single place',
        description: 'Value prop for joining Confluence when there is a connected Confluence space'
    },
    joinProductButton: {
        id: 'project-pages.cross-join.inline-join-product.button',
        defaultMessage: 'Join',
        description: 'Button label for joining Confluence CTA'
    },
    joinProductButtonDescription: {
        id: 'project-pages.cross-join.inline-join-product.button',
        defaultMessage: "You\u2019ll get access to Confluence. Your site admin has already approved you.",
        description: 'Button label for joining Confluence CTA'
    }
});

});


parcelRegister("gOz9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $9704e7c55b250cbd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9ffgd = parcelRequire("9ffgd");

var $220ac = parcelRequire("220ac");

var $2pBhQ = parcelRequire("2pBhQ");

var $2qhQi = parcelRequire("2qhQi");

var $85INN = parcelRequire("85INN");

var $a1ivA = parcelRequire("a1ivA");
const $9704e7c55b250cbd$var$DeniedAccess = (0, $2qhQi.default)(({ intl: { formatMessage: formatMessage } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9ffgd))),
        imageHeight: 126,
        imageWidth: 96,
        header: formatMessage((0, $2pBhQ.default).requestDeniedAccessRequestTitle),
        description: formatMessage((0, $2pBhQ.default).requestDeniedAccessRequestSubtitle),
        testId: "confluence-project-pages.cross-join.denied-access"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null));
});
var $9704e7c55b250cbd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceName: "projectPagesAccessDenied",
        sourceType: (0, $e779cc169fd2a347$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9704e7c55b250cbd$var$DeniedAccess, null));

});
parcelRegister("9ffgd", function(module, exports) {
module.exports = new URL("lock-red.d0e5588b.svg", import.meta.url).toString();

});


parcelRegister("jH70B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f82765b1e4b1e513$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9ffgd = parcelRequire("9ffgd");

var $220ac = parcelRequire("220ac");

var $2pBhQ = parcelRequire("2pBhQ");

var $2qhQi = parcelRequire("2qhQi");

var $85INN = parcelRequire("85INN");

var $a1ivA = parcelRequire("a1ivA");
const $f82765b1e4b1e513$var$AccessRevoked = (0, $2qhQi.default)(({ intl: { formatMessage: formatMessage } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9ffgd))),
        imageHeight: 126,
        imageWidth: 96,
        header: formatMessage((0, $2pBhQ.default).requestAccessRevokedTitle),
        description: formatMessage((0, $2pBhQ.default).requestAccessRevokedSubtitle),
        testId: "confluence-project-pages.cross-join.access-revoked"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null));
});
var $f82765b1e4b1e513$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceName: "projectPagesAccessRevoked",
        sourceType: (0, $e779cc169fd2a347$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f82765b1e4b1e513$var$AccessRevoked, null));

});

parcelRegister("kc9lj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fa422f629b9e5e1$export$2e2bcd8739ae039);

var $hqaEI = parcelRequire("hqaEI");

var $eUqFw = parcelRequire("eUqFw");

var $85INN = parcelRequire("85INN");

var $bXTjv = parcelRequire("bXTjv");

var $a1ivA = parcelRequire("a1ivA");
const $9fa422f629b9e5e1$var$UnknownError = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqaEI.default), {
        messages: (0, $bXTjv.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null));
};
var $9fa422f629b9e5e1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceName: "projectPagesUnknownError",
        sourceType: (0, $e779cc169fd2a347$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9fa422f629b9e5e1$var$UnknownError, null));

});
parcelRegister("bXTjv", function(module, exports) {

$parcel$export(module.exports, "default", () => $24dcb13d93c9f84c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $24dcb13d93c9f84c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        id: 'project-pages.cross-join.errors.unknown-error.title',
        defaultMessage: "We can't display project pages right now",
        description: 'Generic / unknown error message title'
    },
    description: {
        id: 'project-pages.cross-join.errors.unknown-error.description',
        defaultMessage: "{contactSupport} if refreshing doesn't fix things.",
        description: 'Generic / unknown error message description'
    }
});

});




parcelRegister("9c14t", function(module, exports) {

$parcel$export(module.exports, "getAccessRequestCapability", () => $156114839aa58f54$export$33030a40c54ad600);
const $156114839aa58f54$export$33030a40c54ad600 = (state)=>state.confluence.accessRequestCapabilities.loaded ? state.confluence.accessRequestCapabilities.capability : undefined;

});

parcelRegister("6znmO", function(module, exports) {

$parcel$export(module.exports, "getCollaborators", () => $8098d52619fa9eb7$export$985b350648b09ad8);
const $8098d52619fa9eb7$export$985b350648b09ad8 = (state)=>state.confluence.collaborators.loaded ? state.confluence.collaborators.users : undefined;

});



parcelRegister("jsOid", function(module, exports) {

$parcel$export(module.exports, "default", () => $405af2f547df93ce$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $3pvFP = parcelRequire("3pvFP");

var $8edqF = parcelRequire("8edqF");

var $jlQ7M = parcelRequire("jlQ7M");
const $405af2f547df93ce$var$mapStateToProps = (state)=>({
        hasErrors: (0, $8edqF.isThereAnError)(state),
        showSuccessFlag: (0, $8edqF.successfullyConnectedSpace)(state),
        connectedSpaceOrPageName: (0, $8edqF.getConnectedSpaceName)(state),
        isConnectedToPage: (0, $8edqF.getIsConnectedToPage)(state),
        title: (0, $8edqF.getCustomFlagTitle)(state),
        description: (0, $8edqF.getCustomFlagDescription)(state),
        showActivationErrorFlag: (0, $8edqF.isActivationError)(state)
    });
const $405af2f547df93ce$var$mapDispatchToProps = (dispatch)=>({
        onErrorDismiss: ()=>dispatch((0, $3pvFP.dismissError)()),
        onSuccessDismiss: ()=>dispatch((0, $3pvFP.dismissSuccessFlag)()),
        onActivationErrorDismiss: ()=>dispatch((0, $3pvFP.dismissActivationErrorFlag)())
    });
var $405af2f547df93ce$export$2e2bcd8739ae039 = (0, $cllCv.connect)($405af2f547df93ce$var$mapStateToProps, $405af2f547df93ce$var$mapDispatchToProps)((0, $jlQ7M.default));

});
parcelRegister("8edqF", function(module, exports) {

$parcel$export(module.exports, "isThereAnError", () => $20b8d08580dc0c08$export$6caae3e4f5ab892d);
$parcel$export(module.exports, "successfullyConnectedSpace", () => $20b8d08580dc0c08$export$5fe667e6e7e6ce92);
$parcel$export(module.exports, "getConnectedSpaceName", () => $20b8d08580dc0c08$export$152b6e4dd8acd600);
$parcel$export(module.exports, "getIsConnectedToPage", () => $20b8d08580dc0c08$export$8062d4f2391d5856);
$parcel$export(module.exports, "getCustomFlagTitle", () => $20b8d08580dc0c08$export$d2b91d70eb29beed);
$parcel$export(module.exports, "getCustomFlagDescription", () => $20b8d08580dc0c08$export$743a9c2d20ab6d0e);
$parcel$export(module.exports, "isActivationError", () => $20b8d08580dc0c08$export$23e2ff39033650b7);
const $20b8d08580dc0c08$export$6caae3e4f5ab892d = (state)=>state.flags.hasErrors;
const $20b8d08580dc0c08$export$5fe667e6e7e6ce92 = (state)=>state.flags.showSuccessFlag;
const $20b8d08580dc0c08$export$152b6e4dd8acd600 = (state)=>state.flags.connectedSpaceName;
const $20b8d08580dc0c08$export$8062d4f2391d5856 = (state)=>state.flags.isConnectedToPage;
const $20b8d08580dc0c08$export$d2b91d70eb29beed = (state)=>state.flags.title;
const $20b8d08580dc0c08$export$743a9c2d20ab6d0e = (state)=>state.flags.description;
const $20b8d08580dc0c08$export$23e2ff39033650b7 = (state)=>state.flags.showActivationErrorFlag;

});

parcelRegister("jlQ7M", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6096a0244d26a409$export$defe85febe8b728c);
$parcel$export(module.exports, "default", () => $6096a0244d26a409$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $2qhQi = parcelRequire("2qhQi");

var $3Oaez = parcelRequire("3Oaez");
var $4GEic = parcelRequire("4GEic");
var $gpNMq = parcelRequire("gpNMq");

var $iqFZO = parcelRequire("iqFZO");

var $ek6sP = parcelRequire("ek6sP");

var $1Qu2i = parcelRequire("1Qu2i");


var $85INN = parcelRequire("85INN");

var $a1ivA = parcelRequire("a1ivA");
const $6096a0244d26a409$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    'generic-error-heading': {
        id: 'project-pages.generic-error.heading',
        defaultMessage: 'Well, this is awkward...',
        description: ''
    },
    'generic-error-description': {
        id: 'project-pages.generic-error.description',
        defaultMessage: 'Something went wrong. Please try again later.',
        description: ''
    },
    'generic-error-reload-button': {
        id: 'project-pages.generic-error.button.reload',
        defaultMessage: 'Reload page',
        description: ''
    },
    'generic-success-flag-heading-space': {
        id: 'project-pages.generic-success-flag.heading.space',
        defaultMessage: 'Space connected',
        description: ''
    },
    'generic-success-flag-heading-page': {
        id: 'project-pages.generic-success-flag.heading.page',
        defaultMessage: 'Page connected',
        description: ''
    },
    'generic-success-flag-description-space': {
        id: 'project-pages.generic-success-flag.description.space',
        defaultMessage: 'Successfully connected with {connectedSpaceOrPageName} space.',
        description: ''
    },
    'generic-success-flag-description-page': {
        id: 'project-pages.generic-success-flag.description.page',
        defaultMessage: 'Successfully connected with {connectedSpaceOrPageName} page.',
        description: ''
    },
    'generic-activation-error-flag-description': {
        id: 'project-pages.generic-info-flag.description',
        defaultMessage: 'Something went wrong. Please try again or contact support if the issue persists',
        description: 'Description in an informative flag, prompting users to try again or contact support if the issue persists'
    }
});
class $6096a0244d26a409$var$Flags extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, hasErrors: hasErrors, onErrorDismiss: onErrorDismiss, onSuccessDismiss: onSuccessDismiss, onActivationErrorDismiss: onActivationErrorDismiss, onReload: onReload, showSuccessFlag: showSuccessFlag, connectedSpaceOrPageName: connectedSpaceOrPageName, isConnectedToPage: isConnectedToPage, title: title, description: description, showActivationErrorFlag: showActivationErrorFlag } = this.props;
        // eslint-disable-next-line no-undef
        if (false) return null;
        const SUCCESS_FLAG_ID = 'success';
        const ERROR_FLAG_ID = 'error';
        const INFO_FLAG_ID = 'info';
        const handleDismiss = (id)=>{
            if (id === SUCCESS_FLAG_ID) onSuccessDismiss();
            if (id === ERROR_FLAG_ID) onErrorDismiss();
            if (id === INFO_FLAG_ID) onActivationErrorDismiss();
        };
        const flags = [];
        if (hasErrors) {
            const primaryColor = `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y300})`;
            const actions = [
                {
                    content: intl.formatMessage($6096a0244d26a409$export$defe85febe8b728c['generic-error-reload-button']),
                    onClick: ()=>onReload && onReload()
                }
            ];
            flags.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4GEic.default), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Qu2i))), {
                    label: "Warning",
                    color: primaryColor
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
                    sourceName: "errorFlag",
                    sourceType: (0, $e779cc169fd2a347$export$1171103ea9083ffa)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null))),
                id: ERROR_FLAG_ID,
                key: ERROR_FLAG_ID,
                actions: actions,
                title: intl.formatMessage($6096a0244d26a409$export$defe85febe8b728c['generic-error-heading']),
                description: intl.formatMessage($6096a0244d26a409$export$defe85febe8b728c['generic-error-description'])
            }));
        }
        if (showActivationErrorFlag) flags.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Oaez.default), {
            testId: "confluence-project-pages.info-flag",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek6sP))), {
                label: "info",
                color: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
                sourceName: "infoFlag",
                sourceType: (0, $e779cc169fd2a347$export$1171103ea9083ffa)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null))),
            id: INFO_FLAG_ID,
            key: INFO_FLAG_ID,
            title: intl.formatMessage($6096a0244d26a409$export$defe85febe8b728c['generic-error-heading']),
            description: intl.formatMessage($6096a0244d26a409$export$defe85febe8b728c['generic-activation-error-flag-description'])
        }));
        if (showSuccessFlag) {
            const primaryColor = `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
            flags.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Oaez.default), {
                testId: "confluence-project-pages.success-flag",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iqFZO))), {
                    label: "Success",
                    color: primaryColor
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
                    sourceName: "successFlag",
                    sourceType: (0, $e779cc169fd2a347$export$1171103ea9083ffa)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null))),
                id: SUCCESS_FLAG_ID,
                key: SUCCESS_FLAG_ID,
                title: title || intl.formatMessage(isConnectedToPage ? $6096a0244d26a409$export$defe85febe8b728c['generic-success-flag-heading-page'] : $6096a0244d26a409$export$defe85febe8b728c['generic-success-flag-heading-space'], {
                    connectedSpaceOrPageName: connectedSpaceOrPageName
                }),
                description: description || intl.formatMessage(isConnectedToPage ? $6096a0244d26a409$export$defe85febe8b728c['generic-success-flag-description-page'] : $6096a0244d26a409$export$defe85febe8b728c['generic-success-flag-description-space'], {
                    connectedSpaceOrPageName: connectedSpaceOrPageName
                })
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gpNMq.default), {
            onDismissed: handleDismiss
        }, flags);
    }
}
var $6096a0244d26a409$export$2e2bcd8739ae039 = (0, $2qhQi.default)($6096a0244d26a409$var$Flags);

});
parcelRegister("iqFZO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4b1d8f8ae82590ab9e3b231233297b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6ab3b374a166728$var$_react = $d6ab3b374a166728$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d6ab3b374a166728$var$_success = $d6ab3b374a166728$var$_interopRequireDefault((parcelRequire("50qGm")));

var $d6ab3b374a166728$var$_checkCircle = $d6ab3b374a166728$var$_interopRequireDefault((parcelRequire("aWvIp")));
function $d6ab3b374a166728$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d6ab3b374a166728$var$SuccessIcon = (props)=>/*#__PURE__*/ $d6ab3b374a166728$var$_react.default.createElement($d6ab3b374a166728$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $d6ab3b374a166728$var$_checkCircle.default
    }, props));
$d6ab3b374a166728$var$SuccessIcon.Name = 'SuccessIconMigration';
var $d6ab3b374a166728$var$_default = module.exports.default = $d6ab3b374a166728$var$SuccessIcon;

});

parcelRegister("ek6sP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e457cb24ac9ea7300ef511f2118ffa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6d7f28dcbf6a858$var$_react = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6d7f28dcbf6a858$var$_information = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("h6FFs")));

var $a6d7f28dcbf6a858$var$_info = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("2bv8J")));
function $a6d7f28dcbf6a858$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6d7f28dcbf6a858$var$InformationIcon = (props)=>/*#__PURE__*/ $a6d7f28dcbf6a858$var$_react.default.createElement($a6d7f28dcbf6a858$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $a6d7f28dcbf6a858$var$_info.default
    }, props));
$a6d7f28dcbf6a858$var$InformationIcon.Name = 'InformationIconMigration';
var $a6d7f28dcbf6a858$var$_default = module.exports.default = $a6d7f28dcbf6a858$var$InformationIcon;

});



parcelRegister("3a6Xq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c265247f788f5a06$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $4aXoz = parcelRequire("4aXoz");

var $3pvFP = parcelRequire("3pvFP");

var $7E29E = parcelRequire("7E29E");

var $jGyKS = parcelRequire("jGyKS");
const $c265247f788f5a06$var$mapStateToProps = (state)=>({
        isSpaceConnected: (0, $4aXoz.isSpaceConnected)(state),
        spaceOrPageId: (0, $4aXoz.getProjectPageLinkedId)(state),
        spaceOrPageTitle: (0, $4aXoz.getConnectedSpaceOrPageTitle)(state),
        spaceOrPageLink: (0, $4aXoz.getConnectedSpaceOrPageUrl)(state),
        isConnectedToPage: (0, $4aXoz.getIsConnectedToPage)(state),
        spaceIcon: (0, $4aXoz.getProjectSpaceIcon)(state),
        isProjectMember: (0, $jGyKS.getIsProjectMember)(state)
    });
const $c265247f788f5a06$var$mapDispatchToProps = (dispatch)=>({
        triggerShowConnectSpaceDialog: ()=>{
            dispatch((0, $3pvFP.showConnectSpaceDialog)());
        },
        triggerFetchConnectedSpacePageTitle: ()=>dispatch((0, $3pvFP.fetchConnectedSpaceOrPageTitle)())
    });
var $c265247f788f5a06$export$2e2bcd8739ae039 = (0, $cllCv.connect)($c265247f788f5a06$var$mapStateToProps, $c265247f788f5a06$var$mapDispatchToProps)((0, $7E29E.default));

});
parcelRegister("7E29E", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe821b640c5dea1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $2eG9N = parcelRequire("2eG9N");

var $2ziLQ = parcelRequire("2ziLQ");

var $iFLpn = parcelRequire("iFLpn");

var $7u4fN = parcelRequire("7u4fN");

var $j9fWg = parcelRequire("j9fWg");

var $j9IA5 = parcelRequire("j9IA5");

var $4bdrZ = parcelRequire("4bdrZ");

var $9cKZS = parcelRequire("9cKZS");

var $a1ivA = parcelRequire("a1ivA");
var $gWxA1 = parcelRequire("gWxA1");

var $6ji7W = parcelRequire("6ji7W");
const $6fe821b640c5dea1$var$MoreMenuComponent = (0, $2qhQi.default)(({ triggerShowConnectSpaceDialog: triggerShowConnectSpaceDialog, triggerFetchConnectedSpacePageTitle: triggerFetchConnectedSpacePageTitle, isSpaceConnected: isSpaceConnected, spaceOrPageTitle: spaceOrPageTitle, spaceOrPageLink: spaceOrPageLink, isConnectedToPage: isConnectedToPage, spaceIcon: spaceIcon, isProjectMember: isProjectMember, intl: { formatMessage: formatMessage } })=>{
    const handleUpdateSpaceOrPageClick = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        triggerShowConnectSpaceDialog();
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'updateSpaceOrPageButton', {
            isConnectedToPage: isConnectedToPage
        });
    }, [
        isConnectedToPage,
        triggerShowConnectSpaceDialog
    ]);
    const handleNavigateToConnectedSpaceOrPageClick = (analyticsEvent)=>{
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'navigateToConnectedSpaceOrPageButton', {
            isConnectedToPage: isConnectedToPage
        });
    };
    (0, $eUqFw.useEffect)(()=>{
        if (isSpaceConnected) triggerFetchConnectedSpacePageTitle();
    }, [
        triggerFetchConnectedSpacePageTitle,
        isSpaceConnected
    ]);
    const { maxWidth: maxWidth, appearance: appearance } = {
        maxWidth: '208px',
        appearance: 'default'
    };
    const connectionIcon = (0, $eUqFw.useMemo)(()=>{
        if (isConnectedToPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bdrZ.PaddedIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9cKZS.PageIcon), null));
        if (spaceIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bdrZ.PaddedIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9cKZS.SpaceIcon), {
            iconPath: spaceIcon
        }));
        return undefined;
    }, [
        isConnectedToPage,
        spaceIcon
    ]);
    const theme = (0, $6ji7W.useThemeContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bdrZ.Wrapper), null, spaceOrPageTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage(isConnectedToPage ? (0, $j9IA5.default).goToConnectedPageTooltip : (0, $j9IA5.default).goToConnectedSpaceTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            maxWidth: maxWidth
        },
        href: spaceOrPageLink || undefined,
        onClick: (_, analyticsEvent)=>handleNavigateToConnectedSpaceOrPageClick(analyticsEvent),
        target: "_blank",
        iconBefore: connectionIcon,
        spacing: isProjectMember ? 'default' : 'none'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bdrZ.SpaceOrPageTitleWrapper), {
        theme: theme
    }, spaceOrPageTitle))), isProjectMember && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: spaceOrPageTitle ? formatMessage((0, $j9IA5.default).updateConnectedSpaceOrPageTooltip) : formatMessage((0, $j9IA5.default).connectedSpaceOrPageTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        label: formatMessage((0, $j9IA5.default).label),
        appearance: appearance,
        onClick: (_, analyticsEvent)=>handleUpdateSpaceOrPageClick(analyticsEvent),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                ...iconProps,
                glyph: (0, $iFLpn.ConnectedPageGlyph),
                primaryColor: theme.navigation.icon.color
            }),
        "data-test-id": "confluence-project-pages.post-expand.connect-or-update-space-button"
    })));
});
var $6fe821b640c5dea1$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceName: "moreMenu",
        sourceType: (0, $e779cc169fd2a347$export$d1123261ca8831d2)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fe821b640c5dea1$var$MoreMenuComponent, props));

});
parcelRegister("iFLpn", function(module, exports) {

$parcel$export(module.exports, "ConnectedPageGlyph", () => $2aa34f720c75caf6$export$42f6f8b7002b5af7);
// TODO: https://product-fabric.atlassian.net/browse/DSP-4169

var $eUqFw = parcelRequire("eUqFw");
const $2aa34f720c75caf6$export$42f6f8b7002b5af7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4123 10.1551C12.8378 10.1525 12.3701 9.68475 12.3675 9.11027L12.3598 7.39768L5.63605 14.1215C5.24553 14.512 4.61236 14.512 4.22184 14.1215C3.83132 13.731 3.83132 13.0978 4.22184 12.7073L10.9456 5.98347L9.23304 5.97583C8.65857 5.97326 8.19079 5.50548 8.18823 4.93101C8.18567 4.35654 8.64929 3.89291 9.22376 3.89548L13.3845 3.91404C13.9589 3.9166 14.4267 4.38438 14.4293 4.95886L14.4478 9.11955C14.4504 9.69403 13.9868 10.1577 13.4123 10.1551Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8118 19.0691C15.8093 18.4946 15.3415 18.0269 14.767 18.0243L13.0544 18.0166L19.7782 11.2929C20.1687 10.9023 20.1687 10.2692 19.7782 9.87864C19.3877 9.48812 18.7545 9.48811 18.364 9.87864L11.6402 16.6024L11.6326 14.8898C11.63 14.3154 11.1622 13.8476 10.5877 13.845C10.0133 13.8425 9.54965 14.3061 9.55222 14.8806L9.57078 19.0413C9.57334 19.6157 10.0411 20.0835 10.6156 20.0861L14.7763 20.1046C15.3508 20.1072 15.8144 19.6436 15.8118 19.0691Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0",
        "mask-type": "alpha",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "7",
        width: "16",
        height: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8118 19.0691C15.8093 18.4946 15.3415 18.0269 14.767 18.0243L13.0544 18.0166L19.7782 11.2929C20.1687 10.9023 20.1687 10.2692 19.7782 9.87864C19.3877 9.48812 18.7545 9.48811 18.364 9.87864L11.6402 16.6024L11.6326 14.8898C11.63 14.3154 11.1622 13.8476 10.5877 13.845C10.0133 13.8425 9.54965 14.3061 9.55222 14.8806L9.57078 19.0413C9.57334 19.6157 10.0411 20.0835 10.6156 20.0861L14.7763 20.1046C15.3508 20.1072 15.8144 19.6436 15.8118 19.0691Z",
        fill: "var(--ds-icon-inverse, white)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0)"
    }));

});

parcelRegister("j9IA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d526a8c410d095$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $72d526a8c410d095$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        id: 'project-pages.button.connect-different-space-or-page.label',
        defaultMessage: 'Update space or page icon',
        description: 'Label for update space or page icon'
    },
    goToConnectedSpaceTooltip: {
        id: 'project-pages.button.go-to-connected-space.tooltip',
        defaultMessage: 'Open space in Confluence',
        description: 'Tooltip displayed on hover over the button to connect to a different Confluence space'
    },
    goToConnectedPageTooltip: {
        id: 'project-pages.button.go-to-connected-page.tooltip',
        defaultMessage: 'Open page in Confluence',
        description: 'Tooltip displayed on hover over the button to connect to a different Confluence page'
    },
    updateConnectedSpaceOrPageTooltip: {
        id: 'project-pages.button.connect-different-space-or-page.tooltip',
        defaultMessage: 'Connect different space or page',
        description: 'Tooltip displayed on hover over the button to connect to a different Confluence space or page'
    },
    connectedSpaceOrPageTooltip: {
        id: 'project-pages.button.connect-space-or-page.tooltip',
        defaultMessage: 'Connect to Confluence',
        description: 'Tooltip displayed on hover over the button to connect to a Confluence space or page'
    }
});

});

parcelRegister("4bdrZ", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $62b51b84e126c58b$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "PaddedIcon", () => $62b51b84e126c58b$export$e2c1843c9369c070);
$parcel$export(module.exports, "SpaceOrPageTitleWrapper", () => $62b51b84e126c58b$export$b7d1851404721f6c);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $62b51b84e126c58b$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1k42rnn-0"
})({
    display: 'flex',
    alignItems: 'center',
    minHeight: "var(--ds-space-400, 32px)"
});
const $62b51b84e126c58b$export$e2c1843c9369c070 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1k42rnn-1"
})({
    marginRight: "var(--ds-space-050, 4px)"
});
const $62b51b84e126c58b$export$b7d1851404721f6c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1k42rnn-2"
})`${({ theme: theme })=>`color: ${theme.color.primary} ;`}`;

});

parcelRegister("6ji7W", function(module, exports) {

$parcel$export(module.exports, "whiteTheme", () => $ddbedfa50a5a57c7$export$d50851c3d0154c0a);
$parcel$export(module.exports, "ThemeContext", () => $ddbedfa50a5a57c7$export$2c657da244d00bd6);
$parcel$export(module.exports, "useThemeContext", () => $ddbedfa50a5a57c7$export$c4281ec44b929e6);


var $eUqFw = parcelRequire("eUqFw");
const $ddbedfa50a5a57c7$export$d50851c3d0154c0a = {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    name: 'white',
    type: 'light',
    background: {
        color: `var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
    },
    color: {
        primary: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`,
        secondary: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`
    },
    navigation: {
        icon: {
            textColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`,
            color: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
            gradientStart: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$7090862dc3038a9f)})`,
            gradientStop: `var(--ds-icon-accent-gray, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`
        }
    }
};
const $ddbedfa50a5a57c7$export$2c657da244d00bd6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($ddbedfa50a5a57c7$export$d50851c3d0154c0a);
const $ddbedfa50a5a57c7$export$c4281ec44b929e6 = ()=>(0, $eUqFw.useContext)($ddbedfa50a5a57c7$export$2c657da244d00bd6);

});



parcelRegister("k0kPd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e532e616dfbbd979$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $fVsKL = parcelRequire("fVsKL");
const $e532e616dfbbd979$var$PagesHeading = ({ intl: intl, isPreExpand: isPreExpand })=>{
    return isPreExpand ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        "data-testid": "confluence.project-pages.pre-expand.heading"
    }, intl.formatMessage((0, $fVsKL.default).headingInfo)) : null;
};
var $e532e616dfbbd979$export$2e2bcd8739ae039 = (0, $2qhQi.default)($e532e616dfbbd979$var$PagesHeading);

});
parcelRegister("fVsKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb89f413dab23f0f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bb89f413dab23f0f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        id: 'project-pages.improvement.title',
        defaultMessage: 'Project pages',
        description: 'Page title for the Project pages feature'
    },
    headingInfo: {
        id: 'project-pages.improvement.heading-info',
        defaultMessage: "Capture your team's knowledge and improve the way you get work done.",
        description: 'Information about the value of the Project pages feature'
    },
    headingInfoV2: {
        id: 'project-pages.improvement.heading-info-v2',
        defaultMessage: "Create one place for all your team's project documents",
        description: 'Information about the value of the Project pages feature'
    },
    feature1: {
        id: 'project-pages.improvement.feature1',
        defaultMessage: 'Access and create documents without leaving Jira',
        description: 'First bulleted feature that explains the value of using Confluence alongside Jira'
    },
    feature2: {
        id: 'project-pages.improvement.feature2',
        defaultMessage: 'Templates for meetings, sprint plans, and more',
        description: 'Second bulleted feature that explains the value of using Confluence alongside Jira'
    },
    feature3: {
        id: 'project-pages.improvement.feature3',
        defaultMessage: 'Sync documents to Jira for automatic updates',
        description: 'Third bulleted feature that explains the value of using Confluence alongside Jira'
    },
    termsAndConditionsV2: {
        id: 'project-pages.improvement.terms-and-conditions-v2',
        defaultMessage: "By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.",
        description: 'Links to the Terms and Conditions and Privacy Policy that the user must agree to before starting their Confluence trial'
    },
    tryItNow: {
        id: 'project-pages.improvement.try-it-now',
        defaultMessage: 'Try it now',
        description: 'Call to action for the user to start their Confluence trial'
    },
    poweredBy: {
        id: 'project-pages.improvement.powered-by',
        defaultMessage: 'Powered by',
        description: 'Prefix to the footer indicating the Project pages feature is powered by Confluence'
    },
    poweredByTooltip: {
        id: 'project-pages.improvement.powered-by.tooltip',
        defaultMessage: 'Open Confluence in a new tab',
        description: 'Tooltip on the Confluence logo in the powered by footer to indicate that clicking will open Confluence in a new tab'
    },
    previewTeaser: {
        id: 'project-pages.improvement.preview-teaser',
        defaultMessage: 'Unlock templates, project pages, and more.',
        description: 'Teaser for Confluence touchpoint'
    },
    learnMoreButton: {
        id: 'project-pages.improvement.learn-more-button',
        defaultMessage: 'Learn more',
        description: 'Button label for Confluence touchpoint'
    },
    tryLozenge: {
        id: 'project-pages.improvement.try-lozenge',
        defaultMessage: 'try',
        description: 'This text appears as a way to encourage the user to try Confluence'
    },
    tryButton: {
        id: 'project-pages.improvement.try-button',
        defaultMessage: 'Try this template in Confluence',
        description: 'Button label for Confluence touchpoint'
    },
    tryOnDemandButton: {
        id: 'project-pages.improvement.try-on-demand-button',
        defaultMessage: 'Try it free',
        description: 'Button label for Confluence touchpoint when users can activate Confluence for free'
    },
    templatesPreExpandTitle: {
        id: 'project-pages.improvement.templates.pre-expand.title',
        defaultMessage: 'Preview templates',
        description: 'Title for list of page templates'
    },
    templatesPreExpandSubtitle: {
        id: 'project-pages.improvement.templates.pre-expand.subtitle',
        defaultMessage: 'Popular with teams like yours',
        description: 'Information for list of page templates'
    },
    templatesPreExpandMore: {
        id: 'project-pages.improvement.templates.pre-expand.more',
        defaultMessage: 'Explore more templates',
        description: 'Link to documentation about Confluence templates'
    },
    templatesPostExpandTitle: {
        id: 'project-pages.improvement.templates.post-expand.title',
        defaultMessage: 'Create a page',
        description: 'Title for list of page templates'
    },
    templatesPostExpandSubtitle: {
        id: 'project-pages.improvement.templates.post-expand.subtitle',
        defaultMessage: 'Popular templates',
        description: 'Information for list of page templates'
    },
    templatesPostExpandMore: {
        id: 'project-pages.improvement.templates.post-expand.more',
        defaultMessage: 'More templates',
        description: 'Link to browse templates'
    },
    templatesPostExpandMoreTooltip: {
        id: 'project-pages.improvement.templates.post-expand.more.tooltip',
        defaultMessage: 'View all templates in Confluence',
        description: 'Tooltip for link to browse templates'
    },
    connectSpaceTooltip: {
        id: 'project-pages.improvement.templates.template.disabled-tooltip',
        defaultMessage: 'Connect a Confluence space first',
        description: 'Tooltip informing user that template creation is disabled until they connect a space'
    },
    blankPageTemplateName: {
        id: 'project-pages.improvement.templates.blank-page.name',
        defaultMessage: 'Blank page',
        description: 'Title of a blank template'
    },
    blankPageTemplateDescription: {
        id: 'project-pages.improvement.templates.blank-page.description',
        defaultMessage: 'Start a page from scratch.',
        description: 'Description of a blank template'
    },
    productRequirementsTemplateName: {
        id: 'project-pages.improvement.templates.product-requirements.name',
        defaultMessage: 'Product requirements',
        description: 'Title of a template'
    },
    productRequirementsTemplateDescription: {
        id: 'project-pages.improvement.templates.product-requirements.description',
        defaultMessage: 'Define, track and scope requirements for your product or feature.',
        description: 'Description for a template'
    },
    decisionTemplateName: {
        id: 'project-pages.improvement.templates.decision.name',
        defaultMessage: 'Decision',
        description: 'Title of a template'
    },
    decisionV2TemplateName: {
        id: 'project-pages.improvement.templates.decision.name.v2',
        defaultMessage: 'Decision',
        description: 'Title of a template'
    },
    decisionTemplateDescription: {
        id: 'project-pages.improvement.templates.decision.description',
        defaultMessage: 'Record important project decisions and communicate them with your team.',
        description: 'Description for a template'
    },
    meetingNotesTemplateName: {
        id: 'project-pages.improvement.templates.meeting-notes.name',
        defaultMessage: 'Meeting notes',
        description: 'Title of a template'
    },
    meetingNotesTemplateDescription: {
        id: 'project-pages.improvement.templates.meeting-notes.description',
        defaultMessage: 'Set meeting agendas, take notes, and share action items with your team.',
        description: 'Description for a template'
    },
    retrospectiveTemplateName: {
        id: 'project-pages.improvement.templates.retrospective.name',
        defaultMessage: 'Retrospective',
        description: 'Title of a template'
    },
    retrospectiveTemplateDescription: {
        id: 'project-pages.improvement.templates.retrospective.description',
        defaultMessage: 'What went well? What could have gone better? Crowdsource improvements with your team.',
        description: 'Description for a template'
    },
    tutorialPageDescription: {
        id: 'project-pages.improvement.templates.tutorial.description',
        defaultMessage: 'Learn how to edit a page.',
        description: 'Description for the tutorial page'
    },
    tutorialPageName: {
        id: 'project-pages.improvement.templates.tutorial.name',
        defaultMessage: 'Welcome to Project Pages!',
        description: 'Title of the tutorial page'
    }
});

});


parcelRegister("6shJa", function(module, exports) {

$parcel$export(module.exports, "EmbeddedConfluenceDialog", () => $334ebc5eaa5b081a$export$7e517a57a72534f5);

var $eUqFw = parcelRequire("eUqFw");

var $hUYqC = parcelRequire("hUYqC");
var $1xrmr = parcelRequire("1xrmr");

var $dxopF = parcelRequire("dxopF");

var $jGe11 = parcelRequire("jGe11");

var $4q38b = parcelRequire("4q38b");

var $9iYvT = parcelRequire("9iYvT");

var $7DB1t = parcelRequire("7DB1t");

var $2GYb9 = parcelRequire("2GYb9");

var $4iCLc = parcelRequire("4iCLc");
parcelRequire("hPmJU");
var $aM4Um = parcelRequire("aM4Um");
var $a9Brc = parcelRequire("a9Brc");

var $5mIIe = parcelRequire("5mIIe");

var $ez8b7 = parcelRequire("ez8b7");

var $a1ivA = parcelRequire("a1ivA");
var $gWxA1 = parcelRequire("gWxA1");

var $85INN = parcelRequire("85INN");

var $bFzGY = parcelRequire("bFzGY");

var $kqxVx = parcelRequire("kqxVx");
// a list of experience tracker events that we're interested in to monitor
const $334ebc5eaa5b081a$var$MONITORED_EXPERIENCE_TRACKER_EVENT_NAMES = [
    // these first 3 are child experiences of a view page
    'edit-page/load',
    'edit-page/publish',
    'view-content',
    'view-page/edit'
];
const $334ebc5eaa5b081a$var$EmbeddedConfluenceDialogView = ({ spaceKey: spaceKey })=>{
    const { accountId: accountId, parentProduct: parentProduct } = (0, $kqxVx.useProjectPages)();
    const themeState = (0, $4q38b.default)();
    const { showPagePublishedFlag: showPagePublishedFlag, showPageDeletedFlag: showPageDeletedFlag, showDraftSavedFlag: showDraftSavedFlag, showErrorFlag: showErrorFlag } = (0, $jGe11.useEmbeddedPagesFlags)();
    const experienceTracker = (0, $eUqFw.useMemo)(()=>new (0, $hUYqC.ExperienceTracker)(), []);
    const { mode: mode, page: page, isOpen: isOpen, isLoading: isLoading, pageCreate: pageCreate, setEmbeddedPage: setEmbeddedPage } = (0, $4iCLc.useEmbeddedPage)();
    const { updatePage: updatePage, removePage: removePage } = (0, $a9Brc.useConfluencePageTree)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const sendTrackEvent = (0, $eUqFw.useCallback)((actionSubject, action, attributes)=>{
        (0, $gWxA1.fireTrackAnalytics)(createAnalyticsEvent({}), `${actionSubject} ${action}`, {
            embeddedPageAction: true,
            ...attributes
        });
    }, [
        createAnalyticsEvent
    ]);
    const isFailEvent = (event)=>event.action === 'taskFail';
    // fires an operational event for an experience tracker event
    const sendExperienceTrackerEvent = (0, $eUqFw.useCallback)((event)=>{
        const { action: action, name: name, attributes: attributes, id: id, startTime: startTime } = event;
        const eventAttributes = {
            ...attributes,
            ...isFailEvent(event) && {
                errorMessage: event.error.message,
                errorName: event.error.name,
                errorTime: window.performance.now()
            }
        };
        (0, $gWxA1.fireOperationalAnalytics)(createAnalyticsEvent({}), `embeddedPage ${action}`, {
            task: name,
            taskId: id,
            startTime: startTime,
            attributes: eventAttributes
        });
    }, [
        createAnalyticsEvent
    ]);
    // When showing a modal inside the embedded component, we stitch some shaded blankets around it make it look seamless
    const [isInnerModalOpen, setIsInnerModalOpen] = (0, $eUqFw.useState)(false);
    const navigationPolicy = (0, $eUqFw.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                // When in edit mode, ignore defaultNavigate and delegate user actions to the experienceTracker
                if (mode === 'edit') return;
                // Note1: When in view mode, and when the edit button is clicked, and if the page supports
                // embedded editing, toggle the edit mode. defaultNavigate() is called for other cases (eg. synchrony pages)
                // Note2: deleting a comment triggers a navigation event with its target set to '_self'
                // other navigation events, like editing or deleting a page, have their target set to '_blank'
                if (mode === 'view' && page && page.hasEmbeddedEdit && (modifiers.routeName === 'EDIT_PAGE_EMBED' || url.includes('/edit-embed/') // FIXME modifiers.routeName does not appear to be populated properly yet, remove this when it is
                )) {
                    setEmbeddedPage({
                        mode: 'edit',
                        isLoading: true
                    });
                    sendTrackEvent('embeddedPage', 'edit');
                    return;
                }
                return defaultNavigate(url, modifiers);
            }
        }), [
        mode,
        page,
        sendTrackEvent,
        setEmbeddedPage
    ]);
    const PageDialog = (0, $eUqFw.useMemo)(()=>{
        return mode === 'edit' ? (0, $7DB1t.EditPageDialog) : (0, $9iYvT.ViewPageDialog);
    }, [
        mode
    ]);
    const handleOnPublish = (0, $eUqFw.useCallback)(async ()=>{
        if (page) {
            setEmbeddedPage({
                mode: 'view',
                isLoading: true,
                page: {
                    ...page,
                    isDraft: false
                }
            });
            const publishedPage = await updatePage(page.id, 'current');
            // update the view URL now that the page is published
            if (publishedPage) setEmbeddedPage({
                page: publishedPage
            });
        }
        showPagePublishedFlag();
        sendTrackEvent('embeddedPage', 'updated');
    }, [
        page,
        sendTrackEvent,
        setEmbeddedPage,
        showPagePublishedFlag,
        updatePage
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)(async ()=>{
        if (page && page.isDraft) {
            const { id: id } = page;
            try {
                await updatePage(id, 'draft');
                showDraftSavedFlag();
            } catch (e) {
                showErrorFlag();
            }
        }
        setEmbeddedPage({
            page: null,
            isOpen: false,
            isLoading: false,
            pageCreate: null
        });
        sendTrackEvent('embeddedPageDialog', 'closed');
    }, [
        page,
        setEmbeddedPage,
        sendTrackEvent,
        updatePage,
        showDraftSavedFlag,
        showErrorFlag
    ]);
    const handleOpenInnerModal = (0, $eUqFw.useCallback)(()=>{
        setIsInnerModalOpen(true);
    }, []);
    const handleCloseInnerModal = (0, $eUqFw.useCallback)(({ closeOuterModal: closeOuterModal, updatePageTree: updatePageTree })=>{
        setIsInnerModalOpen(false);
        if (closeOuterModal) {
            handleOnClose();
            showPageDeletedFlag();
        }
        if (updatePageTree && page) removePage(page.id);
    }, [
        handleOnClose,
        page,
        removePage,
        showPageDeletedFlag
    ]);
    (0, $eUqFw.useEffect)(()=>experienceTracker.subscribe((event)=>{
            const { name: name, action: action } = event;
            if ($334ebc5eaa5b081a$var$MONITORED_EXPERIENCE_TRACKER_EVENT_NAMES.includes(name)) sendExperienceTrackerEvent(event);
            if ((name === 'view-page' || name === 'edit-page/load') && action !== 'taskStart' // abort/fail/success
            ) // turn off the Loading screen only when there is something to show in the iframe
            setEmbeddedPage({
                isLoading: false
            });
            if (name === 'edit-page/close' && action === 'taskSuccess') {
                if (page && page.isDraft) handleOnClose();
                else // just switch back to view mode
                setEmbeddedPage({
                    mode: 'view',
                    isLoading: true
                });
                // fires for both drafts and published close clicks
                sendTrackEvent('embeddedPage', 'closed');
            }
            if (name === 'edit-page/publish' && action === 'taskSuccess') handleOnPublish();
            if (name === 'delete-page') {
                if (action === 'taskStart') handleOpenInnerModal();
                else {
                    const success = action === 'taskSuccess';
                    handleCloseInnerModal({
                        closeOuterModal: success,
                        updatePageTree: success
                    });
                    if (success) sendTrackEvent('embeddedPage', 'deleted', {
                        actionType: 'delete'
                    });
                }
            }
            if (name === 'archiving/archive-pages') {
                if (action === 'taskStart') handleOpenInnerModal();
                else {
                    const success = action === 'taskSuccess';
                    handleCloseInnerModal({
                        closeOuterModal: false,
                        // unlike delete, archiving a page should not close the modal
                        updatePageTree: success
                    });
                    if (success) sendTrackEvent('embeddedPage', 'deleted', {
                        actionType: 'archive'
                    });
                }
            }
            if (name === 'archiving/restore-pages') {
                if (action === 'taskStart') handleOpenInnerModal();
                else handleCloseInnerModal({
                    closeOuterModal: false,
                    // FIXME the problem is you can restore the page to a different parent...
                    // also there seems to be a delay/race condition around this even if restored to same parent
                    updatePageTree: action === 'taskSuccess'
                });
            }
            if (name === 'add-page-comment' && action === 'taskSuccess') sendTrackEvent('embeddedPageComment', 'created');
            if (name === 'delete-page-comment' && action === 'taskSuccess') sendTrackEvent('embeddedPageComment', 'deleted');
        }), [
        experienceTracker,
        handleOnClose,
        handleOnPublish,
        handleOpenInnerModal,
        handleCloseInnerModal,
        page,
        setEmbeddedPage,
        showDraftSavedFlag,
        pageCreate,
        sendTrackEvent,
        sendExperienceTrackerEvent
    ]);
    const content = (0, $eUqFw.useMemo)(()=>{
        if (!isOpen) return null;
        if (pageCreate && pageCreate.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ez8b7.default), {
            spaceKey: spaceKey,
            onCloseModal: handleOnClose
        });
        if (page && spaceKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mIIe.LoadingContainer), {
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PageDialog, {
            parentProduct: parentProduct,
            spaceKey: spaceKey,
            contentId: page.id,
            navigationPolicy: navigationPolicy,
            accountId: accountId,
            themeState: themeState
        }));
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mIIe.LoadingContainer), {
            isLoading: true
        });
        return null;
    }, [
        PageDialog,
        handleOnClose,
        isLoading,
        isOpen,
        navigationPolicy,
        page,
        pageCreate,
        parentProduct,
        spaceKey,
        accountId,
        themeState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1xrmr.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GYb9.default), {
        "data-testid": "embedded-confluence-embedded-page-modal",
        mode: mode,
        headerBtnHref: page?.url,
        onClose: handleOnClose,
        isInnerModalOpen: isInnerModalOpen
    }, content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null))));
};
const $334ebc5eaa5b081a$export$7e517a57a72534f5 = (props)=>{
    const { page: page, mode: mode, pageCreate: pageCreate } = (0, $4iCLc.useEmbeddedPage)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceName: "embeddedPage",
        sourceType: (0, $e779cc169fd2a347$export$1171103ea9083ffa),
        attributes: {
            ...page && (0, $aM4Um.pageAnalyticsAttributes)(page),
            embeddedPageMode: mode,
            ...pageCreate ? {
                embeddedPageMode: 'create',
                createRootPage: pageCreate.isRoot
            } : {}
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($334ebc5eaa5b081a$var$EmbeddedConfluenceDialogView, props));
};

});
parcelRegister("jGe11", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPagesFlags", () => $a62e1887338b573a$export$fc3e883640d66552);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $f86rB = parcelRequire("f86rB");


var $kmvbs = parcelRequire("kmvbs");

var $bFzGY = parcelRequire("bFzGY");

var $gWxA1 = parcelRequire("gWxA1");

var $iqFZO = parcelRequire("iqFZO");

var $1Qu2i = parcelRequire("1Qu2i");

var $jlQ7M = parcelRequire("jlQ7M");
const $a62e1887338b573a$var$withAutoDismissFlagArgs = {
    isAutoDismiss: true
};
const $a62e1887338b573a$var$baseSuccessFlagArgs = {
    ...$a62e1887338b573a$var$withAutoDismissFlagArgs,
    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iqFZO))), {
        label: "Success",
        spacing: "spacious",
        color: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`
    })
};
const $a62e1887338b573a$var$baseErrorFlagArgs = {
    ...$a62e1887338b573a$var$withAutoDismissFlagArgs,
    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Qu2i))), {
        label: "Warning",
        spacing: "spacious",
        color: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`
    })
};
const $a62e1887338b573a$export$fc3e883640d66552 = ()=>{
    const { showFlag: showFlag } = (0, $f86rB.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const showPagePublishedFlag = (0, $eUqFw.useCallback)(()=>{
        const analyticsEventFlag = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'flag'
        });
        (0, $gWxA1.fireUIAnalytics)(analyticsEventFlag, 'embeddedPagePublishSuccessFlag');
        showFlag({
            ...$a62e1887338b573a$var$baseSuccessFlagArgs,
            id: 'pagePublishedFlag',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kmvbs.default).pagePublishedFlagTitle),
            analyticsContext: {},
            testId: 'confluence-project-pages.flag.page-published'
        });
    }, [
        createAnalyticsEvent,
        showFlag
    ]);
    const showDraftSavedFlag = (0, $eUqFw.useCallback)((onOpenDraft)=>{
        const actions = onOpenDraft ? [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kmvbs.default).draftSavedFlagOpenDraft),
                onClick: onOpenDraft
            }
        ] : [];
        return showFlag({
            ...$a62e1887338b573a$var$baseSuccessFlagArgs,
            id: 'draftSavedFlag',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kmvbs.default).draftSavedFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kmvbs.default).draftSavedFlagDescription),
            actions: actions,
            testId: 'confluence-project-pages.flag.draft-saved'
        });
    }, [
        showFlag
    ]);
    const showPageDeletedFlag = (0, $eUqFw.useCallback)(()=>showFlag({
            ...$a62e1887338b573a$var$baseSuccessFlagArgs,
            id: 'pageDeletedFlag',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kmvbs.default).pageDeletedFlagTitle),
            testId: 'confluence-project-pages.flag.page-deleted'
        }), [
        showFlag
    ]);
    const showErrorFlag = (0, $eUqFw.useCallback)(()=>showFlag({
            ...$a62e1887338b573a$var$baseErrorFlagArgs,
            id: 'pageErrorFlag',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $jlQ7M.messages)['generic-error-heading']),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $jlQ7M.messages)['generic-error-description']),
            testId: 'confluence-project-pages.flag.error'
        }), [
        showFlag
    ]);
    return {
        showPagePublishedFlag: showPagePublishedFlag,
        showDraftSavedFlag: showDraftSavedFlag,
        showPageDeletedFlag: showPageDeletedFlag,
        showErrorFlag: showErrorFlag
    };
};

});
parcelRegister("kmvbs", function(module, exports) {

$parcel$export(module.exports, "default", () => $1da354e435bd1c26$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $1da354e435bd1c26$var$messages = (0, $90IgZ.defineMessages)({
    pagePublishedFlagTitle: {
        id: 'project-pages.page-published-flag.title',
        defaultMessage: 'Your page has been published.',
        description: 'Notification title when a Confluence page is published'
    },
    draftSavedFlagTitle: {
        id: 'project-pages.draft-saved-flag.title',
        defaultMessage: 'Draft saved',
        description: 'Notification title when a Confluence draft is saved'
    },
    draftSavedFlagDescription: {
        id: 'project-pages.draft-saved-flag.description',
        defaultMessage: 'Your draft is only visible to you until you publish it.',
        description: 'Notification body when a Confluence draft is saved.'
    },
    draftSavedFlagOpenDraft: {
        id: 'project-pages.draft-saved-flag.action',
        defaultMessage: 'Open draft',
        description: 'Notification link to open the Confluence saved draft'
    },
    pageDeletedFlagTitle: {
        id: 'project-pages.page-deleted-flag.title',
        defaultMessage: 'Page deleted.',
        description: 'Notification title when a Confluence page is deleted'
    }
});
var $1da354e435bd1c26$export$2e2bcd8739ae039 = $1da354e435bd1c26$var$messages;

});


parcelRegister("9iYvT", function(module, exports) {

$parcel$export(module.exports, "ViewPageDialog", () => $d4cb68aaab2f0592$export$5691cfa937ca280a);

var $eUqFw = parcelRequire("eUqFw");

var $8ch8V = parcelRequire("8ch8V");

var $5JgJ2 = parcelRequire("5JgJ2");
const $d4cb68aaab2f0592$export$5691cfa937ca280a = ({ contentId: contentId, spaceKey: spaceKey, parentProduct: parentProduct, navigationPolicy: navigationPolicy, accountId: accountId, themeState: themeState })=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ch8V.ViewPage), {
        locale: locale,
        "data-testid": "embedded-confluence-view-page-dialog",
        contentId: contentId,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        navigationPolicy: navigationPolicy,
        allowedFeatures: [
            'byline-contributors',
            'byline-extensions',
            'page-comments',
            'edit',
            'delete',
            'page-reactions',
            'inline-comments',
            'non-licensed-share'
        ],
        hasFooterLogo: false,
        userInfo: {
            userId: accountId,
            userIdType: 'atlassianAccount'
        },
        themeState: themeState
    });
};

});
parcelRegister("8ch8V", function(module, exports) {

$parcel$export(module.exports, "ViewPage", () => $ea34dd2fc075de79$export$767e3006bdbb424a);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $T0sfQ = parcelRequire("T0sfQ");

var $5IA0G = parcelRequire("5IA0G");

var $nbjr0 = parcelRequire("nbjr0");

const $ea34dd2fc075de79$var$LazyViewPage = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("i6qLr")), {
    moduleId: "../platform/packages/confluence/embedded-confluence/src/view-page/ViewPage.tsx"
});
const $ea34dd2fc075de79$export$767e3006bdbb424a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5IA0G.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $nbjr0.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $T0sfQ.LazyLoadFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ea34dd2fc075de79$var$LazyViewPage, props)));

});
parcelRegister("T0sfQ", function(module, exports) {

$parcel$export(module.exports, "LazyLoadFallback", () => $f266c2cb7a5d0c03$export$da581bf12e325888);

var $joBf7 = parcelRequire("joBf7");
function $f266c2cb7a5d0c03$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f266c2cb7a5d0c03$export$da581bf12e325888 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "egw45yn0"
})({
    name: "w1atjl",
    styles: "width:100%;height:100%"
});

});

parcelRegister("5IA0G", function(module, exports) {

$parcel$export(module.exports, "I18nProvider", () => $95852fff436b68f6$export$a54013f0d02a8f82);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");

var $5wUSP = parcelRequire("5wUSP");
const $95852fff436b68f6$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $5wUSP.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $eUqFw.useState)();
    const locale = (0, $eUqFw.useMemo)(()=>(0, $5wUSP.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $5wUSP.DEFAULT_LOCALE)
    }, children);
};

});
parcelRegister("5wUSP", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $99f0131a1aca5736$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "normalizeLocale", () => $99f0131a1aca5736$export$dca0327c9b9c6498);
const $99f0131a1aca5736$var$DEFAULT_LANGUAGE = 'en';
const $99f0131a1aca5736$var$DEFAULT_REGION = 'US';
const $99f0131a1aca5736$export$1af4c7e47ad72f44 = `${$99f0131a1aca5736$var$DEFAULT_LANGUAGE}-${$99f0131a1aca5736$var$DEFAULT_REGION}`;
const $99f0131a1aca5736$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $99f0131a1aca5736$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $99f0131a1aca5736$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $99f0131a1aca5736$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $99f0131a1aca5736$export$1af4c7e47ad72f44;
};

});


parcelRegister("nbjr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $26cff5d9c9109037$export$2e2bcd8739ae039);
























const $26cff5d9c9109037$var$importTranslations = async (locale)=>{
    switch(locale){
        case 'cs-CZ':
            return (parcelRequire("htdAA"));
        case 'da-DK':
            return (parcelRequire("hCq9l"));
        case 'de-DE':
            return (parcelRequire("6CAQ1"));
        case 'en-US':
            return (parcelRequire("ctlgI"));
        case 'en-GB':
            return (parcelRequire("3E81x"));
        case 'es-ES':
            return (parcelRequire("i93xW"));
        case 'fi-FI':
            return (parcelRequire("jRZi5"));
        case 'fr-FR':
            return (parcelRequire("135BP"));
        case 'hu-HU':
            return (parcelRequire("9H6kI"));
        case 'it-IT':
            return (parcelRequire("lHceO"));
        case 'ja-JP':
            return (parcelRequire("3raA9"));
        case 'ko-KR':
            return (parcelRequire("knyL4"));
        case 'no-NO':
            return (parcelRequire("gCMrx"));
        case 'nl-NL':
            return (parcelRequire("3PnaJ"));
        case 'pl-PL':
            return (parcelRequire("hvXZ8"));
        case 'pt-BR':
            return (parcelRequire("5n4lS"));
        case 'ru-RU':
            return (parcelRequire("4Nyf4"));
        case 'sv-SE':
            return (parcelRequire("duaFU"));
        case 'tr-TR':
            return (parcelRequire("4yXHl"));
        case 'th-TH':
            return (parcelRequire("eHnJt"));
        case 'uk-UA':
            return (parcelRequire("1h79U"));
        case 'vi-VN':
            return (parcelRequire("7qh20"));
        case 'zh-TW':
            return (parcelRequire("jmRU3"));
        case 'zh-CN':
            return (parcelRequire("eqDvs"));
        default:
            return Promise.resolve({
                default: {}
            });
    }
};
const $26cff5d9c9109037$var$fetchTranslations = async (locale)=>{
    const module = await $26cff5d9c9109037$var$importTranslations(locale);
    return module.default;
};
var $26cff5d9c9109037$export$2e2bcd8739ae039 = $26cff5d9c9109037$var$fetchTranslations;

});
parcelRegister("htdAA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3iJJ1").then(()=>parcelRequire('jH88R'));

});

parcelRegister("hCq9l", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6xGae").then(()=>parcelRequire('ejNVU'));

});

parcelRegister("6CAQ1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3QdAb").then(()=>parcelRequire('7bpRo'));

});

parcelRegister("ctlgI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jJ1gp").then(()=>parcelRequire('2c0DC'));

});

parcelRegister("3E81x", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("29zxk").then(()=>parcelRequire('7ntZ7'));

});

parcelRegister("i93xW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6ykNw").then(()=>parcelRequire('jO14M'));

});

parcelRegister("jRZi5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7i4AO").then(()=>parcelRequire('bitgf'));

});

parcelRegister("135BP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gu6zH").then(()=>parcelRequire('14Ivx'));

});

parcelRegister("9H6kI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6sv5r").then(()=>parcelRequire('k3o1i'));

});

parcelRegister("lHceO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3txSy").then(()=>parcelRequire('1Xzs2'));

});

parcelRegister("3raA9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iAmK1").then(()=>parcelRequire('cmMSY'));

});

parcelRegister("knyL4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("af8fp").then(()=>parcelRequire('b7Qk7'));

});

parcelRegister("gCMrx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6WIxJ").then(()=>parcelRequire('fIJSY'));

});

parcelRegister("3PnaJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fZLhn").then(()=>parcelRequire('eh4pG'));

});

parcelRegister("hvXZ8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7TJyn").then(()=>parcelRequire('dkaL6'));

});

parcelRegister("5n4lS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lSjJI").then(()=>parcelRequire('5ZunI'));

});

parcelRegister("4Nyf4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9ggmB").then(()=>parcelRequire('dVOn3'));

});

parcelRegister("duaFU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6TzZp").then(()=>parcelRequire('6wCdD'));

});

parcelRegister("4yXHl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("96zlg").then(()=>parcelRequire('3Ob4C'));

});

parcelRegister("eHnJt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hpvxT").then(()=>parcelRequire('gYuvB'));

});

parcelRegister("1h79U", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("anop0").then(()=>parcelRequire('aUHJg'));

});

parcelRegister("7qh20", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("g1kST").then(()=>parcelRequire('byj5i'));

});

parcelRegister("jmRU3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9iMSY").then(()=>parcelRequire('ikswu'));

});

parcelRegister("eqDvs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3wcIl").then(()=>parcelRequire('aos8Q'));

});


parcelRegister("i6qLr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("lUoX0")
]).then(()=>parcelRequire('bpG3s'));

});



parcelRegister("7DB1t", function(module, exports) {

$parcel$export(module.exports, "EditPageDialog", () => $a579785dbc7490d1$export$e10ae5ccd4f0f9de);

var $eUqFw = parcelRequire("eUqFw");

var $1T1Qr = parcelRequire("1T1Qr");

var $5JgJ2 = parcelRequire("5JgJ2");
const $a579785dbc7490d1$export$e10ae5ccd4f0f9de = ({ contentId: contentId, spaceKey: spaceKey, parentProduct: parentProduct, navigationPolicy: navigationPolicy, accountId: accountId, themeState: themeState })=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T1Qr.EditPage), {
        locale: locale,
        "data-testid": "embedded-confluence-edit-page-dialog",
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        navigationPolicy: navigationPolicy,
        userInfo: {
            userId: accountId,
            userIdType: 'atlassianAccount'
        },
        themeState: themeState
    });
};

});
parcelRegister("1T1Qr", function(module, exports) {

$parcel$export(module.exports, "EditPage", () => $5462813835c8440b$export$1fea75498367c4ac);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $T0sfQ = parcelRequire("T0sfQ");

var $5IA0G = parcelRequire("5IA0G");

var $nbjr0 = parcelRequire("nbjr0");

const $5462813835c8440b$var$LazyEditPage = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("143hQ")), {
    moduleId: "../platform/packages/confluence/embedded-confluence/src/edit-page/EditPage.tsx"
});
const $5462813835c8440b$export$1fea75498367c4ac = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5IA0G.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $nbjr0.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $T0sfQ.LazyLoadFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5462813835c8440b$var$LazyEditPage, props)));

});
parcelRegister("143hQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("5qdnD")
]).then(()=>parcelRequire('lKY35'));

});



parcelRegister("2GYb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d3feac860b7969f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $aOw1G = parcelRequire("aOw1G");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");
var $fI650 = parcelRequire("fI650");

var $hGcnP = parcelRequire("hGcnP");

var $8xkEh = parcelRequire("8xkEh");

var $2eG9N = parcelRequire("2eG9N");

var $awobK = parcelRequire("awobK");

var $5oAL6 = parcelRequire("5oAL6");

var $jkH4Q = parcelRequire("jkH4Q");

var $gWxA1 = parcelRequire("gWxA1");
const $0d3feac860b7969f$var$EmbeddedPageModal = ({ mode: mode, headerBtnHref: headerBtnHref, onClose: onClose, children: children, isInnerModalOpen: isInnerModalOpen, intl: { formatMessage: formatMessage } })=>{
    const Header = ()=>{
        const origin = (0, $eUqFw.useMemo)(()=>new (0, $jkH4Q.default)({
                product: 'jira'
            }), []);
        const handleOpenInConfluence = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
            const originAttributes = origin?.toAnalyticsAttributes({
                hasGeneratedId: true
            });
            (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'openEmbeddedViewPageInConfluenceButton', originAttributes);
        }, [
            origin
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5oAL6.CustomModalHeader), null, headerBtnHref ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
            iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($hGcnP))),
            // technically href already has an origin generated by confluence-table-tree, but we clobber it
            // since we are firing the click event with a new generated id
            href: headerBtnHref,
            target: "_blank",
            onClick: handleOpenInConfluence,
            testId: "confluence-project-pages.embedded-confluence-dialog.open-in-confluence-button"
        }, formatMessage((0, $awobK.default).titleButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($hGcnP))),
            onClick: handleOpenInConfluence,
            testId: "confluence-project-pages.embedded-confluence-dialog.open-in-confluence-button"
        }, formatMessage((0, $awobK.default).titleButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: formatMessage((0, $awobK.default).closeHint)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            onClick: onClose,
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8xkEh))),
            label: formatMessage((0, $awobK.default).closeHint),
            testId: "confluence-project-pages.embedded-confluence-dialog.close-button"
        })));
    };
    const modalBodyWrapperTestId = mode === 'view' ? 'confluence-project-pages.embedded-confluence-dialog.modal-body-view-wrapper' : 'confluence-project-pages.embedded-confluence-dialog.modal-body-edit-wrapper';
    const ModalBodyWrapper = mode === 'view' ? (0, $5oAL6.ModalBodyViewWrapper) : (0, $5oAL6.ModalBodyEditWrapper);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        autoFocus: false,
        onClose: onClose,
        width: '100%',
        height: '100%'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5oAL6.ModalContainer), null, mode === 'view' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ModalBodyWrapper, {
        "data-testid": modalBodyWrapperTestId
    }, children, isInnerModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5oAL6.ModalInnerBlanket), {
        "data-testid": "confluence-project-pages.embedded-confluence-dialog.modal-inner-blanket"
    })))), isInnerModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5oAL6.ModalOuterBlanket), {
        "data-testid": "confluence-project-pages.embedded-confluence-dialog.modal-outer-blanket"
    }));
};
var $0d3feac860b7969f$export$2e2bcd8739ae039 = (0, $2qhQi.default)($0d3feac860b7969f$var$EmbeddedPageModal);

});
parcelRegister("hGcnP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40593711b26197c57261c5345b6d6cc5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cdeff6f7a5b7fded$var$_react = $cdeff6f7a5b7fded$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cdeff6f7a5b7fded$var$_linkExternal = $cdeff6f7a5b7fded$var$_interopRequireDefault((parcelRequire("1yh1n")));

var $cdeff6f7a5b7fded$var$_shortcut = $cdeff6f7a5b7fded$var$_interopRequireDefault((parcelRequire("23NQ5")));
function $cdeff6f7a5b7fded$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkExternalIcon.
 * This component is LinkExternalIcon, with `UNSAFE_fallbackIcon` set to "ShortcutIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cdeff6f7a5b7fded$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $cdeff6f7a5b7fded$var$_react.default.createElement($cdeff6f7a5b7fded$var$_linkExternal.default, Object.assign({
        LEGACY_fallbackIcon: $cdeff6f7a5b7fded$var$_shortcut.default
    }, props));
$cdeff6f7a5b7fded$var$LinkExternalIcon.Name = 'LinkExternalIconMigration';
var $cdeff6f7a5b7fded$var$_default = module.exports.default = $cdeff6f7a5b7fded$var$LinkExternalIcon;

});

parcelRegister("awobK", function(module, exports) {

$parcel$export(module.exports, "default", () => $71d86fa41ccb8f18$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $71d86fa41ccb8f18$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    titleButton: {
        id: 'project-pages.embedded-pages.modal.title.button',
        defaultMessage: 'Open in Confluence',
        description: 'Button title for the embedded page modal that opens the current page in Confluence'
    },
    openInANewTabHint: {
        id: 'project-pages.embedded-pages.modal.title.button.hint',
        defaultMessage: 'Open in a new tab',
        description: 'Button icon hint for the embedded page modal that opens the current page in Confluence'
    },
    closeHint: {
        id: 'project-pages.embedded-pages.modal.close.button.hint',
        defaultMessage: 'Close',
        description: 'Button icon hint for the embedded page modal that closes the modal'
    }
});

});

parcelRegister("5oAL6", function(module, exports) {

$parcel$export(module.exports, "CustomModalHeader", () => $05dd00143359a6df$export$317cc87ecc16a2d3);
$parcel$export(module.exports, "ModalBodyViewWrapper", () => $05dd00143359a6df$export$d8491371e5906f72);
$parcel$export(module.exports, "ModalBodyEditWrapper", () => $05dd00143359a6df$export$16fb1c3667f7fb66);
$parcel$export(module.exports, "ModalContainer", () => $05dd00143359a6df$export$c9554889b3e706cd);
$parcel$export(module.exports, "ModalOuterBlanket", () => $05dd00143359a6df$export$283b6f7b7aeabb83);
$parcel$export(module.exports, "ModalInnerBlanket", () => $05dd00143359a6df$export$5d882c4a695c0ed6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");


var $lcnyw = parcelRequire("lcnyw");
const $05dd00143359a6df$export$317cc87ecc16a2d3 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "b0hh3i-0"
})({
    display: 'flex',
    position: 'relative',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-250, 20px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginBottom: `${(0, $lcnyw.gridSize)() * 1.25}px`,
    borderBottom: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`}`,
    justifyContent: 'space-between'
});
const $05dd00143359a6df$export$d8491371e5906f72 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "b0hh3i-1"
})({
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-250, 20px)"}`
    }
});
const $05dd00143359a6df$export$16fb1c3667f7fb66 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "b0hh3i-2"
})({
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        padding: "var(--ds-space-0, 0px)",
        overflowY: 'hidden'
    }
});
const $05dd00143359a6df$export$c9554889b3e706cd = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "b0hh3i-3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        width: 'calc(100vw - 120px)',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        padding: '1px' // needed to display border-radius in edit mode
    },
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
});
const $05dd00143359a6df$export$283b6f7b7aeabb83 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "b0hh3i-4"
})({
    height: '100vh',
    width: '100vw',
    position: 'fixed',
    top: "var(--ds-space-0, 0px)",
    left: "var(--ds-space-0, 0px)",
    zIndex: (0, $lcnyw.layers).modal(),
    backgroundColor: `var(--ds-blanket, ${(0, $73a5c9d720aa66e1$export$486ab785e4bac3c6)})`
});
const $05dd00143359a6df$export$5d882c4a695c0ed6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "b0hh3i-5"
})({
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: "var(--ds-space-0, 0px)",
    left: "var(--ds-space-0, 0px)",
    zIndex: 0,
    backgroundColor: `var(--ds-blanket, ${(0, $73a5c9d720aa66e1$export$486ab785e4bac3c6)})`
});

});


parcelRegister("5mIIe", function(module, exports) {

$parcel$export(module.exports, "LoadingContainer", () => $126ef3ad5669e7e0$export$5e3f251c730829);
// this component replicates the Confluence loading screen in the iframe as close to pixel-perfect
// as possible, so that we can transition between loading the iframe and rendering the iframe once
// it's ready as seamlessly as possible

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $5KT10 = parcelRequire("5KT10");

var $lcnyw = parcelRequire("lcnyw");
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $126ef3ad5669e7e0$var$Blanket = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-714cn4-0"
})({
    zIndex: (0, $lcnyw.layers).blanket(),
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundColor: "var(--ds-surface, white)",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span': {
        height: '56px',
        margin: '181px 14px 13px 11px',
        animation: 'pulse 2s infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '@keyframes pulse': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '0%': {
                opacity: 0.7
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '50%': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '100%': {
                opacity: 0.7
            }
        }
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $126ef3ad5669e7e0$var$Container = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-714cn4-1"
})({
    position: 'relative',
    height: '100%',
    zIndex: 1,
    // make sure this is on top of the inner modal blanket when it is shown
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    iframe: {
        backgroundColor: "var(--ds-surface, white)"
    } // ensure the iframe is not transparent so we won't see the modal blanket under it even if the content is short
});
const $126ef3ad5669e7e0$export$5e3f251c730829 = ({ isLoading: isLoading, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($126ef3ad5669e7e0$var$Container, {
        "data-testid": "embedded-confluence-loading-container"
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($126ef3ad5669e7e0$var$Blanket, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
        appearance: "neutral"
    })));

});
parcelRegister("5KT10", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $bd2fb8be68c26b84$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $bd2fb8be68c26b84$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $bd2fb8be68c26b84$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $bd2fb8be68c26b84$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("ez8b7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f782eb152cfe8d4d$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $58xWZ = parcelRequire("58xWZ");

var $jGyKS = parcelRequire("jGyKS");
const $f782eb152cfe8d4d$var$mapStateToProps = (state)=>({
        projectId: (0, $jGyKS.getProjectId)(state),
        projectType: (0, $jGyKS.getProjectType)(state)
    });
var $f782eb152cfe8d4d$export$2e2bcd8739ae039 = (0, $cllCv.connect)($f782eb152cfe8d4d$var$mapStateToProps)((0, $58xWZ.default));

});
parcelRegister("58xWZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a2fbda6ed213dc4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");

var $220ac = parcelRequire("220ac");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $kwce8 = parcelRequire("kwce8");

var $4iCLc = parcelRequire("4iCLc");

var $l3ugm = parcelRequire("l3ugm");

var $iCgZp = parcelRequire("iCgZp");

var $d9yvy = parcelRequire("d9yvy");

var $gWxA1 = parcelRequire("gWxA1");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a2fbda6ed213dc4$var$Wrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-13iwcac-0"
})({
    display: 'flex',
    height: '100%',
    alignItems: 'center'
});
const $6a2fbda6ed213dc4$var$CreatePageError = ({ spaceKey: spaceKey, onCloseModal: onCloseModal, projectId: projectId, projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { pageCreate: pageCreate } = (0, $4iCLc.useEmbeddedPage)();
    const handleClose = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        onCloseModal();
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'createEmbeddedPageErrorCloseButton', {
            embeddedPageAction: true
        });
    }, [
        onCloseModal
    ]);
    const createEmbeddedPage = (0, $iCgZp.useCreateEmbeddedPage)({
        spaceKey: spaceKey,
        projectId: projectId,
        projectType: projectType
    });
    const handleTryAgain = (0, $eUqFw.useCallback)(async (_, analyticsEvent)=>{
        if (pageCreate) await createEmbeddedPage(pageCreate.parentContentId, pageCreate.isRoot, pageCreate.blueprint);
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'createEmbeddedPageErrorTryAgainButton', {
            embeddedPageAction: true
        });
    }, [
        createEmbeddedPage,
        pageCreate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a2fbda6ed213dc4$var$Wrapper, {
        "data-testid": "embedded-confluence-error-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($l3ugm))),
        imageWidth: 71,
        header: formatMessage((0, $d9yvy.default).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $d9yvy.default).description),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            appearance: "primary",
            onClick: handleTryAgain
        }, formatMessage((0, $d9yvy.default).tryAgain)),
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            onClick: handleClose
        }, formatMessage((0, $d9yvy.default).close))
    }));
};
var $6a2fbda6ed213dc4$export$2e2bcd8739ae039 = $6a2fbda6ed213dc4$var$CreatePageError;

});
parcelRegister("d9yvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3b8a25792a1fad$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7c3b8a25792a1fad$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        id: 'project-pages.embedded-pages.create-page-error.title',
        defaultMessage: "We couldn\u2019t create a page",
        description: 'Title of create page error modal'
    },
    description: {
        id: 'project-pages.embedded-pages.create-page-error.description',
        defaultMessage: "There was a problem and we couldn\u2019t create a page for you.",
        description: 'Description of create page error modal'
    },
    tryAgain: {
        id: 'project-pages.embedded-pages.create-page-error.try-again-button',
        defaultMessage: 'Try again',
        description: 'Try again button label for the create page error modal'
    },
    close: {
        id: 'project-pages.embedded-pages.create-page-error.close-button',
        defaultMessage: 'Close',
        description: 'Button label for closing the create page error modal'
    }
});

});




parcelRegister("2ZONo", function(module, exports) {

$parcel$export(module.exports, "default", () => $d66b7ea1783e822d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $2qhQi = parcelRequire("2qhQi");

var $kHo9c = parcelRequire("kHo9c");


var $85INN = parcelRequire("85INN");

var $aGbLO = parcelRequire("aGbLO");

var $kgX2t = parcelRequire("kgX2t");

var $6deQg = parcelRequire("6deQg");

var $4iCLc = parcelRequire("4iCLc");
parcelRequire("hPmJU");
var $03Jpi = parcelRequire("03Jpi");

var $b18Mx = parcelRequire("b18Mx");

var $6ji7W = parcelRequire("6ji7W");

var $4sLzA = parcelRequire("4sLzA");

var $haZRi = parcelRequire("haZRi");

var $4R1VH = parcelRequire("4R1VH");

var $dVd22 = parcelRequire("dVd22");

var $7YRWo = parcelRequire("7YRWo");

var $k93Dd = parcelRequire("k93Dd");

var $e8sOK = parcelRequire("e8sOK");

var $ampft = parcelRequire("ampft");

var $ehFRZ = parcelRequire("ehFRZ");
const $d66b7ea1783e822d$var$View = (props)=>{
    const { CreateSpaceDialog: CreateSpaceDialog, ConnectSpaceDialog: ConnectSpaceDialog, MoreMenu: MoreMenu, PagesHeading: PagesHeading, Flags: Flags, breadcrumbs: breadcrumbs, EmbeddedConfluenceDialog: EmbeddedConfluenceDialog, triggerShowConnectSpaceDialog: triggerShowConnectSpaceDialog, triggerHideConnectSpaceDialog: triggerHideConnectSpaceDialog, confluenceLicenseStatus: confluenceLicenseStatus, confluenceState: confluenceState, hasConfluence: hasConfluence, renderFullHeader: renderFullHeader = true, projectSpaceKey: projectSpaceKey, hasAccessToConfluence: hasAccessToConfluence } = props;
    const isErrorState = (0, $eUqFw.useMemo)(()=>{
        return [
            (0, $eda5adb3daefc3fa$export$65d0a606bcce00e6),
            (0, $eda5adb3daefc3fa$export$52022723d6fe5666)
        ].includes(confluenceLicenseStatus);
    }, [
        confluenceLicenseStatus
    ]);
    const containerRef = (0, $eUqFw.useRef)(null);
    const dataTestId = hasAccessToConfluence ? 'post-expand' : 'pre-expand';
    const handleReload = (0, $eUqFw.useCallback)(()=>window.location.reload(), []);
    const isCrossSell = confluenceLicenseStatus === (0, $eda5adb3daefc3fa$export$beb27109f0387267);
    const theme = (0, $6ji7W.useThemeContext)();
    const shouldShowMeatballMenu = !isErrorState && confluenceState === (0, $kHo9c.CONFLUENCE_ACTIVE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4sLzA.ProjectPagesContent, {
        innerRef: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4sLzA.ProjectPagesContentWrapper, {
        "data-testid": `confluence-project-pages.${dataTestId}`,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4sLzA.ViewContainer, {
        id: "project-pages-view-container",
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4sLzA.ViewSpacer, {
        hasHeader: renderFullHeader
    }, renderFullHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dVd22.default), {
        breadcrumbs: breadcrumbs,
        isCrossSell: isCrossSell,
        MoreMenu: MoreMenu,
        shouldShowMeatballMenu: shouldShowMeatballMenu
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ehFRZ.CompactHeader), {
        MoreMenu: MoreMenu,
        shouldShowMeatballMenu: shouldShowMeatballMenu
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4sLzA.MainContainer, {
        id: "project-pages-main-container",
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PagesHeading, {
        key: "PagesHeading",
        isPreExpand: isCrossSell
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7YRWo.ActivePage), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ConnectSpaceDialog, {
        key: "ConnectSpaceDialog",
        onCancel: triggerHideConnectSpaceDialog
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CreateSpaceDialog, {
        key: "CreateSpaceDialog",
        onCancel: triggerShowConnectSpaceDialog
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EmbeddedConfluenceDialog, {
        spaceKey: projectSpaceKey
    }), confluenceState !== (0, $kHo9c.CONFLUENCE_LOADING) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85INN.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aGbLO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Flags, {
        onReload: handleReload
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $haZRi.default), {
        hasAccessToConfluence: hasAccessToConfluence
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e8sOK.PageDecorators), {
        hasConfluence: hasConfluence,
        containerRef: containerRef
    }))));
};
const $d66b7ea1783e822d$var$withProviders = (Component)=>(props)=>{
        const { triggerErrorFlag: triggerErrorFlag, accountId: accountId, confluenceState: confluenceState, triggerInitializeView: triggerInitializeView } = props;
        const [activeTemplatePreview, setActiveTemplatePreview] = (0, $eUqFw.useState)((0, $4R1VH.getBasePreExpandTemplates)()[0]);
        const analyticsClient = (0, $eUqFw.useMemo)((0, $b18Mx.getAnalyticsWebClient), []);
        (0, $eUqFw.useEffect)(()=>{
            triggerInitializeView();
        }, [
            triggerInitializeView
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6deQg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4iCLc.EmbeddedPageProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $03Jpi.ConfluencePageTreeProvider), {
            onError: triggerErrorFlag,
            // @ts-expect-error -  Type 'import("platform/packages/atlassian-analytics-pipeline/analytics-web-client/dist/types/analyticsWebClient").default' is not assignable to type 'import("platform/packages/confluence/confluence-table-tree/dist/types/types").AnalyticsWebClient'.
            analyticsClient: analyticsClient,
            accountId: accountId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
            data: {
                attributes: {
                    hasConfluence: confluenceState === (0, $kHo9c.CONFLUENCE_ACTIVE)
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgX2t.TemplateProvider), {
            value: {
                template: activeTemplatePreview,
                setActiveTemplatePreview: setActiveTemplatePreview
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ampft.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k93Dd.RouteProvider), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props))))))));
    };
var $d66b7ea1783e822d$export$2e2bcd8739ae039 = (0, $2qhQi.default)($d66b7ea1783e822d$var$withProviders($d66b7ea1783e822d$var$View));

});
parcelRegister("aGbLO", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc51694071e71c51$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $4aXoz = parcelRequire("4aXoz");

var $iybhd = parcelRequire("iybhd");
const $fc51694071e71c51$var$mapStateToProps = (state)=>({
        connectionState: (0, $4aXoz.getConnectionState)(state)
    });
var $fc51694071e71c51$export$2e2bcd8739ae039 = (0, $cllCv.connect)($fc51694071e71c51$var$mapStateToProps)((0, $iybhd.default));

});
parcelRegister("iybhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $35154c5e3a6f305d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b18Mx = parcelRequire("b18Mx");
const $35154c5e3a6f305d$var$SpaceConnectionTracker = ({ connectionState: connectionState })=>{
    (0, $eUqFw.useEffect)(()=>{
        if (![
            'CONNECTED',
            'NOT_CONNECTED',
            'ERROR'
        ].includes(connectionState)) return;
        (0, $b18Mx.sendTrackAnalyticsEvent)({
            source: 'space.tracker',
            action: 'retrieved',
            actionSubject: 'fetchSpaceConnectionStatus',
            attributes: {
                status: connectionState
            }
        });
    }, [
        connectionState
    ]);
    return null;
};
var $35154c5e3a6f305d$export$2e2bcd8739ae039 = $35154c5e3a6f305d$var$SpaceConnectionTracker;

});


parcelRegister("6deQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $850ce0e45a0d08e6$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $9c14t = parcelRequire("9c14t");

var $4aXoz = parcelRequire("4aXoz");

var $k5Sv6 = parcelRequire("k5Sv6");
const $850ce0e45a0d08e6$var$mapStateToProps = (state)=>({
        accessRequestCapability: (0, $9c14t.getAccessRequestCapability)(state),
        isSpaceConnected: (0, $4aXoz.isSpaceConnected)(state),
        confluenceEdition: (0, $4aXoz.getConfluenceEdition)(state),
        jswEdition: (0, $4aXoz.getJswEdition)(state)
    });
var $850ce0e45a0d08e6$export$2e2bcd8739ae039 = (0, $cllCv.connect)($850ce0e45a0d08e6$var$mapStateToProps)((0, $k5Sv6.default));

});
parcelRegister("k5Sv6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb083be23968723$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");


var $kJeqC = parcelRequire("kJeqC");

var $dcSvg = parcelRequire("dcSvg");
const $9fb083be23968723$var$CROSS_JOIN_SCENARIOS = [
    {
        type: (0, $dcSvg.AccessRequestCapabilityType).DIRECT_ACCESS,
        analyticsName: 'join-product'
    },
    {
        type: (0, $dcSvg.AccessRequestCapabilityType).REQUEST_ACCESS,
        analyticsName: 'request-access'
    },
    {
        type: (0, $dcSvg.AccessRequestCapabilityType).PENDING_REQUEST_EXISTS,
        analyticsName: 'access-requested'
    },
    {
        type: (0, $dcSvg.AccessRequestCapabilityType).DENIED_REQUEST_EXISTS,
        analyticsName: 'access-denied'
    },
    {
        type: (0, $dcSvg.AccessRequestCapabilityType).APPROVED_REQUEST_EXISTS,
        analyticsName: 'access-revoked'
    },
    {
        type: (0, $dcSvg.AccessRequestCapabilityType).ERROR,
        analyticsName: 'error'
    }
];
const $9fb083be23968723$var$View = ({ isSpaceConnected: isSpaceConnected, confluenceEdition: confluenceEdition, jswEdition: jswEdition, accessRequestCapability: accessRequestCapability, children: children })=>{
    const crossJoinScenario = $9fb083be23968723$var$CROSS_JOIN_SCENARIOS.find(({ type: type })=>type === accessRequestCapability)?.analyticsName;
    const isCrossJoinProjectExperimentEnabled = (0, $kJeqC.getTargetingGate)((0, $acc8984185b87525$export$7d578ef8316f5d8b));
    const crossJoinNudgeExperimentCohort = isCrossJoinProjectExperimentEnabled ? (0, $kJeqC.getExperimentValue)((0, $acc8984185b87525$export$616a7764e9436f13), 'not-enrolled', false) : 'not-enrolled';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            attributes: {
                isSpaceConnected: isSpaceConnected,
                isCrossJoinProjectExperimentEnabled: isCrossJoinProjectExperimentEnabled,
                crossJoinNudgeExperimentCohort: crossJoinNudgeExperimentCohort,
                crossJoinScenario: crossJoinScenario,
                confluenceEdition: confluenceEdition,
                jswEdition: jswEdition
            }
        }
    }, children);
};
var $9fb083be23968723$export$2e2bcd8739ae039 = $9fb083be23968723$var$View;

});


parcelRegister("4sLzA", function(module, exports) {

$parcel$export(module.exports, "ProjectPagesContent", () => $f2e0b048f769b3e5$export$4d4ef902168a75a);
$parcel$export(module.exports, "ProjectPagesContentWrapper", () => $f2e0b048f769b3e5$export$942cb012bbd94748);
$parcel$export(module.exports, "ViewContainer", () => $f2e0b048f769b3e5$export$19fb617b96998849);
$parcel$export(module.exports, "ViewSpacer", () => $f2e0b048f769b3e5$export$9525d58b36c82c4e);
$parcel$export(module.exports, "MainContainer", () => $f2e0b048f769b3e5$export$d653589df987fd93);
$parcel$export(module.exports, "PageTitleStyleWrapper", () => $f2e0b048f769b3e5$export$bd8006fee20a6b76);
$parcel$export(module.exports, "PageHeaderStyleWrapper", () => $f2e0b048f769b3e5$export$380dde9e77692cbd);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $f2e0b048f769b3e5$export$4d4ef902168a75a = /*#__PURE__*/ (0, $kwce8.default).main.withConfig({
    componentId: "sc-1bpsg6h-0"
})`height:100%;flex:1 1 auto;`;
const $f2e0b048f769b3e5$export$942cb012bbd94748 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1bpsg6h-1"
})`height:100%;${({ theme: theme })=>theme?.overrideStyles?.contentWrapper ? `padding: ${theme?.overrideStyles.contentWrapper.padding}` : `padding: 0 ${"var(--ds-space-500, 40px)"} 0 0`};`;
const $f2e0b048f769b3e5$export$19fb617b96998849 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1bpsg6h-2"
})`width:100%;${({ theme: theme })=>theme?.overrideStyles?.viewContainer ? `padding: ${theme?.overrideStyles.viewContainer.padding}` : `padding-bottom: ${"var(--ds-space-300, 24px)"}`};display:flex;flex-direction:row;height:100%;`;
const $f2e0b048f769b3e5$export$9525d58b36c82c4e = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1bpsg6h-3"
})`flex:1 1 auto;overflow-x:auto;margin-right:${"var(--ds-space-500, 40px)"};position:relative;display:flex;flex-direction:column;${({ hasHeader: hasHeader })=>!hasHeader && `padding-top: ${"var(--ds-space-300, 24px)"};`}`;
const $f2e0b048f769b3e5$export$d653589df987fd93 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1bpsg6h-4"
})`${({ theme: theme })=>theme.overrideStyles?.mainContainer && `background-color: ${theme.overrideStyles.mainContainer.backgroundColor};
  color: ${theme.overrideStyles.mainContainer.color};
  border-radius: ${theme.overrideStyles.mainContainer.borderRadius};
  padding: ${theme.overrideStyles.mainContainer.padding};`}`;
const $f2e0b048f769b3e5$export$bd8006fee20a6b76 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1bpsg6h-5"
})`${({ theme: theme })=>theme.overrideStyles?.pageTitleStyleWrapper && `color: ${theme.overrideStyles.pageTitleStyleWrapper.color};
  margin-top: ${theme.overrideStyles.pageTitleStyleWrapper.marginTop}px;
  line-height: ${theme.overrideStyles.pageTitleStyleWrapper.lineHeight};
  outline: ${theme.overrideStyles.pageTitleStyleWrapper.outline};
  font-size: ${theme.overrideStyles.pageTitleStyleWrapper.fontSize};`}`;
const $f2e0b048f769b3e5$export$380dde9e77692cbd = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1bpsg6h-6"
})`${({ theme: theme })=>theme.overrideStyles?.pageHeader?.wrapper && `background-color: ${theme.overrideStyles.pageHeader.wrapper.backgroundColor};
  padding: ${theme.overrideStyles.pageHeader.wrapper.padding};
  margin: ${theme.overrideStyles.pageHeader.wrapper.margin};
  border-radius: ${theme.overrideStyles.pageHeader.wrapper.borderRadius};`}`;

});

parcelRegister("haZRi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9878e8ad6bc3c31d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $25FRy = parcelRequire("25FRy");

var $4kMup = parcelRequire("4kMup");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $jkH4Q = parcelRequire("jkH4Q");

var $gWxA1 = parcelRequire("gWxA1");

var $9SoUI = parcelRequire("9SoUI");

var $6ji7W = parcelRequire("6ji7W");

var $h2RtS = parcelRequire("h2RtS");
const $9878e8ad6bc3c31d$var$buttonStyles = (0, $1ZAYh.xcss)({
    marginInlineStart: 'space.050',
    paddingInline: 'space.100',
    paddingBlock: 'space.050',
    height: 'size.200',
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 'border.radius',
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $9878e8ad6bc3c31d$var$PoweredByConfluenceFooter = ({ intl: intl, hasAccessToConfluence: hasAccessToConfluence })=>{
    const origin = (0, $eUqFw.useMemo)(()=>new (0, $jkH4Q.default)({
            product: 'jira'
        }), []);
    const theme = (0, $6ji7W.useThemeContext)();
    const handlePoweredByClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        const originAttributes = origin.toAnalyticsAttributes({
            hasGeneratedId: true
        });
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'poweredByConfluenceButton', originAttributes);
    }, [
        origin
    ]);
    return hasAccessToConfluence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9SoUI.StyledFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9SoUI.PoweredBy), {
        theme: theme
    }, intl.formatMessage((0, $h2RtS.default).poweredBy), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: intl.formatMessage((0, $h2RtS.default).poweredByTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        onClick: handlePoweredByClick,
        href: origin.addToUrl('/wiki'),
        target: "_blank",
        xcss: $9878e8ad6bc3c31d$var$buttonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $25FRy.ConfluenceLogo), {
        size: "xsmall",
        appearance: "neutral"
    }))))) : null;
};
var $9878e8ad6bc3c31d$export$2e2bcd8739ae039 = (0, $2qhQi.default)($9878e8ad6bc3c31d$var$PoweredByConfluenceFooter);

});
parcelRegister("25FRy", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogo", () => $c3f107972b89a433$export$1b2e4fe6ef471556);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $c3f107972b89a433$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 180 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098"/>
      <path fill="${colors.textColor}" d="M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227"/>
    </svg>
    `;
};
const $c3f107972b89a433$export$1b2e4fe6ef471556 = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c3f107972b89a433$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9SoUI", function(module, exports) {

$parcel$export(module.exports, "StyledFooter", () => $5e0ec1351a9d48b5$export$61905ae62c7860fb);
$parcel$export(module.exports, "PoweredBy", () => $5e0ec1351a9d48b5$export$3dbb5766eaeb5b24);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

const $5e0ec1351a9d48b5$export$61905ae62c7860fb = /*#__PURE__*/ (0, $kwce8.default).footer.withConfig({
    componentId: "rgz360-0"
})({
    textAlign: 'center',
    marginTop: 'auto',
    padding: `${"var(--ds-space-200, 16px)"} 0`
});
const $5e0ec1351a9d48b5$export$3dbb5766eaeb5b24 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "rgz360-1"
})({
    fontSize: '11px',
    lineHeight: '14px',
    display: 'inline-flex',
    alignItems: 'center'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ theme: theme })=>`color: ${theme.overrideStyles?.poweredBy?.color || `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})`} ;`);

});

parcelRegister("h2RtS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7876f27281bfdba2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7876f27281bfdba2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    poweredBy: {
        id: 'project-pages.improvement.powered-by',
        defaultMessage: 'Powered by',
        description: 'Prefix to the footer indicating the Project pages feature is powered by Confluence'
    },
    poweredByTooltip: {
        id: 'project-pages.improvement.powered-by.tooltip',
        defaultMessage: 'Open Confluence in a new tab',
        description: 'Tooltip on the Confluence logo in the powered by footer to indicate that clicking will open Confluence in a new tab'
    }
});

});


parcelRegister("4R1VH", function(module, exports) {

$parcel$export(module.exports, "getDefaultTemplates", () => $03557462562c21be$export$8cf83cfb3f569a52);
$parcel$export(module.exports, "moreTemplatesBase", () => $03557462562c21be$export$511a74d9b2114743);
$parcel$export(module.exports, "getBasePreExpandTemplates", () => $03557462562c21be$export$4286cc6e4b577f02);
$parcel$export(module.exports, "getTutorialTemplate", () => $03557462562c21be$export$2fcaa2667dafd1ee);

var $eUqFw = parcelRequire("eUqFw");

var $7vgFZ = parcelRequire("7vgFZ");

var $fu3px = parcelRequire("fu3px");

var $kLb7F = parcelRequire("kLb7F");

var $aGd41 = parcelRequire("aGd41");

var $C0oHT = parcelRequire("C0oHT");

var $5H3Kn = parcelRequire("5H3Kn");


var $hpJ8O = parcelRequire("hpJ8O");

var $fVsKL = parcelRequire("fVsKL");

var $6jUv4 = parcelRequire("6jUv4");

var $dZsZr = parcelRequire("dZsZr");

var $6TeVR = parcelRequire("6TeVR");

var $734Zv = parcelRequire("734Zv");

var $dWs8I = parcelRequire("dWs8I");

var $kJeqC = parcelRequire("kJeqC");

var $gA5DM = parcelRequire("gA5DM");

var $f6CbL = parcelRequire("f6CbL");

var $6ccZl = parcelRequire("6ccZl");

var $ikRGc = parcelRequire("ikRGc");

var $8XBaT = parcelRequire("8XBaT");

var $cPWXl = parcelRequire("cPWXl");

var $aZsgD = parcelRequire("aZsgD");

var $fBHxs = parcelRequire("fBHxs");

var $65Tlk = parcelRequire("65Tlk");

var $4bthJ = parcelRequire("4bthJ");

var $17qPc = parcelRequire("17qPc");

var $2aHUT = parcelRequire("2aHUT");

var $9nsB9 = parcelRequire("9nsB9");

var $4T8DH = parcelRequire("4T8DH");

var $jkYBh = parcelRequire("jkYBh");

var $02eMl = parcelRequire("02eMl");

var $iqKPt = parcelRequire("iqKPt");

var $acp0d = parcelRequire("acp0d");

var $69IE8 = parcelRequire("69IE8");

var $6k5IT = parcelRequire("6k5IT");

var $akCzB = parcelRequire("akCzB");

var $lhngP = parcelRequire("lhngP");

var $9y711 = parcelRequire("9y711");

var $kreb0 = parcelRequire("kreb0");

var $fFk3W = parcelRequire("fFk3W");

var $f7HeT = parcelRequire("f7HeT");

var $irYj5 = parcelRequire("irYj5");

var $ghDkc = parcelRequire("ghDkc");
const $03557462562c21be$var$defaultTemplates = [
    {
        type: (0, $dZsZr.TemplateType).Confluence,
        key: 'blankPage',
        name: (0, $fVsKL.default).blankPageTemplateName,
        description: (0, $fVsKL.default).blankPageTemplateDescription,
        blueprintModuleCompleteKey: null,
        itemModuleCompleteKey: (0, $6TeVR.ItemModuleCompleteKeys).BLANK_PAGE,
        iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6jUv4.TemplateIcon), {
                size: size,
                backgroundColor: color
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($C0oHT))), {
                label: "blank",
                color: "var(--ds-icon-inverse, #fff)",
                LEGACY_size: size
            })),
        defaultIconColor: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
        preview: {
            preExpand: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($gA5DM))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($02eMl)))
            },
            postExpand: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($f6CbL))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($jkYBh)))
            }
        }
    },
    {
        type: (0, $dZsZr.TemplateType).Confluence,
        key: 'productRequirements',
        name: (0, $fVsKL.default).productRequirementsTemplateName,
        description: (0, $fVsKL.default).productRequirementsTemplateDescription,
        blueprintModuleCompleteKey: (0, $6TeVR.BlueprintModuleCompleteKeys).PRODUCT_REQUIREMENTS,
        itemModuleCompleteKey: (0, $6TeVR.ItemModuleCompleteKeys).PRODUCT_REQUIREMENTS,
        iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6jUv4.TemplateIcon), {
                size: size,
                backgroundColor: color
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7vgFZ))), {
                label: "product-requirements",
                color: "var(--ds-icon-inverse, #fff)",
                LEGACY_size: size
            })),
        defaultIconColor: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$export$b48405b95304b5a1)})`,
        preview: {
            preExpand: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($fBHxs))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($lhngP)))
            },
            postExpand: {
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($akCzB))),
                default: (0, (/*@__PURE__*/$parcel$interopDefault($ikRGc)))
            }
        },
        getTitle: ()=>`${(0, $734Zv.getDateString)()} Product requirements`
    },
    {
        type: (0, $dZsZr.TemplateType).Confluence,
        key: 'decision',
        name: (0, $fVsKL.default).decisionTemplateName,
        description: (0, $fVsKL.default).decisionTemplateDescription,
        blueprintModuleCompleteKey: (0, $6TeVR.BlueprintModuleCompleteKeys).DECISION,
        itemModuleCompleteKey: (0, $6TeVR.ItemModuleCompleteKeys).DECISION,
        iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6jUv4.TemplateIcon), {
                size: size,
                backgroundColor: color
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fu3px))), {
                label: "decision",
                color: "var(--ds-icon-inverse, #fff)",
                LEGACY_size: size
            })),
        defaultIconColor: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`,
        preview: {
            preExpand: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($8XBaT))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($acp0d)))
            },
            postExpand: {
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($iqKPt))),
                default: (0, (/*@__PURE__*/$parcel$interopDefault($6ccZl)))
            }
        },
        getTitle: ()=>`${(0, $734Zv.getDateString)()} Decision`
    },
    {
        type: (0, $dZsZr.TemplateType).Confluence,
        key: 'meetingNotes',
        name: (0, $fVsKL.default).meetingNotesTemplateName,
        description: (0, $fVsKL.default).meetingNotesTemplateDescription,
        blueprintModuleCompleteKey: (0, $6TeVR.BlueprintModuleCompleteKeys).MEETING_NOTES,
        itemModuleCompleteKey: (0, $6TeVR.ItemModuleCompleteKeys).MEETING_NOTES,
        iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6jUv4.TemplateIcon), {
                size: size,
                backgroundColor: color
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5H3Kn))), {
                label: "meeting-notes",
                color: "var(--ds-icon-inverse, #fff)",
                LEGACY_size: size
            })),
        defaultIconColor: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$export$9dc1ef0f3f48059b)})`,
        preview: {
            preExpand: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($cPWXl))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($6k5IT)))
            },
            postExpand: {
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($69IE8))),
                default: (0, (/*@__PURE__*/$parcel$interopDefault($aZsgD)))
            }
        }
    },
    {
        type: (0, $dZsZr.TemplateType).Confluence,
        key: 'retrospective',
        name: (0, $fVsKL.default).retrospectiveTemplateName,
        description: (0, $fVsKL.default).retrospectiveTemplateDescription,
        blueprintModuleCompleteKey: (0, $6TeVR.BlueprintModuleCompleteKeys).RESTROSPECTIVE,
        itemModuleCompleteKey: (0, $6TeVR.ItemModuleCompleteKeys).RESTROSPECTIVE,
        iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6jUv4.TemplateIcon), {
                size: size,
                backgroundColor: color
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hpJ8O))), {
                label: "retrospective",
                color: "var(--ds-icon-inverse, #fff)",
                LEGACY_size: size
            })),
        defaultIconColor: `var(--ds-background-accent-yellow-bolder, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`,
        preview: {
            preExpand: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($65Tlk))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($kreb0)))
            },
            postExpand: {
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($9y711))),
                default: (0, (/*@__PURE__*/$parcel$interopDefault($4bthJ)))
            }
        },
        getTitle: ()=>`${(0, $734Zv.getDateString)()} Retrospective`
    }
];
const $03557462562c21be$export$8cf83cfb3f569a52 = ()=>$03557462562c21be$var$defaultTemplates;
const $03557462562c21be$export$511a74d9b2114743 = {
    key: 'more',
    iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6jUv4.TemplateIcon), {
            size: size,
            backgroundColor: color
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kLb7F))), {
            label: "more",
            color: "var(--ds-icon, #000)",
            LEGACY_size: size
        })),
    defaultIconColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`
};
const $03557462562c21be$var$reorderedWeight = {
    [(0, $6TeVR.ItemModuleCompleteKeys).MEETING_NOTES]: 1,
    [(0, $6TeVR.ItemModuleCompleteKeys).PRODUCT_REQUIREMENTS]: 2,
    [(0, $6TeVR.ItemModuleCompleteKeys).RESTROSPECTIVE]: 3,
    [(0, $6TeVR.ItemModuleCompleteKeys).DECISION]: 4,
    [(0, $6TeVR.ItemModuleCompleteKeys).BLANK_PAGE]: 5
};
const $03557462562c21be$export$4286cc6e4b577f02 = ()=>{
    const templates = [
        ...$03557462562c21be$export$8cf83cfb3f569a52()
    ];
    if ((0, $kJeqC.getExperimentValue)('jsw_project_pages_reorder_templates_v2', 'not-enrolled') === 'variation') templates.sort((a, b)=>$03557462562c21be$var$reorderedWeight[a.itemModuleCompleteKey || (0, $6TeVR.ItemModuleCompleteKeys).BLANK_PAGE] - $03557462562c21be$var$reorderedWeight[b.itemModuleCompleteKey || (0, $6TeVR.ItemModuleCompleteKeys).BLANK_PAGE]);
    return [
        ...templates,
        {
            ...$03557462562c21be$export$511a74d9b2114743,
            type: (0, $dZsZr.TemplateType).Link,
            name: (0, $fVsKL.default).templatesPreExpandMore,
            url: 'https://www.atlassian.com/software/confluence/templates',
            renderShortcutIcon: false
        }
    ];
};
const $03557462562c21be$export$2fcaa2667dafd1ee = (intl, isProjectPagesSporkRebrandingEnabled = false)=>{
    const tutorialContent = (0, $dWs8I.getTutorialContent)(intl, isProjectPagesSporkRebrandingEnabled);
    return {
        type: (0, $dZsZr.TemplateType).Confluence,
        key: 'tutorial',
        name: (0, $fVsKL.default).tutorialPageName,
        title: (0, $fVsKL.default).tutorialPageName,
        description: (0, $fVsKL.default).tutorialPageDescription,
        blueprintModuleCompleteKey: null,
        itemModuleCompleteKey: null,
        iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6jUv4.TemplateIcon), {
                size: size,
                backgroundColor: color
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aGd41))), {
                label: "blank",
                color: "var(--ds-icon-inverse, #fff)",
                LEGACY_size: size
            })),
        defaultIconColor: `var(--ds-background-accent-purple-bolder, ${0, $73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        preview: {
            preExpand: {
                default: isProjectPagesSporkRebrandingEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($9nsB9))) : (0, (/*@__PURE__*/$parcel$interopDefault($17qPc))),
                dark: isProjectPagesSporkRebrandingEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($irYj5))) : (0, (/*@__PURE__*/$parcel$interopDefault($f7HeT)))
            },
            postExpand: {
                default: isProjectPagesSporkRebrandingEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($4T8DH))) : (0, (/*@__PURE__*/$parcel$interopDefault($2aHUT))),
                dark: isProjectPagesSporkRebrandingEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($ghDkc))) : (0, (/*@__PURE__*/$parcel$interopDefault($fFk3W)))
            }
        },
        content: tutorialContent
    };
};

});
parcelRegister("7vgFZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88863a835088beabc3bf8ea8682265f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57685d37c755c5e3$var$_react = $57685d37c755c5e3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $57685d37c755c5e3$var$_bulletedList = $57685d37c755c5e3$var$_interopRequireDefault((parcelRequire("i6wfn")));

var $57685d37c755c5e3$var$_bulletList = $57685d37c755c5e3$var$_interopRequireDefault((parcelRequire("fD5Ev")));
function $57685d37c755c5e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for BulletedListIcon.
 * This component is BulletedListIcon, with `UNSAFE_fallbackIcon` set to "BulletListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57685d37c755c5e3$var$BulletedListIcon = (props)=>/*#__PURE__*/ $57685d37c755c5e3$var$_react.default.createElement($57685d37c755c5e3$var$_bulletedList.default, Object.assign({
        LEGACY_fallbackIcon: $57685d37c755c5e3$var$_bulletList.default
    }, props));
$57685d37c755c5e3$var$BulletedListIcon.Name = 'BulletedListIconMigration';
var $57685d37c755c5e3$var$_default = module.exports.default = $57685d37c755c5e3$var$BulletedListIcon;

});
parcelRegister("i6wfn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb8036f361a1be1ee04edce58f70ad76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2e1cd198156fb13$var$_react = $d2e1cd198156fb13$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d2e1cd198156fb13$var$_UNSAFE_baseNew = $d2e1cd198156fb13$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $d2e1cd198156fb13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * @deprecated Use `@atlaskit/icon/core/list-bulleted` instead.
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "BulletedList".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2e1cd198156fb13$var$BulletedListIcon = (props)=>/*#__PURE__*/ $d2e1cd198156fb13$var$_react.default.createElement($d2e1cd198156fb13$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$d2e1cd198156fb13$var$BulletedListIcon.displayName = 'BulletedListIcon';
var $d2e1cd198156fb13$var$_default = module.exports.default = $d2e1cd198156fb13$var$BulletedListIcon;

});

parcelRegister("fD5Ev", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b60ee1f4d4329714$var$_react = $b60ee1f4d4329714$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b60ee1f4d4329714$var$_listBulleted = $b60ee1f4d4329714$var$_interopRequireDefault((parcelRequire("bH5AZ")));
function $b60ee1f4d4329714$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b60ee1f4d4329714$var$BulletListIcon = (props)=>/*#__PURE__*/ $b60ee1f4d4329714$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $b60ee1f4d4329714$var$_listBulleted.default
    }));
$b60ee1f4d4329714$var$BulletListIcon.displayName = 'BulletListIcon';
var $b60ee1f4d4329714$var$_default = module.exports.default = $b60ee1f4d4329714$var$BulletListIcon;

});
parcelRegister("bH5AZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff718278f5b90796d34b75a3e59b4f33>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88380d0c63fc4ead$var$_react = $88380d0c63fc4ead$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $88380d0c63fc4ead$var$_UNSAFE_baseNew = $88380d0c63fc4ead$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $88380d0c63fc4ead$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $88380d0c63fc4ead$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $88380d0c63fc4ead$var$_react.default.createElement($88380d0c63fc4ead$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$88380d0c63fc4ead$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $88380d0c63fc4ead$var$_default = module.exports.default = $88380d0c63fc4ead$var$ListBulletedIcon;

});



parcelRegister("fu3px", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5409452739c15839cfc1ab65615763f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b45c4dad1de2c664$var$_react = $b45c4dad1de2c664$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b45c4dad1de2c664$var$_decision = $b45c4dad1de2c664$var$_interopRequireDefault((parcelRequire("12N7N")));

var $b45c4dad1de2c664$var$_decision2 = $b45c4dad1de2c664$var$_interopRequireDefault((parcelRequire("3uI7Y")));
function $b45c4dad1de2c664$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for DecisionIcon.
 * This component is DecisionIcon, with `UNSAFE_fallbackIcon` set to "DecisionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b45c4dad1de2c664$var$DecisionIcon = (props)=>/*#__PURE__*/ $b45c4dad1de2c664$var$_react.default.createElement($b45c4dad1de2c664$var$_decision.default, Object.assign({
        LEGACY_fallbackIcon: $b45c4dad1de2c664$var$_decision2.default
    }, props));
$b45c4dad1de2c664$var$DecisionIcon.Name = 'DecisionIconMigration';
var $b45c4dad1de2c664$var$_default = module.exports.default = $b45c4dad1de2c664$var$DecisionIcon;

});
parcelRegister("12N7N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::939dadec476a99ebe1c423e886864d19>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c2c157cf94b0e53$var$_react = $0c2c157cf94b0e53$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0c2c157cf94b0e53$var$_UNSAFE_baseNew = $0c2c157cf94b0e53$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $0c2c157cf94b0e53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c2c157cf94b0e53$var$DecisionIcon = (props)=>/*#__PURE__*/ $0c2c157cf94b0e53$var$_react.default.createElement($0c2c157cf94b0e53$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V8.518c0-.332-.132-.65-.366-.884L2.25 2.25M14.5 1.5 10 6M8 1.75H1.75V8"/>`
    }, props));
$0c2c157cf94b0e53$var$DecisionIcon.displayName = 'DecisionIcon';
var $0c2c157cf94b0e53$var$_default = module.exports.default = $0c2c157cf94b0e53$var$DecisionIcon;

});

parcelRegister("3uI7Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28b6673eec996385$var$_react = $28b6673eec996385$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $28b6673eec996385$var$_decision = $28b6673eec996385$var$_interopRequireDefault((parcelRequire("12N7N")));
function $28b6673eec996385$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $28b6673eec996385$var$DecisionIcon = (props)=>/*#__PURE__*/ $28b6673eec996385$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="m19.29 3.29-5 5A1 1 0 1 0 15.7 9.7l5-5a1 1 0 1 0-1.41-1.41M8.04 4.93a.96.96 0 1 0 .01-1.91L4.06 3A1.05 1.05 0 0 0 3 4.04l.02 4a.96.96 0 0 0 1.92-.01l-.02-3.11z"/><path d="M11 19.998A1 1 0 0 0 12 21c.552 0 1-.454 1-1.007v-7.4c0-.556-.315-1.322-.705-1.713L5.207 3.793 3.793 5.207 11 12.414z"/></g></svg>`
    }, props, {
        newIcon: $28b6673eec996385$var$_decision.default
    }));
$28b6673eec996385$var$DecisionIcon.displayName = 'DecisionIcon';
var $28b6673eec996385$var$_default = module.exports.default = $28b6673eec996385$var$DecisionIcon;

});


parcelRegister("kLb7F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::077a98e35ef0cd960ccf89c3717ac609>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d0d32f61f606c2$var$_react = $f1d0d32f61f606c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f1d0d32f61f606c2$var$_compass = $f1d0d32f61f606c2$var$_interopRequireDefault((parcelRequire("aT0C7")));

var $f1d0d32f61f606c2$var$_discoverFilled = $f1d0d32f61f606c2$var$_interopRequireDefault((parcelRequire("5uSnV")));
function $f1d0d32f61f606c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CompassIcon.
 * This component is CompassIcon, with `UNSAFE_fallbackIcon` set to "DiscoverFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d0d32f61f606c2$var$CompassIcon = (props)=>/*#__PURE__*/ $f1d0d32f61f606c2$var$_react.default.createElement($f1d0d32f61f606c2$var$_compass.default, Object.assign({
        LEGACY_fallbackIcon: $f1d0d32f61f606c2$var$_discoverFilled.default
    }, props));
$f1d0d32f61f606c2$var$CompassIcon.Name = 'CompassIconMigration';
var $f1d0d32f61f606c2$var$_default = module.exports.default = $f1d0d32f61f606c2$var$CompassIcon;

});
parcelRegister("aT0C7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48d6c52e2f1120d34c1ed8048cf8da09>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ecf84587571ce34$var$_react = $7ecf84587571ce34$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7ecf84587571ce34$var$_UNSAFE_baseNew = $7ecf84587571ce34$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $7ecf84587571ce34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ecf84587571ce34$var$CompassIcon = (props)=>/*#__PURE__*/ $7ecf84587571ce34$var$_react.default.createElement($7ecf84587571ce34$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.75 11.25 4.5-2-2.5-2.5z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m11.25 4.75-4.5 2 2.5 2.5z"/>`
    }, props));
$7ecf84587571ce34$var$CompassIcon.displayName = 'CompassIcon';
var $7ecf84587571ce34$var$_default = module.exports.default = $7ecf84587571ce34$var$CompassIcon;

});

parcelRegister("5uSnV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4009f0cb29918b42$var$_react = $4009f0cb29918b42$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $4009f0cb29918b42$var$_compass = $4009f0cb29918b42$var$_interopRequireDefault((parcelRequire("aT0C7")));
function $4009f0cb29918b42$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4009f0cb29918b42$var$DiscoverFilledIcon = (props)=>/*#__PURE__*/ $4009f0cb29918b42$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18m-1.101-10.78c-.248.127-.55.427-.678.678L8.24 14.797c-.55 1.084-.118 1.514.965.963l3.898-1.98c.248-.127.55-.427.677-.678l1.981-3.899c.552-1.083.12-1.514-.964-.964zM12 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/></svg>`
    }, props, {
        newIcon: $4009f0cb29918b42$var$_compass.default
    }));
$4009f0cb29918b42$var$DiscoverFilledIcon.displayName = 'DiscoverFilledIcon';
var $4009f0cb29918b42$var$_default = module.exports.default = $4009f0cb29918b42$var$DiscoverFilledIcon;

});


parcelRegister("aGd41", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78bf5376661b88e83d63d02d7717dc62>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c67f5d2ca26ba78$var$_react = $7c67f5d2ca26ba78$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7c67f5d2ca26ba78$var$_lightbulb = $7c67f5d2ca26ba78$var$_interopRequireDefault((parcelRequire("aUmij")));

var $7c67f5d2ca26ba78$var$_lightbulb2 = $7c67f5d2ca26ba78$var$_interopRequireDefault((parcelRequire("fD6AU")));
function $7c67f5d2ca26ba78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LightbulbIcon.
 * This component is LightbulbIcon, with `UNSAFE_fallbackIcon` set to "LightbulbIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: learnings in Atlas, initiatives in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c67f5d2ca26ba78$var$LightbulbIcon = (props)=>/*#__PURE__*/ $7c67f5d2ca26ba78$var$_react.default.createElement($7c67f5d2ca26ba78$var$_lightbulb.default, Object.assign({
        LEGACY_fallbackIcon: $7c67f5d2ca26ba78$var$_lightbulb2.default
    }, props));
$7c67f5d2ca26ba78$var$LightbulbIcon.Name = 'LightbulbIconMigration';
var $7c67f5d2ca26ba78$var$_default = module.exports.default = $7c67f5d2ca26ba78$var$LightbulbIcon;

});
parcelRegister("aUmij", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f91a4310de3c70ba94bb483517efe6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f106d874eab35ef$var$_react = $7f106d874eab35ef$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7f106d874eab35ef$var$_UNSAFE_baseNew = $7f106d874eab35ef$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $7f106d874eab35ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: learnings in Atlas, initiatives in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f106d874eab35ef$var$LightbulbIcon = (props)=>/*#__PURE__*/ $7f106d874eab35ef$var$_react.default.createElement($7f106d874eab35ef$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.75 12.25V14c0 .69.56 1.25 1.25 1.25h2c.69 0 1.25-.56 1.25-1.25v-1.75m-4.5 0v-.715c0-.483-.286-.912-.685-1.182a5.25 5.25 0 1 1 5.871 0c-.4.27-.686.7-.686 1.182v.715m-4.5 0h4.5"/>`
    }, props));
$7f106d874eab35ef$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $7f106d874eab35ef$var$_default = module.exports.default = $7f106d874eab35ef$var$LightbulbIcon;

});

parcelRegister("fD6AU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b60f9d0621ab0edb$var$_react = $b60f9d0621ab0edb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b60f9d0621ab0edb$var$_lightbulb = $b60f9d0621ab0edb$var$_interopRequireDefault((parcelRequire("aUmij")));
function $b60f9d0621ab0edb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b60f9d0621ab0edb$var$LightbulbIcon = (props)=>/*#__PURE__*/ $b60f9d0621ab0edb$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.998 4A5.997 5.997 0 0 0 6 9.998c0 2.218 2.288 4.484 2.288 4.484.39.387.71 1.112.71 1.611s.45.907 1 .907h4c.55 0 1-.408 1-.907s.32-1.224.71-1.611c0 0 2.288-2.266 2.288-4.484A5.997 5.997 0 0 0 11.998 4m0 2a4.003 4.003 0 0 1 3.998 3.998c0 1.029-1.145 2.511-1.695 3.064-.507.501-.912 1.216-1.13 1.938h-2.346c-.217-.722-.622-1.435-1.125-1.934-.555-.557-1.7-2.039-1.7-3.068A4.003 4.003 0 0 1 11.998 6m2.965 13c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.003c0 .55.45 1 1 1h4c.55 0 1-.45 1-1z"/></svg>`
    }, props, {
        newIcon: $b60f9d0621ab0edb$var$_lightbulb.default
    }));
$b60f9d0621ab0edb$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $b60f9d0621ab0edb$var$_default = module.exports.default = $b60f9d0621ab0edb$var$LightbulbIcon;

});


parcelRegister("C0oHT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0b0e2b27f8c156d770b2ff72f8f4460>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0723dba8ca917d51$var$_react = $0723dba8ca917d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0723dba8ca917d51$var$_page = $0723dba8ca917d51$var$_interopRequireDefault((parcelRequire("20Mcc")));

var $0723dba8ca917d51$var$_page2 = $0723dba8ca917d51$var$_interopRequireDefault((parcelRequire("8CfG4")));
function $0723dba8ca917d51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for PageIcon.
 * This component is PageIcon, with `UNSAFE_fallbackIcon` set to "PageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0723dba8ca917d51$var$PageIcon = (props)=>/*#__PURE__*/ $0723dba8ca917d51$var$_react.default.createElement($0723dba8ca917d51$var$_page.default, Object.assign({
        LEGACY_fallbackIcon: $0723dba8ca917d51$var$_page2.default
    }, props));
$0723dba8ca917d51$var$PageIcon.Name = 'PageIconMigration';
var $0723dba8ca917d51$var$_default = module.exports.default = $0723dba8ca917d51$var$PageIcon;

});
parcelRegister("20Mcc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c63ce0083f2e9a73a4c7c0a839641a58>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1770f78818431634$var$_react = $1770f78818431634$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1770f78818431634$var$_UNSAFE_baseNew = $1770f78818431634$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $1770f78818431634$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1770f78818431634$var$PageIcon = (props)=>/*#__PURE__*/ $1770f78818431634$var$_react.default.createElement($1770f78818431634$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$1770f78818431634$var$PageIcon.displayName = 'PageIcon';
var $1770f78818431634$var$_default = module.exports.default = $1770f78818431634$var$PageIcon;

});

parcelRegister("8CfG4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $645e088e86b3f594$var$_react = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $645e088e86b3f594$var$_page = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("20Mcc")));
function $645e088e86b3f594$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $645e088e86b3f594$var$PageIcon = (props)=>/*#__PURE__*/ $645e088e86b3f594$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $645e088e86b3f594$var$_page.default
    }));
$645e088e86b3f594$var$PageIcon.displayName = 'PageIcon';
var $645e088e86b3f594$var$_default = module.exports.default = $645e088e86b3f594$var$PageIcon;

});


parcelRegister("5H3Kn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1616676f25044c234b1abae067c05b78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4253dffa18f2e3af$var$_react = $4253dffa18f2e3af$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $4253dffa18f2e3af$var$_peopleGroup = $4253dffa18f2e3af$var$_interopRequireDefault((parcelRequire("dd6Uq")));

var $4253dffa18f2e3af$var$_peopleGroup2 = $4253dffa18f2e3af$var$_interopRequireDefault((parcelRequire("iwsIy")));
function $4253dffa18f2e3af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4253dffa18f2e3af$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $4253dffa18f2e3af$var$_react.default.createElement($4253dffa18f2e3af$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $4253dffa18f2e3af$var$_peopleGroup2.default
    }, props));
$4253dffa18f2e3af$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $4253dffa18f2e3af$var$_default = module.exports.default = $4253dffa18f2e3af$var$PeopleGroupIcon;

});

parcelRegister("hpJ8O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53acb4f80ce65157170d94e433cfd888>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cad7c98e94f34db6$var$_react = $cad7c98e94f34db6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cad7c98e94f34db6$var$_sprint = $cad7c98e94f34db6$var$_interopRequireDefault((parcelRequire("8TYIE")));

var $cad7c98e94f34db6$var$_sprint2 = $cad7c98e94f34db6$var$_interopRequireDefault((parcelRequire("gk7tF")));
function $cad7c98e94f34db6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SprintIcon.
 * This component is SprintIcon, with `UNSAFE_fallbackIcon` set to "SprintIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cad7c98e94f34db6$var$SprintIcon = (props)=>/*#__PURE__*/ $cad7c98e94f34db6$var$_react.default.createElement($cad7c98e94f34db6$var$_sprint.default, Object.assign({
        LEGACY_fallbackIcon: $cad7c98e94f34db6$var$_sprint2.default
    }, props));
$cad7c98e94f34db6$var$SprintIcon.Name = 'SprintIconMigration';
var $cad7c98e94f34db6$var$_default = module.exports.default = $cad7c98e94f34db6$var$SprintIcon;

});
parcelRegister("8TYIE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ac782676a50cd4df56827dce883b620>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67b28f597116f9a1$var$_react = $67b28f597116f9a1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $67b28f597116f9a1$var$_UNSAFE_baseNew = $67b28f597116f9a1$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $67b28f597116f9a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $67b28f597116f9a1$var$SprintIcon = (props)=>/*#__PURE__*/ $67b28f597116f9a1$var$_react.default.createElement($67b28f597116f9a1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.5 6.25a5.5 5.5 0 1 0-5.5 5.5m0 0H0m8 0h6.75m-3-3.5 3.5 3.5-3.5 3.5"/>`
    }, props));
$67b28f597116f9a1$var$SprintIcon.displayName = 'SprintIcon';
var $67b28f597116f9a1$var$_default = module.exports.default = $67b28f597116f9a1$var$SprintIcon;

});

parcelRegister("gk7tF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be245075b7e5aee7$var$_react = $be245075b7e5aee7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $be245075b7e5aee7$var$_sprint = $be245075b7e5aee7$var$_interopRequireDefault((parcelRequire("8TYIE")));
function $be245075b7e5aee7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be245075b7e5aee7$var$SprintIcon = (props)=>/*#__PURE__*/ $be245075b7e5aee7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
    }, props, {
        newIcon: $be245075b7e5aee7$var$_sprint.default
    }));
$be245075b7e5aee7$var$SprintIcon.displayName = 'SprintIcon';
var $be245075b7e5aee7$var$_default = module.exports.default = $be245075b7e5aee7$var$SprintIcon;

});


parcelRegister("6jUv4", function(module, exports) {

$parcel$export(module.exports, "TemplateIcon", () => $9e8ab2f93b22c364$export$17f8b5fdc0dde895);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");


var $734Zv = parcelRequire("734Zv");
const $9e8ab2f93b22c364$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1adz7o9-0"
})((props)=>({
        boxSizing: 'border-box',
        alignSelf: 'flex-start',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: `${(0, $734Zv.getIconSize)(props.size)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: `${(0, $734Zv.getIconSize)(props.size)}px`,
        borderRadius: '4px',
        textAlign: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.backgroundColor ? props.backgroundColor : `var(--ds-background-neutral-bold, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`,
        border: `1px solid ${"var(--ds-border, rgba(0, 0, 0, 0.1))"}`
    }));

});
parcelRegister("734Zv", function(module, exports) {

$parcel$export(module.exports, "getIconSize", () => $0802aa6c7bdbf55e$export$3eb7d6130acfda37);
$parcel$export(module.exports, "getDateString", () => $0802aa6c7bdbf55e$export$60248f42f43df209);
$parcel$export(module.exports, "getPostExpandTemplates", () => $0802aa6c7bdbf55e$export$726f90dcc8a488d7);
$parcel$export(module.exports, "getPreExpandTemplates", () => $0802aa6c7bdbf55e$export$112c8b3cc38ec332);

var $lcnyw = parcelRequire("lcnyw");


var $dZsZr = parcelRequire("dZsZr");

var $4R1VH = parcelRequire("4R1VH");

var $c06r3 = parcelRequire("c06r3");

var $fVsKL = parcelRequire("fVsKL");
const $0802aa6c7bdbf55e$export$3eb7d6130acfda37 = (size)=>(0, $lcnyw.gridSize)() * (size === 'small' ? 3 : 4);
const $0802aa6c7bdbf55e$export$dca25b2cf2908df8 = (size)=>size === 'small' ? 14 : 18;
const $0802aa6c7bdbf55e$export$60248f42f43df209 = ()=>{
    const dt = new Date();
    const month = (dt.getMonth() + 1).toString().padStart(2, '0');
    const day = dt.getDate().toString().padStart(2, '0');
    return `${dt.getFullYear()}-${month}-${day}`;
};
const $0802aa6c7bdbf55e$export$726f90dcc8a488d7 = (spaceKey, areTemplatesEnabled, confluenceLicenseStatus, blueprints, intl, isConfluenceAutoProvisioned, isProjectPagesSporkRebrandingEnabled)=>{
    const moreTemplates = {
        ...(0, $4R1VH.moreTemplatesBase),
        type: (0, $dZsZr.TemplateType).Link,
        name: (0, $fVsKL.default).templatesPostExpandMore,
        url: `/wiki/templates?space=${spaceKey}`,
        renderShortcutIcon: true
    };
    // Verify that we should only obtain templates from defaultTemplates that also exist in the blueprints api
    const enabledTemplates = (0, $4R1VH.getDefaultTemplates)().filter((template)=>blueprints.find((blueprint)=>blueprint.itemModuleCompleteKey && blueprint.itemModuleCompleteKey === template.itemModuleCompleteKey));
    const allTemplates = [
        ...enabledTemplates,
        moreTemplates
    ];
    if (isConfluenceAutoProvisioned) allTemplates.unshift((0, $4R1VH.getTutorialTemplate)(intl, isProjectPagesSporkRebrandingEnabled));
    return allTemplates.map((tmpl)=>({
            ...tmpl,
            tooltip: $0802aa6c7bdbf55e$var$getTooltip(tmpl, areTemplatesEnabled, confluenceLicenseStatus)
        }));
};
const $0802aa6c7bdbf55e$export$112c8b3cc38ec332 = (intl, isConfluenceAutoProvisioned, isProjectPagesSporkRebrandingEnabled)=>{
    if (isConfluenceAutoProvisioned) return [
        (0, $4R1VH.getTutorialTemplate)(intl, isProjectPagesSporkRebrandingEnabled),
        ...(0, $4R1VH.getBasePreExpandTemplates)()
    ];
    return (0, $4R1VH.getBasePreExpandTemplates)();
};
const $0802aa6c7bdbf55e$var$getTooltip = (tmpl, areTemplatesEnabled, confluenceLicenseStatus)=>{
    if (confluenceLicenseStatus === (0, $eda5adb3daefc3fa$export$e74e627186613bef)) return (0, $fVsKL.default).connectSpaceTooltip;
    else if (!areTemplatesEnabled) return undefined;
    else if ((0, $c06r3.isMoreTemplates)(tmpl)) return (0, $fVsKL.default).templatesPostExpandMoreTooltip;
    else return undefined;
};

});


parcelRegister("gA5DM", function(module, exports) {
module.exports = new URL("blank.0c2912ca.svg", import.meta.url).toString();

});

parcelRegister("f6CbL", function(module, exports) {
module.exports = new URL("blank.236d38f6.png", import.meta.url).toString();

});

parcelRegister("6ccZl", function(module, exports) {
module.exports = new URL("decision.bd0dad97.png", import.meta.url).toString();

});

parcelRegister("ikRGc", function(module, exports) {
module.exports = new URL("product-requirements.b229ef14.png", import.meta.url).toString();

});

parcelRegister("8XBaT", function(module, exports) {
module.exports = new URL("decision.5f3ba352.svg", import.meta.url).toString();

});

parcelRegister("cPWXl", function(module, exports) {
module.exports = new URL("meeting-notes.45a2e0c0.svg", import.meta.url).toString();

});

parcelRegister("aZsgD", function(module, exports) {
module.exports = new URL("meeting-notes.b36f93e3.png", import.meta.url).toString();

});

parcelRegister("fBHxs", function(module, exports) {
module.exports = new URL("product-requirements.64ca7b12.svg", import.meta.url).toString();

});

parcelRegister("65Tlk", function(module, exports) {
module.exports = new URL("retrospective.1a3389a9.svg", import.meta.url).toString();

});

parcelRegister("4bthJ", function(module, exports) {
module.exports = new URL("retrospective.fc00e92a.png", import.meta.url).toString();

});

parcelRegister("17qPc", function(module, exports) {
module.exports = new URL("welcome-to-project-pages.5dd7820d.svg", import.meta.url).toString();

});

parcelRegister("2aHUT", function(module, exports) {
module.exports = new URL("welcome-to-project-pages.7259f386.png", import.meta.url).toString();

});

parcelRegister("9nsB9", function(module, exports) {
module.exports = new URL("welcome-to-project-pages-spork-rebranding.dd069d6d.svg", import.meta.url).toString();

});

parcelRegister("4T8DH", function(module, exports) {
module.exports = new URL("welcome-to-project-pages-spork-rebranding.e36e44bb.png", import.meta.url).toString();

});

parcelRegister("jkYBh", function(module, exports) {
module.exports = new URL("blank-dark.2ba4c737.png", import.meta.url).toString();

});

parcelRegister("02eMl", function(module, exports) {
module.exports = new URL("blank-dark.0d5d0868.svg", import.meta.url).toString();

});

parcelRegister("iqKPt", function(module, exports) {
module.exports = new URL("decision-dark.70f9a9e4.png", import.meta.url).toString();

});

parcelRegister("acp0d", function(module, exports) {
module.exports = new URL("decision-dark.3127b35c.svg", import.meta.url).toString();

});

parcelRegister("69IE8", function(module, exports) {
module.exports = new URL("meeting-notes-dark.b7db3bc0.png", import.meta.url).toString();

});

parcelRegister("6k5IT", function(module, exports) {
module.exports = new URL("meeting-notes-dark.d7bb00c4.svg", import.meta.url).toString();

});

parcelRegister("akCzB", function(module, exports) {
module.exports = new URL("product-requirements-dark.2b46bcb3.png", import.meta.url).toString();

});

parcelRegister("lhngP", function(module, exports) {
module.exports = new URL("product-requirements-dark.ac25b817.svg", import.meta.url).toString();

});

parcelRegister("9y711", function(module, exports) {
module.exports = new URL("retrospective-dark.2133cd8c.png", import.meta.url).toString();

});

parcelRegister("kreb0", function(module, exports) {
module.exports = new URL("retrospective-dark.1bf3d64c.svg", import.meta.url).toString();

});

parcelRegister("fFk3W", function(module, exports) {
module.exports = new URL("welcome-to-project-pages-dark.6a661445.png", import.meta.url).toString();

});

parcelRegister("f7HeT", function(module, exports) {
module.exports = new URL("welcome-to-project-pages-dark.fa778104.svg", import.meta.url).toString();

});

parcelRegister("irYj5", function(module, exports) {
module.exports = new URL("welcome-to-project-pages-spork-rebranding-dark.a7e189fa.svg", import.meta.url).toString();

});

parcelRegister("ghDkc", function(module, exports) {
module.exports = new URL("welcome-to-project-pages-spork-rebranding-dark.354ad4a2.png", import.meta.url).toString();

});


parcelRegister("dVd22", function(module, exports) {

$parcel$export(module.exports, "default", () => $97e2fb4629adb5cc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hFGUl = parcelRequire("hFGUl");

var $jcDlW = parcelRequire("jcDlW");

var $6ji7W = parcelRequire("6ji7W");

var $4sLzA = parcelRequire("4sLzA");
// eslint-disable-next-line @typescript-eslint/ban-types
const $97e2fb4629adb5cc$var$Header = ({ breadcrumbs: breadcrumbs, isCrossSell: isCrossSell, MoreMenu: MoreMenu, shouldShowMeatballMenu: shouldShowMeatballMenu })=>{
    const theme = (0, $6ji7W.useThemeContext)();
    const actions = shouldShowMeatballMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MoreMenu, null) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4sLzA.PageHeaderStyleWrapper, {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        breadcrumbs: breadcrumbs,
        actions: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4sLzA.PageTitleStyleWrapper, {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcDlW.default), {
        isPreExpand: isCrossSell
    }))));
};
var $97e2fb4629adb5cc$export$2e2bcd8739ae039 = $97e2fb4629adb5cc$var$Header;

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});


parcelRegister("jcDlW", function(module, exports) {

$parcel$export(module.exports, "default", () => $64cf6f56827ec063$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $ffiyv = parcelRequire("ffiyv");

var $fVsKL = parcelRequire("fVsKL");

var $k9zk4 = parcelRequire("k9zk4");
const $64cf6f56827ec063$var$ProjectPagesImprovementTitle = ({ intl: intl, isPreExpand: isPreExpand })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9zk4.TitleWrapper), null, intl.formatMessage((0, $fVsKL.default).title), isPreExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9zk4.TryLozenge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "inprogress"
    }, intl.formatMessage((0, $fVsKL.default).tryLozenge))));
};
var $64cf6f56827ec063$export$2e2bcd8739ae039 = (0, $2qhQi.default)($64cf6f56827ec063$var$ProjectPagesImprovementTitle);

});
parcelRegister("k9zk4", function(module, exports) {

$parcel$export(module.exports, "TryLozenge", () => $ef233dd5c8ecf1c5$export$ff5672c4664546a);
$parcel$export(module.exports, "TitleWrapper", () => $ef233dd5c8ecf1c5$export$585a3b23e887288b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $ef233dd5c8ecf1c5$export$ff5672c4664546a = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "vrezu7-0"
})({
    display: 'flex',
    paddingTop: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-100, 8px)"
});
const $ef233dd5c8ecf1c5$export$585a3b23e887288b = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "vrezu7-1"
})({
    display: 'flex',
    alignItems: 'center',
    /* prevent legacy batch.css in JFE from overriding these styles */ fontSize: 'inherit',
    fontWeight: 500
});

});



parcelRegister("7YRWo", function(module, exports) {

$parcel$export(module.exports, "ActivePage", () => $59c19cc4da165b36$export$416e47b9c84721a);

var $eUqFw = parcelRequire("eUqFw");

var $lO3as = parcelRequire("lO3as");

var $k2KdB = parcelRequire("k2KdB");

var $7GbCF = parcelRequire("7GbCF");

var $k93Dd = parcelRequire("k93Dd");

var $jmJqM = parcelRequire("jmJqM");

var $bFzGY = parcelRequire("bFzGY");

var $gWxA1 = parcelRequire("gWxA1");
const $59c19cc4da165b36$export$416e47b9c84721a = ({ EmbeddedProductUpdater: EmbeddedProductUpdater, ConfluenceTree: ConfluenceTree, ConfluenceActivating: ConfluenceActivating, ConnectSpace: ConnectSpace, ServerError: ServerError, renderFullHeader: renderFullHeader })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { activeRoute: activeRoute } = (0, $k93Dd.useRouter)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $gWxA1.fireUIAnalytics)(createAnalyticsEvent({}), 'activePage viewed', {
            route: activeRoute
        });
    }, [
        activeRoute,
        createAnalyticsEvent
    ]);
    switch(activeRoute){
        case (0, $jmJqM.Routes).TemplatePreview:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lO3as.default), null);
        case (0, $jmJqM.Routes).ConfluenceActivating:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ConfluenceActivating, null);
        case (0, $jmJqM.Routes).ConfluenceActivatingOnDemand:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GbCF.default), null);
        case (0, $jmJqM.Routes).ConnectSpace:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ConnectSpace, {
                key: "ConnectSpace"
            });
        case (0, $jmJqM.Routes).ServerError:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ServerError, null);
        case (0, $jmJqM.Routes).ServerErrorAccess:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ServerError, {
                type: "access"
            });
        case (0, $jmJqM.Routes).SpaceOrPageNotFound:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k2KdB.default), null);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ConfluenceTree, {
                EmbeddedProductUpdater: EmbeddedProductUpdater,
                showDraftToggle: renderFullHeader ?? true
            });
    }
};

});
parcelRegister("lO3as", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef87eee834cf69e5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kWWS6 = parcelRequire("kWWS6");

var $4Vya4 = parcelRequire("4Vya4");
const $ef87eee834cf69e5$var$TemplatePreviewContainer = ()=>{
    const getConfluenceViewContext = (0, $4Vya4.useGetConfluenceViewContext)();
    if (!getConfluenceViewContext) throw new Error('PreprovisionLandingContainer must be used within GetConfluenceViewProvider');
    const { onViewed: onViewed, primaryAction: primaryAction, secondaryAction: secondaryAction, shouldDisplayTermsAndConditions: shouldDisplayTermsAndConditions } = getConfluenceViewContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kWWS6.default), {
        shouldDisplayTermsAndConditions: shouldDisplayTermsAndConditions,
        primaryAction: primaryAction,
        secondaryAction: secondaryAction,
        onViewed: onViewed
    });
};
var $ef87eee834cf69e5$export$2e2bcd8739ae039 = $ef87eee834cf69e5$var$TemplatePreviewContainer;

});
parcelRegister("kWWS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4231ec18603e1cb9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $hF25J = parcelRequire("hF25J");

var $iFmgL = parcelRequire("iFmgL");

var $bLFgh = parcelRequire("bLFgh");

var $6zOB7 = parcelRequire("6zOB7");

var $fVsKL = parcelRequire("fVsKL");

var $5OkYt = parcelRequire("5OkYt");

var $kgX2t = parcelRequire("kgX2t");

var $dZsZr = parcelRequire("dZsZr");

var $ej2fX = parcelRequire("ej2fX");
const $4231ec18603e1cb9$var$TemplatePreviewView = ({ intl: intl, shouldDisplayTermsAndConditions: shouldDisplayTermsAndConditions = false, primaryAction: primaryAction, secondaryAction: secondaryAction, onViewed: onViewed })=>{
    const { template: template } = (0, $kgX2t.useTemplate)();
    // eslint-disable-next-line no-undef
    const shouldDisplayPreview = !false && template && template.type === (0, $dZsZr.TemplateType).Confluence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OkYt.PreviewWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OkYt.TopBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OkYt.TopBarDot), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OkYt.TopBarDot), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OkYt.TopBarDot), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OkYt.Content), {
        shouldDisplayTermsAndConditions: shouldDisplayTermsAndConditions
    }, shouldDisplayPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
        src: template.preview.preExpand.default,
        srcDark: template.preview.preExpand.dark,
        width: "100%",
        alt: `${template.name.description} Confluence Template`
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OkYt.BottomBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OkYt.PreviewTeaser), null, intl.formatMessage((0, $fVsKL.default).previewTeaser)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "subtle",
        onClick: secondaryAction.onClick,
        isLoading: secondaryAction.isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), secondaryAction.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "primary",
        onClick: primaryAction.onClick,
        isLoading: primaryAction.isLoading
    }, !primaryAction.isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hF25J.MountEvent), {
        onMount: primaryAction.onReady || (()=>void 0)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), primaryAction.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hF25J.MountEvent), {
        onMount: onViewed
    })))), shouldDisplayTermsAndConditions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ej2fX.default), null));
};
var $4231ec18603e1cb9$export$2e2bcd8739ae039 = (0, $2qhQi.default)($4231ec18603e1cb9$var$TemplatePreviewView);

});
parcelRegister("5OkYt", function(module, exports) {

$parcel$export(module.exports, "PreviewWrapper", () => $e3af2eabbd9a4fb6$export$700087f99bb44ee4);
$parcel$export(module.exports, "TopBar", () => $e3af2eabbd9a4fb6$export$c4e96258f3b6511);
$parcel$export(module.exports, "TopBarDot", () => $e3af2eabbd9a4fb6$export$6049a79b5f0a9d6e);
$parcel$export(module.exports, "Content", () => $e3af2eabbd9a4fb6$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "BottomBar", () => $e3af2eabbd9a4fb6$export$baad9f01dbfd9b39);
$parcel$export(module.exports, "PreviewTeaser", () => $e3af2eabbd9a4fb6$export$b7c5ef56a55afe97);
$parcel$export(module.exports, "TermsAndPrivacyWrapper", () => $e3af2eabbd9a4fb6$export$b306c2f5d4db1b52);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $lcnyw = parcelRequire("lcnyw");

const $e3af2eabbd9a4fb6$export$700087f99bb44ee4 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18hgx24-0"
})({
    minWidth: '320px',
    marginTop: "var(--ds-space-200, 16px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0px 3px 5px rgba(9, 30, 66, 0.2),
    0px 0px 1px rgba(9, 30, 66, 0.31)`})`,
    borderRadius: '4px'
});
const $e3af2eabbd9a4fb6$export$c4e96258f3b6511 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18hgx24-1"
})({
    display: 'flex',
    padding: "var(--ds-space-100, 8px)",
    borderRadius: '4px 4px 0 0',
    backgroundColor: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`
});
const $e3af2eabbd9a4fb6$export$6049a79b5f0a9d6e = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18hgx24-2"
})({
    backgroundColor: "var(--ds-icon-inverse, #fff)",
    marginRight: "var(--ds-space-050, 4px)",
    width: '6px',
    height: '6px',
    borderRadius: '50%'
});
const $e3af2eabbd9a4fb6$var$TERMS_AND_CONDITIONS_ALLOWANCE = '88px';
const $e3af2eabbd9a4fb6$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18hgx24-3"
})({
    minHeight: '346px',
    overflowY: 'scroll',
    height: `calc( 100vh - 297px - ${$e3af2eabbd9a4fb6$var$TERMS_AND_CONDITIONS_ALLOWANCE} )`,
    maxHeight: '800px'
});
const $e3af2eabbd9a4fb6$export$baad9f01dbfd9b39 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18hgx24-4"
})({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
    borderTop: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`}`,
    borderRadius: '0 0 4px 4px',
    backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $e3af2eabbd9a4fb6$export$b7c5ef56a55afe97 = /*#__PURE__*/ (0, $kwce8.default).p.withConfig({
    componentId: "sc-18hgx24-5"
})({
    fontSize: `${(0, $lcnyw.fontSizeSmall)()}px`
});
const $e3af2eabbd9a4fb6$export$4827d26eeaf255c9 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18hgx24-6"
})({
    flex: '1 1 auto'
});
const $e3af2eabbd9a4fb6$export$b306c2f5d4db1b52 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18hgx24-7"
})({
    paddingTop: "var(--ds-space-300, 24px)",
    paddingBottom: "var(--ds-space-300, 24px)",
    textAlign: 'center'
});

});

parcelRegister("ej2fX", function(module, exports) {

$parcel$export(module.exports, "default", () => $57ed492bb705cfba$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5OdZ3 = parcelRequire("5OdZ3");

var $5OkYt = parcelRequire("5OkYt");

var $8uD7Y = parcelRequire("8uD7Y");

var $kJeqC = parcelRequire("kJeqC");
const $57ed492bb705cfba$var$TermsAndPrivacyPolicy = ()=>{
    const shouldDisplayTryNow = (0, $kJeqC.getTargetingGate)('project-pages-cta-content-update-gate') && (0, $kJeqC.getExperimentValue)('project-pages-cta-content-update', 'not-enrolled', true) === 'variation';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5OkYt.TermsAndPrivacyWrapper, null, shouldDisplayTryNow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57ed492bb705cfba$var$TermsAndPrivacyPolicyTryNow, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57ed492bb705cfba$var$TermsAndPrivacyPolicyDefault, null));
};
const $57ed492bb705cfba$var$terms = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
        target: "_blank",
        href: "https://www.atlassian.com/legal/cloud-terms-of-service"
    }, chunks);
const $57ed492bb705cfba$var$privacyPolicy = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
        target: "_blank",
        href: "https://www.atlassian.com/legal/privacy-policy"
    }, chunks);
const $57ed492bb705cfba$var$TermsAndPrivacyPolicyDefault = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        defaultMessage: 'By clicking "Try it free", you will be enrolled in Confluence and agree to the Atlassian <termsOfServiceLinkText>Cloud Terms of Service</termsOfServiceLinkText> and <privacyPolicyLinkText>Privacy Policy</privacyPolicyLinkText>.',
        id: "projectpages.templatepreview.termsandprivacy",
        values: {
            termsOfServiceLinkText: $57ed492bb705cfba$var$terms,
            privacyPolicyLinkText: $57ed492bb705cfba$var$privacyPolicy
        }
    });
const $57ed492bb705cfba$var$TermsAndPrivacyPolicyTryNow = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        defaultMessage: 'By clicking "Try it now", you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.',
        id: "project-pages.improvement.terms-and-conditions-v2",
        values: {
            termsLink: $57ed492bb705cfba$var$terms,
            privacyLink: $57ed492bb705cfba$var$privacyPolicy
        }
    });
var $57ed492bb705cfba$export$2e2bcd8739ae039 = $57ed492bb705cfba$var$TermsAndPrivacyPolicy;

});


parcelRegister("4Vya4", function(module, exports) {

$parcel$export(module.exports, "useGetConfluenceViewContext", () => $cb3760612d47f66f$export$6d89ff2605ccb549);
$parcel$export(module.exports, "default", () => $cb3760612d47f66f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("2Nzqx");
var $hXPzA = parcelRequire("hXPzA");
var $8a0ZO = parcelRequire("8a0ZO");

var $i5NVC = parcelRequire("i5NVC");

var $kqxVx = parcelRequire("kqxVx");

var $kgX2t = parcelRequire("kgX2t");

var $c06r3 = parcelRequire("c06r3");


var $fVsKL = parcelRequire("fVsKL");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
var $9IbuV = parcelRequire("9IbuV");

var $bFzGY = parcelRequire("bFzGY");

var $gWxA1 = parcelRequire("gWxA1");

var $kJeqC = parcelRequire("kJeqC");
const $cb3760612d47f66f$var$GetConfluenceViewContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    onViewed: ()=>{},
    shouldDisplayTermsAndConditions: false,
    primaryAction: {
        onClick: ()=>{},
        isLoading: false,
        text: (0, $fVsKL.default).tryButton
    },
    secondaryAction: {
        onClick: ()=>{},
        isLoading: false,
        text: (0, $fVsKL.default).learnMoreButton
    }
});
const $cb3760612d47f66f$var$primaryActionOptionsPerMethod = {
    integrated: {
        text: (0, $fVsKL.default).tryOnDemandButton
    },
    modal: {
        text: (0, $fVsKL.default).tryButton
    },
    loading: {
        text: (0, $fVsKL.default).tryOnDemandButton
    }
};
const $cb3760612d47f66f$var$primaryActionOptionsPerMethodVariation = {
    integrated: {
        text: (0, $fVsKL.default).tryItNow
    },
    modal: {
        text: (0, $fVsKL.default).tryItNow
    },
    loading: {
        text: (0, $fVsKL.default).tryOnDemandButton
    }
};
function $cb3760612d47f66f$var$getPrimaryActionOptions() {
    const cohort = (0, $kJeqC.getExperimentValue)('project-pages-cta-content-update', 'not-enrolled', true);
    switch(cohort){
        case 'variation':
            return $cb3760612d47f66f$var$primaryActionOptionsPerMethodVariation;
        case 'control':
        case 'not-enrolled':
        default:
            return $cb3760612d47f66f$var$primaryActionOptionsPerMethod;
    }
}
const $cb3760612d47f66f$var$ufoPrimaryActionLoadTracker = new (0, $kDfSL.UFOExperience)('get-confluence-primary-action', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $12kyE.ExperienceTypes).Load,
    platform: {
        component: 'project-pages'
    }
});
const $cb3760612d47f66f$var$ufoViewComponentLoadTracker = new (0, $kDfSL.UFOExperience)('get-confluence-page', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $12kyE.ExperienceTypes).Load,
    platform: {
        component: 'project-pages'
    }
});
const $cb3760612d47f66f$var$GetConfluenceViewProvider = ({ onOpenCrossFlowError: onOpenCrossFlowError, onSuccessfulCrossFlowExpansion: onSuccessfulCrossFlowExpansion, activationMethod: activationMethod, triggerOnDemandActivation: triggerOnDemandActivation, children: children })=>{
    (0, $9IbuV.useUFOComponentExperience)($cb3760612d47f66f$var$ufoViewComponentLoadTracker);
    const crossFlow = (0, $hXPzA.useCrossFlow)();
    const { projectKey: jiraProjectKey } = (0, $kqxVx.useProjectPages)();
    const { template: template } = (0, $kgX2t.useTemplate)();
    const { fireViewedEvent: fireViewedEvent, fireClickedEvent: fireClickedEvent } = (0, $i5NVC.useFireCrossFlowAnalyticsEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $gWxA1.fireOperationalAnalytics)(createAnalyticsEvent({}), 'activationMethod set', {
            activationMethod: activationMethod
        });
    }, [
        activationMethod,
        createAnalyticsEvent
    ]);
    const onViewed = (0, $eUqFw.useCallback)(()=>{
        fireViewedEvent();
        $cb3760612d47f66f$var$ufoViewComponentLoadTracker.success();
        $cb3760612d47f66f$var$ufoPrimaryActionLoadTracker.start();
    }, [
        fireViewedEvent
    ]);
    const openCrossFlowOrDisplayError = (0, $eUqFw.useCallback)(async (journey)=>{
        if (crossFlow.isEnabled && jiraProjectKey && (0, $c06r3.isConfluenceTemplate)(template)) {
            const crossFlowCompletionStatus = await crossFlow.api.open({
                sourceComponent: (0, $2bdc823b57417d54$export$400f359cf7604d7a),
                sourceContext: (0, $2bdc823b57417d54$export$e776c72d9769c47a),
                targetProduct: (0, $8a0ZO.Targets).CONFLUENCE,
                journey: journey,
                experimentalOptions: {
                    isCrossSell: true,
                    jiraProjectKey: jiraProjectKey,
                    isPagesImprovementExperiment: true,
                    confluenceBlueprintModuleCompleteKey: template.blueprintModuleCompleteKey
                }
            });
            if (crossFlowCompletionStatus.success) onSuccessfulCrossFlowExpansion();
        } else onOpenCrossFlowError();
    }, [
        crossFlow,
        jiraProjectKey,
        template,
        onSuccessfulCrossFlowExpansion,
        onOpenCrossFlowError
    ]);
    const onSecondaryActionClick = (0, $eUqFw.useCallback)(()=>{
        fireClickedEvent('learnMoreButton', {
            activationMethod: activationMethod
        });
        openCrossFlowOrDisplayError((0, $hXPzA.Journeys).DECIDE);
    }, [
        fireClickedEvent,
        openCrossFlowOrDisplayError,
        activationMethod
    ]);
    const onPrimaryActionClick = (0, $eUqFw.useCallback)(()=>{
        fireClickedEvent('tryThisTemplateButton', {
            activationMethod: activationMethod
        });
        if (activationMethod === 'integrated') triggerOnDemandActivation();
        else openCrossFlowOrDisplayError((0, $hXPzA.Journeys).GET_STARTED);
    }, [
        fireClickedEvent,
        activationMethod,
        triggerOnDemandActivation,
        openCrossFlowOrDisplayError
    ]);
    const onPrimaryActionReady = (0, $eUqFw.useCallback)(()=>{
        $cb3760612d47f66f$var$ufoPrimaryActionLoadTracker.success();
        const experimentAttributes = {
            'project-pages-cta-content-update': (0, $kJeqC.getTargetingGate)('project-pages-cta-content-update-gate') ? (0, $kJeqC.getExperimentValue)('project-pages-cta-content-update', 'not-enrolled', true) : 'not-enrolled',
            'project-pages-cta-content-update-aa': (0, $kJeqC.getExperimentValue)('project-pages-cta-content-update-aa', 'not-enrolled', true)
        };
        (0, $gWxA1.fireUIAnalytics)(createAnalyticsEvent({}), 'tryButton viewed', {
            activationMethod: activationMethod,
            ...experimentAttributes
        });
    }, [
        activationMethod,
        createAnalyticsEvent
    ]);
    const primaryAction = (0, $eUqFw.useMemo)(()=>{
        const primaryActionOptions = (0, $kJeqC.getTargetingGate)('project-pages-cta-content-update-gate') ? $cb3760612d47f66f$var$getPrimaryActionOptions() : $cb3760612d47f66f$var$primaryActionOptionsPerMethod;
        return {
            isLoading: activationMethod === 'loading',
            onClick: onPrimaryActionClick,
            onReady: onPrimaryActionReady,
            ...primaryActionOptions[activationMethod]
        };
    }, [
        activationMethod,
        onPrimaryActionClick,
        onPrimaryActionReady
    ]);
    const secondaryAction = (0, $eUqFw.useMemo)(()=>({
            isLoading: false,
            onClick: onSecondaryActionClick,
            text: (0, $fVsKL.default).learnMoreButton
        }), [
        onSecondaryActionClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb3760612d47f66f$var$GetConfluenceViewContext.Provider, {
        value: {
            onViewed: onViewed,
            primaryAction: primaryAction,
            secondaryAction: secondaryAction,
            shouldDisplayTermsAndConditions: activationMethod === 'integrated'
        }
    }, children);
};
const $cb3760612d47f66f$export$6d89ff2605ccb549 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($cb3760612d47f66f$var$GetConfluenceViewContext);
var $cb3760612d47f66f$export$2e2bcd8739ae039 = $cb3760612d47f66f$var$GetConfluenceViewProvider;

});
parcelRegister("i5NVC", function(module, exports) {

$parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", () => $ec62eb0d4ca801b0$export$c2095165ae2bdcda);

var $8fAH0 = parcelRequire("8fAH0");
var $a0eNT = parcelRequire("a0eNT");

var $kqxVx = parcelRequire("kqxVx");
const $ec62eb0d4ca801b0$export$c2095165ae2bdcda = ()=>{
    const { fireViewedScreenEvent: fireViewedScreenEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $a0eNT.useFireCrossFlowAnalyticsEvents)();
    const { environment: environment } = (0, $kqxVx.useProjectPages)();
    const env = environment === 'prod' ? 'prod' : 'staging';
    const confluenceCloudCCPProductID = (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].confluence_cloud;
    return {
        fireViewedEvent: ()=>{
            fireViewedScreenEvent('projectPagesScreen', {
                recommendedProductIds: [
                    confluenceCloudCCPProductID
                ]
            });
        },
        fireClickedEvent: (buttonId, attributes = {})=>{
            fireInteractedUIEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: buttonId
            }, {
                recommendedProductIds: [
                    confluenceCloudCCPProductID
                ],
                targetProductId: confluenceCloudCCPProductID,
                source: 'projectPagesScreen'
            }, attributes);
        }
    };
};

});



parcelRegister("k2KdB", function(module, exports) {

$parcel$export(module.exports, "default", () => $42210cab0338ad4a$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $3pvFP = parcelRequire("3pvFP");

var $e2w6X = parcelRequire("e2w6X");
const $42210cab0338ad4a$var$mapDispatchToProps = (dispatch)=>({
        showConnectSpaceDialog: ()=>{
            dispatch((0, $3pvFP.showConnectSpaceDialog)());
            dispatch((0, $3pvFP.fetchConfluenceSpaces)());
        }
    });
var $42210cab0338ad4a$export$2e2bcd8739ae039 = (0, $cllCv.connect)(null, $42210cab0338ad4a$var$mapDispatchToProps)((0, $e2w6X.default));

});
parcelRegister("e2w6X", function(module, exports) {

$parcel$export(module.exports, "default", () => $96400f7529ae9cd7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $6zOB7 = parcelRequire("6zOB7");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $cyysI = parcelRequire("cyysI");

var $gWxA1 = parcelRequire("gWxA1");

var $l3ugm = parcelRequire("l3ugm");

var $48Bjb = parcelRequire("48Bjb");

var $j5YY5 = parcelRequire("j5YY5");
const $96400f7529ae9cd7$var$MountTracker = (0, $48Bjb.default)('SpaceOrPageNotFound');
const $96400f7529ae9cd7$var$SpaceOrPageNotFound = ({ showConnectSpaceDialog: showConnectSpaceDialog })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleClick = (_, analyticsEvent)=>{
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'spaceOrPageNotFoundCreateButton');
        showConnectSpaceDialog();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($l3ugm))),
        imageWidth: 71,
        header: formatMessage((0, $cyysI.default).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $cyysI.default).description,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j5YY5.default), {
                        label: chunks
                    })
            }
        }),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            appearance: "default",
            onClick: handleClick
        }, formatMessage((0, $cyysI.default).connectSpaceButton))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96400f7529ae9cd7$var$MountTracker, null));
};
var $96400f7529ae9cd7$export$2e2bcd8739ae039 = $96400f7529ae9cd7$var$SpaceOrPageNotFound;

});
parcelRegister("cyysI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab76433c83548dda$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ab76433c83548dda$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        id: 'project-pages.improvement.errors.space-or-page-not-found.title',
        defaultMessage: 'Space or page not found',
        description: 'Title when the Confluence space or page linked to a Jira project cannot be found due to an error'
    },
    description: {
        id: 'project-pages.improvement.errors.space-or-page-not-found.description',
        defaultMessage: "The Confluence space or page that was connected has been moved, archived, or deleted. <link>Contact support</link> if re-connecting doesn't fix things",
        description: 'Information about potential reasons why the space or page cannot be found'
    },
    connectSpaceButton: {
        id: 'project-pages.connection-error.space-or-page-not-found.button',
        defaultMessage: 'Connect to a different space or page',
        description: 'Button to connect to a different Confluence space or page'
    }
});

});



parcelRegister("7GbCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4b63f19bb8c816$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $iTB7p = parcelRequire("iTB7p");

var $hXy49 = parcelRequire("hXy49");

var $8LwVJ = parcelRequire("8LwVJ");

var $1UwLx = parcelRequire("1UwLx");
const $6f4b63f19bb8c816$var$mapStateToProps = (state)=>({
        status: (0, $hXy49.getActivationStatus)(state)
    });
const $6f4b63f19bb8c816$var$mapDispatchToProps = (dispatch)=>({
        startStatusCheck: ()=>{
            dispatch((0, $1UwLx.checkConfluenceActivationStatus)());
        },
        changeModalState: (modalState)=>{
            dispatch((0, $8LwVJ.updateOnDemandActivationModalState)({
                modalState: modalState
            }));
        }
    });
var $6f4b63f19bb8c816$export$2e2bcd8739ae039 = (0, $cllCv.connect)($6f4b63f19bb8c816$var$mapStateToProps, $6f4b63f19bb8c816$var$mapDispatchToProps)((0, $iTB7p.default));

});
parcelRegister("iTB7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebcd432cb0c192fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6gaAt = parcelRequire("6gaAt");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
var $9IbuV = parcelRequire("9IbuV");
const $ebcd432cb0c192fc$var$ufoExperienceTracker = new (0, $kDfSL.UFOExperience)('on-demand-activation-in-progress', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $12kyE.ExperienceTypes).Load,
    platform: {
        component: 'project-pages'
    }
});
const $ebcd432cb0c192fc$var$activationStatusToProgress = {
    activating: 'in-progress',
    completed: 'completed',
    'not-started': 'not-started',
    allowed: 'not-started',
    error: 'error',
    'not-allowed': 'error'
};
const $ebcd432cb0c192fc$var$OnDemandActivationInProgress = ({ startStatusCheck: startStatusCheck, changeModalState: changeModalState, status: status })=>{
    (0, $9IbuV.useUFOComponentExperience)($ebcd432cb0c192fc$var$ufoExperienceTracker);
    (0, $eUqFw.useEffect)(()=>{
        startStatusCheck();
    }, [
        startStatusCheck
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (status === 'completed') $ebcd432cb0c192fc$var$ufoExperienceTracker.success();
        if (status === 'error') $ebcd432cb0c192fc$var$ufoExperienceTracker.failure();
    }, [
        status
    ]);
    const handleDismissModal = ()=>{
        changeModalState('closed');
    };
    const handleOpenModal = ()=>{
        changeModalState('open');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6gaAt.default), {
        status: $ebcd432cb0c192fc$var$activationStatusToProgress[status],
        onDismiss: handleDismissModal,
        onOpen: handleOpenModal
    });
};
var $ebcd432cb0c192fc$export$2e2bcd8739ae039 = $ebcd432cb0c192fc$var$OnDemandActivationInProgress;

});
parcelRegister("6gaAt", function(module, exports) {

$parcel$export(module.exports, "ModalState", () => $f9c966de4a954f26$export$bb4219a9afe59f51);
$parcel$export(module.exports, "ActivationInProgressContext", () => $f9c966de4a954f26$export$c4018f4c76290b47);
$parcel$export(module.exports, "default", () => $f9c966de4a954f26$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bGemO = parcelRequire("bGemO");

var $1IXx6 = parcelRequire("1IXx6");
var $f9c966de4a954f26$export$bb4219a9afe59f51;
(function(ModalState) {
    ModalState["OPEN"] = "open";
    ModalState["CLOSED"] = "closed";
})($f9c966de4a954f26$export$bb4219a9afe59f51 || ($f9c966de4a954f26$export$bb4219a9afe59f51 = {}));
const $f9c966de4a954f26$export$c4018f4c76290b47 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    modalState: "closed",
    onOpen: ()=>void 0,
    onDismiss: ()=>void 0
});
const $f9c966de4a954f26$var$ActivationInProgressPage = ({ onDismiss: onDismiss, onOpen: onOpen, status: status })=>{
    const [modalState, setModalState] = (0, $eUqFw.useState)("open");
    const changeModalState = (state)=>{
        setModalState(state);
    };
    const handleDismiss = (0, $eUqFw.useCallback)(()=>{
        changeModalState("closed");
        onDismiss();
    }, [
        onDismiss
    ]);
    const handleOpen = (0, $eUqFw.useCallback)(()=>{
        changeModalState("open");
        onOpen();
    }, [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f9c966de4a954f26$export$c4018f4c76290b47.Provider, {
        value: {
            modalState: modalState,
            onOpen: handleOpen,
            onDismiss: handleDismiss
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IXx6.default), {
        status: status
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bGemO.default), null));
};
var $f9c966de4a954f26$export$2e2bcd8739ae039 = $f9c966de4a954f26$var$ActivationInProgressPage;

});
parcelRegister("bGemO", function(module, exports) {

$parcel$export(module.exports, "default", () => $48c8f6e05e1e0dd4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");
var $dxopF = parcelRequire("dxopF");

var $grD8L = parcelRequire("grD8L");

var $9N3Vb = parcelRequire("9N3Vb");

var $6gaAt = parcelRequire("6gaAt");

var $euoNQ = parcelRequire("euoNQ");

const $48c8f6e05e1e0dd4$var$ActivationInProgressModal = ()=>{
    const { modalState: modalState } = (0, $eUqFw.useContext)((0, $6gaAt.ActivationInProgressContext) || (0, $6gaAt.ModalState).OPEN);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, modalState === (0, $6gaAt.ModalState).OPEN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        height: (0, $5f6e638ea25cd3e4$export$1dd7793cb602b5ab),
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($grD8L.ModalBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($grD8L.Backdrop, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9N3Vb))),
        alt: "Blue backdrop"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $euoNQ.default), null))));
};
var $48c8f6e05e1e0dd4$export$2e2bcd8739ae039 = $48c8f6e05e1e0dd4$var$ActivationInProgressModal;

});
parcelRegister("grD8L", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $5f794b117a8fc10c$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "Backdrop", () => $5f794b117a8fc10c$export$698223c589197ab7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

const $5f794b117a8fc10c$export$cb540d8b0ef7906c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1o2fyg2-0"
})({
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $5f6e638ea25cd3e4$export$3d931b64f46140b3)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $5f6e638ea25cd3e4$export$1dd7793cb602b5ab)}px`,
    textAlign: 'center',
    display: 'grid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `[image] ${(0, $5f6e638ea25cd3e4$export$11c28e35a0c89402) - (0, $5f6e638ea25cd3e4$export$a97597a250e1e38d)}px [content] 1fr [controls] 72px [footer] 36px`,
    paddingBottom: "var(--ds-space-300, 24px)",
    justifyItems: 'center'
});
const $5f794b117a8fc10c$export$698223c589197ab7 = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "sc-1o2fyg2-1"
})({
    width: '100%',
    objectFit: 'cover',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $5f6e638ea25cd3e4$export$11c28e35a0c89402)}px`,
    userSelect: 'none'
});

});
const $5f6e638ea25cd3e4$export$11c28e35a0c89402 = 200;
const $5f6e638ea25cd3e4$export$1dd7793cb602b5ab = 600;
const $5f6e638ea25cd3e4$export$a97597a250e1e38d = 150;
const $5f6e638ea25cd3e4$export$3d931b64f46140b3 = 600;


parcelRegister("9N3Vb", function(module, exports) {
module.exports = new URL("info-background.3cdd6630.png", import.meta.url).toString();

});

parcelRegister("euoNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb7b6393d4720428$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7JOkx = parcelRequire("7JOkx");

var $9Epbi = parcelRequire("9Epbi");

var $6gaAt = parcelRequire("6gaAt");

var $e9oJE = parcelRequire("e9oJE");

var $7b06u = parcelRequire("7b06u");
const $bb7b6393d4720428$var$CAROUSEL_ITEM_COUNT = 3;
const $bb7b6393d4720428$export$7bf2b67922fe03be = ()=>{
    const { onDismiss: onDismiss } = (0, $eUqFw.useContext)((0, $6gaAt.ActivationInProgressContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7JOkx.default), {
        slideRange: [
            1,
            $bb7b6393d4720428$var$CAROUSEL_ITEM_COUNT
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7JOkx.default).Slide, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7JOkx.default).Item, {
        position: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7b06u.YourProjectPagesInJira), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7JOkx.default).Item, {
        position: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7b06u.SeamlesslyUpdateStakeholders), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7JOkx.default).Item, {
        position: 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7b06u.UnifyDocumentation), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7JOkx.default).Control, null, ({ onPrevious: onPrevious, isStart: isStart })=>!isStart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Epbi.default).Chevron, {
            direction: (0, $e9oJE.ChevronDirection).LEFT,
            onPrevious: onPrevious
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7JOkx.default).Control, null, ({ onNext: onNext, isEnd: isEnd })=>!isEnd && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Epbi.default).Chevron, {
            direction: (0, $e9oJE.ChevronDirection).RIGHT,
            onNext: onNext
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7JOkx.default).Control, null, ({ onNext: onNext, onChangePosition: onChangePosition, visiblePosition: visiblePosition, isEnd: isEnd })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Epbi.default).Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Epbi.default).Button, {
            buttonActionType: (0, $e9oJE.ButtonActionType).DISMISS,
            onClick: onDismiss
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Epbi.default).NavigationBulletGroup, {
            count: $bb7b6393d4720428$var$CAROUSEL_ITEM_COUNT,
            activePosition: visiblePosition,
            onNavigationBulletClick: onChangePosition
        }), isEnd ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Epbi.default).Button, {
            buttonActionType: (0, $e9oJE.ButtonActionType).DONE,
            onClick: onDismiss
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Epbi.default).Button, {
            buttonActionType: (0, $e9oJE.ButtonActionType).NEXT,
            onClick: onNext
        }))));
};
var $bb7b6393d4720428$export$2e2bcd8739ae039 = $bb7b6393d4720428$export$7bf2b67922fe03be;

});
parcelRegister("7JOkx", function(module, exports) {

$parcel$export(module.exports, "CarouselConsumer", () => $b54ffb6f7ae1e3ff$export$4552b2d5a7ba5038);
$parcel$export(module.exports, "default", () => $b54ffb6f7ae1e3ff$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cbcPR = parcelRequire("cbcPR");

var $7Acw2 = parcelRequire("7Acw2");

var $lBAye = parcelRequire("lBAye");
const $b54ffb6f7ae1e3ff$export$b9f5e42d7424d064 = {
    visiblePosition: 1,
    onNext: ()=>void 0,
    onPrevious: ()=>void 0,
    onChangePosition: ()=>void 0,
    isStart: true,
    isEnd: false
};
const $b54ffb6f7ae1e3ff$export$762b25d1c14c81e4 = /*#__PURE__*/ (0, $eUqFw.createContext)($b54ffb6f7ae1e3ff$export$b9f5e42d7424d064);
const $b54ffb6f7ae1e3ff$export$4552b2d5a7ba5038 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b54ffb6f7ae1e3ff$export$762b25d1c14c81e4.Consumer, null, (context)=>{
        if (!context) throw new Error('Please pass the necessary context');
        if (!children) throw new Error('Please add at least one child component');
        return children(context);
    });
const $b54ffb6f7ae1e3ff$export$144901db2ea8e967 = (props)=>{
    const { slideRange: slideRange, children: children, loop: loop } = props;
    const [slideStart, slideEnd] = slideRange;
    const [visiblePosition, setVisiblePosition] = (0, $eUqFw.useState)(slideStart);
    const isFirstItemVisible = visiblePosition === slideStart;
    const isLastItemVisible = visiblePosition === slideEnd;
    const handleChangePosition = (position)=>{
        setVisiblePosition(position);
    };
    const showNextItem = (0, $eUqFw.useCallback)(()=>{
        if (isLastItemVisible && !loop) return;
        const shouldResetToStart = isLastItemVisible && loop;
        const nextItemPosition = visiblePosition + 1;
        const newPosition = shouldResetToStart ? slideStart : nextItemPosition;
        handleChangePosition(newPosition);
    }, [
        isLastItemVisible,
        loop,
        slideStart,
        visiblePosition
    ]);
    const showPreviousItem = (0, $eUqFw.useCallback)(()=>{
        if (isFirstItemVisible && !loop) return;
        const shouldJumpToEnd = loop && isFirstItemVisible;
        const previousItemPosition = visiblePosition - 1;
        const newPosition = shouldJumpToEnd ? slideEnd : previousItemPosition;
        handleChangePosition(newPosition);
    }, [
        isFirstItemVisible,
        loop,
        slideEnd,
        visiblePosition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b54ffb6f7ae1e3ff$export$762b25d1c14c81e4.Provider, {
        value: {
            visiblePosition: visiblePosition,
            onNext: showNextItem,
            onPrevious: showPreviousItem,
            onChangePosition: handleChangePosition,
            isStart: isFirstItemVisible,
            isEnd: isLastItemVisible
        }
    }, children);
};
$b54ffb6f7ae1e3ff$export$144901db2ea8e967.Control = (0, $cbcPR.Control);
$b54ffb6f7ae1e3ff$export$144901db2ea8e967.Item = (0, $7Acw2.Item);
$b54ffb6f7ae1e3ff$export$144901db2ea8e967.Slide = (0, $lBAye.Slide);
var $b54ffb6f7ae1e3ff$export$2e2bcd8739ae039 = $b54ffb6f7ae1e3ff$export$144901db2ea8e967;

});
parcelRegister("cbcPR", function(module, exports) {

$parcel$export(module.exports, "Control", () => $78ba4ae7ef87f590$export$7a7fa4424cb20976);

var $eUqFw = parcelRequire("eUqFw");

var $7JOkx = parcelRequire("7JOkx");
const $78ba4ae7ef87f590$export$7a7fa4424cb20976 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7JOkx.CarouselConsumer), null, children);

});

parcelRegister("7Acw2", function(module, exports) {

$parcel$export(module.exports, "Item", () => $8bc8dc059c07625a$export$6d08773d2e66f8f2);

var $eUqFw = parcelRequire("eUqFw");

var $7JOkx = parcelRequire("7JOkx");

var $3yTAX = parcelRequire("3yTAX");
const $8bc8dc059c07625a$export$6d08773d2e66f8f2 = ({ children: children, position: position, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7JOkx.CarouselConsumer), null, ({ visiblePosition: visiblePosition })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3yTAX.StyledCarouselItem), {
            visiblePosition: visiblePosition,
            currentPosition: position,
            ...rest
        }, children));

});
parcelRegister("3yTAX", function(module, exports) {

$parcel$export(module.exports, "StyledCarouselSlide", () => $534ff7c51245a648$export$da5dc1115c18b364);
$parcel$export(module.exports, "StyledCarouselItem", () => $534ff7c51245a648$export$365b3aec472df75b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
var $534ff7c51245a648$var$ItemRelativePosition;
(function(ItemRelativePosition) {
    ItemRelativePosition[ItemRelativePosition["ITEM_IS_AFTER_VISIBLE_CARD"] = 1] = "ITEM_IS_AFTER_VISIBLE_CARD";
    ItemRelativePosition[ItemRelativePosition["ITEM_IS_BEFORE_VISIBLE_CARD"] = -1] = "ITEM_IS_BEFORE_VISIBLE_CARD";
    ItemRelativePosition[ItemRelativePosition["ITEM_IS_VISIBLE_CARD"] = 0] = "ITEM_IS_VISIBLE_CARD";
})($534ff7c51245a648$var$ItemRelativePosition || ($534ff7c51245a648$var$ItemRelativePosition = {}));
const $534ff7c51245a648$var$getCurrentCardPosition = ({ visiblePosition: visiblePosition, currentPosition: currentPosition })=>{
    const relativePosition = Math.sign(visiblePosition - currentPosition) || 0;
    switch(relativePosition){
        case 0:
            return '0';
        case 1:
            return '-100%';
        case -1:
        default:
            return '100%';
    }
};
const $534ff7c51245a648$export$da5dc1115c18b364 = /*#__PURE__*/ (0, $kwce8.default).ul.withConfig({
    componentId: "g3b0j7-0"
})({
    position: 'relative',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    width: '100%',
    height: '100%',
    overflow: 'hidden'
});
const $534ff7c51245a648$export$365b3aec472df75b = /*#__PURE__*/ (0, $kwce8.default).li.withConfig({
    componentId: "g3b0j7-1"
})`position:absolute;top:0;bottom:0;padding:0;margin:0;width:100%;transition:transform 0.365s ease-in-out;${(props)=>{
    const cardPosition = $534ff7c51245a648$var$getCurrentCardPosition(props);
    return `
            height: 100%;
            transform: translateX(${cardPosition});
        `;
}}`;

});


parcelRegister("lBAye", function(module, exports) {

$parcel$export(module.exports, "Slide", () => $4bb42a090896cf90$export$d8dc01b5c85a37b9);

var $eUqFw = parcelRequire("eUqFw");

var $7JOkx = parcelRequire("7JOkx");

var $3yTAX = parcelRequire("3yTAX");
const $4bb42a090896cf90$export$d8dc01b5c85a37b9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7JOkx.CarouselConsumer), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3yTAX.StyledCarouselSlide), null, children));

});


parcelRegister("9Epbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ffe95afea8daba5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $7bmKk = parcelRequire("7bmKk");

var $8uD7Y = parcelRequire("8uD7Y");

var $6KMVe = parcelRequire("6KMVe");

var $bFzGY = parcelRequire("bFzGY");

var $gWxA1 = parcelRequire("gWxA1");

var $e9oJE = parcelRequire("e9oJE");

var $9xXn5 = parcelRequire("9xXn5");

var $6EfnZ = parcelRequire("6EfnZ");
const $9ffe95afea8daba5$var$NavigationBullet = ({ position: position, activePosition: activePosition, onNavigationBulletClick: onNavigationBulletClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleNavigationBulletClick = ()=>{
        const event = createAnalyticsEvent({
            actionSubject: 'provisioningModalNavigationBullet',
            action: 'clicked',
            attributes: {
                position: position
            }
        });
        (0, $gWxA1.fireUIAnalytics)(event);
        onNavigationBulletClick(position);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7bmKk.NavigationBullet, {
        onClick: handleNavigationBulletClick,
        isActive: activePosition === position
    });
};
const $9ffe95afea8daba5$var$NavigationBulletGroup = ({ count: count, activePosition: activePosition, onNavigationBulletClick: onNavigationBulletClick })=>{
    if (count < 2) return null;
    const navigationBullets = Array(count).fill(0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7bmKk.NavigationBulletsWrapper, null, navigationBullets.map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9ffe95afea8daba5$var$NavigationBullet, {
            activePosition: activePosition,
            position: index + 1,
            onNavigationBulletClick: onNavigationBulletClick
        })));
};
const $9ffe95afea8daba5$var$buttonAppearance = {
    [(0, $e9oJE.ButtonActionType).DISMISS]: 'subtle',
    [(0, $e9oJE.ButtonActionType).NEXT]: 'primary',
    [(0, $e9oJE.ButtonActionType).DONE]: 'primary'
};
const $9ffe95afea8daba5$var$Button = ({ onClick: onClick, buttonActionType: buttonActionType })=>{
    const handleClick = (_, analyticsEvent)=>{
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'provisioningModalControl', {
            buttonActionType: buttonActionType
        });
        onClick();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7bmKk.ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: $9ffe95afea8daba5$var$buttonAppearance[buttonActionType],
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6KMVe.default)[buttonActionType])));
};
const $9ffe95afea8daba5$var$Container = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7bmKk.ControlsWrapper, null, children);
const $9ffe95afea8daba5$var$ChevronIconTypes = {
    // TODO: Migrate to new icon DSP-20773
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    [(0, $e9oJE.ChevronDirection).RIGHT]: (0, (/*@__PURE__*/$parcel$interopDefault($6EfnZ))),
    // TODO: Migrate to new icon DSP-20773
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    [(0, $e9oJE.ChevronDirection).LEFT]: (0, (/*@__PURE__*/$parcel$interopDefault($9xXn5)))
};
const $9ffe95afea8daba5$var$Chevron = ({ onPrevious: onPrevious, direction: direction, onNext: onNext })=>{
    const handleClick = ()=>{
        if (direction === (0, $e9oJE.ChevronDirection).LEFT && onPrevious) onPrevious();
        if (direction === (0, $e9oJE.ChevronDirection).RIGHT && onNext) onNext();
    };
    const ChevronIcon = $9ffe95afea8daba5$var$ChevronIconTypes[direction];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7bmKk.ChevronWrapper, {
        direction: direction,
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChevronIcon, {
        size: "large",
        label: direction
    }));
};
var $9ffe95afea8daba5$export$2e2bcd8739ae039 = {
    Button: $9ffe95afea8daba5$var$Button,
    NavigationBulletGroup: $9ffe95afea8daba5$var$NavigationBulletGroup,
    Container: $9ffe95afea8daba5$var$Container,
    Chevron: $9ffe95afea8daba5$var$Chevron
};

});
parcelRegister("7bmKk", function(module, exports) {

$parcel$export(module.exports, "ControlsWrapper", () => $f03cb251d7ba0276$export$5ba2725878d48f40);
$parcel$export(module.exports, "ButtonWrapper", () => $f03cb251d7ba0276$export$d53c836cccbb0d90);
$parcel$export(module.exports, "NavigationBulletsWrapper", () => $f03cb251d7ba0276$export$5da873e643f6e8be);
$parcel$export(module.exports, "NavigationBullet", () => $f03cb251d7ba0276$export$c79585d7177d0a0);
$parcel$export(module.exports, "ChevronWrapper", () => $f03cb251d7ba0276$export$175b3820ff858b37);


var $kwce8 = parcelRequire("kwce8");

var $e9oJE = parcelRequire("e9oJE");
const $f03cb251d7ba0276$export$5ba2725878d48f40 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1fnsr4s-0"
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
});
const $f03cb251d7ba0276$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1fnsr4s-1"
})({
    width: '120px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        userSelect: 'none'
    }
});
const $f03cb251d7ba0276$export$5da873e643f6e8be = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1fnsr4s-2"
})({
    display: 'inherit',
    alignItems: 'inherit',
    justifyContent: 'center',
    maxWidth: '120px'
});
const $f03cb251d7ba0276$export$c79585d7177d0a0 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1fnsr4s-3"
})(({ isActive: isActive })=>({
        width: '8px',
        height: '8px',
        backgroundColor: `var(--ds-background-brand-bold, ${0, $73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
        borderRadius: '50%',
        cursor: 'pointer',
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isActive ? '1' : '0.4',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            opacity: isActive ? '1' : '0.6'
        }
    }));
const $f03cb251d7ba0276$export$175b3820ff858b37 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1fnsr4s-4"
})`position:absolute;left:${({ direction: direction })=>direction === (0, $e9oJE.ChevronDirection).LEFT ? "var(--ds-space-300, 24px)" : 'auto'};right:${({ direction: direction })=>direction === (0, $e9oJE.ChevronDirection).RIGHT ? "var(--ds-space-300, 24px)" : 'auto'};top:150px;opacity:0.6;:hover{opacity:1;}cursor:pointer;z-index:1;`;

});
parcelRegister("e9oJE", function(module, exports) {

$parcel$export(module.exports, "ButtonActionType", () => $94b1396dd25fd71d$export$e3bd8c5021ad764b);
$parcel$export(module.exports, "ChevronDirection", () => $94b1396dd25fd71d$export$28cad1695513a229);
var $94b1396dd25fd71d$export$e3bd8c5021ad764b;
(function(ButtonActionType) {
    ButtonActionType["DISMISS"] = "dismiss";
    ButtonActionType["NEXT"] = "next";
    ButtonActionType["DONE"] = "done";
})($94b1396dd25fd71d$export$e3bd8c5021ad764b || ($94b1396dd25fd71d$export$e3bd8c5021ad764b = {}));
var $94b1396dd25fd71d$export$28cad1695513a229;
(function(ChevronDirection) {
    ChevronDirection["RIGHT"] = "right";
    ChevronDirection["LEFT"] = "left";
})($94b1396dd25fd71d$export$28cad1695513a229 || ($94b1396dd25fd71d$export$28cad1695513a229 = {}));

});


parcelRegister("6KMVe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8219abc384b6a8a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $c8219abc384b6a8a$var$messages = (0, $90IgZ.defineMessages)({
    dismiss: {
        id: 'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss',
        defaultMessage: 'Dismiss',
        description: 'Label of a button to allow users to dismiss the info modal'
    },
    next: {
        id: 'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next',
        defaultMessage: 'Next',
        description: 'Label of a button to allow users to go to the next screen within the info modal'
    },
    done: {
        id: 'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done',
        defaultMessage: 'Done',
        description: 'Label of a button indicating that Jira provisioning is completed and users can dismiss the modal by clicking Done'
    }
});
var $c8219abc384b6a8a$export$2e2bcd8739ae039 = $c8219abc384b6a8a$var$messages;

});

parcelRegister("9xXn5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f35400da13b72d7$var$_react = $6f35400da13b72d7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6f35400da13b72d7$var$_chevronLeft = $6f35400da13b72d7$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $6f35400da13b72d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6f35400da13b72d7$var$ChevronLeftCircleIcon = (props)=>/*#__PURE__*/ $6f35400da13b72d7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></g></svg>`
    }, props, {
        newIcon: $6f35400da13b72d7$var$_chevronLeft.default,
        iconType: "utility"
    }));
$6f35400da13b72d7$var$ChevronLeftCircleIcon.displayName = 'ChevronLeftCircleIcon';
var $6f35400da13b72d7$var$_default = module.exports.default = $6f35400da13b72d7$var$ChevronLeftCircleIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});


parcelRegister("6EfnZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d7269d0f6dcc3b2$var$_react = $4d7269d0f6dcc3b2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $4d7269d0f6dcc3b2$var$_chevronRight = $4d7269d0f6dcc3b2$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $4d7269d0f6dcc3b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4d7269d0f6dcc3b2$var$ChevronRightCircleIcon = (props)=>/*#__PURE__*/ $4d7269d0f6dcc3b2$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></g></svg>`
    }, props, {
        newIcon: $4d7269d0f6dcc3b2$var$_chevronRight.default,
        iconType: "utility"
    }));
$4d7269d0f6dcc3b2$var$ChevronRightCircleIcon.displayName = 'ChevronRightCircleIcon';
var $4d7269d0f6dcc3b2$var$_default = module.exports.default = $4d7269d0f6dcc3b2$var$ChevronRightCircleIcon;

});


parcelRegister("7b06u", function(module, exports) {

$parcel$export(module.exports, "YourProjectPagesInJira", () => $37ff4ab9f5414575$export$41899e7e2672fb19);
$parcel$export(module.exports, "SeamlesslyUpdateStakeholders", () => $37ff4ab9f5414575$export$2654a507013898c6);
$parcel$export(module.exports, "UnifyDocumentation", () => $37ff4ab9f5414575$export$dd39790e2f9c8f14);

var $eUqFw = parcelRequire("eUqFw");

var $00jM8 = parcelRequire("00jM8");

var $ioQ66 = parcelRequire("ioQ66");

var $8eNgj = parcelRequire("8eNgj");

var $8uD7Y = parcelRequire("8uD7Y");

var $aptAI = parcelRequire("aptAI");

var $cQl06 = parcelRequire("cQl06");
const $37ff4ab9f5414575$export$41899e7e2672fb19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQl06.Card), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($00jM8))),
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aptAI.default).yourProjectPagesInJiraTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aptAI.default).yourProjectPagesInJiraDescription));
const $37ff4ab9f5414575$export$2654a507013898c6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQl06.Card), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ioQ66))),
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aptAI.default).seamlesslyUpdateStakeholdersTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aptAI.default).seamlesslyUpdateStakeholdersDescription));
const $37ff4ab9f5414575$export$dd39790e2f9c8f14 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQl06.Card), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($8eNgj))),
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aptAI.default).seamlesslyUpdateStakeholdersTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aptAI.default).seamlesslyUpdateStakeholdersDescription));

});
parcelRegister("00jM8", function(module, exports) {
module.exports = new URL("browser1.05f8e65f.png", import.meta.url).toString();

});

parcelRegister("ioQ66", function(module, exports) {
module.exports = new URL("browser2.fcf4be7d.png", import.meta.url).toString();

});

parcelRegister("8eNgj", function(module, exports) {
module.exports = new URL("browser3.f2a4f80b.png", import.meta.url).toString();

});

parcelRegister("aptAI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e849dc2f41212f66$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");

var $h2Mrz = parcelRequire("h2Mrz");
const $e849dc2f41212f66$var$values = {
    a: (0, $h2Mrz.anchorConstructor),
    p: (0, $h2Mrz.paragraphConstructor)
};
const $e849dc2f41212f66$var$messages = (0, $90IgZ.defineMessages)({
    yourProjectPagesInJiraTitle: {
        id: 'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title',
        defaultMessage: 'Your project pages, directly in Jira',
        description: '',
        values: $e849dc2f41212f66$var$values
    },
    yourProjectPagesInJiraDescription: {
        id: 'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description',
        defaultMessage: `
        <p>Create a single source of truth for important information by creating and managing documentation from the project pages tab in Jira.</p>
        <p>Did you know project pages runs on Confluence? It's free for up to 10 users. Invite the rest of your team in admin settings.</p>
    `,
        description: '',
        values: $e849dc2f41212f66$var$values
    },
    seamlesslyUpdateStakeholdersTitle: {
        id: 'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title',
        defaultMessage: 'Seamlessly update your stakeholders',
        description: '',
        values: $e849dc2f41212f66$var$values
    },
    seamlesslyUpdateStakeholdersDescription: {
        id: 'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description',
        defaultMessage: `
        <p>Keep your project reports up-to-date with auto-updating status labels.</p>
        <p>Simply link a Jira ticket in a doc and it will automatically display a status label that updates in sync with the ticket, so you don't have to spend your time creating manual reports.</p>
    `,
        description: '',
        values: $e849dc2f41212f66$var$values
    },
    unifyDocumentationTitle: {
        id: 'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title',
        defaultMessage: 'Unify your documentation standards',
        description: '',
        values: $e849dc2f41212f66$var$values
    },
    unifyDocumentationDescription: {
        id: 'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description',
        defaultMessage: `
        <p>Create consistent documentation by using our built-in templates. They are simple to use and customizable for your needs.</p>
        <p>You can use templates directly from project pages, so you never have to leave what you're working on. Browse all templates <a>here</a>.</p>
    `,
        description: '',
        values: $e849dc2f41212f66$var$values
    }
});
var $e849dc2f41212f66$export$2e2bcd8739ae039 = $e849dc2f41212f66$var$messages;

});
parcelRegister("h2Mrz", function(module, exports) {

$parcel$export(module.exports, "paragraphConstructor", () => $488334fe3bdc971b$export$c9e5fc37b88cf735);
$parcel$export(module.exports, "anchorConstructor", () => $488334fe3bdc971b$export$59032c4ec43430cf);

var $eUqFw = parcelRequire("eUqFw");
const $488334fe3bdc971b$var$TEMPLATES_URL = 'https://www.atlassian.com/software/confluence/templates/categories/project-planning';
const $488334fe3bdc971b$export$c9e5fc37b88cf735 = (intlStr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, intlStr);
const $488334fe3bdc971b$export$59032c4ec43430cf = (intlStr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: $488334fe3bdc971b$var$TEMPLATES_URL,
        target: "_blank"
    }, intlStr);

});


parcelRegister("cQl06", function(module, exports) {

$parcel$export(module.exports, "Card", () => $60580350e0d08022$export$60332b2344f7fe41);

var $eUqFw = parcelRequire("eUqFw");

var $fQjhY = parcelRequire("fQjhY");
const $60580350e0d08022$export$60332b2344f7fe41 = ({ heading: heading, children: children, image: image })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fQjhY.CardWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fQjhY.CardImage, {
        src: image,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fQjhY.CardText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h2", null, heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), children));

});
parcelRegister("fQjhY", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $976b6b0785f51f6f$export$6aa22a823032b784);
$parcel$export(module.exports, "CardText", () => $976b6b0785f51f6f$export$c6336bc933e0ce5f);
$parcel$export(module.exports, "CardImage", () => $976b6b0785f51f6f$export$8a8c015277a3d77a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $976b6b0785f51f6f$var$IMAGE_HEIGHT = 180;
const $976b6b0785f51f6f$export$6aa22a823032b784 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "gdinkh-0"
})({
    display: 'grid',
    gridTemplateColumns: '100%',
    gridTemplateRows: '50% 50%',
    height: '100%',
    width: '80%',
    margin: '0 auto',
    overflowY: 'auto',
    justifyItems: 'center',
    alignItems: 'center'
});
const $976b6b0785f51f6f$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "gdinkh-1"
})({
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%'
});
const $976b6b0785f51f6f$export$c6336bc933e0ce5f = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "gdinkh-2"
})({
    width: '100%'
});
const $976b6b0785f51f6f$export$8a8c015277a3d77a = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "gdinkh-3"
})({
    position: 'relative',
    height: `${$976b6b0785f51f6f$var$IMAGE_HEIGHT}px`,
    objectFit: 'cover',
    userSelect: 'none'
});

});





parcelRegister("1IXx6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2180cbec8bd494c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iRFLU = parcelRequire("iRFLU");
var $7Tlwb = parcelRequire("7Tlwb");

var $93lz3 = parcelRequire("93lz3");

var $8QFeQ = parcelRequire("8QFeQ");

var $8uD7Y = parcelRequire("8uD7Y");

var $6MxaZ = parcelRequire("6MxaZ");

var $iFmgL = parcelRequire("iFmgL");
const $f2180cbec8bd494c$var$ProvisioningProgressBar = ({ status: status })=>{
    if (status === 'completed') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Tlwb.default), {
        value: 1
    });
    if (status === 'in-progress') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Tlwb.default), {
        value: 0.8
    });
    if (status === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRFLU.default), {
        value: 1,
        appearance: "inverse"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Tlwb.default), {
        isIndeterminate: true
    });
};
const $f2180cbec8bd494c$var$ActivationInProgressBackground = ({ status: status = 'not-started' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8QFeQ.Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
        height: 144,
        width: 144,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($93lz3)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8QFeQ.ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f2180cbec8bd494c$var$ProvisioningProgressBar, {
        status: status
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        tagName: "h3",
        ...(0, $6MxaZ.default).provisioningBackgroundTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        tagName: "p",
        ...(0, $6MxaZ.default).provisioningBackgroundText
    })));
var $f2180cbec8bd494c$export$2e2bcd8739ae039 = $f2180cbec8bd494c$var$ActivationInProgressBackground;

});
parcelRegister("iRFLU", function(module, exports) {

$parcel$export(module.exports, "default", () => $741f3f691e937b15$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

function $741f3f691e937b15$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $741f3f691e937b15$var$MIN_VALUE = 0;
const $741f3f691e937b15$var$MAX_VALUE = 1;
const $741f3f691e937b15$var$increasingBarAnimation = (0, $byn9U.keyframes)({
    from: {
        left: '-5%',
        width: '5%'
    },
    to: {
        left: '130%',
        width: ' 100%'
    }
});
const $741f3f691e937b15$var$decreasingBarAnimation = (0, $byn9U.keyframes)({
    from: {
        left: '-80%',
        width: '80%'
    },
    to: {
        left: '110%',
        width: '10%'
    }
});
const $741f3f691e937b15$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: `100%`,
    height: 6,
    position: 'relative',
    background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    overflow: 'hidden'
});
const $741f3f691e937b15$var$containerAppearance = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`
    }),
    success: /*#__PURE__*/ (0, $byn9U.css)({
        background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`
    }),
    inverse: {
        name: "17q4nu8",
        styles: "background:var(--ds-background-inverse-subtle, rgba(255, 255, 255, 0.5))"
    }
};
const $741f3f691e937b15$var$barAppearance = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        background: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
    }),
    success: /*#__PURE__*/ (0, $byn9U.css)({
        background: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`
    }),
    inverse: {
        name: "1n6cgt8",
        styles: "background:var(--ds-surface, white)"
    }
};
const $741f3f691e937b15$var$barStyles = {
    name: "np1q02",
    styles: "display:block;height:6px;position:absolute;border-radius:var(--ds-border-radius, 3px)"
};
const $741f3f691e937b15$var$determinateBarStyles = {
    name: "1nxgqyg",
    styles: "transition:width 0.2s"
};
const $741f3f691e937b15$var$increasingBarStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animation: `${$741f3f691e937b15$var$increasingBarAnimation} 2s infinite`
});
const $741f3f691e937b15$var$decreasingBarStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animation: `${$741f3f691e937b15$var$decreasingBarAnimation} 2s 0.5s infinite`
});
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ const $741f3f691e937b15$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $741f3f691e937b15$var$MIN_VALUE : Math.max($741f3f691e937b15$var$MIN_VALUE, Math.min(value, $741f3f691e937b15$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $741f3f691e937b15$var$containerStyles,
            $741f3f691e937b15$var$containerAppearance[appearance]
        ],
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $741f3f691e937b15$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $741f3f691e937b15$var$MAX_VALUE,
        tabIndex: 0,
        "data-testid": testId
    }, isIndeterminate ? /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $741f3f691e937b15$var$barStyles,
            $741f3f691e937b15$var$barAppearance[appearance],
            $741f3f691e937b15$var$increasingBarStyles
        ]
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $741f3f691e937b15$var$barStyles,
            $741f3f691e937b15$var$barAppearance[appearance],
            $741f3f691e937b15$var$decreasingBarStyles
        ]
    })) : /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: {
            width: `${Number(value) * 100}%`
        },
        css: [
            $741f3f691e937b15$var$barStyles,
            $741f3f691e937b15$var$barAppearance[appearance],
            $741f3f691e937b15$var$determinateBarStyles
        ]
    }));
};
var $741f3f691e937b15$export$2e2bcd8739ae039 = $741f3f691e937b15$var$ProgressBar;

});

parcelRegister("7Tlwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $11fcf6a4318397d5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iRFLU = parcelRequire("iRFLU");
/**
 * __Success progress bar__
 *
 * A success progress bar indicates the completion of a process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/success-progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/success-progress-bar/code)
 */ const $11fcf6a4318397d5$var$SuccessProgressBar = ({ ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId, value: value = 0 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRFLU.default), {
        appearance: value < 1 || isIndeterminate ? 'default' : 'success',
        value: value,
        isIndeterminate: isIndeterminate,
        ariaLabel: ariaLabel,
        testId: testId
    });
};
var $11fcf6a4318397d5$export$2e2bcd8739ae039 = $11fcf6a4318397d5$var$SuccessProgressBar;

});

parcelRegister("93lz3", function(module, exports) {
module.exports = new URL("cog-illustration.58f1b3ca.png", import.meta.url).toString();

});

parcelRegister("8QFeQ", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $fdac86171acc7d34$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "ContentWrapper", () => $fdac86171acc7d34$export$6ce170286acaa8d3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $fdac86171acc7d34$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-15tbicu-0"
})({
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: "var(--ds-space-400, 32px)",
    marginTop: "var(--ds-space-400, 32px)"
});
const $fdac86171acc7d34$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-15tbicu-1"
})({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: "var(--ds-space-300, 24px)"
});
const $fdac86171acc7d34$export$d4467089dab4970d = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-15tbicu-2"
})({
    width: '100%',
    margin: '0 auto'
});
const $fdac86171acc7d34$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $kwce8.default).footer.withConfig({
    componentId: "sc-15tbicu-3"
})({
    position: 'fixed',
    bottom: "var(--ds-space-400, 32px)",
    left: 0,
    right: 0,
    textAlign: 'center'
});

});

parcelRegister("6MxaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cb55d355301f37a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $3cb55d355301f37a$var$messages = (0, $90IgZ.defineMessages)({
    provisioningBackgroundTitle: {
        id: 'confluence.project-pages.improvement.provisioning-background.title',
        defaultMessage: 'Setting up your Project Pages',
        description: 'Heading in provisioning in progress screen, informing users that Project Pages is currently being set up.'
    },
    provisioningBackgroundText: {
        id: 'confluence.project-pages.improvement.provisioning-background.text',
        defaultMessage: 'This should take less than a minute',
        description: 'Sentence informing users that provisioning will be done in no time'
    }
});
var $3cb55d355301f37a$export$2e2bcd8739ae039 = $3cb55d355301f37a$var$messages;

});




parcelRegister("8LwVJ", function(module, exports) {

$parcel$export(module.exports, "SET", () => $a4151e16c7fc37a7$export$5e8f180ef0142226);
$parcel$export(module.exports, "UPDATE_ONDEMAND_ACTIVATION_MODAL_STATE", () => $a4151e16c7fc37a7$export$afbcfbc1c3b0dcf4);
$parcel$export(module.exports, "updateOnDemandActivationModalState", () => $a4151e16c7fc37a7$export$1308542fa5d9be2d);
const $a4151e16c7fc37a7$export$5e8f180ef0142226 = 'ui.onDemandActivation.SET';
const $a4151e16c7fc37a7$export$adaa4cf7ef1b65be = (payload)=>({
        type: $a4151e16c7fc37a7$export$5e8f180ef0142226,
        payload: payload
    });
const $a4151e16c7fc37a7$export$afbcfbc1c3b0dcf4 = 'UPDATE_ONDEMAND_ACTIVATION_MODAL_STATE';
const $a4151e16c7fc37a7$export$1308542fa5d9be2d = ({ modalState: modalState })=>({
        type: $a4151e16c7fc37a7$export$afbcfbc1c3b0dcf4,
        payload: {
            modalState: modalState
        }
    });

});

parcelRegister("1UwLx", function(module, exports) {

$parcel$export(module.exports, "PLAN_ACTIVATION", () => $d1510ba697812fa5$export$693f82e6d15e2001);
$parcel$export(module.exports, "planConfluenceActivation", () => $d1510ba697812fa5$export$719a6d82e18d7952);
$parcel$export(module.exports, "START_ACTIVATION", () => $d1510ba697812fa5$export$df745e370b4d7554);
$parcel$export(module.exports, "startConfluenceActivation", () => $d1510ba697812fa5$export$5eb8bc3af0b02481);
$parcel$export(module.exports, "CHECK_ACTIVATION_STATUS", () => $d1510ba697812fa5$export$96d1ac5936a813d0);
$parcel$export(module.exports, "checkConfluenceActivationStatus", () => $d1510ba697812fa5$export$6b9af70858c06776);
$parcel$export(module.exports, "CHECK_ACTIVATION_STATUS_SUCCESS", () => $d1510ba697812fa5$export$5627e8b0363a4224);
$parcel$export(module.exports, "checkConfluenceActivationStatusSuccess", () => $d1510ba697812fa5$export$bd1e98dfc3279e5e);
$parcel$export(module.exports, "CHECK_ACTIVATION_STATUS_ERROR", () => $d1510ba697812fa5$export$974eca385726fba3);
$parcel$export(module.exports, "checkConfluenceActivationStatusFailed", () => $d1510ba697812fa5$export$c59b45e8667ba1b5);
$parcel$export(module.exports, "UPDATE_ACTIVATION_STATUS", () => $d1510ba697812fa5$export$10ad70d4ba1d6fd3);
$parcel$export(module.exports, "updateConfluenceActivationStatus", () => $d1510ba697812fa5$export$15e97fc2ce13e356);
$parcel$export(module.exports, "MARK_ACTIVATION_COMPLETED", () => $d1510ba697812fa5$export$6a79429e78cccf1c);
$parcel$export(module.exports, "markActivationCompleted", () => $d1510ba697812fa5$export$72135711c378954c);
$parcel$export(module.exports, "MARK_ACTIVATION_ERROR", () => $d1510ba697812fa5$export$6eb749a3d854f4cd);
$parcel$export(module.exports, "markActivationFailed", () => $d1510ba697812fa5$export$1a1fa78555603743);

var $1lqG4 = parcelRequire("1lqG4");
function $d1510ba697812fa5$var$createAction(type, identifier) {
    const actionType = `ACTIVATE_CONFLUENCE_${type}_${identifier}`;
    const actionCreator = (0, $1lqG4.genericActionCreator)(actionType);
    return [
        actionType,
        actionCreator
    ];
}
const [$d1510ba697812fa5$export$693f82e6d15e2001, $d1510ba697812fa5$export$719a6d82e18d7952] = $d1510ba697812fa5$var$createAction('PLAN', 'BASE');
const [$d1510ba697812fa5$export$df745e370b4d7554, $d1510ba697812fa5$export$5eb8bc3af0b02481] = $d1510ba697812fa5$var$createAction('START', 'BASE');
const [$d1510ba697812fa5$export$96d1ac5936a813d0, $d1510ba697812fa5$export$6b9af70858c06776] = $d1510ba697812fa5$var$createAction('CHECK_STATUS', 'BASE');
const [$d1510ba697812fa5$export$5627e8b0363a4224, $d1510ba697812fa5$export$bd1e98dfc3279e5e] = $d1510ba697812fa5$var$createAction('CHECK_STATUS', 'SUCCESS');
const [$d1510ba697812fa5$export$974eca385726fba3, $d1510ba697812fa5$export$c59b45e8667ba1b5] = $d1510ba697812fa5$var$createAction('CHECK_STATUS', 'ERROR');
const [$d1510ba697812fa5$export$10ad70d4ba1d6fd3, $d1510ba697812fa5$export$15e97fc2ce13e356] = $d1510ba697812fa5$var$createAction('UPDATE_STATUS', 'BASE');
const [$d1510ba697812fa5$export$6a79429e78cccf1c, $d1510ba697812fa5$export$72135711c378954c] = $d1510ba697812fa5$var$createAction('MARK_COMPLETED', 'BASE');
const [$d1510ba697812fa5$export$6eb749a3d854f4cd, $d1510ba697812fa5$export$1a1fa78555603743] = $d1510ba697812fa5$var$createAction('MARK_ERROR', 'BASE');

});
parcelRegister("1lqG4", function(module, exports) {

$parcel$export(module.exports, "genericActionCreator", () => $3cd327fbe7118c43$export$1c79bd8e318e0de0);
function $3cd327fbe7118c43$export$1c79bd8e318e0de0(type) {
    return (payload)=>({
            type: type,
            payload: payload
        });
}

});



parcelRegister("k93Dd", function(module, exports) {

$parcel$export(module.exports, "useRouter", () => $9b507ce424bfa5ef$export$9a302a45f65d0572);
$parcel$export(module.exports, "RouteProvider", () => $9b507ce424bfa5ef$export$56484b1710c65ae5);

var $eUqFw = parcelRequire("eUqFw");


var $jmJqM = parcelRequire("jmJqM");
const $9b507ce424bfa5ef$export$9c38b177931e3e5c = {
    [(0, $eda5adb3daefc3fa$export$beb27109f0387267)]: (0, $jmJqM.Routes).TemplatePreview,
    [(0, $eda5adb3daefc3fa$export$22ad4d38ecffca72)]: (0, $jmJqM.Routes).ConfluenceActivating,
    [(0, $eda5adb3daefc3fa$export$ed9dbaba8445f424)]: (0, $jmJqM.Routes).ConfluenceActivatingOnDemand,
    [(0, $eda5adb3daefc3fa$export$e74e627186613bef)]: (0, $jmJqM.Routes).ConnectSpace,
    [(0, $eda5adb3daefc3fa$export$65d0a606bcce00e6)]: (0, $jmJqM.Routes).ServerError,
    [(0, $eda5adb3daefc3fa$export$52022723d6fe5666)]: (0, $jmJqM.Routes).ServerErrorAccess,
    [(0, $eda5adb3daefc3fa$export$f603e10769c22ef6)]: (0, $jmJqM.Routes).SpaceOrPageNotFound,
    [(0, $eda5adb3daefc3fa$export$396960dbbf8fe6e1)]: (0, $jmJqM.Routes).SpaceOrPageNotFound,
    [(0, $eda5adb3daefc3fa$export$98cc058279f6e82f)]: (0, $jmJqM.Routes).SpaceOrPageNotFound,
    [(0, $eda5adb3daefc3fa$export$2f82131be5023f37)]: (0, $jmJqM.Routes).ConfluenceTree,
    [(0, $eda5adb3daefc3fa$export$5a0e72a8258542bd)]: (0, $jmJqM.Routes).ConfluenceTree,
    [(0, $eda5adb3daefc3fa$export$bde25b564fc94248)]: (0, $jmJqM.Routes).ConfluenceTree
};
const $9b507ce424bfa5ef$var$RouteContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    navigate: ()=>void 0
});
const $9b507ce424bfa5ef$export$9a302a45f65d0572 = ()=>(0, $eUqFw.useContext)($9b507ce424bfa5ef$var$RouteContext);
const $9b507ce424bfa5ef$export$56484b1710c65ae5 = ({ children: children, confluenceLicenseStatus: confluenceLicenseStatus })=>{
    const [activeRoute, setActiveRoute] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        setActiveRoute($9b507ce424bfa5ef$export$9c38b177931e3e5c[confluenceLicenseStatus]);
    }, [
        confluenceLicenseStatus
    ]);
    const navigate = (route)=>{
        setActiveRoute(route);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b507ce424bfa5ef$var$RouteContext.Provider, {
        value: {
            navigate: navigate,
            activeRoute: activeRoute
        }
    }, children);
};

});
parcelRegister("jmJqM", function(module, exports) {

$parcel$export(module.exports, "Routes", () => $564119005dc57f37$export$3565eb3d00ca5a74);
var $564119005dc57f37$export$3565eb3d00ca5a74;
(function(Routes) {
    Routes["TemplatePreview"] = "TEMPLATE_PREVIEW";
    Routes["ConfluenceActivating"] = "CONFLUENCE_ACTIVATING";
    Routes["ConfluenceActivatingOnDemand"] = "CONFLUENCE_ACTIVATING_ONDEMAND";
    Routes["ConnectSpace"] = "CONNECT_SPACE";
    Routes["ServerError"] = "SERVER_ERROR";
    Routes["ServerErrorAccess"] = "SERVER_ERROR_ACCESS";
    Routes["SpaceOrPageNotFound"] = "SPACE_OR_PAGE_NOT_FOUND";
    Routes["ConfluenceTree"] = "CONFLUENCE_TREE";
})($564119005dc57f37$export$3565eb3d00ca5a74 || ($564119005dc57f37$export$3565eb3d00ca5a74 = {}));

});



parcelRegister("e8sOK", function(module, exports) {

$parcel$export(module.exports, "PageDecorators", () => $5dcad2a80bc01034$export$2fdd42cedb1d9e1);

var $eUqFw = parcelRequire("eUqFw");

var $enWzh = parcelRequire("enWzh");

var $k93Dd = parcelRequire("k93Dd");

var $jmJqM = parcelRequire("jmJqM");
const $5dcad2a80bc01034$export$2fdd42cedb1d9e1 = ({ hasConfluence: hasConfluence, containerRef: containerRef })=>{
    const { activeRoute: activeRoute } = (0, $k93Dd.useRouter)();
    if (activeRoute === (0, $jmJqM.Routes).ConfluenceActivatingOnDemand) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $enWzh.default), {
        hasConfluence: hasConfluence,
        containerRef: containerRef
    });
};

});
parcelRegister("enWzh", function(module, exports) {

$parcel$export(module.exports, "default", () => $98f70b5d72eb0ddf$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $3pvFP = parcelRequire("3pvFP");

var $hMy8N = parcelRequire("hMy8N");

var $9yekW = parcelRequire("9yekW");

var $4aXoz = parcelRequire("4aXoz");

var $4vaC4 = parcelRequire("4vaC4");

var $gb4n8 = parcelRequire("gb4n8");

var $9c14t = parcelRequire("9c14t");

var $elvqY = parcelRequire("elvqY");

var $baKYD = parcelRequire("baKYD");

var $jGyKS = parcelRequire("jGyKS");
const $98f70b5d72eb0ddf$var$mapStateToProps = (state, { hasConfluence: hasConfluence })=>({
        accessRequestCapability: (0, $9c14t.getAccessRequestCapability)(state),
        areTemplatesEnabled: (0, $elvqY.areTemplatesEnabled)(state) && !((0, $9yekW.isSpaceHomePageNull)(state) || (0, $9yekW.isPageHomePageNull)(state)),
        blueprints: (0, $4aXoz.getBlueprints)(state),
        isProjectPagesSporkRebrandingEnabled: (0, $4vaC4.getIsProjectPagesSporkRebrandingEnabled)(state),
        isConfluenceAutoProvisioned: (0, $baKYD.isConfluenceAutoProvisioned)(state),
        confluenceLicenseStatus: (0, $9yekW.getConfluenceLicenseStatus)(state),
        hasAccessToConfluence: (0, $9yekW.getIsPostExpand)(state, hasConfluence),
        origin: (0, $hMy8N.getOrigin)(state),
        contentId: (0, $4aXoz.getProjectPageLinkedId)(state),
        spaceKey: (0, $4aXoz.getProjectSpaceKey)(state),
        projectId: (0, $jGyKS.getProjectId)(state),
        projectType: (0, $jGyKS.getProjectType)(state)
    });
const $98f70b5d72eb0ddf$var$mapDispatchToProps = (dispatch)=>({
        showError: ()=>dispatch((0, $3pvFP.showError)())
    });
var $98f70b5d72eb0ddf$export$2e2bcd8739ae039 = (0, $cllCv.connect)($98f70b5d72eb0ddf$var$mapStateToProps, $98f70b5d72eb0ddf$var$mapDispatchToProps)((0, $gb4n8.default));

});
parcelRegister("4vaC4", function(module, exports) {

$parcel$export(module.exports, "getIsProjectPagesSporkRebrandingEnabled", () => $ca3db36eae20b0ce$export$ec2ec602bc0ecd73);
const $ca3db36eae20b0ce$export$ec2ec602bc0ecd73 = (state)=>state.featureFlags.isProjectPagesSporkRebrandingEnabled;

});

parcelRegister("gb4n8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb9e1eed1e55fe5e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $afgkZ = parcelRequire("afgkZ");

var $iWw3g = parcelRequire("iWw3g");

var $3Q4O0 = parcelRequire("3Q4O0");

var $gap96 = parcelRequire("gap96");

var $kgX2t = parcelRequire("kgX2t");
const $cb9e1eed1e55fe5e$export$f5a02fa7d7af52b8 = ({ accessRequestCapability: accessRequestCapability, areTemplatesEnabled: areTemplatesEnabled, blueprints: blueprints, contentId: contentId, containerRef: containerRef, isConfluenceAutoProvisioned: isConfluenceAutoProvisioned, intl: intl, hasAccessToConfluence: hasAccessToConfluence, origin: origin, confluenceLicenseStatus: confluenceLicenseStatus, showError: showError, spaceKey: spaceKey, projectId: projectId, projectType: projectType, isProjectPagesSporkRebrandingEnabled: isProjectPagesSporkRebrandingEnabled })=>{
    const { getTemplates: getTemplates, props: props, hoverPreviewProps: hoverPreviewProps } = (0, $afgkZ.useTemplatesPanelControls)({
        accessRequestCapability: accessRequestCapability,
        areTemplatesEnabled: areTemplatesEnabled,
        blueprints: blueprints,
        contentId: contentId,
        intl: intl,
        hasAccessToConfluence: hasAccessToConfluence,
        origin: origin,
        spaceKey: spaceKey,
        showError: showError,
        projectId: projectId,
        projectType: projectType
    });
    const templates = (0, $eUqFw.useMemo)(()=>getTemplates({
            intl: intl,
            isConfluenceAutoProvisioned: isConfluenceAutoProvisioned,
            isProjectPagesSporkRebrandingEnabled: isProjectPagesSporkRebrandingEnabled,
            confluenceLicenseStatus: confluenceLicenseStatus
        }), [
        intl,
        isConfluenceAutoProvisioned,
        isProjectPagesSporkRebrandingEnabled,
        confluenceLicenseStatus,
        getTemplates
    ]);
    (0, $kgX2t.usePreloadPreviews)(templates, hasAccessToConfluence);
    return hasAccessToConfluence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWw3g.TemplatesPanelHoverPreview), {
        containerRef: containerRef,
        templates: templates,
        hoverPreviewProps: hoverPreviewProps,
        origin: origin,
        ...props
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Q4O0.default), {
        templates: templates,
        ...props,
        title: (0, $gap96.default).noConfluenceLicenseTitle,
        subtitle: (0, $gap96.default).noConfluenceLicenseSubTitle
    });
};
var $cb9e1eed1e55fe5e$export$2e2bcd8739ae039 = (0, $2qhQi.default)($cb9e1eed1e55fe5e$export$f5a02fa7d7af52b8);

});
parcelRegister("afgkZ", function(module, exports) {

$parcel$export(module.exports, "useTemplatesPanelControls", () => $55307c0e381e8fbc$export$3a47ec68a82733fa);

var $734Zv = parcelRequire("734Zv");

var $l505P = parcelRequire("l505P");

var $4Efjl = parcelRequire("4Efjl");
const $55307c0e381e8fbc$export$3a47ec68a82733fa = ({ accessRequestCapability: accessRequestCapability, areTemplatesEnabled: areTemplatesEnabled, blueprints: blueprints, contentId: contentId, hasAccessToConfluence: hasAccessToConfluence, intl: intl, origin: origin, spaceKey: spaceKey, showError: showError, projectId: projectId, projectType: projectType })=>{
    const { props: hasLicenseProps, hoverPreviewProps: hoverPreviewProps } = (0, $l505P.useTemplatesPanelControlsWithLicense)({
        accessRequestCapability: accessRequestCapability,
        areTemplatesEnabled: areTemplatesEnabled,
        blueprints: blueprints,
        contentId: contentId,
        intl: intl,
        origin: origin,
        spaceKey: spaceKey,
        showError: showError,
        projectId: projectId,
        projectType: projectType
    });
    const { props: hasNoLicenseProps } = (0, $4Efjl.useTemplatesControlsWithoutLicense)({});
    const getTemplates = ({ isConfluenceAutoProvisioned: isConfluenceAutoProvisioned, isProjectPagesSporkRebrandingEnabled: isProjectPagesSporkRebrandingEnabled, confluenceLicenseStatus: confluenceLicenseStatus })=>hasAccessToConfluence ? (0, $734Zv.getPostExpandTemplates)(spaceKey, areTemplatesEnabled, confluenceLicenseStatus, blueprints, intl, isConfluenceAutoProvisioned, isProjectPagesSporkRebrandingEnabled) : (0, $734Zv.getPreExpandTemplates)(intl, isConfluenceAutoProvisioned, isProjectPagesSporkRebrandingEnabled);
    return {
        getTemplates: getTemplates,
        props: hasAccessToConfluence ? hasLicenseProps : hasNoLicenseProps,
        hoverPreviewProps: hasAccessToConfluence ? hoverPreviewProps : undefined
    };
};

});
parcelRegister("l505P", function(module, exports) {

$parcel$export(module.exports, "useTemplatesPanelControlsWithLicense", () => $72403c939ac01315$export$35ee4df5a8ec1bd8);

var $eUqFw = parcelRequire("eUqFw");

var $dZsZr = parcelRequire("dZsZr");

var $dcSvg = parcelRequire("dcSvg");

var $iCgZp = parcelRequire("iCgZp");
const $72403c939ac01315$var$HIDE_DELAY_MS = 250;
const $72403c939ac01315$export$a787a847e7bc1b42 = (areTemplatesEnabled, accessRequestCapability)=>{
    if (areTemplatesEnabled) return areTemplatesEnabled;
    if (accessRequestCapability === (0, $dcSvg.AccessRequestCapabilityType).DIRECT_ACCESS || accessRequestCapability === (0, $dcSvg.AccessRequestCapabilityType).REQUEST_ACCESS) return false;
};
const $72403c939ac01315$export$35ee4df5a8ec1bd8 = ({ accessRequestCapability: accessRequestCapability, areTemplatesEnabled: areTemplatesEnabled, blueprints: blueprints, contentId: contentId, intl: intl, origin: origin, spaceKey: spaceKey, showError: showError, projectId: projectId, projectType: projectType })=>{
    const createEmbeddedPage = (0, $iCgZp.useCreateEmbeddedPage)({
        spaceKey: spaceKey,
        projectId: projectId,
        projectType: projectType
    });
    const [activeTemplate, setActiveTemplate] = (0, $eUqFw.useState)(undefined);
    const hidePreviewTimer = (0, $eUqFw.useRef)(null);
    const cancelHidePreview = (0, $eUqFw.useCallback)(()=>{
        if (hidePreviewTimer.current) {
            clearTimeout(hidePreviewTimer.current);
            hidePreviewTimer.current = null;
        }
    }, []);
    const startHidePreview = (0, $eUqFw.useCallback)(()=>{
        if (hidePreviewTimer.current) return;
        hidePreviewTimer.current = window.setTimeout(()=>{
            hidePreviewTimer.current = null;
            setActiveTemplate(undefined);
        }, $72403c939ac01315$var$HIDE_DELAY_MS);
    }, []);
    const showPreview = (0, $eUqFw.useCallback)((tmpl)=>{
        if (tmpl.type !== (0, $dZsZr.TemplateType).Confluence) {
            startHidePreview();
            return;
        }
        cancelHidePreview();
        setActiveTemplate(tmpl);
    }, [
        cancelHidePreview,
        startHidePreview
    ]);
    const onTemplateClick = (template)=>{
        if (accessRequestCapability === (0, $dcSvg.AccessRequestCapabilityType).REQUEST_ACCESS || accessRequestCapability === (0, $dcSvg.AccessRequestCapabilityType).DIRECT_ACCESS || !areTemplatesEnabled) return;
        if (template.type === (0, $dZsZr.TemplateType).Link) {
            window.open(origin ? origin.addToUrl(template.url) : template.url, '_blank');
            return;
        } else {
            // TemplateType here must be of type Confluence, in which case we bring up the template in an embedded page
            if (!template.blueprintModuleCompleteKey) {
                // create blank with or without prepopulated content
                createEmbeddedPage(contentId || undefined, true, undefined, intl && template.title && template.content ? {
                    title: intl.formatMessage(template.title),
                    body: template.content
                } : undefined);
                return;
            }
            const blueprint = blueprints.find((blueprint)=>blueprint.blueprintModuleCompleteKey === template.blueprintModuleCompleteKey);
            if (!blueprint) {
                // site probably has this template turned off, we need to show an error
                showError && showError();
                return;
            }
            createEmbeddedPage(contentId || undefined, true, blueprint);
        }
    };
    const sidebarEnabled = $72403c939ac01315$export$a787a847e7bc1b42(areTemplatesEnabled, accessRequestCapability);
    // on unmount, clear any pending timers to prevent operations on unmounted components
    (0, $eUqFw.useEffect)(()=>()=>{
            if (hidePreviewTimer.current) clearTimeout(hidePreviewTimer.current);
        }, []);
    return {
        props: {
            onTemplateClick: onTemplateClick,
            onMouseLeave: startHidePreview,
            onTemplateMouseEnter: showPreview,
            isDisabled: !sidebarEnabled
        },
        hoverPreviewProps: {
            onMouseEnter: cancelHidePreview,
            onMouseLeave: startHidePreview,
            template: activeTemplate
        }
    };
};

});

parcelRegister("4Efjl", function(module, exports) {

$parcel$export(module.exports, "useTemplatesControlsWithoutLicense", () => $07f1c1eb66414f7c$export$e76165d0765dc8a0);

var $dZsZr = parcelRequire("dZsZr");

var $kgX2t = parcelRequire("kgX2t");
const $07f1c1eb66414f7c$export$e76165d0765dc8a0 = ({})=>{
    const { template: activeTemplate, setActiveTemplatePreview: setActiveTemplatePreview } = (0, $kgX2t.useTemplate)();
    const onTemplateClick = (template)=>{
        if (template.type === (0, $dZsZr.TemplateType).Link) window.open(template.url, '_blank');
        else setActiveTemplatePreview(template);
    };
    return {
        props: {
            activeTemplate: activeTemplate,
            onTemplateClick: onTemplateClick,
            isDisabled: false
        }
    };
};

});


parcelRegister("iWw3g", function(module, exports) {

$parcel$export(module.exports, "TemplatesPanelHoverPreview", () => $2fe55b87b0a4a045$export$699c1c3678c2eea5);

var $eUqFw = parcelRequire("eUqFw");

var $8nlzU = parcelRequire("8nlzU");
var $6frYP = parcelRequire("6frYP");

var $dMAPB = parcelRequire("dMAPB");

var $3Q4O0 = parcelRequire("3Q4O0");

var $4BF2n = parcelRequire("4BF2n");
// If hover preview props are undefined, send noop functions for the mouse events
// so no unexpected errors are thrown
const $2fe55b87b0a4a045$var$noopHoverProps = {
    onMouseEnter: (event)=>{},
    onMouseLeave: (event)=>{}
};
const $2fe55b87b0a4a045$export$699c1c3678c2eea5 = ({ containerRef: containerRef, templates: templates, onTemplateClick: onTemplateClick, onTemplateMouseEnter: onTemplateMouseEnter, onMouseLeave: onMouseLeave, isDisabled: isDisabled, origin: origin, hoverPreviewProps: hoverPreviewProps = $2fe55b87b0a4a045$var$noopHoverProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Q4O0.default), {
            hoverRef: ref,
            onTemplateClick: onTemplateClick,
            onTemplateMouseEnter: onTemplateMouseEnter,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled,
            origin: origin,
            templates: templates,
            title: (0, $4BF2n.default).hasConfluenceLicenseTitle,
            subtitle: (0, $4BF2n.default).hasConfluenceLicenseSubTitle
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dMAPB.default), {
        boundaryRef: containerRef,
        ...hoverPreviewProps
    }));

});
parcelRegister("dMAPB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b38f3fb144849250$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iFmgL = parcelRequire("iFmgL");

var $i6BC8 = parcelRequire("i6BC8");

var $2qhQi = parcelRequire("2qhQi");

var $dZsZr = parcelRequire("dZsZr");

var $5J91X = parcelRequire("5J91X");
const $b38f3fb144849250$var$HoverPreview = ({ template: template, boundaryRef: boundaryRef, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, intl: intl })=>{
    if (!template || template.type !== (0, $dZsZr.TemplateType).Confluence) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), {
        placement: "left",
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        0,
                        32
                    ]
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    padding: 16,
                    boundary: boundaryRef.current || undefined
                }
            }
        ],
        strategy: "absolute"
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5J91X.HoverPreviewContainer), {
            innerRef: ref || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5J91X.TemplateInfo), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5J91X.Icon), null, template.iconRender({
            size: 'small',
            color: template.defaultIconColor
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5J91X.TemplateName), null, intl.formatMessage(template.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5J91X.Preview), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: template.preview.postExpand.default,
            srcDark: template.preview.postExpand.dark,
            width: "100%",
            alt: `${template.name} Confluence Template`
        }))));
};
var $b38f3fb144849250$export$2e2bcd8739ae039 = (0, $2qhQi.default)($b38f3fb144849250$var$HoverPreview);

});
parcelRegister("5J91X", function(module, exports) {

$parcel$export(module.exports, "HoverPreviewContainer", () => $331baaa3d8861d79$export$f8a404b45d23b116);
$parcel$export(module.exports, "TemplateInfo", () => $331baaa3d8861d79$export$d606b414323c8d76);
$parcel$export(module.exports, "TemplateName", () => $331baaa3d8861d79$export$5c554e59c1d4b9ae);
$parcel$export(module.exports, "Icon", () => $331baaa3d8861d79$export$f04a61298a47a40f);
$parcel$export(module.exports, "Preview", () => $331baaa3d8861d79$export$133773870222880f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $lcnyw = parcelRequire("lcnyw");


var $4lTFP = parcelRequire("4lTFP");
// taken from https://stash.atlassian.com/projects/confcloud/repos/confluence-frontend/browse/next/packages/template-preview/src/PreviewFrame.tsx
const $331baaa3d8861d79$var$PREVIEW_MIN_WIDTH = 480;
const $331baaa3d8861d79$var$TEMPLATE_PANEL_WIDTH = 320;
const $331baaa3d8861d79$var$DISTANCE_FROM_ITEM = (0, $lcnyw.gridSize)() * 4;
const $331baaa3d8861d79$export$f8a404b45d23b116 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "suk59g-0"
})({
    display: 'flex',
    flexDirection: 'column',
    zIndex: (0, $lcnyw.layers).tooltip(),
    background: "var(--ds-surface, white)",
    border: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`}`,
    borderRadius: '3px',
    boxShadow: "var(--ds-shadow-overlay, 0px 0px 1px rgba(9, 30, 66, 0.31), 0px 3px 5px rgba(9, 30, 66, 0.2))",
    width: '40vw',
    maxWidth: '600px',
    minWidth: `${$331baaa3d8861d79$var$PREVIEW_MIN_WIDTH}px`,
    height: '85%',
    maxHeight: '790px',
    // do not show preview on very narrow devices
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media screen and (max-width: ${$331baaa3d8861d79$var$TEMPLATE_PANEL_WIDTH + $331baaa3d8861d79$var$DISTANCE_FROM_ITEM + $331baaa3d8861d79$var$PREVIEW_MIN_WIDTH}px)`]: {
        display: 'none'
    }
});
const $331baaa3d8861d79$export$d606b414323c8d76 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "suk59g-1"
})({
    height: '53px',
    padding: `14px ${"var(--ds-space-300, 24px)"}`,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`}`
});
const $331baaa3d8861d79$export$5c554e59c1d4b9ae = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "suk59g-2"
})`${(0, $4lTFP.h500)()} margin:0 0 0 ${"var(--ds-space-100, 8px)"};overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`;
const $331baaa3d8861d79$export$f04a61298a47a40f = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "suk59g-3"
})({
    alignSelf: 'center'
});
const $331baaa3d8861d79$export$133773870222880f = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "suk59g-4"
})({
    overflowY: 'scroll'
});

});


parcelRegister("3Q4O0", function(module, exports) {

$parcel$export(module.exports, "default", () => $46dd97b1f9ec6087$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $f1LVB = parcelRequire("f1LVB");

var $cQTL5 = parcelRequire("cQTL5");

var $6ji7W = parcelRequire("6ji7W");
const $46dd97b1f9ec6087$var$TemplatesSidebar = ({ intl: intl, templates: templates, onTemplateClick: onTemplateClick, onTemplateMouseEnter: onTemplateMouseEnter, onMouseLeave: onMouseLeave, hoverRef: hoverRef, isDisabled: isDisabled, activeTemplate: activeTemplate, origin: origin, title: title, subtitle: subtitle })=>{
    const theme = (0, $6ji7W.useThemeContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQTL5.SidebarWrapper), {
        "data-test-id": "confluence-project-pages.template-sidebar",
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQTL5.HeaderContainer), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: isDisabled ? 'is-disabled' : '',
        "data-testid": "confluence-project-pages.template-sidebar-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQTL5.Title), null, intl.formatMessage(title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQTL5.Subtitle), null, intl.formatMessage(subtitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f1LVB.default), {
        templates: templates,
        activeTemplate: activeTemplate,
        onTemplateClick: onTemplateClick,
        onTemplateMouseEnter: onTemplateMouseEnter,
        onMouseLeave: onMouseLeave,
        hoverRef: hoverRef,
        isDisabled: isDisabled,
        origin: origin
    }));
};
var $46dd97b1f9ec6087$export$2e2bcd8739ae039 = (0, $2qhQi.default)($46dd97b1f9ec6087$var$TemplatesSidebar);

});
parcelRegister("f1LVB", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e29599ede03935$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $dZsZr = parcelRequire("dZsZr");

var $dyzc1 = parcelRequire("dyzc1");

var $gWxA1 = parcelRequire("gWxA1");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61e29599ede03935$var$Wrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1n2t7hx-0"
})({
    marginTop: "var(--ds-space-200, 16px)"
});
const $61e29599ede03935$var$TemplateList = ({ onTemplateClick: onTemplateClick, onTemplateMouseEnter: onTemplateMouseEnter, onMouseLeave: onMouseLeave, hoverRef: hoverRef, templates: templates, activeTemplate: activeTemplate, isDisabled: isDisabled, origin: origin })=>{
    const [hoveredTemplate, setHoveredTemplate] = (0, $eUqFw.useState)(null);
    const handleClick = (template)=>(_, analyticsEvent)=>{
            const originAttributes = origin?.toAnalyticsAttributes({
                hasGeneratedId: true
            });
            if (analyticsEvent) (0, $gWxA1.fireUIAnalytics)(analyticsEvent, `${template.key}TemplateButton`, originAttributes ?? {});
            onTemplateClick && onTemplateClick(template);
        };
    const handleMouseEnter = (template)=>()=>{
            onTemplateMouseEnter && onTemplateMouseEnter(template);
            setHoveredTemplate(template);
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($61e29599ede03935$var$Wrapper, {
        onMouseLeave: onMouseLeave
    }, templates.map((tmpl)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: tmpl.key,
            ref: hoveredTemplate && hoveredTemplate.type === (0, $dZsZr.TemplateType).Confluence && hoveredTemplate.key === tmpl.key ? hoverRef : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dyzc1.default), {
            name: tmpl.name,
            description: tmpl.description,
            icon: tmpl.iconRender({
                size: 'medium',
                color: tmpl.defaultIconColor
            }),
            onClick: handleClick(tmpl),
            onMouseEnter: handleMouseEnter(tmpl),
            tooltip: tmpl.tooltip,
            isDisabled: isDisabled,
            isActive: tmpl.key === activeTemplate?.key,
            renderShortcutIcon: tmpl.type === (0, $dZsZr.TemplateType).Link && tmpl.renderShortcutIcon
        }))));
};
var $61e29599ede03935$export$2e2bcd8739ae039 = $61e29599ede03935$var$TemplateList;

});
parcelRegister("dyzc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d995664f322f688c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6R0C9 = parcelRequire("6R0C9");

var $2qhQi = parcelRequire("2qhQi");

var $3YUW6 = parcelRequire("3YUW6");

var $2eG9N = parcelRequire("2eG9N");

var $hGcnP = parcelRequire("hGcnP");

var $5aAqT = parcelRequire("5aAqT");
const $d995664f322f688c$var$TemplateCard = ({ name: name, description: description, icon: icon, intl: intl, onClick: onClick, onMouseEnter: onMouseEnter, tooltip: tooltip, isDisabled: isDisabled, isActive: isActive, renderShortcutIcon: renderShortcutIcon })=>{
    const primaryText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YUW6.PrimaryTextWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YUW6.Title), null, intl.formatMessage(name)), renderShortcutIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hGcnP))), {
        color: "currentColor",
        LEGACY_size: "small",
        label: "open in tab"
    }));
    const card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YUW6.CardWrapper), {
        onMouseEnter: isDisabled ? undefined : onMouseEnter,
        isActive: isActive,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: isDisabled ? 'is-disabled' : '',
        hasTooltip: !!tooltip,
        "data-testid": "confluence-project-pages.template-sidebar-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6R0C9.default), {
        avatar: icon,
        primaryText: primaryText,
        secondaryText: description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YUW6.Description), null, intl.formatMessage(description)) : undefined,
        onClick: onClick,
        testId: "confluence-project-pages.templates-sidebar.template-card"
    }));
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: intl.formatMessage(tooltip)
    }, card);
    else return card;
};
var $d995664f322f688c$export$2e2bcd8739ae039 = (0, $5aAqT.AnalyticsEventToProps)('templateButton', {
    onClick: 'clicked'
})((0, $2qhQi.default)($d995664f322f688c$var$TemplateCard));

});
parcelRegister("6R0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d303d2caa12f1c14$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $1Yimi = parcelRequire("1Yimi");


var $lcnyw = parcelRequire("lcnyw");

var $eri7S = parcelRequire("eri7S");

var $6ecEX = parcelRequire("6ecEX");
function $d303d2caa12f1c14$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d303d2caa12f1c14$var$avatarItemStyles = {
    name: "1dq1lfl",
    styles: "min-width:0;max-width:100%;flex:1 1 100%;line-height:1.4;padding-inline-start:var(--ds-space-100, 8px)"
};
const $d303d2caa12f1c14$var$secondaryTextOldStyles = {
    name: "1udad45",
    styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.85em"
};
const $d303d2caa12f1c14$var$baseTextStyles = {
    name: "1sodx6b",
    styles: "display:block;color:var(--ds-text, #172B4D)"
};
const $d303d2caa12f1c14$var$truncationStyles = {
    name: "n3ut7m",
    styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $d303d2caa12f1c14$var$getStyles = (css, { backgroundColor: backgroundColor, isInteractive: isInteractive, isDisabled: isDisabled })=>// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @repo/internal/react/no-css-string-literals
    css`
		align-items: center;
		background-color: ${backgroundColor};
		border-radius: ${(0, $lcnyw.borderRadius)()}px;
		border: ${0, $eri7S.BORDER_WIDTH}px solid transparent;
		box-sizing: border-box;
		color: inherit;
		display: flex;
		font-size: inherit;
		font-style: normal;
		font-weight: normal;
		line-height: 1;
		outline: none;
		margin: ${"var(--ds-space-0, 0px)"};
		padding: ${"var(--ds-space-050, 4px)"};
		text-align: left;
		text-decoration: none;
		width: 100%;

		${isInteractive && `
        :hover {
          background-color: ${`var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`};
          cursor: pointer;
          text-decoration: none;
        }

        :focus {
          outline: none;
          border-color: ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`};
        }

        :active {
          background-color: ${`var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`};
        }
      `}

		${isDisabled && `
        cursor: not-allowed;
        opacity: ${"var(--ds-opacity-disabled, 0.5)"};
        pointer-events: none;
      `}
	`;
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ const $d303d2caa12f1c14$var$AvatarItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', children: children, isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
    const getTestId = (testId, children)=>!children ? {
            'data-testid': `${testId}--itemInner`
        } : {
            testId: `${testId}--itemInner`
        };
    const componentProps = ()=>{
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return {
            ...href && (0, $6ecEX.getLinkProps)(href, target),
            ...onClick && !href ? (0, $6ecEX.getButtonProps)(onClick) : {
                onClick: onClick
            }
        };
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>{
        const props = {
            ref: ref,
            className: $d303d2caa12f1c14$var$getStyles(css, {
                backgroundColor: backgroundColor,
                isInteractive: Boolean(onClick || href),
                isDisabled: isDisabled
            }),
            ...componentProps(),
            ...testId && getTestId(testId, children),
            ...(onClick || href) && {
                'aria-label': label
            },
            children: /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, avatar, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $d303d2caa12f1c14$var$avatarItemStyles
            }, (0, $XHGTv.getBooleanFF)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
                maxLines: isTruncationDisabled ? undefined : 1
            }, primaryText), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
                color: "color.text.subtlest",
                maxLines: isTruncationDisabled ? undefined : 1,
                size: "UNSAFE_small"
            }, secondaryText)) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: [
                    $d303d2caa12f1c14$var$baseTextStyles,
                    !isTruncationDisabled && $d303d2caa12f1c14$var$truncationStyles
                ]
            }, primaryText), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: [
                    $d303d2caa12f1c14$var$baseTextStyles,
                    $d303d2caa12f1c14$var$secondaryTextOldStyles,
                    !isTruncationDisabled && $d303d2caa12f1c14$var$truncationStyles
                ]
            }, secondaryText))))
        };
        return children ? children(props) : /*#__PURE__*/ (0, $eUqFw.createElement)((0, $6ecEX.getCustomElement)(isDisabled, href, onClick), props);
    });
});
$d303d2caa12f1c14$var$AvatarItem.displayName = 'AvatarItem';
var $d303d2caa12f1c14$export$2e2bcd8739ae039 = $d303d2caa12f1c14$var$AvatarItem;

});

parcelRegister("3YUW6", function(module, exports) {

$parcel$export(module.exports, "Title", () => $17b11544e3b3af2b$export$f99233281efd08a0);
$parcel$export(module.exports, "PrimaryTextWrapper", () => $17b11544e3b3af2b$export$3174221b6a744abb);
$parcel$export(module.exports, "Description", () => $17b11544e3b3af2b$export$393edc798c47379d);
$parcel$export(module.exports, "CardWrapper", () => $17b11544e3b3af2b$export$6aa22a823032b784);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

const $17b11544e3b3af2b$export$f99233281efd08a0 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-11b8yaf-0"
})({
    marginTop: "var(--ds-space-negative-050, -4px)",
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
});
const $17b11544e3b3af2b$export$3174221b6a744abb = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-11b8yaf-1"
})({
    display: 'flex',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)"
});
const $17b11544e3b3af2b$export$393edc798c47379d = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-11b8yaf-2"
})({
    marginTop: "var(--ds-space-050, 4px)",
    display: '-webkit-box',
    WebkitLineClamp: 4,
    WebkitBoxOrient: 'vertical',
    whiteSpace: 'normal'
});
const $17b11544e3b3af2b$export$6aa22a823032b784 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-11b8yaf-3"
})((props)=>({
        position: 'relative',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            padding: "var(--ds-space-150, 12px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: props.isActive ? `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})` : 'initial',
            '&:focus': {
                boxShadow: 'none' /* legacy batch.css in JFE ends up adding additional box shadow around this, which we don't want */ 
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.is-disabled': {
            opacity: "var(--ds-opacity-disabled, 0.5)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            cursor: props.hasTooltip ? 'pointer' : 'auto',
            pointerEvents: 'none'
        }
    }));

});



parcelRegister("cQTL5", function(module, exports) {

$parcel$export(module.exports, "SidebarWrapper", () => $ac7e250004cd04bf$export$d9b764b921677bb1);
$parcel$export(module.exports, "Title", () => $ac7e250004cd04bf$export$f99233281efd08a0);
$parcel$export(module.exports, "Subtitle", () => $ac7e250004cd04bf$export$cf345ef34cd72655);
$parcel$export(module.exports, "HeaderContainer", () => $ac7e250004cd04bf$export$1e86fd0e1db89578);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $4lTFP = parcelRequire("4lTFP");
const $ac7e250004cd04bf$export$d9b764b921677bb1 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1tnkdm-0"
})({
    minWidth: '320px',
    width: '320px',
    position: 'relative',
    overflowY: 'auto',
    zIndex: 10
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ theme: theme })=>theme?.overrideStyles?.sidebarWrapper ? `background-color: ${theme.overrideStyles.sidebarWrapper.backgroundColor};
  border: ${theme.overrideStyles.sidebarWrapper.border};
  border-radius: ${theme.overrideStyles.sidebarWrapper.borderRadius};
  box-shadow: ${theme.overrideStyles.sidebarWrapper.boxShadow};
  height: ${theme.overrideStyles.sidebarWrapper.height};
  margin: ${theme.overrideStyles.sidebarWrapper.margin};
  padding: ${theme.overrideStyles.sidebarWrapper.padding};` : `height: 100%;
  padding: 0 0 0 ${"var(--ds-space-200, 16px)"};
  ${''}
  border-left: 1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N30})`};
  background-color: ${"var(--ds-surface, #fff)"};`);
const $ac7e250004cd04bf$export$f99233281efd08a0 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1tnkdm-1"
})`${(0, $4lTFP).h500} margin-left:${"var(--ds-space-200, 16px)"};`;
const $ac7e250004cd04bf$export$cf345ef34cd72655 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1tnkdm-2"
})`${(0, $4lTFP).h100} margin-top:${"var(--ds-space-050, 4px)"};margin-left:${"var(--ds-space-200, 16px)"};color:${`var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N60})`};text-transform:uppercase;`;
const $ac7e250004cd04bf$export$1e86fd0e1db89578 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1tnkdm-3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.is-disabled': {
        opacity: "var(--ds-opacity-disabled, 0.5)"
    }
});

});


parcelRegister("4BF2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a015f239daf1971$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7a015f239daf1971$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    hasConfluenceLicenseTitle: {
        id: 'project-pages.improvement.templates.post-expand.title',
        defaultMessage: 'Create a page',
        description: 'Title for list of page templates'
    },
    hasConfluenceLicenseSubTitle: {
        id: 'project-pages.improvement.templates.post-expand.subtitle',
        defaultMessage: 'Popular templates',
        description: 'Information for list of page templates'
    }
});

});


parcelRegister("gap96", function(module, exports) {

$parcel$export(module.exports, "default", () => $16dbcdab51015c91$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $16dbcdab51015c91$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noConfluenceLicenseTitle: {
        id: 'project-pages.improvement.templates.pre-expand.title',
        defaultMessage: 'Preview templates',
        description: 'Title for list of page templates'
    },
    noConfluenceLicenseSubTitle: {
        id: 'project-pages.improvement.templates.pre-expand.subtitle',
        defaultMessage: 'Popular with teams like yours',
        description: 'Information for list of page templates'
    }
});

});




parcelRegister("ampft", function(module, exports) {

$parcel$export(module.exports, "default", () => $a344f1bdf62301ab$export$2e2bcd8739ae039);

var $cllCv = parcelRequire("cllCv");

var $6waye = parcelRequire("6waye");

var $3pvFP = parcelRequire("3pvFP");

var $4Vya4 = parcelRequire("4Vya4");

var $hXy49 = parcelRequire("hXy49");

var $1UwLx = parcelRequire("1UwLx");
const $a344f1bdf62301ab$var$mapStateToProps = (state)=>({
        activationMethod: (0, $hXy49.getActivationMethod)(state)
    });
const $a344f1bdf62301ab$var$mapDispatchToProps = (dispatch)=>({
        onOpenCrossFlowError: ()=>dispatch((0, $3pvFP.showXflowDialogError)()),
        onSuccessfulCrossFlowExpansion: ()=>{
            dispatch((0, $3pvFP.checkProductsLicenceState)());
            dispatch((0, $6waye.fetchPersonalizationSiteTraits)());
        },
        triggerOnDemandActivation: ()=>{
            dispatch((0, $1UwLx.startConfluenceActivation)());
        }
    });
var $a344f1bdf62301ab$export$2e2bcd8739ae039 = (0, $cllCv.connect)($a344f1bdf62301ab$var$mapStateToProps, $a344f1bdf62301ab$var$mapDispatchToProps)((0, $4Vya4.default));

});
parcelRegister("6waye", function(module, exports) {

$parcel$export(module.exports, "FETCH_PERSONALIZATION_SITE_TRAITS", () => $ac9800745bda183c$export$19dc55439c44d6e5);
$parcel$export(module.exports, "fetchPersonalizationSiteTraits", () => $ac9800745bda183c$export$f3f6bb53f650126e);
$parcel$export(module.exports, "fetchPersonalizationSiteTraitsFailed", () => $ac9800745bda183c$export$789016de78154b40);
$parcel$export(module.exports, "UPDATE_PERSONALIZATION_SITE_TRAITS", () => $ac9800745bda183c$export$b031700ffe873b04);
$parcel$export(module.exports, "updatePersonalizationSiteTraits", () => $ac9800745bda183c$export$ba79c9388a936022);
const $ac9800745bda183c$export$19dc55439c44d6e5 = 'FETCH_PERSONALIZATION_SITE_TRAITS';
const $ac9800745bda183c$export$f3f6bb53f650126e = ()=>({
        type: $ac9800745bda183c$export$19dc55439c44d6e5
    });
const $ac9800745bda183c$export$6aae235fee267e07 = 'FETCH_PERSONALIZATION_SITE_TRAITS_FAILED';
const $ac9800745bda183c$export$789016de78154b40 = ()=>({
        type: $ac9800745bda183c$export$6aae235fee267e07
    });
const $ac9800745bda183c$export$b031700ffe873b04 = 'UPDATE_PERSONALIZATION_SITE_TRAITS';
const $ac9800745bda183c$export$ba79c9388a936022 = (traits)=>({
        type: $ac9800745bda183c$export$b031700ffe873b04,
        traits: traits
    });

});


parcelRegister("ehFRZ", function(module, exports) {

$parcel$export(module.exports, "CompactHeader", () => $951c8a2bd5b87692$export$1b93308da7cb4060);
/**
 * Alternative header component that doesn't render breadcrumbs or a heading
 * It also renders the DraftsToggle next to the MoreMenu
 */ 
var $eUqFw = parcelRequire("eUqFw");
parcelRequire("hPmJU");
var $kQ8I0 = parcelRequire("kQ8I0");
var $6K8He = parcelRequire("6K8He");
var $a9Brc = parcelRequire("a9Brc");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $kqxVx = parcelRequire("kqxVx");

var $k93Dd = parcelRequire("k93Dd");

var $jmJqM = parcelRequire("jmJqM");
const $951c8a2bd5b87692$export$1b93308da7cb4060 = ({ shouldShowMeatballMenu: shouldShowMeatballMenu, MoreMenu: MoreMenu })=>{
    const { activeRoute: activeRoute } = (0, $k93Dd.useRouter)();
    const { locale: locale } = (0, $kqxVx.useProjectPages)();
    const { treeState: treeState } = (0, $a9Brc.useConfluencePageTree)();
    const isTreeLoaded = treeState && treeState !== (0, $6K8He.TreeStates).Loading;
    // only show the drafts toggle if the PageTree would be loaded (see ActivePage component)
    const shouldShowDraftsToggle = isTreeLoaded && (!activeRoute || ![
        (0, $jmJqM.Routes).TemplatePreview,
        (0, $jmJqM.Routes).ConfluenceActivating,
        (0, $jmJqM.Routes).ConfluenceActivatingOnDemand,
        (0, $jmJqM.Routes).ConnectSpace,
        (0, $jmJqM.Routes).ServerError,
        (0, $jmJqM.Routes).ServerErrorAccess,
        (0, $jmJqM.Routes).SpaceOrPageNotFound
    ].includes(activeRoute));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignInline: "end",
        space: "space.100",
        xcss: $951c8a2bd5b87692$var$compactHeaderStyles
    }, shouldShowMeatballMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MoreMenu, null), shouldShowDraftsToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ8I0.default), {
        locale: locale
    }));
};
const $951c8a2bd5b87692$var$compactHeaderStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.200'
});

});



parcelRegister("gneuB", function(module, exports) {

$parcel$export(module.exports, "initialProjectState", () => $70feaada3d7b5c51$export$e98b04a545b093d7);
$parcel$export(module.exports, "default", () => $70feaada3d7b5c51$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $fFPgi = parcelRequire("fFPgi");
const $70feaada3d7b5c51$export$e98b04a545b093d7 = {
    key: '',
    id: -1,
    type: '',
    name: ''
};
var $70feaada3d7b5c51$export$2e2bcd8739ae039 = (state = $70feaada3d7b5c51$export$e98b04a545b093d7, action)=>{
    switch(action.type){
        case 0, $fFPgi.SET:
            return (0, $6JFcL.freeze)(action.payload);
        case 0, $fFPgi.SET_IS_MEMBER:
            return (0, $6JFcL.merge)(state, {
                isMember: action.isMember
            });
        default:
            return state;
    }
};

});
parcelRegister("fFPgi", function(module, exports) {

$parcel$export(module.exports, "SET", () => $77f0afd7ade7d2f5$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $77f0afd7ade7d2f5$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "SET_IS_MEMBER", () => $77f0afd7ade7d2f5$export$681057d0004eb9a8);
$parcel$export(module.exports, "setIsMember", () => $77f0afd7ade7d2f5$export$94760d89229d957);
const $77f0afd7ade7d2f5$export$5e8f180ef0142226 = 'project.SET';
const $77f0afd7ade7d2f5$export$adaa4cf7ef1b65be = (payload)=>({
        type: $77f0afd7ade7d2f5$export$5e8f180ef0142226,
        payload: payload
    });
const $77f0afd7ade7d2f5$export$681057d0004eb9a8 = 'project.SET_IS_MEMBER';
const $77f0afd7ade7d2f5$export$94760d89229d957 = (isMember)=>({
        type: $77f0afd7ade7d2f5$export$681057d0004eb9a8,
        isMember: isMember
    });

});


parcelRegister("3eKVQ", function(module, exports) {

$parcel$export(module.exports, "initialContextState", () => $a64f910a7a639bdf$export$ce2ca3f2bd913448);
$parcel$export(module.exports, "default", () => $a64f910a7a639bdf$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");


var $3pvFP = parcelRequire("3pvFP");

var $8ueGw = parcelRequire("8ueGw");

var $kHo9c = parcelRequire("kHo9c");

var $5ZGUz = parcelRequire("5ZGUz");
const $a64f910a7a639bdf$export$ce2ca3f2bd913448 = (0, $6JFcL.freeze)({
    baseUrl: '',
    isAdmin: false,
    locale: (0, $32df593be34bd00e$export$d7f512c98c859244),
    cloudId: '',
    accountId: '',
    confluenceState: (0, $kHo9c.CONFLUENCE_LOADING),
    suggestedKey: null,
    origin: null,
    environment: 'dev',
    licenseInformation: undefined
});
var $a64f910a7a639bdf$export$2e2bcd8739ae039 = (state = $a64f910a7a639bdf$export$ce2ca3f2bd913448, action)=>{
    switch(action.type){
        case 0, $8ueGw.SET:
            return (0, $6JFcL.freeze)(action.payload);
        case 0, $3pvFP.NO_VALID_KEY:
            return (0, $6JFcL.merge)(state, {
                suggestedKey: null
            });
        case 0, $3pvFP.NO_VALID_KEY_FAILURE:
            return (0, $6JFcL.merge)(state, {
                suggestedKey: null
            });
        case 0, $3pvFP.UPDATE_CONFLUENCE_STATE:
            return (0, $6JFcL.merge)(state, {
                confluenceState: action.payload
            });
        case 0, $5ZGUz.UPDATE_LICENSE_INFORMATION:
            return (0, $6JFcL.merge)(state, {
                licenseInformation: action.payload
            });
        case 0, $3pvFP.UPDATE_CONFLUENCE_EDITION:
            return (0, $6JFcL.merge)(state, {
                confluenceEdition: action.payload
            });
        case 0, $3pvFP.UPDATE_JSW_EDITION:
            return (0, $6JFcL.merge)(state, {
                jswEdition: action.payload
            });
        case 0, $3pvFP.UPDATE_SUGGESTED_KEY:
            return (0, $6JFcL.merge)(state, {
                suggestedKey: action.key
            });
        default:
            return state;
    }
};

});
parcelRegister("8ueGw", function(module, exports) {

$parcel$export(module.exports, "SET", () => $c775deaef01b07dc$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $c775deaef01b07dc$export$adaa4cf7ef1b65be);
const $c775deaef01b07dc$export$5e8f180ef0142226 = 'context.SET';
const $c775deaef01b07dc$export$adaa4cf7ef1b65be = (payload)=>({
        type: $c775deaef01b07dc$export$5e8f180ef0142226,
        payload: payload
    });

});

parcelRegister("5ZGUz", function(module, exports) {

$parcel$export(module.exports, "UPDATE_LICENSE_INFORMATION", () => $bce049b1fd9c2bbe$export$482eb5280a7b12af);
$parcel$export(module.exports, "updateProductLicenses", () => $bce049b1fd9c2bbe$export$a6afaeb75db595fa);
const $bce049b1fd9c2bbe$export$482eb5280a7b12af = 'UPDATE_LICENSE_INFORMATION';
const $bce049b1fd9c2bbe$export$a6afaeb75db595fa = (payload)=>({
        type: $bce049b1fd9c2bbe$export$482eb5280a7b12af,
        payload: payload
    });

});


parcelRegister("kCoCX", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $f9c2650abc7f7015$export$f51a9068ac82ea43);

var $huRi7 = parcelRequire("huRi7");

var $bd1K7 = parcelRequire("bd1K7");

var $aGKYb = parcelRequire("aGKYb");

var $1fNno = parcelRequire("1fNno");

var $97aDF = parcelRequire("97aDF");
const $f9c2650abc7f7015$export$f51a9068ac82ea43 = (initialState, middlewares = [])=>{
    // @ts-ignore - Expected 4 type arguments, but got 1
    // This was added when enrolling `@atlassiansox/project-pages` into JFE local consumption
    const store = (0, $huRi7.createStore)((0, $97aDF.default), initialState, // @ts-ignore - Expected 1-2 arguments, but got 3
    // This was added when enrolling `@atlassiansox/project-pages` into JFE local consumption
    (0, $aGKYb.composeWithDevtools)({
        name: 'Project Pages'
    })((0, $huRi7.applyMiddleware)(...middlewares, (0, $bd1K7.createEpicMiddleware)((0, $1fNno.default)))));
    return store;
};

});
parcelRegister("aGKYb", function(module, exports) {

$parcel$export(module.exports, "composeWithDevtools", () => $6eb1321528f87266$export$635593bd946c7364);

var $huRi7 = parcelRequire("huRi7");
const $6eb1321528f87266$export$635593bd946c7364 = (devtoolsConfig = {})=>{
    const devtoolsEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    return devtoolsEnhancer ? devtoolsEnhancer(devtoolsConfig) : (0, $huRi7.compose);
};

});

parcelRegister("1fNno", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b846d6adddc4c47$export$2e2bcd8739ae039);

var $b18Mx = parcelRequire("b18Mx");

var $fs9fI = parcelRequire("fs9fI");

var $6drzS = parcelRequire("6drzS");

var $kbspg = parcelRequire("kbspg");

var $472m1 = parcelRequire("472m1");

var $fodVY = parcelRequire("fodVY");

var $bo3PF = parcelRequire("bo3PF");

var $bUazD = parcelRequire("bUazD");

var $shkrL = parcelRequire("shkrL");

var $hy4n7 = parcelRequire("hy4n7");

var $lsj44 = parcelRequire("lsj44");

var $bwi9f = parcelRequire("bwi9f");

var $lsx6O = parcelRequire("lsx6O");

var $jeUC5 = parcelRequire("jeUC5");

var $hwVGC = parcelRequire("hwVGC");

var $do7Gi = parcelRequire("do7Gi");

var $2OlyA = parcelRequire("2OlyA");

var $e4Evd = parcelRequire("e4Evd");

var $9EqMh = parcelRequire("9EqMh");

var $cJg3N = parcelRequire("cJg3N");

var $8qph5 = parcelRequire("8qph5");

var $ixnRZ = parcelRequire("ixnRZ");

var $8b7mq = parcelRequire("8b7mq");

var $2cqbF = parcelRequire("2cqbF");

var $4v5DF = parcelRequire("4v5DF");

var $40C8I = parcelRequire("40C8I");

var $1OvIw = parcelRequire("1OvIw");

var $3ZA6a = parcelRequire("3ZA6a");

var $3jSSX = parcelRequire("3jSSX");

var $Y75pB = parcelRequire("Y75pB");

var $8M2or = parcelRequire("8M2or");

var $gBwUP = parcelRequire("gBwUP");

var $88kIt = parcelRequire("88kIt");

var $6JXig = parcelRequire("6JXig");
const $2b846d6adddc4c47$var$onError = (error, epicName)=>{
    // Bubble the error all the way to the top.
    setTimeout(()=>{
        throw error;
    }, 0);
    // Fire an analytics event to signal the error in the epic.
    (0, $b18Mx.sendTrackAnalyticsEvent)({
        source: 'epic',
        action: 'error',
        actionSubject: epicName,
        attributes: {
            reason: String(error) || 'Unknown error'
        }
    });
};
const $2b846d6adddc4c47$export$aaa76db017874a43 = ()=>({
        changeSpaceName: $6drzS.default,
        checkProductsLicence: $kbspg.default,
        checkConfluenceUserPermissions: $472m1.default,
        connectConfluenceSpace: $fodVY.default,
        createConfluenceSpace: $bo3PF.default,
        fetchConnectedSpaceBlueprints: $bUazD.default,
        generateSpaceKey: $hy4n7.default,
        noValidKeyEpic: $lsj44.default,
        projectSpaceLink: $bwi9f.default,
        retrieveConfluenceSpaces: $lsx6O.default,
        setFirstSpaceCreatedFlag: $jeUC5.default,
        showXflowDialog: $hwVGC.default,
        updateProjectSpaceLink: $do7Gi.default,
        confluenceAccessRequestCapabilities: $2OlyA.default,
        confluenceCollaborators: $e4Evd.default,
        fetchConnectedSpaceOrPageTitle: $9EqMh.default,
        fetchConnectedSpace: $cJg3N.default,
        jiraProjectPermissions: $8qph5.default,
        confluenceInlineJoin: $ixnRZ.default,
        checkConfluenceAccessWithRetry: $shkrL.default,
        fetchPersonalizationSiteTraits: $8b7mq.default,
        checkConfluenceSpacesForAutoProvisionedUsers: $2cqbF.default,
        initializeView: $4v5DF.default,
        autoCreateSpace: $1OvIw.default,
        autoCreateSpaceKey: $40C8I.default,
        activateConfluencePlan: $3ZA6a.default,
        activateConfluenceStart: $3jSSX.default,
        activateConfluenceStatusCheck: $Y75pB.default,
        activateConfluenceStatusCheckSuccess: $8M2or.default,
        activateConfluenceStatusCheckFailed: $gBwUP.default,
        activateConfluenceCompleted: $88kIt.default,
        activateConfluenceFailed: $6JXig.default
    });
var $2b846d6adddc4c47$export$2e2bcd8739ae039 = (0, $fs9fI.default)($2b846d6adddc4c47$export$aaa76db017874a43(), $2b846d6adddc4c47$var$onError);

});
parcelRegister("fs9fI", function(module, exports) {

$parcel$export(module.exports, "default", () => $495827214031049c$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");
const $495827214031049c$var$defaultOnErrorHandler = (error)=>{
    throw error;
};
/**
 * Wrap the specified epic so that any errors invoke an error handler and return the original
 * source stream.
 *
 * By default, the onError handler will bubble errors to the top, so they can be displayed
 * in the console, or captured by error reporting.
 *
 * Note: The onError handler is deferred, to ensure that it can no longer cause further errors
 * in the epic.
 *
 * @param onError - an optional handler which will be called if an epic encounters an error
 */ const $495827214031049c$var$wrapEpic = (epic, epicName, onError = $495827214031049c$var$defaultOnErrorHandler)=>(...args)=>epic(...args).catch((error, source)=>{
            setTimeout(()=>onError(error, epicName), 0);
            return source;
        });
var /**
 * Combine and wrap all epics, so that errors do not kill the entire action stream.
 *
 * @param epicObject - values are epics and keys are their identifiers
 * @param onError - an optional handler which will be called if any epic encounters an error
 */ $495827214031049c$export$2e2bcd8739ae039 = (epicObject, onError)=>(0, $bd1K7.combineEpics)(...Object.entries(epicObject).map(([name, epic])=>$495827214031049c$var$wrapEpic(epic, name, onError)));

});

parcelRegister("6drzS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca49681204563161$export$2e2bcd8739ae039);
parcelRequire("iects");

var $jpkPA = parcelRequire("jpkPA");

var $3pvFP = parcelRequire("3pvFP");
const $ca49681204563161$var$isWhitespace = (str)=>/^\s+$/.test(str);
const $ca49681204563161$var$containsAlphanumeric = (str)=>/[a-zA-Z0-9]/g.test(str);
var $ca49681204563161$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $3pvFP.CHANGE_SPACE_NAME)).mergeMap(({ name: name })=>(0, $jpkPA.from)([
            (0, $3pvFP.updateSuggestedKey)(null),
            (0, $3pvFP.updateSpaceName)(name),
            (0, $3pvFP.toggleSpaceNameInvalid)($ca49681204563161$var$isWhitespace(name)),
            ...$ca49681204563161$var$containsAlphanumeric(name) ? [
                (0, $3pvFP.generateSpaceKey)(name)
            ] : [
                (0, $3pvFP.noValidKey)()
            ]
        ]));

});

parcelRegister("kbspg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e7e03cab8125a69$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $jpkPA = parcelRequire("jpkPA");

var $cwK3t = parcelRequire("cwK3t");

var $iUfoI = parcelRequire("iUfoI");

var $3pvFP = parcelRequire("3pvFP");

var $hMy8N = parcelRequire("hMy8N");

var $kHo9c = parcelRequire("kHo9c");

var $jGyKS = parcelRequire("jGyKS");

var $2fabp = parcelRequire("2fabp");

var $5ZGUz = parcelRequire("5ZGUz");
const $2e7e03cab8125a69$var$confluenceStateMap = {
    LOADING: (0, $kHo9c.CONFLUENCE_LOADING),
    INACTIVE: (0, $kHo9c.CONFLUENCE_INACTIVE),
    DEACTIVATED: (0, $kHo9c.CONFLUENCE_DEACTIVATED),
    ACTIVE: (0, $kHo9c.CONFLUENCE_ACTIVE),
    ACTIVATING: (0, $kHo9c.CONFLUENCE_ACTIVATING),
    EXPIRED: (0, $kHo9c.CONFLUENCE_EXPIRED),
    ERROR: (0, $kHo9c.CONFLUENCE_ERROR)
};
var $2e7e03cab8125a69$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3pvFP.CHECK_PRODUCTS_LICENCE_STATE)).switchMap(()=>{
        const state = store.getState();
        const projectId = (0, $jGyKS.getProjectId)(state);
        const cloudId = (0, $hMy8N.getCloudId)(state);
        if (!projectId) {
            (0, $iUfoI.fetchFailed)('confluence.license', new Error('missing projectId in project-pages state'));
            return (0, $cwK3t.of)((0, $3pvFP.updateConfluenceState)((0, $kHo9c.CONFLUENCE_ERROR)));
        }
        if (!cloudId) {
            (0, $iUfoI.fetchFailed)('confluence.license', new Error('missing cloudId in project-pages state'));
            return (0, $cwK3t.of)((0, $3pvFP.updateConfluenceState)((0, $kHo9c.CONFLUENCE_ERROR)));
        }
        return (0, $2fabp.requestProductLicenceState$)(cloudId).mergeMap((values)=>{
            (0, $iUfoI.fetchSuccess)('confluence.license');
            const confluence = values.products?.[(0, $kHo9c.ProductKeys).CONFLUENCE];
            let confluenceState = confluence ? $2e7e03cab8125a69$var$confluenceStateMap[confluence.state] : (0, $kHo9c.CONFLUENCE_INACTIVE);
            if (confluence && confluence.isSuspended) confluenceState = (0, $kHo9c.CONFLUENCE_DEACTIVATED);
            const jswEdition = values.products?.[(0, $kHo9c.ProductKeys).JIRA_SOFTWARE]?.edition;
            return (0, $jpkPA.from)([
                (0, $5ZGUz.updateProductLicenses)(values),
                (0, $3pvFP.updateConfluenceState)(confluenceState),
                (0, $3pvFP.updateConfluenceEdition)(confluence?.edition),
                (0, $3pvFP.updateJswEdition)(jswEdition),
                ...confluenceState === (0, $kHo9c.CONFLUENCE_ACTIVE) ? [
                    (0, $3pvFP.checkConfluenceUserPermissions)(),
                    (0, $3pvFP.fetchJiraProjectPermissions)(),
                    (0, $3pvFP.getProjectSpaceLink)(projectId)
                ] : []
            ]);
        }).catch((err)=>{
            (0, $iUfoI.fetchFailed)('confluence.license', err);
            return (0, $cwK3t.of)((0, $3pvFP.updateConfluenceState)((0, $kHo9c.CONFLUENCE_ERROR)));
        });
    });

});
parcelRegister("iUfoI", function(module, exports) {

$parcel$export(module.exports, "fetchFailed", () => $0300a8f42762ca65$export$b6fac9536a9cb64e);
$parcel$export(module.exports, "fetchSuccess", () => $0300a8f42762ca65$export$56c204dda9cb636c);

var $b18Mx = parcelRequire("b18Mx");
const $0300a8f42762ca65$export$b6fac9536a9cb64e = (source, err, data)=>{
    (0, $b18Mx.sendOperationalAnalyticsEvent)({
        source: source,
        action: 'failed',
        actionSubject: 'fetch',
        attributes: {
            errorMessage: err.message || 'Unknown error',
            ...data
        }
    });
};
const $0300a8f42762ca65$export$56c204dda9cb636c = (source, data = {})=>{
    const { spaceKey: spaceKey, projectKey: projectKey, autoCreated: autoCreated } = data;
    (0, $b18Mx.sendOperationalAnalyticsEvent)({
        source: source,
        action: 'success',
        actionSubject: 'fetch',
        attributes: {
            spaceKey: spaceKey,
            projectKey: projectKey,
            autoCreated: autoCreated
        }
    });
};

});


parcelRegister("472m1", function(module, exports) {

$parcel$export(module.exports, "default", () => $30f4c8d9b0e33da9$export$2e2bcd8739ae039);
/* eslint-disable no-console */ 
var $cwK3t = parcelRequire("cwK3t");

var $bKhOq = parcelRequire("bKhOq");

var $illlw = parcelRequire("illlw");

var $iUfoI = parcelRequire("iUfoI");

var $3pvFP = parcelRequire("3pvFP");


var $2fabp = parcelRequire("2fabp");

var $jGyKS = parcelRequire("jGyKS");
var $30f4c8d9b0e33da9$export$2e2bcd8739ae039 = (action$, store)=>{
    return action$.ofType((0, $3pvFP.CHECK_CONFLUENCE_USER_PERMISSIONS)).switchMap(()=>{
        return (0, $2fabp.fetchConfluenceCurrentUser)((0, $jGyKS.getProjectId)(store.getState()), (0, $jGyKS.getProjectType)(store.getState())).mergeMap((value)=>{
            (0, $iUfoI.fetchSuccess)('confluence.user');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(value, 'operations.length')) return (0, $cwK3t.of)((0, $3pvFP.updateConfluenceUserAccess)((0, $dfecdf57a1227fce$export$c6813a8d51f77eaf)));
            return (0, $cwK3t.of)((0, $3pvFP.updateConfluenceUserAccess)((0, $dfecdf57a1227fce$export$a3269a3914b007e3)));
        }).catch((err)=>{
            if (err.statusCode === 403) return (0, $cwK3t.of)((0, $3pvFP.updateConfluenceUserAccess)((0, $dfecdf57a1227fce$export$a3269a3914b007e3)));
            (0, $iUfoI.fetchFailed)('confluence.user', err);
            return (0, $bKhOq.empty)();
        });
    });
};

});

parcelRegister("fodVY", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7aa42d40dacde5$export$2e2bcd8739ae039);
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $iUfoI = parcelRequire("iUfoI");

var $3pvFP = parcelRequire("3pvFP");

var $jGyKS = parcelRequire("jGyKS");

var $dJJDt = parcelRequire("dJJDt");

var $4aXoz = parcelRequire("4aXoz");
var $da7aa42d40dacde5$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3pvFP.CONNECT_CONFLUENCE_SPACE)).map(()=>{
        const state = store.getState();
        const projectKey = (0, $jGyKS.getProjectKey)(state);
        const projectId = (0, $jGyKS.getProjectId)(state);
        const connectedPageId = (0, $4aXoz.getProjectPageLinkedId)(state);
        const connectedSpaceId = (0, $4aXoz.getProjectSpaceId)(state);
        const selectedSpace = (0, $dJJDt.getSelectedSpace)(state);
        if (!projectKey) {
            (0, $iUfoI.fetchFailed)('connect.confluence.space', new Error('missing projectKey'));
            return (0, $3pvFP.putProjectSpaceLinkError)();
        }
        if (!projectId) {
            (0, $iUfoI.fetchFailed)('connect.confluence.space', new Error('missing projectId'));
            return (0, $3pvFP.putProjectSpaceLinkError)();
        }
        if (!selectedSpace || !selectedSpace.spaceKey) {
            (0, $iUfoI.fetchFailed)('connect.confluence.space', new Error('missing selected space spaceKey'));
            return (0, $3pvFP.putProjectSpaceLinkError)();
        }
        if (!selectedSpace || !selectedSpace.spaceId) {
            (0, $iUfoI.fetchFailed)('connect.confluence.space', new Error('missing selected space spaceId'));
            return (0, $3pvFP.putProjectSpaceLinkError)();
        }
        const { spaceKey: spaceKey, spaceUrl: spaceUrl, spaceId: spaceId } = selectedSpace;
        (0, $iUfoI.fetchSuccess)('connect.confluence.space');
        return (0, $3pvFP.putProjectSpaceLink)({
            projectKey: projectKey,
            projectId: projectId,
            spaceKey: spaceKey,
            spaceUrl: spaceUrl,
            spaceId: spaceId,
            connectedSpaceId: connectedSpaceId,
            connectedPageId: connectedPageId
        });
    });

});

parcelRegister("bo3PF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a39460d54d752dd2$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $jpkPA = parcelRequire("jpkPA");

var $iUfoI = parcelRequire("iUfoI");

var $3pvFP = parcelRequire("3pvFP");

var $gilIH = parcelRequire("gilIH");

var $490NN = parcelRequire("490NN");

var $hMy8N = parcelRequire("hMy8N");

var $jGyKS = parcelRequire("jGyKS");

var $d5OES = parcelRequire("d5OES");

var $4aXoz = parcelRequire("4aXoz");

var $2fabp = parcelRequire("2fabp");
var $a39460d54d752dd2$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $gilIH.CREATE_CONFLUENCE_SPACE)).switchMap(({ autoCreated: autoCreated = false })=>{
        const state = store.getState();
        const availableSpaces = (0, $490NN.getAvailableSpaces)(state);
        const userEnteredSpaceName = (0, $d5OES.getUserEnteredSpaceName)(state);
        const connectedPageId = (0, $4aXoz.getProjectPageLinkedId)(state);
        const connectedSpaceId = (0, $4aXoz.getProjectSpaceId)(state);
        const confluenceSpaceKey = (0, $hMy8N.getSuggestedKey)(state);
        const projectName = (0, $jGyKS.getProjectName)(state);
        const projectKey = (0, $jGyKS.getProjectKey)(state);
        const projectId = (0, $jGyKS.getProjectId)(state);
        const projectType = (0, $jGyKS.getProjectType)(state);
        const confluenceSpaceName = autoCreated ? projectName : userEnteredSpaceName;
        if (confluenceSpaceKey === null || confluenceSpaceKey === undefined || confluenceSpaceKey === '') return (0, $cwK3t.of)((0, $gilIH.createConfluenceSpaceError)());
        return (0, $2fabp.requestCreateConfluenceSpace$)(confluenceSpaceName, confluenceSpaceKey, projectKey, projectId, projectType).switchMap(({ spaceKey: spaceKey, spaceUrl: spaceUrl, spaceId: spaceId })=>{
            (0, $iUfoI.fetchSuccess)('confluence.space.create', {
                autoCreated: autoCreated
            });
            return (0, $jpkPA.from)([
                (0, $3pvFP.putProjectSpaceLink)({
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    spaceUrl: spaceUrl,
                    projectKey: projectKey,
                    projectId: projectId,
                    autoCreated: autoCreated,
                    connectedPageId: connectedPageId,
                    connectedSpaceId: connectedSpaceId
                }),
                ...availableSpaces.length === 0 ? [
                    (0, $3pvFP.setFirstSpaceCreatedFlag)()
                ] : []
            ]);
        }).catch((err)=>{
            (0, $iUfoI.fetchFailed)('confluence.space.create', err, {
                autoCreated: autoCreated
            });
            return (0, $cwK3t.of)((0, $gilIH.createConfluenceSpaceError)());
        });
    });

});

parcelRegister("bUazD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4f15f622c701ab7$export$2e2bcd8739ae039);
parcelRequire("flmol");
parcelRequire("3wBUP");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $iUfoI = parcelRequire("iUfoI");

var $3pvFP = parcelRequire("3pvFP");

var $4aXoz = parcelRequire("4aXoz");

var $2fabp = parcelRequire("2fabp");

var $jGyKS = parcelRequire("jGyKS");
var $c4f15f622c701ab7$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3pvFP.FETCH_CONNECTED_SPACE_BLUEPRINTS)).switchMap(()=>{
        const state = store.getState();
        const projectSpaceKey = (0, $4aXoz.getProjectSpaceKey)(state);
        if (!projectSpaceKey) {
            (0, $iUfoI.fetchFailed)('connected.space.blueprints', new Error('missing projectSpaceKey in project-pages state'));
            return (0, $cwK3t.of)((0, $3pvFP.fetchConnectedSpaceBlueprintsError)());
        }
        return (0, $2fabp.fetchConnectedSpaceBlueprints$)(projectSpaceKey, (0, $jGyKS.getProjectId)(store.getState()), (0, $jGyKS.getProjectType)(store.getState())).map((value)=>{
            (0, $iUfoI.fetchSuccess)('connected.space.blueprints');
            return (0, $3pvFP.updateConnectedSpaceBlueprints)(value.map(({ name: name, itemModuleCompleteKey: itemModuleCompleteKey, blueprintModuleCompleteKey: blueprintModuleCompleteKey, contentBlueprintId: contentBlueprintId, skipHowToUse: skipHowToUse })=>({
                    name: name,
                    itemModuleCompleteKey: itemModuleCompleteKey,
                    blueprintModuleCompleteKey: blueprintModuleCompleteKey,
                    contentBlueprintId: contentBlueprintId,
                    skipHowToUse: skipHowToUse
                })));
        }).catch((err)=>{
            (0, $iUfoI.fetchFailed)('connected.space.blueprints', err);
            return (0, $cwK3t.of)((0, $3pvFP.fetchConnectedSpaceBlueprintsError)());
        });
    });

});

parcelRegister("shkrL", function(module, exports) {

$parcel$export(module.exports, "default", () => $881756b713ba9cf5$export$2e2bcd8739ae039);
parcelRequire("3wBUP");

var $cwK3t = parcelRequire("cwK3t");

var $iUfoI = parcelRequire("iUfoI");

var $3pvFP = parcelRequire("3pvFP");

var $6waye = parcelRequire("6waye");

var $2fabp = parcelRequire("2fabp");

var $b1qLQ = parcelRequire("b1qLQ");

var $df9H8 = parcelRequire("df9H8");

var $7O6Ck = parcelRequire("7O6Ck");

var $29RSJ = parcelRequire("29RSJ");

var $kW6gr = parcelRequire("kW6gr");


var $illlw = parcelRequire("illlw");

var $jpkPA = parcelRequire("jpkPA");

var $9naRE = parcelRequire("9naRE");
var $881756b713ba9cf5$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $3pvFP.CHECK_CONFLUENCE_ACCESS_WITH_RETRY)).switchMap(()=>{
        // In staging this takes roughly 10 seconds to resolve, 15 adds some overhead to 10 retries without making it too long
        // for users.
        const maxTries = 15;
        let retries = maxTries - 1;
        return (0, $2fabp.fetchConfluenceCurrentUser)().pipe((0, $b1qLQ.mergeMap)((value)=>{
            (0, $iUfoI.fetchSuccess)('confluence.user.retry');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(value, 'operations.length')) return (0, $jpkPA.from)([
                (0, $3pvFP.updateConfluenceUserAccess)((0, $dfecdf57a1227fce$export$78244dbb77cfa6b6)),
                (0, $3pvFP.resetConnectedSpace)(),
                /* 
							The most important observables to trigger when we got access to Confluence are:
								- checkProductsLicenceState
								- fetchPersonalizationSiteTraits
							without them the screen is going to be stuck in connectedSpace.connectionState === "LOADING"
						*/ (0, $3pvFP.checkProductsLicenceState)(),
                (0, $6waye.fetchPersonalizationSiteTraits)(),
                (0, $3pvFP.fetchConfluenceAccessRequestCapabilities)()
            ]);
            throw new Error((0, $9naRE.NO_ACCESS_ERROR_MESSAGE));
        }), (0, $7O6Ck.retryWhen)((errors)=>{
            return errors.pipe((0, $29RSJ.takeWhile)((error)=>{
                if (error.statusCode !== 403) throw error;
                if (retries <= 0) throw new Error((0, $9naRE.NO_ACCESS_ERROR_MESSAGE) + ` after ${maxTries} tries`);
                retries -= 1;
                return true;
            }), (0, $kW6gr.delay)(1000));
        }), (0, $df9H8.catchError)((err)=>{
            if (err.message !== (0, $9naRE.NO_ACCESS_ERROR_MESSAGE) + ` after ${maxTries} tries`) (0, $iUfoI.fetchFailed)('confluence.user.retry', err);
            return (0, $cwK3t.of)((0, $3pvFP.inlineJoinConfluenceFailed)());
        }));
    });

});
parcelRegister("9naRE", function(module, exports) {

$parcel$export(module.exports, "NO_ACCESS_ERROR_MESSAGE", () => $2c12bd2e749da673$export$cdfa7869a106ec85);
$parcel$export(module.exports, "inlineJoin$", () => $2c12bd2e749da673$export$b44ff9074cf5d07f);

var $aynDk = parcelRequire("aynDk");

var $7y517 = parcelRequire("7y517");

var $dcSvg = parcelRequire("dcSvg");
const $2c12bd2e749da673$var$INLINE_JOIN_URL = '/gateway/api/invitations/v1/access-requests/request';
const $2c12bd2e749da673$export$cdfa7869a106ec85 = 'No confluence access';
const $2c12bd2e749da673$export$b44ff9074cf5d07f = (product, cloudId)=>(0, $7y517.default)($2c12bd2e749da673$var$INLINE_JOIN_URL, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            resource: `ari:cloud:${product}::site/${cloudId}`
        })
    }).pipe((0, $aynDk.map)((response)=>{
        const results = response.results;
        const result = results[`ari:cloud:${product}::site/${cloudId}`];
        if (result === (0, $dcSvg.AccessRequestCapabilityType).ACCESS_GRANTED || result === (0, $dcSvg.AccessRequestCapabilityType).ACCESS_EXISTS || result === (0, $dcSvg.AccessRequestCapabilityType).PENDING_REQUEST_CREATED) return {
            status: true,
            result: result
        };
        throw new Error($2c12bd2e749da673$export$cdfa7869a106ec85);
    }));

});


parcelRegister("hy4n7", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b609b0b4c7e6da$export$2e2bcd8739ae039);
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("5dKXv");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $6JvmY = parcelRequire("6JvmY");

var $MdoH4 = parcelRequire("MdoH4");

var $id6QM = parcelRequire("id6QM");

var $b18Mx = parcelRequire("b18Mx");

var $3pvFP = parcelRequire("3pvFP");

var $2fabp = parcelRequire("2fabp");

var $jGyKS = parcelRequire("jGyKS");
const $72b609b0b4c7e6da$var$generateKey = (name)=>{
    // Create a list of suggestions
    let keySuggestions = [];
    // Restrict length of the final key
    const minKeyLength = 1;
    const maxKeyLength = 10;
    // These words will not be used in key generation for acronyms.
    const IGNORED_WORDS = [
        'THE',
        'A',
        'AN',
        'AS',
        'AND',
        'OF',
        'OR'
    ];
    const getTotalLength = (words)=>words.join('').length;
    const removeIgnoredWords = (words)=>words.filter((word)=>!IGNORED_WORDS.includes(word));
    const createAcronym = (words)=>words.map((word)=>word.charAt(0)).join('');
    const getFirstSyllable = (word)=>{
        // Best guess at getting the first syllable
        // Returns the substring up to and including the first consonant to appear after a vowel
        const vowelIndex = word.search(/[AEIOUYaeiouy]/);
        return vowelIndex ? word.substr(0, vowelIndex + 1) : word;
    };
    const trimmedName = (0, (/*@__PURE__*/$parcel$interopDefault($id6QM))).clean(name.trim());
    if (!trimmedName) return [];
    // Split into words
    let nameAsArray = trimmedName.replace(/[^a-zA-Z0-9' ']/g, '').toUpperCase().split(' ');
    // Remove ignored words
    nameAsArray = nameAsArray > getTotalLength(nameAsArray) ? removeIgnoredWords(nameAsArray) : nameAsArray;
    if (nameAsArray.length === 0) // No words were worthy!
    keySuggestions = [];
    else {
        // Get the first syllable
        const word = nameAsArray[0];
        if (getFirstSyllable(word)) keySuggestions.push(getFirstSyllable(word));
        // The first word as a key
        keySuggestions.push(word);
        // The first letter from each
        keySuggestions.push(createAcronym(nameAsArray));
    }
    // Limit the length of the key suggestions
    const results = keySuggestions.map((keyOption)=>keyOption.length > maxKeyLength ? keyOption.substr(0, maxKeyLength).toUpperCase() : keyOption.toUpperCase()).filter((keyOption)=>keyOption.length >= minKeyLength).sort();
    return (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(results);
};
const $72b609b0b4c7e6da$var$failureAnalytics = ()=>{
    (0, $b18Mx.sendTrackAnalyticsEvent)({
        source: 'space.key',
        action: 'error',
        actionSubject: 'generate'
    });
};
const $72b609b0b4c7e6da$var$successAnalytics = ()=>{
    (0, $b18Mx.sendTrackAnalyticsEvent)({
        source: 'space.key',
        action: 'success',
        actionSubject: 'generate'
    });
};
const $72b609b0b4c7e6da$var$noValidKeyAnalytics = ()=>{
    (0, $b18Mx.sendTrackAnalyticsEvent)({
        source: 'space.key',
        action: 'no.valid',
        actionSubject: 'generate'
    });
};
const $72b609b0b4c7e6da$export$d8394ba24e88fd87 = 1000;
var $72b609b0b4c7e6da$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3pvFP.GENERATE_SPACE_KEY)).debounceTime($72b609b0b4c7e6da$export$d8394ba24e88fd87).mergeMap(({ name: name })=>(0, $6JvmY.forkJoin)(...$72b609b0b4c7e6da$var$generateKey(name).map((key)=>(0, $2fabp.checkConfluenceSpaceAvailability$)(key, (0, $jGyKS.getProjectId)(store.getState()), (0, $jGyKS.getProjectType)(store.getState())).catch((err)=>(0, $cwK3t.of)(err)))).map((payloads)=>{
            const someSucceeded = payloads.some((payload)=>!(payload instanceof Error));
            if (someSucceeded) {
                const availablePayload = payloads.find((payload)=>payload.available);
                if (availablePayload) {
                    $72b609b0b4c7e6da$var$successAnalytics();
                    return (0, $3pvFP.updateSuggestedKey)(availablePayload.key);
                }
                $72b609b0b4c7e6da$var$noValidKeyAnalytics();
                return (0, $3pvFP.noValidKey)();
            }
            $72b609b0b4c7e6da$var$failureAnalytics();
            return (0, $3pvFP.noValidKeyFailure)();
        }).catch(()=>{
            $72b609b0b4c7e6da$var$failureAnalytics();
            return (0, $cwK3t.of)((0, $3pvFP.noValidKeyFailure)());
        }));

});
parcelRegister("id6QM", function(module, exports) {
// Diacritics.js
// 
// Started as something to be an equivalent of the Google Java Library diacritics library for JavaScript.
// Found this: http://jsperf.com/diacritics/6 and converted it into a reusable module.
// 
// @author Nijiko Yonskai
// @license MIT
// @copyright Nijikokun 2013 <nijikokun@gmail.com>
(function(name, definition) {
    if (0, module.exports) module.exports = definition();
    else if (typeof define == 'function' && define.amd) define(definition);
    else this[name] = definition();
})('Diacritics', function() {
    // Create public object
    var output = {
        map: {}
    };
    // Create private reference map.
    var reference = [
        {
            'base': ' ',
            'letters': '\u00A0'
        },
        {
            'base': 'A',
            'letters': '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            'base': 'AA',
            'letters': '\uA732'
        },
        {
            'base': 'AE',
            'letters': '\u00C6\u01FC\u01E2'
        },
        {
            'base': 'AO',
            'letters': '\uA734'
        },
        {
            'base': 'AU',
            'letters': '\uA736'
        },
        {
            'base': 'AV',
            'letters': '\uA738\uA73A'
        },
        {
            'base': 'AY',
            'letters': '\uA73C'
        },
        {
            'base': 'B',
            'letters': '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            'base': 'C',
            'letters': '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            'base': 'D',
            'letters': '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            'base': 'DZ',
            'letters': '\u01F1\u01C4'
        },
        {
            'base': 'Dz',
            'letters': '\u01F2\u01C5'
        },
        {
            'base': 'E',
            'letters': '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            'base': 'F',
            'letters': '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            'base': 'G',
            'letters': '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            'base': 'H',
            'letters': '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            'base': 'I',
            'letters': '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            'base': 'J',
            'letters': '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            'base': 'K',
            'letters': '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            'base': 'L',
            'letters': '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            'base': 'LJ',
            'letters': '\u01C7'
        },
        {
            'base': 'Lj',
            'letters': '\u01C8'
        },
        {
            'base': 'M',
            'letters': '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            'base': 'N',
            'letters': '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            'base': 'NJ',
            'letters': '\u01CA'
        },
        {
            'base': 'Nj',
            'letters': '\u01CB'
        },
        {
            'base': 'O',
            'letters': '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            'base': 'OI',
            'letters': '\u01A2'
        },
        {
            'base': 'OO',
            'letters': '\uA74E'
        },
        {
            'base': 'OU',
            'letters': '\u0222'
        },
        {
            'base': 'P',
            'letters': '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            'base': 'Q',
            'letters': '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            'base': 'R',
            'letters': '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            'base': 'S',
            'letters': '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            'base': 'T',
            'letters': '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            'base': 'Th',
            'letters': '\u00DE'
        },
        {
            'base': 'TZ',
            'letters': '\uA728'
        },
        {
            'base': 'U',
            'letters': '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            'base': 'V',
            'letters': '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            'base': 'VY',
            'letters': '\uA760'
        },
        {
            'base': 'W',
            'letters': '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            'base': 'X',
            'letters': '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            'base': 'Y',
            'letters': '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            'base': 'Z',
            'letters': '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            'base': 'a',
            'letters': '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251'
        },
        {
            'base': 'aa',
            'letters': '\uA733'
        },
        {
            'base': 'ae',
            'letters': '\u00E6\u01FD\u01E3'
        },
        {
            'base': 'ao',
            'letters': '\uA735'
        },
        {
            'base': 'au',
            'letters': '\uA737'
        },
        {
            'base': 'av',
            'letters': '\uA739\uA73B'
        },
        {
            'base': 'ay',
            'letters': '\uA73D'
        },
        {
            'base': 'b',
            'letters': '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            'base': 'c',
            'letters': '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            'base': 'd',
            'letters': '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            'base': 'dz',
            'letters': '\u01F3\u01C6'
        },
        {
            'base': 'e',
            'letters': '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            'base': 'f',
            'letters': '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            'base': 'ff',
            'letters': '\uFB00'
        },
        {
            'base': 'fi',
            'letters': '\uFB01'
        },
        {
            'base': 'fl',
            'letters': '\uFB02'
        },
        {
            'base': 'ffi',
            'letters': '\uFB03'
        },
        {
            'base': 'ffl',
            'letters': '\uFB04'
        },
        {
            'base': 'g',
            'letters': '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            'base': 'h',
            'letters': '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            'base': 'hv',
            'letters': '\u0195'
        },
        {
            'base': 'i',
            'letters': '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            'base': 'j',
            'letters': '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            'base': 'k',
            'letters': '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            'base': 'l',
            'letters': '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            'base': 'lj',
            'letters': '\u01C9'
        },
        {
            'base': 'm',
            'letters': '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            'base': 'n',
            'letters': '\x6E\xF1\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509'
        },
        {
            'base': 'nj',
            'letters': '\u01CC'
        },
        {
            'base': 'o',
            'letters': '\u07C0\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            'base': 'oe',
            'letters': '\u0152\u0153'
        },
        {
            'base': 'oi',
            'letters': '\u01A3'
        },
        {
            'base': 'ou',
            'letters': '\u0223'
        },
        {
            'base': 'oo',
            'letters': '\uA74F'
        },
        {
            'base': 'p',
            'letters': '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            'base': 'q',
            'letters': '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            'base': 'r',
            'letters': '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            'base': 's',
            'letters': '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            'base': 'ss',
            'letters': '\xDF'
        },
        {
            'base': 't',
            'letters': '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            'base': 'th',
            'letters': '\u00FE'
        },
        {
            'base': 'tz',
            'letters': '\uA729'
        },
        {
            'base': 'u',
            'letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            'base': 'v',
            'letters': '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            'base': 'vy',
            'letters': '\uA761'
        },
        {
            'base': 'w',
            'letters': '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            'base': 'x',
            'letters': '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            'base': 'y',
            'letters': '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            'base': 'z',
            'letters': '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    // Generate reference mapping
    for(var i = 0, refLength = reference.length; i < refLength; i++){
        var letters = reference[i].letters.split("");
        for(var j = 0, letLength = letters.length; j < letLength; j++)output.map[letters[j]] = reference[i].base;
    }
    /**
   * Clean accents (diacritics) from string.
   * 
   * @param  {String} input String to be cleaned of diacritics.
   * @return {String}
   */ output.clean = function(input) {
        if (!input || !input.length || input.length < 1) return "";
        var string = "";
        var letters = input.split("");
        var index = 0;
        var length = letters.length;
        var letter;
        for(; index < length; index++){
            letter = letters[index];
            string += letter in output.map ? output.map[letter] : letter;
        }
        return string;
    };
    return output;
});

});


parcelRegister("lsj44", function(module, exports) {

$parcel$export(module.exports, "default", () => $55afc61152645161$export$2e2bcd8739ae039);
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("dpYY5");
parcelRequire("flmol");

var $cwK3t = parcelRequire("cwK3t");

var $3pvFP = parcelRequire("3pvFP");

var $2fabp = parcelRequire("2fabp");

var $b18Mx = parcelRequire("b18Mx");

var $jGyKS = parcelRequire("jGyKS");
const $55afc61152645161$export$95395d1f872e0bb5 = ()=>Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5).toUpperCase();
const $55afc61152645161$var$failureAnalytics = ({ message: message })=>{
    (0, $b18Mx.sendTrackAnalyticsEvent)({
        source: 'space.key',
        action: 'error',
        actionSubject: 'randomly.generate',
        attributes: {
            errorMessage: message
        }
    });
};
const $55afc61152645161$var$successAnalytics = ()=>{
    (0, $b18Mx.sendTrackAnalyticsEvent)({
        source: 'space.key',
        action: 'success',
        actionSubject: 'randomly.generate'
    });
};
const $55afc61152645161$var$RETRY_ATTEMPTS = 3;
var $55afc61152645161$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3pvFP.NO_VALID_KEY)).mergeMap(()=>(0, $cwK3t.of)(null).mergeMap(()=>{
            const generatedKey = $55afc61152645161$export$95395d1f872e0bb5();
            return (0, $2fabp.checkConfluenceSpaceAvailability$)(generatedKey, (0, $jGyKS.getProjectId)(store.getState()), (0, $jGyKS.getProjectType)(store.getState())).map(({ available: available, key: key })=>{
                if (available) {
                    $55afc61152645161$var$successAnalytics();
                    return (0, $3pvFP.updateSuggestedKey)(key);
                }
                throw new Error('Random key not available');
            });
        }).retry($55afc61152645161$var$RETRY_ATTEMPTS).catch((error)=>{
            $55afc61152645161$var$failureAnalytics(error);
            return (0, $cwK3t.of)((0, $3pvFP.noValidKeyFailure)());
        }));

});

parcelRegister("bwi9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $457149d26b63e0f1$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("jnCPY");
parcelRequire("8OtG5");

var $cwK3t = parcelRequire("cwK3t");

var $bd1K7 = parcelRequire("bd1K7");

var $h5OsT = parcelRequire("h5OsT");

var $b18Mx = parcelRequire("b18Mx");


var $iUfoI = parcelRequire("iUfoI");

var $3pvFP = parcelRequire("3pvFP");

var $dJJDt = parcelRequire("dJJDt");

var $d5OES = parcelRequire("d5OES");

var $2fabp = parcelRequire("2fabp");

var $hMy8N = parcelRequire("hMy8N");


var $baKYD = parcelRequire("baKYD");

var $3C6Im = parcelRequire("3C6Im");

var $6waye = parcelRequire("6waye");
const $457149d26b63e0f1$var$missingCloudId = ()=>{
    (0, $b18Mx.sendTrackAnalyticsEvent)({
        source: 'space.create',
        action: 'missing',
        actionSubject: 'cloudId',
        attributes: {
            errorMessage: 'Missing cloudId in tenant context'
        }
    });
};
const $457149d26b63e0f1$var$updateProjectSpaceAnalytics = ()=>{
    (0, $b18Mx.sendTrackAnalyticsEvent)({
        source: 'project.space',
        action: 'update',
        actionSubject: 'link'
    });
};
/**
 * Finds the root page of the space intended to be linked to the project and
 * sends a PUT request to xflow to store the project + space link
 * @param action$
 */ const $457149d26b63e0f1$var$putProjectSpaceLink = (action$, store)=>action$.ofType((0, $3pvFP.PUT_PROJECT_SPACE_LINK)).switchMap((action)=>{
        const state = store.getState();
        const { spaceKey: spaceKey, spaceUrl: spaceUrl, projectKey: projectKey, projectId: projectId, autoCreated: autoCreated = false, spaceId: spaceId, connectedSpaceId: connectedSpaceId, connectedPageId: connectedPageId } = action;
        const selectedSpace = (0, $dJJDt.getSelectedSpace)(state);
        const userEnteredSpaceName = (0, $d5OES.getUserEnteredSpaceName)(state);
        const connectedSpaceOrPageTitle = selectedSpace?.linkedPageTitle || selectedSpace?.spaceName || userEnteredSpaceName;
        const connectedSpaceOrPageUrl = selectedSpace?.linkedPageUrl || selectedSpace?.spaceUrl || spaceUrl;
        const isConnectedToPage = Boolean(selectedSpace?.linkedPageTitle);
        const cloudId = (0, $hMy8N.getCloudId)(state);
        if (!cloudId) {
            $457149d26b63e0f1$var$missingCloudId();
            return (0, $3pvFP.putProjectSpaceLinkError)();
        }
        const dispatchOnSuccessActions = ()=>{
            const updateLinkAction = isConnectedToPage ? (0, $3pvFP.updateConnectedSpaceOrPageContent)({
                title: connectedSpaceOrPageTitle,
                url: connectedSpaceOrPageUrl,
                projectSpacePageTitleHasBeenFetched: true,
                isConnectedToPage: isConnectedToPage,
                iconUrl: null,
                pageId: null
            }) : (0, $3pvFP.fetchConnectedSpace)(spaceKey);
            return (0, $h5OsT.concat)((0, $cwK3t.of)((0, $3pvFP.successfullyConnectedSpace)(connectedSpaceOrPageTitle, isConnectedToPage)), (0, $cwK3t.of)((0, $3pvFP.updateProjectSpaceLink)(spaceKey, selectedSpace?.linkedPageId ? selectedSpace.linkedPageId : null)), (0, $cwK3t.of)(updateLinkAction), (0, $cwK3t.of)((0, $3pvFP.updateConfluenceSpaceConnectionState)(spaceKey ? (0, $d01310c7d13ad40a$export$1a9cf3a686991f62) : (0, $d01310c7d13ad40a$export$4c83162cd5864fb8))));
        };
        // First create the new project -> space/page association
        return (0, $2fabp.createProjectSpaceLink$)({
            linkedPageId: selectedSpace?.linkedPageId ? selectedSpace?.linkedPageId : null,
            cloudId: cloudId,
            projectId: projectId,
            spaceId: spaceId
        }).switchMap(()=>{
            (0, $iUfoI.fetchSuccess)('put.project.space', {
                spaceKey: spaceKey,
                projectKey: projectKey,
                autoCreated: autoCreated
            });
            // If new project -> space/page association succeeds, delete the old project -> space/page association
            return (0, $2fabp.deleteProjectSpaceLink$)({
                linkedPageId: connectedPageId ?? null,
                cloudId: cloudId,
                projectId: projectId,
                spaceId: connectedSpaceId
            }).switchMap(()=>{
                (0, $iUfoI.fetchSuccess)('delete.project.space', {
                    spaceKey: spaceKey,
                    projectKey: projectKey
                });
                return dispatchOnSuccessActions();
            }).catch((err)=>{
                (0, $iUfoI.fetchFailed)('delete.project.space', err);
                /**
						 * If this catch block is hit it means the previous association was unable to be deleted, but the new association was still created.
						 * Therefore we dispatch success actions here to ensure the UI is updated to show the newly associated space/page.
						 * This is an edge case and should be quite rare, it is tied to the reliability of AGG / AGS.
						 */ return dispatchOnSuccessActions();
            });
        }).catch((err)=>{
            (0, $iUfoI.fetchFailed)('put.project.space', err, {
                autoCreated: autoCreated
            });
            return (0, $h5OsT.concat)((0, $cwK3t.of)((0, $3pvFP.putProjectSpaceLinkError)()), (0, $cwK3t.of)((0, $3pvFP.updateConfluenceSpaceConnectionState)((0, $d01310c7d13ad40a$export$103bedf43ba882db))));
        });
    });
/**
 * Sends a GET request to xflow to retrieve the project + space link
 * Note: returned space may have been deleted already. Another issue should handle this.
 * @param action$
 */ const $457149d26b63e0f1$var$getProjectSpaceLink = (action$, store)=>(0, $3C6Im.combineLatest)(action$.ofType((0, $6waye.UPDATE_PERSONALIZATION_SITE_TRAITS)), action$.ofType((0, $3pvFP.UPDATE_CONFLUENCE_SPACES)), action$.ofType((0, $3pvFP.GET_PROJECT_SPACE_LINK))).take(1).switchMap(([traits, spaces, action])=>{
        const state = store.getState();
        const { projectId: projectId } = action;
        const cloudId = (0, $hMy8N.getCloudId)(state);
        if (!cloudId) throw new Error('Error fetching project space link: missing cloudId in tenant context');
        return (0, $2fabp.fetchProjectSpaceLink$)(cloudId, projectId).switchMap(({ spaceKey: spaceKey, linkedPageId: linkedPageId })=>{
            (0, $iUfoI.fetchSuccess)('fetch.project.space');
            $457149d26b63e0f1$var$updateProjectSpaceAnalytics();
            return (0, $h5OsT.concat)([
                (0, $3pvFP.updateProjectSpaceLink)(spaceKey || null, linkedPageId || null),
                (0, $3pvFP.updateConfluenceSpaceConnectionState)(spaceKey ? (0, $d01310c7d13ad40a$export$1a9cf3a686991f62) : (0, $d01310c7d13ad40a$export$4c83162cd5864fb8))
            ]);
        }).catch((err)=>{
            if (err.statusCode === (0, $d66f1468f922cebe$export$8bca792d963eb0ef)) {
                // no project space stored previously. Treat as success and clear confluence space link
                (0, $iUfoI.fetchSuccess)('updated.previously.empty.project.space');
                const isAutoProvisionFlow = (0, $baKYD.shouldCreateSpaceForAutoProvisionedConfluence)(state);
                return (0, $h5OsT.concat)([
                    (0, $3pvFP.updateProjectSpaceLink)(null, null),
                    ...!isAutoProvisionFlow ? [
                        (0, $3pvFP.updateConfluenceSpaceConnectionState)((0, $d01310c7d13ad40a$export$4c83162cd5864fb8))
                    ] : []
                ]);
            }
            (0, $iUfoI.fetchFailed)('fetch.project.space', err);
            return (0, $cwK3t.of)((0, $3pvFP.getProjectSpaceLinkError)());
        });
    });
var $457149d26b63e0f1$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($457149d26b63e0f1$var$putProjectSpaceLink, $457149d26b63e0f1$var$getProjectSpaceLink);

});

parcelRegister("lsx6O", function(module, exports) {

$parcel$export(module.exports, "default", () => $da9a7206a5efd53b$export$2e2bcd8739ae039);
parcelRequire("flmol");
parcelRequire("3wBUP");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $iUfoI = parcelRequire("iUfoI");

var $3pvFP = parcelRequire("3pvFP");

var $2fabp = parcelRequire("2fabp");

var $jGyKS = parcelRequire("jGyKS");
const $da9a7206a5efd53b$var$decodeHtml = (html)=>{
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};
var $da9a7206a5efd53b$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3pvFP.FETCH_CONFLUENCE_SPACES)).switchMap(()=>(0, $2fabp.requestConfluenceSpaces$)((0, $jGyKS.getProjectId)(store.getState()), (0, $jGyKS.getProjectType)(store.getState())).map((value)=>{
            (0, $iUfoI.fetchSuccess)('confluence.spaces');
            return (0, $3pvFP.updateConfluenceSpaces)(value.map((space)=>({
                    spaceKey: space.id,
                    spaceName: $da9a7206a5efd53b$var$decodeHtml(space.text)
                })));
        }).catch((err)=>{
            (0, $iUfoI.fetchFailed)('confluence.spaces', err);
            return (0, $cwK3t.of)((0, $3pvFP.fetchConfluenceSpacesError)());
        }));

});

parcelRegister("jeUC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a604dca61081bd5$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("1Lcr1");

var $bKhOq = parcelRequire("bKhOq");

var $iUfoI = parcelRequire("iUfoI");

var $3pvFP = parcelRequire("3pvFP");

var $2fabp = parcelRequire("2fabp");

var $jGyKS = parcelRequire("jGyKS");
var $3a604dca61081bd5$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3pvFP.SET_FIRST_SPACE_CREATED_FLAG)).switchMap(()=>(0, $2fabp.putFirstSpaceCreatedFlag$)((0, $jGyKS.getProjectId)(store.getState()), (0, $jGyKS.getProjectType)(store.getState())).switchMap(()=>{
            (0, $iUfoI.fetchSuccess)('confluence.first.space.created.flag');
            return (0, $bKhOq.empty)();
        }).catch((err)=>{
            (0, $iUfoI.fetchFailed)('confluence.first.space.created.flag', err);
            return (0, $bKhOq.empty)();
        }));

});

parcelRegister("hwVGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae548b20d5b14e5$export$2e2bcd8739ae039);
parcelRequire("iects");
parcelRequire("dfsI8");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $8riMk = parcelRequire("8riMk");

var $bKhOq = parcelRequire("bKhOq");
parcelRequire("2Nzqx");
var $hXPzA = parcelRequire("hXPzA");
var $8a0ZO = parcelRequire("8a0ZO");

var $3pvFP = parcelRequire("3pvFP");

var $6d0o8 = parcelRequire("6d0o8");

var $b18Mx = parcelRequire("b18Mx");

const $0ae548b20d5b14e5$var$IS_CROSS_SELL = true;
var $0ae548b20d5b14e5$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3pvFP.INVOKE_CROSS_FLOW)).mergeMap((action)=>{
        const state = store.getState();
        const crossFlow = (0, $6d0o8.getCrossFlowApi)(state);
        if (crossFlow.isEnabled) return (0, $8riMk.fromPromise)(crossFlow.api.open({
            journey: action.contextInfo ? (0, $hXPzA.Journeys).GET_STARTED : (0, $hXPzA.Journeys).DECIDE,
            targetProduct: (0, $8a0ZO.Targets).CONFLUENCE,
            sourceComponent: (0, $2bdc823b57417d54$export$400f359cf7604d7a),
            sourceContext: (0, $2bdc823b57417d54$export$e776c72d9769c47a),
            experimentalOptions: {
                isCrossSell: $0ae548b20d5b14e5$var$IS_CROSS_SELL,
                contextInfo: action.contextInfo
            }
        })).mergeMap(()=>(0, $bKhOq.empty)()).catch((_)=>{
            return (0, $cwK3t.of)((0, $3pvFP.showXflowDialogError)());
        });
        (0, $b18Mx.sendOperationalAnalyticsEvent)({
            source: 'projectPages',
            action: 'failed',
            actionSubject: 'invokeCrossFlowEpic',
            attributes: {
                reason: crossFlow.reason
            }
        });
        return (0, $cwK3t.of)((0, $3pvFP.showXflowDialogError)());
    });

});
parcelRegister("6d0o8", function(module, exports) {

$parcel$export(module.exports, "getCrossFlowApi", () => $4582e3aa75ed295a$export$a38e110f7441e437);
const $4582e3aa75ed295a$export$a38e110f7441e437 = (state)=>state.external.crossFlow;
const $4582e3aa75ed295a$export$2b73c7b4d0c976b4 = (state)=>state.external.onFireExposureEvent;

});


parcelRegister("do7Gi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fb8f290850bdcf5$export$2e2bcd8739ae039);
parcelRequire("3wBUP");

var $bKhOq = parcelRequire("bKhOq");

var $cwK3t = parcelRequire("cwK3t");

var $3pvFP = parcelRequire("3pvFP");
var $7fb8f290850bdcf5$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $3pvFP.UPDATE_PROJECT_SPACE_LINK)).switchMap(({ spaceKey: spaceKey })=>spaceKey !== null ? (0, $cwK3t.of)((0, $3pvFP.fetchConnectedSpaceBlueprints)()) : (0, $bKhOq.empty)());

});

parcelRegister("2OlyA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3033c94be7d38a8$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $3pvFP = parcelRequire("3pvFP");

var $hMy8N = parcelRequire("hMy8N");

var $2fabp = parcelRequire("2fabp");

var $iUfoI = parcelRequire("iUfoI");

var $dcSvg = parcelRequire("dcSvg");
const $c3033c94be7d38a8$var$LICENCE_EXCEEDED_ERROR_CODE = 'licence-exceeded';
const $c3033c94be7d38a8$var$confluenceAccessRequestCapabilitiesEpic = (action$, store)=>action$.ofType((0, $3pvFP.FETCH_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES)).switchMap(()=>{
        const state = store.getState();
        const cloudId = (0, $hMy8N.getCloudId)(state);
        return (0, $2fabp.getConfluenceAccessRequestCapabilities$)(cloudId).mergeMap((response)=>{
            (0, $iUfoI.fetchSuccess)('confluence.access-request-capabilities');
            const results = Object.values(response.results);
            // check we got exactly 1 result and the result is known, otherwise error
            if (results.length !== 1 || !Object.values((0, $dcSvg.AccessRequestCapabilityType)).includes(results[0])) return (0, $cwK3t.of)((0, $3pvFP.updateConfluenceAccessRequestCapabilities)((0, $dcSvg.AccessRequestCapabilityType).ERROR));
            return (0, $cwK3t.of)((0, $3pvFP.updateConfluenceAccessRequestCapabilities)(results[0]));
        }).catch((err)=>{
            let shouldFireOperationalEvent = true;
            try {
                const errorMessageObject = JSON.parse(err?.message);
                // do not fire failure event if it's a 'licence-exceeded' error
                if (errorMessageObject?.code === $c3033c94be7d38a8$var$LICENCE_EXCEEDED_ERROR_CODE) shouldFireOperationalEvent = false;
            } catch (e) {
                //Not a valid JSON, should fire failure event
                shouldFireOperationalEvent = true;
            }
            shouldFireOperationalEvent && (0, $iUfoI.fetchFailed)('confluence.access-request-capabilities', err);
            return (0, $cwK3t.of)((0, $3pvFP.updateConfluenceAccessRequestCapabilities)((0, $dcSvg.AccessRequestCapabilityType).ERROR));
        });
    });
var $c3033c94be7d38a8$export$2e2bcd8739ae039 = $c3033c94be7d38a8$var$confluenceAccessRequestCapabilitiesEpic;

});

parcelRegister("e4Evd", function(module, exports) {

$parcel$export(module.exports, "default", () => $33bdb08e6045db4f$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $3pvFP = parcelRequire("3pvFP");

var $hMy8N = parcelRequire("hMy8N");

var $iUfoI = parcelRequire("iUfoI");

var $hTP3U = parcelRequire("hTP3U");

var $jGyKS = parcelRequire("jGyKS");
const $33bdb08e6045db4f$var$confluenceCollaboratorsEpic = (action$, store)=>action$.ofType((0, $3pvFP.FETCH_CONFLUENCE_COLLABORATORS)).switchMap(()=>{
        const state = store.getState();
        const cloudId = (0, $hMy8N.getCloudId)(state);
        const userId = (0, $hMy8N.getAccountId)(state);
        const projectId = (0, $jGyKS.getProjectId)(state);
        return (0, $hTP3U.getSuggestedPeople$)(cloudId, userId, projectId).mergeMap((collaborators)=>{
            (0, $iUfoI.fetchSuccess)('site.collaborators');
            return (0, $cwK3t.of)((0, $3pvFP.updateConfluenceCollaborators)(collaborators));
        }).catch((err)=>{
            (0, $iUfoI.fetchFailed)('site.collaborators', err);
            return (0, $cwK3t.of)((0, $3pvFP.updateConfluenceCollaborators)([]));
        });
    });
var $33bdb08e6045db4f$export$2e2bcd8739ae039 = $33bdb08e6045db4f$var$confluenceCollaboratorsEpic;

});
parcelRegister("hTP3U", function(module, exports) {

$parcel$export(module.exports, "getSuggestedPeople$", () => $e8890a56c187b743$export$b976047653fe5487);
parcelRequire("flmol");

var $7y517 = parcelRequire("7y517");
const $e8890a56c187b743$var$SUGGESTED_PEOPLE_URL = '/gateway/api/v1/recommendations';
const $e8890a56c187b743$export$b976047653fe5487 = (cloudId, userId, projectId)=>(0, $7y517.default)($e8890a56c187b743$var$SUGGESTED_PEOPLE_URL, {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({
            context: {
                contextType: 'Mentions, Assignee, Generic, <BYO>',
                principalId: userId,
                siteId: cloudId,
                productKey: 'jira',
                containerId: projectId
            },
            searchQuery: {
                queryString: ''
            },
            maxNumberOfResults: 10,
            filter: '(NOT not_mentionable:true) AND (account_status:active)'
        })
    }).map((response)=>{
        return response.recommendedUsers.filter((account)=>account.id !== userId).map((account)=>({
                id: account.id,
                name: account.name,
                avatarUrl: account.avatarUrl
            }));
    });

});


parcelRegister("9EqMh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fb84a7e5e27b547$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $bKhOq = parcelRequire("bKhOq");

var $3pvFP = parcelRequire("3pvFP");

var $4aXoz = parcelRequire("4aXoz");

var $2fabp = parcelRequire("2fabp");

var $iUfoI = parcelRequire("iUfoI");

var $jGyKS = parcelRequire("jGyKS");
const $8fb84a7e5e27b547$var$fetchConnectedSpaceOrPageTitleEpic = (action$, store)=>action$.ofType((0, $3pvFP.FETCH_CONNECTED_SPACE_OR_PAGE_TITLE)).switchMap(()=>{
        const state = store.getState();
        const pageId = (0, $4aXoz.getProjectPageLinkedId)(state);
        const isConnectedToPage = Boolean((0, $4aXoz.getProjectPageLinkedId)(state));
        const spaceKey = (0, $4aXoz.getProjectSpaceKey)(state);
        // if we are connected to a space, use the fetchConnectedSpace to update the state
        if (spaceKey && !isConnectedToPage) return (0, $cwK3t.of)((0, $3pvFP.fetchConnectedSpace)(spaceKey));
        if (!pageId) return (0, $bKhOq.empty)();
        // otherwise fetch page content and update page title etc
        return (0, $2fabp.getConfluencePageContent$)(pageId, (0, $jGyKS.getProjectId)(state), (0, $jGyKS.getProjectType)(state)).mergeMap(({ title: title, _links: { webui: webui, base: base } })=>{
            const url = `${base}${webui}`;
            (0, $iUfoI.fetchSuccess)('confluence.content');
            return (0, $cwK3t.of)((0, $3pvFP.updateConnectedSpaceOrPageContent)({
                title: title,
                url: url,
                isConnectedToPage: isConnectedToPage,
                projectSpacePageTitleHasBeenFetched: true,
                iconUrl: null,
                pageId: pageId
            }));
        }).catch((err)=>{
            (0, $iUfoI.fetchFailed)('confluence.content', err);
            return (0, $cwK3t.of)((0, $3pvFP.updateConnectedSpaceOrPageContent)({
                title: null,
                iconUrl: null,
                projectSpacePageTitleHasBeenFetched: true,
                pageId: pageId
            }));
        });
    });
var $8fb84a7e5e27b547$export$2e2bcd8739ae039 = $8fb84a7e5e27b547$var$fetchConnectedSpaceOrPageTitleEpic;

});

parcelRegister("cJg3N", function(module, exports) {

$parcel$export(module.exports, "default", () => $259148486c4fb5b9$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $3pvFP = parcelRequire("3pvFP");

var $2fabp = parcelRequire("2fabp");

var $iUfoI = parcelRequire("iUfoI");

var $jGyKS = parcelRequire("jGyKS");
const $259148486c4fb5b9$var$fetchConnectedSpaceEpic = (action$, store)=>action$.ofType((0, $3pvFP.FETCH_CONNECTED_SPACE)).switchMap(({ spaceKey: spaceKey })=>{
        return (0, $2fabp.getConfluenceSpace$)(spaceKey, (0, $jGyKS.getProjectId)(store.getState()), (0, $jGyKS.getProjectType)(store.getState())).mergeMap(({ id: id, name: name, homepage: homepage, icon: { path: iconPath }, _links: { base: base, webui: webui } })=>{
            (0, $iUfoI.fetchSuccess)('confluence.space');
            return (0, $cwK3t.of)((0, $3pvFP.updateConnectedSpaceOrPageContent)({
                spaceId: id,
                title: name,
                isConnectedToPage: false,
                projectSpacePageTitleHasBeenFetched: true,
                url: `${base}${webui}`,
                iconUrl: `${base}${iconPath}`,
                pageId: homepage?.id || null
            }));
        }).catch((err)=>{
            (0, $iUfoI.fetchFailed)('confluence.space', err);
            return (0, $cwK3t.of)((0, $3pvFP.updateConnectedSpaceOrPageContent)({
                spaceId: null,
                title: null,
                iconUrl: null,
                projectSpacePageTitleHasBeenFetched: true,
                pageId: null
            }));
        });
    });
var $259148486c4fb5b9$export$2e2bcd8739ae039 = $259148486c4fb5b9$var$fetchConnectedSpaceEpic;

});

parcelRegister("8qph5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f88e11e61e107c4$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $3pvFP = parcelRequire("3pvFP");

var $fFPgi = parcelRequire("fFPgi");

var $2fabp = parcelRequire("2fabp");

var $iUfoI = parcelRequire("iUfoI");

var $jGyKS = parcelRequire("jGyKS");
const $0f88e11e61e107c4$var$jiraProjectPermissions = (action$, store)=>action$.ofType((0, $3pvFP.FETCH_JIRA_PROJECT_PERMISSIONS)).switchMap(()=>{
        const state = store.getState();
        const projectKey = (0, $jGyKS.getProjectKey)(state);
        return (0, $2fabp.getJiraProjectPermissions$)(projectKey).mergeMap((response)=>{
            (0, $iUfoI.fetchSuccess)('jira.permissions');
            const isMember = response.permissions.CREATE_ISSUES.havePermission && response.permissions.EDIT_ISSUES.havePermission;
            return (0, $cwK3t.of)((0, $fFPgi.setIsMember)(isMember));
        }).catch((err)=>{
            (0, $iUfoI.fetchFailed)('jira.permissions', err);
            // just gracefully fallback to user not being a project member if unable to fetch perms for some reason
            return (0, $cwK3t.of)((0, $fFPgi.setIsMember)(false));
        });
    });
var $0f88e11e61e107c4$export$2e2bcd8739ae039 = $0f88e11e61e107c4$var$jiraProjectPermissions;

});

parcelRegister("ixnRZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba98180ffcd4db0$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $jpkPA = parcelRequire("jpkPA");

var $3pvFP = parcelRequire("3pvFP");

var $hMy8N = parcelRequire("hMy8N");

var $dcSvg = parcelRequire("dcSvg");

var $iUfoI = parcelRequire("iUfoI");

var $9naRE = parcelRequire("9naRE");

var $b1qLQ = parcelRequire("b1qLQ");

var $df9H8 = parcelRequire("df9H8");
const $1ba98180ffcd4db0$var$confluenceInlineJoin = (action$, store)=>action$.ofType((0, $3pvFP.INLINE_JOIN_CONFLUENCE)).switchMap(()=>{
        const state = store.getState();
        const cloudId = (0, $hMy8N.getCloudId)(state);
        return (0, $9naRE.inlineJoin$)('confluence', cloudId).pipe((0, $b1qLQ.mergeMap)(({ status: status, result: result })=>{
            const isRaFlow = result === (0, $dcSvg.AccessRequestCapabilityType).PENDING_REQUEST_CREATED;
            /*
					For RA flow we just need to fetch access request capabilities from identity as it'll refresh the main screen 
					to show pending RA. We must not checkConfluenceAccessWithRetry as it'll send requests to Confluence
					whereby the user is still pending admin approval. All requests to Confluence endpoint will result in 403
					as expected because they don't have Confluence permission yet. 
				*/ if (isRaFlow) (0, $iUfoI.fetchSuccess)('auto.ra.confluence');
            else (0, $iUfoI.fetchSuccess)('inline.join.confluence');
            return (0, $jpkPA.from)([
                isRaFlow ? (0, $3pvFP.fetchConfluenceAccessRequestCapabilities)() : (0, $3pvFP.checkConfluenceAccessWithRetry)()
            ]);
        }), (0, $df9H8.catchError)((err)=>{
            (0, $iUfoI.fetchFailed)('inline.join.confluence', err);
            return (0, $cwK3t.of)((0, $3pvFP.inlineJoinConfluenceFailed)());
        }));
    });
var $1ba98180ffcd4db0$export$2e2bcd8739ae039 = $1ba98180ffcd4db0$var$confluenceInlineJoin;

});

parcelRegister("8b7mq", function(module, exports) {

$parcel$export(module.exports, "default", () => $af0ffa0101950ddc$export$2e2bcd8739ae039);
parcelRequire("flmol");
parcelRequire("3wBUP");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $iUfoI = parcelRequire("iUfoI");

var $6waye = parcelRequire("6waye");

var $2fabp = parcelRequire("2fabp");

var $hMy8N = parcelRequire("hMy8N");
var $af0ffa0101950ddc$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $6waye.FETCH_PERSONALIZATION_SITE_TRAITS)).switchMap(()=>{
        const cloudId = (0, $hMy8N.getCloudId)(store.getState());
        return (0, $2fabp.requestPersonalizationSiteTraits$)(cloudId).map((traits)=>{
            (0, $iUfoI.fetchSuccess)('personalization.site.traits');
            return (0, $6waye.updatePersonalizationSiteTraits)(traits);
        }).catch((err)=>{
            (0, $iUfoI.fetchFailed)('personalization.site.traits', err);
            return (0, $cwK3t.of)((0, $6waye.fetchPersonalizationSiteTraitsFailed)());
        });
    });

});

parcelRegister("2cqbF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d532755f24a6ca31$export$2e2bcd8739ae039);
parcelRequire("flmol");
parcelRequire("3wBUP");
parcelRequire("1Lcr1");
parcelRequire("8OtG5");

var $cwK3t = parcelRequire("cwK3t");

var $3pvFP = parcelRequire("3pvFP");

var $6waye = parcelRequire("6waye");
var $d532755f24a6ca31$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $6waye.UPDATE_PERSONALIZATION_SITE_TRAITS)).switchMap(()=>(0, $cwK3t.of)((0, $3pvFP.fetchConfluenceSpaces)()));

});

parcelRegister("4v5DF", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc319c9a29df2038$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $3pvFP = parcelRequire("3pvFP");

var $lpJ9O = parcelRequire("lpJ9O");

var $6waye = parcelRequire("6waye");

var $fgPvC = parcelRequire("fgPvC");

var $hXy49 = parcelRequire("hXy49");

var $1UwLx = parcelRequire("1UwLx");
var $dc319c9a29df2038$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $lpJ9O.INITIALIZE_VIEW)).switchMap(()=>{
        const state = store.getState();
        const baseObservables = [
            (0, $3pvFP.checkProductsLicenceState)(),
            (0, $6waye.fetchPersonalizationSiteTraits)()
        ];
        if ((0, $hXy49.isActivationMethodDetermined)(state)) return (0, $fgPvC.merge)(baseObservables);
        return (0, $fgPvC.merge)([
            ...baseObservables,
            (0, $1UwLx.planConfluenceActivation)()
        ]);
    });

});

parcelRegister("40C8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fb84022865aa965$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("8OtG5");
parcelRequire("DPH94");

var $3pvFP = parcelRequire("3pvFP");

var $6waye = parcelRequire("6waye");

var $3C6Im = parcelRequire("3C6Im");

var $cwK3t = parcelRequire("cwK3t");

var $baKYD = parcelRequire("baKYD");

var $jGyKS = parcelRequire("jGyKS");
var $3fb84022865aa965$export$2e2bcd8739ae039 = (action$, store)=>(0, $3C6Im.combineLatest)(action$.ofType((0, $6waye.UPDATE_PERSONALIZATION_SITE_TRAITS)), action$.ofType((0, $3pvFP.UPDATE_CONFLUENCE_SPACES))).filter(()=>(0, $baKYD.shouldCreateSpaceForAutoProvisionedConfluence)(store.getState()) === true).switchMap(()=>(0, $cwK3t.of)((0, $3pvFP.generateSpaceKey)((0, $jGyKS.getProjectName)(store.getState()))));

});
parcelRegister("DPH94", function(module, exports) {
"use strict";

var $3JafE = parcelRequire("3JafE");

var $6jSKT = parcelRequire("6jSKT");
$3JafE.Observable.prototype.combineLatest = $6jSKT.combineLatest;

});
parcelRegister("6jSKT", function(module, exports) {

$parcel$export(module.exports, "combineLatest", () => $499efdb555bc8fc8$export$77fa7d86f5204e8a, (v) => $499efdb555bc8fc8$export$77fa7d86f5204e8a = v);
var $499efdb555bc8fc8$export$77fa7d86f5204e8a;
"use strict";

var $fEMiR = parcelRequire("fEMiR");
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $499efdb555bc8fc8$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $fEMiR.combineLatest.apply(void 0, observables)(this);
}
$499efdb555bc8fc8$export$77fa7d86f5204e8a = $499efdb555bc8fc8$var$combineLatest;

});



parcelRegister("1OvIw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a43749db7f09241$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("8OtG5");
parcelRequire("DPH94");

var $3pvFP = parcelRequire("3pvFP");

var $gilIH = parcelRequire("gilIH");

var $6waye = parcelRequire("6waye");

var $3C6Im = parcelRequire("3C6Im");

var $cwK3t = parcelRequire("cwK3t");

var $baKYD = parcelRequire("baKYD");
var $1a43749db7f09241$export$2e2bcd8739ae039 = (action$, store)=>(0, $3C6Im.combineLatest)(action$.ofType((0, $6waye.UPDATE_PERSONALIZATION_SITE_TRAITS)), action$.ofType((0, $3pvFP.UPDATE_SUGGESTED_KEY))).filter(()=>(0, $baKYD.shouldCreateSpaceForAutoProvisionedConfluence)(store.getState()) === true).switchMap(()=>(0, $cwK3t.of)((0, $gilIH.createConfluenceSpace)(true)));

});

parcelRegister("3ZA6a", function(module, exports) {

$parcel$export(module.exports, "default", () => $a088aba2fff631a7$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $iUfoI = parcelRequire("iUfoI");

var $hMy8N = parcelRequire("hMy8N");

var $jGyKS = parcelRequire("jGyKS");

var $2fabp = parcelRequire("2fabp");

var $1UwLx = parcelRequire("1UwLx");

var $hXy49 = parcelRequire("hXy49");
const $a088aba2fff631a7$var$provisioningStatusToActivationStatusMap = {
    PROVISIONING_IN_PROGRESS: 'activating',
    PROVISIONING_FAILED: 'error',
    PROVISIONING_COMPLETED: 'completed',
    PROVISIONING_PROCESS_NOT_FOUND: 'not-allowed'
};
var $a088aba2fff631a7$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $1UwLx.PLAN_ACTIVATION)).filter(()=>{
        const state = store.getState();
        const activationStatus = (0, $hXy49.getActivationStatus)(state);
        return activationStatus === 'not-started';
    }).switchMap(()=>{
        const state = store.getState();
        const project = (0, $jGyKS.getProject)(state);
        const cloudId = (0, $hMy8N.getCloudId)(state);
        return (0, $2fabp.planConfluenceActivation$)(cloudId, {
            projectId: project.id
        }).mergeMap((response)=>{
            (0, $iUfoI.fetchSuccess)('confluence.activate.plan');
            if (response.allowed) return (0, $cwK3t.of)((0, $1UwLx.updateConfluenceActivationStatus)({
                status: 'allowed'
            }));
            return (0, $cwK3t.of)((0, $1UwLx.updateConfluenceActivationStatus)({
                status: $a088aba2fff631a7$var$provisioningStatusToActivationStatusMap[response.context?.status || 'PROVISIONING_PROCESS_NOT_FOUND']
            }));
        }).catch((error)=>{
            (0, $iUfoI.fetchFailed)('confluence.activate.plan', error);
            return (0, $cwK3t.of)((0, $1UwLx.updateConfluenceActivationStatus)({
                status: 'not-allowed'
            }));
        });
    });

});

parcelRegister("3jSSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d74a5ef64eab580a$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $cwK3t = parcelRequire("cwK3t");

var $h5OsT = parcelRequire("h5OsT");

var $iUfoI = parcelRequire("iUfoI");

var $hMy8N = parcelRequire("hMy8N");

var $jGyKS = parcelRequire("jGyKS");

var $2fabp = parcelRequire("2fabp");

var $1UwLx = parcelRequire("1UwLx");

var $3pvFP = parcelRequire("3pvFP");
var $d74a5ef64eab580a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $1UwLx.START_ACTIVATION)).switchMap(()=>{
        const state = store.getState();
        const projectId = (0, $jGyKS.getProjectId)(state);
        const cloudId = (0, $hMy8N.getCloudId)(state);
        return (0, $2fabp.startConfluenceActivation$)(cloudId, {
            projectId: projectId
        }).mergeMap((response)=>{
            if (!response?.started) throw new Error('Could not start confluence activation.');
            (0, $iUfoI.fetchSuccess)('confluence.activate.start');
            return (0, $cwK3t.of)((0, $1UwLx.updateConfluenceActivationStatus)({
                status: 'activating'
            }));
        }).catch((error)=>{
            (0, $iUfoI.fetchFailed)('confluence.activate.start', error);
            return (0, $h5OsT.concat)([
                (0, $3pvFP.showActivationErrorFlag)(),
                (0, $1UwLx.updateConfluenceActivationStatus)({
                    status: 'not-allowed'
                })
            ]);
        });
    });

});

parcelRegister("Y75pB", function(module, exports) {

$parcel$export(module.exports, "default", () => $89494da244d74608$export$2e2bcd8739ae039);
parcelRequire("zQVFQ");
parcelRequire("2OBiA");
parcelRequire("iects");
parcelRequire("3wBUP");
parcelRequire("5hZYM");

var $cwK3t = parcelRequire("cwK3t");

var $29oaj = parcelRequire("29oaj");

var $1UwLx = parcelRequire("1UwLx");

var $hXy49 = parcelRequire("hXy49");

var $2fabp = parcelRequire("2fabp");

var $iUfoI = parcelRequire("iUfoI");

var $hMy8N = parcelRequire("hMy8N");
const $89494da244d74608$var$MAX_RETRIES = 50;
const $89494da244d74608$var$POLL_INTERVAL = 3000;
const $89494da244d74608$var$INITIAL_DELAY = 6000;
var $89494da244d74608$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $1UwLx.CHECK_ACTIVATION_STATUS)).takeUntil(action$.ofType((0, $1UwLx.CHECK_ACTIVATION_STATUS_ERROR)) || action$.ofType((0, $1UwLx.CHECK_ACTIVATION_STATUS_SUCCESS))).delayWhen(()=>{
        const state = store.getState();
        const retryCount = (0, $hXy49.activationStatusRetryCount)(state);
        if (retryCount === 0) return (0, $29oaj.timer)($89494da244d74608$var$INITIAL_DELAY);
        if (retryCount % 2 === 0) return (0, $29oaj.timer)($89494da244d74608$var$POLL_INTERVAL * 2);
        return (0, $29oaj.timer)($89494da244d74608$var$POLL_INTERVAL);
    }).switchMap(()=>{
        const state = store.getState();
        const cloudId = (0, $hMy8N.getCloudId)(state);
        const retryCount = (0, $hXy49.activationStatusRetryCount)(state);
        if (retryCount > $89494da244d74608$var$MAX_RETRIES) return (0, $cwK3t.of)((0, $1UwLx.checkConfluenceActivationStatusFailed)());
        return (0, $2fabp.checkConfluenceActivationStatus$)(cloudId).mergeMap((response)=>{
            (0, $iUfoI.fetchSuccess)('confluence.activate.status');
            switch(response.status){
                case 'PROVISIONING_COMPLETED':
                    return (0, $cwK3t.of)((0, $1UwLx.checkConfluenceActivationStatusSuccess)());
                case 'PROVISIONING_FAILED':
                    return (0, $cwK3t.of)((0, $1UwLx.checkConfluenceActivationStatusFailed)());
                case 'PROVISIONING_IN_PROGRESS':
                default:
                    return (0, $cwK3t.of)((0, $1UwLx.checkConfluenceActivationStatus)());
            }
        }).catch((error)=>{
            (0, $iUfoI.fetchFailed)('confluence.activate.status', error);
            return (0, $cwK3t.of)((0, $1UwLx.checkConfluenceActivationStatusFailed)());
        });
    });

});
parcelRegister("zQVFQ", function(module, exports) {
"use strict";

var $3JafE = parcelRequire("3JafE");

var $d5II8 = parcelRequire("d5II8");
$3JafE.Observable.prototype.delayWhen = $d5II8.delayWhen;

});
parcelRegister("d5II8", function(module, exports) {

$parcel$export(module.exports, "delayWhen", () => $987e6c9da954fde8$export$286ca829307725c9, (v) => $987e6c9da954fde8$export$286ca829307725c9 = v);
var $987e6c9da954fde8$export$286ca829307725c9;
"use strict";

var $jrplL = parcelRequire("jrplL");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $987e6c9da954fde8$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    return $jrplL.delayWhen(delayDurationSelector, subscriptionDelay)(this);
}
$987e6c9da954fde8$export$286ca829307725c9 = $987e6c9da954fde8$var$delayWhen;

});
parcelRegister("jrplL", function(module, exports) {
"use strict";
var $e27433ea0c9c0240$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $3JafE = parcelRequire("3JafE");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $e27433ea0c9c0240$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new $e27433ea0c9c0240$var$SubscriptionDelayObservable(source, subscriptionDelay).lift(new $e27433ea0c9c0240$var$DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new $e27433ea0c9c0240$var$DelayWhenOperator(delayDurationSelector));
    };
}
module.exports.delayWhen = $e27433ea0c9c0240$var$delayWhen;
var $e27433ea0c9c0240$var$DelayWhenOperator = function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e27433ea0c9c0240$var$DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e27433ea0c9c0240$var$DelayWhenSubscriber = function(_super) {
    $e27433ea0c9c0240$var$__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = $87MtM.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}($6UnJS.OuterSubscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e27433ea0c9c0240$var$SubscriptionDelayObservable = function(_super) {
    $e27433ea0c9c0240$var$__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new $e27433ea0c9c0240$var$SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}($3JafE.Observable);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e27433ea0c9c0240$var$SubscriptionDelaySubscriber = function(_super) {
    $e27433ea0c9c0240$var$__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}($a7QRR.Subscriber);

});




parcelRegister("8M2or", function(module, exports) {

$parcel$export(module.exports, "default", () => $d034745cf32b1466$export$2e2bcd8739ae039);
parcelRequire("3wBUP");

var $cwK3t = parcelRequire("cwK3t");

var $1UwLx = parcelRequire("1UwLx");
var $d034745cf32b1466$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $1UwLx.CHECK_ACTIVATION_STATUS_SUCCESS)).switchMap(()=>{
        return (0, $cwK3t.of)((0, $1UwLx.markActivationCompleted)());
    });

});

parcelRegister("gBwUP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24c0d90b6cbe3b9$export$2e2bcd8739ae039);
parcelRequire("8SBcT");
parcelRequire("3wBUP");

var $h5OsT = parcelRequire("h5OsT");

var $1UwLx = parcelRequire("1UwLx");

var $3pvFP = parcelRequire("3pvFP");
var $c24c0d90b6cbe3b9$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $1UwLx.CHECK_ACTIVATION_STATUS_ERROR)).switchMap(()=>{
        return (0, $h5OsT.concat)([
            (0, $1UwLx.markActivationFailed)(),
            (0, $3pvFP.showActivationErrorFlag)()
        ]);
    });

});

parcelRegister("88kIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6468ca5ed0a83e6$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("1Lcr1");

var $h5OsT = parcelRequire("h5OsT");

var $3C6Im = parcelRequire("3C6Im");

var $8LwVJ = parcelRequire("8LwVJ");

var $hXy49 = parcelRequire("hXy49");

var $lpJ9O = parcelRequire("lpJ9O");

var $3pvFP = parcelRequire("3pvFP");

var $1UwLx = parcelRequire("1UwLx");

var $8tM2T = parcelRequire("8tM2T");

var $XHGTv = parcelRequire("XHGTv");
function $c6468ca5ed0a83e6$var$isExperimentEnabled() {
    const cohort = (0, $8tM2T.default).getExperimentValue('project_pages_embedded_confluence_experiment', 'cohort', 'not-enrolled', // NOTE: This is on purpose, we do not want to overexpose at this point given that users haven't actually started on-demand activation yet.
    {
        fireExperimentExposure: false
    });
    return (0, $XHGTv.fg)('project_pages_embededed_confluence_gate') && cohort === 'variation';
}
function $c6468ca5ed0a83e6$var$getObservables(action$) {
    if ($c6468ca5ed0a83e6$var$isExperimentEnabled()) return (0, $3C6Im.combineLatest)(action$.ofType((0, $1UwLx.MARK_ACTIVATION_COMPLETED)));
    return (0, $3C6Im.combineLatest)(action$.ofType((0, $8LwVJ.UPDATE_ONDEMAND_ACTIVATION_MODAL_STATE)), action$.ofType((0, $1UwLx.MARK_ACTIVATION_COMPLETED)));
}
var $c6468ca5ed0a83e6$export$2e2bcd8739ae039 = (action$, store)=>{
    return $c6468ca5ed0a83e6$var$getObservables(action$).filter(([modalStateAction])=>{
        const isActivating = (0, $hXy49.getActivationStatus)(store.getState()) === 'activating';
        if ($c6468ca5ed0a83e6$var$isExperimentEnabled()) return isActivating;
        return modalStateAction.payload?.modalState === 'closed' && isActivating;
    }).switchMap(()=>{
        const userInitiated = (0, $hXy49.getUserInitiatedActivation)(store.getState());
        if (userInitiated && $c6468ca5ed0a83e6$var$isExperimentEnabled()) return (0, $h5OsT.concat)([
            // Only close modal if user is in variation
            (0, $8LwVJ.updateOnDemandActivationModalState)({
                modalState: 'closed'
            }),
            (0, $3pvFP.updateConfluenceState)('CONFLUENCE_LOADING'),
            (0, $1UwLx.updateConfluenceActivationStatus)({
                status: 'completed'
            }),
            (0, $lpJ9O.initializeView)()
        ]);
        return (0, $h5OsT.concat)([
            (0, $3pvFP.updateConfluenceState)('CONFLUENCE_LOADING'),
            (0, $1UwLx.updateConfluenceActivationStatus)({
                status: 'completed'
            }),
            (0, $lpJ9O.initializeView)()
        ]);
    });
};

});

parcelRegister("6JXig", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc4fe4ba532776c8$export$2e2bcd8739ae039);
parcelRequire("3wBUP");
parcelRequire("1Lcr1");

var $h5OsT = parcelRequire("h5OsT");

var $3C6Im = parcelRequire("3C6Im");

var $8LwVJ = parcelRequire("8LwVJ");

var $hXy49 = parcelRequire("hXy49");

var $lpJ9O = parcelRequire("lpJ9O");

var $3pvFP = parcelRequire("3pvFP");

var $1UwLx = parcelRequire("1UwLx");
var $cc4fe4ba532776c8$export$2e2bcd8739ae039 = (action$, store)=>(0, $3C6Im.combineLatest)(action$.ofType((0, $8LwVJ.UPDATE_ONDEMAND_ACTIVATION_MODAL_STATE)), action$.ofType((0, $1UwLx.MARK_ACTIVATION_ERROR))).filter(([modalStateAction])=>modalStateAction.payload?.modalState === 'closed' && (0, $hXy49.getActivationStatus)(store.getState()) === 'activating').delay(1000).switchMap(()=>(0, $h5OsT.concat)([
            (0, $3pvFP.updateConfluenceState)('CONFLUENCE_LOADING'),
            (0, $1UwLx.updateConfluenceActivationStatus)({
                status: 'error'
            }),
            (0, $lpJ9O.initializeView)()
        ]));

});


parcelRegister("97aDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c29a1cc8873c0edc$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $heugu = parcelRequire("heugu");

var $3eKVQ = parcelRequire("3eKVQ");

var $goPoF = parcelRequire("goPoF");

var $1kRE2 = parcelRequire("1kRE2");

var $jvzTX = parcelRequire("jvzTX");

var $gneuB = parcelRequire("gneuB");

var $9MNJa = parcelRequire("9MNJa");

var $27RnF = parcelRequire("27RnF");

var $2MaQ2 = parcelRequire("2MaQ2");
var $c29a1cc8873c0edc$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    confluence: $heugu.default,
    context: $3eKVQ.default,
    external: $goPoF.default,
    project: $gneuB.default,
    ui: $9MNJa.default,
    flags: $jvzTX.default,
    featureFlags: $1kRE2.default,
    personalization: $27RnF.default,
    activation: $2MaQ2.default
});

});
parcelRegister("heugu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b507116bd8b5d69$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $h6k4S = parcelRequire("h6k4S");

var $cZS5d = parcelRequire("cZS5d");

var $hxNEt = parcelRequire("hxNEt");

var $hFIWK = parcelRequire("hFIWK");

var $9aG8g = parcelRequire("9aG8g");
var $2b507116bd8b5d69$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    connectedSpace: $h6k4S.default,
    spaces: $cZS5d.default,
    user: $hxNEt.default,
    accessRequestCapabilities: $hFIWK.default,
    collaborators: $9aG8g.default
});

});
parcelRegister("h6k4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec6e8a9a22688607$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $3pvFP = parcelRequire("3pvFP");

var $i2XH3 = parcelRequire("i2XH3");

const $ec6e8a9a22688607$var$initialState = {
    blueprintsState: (0, $d01310c7d13ad40a$export$78244dbb77cfa6b6),
    blueprints: null,
    connectionState: (0, $d01310c7d13ad40a$export$78244dbb77cfa6b6),
    projectSpaceKey: null,
    projectPageLinkedId: null,
    projectSpacePageTitle: null,
    projectSpacePageUrl: null,
    projectIsConnectedToPage: false,
    projectSpacePageTitleHasBeenFetched: false,
    projectSpaceIcon: null,
    projectSpaceId: null
};
var $ec6e8a9a22688607$export$2e2bcd8739ae039 = (state = $ec6e8a9a22688607$var$initialState, action)=>{
    switch(action.type){
        case 0, $i2XH3.SET:
            return (0, $6JFcL.freeze)(action.payload);
        case 0, $3pvFP.RESET_CONNECTED_SPACE:
            return $ec6e8a9a22688607$var$initialState;
        case 0, $3pvFP.GET_PROJECT_SPACE_LINK:
            return (0, $6JFcL.merge)(state, {
                connectionState: (0, $d01310c7d13ad40a$export$26d55645375ca9a)
            });
        case 0, $3pvFP.PUT_PROJECT_SPACE_LINK:
            // reset to initial state whenever a new space link is being made
            return (0, $6JFcL.freeze)($ec6e8a9a22688607$var$initialState);
        case 0, $3pvFP.GET_PROJECT_SPACE_LINK_ERROR:
            return (0, $6JFcL.merge)(state, {
                projectSpaceKey: null,
                connectionState: (0, $d01310c7d13ad40a$export$103bedf43ba882db)
            });
        case 0, $3pvFP.FETCH_CONNECTED_SPACE_BLUEPRINTS:
            return (0, $6JFcL.merge)(state, {
                blueprintsState: (0, $d01310c7d13ad40a$export$26d55645375ca9a),
                blueprints: null
            });
        case 0, $3pvFP.FETCH_CONNECTED_SPACE_BLUEPRINTS_ERROR:
            return (0, $6JFcL.merge)(state, {
                blueprintsState: (0, $d01310c7d13ad40a$export$103bedf43ba882db),
                blueprints: null
            });
        case 0, $3pvFP.UPDATE_CONNECTED_SPACE_BLUEPRINTS:
            return (0, $6JFcL.merge)(state, {
                blueprintsState: (0, $d01310c7d13ad40a$export$c6813a8d51f77eaf),
                blueprints: action.payload
            });
        case 0, $3pvFP.UPDATE_PROJECT_SPACE_LINK:
            return (0, $6JFcL.merge)(state, {
                projectSpaceKey: action.spaceKey,
                projectPageLinkedId: action.linkedPageId
            });
        case 0, $3pvFP.UPDATE_CONNECTED_SPACE_OR_PAGE_CONTENT:
            return (0, $6JFcL.merge)(state, {
                projectSpaceId: action.spaceId,
                projectSpacePageTitle: action.title,
                projectSpacePageUrl: action.url,
                projectIsConnectedToPage: action.isConnectedToPage,
                projectSpacePageTitleHasBeenFetched: action.projectSpacePageTitleHasBeenFetched,
                projectSpaceIcon: action.iconUrl
            });
        case 0, $3pvFP.UPDATE_CONFLUENCE_SPACE_CONNECTION_STATE:
            return (0, $6JFcL.merge)(state, {
                connectionState: action.connectionState
            });
        default:
            return state;
    }
};

});
parcelRegister("i2XH3", function(module, exports) {

$parcel$export(module.exports, "SET", () => $4dc4fe134a16003d$export$5e8f180ef0142226);
const $4dc4fe134a16003d$export$5e8f180ef0142226 = 'confluence.connectedSpace.SET';
const $4dc4fe134a16003d$export$adaa4cf7ef1b65be = (payload)=>({
        type: $4dc4fe134a16003d$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("cZS5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8515801cb338a7f$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $3pvFP = parcelRequire("3pvFP");

var $7BsGe = parcelRequire("7BsGe");
const $a8515801cb338a7f$var$initialState = (0, $6JFcL.freeze)({
    availableSpaces: [],
    spacesLoaded: false
});
var $a8515801cb338a7f$export$2e2bcd8739ae039 = (state = $a8515801cb338a7f$var$initialState, action)=>{
    switch(action.type){
        case 0, $7BsGe.SET:
            return (0, $6JFcL.freeze)(action.payload);
        case 0, $3pvFP.UPDATE_CONFLUENCE_SPACES:
            return (0, $6JFcL.merge)(state, {
                availableSpaces: action.payload,
                spacesLoaded: true
            });
        default:
            return state;
    }
};

});
parcelRegister("7BsGe", function(module, exports) {

$parcel$export(module.exports, "SET", () => $467e692ff14a1de4$export$5e8f180ef0142226);
const $467e692ff14a1de4$export$5e8f180ef0142226 = 'confluence.spaces.SET';
const $467e692ff14a1de4$export$adaa4cf7ef1b65be = (payload)=>({
        type: $467e692ff14a1de4$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("hxNEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8621ea39768bf7fe$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $3pvFP = parcelRequire("3pvFP");

var $6ACkO = parcelRequire("6ACkO");

const $8621ea39768bf7fe$var$initialState = {
    access: (0, $dfecdf57a1227fce$export$78244dbb77cfa6b6)
};
var $8621ea39768bf7fe$export$2e2bcd8739ae039 = (state = $8621ea39768bf7fe$var$initialState, action)=>{
    switch(action.type){
        case 0, $6ACkO.SET:
            return (0, $6JFcL.freeze)(action.payload);
        case 0, $3pvFP.UPDATE_CONFLUENCE_USER_ACCESS:
            return (0, $6JFcL.merge)(state, {
                access: action.access
            });
        default:
            return state;
    }
};

});
parcelRegister("6ACkO", function(module, exports) {

$parcel$export(module.exports, "SET", () => $9a9e2e5f7bfb64d6$export$5e8f180ef0142226);
const $9a9e2e5f7bfb64d6$export$5e8f180ef0142226 = 'confluence.user.SET';
const $9a9e2e5f7bfb64d6$export$adaa4cf7ef1b65be = (payload)=>({
        type: $9a9e2e5f7bfb64d6$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("hFIWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3586bd670740a640$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $3pvFP = parcelRequire("3pvFP");

var $dcSvg = parcelRequire("dcSvg");
const $3586bd670740a640$var$initialState = (0, $6JFcL.freeze)({
    capability: (0, $dcSvg.AccessRequestCapabilityType).ERROR,
    loaded: false
});
var $3586bd670740a640$export$2e2bcd8739ae039 = (state = $3586bd670740a640$var$initialState, action)=>{
    switch(action.type){
        case 0, $3pvFP.UPDATE_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES:
            return (0, $6JFcL.merge)(state, {
                capability: action.capability,
                loaded: true
            });
        default:
            return state;
    }
};

});

parcelRegister("9aG8g", function(module, exports) {

$parcel$export(module.exports, "default", () => $519d2344d8f40d03$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $3pvFP = parcelRequire("3pvFP");
const $519d2344d8f40d03$var$initialState = (0, $6JFcL.freeze)({
    users: [],
    loaded: false
});
var $519d2344d8f40d03$export$2e2bcd8739ae039 = (state = $519d2344d8f40d03$var$initialState, action)=>{
    switch(action.type){
        case 0, $3pvFP.UPDATE_CONFLUENCE_COLLABORATORS:
            const { users: users } = action;
            return (0, $6JFcL.merge)(state, {
                users: users,
                loaded: true
            });
        default:
            return state;
    }
};

});


parcelRegister("goPoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f78afebc15431c$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $ggLRr = parcelRequire("ggLRr");
parcelRequire("2Nzqx");
var $hXPzA = parcelRequire("hXPzA");
const $61f78afebc15431c$export$7408552c6b1b4938 = (0, $6JFcL.freeze)({
    onGetFeatureFlagValue: ()=>({
        }),
    onFireExposureEvent: (flagKey)=>({
        }),
    onFireErrorEvent: (error, info, meta)=>({
        }),
    crossFlow: {
        isEnabled: false,
        reason: (0, $hXPzA.Reasons).NO_PROVIDER
    }
});
var $61f78afebc15431c$export$2e2bcd8739ae039 = (state = $61f78afebc15431c$export$7408552c6b1b4938, action)=>{
    switch(action.type){
        case 0, $ggLRr.SET:
            return (0, $6JFcL.freeze)(action.payload);
        default:
            return state;
    }
};

});
parcelRegister("ggLRr", function(module, exports) {

$parcel$export(module.exports, "SET", () => $e9010adf05ec566e$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $e9010adf05ec566e$export$adaa4cf7ef1b65be);
const $e9010adf05ec566e$export$5e8f180ef0142226 = 'external.SET';
const $e9010adf05ec566e$export$adaa4cf7ef1b65be = (payload)=>({
        type: $e9010adf05ec566e$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("1kRE2", function(module, exports) {

$parcel$export(module.exports, "default", () => $abbda70fa39229b8$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $8dZP8 = parcelRequire("8dZP8");
const $abbda70fa39229b8$export$cb7e03ffc687d619 = (0, $6JFcL.freeze)({
    isProjectPagesSporkRebrandingEnabled: false
});
var $abbda70fa39229b8$export$2e2bcd8739ae039 = (state = $abbda70fa39229b8$export$cb7e03ffc687d619, action)=>{
    switch(action.type){
        case 0, $8dZP8.SET:
            return (0, $6JFcL.freeze)(action.payload);
        default:
            return state;
    }
};

});
parcelRegister("8dZP8", function(module, exports) {

$parcel$export(module.exports, "SET", () => $0ec47f3755f70628$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $0ec47f3755f70628$export$adaa4cf7ef1b65be);
const $0ec47f3755f70628$export$5e8f180ef0142226 = 'feature-flags.SET';
const $0ec47f3755f70628$export$adaa4cf7ef1b65be = (payload)=>({
        type: $0ec47f3755f70628$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("jvzTX", function(module, exports) {

$parcel$export(module.exports, "default", () => $82eb34fad1e6d6e0$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $3pvFP = parcelRequire("3pvFP");

var $l2hLv = parcelRequire("l2hLv");
const $82eb34fad1e6d6e0$export$75c4ebf4e42e8dda = {
    hasErrors: false,
    showSuccessFlag: false,
    connectedSpaceName: '',
    isConnectedToPage: false,
    title: '',
    description: '',
    showActivationErrorFlag: false
};
var $82eb34fad1e6d6e0$export$2e2bcd8739ae039 = (state = $82eb34fad1e6d6e0$export$75c4ebf4e42e8dda, action)=>{
    switch(action.type){
        case 0, $l2hLv.SET:
            return (0, $6JFcL.freeze)(action.payload);
        case 0, $3pvFP.REDIRECT_TO_CONFLUENCE_CREATE_ERROR:
        case 0, $3pvFP.SHOW_XFLOW_DIALOG_ERROR:
        case 0, $3pvFP.INLINE_JOIN_FAILED:
        case 0, $3pvFP.SHOW_ERROR:
            return (0, $6JFcL.merge)(state, {
                hasErrors: true
            });
        case 0, $3pvFP.DISMISS_ERROR:
            return (0, $6JFcL.merge)(state, {
                hasErrors: false
            });
        case 0, $3pvFP.SUCCESSFULLY_CONNECTED_SPACE:
            return (0, $6JFcL.merge)(state, {
                showSuccessFlag: true,
                connectedSpaceName: action.connectedSpaceName,
                isConnectedToPage: action.isConnectedToPage,
                title: '',
                description: ''
            });
        case 0, $3pvFP.SUCCESSFULLY_REQUESTED_ACCESS:
            return (0, $6JFcL.merge)(state, {
                hasErrors: false,
                showSuccessFlag: true,
                connectedSpaceName: '',
                title: action.payload.title,
                description: action.payload.description
            });
        case 0, $3pvFP.DISMISS_SUCCESS_FLAG:
            return (0, $6JFcL.merge)(state, {
                showSuccessFlag: false
            });
        case 0, $3pvFP.SHOW_ACTIVATION_ERROR_FLAG:
            return (0, $6JFcL.merge)(state, {
                showActivationErrorFlag: true,
                title: action.payload?.title || state.title,
                description: action.payload?.description || state.description
            });
        case 0, $3pvFP.DISMISS_ACTIVATION_ERROR_FLAG:
            return (0, $6JFcL.merge)(state, {
                showActivationErrorFlag: false
            });
        default:
            return state;
    }
};

});
parcelRegister("l2hLv", function(module, exports) {

$parcel$export(module.exports, "SET", () => $628a1ae2ed47cf07$export$5e8f180ef0142226);
const $628a1ae2ed47cf07$export$5e8f180ef0142226 = 'flags.SET';
const $628a1ae2ed47cf07$export$adaa4cf7ef1b65be = (payload)=>({
        type: $628a1ae2ed47cf07$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("9MNJa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5973f3d419a829e$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $1Audr = parcelRequire("1Audr");

var $cjFmh = parcelRequire("cjFmh");

var $jAqj8 = parcelRequire("jAqj8");

var $h6KdK = parcelRequire("h6KdK");

var $bFnoS = parcelRequire("bFnoS");
var $b5973f3d419a829e$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    blueprints: $1Audr.default,
    connectSpaceDialog: $cjFmh.default,
    createSpaceDialog: $jAqj8.default,
    inlineJoin: $h6KdK.default,
    onDemandActivation: $bFnoS.default
});

});
parcelRegister("1Audr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec7bf584c934ac39$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $jX0CR = parcelRequire("jX0CR");

var $6TeVR = parcelRequire("6TeVR");
const $ec7bf584c934ac39$var$initialState = {
    defaultBlueprints: [
        {
            name: 'Blank page',
            itemModuleCompleteKey: (0, $6TeVR.ItemModuleCompleteKeys).BLANK_PAGE,
            contentBlueprintId: '00000000-0000-0000-0000-000000000000',
            skipHowToUse: false
        },
        {
            name: 'Decision',
            itemModuleCompleteKey: (0, $6TeVR.ItemModuleCompleteKeys).DECISION,
            contentBlueprintId: '5f4151a9-31cb-4466-8b9a-4d2797da3d0c',
            skipHowToUse: false
        },
        {
            name: 'Meeting notes',
            itemModuleCompleteKey: (0, $6TeVR.ItemModuleCompleteKeys).MEETING_NOTES,
            contentBlueprintId: '8b2245c5-60eb-4ba4-9139-563a4f0a8d9e',
            skipHowToUse: false
        },
        {
            name: 'Product requirements',
            itemModuleCompleteKey: (0, $6TeVR.ItemModuleCompleteKeys).PRODUCT_REQUIREMENTS,
            contentBlueprintId: 'd436e36c-2779-455b-ad86-adb6398d1a99',
            skipHowToUse: false
        },
        {
            name: 'Retrospective',
            itemModuleCompleteKey: (0, $6TeVR.ItemModuleCompleteKeys).RESTROSPECTIVE,
            contentBlueprintId: '5e76e3f2-8835-4568-8848-5b87e0bea05e',
            skipHowToUse: false
        }
    ]
};
for(let i = 0; i < 7; i += 1){
    const fillerTemplate = {
        name: 'Filler Template',
        itemModuleCompleteKey: null,
        contentBlueprintId: `filler${i}`
    };
    $ec7bf584c934ac39$var$initialState.defaultBlueprints.push(fillerTemplate);
}
var $ec7bf584c934ac39$export$2e2bcd8739ae039 = (state = $ec7bf584c934ac39$var$initialState, action)=>{
    switch(action.type){
        case 0, $jX0CR.SET:
            return (0, $6JFcL.freeze)(action.payload);
        default:
            return state;
    }
};

});
parcelRegister("jX0CR", function(module, exports) {

$parcel$export(module.exports, "SET", () => $d260953b923f6a63$export$5e8f180ef0142226);
const $d260953b923f6a63$export$5e8f180ef0142226 = 'ui.blueprints.SET';
const $d260953b923f6a63$export$adaa4cf7ef1b65be = (payload)=>({
        type: $d260953b923f6a63$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("cjFmh", function(module, exports) {

$parcel$export(module.exports, "default", () => $94abbfe3565e3713$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $3pvFP = parcelRequire("3pvFP");

var $4Edxa = parcelRequire("4Edxa");

const $94abbfe3565e3713$var$initialState = (0, $6JFcL.freeze)({
    selectedSpace: null,
    connectingSpace: false,
    connectSpaceDialogErrorState: (0, $9b5baad096b49e71$export$2841857f996c7c26),
    connectSpaceDialogOpen: false,
    disconnectedTemplatesClick: false
});
var $94abbfe3565e3713$export$2e2bcd8739ae039 = (state = $94abbfe3565e3713$var$initialState, action)=>{
    switch(action.type){
        case 0, $4Edxa.SET:
            return (0, $6JFcL.freeze)(action.payload);
        case 0, $3pvFP.CONNECT_CONFLUENCE_SPACE:
            return (0, $6JFcL.merge)(state, {
                connectingSpace: true,
                connectSpaceDialogErrorState: (0, $9b5baad096b49e71$export$2841857f996c7c26)
            });
        case 0, $3pvFP.UPDATE_CONFLUENCE_SPACES:
            return (0, $6JFcL.merge)(state, {
                connectSpaceDialogErrorState: (0, $9b5baad096b49e71$export$2841857f996c7c26)
            });
        case 0, $3pvFP.FETCH_CONFLUENCE_SPACES_ERROR:
            return (0, $6JFcL.merge)(state, {
                connectingSpace: false,
                connectSpaceDialogErrorState: (0, $9b5baad096b49e71$export$a71624947af1f122)
            });
        case 0, $3pvFP.HIDE_CONNECT_SPACE_DIALOG:
            return (0, $6JFcL.merge)(state, {
                selectedSpace: null,
                connectingSpace: false,
                connectSpaceDialogOpen: false,
                connectSpaceDialogErrorState: (0, $9b5baad096b49e71$export$2841857f996c7c26)
            });
        case 0, $3pvFP.PUT_PROJECT_SPACE_LINK_ERROR:
            return (0, $6JFcL.merge)(state, {
                connectingSpace: false,
                connectSpaceDialogErrorState: (0, $9b5baad096b49e71$export$f5569b14a81f6409)
            });
        case 0, $3pvFP.SET_SELECTED_SPACE:
            return (0, $6JFcL.merge)(state, {
                selectedSpace: action.payload
            });
        case 0, $3pvFP.SHOW_CONNECT_SPACE_DIALOG:
            return (0, $6JFcL.merge)(state, {
                ...$94abbfe3565e3713$var$initialState,
                connectSpaceDialogOpen: true,
                disconnectedTemplatesClick: action.disconnectedTemplatesClick
            });
        case 0, $3pvFP.SHOW_CREATE_SPACE_DIALOG:
            return (0, $6JFcL.merge)(state, {
                connectSpaceDialogOpen: false
            });
        case 0, $3pvFP.UPDATE_PROJECT_SPACE_LINK:
            return (0, $6JFcL.merge)(state, {
                selectedSpace: null,
                connectingSpace: false,
                connectSpaceDialogOpen: false
            });
        default:
            return state;
    }
};

});
parcelRegister("4Edxa", function(module, exports) {

$parcel$export(module.exports, "SET", () => $e39afa7e2fe578ff$export$5e8f180ef0142226);
const $e39afa7e2fe578ff$export$5e8f180ef0142226 = 'ui.connectSpaceDialog.SET';
const $e39afa7e2fe578ff$export$adaa4cf7ef1b65be = (payload)=>({
        type: $e39afa7e2fe578ff$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("jAqj8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b01c05bd8abc190$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $3pvFP = parcelRequire("3pvFP");

var $gilIH = parcelRequire("gilIH");

var $bJ8HW = parcelRequire("bJ8HW");

const $7b01c05bd8abc190$var$initialState = (0, $6JFcL.freeze)({
    createSpaceDialogOpen: false,
    createSpaceDialogErrorState: (0, $a4d39a31ee3c5204$export$2841857f996c7c26),
    creatingSpace: false,
    generatingKey: false,
    userEnteredSpaceNameInvalid: false,
    userEnteredSpaceName: ''
});
var $7b01c05bd8abc190$export$2e2bcd8739ae039 = (state = $7b01c05bd8abc190$var$initialState, action)=>{
    switch(action.type){
        case 0, $bJ8HW.SET:
            return (0, $6JFcL.freeze)(action.payload);
        case 0, $gilIH.CREATE_CONFLUENCE_SPACE:
            return (0, $6JFcL.merge)(state, {
                creatingSpace: true,
                createSpaceDialogErrorState: (0, $a4d39a31ee3c5204$export$2841857f996c7c26)
            });
        case 0, $gilIH.CREATE_CONFLUENCE_SPACE_ERROR:
            return (0, $6JFcL.merge)(state, {
                creatingSpace: false,
                createSpaceDialogErrorState: (0, $a4d39a31ee3c5204$export$58e5d3e30f50fa06)
            });
        case 0, $3pvFP.GENERATE_SPACE_KEY:
            return (0, $6JFcL.merge)(state, {
                generatingKey: true,
                createSpaceDialogErrorState: (0, $a4d39a31ee3c5204$export$2841857f996c7c26)
            });
        case 0, $3pvFP.HIDE_CREATE_SPACE_DIALOG:
            return (0, $6JFcL.merge)(state, {
                createSpaceDialogOpen: false
            });
        case 0, $3pvFP.NO_VALID_KEY_FAILURE:
            return (0, $6JFcL.merge)(state, {
                generatingKey: false,
                createSpaceDialogErrorState: (0, $a4d39a31ee3c5204$export$d822474b2a7c6d59)
            });
        case 0, $3pvFP.SHOW_CONNECT_SPACE_DIALOG:
            return (0, $6JFcL.merge)(state, {
                createSpaceDialogOpen: false
            });
        case 0, $3pvFP.SHOW_CREATE_SPACE_DIALOG:
            return (0, $6JFcL.merge)(state, {
                ...$7b01c05bd8abc190$var$initialState,
                createSpaceDialogOpen: true
            });
        case 0, $3pvFP.TOGGLE_SPACE_NAME_INVALID:
            return (0, $6JFcL.merge)(state, {
                userEnteredSpaceNameInvalid: action.userEnteredSpaceNameInvalid
            });
        case 0, $3pvFP.UPDATE_PROJECT_SPACE_LINK:
            return (0, $6JFcL.merge)(state, {
                creatingSpace: false,
                createSpaceDialogOpen: false,
                userEnteredSpaceName: ''
            });
        case 0, $3pvFP.UPDATE_SPACE_NAME:
            return (0, $6JFcL.merge)(state, {
                userEnteredSpaceName: action.userEnteredSpaceName
            });
        case 0, $3pvFP.UPDATE_SUGGESTED_KEY:
            return (0, $6JFcL.merge)(state, {
                generatingKey: false,
                createSpaceDialogErrorState: (0, $a4d39a31ee3c5204$export$2841857f996c7c26)
            });
        default:
            return state;
    }
};

});
parcelRegister("bJ8HW", function(module, exports) {

$parcel$export(module.exports, "SET", () => $307dc95b2f750945$export$5e8f180ef0142226);
const $307dc95b2f750945$export$5e8f180ef0142226 = 'ui.createSpaceDialog.SET';
const $307dc95b2f750945$export$adaa4cf7ef1b65be = (payload)=>({
        type: $307dc95b2f750945$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("h6KdK", function(module, exports) {

$parcel$export(module.exports, "default", () => $8964e53f49ea0885$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $bJ8HW = parcelRequire("bJ8HW");

var $3pvFP = parcelRequire("3pvFP");
const $8964e53f49ea0885$var$initialState = (0, $6JFcL.freeze)({
    isJoinPending: false
});
var $8964e53f49ea0885$export$2e2bcd8739ae039 = (state = $8964e53f49ea0885$var$initialState, action)=>{
    switch(action.type){
        case 0, $bJ8HW.SET:
            return (0, $6JFcL.freeze)(action.payload);
        case 0, $3pvFP.INLINE_JOIN_CONFLUENCE:
            return (0, $6JFcL.merge)(state, {
                isJoinPending: true
            });
        case 0, $3pvFP.INLINE_JOIN_FAILED:
            return (0, $6JFcL.merge)(state, {
                isJoinPending: false
            });
        default:
            return state;
    }
};

});

parcelRegister("bFnoS", function(module, exports) {

$parcel$export(module.exports, "default", () => $497f468254b7f9d6$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $8LwVJ = parcelRequire("8LwVJ");
const $497f468254b7f9d6$var$initialState = {
    modalState: 'open'
};
var $497f468254b7f9d6$export$2e2bcd8739ae039 = (state = $497f468254b7f9d6$var$initialState, action)=>{
    switch(action.type){
        case 0, $8LwVJ.SET:
            return (0, $6JFcL.freeze)(action.payload);
        case 0, $8LwVJ.UPDATE_ONDEMAND_ACTIVATION_MODAL_STATE:
            return (0, $6JFcL.merge)(state, {
                modalState: action.payload.modalState
            });
        default:
            return state;
    }
};

});


parcelRegister("27RnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $406b7a88634bb0cb$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $6waye = parcelRequire("6waye");
const $406b7a88634bb0cb$export$eec01d9730781097 = {
    siteTraits: []
};
var $406b7a88634bb0cb$export$2e2bcd8739ae039 = (state = $406b7a88634bb0cb$export$eec01d9730781097, action)=>{
    switch(action.type){
        case 0, $6waye.UPDATE_PERSONALIZATION_SITE_TRAITS:
            return (0, $6JFcL.merge)(state, {
                siteTraits: action.traits
            });
        default:
            return state;
    }
};

});

parcelRegister("2MaQ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f01d6e539865ebb2$export$2e2bcd8739ae039);

var $6JFcL = parcelRequire("6JFcL");

var $hG7sF = parcelRequire("hG7sF");

var $1UwLx = parcelRequire("1UwLx");
const $f01d6e539865ebb2$export$ce2ca3f2bd913448 = (0, $6JFcL.freeze)({
    status: 'not-started',
    retryCount: 0,
    userInitiated: false
});
var $f01d6e539865ebb2$export$2e2bcd8739ae039 = (state = $f01d6e539865ebb2$export$ce2ca3f2bd913448, action)=>{
    switch(action.type){
        case 0, $hG7sF.SET:
            return (0, $6JFcL.freeze)(action.payload);
        case 0, $1UwLx.UPDATE_ACTIVATION_STATUS:
            return (0, $6JFcL.merge)(state, {
                status: action.payload.status
            });
        case 0, $1UwLx.START_ACTIVATION:
            return (0, $6JFcL.merge)(state, {
                status: 'activating',
                userInitiated: true
            });
        case 0, $1UwLx.CHECK_ACTIVATION_STATUS:
            return (0, $6JFcL.merge)(state, {
                retryCount: state.retryCount + 1
            });
        default:
            return state;
    }
};

});
parcelRegister("hG7sF", function(module, exports) {

$parcel$export(module.exports, "SET", () => $ea6c42fd23e9835f$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $ea6c42fd23e9835f$export$adaa4cf7ef1b65be);
const $ea6c42fd23e9835f$export$5e8f180ef0142226 = 'activation.SET';
const $ea6c42fd23e9835f$export$adaa4cf7ef1b65be = (payload)=>({
        type: $ea6c42fd23e9835f$export$5e8f180ef0142226,
        payload: payload
    });

});




parcelRegister("8lqS6", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagsProvider", () => $2787d219a19ad614$export$6d7e43f2d6e1c7c6);

var $eUqFw = parcelRequire("eUqFw");
const $2787d219a19ad614$var$FeatureFlagsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    fireFeatureExposed: ()=>{}
});
const $2787d219a19ad614$export$90335b3ff08f335 = ()=>(0, $eUqFw.useContext)($2787d219a19ad614$var$FeatureFlagsContext);
const $2787d219a19ad614$export$6d7e43f2d6e1c7c6 = $2787d219a19ad614$var$FeatureFlagsContext.Provider;

});


parcelRegister("74EXT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e91dddedcaa6733c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $i5fMx = parcelRequire("i5fMx");
class $e91dddedcaa6733c$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidMount() {
        (0, $i5fMx.set)(this.props.embeddedProduct).catch((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))));
    }
    componentWillUnmount() {
        (0, $i5fMx.clear)().catch((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))));
    }
    render() {
        return null;
    }
}

});
parcelRegister("i5fMx", function(module, exports) {

$parcel$export(module.exports, "set", () => $e77287bc8a976506$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "clear", () => $e77287bc8a976506$export$42ffd38884aecdac);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");

var $gUUjF = parcelRequire("gUUjF");

var $3DOEL = parcelRequire("3DOEL");
const $e77287bc8a976506$export$7271276960377470 = 'jira.analytics.embedded-product';
let $e77287bc8a976506$var$cachedResolver;
const $e77287bc8a976506$export$5a1ebbbe9b82546e = ()=>{
    if ($e77287bc8a976506$var$cachedResolver) return $e77287bc8a976506$var$cachedResolver;
    const wrmKeys = [
        'wrc!jira.webresources:top-same-origin-window',
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
    ];
    // eslint-disable-next-line jira/wrm/no-load-bridge
    $e77287bc8a976506$var$cachedResolver = (0, $2BvS3.loadBridge)({
        name: 'jira/analytics/embedded-product-resolver',
        wrmKeys: wrmKeys,
        shouldLogError: false
    }).then((embeddedProductResolver)=>{
        const updateValue = (embeddedProduct)=>{
            // Set embedded product fn to reset the "track" interval (check analytics-web-client sources for more details).
            // User has to be at least active for 2 seconds before we can submit the track event.
            embeddedProduct ? (0, $3DOEL.getAnalyticsWebClient)().setEmbeddedProduct(embeddedProduct) : (0, $3DOEL.getAnalyticsWebClient)().clearEmbeddedProduct();
        };
        updateValue(embeddedProductResolver.get());
        embeddedProductResolver.onChange(updateValue);
        return embeddedProductResolver;
    }).catch((e)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData($e77287bc8a976506$export$7271276960377470, 'Cannot get embedded product resolver via bridge', e);
        throw e;
    });
    return $e77287bc8a976506$var$cachedResolver;
};
const $e77287bc8a976506$export$adaa4cf7ef1b65be = (embeddedProduct)=>$e77287bc8a976506$export$5a1ebbbe9b82546e().then((resolver)=>resolver.set(embeddedProduct));
const $e77287bc8a976506$export$42ffd38884aecdac = ()=>$e77287bc8a976506$export$5a1ebbbe9b82546e().then((resolver)=>resolver.clear());
const $e77287bc8a976506$export$5428ebc594af9d04 = (value)=>{
    $e77287bc8a976506$var$cachedResolver = value;
};

});


parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("bG3kA", function(module, exports) {

$parcel$export(module.exports, "usePagesFeatureState", () => $e3858653c6e6fc45$export$521163b675f0ea59);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $9XiZt = parcelRequire("9XiZt");

var $0IclK = parcelRequire("0IclK");

var $fkAfS = parcelRequire("fkAfS");
const $e3858653c6e6fc45$var$actions = {
    setFeatureState: $0IclK.setFeatureState
};
const $e3858653c6e6fc45$var$initialState = {
    state: (0, $fkAfS.pagesFeatureStates).LOADING
};
const $e3858653c6e6fc45$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    name: 'pagesFeatureStateStore',
    initialState: $e3858653c6e6fc45$var$initialState,
    actions: $e3858653c6e6fc45$var$actions
});
const $e3858653c6e6fc45$var$usePagesFeatureHook = (0, $WBLbN.createHook)($e3858653c6e6fc45$export$390f32400eaf98c9);
const $e3858653c6e6fc45$export$521163b675f0ea59 = (projectId)=>{
    const [featureState, featureActions] = $e3858653c6e6fc45$var$usePagesFeatureHook();
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    if (error) {
        setError(undefined);
        throw error;
    }
    (0, $eUqFw.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const { value: isEnabled } = await (0, $9XiZt.getPagesFeatureState)(projectId);
                featureActions.setFeatureState(isEnabled);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (thrownError) {
                setError(thrownError);
            }
        };
        fetchData();
    }, [
        featureActions,
        projectId
    ]);
    return featureState.state;
};

});
parcelRegister("9XiZt", function(module, exports) {

$parcel$export(module.exports, "getPagesFeatureState", () => $ad643b07f969e7e5$export$90bc82d3b826ba38);

var $lRmyA = parcelRequire("lRmyA");
const $ad643b07f969e7e5$export$90bc82d3b826ba38 = (projectId)=>(0, $lRmyA.performGetRequest)(`/rest/api/2/project/${projectId}/properties/project-pages-link-enabled`).catch((thrownError)=>{
        /** If feature has never been set before 404 is returned. But default state of feature is enabled. */ if (thrownError.statusCode === 404) return Promise.resolve({
            value: true
        });
        return Promise.reject(thrownError);
    });

});

parcelRegister("0IclK", function(module, exports) {

$parcel$export(module.exports, "setFeatureState", () => $e5c4665b45d3cf6f$export$bed5a5469370c50d);

var $fkAfS = parcelRequire("fkAfS");
const $e5c4665b45d3cf6f$export$bed5a5469370c50d = (isEnabled)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newState = isEnabled ? (0, $fkAfS.pagesFeatureStates).ENABLED : (0, $fkAfS.pagesFeatureStates).DISABLED;
        if (currentState.state !== newState) setState({
            state: newState
        });
    };

});
parcelRegister("fkAfS", function(module, exports) {

$parcel$export(module.exports, "pagesFeatureStates", () => $1f43003d75ad3968$export$9c7e040262f6af5c);
const $1f43003d75ad3968$export$9c7e040262f6af5c = {
    LOADING: 'LOADING',
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED'
};

});



parcelRegister("cBSii", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b8dec2b9e0c7cb8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0b8dec2b9e0c7cb8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pageTitlePages: {
        "id": "project-pages.page-title-pages",
        "defaultMessage": "Pages"
    }
});

});

parcelRegister("kCe2K", function(module, exports) {

$parcel$export(module.exports, "onFireErrorEvent", () => $308569e5cedf9b51$export$8279421a5ba6bd14);

var $guiFP = parcelRequire("guiFP");
const $308569e5cedf9b51$export$8279421a5ba6bd14 = (error, info, meta)=>(0, $guiFP.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: meta || {
            id: 'unhandled',
            packageName: 'jiraProjectPagesErrorEventUtil',
            teamName: 'confluence-better-together'
        }
    });

});



parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("afBr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a0a341667acfde3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hFmdR = parcelRequire("hFmdR");

var $c76ap = parcelRequire("c76ap");

var $aR8n6 = parcelRequire("aR8n6");


var $5yh8X = parcelRequire("5yh8X");

var $7vf5z = parcelRequire("7vf5z");

var $9pZ9R = parcelRequire("9pZ9R");

var $6M8Uw = parcelRequire("6M8Uw");

var $iJHZm = parcelRequire("iJHZm");

var $4KTkh = parcelRequire("4KTkh");
const $3a0a341667acfde3$var$pageLayoutStyles = null;
function $3a0a341667acfde3$var$ProjectPages(props) {
    const { Updater: Updater, ProjectPagesApp: ProjectPagesApp, tenantContext: tenantContext, projectContext: projectContext } = props;
    if (!(projectContext && projectContext.data && projectContext.data.projectKey)) return null;
    const { isAdmin: isAdmin, baseUrl: baseUrl, locale: locale, cloudId: cloudId, atlassianAccountId: atlassianAccountId, environment: environment } = tenantContext;
    const { projectId: projectId, projectKey: projectKey, projectName: projectName, projectType: projectType } = projectContext.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_4t3i1osq _18s8zdiv"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "unhandled",
        packageName: "jiraSpaAppsProjectPages",
        teamName: "confluence-better-together"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Updater, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectPagesApp, {
        baseUrl: baseUrl,
        locale: locale,
        isAdmin: isAdmin,
        cloudId: cloudId,
        accountId: atlassianAccountId,
        projectId: projectId,
        projectKey: projectKey,
        projectName: projectName,
        projectType: projectType,
        environment: environment,
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        metricKey: "jira.project.pages",
        metric: (0, $4KTkh.projectPagesPageLoad),
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $5yh8X.appBundleReadyMark),
            (0, $5yh8X.prefetchApiReadyMark)
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pZ9R.default), {
        baseUrl: baseUrl,
        projectKey: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null)));
}
var $3a0a341667acfde3$export$2e2bcd8739ae039 = (0, $hFmdR.AnalyticsSource)('project-pages', (0, $41ea3621645e2acc$export$f636b5b56f1d624a))($3a0a341667acfde3$var$ProjectPages);

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("9pZ9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe2461c5190afbae$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $lgxha = parcelRequire("lgxha");

var $lRmyA = parcelRequire("lRmyA");
const $fe2461c5190afbae$export$fa156a01818e3239 = (baseUrl, projectKey)=>(0, $lRmyA.performPostRequest)(`${baseUrl}/rest/internal/2/project/${projectKey}/recent`).catch((e)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.common.src.add-project-to-history', 'Cannot set recent project', e);
    });
const $fe2461c5190afbae$var$AddProjectToHistory = ({ baseUrl: baseUrl, projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: ()=>$fe2461c5190afbae$export$fa156a01818e3239(baseUrl, projectKey)
    });
var $fe2461c5190afbae$export$2e2bcd8739ae039 = $fe2461c5190afbae$var$AddProjectToHistory;

});

parcelRegister("4KTkh", function(module, exports) {

$parcel$export(module.exports, "projectPagesPageLoad", () => $a7c63cc031ddcb3b$export$1874d1120998dfa4);

var $lNfG4 = parcelRequire("lNfG4");
const $a7c63cc031ddcb3b$export$1874d1120998dfa4 = (0, $lNfG4.metrics).pageLoad({
    key: 'project-pages',
    ssr: {
        doneAsFmp: true
    }
});

});





//# sourceMappingURL=async-project-pages.03fead7e.js.map
